import { FontAwesomeIcon as _A } from "@fortawesome/react-fontawesome";
import { createElement as bA } from "react";
import { definition as SA } from "@fortawesome/free-solid-svg-icons/fa0";
import { definition as HU2 } from "@fortawesome/free-solid-svg-icons/fa0";
import { definition as yA } from "@fortawesome/free-solid-svg-icons/fa1";
import { definition as UU2 } from "@fortawesome/free-solid-svg-icons/fa1";
import { definition as OA } from "@fortawesome/free-solid-svg-icons/fa2";
import { definition as GU2 } from "@fortawesome/free-solid-svg-icons/fa2";
import { definition as kA } from "@fortawesome/free-solid-svg-icons/fa3";
import { definition as EU2 } from "@fortawesome/free-solid-svg-icons/fa3";
import { definition as AA } from "@fortawesome/free-solid-svg-icons/fa4";
import { definition as IU2 } from "@fortawesome/free-solid-svg-icons/fa4";
import { definition as jA } from "@fortawesome/free-solid-svg-icons/fa5";
import { definition as XU2 } from "@fortawesome/free-solid-svg-icons/fa5";
import { definition as BA } from "@fortawesome/free-solid-svg-icons/fa6";
import { definition as JU2 } from "@fortawesome/free-solid-svg-icons/fa6";
import { definition as TA } from "@fortawesome/free-solid-svg-icons/fa7";
import { definition as ZU2 } from "@fortawesome/free-solid-svg-icons/fa7";
import { definition as FA } from "@fortawesome/free-solid-svg-icons/fa8";
import { definition as xU2 } from "@fortawesome/free-solid-svg-icons/fa8";
import { definition as HA } from "@fortawesome/free-solid-svg-icons/fa9";
import { definition as aq2 } from "@fortawesome/free-solid-svg-icons/fa9";
import { definition as RA } from "@fortawesome/free-solid-svg-icons/faA";
import { definition as nq2 } from "@fortawesome/free-solid-svg-icons/faA";
import { definition as UA } from "@fortawesome/free-solid-svg-icons/faAd";
import { definition as cq2 } from "@fortawesome/free-solid-svg-icons/faAd";
import { definition as qA } from "@fortawesome/free-solid-svg-icons/faAdd";
import { definition as oq2 } from "@fortawesome/free-solid-svg-icons/faAdd";
import { definition as GA } from "@fortawesome/free-solid-svg-icons/faAddressBook";
import { definition as dq2 } from "@fortawesome/free-solid-svg-icons/faAddressBook";
import { definition as WA } from "@fortawesome/free-solid-svg-icons/faAddressCard";
import { definition as sq2 } from "@fortawesome/free-solid-svg-icons/faAddressCard";
import { definition as EA } from "@fortawesome/free-solid-svg-icons/faAdjust";
import { definition as vq2 } from "@fortawesome/free-solid-svg-icons/faAdjust";
import { definition as VA } from "@fortawesome/free-solid-svg-icons/faAirFreshener";
import { definition as mq2 } from "@fortawesome/free-solid-svg-icons/faAirFreshener";
import { definition as IA } from "@fortawesome/free-solid-svg-icons/faAlignCenter";
import { definition as Pq2 } from "@fortawesome/free-solid-svg-icons/faAlignCenter";
import { definition as KA } from "@fortawesome/free-solid-svg-icons/faAlignJustify";
import { definition as wq2 } from "@fortawesome/free-solid-svg-icons/faAlignJustify";
import { definition as XA } from "@fortawesome/free-solid-svg-icons/faAlignLeft";
import { definition as zq2 } from "@fortawesome/free-solid-svg-icons/faAlignLeft";
import { definition as QA } from "@fortawesome/free-solid-svg-icons/faAlignRight";
import { definition as Cq2 } from "@fortawesome/free-solid-svg-icons/faAlignRight";
import { definition as JA } from "@fortawesome/free-solid-svg-icons/faAllergies";
import { definition as $q2 } from "@fortawesome/free-solid-svg-icons/faAllergies";
import { definition as YA } from "@fortawesome/free-solid-svg-icons/faAmbulance";
import { definition as bq2 } from "@fortawesome/free-solid-svg-icons/faAmbulance";
import { definition as ZA } from "@fortawesome/free-solid-svg-icons/faAmericanSignLanguageInterpreting";
import { definition as yq2 } from "@fortawesome/free-solid-svg-icons/faAmericanSignLanguageInterpreting";
import { definition as pA } from "@fortawesome/free-solid-svg-icons/faAnchor";
import { definition as kq2 } from "@fortawesome/free-solid-svg-icons/faAnchor";
import { definition as xA } from "@fortawesome/free-solid-svg-icons/faAnchorCircleCheck";
import { definition as jq2 } from "@fortawesome/free-solid-svg-icons/faAnchorCircleCheck";
import { definition as ij } from "@fortawesome/free-solid-svg-icons/faAnchorCircleExclamation";
import { definition as Tq2 } from "@fortawesome/free-solid-svg-icons/faAnchorCircleExclamation";
import { definition as aj } from "@fortawesome/free-solid-svg-icons/faAnchorCircleXmark";
import { definition as Hq2 } from "@fortawesome/free-solid-svg-icons/faAnchorCircleXmark";
import { definition as ej } from "@fortawesome/free-solid-svg-icons/faAnchorLock";
import { definition as Uq2 } from "@fortawesome/free-solid-svg-icons/faAnchorLock";
import { definition as nj } from "@fortawesome/free-solid-svg-icons/faAngleDoubleDown";
import { definition as Gq2 } from "@fortawesome/free-solid-svg-icons/faAngleDoubleDown";
import { definition as fj } from "@fortawesome/free-solid-svg-icons/faAngleDoubleLeft";
import { definition as Eq2 } from "@fortawesome/free-solid-svg-icons/faAngleDoubleLeft";
import { definition as cj } from "@fortawesome/free-solid-svg-icons/faAngleDoubleRight";
import { definition as Iq2 } from "@fortawesome/free-solid-svg-icons/faAngleDoubleRight";
import { definition as tj } from "@fortawesome/free-solid-svg-icons/faAngleDoubleUp";
import { definition as Xq2 } from "@fortawesome/free-solid-svg-icons/faAngleDoubleUp";
import { definition as oj } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import { definition as Jq2 } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import { definition as lj } from "@fortawesome/free-solid-svg-icons/faAngleLeft";
import { definition as Zq2 } from "@fortawesome/free-solid-svg-icons/faAngleLeft";
import { definition as dj } from "@fortawesome/free-solid-svg-icons/faAngleRight";
import { definition as xq2 } from "@fortawesome/free-solid-svg-icons/faAngleRight";
import { definition as rj } from "@fortawesome/free-solid-svg-icons/faAngleUp";
import { definition as aG2 } from "@fortawesome/free-solid-svg-icons/faAngleUp";
import { definition as sj } from "@fortawesome/free-solid-svg-icons/faAnglesDown";
import { definition as nG2 } from "@fortawesome/free-solid-svg-icons/faAnglesDown";
import { definition as hj } from "@fortawesome/free-solid-svg-icons/faAnglesLeft";
import { definition as cG2 } from "@fortawesome/free-solid-svg-icons/faAnglesLeft";
import { definition as vj } from "@fortawesome/free-solid-svg-icons/faAnglesRight";
import { definition as oG2 } from "@fortawesome/free-solid-svg-icons/faAnglesRight";
import { definition as uj } from "@fortawesome/free-solid-svg-icons/faAnglesUp";
import { definition as dG2 } from "@fortawesome/free-solid-svg-icons/faAnglesUp";
import { definition as mj } from "@fortawesome/free-solid-svg-icons/faAngry";
import { definition as sG2 } from "@fortawesome/free-solid-svg-icons/faAngry";
import { definition as gj } from "@fortawesome/free-solid-svg-icons/faAnkh";
import { definition as vG2 } from "@fortawesome/free-solid-svg-icons/faAnkh";
import { definition as Pj } from "@fortawesome/free-solid-svg-icons/faAppleAlt";
import { definition as mG2 } from "@fortawesome/free-solid-svg-icons/faAppleAlt";
import { definition as Mj } from "@fortawesome/free-solid-svg-icons/faAppleWhole";
import { definition as PG2 } from "@fortawesome/free-solid-svg-icons/faAppleWhole";
import { definition as wj } from "@fortawesome/free-solid-svg-icons/faArchive";
import { definition as wG2 } from "@fortawesome/free-solid-svg-icons/faArchive";
import { definition as Nj } from "@fortawesome/free-solid-svg-icons/faArchway";
import { definition as zG2 } from "@fortawesome/free-solid-svg-icons/faArchway";
import { definition as zj } from "@fortawesome/free-solid-svg-icons/faAreaChart";
import { definition as CG2 } from "@fortawesome/free-solid-svg-icons/faAreaChart";
import { definition as Lj } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleDown";
import { definition as $G2 } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleDown";
import { definition as Cj } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleLeft";
import { definition as bG2 } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleLeft";
import { definition as Dj } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleRight";
import { definition as yG2 } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleRight";
import { definition as $j } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleUp";
import { definition as kG2 } from "@fortawesome/free-solid-svg-icons/faArrowAltCircleUp";
import { definition as _j } from "@fortawesome/free-solid-svg-icons/faArrowCircleDown";
import { definition as jG2 } from "@fortawesome/free-solid-svg-icons/faArrowCircleDown";
import { definition as bj } from "@fortawesome/free-solid-svg-icons/faArrowCircleLeft";
import { definition as TG2 } from "@fortawesome/free-solid-svg-icons/faArrowCircleLeft";
import { definition as Sj } from "@fortawesome/free-solid-svg-icons/faArrowCircleRight";
import { definition as HG2 } from "@fortawesome/free-solid-svg-icons/faArrowCircleRight";
import { definition as yj } from "@fortawesome/free-solid-svg-icons/faArrowCircleUp";
import { definition as UG2 } from "@fortawesome/free-solid-svg-icons/faArrowCircleUp";
import { definition as Oj } from "@fortawesome/free-solid-svg-icons/faArrowDown";
import { definition as GG2 } from "@fortawesome/free-solid-svg-icons/faArrowDown";
import { definition as kj } from "@fortawesome/free-solid-svg-icons/faArrowDown19";
import { definition as EG2 } from "@fortawesome/free-solid-svg-icons/faArrowDown19";
import { definition as Aj } from "@fortawesome/free-solid-svg-icons/faArrowDown91";
import { definition as IG2 } from "@fortawesome/free-solid-svg-icons/faArrowDown91";
import { definition as jj } from "@fortawesome/free-solid-svg-icons/faArrowDownAZ";
import { definition as XG2 } from "@fortawesome/free-solid-svg-icons/faArrowDownAZ";
import { definition as Bj } from "@fortawesome/free-solid-svg-icons/faArrowDownLong";
import { definition as JG2 } from "@fortawesome/free-solid-svg-icons/faArrowDownLong";
import { definition as Tj } from "@fortawesome/free-solid-svg-icons/faArrowDownShortWide";
import { definition as ZG2 } from "@fortawesome/free-solid-svg-icons/faArrowDownShortWide";
import { definition as Fj } from "@fortawesome/free-solid-svg-icons/faArrowDownUpAcrossLine";
import { definition as xG2 } from "@fortawesome/free-solid-svg-icons/faArrowDownUpAcrossLine";
import { definition as Hj } from "@fortawesome/free-solid-svg-icons/faArrowDownUpLock";
import { definition as aW2 } from "@fortawesome/free-solid-svg-icons/faArrowDownUpLock";
import { definition as Rj } from "@fortawesome/free-solid-svg-icons/faArrowDownWideShort";
import { definition as nW2 } from "@fortawesome/free-solid-svg-icons/faArrowDownWideShort";
import { definition as Uj } from "@fortawesome/free-solid-svg-icons/faArrowDownZA";
import { definition as cW2 } from "@fortawesome/free-solid-svg-icons/faArrowDownZA";
import { definition as qj } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { definition as oW2 } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { definition as Gj } from "@fortawesome/free-solid-svg-icons/faArrowLeftLong";
import { definition as dW2 } from "@fortawesome/free-solid-svg-icons/faArrowLeftLong";
import { definition as Wj } from "@fortawesome/free-solid-svg-icons/faArrowLeftRotate";
import { definition as sW2 } from "@fortawesome/free-solid-svg-icons/faArrowLeftRotate";
import { definition as Ej } from "@fortawesome/free-solid-svg-icons/faArrowPointer";
import { definition as vW2 } from "@fortawesome/free-solid-svg-icons/faArrowPointer";
import { definition as Vj } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { definition as mW2 } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { definition as Ij } from "@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft";
import { definition as PW2 } from "@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft";
import { definition as Kj } from "@fortawesome/free-solid-svg-icons/faArrowRightFromBracket";
import { definition as wW2 } from "@fortawesome/free-solid-svg-icons/faArrowRightFromBracket";
import { definition as Xj } from "@fortawesome/free-solid-svg-icons/faArrowRightFromFile";
import { definition as zW2 } from "@fortawesome/free-solid-svg-icons/faArrowRightFromFile";
import { definition as Qj } from "@fortawesome/free-solid-svg-icons/faArrowRightLong";
import { definition as CW2 } from "@fortawesome/free-solid-svg-icons/faArrowRightLong";
import { definition as Jj } from "@fortawesome/free-solid-svg-icons/faArrowRightRotate";
import { definition as $W2 } from "@fortawesome/free-solid-svg-icons/faArrowRightRotate";
import { definition as Yj } from "@fortawesome/free-solid-svg-icons/faArrowRightToBracket";
import { definition as bW2 } from "@fortawesome/free-solid-svg-icons/faArrowRightToBracket";
import { definition as Zj } from "@fortawesome/free-solid-svg-icons/faArrowRightToCity";
import { definition as yW2 } from "@fortawesome/free-solid-svg-icons/faArrowRightToCity";
import { definition as pj } from "@fortawesome/free-solid-svg-icons/faArrowRightToFile";
import { definition as kW2 } from "@fortawesome/free-solid-svg-icons/faArrowRightToFile";
import { definition as xj } from "@fortawesome/free-solid-svg-icons/faArrowRotateBack";
import { definition as jW2 } from "@fortawesome/free-solid-svg-icons/faArrowRotateBack";
import { definition as iB } from "@fortawesome/free-solid-svg-icons/faArrowRotateBackward";
import { definition as TW2 } from "@fortawesome/free-solid-svg-icons/faArrowRotateBackward";
import { definition as aB } from "@fortawesome/free-solid-svg-icons/faArrowRotateForward";
import { definition as HW2 } from "@fortawesome/free-solid-svg-icons/faArrowRotateForward";
import { definition as eB } from "@fortawesome/free-solid-svg-icons/faArrowRotateLeft";
import { definition as UW2 } from "@fortawesome/free-solid-svg-icons/faArrowRotateLeft";
import { definition as nB } from "@fortawesome/free-solid-svg-icons/faArrowRotateRight";
import { definition as GW2 } from "@fortawesome/free-solid-svg-icons/faArrowRotateRight";
import { definition as fB } from "@fortawesome/free-solid-svg-icons/faArrowTrendDown";
import { definition as EW2 } from "@fortawesome/free-solid-svg-icons/faArrowTrendDown";
import { definition as cB } from "@fortawesome/free-solid-svg-icons/faArrowTrendUp";
import { definition as IW2 } from "@fortawesome/free-solid-svg-icons/faArrowTrendUp";
import { definition as tB } from "@fortawesome/free-solid-svg-icons/faArrowTurnDown";
import { definition as XW2 } from "@fortawesome/free-solid-svg-icons/faArrowTurnDown";
import { definition as oB } from "@fortawesome/free-solid-svg-icons/faArrowTurnUp";
import { definition as JW2 } from "@fortawesome/free-solid-svg-icons/faArrowTurnUp";
import { definition as lB } from "@fortawesome/free-solid-svg-icons/faArrowUp";
import { definition as ZW2 } from "@fortawesome/free-solid-svg-icons/faArrowUp";
import { definition as dB } from "@fortawesome/free-solid-svg-icons/faArrowUp19";
import { definition as xW2 } from "@fortawesome/free-solid-svg-icons/faArrowUp19";
import { definition as rB } from "@fortawesome/free-solid-svg-icons/faArrowUp91";
import { definition as aE2 } from "@fortawesome/free-solid-svg-icons/faArrowUp91";
import { definition as sB } from "@fortawesome/free-solid-svg-icons/faArrowUpAZ";
import { definition as nE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpAZ";
import { definition as hB } from "@fortawesome/free-solid-svg-icons/faArrowUpFromBracket";
import { definition as cE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpFromBracket";
import { definition as vB } from "@fortawesome/free-solid-svg-icons/faArrowUpFromGroundWater";
import { definition as oE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpFromGroundWater";
import { definition as uB } from "@fortawesome/free-solid-svg-icons/faArrowUpFromWaterPump";
import { definition as dE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpFromWaterPump";
import { definition as mB } from "@fortawesome/free-solid-svg-icons/faArrowUpLong";
import { definition as sE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpLong";
import { definition as gB } from "@fortawesome/free-solid-svg-icons/faArrowUpRightDots";
import { definition as vE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpRightDots";
import { definition as PB } from "@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare";
import { definition as mE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare";
import { definition as MB } from "@fortawesome/free-solid-svg-icons/faArrowUpShortWide";
import { definition as PE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpShortWide";
import { definition as wB } from "@fortawesome/free-solid-svg-icons/faArrowUpWideShort";
import { definition as wE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpWideShort";
import { definition as NB } from "@fortawesome/free-solid-svg-icons/faArrowUpZA";
import { definition as zE2 } from "@fortawesome/free-solid-svg-icons/faArrowUpZA";
import { definition as zB } from "@fortawesome/free-solid-svg-icons/faArrows";
import { definition as CE2 } from "@fortawesome/free-solid-svg-icons/faArrows";
import { definition as LB } from "@fortawesome/free-solid-svg-icons/faArrowsAlt";
import { definition as $E2 } from "@fortawesome/free-solid-svg-icons/faArrowsAlt";
import { definition as CB } from "@fortawesome/free-solid-svg-icons/faArrowsAltH";
import { definition as bE2 } from "@fortawesome/free-solid-svg-icons/faArrowsAltH";
import { definition as DB } from "@fortawesome/free-solid-svg-icons/faArrowsAltV";
import { definition as yE2 } from "@fortawesome/free-solid-svg-icons/faArrowsAltV";
import { definition as $B } from "@fortawesome/free-solid-svg-icons/faArrowsDownToLine";
import { definition as kE2 } from "@fortawesome/free-solid-svg-icons/faArrowsDownToLine";
import { definition as _B } from "@fortawesome/free-solid-svg-icons/faArrowsDownToPeople";
import { definition as jE2 } from "@fortawesome/free-solid-svg-icons/faArrowsDownToPeople";
import { definition as bB } from "@fortawesome/free-solid-svg-icons/faArrowsH";
import { definition as TE2 } from "@fortawesome/free-solid-svg-icons/faArrowsH";
import { definition as SB } from "@fortawesome/free-solid-svg-icons/faArrowsLeftRight";
import { definition as HE2 } from "@fortawesome/free-solid-svg-icons/faArrowsLeftRight";
import { definition as yB } from "@fortawesome/free-solid-svg-icons/faArrowsLeftRightToLine";
import { definition as UE2 } from "@fortawesome/free-solid-svg-icons/faArrowsLeftRightToLine";
import { definition as OB } from "@fortawesome/free-solid-svg-icons/faArrowsRotate";
import { definition as GE2 } from "@fortawesome/free-solid-svg-icons/faArrowsRotate";
import { definition as kB } from "@fortawesome/free-solid-svg-icons/faArrowsSpin";
import { definition as EE2 } from "@fortawesome/free-solid-svg-icons/faArrowsSpin";
import { definition as AB } from "@fortawesome/free-solid-svg-icons/faArrowsSplitUpAndLeft";
import { definition as IE2 } from "@fortawesome/free-solid-svg-icons/faArrowsSplitUpAndLeft";
import { definition as jB } from "@fortawesome/free-solid-svg-icons/faArrowsToCircle";
import { definition as XE2 } from "@fortawesome/free-solid-svg-icons/faArrowsToCircle";
import { definition as BB } from "@fortawesome/free-solid-svg-icons/faArrowsToDot";
import { definition as JE2 } from "@fortawesome/free-solid-svg-icons/faArrowsToDot";
import { definition as TB } from "@fortawesome/free-solid-svg-icons/faArrowsToEye";
import { definition as ZE2 } from "@fortawesome/free-solid-svg-icons/faArrowsToEye";
import { definition as FB } from "@fortawesome/free-solid-svg-icons/faArrowsTurnRight";
import { definition as xE2 } from "@fortawesome/free-solid-svg-icons/faArrowsTurnRight";
import { definition as HB } from "@fortawesome/free-solid-svg-icons/faArrowsTurnToDots";
import { definition as aV2 } from "@fortawesome/free-solid-svg-icons/faArrowsTurnToDots";
import { definition as RB } from "@fortawesome/free-solid-svg-icons/faArrowsUpDown";
import { definition as nV2 } from "@fortawesome/free-solid-svg-icons/faArrowsUpDown";
import { definition as UB } from "@fortawesome/free-solid-svg-icons/faArrowsUpDownLeftRight";
import { definition as cV2 } from "@fortawesome/free-solid-svg-icons/faArrowsUpDownLeftRight";
import { definition as qB } from "@fortawesome/free-solid-svg-icons/faArrowsUpToLine";
import { definition as oV2 } from "@fortawesome/free-solid-svg-icons/faArrowsUpToLine";
import { definition as GB } from "@fortawesome/free-solid-svg-icons/faArrowsV";
import { definition as dV2 } from "@fortawesome/free-solid-svg-icons/faArrowsV";
import { definition as WB } from "@fortawesome/free-solid-svg-icons/faAslInterpreting";
import { definition as sV2 } from "@fortawesome/free-solid-svg-icons/faAslInterpreting";
import { definition as EB } from "@fortawesome/free-solid-svg-icons/faAssistiveListeningSystems";
import { definition as vV2 } from "@fortawesome/free-solid-svg-icons/faAssistiveListeningSystems";
import { definition as VB } from "@fortawesome/free-solid-svg-icons/faAsterisk";
import { definition as mV2 } from "@fortawesome/free-solid-svg-icons/faAsterisk";
import { definition as IB } from "@fortawesome/free-solid-svg-icons/faAt";
import { definition as PV2 } from "@fortawesome/free-solid-svg-icons/faAt";
import { definition as KB } from "@fortawesome/free-solid-svg-icons/faAtlas";
import { definition as wV2 } from "@fortawesome/free-solid-svg-icons/faAtlas";
import { definition as XB } from "@fortawesome/free-solid-svg-icons/faAtom";
import { definition as zV2 } from "@fortawesome/free-solid-svg-icons/faAtom";
import { definition as QB } from "@fortawesome/free-solid-svg-icons/faAudioDescription";
import { definition as CV2 } from "@fortawesome/free-solid-svg-icons/faAudioDescription";
import { definition as JB } from "@fortawesome/free-solid-svg-icons/faAustralSign";
import { definition as $V2 } from "@fortawesome/free-solid-svg-icons/faAustralSign";
import { definition as YB } from "@fortawesome/free-solid-svg-icons/faAutomobile";
import { definition as bV2 } from "@fortawesome/free-solid-svg-icons/faAutomobile";
import { definition as ZB } from "@fortawesome/free-solid-svg-icons/faAward";
import { definition as yV2 } from "@fortawesome/free-solid-svg-icons/faAward";
import { definition as pB } from "@fortawesome/free-solid-svg-icons/faB";
import { definition as kV2 } from "@fortawesome/free-solid-svg-icons/faB";
import { definition as xB } from "@fortawesome/free-solid-svg-icons/faBaby";
import { definition as jV2 } from "@fortawesome/free-solid-svg-icons/faBaby";
import { definition as iT } from "@fortawesome/free-solid-svg-icons/faBabyCarriage";
import { definition as TV2 } from "@fortawesome/free-solid-svg-icons/faBabyCarriage";
import { definition as aT } from "@fortawesome/free-solid-svg-icons/faBackspace";
import { definition as HV2 } from "@fortawesome/free-solid-svg-icons/faBackspace";
import { definition as eT } from "@fortawesome/free-solid-svg-icons/faBackward";
import { definition as UV2 } from "@fortawesome/free-solid-svg-icons/faBackward";
import { definition as nT } from "@fortawesome/free-solid-svg-icons/faBackwardFast";
import { definition as GV2 } from "@fortawesome/free-solid-svg-icons/faBackwardFast";
import { definition as fT } from "@fortawesome/free-solid-svg-icons/faBackwardStep";
import { definition as EV2 } from "@fortawesome/free-solid-svg-icons/faBackwardStep";
import { definition as cT } from "@fortawesome/free-solid-svg-icons/faBacon";
import { definition as IV2 } from "@fortawesome/free-solid-svg-icons/faBacon";
import { definition as tT } from "@fortawesome/free-solid-svg-icons/faBacteria";
import { definition as XV2 } from "@fortawesome/free-solid-svg-icons/faBacteria";
import { definition as oT } from "@fortawesome/free-solid-svg-icons/faBacterium";
import { definition as JV2 } from "@fortawesome/free-solid-svg-icons/faBacterium";
import { definition as lT } from "@fortawesome/free-solid-svg-icons/faBagShopping";
import { definition as ZV2 } from "@fortawesome/free-solid-svg-icons/faBagShopping";
import { definition as dT } from "@fortawesome/free-solid-svg-icons/faBahai";
import { definition as xV2 } from "@fortawesome/free-solid-svg-icons/faBahai";
import { definition as rT } from "@fortawesome/free-solid-svg-icons/faBahtSign";
import { definition as aI2 } from "@fortawesome/free-solid-svg-icons/faBahtSign";
import { definition as sT } from "@fortawesome/free-solid-svg-icons/faBalanceScale";
import { definition as nI2 } from "@fortawesome/free-solid-svg-icons/faBalanceScale";
import { definition as hT } from "@fortawesome/free-solid-svg-icons/faBalanceScaleLeft";
import { definition as cI2 } from "@fortawesome/free-solid-svg-icons/faBalanceScaleLeft";
import { definition as vT } from "@fortawesome/free-solid-svg-icons/faBalanceScaleRight";
import { definition as oI2 } from "@fortawesome/free-solid-svg-icons/faBalanceScaleRight";
import { definition as uT } from "@fortawesome/free-solid-svg-icons/faBan";
import { definition as dI2 } from "@fortawesome/free-solid-svg-icons/faBan";
import { definition as mT } from "@fortawesome/free-solid-svg-icons/faBanSmoking";
import { definition as sI2 } from "@fortawesome/free-solid-svg-icons/faBanSmoking";
import { definition as gT } from "@fortawesome/free-solid-svg-icons/faBandAid";
import { definition as vI2 } from "@fortawesome/free-solid-svg-icons/faBandAid";
import { definition as PT } from "@fortawesome/free-solid-svg-icons/faBandage";
import { definition as mI2 } from "@fortawesome/free-solid-svg-icons/faBandage";
import { definition as MT } from "@fortawesome/free-solid-svg-icons/faBangladeshiTakaSign";
import { definition as PI2 } from "@fortawesome/free-solid-svg-icons/faBangladeshiTakaSign";
import { definition as wT } from "@fortawesome/free-solid-svg-icons/faBank";
import { definition as wI2 } from "@fortawesome/free-solid-svg-icons/faBank";
import { definition as NT } from "@fortawesome/free-solid-svg-icons/faBarChart";
import { definition as zI2 } from "@fortawesome/free-solid-svg-icons/faBarChart";
import { definition as zT } from "@fortawesome/free-solid-svg-icons/faBarcode";
import { definition as CI2 } from "@fortawesome/free-solid-svg-icons/faBarcode";
import { definition as LT } from "@fortawesome/free-solid-svg-icons/faBars";
import { definition as $I2 } from "@fortawesome/free-solid-svg-icons/faBars";
import { definition as CT } from "@fortawesome/free-solid-svg-icons/faBarsProgress";
import { definition as bI2 } from "@fortawesome/free-solid-svg-icons/faBarsProgress";
import { definition as DT } from "@fortawesome/free-solid-svg-icons/faBarsStaggered";
import { definition as yI2 } from "@fortawesome/free-solid-svg-icons/faBarsStaggered";
import { definition as $T } from "@fortawesome/free-solid-svg-icons/faBaseball";
import { definition as kI2 } from "@fortawesome/free-solid-svg-icons/faBaseball";
import { definition as _T } from "@fortawesome/free-solid-svg-icons/faBaseballBall";
import { definition as jI2 } from "@fortawesome/free-solid-svg-icons/faBaseballBall";
import { definition as bT } from "@fortawesome/free-solid-svg-icons/faBaseballBatBall";
import { definition as TI2 } from "@fortawesome/free-solid-svg-icons/faBaseballBatBall";
import { definition as ST } from "@fortawesome/free-solid-svg-icons/faBasketShopping";
import { definition as HI2 } from "@fortawesome/free-solid-svg-icons/faBasketShopping";
import { definition as yT } from "@fortawesome/free-solid-svg-icons/faBasketball";
import { definition as UI2 } from "@fortawesome/free-solid-svg-icons/faBasketball";
import { definition as OT } from "@fortawesome/free-solid-svg-icons/faBasketballBall";
import { definition as GI2 } from "@fortawesome/free-solid-svg-icons/faBasketballBall";
import { definition as kT } from "@fortawesome/free-solid-svg-icons/faBath";
import { definition as EI2 } from "@fortawesome/free-solid-svg-icons/faBath";
import { definition as AT } from "@fortawesome/free-solid-svg-icons/faBathtub";
import { definition as II2 } from "@fortawesome/free-solid-svg-icons/faBathtub";
import { definition as jT } from "@fortawesome/free-solid-svg-icons/faBattery";
import { definition as XI2 } from "@fortawesome/free-solid-svg-icons/faBattery";
import { definition as BT } from "@fortawesome/free-solid-svg-icons/faBattery0";
import { definition as JI2 } from "@fortawesome/free-solid-svg-icons/faBattery0";
import { definition as TT } from "@fortawesome/free-solid-svg-icons/faBattery2";
import { definition as ZI2 } from "@fortawesome/free-solid-svg-icons/faBattery2";
import { definition as FT } from "@fortawesome/free-solid-svg-icons/faBattery3";
import { definition as xI2 } from "@fortawesome/free-solid-svg-icons/faBattery3";
import { definition as HT } from "@fortawesome/free-solid-svg-icons/faBattery4";
import { definition as aK2 } from "@fortawesome/free-solid-svg-icons/faBattery4";
import { definition as RT } from "@fortawesome/free-solid-svg-icons/faBattery5";
import { definition as nK2 } from "@fortawesome/free-solid-svg-icons/faBattery5";
import { definition as UT } from "@fortawesome/free-solid-svg-icons/faBatteryCar";
import { definition as cK2 } from "@fortawesome/free-solid-svg-icons/faBatteryCar";
import { definition as qT } from "@fortawesome/free-solid-svg-icons/faBatteryEmpty";
import { definition as oK2 } from "@fortawesome/free-solid-svg-icons/faBatteryEmpty";
import { definition as GT } from "@fortawesome/free-solid-svg-icons/faBatteryFull";
import { definition as dK2 } from "@fortawesome/free-solid-svg-icons/faBatteryFull";
import { definition as WT } from "@fortawesome/free-solid-svg-icons/faBatteryHalf";
import { definition as sK2 } from "@fortawesome/free-solid-svg-icons/faBatteryHalf";
import { definition as ET } from "@fortawesome/free-solid-svg-icons/faBatteryQuarter";
import { definition as vK2 } from "@fortawesome/free-solid-svg-icons/faBatteryQuarter";
import { definition as VT } from "@fortawesome/free-solid-svg-icons/faBatteryThreeQuarters";
import { definition as mK2 } from "@fortawesome/free-solid-svg-icons/faBatteryThreeQuarters";
import { definition as IT } from "@fortawesome/free-solid-svg-icons/faBed";
import { definition as PK2 } from "@fortawesome/free-solid-svg-icons/faBed";
import { definition as KT } from "@fortawesome/free-solid-svg-icons/faBedPulse";
import { definition as wK2 } from "@fortawesome/free-solid-svg-icons/faBedPulse";
import { definition as XT } from "@fortawesome/free-solid-svg-icons/faBeer";
import { definition as zK2 } from "@fortawesome/free-solid-svg-icons/faBeer";
import { definition as QT } from "@fortawesome/free-solid-svg-icons/faBeerMugEmpty";
import { definition as CK2 } from "@fortawesome/free-solid-svg-icons/faBeerMugEmpty";
import { definition as JT } from "@fortawesome/free-solid-svg-icons/faBell";
import { definition as $K2 } from "@fortawesome/free-solid-svg-icons/faBell";
import { definition as YT } from "@fortawesome/free-solid-svg-icons/faBellConcierge";
import { definition as bK2 } from "@fortawesome/free-solid-svg-icons/faBellConcierge";
import { definition as ZT } from "@fortawesome/free-solid-svg-icons/faBellSlash";
import { definition as yK2 } from "@fortawesome/free-solid-svg-icons/faBellSlash";
import { definition as pT } from "@fortawesome/free-solid-svg-icons/faBezierCurve";
import { definition as kK2 } from "@fortawesome/free-solid-svg-icons/faBezierCurve";
import { definition as xT } from "@fortawesome/free-solid-svg-icons/faBible";
import { definition as jK2 } from "@fortawesome/free-solid-svg-icons/faBible";
import { definition as iF } from "@fortawesome/free-solid-svg-icons/faBicycle";
import { definition as TK2 } from "@fortawesome/free-solid-svg-icons/faBicycle";
import { definition as aF } from "@fortawesome/free-solid-svg-icons/faBiking";
import { definition as HK2 } from "@fortawesome/free-solid-svg-icons/faBiking";
import { definition as eF } from "@fortawesome/free-solid-svg-icons/faBinoculars";
import { definition as UK2 } from "@fortawesome/free-solid-svg-icons/faBinoculars";
import { definition as nF } from "@fortawesome/free-solid-svg-icons/faBiohazard";
import { definition as GK2 } from "@fortawesome/free-solid-svg-icons/faBiohazard";
import { definition as fF } from "@fortawesome/free-solid-svg-icons/faBirthdayCake";
import { definition as EK2 } from "@fortawesome/free-solid-svg-icons/faBirthdayCake";
import { definition as cF } from "@fortawesome/free-solid-svg-icons/faBitcoinSign";
import { definition as IK2 } from "@fortawesome/free-solid-svg-icons/faBitcoinSign";
import { definition as tF } from "@fortawesome/free-solid-svg-icons/faBlackboard";
import { definition as XK2 } from "@fortawesome/free-solid-svg-icons/faBlackboard";
import { definition as oF } from "@fortawesome/free-solid-svg-icons/faBlender";
import { definition as JK2 } from "@fortawesome/free-solid-svg-icons/faBlender";
import { definition as lF } from "@fortawesome/free-solid-svg-icons/faBlenderPhone";
import { definition as ZK2 } from "@fortawesome/free-solid-svg-icons/faBlenderPhone";
import { definition as dF } from "@fortawesome/free-solid-svg-icons/faBlind";
import { definition as xK2 } from "@fortawesome/free-solid-svg-icons/faBlind";
import { definition as rF } from "@fortawesome/free-solid-svg-icons/faBlog";
import { definition as aX2 } from "@fortawesome/free-solid-svg-icons/faBlog";
import { definition as sF } from "@fortawesome/free-solid-svg-icons/faBold";
import { definition as nX2 } from "@fortawesome/free-solid-svg-icons/faBold";
import { definition as hF } from "@fortawesome/free-solid-svg-icons/faBolt";
import { definition as cX2 } from "@fortawesome/free-solid-svg-icons/faBolt";
import { definition as vF } from "@fortawesome/free-solid-svg-icons/faBoltLightning";
import { definition as oX2 } from "@fortawesome/free-solid-svg-icons/faBoltLightning";
import { definition as uF } from "@fortawesome/free-solid-svg-icons/faBomb";
import { definition as dX2 } from "@fortawesome/free-solid-svg-icons/faBomb";
import { definition as mF } from "@fortawesome/free-solid-svg-icons/faBone";
import { definition as sX2 } from "@fortawesome/free-solid-svg-icons/faBone";
import { definition as gF } from "@fortawesome/free-solid-svg-icons/faBong";
import { definition as vX2 } from "@fortawesome/free-solid-svg-icons/faBong";
import { definition as PF } from "@fortawesome/free-solid-svg-icons/faBook";
import { definition as mX2 } from "@fortawesome/free-solid-svg-icons/faBook";
import { definition as MF } from "@fortawesome/free-solid-svg-icons/faBookAtlas";
import { definition as PX2 } from "@fortawesome/free-solid-svg-icons/faBookAtlas";
import { definition as wF } from "@fortawesome/free-solid-svg-icons/faBookBible";
import { definition as wX2 } from "@fortawesome/free-solid-svg-icons/faBookBible";
import { definition as NF } from "@fortawesome/free-solid-svg-icons/faBookBookmark";
import { definition as zX2 } from "@fortawesome/free-solid-svg-icons/faBookBookmark";
import { definition as zF } from "@fortawesome/free-solid-svg-icons/faBookDead";
import { definition as CX2 } from "@fortawesome/free-solid-svg-icons/faBookDead";
import { definition as LF } from "@fortawesome/free-solid-svg-icons/faBookJournalWhills";
import { definition as $X2 } from "@fortawesome/free-solid-svg-icons/faBookJournalWhills";
import { definition as CF } from "@fortawesome/free-solid-svg-icons/faBookMedical";
import { definition as bX2 } from "@fortawesome/free-solid-svg-icons/faBookMedical";
import { definition as DF } from "@fortawesome/free-solid-svg-icons/faBookOpen";
import { definition as yX2 } from "@fortawesome/free-solid-svg-icons/faBookOpen";
import { definition as $F } from "@fortawesome/free-solid-svg-icons/faBookOpenReader";
import { definition as kX2 } from "@fortawesome/free-solid-svg-icons/faBookOpenReader";
import { definition as _F } from "@fortawesome/free-solid-svg-icons/faBookQuran";
import { definition as jX2 } from "@fortawesome/free-solid-svg-icons/faBookQuran";
import { definition as bF } from "@fortawesome/free-solid-svg-icons/faBookReader";
import { definition as TX2 } from "@fortawesome/free-solid-svg-icons/faBookReader";
import { definition as SF } from "@fortawesome/free-solid-svg-icons/faBookSkull";
import { definition as HX2 } from "@fortawesome/free-solid-svg-icons/faBookSkull";
import { definition as yF } from "@fortawesome/free-solid-svg-icons/faBookTanakh";
import { definition as UX2 } from "@fortawesome/free-solid-svg-icons/faBookTanakh";
import { definition as OF } from "@fortawesome/free-solid-svg-icons/faBookmark";
import { definition as GX2 } from "@fortawesome/free-solid-svg-icons/faBookmark";
import { definition as kF } from "@fortawesome/free-solid-svg-icons/faBorderAll";
import { definition as EX2 } from "@fortawesome/free-solid-svg-icons/faBorderAll";
import { definition as AF } from "@fortawesome/free-solid-svg-icons/faBorderNone";
import { definition as IX2 } from "@fortawesome/free-solid-svg-icons/faBorderNone";
import { definition as jF } from "@fortawesome/free-solid-svg-icons/faBorderStyle";
import { definition as XX2 } from "@fortawesome/free-solid-svg-icons/faBorderStyle";
import { definition as BF } from "@fortawesome/free-solid-svg-icons/faBorderTopLeft";
import { definition as JX2 } from "@fortawesome/free-solid-svg-icons/faBorderTopLeft";
import { definition as TF } from "@fortawesome/free-solid-svg-icons/faBoreHole";
import { definition as ZX2 } from "@fortawesome/free-solid-svg-icons/faBoreHole";
import { definition as FF } from "@fortawesome/free-solid-svg-icons/faBottleDroplet";
import { definition as xX2 } from "@fortawesome/free-solid-svg-icons/faBottleDroplet";
import { definition as HF } from "@fortawesome/free-solid-svg-icons/faBottleWater";
import { definition as aQ2 } from "@fortawesome/free-solid-svg-icons/faBottleWater";
import { definition as RF } from "@fortawesome/free-solid-svg-icons/faBowlFood";
import { definition as nQ2 } from "@fortawesome/free-solid-svg-icons/faBowlFood";
import { definition as UF } from "@fortawesome/free-solid-svg-icons/faBowlRice";
import { definition as cQ2 } from "@fortawesome/free-solid-svg-icons/faBowlRice";
import { definition as qF } from "@fortawesome/free-solid-svg-icons/faBowlingBall";
import { definition as oQ2 } from "@fortawesome/free-solid-svg-icons/faBowlingBall";
import { definition as GF } from "@fortawesome/free-solid-svg-icons/faBox";
import { definition as dQ2 } from "@fortawesome/free-solid-svg-icons/faBox";
import { definition as WF } from "@fortawesome/free-solid-svg-icons/faBoxArchive";
import { definition as sQ2 } from "@fortawesome/free-solid-svg-icons/faBoxArchive";
import { definition as EF } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import { definition as vQ2 } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import { definition as VF } from "@fortawesome/free-solid-svg-icons/faBoxTissue";
import { definition as mQ2 } from "@fortawesome/free-solid-svg-icons/faBoxTissue";
import { definition as IF } from "@fortawesome/free-solid-svg-icons/faBoxes";
import { definition as PQ2 } from "@fortawesome/free-solid-svg-icons/faBoxes";
import { definition as KF } from "@fortawesome/free-solid-svg-icons/faBoxesAlt";
import { definition as wQ2 } from "@fortawesome/free-solid-svg-icons/faBoxesAlt";
import { definition as XF } from "@fortawesome/free-solid-svg-icons/faBoxesPacking";
import { definition as zQ2 } from "@fortawesome/free-solid-svg-icons/faBoxesPacking";
import { definition as QF } from "@fortawesome/free-solid-svg-icons/faBoxesStacked";
import { definition as CQ2 } from "@fortawesome/free-solid-svg-icons/faBoxesStacked";
import { definition as JF } from "@fortawesome/free-solid-svg-icons/faBraille";
import { definition as $Q2 } from "@fortawesome/free-solid-svg-icons/faBraille";
import { definition as YF } from "@fortawesome/free-solid-svg-icons/faBrain";
import { definition as bQ2 } from "@fortawesome/free-solid-svg-icons/faBrain";
import { definition as ZF } from "@fortawesome/free-solid-svg-icons/faBrazilianRealSign";
import { definition as yQ2 } from "@fortawesome/free-solid-svg-icons/faBrazilianRealSign";
import { definition as pF } from "@fortawesome/free-solid-svg-icons/faBreadSlice";
import { definition as kQ2 } from "@fortawesome/free-solid-svg-icons/faBreadSlice";
import { definition as xF } from "@fortawesome/free-solid-svg-icons/faBridge";
import { definition as jQ2 } from "@fortawesome/free-solid-svg-icons/faBridge";
import { definition as iH } from "@fortawesome/free-solid-svg-icons/faBridgeCircleCheck";
import { definition as TQ2 } from "@fortawesome/free-solid-svg-icons/faBridgeCircleCheck";
import { definition as aH } from "@fortawesome/free-solid-svg-icons/faBridgeCircleExclamation";
import { definition as HQ2 } from "@fortawesome/free-solid-svg-icons/faBridgeCircleExclamation";
import { definition as eH } from "@fortawesome/free-solid-svg-icons/faBridgeCircleXmark";
import { definition as UQ2 } from "@fortawesome/free-solid-svg-icons/faBridgeCircleXmark";
import { definition as nH } from "@fortawesome/free-solid-svg-icons/faBridgeLock";
import { definition as GQ2 } from "@fortawesome/free-solid-svg-icons/faBridgeLock";
import { definition as fH } from "@fortawesome/free-solid-svg-icons/faBridgeWater";
import { definition as EQ2 } from "@fortawesome/free-solid-svg-icons/faBridgeWater";
import { definition as cH } from "@fortawesome/free-solid-svg-icons/faBriefcase";
import { definition as IQ2 } from "@fortawesome/free-solid-svg-icons/faBriefcase";
import { definition as tH } from "@fortawesome/free-solid-svg-icons/faBriefcaseClock";
import { definition as XQ2 } from "@fortawesome/free-solid-svg-icons/faBriefcaseClock";
import { definition as oH } from "@fortawesome/free-solid-svg-icons/faBriefcaseMedical";
import { definition as JQ2 } from "@fortawesome/free-solid-svg-icons/faBriefcaseMedical";
import { definition as lH } from "@fortawesome/free-solid-svg-icons/faBroadcastTower";
import { definition as ZQ2 } from "@fortawesome/free-solid-svg-icons/faBroadcastTower";
import { definition as dH } from "@fortawesome/free-solid-svg-icons/faBroom";
import { definition as xQ2 } from "@fortawesome/free-solid-svg-icons/faBroom";
import { definition as rH } from "@fortawesome/free-solid-svg-icons/faBroomBall";
import { definition as aJ2 } from "@fortawesome/free-solid-svg-icons/faBroomBall";
import { definition as sH } from "@fortawesome/free-solid-svg-icons/faBrush";
import { definition as nJ2 } from "@fortawesome/free-solid-svg-icons/faBrush";
import { definition as hH } from "@fortawesome/free-solid-svg-icons/faBucket";
import { definition as cJ2 } from "@fortawesome/free-solid-svg-icons/faBucket";
import { definition as vH } from "@fortawesome/free-solid-svg-icons/faBug";
import { definition as oJ2 } from "@fortawesome/free-solid-svg-icons/faBug";
import { definition as uH } from "@fortawesome/free-solid-svg-icons/faBugSlash";
import { definition as dJ2 } from "@fortawesome/free-solid-svg-icons/faBugSlash";
import { definition as mH } from "@fortawesome/free-solid-svg-icons/faBugs";
import { definition as sJ2 } from "@fortawesome/free-solid-svg-icons/faBugs";
import { definition as gH } from "@fortawesome/free-solid-svg-icons/faBuilding";
import { definition as vJ2 } from "@fortawesome/free-solid-svg-icons/faBuilding";
import { definition as PH } from "@fortawesome/free-solid-svg-icons/faBuildingCircleArrowRight";
import { definition as mJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingCircleArrowRight";
import { definition as MH } from "@fortawesome/free-solid-svg-icons/faBuildingCircleCheck";
import { definition as PJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingCircleCheck";
import { definition as wH } from "@fortawesome/free-solid-svg-icons/faBuildingCircleExclamation";
import { definition as wJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingCircleExclamation";
import { definition as NH } from "@fortawesome/free-solid-svg-icons/faBuildingCircleXmark";
import { definition as zJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingCircleXmark";
import { definition as zH } from "@fortawesome/free-solid-svg-icons/faBuildingColumns";
import { definition as CJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingColumns";
import { definition as LH } from "@fortawesome/free-solid-svg-icons/faBuildingFlag";
import { definition as $J2 } from "@fortawesome/free-solid-svg-icons/faBuildingFlag";
import { definition as CH } from "@fortawesome/free-solid-svg-icons/faBuildingLock";
import { definition as bJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingLock";
import { definition as DH } from "@fortawesome/free-solid-svg-icons/faBuildingNgo";
import { definition as yJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingNgo";
import { definition as $H } from "@fortawesome/free-solid-svg-icons/faBuildingShield";
import { definition as kJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingShield";
import { definition as _H } from "@fortawesome/free-solid-svg-icons/faBuildingUn";
import { definition as jJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingUn";
import { definition as bH } from "@fortawesome/free-solid-svg-icons/faBuildingUser";
import { definition as TJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingUser";
import { definition as SH } from "@fortawesome/free-solid-svg-icons/faBuildingWheat";
import { definition as HJ2 } from "@fortawesome/free-solid-svg-icons/faBuildingWheat";
import { definition as yH } from "@fortawesome/free-solid-svg-icons/faBullhorn";
import { definition as UJ2 } from "@fortawesome/free-solid-svg-icons/faBullhorn";
import { definition as OH } from "@fortawesome/free-solid-svg-icons/faBullseye";
import { definition as GJ2 } from "@fortawesome/free-solid-svg-icons/faBullseye";
import { definition as kH } from "@fortawesome/free-solid-svg-icons/faBurger";
import { definition as EJ2 } from "@fortawesome/free-solid-svg-icons/faBurger";
import { definition as AH } from "@fortawesome/free-solid-svg-icons/faBurn";
import { definition as IJ2 } from "@fortawesome/free-solid-svg-icons/faBurn";
import { definition as jH } from "@fortawesome/free-solid-svg-icons/faBurst";
import { definition as XJ2 } from "@fortawesome/free-solid-svg-icons/faBurst";
import { definition as BH } from "@fortawesome/free-solid-svg-icons/faBus";
import { definition as JJ2 } from "@fortawesome/free-solid-svg-icons/faBus";
import { definition as TH } from "@fortawesome/free-solid-svg-icons/faBusAlt";
import { definition as ZJ2 } from "@fortawesome/free-solid-svg-icons/faBusAlt";
import { definition as FH } from "@fortawesome/free-solid-svg-icons/faBusSimple";
import { definition as xJ2 } from "@fortawesome/free-solid-svg-icons/faBusSimple";
import { definition as HH } from "@fortawesome/free-solid-svg-icons/faBusinessTime";
import { definition as aY2 } from "@fortawesome/free-solid-svg-icons/faBusinessTime";
import { definition as RH } from "@fortawesome/free-solid-svg-icons/faC";
import { definition as nY2 } from "@fortawesome/free-solid-svg-icons/faC";
import { definition as UH } from "@fortawesome/free-solid-svg-icons/faCab";
import { definition as cY2 } from "@fortawesome/free-solid-svg-icons/faCab";
import { definition as qH } from "@fortawesome/free-solid-svg-icons/faCableCar";
import { definition as oY2 } from "@fortawesome/free-solid-svg-icons/faCableCar";
import { definition as GH } from "@fortawesome/free-solid-svg-icons/faCake";
import { definition as dY2 } from "@fortawesome/free-solid-svg-icons/faCake";
import { definition as WH } from "@fortawesome/free-solid-svg-icons/faCakeCandles";
import { definition as sY2 } from "@fortawesome/free-solid-svg-icons/faCakeCandles";
import { definition as EH } from "@fortawesome/free-solid-svg-icons/faCalculator";
import { definition as vY2 } from "@fortawesome/free-solid-svg-icons/faCalculator";
import { definition as VH } from "@fortawesome/free-solid-svg-icons/faCalendar";
import { definition as mY2 } from "@fortawesome/free-solid-svg-icons/faCalendar";
import { definition as IH } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { definition as PY2 } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { definition as KH } from "@fortawesome/free-solid-svg-icons/faCalendarCheck";
import { definition as wY2 } from "@fortawesome/free-solid-svg-icons/faCalendarCheck";
import { definition as XH } from "@fortawesome/free-solid-svg-icons/faCalendarDay";
import { definition as zY2 } from "@fortawesome/free-solid-svg-icons/faCalendarDay";
import { definition as QH } from "@fortawesome/free-solid-svg-icons/faCalendarDays";
import { definition as CY2 } from "@fortawesome/free-solid-svg-icons/faCalendarDays";
import { definition as JH } from "@fortawesome/free-solid-svg-icons/faCalendarMinus";
import { definition as $Y2 } from "@fortawesome/free-solid-svg-icons/faCalendarMinus";
import { definition as YH } from "@fortawesome/free-solid-svg-icons/faCalendarPlus";
import { definition as bY2 } from "@fortawesome/free-solid-svg-icons/faCalendarPlus";
import { definition as ZH } from "@fortawesome/free-solid-svg-icons/faCalendarTimes";
import { definition as yY2 } from "@fortawesome/free-solid-svg-icons/faCalendarTimes";
import { definition as pH } from "@fortawesome/free-solid-svg-icons/faCalendarWeek";
import { definition as kY2 } from "@fortawesome/free-solid-svg-icons/faCalendarWeek";
import { definition as xH } from "@fortawesome/free-solid-svg-icons/faCalendarXmark";
import { definition as jY2 } from "@fortawesome/free-solid-svg-icons/faCalendarXmark";
import { definition as iR } from "@fortawesome/free-solid-svg-icons/faCamera";
import { definition as TY2 } from "@fortawesome/free-solid-svg-icons/faCamera";
import { definition as aR } from "@fortawesome/free-solid-svg-icons/faCameraAlt";
import { definition as HY2 } from "@fortawesome/free-solid-svg-icons/faCameraAlt";
import { definition as eR } from "@fortawesome/free-solid-svg-icons/faCameraRetro";
import { definition as UY2 } from "@fortawesome/free-solid-svg-icons/faCameraRetro";
import { definition as nR } from "@fortawesome/free-solid-svg-icons/faCameraRotate";
import { definition as GY2 } from "@fortawesome/free-solid-svg-icons/faCameraRotate";
import { definition as fR } from "@fortawesome/free-solid-svg-icons/faCampground";
import { definition as EY2 } from "@fortawesome/free-solid-svg-icons/faCampground";
import { definition as cR } from "@fortawesome/free-solid-svg-icons/faCancel";
import { definition as IY2 } from "@fortawesome/free-solid-svg-icons/faCancel";
import { definition as tR } from "@fortawesome/free-solid-svg-icons/faCandyCane";
import { definition as XY2 } from "@fortawesome/free-solid-svg-icons/faCandyCane";
import { definition as oR } from "@fortawesome/free-solid-svg-icons/faCannabis";
import { definition as JY2 } from "@fortawesome/free-solid-svg-icons/faCannabis";
import { definition as lR } from "@fortawesome/free-solid-svg-icons/faCapsules";
import { definition as ZY2 } from "@fortawesome/free-solid-svg-icons/faCapsules";
import { definition as dR } from "@fortawesome/free-solid-svg-icons/faCar";
import { definition as xY2 } from "@fortawesome/free-solid-svg-icons/faCar";
import { definition as rR } from "@fortawesome/free-solid-svg-icons/faCarAlt";
import { definition as aZ2 } from "@fortawesome/free-solid-svg-icons/faCarAlt";
import { definition as sR } from "@fortawesome/free-solid-svg-icons/faCarBattery";
import { definition as nZ2 } from "@fortawesome/free-solid-svg-icons/faCarBattery";
import { definition as hR } from "@fortawesome/free-solid-svg-icons/faCarBurst";
import { definition as cZ2 } from "@fortawesome/free-solid-svg-icons/faCarBurst";
import { definition as vR } from "@fortawesome/free-solid-svg-icons/faCarCrash";
import { definition as oZ2 } from "@fortawesome/free-solid-svg-icons/faCarCrash";
import { definition as uR } from "@fortawesome/free-solid-svg-icons/faCarOn";
import { definition as dZ2 } from "@fortawesome/free-solid-svg-icons/faCarOn";
import { definition as mR } from "@fortawesome/free-solid-svg-icons/faCarRear";
import { definition as sZ2 } from "@fortawesome/free-solid-svg-icons/faCarRear";
import { definition as gR } from "@fortawesome/free-solid-svg-icons/faCarSide";
import { definition as vZ2 } from "@fortawesome/free-solid-svg-icons/faCarSide";
import { definition as PR } from "@fortawesome/free-solid-svg-icons/faCarTunnel";
import { definition as mZ2 } from "@fortawesome/free-solid-svg-icons/faCarTunnel";
import { definition as MR } from "@fortawesome/free-solid-svg-icons/faCaravan";
import { definition as PZ2 } from "@fortawesome/free-solid-svg-icons/faCaravan";
import { definition as wR } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { definition as wZ2 } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { definition as NR } from "@fortawesome/free-solid-svg-icons/faCaretLeft";
import { definition as zZ2 } from "@fortawesome/free-solid-svg-icons/faCaretLeft";
import { definition as zR } from "@fortawesome/free-solid-svg-icons/faCaretRight";
import { definition as CZ2 } from "@fortawesome/free-solid-svg-icons/faCaretRight";
import { definition as LR } from "@fortawesome/free-solid-svg-icons/faCaretSquareDown";
import { definition as $Z2 } from "@fortawesome/free-solid-svg-icons/faCaretSquareDown";
import { definition as CR } from "@fortawesome/free-solid-svg-icons/faCaretSquareLeft";
import { definition as bZ2 } from "@fortawesome/free-solid-svg-icons/faCaretSquareLeft";
import { definition as DR } from "@fortawesome/free-solid-svg-icons/faCaretSquareRight";
import { definition as yZ2 } from "@fortawesome/free-solid-svg-icons/faCaretSquareRight";
import { definition as $R } from "@fortawesome/free-solid-svg-icons/faCaretSquareUp";
import { definition as kZ2 } from "@fortawesome/free-solid-svg-icons/faCaretSquareUp";
import { definition as _R } from "@fortawesome/free-solid-svg-icons/faCaretUp";
import { definition as jZ2 } from "@fortawesome/free-solid-svg-icons/faCaretUp";
import { definition as bR } from "@fortawesome/free-solid-svg-icons/faCarriageBaby";
import { definition as TZ2 } from "@fortawesome/free-solid-svg-icons/faCarriageBaby";
import { definition as SR } from "@fortawesome/free-solid-svg-icons/faCarrot";
import { definition as HZ2 } from "@fortawesome/free-solid-svg-icons/faCarrot";
import { definition as yR } from "@fortawesome/free-solid-svg-icons/faCartArrowDown";
import { definition as UZ2 } from "@fortawesome/free-solid-svg-icons/faCartArrowDown";
import { definition as OR } from "@fortawesome/free-solid-svg-icons/faCartFlatbed";
import { definition as GZ2 } from "@fortawesome/free-solid-svg-icons/faCartFlatbed";
import { definition as kR } from "@fortawesome/free-solid-svg-icons/faCartFlatbedSuitcase";
import { definition as EZ2 } from "@fortawesome/free-solid-svg-icons/faCartFlatbedSuitcase";
import { definition as AR } from "@fortawesome/free-solid-svg-icons/faCartPlus";
import { definition as IZ2 } from "@fortawesome/free-solid-svg-icons/faCartPlus";
import { definition as jR } from "@fortawesome/free-solid-svg-icons/faCartShopping";
import { definition as XZ2 } from "@fortawesome/free-solid-svg-icons/faCartShopping";
import { definition as BR } from "@fortawesome/free-solid-svg-icons/faCashRegister";
import { definition as JZ2 } from "@fortawesome/free-solid-svg-icons/faCashRegister";
import { definition as TR } from "@fortawesome/free-solid-svg-icons/faCat";
import { definition as ZZ2 } from "@fortawesome/free-solid-svg-icons/faCat";
import { definition as FR } from "@fortawesome/free-solid-svg-icons/faCediSign";
import { definition as xZ2 } from "@fortawesome/free-solid-svg-icons/faCediSign";
import { definition as HR } from "@fortawesome/free-solid-svg-icons/faCentSign";
import { definition as ap2 } from "@fortawesome/free-solid-svg-icons/faCentSign";
import { definition as RR } from "@fortawesome/free-solid-svg-icons/faCertificate";
import { definition as np2 } from "@fortawesome/free-solid-svg-icons/faCertificate";
import { definition as UR } from "@fortawesome/free-solid-svg-icons/faChain";
import { definition as cp2 } from "@fortawesome/free-solid-svg-icons/faChain";
import { definition as qR } from "@fortawesome/free-solid-svg-icons/faChainBroken";
import { definition as op2 } from "@fortawesome/free-solid-svg-icons/faChainBroken";
import { definition as GR } from "@fortawesome/free-solid-svg-icons/faChainSlash";
import { definition as dp2 } from "@fortawesome/free-solid-svg-icons/faChainSlash";
import { definition as WR } from "@fortawesome/free-solid-svg-icons/faChair";
import { definition as sp2 } from "@fortawesome/free-solid-svg-icons/faChair";
import { definition as ER } from "@fortawesome/free-solid-svg-icons/faChalkboard";
import { definition as vp2 } from "@fortawesome/free-solid-svg-icons/faChalkboard";
import { definition as VR } from "@fortawesome/free-solid-svg-icons/faChalkboardTeacher";
import { definition as mp2 } from "@fortawesome/free-solid-svg-icons/faChalkboardTeacher";
import { definition as IR } from "@fortawesome/free-solid-svg-icons/faChalkboardUser";
import { definition as Pp2 } from "@fortawesome/free-solid-svg-icons/faChalkboardUser";
import { definition as KR } from "@fortawesome/free-solid-svg-icons/faChampagneGlasses";
import { definition as wp2 } from "@fortawesome/free-solid-svg-icons/faChampagneGlasses";
import { definition as XR } from "@fortawesome/free-solid-svg-icons/faChargingStation";
import { definition as zp2 } from "@fortawesome/free-solid-svg-icons/faChargingStation";
import { definition as QR } from "@fortawesome/free-solid-svg-icons/faChartArea";
import { definition as Cp2 } from "@fortawesome/free-solid-svg-icons/faChartArea";
import { definition as JR } from "@fortawesome/free-solid-svg-icons/faChartBar";
import { definition as $p2 } from "@fortawesome/free-solid-svg-icons/faChartBar";
import { definition as YR } from "@fortawesome/free-solid-svg-icons/faChartColumn";
import { definition as bp2 } from "@fortawesome/free-solid-svg-icons/faChartColumn";
import { definition as ZR } from "@fortawesome/free-solid-svg-icons/faChartGantt";
import { definition as yp2 } from "@fortawesome/free-solid-svg-icons/faChartGantt";
import { definition as pR } from "@fortawesome/free-solid-svg-icons/faChartLine";
import { definition as kp2 } from "@fortawesome/free-solid-svg-icons/faChartLine";
import { definition as xR } from "@fortawesome/free-solid-svg-icons/faChartPie";
import { definition as jp2 } from "@fortawesome/free-solid-svg-icons/faChartPie";
import { definition as iU } from "@fortawesome/free-solid-svg-icons/faChartSimple";
import { definition as Tp2 } from "@fortawesome/free-solid-svg-icons/faChartSimple";
import { definition as aU } from "@fortawesome/free-solid-svg-icons/faCheck";
import { definition as Hp2 } from "@fortawesome/free-solid-svg-icons/faCheck";
import { definition as eU } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { definition as Up2 } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { definition as nU } from "@fortawesome/free-solid-svg-icons/faCheckDouble";
import { definition as Gp2 } from "@fortawesome/free-solid-svg-icons/faCheckDouble";
import { definition as fU } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
import { definition as Ep2 } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
import { definition as cU } from "@fortawesome/free-solid-svg-icons/faCheckToSlot";
import { definition as Ip2 } from "@fortawesome/free-solid-svg-icons/faCheckToSlot";
import { definition as tU } from "@fortawesome/free-solid-svg-icons/faCheese";
import { definition as Xp2 } from "@fortawesome/free-solid-svg-icons/faCheese";
import { definition as oU } from "@fortawesome/free-solid-svg-icons/faChess";
import { definition as Jp2 } from "@fortawesome/free-solid-svg-icons/faChess";
import { definition as lU } from "@fortawesome/free-solid-svg-icons/faChessBishop";
import { definition as Zp2 } from "@fortawesome/free-solid-svg-icons/faChessBishop";
import { definition as dU } from "@fortawesome/free-solid-svg-icons/faChessBoard";
import { definition as xp2 } from "@fortawesome/free-solid-svg-icons/faChessBoard";
import { definition as rU } from "@fortawesome/free-solid-svg-icons/faChessKing";
import { definition as ax2 } from "@fortawesome/free-solid-svg-icons/faChessKing";
import { definition as sU } from "@fortawesome/free-solid-svg-icons/faChessKnight";
import { definition as nx2 } from "@fortawesome/free-solid-svg-icons/faChessKnight";
import { definition as hU } from "@fortawesome/free-solid-svg-icons/faChessPawn";
import { definition as cx2 } from "@fortawesome/free-solid-svg-icons/faChessPawn";
import { definition as vU } from "@fortawesome/free-solid-svg-icons/faChessQueen";
import { definition as ox2 } from "@fortawesome/free-solid-svg-icons/faChessQueen";
import { definition as uU } from "@fortawesome/free-solid-svg-icons/faChessRook";
import { definition as dx2 } from "@fortawesome/free-solid-svg-icons/faChessRook";
import { definition as mU } from "@fortawesome/free-solid-svg-icons/faChevronCircleDown";
import { definition as sx2 } from "@fortawesome/free-solid-svg-icons/faChevronCircleDown";
import { definition as gU } from "@fortawesome/free-solid-svg-icons/faChevronCircleLeft";
import { definition as vx2 } from "@fortawesome/free-solid-svg-icons/faChevronCircleLeft";
import { definition as PU } from "@fortawesome/free-solid-svg-icons/faChevronCircleRight";
import { definition as mx2 } from "@fortawesome/free-solid-svg-icons/faChevronCircleRight";
import { definition as MU } from "@fortawesome/free-solid-svg-icons/faChevronCircleUp";
import { definition as Px2 } from "@fortawesome/free-solid-svg-icons/faChevronCircleUp";
import { definition as wU } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { definition as wx2 } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { definition as NU } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { definition as zx2 } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { definition as zU } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { definition as Cx2 } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { definition as LU } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { definition as $x2 } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { definition as CU } from "@fortawesome/free-solid-svg-icons/faChild";
import { definition as bx2 } from "@fortawesome/free-solid-svg-icons/faChild";
import { definition as DU } from "@fortawesome/free-solid-svg-icons/faChildCombatant";
import { definition as yx2 } from "@fortawesome/free-solid-svg-icons/faChildCombatant";
import { definition as $U } from "@fortawesome/free-solid-svg-icons/faChildDress";
import { definition as kx2 } from "@fortawesome/free-solid-svg-icons/faChildDress";
import { definition as _U } from "@fortawesome/free-solid-svg-icons/faChildReaching";
import { definition as jx2 } from "@fortawesome/free-solid-svg-icons/faChildReaching";
import { definition as bU } from "@fortawesome/free-solid-svg-icons/faChildRifle";
import { definition as Tx2 } from "@fortawesome/free-solid-svg-icons/faChildRifle";
import { definition as SU } from "@fortawesome/free-solid-svg-icons/faChildren";
import { definition as Hx2 } from "@fortawesome/free-solid-svg-icons/faChildren";
import { definition as yU } from "@fortawesome/free-solid-svg-icons/faChurch";
import { definition as Ux2 } from "@fortawesome/free-solid-svg-icons/faChurch";
import { definition as OU } from "@fortawesome/free-solid-svg-icons/faCircle";
import { definition as Gx2 } from "@fortawesome/free-solid-svg-icons/faCircle";
import { definition as kU } from "@fortawesome/free-solid-svg-icons/faCircleArrowDown";
import { definition as Ex2 } from "@fortawesome/free-solid-svg-icons/faCircleArrowDown";
import { definition as AU } from "@fortawesome/free-solid-svg-icons/faCircleArrowLeft";
import { definition as Ix2 } from "@fortawesome/free-solid-svg-icons/faCircleArrowLeft";
import { definition as jU } from "@fortawesome/free-solid-svg-icons/faCircleArrowRight";
import { definition as Xx2 } from "@fortawesome/free-solid-svg-icons/faCircleArrowRight";
import { definition as BU } from "@fortawesome/free-solid-svg-icons/faCircleArrowUp";
import { definition as Jx2 } from "@fortawesome/free-solid-svg-icons/faCircleArrowUp";
import { definition as TU } from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import { definition as Zx2 } from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import { definition as FU } from "@fortawesome/free-solid-svg-icons/faCircleChevronDown";
import { definition as xx2 } from "@fortawesome/free-solid-svg-icons/faCircleChevronDown";
import { definition as HU } from "@fortawesome/free-solid-svg-icons/faCircleChevronLeft";
import { definition as ai1 } from "@fortawesome/free-solid-svg-icons/faCircleChevronLeft";
import { definition as RU } from "@fortawesome/free-solid-svg-icons/faCircleChevronRight";
import { definition as ni1 } from "@fortawesome/free-solid-svg-icons/faCircleChevronRight";
import { definition as UU } from "@fortawesome/free-solid-svg-icons/faCircleChevronUp";
import { definition as ci1 } from "@fortawesome/free-solid-svg-icons/faCircleChevronUp";
import { definition as qU } from "@fortawesome/free-solid-svg-icons/faCircleDollarToSlot";
import { definition as oi1 } from "@fortawesome/free-solid-svg-icons/faCircleDollarToSlot";
import { definition as GU } from "@fortawesome/free-solid-svg-icons/faCircleDot";
import { definition as di1 } from "@fortawesome/free-solid-svg-icons/faCircleDot";
import { definition as WU } from "@fortawesome/free-solid-svg-icons/faCircleDown";
import { definition as si1 } from "@fortawesome/free-solid-svg-icons/faCircleDown";
import { definition as EU } from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import { definition as vi1 } from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import { definition as VU } from "@fortawesome/free-solid-svg-icons/faCircleH";
import { definition as mi1 } from "@fortawesome/free-solid-svg-icons/faCircleH";
import { definition as IU } from "@fortawesome/free-solid-svg-icons/faCircleHalfStroke";
import { definition as Pi1 } from "@fortawesome/free-solid-svg-icons/faCircleHalfStroke";
import { definition as KU } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { definition as wi1 } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { definition as XU } from "@fortawesome/free-solid-svg-icons/faCircleLeft";
import { definition as zi1 } from "@fortawesome/free-solid-svg-icons/faCircleLeft";
import { definition as QU } from "@fortawesome/free-solid-svg-icons/faCircleMinus";
import { definition as Ci1 } from "@fortawesome/free-solid-svg-icons/faCircleMinus";
import { definition as JU } from "@fortawesome/free-solid-svg-icons/faCircleNodes";
import { definition as $i1 } from "@fortawesome/free-solid-svg-icons/faCircleNodes";
import { definition as YU } from "@fortawesome/free-solid-svg-icons/faCircleNotch";
import { definition as bi1 } from "@fortawesome/free-solid-svg-icons/faCircleNotch";
import { definition as ZU } from "@fortawesome/free-solid-svg-icons/faCirclePause";
import { definition as yi1 } from "@fortawesome/free-solid-svg-icons/faCirclePause";
import { definition as pU } from "@fortawesome/free-solid-svg-icons/faCirclePlay";
import { definition as ki1 } from "@fortawesome/free-solid-svg-icons/faCirclePlay";
import { definition as xU } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { definition as ji1 } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { definition as iq } from "@fortawesome/free-solid-svg-icons/faCircleQuestion";
import { definition as Ti1 } from "@fortawesome/free-solid-svg-icons/faCircleQuestion";
import { definition as aq } from "@fortawesome/free-solid-svg-icons/faCircleRadiation";
import { definition as Hi1 } from "@fortawesome/free-solid-svg-icons/faCircleRadiation";
import { definition as eq } from "@fortawesome/free-solid-svg-icons/faCircleRight";
import { definition as Ui1 } from "@fortawesome/free-solid-svg-icons/faCircleRight";
import { definition as nq } from "@fortawesome/free-solid-svg-icons/faCircleStop";
import { definition as Gi1 } from "@fortawesome/free-solid-svg-icons/faCircleStop";
import { definition as fq } from "@fortawesome/free-solid-svg-icons/faCircleUp";
import { definition as Ei1 } from "@fortawesome/free-solid-svg-icons/faCircleUp";
import { definition as cq } from "@fortawesome/free-solid-svg-icons/faCircleUser";
import { definition as Ii1 } from "@fortawesome/free-solid-svg-icons/faCircleUser";
import { definition as tq } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { definition as Xi1 } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { definition as oq } from "@fortawesome/free-solid-svg-icons/faCity";
import { definition as Ji1 } from "@fortawesome/free-solid-svg-icons/faCity";
import { definition as lq } from "@fortawesome/free-solid-svg-icons/faClapperboard";
import { definition as Zi1 } from "@fortawesome/free-solid-svg-icons/faClapperboard";
import { definition as dq } from "@fortawesome/free-solid-svg-icons/faClinicMedical";
import { definition as xi1 } from "@fortawesome/free-solid-svg-icons/faClinicMedical";
import { definition as rq } from "@fortawesome/free-solid-svg-icons/faClipboard";
import { definition as a21 } from "@fortawesome/free-solid-svg-icons/faClipboard";
import { definition as sq } from "@fortawesome/free-solid-svg-icons/faClipboardCheck";
import { definition as n21 } from "@fortawesome/free-solid-svg-icons/faClipboardCheck";
import { definition as hq } from "@fortawesome/free-solid-svg-icons/faClipboardList";
import { definition as c21 } from "@fortawesome/free-solid-svg-icons/faClipboardList";
import { definition as vq } from "@fortawesome/free-solid-svg-icons/faClipboardQuestion";
import { definition as o21 } from "@fortawesome/free-solid-svg-icons/faClipboardQuestion";
import { definition as uq } from "@fortawesome/free-solid-svg-icons/faClipboardUser";
import { definition as d21 } from "@fortawesome/free-solid-svg-icons/faClipboardUser";
import { definition as mq } from "@fortawesome/free-solid-svg-icons/faClock";
import { definition as s21 } from "@fortawesome/free-solid-svg-icons/faClock";
import { definition as gq } from "@fortawesome/free-solid-svg-icons/faClockFour";
import { definition as v21 } from "@fortawesome/free-solid-svg-icons/faClockFour";
import { definition as Pq } from "@fortawesome/free-solid-svg-icons/faClockRotateLeft";
import { definition as m21 } from "@fortawesome/free-solid-svg-icons/faClockRotateLeft";
import { definition as Mq } from "@fortawesome/free-solid-svg-icons/faClone";
import { definition as P21 } from "@fortawesome/free-solid-svg-icons/faClone";
import { definition as wq } from "@fortawesome/free-solid-svg-icons/faClose";
import { definition as w21 } from "@fortawesome/free-solid-svg-icons/faClose";
import { definition as Nq } from "@fortawesome/free-solid-svg-icons/faClosedCaptioning";
import { definition as z21 } from "@fortawesome/free-solid-svg-icons/faClosedCaptioning";
import { definition as zq } from "@fortawesome/free-solid-svg-icons/faCloud";
import { definition as C21 } from "@fortawesome/free-solid-svg-icons/faCloud";
import { definition as Lq } from "@fortawesome/free-solid-svg-icons/faCloudArrowDown";
import { definition as $21 } from "@fortawesome/free-solid-svg-icons/faCloudArrowDown";
import { definition as Cq } from "@fortawesome/free-solid-svg-icons/faCloudArrowUp";
import { definition as b21 } from "@fortawesome/free-solid-svg-icons/faCloudArrowUp";
import { definition as Dq } from "@fortawesome/free-solid-svg-icons/faCloudBolt";
import { definition as y21 } from "@fortawesome/free-solid-svg-icons/faCloudBolt";
import { definition as $q } from "@fortawesome/free-solid-svg-icons/faCloudDownload";
import { definition as k21 } from "@fortawesome/free-solid-svg-icons/faCloudDownload";
import { definition as _q } from "@fortawesome/free-solid-svg-icons/faCloudDownloadAlt";
import { definition as j21 } from "@fortawesome/free-solid-svg-icons/faCloudDownloadAlt";
import { definition as bq } from "@fortawesome/free-solid-svg-icons/faCloudMeatball";
import { definition as T21 } from "@fortawesome/free-solid-svg-icons/faCloudMeatball";
import { definition as Sq } from "@fortawesome/free-solid-svg-icons/faCloudMoon";
import { definition as H21 } from "@fortawesome/free-solid-svg-icons/faCloudMoon";
import { definition as yq } from "@fortawesome/free-solid-svg-icons/faCloudMoonRain";
import { definition as U21 } from "@fortawesome/free-solid-svg-icons/faCloudMoonRain";
import { definition as Oq } from "@fortawesome/free-solid-svg-icons/faCloudRain";
import { definition as G21 } from "@fortawesome/free-solid-svg-icons/faCloudRain";
import { definition as kq } from "@fortawesome/free-solid-svg-icons/faCloudShowersHeavy";
import { definition as E21 } from "@fortawesome/free-solid-svg-icons/faCloudShowersHeavy";
import { definition as Aq } from "@fortawesome/free-solid-svg-icons/faCloudShowersWater";
import { definition as I21 } from "@fortawesome/free-solid-svg-icons/faCloudShowersWater";
import { definition as jq } from "@fortawesome/free-solid-svg-icons/faCloudSun";
import { definition as X21 } from "@fortawesome/free-solid-svg-icons/faCloudSun";
import { definition as Bq } from "@fortawesome/free-solid-svg-icons/faCloudSunRain";
import { definition as J21 } from "@fortawesome/free-solid-svg-icons/faCloudSunRain";
import { definition as Tq } from "@fortawesome/free-solid-svg-icons/faCloudUpload";
import { definition as Z21 } from "@fortawesome/free-solid-svg-icons/faCloudUpload";
import { definition as Fq } from "@fortawesome/free-solid-svg-icons/faCloudUploadAlt";
import { definition as x21 } from "@fortawesome/free-solid-svg-icons/faCloudUploadAlt";
import { definition as Hq } from "@fortawesome/free-solid-svg-icons/faClover";
import { definition as a11 } from "@fortawesome/free-solid-svg-icons/faClover";
import { definition as Rq } from "@fortawesome/free-solid-svg-icons/faCny";
import { definition as n11 } from "@fortawesome/free-solid-svg-icons/faCny";
import { definition as Uq } from "@fortawesome/free-solid-svg-icons/faCocktail";
import { definition as c11 } from "@fortawesome/free-solid-svg-icons/faCocktail";
import { definition as qq } from "@fortawesome/free-solid-svg-icons/faCode";
import { definition as o11 } from "@fortawesome/free-solid-svg-icons/faCode";
import { definition as Gq } from "@fortawesome/free-solid-svg-icons/faCodeBranch";
import { definition as d11 } from "@fortawesome/free-solid-svg-icons/faCodeBranch";
import { definition as Wq } from "@fortawesome/free-solid-svg-icons/faCodeCommit";
import { definition as s11 } from "@fortawesome/free-solid-svg-icons/faCodeCommit";
import { definition as Eq } from "@fortawesome/free-solid-svg-icons/faCodeCompare";
import { definition as v11 } from "@fortawesome/free-solid-svg-icons/faCodeCompare";
import { definition as Vq } from "@fortawesome/free-solid-svg-icons/faCodeFork";
import { definition as m11 } from "@fortawesome/free-solid-svg-icons/faCodeFork";
import { definition as Iq } from "@fortawesome/free-solid-svg-icons/faCodeMerge";
import { definition as P11 } from "@fortawesome/free-solid-svg-icons/faCodeMerge";
import { definition as Kq } from "@fortawesome/free-solid-svg-icons/faCodePullRequest";
import { definition as w11 } from "@fortawesome/free-solid-svg-icons/faCodePullRequest";
import { definition as Xq } from "@fortawesome/free-solid-svg-icons/faCoffee";
import { definition as z11 } from "@fortawesome/free-solid-svg-icons/faCoffee";
import { definition as Qq } from "@fortawesome/free-solid-svg-icons/faCog";
import { definition as C11 } from "@fortawesome/free-solid-svg-icons/faCog";
import { definition as Jq } from "@fortawesome/free-solid-svg-icons/faCogs";
import { definition as $11 } from "@fortawesome/free-solid-svg-icons/faCogs";
import { definition as Yq } from "@fortawesome/free-solid-svg-icons/faCoins";
import { definition as b11 } from "@fortawesome/free-solid-svg-icons/faCoins";
import { definition as Zq } from "@fortawesome/free-solid-svg-icons/faColonSign";
import { definition as y11 } from "@fortawesome/free-solid-svg-icons/faColonSign";
import { definition as pq } from "@fortawesome/free-solid-svg-icons/faColumns";
import { definition as k11 } from "@fortawesome/free-solid-svg-icons/faColumns";
import { definition as xq } from "@fortawesome/free-solid-svg-icons/faComment";
import { definition as j11 } from "@fortawesome/free-solid-svg-icons/faComment";
import { definition as iG } from "@fortawesome/free-solid-svg-icons/faCommentAlt";
import { definition as T11 } from "@fortawesome/free-solid-svg-icons/faCommentAlt";
import { definition as aG } from "@fortawesome/free-solid-svg-icons/faCommentDollar";
import { definition as H11 } from "@fortawesome/free-solid-svg-icons/faCommentDollar";
import { definition as eG } from "@fortawesome/free-solid-svg-icons/faCommentDots";
import { definition as U11 } from "@fortawesome/free-solid-svg-icons/faCommentDots";
import { definition as nG } from "@fortawesome/free-solid-svg-icons/faCommentMedical";
import { definition as G11 } from "@fortawesome/free-solid-svg-icons/faCommentMedical";
import { definition as fG } from "@fortawesome/free-solid-svg-icons/faCommentSlash";
import { definition as E11 } from "@fortawesome/free-solid-svg-icons/faCommentSlash";
import { definition as cG } from "@fortawesome/free-solid-svg-icons/faCommentSms";
import { definition as I11 } from "@fortawesome/free-solid-svg-icons/faCommentSms";
import { definition as tG } from "@fortawesome/free-solid-svg-icons/faCommenting";
import { definition as X11 } from "@fortawesome/free-solid-svg-icons/faCommenting";
import { definition as oG } from "@fortawesome/free-solid-svg-icons/faComments";
import { definition as J11 } from "@fortawesome/free-solid-svg-icons/faComments";
import { definition as lG } from "@fortawesome/free-solid-svg-icons/faCommentsDollar";
import { definition as Z11 } from "@fortawesome/free-solid-svg-icons/faCommentsDollar";
import { definition as dG } from "@fortawesome/free-solid-svg-icons/faCompactDisc";
import { definition as x11 } from "@fortawesome/free-solid-svg-icons/faCompactDisc";
import { definition as rG } from "@fortawesome/free-solid-svg-icons/faCompass";
import { definition as aa1 } from "@fortawesome/free-solid-svg-icons/faCompass";
import { definition as sG } from "@fortawesome/free-solid-svg-icons/faCompassDrafting";
import { definition as na1 } from "@fortawesome/free-solid-svg-icons/faCompassDrafting";
import { definition as hG } from "@fortawesome/free-solid-svg-icons/faCompress";
import { definition as ca1 } from "@fortawesome/free-solid-svg-icons/faCompress";
import { definition as vG } from "@fortawesome/free-solid-svg-icons/faCompressAlt";
import { definition as oa1 } from "@fortawesome/free-solid-svg-icons/faCompressAlt";
import { definition as uG } from "@fortawesome/free-solid-svg-icons/faCompressArrowsAlt";
import { definition as da1 } from "@fortawesome/free-solid-svg-icons/faCompressArrowsAlt";
import { definition as mG } from "@fortawesome/free-solid-svg-icons/faComputer";
import { definition as sa1 } from "@fortawesome/free-solid-svg-icons/faComputer";
import { definition as gG } from "@fortawesome/free-solid-svg-icons/faComputerMouse";
import { definition as va1 } from "@fortawesome/free-solid-svg-icons/faComputerMouse";
import { definition as PG } from "@fortawesome/free-solid-svg-icons/faConciergeBell";
import { definition as ma1 } from "@fortawesome/free-solid-svg-icons/faConciergeBell";
import { definition as MG } from "@fortawesome/free-solid-svg-icons/faContactBook";
import { definition as Pa1 } from "@fortawesome/free-solid-svg-icons/faContactBook";
import { definition as wG } from "@fortawesome/free-solid-svg-icons/faContactCard";
import { definition as wa1 } from "@fortawesome/free-solid-svg-icons/faContactCard";
import { definition as NG } from "@fortawesome/free-solid-svg-icons/faCookie";
import { definition as za1 } from "@fortawesome/free-solid-svg-icons/faCookie";
import { definition as zG } from "@fortawesome/free-solid-svg-icons/faCookieBite";
import { definition as Ca1 } from "@fortawesome/free-solid-svg-icons/faCookieBite";
import { definition as LG } from "@fortawesome/free-solid-svg-icons/faCopy";
import { definition as $a1 } from "@fortawesome/free-solid-svg-icons/faCopy";
import { definition as CG } from "@fortawesome/free-solid-svg-icons/faCopyright";
import { definition as ba1 } from "@fortawesome/free-solid-svg-icons/faCopyright";
import { definition as DG } from "@fortawesome/free-solid-svg-icons/faCouch";
import { definition as ya1 } from "@fortawesome/free-solid-svg-icons/faCouch";
import { definition as $G } from "@fortawesome/free-solid-svg-icons/faCow";
import { definition as ka1 } from "@fortawesome/free-solid-svg-icons/faCow";
import { definition as _G } from "@fortawesome/free-solid-svg-icons/faCreditCard";
import { definition as ja1 } from "@fortawesome/free-solid-svg-icons/faCreditCard";
import { definition as bG } from "@fortawesome/free-solid-svg-icons/faCreditCardAlt";
import { definition as Ta1 } from "@fortawesome/free-solid-svg-icons/faCreditCardAlt";
import { definition as SG } from "@fortawesome/free-solid-svg-icons/faCrop";
import { definition as Ha1 } from "@fortawesome/free-solid-svg-icons/faCrop";
import { definition as yG } from "@fortawesome/free-solid-svg-icons/faCropAlt";
import { definition as Ua1 } from "@fortawesome/free-solid-svg-icons/faCropAlt";
import { definition as OG } from "@fortawesome/free-solid-svg-icons/faCropSimple";
import { definition as Ga1 } from "@fortawesome/free-solid-svg-icons/faCropSimple";
import { definition as kG } from "@fortawesome/free-solid-svg-icons/faCross";
import { definition as Ea1 } from "@fortawesome/free-solid-svg-icons/faCross";
import { definition as AG } from "@fortawesome/free-solid-svg-icons/faCrosshairs";
import { definition as Ia1 } from "@fortawesome/free-solid-svg-icons/faCrosshairs";
import { definition as jG } from "@fortawesome/free-solid-svg-icons/faCrow";
import { definition as Xa1 } from "@fortawesome/free-solid-svg-icons/faCrow";
import { definition as BG } from "@fortawesome/free-solid-svg-icons/faCrown";
import { definition as Ja1 } from "@fortawesome/free-solid-svg-icons/faCrown";
import { definition as TG } from "@fortawesome/free-solid-svg-icons/faCrutch";
import { definition as Za1 } from "@fortawesome/free-solid-svg-icons/faCrutch";
import { definition as FG } from "@fortawesome/free-solid-svg-icons/faCruzeiroSign";
import { definition as xa1 } from "@fortawesome/free-solid-svg-icons/faCruzeiroSign";
import { definition as HG } from "@fortawesome/free-solid-svg-icons/faCube";
import { definition as a41 } from "@fortawesome/free-solid-svg-icons/faCube";
import { definition as RG } from "@fortawesome/free-solid-svg-icons/faCubes";
import { definition as n41 } from "@fortawesome/free-solid-svg-icons/faCubes";
import { definition as UG } from "@fortawesome/free-solid-svg-icons/faCubesStacked";
import { definition as c41 } from "@fortawesome/free-solid-svg-icons/faCubesStacked";
import { definition as qG } from "@fortawesome/free-solid-svg-icons/faCut";
import { definition as o41 } from "@fortawesome/free-solid-svg-icons/faCut";
import { definition as GG } from "@fortawesome/free-solid-svg-icons/faCutlery";
import { definition as d41 } from "@fortawesome/free-solid-svg-icons/faCutlery";
import { definition as WG } from "@fortawesome/free-solid-svg-icons/faD";
import { definition as s41 } from "@fortawesome/free-solid-svg-icons/faD";
import { definition as EG } from "@fortawesome/free-solid-svg-icons/faDashboard";
import { definition as v41 } from "@fortawesome/free-solid-svg-icons/faDashboard";
import { definition as VG } from "@fortawesome/free-solid-svg-icons/faDatabase";
import { definition as m41 } from "@fortawesome/free-solid-svg-icons/faDatabase";
import { definition as IG } from "@fortawesome/free-solid-svg-icons/faDeaf";
import { definition as P41 } from "@fortawesome/free-solid-svg-icons/faDeaf";
import { definition as KG } from "@fortawesome/free-solid-svg-icons/faDeafness";
import { definition as w41 } from "@fortawesome/free-solid-svg-icons/faDeafness";
import { definition as XG } from "@fortawesome/free-solid-svg-icons/faDedent";
import { definition as z41 } from "@fortawesome/free-solid-svg-icons/faDedent";
import { definition as QG } from "@fortawesome/free-solid-svg-icons/faDeleteLeft";
import { definition as C41 } from "@fortawesome/free-solid-svg-icons/faDeleteLeft";
import { definition as JG } from "@fortawesome/free-solid-svg-icons/faDemocrat";
import { definition as $41 } from "@fortawesome/free-solid-svg-icons/faDemocrat";
import { definition as YG } from "@fortawesome/free-solid-svg-icons/faDesktop";
import { definition as b41 } from "@fortawesome/free-solid-svg-icons/faDesktop";
import { definition as ZG } from "@fortawesome/free-solid-svg-icons/faDesktopAlt";
import { definition as y41 } from "@fortawesome/free-solid-svg-icons/faDesktopAlt";
import { definition as pG } from "@fortawesome/free-solid-svg-icons/faDharmachakra";
import { definition as k41 } from "@fortawesome/free-solid-svg-icons/faDharmachakra";
import { definition as xG } from "@fortawesome/free-solid-svg-icons/faDiagnoses";
import { definition as j41 } from "@fortawesome/free-solid-svg-icons/faDiagnoses";
import { definition as iW } from "@fortawesome/free-solid-svg-icons/faDiagramNext";
import { definition as T41 } from "@fortawesome/free-solid-svg-icons/faDiagramNext";
import { definition as aW } from "@fortawesome/free-solid-svg-icons/faDiagramPredecessor";
import { definition as H41 } from "@fortawesome/free-solid-svg-icons/faDiagramPredecessor";
import { definition as eW } from "@fortawesome/free-solid-svg-icons/faDiagramProject";
import { definition as U41 } from "@fortawesome/free-solid-svg-icons/faDiagramProject";
import { definition as nW } from "@fortawesome/free-solid-svg-icons/faDiagramSuccessor";
import { definition as G41 } from "@fortawesome/free-solid-svg-icons/faDiagramSuccessor";
import { definition as fW } from "@fortawesome/free-solid-svg-icons/faDiamond";
import { definition as E41 } from "@fortawesome/free-solid-svg-icons/faDiamond";
import { definition as cW } from "@fortawesome/free-solid-svg-icons/faDiamondTurnRight";
import { definition as I41 } from "@fortawesome/free-solid-svg-icons/faDiamondTurnRight";
import { definition as tW } from "@fortawesome/free-solid-svg-icons/faDice";
import { definition as X41 } from "@fortawesome/free-solid-svg-icons/faDice";
import { definition as oW } from "@fortawesome/free-solid-svg-icons/faDiceD20";
import { definition as J41 } from "@fortawesome/free-solid-svg-icons/faDiceD20";
import { definition as lW } from "@fortawesome/free-solid-svg-icons/faDiceD6";
import { definition as Z41 } from "@fortawesome/free-solid-svg-icons/faDiceD6";
import { definition as dW } from "@fortawesome/free-solid-svg-icons/faDiceFive";
import { definition as x41 } from "@fortawesome/free-solid-svg-icons/faDiceFive";
import { definition as rW } from "@fortawesome/free-solid-svg-icons/faDiceFour";
import { definition as a31 } from "@fortawesome/free-solid-svg-icons/faDiceFour";
import { definition as sW } from "@fortawesome/free-solid-svg-icons/faDiceOne";
import { definition as n31 } from "@fortawesome/free-solid-svg-icons/faDiceOne";
import { definition as hW } from "@fortawesome/free-solid-svg-icons/faDiceSix";
import { definition as c31 } from "@fortawesome/free-solid-svg-icons/faDiceSix";
import { definition as vW } from "@fortawesome/free-solid-svg-icons/faDiceThree";
import { definition as o31 } from "@fortawesome/free-solid-svg-icons/faDiceThree";
import { definition as uW } from "@fortawesome/free-solid-svg-icons/faDiceTwo";
import { definition as d31 } from "@fortawesome/free-solid-svg-icons/faDiceTwo";
import { definition as mW } from "@fortawesome/free-solid-svg-icons/faDigging";
import { definition as s31 } from "@fortawesome/free-solid-svg-icons/faDigging";
import { definition as gW } from "@fortawesome/free-solid-svg-icons/faDigitalTachograph";
import { definition as v31 } from "@fortawesome/free-solid-svg-icons/faDigitalTachograph";
import { definition as PW } from "@fortawesome/free-solid-svg-icons/faDirections";
import { definition as m31 } from "@fortawesome/free-solid-svg-icons/faDirections";
import { definition as MW } from "@fortawesome/free-solid-svg-icons/faDisease";
import { definition as P31 } from "@fortawesome/free-solid-svg-icons/faDisease";
import { definition as wW } from "@fortawesome/free-solid-svg-icons/faDisplay";
import { definition as w31 } from "@fortawesome/free-solid-svg-icons/faDisplay";
import { definition as NW } from "@fortawesome/free-solid-svg-icons/faDivide";
import { definition as z31 } from "@fortawesome/free-solid-svg-icons/faDivide";
import { definition as zW } from "@fortawesome/free-solid-svg-icons/faDizzy";
import { definition as C31 } from "@fortawesome/free-solid-svg-icons/faDizzy";
import { definition as LW } from "@fortawesome/free-solid-svg-icons/faDna";
import { definition as $31 } from "@fortawesome/free-solid-svg-icons/faDna";
import { definition as CW } from "@fortawesome/free-solid-svg-icons/faDog";
import { definition as b31 } from "@fortawesome/free-solid-svg-icons/faDog";
import { definition as DW } from "@fortawesome/free-solid-svg-icons/faDollar";
import { definition as y31 } from "@fortawesome/free-solid-svg-icons/faDollar";
import { definition as $W } from "@fortawesome/free-solid-svg-icons/faDollarSign";
import { definition as k31 } from "@fortawesome/free-solid-svg-icons/faDollarSign";
import { definition as _W } from "@fortawesome/free-solid-svg-icons/faDolly";
import { definition as j31 } from "@fortawesome/free-solid-svg-icons/faDolly";
import { definition as bW } from "@fortawesome/free-solid-svg-icons/faDollyBox";
import { definition as T31 } from "@fortawesome/free-solid-svg-icons/faDollyBox";
import { definition as SW } from "@fortawesome/free-solid-svg-icons/faDollyFlatbed";
import { definition as H31 } from "@fortawesome/free-solid-svg-icons/faDollyFlatbed";
import { definition as yW } from "@fortawesome/free-solid-svg-icons/faDonate";
import { definition as U31 } from "@fortawesome/free-solid-svg-icons/faDonate";
import { definition as OW } from "@fortawesome/free-solid-svg-icons/faDongSign";
import { definition as G31 } from "@fortawesome/free-solid-svg-icons/faDongSign";
import { definition as kW } from "@fortawesome/free-solid-svg-icons/faDoorClosed";
import { definition as E31 } from "@fortawesome/free-solid-svg-icons/faDoorClosed";
import { definition as AW } from "@fortawesome/free-solid-svg-icons/faDoorOpen";
import { definition as I31 } from "@fortawesome/free-solid-svg-icons/faDoorOpen";
import { definition as jW } from "@fortawesome/free-solid-svg-icons/faDotCircle";
import { definition as X31 } from "@fortawesome/free-solid-svg-icons/faDotCircle";
import { definition as BW } from "@fortawesome/free-solid-svg-icons/faDove";
import { definition as J31 } from "@fortawesome/free-solid-svg-icons/faDove";
import { definition as TW } from "@fortawesome/free-solid-svg-icons/faDownLeftAndUpRightToCenter";
import { definition as Z31 } from "@fortawesome/free-solid-svg-icons/faDownLeftAndUpRightToCenter";
import { definition as FW } from "@fortawesome/free-solid-svg-icons/faDownLong";
import { definition as x31 } from "@fortawesome/free-solid-svg-icons/faDownLong";
import { definition as HW } from "@fortawesome/free-solid-svg-icons/faDownload";
import { definition as a01 } from "@fortawesome/free-solid-svg-icons/faDownload";
import { definition as RW } from "@fortawesome/free-solid-svg-icons/faDraftingCompass";
import { definition as n01 } from "@fortawesome/free-solid-svg-icons/faDraftingCompass";
import { definition as UW } from "@fortawesome/free-solid-svg-icons/faDragon";
import { definition as c01 } from "@fortawesome/free-solid-svg-icons/faDragon";
import { definition as qW } from "@fortawesome/free-solid-svg-icons/faDrawPolygon";
import { definition as o01 } from "@fortawesome/free-solid-svg-icons/faDrawPolygon";
import { definition as GW } from "@fortawesome/free-solid-svg-icons/faDriversLicense";
import { definition as d01 } from "@fortawesome/free-solid-svg-icons/faDriversLicense";
import { definition as WW } from "@fortawesome/free-solid-svg-icons/faDroplet";
import { definition as s01 } from "@fortawesome/free-solid-svg-icons/faDroplet";
import { definition as EW } from "@fortawesome/free-solid-svg-icons/faDropletSlash";
import { definition as v01 } from "@fortawesome/free-solid-svg-icons/faDropletSlash";
import { definition as VW } from "@fortawesome/free-solid-svg-icons/faDrum";
import { definition as m01 } from "@fortawesome/free-solid-svg-icons/faDrum";
import { definition as IW } from "@fortawesome/free-solid-svg-icons/faDrumSteelpan";
import { definition as P01 } from "@fortawesome/free-solid-svg-icons/faDrumSteelpan";
import { definition as KW } from "@fortawesome/free-solid-svg-icons/faDrumstickBite";
import { definition as w01 } from "@fortawesome/free-solid-svg-icons/faDrumstickBite";
import { definition as XW } from "@fortawesome/free-solid-svg-icons/faDumbbell";
import { definition as z01 } from "@fortawesome/free-solid-svg-icons/faDumbbell";
import { definition as QW } from "@fortawesome/free-solid-svg-icons/faDumpster";
import { definition as C01 } from "@fortawesome/free-solid-svg-icons/faDumpster";
import { definition as JW } from "@fortawesome/free-solid-svg-icons/faDumpsterFire";
import { definition as $01 } from "@fortawesome/free-solid-svg-icons/faDumpsterFire";
import { definition as YW } from "@fortawesome/free-solid-svg-icons/faDungeon";
import { definition as b01 } from "@fortawesome/free-solid-svg-icons/faDungeon";
import { definition as ZW } from "@fortawesome/free-solid-svg-icons/faE";
import { definition as y01 } from "@fortawesome/free-solid-svg-icons/faE";
import { definition as pW } from "@fortawesome/free-solid-svg-icons/faEarDeaf";
import { definition as k01 } from "@fortawesome/free-solid-svg-icons/faEarDeaf";
import { definition as xW } from "@fortawesome/free-solid-svg-icons/faEarListen";
import { definition as j01 } from "@fortawesome/free-solid-svg-icons/faEarListen";
import { definition as iE } from "@fortawesome/free-solid-svg-icons/faEarth";
import { definition as T01 } from "@fortawesome/free-solid-svg-icons/faEarth";
import { definition as aE } from "@fortawesome/free-solid-svg-icons/faEarthAfrica";
import { definition as H01 } from "@fortawesome/free-solid-svg-icons/faEarthAfrica";
import { definition as eE } from "@fortawesome/free-solid-svg-icons/faEarthAmerica";
import { definition as U01 } from "@fortawesome/free-solid-svg-icons/faEarthAmerica";
import { definition as nE } from "@fortawesome/free-solid-svg-icons/faEarthAmericas";
import { definition as G01 } from "@fortawesome/free-solid-svg-icons/faEarthAmericas";
import { definition as fE } from "@fortawesome/free-solid-svg-icons/faEarthAsia";
import { definition as E01 } from "@fortawesome/free-solid-svg-icons/faEarthAsia";
import { definition as cE } from "@fortawesome/free-solid-svg-icons/faEarthEurope";
import { definition as I01 } from "@fortawesome/free-solid-svg-icons/faEarthEurope";
import { definition as tE } from "@fortawesome/free-solid-svg-icons/faEarthOceania";
import { definition as X01 } from "@fortawesome/free-solid-svg-icons/faEarthOceania";
import { definition as oE } from "@fortawesome/free-solid-svg-icons/faEdit";
import { definition as J01 } from "@fortawesome/free-solid-svg-icons/faEdit";
import { definition as lE } from "@fortawesome/free-solid-svg-icons/faEgg";
import { definition as Z01 } from "@fortawesome/free-solid-svg-icons/faEgg";
import { definition as dE } from "@fortawesome/free-solid-svg-icons/faEject";
import { definition as x01 } from "@fortawesome/free-solid-svg-icons/faEject";
import { definition as rE } from "@fortawesome/free-solid-svg-icons/faElevator";
import { definition as ae1 } from "@fortawesome/free-solid-svg-icons/faElevator";
import { definition as sE } from "@fortawesome/free-solid-svg-icons/faEllipsis";
import { definition as ne1 } from "@fortawesome/free-solid-svg-icons/faEllipsis";
import { definition as hE } from "@fortawesome/free-solid-svg-icons/faEllipsisH";
import { definition as ce1 } from "@fortawesome/free-solid-svg-icons/faEllipsisH";
import { definition as vE } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import { definition as oe1 } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import { definition as uE } from "@fortawesome/free-solid-svg-icons/faEllipsisVertical";
import { definition as de1 } from "@fortawesome/free-solid-svg-icons/faEllipsisVertical";
import { definition as mE } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { definition as se1 } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { definition as gE } from "@fortawesome/free-solid-svg-icons/faEnvelopeCircleCheck";
import { definition as ve1 } from "@fortawesome/free-solid-svg-icons/faEnvelopeCircleCheck";
import { definition as PE } from "@fortawesome/free-solid-svg-icons/faEnvelopeOpen";
import { definition as me1 } from "@fortawesome/free-solid-svg-icons/faEnvelopeOpen";
import { definition as ME } from "@fortawesome/free-solid-svg-icons/faEnvelopeOpenText";
import { definition as Pe1 } from "@fortawesome/free-solid-svg-icons/faEnvelopeOpenText";
import { definition as wE } from "@fortawesome/free-solid-svg-icons/faEnvelopeSquare";
import { definition as we1 } from "@fortawesome/free-solid-svg-icons/faEnvelopeSquare";
import { definition as NE } from "@fortawesome/free-solid-svg-icons/faEnvelopesBulk";
import { definition as ze1 } from "@fortawesome/free-solid-svg-icons/faEnvelopesBulk";
import { definition as zE } from "@fortawesome/free-solid-svg-icons/faEquals";
import { definition as Ce1 } from "@fortawesome/free-solid-svg-icons/faEquals";
import { definition as LE } from "@fortawesome/free-solid-svg-icons/faEraser";
import { definition as $e1 } from "@fortawesome/free-solid-svg-icons/faEraser";
import { definition as CE } from "@fortawesome/free-solid-svg-icons/faEthernet";
import { definition as be1 } from "@fortawesome/free-solid-svg-icons/faEthernet";
import { definition as DE } from "@fortawesome/free-solid-svg-icons/faEur";
import { definition as ye1 } from "@fortawesome/free-solid-svg-icons/faEur";
import { definition as $E } from "@fortawesome/free-solid-svg-icons/faEuro";
import { definition as ke1 } from "@fortawesome/free-solid-svg-icons/faEuro";
import { definition as _E } from "@fortawesome/free-solid-svg-icons/faEuroSign";
import { definition as je1 } from "@fortawesome/free-solid-svg-icons/faEuroSign";
import { definition as bE } from "@fortawesome/free-solid-svg-icons/faExchange";
import { definition as Te1 } from "@fortawesome/free-solid-svg-icons/faExchange";
import { definition as SE } from "@fortawesome/free-solid-svg-icons/faExchangeAlt";
import { definition as He1 } from "@fortawesome/free-solid-svg-icons/faExchangeAlt";
import { definition as yE } from "@fortawesome/free-solid-svg-icons/faExclamation";
import { definition as Ue1 } from "@fortawesome/free-solid-svg-icons/faExclamation";
import { definition as OE } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { definition as Ge1 } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { definition as kE } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { definition as Ee1 } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { definition as AE } from "@fortawesome/free-solid-svg-icons/faExpand";
import { definition as Ie1 } from "@fortawesome/free-solid-svg-icons/faExpand";
import { definition as jE } from "@fortawesome/free-solid-svg-icons/faExpandAlt";
import { definition as Xe1 } from "@fortawesome/free-solid-svg-icons/faExpandAlt";
import { definition as BE } from "@fortawesome/free-solid-svg-icons/faExpandArrowsAlt";
import { definition as Je1 } from "@fortawesome/free-solid-svg-icons/faExpandArrowsAlt";
import { definition as TE } from "@fortawesome/free-solid-svg-icons/faExplosion";
import { definition as Ze1 } from "@fortawesome/free-solid-svg-icons/faExplosion";
import { definition as FE } from "@fortawesome/free-solid-svg-icons/faExternalLink";
import { definition as xe1 } from "@fortawesome/free-solid-svg-icons/faExternalLink";
import { definition as HE } from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt";
import { definition as an1 } from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt";
import { definition as RE } from "@fortawesome/free-solid-svg-icons/faExternalLinkSquare";
import { definition as nn1 } from "@fortawesome/free-solid-svg-icons/faExternalLinkSquare";
import { definition as UE } from "@fortawesome/free-solid-svg-icons/faExternalLinkSquareAlt";
import { definition as cn1 } from "@fortawesome/free-solid-svg-icons/faExternalLinkSquareAlt";
import { definition as qE } from "@fortawesome/free-solid-svg-icons/faEye";
import { definition as on1 } from "@fortawesome/free-solid-svg-icons/faEye";
import { definition as GE } from "@fortawesome/free-solid-svg-icons/faEyeDropper";
import { definition as dn1 } from "@fortawesome/free-solid-svg-icons/faEyeDropper";
import { definition as WE } from "@fortawesome/free-solid-svg-icons/faEyeDropperEmpty";
import { definition as sn1 } from "@fortawesome/free-solid-svg-icons/faEyeDropperEmpty";
import { definition as EE } from "@fortawesome/free-solid-svg-icons/faEyeLowVision";
import { definition as vn1 } from "@fortawesome/free-solid-svg-icons/faEyeLowVision";
import { definition as VE } from "@fortawesome/free-solid-svg-icons/faEyeSlash";
import { definition as mn1 } from "@fortawesome/free-solid-svg-icons/faEyeSlash";
import { definition as IE } from "@fortawesome/free-solid-svg-icons/faF";
import { definition as Pn1 } from "@fortawesome/free-solid-svg-icons/faF";
import { definition as KE } from "@fortawesome/free-solid-svg-icons/faFaceAngry";
import { definition as wn1 } from "@fortawesome/free-solid-svg-icons/faFaceAngry";
import { definition as XE } from "@fortawesome/free-solid-svg-icons/faFaceDizzy";
import { definition as zn1 } from "@fortawesome/free-solid-svg-icons/faFaceDizzy";
import { definition as QE } from "@fortawesome/free-solid-svg-icons/faFaceFlushed";
import { definition as Cn1 } from "@fortawesome/free-solid-svg-icons/faFaceFlushed";
import { definition as JE } from "@fortawesome/free-solid-svg-icons/faFaceFrown";
import { definition as $n1 } from "@fortawesome/free-solid-svg-icons/faFaceFrown";
import { definition as YE } from "@fortawesome/free-solid-svg-icons/faFaceFrownOpen";
import { definition as bn1 } from "@fortawesome/free-solid-svg-icons/faFaceFrownOpen";
import { definition as ZE } from "@fortawesome/free-solid-svg-icons/faFaceGrimace";
import { definition as yn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrimace";
import { definition as pE } from "@fortawesome/free-solid-svg-icons/faFaceGrin";
import { definition as kn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrin";
import { definition as xE } from "@fortawesome/free-solid-svg-icons/faFaceGrinBeam";
import { definition as jn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinBeam";
import { definition as iV } from "@fortawesome/free-solid-svg-icons/faFaceGrinBeamSweat";
import { definition as Tn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinBeamSweat";
import { definition as aV } from "@fortawesome/free-solid-svg-icons/faFaceGrinHearts";
import { definition as Hn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinHearts";
import { definition as eV } from "@fortawesome/free-solid-svg-icons/faFaceGrinSquint";
import { definition as Un1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinSquint";
import { definition as nV } from "@fortawesome/free-solid-svg-icons/faFaceGrinSquintTears";
import { definition as Gn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinSquintTears";
import { definition as fV } from "@fortawesome/free-solid-svg-icons/faFaceGrinStars";
import { definition as En1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinStars";
import { definition as cV } from "@fortawesome/free-solid-svg-icons/faFaceGrinTears";
import { definition as In1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinTears";
import { definition as tV } from "@fortawesome/free-solid-svg-icons/faFaceGrinTongue";
import { definition as Xn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinTongue";
import { definition as oV } from "@fortawesome/free-solid-svg-icons/faFaceGrinTongueSquint";
import { definition as Jn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinTongueSquint";
import { definition as lV } from "@fortawesome/free-solid-svg-icons/faFaceGrinTongueWink";
import { definition as Zn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinTongueWink";
import { definition as dV } from "@fortawesome/free-solid-svg-icons/faFaceGrinWide";
import { definition as xn1 } from "@fortawesome/free-solid-svg-icons/faFaceGrinWide";
import { definition as rV } from "@fortawesome/free-solid-svg-icons/faFaceGrinWink";
import { definition as a61 } from "@fortawesome/free-solid-svg-icons/faFaceGrinWink";
import { definition as sV } from "@fortawesome/free-solid-svg-icons/faFaceKiss";
import { definition as n61 } from "@fortawesome/free-solid-svg-icons/faFaceKiss";
import { definition as hV } from "@fortawesome/free-solid-svg-icons/faFaceKissBeam";
import { definition as c61 } from "@fortawesome/free-solid-svg-icons/faFaceKissBeam";
import { definition as vV } from "@fortawesome/free-solid-svg-icons/faFaceKissWinkHeart";
import { definition as o61 } from "@fortawesome/free-solid-svg-icons/faFaceKissWinkHeart";
import { definition as uV } from "@fortawesome/free-solid-svg-icons/faFaceLaugh";
import { definition as d61 } from "@fortawesome/free-solid-svg-icons/faFaceLaugh";
import { definition as mV } from "@fortawesome/free-solid-svg-icons/faFaceLaughBeam";
import { definition as s61 } from "@fortawesome/free-solid-svg-icons/faFaceLaughBeam";
import { definition as gV } from "@fortawesome/free-solid-svg-icons/faFaceLaughSquint";
import { definition as v61 } from "@fortawesome/free-solid-svg-icons/faFaceLaughSquint";
import { definition as PV } from "@fortawesome/free-solid-svg-icons/faFaceLaughWink";
import { definition as m61 } from "@fortawesome/free-solid-svg-icons/faFaceLaughWink";
import { definition as MV } from "@fortawesome/free-solid-svg-icons/faFaceMeh";
import { definition as P61 } from "@fortawesome/free-solid-svg-icons/faFaceMeh";
import { definition as wV } from "@fortawesome/free-solid-svg-icons/faFaceMehBlank";
import { definition as w61 } from "@fortawesome/free-solid-svg-icons/faFaceMehBlank";
import { definition as NV } from "@fortawesome/free-solid-svg-icons/faFaceRollingEyes";
import { definition as z61 } from "@fortawesome/free-solid-svg-icons/faFaceRollingEyes";
import { definition as zV } from "@fortawesome/free-solid-svg-icons/faFaceSadCry";
import { definition as C61 } from "@fortawesome/free-solid-svg-icons/faFaceSadCry";
import { definition as LV } from "@fortawesome/free-solid-svg-icons/faFaceSadTear";
import { definition as $61 } from "@fortawesome/free-solid-svg-icons/faFaceSadTear";
import { definition as CV } from "@fortawesome/free-solid-svg-icons/faFaceSmile";
import { definition as b61 } from "@fortawesome/free-solid-svg-icons/faFaceSmile";
import { definition as DV } from "@fortawesome/free-solid-svg-icons/faFaceSmileBeam";
import { definition as y61 } from "@fortawesome/free-solid-svg-icons/faFaceSmileBeam";
import { definition as $V } from "@fortawesome/free-solid-svg-icons/faFaceSmileWink";
import { definition as k61 } from "@fortawesome/free-solid-svg-icons/faFaceSmileWink";
import { definition as _V } from "@fortawesome/free-solid-svg-icons/faFaceSurprise";
import { definition as j61 } from "@fortawesome/free-solid-svg-icons/faFaceSurprise";
import { definition as bV } from "@fortawesome/free-solid-svg-icons/faFaceTired";
import { definition as T61 } from "@fortawesome/free-solid-svg-icons/faFaceTired";
import { definition as SV } from "@fortawesome/free-solid-svg-icons/faFan";
import { definition as H61 } from "@fortawesome/free-solid-svg-icons/faFan";
import { definition as yV } from "@fortawesome/free-solid-svg-icons/faFastBackward";
import { definition as U61 } from "@fortawesome/free-solid-svg-icons/faFastBackward";
import { definition as OV } from "@fortawesome/free-solid-svg-icons/faFastForward";
import { definition as G61 } from "@fortawesome/free-solid-svg-icons/faFastForward";
import { definition as kV } from "@fortawesome/free-solid-svg-icons/faFaucet";
import { definition as E61 } from "@fortawesome/free-solid-svg-icons/faFaucet";
import { definition as AV } from "@fortawesome/free-solid-svg-icons/faFaucetDrip";
import { definition as I61 } from "@fortawesome/free-solid-svg-icons/faFaucetDrip";
import { definition as jV } from "@fortawesome/free-solid-svg-icons/faFax";
import { definition as X61 } from "@fortawesome/free-solid-svg-icons/faFax";
import { definition as BV } from "@fortawesome/free-solid-svg-icons/faFeather";
import { definition as J61 } from "@fortawesome/free-solid-svg-icons/faFeather";
import { definition as TV } from "@fortawesome/free-solid-svg-icons/faFeatherAlt";
import { definition as Z61 } from "@fortawesome/free-solid-svg-icons/faFeatherAlt";
import { definition as FV } from "@fortawesome/free-solid-svg-icons/faFeatherPointed";
import { definition as x61 } from "@fortawesome/free-solid-svg-icons/faFeatherPointed";
import { definition as HV } from "@fortawesome/free-solid-svg-icons/faFeed";
import { definition as af1 } from "@fortawesome/free-solid-svg-icons/faFeed";
import { definition as RV } from "@fortawesome/free-solid-svg-icons/faFemale";
import { definition as nf1 } from "@fortawesome/free-solid-svg-icons/faFemale";
import { definition as UV } from "@fortawesome/free-solid-svg-icons/faFerry";
import { definition as cf1 } from "@fortawesome/free-solid-svg-icons/faFerry";
import { definition as qV } from "@fortawesome/free-solid-svg-icons/faFighterJet";
import { definition as of1 } from "@fortawesome/free-solid-svg-icons/faFighterJet";
import { definition as GV } from "@fortawesome/free-solid-svg-icons/faFile";
import { definition as df1 } from "@fortawesome/free-solid-svg-icons/faFile";
import { definition as WV } from "@fortawesome/free-solid-svg-icons/faFileAlt";
import { definition as sf1 } from "@fortawesome/free-solid-svg-icons/faFileAlt";
import { definition as EV } from "@fortawesome/free-solid-svg-icons/faFileArchive";
import { definition as vf1 } from "@fortawesome/free-solid-svg-icons/faFileArchive";
import { definition as VV } from "@fortawesome/free-solid-svg-icons/faFileArrowDown";
import { definition as mf1 } from "@fortawesome/free-solid-svg-icons/faFileArrowDown";
import { definition as IV } from "@fortawesome/free-solid-svg-icons/faFileArrowUp";
import { definition as Pf1 } from "@fortawesome/free-solid-svg-icons/faFileArrowUp";
import { definition as KV } from "@fortawesome/free-solid-svg-icons/faFileAudio";
import { definition as wf1 } from "@fortawesome/free-solid-svg-icons/faFileAudio";
import { definition as XV } from "@fortawesome/free-solid-svg-icons/faFileCircleCheck";
import { definition as zf1 } from "@fortawesome/free-solid-svg-icons/faFileCircleCheck";
import { definition as QV } from "@fortawesome/free-solid-svg-icons/faFileCircleExclamation";
import { definition as Cf1 } from "@fortawesome/free-solid-svg-icons/faFileCircleExclamation";
import { definition as JV } from "@fortawesome/free-solid-svg-icons/faFileCircleMinus";
import { definition as $f1 } from "@fortawesome/free-solid-svg-icons/faFileCircleMinus";
import { definition as YV } from "@fortawesome/free-solid-svg-icons/faFileCirclePlus";
import { definition as bf1 } from "@fortawesome/free-solid-svg-icons/faFileCirclePlus";
import { definition as ZV } from "@fortawesome/free-solid-svg-icons/faFileCircleQuestion";
import { definition as yf1 } from "@fortawesome/free-solid-svg-icons/faFileCircleQuestion";
import { definition as pV } from "@fortawesome/free-solid-svg-icons/faFileCircleXmark";
import { definition as kf1 } from "@fortawesome/free-solid-svg-icons/faFileCircleXmark";
import { definition as xV } from "@fortawesome/free-solid-svg-icons/faFileClipboard";
import { definition as jf1 } from "@fortawesome/free-solid-svg-icons/faFileClipboard";
import { definition as iI } from "@fortawesome/free-solid-svg-icons/faFileCode";
import { definition as Tf1 } from "@fortawesome/free-solid-svg-icons/faFileCode";
import { definition as aI } from "@fortawesome/free-solid-svg-icons/faFileContract";
import { definition as Hf1 } from "@fortawesome/free-solid-svg-icons/faFileContract";
import { definition as eI } from "@fortawesome/free-solid-svg-icons/faFileCsv";
import { definition as Uf1 } from "@fortawesome/free-solid-svg-icons/faFileCsv";
import { definition as nI } from "@fortawesome/free-solid-svg-icons/faFileDownload";
import { definition as Gf1 } from "@fortawesome/free-solid-svg-icons/faFileDownload";
import { definition as fI } from "@fortawesome/free-solid-svg-icons/faFileEdit";
import { definition as Ef1 } from "@fortawesome/free-solid-svg-icons/faFileEdit";
import { definition as cI } from "@fortawesome/free-solid-svg-icons/faFileExcel";
import { definition as If1 } from "@fortawesome/free-solid-svg-icons/faFileExcel";
import { definition as tI } from "@fortawesome/free-solid-svg-icons/faFileExport";
import { definition as Xf1 } from "@fortawesome/free-solid-svg-icons/faFileExport";
import { definition as oI } from "@fortawesome/free-solid-svg-icons/faFileImage";
import { definition as Jf1 } from "@fortawesome/free-solid-svg-icons/faFileImage";
import { definition as lI } from "@fortawesome/free-solid-svg-icons/faFileImport";
import { definition as Zf1 } from "@fortawesome/free-solid-svg-icons/faFileImport";
import { definition as dI } from "@fortawesome/free-solid-svg-icons/faFileInvoice";
import { definition as xf1 } from "@fortawesome/free-solid-svg-icons/faFileInvoice";
import { definition as rI } from "@fortawesome/free-solid-svg-icons/faFileInvoiceDollar";
import { definition as ac1 } from "@fortawesome/free-solid-svg-icons/faFileInvoiceDollar";
import { definition as sI } from "@fortawesome/free-solid-svg-icons/faFileLines";
import { definition as nc1 } from "@fortawesome/free-solid-svg-icons/faFileLines";
import { definition as hI } from "@fortawesome/free-solid-svg-icons/faFileMedical";
import { definition as cc1 } from "@fortawesome/free-solid-svg-icons/faFileMedical";
import { definition as vI } from "@fortawesome/free-solid-svg-icons/faFileMedicalAlt";
import { definition as oc1 } from "@fortawesome/free-solid-svg-icons/faFileMedicalAlt";
import { definition as uI } from "@fortawesome/free-solid-svg-icons/faFilePdf";
import { definition as dc1 } from "@fortawesome/free-solid-svg-icons/faFilePdf";
import { definition as mI } from "@fortawesome/free-solid-svg-icons/faFilePen";
import { definition as sc1 } from "@fortawesome/free-solid-svg-icons/faFilePen";
import { definition as gI } from "@fortawesome/free-solid-svg-icons/faFilePowerpoint";
import { definition as vc1 } from "@fortawesome/free-solid-svg-icons/faFilePowerpoint";
import { definition as PI } from "@fortawesome/free-solid-svg-icons/faFilePrescription";
import { definition as mc1 } from "@fortawesome/free-solid-svg-icons/faFilePrescription";
import { definition as MI } from "@fortawesome/free-solid-svg-icons/faFileShield";
import { definition as Pc1 } from "@fortawesome/free-solid-svg-icons/faFileShield";
import { definition as wI } from "@fortawesome/free-solid-svg-icons/faFileSignature";
import { definition as wc1 } from "@fortawesome/free-solid-svg-icons/faFileSignature";
import { definition as NI } from "@fortawesome/free-solid-svg-icons/faFileText";
import { definition as zc1 } from "@fortawesome/free-solid-svg-icons/faFileText";
import { definition as zI } from "@fortawesome/free-solid-svg-icons/faFileUpload";
import { definition as Cc1 } from "@fortawesome/free-solid-svg-icons/faFileUpload";
import { definition as LI } from "@fortawesome/free-solid-svg-icons/faFileVideo";
import { definition as $c1 } from "@fortawesome/free-solid-svg-icons/faFileVideo";
import { definition as CI } from "@fortawesome/free-solid-svg-icons/faFileWaveform";
import { definition as bc1 } from "@fortawesome/free-solid-svg-icons/faFileWaveform";
import { definition as DI } from "@fortawesome/free-solid-svg-icons/faFileWord";
import { definition as yc1 } from "@fortawesome/free-solid-svg-icons/faFileWord";
import { definition as $I } from "@fortawesome/free-solid-svg-icons/faFileZipper";
import { definition as kc1 } from "@fortawesome/free-solid-svg-icons/faFileZipper";
import { definition as _I } from "@fortawesome/free-solid-svg-icons/faFill";
import { definition as jc1 } from "@fortawesome/free-solid-svg-icons/faFill";
import { definition as bI } from "@fortawesome/free-solid-svg-icons/faFillDrip";
import { definition as Tc1 } from "@fortawesome/free-solid-svg-icons/faFillDrip";
import { definition as SI } from "@fortawesome/free-solid-svg-icons/faFilm";
import { definition as Hc1 } from "@fortawesome/free-solid-svg-icons/faFilm";
import { definition as yI } from "@fortawesome/free-solid-svg-icons/faFilter";
import { definition as Uc1 } from "@fortawesome/free-solid-svg-icons/faFilter";
import { definition as OI } from "@fortawesome/free-solid-svg-icons/faFilterCircleDollar";
import { definition as Gc1 } from "@fortawesome/free-solid-svg-icons/faFilterCircleDollar";
import { definition as kI } from "@fortawesome/free-solid-svg-icons/faFilterCircleXmark";
import { definition as Ec1 } from "@fortawesome/free-solid-svg-icons/faFilterCircleXmark";
import { definition as AI } from "@fortawesome/free-solid-svg-icons/faFingerprint";
import { definition as Ic1 } from "@fortawesome/free-solid-svg-icons/faFingerprint";
import { definition as jI } from "@fortawesome/free-solid-svg-icons/faFire";
import { definition as Xc1 } from "@fortawesome/free-solid-svg-icons/faFire";
import { definition as BI } from "@fortawesome/free-solid-svg-icons/faFireAlt";
import { definition as Jc1 } from "@fortawesome/free-solid-svg-icons/faFireAlt";
import { definition as TI } from "@fortawesome/free-solid-svg-icons/faFireBurner";
import { definition as Zc1 } from "@fortawesome/free-solid-svg-icons/faFireBurner";
import { definition as FI } from "@fortawesome/free-solid-svg-icons/faFireExtinguisher";
import { definition as xc1 } from "@fortawesome/free-solid-svg-icons/faFireExtinguisher";
import { definition as HI } from "@fortawesome/free-solid-svg-icons/faFireFlameCurved";
import { definition as a81 } from "@fortawesome/free-solid-svg-icons/faFireFlameCurved";
import { definition as RI } from "@fortawesome/free-solid-svg-icons/faFireFlameSimple";
import { definition as n81 } from "@fortawesome/free-solid-svg-icons/faFireFlameSimple";
import { definition as UI } from "@fortawesome/free-solid-svg-icons/faFirstAid";
import { definition as c81 } from "@fortawesome/free-solid-svg-icons/faFirstAid";
import { definition as qI } from "@fortawesome/free-solid-svg-icons/faFish";
import { definition as o81 } from "@fortawesome/free-solid-svg-icons/faFish";
import { definition as GI } from "@fortawesome/free-solid-svg-icons/faFishFins";
import { definition as d81 } from "@fortawesome/free-solid-svg-icons/faFishFins";
import { definition as WI } from "@fortawesome/free-solid-svg-icons/faFistRaised";
import { definition as s81 } from "@fortawesome/free-solid-svg-icons/faFistRaised";
import { definition as EI } from "@fortawesome/free-solid-svg-icons/faFlag";
import { definition as v81 } from "@fortawesome/free-solid-svg-icons/faFlag";
import { definition as VI } from "@fortawesome/free-solid-svg-icons/faFlagCheckered";
import { definition as m81 } from "@fortawesome/free-solid-svg-icons/faFlagCheckered";
import { definition as II } from "@fortawesome/free-solid-svg-icons/faFlagUsa";
import { definition as P81 } from "@fortawesome/free-solid-svg-icons/faFlagUsa";
import { definition as KI } from "@fortawesome/free-solid-svg-icons/faFlask";
import { definition as w81 } from "@fortawesome/free-solid-svg-icons/faFlask";
import { definition as XI } from "@fortawesome/free-solid-svg-icons/faFlaskVial";
import { definition as z81 } from "@fortawesome/free-solid-svg-icons/faFlaskVial";
import { definition as QI } from "@fortawesome/free-solid-svg-icons/faFloppyDisk";
import { definition as C81 } from "@fortawesome/free-solid-svg-icons/faFloppyDisk";
import { definition as JI } from "@fortawesome/free-solid-svg-icons/faFlorinSign";
import { definition as $81 } from "@fortawesome/free-solid-svg-icons/faFlorinSign";
import { definition as YI } from "@fortawesome/free-solid-svg-icons/faFlushed";
import { definition as b81 } from "@fortawesome/free-solid-svg-icons/faFlushed";
import { definition as ZI } from "@fortawesome/free-solid-svg-icons/faFolder";
import { definition as y81 } from "@fortawesome/free-solid-svg-icons/faFolder";
import { definition as pI } from "@fortawesome/free-solid-svg-icons/faFolderBlank";
import { definition as k81 } from "@fortawesome/free-solid-svg-icons/faFolderBlank";
import { definition as xI } from "@fortawesome/free-solid-svg-icons/faFolderClosed";
import { definition as j81 } from "@fortawesome/free-solid-svg-icons/faFolderClosed";
import { definition as iK } from "@fortawesome/free-solid-svg-icons/faFolderMinus";
import { definition as T81 } from "@fortawesome/free-solid-svg-icons/faFolderMinus";
import { definition as aK } from "@fortawesome/free-solid-svg-icons/faFolderOpen";
import { definition as H81 } from "@fortawesome/free-solid-svg-icons/faFolderOpen";
import { definition as eK } from "@fortawesome/free-solid-svg-icons/faFolderPlus";
import { definition as U81 } from "@fortawesome/free-solid-svg-icons/faFolderPlus";
import { definition as nK } from "@fortawesome/free-solid-svg-icons/faFolderTree";
import { definition as G81 } from "@fortawesome/free-solid-svg-icons/faFolderTree";
import { definition as fK } from "@fortawesome/free-solid-svg-icons/faFont";
import { definition as E81 } from "@fortawesome/free-solid-svg-icons/faFont";
import { definition as cK } from "@fortawesome/free-solid-svg-icons/faFontAwesome";
import { definition as I81 } from "@fortawesome/free-solid-svg-icons/faFontAwesome";
import { definition as tK } from "@fortawesome/free-solid-svg-icons/faFontAwesomeFlag";
import { definition as X81 } from "@fortawesome/free-solid-svg-icons/faFontAwesomeFlag";
import { definition as oK } from "@fortawesome/free-solid-svg-icons/faFontAwesomeLogoFull";
import { definition as J81 } from "@fortawesome/free-solid-svg-icons/faFontAwesomeLogoFull";
import { definition as lK } from "@fortawesome/free-solid-svg-icons/faFootball";
import { definition as Z81 } from "@fortawesome/free-solid-svg-icons/faFootball";
import { definition as dK } from "@fortawesome/free-solid-svg-icons/faFootballBall";
import { definition as x81 } from "@fortawesome/free-solid-svg-icons/faFootballBall";
import { definition as rK } from "@fortawesome/free-solid-svg-icons/faForward";
import { definition as a51 } from "@fortawesome/free-solid-svg-icons/faForward";
import { definition as sK } from "@fortawesome/free-solid-svg-icons/faForwardFast";
import { definition as n51 } from "@fortawesome/free-solid-svg-icons/faForwardFast";
import { definition as hK } from "@fortawesome/free-solid-svg-icons/faForwardStep";
import { definition as c51 } from "@fortawesome/free-solid-svg-icons/faForwardStep";
import { definition as vK } from "@fortawesome/free-solid-svg-icons/faFrancSign";
import { definition as o51 } from "@fortawesome/free-solid-svg-icons/faFrancSign";
import { definition as uK } from "@fortawesome/free-solid-svg-icons/faFrog";
import { definition as d51 } from "@fortawesome/free-solid-svg-icons/faFrog";
import { definition as mK } from "@fortawesome/free-solid-svg-icons/faFrown";
import { definition as s51 } from "@fortawesome/free-solid-svg-icons/faFrown";
import { definition as gK } from "@fortawesome/free-solid-svg-icons/faFrownOpen";
import { definition as v51 } from "@fortawesome/free-solid-svg-icons/faFrownOpen";
import { definition as PK } from "@fortawesome/free-solid-svg-icons/faFunnelDollar";
import { definition as m51 } from "@fortawesome/free-solid-svg-icons/faFunnelDollar";
import { definition as MK } from "@fortawesome/free-solid-svg-icons/faFutbol";
import { definition as P51 } from "@fortawesome/free-solid-svg-icons/faFutbol";
import { definition as wK } from "@fortawesome/free-solid-svg-icons/faFutbolBall";
import { definition as w51 } from "@fortawesome/free-solid-svg-icons/faFutbolBall";
import { definition as NK } from "@fortawesome/free-solid-svg-icons/faG";
import { definition as z51 } from "@fortawesome/free-solid-svg-icons/faG";
import { definition as zK } from "@fortawesome/free-solid-svg-icons/faGamepad";
import { definition as C51 } from "@fortawesome/free-solid-svg-icons/faGamepad";
import { definition as LK } from "@fortawesome/free-solid-svg-icons/faGasPump";
import { definition as $51 } from "@fortawesome/free-solid-svg-icons/faGasPump";
import { definition as CK } from "@fortawesome/free-solid-svg-icons/faGauge";
import { definition as b51 } from "@fortawesome/free-solid-svg-icons/faGauge";
import { definition as DK } from "@fortawesome/free-solid-svg-icons/faGaugeHigh";
import { definition as y51 } from "@fortawesome/free-solid-svg-icons/faGaugeHigh";
import { definition as $K } from "@fortawesome/free-solid-svg-icons/faGaugeMed";
import { definition as k51 } from "@fortawesome/free-solid-svg-icons/faGaugeMed";
import { definition as _K } from "@fortawesome/free-solid-svg-icons/faGaugeSimple";
import { definition as j51 } from "@fortawesome/free-solid-svg-icons/faGaugeSimple";
import { definition as bK } from "@fortawesome/free-solid-svg-icons/faGaugeSimpleHigh";
import { definition as T51 } from "@fortawesome/free-solid-svg-icons/faGaugeSimpleHigh";
import { definition as SK } from "@fortawesome/free-solid-svg-icons/faGaugeSimpleMed";
import { definition as H51 } from "@fortawesome/free-solid-svg-icons/faGaugeSimpleMed";
import { definition as yK } from "@fortawesome/free-solid-svg-icons/faGavel";
import { definition as U51 } from "@fortawesome/free-solid-svg-icons/faGavel";
import { definition as OK } from "@fortawesome/free-solid-svg-icons/faGbp";
import { definition as G51 } from "@fortawesome/free-solid-svg-icons/faGbp";
import { definition as kK } from "@fortawesome/free-solid-svg-icons/faGear";
import { definition as E51 } from "@fortawesome/free-solid-svg-icons/faGear";
import { definition as AK } from "@fortawesome/free-solid-svg-icons/faGears";
import { definition as I51 } from "@fortawesome/free-solid-svg-icons/faGears";
import { definition as jK } from "@fortawesome/free-solid-svg-icons/faGem";
import { definition as X51 } from "@fortawesome/free-solid-svg-icons/faGem";
import { definition as BK } from "@fortawesome/free-solid-svg-icons/faGenderless";
import { definition as J51 } from "@fortawesome/free-solid-svg-icons/faGenderless";
import { definition as TK } from "@fortawesome/free-solid-svg-icons/faGhost";
import { definition as Z51 } from "@fortawesome/free-solid-svg-icons/faGhost";
import { definition as FK } from "@fortawesome/free-solid-svg-icons/faGift";
import { definition as x51 } from "@fortawesome/free-solid-svg-icons/faGift";
import { definition as HK } from "@fortawesome/free-solid-svg-icons/faGifts";
import { definition as a71 } from "@fortawesome/free-solid-svg-icons/faGifts";
import { definition as RK } from "@fortawesome/free-solid-svg-icons/faGlassCheers";
import { definition as n71 } from "@fortawesome/free-solid-svg-icons/faGlassCheers";
import { definition as UK } from "@fortawesome/free-solid-svg-icons/faGlassMartini";
import { definition as c71 } from "@fortawesome/free-solid-svg-icons/faGlassMartini";
import { definition as qK } from "@fortawesome/free-solid-svg-icons/faGlassMartiniAlt";
import { definition as o71 } from "@fortawesome/free-solid-svg-icons/faGlassMartiniAlt";
import { definition as GK } from "@fortawesome/free-solid-svg-icons/faGlassWater";
import { definition as d71 } from "@fortawesome/free-solid-svg-icons/faGlassWater";
import { definition as WK } from "@fortawesome/free-solid-svg-icons/faGlassWaterDroplet";
import { definition as s71 } from "@fortawesome/free-solid-svg-icons/faGlassWaterDroplet";
import { definition as EK } from "@fortawesome/free-solid-svg-icons/faGlassWhiskey";
import { definition as v71 } from "@fortawesome/free-solid-svg-icons/faGlassWhiskey";
import { definition as VK } from "@fortawesome/free-solid-svg-icons/faGlasses";
import { definition as m71 } from "@fortawesome/free-solid-svg-icons/faGlasses";
import { definition as IK } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { definition as P71 } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { definition as KK } from "@fortawesome/free-solid-svg-icons/faGlobeAfrica";
import { definition as w71 } from "@fortawesome/free-solid-svg-icons/faGlobeAfrica";
import { definition as XK } from "@fortawesome/free-solid-svg-icons/faGlobeAmericas";
import { definition as z71 } from "@fortawesome/free-solid-svg-icons/faGlobeAmericas";
import { definition as QK } from "@fortawesome/free-solid-svg-icons/faGlobeAsia";
import { definition as C71 } from "@fortawesome/free-solid-svg-icons/faGlobeAsia";
import { definition as JK } from "@fortawesome/free-solid-svg-icons/faGlobeEurope";
import { definition as $71 } from "@fortawesome/free-solid-svg-icons/faGlobeEurope";
import { definition as YK } from "@fortawesome/free-solid-svg-icons/faGlobeOceania";
import { definition as b71 } from "@fortawesome/free-solid-svg-icons/faGlobeOceania";
import { definition as ZK } from "@fortawesome/free-solid-svg-icons/faGolfBall";
import { definition as y71 } from "@fortawesome/free-solid-svg-icons/faGolfBall";
import { definition as pK } from "@fortawesome/free-solid-svg-icons/faGolfBallTee";
import { definition as k71 } from "@fortawesome/free-solid-svg-icons/faGolfBallTee";
import { definition as xK } from "@fortawesome/free-solid-svg-icons/faGopuram";
import { definition as j71 } from "@fortawesome/free-solid-svg-icons/faGopuram";
import { definition as iX } from "@fortawesome/free-solid-svg-icons/faGraduationCap";
import { definition as T71 } from "@fortawesome/free-solid-svg-icons/faGraduationCap";
import { definition as aX } from "@fortawesome/free-solid-svg-icons/faGreaterThan";
import { definition as H71 } from "@fortawesome/free-solid-svg-icons/faGreaterThan";
import { definition as eX } from "@fortawesome/free-solid-svg-icons/faGreaterThanEqual";
import { definition as U71 } from "@fortawesome/free-solid-svg-icons/faGreaterThanEqual";
import { definition as nX } from "@fortawesome/free-solid-svg-icons/faGrimace";
import { definition as G71 } from "@fortawesome/free-solid-svg-icons/faGrimace";
import { definition as fX } from "@fortawesome/free-solid-svg-icons/faGrin";
import { definition as E71 } from "@fortawesome/free-solid-svg-icons/faGrin";
import { definition as cX } from "@fortawesome/free-solid-svg-icons/faGrinAlt";
import { definition as I71 } from "@fortawesome/free-solid-svg-icons/faGrinAlt";
import { definition as tX } from "@fortawesome/free-solid-svg-icons/faGrinBeam";
import { definition as X71 } from "@fortawesome/free-solid-svg-icons/faGrinBeam";
import { definition as oX } from "@fortawesome/free-solid-svg-icons/faGrinBeamSweat";
import { definition as J71 } from "@fortawesome/free-solid-svg-icons/faGrinBeamSweat";
import { definition as lX } from "@fortawesome/free-solid-svg-icons/faGrinHearts";
import { definition as Z71 } from "@fortawesome/free-solid-svg-icons/faGrinHearts";
import { definition as dX } from "@fortawesome/free-solid-svg-icons/faGrinSquint";
import { definition as x71 } from "@fortawesome/free-solid-svg-icons/faGrinSquint";
import { definition as rX } from "@fortawesome/free-solid-svg-icons/faGrinSquintTears";
import { definition as at1 } from "@fortawesome/free-solid-svg-icons/faGrinSquintTears";
import { definition as sX } from "@fortawesome/free-solid-svg-icons/faGrinStars";
import { definition as nt1 } from "@fortawesome/free-solid-svg-icons/faGrinStars";
import { definition as hX } from "@fortawesome/free-solid-svg-icons/faGrinTears";
import { definition as ct1 } from "@fortawesome/free-solid-svg-icons/faGrinTears";
import { definition as vX } from "@fortawesome/free-solid-svg-icons/faGrinTongue";
import { definition as ot1 } from "@fortawesome/free-solid-svg-icons/faGrinTongue";
import { definition as uX } from "@fortawesome/free-solid-svg-icons/faGrinTongueSquint";
import { definition as dt1 } from "@fortawesome/free-solid-svg-icons/faGrinTongueSquint";
import { definition as mX } from "@fortawesome/free-solid-svg-icons/faGrinTongueWink";
import { definition as st1 } from "@fortawesome/free-solid-svg-icons/faGrinTongueWink";
import { definition as gX } from "@fortawesome/free-solid-svg-icons/faGrinWink";
import { definition as vt1 } from "@fortawesome/free-solid-svg-icons/faGrinWink";
import { definition as PX } from "@fortawesome/free-solid-svg-icons/faGrip";
import { definition as mt1 } from "@fortawesome/free-solid-svg-icons/faGrip";
import { definition as MX } from "@fortawesome/free-solid-svg-icons/faGripHorizontal";
import { definition as Pt1 } from "@fortawesome/free-solid-svg-icons/faGripHorizontal";
import { definition as wX } from "@fortawesome/free-solid-svg-icons/faGripLines";
import { definition as wt1 } from "@fortawesome/free-solid-svg-icons/faGripLines";
import { definition as NX } from "@fortawesome/free-solid-svg-icons/faGripLinesVertical";
import { definition as zt1 } from "@fortawesome/free-solid-svg-icons/faGripLinesVertical";
import { definition as zX } from "@fortawesome/free-solid-svg-icons/faGripVertical";
import { definition as Ct1 } from "@fortawesome/free-solid-svg-icons/faGripVertical";
import { definition as LX } from "@fortawesome/free-solid-svg-icons/faGroupArrowsRotate";
import { definition as $t1 } from "@fortawesome/free-solid-svg-icons/faGroupArrowsRotate";
import { definition as CX } from "@fortawesome/free-solid-svg-icons/faGuaraniSign";
import { definition as bt1 } from "@fortawesome/free-solid-svg-icons/faGuaraniSign";
import { definition as DX } from "@fortawesome/free-solid-svg-icons/faGuitar";
import { definition as yt1 } from "@fortawesome/free-solid-svg-icons/faGuitar";
import { definition as $X } from "@fortawesome/free-solid-svg-icons/faGun";
import { definition as kt1 } from "@fortawesome/free-solid-svg-icons/faGun";
import { definition as _X } from "@fortawesome/free-solid-svg-icons/faH";
import { definition as jt1 } from "@fortawesome/free-solid-svg-icons/faH";
import { definition as bX } from "@fortawesome/free-solid-svg-icons/faHSquare";
import { definition as Tt1 } from "@fortawesome/free-solid-svg-icons/faHSquare";
import { definition as SX } from "@fortawesome/free-solid-svg-icons/faHamburger";
import { definition as Ht1 } from "@fortawesome/free-solid-svg-icons/faHamburger";
import { definition as yX } from "@fortawesome/free-solid-svg-icons/faHammer";
import { definition as Ut1 } from "@fortawesome/free-solid-svg-icons/faHammer";
import { definition as OX } from "@fortawesome/free-solid-svg-icons/faHamsa";
import { definition as Gt1 } from "@fortawesome/free-solid-svg-icons/faHamsa";
import { definition as kX } from "@fortawesome/free-solid-svg-icons/faHand";
import { definition as Et1 } from "@fortawesome/free-solid-svg-icons/faHand";
import { definition as AX } from "@fortawesome/free-solid-svg-icons/faHandBackFist";
import { definition as It1 } from "@fortawesome/free-solid-svg-icons/faHandBackFist";
import { definition as jX } from "@fortawesome/free-solid-svg-icons/faHandDots";
import { definition as Xt1 } from "@fortawesome/free-solid-svg-icons/faHandDots";
import { definition as BX } from "@fortawesome/free-solid-svg-icons/faHandFist";
import { definition as Jt1 } from "@fortawesome/free-solid-svg-icons/faHandFist";
import { definition as TX } from "@fortawesome/free-solid-svg-icons/faHandHolding";
import { definition as Zt1 } from "@fortawesome/free-solid-svg-icons/faHandHolding";
import { definition as FX } from "@fortawesome/free-solid-svg-icons/faHandHoldingDollar";
import { definition as xt1 } from "@fortawesome/free-solid-svg-icons/faHandHoldingDollar";
import { definition as HX } from "@fortawesome/free-solid-svg-icons/faHandHoldingDroplet";
import { definition as ao1 } from "@fortawesome/free-solid-svg-icons/faHandHoldingDroplet";
import { definition as RX } from "@fortawesome/free-solid-svg-icons/faHandHoldingHand";
import { definition as no1 } from "@fortawesome/free-solid-svg-icons/faHandHoldingHand";
import { definition as UX } from "@fortawesome/free-solid-svg-icons/faHandHoldingHeart";
import { definition as co1 } from "@fortawesome/free-solid-svg-icons/faHandHoldingHeart";
import { definition as qX } from "@fortawesome/free-solid-svg-icons/faHandHoldingMedical";
import { definition as oo1 } from "@fortawesome/free-solid-svg-icons/faHandHoldingMedical";
import { definition as GX } from "@fortawesome/free-solid-svg-icons/faHandHoldingUsd";
import { definition as do1 } from "@fortawesome/free-solid-svg-icons/faHandHoldingUsd";
import { definition as WX } from "@fortawesome/free-solid-svg-icons/faHandHoldingWater";
import { definition as so1 } from "@fortawesome/free-solid-svg-icons/faHandHoldingWater";
import { definition as EX } from "@fortawesome/free-solid-svg-icons/faHandLizard";
import { definition as vo1 } from "@fortawesome/free-solid-svg-icons/faHandLizard";
import { definition as VX } from "@fortawesome/free-solid-svg-icons/faHandMiddleFinger";
import { definition as mo1 } from "@fortawesome/free-solid-svg-icons/faHandMiddleFinger";
import { definition as IX } from "@fortawesome/free-solid-svg-icons/faHandPaper";
import { definition as Po1 } from "@fortawesome/free-solid-svg-icons/faHandPaper";
import { definition as KX } from "@fortawesome/free-solid-svg-icons/faHandPeace";
import { definition as wo1 } from "@fortawesome/free-solid-svg-icons/faHandPeace";
import { definition as XX } from "@fortawesome/free-solid-svg-icons/faHandPointDown";
import { definition as zo1 } from "@fortawesome/free-solid-svg-icons/faHandPointDown";
import { definition as QX } from "@fortawesome/free-solid-svg-icons/faHandPointLeft";
import { definition as Co1 } from "@fortawesome/free-solid-svg-icons/faHandPointLeft";
import { definition as JX } from "@fortawesome/free-solid-svg-icons/faHandPointRight";
import { definition as $o1 } from "@fortawesome/free-solid-svg-icons/faHandPointRight";
import { definition as YX } from "@fortawesome/free-solid-svg-icons/faHandPointUp";
import { definition as bo1 } from "@fortawesome/free-solid-svg-icons/faHandPointUp";
import { definition as ZX } from "@fortawesome/free-solid-svg-icons/faHandPointer";
import { definition as yo1 } from "@fortawesome/free-solid-svg-icons/faHandPointer";
import { definition as pX } from "@fortawesome/free-solid-svg-icons/faHandRock";
import { definition as ko1 } from "@fortawesome/free-solid-svg-icons/faHandRock";
import { definition as xX } from "@fortawesome/free-solid-svg-icons/faHandScissors";
import { definition as jo1 } from "@fortawesome/free-solid-svg-icons/faHandScissors";
import { definition as iQ } from "@fortawesome/free-solid-svg-icons/faHandSparkles";
import { definition as To1 } from "@fortawesome/free-solid-svg-icons/faHandSparkles";
import { definition as aQ } from "@fortawesome/free-solid-svg-icons/faHandSpock";
import { definition as Ho1 } from "@fortawesome/free-solid-svg-icons/faHandSpock";
import { definition as eQ } from "@fortawesome/free-solid-svg-icons/faHandcuffs";
import { definition as Uo1 } from "@fortawesome/free-solid-svg-icons/faHandcuffs";
import { definition as nQ } from "@fortawesome/free-solid-svg-icons/faHands";
import { definition as Go1 } from "@fortawesome/free-solid-svg-icons/faHands";
import { definition as fQ } from "@fortawesome/free-solid-svg-icons/faHandsAmericanSignLanguageInterpreting";
import { definition as Eo1 } from "@fortawesome/free-solid-svg-icons/faHandsAmericanSignLanguageInterpreting";
import { definition as cQ } from "@fortawesome/free-solid-svg-icons/faHandsAslInterpreting";
import { definition as Io1 } from "@fortawesome/free-solid-svg-icons/faHandsAslInterpreting";
import { definition as tQ } from "@fortawesome/free-solid-svg-icons/faHandsBound";
import { definition as Xo1 } from "@fortawesome/free-solid-svg-icons/faHandsBound";
import { definition as oQ } from "@fortawesome/free-solid-svg-icons/faHandsBubbles";
import { definition as Jo1 } from "@fortawesome/free-solid-svg-icons/faHandsBubbles";
import { definition as lQ } from "@fortawesome/free-solid-svg-icons/faHandsClapping";
import { definition as Zo1 } from "@fortawesome/free-solid-svg-icons/faHandsClapping";
import { definition as dQ } from "@fortawesome/free-solid-svg-icons/faHandsHelping";
import { definition as xo1 } from "@fortawesome/free-solid-svg-icons/faHandsHelping";
import { definition as rQ } from "@fortawesome/free-solid-svg-icons/faHandsHolding";
import { definition as al1 } from "@fortawesome/free-solid-svg-icons/faHandsHolding";
import { definition as sQ } from "@fortawesome/free-solid-svg-icons/faHandsHoldingChild";
import { definition as nl1 } from "@fortawesome/free-solid-svg-icons/faHandsHoldingChild";
import { definition as hQ } from "@fortawesome/free-solid-svg-icons/faHandsHoldingCircle";
import { definition as cl1 } from "@fortawesome/free-solid-svg-icons/faHandsHoldingCircle";
import { definition as vQ } from "@fortawesome/free-solid-svg-icons/faHandsPraying";
import { definition as ol1 } from "@fortawesome/free-solid-svg-icons/faHandsPraying";
import { definition as uQ } from "@fortawesome/free-solid-svg-icons/faHandsWash";
import { definition as dl1 } from "@fortawesome/free-solid-svg-icons/faHandsWash";
import { definition as mQ } from "@fortawesome/free-solid-svg-icons/faHandshake";
import { definition as sl1 } from "@fortawesome/free-solid-svg-icons/faHandshake";
import { definition as gQ } from "@fortawesome/free-solid-svg-icons/faHandshakeAlt";
import { definition as vl1 } from "@fortawesome/free-solid-svg-icons/faHandshakeAlt";
import { definition as PQ } from "@fortawesome/free-solid-svg-icons/faHandshakeAltSlash";
import { definition as ml1 } from "@fortawesome/free-solid-svg-icons/faHandshakeAltSlash";
import { definition as MQ } from "@fortawesome/free-solid-svg-icons/faHandshakeAngle";
import { definition as Pl1 } from "@fortawesome/free-solid-svg-icons/faHandshakeAngle";
import { definition as wQ } from "@fortawesome/free-solid-svg-icons/faHandshakeSimple";
import { definition as wl1 } from "@fortawesome/free-solid-svg-icons/faHandshakeSimple";
import { definition as NQ } from "@fortawesome/free-solid-svg-icons/faHandshakeSimpleSlash";
import { definition as zl1 } from "@fortawesome/free-solid-svg-icons/faHandshakeSimpleSlash";
import { definition as zQ } from "@fortawesome/free-solid-svg-icons/faHandshakeSlash";
import { definition as Cl1 } from "@fortawesome/free-solid-svg-icons/faHandshakeSlash";
import { definition as LQ } from "@fortawesome/free-solid-svg-icons/faHanukiah";
import { definition as $l1 } from "@fortawesome/free-solid-svg-icons/faHanukiah";
import { definition as CQ } from "@fortawesome/free-solid-svg-icons/faHardDrive";
import { definition as bl1 } from "@fortawesome/free-solid-svg-icons/faHardDrive";
import { definition as DQ } from "@fortawesome/free-solid-svg-icons/faHardHat";
import { definition as yl1 } from "@fortawesome/free-solid-svg-icons/faHardHat";
import { definition as $Q } from "@fortawesome/free-solid-svg-icons/faHardOfHearing";
import { definition as kl1 } from "@fortawesome/free-solid-svg-icons/faHardOfHearing";
import { definition as _Q } from "@fortawesome/free-solid-svg-icons/faHashtag";
import { definition as jl1 } from "@fortawesome/free-solid-svg-icons/faHashtag";
import { definition as bQ } from "@fortawesome/free-solid-svg-icons/faHatCowboy";
import { definition as Tl1 } from "@fortawesome/free-solid-svg-icons/faHatCowboy";
import { definition as SQ } from "@fortawesome/free-solid-svg-icons/faHatCowboySide";
import { definition as Hl1 } from "@fortawesome/free-solid-svg-icons/faHatCowboySide";
import { definition as yQ } from "@fortawesome/free-solid-svg-icons/faHatHard";
import { definition as Ul1 } from "@fortawesome/free-solid-svg-icons/faHatHard";
import { definition as OQ } from "@fortawesome/free-solid-svg-icons/faHatWizard";
import { definition as Gl1 } from "@fortawesome/free-solid-svg-icons/faHatWizard";
import { definition as kQ } from "@fortawesome/free-solid-svg-icons/faHaykal";
import { definition as El1 } from "@fortawesome/free-solid-svg-icons/faHaykal";
import { definition as AQ } from "@fortawesome/free-solid-svg-icons/faHdd";
import { definition as Il1 } from "@fortawesome/free-solid-svg-icons/faHdd";
import { definition as jQ } from "@fortawesome/free-solid-svg-icons/faHeadSideCough";
import { definition as Xl1 } from "@fortawesome/free-solid-svg-icons/faHeadSideCough";
import { definition as BQ } from "@fortawesome/free-solid-svg-icons/faHeadSideCoughSlash";
import { definition as Jl1 } from "@fortawesome/free-solid-svg-icons/faHeadSideCoughSlash";
import { definition as TQ } from "@fortawesome/free-solid-svg-icons/faHeadSideMask";
import { definition as Zl1 } from "@fortawesome/free-solid-svg-icons/faHeadSideMask";
import { definition as FQ } from "@fortawesome/free-solid-svg-icons/faHeadSideVirus";
import { definition as xl1 } from "@fortawesome/free-solid-svg-icons/faHeadSideVirus";
import { definition as HQ } from "@fortawesome/free-solid-svg-icons/faHeader";
import { definition as ad1 } from "@fortawesome/free-solid-svg-icons/faHeader";
import { definition as RQ } from "@fortawesome/free-solid-svg-icons/faHeading";
import { definition as nd1 } from "@fortawesome/free-solid-svg-icons/faHeading";
import { definition as UQ } from "@fortawesome/free-solid-svg-icons/faHeadphones";
import { definition as cd1 } from "@fortawesome/free-solid-svg-icons/faHeadphones";
import { definition as qQ } from "@fortawesome/free-solid-svg-icons/faHeadphonesAlt";
import { definition as od1 } from "@fortawesome/free-solid-svg-icons/faHeadphonesAlt";
import { definition as GQ } from "@fortawesome/free-solid-svg-icons/faHeadphonesSimple";
import { definition as dd1 } from "@fortawesome/free-solid-svg-icons/faHeadphonesSimple";
import { definition as WQ } from "@fortawesome/free-solid-svg-icons/faHeadset";
import { definition as sd1 } from "@fortawesome/free-solid-svg-icons/faHeadset";
import { definition as EQ } from "@fortawesome/free-solid-svg-icons/faHeart";
import { definition as vd1 } from "@fortawesome/free-solid-svg-icons/faHeart";
import { definition as VQ } from "@fortawesome/free-solid-svg-icons/faHeartBroken";
import { definition as md1 } from "@fortawesome/free-solid-svg-icons/faHeartBroken";
import { definition as IQ } from "@fortawesome/free-solid-svg-icons/faHeartCircleBolt";
import { definition as Pd1 } from "@fortawesome/free-solid-svg-icons/faHeartCircleBolt";
import { definition as KQ } from "@fortawesome/free-solid-svg-icons/faHeartCircleCheck";
import { definition as wd1 } from "@fortawesome/free-solid-svg-icons/faHeartCircleCheck";
import { definition as XQ } from "@fortawesome/free-solid-svg-icons/faHeartCircleExclamation";
import { definition as zd1 } from "@fortawesome/free-solid-svg-icons/faHeartCircleExclamation";
import { definition as QQ } from "@fortawesome/free-solid-svg-icons/faHeartCircleMinus";
import { definition as Cd1 } from "@fortawesome/free-solid-svg-icons/faHeartCircleMinus";
import { definition as JQ } from "@fortawesome/free-solid-svg-icons/faHeartCirclePlus";
import { definition as $d1 } from "@fortawesome/free-solid-svg-icons/faHeartCirclePlus";
import { definition as YQ } from "@fortawesome/free-solid-svg-icons/faHeartCircleXmark";
import { definition as bd1 } from "@fortawesome/free-solid-svg-icons/faHeartCircleXmark";
import { definition as ZQ } from "@fortawesome/free-solid-svg-icons/faHeartCrack";
import { definition as yd1 } from "@fortawesome/free-solid-svg-icons/faHeartCrack";
import { definition as pQ } from "@fortawesome/free-solid-svg-icons/faHeartMusicCameraBolt";
import { definition as kd1 } from "@fortawesome/free-solid-svg-icons/faHeartMusicCameraBolt";
import { definition as xQ } from "@fortawesome/free-solid-svg-icons/faHeartPulse";
import { definition as jd1 } from "@fortawesome/free-solid-svg-icons/faHeartPulse";
import { definition as iJ } from "@fortawesome/free-solid-svg-icons/faHeartbeat";
import { definition as Td1 } from "@fortawesome/free-solid-svg-icons/faHeartbeat";
import { definition as aJ } from "@fortawesome/free-solid-svg-icons/faHelicopter";
import { definition as Hd1 } from "@fortawesome/free-solid-svg-icons/faHelicopter";
import { definition as eJ } from "@fortawesome/free-solid-svg-icons/faHelicopterSymbol";
import { definition as Ud1 } from "@fortawesome/free-solid-svg-icons/faHelicopterSymbol";
import { definition as nJ } from "@fortawesome/free-solid-svg-icons/faHelmetSafety";
import { definition as Gd1 } from "@fortawesome/free-solid-svg-icons/faHelmetSafety";
import { definition as fJ } from "@fortawesome/free-solid-svg-icons/faHelmetUn";
import { definition as Ed1 } from "@fortawesome/free-solid-svg-icons/faHelmetUn";
import { definition as cJ } from "@fortawesome/free-solid-svg-icons/faHighlighter";
import { definition as Id1 } from "@fortawesome/free-solid-svg-icons/faHighlighter";
import { definition as tJ } from "@fortawesome/free-solid-svg-icons/faHiking";
import { definition as Xd1 } from "@fortawesome/free-solid-svg-icons/faHiking";
import { definition as oJ } from "@fortawesome/free-solid-svg-icons/faHillAvalanche";
import { definition as Jd1 } from "@fortawesome/free-solid-svg-icons/faHillAvalanche";
import { definition as lJ } from "@fortawesome/free-solid-svg-icons/faHillRockslide";
import { definition as Zd1 } from "@fortawesome/free-solid-svg-icons/faHillRockslide";
import { definition as dJ } from "@fortawesome/free-solid-svg-icons/faHippo";
import { definition as xd1 } from "@fortawesome/free-solid-svg-icons/faHippo";
import { definition as rJ } from "@fortawesome/free-solid-svg-icons/faHistory";
import { definition as ar1 } from "@fortawesome/free-solid-svg-icons/faHistory";
import { definition as sJ } from "@fortawesome/free-solid-svg-icons/faHockeyPuck";
import { definition as nr1 } from "@fortawesome/free-solid-svg-icons/faHockeyPuck";
import { definition as hJ } from "@fortawesome/free-solid-svg-icons/faHollyBerry";
import { definition as cr1 } from "@fortawesome/free-solid-svg-icons/faHollyBerry";
import { definition as vJ } from "@fortawesome/free-solid-svg-icons/faHome";
import { definition as or1 } from "@fortawesome/free-solid-svg-icons/faHome";
import { definition as uJ } from "@fortawesome/free-solid-svg-icons/faHomeAlt";
import { definition as dr1 } from "@fortawesome/free-solid-svg-icons/faHomeAlt";
import { definition as mJ } from "@fortawesome/free-solid-svg-icons/faHomeLg";
import { definition as sr1 } from "@fortawesome/free-solid-svg-icons/faHomeLg";
import { definition as gJ } from "@fortawesome/free-solid-svg-icons/faHomeLgAlt";
import { definition as vr1 } from "@fortawesome/free-solid-svg-icons/faHomeLgAlt";
import { definition as PJ } from "@fortawesome/free-solid-svg-icons/faHomeUser";
import { definition as mr1 } from "@fortawesome/free-solid-svg-icons/faHomeUser";
import { definition as MJ } from "@fortawesome/free-solid-svg-icons/faHorse";
import { definition as Pr1 } from "@fortawesome/free-solid-svg-icons/faHorse";
import { definition as wJ } from "@fortawesome/free-solid-svg-icons/faHorseHead";
import { definition as wr1 } from "@fortawesome/free-solid-svg-icons/faHorseHead";
import { definition as NJ } from "@fortawesome/free-solid-svg-icons/faHospital";
import { definition as zr1 } from "@fortawesome/free-solid-svg-icons/faHospital";
import { definition as zJ } from "@fortawesome/free-solid-svg-icons/faHospitalAlt";
import { definition as Cr1 } from "@fortawesome/free-solid-svg-icons/faHospitalAlt";
import { definition as LJ } from "@fortawesome/free-solid-svg-icons/faHospitalSymbol";
import { definition as $r1 } from "@fortawesome/free-solid-svg-icons/faHospitalSymbol";
import { definition as CJ } from "@fortawesome/free-solid-svg-icons/faHospitalUser";
import { definition as br1 } from "@fortawesome/free-solid-svg-icons/faHospitalUser";
import { definition as DJ } from "@fortawesome/free-solid-svg-icons/faHospitalWide";
import { definition as yr1 } from "@fortawesome/free-solid-svg-icons/faHospitalWide";
import { definition as $J } from "@fortawesome/free-solid-svg-icons/faHotTub";
import { definition as kr1 } from "@fortawesome/free-solid-svg-icons/faHotTub";
import { definition as _J } from "@fortawesome/free-solid-svg-icons/faHotTubPerson";
import { definition as jr1 } from "@fortawesome/free-solid-svg-icons/faHotTubPerson";
import { definition as bJ } from "@fortawesome/free-solid-svg-icons/faHotdog";
import { definition as Tr1 } from "@fortawesome/free-solid-svg-icons/faHotdog";
import { definition as SJ } from "@fortawesome/free-solid-svg-icons/faHotel";
import { definition as Hr1 } from "@fortawesome/free-solid-svg-icons/faHotel";
import { definition as yJ } from "@fortawesome/free-solid-svg-icons/faHourglass";
import { definition as Ur1 } from "@fortawesome/free-solid-svg-icons/faHourglass";
import { definition as OJ } from "@fortawesome/free-solid-svg-icons/faHourglass1";
import { definition as Gr1 } from "@fortawesome/free-solid-svg-icons/faHourglass1";
import { definition as kJ } from "@fortawesome/free-solid-svg-icons/faHourglass2";
import { definition as Er1 } from "@fortawesome/free-solid-svg-icons/faHourglass2";
import { definition as AJ } from "@fortawesome/free-solid-svg-icons/faHourglass3";
import { definition as Ir1 } from "@fortawesome/free-solid-svg-icons/faHourglass3";
import { definition as jJ } from "@fortawesome/free-solid-svg-icons/faHourglassEmpty";
import { definition as Xr1 } from "@fortawesome/free-solid-svg-icons/faHourglassEmpty";
import { definition as BJ } from "@fortawesome/free-solid-svg-icons/faHourglassEnd";
import { definition as Jr1 } from "@fortawesome/free-solid-svg-icons/faHourglassEnd";
import { definition as TJ } from "@fortawesome/free-solid-svg-icons/faHourglassHalf";
import { definition as Zr1 } from "@fortawesome/free-solid-svg-icons/faHourglassHalf";
import { definition as FJ } from "@fortawesome/free-solid-svg-icons/faHourglassStart";
import { definition as xr1 } from "@fortawesome/free-solid-svg-icons/faHourglassStart";
import { definition as HJ } from "@fortawesome/free-solid-svg-icons/faHouse";
import { definition as a91 } from "@fortawesome/free-solid-svg-icons/faHouse";
import { definition as RJ } from "@fortawesome/free-solid-svg-icons/faHouseChimney";
import { definition as n91 } from "@fortawesome/free-solid-svg-icons/faHouseChimney";
import { definition as UJ } from "@fortawesome/free-solid-svg-icons/faHouseChimneyCrack";
import { definition as c91 } from "@fortawesome/free-solid-svg-icons/faHouseChimneyCrack";
import { definition as qJ } from "@fortawesome/free-solid-svg-icons/faHouseChimneyMedical";
import { definition as o91 } from "@fortawesome/free-solid-svg-icons/faHouseChimneyMedical";
import { definition as GJ } from "@fortawesome/free-solid-svg-icons/faHouseChimneyUser";
import { definition as d91 } from "@fortawesome/free-solid-svg-icons/faHouseChimneyUser";
import { definition as WJ } from "@fortawesome/free-solid-svg-icons/faHouseChimneyWindow";
import { definition as s91 } from "@fortawesome/free-solid-svg-icons/faHouseChimneyWindow";
import { definition as EJ } from "@fortawesome/free-solid-svg-icons/faHouseCircleCheck";
import { definition as v91 } from "@fortawesome/free-solid-svg-icons/faHouseCircleCheck";
import { definition as VJ } from "@fortawesome/free-solid-svg-icons/faHouseCircleExclamation";
import { definition as m91 } from "@fortawesome/free-solid-svg-icons/faHouseCircleExclamation";
import { definition as IJ } from "@fortawesome/free-solid-svg-icons/faHouseCircleXmark";
import { definition as P91 } from "@fortawesome/free-solid-svg-icons/faHouseCircleXmark";
import { definition as KJ } from "@fortawesome/free-solid-svg-icons/faHouseCrack";
import { definition as w91 } from "@fortawesome/free-solid-svg-icons/faHouseCrack";
import { definition as XJ } from "@fortawesome/free-solid-svg-icons/faHouseDamage";
import { definition as z91 } from "@fortawesome/free-solid-svg-icons/faHouseDamage";
import { definition as QJ } from "@fortawesome/free-solid-svg-icons/faHouseFire";
import { definition as C91 } from "@fortawesome/free-solid-svg-icons/faHouseFire";
import { definition as JJ } from "@fortawesome/free-solid-svg-icons/faHouseFlag";
import { definition as $91 } from "@fortawesome/free-solid-svg-icons/faHouseFlag";
import { definition as YJ } from "@fortawesome/free-solid-svg-icons/faHouseFloodWater";
import { definition as b91 } from "@fortawesome/free-solid-svg-icons/faHouseFloodWater";
import { definition as ZJ } from "@fortawesome/free-solid-svg-icons/faHouseFloodWaterCircleArrowRight";
import { definition as y91 } from "@fortawesome/free-solid-svg-icons/faHouseFloodWaterCircleArrowRight";
import { definition as pJ } from "@fortawesome/free-solid-svg-icons/faHouseLaptop";
import { definition as k91 } from "@fortawesome/free-solid-svg-icons/faHouseLaptop";
import { definition as xJ } from "@fortawesome/free-solid-svg-icons/faHouseLock";
import { definition as j91 } from "@fortawesome/free-solid-svg-icons/faHouseLock";
import { definition as iY } from "@fortawesome/free-solid-svg-icons/faHouseMedical";
import { definition as T91 } from "@fortawesome/free-solid-svg-icons/faHouseMedical";
import { definition as aY } from "@fortawesome/free-solid-svg-icons/faHouseMedicalCircleCheck";
import { definition as H91 } from "@fortawesome/free-solid-svg-icons/faHouseMedicalCircleCheck";
import { definition as eY } from "@fortawesome/free-solid-svg-icons/faHouseMedicalCircleExclamation";
import { definition as U91 } from "@fortawesome/free-solid-svg-icons/faHouseMedicalCircleExclamation";
import { definition as nY } from "@fortawesome/free-solid-svg-icons/faHouseMedicalCircleXmark";
import { definition as G91 } from "@fortawesome/free-solid-svg-icons/faHouseMedicalCircleXmark";
import { definition as fY } from "@fortawesome/free-solid-svg-icons/faHouseMedicalFlag";
import { definition as E91 } from "@fortawesome/free-solid-svg-icons/faHouseMedicalFlag";
import { definition as cY } from "@fortawesome/free-solid-svg-icons/faHouseSignal";
import { definition as I91 } from "@fortawesome/free-solid-svg-icons/faHouseSignal";
import { definition as tY } from "@fortawesome/free-solid-svg-icons/faHouseTsunami";
import { definition as X91 } from "@fortawesome/free-solid-svg-icons/faHouseTsunami";
import { definition as oY } from "@fortawesome/free-solid-svg-icons/faHouseUser";
import { definition as J91 } from "@fortawesome/free-solid-svg-icons/faHouseUser";
import { definition as lY } from "@fortawesome/free-solid-svg-icons/faHryvnia";
import { definition as Z91 } from "@fortawesome/free-solid-svg-icons/faHryvnia";
import { definition as dY } from "@fortawesome/free-solid-svg-icons/faHryvniaSign";
import { definition as x91 } from "@fortawesome/free-solid-svg-icons/faHryvniaSign";
import { definition as rY } from "@fortawesome/free-solid-svg-icons/faHurricane";
import { definition as as1 } from "@fortawesome/free-solid-svg-icons/faHurricane";
import { definition as sY } from "@fortawesome/free-solid-svg-icons/faI";
import { definition as ns1 } from "@fortawesome/free-solid-svg-icons/faI";
import { definition as hY } from "@fortawesome/free-solid-svg-icons/faICursor";
import { definition as cs1 } from "@fortawesome/free-solid-svg-icons/faICursor";
import { definition as vY } from "@fortawesome/free-solid-svg-icons/faIceCream";
import { definition as os1 } from "@fortawesome/free-solid-svg-icons/faIceCream";
import { definition as uY } from "@fortawesome/free-solid-svg-icons/faIcicles";
import { definition as ds1 } from "@fortawesome/free-solid-svg-icons/faIcicles";
import { definition as mY } from "@fortawesome/free-solid-svg-icons/faIcons";
import { definition as ss1 } from "@fortawesome/free-solid-svg-icons/faIcons";
import { definition as gY } from "@fortawesome/free-solid-svg-icons/faIdBadge";
import { definition as vs1 } from "@fortawesome/free-solid-svg-icons/faIdBadge";
import { definition as PY } from "@fortawesome/free-solid-svg-icons/faIdCard";
import { definition as ms1 } from "@fortawesome/free-solid-svg-icons/faIdCard";
import { definition as MY } from "@fortawesome/free-solid-svg-icons/faIdCardAlt";
import { definition as Ps1 } from "@fortawesome/free-solid-svg-icons/faIdCardAlt";
import { definition as wY } from "@fortawesome/free-solid-svg-icons/faIdCardClip";
import { definition as ws1 } from "@fortawesome/free-solid-svg-icons/faIdCardClip";
import { definition as NY } from "@fortawesome/free-solid-svg-icons/faIgloo";
import { definition as zs1 } from "@fortawesome/free-solid-svg-icons/faIgloo";
import { definition as zY } from "@fortawesome/free-solid-svg-icons/faIls";
import { definition as Cs1 } from "@fortawesome/free-solid-svg-icons/faIls";
import { definition as LY } from "@fortawesome/free-solid-svg-icons/faImage";
import { definition as $s1 } from "@fortawesome/free-solid-svg-icons/faImage";
import { definition as CY } from "@fortawesome/free-solid-svg-icons/faImagePortrait";
import { definition as bs1 } from "@fortawesome/free-solid-svg-icons/faImagePortrait";
import { definition as DY } from "@fortawesome/free-solid-svg-icons/faImages";
import { definition as ys1 } from "@fortawesome/free-solid-svg-icons/faImages";
import { definition as $Y } from "@fortawesome/free-solid-svg-icons/faInbox";
import { definition as ks1 } from "@fortawesome/free-solid-svg-icons/faInbox";
import { definition as _Y } from "@fortawesome/free-solid-svg-icons/faIndent";
import { definition as js1 } from "@fortawesome/free-solid-svg-icons/faIndent";
import { definition as bY } from "@fortawesome/free-solid-svg-icons/faIndianRupee";
import { definition as Ts1 } from "@fortawesome/free-solid-svg-icons/faIndianRupee";
import { definition as SY } from "@fortawesome/free-solid-svg-icons/faIndianRupeeSign";
import { definition as Hs1 } from "@fortawesome/free-solid-svg-icons/faIndianRupeeSign";
import { definition as yY } from "@fortawesome/free-solid-svg-icons/faIndustry";
import { definition as Us1 } from "@fortawesome/free-solid-svg-icons/faIndustry";
import { definition as OY } from "@fortawesome/free-solid-svg-icons/faInfinity";
import { definition as Gs1 } from "@fortawesome/free-solid-svg-icons/faInfinity";
import { definition as kY } from "@fortawesome/free-solid-svg-icons/faInfo";
import { definition as Es1 } from "@fortawesome/free-solid-svg-icons/faInfo";
import { definition as AY } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { definition as Is1 } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { definition as jY } from "@fortawesome/free-solid-svg-icons/faInr";
import { definition as Xs1 } from "@fortawesome/free-solid-svg-icons/faInr";
import { definition as BY } from "@fortawesome/free-solid-svg-icons/faInstitution";
import { definition as Js1 } from "@fortawesome/free-solid-svg-icons/faInstitution";
import { definition as TY } from "@fortawesome/free-solid-svg-icons/faItalic";
import { definition as Zs1 } from "@fortawesome/free-solid-svg-icons/faItalic";
import { definition as FY } from "@fortawesome/free-solid-svg-icons/faJ";
import { definition as xs1 } from "@fortawesome/free-solid-svg-icons/faJ";
import { definition as HY } from "@fortawesome/free-solid-svg-icons/faJar";
import { definition as ah1 } from "@fortawesome/free-solid-svg-icons/faJar";
import { definition as RY } from "@fortawesome/free-solid-svg-icons/faJarWheat";
import { definition as nh1 } from "@fortawesome/free-solid-svg-icons/faJarWheat";
import { definition as UY } from "@fortawesome/free-solid-svg-icons/faJedi";
import { definition as ch1 } from "@fortawesome/free-solid-svg-icons/faJedi";
import { definition as qY } from "@fortawesome/free-solid-svg-icons/faJetFighter";
import { definition as oh1 } from "@fortawesome/free-solid-svg-icons/faJetFighter";
import { definition as GY } from "@fortawesome/free-solid-svg-icons/faJetFighterUp";
import { definition as dh1 } from "@fortawesome/free-solid-svg-icons/faJetFighterUp";
import { definition as WY } from "@fortawesome/free-solid-svg-icons/faJoint";
import { definition as sh1 } from "@fortawesome/free-solid-svg-icons/faJoint";
import { definition as EY } from "@fortawesome/free-solid-svg-icons/faJournalWhills";
import { definition as vh1 } from "@fortawesome/free-solid-svg-icons/faJournalWhills";
import { definition as VY } from "@fortawesome/free-solid-svg-icons/faJpy";
import { definition as mh1 } from "@fortawesome/free-solid-svg-icons/faJpy";
import { definition as IY } from "@fortawesome/free-solid-svg-icons/faJugDetergent";
import { definition as Ph1 } from "@fortawesome/free-solid-svg-icons/faJugDetergent";
import { definition as KY } from "@fortawesome/free-solid-svg-icons/faK";
import { definition as wh1 } from "@fortawesome/free-solid-svg-icons/faK";
import { definition as XY } from "@fortawesome/free-solid-svg-icons/faKaaba";
import { definition as zh1 } from "@fortawesome/free-solid-svg-icons/faKaaba";
import { definition as QY } from "@fortawesome/free-solid-svg-icons/faKey";
import { definition as Ch1 } from "@fortawesome/free-solid-svg-icons/faKey";
import { definition as JY } from "@fortawesome/free-solid-svg-icons/faKeyboard";
import { definition as $h1 } from "@fortawesome/free-solid-svg-icons/faKeyboard";
import { definition as YY } from "@fortawesome/free-solid-svg-icons/faKhanda";
import { definition as bh1 } from "@fortawesome/free-solid-svg-icons/faKhanda";
import { definition as ZY } from "@fortawesome/free-solid-svg-icons/faKipSign";
import { definition as yh1 } from "@fortawesome/free-solid-svg-icons/faKipSign";
import { definition as pY } from "@fortawesome/free-solid-svg-icons/faKiss";
import { definition as kh1 } from "@fortawesome/free-solid-svg-icons/faKiss";
import { definition as xY } from "@fortawesome/free-solid-svg-icons/faKissBeam";
import { definition as jh1 } from "@fortawesome/free-solid-svg-icons/faKissBeam";
import { definition as iZ } from "@fortawesome/free-solid-svg-icons/faKissWinkHeart";
import { definition as Th1 } from "@fortawesome/free-solid-svg-icons/faKissWinkHeart";
import { definition as aZ } from "@fortawesome/free-solid-svg-icons/faKitMedical";
import { definition as Hh1 } from "@fortawesome/free-solid-svg-icons/faKitMedical";
import { definition as eZ } from "@fortawesome/free-solid-svg-icons/faKitchenSet";
import { definition as Uh1 } from "@fortawesome/free-solid-svg-icons/faKitchenSet";
import { definition as nZ } from "@fortawesome/free-solid-svg-icons/faKiwiBird";
import { definition as Gh1 } from "@fortawesome/free-solid-svg-icons/faKiwiBird";
import { definition as fZ } from "@fortawesome/free-solid-svg-icons/faKrw";
import { definition as Eh1 } from "@fortawesome/free-solid-svg-icons/faKrw";
import { definition as cZ } from "@fortawesome/free-solid-svg-icons/faL";
import { definition as Ih1 } from "@fortawesome/free-solid-svg-icons/faL";
import { definition as tZ } from "@fortawesome/free-solid-svg-icons/faLadderWater";
import { definition as Xh1 } from "@fortawesome/free-solid-svg-icons/faLadderWater";
import { definition as oZ } from "@fortawesome/free-solid-svg-icons/faLandMineOn";
import { definition as Jh1 } from "@fortawesome/free-solid-svg-icons/faLandMineOn";
import { definition as lZ } from "@fortawesome/free-solid-svg-icons/faLandmark";
import { definition as Zh1 } from "@fortawesome/free-solid-svg-icons/faLandmark";
import { definition as dZ } from "@fortawesome/free-solid-svg-icons/faLandmarkAlt";
import { definition as xh1 } from "@fortawesome/free-solid-svg-icons/faLandmarkAlt";
import { definition as rZ } from "@fortawesome/free-solid-svg-icons/faLandmarkDome";
import { definition as av1 } from "@fortawesome/free-solid-svg-icons/faLandmarkDome";
import { definition as sZ } from "@fortawesome/free-solid-svg-icons/faLandmarkFlag";
import { definition as nv1 } from "@fortawesome/free-solid-svg-icons/faLandmarkFlag";
import { definition as hZ } from "@fortawesome/free-solid-svg-icons/faLanguage";
import { definition as cv1 } from "@fortawesome/free-solid-svg-icons/faLanguage";
import { definition as vZ } from "@fortawesome/free-solid-svg-icons/faLaptop";
import { definition as ov1 } from "@fortawesome/free-solid-svg-icons/faLaptop";
import { definition as uZ } from "@fortawesome/free-solid-svg-icons/faLaptopCode";
import { definition as dv1 } from "@fortawesome/free-solid-svg-icons/faLaptopCode";
import { definition as mZ } from "@fortawesome/free-solid-svg-icons/faLaptopFile";
import { definition as sv1 } from "@fortawesome/free-solid-svg-icons/faLaptopFile";
import { definition as gZ } from "@fortawesome/free-solid-svg-icons/faLaptopHouse";
import { definition as vv1 } from "@fortawesome/free-solid-svg-icons/faLaptopHouse";
import { definition as PZ } from "@fortawesome/free-solid-svg-icons/faLaptopMedical";
import { definition as mv1 } from "@fortawesome/free-solid-svg-icons/faLaptopMedical";
import { definition as MZ } from "@fortawesome/free-solid-svg-icons/faLariSign";
import { definition as Pv1 } from "@fortawesome/free-solid-svg-icons/faLariSign";
import { definition as wZ } from "@fortawesome/free-solid-svg-icons/faLaugh";
import { definition as wv1 } from "@fortawesome/free-solid-svg-icons/faLaugh";
import { definition as NZ } from "@fortawesome/free-solid-svg-icons/faLaughBeam";
import { definition as zv1 } from "@fortawesome/free-solid-svg-icons/faLaughBeam";
import { definition as zZ } from "@fortawesome/free-solid-svg-icons/faLaughSquint";
import { definition as Cv1 } from "@fortawesome/free-solid-svg-icons/faLaughSquint";
import { definition as LZ } from "@fortawesome/free-solid-svg-icons/faLaughWink";
import { definition as $v1 } from "@fortawesome/free-solid-svg-icons/faLaughWink";
import { definition as CZ } from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import { definition as bv1 } from "@fortawesome/free-solid-svg-icons/faLayerGroup";
import { definition as DZ } from "@fortawesome/free-solid-svg-icons/faLeaf";
import { definition as yv1 } from "@fortawesome/free-solid-svg-icons/faLeaf";
import { definition as $Z } from "@fortawesome/free-solid-svg-icons/faLeftLong";
import { definition as kv1 } from "@fortawesome/free-solid-svg-icons/faLeftLong";
import { definition as _Z } from "@fortawesome/free-solid-svg-icons/faLeftRight";
import { definition as jv1 } from "@fortawesome/free-solid-svg-icons/faLeftRight";
import { definition as bZ } from "@fortawesome/free-solid-svg-icons/faLegal";
import { definition as Tv1 } from "@fortawesome/free-solid-svg-icons/faLegal";
import { definition as SZ } from "@fortawesome/free-solid-svg-icons/faLemon";
import { definition as Hv1 } from "@fortawesome/free-solid-svg-icons/faLemon";
import { definition as yZ } from "@fortawesome/free-solid-svg-icons/faLessThan";
import { definition as Uv1 } from "@fortawesome/free-solid-svg-icons/faLessThan";
import { definition as OZ } from "@fortawesome/free-solid-svg-icons/faLessThanEqual";
import { definition as Gv1 } from "@fortawesome/free-solid-svg-icons/faLessThanEqual";
import { definition as kZ } from "@fortawesome/free-solid-svg-icons/faLevelDown";
import { definition as Ev1 } from "@fortawesome/free-solid-svg-icons/faLevelDown";
import { definition as AZ } from "@fortawesome/free-solid-svg-icons/faLevelDownAlt";
import { definition as Iv1 } from "@fortawesome/free-solid-svg-icons/faLevelDownAlt";
import { definition as jZ } from "@fortawesome/free-solid-svg-icons/faLevelUp";
import { definition as Xv1 } from "@fortawesome/free-solid-svg-icons/faLevelUp";
import { definition as BZ } from "@fortawesome/free-solid-svg-icons/faLevelUpAlt";
import { definition as Jv1 } from "@fortawesome/free-solid-svg-icons/faLevelUpAlt";
import { definition as TZ } from "@fortawesome/free-solid-svg-icons/faLifeRing";
import { definition as Zv1 } from "@fortawesome/free-solid-svg-icons/faLifeRing";
import { definition as FZ } from "@fortawesome/free-solid-svg-icons/faLightbulb";
import { definition as xv1 } from "@fortawesome/free-solid-svg-icons/faLightbulb";
import { definition as HZ } from "@fortawesome/free-solid-svg-icons/faLineChart";
import { definition as au1 } from "@fortawesome/free-solid-svg-icons/faLineChart";
import { definition as RZ } from "@fortawesome/free-solid-svg-icons/faLinesLeaning";
import { definition as nu1 } from "@fortawesome/free-solid-svg-icons/faLinesLeaning";
import { definition as UZ } from "@fortawesome/free-solid-svg-icons/faLink";
import { definition as cu1 } from "@fortawesome/free-solid-svg-icons/faLink";
import { definition as qZ } from "@fortawesome/free-solid-svg-icons/faLinkSlash";
import { definition as ou1 } from "@fortawesome/free-solid-svg-icons/faLinkSlash";
import { definition as GZ } from "@fortawesome/free-solid-svg-icons/faLiraSign";
import { definition as du1 } from "@fortawesome/free-solid-svg-icons/faLiraSign";
import { definition as WZ } from "@fortawesome/free-solid-svg-icons/faList";
import { definition as su1 } from "@fortawesome/free-solid-svg-icons/faList";
import { definition as EZ } from "@fortawesome/free-solid-svg-icons/faList12";
import { definition as vu1 } from "@fortawesome/free-solid-svg-icons/faList12";
import { definition as VZ } from "@fortawesome/free-solid-svg-icons/faListAlt";
import { definition as mu1 } from "@fortawesome/free-solid-svg-icons/faListAlt";
import { definition as IZ } from "@fortawesome/free-solid-svg-icons/faListCheck";
import { definition as Pu1 } from "@fortawesome/free-solid-svg-icons/faListCheck";
import { definition as KZ } from "@fortawesome/free-solid-svg-icons/faListDots";
import { definition as wu1 } from "@fortawesome/free-solid-svg-icons/faListDots";
import { definition as XZ } from "@fortawesome/free-solid-svg-icons/faListNumeric";
import { definition as zu1 } from "@fortawesome/free-solid-svg-icons/faListNumeric";
import { definition as QZ } from "@fortawesome/free-solid-svg-icons/faListOl";
import { definition as Cu1 } from "@fortawesome/free-solid-svg-icons/faListOl";
import { definition as JZ } from "@fortawesome/free-solid-svg-icons/faListSquares";
import { definition as $u1 } from "@fortawesome/free-solid-svg-icons/faListSquares";
import { definition as YZ } from "@fortawesome/free-solid-svg-icons/faListUl";
import { definition as bu1 } from "@fortawesome/free-solid-svg-icons/faListUl";
import { definition as ZZ } from "@fortawesome/free-solid-svg-icons/faLitecoinSign";
import { definition as yu1 } from "@fortawesome/free-solid-svg-icons/faLitecoinSign";
import { definition as pZ } from "@fortawesome/free-solid-svg-icons/faLocation";
import { definition as ku1 } from "@fortawesome/free-solid-svg-icons/faLocation";
import { definition as xZ } from "@fortawesome/free-solid-svg-icons/faLocationArrow";
import { definition as ju1 } from "@fortawesome/free-solid-svg-icons/faLocationArrow";
import { definition as ip } from "@fortawesome/free-solid-svg-icons/faLocationCrosshairs";
import { definition as Tu1 } from "@fortawesome/free-solid-svg-icons/faLocationCrosshairs";
import { definition as ap } from "@fortawesome/free-solid-svg-icons/faLocationDot";
import { definition as Hu1 } from "@fortawesome/free-solid-svg-icons/faLocationDot";
import { definition as ep } from "@fortawesome/free-solid-svg-icons/faLocationPin";
import { definition as Uu1 } from "@fortawesome/free-solid-svg-icons/faLocationPin";
import { definition as np } from "@fortawesome/free-solid-svg-icons/faLocationPinLock";
import { definition as Gu1 } from "@fortawesome/free-solid-svg-icons/faLocationPinLock";
import { definition as fp } from "@fortawesome/free-solid-svg-icons/faLock";
import { definition as Eu1 } from "@fortawesome/free-solid-svg-icons/faLock";
import { definition as cp } from "@fortawesome/free-solid-svg-icons/faLockOpen";
import { definition as Iu1 } from "@fortawesome/free-solid-svg-icons/faLockOpen";
import { definition as tp } from "@fortawesome/free-solid-svg-icons/faLocust";
import { definition as Xu1 } from "@fortawesome/free-solid-svg-icons/faLocust";
import { definition as op } from "@fortawesome/free-solid-svg-icons/faLongArrowAltDown";
import { definition as Ju1 } from "@fortawesome/free-solid-svg-icons/faLongArrowAltDown";
import { definition as lp } from "@fortawesome/free-solid-svg-icons/faLongArrowAltLeft";
import { definition as Zu1 } from "@fortawesome/free-solid-svg-icons/faLongArrowAltLeft";
import { definition as dp } from "@fortawesome/free-solid-svg-icons/faLongArrowAltRight";
import { definition as xu1 } from "@fortawesome/free-solid-svg-icons/faLongArrowAltRight";
import { definition as rp } from "@fortawesome/free-solid-svg-icons/faLongArrowAltUp";
import { definition as am1 } from "@fortawesome/free-solid-svg-icons/faLongArrowAltUp";
import { definition as sp } from "@fortawesome/free-solid-svg-icons/faLongArrowDown";
import { definition as nm1 } from "@fortawesome/free-solid-svg-icons/faLongArrowDown";
import { definition as hp } from "@fortawesome/free-solid-svg-icons/faLongArrowLeft";
import { definition as cm1 } from "@fortawesome/free-solid-svg-icons/faLongArrowLeft";
import { definition as vp } from "@fortawesome/free-solid-svg-icons/faLongArrowRight";
import { definition as om1 } from "@fortawesome/free-solid-svg-icons/faLongArrowRight";
import { definition as up } from "@fortawesome/free-solid-svg-icons/faLongArrowUp";
import { definition as dm1 } from "@fortawesome/free-solid-svg-icons/faLongArrowUp";
import { definition as mp } from "@fortawesome/free-solid-svg-icons/faLowVision";
import { definition as sm1 } from "@fortawesome/free-solid-svg-icons/faLowVision";
import { definition as gp } from "@fortawesome/free-solid-svg-icons/faLuggageCart";
import { definition as vm1 } from "@fortawesome/free-solid-svg-icons/faLuggageCart";
import { definition as Pp } from "@fortawesome/free-solid-svg-icons/faLungs";
import { definition as mm1 } from "@fortawesome/free-solid-svg-icons/faLungs";
import { definition as Mp } from "@fortawesome/free-solid-svg-icons/faLungsVirus";
import { definition as Pm1 } from "@fortawesome/free-solid-svg-icons/faLungsVirus";
import { definition as wp } from "@fortawesome/free-solid-svg-icons/faM";
import { definition as wm1 } from "@fortawesome/free-solid-svg-icons/faM";
import { definition as Np } from "@fortawesome/free-solid-svg-icons/faMagic";
import { definition as zm1 } from "@fortawesome/free-solid-svg-icons/faMagic";
import { definition as zp } from "@fortawesome/free-solid-svg-icons/faMagicWandSparkles";
import { definition as Cm1 } from "@fortawesome/free-solid-svg-icons/faMagicWandSparkles";
import { definition as Lp } from "@fortawesome/free-solid-svg-icons/faMagnet";
import { definition as $m1 } from "@fortawesome/free-solid-svg-icons/faMagnet";
import { definition as Cp } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import { definition as bm1 } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import { definition as Dp } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassArrowRight";
import { definition as ym1 } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassArrowRight";
import { definition as $p } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassChart";
import { definition as km1 } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassChart";
import { definition as _p } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassDollar";
import { definition as jm1 } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassDollar";
import { definition as bp } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassLocation";
import { definition as Tm1 } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassLocation";
import { definition as Sp } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassMinus";
import { definition as Hm1 } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassMinus";
import { definition as yp } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassPlus";
import { definition as Um1 } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassPlus";
import { definition as Op } from "@fortawesome/free-solid-svg-icons/faMailBulk";
import { definition as Gm1 } from "@fortawesome/free-solid-svg-icons/faMailBulk";
import { definition as kp } from "@fortawesome/free-solid-svg-icons/faMailForward";
import { definition as Em1 } from "@fortawesome/free-solid-svg-icons/faMailForward";
import { definition as Ap } from "@fortawesome/free-solid-svg-icons/faMailReply";
import { definition as Im1 } from "@fortawesome/free-solid-svg-icons/faMailReply";
import { definition as jp } from "@fortawesome/free-solid-svg-icons/faMailReplyAll";
import { definition as Xm1 } from "@fortawesome/free-solid-svg-icons/faMailReplyAll";
import { definition as Bp } from "@fortawesome/free-solid-svg-icons/faMale";
import { definition as Jm1 } from "@fortawesome/free-solid-svg-icons/faMale";
import { definition as Tp } from "@fortawesome/free-solid-svg-icons/faManatSign";
import { definition as Zm1 } from "@fortawesome/free-solid-svg-icons/faManatSign";
import { definition as Fp } from "@fortawesome/free-solid-svg-icons/faMap";
import { definition as xm1 } from "@fortawesome/free-solid-svg-icons/faMap";
import { definition as Hp } from "@fortawesome/free-solid-svg-icons/faMapLocation";
import { definition as ag1 } from "@fortawesome/free-solid-svg-icons/faMapLocation";
import { definition as Rp } from "@fortawesome/free-solid-svg-icons/faMapLocationDot";
import { definition as ng1 } from "@fortawesome/free-solid-svg-icons/faMapLocationDot";
import { definition as Up } from "@fortawesome/free-solid-svg-icons/faMapMarked";
import { definition as cg1 } from "@fortawesome/free-solid-svg-icons/faMapMarked";
import { definition as qp } from "@fortawesome/free-solid-svg-icons/faMapMarkedAlt";
import { definition as og1 } from "@fortawesome/free-solid-svg-icons/faMapMarkedAlt";
import { definition as Gp } from "@fortawesome/free-solid-svg-icons/faMapMarker";
import { definition as dg1 } from "@fortawesome/free-solid-svg-icons/faMapMarker";
import { definition as Wp } from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import { definition as sg1 } from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import { definition as Ep } from "@fortawesome/free-solid-svg-icons/faMapPin";
import { definition as vg1 } from "@fortawesome/free-solid-svg-icons/faMapPin";
import { definition as Vp } from "@fortawesome/free-solid-svg-icons/faMapSigns";
import { definition as mg1 } from "@fortawesome/free-solid-svg-icons/faMapSigns";
import { definition as Ip } from "@fortawesome/free-solid-svg-icons/faMarker";
import { definition as Pg1 } from "@fortawesome/free-solid-svg-icons/faMarker";
import { definition as Kp } from "@fortawesome/free-solid-svg-icons/faMars";
import { definition as wg1 } from "@fortawesome/free-solid-svg-icons/faMars";
import { definition as Xp } from "@fortawesome/free-solid-svg-icons/faMarsAndVenus";
import { definition as zg1 } from "@fortawesome/free-solid-svg-icons/faMarsAndVenus";
import { definition as Qp } from "@fortawesome/free-solid-svg-icons/faMarsAndVenusBurst";
import { definition as Cg1 } from "@fortawesome/free-solid-svg-icons/faMarsAndVenusBurst";
import { definition as Jp } from "@fortawesome/free-solid-svg-icons/faMarsDouble";
import { definition as $g1 } from "@fortawesome/free-solid-svg-icons/faMarsDouble";
import { definition as Yp } from "@fortawesome/free-solid-svg-icons/faMarsStroke";
import { definition as bg1 } from "@fortawesome/free-solid-svg-icons/faMarsStroke";
import { definition as Zp } from "@fortawesome/free-solid-svg-icons/faMarsStrokeH";
import { definition as yg1 } from "@fortawesome/free-solid-svg-icons/faMarsStrokeH";
import { definition as pp } from "@fortawesome/free-solid-svg-icons/faMarsStrokeRight";
import { definition as kg1 } from "@fortawesome/free-solid-svg-icons/faMarsStrokeRight";
import { definition as xp } from "@fortawesome/free-solid-svg-icons/faMarsStrokeUp";
import { definition as jg1 } from "@fortawesome/free-solid-svg-icons/faMarsStrokeUp";
import { definition as ix } from "@fortawesome/free-solid-svg-icons/faMarsStrokeV";
import { definition as Tg1 } from "@fortawesome/free-solid-svg-icons/faMarsStrokeV";
import { definition as ax } from "@fortawesome/free-solid-svg-icons/faMartiniGlass";
import { definition as Hg1 } from "@fortawesome/free-solid-svg-icons/faMartiniGlass";
import { definition as ex } from "@fortawesome/free-solid-svg-icons/faMartiniGlassCitrus";
import { definition as Ug1 } from "@fortawesome/free-solid-svg-icons/faMartiniGlassCitrus";
import { definition as nx } from "@fortawesome/free-solid-svg-icons/faMartiniGlassEmpty";
import { definition as Gg1 } from "@fortawesome/free-solid-svg-icons/faMartiniGlassEmpty";
import { definition as fx } from "@fortawesome/free-solid-svg-icons/faMask";
import { definition as Eg1 } from "@fortawesome/free-solid-svg-icons/faMask";
import { definition as cx } from "@fortawesome/free-solid-svg-icons/faMaskFace";
import { definition as Ig1 } from "@fortawesome/free-solid-svg-icons/faMaskFace";
import { definition as tx } from "@fortawesome/free-solid-svg-icons/faMaskVentilator";
import { definition as Xg1 } from "@fortawesome/free-solid-svg-icons/faMaskVentilator";
import { definition as ox } from "@fortawesome/free-solid-svg-icons/faMasksTheater";
import { definition as Jg1 } from "@fortawesome/free-solid-svg-icons/faMasksTheater";
import { definition as lx } from "@fortawesome/free-solid-svg-icons/faMattressPillow";
import { definition as Zg1 } from "@fortawesome/free-solid-svg-icons/faMattressPillow";
import { definition as dx } from "@fortawesome/free-solid-svg-icons/faMaximize";
import { definition as xg1 } from "@fortawesome/free-solid-svg-icons/faMaximize";
import { definition as rx } from "@fortawesome/free-solid-svg-icons/faMedal";
import { definition as aP1 } from "@fortawesome/free-solid-svg-icons/faMedal";
import { definition as sx } from "@fortawesome/free-solid-svg-icons/faMedkit";
import { definition as nP1 } from "@fortawesome/free-solid-svg-icons/faMedkit";
import { definition as hx } from "@fortawesome/free-solid-svg-icons/faMeh";
import { definition as cP1 } from "@fortawesome/free-solid-svg-icons/faMeh";
import { definition as vx } from "@fortawesome/free-solid-svg-icons/faMehBlank";
import { definition as oP1 } from "@fortawesome/free-solid-svg-icons/faMehBlank";
import { definition as ux } from "@fortawesome/free-solid-svg-icons/faMehRollingEyes";
import { definition as dP1 } from "@fortawesome/free-solid-svg-icons/faMehRollingEyes";
import { definition as mx } from "@fortawesome/free-solid-svg-icons/faMemory";
import { definition as sP1 } from "@fortawesome/free-solid-svg-icons/faMemory";
import { definition as gx } from "@fortawesome/free-solid-svg-icons/faMenorah";
import { definition as vP1 } from "@fortawesome/free-solid-svg-icons/faMenorah";
import { definition as Px } from "@fortawesome/free-solid-svg-icons/faMercury";
import { definition as mP1 } from "@fortawesome/free-solid-svg-icons/faMercury";
import { definition as Mx } from "@fortawesome/free-solid-svg-icons/faMessage";
import { definition as PP1 } from "@fortawesome/free-solid-svg-icons/faMessage";
import { definition as wx } from "@fortawesome/free-solid-svg-icons/faMeteor";
import { definition as wP1 } from "@fortawesome/free-solid-svg-icons/faMeteor";
import { definition as Nx } from "@fortawesome/free-solid-svg-icons/faMicrochip";
import { definition as zP1 } from "@fortawesome/free-solid-svg-icons/faMicrochip";
import { definition as zx } from "@fortawesome/free-solid-svg-icons/faMicrophone";
import { definition as CP1 } from "@fortawesome/free-solid-svg-icons/faMicrophone";
import { definition as Lx } from "@fortawesome/free-solid-svg-icons/faMicrophoneAlt";
import { definition as $P1 } from "@fortawesome/free-solid-svg-icons/faMicrophoneAlt";
import { definition as Cx } from "@fortawesome/free-solid-svg-icons/faMicrophoneAltSlash";
import { definition as bP1 } from "@fortawesome/free-solid-svg-icons/faMicrophoneAltSlash";
import { definition as Dx } from "@fortawesome/free-solid-svg-icons/faMicrophoneLines";
import { definition as yP1 } from "@fortawesome/free-solid-svg-icons/faMicrophoneLines";
import { definition as $x } from "@fortawesome/free-solid-svg-icons/faMicrophoneLinesSlash";
import { definition as kP1 } from "@fortawesome/free-solid-svg-icons/faMicrophoneLinesSlash";
import { definition as _x } from "@fortawesome/free-solid-svg-icons/faMicrophoneSlash";
import { definition as jP1 } from "@fortawesome/free-solid-svg-icons/faMicrophoneSlash";
import { definition as bx } from "@fortawesome/free-solid-svg-icons/faMicroscope";
import { definition as TP1 } from "@fortawesome/free-solid-svg-icons/faMicroscope";
import { definition as Sx } from "@fortawesome/free-solid-svg-icons/faMillSign";
import { definition as HP1 } from "@fortawesome/free-solid-svg-icons/faMillSign";
import { definition as yx } from "@fortawesome/free-solid-svg-icons/faMinimize";
import { definition as UP1 } from "@fortawesome/free-solid-svg-icons/faMinimize";
import { definition as Ox } from "@fortawesome/free-solid-svg-icons/faMinus";
import { definition as GP1 } from "@fortawesome/free-solid-svg-icons/faMinus";
import { definition as kx } from "@fortawesome/free-solid-svg-icons/faMinusCircle";
import { definition as EP1 } from "@fortawesome/free-solid-svg-icons/faMinusCircle";
import { definition as Ax } from "@fortawesome/free-solid-svg-icons/faMinusSquare";
import { definition as IP1 } from "@fortawesome/free-solid-svg-icons/faMinusSquare";
import { definition as jx } from "@fortawesome/free-solid-svg-icons/faMitten";
import { definition as XP1 } from "@fortawesome/free-solid-svg-icons/faMitten";
import { definition as Bx } from "@fortawesome/free-solid-svg-icons/faMobile";
import { definition as JP1 } from "@fortawesome/free-solid-svg-icons/faMobile";
import { definition as Tx } from "@fortawesome/free-solid-svg-icons/faMobileAlt";
import { definition as ZP1 } from "@fortawesome/free-solid-svg-icons/faMobileAlt";
import { definition as Fx } from "@fortawesome/free-solid-svg-icons/faMobileAndroid";
import { definition as xP1 } from "@fortawesome/free-solid-svg-icons/faMobileAndroid";
import { definition as Hx } from "@fortawesome/free-solid-svg-icons/faMobileAndroidAlt";
import { definition as aM1 } from "@fortawesome/free-solid-svg-icons/faMobileAndroidAlt";
import { definition as Rx } from "@fortawesome/free-solid-svg-icons/faMobileButton";
import { definition as nM1 } from "@fortawesome/free-solid-svg-icons/faMobileButton";
import { definition as Ux } from "@fortawesome/free-solid-svg-icons/faMobilePhone";
import { definition as cM1 } from "@fortawesome/free-solid-svg-icons/faMobilePhone";
import { definition as qx } from "@fortawesome/free-solid-svg-icons/faMobileRetro";
import { definition as oM1 } from "@fortawesome/free-solid-svg-icons/faMobileRetro";
import { definition as Gx } from "@fortawesome/free-solid-svg-icons/faMobileScreen";
import { definition as dM1 } from "@fortawesome/free-solid-svg-icons/faMobileScreen";
import { definition as Wx } from "@fortawesome/free-solid-svg-icons/faMobileScreenButton";
import { definition as sM1 } from "@fortawesome/free-solid-svg-icons/faMobileScreenButton";
import { definition as Ex } from "@fortawesome/free-solid-svg-icons/faMoneyBill";
import { definition as vM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBill";
import { definition as Vx } from "@fortawesome/free-solid-svg-icons/faMoneyBill1";
import { definition as mM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBill1";
import { definition as Ix } from "@fortawesome/free-solid-svg-icons/faMoneyBill1Wave";
import { definition as PM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBill1Wave";
import { definition as Kx } from "@fortawesome/free-solid-svg-icons/faMoneyBillAlt";
import { definition as wM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBillAlt";
import { definition as Xx } from "@fortawesome/free-solid-svg-icons/faMoneyBillTransfer";
import { definition as zM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBillTransfer";
import { definition as Qx } from "@fortawesome/free-solid-svg-icons/faMoneyBillTrendUp";
import { definition as CM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBillTrendUp";
import { definition as Jx } from "@fortawesome/free-solid-svg-icons/faMoneyBillWave";
import { definition as $M1 } from "@fortawesome/free-solid-svg-icons/faMoneyBillWave";
import { definition as Yx } from "@fortawesome/free-solid-svg-icons/faMoneyBillWaveAlt";
import { definition as bM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBillWaveAlt";
import { definition as Zx } from "@fortawesome/free-solid-svg-icons/faMoneyBillWheat";
import { definition as yM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBillWheat";
import { definition as px } from "@fortawesome/free-solid-svg-icons/faMoneyBills";
import { definition as kM1 } from "@fortawesome/free-solid-svg-icons/faMoneyBills";
import { definition as xx } from "@fortawesome/free-solid-svg-icons/faMoneyCheck";
import { definition as jM1 } from "@fortawesome/free-solid-svg-icons/faMoneyCheck";
import { definition as iii } from "@fortawesome/free-solid-svg-icons/faMoneyCheckAlt";
import { definition as TM1 } from "@fortawesome/free-solid-svg-icons/faMoneyCheckAlt";
import { definition as aii } from "@fortawesome/free-solid-svg-icons/faMoneyCheckDollar";
import { definition as HM1 } from "@fortawesome/free-solid-svg-icons/faMoneyCheckDollar";
import { definition as eii } from "@fortawesome/free-solid-svg-icons/faMonument";
import { definition as UM1 } from "@fortawesome/free-solid-svg-icons/faMonument";
import { definition as nii } from "@fortawesome/free-solid-svg-icons/faMoon";
import { definition as GM1 } from "@fortawesome/free-solid-svg-icons/faMoon";
import { definition as fii } from "@fortawesome/free-solid-svg-icons/faMortarBoard";
import { definition as EM1 } from "@fortawesome/free-solid-svg-icons/faMortarBoard";
import { definition as cii } from "@fortawesome/free-solid-svg-icons/faMortarPestle";
import { definition as IM1 } from "@fortawesome/free-solid-svg-icons/faMortarPestle";
import { definition as tii } from "@fortawesome/free-solid-svg-icons/faMosque";
import { definition as XM1 } from "@fortawesome/free-solid-svg-icons/faMosque";
import { definition as oii } from "@fortawesome/free-solid-svg-icons/faMosquito";
import { definition as JM1 } from "@fortawesome/free-solid-svg-icons/faMosquito";
import { definition as lii } from "@fortawesome/free-solid-svg-icons/faMosquitoNet";
import { definition as ZM1 } from "@fortawesome/free-solid-svg-icons/faMosquitoNet";
import { definition as dii } from "@fortawesome/free-solid-svg-icons/faMotorcycle";
import { definition as xM1 } from "@fortawesome/free-solid-svg-icons/faMotorcycle";
import { definition as rii } from "@fortawesome/free-solid-svg-icons/faMound";
import { definition as aw1 } from "@fortawesome/free-solid-svg-icons/faMound";
import { definition as sii } from "@fortawesome/free-solid-svg-icons/faMountain";
import { definition as nw1 } from "@fortawesome/free-solid-svg-icons/faMountain";
import { definition as hii } from "@fortawesome/free-solid-svg-icons/faMountainCity";
import { definition as cw1 } from "@fortawesome/free-solid-svg-icons/faMountainCity";
import { definition as vii } from "@fortawesome/free-solid-svg-icons/faMountainSun";
import { definition as ow1 } from "@fortawesome/free-solid-svg-icons/faMountainSun";
import { definition as uii } from "@fortawesome/free-solid-svg-icons/faMouse";
import { definition as dw1 } from "@fortawesome/free-solid-svg-icons/faMouse";
import { definition as mii } from "@fortawesome/free-solid-svg-icons/faMousePointer";
import { definition as sw1 } from "@fortawesome/free-solid-svg-icons/faMousePointer";
import { definition as gii } from "@fortawesome/free-solid-svg-icons/faMugHot";
import { definition as vw1 } from "@fortawesome/free-solid-svg-icons/faMugHot";
import { definition as Pii } from "@fortawesome/free-solid-svg-icons/faMugSaucer";
import { definition as mw1 } from "@fortawesome/free-solid-svg-icons/faMugSaucer";
import { definition as Mii } from "@fortawesome/free-solid-svg-icons/faMultiply";
import { definition as Pw1 } from "@fortawesome/free-solid-svg-icons/faMultiply";
import { definition as wii } from "@fortawesome/free-solid-svg-icons/faMuseum";
import { definition as ww1 } from "@fortawesome/free-solid-svg-icons/faMuseum";
import { definition as Nii } from "@fortawesome/free-solid-svg-icons/faMusic";
import { definition as zw1 } from "@fortawesome/free-solid-svg-icons/faMusic";
import { definition as zii } from "@fortawesome/free-solid-svg-icons/faN";
import { definition as Cw1 } from "@fortawesome/free-solid-svg-icons/faN";
import { definition as Lii } from "@fortawesome/free-solid-svg-icons/faNairaSign";
import { definition as $w1 } from "@fortawesome/free-solid-svg-icons/faNairaSign";
import { definition as Cii } from "@fortawesome/free-solid-svg-icons/faNavicon";
import { definition as bw1 } from "@fortawesome/free-solid-svg-icons/faNavicon";
import { definition as Dii } from "@fortawesome/free-solid-svg-icons/faNetworkWired";
import { definition as yw1 } from "@fortawesome/free-solid-svg-icons/faNetworkWired";
import { definition as $ii } from "@fortawesome/free-solid-svg-icons/faNeuter";
import { definition as kw1 } from "@fortawesome/free-solid-svg-icons/faNeuter";
import { definition as _ii } from "@fortawesome/free-solid-svg-icons/faNewspaper";
import { definition as jw1 } from "@fortawesome/free-solid-svg-icons/faNewspaper";
import { definition as bii } from "@fortawesome/free-solid-svg-icons/faNotEqual";
import { definition as Tw1 } from "@fortawesome/free-solid-svg-icons/faNotEqual";
import { definition as Sii } from "@fortawesome/free-solid-svg-icons/faNotdef";
import { definition as Hw1 } from "@fortawesome/free-solid-svg-icons/faNotdef";
import { definition as yii } from "@fortawesome/free-solid-svg-icons/faNoteSticky";
import { definition as Uw1 } from "@fortawesome/free-solid-svg-icons/faNoteSticky";
import { definition as Oii } from "@fortawesome/free-solid-svg-icons/faNotesMedical";
import { definition as Gw1 } from "@fortawesome/free-solid-svg-icons/faNotesMedical";
import { definition as kii } from "@fortawesome/free-solid-svg-icons/faO";
import { definition as Ew1 } from "@fortawesome/free-solid-svg-icons/faO";
import { definition as Aii } from "@fortawesome/free-solid-svg-icons/faObjectGroup";
import { definition as Iw1 } from "@fortawesome/free-solid-svg-icons/faObjectGroup";
import { definition as jii } from "@fortawesome/free-solid-svg-icons/faObjectUngroup";
import { definition as Xw1 } from "@fortawesome/free-solid-svg-icons/faObjectUngroup";
import { definition as Bii } from "@fortawesome/free-solid-svg-icons/faOilCan";
import { definition as Jw1 } from "@fortawesome/free-solid-svg-icons/faOilCan";
import { definition as Tii } from "@fortawesome/free-solid-svg-icons/faOilWell";
import { definition as Zw1 } from "@fortawesome/free-solid-svg-icons/faOilWell";
import { definition as Fii } from "@fortawesome/free-solid-svg-icons/faOm";
import { definition as xw1 } from "@fortawesome/free-solid-svg-icons/faOm";
import { definition as Hii } from "@fortawesome/free-solid-svg-icons/faOtter";
import { definition as aN1 } from "@fortawesome/free-solid-svg-icons/faOtter";
import { definition as Rii } from "@fortawesome/free-solid-svg-icons/faOutdent";
import { definition as nN1 } from "@fortawesome/free-solid-svg-icons/faOutdent";
import { definition as Uii } from "@fortawesome/free-solid-svg-icons/faP";
import { definition as cN1 } from "@fortawesome/free-solid-svg-icons/faP";
import { definition as qii } from "@fortawesome/free-solid-svg-icons/faPager";
import { definition as oN1 } from "@fortawesome/free-solid-svg-icons/faPager";
import { definition as Gii } from "@fortawesome/free-solid-svg-icons/faPaintRoller";
import { definition as dN1 } from "@fortawesome/free-solid-svg-icons/faPaintRoller";
import { definition as Wii } from "@fortawesome/free-solid-svg-icons/faPaintbrush";
import { definition as sN1 } from "@fortawesome/free-solid-svg-icons/faPaintbrush";
import { definition as Eii } from "@fortawesome/free-solid-svg-icons/faPalette";
import { definition as vN1 } from "@fortawesome/free-solid-svg-icons/faPalette";
import { definition as Vii } from "@fortawesome/free-solid-svg-icons/faPallet";
import { definition as mN1 } from "@fortawesome/free-solid-svg-icons/faPallet";
import { definition as Iii } from "@fortawesome/free-solid-svg-icons/faPanorama";
import { definition as PN1 } from "@fortawesome/free-solid-svg-icons/faPanorama";
import { definition as Kii } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { definition as wN1 } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { definition as Xii } from "@fortawesome/free-solid-svg-icons/faPaperclip";
import { definition as zN1 } from "@fortawesome/free-solid-svg-icons/faPaperclip";
import { definition as Qii } from "@fortawesome/free-solid-svg-icons/faParachuteBox";
import { definition as CN1 } from "@fortawesome/free-solid-svg-icons/faParachuteBox";
import { definition as Jii } from "@fortawesome/free-solid-svg-icons/faParagraph";
import { definition as $N1 } from "@fortawesome/free-solid-svg-icons/faParagraph";
import { definition as Yii } from "@fortawesome/free-solid-svg-icons/faParking";
import { definition as bN1 } from "@fortawesome/free-solid-svg-icons/faParking";
import { definition as Zii } from "@fortawesome/free-solid-svg-icons/faPassport";
import { definition as yN1 } from "@fortawesome/free-solid-svg-icons/faPassport";
import { definition as pii } from "@fortawesome/free-solid-svg-icons/faPastafarianism";
import { definition as kN1 } from "@fortawesome/free-solid-svg-icons/faPastafarianism";
import { definition as xii } from "@fortawesome/free-solid-svg-icons/faPaste";
import { definition as jN1 } from "@fortawesome/free-solid-svg-icons/faPaste";
import { definition as i2i } from "@fortawesome/free-solid-svg-icons/faPause";
import { definition as TN1 } from "@fortawesome/free-solid-svg-icons/faPause";
import { definition as a2i } from "@fortawesome/free-solid-svg-icons/faPauseCircle";
import { definition as HN1 } from "@fortawesome/free-solid-svg-icons/faPauseCircle";
import { definition as e2i } from "@fortawesome/free-solid-svg-icons/faPaw";
import { definition as UN1 } from "@fortawesome/free-solid-svg-icons/faPaw";
import { definition as n2i } from "@fortawesome/free-solid-svg-icons/faPeace";
import { definition as GN1 } from "@fortawesome/free-solid-svg-icons/faPeace";
import { definition as f2i } from "@fortawesome/free-solid-svg-icons/faPen";
import { definition as EN1 } from "@fortawesome/free-solid-svg-icons/faPen";
import { definition as c2i } from "@fortawesome/free-solid-svg-icons/faPenAlt";
import { definition as IN1 } from "@fortawesome/free-solid-svg-icons/faPenAlt";
import { definition as t2i } from "@fortawesome/free-solid-svg-icons/faPenClip";
import { definition as XN1 } from "@fortawesome/free-solid-svg-icons/faPenClip";
import { definition as o2i } from "@fortawesome/free-solid-svg-icons/faPenFancy";
import { definition as JN1 } from "@fortawesome/free-solid-svg-icons/faPenFancy";
import { definition as l2i } from "@fortawesome/free-solid-svg-icons/faPenNib";
import { definition as ZN1 } from "@fortawesome/free-solid-svg-icons/faPenNib";
import { definition as d2i } from "@fortawesome/free-solid-svg-icons/faPenRuler";
import { definition as xN1 } from "@fortawesome/free-solid-svg-icons/faPenRuler";
import { definition as r2i } from "@fortawesome/free-solid-svg-icons/faPenSquare";
import { definition as az1 } from "@fortawesome/free-solid-svg-icons/faPenSquare";
import { definition as s2i } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { definition as nz1 } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { definition as h2i } from "@fortawesome/free-solid-svg-icons/faPencil";
import { definition as cz1 } from "@fortawesome/free-solid-svg-icons/faPencil";
import { definition as v2i } from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import { definition as oz1 } from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import { definition as u2i } from "@fortawesome/free-solid-svg-icons/faPencilRuler";
import { definition as dz1 } from "@fortawesome/free-solid-svg-icons/faPencilRuler";
import { definition as m2i } from "@fortawesome/free-solid-svg-icons/faPencilSquare";
import { definition as sz1 } from "@fortawesome/free-solid-svg-icons/faPencilSquare";
import { definition as g2i } from "@fortawesome/free-solid-svg-icons/faPeopleArrows";
import { definition as vz1 } from "@fortawesome/free-solid-svg-icons/faPeopleArrows";
import { definition as P2i } from "@fortawesome/free-solid-svg-icons/faPeopleArrowsLeftRight";
import { definition as mz1 } from "@fortawesome/free-solid-svg-icons/faPeopleArrowsLeftRight";
import { definition as M2i } from "@fortawesome/free-solid-svg-icons/faPeopleCarry";
import { definition as Pz1 } from "@fortawesome/free-solid-svg-icons/faPeopleCarry";
import { definition as w2i } from "@fortawesome/free-solid-svg-icons/faPeopleCarryBox";
import { definition as wz1 } from "@fortawesome/free-solid-svg-icons/faPeopleCarryBox";
import { definition as N2i } from "@fortawesome/free-solid-svg-icons/faPeopleGroup";
import { definition as zz1 } from "@fortawesome/free-solid-svg-icons/faPeopleGroup";
import { definition as z2i } from "@fortawesome/free-solid-svg-icons/faPeopleLine";
import { definition as Cz1 } from "@fortawesome/free-solid-svg-icons/faPeopleLine";
import { definition as L2i } from "@fortawesome/free-solid-svg-icons/faPeoplePulling";
import { definition as $z1 } from "@fortawesome/free-solid-svg-icons/faPeoplePulling";
import { definition as C2i } from "@fortawesome/free-solid-svg-icons/faPeopleRobbery";
import { definition as bz1 } from "@fortawesome/free-solid-svg-icons/faPeopleRobbery";
import { definition as D2i } from "@fortawesome/free-solid-svg-icons/faPeopleRoof";
import { definition as yz1 } from "@fortawesome/free-solid-svg-icons/faPeopleRoof";
import { definition as $2i } from "@fortawesome/free-solid-svg-icons/faPepperHot";
import { definition as kz1 } from "@fortawesome/free-solid-svg-icons/faPepperHot";
import { definition as _2i } from "@fortawesome/free-solid-svg-icons/faPercent";
import { definition as jz1 } from "@fortawesome/free-solid-svg-icons/faPercent";
import { definition as b2i } from "@fortawesome/free-solid-svg-icons/faPercentage";
import { definition as Tz1 } from "@fortawesome/free-solid-svg-icons/faPercentage";
import { definition as S2i } from "@fortawesome/free-solid-svg-icons/faPerson";
import { definition as Hz1 } from "@fortawesome/free-solid-svg-icons/faPerson";
import { definition as y2i } from "@fortawesome/free-solid-svg-icons/faPersonArrowDownToLine";
import { definition as Uz1 } from "@fortawesome/free-solid-svg-icons/faPersonArrowDownToLine";
import { definition as O2i } from "@fortawesome/free-solid-svg-icons/faPersonArrowUpFromLine";
import { definition as Gz1 } from "@fortawesome/free-solid-svg-icons/faPersonArrowUpFromLine";
import { definition as k2i } from "@fortawesome/free-solid-svg-icons/faPersonBiking";
import { definition as Ez1 } from "@fortawesome/free-solid-svg-icons/faPersonBiking";
import { definition as A2i } from "@fortawesome/free-solid-svg-icons/faPersonBooth";
import { definition as Iz1 } from "@fortawesome/free-solid-svg-icons/faPersonBooth";
import { definition as j2i } from "@fortawesome/free-solid-svg-icons/faPersonBreastfeeding";
import { definition as Xz1 } from "@fortawesome/free-solid-svg-icons/faPersonBreastfeeding";
import { definition as B2i } from "@fortawesome/free-solid-svg-icons/faPersonBurst";
import { definition as Jz1 } from "@fortawesome/free-solid-svg-icons/faPersonBurst";
import { definition as T2i } from "@fortawesome/free-solid-svg-icons/faPersonCane";
import { definition as Zz1 } from "@fortawesome/free-solid-svg-icons/faPersonCane";
import { definition as F2i } from "@fortawesome/free-solid-svg-icons/faPersonChalkboard";
import { definition as xz1 } from "@fortawesome/free-solid-svg-icons/faPersonChalkboard";
import { definition as H2i } from "@fortawesome/free-solid-svg-icons/faPersonCircleCheck";
import { definition as aL1 } from "@fortawesome/free-solid-svg-icons/faPersonCircleCheck";
import { definition as R2i } from "@fortawesome/free-solid-svg-icons/faPersonCircleExclamation";
import { definition as nL1 } from "@fortawesome/free-solid-svg-icons/faPersonCircleExclamation";
import { definition as U2i } from "@fortawesome/free-solid-svg-icons/faPersonCircleMinus";
import { definition as cL1 } from "@fortawesome/free-solid-svg-icons/faPersonCircleMinus";
import { definition as q2i } from "@fortawesome/free-solid-svg-icons/faPersonCirclePlus";
import { definition as oL1 } from "@fortawesome/free-solid-svg-icons/faPersonCirclePlus";
import { definition as G2i } from "@fortawesome/free-solid-svg-icons/faPersonCircleQuestion";
import { definition as dL1 } from "@fortawesome/free-solid-svg-icons/faPersonCircleQuestion";
import { definition as W2i } from "@fortawesome/free-solid-svg-icons/faPersonCircleXmark";
import { definition as sL1 } from "@fortawesome/free-solid-svg-icons/faPersonCircleXmark";
import { definition as E2i } from "@fortawesome/free-solid-svg-icons/faPersonDigging";
import { definition as vL1 } from "@fortawesome/free-solid-svg-icons/faPersonDigging";
import { definition as V2i } from "@fortawesome/free-solid-svg-icons/faPersonDotsFromLine";
import { definition as mL1 } from "@fortawesome/free-solid-svg-icons/faPersonDotsFromLine";
import { definition as I2i } from "@fortawesome/free-solid-svg-icons/faPersonDress";
import { definition as PL1 } from "@fortawesome/free-solid-svg-icons/faPersonDress";
import { definition as K2i } from "@fortawesome/free-solid-svg-icons/faPersonDressBurst";
import { definition as wL1 } from "@fortawesome/free-solid-svg-icons/faPersonDressBurst";
import { definition as X2i } from "@fortawesome/free-solid-svg-icons/faPersonDrowning";
import { definition as zL1 } from "@fortawesome/free-solid-svg-icons/faPersonDrowning";
import { definition as Q2i } from "@fortawesome/free-solid-svg-icons/faPersonFalling";
import { definition as CL1 } from "@fortawesome/free-solid-svg-icons/faPersonFalling";
import { definition as J2i } from "@fortawesome/free-solid-svg-icons/faPersonFallingBurst";
import { definition as $L1 } from "@fortawesome/free-solid-svg-icons/faPersonFallingBurst";
import { definition as Y2i } from "@fortawesome/free-solid-svg-icons/faPersonHalfDress";
import { definition as bL1 } from "@fortawesome/free-solid-svg-icons/faPersonHalfDress";
import { definition as Z2i } from "@fortawesome/free-solid-svg-icons/faPersonHarassing";
import { definition as yL1 } from "@fortawesome/free-solid-svg-icons/faPersonHarassing";
import { definition as p2i } from "@fortawesome/free-solid-svg-icons/faPersonHiking";
import { definition as kL1 } from "@fortawesome/free-solid-svg-icons/faPersonHiking";
import { definition as x2i } from "@fortawesome/free-solid-svg-icons/faPersonMilitaryPointing";
import { definition as jL1 } from "@fortawesome/free-solid-svg-icons/faPersonMilitaryPointing";
import { definition as i1i } from "@fortawesome/free-solid-svg-icons/faPersonMilitaryRifle";
import { definition as TL1 } from "@fortawesome/free-solid-svg-icons/faPersonMilitaryRifle";
import { definition as a1i } from "@fortawesome/free-solid-svg-icons/faPersonMilitaryToPerson";
import { definition as HL1 } from "@fortawesome/free-solid-svg-icons/faPersonMilitaryToPerson";
import { definition as e1i } from "@fortawesome/free-solid-svg-icons/faPersonPraying";
import { definition as UL1 } from "@fortawesome/free-solid-svg-icons/faPersonPraying";
import { definition as n1i } from "@fortawesome/free-solid-svg-icons/faPersonPregnant";
import { definition as GL1 } from "@fortawesome/free-solid-svg-icons/faPersonPregnant";
import { definition as f1i } from "@fortawesome/free-solid-svg-icons/faPersonRays";
import { definition as EL1 } from "@fortawesome/free-solid-svg-icons/faPersonRays";
import { definition as c1i } from "@fortawesome/free-solid-svg-icons/faPersonRifle";
import { definition as IL1 } from "@fortawesome/free-solid-svg-icons/faPersonRifle";
import { definition as t1i } from "@fortawesome/free-solid-svg-icons/faPersonRunning";
import { definition as XL1 } from "@fortawesome/free-solid-svg-icons/faPersonRunning";
import { definition as o1i } from "@fortawesome/free-solid-svg-icons/faPersonShelter";
import { definition as JL1 } from "@fortawesome/free-solid-svg-icons/faPersonShelter";
import { definition as l1i } from "@fortawesome/free-solid-svg-icons/faPersonSkating";
import { definition as ZL1 } from "@fortawesome/free-solid-svg-icons/faPersonSkating";
import { definition as d1i } from "@fortawesome/free-solid-svg-icons/faPersonSkiing";
import { definition as xL1 } from "@fortawesome/free-solid-svg-icons/faPersonSkiing";
import { definition as r1i } from "@fortawesome/free-solid-svg-icons/faPersonSkiingNordic";
import { definition as aC1 } from "@fortawesome/free-solid-svg-icons/faPersonSkiingNordic";
import { definition as s1i } from "@fortawesome/free-solid-svg-icons/faPersonSnowboarding";
import { definition as nC1 } from "@fortawesome/free-solid-svg-icons/faPersonSnowboarding";
import { definition as h1i } from "@fortawesome/free-solid-svg-icons/faPersonSwimming";
import { definition as cC1 } from "@fortawesome/free-solid-svg-icons/faPersonSwimming";
import { definition as v1i } from "@fortawesome/free-solid-svg-icons/faPersonThroughWindow";
import { definition as oC1 } from "@fortawesome/free-solid-svg-icons/faPersonThroughWindow";
import { definition as u1i } from "@fortawesome/free-solid-svg-icons/faPersonWalking";
import { definition as dC1 } from "@fortawesome/free-solid-svg-icons/faPersonWalking";
import { definition as m1i } from "@fortawesome/free-solid-svg-icons/faPersonWalkingArrowLoopLeft";
import { definition as sC1 } from "@fortawesome/free-solid-svg-icons/faPersonWalkingArrowLoopLeft";
import { definition as g1i } from "@fortawesome/free-solid-svg-icons/faPersonWalkingArrowRight";
import { definition as vC1 } from "@fortawesome/free-solid-svg-icons/faPersonWalkingArrowRight";
import { definition as P1i } from "@fortawesome/free-solid-svg-icons/faPersonWalkingDashedLineArrowRight";
import { definition as mC1 } from "@fortawesome/free-solid-svg-icons/faPersonWalkingDashedLineArrowRight";
import { definition as M1i } from "@fortawesome/free-solid-svg-icons/faPersonWalkingLuggage";
import { definition as PC1 } from "@fortawesome/free-solid-svg-icons/faPersonWalkingLuggage";
import { definition as w1i } from "@fortawesome/free-solid-svg-icons/faPersonWalkingWithCane";
import { definition as wC1 } from "@fortawesome/free-solid-svg-icons/faPersonWalkingWithCane";
import { definition as N1i } from "@fortawesome/free-solid-svg-icons/faPesetaSign";
import { definition as zC1 } from "@fortawesome/free-solid-svg-icons/faPesetaSign";
import { definition as z1i } from "@fortawesome/free-solid-svg-icons/faPesoSign";
import { definition as CC1 } from "@fortawesome/free-solid-svg-icons/faPesoSign";
import { definition as L1i } from "@fortawesome/free-solid-svg-icons/faPhone";
import { definition as $C1 } from "@fortawesome/free-solid-svg-icons/faPhone";
import { definition as C1i } from "@fortawesome/free-solid-svg-icons/faPhoneAlt";
import { definition as bC1 } from "@fortawesome/free-solid-svg-icons/faPhoneAlt";
import { definition as D1i } from "@fortawesome/free-solid-svg-icons/faPhoneFlip";
import { definition as yC1 } from "@fortawesome/free-solid-svg-icons/faPhoneFlip";
import { definition as $1i } from "@fortawesome/free-solid-svg-icons/faPhoneSlash";
import { definition as kC1 } from "@fortawesome/free-solid-svg-icons/faPhoneSlash";
import { definition as _1i } from "@fortawesome/free-solid-svg-icons/faPhoneSquare";
import { definition as jC1 } from "@fortawesome/free-solid-svg-icons/faPhoneSquare";
import { definition as b1i } from "@fortawesome/free-solid-svg-icons/faPhoneSquareAlt";
import { definition as TC1 } from "@fortawesome/free-solid-svg-icons/faPhoneSquareAlt";
import { definition as S1i } from "@fortawesome/free-solid-svg-icons/faPhoneVolume";
import { definition as HC1 } from "@fortawesome/free-solid-svg-icons/faPhoneVolume";
import { definition as y1i } from "@fortawesome/free-solid-svg-icons/faPhotoFilm";
import { definition as UC1 } from "@fortawesome/free-solid-svg-icons/faPhotoFilm";
import { definition as O1i } from "@fortawesome/free-solid-svg-icons/faPhotoVideo";
import { definition as GC1 } from "@fortawesome/free-solid-svg-icons/faPhotoVideo";
import { definition as k1i } from "@fortawesome/free-solid-svg-icons/faPieChart";
import { definition as EC1 } from "@fortawesome/free-solid-svg-icons/faPieChart";
import { definition as A1i } from "@fortawesome/free-solid-svg-icons/faPiggyBank";
import { definition as IC1 } from "@fortawesome/free-solid-svg-icons/faPiggyBank";
import { definition as j1i } from "@fortawesome/free-solid-svg-icons/faPills";
import { definition as XC1 } from "@fortawesome/free-solid-svg-icons/faPills";
import { definition as B1i } from "@fortawesome/free-solid-svg-icons/faPingPongPaddleBall";
import { definition as JC1 } from "@fortawesome/free-solid-svg-icons/faPingPongPaddleBall";
import { definition as T1i } from "@fortawesome/free-solid-svg-icons/faPizzaSlice";
import { definition as ZC1 } from "@fortawesome/free-solid-svg-icons/faPizzaSlice";
import { definition as F1i } from "@fortawesome/free-solid-svg-icons/faPlaceOfWorship";
import { definition as xC1 } from "@fortawesome/free-solid-svg-icons/faPlaceOfWorship";
import { definition as H1i } from "@fortawesome/free-solid-svg-icons/faPlane";
import { definition as aD1 } from "@fortawesome/free-solid-svg-icons/faPlane";
import { definition as R1i } from "@fortawesome/free-solid-svg-icons/faPlaneArrival";
import { definition as nD1 } from "@fortawesome/free-solid-svg-icons/faPlaneArrival";
import { definition as U1i } from "@fortawesome/free-solid-svg-icons/faPlaneCircleCheck";
import { definition as cD1 } from "@fortawesome/free-solid-svg-icons/faPlaneCircleCheck";
import { definition as q1i } from "@fortawesome/free-solid-svg-icons/faPlaneCircleExclamation";
import { definition as oD1 } from "@fortawesome/free-solid-svg-icons/faPlaneCircleExclamation";
import { definition as G1i } from "@fortawesome/free-solid-svg-icons/faPlaneCircleXmark";
import { definition as dD1 } from "@fortawesome/free-solid-svg-icons/faPlaneCircleXmark";
import { definition as W1i } from "@fortawesome/free-solid-svg-icons/faPlaneDeparture";
import { definition as sD1 } from "@fortawesome/free-solid-svg-icons/faPlaneDeparture";
import { definition as E1i } from "@fortawesome/free-solid-svg-icons/faPlaneLock";
import { definition as vD1 } from "@fortawesome/free-solid-svg-icons/faPlaneLock";
import { definition as V1i } from "@fortawesome/free-solid-svg-icons/faPlaneSlash";
import { definition as mD1 } from "@fortawesome/free-solid-svg-icons/faPlaneSlash";
import { definition as I1i } from "@fortawesome/free-solid-svg-icons/faPlaneUp";
import { definition as PD1 } from "@fortawesome/free-solid-svg-icons/faPlaneUp";
import { definition as K1i } from "@fortawesome/free-solid-svg-icons/faPlantWilt";
import { definition as wD1 } from "@fortawesome/free-solid-svg-icons/faPlantWilt";
import { definition as X1i } from "@fortawesome/free-solid-svg-icons/faPlateWheat";
import { definition as zD1 } from "@fortawesome/free-solid-svg-icons/faPlateWheat";
import { definition as Q1i } from "@fortawesome/free-solid-svg-icons/faPlay";
import { definition as CD1 } from "@fortawesome/free-solid-svg-icons/faPlay";
import { definition as J1i } from "@fortawesome/free-solid-svg-icons/faPlayCircle";
import { definition as $D1 } from "@fortawesome/free-solid-svg-icons/faPlayCircle";
import { definition as Y1i } from "@fortawesome/free-solid-svg-icons/faPlug";
import { definition as bD1 } from "@fortawesome/free-solid-svg-icons/faPlug";
import { definition as Z1i } from "@fortawesome/free-solid-svg-icons/faPlugCircleBolt";
import { definition as yD1 } from "@fortawesome/free-solid-svg-icons/faPlugCircleBolt";
import { definition as p1i } from "@fortawesome/free-solid-svg-icons/faPlugCircleCheck";
import { definition as kD1 } from "@fortawesome/free-solid-svg-icons/faPlugCircleCheck";
import { definition as x1i } from "@fortawesome/free-solid-svg-icons/faPlugCircleExclamation";
import { definition as jD1 } from "@fortawesome/free-solid-svg-icons/faPlugCircleExclamation";
import { definition as iai } from "@fortawesome/free-solid-svg-icons/faPlugCircleMinus";
import { definition as TD1 } from "@fortawesome/free-solid-svg-icons/faPlugCircleMinus";
import { definition as aai } from "@fortawesome/free-solid-svg-icons/faPlugCirclePlus";
import { definition as HD1 } from "@fortawesome/free-solid-svg-icons/faPlugCirclePlus";
import { definition as eai } from "@fortawesome/free-solid-svg-icons/faPlugCircleXmark";
import { definition as UD1 } from "@fortawesome/free-solid-svg-icons/faPlugCircleXmark";
import { definition as nai } from "@fortawesome/free-solid-svg-icons/faPlus";
import { definition as GD1 } from "@fortawesome/free-solid-svg-icons/faPlus";
import { definition as fai } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { definition as ED1 } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { definition as cai } from "@fortawesome/free-solid-svg-icons/faPlusMinus";
import { definition as ID1 } from "@fortawesome/free-solid-svg-icons/faPlusMinus";
import { definition as tai } from "@fortawesome/free-solid-svg-icons/faPlusSquare";
import { definition as XD1 } from "@fortawesome/free-solid-svg-icons/faPlusSquare";
import { definition as oai } from "@fortawesome/free-solid-svg-icons/faPodcast";
import { definition as JD1 } from "@fortawesome/free-solid-svg-icons/faPodcast";
import { definition as lai } from "@fortawesome/free-solid-svg-icons/faPoll";
import { definition as ZD1 } from "@fortawesome/free-solid-svg-icons/faPoll";
import { definition as dai } from "@fortawesome/free-solid-svg-icons/faPollH";
import { definition as xD1 } from "@fortawesome/free-solid-svg-icons/faPollH";
import { definition as rai } from "@fortawesome/free-solid-svg-icons/faPoo";
import { definition as a$1 } from "@fortawesome/free-solid-svg-icons/faPoo";
import { definition as sai } from "@fortawesome/free-solid-svg-icons/faPooBolt";
import { definition as n$1 } from "@fortawesome/free-solid-svg-icons/faPooBolt";
import { definition as hai } from "@fortawesome/free-solid-svg-icons/faPooStorm";
import { definition as c$1 } from "@fortawesome/free-solid-svg-icons/faPooStorm";
import { definition as vai } from "@fortawesome/free-solid-svg-icons/faPoop";
import { definition as o$1 } from "@fortawesome/free-solid-svg-icons/faPoop";
import { definition as uai } from "@fortawesome/free-solid-svg-icons/faPortrait";
import { definition as d$1 } from "@fortawesome/free-solid-svg-icons/faPortrait";
import { definition as mai } from "@fortawesome/free-solid-svg-icons/faPoundSign";
import { definition as s$1 } from "@fortawesome/free-solid-svg-icons/faPoundSign";
import { definition as gai } from "@fortawesome/free-solid-svg-icons/faPowerOff";
import { definition as v$1 } from "@fortawesome/free-solid-svg-icons/faPowerOff";
import { definition as Pai } from "@fortawesome/free-solid-svg-icons/faPray";
import { definition as m$1 } from "@fortawesome/free-solid-svg-icons/faPray";
import { definition as Mai } from "@fortawesome/free-solid-svg-icons/faPrayingHands";
import { definition as P$1 } from "@fortawesome/free-solid-svg-icons/faPrayingHands";
import { definition as wai } from "@fortawesome/free-solid-svg-icons/faPrescription";
import { definition as w$1 } from "@fortawesome/free-solid-svg-icons/faPrescription";
import { definition as Nai } from "@fortawesome/free-solid-svg-icons/faPrescriptionBottle";
import { definition as z$1 } from "@fortawesome/free-solid-svg-icons/faPrescriptionBottle";
import { definition as zai } from "@fortawesome/free-solid-svg-icons/faPrescriptionBottleAlt";
import { definition as C$1 } from "@fortawesome/free-solid-svg-icons/faPrescriptionBottleAlt";
import { definition as Lai } from "@fortawesome/free-solid-svg-icons/faPrescriptionBottleMedical";
import { definition as $$1 } from "@fortawesome/free-solid-svg-icons/faPrescriptionBottleMedical";
import { definition as Cai } from "@fortawesome/free-solid-svg-icons/faPrint";
import { definition as b$1 } from "@fortawesome/free-solid-svg-icons/faPrint";
import { definition as Dai } from "@fortawesome/free-solid-svg-icons/faProcedures";
import { definition as y$1 } from "@fortawesome/free-solid-svg-icons/faProcedures";
import { definition as $ai } from "@fortawesome/free-solid-svg-icons/faProjectDiagram";
import { definition as k$1 } from "@fortawesome/free-solid-svg-icons/faProjectDiagram";
import { definition as _ai } from "@fortawesome/free-solid-svg-icons/faPumpMedical";
import { definition as j$1 } from "@fortawesome/free-solid-svg-icons/faPumpMedical";
import { definition as bai } from "@fortawesome/free-solid-svg-icons/faPumpSoap";
import { definition as T$1 } from "@fortawesome/free-solid-svg-icons/faPumpSoap";
import { definition as Sai } from "@fortawesome/free-solid-svg-icons/faPuzzlePiece";
import { definition as H$1 } from "@fortawesome/free-solid-svg-icons/faPuzzlePiece";
import { definition as yai } from "@fortawesome/free-solid-svg-icons/faQ";
import { definition as U$1 } from "@fortawesome/free-solid-svg-icons/faQ";
import { definition as Oai } from "@fortawesome/free-solid-svg-icons/faQrcode";
import { definition as G$1 } from "@fortawesome/free-solid-svg-icons/faQrcode";
import { definition as kai } from "@fortawesome/free-solid-svg-icons/faQuestion";
import { definition as E$1 } from "@fortawesome/free-solid-svg-icons/faQuestion";
import { definition as Aai } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { definition as I$1 } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { definition as jai } from "@fortawesome/free-solid-svg-icons/faQuidditch";
import { definition as X$1 } from "@fortawesome/free-solid-svg-icons/faQuidditch";
import { definition as Bai } from "@fortawesome/free-solid-svg-icons/faQuidditchBroomBall";
import { definition as J$1 } from "@fortawesome/free-solid-svg-icons/faQuidditchBroomBall";
import { definition as Tai } from "@fortawesome/free-solid-svg-icons/faQuoteLeft";
import { definition as Z$1 } from "@fortawesome/free-solid-svg-icons/faQuoteLeft";
import { definition as Fai } from "@fortawesome/free-solid-svg-icons/faQuoteLeftAlt";
import { definition as x$1 } from "@fortawesome/free-solid-svg-icons/faQuoteLeftAlt";
import { definition as Hai } from "@fortawesome/free-solid-svg-icons/faQuoteRight";
import { definition as a_1 } from "@fortawesome/free-solid-svg-icons/faQuoteRight";
import { definition as Rai } from "@fortawesome/free-solid-svg-icons/faQuoteRightAlt";
import { definition as n_1 } from "@fortawesome/free-solid-svg-icons/faQuoteRightAlt";
import { definition as Uai } from "@fortawesome/free-solid-svg-icons/faQuran";
import { definition as c_1 } from "@fortawesome/free-solid-svg-icons/faQuran";
import { definition as qai } from "@fortawesome/free-solid-svg-icons/faR";
import { definition as o_1 } from "@fortawesome/free-solid-svg-icons/faR";
import { definition as Gai } from "@fortawesome/free-solid-svg-icons/faRadiation";
import { definition as d_1 } from "@fortawesome/free-solid-svg-icons/faRadiation";
import { definition as Wai } from "@fortawesome/free-solid-svg-icons/faRadiationAlt";
import { definition as s_1 } from "@fortawesome/free-solid-svg-icons/faRadiationAlt";
import { definition as Eai } from "@fortawesome/free-solid-svg-icons/faRadio";
import { definition as v_1 } from "@fortawesome/free-solid-svg-icons/faRadio";
import { definition as Vai } from "@fortawesome/free-solid-svg-icons/faRainbow";
import { definition as m_1 } from "@fortawesome/free-solid-svg-icons/faRainbow";
import { definition as Iai } from "@fortawesome/free-solid-svg-icons/faRandom";
import { definition as P_1 } from "@fortawesome/free-solid-svg-icons/faRandom";
import { definition as Kai } from "@fortawesome/free-solid-svg-icons/faRankingStar";
import { definition as w_1 } from "@fortawesome/free-solid-svg-icons/faRankingStar";
import { definition as Xai } from "@fortawesome/free-solid-svg-icons/faReceipt";
import { definition as z_1 } from "@fortawesome/free-solid-svg-icons/faReceipt";
import { definition as Qai } from "@fortawesome/free-solid-svg-icons/faRecordVinyl";
import { definition as C_1 } from "@fortawesome/free-solid-svg-icons/faRecordVinyl";
import { definition as Jai } from "@fortawesome/free-solid-svg-icons/faRectangleAd";
import { definition as $_1 } from "@fortawesome/free-solid-svg-icons/faRectangleAd";
import { definition as Yai } from "@fortawesome/free-solid-svg-icons/faRectangleList";
import { definition as b_1 } from "@fortawesome/free-solid-svg-icons/faRectangleList";
import { definition as Zai } from "@fortawesome/free-solid-svg-icons/faRectangleTimes";
import { definition as y_1 } from "@fortawesome/free-solid-svg-icons/faRectangleTimes";
import { definition as pai } from "@fortawesome/free-solid-svg-icons/faRectangleXmark";
import { definition as k_1 } from "@fortawesome/free-solid-svg-icons/faRectangleXmark";
import { definition as xai } from "@fortawesome/free-solid-svg-icons/faRecycle";
import { definition as j_1 } from "@fortawesome/free-solid-svg-icons/faRecycle";
import { definition as i4i } from "@fortawesome/free-solid-svg-icons/faRedo";
import { definition as T_1 } from "@fortawesome/free-solid-svg-icons/faRedo";
import { definition as a4i } from "@fortawesome/free-solid-svg-icons/faRedoAlt";
import { definition as H_1 } from "@fortawesome/free-solid-svg-icons/faRedoAlt";
import { definition as e4i } from "@fortawesome/free-solid-svg-icons/faRefresh";
import { definition as U_1 } from "@fortawesome/free-solid-svg-icons/faRefresh";
import { definition as n4i } from "@fortawesome/free-solid-svg-icons/faRegistered";
import { definition as G_1 } from "@fortawesome/free-solid-svg-icons/faRegistered";
import { definition as f4i } from "@fortawesome/free-solid-svg-icons/faRemove";
import { definition as E_1 } from "@fortawesome/free-solid-svg-icons/faRemove";
import { definition as c4i } from "@fortawesome/free-solid-svg-icons/faRemoveFormat";
import { definition as I_1 } from "@fortawesome/free-solid-svg-icons/faRemoveFormat";
import { definition as t4i } from "@fortawesome/free-solid-svg-icons/faReorder";
import { definition as X_1 } from "@fortawesome/free-solid-svg-icons/faReorder";
import { definition as o4i } from "@fortawesome/free-solid-svg-icons/faRepeat";
import { definition as J_1 } from "@fortawesome/free-solid-svg-icons/faRepeat";
import { definition as l4i } from "@fortawesome/free-solid-svg-icons/faReply";
import { definition as Z_1 } from "@fortawesome/free-solid-svg-icons/faReply";
import { definition as d4i } from "@fortawesome/free-solid-svg-icons/faReplyAll";
import { definition as x_1 } from "@fortawesome/free-solid-svg-icons/faReplyAll";
import { definition as r4i } from "@fortawesome/free-solid-svg-icons/faRepublican";
import { definition as ab1 } from "@fortawesome/free-solid-svg-icons/faRepublican";
import { definition as s4i } from "@fortawesome/free-solid-svg-icons/faRestroom";
import { definition as nb1 } from "@fortawesome/free-solid-svg-icons/faRestroom";
import { definition as h4i } from "@fortawesome/free-solid-svg-icons/faRetweet";
import { definition as cb1 } from "@fortawesome/free-solid-svg-icons/faRetweet";
import { definition as v4i } from "@fortawesome/free-solid-svg-icons/faRibbon";
import { definition as ob1 } from "@fortawesome/free-solid-svg-icons/faRibbon";
import { definition as u4i } from "@fortawesome/free-solid-svg-icons/faRightFromBracket";
import { definition as db1 } from "@fortawesome/free-solid-svg-icons/faRightFromBracket";
import { definition as m4i } from "@fortawesome/free-solid-svg-icons/faRightLeft";
import { definition as sb1 } from "@fortawesome/free-solid-svg-icons/faRightLeft";
import { definition as g4i } from "@fortawesome/free-solid-svg-icons/faRightLong";
import { definition as vb1 } from "@fortawesome/free-solid-svg-icons/faRightLong";
import { definition as P4i } from "@fortawesome/free-solid-svg-icons/faRightToBracket";
import { definition as mb1 } from "@fortawesome/free-solid-svg-icons/faRightToBracket";
import { definition as M4i } from "@fortawesome/free-solid-svg-icons/faRing";
import { definition as Pb1 } from "@fortawesome/free-solid-svg-icons/faRing";
import { definition as w4i } from "@fortawesome/free-solid-svg-icons/faRmb";
import { definition as wb1 } from "@fortawesome/free-solid-svg-icons/faRmb";
import { definition as N4i } from "@fortawesome/free-solid-svg-icons/faRoad";
import { definition as zb1 } from "@fortawesome/free-solid-svg-icons/faRoad";
import { definition as z4i } from "@fortawesome/free-solid-svg-icons/faRoadBarrier";
import { definition as Cb1 } from "@fortawesome/free-solid-svg-icons/faRoadBarrier";
import { definition as L4i } from "@fortawesome/free-solid-svg-icons/faRoadBridge";
import { definition as $b1 } from "@fortawesome/free-solid-svg-icons/faRoadBridge";
import { definition as C4i } from "@fortawesome/free-solid-svg-icons/faRoadCircleCheck";
import { definition as bb1 } from "@fortawesome/free-solid-svg-icons/faRoadCircleCheck";
import { definition as D4i } from "@fortawesome/free-solid-svg-icons/faRoadCircleExclamation";
import { definition as yb1 } from "@fortawesome/free-solid-svg-icons/faRoadCircleExclamation";
import { definition as $4i } from "@fortawesome/free-solid-svg-icons/faRoadCircleXmark";
import { definition as kb1 } from "@fortawesome/free-solid-svg-icons/faRoadCircleXmark";
import { definition as _4i } from "@fortawesome/free-solid-svg-icons/faRoadLock";
import { definition as jb1 } from "@fortawesome/free-solid-svg-icons/faRoadLock";
import { definition as b4i } from "@fortawesome/free-solid-svg-icons/faRoadSpikes";
import { definition as Tb1 } from "@fortawesome/free-solid-svg-icons/faRoadSpikes";
import { definition as S4i } from "@fortawesome/free-solid-svg-icons/faRobot";
import { definition as Hb1 } from "@fortawesome/free-solid-svg-icons/faRobot";
import { definition as y4i } from "@fortawesome/free-solid-svg-icons/faRocket";
import { definition as Ub1 } from "@fortawesome/free-solid-svg-icons/faRocket";
import { definition as O4i } from "@fortawesome/free-solid-svg-icons/faRodAsclepius";
import { definition as Gb1 } from "@fortawesome/free-solid-svg-icons/faRodAsclepius";
import { definition as k4i } from "@fortawesome/free-solid-svg-icons/faRodSnake";
import { definition as Eb1 } from "@fortawesome/free-solid-svg-icons/faRodSnake";
import { definition as A4i } from "@fortawesome/free-solid-svg-icons/faRotate";
import { definition as Ib1 } from "@fortawesome/free-solid-svg-icons/faRotate";
import { definition as j4i } from "@fortawesome/free-solid-svg-icons/faRotateBack";
import { definition as Xb1 } from "@fortawesome/free-solid-svg-icons/faRotateBack";
import { definition as B4i } from "@fortawesome/free-solid-svg-icons/faRotateBackward";
import { definition as Jb1 } from "@fortawesome/free-solid-svg-icons/faRotateBackward";
import { definition as T4i } from "@fortawesome/free-solid-svg-icons/faRotateForward";
import { definition as Zb1 } from "@fortawesome/free-solid-svg-icons/faRotateForward";
import { definition as F4i } from "@fortawesome/free-solid-svg-icons/faRotateLeft";
import { definition as xb1 } from "@fortawesome/free-solid-svg-icons/faRotateLeft";
import { definition as H4i } from "@fortawesome/free-solid-svg-icons/faRotateRight";
import { definition as aS1 } from "@fortawesome/free-solid-svg-icons/faRotateRight";
import { definition as R4i } from "@fortawesome/free-solid-svg-icons/faRouble";
import { definition as nS1 } from "@fortawesome/free-solid-svg-icons/faRouble";
import { definition as U4i } from "@fortawesome/free-solid-svg-icons/faRoute";
import { definition as cS1 } from "@fortawesome/free-solid-svg-icons/faRoute";
import { definition as q4i } from "@fortawesome/free-solid-svg-icons/faRss";
import { definition as oS1 } from "@fortawesome/free-solid-svg-icons/faRss";
import { definition as G4i } from "@fortawesome/free-solid-svg-icons/faRssSquare";
import { definition as dS1 } from "@fortawesome/free-solid-svg-icons/faRssSquare";
import { definition as W4i } from "@fortawesome/free-solid-svg-icons/faRub";
import { definition as sS1 } from "@fortawesome/free-solid-svg-icons/faRub";
import { definition as E4i } from "@fortawesome/free-solid-svg-icons/faRuble";
import { definition as vS1 } from "@fortawesome/free-solid-svg-icons/faRuble";
import { definition as V4i } from "@fortawesome/free-solid-svg-icons/faRubleSign";
import { definition as mS1 } from "@fortawesome/free-solid-svg-icons/faRubleSign";
import { definition as I4i } from "@fortawesome/free-solid-svg-icons/faRug";
import { definition as PS1 } from "@fortawesome/free-solid-svg-icons/faRug";
import { definition as K4i } from "@fortawesome/free-solid-svg-icons/faRuler";
import { definition as wS1 } from "@fortawesome/free-solid-svg-icons/faRuler";
import { definition as X4i } from "@fortawesome/free-solid-svg-icons/faRulerCombined";
import { definition as zS1 } from "@fortawesome/free-solid-svg-icons/faRulerCombined";
import { definition as Q4i } from "@fortawesome/free-solid-svg-icons/faRulerHorizontal";
import { definition as CS1 } from "@fortawesome/free-solid-svg-icons/faRulerHorizontal";
import { definition as J4i } from "@fortawesome/free-solid-svg-icons/faRulerVertical";
import { definition as $S1 } from "@fortawesome/free-solid-svg-icons/faRulerVertical";
import { definition as Y4i } from "@fortawesome/free-solid-svg-icons/faRunning";
import { definition as bS1 } from "@fortawesome/free-solid-svg-icons/faRunning";
import { definition as Z4i } from "@fortawesome/free-solid-svg-icons/faRupee";
import { definition as yS1 } from "@fortawesome/free-solid-svg-icons/faRupee";
import { definition as p4i } from "@fortawesome/free-solid-svg-icons/faRupeeSign";
import { definition as kS1 } from "@fortawesome/free-solid-svg-icons/faRupeeSign";
import { definition as x4i } from "@fortawesome/free-solid-svg-icons/faRupiahSign";
import { definition as jS1 } from "@fortawesome/free-solid-svg-icons/faRupiahSign";
import { definition as i3i } from "@fortawesome/free-solid-svg-icons/faS";
import { definition as TS1 } from "@fortawesome/free-solid-svg-icons/faS";
import { definition as a3i } from "@fortawesome/free-solid-svg-icons/faSackDollar";
import { definition as HS1 } from "@fortawesome/free-solid-svg-icons/faSackDollar";
import { definition as e3i } from "@fortawesome/free-solid-svg-icons/faSackXmark";
import { definition as US1 } from "@fortawesome/free-solid-svg-icons/faSackXmark";
import { definition as n3i } from "@fortawesome/free-solid-svg-icons/faSadCry";
import { definition as GS1 } from "@fortawesome/free-solid-svg-icons/faSadCry";
import { definition as f3i } from "@fortawesome/free-solid-svg-icons/faSadTear";
import { definition as ES1 } from "@fortawesome/free-solid-svg-icons/faSadTear";
import { definition as c3i } from "@fortawesome/free-solid-svg-icons/faSailboat";
import { definition as IS1 } from "@fortawesome/free-solid-svg-icons/faSailboat";
import { definition as t3i } from "@fortawesome/free-solid-svg-icons/faSatellite";
import { definition as XS1 } from "@fortawesome/free-solid-svg-icons/faSatellite";
import { definition as o3i } from "@fortawesome/free-solid-svg-icons/faSatelliteDish";
import { definition as JS1 } from "@fortawesome/free-solid-svg-icons/faSatelliteDish";
import { definition as l3i } from "@fortawesome/free-solid-svg-icons/faSave";
import { definition as ZS1 } from "@fortawesome/free-solid-svg-icons/faSave";
import { definition as d3i } from "@fortawesome/free-solid-svg-icons/faScaleBalanced";
import { definition as xS1 } from "@fortawesome/free-solid-svg-icons/faScaleBalanced";
import { definition as r3i } from "@fortawesome/free-solid-svg-icons/faScaleUnbalanced";
import { definition as ay1 } from "@fortawesome/free-solid-svg-icons/faScaleUnbalanced";
import { definition as s3i } from "@fortawesome/free-solid-svg-icons/faScaleUnbalancedFlip";
import { definition as ny1 } from "@fortawesome/free-solid-svg-icons/faScaleUnbalancedFlip";
import { definition as h3i } from "@fortawesome/free-solid-svg-icons/faSchool";
import { definition as cy1 } from "@fortawesome/free-solid-svg-icons/faSchool";
import { definition as v3i } from "@fortawesome/free-solid-svg-icons/faSchoolCircleCheck";
import { definition as oy1 } from "@fortawesome/free-solid-svg-icons/faSchoolCircleCheck";
import { definition as u3i } from "@fortawesome/free-solid-svg-icons/faSchoolCircleExclamation";
import { definition as dy1 } from "@fortawesome/free-solid-svg-icons/faSchoolCircleExclamation";
import { definition as m3i } from "@fortawesome/free-solid-svg-icons/faSchoolCircleXmark";
import { definition as sy1 } from "@fortawesome/free-solid-svg-icons/faSchoolCircleXmark";
import { definition as g3i } from "@fortawesome/free-solid-svg-icons/faSchoolFlag";
import { definition as vy1 } from "@fortawesome/free-solid-svg-icons/faSchoolFlag";
import { definition as P3i } from "@fortawesome/free-solid-svg-icons/faSchoolLock";
import { definition as my1 } from "@fortawesome/free-solid-svg-icons/faSchoolLock";
import { definition as M3i } from "@fortawesome/free-solid-svg-icons/faScissors";
import { definition as Py1 } from "@fortawesome/free-solid-svg-icons/faScissors";
import { definition as w3i } from "@fortawesome/free-solid-svg-icons/faScrewdriver";
import { definition as wy1 } from "@fortawesome/free-solid-svg-icons/faScrewdriver";
import { definition as N3i } from "@fortawesome/free-solid-svg-icons/faScrewdriverWrench";
import { definition as zy1 } from "@fortawesome/free-solid-svg-icons/faScrewdriverWrench";
import { definition as z3i } from "@fortawesome/free-solid-svg-icons/faScroll";
import { definition as Cy1 } from "@fortawesome/free-solid-svg-icons/faScroll";
import { definition as L3i } from "@fortawesome/free-solid-svg-icons/faScrollTorah";
import { definition as $y1 } from "@fortawesome/free-solid-svg-icons/faScrollTorah";
import { definition as C3i } from "@fortawesome/free-solid-svg-icons/faSdCard";
import { definition as by1 } from "@fortawesome/free-solid-svg-icons/faSdCard";
import { definition as D3i } from "@fortawesome/free-solid-svg-icons/faSearch";
import { definition as yy1 } from "@fortawesome/free-solid-svg-icons/faSearch";
import { definition as $3i } from "@fortawesome/free-solid-svg-icons/faSearchDollar";
import { definition as ky1 } from "@fortawesome/free-solid-svg-icons/faSearchDollar";
import { definition as _3i } from "@fortawesome/free-solid-svg-icons/faSearchLocation";
import { definition as jy1 } from "@fortawesome/free-solid-svg-icons/faSearchLocation";
import { definition as b3i } from "@fortawesome/free-solid-svg-icons/faSearchMinus";
import { definition as Ty1 } from "@fortawesome/free-solid-svg-icons/faSearchMinus";
import { definition as S3i } from "@fortawesome/free-solid-svg-icons/faSearchPlus";
import { definition as Hy1 } from "@fortawesome/free-solid-svg-icons/faSearchPlus";
import { definition as y3i } from "@fortawesome/free-solid-svg-icons/faSection";
import { definition as Uy1 } from "@fortawesome/free-solid-svg-icons/faSection";
import { definition as O3i } from "@fortawesome/free-solid-svg-icons/faSeedling";
import { definition as Gy1 } from "@fortawesome/free-solid-svg-icons/faSeedling";
import { definition as k3i } from "@fortawesome/free-solid-svg-icons/faServer";
import { definition as Ey1 } from "@fortawesome/free-solid-svg-icons/faServer";
import { definition as A3i } from "@fortawesome/free-solid-svg-icons/faShapes";
import { definition as Iy1 } from "@fortawesome/free-solid-svg-icons/faShapes";
import { definition as j3i } from "@fortawesome/free-solid-svg-icons/faShare";
import { definition as Xy1 } from "@fortawesome/free-solid-svg-icons/faShare";
import { definition as B3i } from "@fortawesome/free-solid-svg-icons/faShareAlt";
import { definition as Jy1 } from "@fortawesome/free-solid-svg-icons/faShareAlt";
import { definition as T3i } from "@fortawesome/free-solid-svg-icons/faShareAltSquare";
import { definition as Zy1 } from "@fortawesome/free-solid-svg-icons/faShareAltSquare";
import { definition as F3i } from "@fortawesome/free-solid-svg-icons/faShareFromSquare";
import { definition as xy1 } from "@fortawesome/free-solid-svg-icons/faShareFromSquare";
import { definition as H3i } from "@fortawesome/free-solid-svg-icons/faShareNodes";
import { definition as aO1 } from "@fortawesome/free-solid-svg-icons/faShareNodes";
import { definition as R3i } from "@fortawesome/free-solid-svg-icons/faShareSquare";
import { definition as nO1 } from "@fortawesome/free-solid-svg-icons/faShareSquare";
import { definition as U3i } from "@fortawesome/free-solid-svg-icons/faSheetPlastic";
import { definition as cO1 } from "@fortawesome/free-solid-svg-icons/faSheetPlastic";
import { definition as q3i } from "@fortawesome/free-solid-svg-icons/faShekel";
import { definition as oO1 } from "@fortawesome/free-solid-svg-icons/faShekel";
import { definition as G3i } from "@fortawesome/free-solid-svg-icons/faShekelSign";
import { definition as dO1 } from "@fortawesome/free-solid-svg-icons/faShekelSign";
import { definition as W3i } from "@fortawesome/free-solid-svg-icons/faSheqel";
import { definition as sO1 } from "@fortawesome/free-solid-svg-icons/faSheqel";
import { definition as E3i } from "@fortawesome/free-solid-svg-icons/faSheqelSign";
import { definition as vO1 } from "@fortawesome/free-solid-svg-icons/faSheqelSign";
import { definition as V3i } from "@fortawesome/free-solid-svg-icons/faShield";
import { definition as mO1 } from "@fortawesome/free-solid-svg-icons/faShield";
import { definition as I3i } from "@fortawesome/free-solid-svg-icons/faShieldAlt";
import { definition as PO1 } from "@fortawesome/free-solid-svg-icons/faShieldAlt";
import { definition as K3i } from "@fortawesome/free-solid-svg-icons/faShieldBlank";
import { definition as wO1 } from "@fortawesome/free-solid-svg-icons/faShieldBlank";
import { definition as X3i } from "@fortawesome/free-solid-svg-icons/faShieldCat";
import { definition as zO1 } from "@fortawesome/free-solid-svg-icons/faShieldCat";
import { definition as Q3i } from "@fortawesome/free-solid-svg-icons/faShieldDog";
import { definition as CO1 } from "@fortawesome/free-solid-svg-icons/faShieldDog";
import { definition as J3i } from "@fortawesome/free-solid-svg-icons/faShieldHalved";
import { definition as $O1 } from "@fortawesome/free-solid-svg-icons/faShieldHalved";
import { definition as Y3i } from "@fortawesome/free-solid-svg-icons/faShieldHeart";
import { definition as bO1 } from "@fortawesome/free-solid-svg-icons/faShieldHeart";
import { definition as Z3i } from "@fortawesome/free-solid-svg-icons/faShieldVirus";
import { definition as yO1 } from "@fortawesome/free-solid-svg-icons/faShieldVirus";
import { definition as p3i } from "@fortawesome/free-solid-svg-icons/faShip";
import { definition as kO1 } from "@fortawesome/free-solid-svg-icons/faShip";
import { definition as x3i } from "@fortawesome/free-solid-svg-icons/faShippingFast";
import { definition as jO1 } from "@fortawesome/free-solid-svg-icons/faShippingFast";
import { definition as i0i } from "@fortawesome/free-solid-svg-icons/faShirt";
import { definition as TO1 } from "@fortawesome/free-solid-svg-icons/faShirt";
import { definition as a0i } from "@fortawesome/free-solid-svg-icons/faShoePrints";
import { definition as HO1 } from "@fortawesome/free-solid-svg-icons/faShoePrints";
import { definition as e0i } from "@fortawesome/free-solid-svg-icons/faShop";
import { definition as UO1 } from "@fortawesome/free-solid-svg-icons/faShop";
import { definition as n0i } from "@fortawesome/free-solid-svg-icons/faShopLock";
import { definition as GO1 } from "@fortawesome/free-solid-svg-icons/faShopLock";
import { definition as f0i } from "@fortawesome/free-solid-svg-icons/faShopSlash";
import { definition as EO1 } from "@fortawesome/free-solid-svg-icons/faShopSlash";
import { definition as c0i } from "@fortawesome/free-solid-svg-icons/faShoppingBag";
import { definition as IO1 } from "@fortawesome/free-solid-svg-icons/faShoppingBag";
import { definition as t0i } from "@fortawesome/free-solid-svg-icons/faShoppingBasket";
import { definition as XO1 } from "@fortawesome/free-solid-svg-icons/faShoppingBasket";
import { definition as o0i } from "@fortawesome/free-solid-svg-icons/faShoppingCart";
import { definition as JO1 } from "@fortawesome/free-solid-svg-icons/faShoppingCart";
import { definition as l0i } from "@fortawesome/free-solid-svg-icons/faShower";
import { definition as ZO1 } from "@fortawesome/free-solid-svg-icons/faShower";
import { definition as d0i } from "@fortawesome/free-solid-svg-icons/faShrimp";
import { definition as xO1 } from "@fortawesome/free-solid-svg-icons/faShrimp";
import { definition as r0i } from "@fortawesome/free-solid-svg-icons/faShuffle";
import { definition as ak1 } from "@fortawesome/free-solid-svg-icons/faShuffle";
import { definition as s0i } from "@fortawesome/free-solid-svg-icons/faShuttleSpace";
import { definition as nk1 } from "@fortawesome/free-solid-svg-icons/faShuttleSpace";
import { definition as h0i } from "@fortawesome/free-solid-svg-icons/faShuttleVan";
import { definition as ck1 } from "@fortawesome/free-solid-svg-icons/faShuttleVan";
import { definition as v0i } from "@fortawesome/free-solid-svg-icons/faSign";
import { definition as ok1 } from "@fortawesome/free-solid-svg-icons/faSign";
import { definition as u0i } from "@fortawesome/free-solid-svg-icons/faSignHanging";
import { definition as dk1 } from "@fortawesome/free-solid-svg-icons/faSignHanging";
import { definition as m0i } from "@fortawesome/free-solid-svg-icons/faSignIn";
import { definition as sk1 } from "@fortawesome/free-solid-svg-icons/faSignIn";
import { definition as g0i } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import { definition as vk1 } from "@fortawesome/free-solid-svg-icons/faSignInAlt";
import { definition as P0i } from "@fortawesome/free-solid-svg-icons/faSignLanguage";
import { definition as mk1 } from "@fortawesome/free-solid-svg-icons/faSignLanguage";
import { definition as M0i } from "@fortawesome/free-solid-svg-icons/faSignOut";
import { definition as Pk1 } from "@fortawesome/free-solid-svg-icons/faSignOut";
import { definition as w0i } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import { definition as wk1 } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import { definition as N0i } from "@fortawesome/free-solid-svg-icons/faSignal";
import { definition as zk1 } from "@fortawesome/free-solid-svg-icons/faSignal";
import { definition as z0i } from "@fortawesome/free-solid-svg-icons/faSignal5";
import { definition as Ck1 } from "@fortawesome/free-solid-svg-icons/faSignal5";
import { definition as L0i } from "@fortawesome/free-solid-svg-icons/faSignalPerfect";
import { definition as $k1 } from "@fortawesome/free-solid-svg-icons/faSignalPerfect";
import { definition as C0i } from "@fortawesome/free-solid-svg-icons/faSignature";
import { definition as bk1 } from "@fortawesome/free-solid-svg-icons/faSignature";
import { definition as D0i } from "@fortawesome/free-solid-svg-icons/faSigning";
import { definition as yk1 } from "@fortawesome/free-solid-svg-icons/faSigning";
import { definition as $0i } from "@fortawesome/free-solid-svg-icons/faSignsPost";
import { definition as kk1 } from "@fortawesome/free-solid-svg-icons/faSignsPost";
import { definition as _0i } from "@fortawesome/free-solid-svg-icons/faSimCard";
import { definition as jk1 } from "@fortawesome/free-solid-svg-icons/faSimCard";
import { definition as b0i } from "@fortawesome/free-solid-svg-icons/faSink";
import { definition as Tk1 } from "@fortawesome/free-solid-svg-icons/faSink";
import { definition as S0i } from "@fortawesome/free-solid-svg-icons/faSitemap";
import { definition as Hk1 } from "@fortawesome/free-solid-svg-icons/faSitemap";
import { definition as y0i } from "@fortawesome/free-solid-svg-icons/faSkating";
import { definition as Uk1 } from "@fortawesome/free-solid-svg-icons/faSkating";
import { definition as O0i } from "@fortawesome/free-solid-svg-icons/faSkiing";
import { definition as Gk1 } from "@fortawesome/free-solid-svg-icons/faSkiing";
import { definition as k0i } from "@fortawesome/free-solid-svg-icons/faSkiingNordic";
import { definition as Ek1 } from "@fortawesome/free-solid-svg-icons/faSkiingNordic";
import { definition as A0i } from "@fortawesome/free-solid-svg-icons/faSkull";
import { definition as Ik1 } from "@fortawesome/free-solid-svg-icons/faSkull";
import { definition as j0i } from "@fortawesome/free-solid-svg-icons/faSkullCrossbones";
import { definition as Xk1 } from "@fortawesome/free-solid-svg-icons/faSkullCrossbones";
import { definition as B0i } from "@fortawesome/free-solid-svg-icons/faSlash";
import { definition as Jk1 } from "@fortawesome/free-solid-svg-icons/faSlash";
import { definition as T0i } from "@fortawesome/free-solid-svg-icons/faSleigh";
import { definition as Zk1 } from "@fortawesome/free-solid-svg-icons/faSleigh";
import { definition as F0i } from "@fortawesome/free-solid-svg-icons/faSliders";
import { definition as xk1 } from "@fortawesome/free-solid-svg-icons/faSliders";
import { definition as H0i } from "@fortawesome/free-solid-svg-icons/faSlidersH";
import { definition as aA1 } from "@fortawesome/free-solid-svg-icons/faSlidersH";
import { definition as R0i } from "@fortawesome/free-solid-svg-icons/faSmile";
import { definition as nA1 } from "@fortawesome/free-solid-svg-icons/faSmile";
import { definition as U0i } from "@fortawesome/free-solid-svg-icons/faSmileBeam";
import { definition as cA1 } from "@fortawesome/free-solid-svg-icons/faSmileBeam";
import { definition as q0i } from "@fortawesome/free-solid-svg-icons/faSmileWink";
import { definition as oA1 } from "@fortawesome/free-solid-svg-icons/faSmileWink";
import { definition as G0i } from "@fortawesome/free-solid-svg-icons/faSmog";
import { definition as dA1 } from "@fortawesome/free-solid-svg-icons/faSmog";
import { definition as W0i } from "@fortawesome/free-solid-svg-icons/faSmoking";
import { definition as sA1 } from "@fortawesome/free-solid-svg-icons/faSmoking";
import { definition as E0i } from "@fortawesome/free-solid-svg-icons/faSmokingBan";
import { definition as vA1 } from "@fortawesome/free-solid-svg-icons/faSmokingBan";
import { definition as V0i } from "@fortawesome/free-solid-svg-icons/faSms";
import { definition as mA1 } from "@fortawesome/free-solid-svg-icons/faSms";
import { definition as I0i } from "@fortawesome/free-solid-svg-icons/faSnowboarding";
import { definition as PA1 } from "@fortawesome/free-solid-svg-icons/faSnowboarding";
import { definition as K0i } from "@fortawesome/free-solid-svg-icons/faSnowflake";
import { definition as wA1 } from "@fortawesome/free-solid-svg-icons/faSnowflake";
import { definition as X0i } from "@fortawesome/free-solid-svg-icons/faSnowman";
import { definition as zA1 } from "@fortawesome/free-solid-svg-icons/faSnowman";
import { definition as Q0i } from "@fortawesome/free-solid-svg-icons/faSnowplow";
import { definition as CA1 } from "@fortawesome/free-solid-svg-icons/faSnowplow";
import { definition as J0i } from "@fortawesome/free-solid-svg-icons/faSoap";
import { definition as $A1 } from "@fortawesome/free-solid-svg-icons/faSoap";
import { definition as Y0i } from "@fortawesome/free-solid-svg-icons/faSoccerBall";
import { definition as bA1 } from "@fortawesome/free-solid-svg-icons/faSoccerBall";
import { definition as Z0i } from "@fortawesome/free-solid-svg-icons/faSocks";
import { definition as yA1 } from "@fortawesome/free-solid-svg-icons/faSocks";
import { definition as p0i } from "@fortawesome/free-solid-svg-icons/faSolarPanel";
import { definition as kA1 } from "@fortawesome/free-solid-svg-icons/faSolarPanel";
import { definition as x0i } from "@fortawesome/free-solid-svg-icons/faSort";
import { definition as jA1 } from "@fortawesome/free-solid-svg-icons/faSort";
import { definition as iei } from "@fortawesome/free-solid-svg-icons/faSortAlphaAsc";
import { definition as TA1 } from "@fortawesome/free-solid-svg-icons/faSortAlphaAsc";
import { definition as aei } from "@fortawesome/free-solid-svg-icons/faSortAlphaDesc";
import { definition as HA1 } from "@fortawesome/free-solid-svg-icons/faSortAlphaDesc";
import { definition as eei } from "@fortawesome/free-solid-svg-icons/faSortAlphaDown";
import { definition as UA1 } from "@fortawesome/free-solid-svg-icons/faSortAlphaDown";
import { definition as nei } from "@fortawesome/free-solid-svg-icons/faSortAlphaDownAlt";
import { definition as GA1 } from "@fortawesome/free-solid-svg-icons/faSortAlphaDownAlt";
import { definition as fei } from "@fortawesome/free-solid-svg-icons/faSortAlphaUp";
import { definition as EA1 } from "@fortawesome/free-solid-svg-icons/faSortAlphaUp";
import { definition as cei } from "@fortawesome/free-solid-svg-icons/faSortAlphaUpAlt";
import { definition as IA1 } from "@fortawesome/free-solid-svg-icons/faSortAlphaUpAlt";
import { definition as tei } from "@fortawesome/free-solid-svg-icons/faSortAmountAsc";
import { definition as XA1 } from "@fortawesome/free-solid-svg-icons/faSortAmountAsc";
import { definition as oei } from "@fortawesome/free-solid-svg-icons/faSortAmountDesc";
import { definition as JA1 } from "@fortawesome/free-solid-svg-icons/faSortAmountDesc";
import { definition as lei } from "@fortawesome/free-solid-svg-icons/faSortAmountDown";
import { definition as ZA1 } from "@fortawesome/free-solid-svg-icons/faSortAmountDown";
import { definition as dei } from "@fortawesome/free-solid-svg-icons/faSortAmountDownAlt";
import { definition as xA1 } from "@fortawesome/free-solid-svg-icons/faSortAmountDownAlt";
import { definition as rei } from "@fortawesome/free-solid-svg-icons/faSortAmountUp";
import { definition as aj1 } from "@fortawesome/free-solid-svg-icons/faSortAmountUp";
import { definition as sei } from "@fortawesome/free-solid-svg-icons/faSortAmountUpAlt";
import { definition as nj1 } from "@fortawesome/free-solid-svg-icons/faSortAmountUpAlt";
import { definition as hei } from "@fortawesome/free-solid-svg-icons/faSortAsc";
import { definition as cj1 } from "@fortawesome/free-solid-svg-icons/faSortAsc";
import { definition as vei } from "@fortawesome/free-solid-svg-icons/faSortDesc";
import { definition as oj1 } from "@fortawesome/free-solid-svg-icons/faSortDesc";
import { definition as uei } from "@fortawesome/free-solid-svg-icons/faSortDown";
import { definition as dj1 } from "@fortawesome/free-solid-svg-icons/faSortDown";
import { definition as mei } from "@fortawesome/free-solid-svg-icons/faSortNumericAsc";
import { definition as sj1 } from "@fortawesome/free-solid-svg-icons/faSortNumericAsc";
import { definition as gei } from "@fortawesome/free-solid-svg-icons/faSortNumericDesc";
import { definition as vj1 } from "@fortawesome/free-solid-svg-icons/faSortNumericDesc";
import { definition as Pei } from "@fortawesome/free-solid-svg-icons/faSortNumericDown";
import { definition as mj1 } from "@fortawesome/free-solid-svg-icons/faSortNumericDown";
import { definition as Mei } from "@fortawesome/free-solid-svg-icons/faSortNumericDownAlt";
import { definition as Pj1 } from "@fortawesome/free-solid-svg-icons/faSortNumericDownAlt";
import { definition as wei } from "@fortawesome/free-solid-svg-icons/faSortNumericUp";
import { definition as wj1 } from "@fortawesome/free-solid-svg-icons/faSortNumericUp";
import { definition as Nei } from "@fortawesome/free-solid-svg-icons/faSortNumericUpAlt";
import { definition as zj1 } from "@fortawesome/free-solid-svg-icons/faSortNumericUpAlt";
import { definition as zei } from "@fortawesome/free-solid-svg-icons/faSortUp";
import { definition as Cj1 } from "@fortawesome/free-solid-svg-icons/faSortUp";
import { definition as Lei } from "@fortawesome/free-solid-svg-icons/faSpa";
import { definition as $j1 } from "@fortawesome/free-solid-svg-icons/faSpa";
import { definition as Cei } from "@fortawesome/free-solid-svg-icons/faSpaceShuttle";
import { definition as bj1 } from "@fortawesome/free-solid-svg-icons/faSpaceShuttle";
import { definition as Dei } from "@fortawesome/free-solid-svg-icons/faSpaghettiMonsterFlying";
import { definition as yj1 } from "@fortawesome/free-solid-svg-icons/faSpaghettiMonsterFlying";
import { definition as $ei } from "@fortawesome/free-solid-svg-icons/faSpellCheck";
import { definition as kj1 } from "@fortawesome/free-solid-svg-icons/faSpellCheck";
import { definition as _ei } from "@fortawesome/free-solid-svg-icons/faSpider";
import { definition as jj1 } from "@fortawesome/free-solid-svg-icons/faSpider";
import { definition as bei } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { definition as Tj1 } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { definition as Sei } from "@fortawesome/free-solid-svg-icons/faSplotch";
import { definition as Hj1 } from "@fortawesome/free-solid-svg-icons/faSplotch";
import { definition as yei } from "@fortawesome/free-solid-svg-icons/faSpoon";
import { definition as Uj1 } from "@fortawesome/free-solid-svg-icons/faSpoon";
import { definition as Oei } from "@fortawesome/free-solid-svg-icons/faSprayCan";
import { definition as Gj1 } from "@fortawesome/free-solid-svg-icons/faSprayCan";
import { definition as kei } from "@fortawesome/free-solid-svg-icons/faSprayCanSparkles";
import { definition as Ej1 } from "@fortawesome/free-solid-svg-icons/faSprayCanSparkles";
import { definition as Aei } from "@fortawesome/free-solid-svg-icons/faSprout";
import { definition as Ij1 } from "@fortawesome/free-solid-svg-icons/faSprout";
import { definition as jei } from "@fortawesome/free-solid-svg-icons/faSquare";
import { definition as Xj1 } from "@fortawesome/free-solid-svg-icons/faSquare";
import { definition as Bei } from "@fortawesome/free-solid-svg-icons/faSquareArrowUpRight";
import { definition as Jj1 } from "@fortawesome/free-solid-svg-icons/faSquareArrowUpRight";
import { definition as Tei } from "@fortawesome/free-solid-svg-icons/faSquareCaretDown";
import { definition as Zj1 } from "@fortawesome/free-solid-svg-icons/faSquareCaretDown";
import { definition as Fei } from "@fortawesome/free-solid-svg-icons/faSquareCaretLeft";
import { definition as xj1 } from "@fortawesome/free-solid-svg-icons/faSquareCaretLeft";
import { definition as Hei } from "@fortawesome/free-solid-svg-icons/faSquareCaretRight";
import { definition as aB1 } from "@fortawesome/free-solid-svg-icons/faSquareCaretRight";
import { definition as Rei } from "@fortawesome/free-solid-svg-icons/faSquareCaretUp";
import { definition as nB1 } from "@fortawesome/free-solid-svg-icons/faSquareCaretUp";
import { definition as Uei } from "@fortawesome/free-solid-svg-icons/faSquareCheck";
import { definition as cB1 } from "@fortawesome/free-solid-svg-icons/faSquareCheck";
import { definition as qei } from "@fortawesome/free-solid-svg-icons/faSquareEnvelope";
import { definition as oB1 } from "@fortawesome/free-solid-svg-icons/faSquareEnvelope";
import { definition as Gei } from "@fortawesome/free-solid-svg-icons/faSquareFull";
import { definition as dB1 } from "@fortawesome/free-solid-svg-icons/faSquareFull";
import { definition as Wei } from "@fortawesome/free-solid-svg-icons/faSquareH";
import { definition as sB1 } from "@fortawesome/free-solid-svg-icons/faSquareH";
import { definition as Eei } from "@fortawesome/free-solid-svg-icons/faSquareMinus";
import { definition as vB1 } from "@fortawesome/free-solid-svg-icons/faSquareMinus";
import { definition as Vei } from "@fortawesome/free-solid-svg-icons/faSquareNfi";
import { definition as mB1 } from "@fortawesome/free-solid-svg-icons/faSquareNfi";
import { definition as Iei } from "@fortawesome/free-solid-svg-icons/faSquareParking";
import { definition as PB1 } from "@fortawesome/free-solid-svg-icons/faSquareParking";
import { definition as Kei } from "@fortawesome/free-solid-svg-icons/faSquarePen";
import { definition as wB1 } from "@fortawesome/free-solid-svg-icons/faSquarePen";
import { definition as Xei } from "@fortawesome/free-solid-svg-icons/faSquarePersonConfined";
import { definition as zB1 } from "@fortawesome/free-solid-svg-icons/faSquarePersonConfined";
import { definition as Qei } from "@fortawesome/free-solid-svg-icons/faSquarePhone";
import { definition as CB1 } from "@fortawesome/free-solid-svg-icons/faSquarePhone";
import { definition as Jei } from "@fortawesome/free-solid-svg-icons/faSquarePhoneFlip";
import { definition as $B1 } from "@fortawesome/free-solid-svg-icons/faSquarePhoneFlip";
import { definition as Yei } from "@fortawesome/free-solid-svg-icons/faSquarePlus";
import { definition as bB1 } from "@fortawesome/free-solid-svg-icons/faSquarePlus";
import { definition as Zei } from "@fortawesome/free-solid-svg-icons/faSquarePollHorizontal";
import { definition as yB1 } from "@fortawesome/free-solid-svg-icons/faSquarePollHorizontal";
import { definition as pei } from "@fortawesome/free-solid-svg-icons/faSquarePollVertical";
import { definition as kB1 } from "@fortawesome/free-solid-svg-icons/faSquarePollVertical";
import { definition as xei } from "@fortawesome/free-solid-svg-icons/faSquareRootAlt";
import { definition as jB1 } from "@fortawesome/free-solid-svg-icons/faSquareRootAlt";
import { definition as ini } from "@fortawesome/free-solid-svg-icons/faSquareRootVariable";
import { definition as TB1 } from "@fortawesome/free-solid-svg-icons/faSquareRootVariable";
import { definition as ani } from "@fortawesome/free-solid-svg-icons/faSquareRss";
import { definition as HB1 } from "@fortawesome/free-solid-svg-icons/faSquareRss";
import { definition as eni } from "@fortawesome/free-solid-svg-icons/faSquareShareNodes";
import { definition as UB1 } from "@fortawesome/free-solid-svg-icons/faSquareShareNodes";
import { definition as nni } from "@fortawesome/free-solid-svg-icons/faSquareUpRight";
import { definition as GB1 } from "@fortawesome/free-solid-svg-icons/faSquareUpRight";
import { definition as fni } from "@fortawesome/free-solid-svg-icons/faSquareVirus";
import { definition as EB1 } from "@fortawesome/free-solid-svg-icons/faSquareVirus";
import { definition as cni } from "@fortawesome/free-solid-svg-icons/faSquareXmark";
import { definition as IB1 } from "@fortawesome/free-solid-svg-icons/faSquareXmark";
import { definition as tni } from "@fortawesome/free-solid-svg-icons/faStaffAesculapius";
import { definition as XB1 } from "@fortawesome/free-solid-svg-icons/faStaffAesculapius";
import { definition as oni } from "@fortawesome/free-solid-svg-icons/faStaffSnake";
import { definition as JB1 } from "@fortawesome/free-solid-svg-icons/faStaffSnake";
import { definition as lni } from "@fortawesome/free-solid-svg-icons/faStairs";
import { definition as ZB1 } from "@fortawesome/free-solid-svg-icons/faStairs";
import { definition as dni } from "@fortawesome/free-solid-svg-icons/faStamp";
import { definition as xB1 } from "@fortawesome/free-solid-svg-icons/faStamp";
import { definition as rni } from "@fortawesome/free-solid-svg-icons/faStapler";
import { definition as aT1 } from "@fortawesome/free-solid-svg-icons/faStapler";
import { definition as sni } from "@fortawesome/free-solid-svg-icons/faStar";
import { definition as nT1 } from "@fortawesome/free-solid-svg-icons/faStar";
import { definition as hni } from "@fortawesome/free-solid-svg-icons/faStarAndCrescent";
import { definition as cT1 } from "@fortawesome/free-solid-svg-icons/faStarAndCrescent";
import { definition as vni } from "@fortawesome/free-solid-svg-icons/faStarHalf";
import { definition as oT1 } from "@fortawesome/free-solid-svg-icons/faStarHalf";
import { definition as uni } from "@fortawesome/free-solid-svg-icons/faStarHalfAlt";
import { definition as dT1 } from "@fortawesome/free-solid-svg-icons/faStarHalfAlt";
import { definition as mni } from "@fortawesome/free-solid-svg-icons/faStarHalfStroke";
import { definition as sT1 } from "@fortawesome/free-solid-svg-icons/faStarHalfStroke";
import { definition as gni } from "@fortawesome/free-solid-svg-icons/faStarOfDavid";
import { definition as vT1 } from "@fortawesome/free-solid-svg-icons/faStarOfDavid";
import { definition as Pni } from "@fortawesome/free-solid-svg-icons/faStarOfLife";
import { definition as mT1 } from "@fortawesome/free-solid-svg-icons/faStarOfLife";
import { definition as Mni } from "@fortawesome/free-solid-svg-icons/faStepBackward";
import { definition as PT1 } from "@fortawesome/free-solid-svg-icons/faStepBackward";
import { definition as wni } from "@fortawesome/free-solid-svg-icons/faStepForward";
import { definition as wT1 } from "@fortawesome/free-solid-svg-icons/faStepForward";
import { definition as Nni } from "@fortawesome/free-solid-svg-icons/faSterlingSign";
import { definition as zT1 } from "@fortawesome/free-solid-svg-icons/faSterlingSign";
import { definition as zni } from "@fortawesome/free-solid-svg-icons/faStethoscope";
import { definition as CT1 } from "@fortawesome/free-solid-svg-icons/faStethoscope";
import { definition as Lni } from "@fortawesome/free-solid-svg-icons/faStickyNote";
import { definition as $T1 } from "@fortawesome/free-solid-svg-icons/faStickyNote";
import { definition as Cni } from "@fortawesome/free-solid-svg-icons/faStop";
import { definition as bT1 } from "@fortawesome/free-solid-svg-icons/faStop";
import { definition as Dni } from "@fortawesome/free-solid-svg-icons/faStopCircle";
import { definition as yT1 } from "@fortawesome/free-solid-svg-icons/faStopCircle";
import { definition as $ni } from "@fortawesome/free-solid-svg-icons/faStopwatch";
import { definition as kT1 } from "@fortawesome/free-solid-svg-icons/faStopwatch";
import { definition as _ni } from "@fortawesome/free-solid-svg-icons/faStopwatch20";
import { definition as jT1 } from "@fortawesome/free-solid-svg-icons/faStopwatch20";
import { definition as bni } from "@fortawesome/free-solid-svg-icons/faStore";
import { definition as TT1 } from "@fortawesome/free-solid-svg-icons/faStore";
import { definition as Sni } from "@fortawesome/free-solid-svg-icons/faStoreAlt";
import { definition as HT1 } from "@fortawesome/free-solid-svg-icons/faStoreAlt";
import { definition as yni } from "@fortawesome/free-solid-svg-icons/faStoreAltSlash";
import { definition as UT1 } from "@fortawesome/free-solid-svg-icons/faStoreAltSlash";
import { definition as Oni } from "@fortawesome/free-solid-svg-icons/faStoreSlash";
import { definition as GT1 } from "@fortawesome/free-solid-svg-icons/faStoreSlash";
import { definition as kni } from "@fortawesome/free-solid-svg-icons/faStream";
import { definition as ET1 } from "@fortawesome/free-solid-svg-icons/faStream";
import { definition as Ani } from "@fortawesome/free-solid-svg-icons/faStreetView";
import { definition as IT1 } from "@fortawesome/free-solid-svg-icons/faStreetView";
import { definition as jni } from "@fortawesome/free-solid-svg-icons/faStrikethrough";
import { definition as XT1 } from "@fortawesome/free-solid-svg-icons/faStrikethrough";
import { definition as Bni } from "@fortawesome/free-solid-svg-icons/faStroopwafel";
import { definition as JT1 } from "@fortawesome/free-solid-svg-icons/faStroopwafel";
import { definition as Tni } from "@fortawesome/free-solid-svg-icons/faSubscript";
import { definition as ZT1 } from "@fortawesome/free-solid-svg-icons/faSubscript";
import { definition as Fni } from "@fortawesome/free-solid-svg-icons/faSubtract";
import { definition as xT1 } from "@fortawesome/free-solid-svg-icons/faSubtract";
import { definition as Hni } from "@fortawesome/free-solid-svg-icons/faSubway";
import { definition as aF1 } from "@fortawesome/free-solid-svg-icons/faSubway";
import { definition as Rni } from "@fortawesome/free-solid-svg-icons/faSuitcase";
import { definition as nF1 } from "@fortawesome/free-solid-svg-icons/faSuitcase";
import { definition as Uni } from "@fortawesome/free-solid-svg-icons/faSuitcaseMedical";
import { definition as cF1 } from "@fortawesome/free-solid-svg-icons/faSuitcaseMedical";
import { definition as qni } from "@fortawesome/free-solid-svg-icons/faSuitcaseRolling";
import { definition as oF1 } from "@fortawesome/free-solid-svg-icons/faSuitcaseRolling";
import { definition as Gni } from "@fortawesome/free-solid-svg-icons/faSun";
import { definition as dF1 } from "@fortawesome/free-solid-svg-icons/faSun";
import { definition as Wni } from "@fortawesome/free-solid-svg-icons/faSunPlantWilt";
import { definition as sF1 } from "@fortawesome/free-solid-svg-icons/faSunPlantWilt";
import { definition as Eni } from "@fortawesome/free-solid-svg-icons/faSuperscript";
import { definition as vF1 } from "@fortawesome/free-solid-svg-icons/faSuperscript";
import { definition as Vni } from "@fortawesome/free-solid-svg-icons/faSurprise";
import { definition as mF1 } from "@fortawesome/free-solid-svg-icons/faSurprise";
import { definition as Ini } from "@fortawesome/free-solid-svg-icons/faSwatchbook";
import { definition as PF1 } from "@fortawesome/free-solid-svg-icons/faSwatchbook";
import { definition as Kni } from "@fortawesome/free-solid-svg-icons/faSwimmer";
import { definition as wF1 } from "@fortawesome/free-solid-svg-icons/faSwimmer";
import { definition as Xni } from "@fortawesome/free-solid-svg-icons/faSwimmingPool";
import { definition as zF1 } from "@fortawesome/free-solid-svg-icons/faSwimmingPool";
import { definition as Qni } from "@fortawesome/free-solid-svg-icons/faSynagogue";
import { definition as CF1 } from "@fortawesome/free-solid-svg-icons/faSynagogue";
import { definition as Jni } from "@fortawesome/free-solid-svg-icons/faSync";
import { definition as $F1 } from "@fortawesome/free-solid-svg-icons/faSync";
import { definition as Yni } from "@fortawesome/free-solid-svg-icons/faSyncAlt";
import { definition as bF1 } from "@fortawesome/free-solid-svg-icons/faSyncAlt";
import { definition as Zni } from "@fortawesome/free-solid-svg-icons/faSyringe";
import { definition as yF1 } from "@fortawesome/free-solid-svg-icons/faSyringe";
import { definition as pni } from "@fortawesome/free-solid-svg-icons/faT";
import { definition as kF1 } from "@fortawesome/free-solid-svg-icons/faT";
import { definition as xni } from "@fortawesome/free-solid-svg-icons/faTShirt";
import { definition as jF1 } from "@fortawesome/free-solid-svg-icons/faTShirt";
import { definition as i6i } from "@fortawesome/free-solid-svg-icons/faTable";
import { definition as TF1 } from "@fortawesome/free-solid-svg-icons/faTable";
import { definition as a6i } from "@fortawesome/free-solid-svg-icons/faTableCells";
import { definition as HF1 } from "@fortawesome/free-solid-svg-icons/faTableCells";
import { definition as e6i } from "@fortawesome/free-solid-svg-icons/faTableCellsColumnLock";
import { definition as UF1 } from "@fortawesome/free-solid-svg-icons/faTableCellsColumnLock";
import { definition as n6i } from "@fortawesome/free-solid-svg-icons/faTableCellsLarge";
import { definition as GF1 } from "@fortawesome/free-solid-svg-icons/faTableCellsLarge";
import { definition as f6i } from "@fortawesome/free-solid-svg-icons/faTableCellsRowLock";
import { definition as EF1 } from "@fortawesome/free-solid-svg-icons/faTableCellsRowLock";
import { definition as c6i } from "@fortawesome/free-solid-svg-icons/faTableCellsRowUnlock";
import { definition as IF1 } from "@fortawesome/free-solid-svg-icons/faTableCellsRowUnlock";
import { definition as t6i } from "@fortawesome/free-solid-svg-icons/faTableColumns";
import { definition as XF1 } from "@fortawesome/free-solid-svg-icons/faTableColumns";
import { definition as o6i } from "@fortawesome/free-solid-svg-icons/faTableList";
import { definition as JF1 } from "@fortawesome/free-solid-svg-icons/faTableList";
import { definition as l6i } from "@fortawesome/free-solid-svg-icons/faTableTennis";
import { definition as ZF1 } from "@fortawesome/free-solid-svg-icons/faTableTennis";
import { definition as d6i } from "@fortawesome/free-solid-svg-icons/faTableTennisPaddleBall";
import { definition as xF1 } from "@fortawesome/free-solid-svg-icons/faTableTennisPaddleBall";
import { definition as r6i } from "@fortawesome/free-solid-svg-icons/faTablet";
import { definition as aH1 } from "@fortawesome/free-solid-svg-icons/faTablet";
import { definition as s6i } from "@fortawesome/free-solid-svg-icons/faTabletAlt";
import { definition as nH1 } from "@fortawesome/free-solid-svg-icons/faTabletAlt";
import { definition as h6i } from "@fortawesome/free-solid-svg-icons/faTabletAndroid";
import { definition as cH1 } from "@fortawesome/free-solid-svg-icons/faTabletAndroid";
import { definition as v6i } from "@fortawesome/free-solid-svg-icons/faTabletButton";
import { definition as oH1 } from "@fortawesome/free-solid-svg-icons/faTabletButton";
import { definition as u6i } from "@fortawesome/free-solid-svg-icons/faTabletScreenButton";
import { definition as dH1 } from "@fortawesome/free-solid-svg-icons/faTabletScreenButton";
import { definition as m6i } from "@fortawesome/free-solid-svg-icons/faTablets";
import { definition as sH1 } from "@fortawesome/free-solid-svg-icons/faTablets";
import { definition as g6i } from "@fortawesome/free-solid-svg-icons/faTachographDigital";
import { definition as vH1 } from "@fortawesome/free-solid-svg-icons/faTachographDigital";
import { definition as P6i } from "@fortawesome/free-solid-svg-icons/faTachometer";
import { definition as mH1 } from "@fortawesome/free-solid-svg-icons/faTachometer";
import { definition as M6i } from "@fortawesome/free-solid-svg-icons/faTachometerAlt";
import { definition as PH1 } from "@fortawesome/free-solid-svg-icons/faTachometerAlt";
import { definition as w6i } from "@fortawesome/free-solid-svg-icons/faTachometerAltAverage";
import { definition as wH1 } from "@fortawesome/free-solid-svg-icons/faTachometerAltAverage";
import { definition as N6i } from "@fortawesome/free-solid-svg-icons/faTachometerAltFast";
import { definition as zH1 } from "@fortawesome/free-solid-svg-icons/faTachometerAltFast";
import { definition as z6i } from "@fortawesome/free-solid-svg-icons/faTachometerAverage";
import { definition as CH1 } from "@fortawesome/free-solid-svg-icons/faTachometerAverage";
import { definition as L6i } from "@fortawesome/free-solid-svg-icons/faTachometerFast";
import { definition as $H1 } from "@fortawesome/free-solid-svg-icons/faTachometerFast";
import { definition as C6i } from "@fortawesome/free-solid-svg-icons/faTag";
import { definition as bH1 } from "@fortawesome/free-solid-svg-icons/faTag";
import { definition as D6i } from "@fortawesome/free-solid-svg-icons/faTags";
import { definition as yH1 } from "@fortawesome/free-solid-svg-icons/faTags";
import { definition as $6i } from "@fortawesome/free-solid-svg-icons/faTanakh";
import { definition as kH1 } from "@fortawesome/free-solid-svg-icons/faTanakh";
import { definition as _6i } from "@fortawesome/free-solid-svg-icons/faTape";
import { definition as jH1 } from "@fortawesome/free-solid-svg-icons/faTape";
import { definition as b6i } from "@fortawesome/free-solid-svg-icons/faTarp";
import { definition as TH1 } from "@fortawesome/free-solid-svg-icons/faTarp";
import { definition as S6i } from "@fortawesome/free-solid-svg-icons/faTarpDroplet";
import { definition as HH1 } from "@fortawesome/free-solid-svg-icons/faTarpDroplet";
import { definition as y6i } from "@fortawesome/free-solid-svg-icons/faTasks";
import { definition as UH1 } from "@fortawesome/free-solid-svg-icons/faTasks";
import { definition as O6i } from "@fortawesome/free-solid-svg-icons/faTasksAlt";
import { definition as GH1 } from "@fortawesome/free-solid-svg-icons/faTasksAlt";
import { definition as k6i } from "@fortawesome/free-solid-svg-icons/faTaxi";
import { definition as EH1 } from "@fortawesome/free-solid-svg-icons/faTaxi";
import { definition as A6i } from "@fortawesome/free-solid-svg-icons/faTeeth";
import { definition as IH1 } from "@fortawesome/free-solid-svg-icons/faTeeth";
import { definition as j6i } from "@fortawesome/free-solid-svg-icons/faTeethOpen";
import { definition as XH1 } from "@fortawesome/free-solid-svg-icons/faTeethOpen";
import { definition as B6i } from "@fortawesome/free-solid-svg-icons/faTeletype";
import { definition as JH1 } from "@fortawesome/free-solid-svg-icons/faTeletype";
import { definition as T6i } from "@fortawesome/free-solid-svg-icons/faTelevision";
import { definition as ZH1 } from "@fortawesome/free-solid-svg-icons/faTelevision";
import { definition as F6i } from "@fortawesome/free-solid-svg-icons/faTemperature0";
import { definition as xH1 } from "@fortawesome/free-solid-svg-icons/faTemperature0";
import { definition as H6i } from "@fortawesome/free-solid-svg-icons/faTemperature1";
import { definition as aR1 } from "@fortawesome/free-solid-svg-icons/faTemperature1";
import { definition as R6i } from "@fortawesome/free-solid-svg-icons/faTemperature2";
import { definition as nR1 } from "@fortawesome/free-solid-svg-icons/faTemperature2";
import { definition as U6i } from "@fortawesome/free-solid-svg-icons/faTemperature3";
import { definition as cR1 } from "@fortawesome/free-solid-svg-icons/faTemperature3";
import { definition as q6i } from "@fortawesome/free-solid-svg-icons/faTemperature4";
import { definition as oR1 } from "@fortawesome/free-solid-svg-icons/faTemperature4";
import { definition as G6i } from "@fortawesome/free-solid-svg-icons/faTemperatureArrowDown";
import { definition as dR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureArrowDown";
import { definition as W6i } from "@fortawesome/free-solid-svg-icons/faTemperatureArrowUp";
import { definition as sR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureArrowUp";
import { definition as E6i } from "@fortawesome/free-solid-svg-icons/faTemperatureDown";
import { definition as vR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureDown";
import { definition as V6i } from "@fortawesome/free-solid-svg-icons/faTemperatureEmpty";
import { definition as mR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureEmpty";
import { definition as I6i } from "@fortawesome/free-solid-svg-icons/faTemperatureFull";
import { definition as PR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureFull";
import { definition as K6i } from "@fortawesome/free-solid-svg-icons/faTemperatureHalf";
import { definition as wR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureHalf";
import { definition as X6i } from "@fortawesome/free-solid-svg-icons/faTemperatureHigh";
import { definition as zR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureHigh";
import { definition as Q6i } from "@fortawesome/free-solid-svg-icons/faTemperatureLow";
import { definition as CR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureLow";
import { definition as J6i } from "@fortawesome/free-solid-svg-icons/faTemperatureQuarter";
import { definition as $R1 } from "@fortawesome/free-solid-svg-icons/faTemperatureQuarter";
import { definition as Y6i } from "@fortawesome/free-solid-svg-icons/faTemperatureThreeQuarters";
import { definition as bR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureThreeQuarters";
import { definition as Z6i } from "@fortawesome/free-solid-svg-icons/faTemperatureUp";
import { definition as yR1 } from "@fortawesome/free-solid-svg-icons/faTemperatureUp";
import { definition as p6i } from "@fortawesome/free-solid-svg-icons/faTenge";
import { definition as kR1 } from "@fortawesome/free-solid-svg-icons/faTenge";
import { definition as x6i } from "@fortawesome/free-solid-svg-icons/faTengeSign";
import { definition as jR1 } from "@fortawesome/free-solid-svg-icons/faTengeSign";
import { definition as ifi } from "@fortawesome/free-solid-svg-icons/faTent";
import { definition as TR1 } from "@fortawesome/free-solid-svg-icons/faTent";
import { definition as afi } from "@fortawesome/free-solid-svg-icons/faTentArrowDownToLine";
import { definition as HR1 } from "@fortawesome/free-solid-svg-icons/faTentArrowDownToLine";
import { definition as efi } from "@fortawesome/free-solid-svg-icons/faTentArrowLeftRight";
import { definition as UR1 } from "@fortawesome/free-solid-svg-icons/faTentArrowLeftRight";
import { definition as nfi } from "@fortawesome/free-solid-svg-icons/faTentArrowTurnLeft";
import { definition as GR1 } from "@fortawesome/free-solid-svg-icons/faTentArrowTurnLeft";
import { definition as ffi } from "@fortawesome/free-solid-svg-icons/faTentArrowsDown";
import { definition as ER1 } from "@fortawesome/free-solid-svg-icons/faTentArrowsDown";
import { definition as cfi } from "@fortawesome/free-solid-svg-icons/faTents";
import { definition as IR1 } from "@fortawesome/free-solid-svg-icons/faTents";
import { definition as tfi } from "@fortawesome/free-solid-svg-icons/faTerminal";
import { definition as XR1 } from "@fortawesome/free-solid-svg-icons/faTerminal";
import { definition as ofi } from "@fortawesome/free-solid-svg-icons/faTextHeight";
import { definition as JR1 } from "@fortawesome/free-solid-svg-icons/faTextHeight";
import { definition as lfi } from "@fortawesome/free-solid-svg-icons/faTextSlash";
import { definition as ZR1 } from "@fortawesome/free-solid-svg-icons/faTextSlash";
import { definition as dfi } from "@fortawesome/free-solid-svg-icons/faTextWidth";
import { definition as xR1 } from "@fortawesome/free-solid-svg-icons/faTextWidth";
import { definition as rfi } from "@fortawesome/free-solid-svg-icons/faTh";
import { definition as aU1 } from "@fortawesome/free-solid-svg-icons/faTh";
import { definition as sfi } from "@fortawesome/free-solid-svg-icons/faThLarge";
import { definition as nU1 } from "@fortawesome/free-solid-svg-icons/faThLarge";
import { definition as hfi } from "@fortawesome/free-solid-svg-icons/faThList";
import { definition as cU1 } from "@fortawesome/free-solid-svg-icons/faThList";
import { definition as vfi } from "@fortawesome/free-solid-svg-icons/faTheaterMasks";
import { definition as oU1 } from "@fortawesome/free-solid-svg-icons/faTheaterMasks";
import { definition as ufi } from "@fortawesome/free-solid-svg-icons/faThermometer";
import { definition as dU1 } from "@fortawesome/free-solid-svg-icons/faThermometer";
import { definition as mfi } from "@fortawesome/free-solid-svg-icons/faThermometer0";
import { definition as sU1 } from "@fortawesome/free-solid-svg-icons/faThermometer0";
import { definition as gfi } from "@fortawesome/free-solid-svg-icons/faThermometer1";
import { definition as vU1 } from "@fortawesome/free-solid-svg-icons/faThermometer1";
import { definition as Pfi } from "@fortawesome/free-solid-svg-icons/faThermometer2";
import { definition as mU1 } from "@fortawesome/free-solid-svg-icons/faThermometer2";
import { definition as Mfi } from "@fortawesome/free-solid-svg-icons/faThermometer3";
import { definition as PU1 } from "@fortawesome/free-solid-svg-icons/faThermometer3";
import { definition as wfi } from "@fortawesome/free-solid-svg-icons/faThermometer4";
import { definition as wU1 } from "@fortawesome/free-solid-svg-icons/faThermometer4";
import { definition as Nfi } from "@fortawesome/free-solid-svg-icons/faThermometerEmpty";
import { definition as zU1 } from "@fortawesome/free-solid-svg-icons/faThermometerEmpty";
import { definition as zfi } from "@fortawesome/free-solid-svg-icons/faThermometerFull";
import { definition as CU1 } from "@fortawesome/free-solid-svg-icons/faThermometerFull";
import { definition as Lfi } from "@fortawesome/free-solid-svg-icons/faThermometerHalf";
import { definition as $U1 } from "@fortawesome/free-solid-svg-icons/faThermometerHalf";
import { definition as Cfi } from "@fortawesome/free-solid-svg-icons/faThermometerQuarter";
import { definition as bU1 } from "@fortawesome/free-solid-svg-icons/faThermometerQuarter";
import { definition as Dfi } from "@fortawesome/free-solid-svg-icons/faThermometerThreeQuarters";
import { definition as yU1 } from "@fortawesome/free-solid-svg-icons/faThermometerThreeQuarters";
import { definition as $fi } from "@fortawesome/free-solid-svg-icons/faThumbsDown";
import { definition as kU1 } from "@fortawesome/free-solid-svg-icons/faThumbsDown";
import { definition as _fi } from "@fortawesome/free-solid-svg-icons/faThumbsUp";
import { definition as jU1 } from "@fortawesome/free-solid-svg-icons/faThumbsUp";
import { definition as bfi } from "@fortawesome/free-solid-svg-icons/faThumbtack";
import { definition as TU1 } from "@fortawesome/free-solid-svg-icons/faThumbtack";
import { definition as Sfi } from "@fortawesome/free-solid-svg-icons/faThumbtackSlash";
import { definition as HU1 } from "@fortawesome/free-solid-svg-icons/faThumbtackSlash";
import { definition as yfi } from "@fortawesome/free-solid-svg-icons/faThunderstorm";
import { definition as UU1 } from "@fortawesome/free-solid-svg-icons/faThunderstorm";
import { definition as Ofi } from "@fortawesome/free-solid-svg-icons/faTicket";
import { definition as GU1 } from "@fortawesome/free-solid-svg-icons/faTicket";
import { definition as kfi } from "@fortawesome/free-solid-svg-icons/faTicketAlt";
import { definition as EU1 } from "@fortawesome/free-solid-svg-icons/faTicketAlt";
import { definition as Afi } from "@fortawesome/free-solid-svg-icons/faTicketSimple";
import { definition as IU1 } from "@fortawesome/free-solid-svg-icons/faTicketSimple";
import { definition as jfi } from "@fortawesome/free-solid-svg-icons/faTimeline";
import { definition as XU1 } from "@fortawesome/free-solid-svg-icons/faTimeline";
import { definition as Bfi } from "@fortawesome/free-solid-svg-icons/faTimes";
import { definition as JU1 } from "@fortawesome/free-solid-svg-icons/faTimes";
import { definition as Tfi } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { definition as ZU1 } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { definition as Ffi } from "@fortawesome/free-solid-svg-icons/faTimesRectangle";
import { definition as xU1 } from "@fortawesome/free-solid-svg-icons/faTimesRectangle";
import { definition as Hfi } from "@fortawesome/free-solid-svg-icons/faTimesSquare";
import { definition as aq1 } from "@fortawesome/free-solid-svg-icons/faTimesSquare";
import { definition as Rfi } from "@fortawesome/free-solid-svg-icons/faTint";
import { definition as nq1 } from "@fortawesome/free-solid-svg-icons/faTint";
import { definition as Ufi } from "@fortawesome/free-solid-svg-icons/faTintSlash";
import { definition as cq1 } from "@fortawesome/free-solid-svg-icons/faTintSlash";
import { definition as qfi } from "@fortawesome/free-solid-svg-icons/faTired";
import { definition as oq1 } from "@fortawesome/free-solid-svg-icons/faTired";
import { definition as Gfi } from "@fortawesome/free-solid-svg-icons/faToggleOff";
import { definition as dq1 } from "@fortawesome/free-solid-svg-icons/faToggleOff";
import { definition as Wfi } from "@fortawesome/free-solid-svg-icons/faToggleOn";
import { definition as sq1 } from "@fortawesome/free-solid-svg-icons/faToggleOn";
import { definition as Efi } from "@fortawesome/free-solid-svg-icons/faToilet";
import { definition as vq1 } from "@fortawesome/free-solid-svg-icons/faToilet";
import { definition as Vfi } from "@fortawesome/free-solid-svg-icons/faToiletPaper";
import { definition as mq1 } from "@fortawesome/free-solid-svg-icons/faToiletPaper";
import { definition as Ifi } from "@fortawesome/free-solid-svg-icons/faToiletPaperSlash";
import { definition as Pq1 } from "@fortawesome/free-solid-svg-icons/faToiletPaperSlash";
import { definition as Kfi } from "@fortawesome/free-solid-svg-icons/faToiletPortable";
import { definition as wq1 } from "@fortawesome/free-solid-svg-icons/faToiletPortable";
import { definition as Xfi } from "@fortawesome/free-solid-svg-icons/faToiletsPortable";
import { definition as zq1 } from "@fortawesome/free-solid-svg-icons/faToiletsPortable";
import { definition as Qfi } from "@fortawesome/free-solid-svg-icons/faToolbox";
import { definition as Cq1 } from "@fortawesome/free-solid-svg-icons/faToolbox";
import { definition as Jfi } from "@fortawesome/free-solid-svg-icons/faTools";
import { definition as $q1 } from "@fortawesome/free-solid-svg-icons/faTools";
import { definition as Yfi } from "@fortawesome/free-solid-svg-icons/faTooth";
import { definition as bq1 } from "@fortawesome/free-solid-svg-icons/faTooth";
import { definition as Zfi } from "@fortawesome/free-solid-svg-icons/faTorah";
import { definition as yq1 } from "@fortawesome/free-solid-svg-icons/faTorah";
import { definition as pfi } from "@fortawesome/free-solid-svg-icons/faToriiGate";
import { definition as kq1 } from "@fortawesome/free-solid-svg-icons/faToriiGate";
import { definition as xfi } from "@fortawesome/free-solid-svg-icons/faTornado";
import { definition as jq1 } from "@fortawesome/free-solid-svg-icons/faTornado";
import { definition as ici } from "@fortawesome/free-solid-svg-icons/faTowerBroadcast";
import { definition as Tq1 } from "@fortawesome/free-solid-svg-icons/faTowerBroadcast";
import { definition as aci } from "@fortawesome/free-solid-svg-icons/faTowerCell";
import { definition as Hq1 } from "@fortawesome/free-solid-svg-icons/faTowerCell";
import { definition as eci } from "@fortawesome/free-solid-svg-icons/faTowerObservation";
import { definition as Uq1 } from "@fortawesome/free-solid-svg-icons/faTowerObservation";
import { definition as nci } from "@fortawesome/free-solid-svg-icons/faTractor";
import { definition as Gq1 } from "@fortawesome/free-solid-svg-icons/faTractor";
import { definition as fci } from "@fortawesome/free-solid-svg-icons/faTrademark";
import { definition as Eq1 } from "@fortawesome/free-solid-svg-icons/faTrademark";
import { definition as cci } from "@fortawesome/free-solid-svg-icons/faTrafficLight";
import { definition as Iq1 } from "@fortawesome/free-solid-svg-icons/faTrafficLight";
import { definition as tci } from "@fortawesome/free-solid-svg-icons/faTrailer";
import { definition as Xq1 } from "@fortawesome/free-solid-svg-icons/faTrailer";
import { definition as oci } from "@fortawesome/free-solid-svg-icons/faTrain";
import { definition as Jq1 } from "@fortawesome/free-solid-svg-icons/faTrain";
import { definition as lci } from "@fortawesome/free-solid-svg-icons/faTrainSubway";
import { definition as Zq1 } from "@fortawesome/free-solid-svg-icons/faTrainSubway";
import { definition as dci } from "@fortawesome/free-solid-svg-icons/faTrainTram";
import { definition as xq1 } from "@fortawesome/free-solid-svg-icons/faTrainTram";
import { definition as rci } from "@fortawesome/free-solid-svg-icons/faTram";
import { definition as aG1 } from "@fortawesome/free-solid-svg-icons/faTram";
import { definition as sci } from "@fortawesome/free-solid-svg-icons/faTransgender";
import { definition as nG1 } from "@fortawesome/free-solid-svg-icons/faTransgender";
import { definition as hci } from "@fortawesome/free-solid-svg-icons/faTransgenderAlt";
import { definition as cG1 } from "@fortawesome/free-solid-svg-icons/faTransgenderAlt";
import { definition as vci } from "@fortawesome/free-solid-svg-icons/faTrash";
import { definition as oG1 } from "@fortawesome/free-solid-svg-icons/faTrash";
import { definition as uci } from "@fortawesome/free-solid-svg-icons/faTrashAlt";
import { definition as dG1 } from "@fortawesome/free-solid-svg-icons/faTrashAlt";
import { definition as mci } from "@fortawesome/free-solid-svg-icons/faTrashArrowUp";
import { definition as sG1 } from "@fortawesome/free-solid-svg-icons/faTrashArrowUp";
import { definition as gci } from "@fortawesome/free-solid-svg-icons/faTrashCan";
import { definition as vG1 } from "@fortawesome/free-solid-svg-icons/faTrashCan";
import { definition as Pci } from "@fortawesome/free-solid-svg-icons/faTrashCanArrowUp";
import { definition as mG1 } from "@fortawesome/free-solid-svg-icons/faTrashCanArrowUp";
import { definition as Mci } from "@fortawesome/free-solid-svg-icons/faTrashRestore";
import { definition as PG1 } from "@fortawesome/free-solid-svg-icons/faTrashRestore";
import { definition as wci } from "@fortawesome/free-solid-svg-icons/faTrashRestoreAlt";
import { definition as wG1 } from "@fortawesome/free-solid-svg-icons/faTrashRestoreAlt";
import { definition as Nci } from "@fortawesome/free-solid-svg-icons/faTree";
import { definition as zG1 } from "@fortawesome/free-solid-svg-icons/faTree";
import { definition as zci } from "@fortawesome/free-solid-svg-icons/faTreeCity";
import { definition as CG1 } from "@fortawesome/free-solid-svg-icons/faTreeCity";
import { definition as Lci } from "@fortawesome/free-solid-svg-icons/faTriangleCircleSquare";
import { definition as $G1 } from "@fortawesome/free-solid-svg-icons/faTriangleCircleSquare";
import { definition as Cci } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";
import { definition as bG1 } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";
import { definition as Dci } from "@fortawesome/free-solid-svg-icons/faTrophy";
import { definition as yG1 } from "@fortawesome/free-solid-svg-icons/faTrophy";
import { definition as $ci } from "@fortawesome/free-solid-svg-icons/faTrowel";
import { definition as kG1 } from "@fortawesome/free-solid-svg-icons/faTrowel";
import { definition as _ci } from "@fortawesome/free-solid-svg-icons/faTrowelBricks";
import { definition as jG1 } from "@fortawesome/free-solid-svg-icons/faTrowelBricks";
import { definition as bci } from "@fortawesome/free-solid-svg-icons/faTruck";
import { definition as TG1 } from "@fortawesome/free-solid-svg-icons/faTruck";
import { definition as Sci } from "@fortawesome/free-solid-svg-icons/faTruckArrowRight";
import { definition as HG1 } from "@fortawesome/free-solid-svg-icons/faTruckArrowRight";
import { definition as yci } from "@fortawesome/free-solid-svg-icons/faTruckDroplet";
import { definition as UG1 } from "@fortawesome/free-solid-svg-icons/faTruckDroplet";
import { definition as Oci } from "@fortawesome/free-solid-svg-icons/faTruckFast";
import { definition as GG1 } from "@fortawesome/free-solid-svg-icons/faTruckFast";
import { definition as kci } from "@fortawesome/free-solid-svg-icons/faTruckField";
import { definition as EG1 } from "@fortawesome/free-solid-svg-icons/faTruckField";
import { definition as Aci } from "@fortawesome/free-solid-svg-icons/faTruckFieldUn";
import { definition as IG1 } from "@fortawesome/free-solid-svg-icons/faTruckFieldUn";
import { definition as jci } from "@fortawesome/free-solid-svg-icons/faTruckFront";
import { definition as XG1 } from "@fortawesome/free-solid-svg-icons/faTruckFront";
import { definition as Bci } from "@fortawesome/free-solid-svg-icons/faTruckLoading";
import { definition as JG1 } from "@fortawesome/free-solid-svg-icons/faTruckLoading";
import { definition as Tci } from "@fortawesome/free-solid-svg-icons/faTruckMedical";
import { definition as ZG1 } from "@fortawesome/free-solid-svg-icons/faTruckMedical";
import { definition as Fci } from "@fortawesome/free-solid-svg-icons/faTruckMonster";
import { definition as xG1 } from "@fortawesome/free-solid-svg-icons/faTruckMonster";
import { definition as Hci } from "@fortawesome/free-solid-svg-icons/faTruckMoving";
import { definition as aW1 } from "@fortawesome/free-solid-svg-icons/faTruckMoving";
import { definition as Rci } from "@fortawesome/free-solid-svg-icons/faTruckPickup";
import { definition as nW1 } from "@fortawesome/free-solid-svg-icons/faTruckPickup";
import { definition as Uci } from "@fortawesome/free-solid-svg-icons/faTruckPlane";
import { definition as cW1 } from "@fortawesome/free-solid-svg-icons/faTruckPlane";
import { definition as qci } from "@fortawesome/free-solid-svg-icons/faTruckRampBox";
import { definition as oW1 } from "@fortawesome/free-solid-svg-icons/faTruckRampBox";
import { definition as Gci } from "@fortawesome/free-solid-svg-icons/faTry";
import { definition as dW1 } from "@fortawesome/free-solid-svg-icons/faTry";
import { definition as Wci } from "@fortawesome/free-solid-svg-icons/faTty";
import { definition as sW1 } from "@fortawesome/free-solid-svg-icons/faTty";
import { definition as Eci } from "@fortawesome/free-solid-svg-icons/faTurkishLira";
import { definition as vW1 } from "@fortawesome/free-solid-svg-icons/faTurkishLira";
import { definition as Vci } from "@fortawesome/free-solid-svg-icons/faTurkishLiraSign";
import { definition as mW1 } from "@fortawesome/free-solid-svg-icons/faTurkishLiraSign";
import { definition as Ici } from "@fortawesome/free-solid-svg-icons/faTurnDown";
import { definition as PW1 } from "@fortawesome/free-solid-svg-icons/faTurnDown";
import { definition as Kci } from "@fortawesome/free-solid-svg-icons/faTurnUp";
import { definition as wW1 } from "@fortawesome/free-solid-svg-icons/faTurnUp";
import { definition as Xci } from "@fortawesome/free-solid-svg-icons/faTv";
import { definition as zW1 } from "@fortawesome/free-solid-svg-icons/faTv";
import { definition as Qci } from "@fortawesome/free-solid-svg-icons/faTvAlt";
import { definition as CW1 } from "@fortawesome/free-solid-svg-icons/faTvAlt";
import { definition as Jci } from "@fortawesome/free-solid-svg-icons/faU";
import { definition as $W1 } from "@fortawesome/free-solid-svg-icons/faU";
import { definition as Yci } from "@fortawesome/free-solid-svg-icons/faUmbrella";
import { definition as bW1 } from "@fortawesome/free-solid-svg-icons/faUmbrella";
import { definition as Zci } from "@fortawesome/free-solid-svg-icons/faUmbrellaBeach";
import { definition as yW1 } from "@fortawesome/free-solid-svg-icons/faUmbrellaBeach";
import { definition as pci } from "@fortawesome/free-solid-svg-icons/faUnderline";
import { definition as kW1 } from "@fortawesome/free-solid-svg-icons/faUnderline";
import { definition as xci } from "@fortawesome/free-solid-svg-icons/faUndo";
import { definition as jW1 } from "@fortawesome/free-solid-svg-icons/faUndo";
import { definition as i8i } from "@fortawesome/free-solid-svg-icons/faUndoAlt";
import { definition as TW1 } from "@fortawesome/free-solid-svg-icons/faUndoAlt";
import { definition as a8i } from "@fortawesome/free-solid-svg-icons/faUniversalAccess";
import { definition as HW1 } from "@fortawesome/free-solid-svg-icons/faUniversalAccess";
import { definition as e8i } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { definition as UW1 } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { definition as n8i } from "@fortawesome/free-solid-svg-icons/faUnlink";
import { definition as GW1 } from "@fortawesome/free-solid-svg-icons/faUnlink";
import { definition as f8i } from "@fortawesome/free-solid-svg-icons/faUnlock";
import { definition as EW1 } from "@fortawesome/free-solid-svg-icons/faUnlock";
import { definition as c8i } from "@fortawesome/free-solid-svg-icons/faUnlockAlt";
import { definition as IW1 } from "@fortawesome/free-solid-svg-icons/faUnlockAlt";
import { definition as t8i } from "@fortawesome/free-solid-svg-icons/faUnlockKeyhole";
import { definition as XW1 } from "@fortawesome/free-solid-svg-icons/faUnlockKeyhole";
import { definition as o8i } from "@fortawesome/free-solid-svg-icons/faUnsorted";
import { definition as JW1 } from "@fortawesome/free-solid-svg-icons/faUnsorted";
import { definition as l8i } from "@fortawesome/free-solid-svg-icons/faUpDown";
import { definition as ZW1 } from "@fortawesome/free-solid-svg-icons/faUpDown";
import { definition as d8i } from "@fortawesome/free-solid-svg-icons/faUpDownLeftRight";
import { definition as xW1 } from "@fortawesome/free-solid-svg-icons/faUpDownLeftRight";
import { definition as r8i } from "@fortawesome/free-solid-svg-icons/faUpLong";
import { definition as aE1 } from "@fortawesome/free-solid-svg-icons/faUpLong";
import { definition as s8i } from "@fortawesome/free-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import { definition as nE1 } from "@fortawesome/free-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import { definition as h8i } from "@fortawesome/free-solid-svg-icons/faUpRightFromSquare";
import { definition as cE1 } from "@fortawesome/free-solid-svg-icons/faUpRightFromSquare";
import { definition as v8i } from "@fortawesome/free-solid-svg-icons/faUpload";
import { definition as oE1 } from "@fortawesome/free-solid-svg-icons/faUpload";
import { definition as u8i } from "@fortawesome/free-solid-svg-icons/faUsd";
import { definition as dE1 } from "@fortawesome/free-solid-svg-icons/faUsd";
import { definition as m8i } from "@fortawesome/free-solid-svg-icons/faUser";
import { definition as sE1 } from "@fortawesome/free-solid-svg-icons/faUser";
import { definition as g8i } from "@fortawesome/free-solid-svg-icons/faUserAlt";
import { definition as vE1 } from "@fortawesome/free-solid-svg-icons/faUserAlt";
import { definition as P8i } from "@fortawesome/free-solid-svg-icons/faUserAltSlash";
import { definition as mE1 } from "@fortawesome/free-solid-svg-icons/faUserAltSlash";
import { definition as M8i } from "@fortawesome/free-solid-svg-icons/faUserAstronaut";
import { definition as PE1 } from "@fortawesome/free-solid-svg-icons/faUserAstronaut";
import { definition as w8i } from "@fortawesome/free-solid-svg-icons/faUserCheck";
import { definition as wE1 } from "@fortawesome/free-solid-svg-icons/faUserCheck";
import { definition as N8i } from "@fortawesome/free-solid-svg-icons/faUserCircle";
import { definition as zE1 } from "@fortawesome/free-solid-svg-icons/faUserCircle";
import { definition as z8i } from "@fortawesome/free-solid-svg-icons/faUserClock";
import { definition as CE1 } from "@fortawesome/free-solid-svg-icons/faUserClock";
import { definition as L8i } from "@fortawesome/free-solid-svg-icons/faUserCog";
import { definition as $E1 } from "@fortawesome/free-solid-svg-icons/faUserCog";
import { definition as C8i } from "@fortawesome/free-solid-svg-icons/faUserDoctor";
import { definition as bE1 } from "@fortawesome/free-solid-svg-icons/faUserDoctor";
import { definition as D8i } from "@fortawesome/free-solid-svg-icons/faUserEdit";
import { definition as yE1 } from "@fortawesome/free-solid-svg-icons/faUserEdit";
import { definition as $8i } from "@fortawesome/free-solid-svg-icons/faUserFriends";
import { definition as kE1 } from "@fortawesome/free-solid-svg-icons/faUserFriends";
import { definition as _8i } from "@fortawesome/free-solid-svg-icons/faUserGear";
import { definition as jE1 } from "@fortawesome/free-solid-svg-icons/faUserGear";
import { definition as b8i } from "@fortawesome/free-solid-svg-icons/faUserGraduate";
import { definition as TE1 } from "@fortawesome/free-solid-svg-icons/faUserGraduate";
import { definition as S8i } from "@fortawesome/free-solid-svg-icons/faUserGroup";
import { definition as HE1 } from "@fortawesome/free-solid-svg-icons/faUserGroup";
import { definition as y8i } from "@fortawesome/free-solid-svg-icons/faUserInjured";
import { definition as UE1 } from "@fortawesome/free-solid-svg-icons/faUserInjured";
import { definition as O8i } from "@fortawesome/free-solid-svg-icons/faUserLarge";
import { definition as GE1 } from "@fortawesome/free-solid-svg-icons/faUserLarge";
import { definition as k8i } from "@fortawesome/free-solid-svg-icons/faUserLargeSlash";
import { definition as EE1 } from "@fortawesome/free-solid-svg-icons/faUserLargeSlash";
import { definition as A8i } from "@fortawesome/free-solid-svg-icons/faUserLock";
import { definition as IE1 } from "@fortawesome/free-solid-svg-icons/faUserLock";
import { definition as j8i } from "@fortawesome/free-solid-svg-icons/faUserMd";
import { definition as XE1 } from "@fortawesome/free-solid-svg-icons/faUserMd";
import { definition as B8i } from "@fortawesome/free-solid-svg-icons/faUserMinus";
import { definition as JE1 } from "@fortawesome/free-solid-svg-icons/faUserMinus";
import { definition as T8i } from "@fortawesome/free-solid-svg-icons/faUserNinja";
import { definition as ZE1 } from "@fortawesome/free-solid-svg-icons/faUserNinja";
import { definition as F8i } from "@fortawesome/free-solid-svg-icons/faUserNurse";
import { definition as xE1 } from "@fortawesome/free-solid-svg-icons/faUserNurse";
import { definition as H8i } from "@fortawesome/free-solid-svg-icons/faUserPen";
import { definition as aV1 } from "@fortawesome/free-solid-svg-icons/faUserPen";
import { definition as R8i } from "@fortawesome/free-solid-svg-icons/faUserPlus";
import { definition as nV1 } from "@fortawesome/free-solid-svg-icons/faUserPlus";
import { definition as U8i } from "@fortawesome/free-solid-svg-icons/faUserSecret";
import { definition as cV1 } from "@fortawesome/free-solid-svg-icons/faUserSecret";
import { definition as q8i } from "@fortawesome/free-solid-svg-icons/faUserShield";
import { definition as oV1 } from "@fortawesome/free-solid-svg-icons/faUserShield";
import { definition as G8i } from "@fortawesome/free-solid-svg-icons/faUserSlash";
import { definition as dV1 } from "@fortawesome/free-solid-svg-icons/faUserSlash";
import { definition as W8i } from "@fortawesome/free-solid-svg-icons/faUserTag";
import { definition as sV1 } from "@fortawesome/free-solid-svg-icons/faUserTag";
import { definition as E8i } from "@fortawesome/free-solid-svg-icons/faUserTie";
import { definition as vV1 } from "@fortawesome/free-solid-svg-icons/faUserTie";
import { definition as V8i } from "@fortawesome/free-solid-svg-icons/faUserTimes";
import { definition as mV1 } from "@fortawesome/free-solid-svg-icons/faUserTimes";
import { definition as I8i } from "@fortawesome/free-solid-svg-icons/faUserXmark";
import { definition as PV1 } from "@fortawesome/free-solid-svg-icons/faUserXmark";
import { definition as K8i } from "@fortawesome/free-solid-svg-icons/faUsers";
import { definition as wV1 } from "@fortawesome/free-solid-svg-icons/faUsers";
import { definition as X8i } from "@fortawesome/free-solid-svg-icons/faUsersBetweenLines";
import { definition as zV1 } from "@fortawesome/free-solid-svg-icons/faUsersBetweenLines";
import { definition as Q8i } from "@fortawesome/free-solid-svg-icons/faUsersCog";
import { definition as CV1 } from "@fortawesome/free-solid-svg-icons/faUsersCog";
import { definition as J8i } from "@fortawesome/free-solid-svg-icons/faUsersGear";
import { definition as $V1 } from "@fortawesome/free-solid-svg-icons/faUsersGear";
import { definition as Y8i } from "@fortawesome/free-solid-svg-icons/faUsersLine";
import { definition as bV1 } from "@fortawesome/free-solid-svg-icons/faUsersLine";
import { definition as Z8i } from "@fortawesome/free-solid-svg-icons/faUsersRays";
import { definition as yV1 } from "@fortawesome/free-solid-svg-icons/faUsersRays";
import { definition as p8i } from "@fortawesome/free-solid-svg-icons/faUsersRectangle";
import { definition as kV1 } from "@fortawesome/free-solid-svg-icons/faUsersRectangle";
import { definition as x8i } from "@fortawesome/free-solid-svg-icons/faUsersSlash";
import { definition as jV1 } from "@fortawesome/free-solid-svg-icons/faUsersSlash";
import { definition as i5i } from "@fortawesome/free-solid-svg-icons/faUsersViewfinder";
import { definition as TV1 } from "@fortawesome/free-solid-svg-icons/faUsersViewfinder";
import { definition as a5i } from "@fortawesome/free-solid-svg-icons/faUtensilSpoon";
import { definition as HV1 } from "@fortawesome/free-solid-svg-icons/faUtensilSpoon";
import { definition as e5i } from "@fortawesome/free-solid-svg-icons/faUtensils";
import { definition as UV1 } from "@fortawesome/free-solid-svg-icons/faUtensils";
import { definition as n5i } from "@fortawesome/free-solid-svg-icons/faV";
import { definition as GV1 } from "@fortawesome/free-solid-svg-icons/faV";
import { definition as f5i } from "@fortawesome/free-solid-svg-icons/faVanShuttle";
import { definition as EV1 } from "@fortawesome/free-solid-svg-icons/faVanShuttle";
import { definition as c5i } from "@fortawesome/free-solid-svg-icons/faVault";
import { definition as IV1 } from "@fortawesome/free-solid-svg-icons/faVault";
import { definition as t5i } from "@fortawesome/free-solid-svg-icons/faVcard";
import { definition as XV1 } from "@fortawesome/free-solid-svg-icons/faVcard";
import { definition as o5i } from "@fortawesome/free-solid-svg-icons/faVectorSquare";
import { definition as JV1 } from "@fortawesome/free-solid-svg-icons/faVectorSquare";
import { definition as l5i } from "@fortawesome/free-solid-svg-icons/faVenus";
import { definition as ZV1 } from "@fortawesome/free-solid-svg-icons/faVenus";
import { definition as d5i } from "@fortawesome/free-solid-svg-icons/faVenusDouble";
import { definition as xV1 } from "@fortawesome/free-solid-svg-icons/faVenusDouble";
import { definition as r5i } from "@fortawesome/free-solid-svg-icons/faVenusMars";
import { definition as aI1 } from "@fortawesome/free-solid-svg-icons/faVenusMars";
import { definition as s5i } from "@fortawesome/free-solid-svg-icons/faVest";
import { definition as nI1 } from "@fortawesome/free-solid-svg-icons/faVest";
import { definition as h5i } from "@fortawesome/free-solid-svg-icons/faVestPatches";
import { definition as cI1 } from "@fortawesome/free-solid-svg-icons/faVestPatches";
import { definition as v5i } from "@fortawesome/free-solid-svg-icons/faVial";
import { definition as oI1 } from "@fortawesome/free-solid-svg-icons/faVial";
import { definition as u5i } from "@fortawesome/free-solid-svg-icons/faVialCircleCheck";
import { definition as dI1 } from "@fortawesome/free-solid-svg-icons/faVialCircleCheck";
import { definition as m5i } from "@fortawesome/free-solid-svg-icons/faVialVirus";
import { definition as sI1 } from "@fortawesome/free-solid-svg-icons/faVialVirus";
import { definition as g5i } from "@fortawesome/free-solid-svg-icons/faVials";
import { definition as vI1 } from "@fortawesome/free-solid-svg-icons/faVials";
import { definition as P5i } from "@fortawesome/free-solid-svg-icons/faVideo";
import { definition as mI1 } from "@fortawesome/free-solid-svg-icons/faVideo";
import { definition as M5i } from "@fortawesome/free-solid-svg-icons/faVideoCamera";
import { definition as PI1 } from "@fortawesome/free-solid-svg-icons/faVideoCamera";
import { definition as w5i } from "@fortawesome/free-solid-svg-icons/faVideoSlash";
import { definition as wI1 } from "@fortawesome/free-solid-svg-icons/faVideoSlash";
import { definition as N5i } from "@fortawesome/free-solid-svg-icons/faVihara";
import { definition as zI1 } from "@fortawesome/free-solid-svg-icons/faVihara";
import { definition as z5i } from "@fortawesome/free-solid-svg-icons/faVirus";
import { definition as CI1 } from "@fortawesome/free-solid-svg-icons/faVirus";
import { definition as L5i } from "@fortawesome/free-solid-svg-icons/faVirusCovid";
import { definition as $I1 } from "@fortawesome/free-solid-svg-icons/faVirusCovid";
import { definition as C5i } from "@fortawesome/free-solid-svg-icons/faVirusCovidSlash";
import { definition as bI1 } from "@fortawesome/free-solid-svg-icons/faVirusCovidSlash";
import { definition as D5i } from "@fortawesome/free-solid-svg-icons/faVirusSlash";
import { definition as yI1 } from "@fortawesome/free-solid-svg-icons/faVirusSlash";
import { definition as $5i } from "@fortawesome/free-solid-svg-icons/faViruses";
import { definition as kI1 } from "@fortawesome/free-solid-svg-icons/faViruses";
import { definition as _5i } from "@fortawesome/free-solid-svg-icons/faVoicemail";
import { definition as jI1 } from "@fortawesome/free-solid-svg-icons/faVoicemail";
import { definition as b5i } from "@fortawesome/free-solid-svg-icons/faVolcano";
import { definition as TI1 } from "@fortawesome/free-solid-svg-icons/faVolcano";
import { definition as S5i } from "@fortawesome/free-solid-svg-icons/faVolleyball";
import { definition as HI1 } from "@fortawesome/free-solid-svg-icons/faVolleyball";
import { definition as y5i } from "@fortawesome/free-solid-svg-icons/faVolleyballBall";
import { definition as UI1 } from "@fortawesome/free-solid-svg-icons/faVolleyballBall";
import { definition as O5i } from "@fortawesome/free-solid-svg-icons/faVolumeControlPhone";
import { definition as GI1 } from "@fortawesome/free-solid-svg-icons/faVolumeControlPhone";
import { definition as k5i } from "@fortawesome/free-solid-svg-icons/faVolumeDown";
import { definition as EI1 } from "@fortawesome/free-solid-svg-icons/faVolumeDown";
import { definition as A5i } from "@fortawesome/free-solid-svg-icons/faVolumeHigh";
import { definition as II1 } from "@fortawesome/free-solid-svg-icons/faVolumeHigh";
import { definition as j5i } from "@fortawesome/free-solid-svg-icons/faVolumeLow";
import { definition as XI1 } from "@fortawesome/free-solid-svg-icons/faVolumeLow";
import { definition as B5i } from "@fortawesome/free-solid-svg-icons/faVolumeMute";
import { definition as JI1 } from "@fortawesome/free-solid-svg-icons/faVolumeMute";
import { definition as T5i } from "@fortawesome/free-solid-svg-icons/faVolumeOff";
import { definition as ZI1 } from "@fortawesome/free-solid-svg-icons/faVolumeOff";
import { definition as F5i } from "@fortawesome/free-solid-svg-icons/faVolumeTimes";
import { definition as xI1 } from "@fortawesome/free-solid-svg-icons/faVolumeTimes";
import { definition as H5i } from "@fortawesome/free-solid-svg-icons/faVolumeUp";
import { definition as aK1 } from "@fortawesome/free-solid-svg-icons/faVolumeUp";
import { definition as R5i } from "@fortawesome/free-solid-svg-icons/faVolumeXmark";
import { definition as nK1 } from "@fortawesome/free-solid-svg-icons/faVolumeXmark";
import { definition as U5i } from "@fortawesome/free-solid-svg-icons/faVoteYea";
import { definition as cK1 } from "@fortawesome/free-solid-svg-icons/faVoteYea";
import { definition as q5i } from "@fortawesome/free-solid-svg-icons/faVrCardboard";
import { definition as oK1 } from "@fortawesome/free-solid-svg-icons/faVrCardboard";
import { definition as G5i } from "@fortawesome/free-solid-svg-icons/faW";
import { definition as dK1 } from "@fortawesome/free-solid-svg-icons/faW";
import { definition as W5i } from "@fortawesome/free-solid-svg-icons/faWalkieTalkie";
import { definition as sK1 } from "@fortawesome/free-solid-svg-icons/faWalkieTalkie";
import { definition as E5i } from "@fortawesome/free-solid-svg-icons/faWalking";
import { definition as vK1 } from "@fortawesome/free-solid-svg-icons/faWalking";
import { definition as V5i } from "@fortawesome/free-solid-svg-icons/faWallet";
import { definition as mK1 } from "@fortawesome/free-solid-svg-icons/faWallet";
import { definition as I5i } from "@fortawesome/free-solid-svg-icons/faWandMagic";
import { definition as PK1 } from "@fortawesome/free-solid-svg-icons/faWandMagic";
import { definition as K5i } from "@fortawesome/free-solid-svg-icons/faWandMagicSparkles";
import { definition as wK1 } from "@fortawesome/free-solid-svg-icons/faWandMagicSparkles";
import { definition as X5i } from "@fortawesome/free-solid-svg-icons/faWandSparkles";
import { definition as zK1 } from "@fortawesome/free-solid-svg-icons/faWandSparkles";
import { definition as Q5i } from "@fortawesome/free-solid-svg-icons/faWarehouse";
import { definition as CK1 } from "@fortawesome/free-solid-svg-icons/faWarehouse";
import { definition as J5i } from "@fortawesome/free-solid-svg-icons/faWarning";
import { definition as $K1 } from "@fortawesome/free-solid-svg-icons/faWarning";
import { definition as Y5i } from "@fortawesome/free-solid-svg-icons/faWater";
import { definition as bK1 } from "@fortawesome/free-solid-svg-icons/faWater";
import { definition as Z5i } from "@fortawesome/free-solid-svg-icons/faWaterLadder";
import { definition as yK1 } from "@fortawesome/free-solid-svg-icons/faWaterLadder";
import { definition as p5i } from "@fortawesome/free-solid-svg-icons/faWaveSquare";
import { definition as kK1 } from "@fortawesome/free-solid-svg-icons/faWaveSquare";
import { definition as x5i } from "@fortawesome/free-solid-svg-icons/faWebAwesome";
import { definition as jK1 } from "@fortawesome/free-solid-svg-icons/faWebAwesome";
import { definition as i7i } from "@fortawesome/free-solid-svg-icons/faWeight";
import { definition as TK1 } from "@fortawesome/free-solid-svg-icons/faWeight";
import { definition as a7i } from "@fortawesome/free-solid-svg-icons/faWeightHanging";
import { definition as HK1 } from "@fortawesome/free-solid-svg-icons/faWeightHanging";
import { definition as e7i } from "@fortawesome/free-solid-svg-icons/faWeightScale";
import { definition as UK1 } from "@fortawesome/free-solid-svg-icons/faWeightScale";
import { definition as n7i } from "@fortawesome/free-solid-svg-icons/faWheatAlt";
import { definition as GK1 } from "@fortawesome/free-solid-svg-icons/faWheatAlt";
import { definition as f7i } from "@fortawesome/free-solid-svg-icons/faWheatAwn";
import { definition as EK1 } from "@fortawesome/free-solid-svg-icons/faWheatAwn";
import { definition as c7i } from "@fortawesome/free-solid-svg-icons/faWheatAwnCircleExclamation";
import { definition as IK1 } from "@fortawesome/free-solid-svg-icons/faWheatAwnCircleExclamation";
import { definition as t7i } from "@fortawesome/free-solid-svg-icons/faWheelchair";
import { definition as XK1 } from "@fortawesome/free-solid-svg-icons/faWheelchair";
import { definition as o7i } from "@fortawesome/free-solid-svg-icons/faWheelchairAlt";
import { definition as JK1 } from "@fortawesome/free-solid-svg-icons/faWheelchairAlt";
import { definition as l7i } from "@fortawesome/free-solid-svg-icons/faWheelchairMove";
import { definition as ZK1 } from "@fortawesome/free-solid-svg-icons/faWheelchairMove";
import { definition as d7i } from "@fortawesome/free-solid-svg-icons/faWhiskeyGlass";
import { definition as xK1 } from "@fortawesome/free-solid-svg-icons/faWhiskeyGlass";
import { definition as r7i } from "@fortawesome/free-solid-svg-icons/faWifi";
import { definition as aX1 } from "@fortawesome/free-solid-svg-icons/faWifi";
import { definition as s7i } from "@fortawesome/free-solid-svg-icons/faWifi3";
import { definition as nX1 } from "@fortawesome/free-solid-svg-icons/faWifi3";
import { definition as h7i } from "@fortawesome/free-solid-svg-icons/faWifiStrong";
import { definition as cX1 } from "@fortawesome/free-solid-svg-icons/faWifiStrong";
import { definition as v7i } from "@fortawesome/free-solid-svg-icons/faWind";
import { definition as oX1 } from "@fortawesome/free-solid-svg-icons/faWind";
import { definition as u7i } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { definition as dX1 } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import { definition as m7i } from "@fortawesome/free-solid-svg-icons/faWindowMaximize";
import { definition as sX1 } from "@fortawesome/free-solid-svg-icons/faWindowMaximize";
import { definition as g7i } from "@fortawesome/free-solid-svg-icons/faWindowMinimize";
import { definition as vX1 } from "@fortawesome/free-solid-svg-icons/faWindowMinimize";
import { definition as P7i } from "@fortawesome/free-solid-svg-icons/faWindowRestore";
import { definition as mX1 } from "@fortawesome/free-solid-svg-icons/faWindowRestore";
import { definition as M7i } from "@fortawesome/free-solid-svg-icons/faWineBottle";
import { definition as PX1 } from "@fortawesome/free-solid-svg-icons/faWineBottle";
import { definition as w7i } from "@fortawesome/free-solid-svg-icons/faWineGlass";
import { definition as wX1 } from "@fortawesome/free-solid-svg-icons/faWineGlass";
import { definition as N7i } from "@fortawesome/free-solid-svg-icons/faWineGlassAlt";
import { definition as zX1 } from "@fortawesome/free-solid-svg-icons/faWineGlassAlt";
import { definition as z7i } from "@fortawesome/free-solid-svg-icons/faWineGlassEmpty";
import { definition as CX1 } from "@fortawesome/free-solid-svg-icons/faWineGlassEmpty";
import { definition as L7i } from "@fortawesome/free-solid-svg-icons/faWon";
import { definition as $X1 } from "@fortawesome/free-solid-svg-icons/faWon";
import { definition as C7i } from "@fortawesome/free-solid-svg-icons/faWonSign";
import { definition as bX1 } from "@fortawesome/free-solid-svg-icons/faWonSign";
import { definition as D7i } from "@fortawesome/free-solid-svg-icons/faWorm";
import { definition as yX1 } from "@fortawesome/free-solid-svg-icons/faWorm";
import { definition as $7i } from "@fortawesome/free-solid-svg-icons/faWrench";
import { definition as kX1 } from "@fortawesome/free-solid-svg-icons/faWrench";
import { definition as _7i } from "@fortawesome/free-solid-svg-icons/faX";
import { definition as jX1 } from "@fortawesome/free-solid-svg-icons/faX";
import { definition as b7i } from "@fortawesome/free-solid-svg-icons/faXRay";
import { definition as TX1 } from "@fortawesome/free-solid-svg-icons/faXRay";
import { definition as S7i } from "@fortawesome/free-solid-svg-icons/faXmark";
import { definition as HX1 } from "@fortawesome/free-solid-svg-icons/faXmark";
import { definition as y7i } from "@fortawesome/free-solid-svg-icons/faXmarkCircle";
import { definition as UX1 } from "@fortawesome/free-solid-svg-icons/faXmarkCircle";
import { definition as O7i } from "@fortawesome/free-solid-svg-icons/faXmarkSquare";
import { definition as GX1 } from "@fortawesome/free-solid-svg-icons/faXmarkSquare";
import { definition as k7i } from "@fortawesome/free-solid-svg-icons/faXmarksLines";
import { definition as EX1 } from "@fortawesome/free-solid-svg-icons/faXmarksLines";
import { definition as A7i } from "@fortawesome/free-solid-svg-icons/faY";
import { definition as IX1 } from "@fortawesome/free-solid-svg-icons/faY";
import { definition as j7i } from "@fortawesome/free-solid-svg-icons/faYen";
import { definition as XX1 } from "@fortawesome/free-solid-svg-icons/faYen";
import { definition as B7i } from "@fortawesome/free-solid-svg-icons/faYenSign";
import { definition as JX1 } from "@fortawesome/free-solid-svg-icons/faYenSign";
import { definition as T7i } from "@fortawesome/free-solid-svg-icons/faYinYang";
import { definition as ZX1 } from "@fortawesome/free-solid-svg-icons/faYinYang";
import { definition as F7i } from "@fortawesome/free-solid-svg-icons/faZ";
import { definition as xX1 } from "@fortawesome/free-solid-svg-icons/faZ";
import { definition as H7i } from "@fortawesome/free-solid-svg-icons/faZap";
import { definition as aQ1 } from "@fortawesome/free-solid-svg-icons/faZap";
import { definition as R7i } from "@fortawesome/free-brands-svg-icons/fa42Group";
import { definition as nQ1 } from "@fortawesome/free-brands-svg-icons/fa42Group";
import { definition as U7i } from "@fortawesome/free-brands-svg-icons/fa500px";
import { definition as cQ1 } from "@fortawesome/free-brands-svg-icons/fa500px";
import { definition as q7i } from "@fortawesome/free-brands-svg-icons/faAccessibleIcon";
import { definition as oQ1 } from "@fortawesome/free-brands-svg-icons/faAccessibleIcon";
import { definition as G7i } from "@fortawesome/free-brands-svg-icons/faAccusoft";
import { definition as dQ1 } from "@fortawesome/free-brands-svg-icons/faAccusoft";
import { definition as W7i } from "@fortawesome/free-brands-svg-icons/faAdn";
import { definition as sQ1 } from "@fortawesome/free-brands-svg-icons/faAdn";
import { definition as E7i } from "@fortawesome/free-brands-svg-icons/faAdversal";
import { definition as vQ1 } from "@fortawesome/free-brands-svg-icons/faAdversal";
import { definition as V7i } from "@fortawesome/free-brands-svg-icons/faAffiliatetheme";
import { definition as mQ1 } from "@fortawesome/free-brands-svg-icons/faAffiliatetheme";
import { definition as I7i } from "@fortawesome/free-brands-svg-icons/faAirbnb";
import { definition as PQ1 } from "@fortawesome/free-brands-svg-icons/faAirbnb";
import { definition as K7i } from "@fortawesome/free-brands-svg-icons/faAlgolia";
import { definition as wQ1 } from "@fortawesome/free-brands-svg-icons/faAlgolia";
import { definition as X7i } from "@fortawesome/free-brands-svg-icons/faAlipay";
import { definition as zQ1 } from "@fortawesome/free-brands-svg-icons/faAlipay";
import { definition as Q7i } from "@fortawesome/free-brands-svg-icons/faAmazon";
import { definition as CQ1 } from "@fortawesome/free-brands-svg-icons/faAmazon";
import { definition as J7i } from "@fortawesome/free-brands-svg-icons/faAmazonPay";
import { definition as $Q1 } from "@fortawesome/free-brands-svg-icons/faAmazonPay";
import { definition as Y7i } from "@fortawesome/free-brands-svg-icons/faAmilia";
import { definition as bQ1 } from "@fortawesome/free-brands-svg-icons/faAmilia";
import { definition as Z7i } from "@fortawesome/free-brands-svg-icons/faAndroid";
import { definition as yQ1 } from "@fortawesome/free-brands-svg-icons/faAndroid";
import { definition as p7i } from "@fortawesome/free-brands-svg-icons/faAngellist";
import { definition as kQ1 } from "@fortawesome/free-brands-svg-icons/faAngellist";
import { definition as x7i } from "@fortawesome/free-brands-svg-icons/faAngrycreative";
import { definition as jQ1 } from "@fortawesome/free-brands-svg-icons/faAngrycreative";
import { definition as iti } from "@fortawesome/free-brands-svg-icons/faAngular";
import { definition as TQ1 } from "@fortawesome/free-brands-svg-icons/faAngular";
import { definition as ati } from "@fortawesome/free-brands-svg-icons/faAppStore";
import { definition as HQ1 } from "@fortawesome/free-brands-svg-icons/faAppStore";
import { definition as eti } from "@fortawesome/free-brands-svg-icons/faAppStoreIos";
import { definition as UQ1 } from "@fortawesome/free-brands-svg-icons/faAppStoreIos";
import { definition as nti } from "@fortawesome/free-brands-svg-icons/faApper";
import { definition as GQ1 } from "@fortawesome/free-brands-svg-icons/faApper";
import { definition as fti } from "@fortawesome/free-brands-svg-icons/faApple";
import { definition as EQ1 } from "@fortawesome/free-brands-svg-icons/faApple";
import { definition as cti } from "@fortawesome/free-brands-svg-icons/faApplePay";
import { definition as IQ1 } from "@fortawesome/free-brands-svg-icons/faApplePay";
import { definition as tti } from "@fortawesome/free-brands-svg-icons/faArtstation";
import { definition as XQ1 } from "@fortawesome/free-brands-svg-icons/faArtstation";
import { definition as oti } from "@fortawesome/free-brands-svg-icons/faAsymmetrik";
import { definition as JQ1 } from "@fortawesome/free-brands-svg-icons/faAsymmetrik";
import { definition as lti } from "@fortawesome/free-brands-svg-icons/faAtlassian";
import { definition as ZQ1 } from "@fortawesome/free-brands-svg-icons/faAtlassian";
import { definition as dti } from "@fortawesome/free-brands-svg-icons/faAudible";
import { definition as xQ1 } from "@fortawesome/free-brands-svg-icons/faAudible";
import { definition as rti } from "@fortawesome/free-brands-svg-icons/faAutoprefixer";
import { definition as aJ1 } from "@fortawesome/free-brands-svg-icons/faAutoprefixer";
import { definition as sti } from "@fortawesome/free-brands-svg-icons/faAvianex";
import { definition as nJ1 } from "@fortawesome/free-brands-svg-icons/faAvianex";
import { definition as hti } from "@fortawesome/free-brands-svg-icons/faAviato";
import { definition as cJ1 } from "@fortawesome/free-brands-svg-icons/faAviato";
import { definition as vti } from "@fortawesome/free-brands-svg-icons/faAws";
import { definition as oJ1 } from "@fortawesome/free-brands-svg-icons/faAws";
import { definition as uti } from "@fortawesome/free-brands-svg-icons/faBandcamp";
import { definition as dJ1 } from "@fortawesome/free-brands-svg-icons/faBandcamp";
import { definition as mti } from "@fortawesome/free-brands-svg-icons/faBattleNet";
import { definition as sJ1 } from "@fortawesome/free-brands-svg-icons/faBattleNet";
import { definition as gti } from "@fortawesome/free-brands-svg-icons/faBehance";
import { definition as vJ1 } from "@fortawesome/free-brands-svg-icons/faBehance";
import { definition as Pti } from "@fortawesome/free-brands-svg-icons/faBehanceSquare";
import { definition as mJ1 } from "@fortawesome/free-brands-svg-icons/faBehanceSquare";
import { definition as Mti } from "@fortawesome/free-brands-svg-icons/faBilibili";
import { definition as PJ1 } from "@fortawesome/free-brands-svg-icons/faBilibili";
import { definition as wti } from "@fortawesome/free-brands-svg-icons/faBimobject";
import { definition as wJ1 } from "@fortawesome/free-brands-svg-icons/faBimobject";
import { definition as Nti } from "@fortawesome/free-brands-svg-icons/faBitbucket";
import { definition as zJ1 } from "@fortawesome/free-brands-svg-icons/faBitbucket";
import { definition as zti } from "@fortawesome/free-brands-svg-icons/faBitcoin";
import { definition as CJ1 } from "@fortawesome/free-brands-svg-icons/faBitcoin";
import { definition as Lti } from "@fortawesome/free-brands-svg-icons/faBity";
import { definition as $J1 } from "@fortawesome/free-brands-svg-icons/faBity";
import { definition as Cti } from "@fortawesome/free-brands-svg-icons/faBlackTie";
import { definition as bJ1 } from "@fortawesome/free-brands-svg-icons/faBlackTie";
import { definition as Dti } from "@fortawesome/free-brands-svg-icons/faBlackberry";
import { definition as yJ1 } from "@fortawesome/free-brands-svg-icons/faBlackberry";
import { definition as $ti } from "@fortawesome/free-brands-svg-icons/faBlogger";
import { definition as kJ1 } from "@fortawesome/free-brands-svg-icons/faBlogger";
import { definition as _ti } from "@fortawesome/free-brands-svg-icons/faBloggerB";
import { definition as jJ1 } from "@fortawesome/free-brands-svg-icons/faBloggerB";
import { definition as bti } from "@fortawesome/free-brands-svg-icons/faBluesky";
import { definition as TJ1 } from "@fortawesome/free-brands-svg-icons/faBluesky";
import { definition as Sti } from "@fortawesome/free-brands-svg-icons/faBluetooth";
import { definition as HJ1 } from "@fortawesome/free-brands-svg-icons/faBluetooth";
import { definition as yti } from "@fortawesome/free-brands-svg-icons/faBluetoothB";
import { definition as UJ1 } from "@fortawesome/free-brands-svg-icons/faBluetoothB";
import { definition as Oti } from "@fortawesome/free-brands-svg-icons/faBootstrap";
import { definition as GJ1 } from "@fortawesome/free-brands-svg-icons/faBootstrap";
import { definition as kti } from "@fortawesome/free-brands-svg-icons/faBots";
import { definition as EJ1 } from "@fortawesome/free-brands-svg-icons/faBots";
import { definition as Ati } from "@fortawesome/free-brands-svg-icons/faBrave";
import { definition as IJ1 } from "@fortawesome/free-brands-svg-icons/faBrave";
import { definition as jti } from "@fortawesome/free-brands-svg-icons/faBraveReverse";
import { definition as XJ1 } from "@fortawesome/free-brands-svg-icons/faBraveReverse";
import { definition as Bti } from "@fortawesome/free-brands-svg-icons/faBtc";
import { definition as JJ1 } from "@fortawesome/free-brands-svg-icons/faBtc";
import { definition as Tti } from "@fortawesome/free-brands-svg-icons/faBuffer";
import { definition as ZJ1 } from "@fortawesome/free-brands-svg-icons/faBuffer";
import { definition as Fti } from "@fortawesome/free-brands-svg-icons/faBuromobelexperte";
import { definition as xJ1 } from "@fortawesome/free-brands-svg-icons/faBuromobelexperte";
import { definition as Hti } from "@fortawesome/free-brands-svg-icons/faBuyNLarge";
import { definition as aY1 } from "@fortawesome/free-brands-svg-icons/faBuyNLarge";
import { definition as Rti } from "@fortawesome/free-brands-svg-icons/faBuysellads";
import { definition as nY1 } from "@fortawesome/free-brands-svg-icons/faBuysellads";
import { definition as Uti } from "@fortawesome/free-brands-svg-icons/faCanadianMapleLeaf";
import { definition as cY1 } from "@fortawesome/free-brands-svg-icons/faCanadianMapleLeaf";
import { definition as qti } from "@fortawesome/free-brands-svg-icons/faCcAmazonPay";
import { definition as oY1 } from "@fortawesome/free-brands-svg-icons/faCcAmazonPay";
import { definition as Gti } from "@fortawesome/free-brands-svg-icons/faCcAmex";
import { definition as dY1 } from "@fortawesome/free-brands-svg-icons/faCcAmex";
import { definition as Wti } from "@fortawesome/free-brands-svg-icons/faCcApplePay";
import { definition as sY1 } from "@fortawesome/free-brands-svg-icons/faCcApplePay";
import { definition as Eti } from "@fortawesome/free-brands-svg-icons/faCcDinersClub";
import { definition as vY1 } from "@fortawesome/free-brands-svg-icons/faCcDinersClub";
import { definition as Vti } from "@fortawesome/free-brands-svg-icons/faCcDiscover";
import { definition as mY1 } from "@fortawesome/free-brands-svg-icons/faCcDiscover";
import { definition as Iti } from "@fortawesome/free-brands-svg-icons/faCcJcb";
import { definition as PY1 } from "@fortawesome/free-brands-svg-icons/faCcJcb";
import { definition as Kti } from "@fortawesome/free-brands-svg-icons/faCcMastercard";
import { definition as wY1 } from "@fortawesome/free-brands-svg-icons/faCcMastercard";
import { definition as Xti } from "@fortawesome/free-brands-svg-icons/faCcPaypal";
import { definition as zY1 } from "@fortawesome/free-brands-svg-icons/faCcPaypal";
import { definition as Qti } from "@fortawesome/free-brands-svg-icons/faCcStripe";
import { definition as CY1 } from "@fortawesome/free-brands-svg-icons/faCcStripe";
import { definition as Jti } from "@fortawesome/free-brands-svg-icons/faCcVisa";
import { definition as $Y1 } from "@fortawesome/free-brands-svg-icons/faCcVisa";
import { definition as Yti } from "@fortawesome/free-brands-svg-icons/faCentercode";
import { definition as bY1 } from "@fortawesome/free-brands-svg-icons/faCentercode";
import { definition as Zti } from "@fortawesome/free-brands-svg-icons/faCentos";
import { definition as yY1 } from "@fortawesome/free-brands-svg-icons/faCentos";
import { definition as pti } from "@fortawesome/free-brands-svg-icons/faChrome";
import { definition as kY1 } from "@fortawesome/free-brands-svg-icons/faChrome";
import { definition as xti } from "@fortawesome/free-brands-svg-icons/faChromecast";
import { definition as jY1 } from "@fortawesome/free-brands-svg-icons/faChromecast";
import { definition as ioi } from "@fortawesome/free-brands-svg-icons/faCloudflare";
import { definition as TY1 } from "@fortawesome/free-brands-svg-icons/faCloudflare";
import { definition as aoi } from "@fortawesome/free-brands-svg-icons/faCloudscale";
import { definition as HY1 } from "@fortawesome/free-brands-svg-icons/faCloudscale";
import { definition as eoi } from "@fortawesome/free-brands-svg-icons/faCloudsmith";
import { definition as UY1 } from "@fortawesome/free-brands-svg-icons/faCloudsmith";
import { definition as noi } from "@fortawesome/free-brands-svg-icons/faCloudversify";
import { definition as GY1 } from "@fortawesome/free-brands-svg-icons/faCloudversify";
import { definition as foi } from "@fortawesome/free-brands-svg-icons/faCmplid";
import { definition as EY1 } from "@fortawesome/free-brands-svg-icons/faCmplid";
import { definition as coi } from "@fortawesome/free-brands-svg-icons/faCodepen";
import { definition as IY1 } from "@fortawesome/free-brands-svg-icons/faCodepen";
import { definition as toi } from "@fortawesome/free-brands-svg-icons/faCodiepie";
import { definition as XY1 } from "@fortawesome/free-brands-svg-icons/faCodiepie";
import { definition as ooi } from "@fortawesome/free-brands-svg-icons/faConfluence";
import { definition as JY1 } from "@fortawesome/free-brands-svg-icons/faConfluence";
import { definition as loi } from "@fortawesome/free-brands-svg-icons/faConnectdevelop";
import { definition as ZY1 } from "@fortawesome/free-brands-svg-icons/faConnectdevelop";
import { definition as doi } from "@fortawesome/free-brands-svg-icons/faContao";
import { definition as xY1 } from "@fortawesome/free-brands-svg-icons/faContao";
import { definition as roi } from "@fortawesome/free-brands-svg-icons/faCottonBureau";
import { definition as aZ1 } from "@fortawesome/free-brands-svg-icons/faCottonBureau";
import { definition as soi } from "@fortawesome/free-brands-svg-icons/faCpanel";
import { definition as nZ1 } from "@fortawesome/free-brands-svg-icons/faCpanel";
import { definition as hoi } from "@fortawesome/free-brands-svg-icons/faCreativeCommons";
import { definition as cZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommons";
import { definition as voi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsBy";
import { definition as oZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsBy";
import { definition as uoi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNc";
import { definition as dZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNc";
import { definition as moi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNcEu";
import { definition as sZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNcEu";
import { definition as goi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNcJp";
import { definition as vZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNcJp";
import { definition as Poi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNd";
import { definition as mZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNd";
import { definition as Moi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsPd";
import { definition as PZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsPd";
import { definition as woi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsPdAlt";
import { definition as wZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsPdAlt";
import { definition as Noi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsRemix";
import { definition as zZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsRemix";
import { definition as zoi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsSa";
import { definition as CZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsSa";
import { definition as Loi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsSampling";
import { definition as $Z1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsSampling";
import { definition as Coi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsSamplingPlus";
import { definition as bZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsSamplingPlus";
import { definition as Doi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsShare";
import { definition as yZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsShare";
import { definition as $oi } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsZero";
import { definition as kZ1 } from "@fortawesome/free-brands-svg-icons/faCreativeCommonsZero";
import { definition as _oi } from "@fortawesome/free-brands-svg-icons/faCriticalRole";
import { definition as jZ1 } from "@fortawesome/free-brands-svg-icons/faCriticalRole";
import { definition as boi } from "@fortawesome/free-brands-svg-icons/faCss3";
import { definition as TZ1 } from "@fortawesome/free-brands-svg-icons/faCss3";
import { definition as Soi } from "@fortawesome/free-brands-svg-icons/faCss3Alt";
import { definition as HZ1 } from "@fortawesome/free-brands-svg-icons/faCss3Alt";
import { definition as yoi } from "@fortawesome/free-brands-svg-icons/faCuttlefish";
import { definition as UZ1 } from "@fortawesome/free-brands-svg-icons/faCuttlefish";
import { definition as Ooi } from "@fortawesome/free-brands-svg-icons/faDAndD";
import { definition as GZ1 } from "@fortawesome/free-brands-svg-icons/faDAndD";
import { definition as koi } from "@fortawesome/free-brands-svg-icons/faDAndDBeyond";
import { definition as EZ1 } from "@fortawesome/free-brands-svg-icons/faDAndDBeyond";
import { definition as Aoi } from "@fortawesome/free-brands-svg-icons/faDailymotion";
import { definition as IZ1 } from "@fortawesome/free-brands-svg-icons/faDailymotion";
import { definition as joi } from "@fortawesome/free-brands-svg-icons/faDartLang";
import { definition as XZ1 } from "@fortawesome/free-brands-svg-icons/faDartLang";
import { definition as Boi } from "@fortawesome/free-brands-svg-icons/faDashcube";
import { definition as JZ1 } from "@fortawesome/free-brands-svg-icons/faDashcube";
import { definition as Toi } from "@fortawesome/free-brands-svg-icons/faDebian";
import { definition as ZZ1 } from "@fortawesome/free-brands-svg-icons/faDebian";
import { definition as Foi } from "@fortawesome/free-brands-svg-icons/faDeezer";
import { definition as xZ1 } from "@fortawesome/free-brands-svg-icons/faDeezer";
import { definition as Hoi } from "@fortawesome/free-brands-svg-icons/faDelicious";
import { definition as ap1 } from "@fortawesome/free-brands-svg-icons/faDelicious";
import { definition as Roi } from "@fortawesome/free-brands-svg-icons/faDeploydog";
import { definition as np1 } from "@fortawesome/free-brands-svg-icons/faDeploydog";
import { definition as Uoi } from "@fortawesome/free-brands-svg-icons/faDeskpro";
import { definition as cp1 } from "@fortawesome/free-brands-svg-icons/faDeskpro";
import { definition as qoi } from "@fortawesome/free-brands-svg-icons/faDev";
import { definition as op1 } from "@fortawesome/free-brands-svg-icons/faDev";
import { definition as Goi } from "@fortawesome/free-brands-svg-icons/faDeviantart";
import { definition as dp1 } from "@fortawesome/free-brands-svg-icons/faDeviantart";
import { definition as Woi } from "@fortawesome/free-brands-svg-icons/faDhl";
import { definition as sp1 } from "@fortawesome/free-brands-svg-icons/faDhl";
import { definition as Eoi } from "@fortawesome/free-brands-svg-icons/faDiaspora";
import { definition as vp1 } from "@fortawesome/free-brands-svg-icons/faDiaspora";
import { definition as Voi } from "@fortawesome/free-brands-svg-icons/faDigg";
import { definition as mp1 } from "@fortawesome/free-brands-svg-icons/faDigg";
import { definition as Ioi } from "@fortawesome/free-brands-svg-icons/faDigitalOcean";
import { definition as Pp1 } from "@fortawesome/free-brands-svg-icons/faDigitalOcean";
import { definition as Koi } from "@fortawesome/free-brands-svg-icons/faDiscord";
import { definition as wp1 } from "@fortawesome/free-brands-svg-icons/faDiscord";
import { definition as Xoi } from "@fortawesome/free-brands-svg-icons/faDiscourse";
import { definition as zp1 } from "@fortawesome/free-brands-svg-icons/faDiscourse";
import { definition as Qoi } from "@fortawesome/free-brands-svg-icons/faDochub";
import { definition as Cp1 } from "@fortawesome/free-brands-svg-icons/faDochub";
import { definition as Joi } from "@fortawesome/free-brands-svg-icons/faDocker";
import { definition as $p1 } from "@fortawesome/free-brands-svg-icons/faDocker";
import { definition as Yoi } from "@fortawesome/free-brands-svg-icons/faDraft2digital";
import { definition as bp1 } from "@fortawesome/free-brands-svg-icons/faDraft2digital";
import { definition as Zoi } from "@fortawesome/free-brands-svg-icons/faDribbble";
import { definition as yp1 } from "@fortawesome/free-brands-svg-icons/faDribbble";
import { definition as poi } from "@fortawesome/free-brands-svg-icons/faDribbbleSquare";
import { definition as kp1 } from "@fortawesome/free-brands-svg-icons/faDribbbleSquare";
import { definition as xoi } from "@fortawesome/free-brands-svg-icons/faDropbox";
import { definition as jp1 } from "@fortawesome/free-brands-svg-icons/faDropbox";
import { definition as ili } from "@fortawesome/free-brands-svg-icons/faDrupal";
import { definition as Tp1 } from "@fortawesome/free-brands-svg-icons/faDrupal";
import { definition as ali } from "@fortawesome/free-brands-svg-icons/faDyalog";
import { definition as Hp1 } from "@fortawesome/free-brands-svg-icons/faDyalog";
import { definition as eli } from "@fortawesome/free-brands-svg-icons/faEarlybirds";
import { definition as Up1 } from "@fortawesome/free-brands-svg-icons/faEarlybirds";
import { definition as nli } from "@fortawesome/free-brands-svg-icons/faEbay";
import { definition as Gp1 } from "@fortawesome/free-brands-svg-icons/faEbay";
import { definition as fli } from "@fortawesome/free-brands-svg-icons/faEdge";
import { definition as Ep1 } from "@fortawesome/free-brands-svg-icons/faEdge";
import { definition as cli } from "@fortawesome/free-brands-svg-icons/faEdgeLegacy";
import { definition as Ip1 } from "@fortawesome/free-brands-svg-icons/faEdgeLegacy";
import { definition as tli } from "@fortawesome/free-brands-svg-icons/faElementor";
import { definition as Xp1 } from "@fortawesome/free-brands-svg-icons/faElementor";
import { definition as oli } from "@fortawesome/free-brands-svg-icons/faEllo";
import { definition as Jp1 } from "@fortawesome/free-brands-svg-icons/faEllo";
import { definition as lli } from "@fortawesome/free-brands-svg-icons/faEmber";
import { definition as Zp1 } from "@fortawesome/free-brands-svg-icons/faEmber";
import { definition as dli } from "@fortawesome/free-brands-svg-icons/faEmpire";
import { definition as xp1 } from "@fortawesome/free-brands-svg-icons/faEmpire";
import { definition as rli } from "@fortawesome/free-brands-svg-icons/faEnvira";
import { definition as ax1 } from "@fortawesome/free-brands-svg-icons/faEnvira";
import { definition as sli } from "@fortawesome/free-brands-svg-icons/faErlang";
import { definition as nx1 } from "@fortawesome/free-brands-svg-icons/faErlang";
import { definition as hli } from "@fortawesome/free-brands-svg-icons/faEthereum";
import { definition as cx1 } from "@fortawesome/free-brands-svg-icons/faEthereum";
import { definition as vli } from "@fortawesome/free-brands-svg-icons/faEtsy";
import { definition as ox1 } from "@fortawesome/free-brands-svg-icons/faEtsy";
import { definition as uli } from "@fortawesome/free-brands-svg-icons/faEvernote";
import { definition as dx1 } from "@fortawesome/free-brands-svg-icons/faEvernote";
import { definition as mli } from "@fortawesome/free-brands-svg-icons/faExpeditedssl";
import { definition as sx1 } from "@fortawesome/free-brands-svg-icons/faExpeditedssl";
import { definition as gli } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { definition as vx1 } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { definition as Pli } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { definition as mx1 } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { definition as Mli } from "@fortawesome/free-brands-svg-icons/faFacebookMessenger";
import { definition as Px1 } from "@fortawesome/free-brands-svg-icons/faFacebookMessenger";
import { definition as wli } from "@fortawesome/free-brands-svg-icons/faFacebookSquare";
import { definition as wx1 } from "@fortawesome/free-brands-svg-icons/faFacebookSquare";
import { definition as Nli } from "@fortawesome/free-brands-svg-icons/faFantasyFlightGames";
import { definition as zx1 } from "@fortawesome/free-brands-svg-icons/faFantasyFlightGames";
import { definition as zli } from "@fortawesome/free-brands-svg-icons/faFedex";
import { definition as Cx1 } from "@fortawesome/free-brands-svg-icons/faFedex";
import { definition as Lli } from "@fortawesome/free-brands-svg-icons/faFedora";
import { definition as $x1 } from "@fortawesome/free-brands-svg-icons/faFedora";
import { definition as Cli } from "@fortawesome/free-brands-svg-icons/faFigma";
import { definition as bx1 } from "@fortawesome/free-brands-svg-icons/faFigma";
import { definition as Dli } from "@fortawesome/free-brands-svg-icons/faFirefox";
import { definition as yx1 } from "@fortawesome/free-brands-svg-icons/faFirefox";
import { definition as $li } from "@fortawesome/free-brands-svg-icons/faFirefoxBrowser";
import { definition as kx1 } from "@fortawesome/free-brands-svg-icons/faFirefoxBrowser";
import { definition as _li } from "@fortawesome/free-brands-svg-icons/faFirstOrder";
import { definition as jx1 } from "@fortawesome/free-brands-svg-icons/faFirstOrder";
import { definition as bli } from "@fortawesome/free-brands-svg-icons/faFirstOrderAlt";
import { definition as Tx1 } from "@fortawesome/free-brands-svg-icons/faFirstOrderAlt";
import { definition as Sli } from "@fortawesome/free-brands-svg-icons/faFirstdraft";
import { definition as Hx1 } from "@fortawesome/free-brands-svg-icons/faFirstdraft";
import { definition as yli } from "@fortawesome/free-brands-svg-icons/faFlickr";
import { definition as Ux1 } from "@fortawesome/free-brands-svg-icons/faFlickr";
import { definition as Oli } from "@fortawesome/free-brands-svg-icons/faFlipboard";
import { definition as Gx1 } from "@fortawesome/free-brands-svg-icons/faFlipboard";
import { definition as kli } from "@fortawesome/free-brands-svg-icons/faFlutter";
import { definition as Ex1 } from "@fortawesome/free-brands-svg-icons/faFlutter";
import { definition as Ali } from "@fortawesome/free-brands-svg-icons/faFly";
import { definition as Ix1 } from "@fortawesome/free-brands-svg-icons/faFly";
import { definition as jli } from "@fortawesome/free-brands-svg-icons/faFontAwesomeAlt";
import { definition as Xx1 } from "@fortawesome/free-brands-svg-icons/faFontAwesomeAlt";
import { definition as Bli } from "@fortawesome/free-brands-svg-icons/faFonticons";
import { definition as Jx1 } from "@fortawesome/free-brands-svg-icons/faFonticons";
import { definition as Tli } from "@fortawesome/free-brands-svg-icons/faFonticonsFi";
import { definition as Zx1 } from "@fortawesome/free-brands-svg-icons/faFonticonsFi";
import { definition as Fli } from "@fortawesome/free-brands-svg-icons/faFortAwesome";
import { definition as xx1 } from "@fortawesome/free-brands-svg-icons/faFortAwesome";
import { definition as Hli } from "@fortawesome/free-brands-svg-icons/faFortAwesomeAlt";
import { definition as aia } from "@fortawesome/free-brands-svg-icons/faFortAwesomeAlt";
import { definition as Rli } from "@fortawesome/free-brands-svg-icons/faForumbee";
import { definition as nia } from "@fortawesome/free-brands-svg-icons/faForumbee";
import { definition as Uli } from "@fortawesome/free-brands-svg-icons/faFoursquare";
import { definition as cia } from "@fortawesome/free-brands-svg-icons/faFoursquare";
import { definition as qli } from "@fortawesome/free-brands-svg-icons/faFreeCodeCamp";
import { definition as oia } from "@fortawesome/free-brands-svg-icons/faFreeCodeCamp";
import { definition as Gli } from "@fortawesome/free-brands-svg-icons/faFreebsd";
import { definition as dia } from "@fortawesome/free-brands-svg-icons/faFreebsd";
import { definition as Wli } from "@fortawesome/free-brands-svg-icons/faFulcrum";
import { definition as sia } from "@fortawesome/free-brands-svg-icons/faFulcrum";
import { definition as Eli } from "@fortawesome/free-brands-svg-icons/faGalacticRepublic";
import { definition as via } from "@fortawesome/free-brands-svg-icons/faGalacticRepublic";
import { definition as Vli } from "@fortawesome/free-brands-svg-icons/faGalacticSenate";
import { definition as mia } from "@fortawesome/free-brands-svg-icons/faGalacticSenate";
import { definition as Ili } from "@fortawesome/free-brands-svg-icons/faGetPocket";
import { definition as Pia } from "@fortawesome/free-brands-svg-icons/faGetPocket";
import { definition as Kli } from "@fortawesome/free-brands-svg-icons/faGg";
import { definition as wia } from "@fortawesome/free-brands-svg-icons/faGg";
import { definition as Xli } from "@fortawesome/free-brands-svg-icons/faGgCircle";
import { definition as zia } from "@fortawesome/free-brands-svg-icons/faGgCircle";
import { definition as Qli } from "@fortawesome/free-brands-svg-icons/faGit";
import { definition as Cia } from "@fortawesome/free-brands-svg-icons/faGit";
import { definition as Jli } from "@fortawesome/free-brands-svg-icons/faGitAlt";
import { definition as $ia } from "@fortawesome/free-brands-svg-icons/faGitAlt";
import { definition as Yli } from "@fortawesome/free-brands-svg-icons/faGitSquare";
import { definition as bia } from "@fortawesome/free-brands-svg-icons/faGitSquare";
import { definition as Zli } from "@fortawesome/free-brands-svg-icons/faGithub";
import { definition as yia } from "@fortawesome/free-brands-svg-icons/faGithub";
import { definition as pli } from "@fortawesome/free-brands-svg-icons/faGithubAlt";
import { definition as kia } from "@fortawesome/free-brands-svg-icons/faGithubAlt";
import { definition as xli } from "@fortawesome/free-brands-svg-icons/faGithubSquare";
import { definition as jia } from "@fortawesome/free-brands-svg-icons/faGithubSquare";
import { definition as idi } from "@fortawesome/free-brands-svg-icons/faGitkraken";
import { definition as Tia } from "@fortawesome/free-brands-svg-icons/faGitkraken";
import { definition as adi } from "@fortawesome/free-brands-svg-icons/faGitlab";
import { definition as Hia } from "@fortawesome/free-brands-svg-icons/faGitlab";
import { definition as edi } from "@fortawesome/free-brands-svg-icons/faGitlabSquare";
import { definition as Uia } from "@fortawesome/free-brands-svg-icons/faGitlabSquare";
import { definition as ndi } from "@fortawesome/free-brands-svg-icons/faGitter";
import { definition as Gia } from "@fortawesome/free-brands-svg-icons/faGitter";
import { definition as fdi } from "@fortawesome/free-brands-svg-icons/faGlide";
import { definition as Eia } from "@fortawesome/free-brands-svg-icons/faGlide";
import { definition as cdi } from "@fortawesome/free-brands-svg-icons/faGlideG";
import { definition as Iia } from "@fortawesome/free-brands-svg-icons/faGlideG";
import { definition as tdi } from "@fortawesome/free-brands-svg-icons/faGofore";
import { definition as Xia } from "@fortawesome/free-brands-svg-icons/faGofore";
import { definition as odi } from "@fortawesome/free-brands-svg-icons/faGolang";
import { definition as Jia } from "@fortawesome/free-brands-svg-icons/faGolang";
import { definition as ldi } from "@fortawesome/free-brands-svg-icons/faGoodreads";
import { definition as Zia } from "@fortawesome/free-brands-svg-icons/faGoodreads";
import { definition as ddi } from "@fortawesome/free-brands-svg-icons/faGoodreadsG";
import { definition as xia } from "@fortawesome/free-brands-svg-icons/faGoodreadsG";
import { definition as rdi } from "@fortawesome/free-brands-svg-icons/faGoogle";
import { definition as a2a } from "@fortawesome/free-brands-svg-icons/faGoogle";
import { definition as sdi } from "@fortawesome/free-brands-svg-icons/faGoogleDrive";
import { definition as n2a } from "@fortawesome/free-brands-svg-icons/faGoogleDrive";
import { definition as hdi } from "@fortawesome/free-brands-svg-icons/faGooglePay";
import { definition as c2a } from "@fortawesome/free-brands-svg-icons/faGooglePay";
import { definition as vdi } from "@fortawesome/free-brands-svg-icons/faGooglePlay";
import { definition as o2a } from "@fortawesome/free-brands-svg-icons/faGooglePlay";
import { definition as udi } from "@fortawesome/free-brands-svg-icons/faGooglePlus";
import { definition as d2a } from "@fortawesome/free-brands-svg-icons/faGooglePlus";
import { definition as mdi } from "@fortawesome/free-brands-svg-icons/faGooglePlusG";
import { definition as s2a } from "@fortawesome/free-brands-svg-icons/faGooglePlusG";
import { definition as gdi } from "@fortawesome/free-brands-svg-icons/faGooglePlusSquare";
import { definition as v2a } from "@fortawesome/free-brands-svg-icons/faGooglePlusSquare";
import { definition as Pdi } from "@fortawesome/free-brands-svg-icons/faGoogleScholar";
import { definition as m2a } from "@fortawesome/free-brands-svg-icons/faGoogleScholar";
import { definition as Mdi } from "@fortawesome/free-brands-svg-icons/faGoogleWallet";
import { definition as P2a } from "@fortawesome/free-brands-svg-icons/faGoogleWallet";
import { definition as wdi } from "@fortawesome/free-brands-svg-icons/faGratipay";
import { definition as w2a } from "@fortawesome/free-brands-svg-icons/faGratipay";
import { definition as Ndi } from "@fortawesome/free-brands-svg-icons/faGrav";
import { definition as z2a } from "@fortawesome/free-brands-svg-icons/faGrav";
import { definition as zdi } from "@fortawesome/free-brands-svg-icons/faGripfire";
import { definition as C2a } from "@fortawesome/free-brands-svg-icons/faGripfire";
import { definition as Ldi } from "@fortawesome/free-brands-svg-icons/faGrunt";
import { definition as $2a } from "@fortawesome/free-brands-svg-icons/faGrunt";
import { definition as Cdi } from "@fortawesome/free-brands-svg-icons/faGuilded";
import { definition as b2a } from "@fortawesome/free-brands-svg-icons/faGuilded";
import { definition as Ddi } from "@fortawesome/free-brands-svg-icons/faGulp";
import { definition as y2a } from "@fortawesome/free-brands-svg-icons/faGulp";
import { definition as $di } from "@fortawesome/free-brands-svg-icons/faHackerNews";
import { definition as k2a } from "@fortawesome/free-brands-svg-icons/faHackerNews";
import { definition as _di } from "@fortawesome/free-brands-svg-icons/faHackerNewsSquare";
import { definition as j2a } from "@fortawesome/free-brands-svg-icons/faHackerNewsSquare";
import { definition as bdi } from "@fortawesome/free-brands-svg-icons/faHackerrank";
import { definition as T2a } from "@fortawesome/free-brands-svg-icons/faHackerrank";
import { definition as Sdi } from "@fortawesome/free-brands-svg-icons/faHashnode";
import { definition as H2a } from "@fortawesome/free-brands-svg-icons/faHashnode";
import { definition as ydi } from "@fortawesome/free-brands-svg-icons/faHips";
import { definition as U2a } from "@fortawesome/free-brands-svg-icons/faHips";
import { definition as Odi } from "@fortawesome/free-brands-svg-icons/faHireAHelper";
import { definition as G2a } from "@fortawesome/free-brands-svg-icons/faHireAHelper";
import { definition as kdi } from "@fortawesome/free-brands-svg-icons/faHive";
import { definition as E2a } from "@fortawesome/free-brands-svg-icons/faHive";
import { definition as Adi } from "@fortawesome/free-brands-svg-icons/faHooli";
import { definition as I2a } from "@fortawesome/free-brands-svg-icons/faHooli";
import { definition as jdi } from "@fortawesome/free-brands-svg-icons/faHornbill";
import { definition as X2a } from "@fortawesome/free-brands-svg-icons/faHornbill";
import { definition as Bdi } from "@fortawesome/free-brands-svg-icons/faHotjar";
import { definition as J2a } from "@fortawesome/free-brands-svg-icons/faHotjar";
import { definition as Tdi } from "@fortawesome/free-brands-svg-icons/faHouzz";
import { definition as Z2a } from "@fortawesome/free-brands-svg-icons/faHouzz";
import { definition as Fdi } from "@fortawesome/free-brands-svg-icons/faHtml5";
import { definition as x2a } from "@fortawesome/free-brands-svg-icons/faHtml5";
import { definition as Hdi } from "@fortawesome/free-brands-svg-icons/faHubspot";
import { definition as a1a } from "@fortawesome/free-brands-svg-icons/faHubspot";
import { definition as Rdi } from "@fortawesome/free-brands-svg-icons/faIdeal";
import { definition as n1a } from "@fortawesome/free-brands-svg-icons/faIdeal";
import { definition as Udi } from "@fortawesome/free-brands-svg-icons/faImdb";
import { definition as c1a } from "@fortawesome/free-brands-svg-icons/faImdb";
import { definition as qdi } from "@fortawesome/free-brands-svg-icons/faInnosoft";
import { definition as o1a } from "@fortawesome/free-brands-svg-icons/faInnosoft";
import { definition as Gdi } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { definition as d1a } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { definition as Wdi } from "@fortawesome/free-brands-svg-icons/faInstagramSquare";
import { definition as s1a } from "@fortawesome/free-brands-svg-icons/faInstagramSquare";
import { definition as Edi } from "@fortawesome/free-brands-svg-icons/faInstalod";
import { definition as v1a } from "@fortawesome/free-brands-svg-icons/faInstalod";
import { definition as Vdi } from "@fortawesome/free-brands-svg-icons/faIntercom";
import { definition as m1a } from "@fortawesome/free-brands-svg-icons/faIntercom";
import { definition as Idi } from "@fortawesome/free-brands-svg-icons/faInternetExplorer";
import { definition as P1a } from "@fortawesome/free-brands-svg-icons/faInternetExplorer";
import { definition as Kdi } from "@fortawesome/free-brands-svg-icons/faInvision";
import { definition as w1a } from "@fortawesome/free-brands-svg-icons/faInvision";
import { definition as Xdi } from "@fortawesome/free-brands-svg-icons/faIoxhost";
import { definition as z1a } from "@fortawesome/free-brands-svg-icons/faIoxhost";
import { definition as Qdi } from "@fortawesome/free-brands-svg-icons/faItchIo";
import { definition as C1a } from "@fortawesome/free-brands-svg-icons/faItchIo";
import { definition as Jdi } from "@fortawesome/free-brands-svg-icons/faItunes";
import { definition as $1a } from "@fortawesome/free-brands-svg-icons/faItunes";
import { definition as Ydi } from "@fortawesome/free-brands-svg-icons/faItunesNote";
import { definition as b1a } from "@fortawesome/free-brands-svg-icons/faItunesNote";
import { definition as Zdi } from "@fortawesome/free-brands-svg-icons/faJava";
import { definition as y1a } from "@fortawesome/free-brands-svg-icons/faJava";
import { definition as pdi } from "@fortawesome/free-brands-svg-icons/faJediOrder";
import { definition as k1a } from "@fortawesome/free-brands-svg-icons/faJediOrder";
import { definition as xdi } from "@fortawesome/free-brands-svg-icons/faJenkins";
import { definition as j1a } from "@fortawesome/free-brands-svg-icons/faJenkins";
import { definition as iri } from "@fortawesome/free-brands-svg-icons/faJira";
import { definition as T1a } from "@fortawesome/free-brands-svg-icons/faJira";
import { definition as ari } from "@fortawesome/free-brands-svg-icons/faJoget";
import { definition as H1a } from "@fortawesome/free-brands-svg-icons/faJoget";
import { definition as eri } from "@fortawesome/free-brands-svg-icons/faJoomla";
import { definition as U1a } from "@fortawesome/free-brands-svg-icons/faJoomla";
import { definition as nri } from "@fortawesome/free-brands-svg-icons/faJs";
import { definition as G1a } from "@fortawesome/free-brands-svg-icons/faJs";
import { definition as fri } from "@fortawesome/free-brands-svg-icons/faJsSquare";
import { definition as E1a } from "@fortawesome/free-brands-svg-icons/faJsSquare";
import { definition as cri } from "@fortawesome/free-brands-svg-icons/faJsfiddle";
import { definition as I1a } from "@fortawesome/free-brands-svg-icons/faJsfiddle";
import { definition as tri } from "@fortawesome/free-brands-svg-icons/faJxl";
import { definition as X1a } from "@fortawesome/free-brands-svg-icons/faJxl";
import { definition as ori } from "@fortawesome/free-brands-svg-icons/faKaggle";
import { definition as J1a } from "@fortawesome/free-brands-svg-icons/faKaggle";
import { definition as lri } from "@fortawesome/free-brands-svg-icons/faKeybase";
import { definition as Z1a } from "@fortawesome/free-brands-svg-icons/faKeybase";
import { definition as dri } from "@fortawesome/free-brands-svg-icons/faKeycdn";
import { definition as x1a } from "@fortawesome/free-brands-svg-icons/faKeycdn";
import { definition as rri } from "@fortawesome/free-brands-svg-icons/faKickstarter";
import { definition as aaa } from "@fortawesome/free-brands-svg-icons/faKickstarter";
import { definition as sri } from "@fortawesome/free-brands-svg-icons/faKickstarterK";
import { definition as naa } from "@fortawesome/free-brands-svg-icons/faKickstarterK";
import { definition as hri } from "@fortawesome/free-brands-svg-icons/faKorvue";
import { definition as caa } from "@fortawesome/free-brands-svg-icons/faKorvue";
import { definition as vri } from "@fortawesome/free-brands-svg-icons/faLaravel";
import { definition as oaa } from "@fortawesome/free-brands-svg-icons/faLaravel";
import { definition as uri } from "@fortawesome/free-brands-svg-icons/faLastfm";
import { definition as daa } from "@fortawesome/free-brands-svg-icons/faLastfm";
import { definition as mri } from "@fortawesome/free-brands-svg-icons/faLastfmSquare";
import { definition as saa } from "@fortawesome/free-brands-svg-icons/faLastfmSquare";
import { definition as gri } from "@fortawesome/free-brands-svg-icons/faLeanpub";
import { definition as vaa } from "@fortawesome/free-brands-svg-icons/faLeanpub";
import { definition as Pri } from "@fortawesome/free-brands-svg-icons/faLess";
import { definition as maa } from "@fortawesome/free-brands-svg-icons/faLess";
import { definition as Mri } from "@fortawesome/free-brands-svg-icons/faLetterboxd";
import { definition as Paa } from "@fortawesome/free-brands-svg-icons/faLetterboxd";
import { definition as wri } from "@fortawesome/free-brands-svg-icons/faLine";
import { definition as waa } from "@fortawesome/free-brands-svg-icons/faLine";
import { definition as Nri } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { definition as zaa } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { definition as zri } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { definition as Caa } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { definition as Lri } from "@fortawesome/free-brands-svg-icons/faLinode";
import { definition as $aa } from "@fortawesome/free-brands-svg-icons/faLinode";
import { definition as Cri } from "@fortawesome/free-brands-svg-icons/faLinux";
import { definition as baa } from "@fortawesome/free-brands-svg-icons/faLinux";
import { definition as Dri } from "@fortawesome/free-brands-svg-icons/faLyft";
import { definition as yaa } from "@fortawesome/free-brands-svg-icons/faLyft";
import { definition as $ri } from "@fortawesome/free-brands-svg-icons/faMagento";
import { definition as kaa } from "@fortawesome/free-brands-svg-icons/faMagento";
import { definition as _ri } from "@fortawesome/free-brands-svg-icons/faMailchimp";
import { definition as jaa } from "@fortawesome/free-brands-svg-icons/faMailchimp";
import { definition as bri } from "@fortawesome/free-brands-svg-icons/faMandalorian";
import { definition as Taa } from "@fortawesome/free-brands-svg-icons/faMandalorian";
import { definition as Sri } from "@fortawesome/free-brands-svg-icons/faMarkdown";
import { definition as Haa } from "@fortawesome/free-brands-svg-icons/faMarkdown";
import { definition as yri } from "@fortawesome/free-brands-svg-icons/faMastodon";
import { definition as Uaa } from "@fortawesome/free-brands-svg-icons/faMastodon";
import { definition as Ori } from "@fortawesome/free-brands-svg-icons/faMaxcdn";
import { definition as Gaa } from "@fortawesome/free-brands-svg-icons/faMaxcdn";
import { definition as kri } from "@fortawesome/free-brands-svg-icons/faMdb";
import { definition as Eaa } from "@fortawesome/free-brands-svg-icons/faMdb";
import { definition as Ari } from "@fortawesome/free-brands-svg-icons/faMedapps";
import { definition as Iaa } from "@fortawesome/free-brands-svg-icons/faMedapps";
import { definition as jri } from "@fortawesome/free-brands-svg-icons/faMedium";
import { definition as Xaa } from "@fortawesome/free-brands-svg-icons/faMedium";
import { definition as Bri } from "@fortawesome/free-brands-svg-icons/faMediumM";
import { definition as Jaa } from "@fortawesome/free-brands-svg-icons/faMediumM";
import { definition as Tri } from "@fortawesome/free-brands-svg-icons/faMedrt";
import { definition as Zaa } from "@fortawesome/free-brands-svg-icons/faMedrt";
import { definition as Fri } from "@fortawesome/free-brands-svg-icons/faMeetup";
import { definition as xaa } from "@fortawesome/free-brands-svg-icons/faMeetup";
import { definition as Hri } from "@fortawesome/free-brands-svg-icons/faMegaport";
import { definition as a4a } from "@fortawesome/free-brands-svg-icons/faMegaport";
import { definition as Rri } from "@fortawesome/free-brands-svg-icons/faMendeley";
import { definition as n4a } from "@fortawesome/free-brands-svg-icons/faMendeley";
import { definition as Uri } from "@fortawesome/free-brands-svg-icons/faMeta";
import { definition as c4a } from "@fortawesome/free-brands-svg-icons/faMeta";
import { definition as qri } from "@fortawesome/free-brands-svg-icons/faMicroblog";
import { definition as o4a } from "@fortawesome/free-brands-svg-icons/faMicroblog";
import { definition as Gri } from "@fortawesome/free-brands-svg-icons/faMicrosoft";
import { definition as d4a } from "@fortawesome/free-brands-svg-icons/faMicrosoft";
import { definition as Wri } from "@fortawesome/free-brands-svg-icons/faMintbit";
import { definition as s4a } from "@fortawesome/free-brands-svg-icons/faMintbit";
import { definition as Eri } from "@fortawesome/free-brands-svg-icons/faMix";
import { definition as v4a } from "@fortawesome/free-brands-svg-icons/faMix";
import { definition as Vri } from "@fortawesome/free-brands-svg-icons/faMixcloud";
import { definition as m4a } from "@fortawesome/free-brands-svg-icons/faMixcloud";
import { definition as Iri } from "@fortawesome/free-brands-svg-icons/faMixer";
import { definition as P4a } from "@fortawesome/free-brands-svg-icons/faMixer";
import { definition as Kri } from "@fortawesome/free-brands-svg-icons/faMizuni";
import { definition as w4a } from "@fortawesome/free-brands-svg-icons/faMizuni";
import { definition as Xri } from "@fortawesome/free-brands-svg-icons/faModx";
import { definition as z4a } from "@fortawesome/free-brands-svg-icons/faModx";
import { definition as Qri } from "@fortawesome/free-brands-svg-icons/faMonero";
import { definition as C4a } from "@fortawesome/free-brands-svg-icons/faMonero";
import { definition as Jri } from "@fortawesome/free-brands-svg-icons/faNapster";
import { definition as $4a } from "@fortawesome/free-brands-svg-icons/faNapster";
import { definition as Yri } from "@fortawesome/free-brands-svg-icons/faNeos";
import { definition as b4a } from "@fortawesome/free-brands-svg-icons/faNeos";
import { definition as Zri } from "@fortawesome/free-brands-svg-icons/faNfcDirectional";
import { definition as y4a } from "@fortawesome/free-brands-svg-icons/faNfcDirectional";
import { definition as pri } from "@fortawesome/free-brands-svg-icons/faNfcSymbol";
import { definition as k4a } from "@fortawesome/free-brands-svg-icons/faNfcSymbol";
import { definition as xri } from "@fortawesome/free-brands-svg-icons/faNimblr";
import { definition as j4a } from "@fortawesome/free-brands-svg-icons/faNimblr";
import { definition as i9i } from "@fortawesome/free-brands-svg-icons/faNode";
import { definition as T4a } from "@fortawesome/free-brands-svg-icons/faNode";
import { definition as a9i } from "@fortawesome/free-brands-svg-icons/faNodeJs";
import { definition as H4a } from "@fortawesome/free-brands-svg-icons/faNodeJs";
import { definition as e9i } from "@fortawesome/free-brands-svg-icons/faNpm";
import { definition as U4a } from "@fortawesome/free-brands-svg-icons/faNpm";
import { definition as n9i } from "@fortawesome/free-brands-svg-icons/faNs8";
import { definition as G4a } from "@fortawesome/free-brands-svg-icons/faNs8";
import { definition as f9i } from "@fortawesome/free-brands-svg-icons/faNutritionix";
import { definition as E4a } from "@fortawesome/free-brands-svg-icons/faNutritionix";
import { definition as c9i } from "@fortawesome/free-brands-svg-icons/faOctopusDeploy";
import { definition as I4a } from "@fortawesome/free-brands-svg-icons/faOctopusDeploy";
import { definition as t9i } from "@fortawesome/free-brands-svg-icons/faOdnoklassniki";
import { definition as X4a } from "@fortawesome/free-brands-svg-icons/faOdnoklassniki";
import { definition as o9i } from "@fortawesome/free-brands-svg-icons/faOdnoklassnikiSquare";
import { definition as J4a } from "@fortawesome/free-brands-svg-icons/faOdnoklassnikiSquare";
import { definition as l9i } from "@fortawesome/free-brands-svg-icons/faOdysee";
import { definition as Z4a } from "@fortawesome/free-brands-svg-icons/faOdysee";
import { definition as d9i } from "@fortawesome/free-brands-svg-icons/faOldRepublic";
import { definition as x4a } from "@fortawesome/free-brands-svg-icons/faOldRepublic";
import { definition as r9i } from "@fortawesome/free-brands-svg-icons/faOpencart";
import { definition as a3a } from "@fortawesome/free-brands-svg-icons/faOpencart";
import { definition as s9i } from "@fortawesome/free-brands-svg-icons/faOpenid";
import { definition as n3a } from "@fortawesome/free-brands-svg-icons/faOpenid";
import { definition as h9i } from "@fortawesome/free-brands-svg-icons/faOpensuse";
import { definition as c3a } from "@fortawesome/free-brands-svg-icons/faOpensuse";
import { definition as v9i } from "@fortawesome/free-brands-svg-icons/faOpera";
import { definition as o3a } from "@fortawesome/free-brands-svg-icons/faOpera";
import { definition as u9i } from "@fortawesome/free-brands-svg-icons/faOptinMonster";
import { definition as d3a } from "@fortawesome/free-brands-svg-icons/faOptinMonster";
import { definition as m9i } from "@fortawesome/free-brands-svg-icons/faOrcid";
import { definition as s3a } from "@fortawesome/free-brands-svg-icons/faOrcid";
import { definition as g9i } from "@fortawesome/free-brands-svg-icons/faOsi";
import { definition as v3a } from "@fortawesome/free-brands-svg-icons/faOsi";
import { definition as P9i } from "@fortawesome/free-brands-svg-icons/faPadlet";
import { definition as m3a } from "@fortawesome/free-brands-svg-icons/faPadlet";
import { definition as M9i } from "@fortawesome/free-brands-svg-icons/faPage4";
import { definition as P3a } from "@fortawesome/free-brands-svg-icons/faPage4";
import { definition as w9i } from "@fortawesome/free-brands-svg-icons/faPagelines";
import { definition as w3a } from "@fortawesome/free-brands-svg-icons/faPagelines";
import { definition as N9i } from "@fortawesome/free-brands-svg-icons/faPalfed";
import { definition as z3a } from "@fortawesome/free-brands-svg-icons/faPalfed";
import { definition as z9i } from "@fortawesome/free-brands-svg-icons/faPatreon";
import { definition as C3a } from "@fortawesome/free-brands-svg-icons/faPatreon";
import { definition as L9i } from "@fortawesome/free-brands-svg-icons/faPaypal";
import { definition as $3a } from "@fortawesome/free-brands-svg-icons/faPaypal";
import { definition as C9i } from "@fortawesome/free-brands-svg-icons/faPerbyte";
import { definition as b3a } from "@fortawesome/free-brands-svg-icons/faPerbyte";
import { definition as D9i } from "@fortawesome/free-brands-svg-icons/faPeriscope";
import { definition as y3a } from "@fortawesome/free-brands-svg-icons/faPeriscope";
import { definition as $9i } from "@fortawesome/free-brands-svg-icons/faPhabricator";
import { definition as k3a } from "@fortawesome/free-brands-svg-icons/faPhabricator";
import { definition as _9i } from "@fortawesome/free-brands-svg-icons/faPhoenixFramework";
import { definition as j3a } from "@fortawesome/free-brands-svg-icons/faPhoenixFramework";
import { definition as b9i } from "@fortawesome/free-brands-svg-icons/faPhoenixSquadron";
import { definition as T3a } from "@fortawesome/free-brands-svg-icons/faPhoenixSquadron";
import { definition as S9i } from "@fortawesome/free-brands-svg-icons/faPhp";
import { definition as H3a } from "@fortawesome/free-brands-svg-icons/faPhp";
import { definition as y9i } from "@fortawesome/free-brands-svg-icons/faPiedPiper";
import { definition as U3a } from "@fortawesome/free-brands-svg-icons/faPiedPiper";
import { definition as O9i } from "@fortawesome/free-brands-svg-icons/faPiedPiperAlt";
import { definition as G3a } from "@fortawesome/free-brands-svg-icons/faPiedPiperAlt";
import { definition as k9i } from "@fortawesome/free-brands-svg-icons/faPiedPiperHat";
import { definition as E3a } from "@fortawesome/free-brands-svg-icons/faPiedPiperHat";
import { definition as A9i } from "@fortawesome/free-brands-svg-icons/faPiedPiperPp";
import { definition as I3a } from "@fortawesome/free-brands-svg-icons/faPiedPiperPp";
import { definition as j9i } from "@fortawesome/free-brands-svg-icons/faPiedPiperSquare";
import { definition as X3a } from "@fortawesome/free-brands-svg-icons/faPiedPiperSquare";
import { definition as B9i } from "@fortawesome/free-brands-svg-icons/faPinterest";
import { definition as J3a } from "@fortawesome/free-brands-svg-icons/faPinterest";
import { definition as T9i } from "@fortawesome/free-brands-svg-icons/faPinterestP";
import { definition as Z3a } from "@fortawesome/free-brands-svg-icons/faPinterestP";
import { definition as F9i } from "@fortawesome/free-brands-svg-icons/faPinterestSquare";
import { definition as x3a } from "@fortawesome/free-brands-svg-icons/faPinterestSquare";
import { definition as H9i } from "@fortawesome/free-brands-svg-icons/faPix";
import { definition as a0a } from "@fortawesome/free-brands-svg-icons/faPix";
import { definition as R9i } from "@fortawesome/free-brands-svg-icons/faPixiv";
import { definition as n0a } from "@fortawesome/free-brands-svg-icons/faPixiv";
import { definition as U9i } from "@fortawesome/free-brands-svg-icons/faPlaystation";
import { definition as c0a } from "@fortawesome/free-brands-svg-icons/faPlaystation";
import { definition as q9i } from "@fortawesome/free-brands-svg-icons/faProductHunt";
import { definition as o0a } from "@fortawesome/free-brands-svg-icons/faProductHunt";
import { definition as G9i } from "@fortawesome/free-brands-svg-icons/faPushed";
import { definition as d0a } from "@fortawesome/free-brands-svg-icons/faPushed";
import { definition as W9i } from "@fortawesome/free-brands-svg-icons/faPython";
import { definition as s0a } from "@fortawesome/free-brands-svg-icons/faPython";
import { definition as E9i } from "@fortawesome/free-brands-svg-icons/faQq";
import { definition as v0a } from "@fortawesome/free-brands-svg-icons/faQq";
import { definition as V9i } from "@fortawesome/free-brands-svg-icons/faQuinscape";
import { definition as m0a } from "@fortawesome/free-brands-svg-icons/faQuinscape";
import { definition as I9i } from "@fortawesome/free-brands-svg-icons/faQuora";
import { definition as P0a } from "@fortawesome/free-brands-svg-icons/faQuora";
import { definition as K9i } from "@fortawesome/free-brands-svg-icons/faRProject";
import { definition as w0a } from "@fortawesome/free-brands-svg-icons/faRProject";
import { definition as X9i } from "@fortawesome/free-brands-svg-icons/faRaspberryPi";
import { definition as z0a } from "@fortawesome/free-brands-svg-icons/faRaspberryPi";
import { definition as Q9i } from "@fortawesome/free-brands-svg-icons/faRavelry";
import { definition as C0a } from "@fortawesome/free-brands-svg-icons/faRavelry";
import { definition as J9i } from "@fortawesome/free-brands-svg-icons/faReact";
import { definition as $0a } from "@fortawesome/free-brands-svg-icons/faReact";
import { definition as Y9i } from "@fortawesome/free-brands-svg-icons/faReacteurope";
import { definition as b0a } from "@fortawesome/free-brands-svg-icons/faReacteurope";
import { definition as Z9i } from "@fortawesome/free-brands-svg-icons/faReadme";
import { definition as y0a } from "@fortawesome/free-brands-svg-icons/faReadme";
import { definition as p9i } from "@fortawesome/free-brands-svg-icons/faRebel";
import { definition as k0a } from "@fortawesome/free-brands-svg-icons/faRebel";
import { definition as x9i } from "@fortawesome/free-brands-svg-icons/faRedRiver";
import { definition as j0a } from "@fortawesome/free-brands-svg-icons/faRedRiver";
import { definition as isi } from "@fortawesome/free-brands-svg-icons/faReddit";
import { definition as T0a } from "@fortawesome/free-brands-svg-icons/faReddit";
import { definition as asi } from "@fortawesome/free-brands-svg-icons/faRedditAlien";
import { definition as H0a } from "@fortawesome/free-brands-svg-icons/faRedditAlien";
import { definition as esi } from "@fortawesome/free-brands-svg-icons/faRedditSquare";
import { definition as U0a } from "@fortawesome/free-brands-svg-icons/faRedditSquare";
import { definition as nsi } from "@fortawesome/free-brands-svg-icons/faRedhat";
import { definition as G0a } from "@fortawesome/free-brands-svg-icons/faRedhat";
import { definition as fsi } from "@fortawesome/free-brands-svg-icons/faRendact";
import { definition as E0a } from "@fortawesome/free-brands-svg-icons/faRendact";
import { definition as csi } from "@fortawesome/free-brands-svg-icons/faRenren";
import { definition as I0a } from "@fortawesome/free-brands-svg-icons/faRenren";
import { definition as tsi } from "@fortawesome/free-brands-svg-icons/faReplyd";
import { definition as X0a } from "@fortawesome/free-brands-svg-icons/faReplyd";
import { definition as osi } from "@fortawesome/free-brands-svg-icons/faResearchgate";
import { definition as J0a } from "@fortawesome/free-brands-svg-icons/faResearchgate";
import { definition as lsi } from "@fortawesome/free-brands-svg-icons/faResolving";
import { definition as Z0a } from "@fortawesome/free-brands-svg-icons/faResolving";
import { definition as dsi } from "@fortawesome/free-brands-svg-icons/faRev";
import { definition as x0a } from "@fortawesome/free-brands-svg-icons/faRev";
import { definition as rsi } from "@fortawesome/free-brands-svg-icons/faRocketchat";
import { definition as aea } from "@fortawesome/free-brands-svg-icons/faRocketchat";
import { definition as ssi } from "@fortawesome/free-brands-svg-icons/faRockrms";
import { definition as nea } from "@fortawesome/free-brands-svg-icons/faRockrms";
import { definition as hsi } from "@fortawesome/free-brands-svg-icons/faRust";
import { definition as cea } from "@fortawesome/free-brands-svg-icons/faRust";
import { definition as vsi } from "@fortawesome/free-brands-svg-icons/faSafari";
import { definition as oea } from "@fortawesome/free-brands-svg-icons/faSafari";
import { definition as usi } from "@fortawesome/free-brands-svg-icons/faSalesforce";
import { definition as dea } from "@fortawesome/free-brands-svg-icons/faSalesforce";
import { definition as msi } from "@fortawesome/free-brands-svg-icons/faSass";
import { definition as sea } from "@fortawesome/free-brands-svg-icons/faSass";
import { definition as gsi } from "@fortawesome/free-brands-svg-icons/faSchlix";
import { definition as vea } from "@fortawesome/free-brands-svg-icons/faSchlix";
import { definition as Psi } from "@fortawesome/free-brands-svg-icons/faScreenpal";
import { definition as mea } from "@fortawesome/free-brands-svg-icons/faScreenpal";
import { definition as Msi } from "@fortawesome/free-brands-svg-icons/faScribd";
import { definition as Pea } from "@fortawesome/free-brands-svg-icons/faScribd";
import { definition as wsi } from "@fortawesome/free-brands-svg-icons/faSearchengin";
import { definition as wea } from "@fortawesome/free-brands-svg-icons/faSearchengin";
import { definition as Nsi } from "@fortawesome/free-brands-svg-icons/faSellcast";
import { definition as zea } from "@fortawesome/free-brands-svg-icons/faSellcast";
import { definition as zsi } from "@fortawesome/free-brands-svg-icons/faSellsy";
import { definition as Cea } from "@fortawesome/free-brands-svg-icons/faSellsy";
import { definition as Lsi } from "@fortawesome/free-brands-svg-icons/faServicestack";
import { definition as $ea } from "@fortawesome/free-brands-svg-icons/faServicestack";
import { definition as Csi } from "@fortawesome/free-brands-svg-icons/faShirtsinbulk";
import { definition as bea } from "@fortawesome/free-brands-svg-icons/faShirtsinbulk";
import { definition as Dsi } from "@fortawesome/free-brands-svg-icons/faShoelace";
import { definition as yea } from "@fortawesome/free-brands-svg-icons/faShoelace";
import { definition as $si } from "@fortawesome/free-brands-svg-icons/faShopify";
import { definition as kea } from "@fortawesome/free-brands-svg-icons/faShopify";
import { definition as _si } from "@fortawesome/free-brands-svg-icons/faShopware";
import { definition as jea } from "@fortawesome/free-brands-svg-icons/faShopware";
import { definition as bsi } from "@fortawesome/free-brands-svg-icons/faSignalMessenger";
import { definition as Tea } from "@fortawesome/free-brands-svg-icons/faSignalMessenger";
import { definition as Ssi } from "@fortawesome/free-brands-svg-icons/faSimplybuilt";
import { definition as Hea } from "@fortawesome/free-brands-svg-icons/faSimplybuilt";
import { definition as ysi } from "@fortawesome/free-brands-svg-icons/faSistrix";
import { definition as Uea } from "@fortawesome/free-brands-svg-icons/faSistrix";
import { definition as Osi } from "@fortawesome/free-brands-svg-icons/faSith";
import { definition as Gea } from "@fortawesome/free-brands-svg-icons/faSith";
import { definition as ksi } from "@fortawesome/free-brands-svg-icons/faSitrox";
import { definition as Eea } from "@fortawesome/free-brands-svg-icons/faSitrox";
import { definition as Asi } from "@fortawesome/free-brands-svg-icons/faSketch";
import { definition as Iea } from "@fortawesome/free-brands-svg-icons/faSketch";
import { definition as jsi } from "@fortawesome/free-brands-svg-icons/faSkyatlas";
import { definition as Xea } from "@fortawesome/free-brands-svg-icons/faSkyatlas";
import { definition as Bsi } from "@fortawesome/free-brands-svg-icons/faSkype";
import { definition as Jea } from "@fortawesome/free-brands-svg-icons/faSkype";
import { definition as Tsi } from "@fortawesome/free-brands-svg-icons/faSlack";
import { definition as Zea } from "@fortawesome/free-brands-svg-icons/faSlack";
import { definition as Fsi } from "@fortawesome/free-brands-svg-icons/faSlackHash";
import { definition as xea } from "@fortawesome/free-brands-svg-icons/faSlackHash";
import { definition as Hsi } from "@fortawesome/free-brands-svg-icons/faSlideshare";
import { definition as ana } from "@fortawesome/free-brands-svg-icons/faSlideshare";
import { definition as Rsi } from "@fortawesome/free-brands-svg-icons/faSnapchat";
import { definition as nna } from "@fortawesome/free-brands-svg-icons/faSnapchat";
import { definition as Usi } from "@fortawesome/free-brands-svg-icons/faSnapchatGhost";
import { definition as cna } from "@fortawesome/free-brands-svg-icons/faSnapchatGhost";
import { definition as qsi } from "@fortawesome/free-brands-svg-icons/faSnapchatSquare";
import { definition as ona } from "@fortawesome/free-brands-svg-icons/faSnapchatSquare";
import { definition as Gsi } from "@fortawesome/free-brands-svg-icons/faSoundcloud";
import { definition as dna } from "@fortawesome/free-brands-svg-icons/faSoundcloud";
import { definition as Wsi } from "@fortawesome/free-brands-svg-icons/faSourcetree";
import { definition as sna } from "@fortawesome/free-brands-svg-icons/faSourcetree";
import { definition as Esi } from "@fortawesome/free-brands-svg-icons/faSpaceAwesome";
import { definition as vna } from "@fortawesome/free-brands-svg-icons/faSpaceAwesome";
import { definition as Vsi } from "@fortawesome/free-brands-svg-icons/faSpeakap";
import { definition as mna } from "@fortawesome/free-brands-svg-icons/faSpeakap";
import { definition as Isi } from "@fortawesome/free-brands-svg-icons/faSpeakerDeck";
import { definition as Pna } from "@fortawesome/free-brands-svg-icons/faSpeakerDeck";
import { definition as Ksi } from "@fortawesome/free-brands-svg-icons/faSpotify";
import { definition as wna } from "@fortawesome/free-brands-svg-icons/faSpotify";
import { definition as Xsi } from "@fortawesome/free-brands-svg-icons/faSquareBehance";
import { definition as zna } from "@fortawesome/free-brands-svg-icons/faSquareBehance";
import { definition as Qsi } from "@fortawesome/free-brands-svg-icons/faSquareDribbble";
import { definition as Cna } from "@fortawesome/free-brands-svg-icons/faSquareDribbble";
import { definition as Jsi } from "@fortawesome/free-brands-svg-icons/faSquareFacebook";
import { definition as $na } from "@fortawesome/free-brands-svg-icons/faSquareFacebook";
import { definition as Ysi } from "@fortawesome/free-brands-svg-icons/faSquareFontAwesome";
import { definition as bna } from "@fortawesome/free-brands-svg-icons/faSquareFontAwesome";
import { definition as Zsi } from "@fortawesome/free-brands-svg-icons/faSquareFontAwesomeStroke";
import { definition as yna } from "@fortawesome/free-brands-svg-icons/faSquareFontAwesomeStroke";
import { definition as psi } from "@fortawesome/free-brands-svg-icons/faSquareGit";
import { definition as kna } from "@fortawesome/free-brands-svg-icons/faSquareGit";
import { definition as xsi } from "@fortawesome/free-brands-svg-icons/faSquareGithub";
import { definition as jna } from "@fortawesome/free-brands-svg-icons/faSquareGithub";
import { definition as ihi } from "@fortawesome/free-brands-svg-icons/faSquareGitlab";
import { definition as Tna } from "@fortawesome/free-brands-svg-icons/faSquareGitlab";
import { definition as ahi } from "@fortawesome/free-brands-svg-icons/faSquareGooglePlus";
import { definition as Hna } from "@fortawesome/free-brands-svg-icons/faSquareGooglePlus";
import { definition as ehi } from "@fortawesome/free-brands-svg-icons/faSquareHackerNews";
import { definition as Una } from "@fortawesome/free-brands-svg-icons/faSquareHackerNews";
import { definition as nhi } from "@fortawesome/free-brands-svg-icons/faSquareInstagram";
import { definition as Gna } from "@fortawesome/free-brands-svg-icons/faSquareInstagram";
import { definition as fhi } from "@fortawesome/free-brands-svg-icons/faSquareJs";
import { definition as Ena } from "@fortawesome/free-brands-svg-icons/faSquareJs";
import { definition as chi } from "@fortawesome/free-brands-svg-icons/faSquareKickstarter";
import { definition as Ina } from "@fortawesome/free-brands-svg-icons/faSquareKickstarter";
import { definition as thi } from "@fortawesome/free-brands-svg-icons/faSquareLastfm";
import { definition as Xna } from "@fortawesome/free-brands-svg-icons/faSquareLastfm";
import { definition as ohi } from "@fortawesome/free-brands-svg-icons/faSquareLetterboxd";
import { definition as Jna } from "@fortawesome/free-brands-svg-icons/faSquareLetterboxd";
import { definition as lhi } from "@fortawesome/free-brands-svg-icons/faSquareOdnoklassniki";
import { definition as Zna } from "@fortawesome/free-brands-svg-icons/faSquareOdnoklassniki";
import { definition as dhi } from "@fortawesome/free-brands-svg-icons/faSquarePiedPiper";
import { definition as xna } from "@fortawesome/free-brands-svg-icons/faSquarePiedPiper";
import { definition as rhi } from "@fortawesome/free-brands-svg-icons/faSquarePinterest";
import { definition as a6a } from "@fortawesome/free-brands-svg-icons/faSquarePinterest";
import { definition as shi } from "@fortawesome/free-brands-svg-icons/faSquareReddit";
import { definition as n6a } from "@fortawesome/free-brands-svg-icons/faSquareReddit";
import { definition as hhi } from "@fortawesome/free-brands-svg-icons/faSquareSnapchat";
import { definition as c6a } from "@fortawesome/free-brands-svg-icons/faSquareSnapchat";
import { definition as vhi } from "@fortawesome/free-brands-svg-icons/faSquareSteam";
import { definition as o6a } from "@fortawesome/free-brands-svg-icons/faSquareSteam";
import { definition as uhi } from "@fortawesome/free-brands-svg-icons/faSquareThreads";
import { definition as d6a } from "@fortawesome/free-brands-svg-icons/faSquareThreads";
import { definition as mhi } from "@fortawesome/free-brands-svg-icons/faSquareTumblr";
import { definition as s6a } from "@fortawesome/free-brands-svg-icons/faSquareTumblr";
import { definition as ghi } from "@fortawesome/free-brands-svg-icons/faSquareTwitter";
import { definition as v6a } from "@fortawesome/free-brands-svg-icons/faSquareTwitter";
import { definition as Phi } from "@fortawesome/free-brands-svg-icons/faSquareUpwork";
import { definition as m6a } from "@fortawesome/free-brands-svg-icons/faSquareUpwork";
import { definition as Mhi } from "@fortawesome/free-brands-svg-icons/faSquareViadeo";
import { definition as P6a } from "@fortawesome/free-brands-svg-icons/faSquareViadeo";
import { definition as whi } from "@fortawesome/free-brands-svg-icons/faSquareVimeo";
import { definition as w6a } from "@fortawesome/free-brands-svg-icons/faSquareVimeo";
import { definition as Nhi } from "@fortawesome/free-brands-svg-icons/faSquareWebAwesome";
import { definition as z6a } from "@fortawesome/free-brands-svg-icons/faSquareWebAwesome";
import { definition as zhi } from "@fortawesome/free-brands-svg-icons/faSquareWebAwesomeStroke";
import { definition as C6a } from "@fortawesome/free-brands-svg-icons/faSquareWebAwesomeStroke";
import { definition as Lhi } from "@fortawesome/free-brands-svg-icons/faSquareWhatsapp";
import { definition as $6a } from "@fortawesome/free-brands-svg-icons/faSquareWhatsapp";
import { definition as Chi } from "@fortawesome/free-brands-svg-icons/faSquareXTwitter";
import { definition as b6a } from "@fortawesome/free-brands-svg-icons/faSquareXTwitter";
import { definition as Dhi } from "@fortawesome/free-brands-svg-icons/faSquareXing";
import { definition as y6a } from "@fortawesome/free-brands-svg-icons/faSquareXing";
import { definition as $hi } from "@fortawesome/free-brands-svg-icons/faSquareYoutube";
import { definition as k6a } from "@fortawesome/free-brands-svg-icons/faSquareYoutube";
import { definition as _hi } from "@fortawesome/free-brands-svg-icons/faSquarespace";
import { definition as j6a } from "@fortawesome/free-brands-svg-icons/faSquarespace";
import { definition as bhi } from "@fortawesome/free-brands-svg-icons/faStackExchange";
import { definition as T6a } from "@fortawesome/free-brands-svg-icons/faStackExchange";
import { definition as Shi } from "@fortawesome/free-brands-svg-icons/faStackOverflow";
import { definition as H6a } from "@fortawesome/free-brands-svg-icons/faStackOverflow";
import { definition as yhi } from "@fortawesome/free-brands-svg-icons/faStackpath";
import { definition as U6a } from "@fortawesome/free-brands-svg-icons/faStackpath";
import { definition as Ohi } from "@fortawesome/free-brands-svg-icons/faStaylinked";
import { definition as G6a } from "@fortawesome/free-brands-svg-icons/faStaylinked";
import { definition as khi } from "@fortawesome/free-brands-svg-icons/faSteam";
import { definition as E6a } from "@fortawesome/free-brands-svg-icons/faSteam";
import { definition as Ahi } from "@fortawesome/free-brands-svg-icons/faSteamSquare";
import { definition as I6a } from "@fortawesome/free-brands-svg-icons/faSteamSquare";
import { definition as jhi } from "@fortawesome/free-brands-svg-icons/faSteamSymbol";
import { definition as X6a } from "@fortawesome/free-brands-svg-icons/faSteamSymbol";
import { definition as Bhi } from "@fortawesome/free-brands-svg-icons/faStickerMule";
import { definition as J6a } from "@fortawesome/free-brands-svg-icons/faStickerMule";
import { definition as Thi } from "@fortawesome/free-brands-svg-icons/faStrava";
import { definition as Z6a } from "@fortawesome/free-brands-svg-icons/faStrava";
import { definition as Fhi } from "@fortawesome/free-brands-svg-icons/faStripe";
import { definition as x6a } from "@fortawesome/free-brands-svg-icons/faStripe";
import { definition as Hhi } from "@fortawesome/free-brands-svg-icons/faStripeS";
import { definition as afa } from "@fortawesome/free-brands-svg-icons/faStripeS";
import { definition as Rhi } from "@fortawesome/free-brands-svg-icons/faStubber";
import { definition as nfa } from "@fortawesome/free-brands-svg-icons/faStubber";
import { definition as Uhi } from "@fortawesome/free-brands-svg-icons/faStudiovinari";
import { definition as cfa } from "@fortawesome/free-brands-svg-icons/faStudiovinari";
import { definition as qhi } from "@fortawesome/free-brands-svg-icons/faStumbleupon";
import { definition as ofa } from "@fortawesome/free-brands-svg-icons/faStumbleupon";
import { definition as Ghi } from "@fortawesome/free-brands-svg-icons/faStumbleuponCircle";
import { definition as dfa } from "@fortawesome/free-brands-svg-icons/faStumbleuponCircle";
import { definition as Whi } from "@fortawesome/free-brands-svg-icons/faSuperpowers";
import { definition as sfa } from "@fortawesome/free-brands-svg-icons/faSuperpowers";
import { definition as Ehi } from "@fortawesome/free-brands-svg-icons/faSupple";
import { definition as vfa } from "@fortawesome/free-brands-svg-icons/faSupple";
import { definition as Vhi } from "@fortawesome/free-brands-svg-icons/faSuse";
import { definition as mfa } from "@fortawesome/free-brands-svg-icons/faSuse";
import { definition as Ihi } from "@fortawesome/free-brands-svg-icons/faSwift";
import { definition as Pfa } from "@fortawesome/free-brands-svg-icons/faSwift";
import { definition as Khi } from "@fortawesome/free-brands-svg-icons/faSymfony";
import { definition as wfa } from "@fortawesome/free-brands-svg-icons/faSymfony";
import { definition as Xhi } from "@fortawesome/free-brands-svg-icons/faTeamspeak";
import { definition as zfa } from "@fortawesome/free-brands-svg-icons/faTeamspeak";
import { definition as Qhi } from "@fortawesome/free-brands-svg-icons/faTelegram";
import { definition as Cfa } from "@fortawesome/free-brands-svg-icons/faTelegram";
import { definition as Jhi } from "@fortawesome/free-brands-svg-icons/faTelegramPlane";
import { definition as $fa } from "@fortawesome/free-brands-svg-icons/faTelegramPlane";
import { definition as Yhi } from "@fortawesome/free-brands-svg-icons/faTencentWeibo";
import { definition as bfa } from "@fortawesome/free-brands-svg-icons/faTencentWeibo";
import { definition as Zhi } from "@fortawesome/free-brands-svg-icons/faTheRedYeti";
import { definition as yfa } from "@fortawesome/free-brands-svg-icons/faTheRedYeti";
import { definition as phi } from "@fortawesome/free-brands-svg-icons/faThemeco";
import { definition as kfa } from "@fortawesome/free-brands-svg-icons/faThemeco";
import { definition as xhi } from "@fortawesome/free-brands-svg-icons/faThemeisle";
import { definition as jfa } from "@fortawesome/free-brands-svg-icons/faThemeisle";
import { definition as ivi } from "@fortawesome/free-brands-svg-icons/faThinkPeaks";
import { definition as Tfa } from "@fortawesome/free-brands-svg-icons/faThinkPeaks";
import { definition as avi } from "@fortawesome/free-brands-svg-icons/faThreads";
import { definition as Hfa } from "@fortawesome/free-brands-svg-icons/faThreads";
import { definition as evi } from "@fortawesome/free-brands-svg-icons/faTiktok";
import { definition as Ufa } from "@fortawesome/free-brands-svg-icons/faTiktok";
import { definition as nvi } from "@fortawesome/free-brands-svg-icons/faTradeFederation";
import { definition as Gfa } from "@fortawesome/free-brands-svg-icons/faTradeFederation";
import { definition as fvi } from "@fortawesome/free-brands-svg-icons/faTrello";
import { definition as Efa } from "@fortawesome/free-brands-svg-icons/faTrello";
import { definition as cvi } from "@fortawesome/free-brands-svg-icons/faTumblr";
import { definition as Ifa } from "@fortawesome/free-brands-svg-icons/faTumblr";
import { definition as tvi } from "@fortawesome/free-brands-svg-icons/faTumblrSquare";
import { definition as Xfa } from "@fortawesome/free-brands-svg-icons/faTumblrSquare";
import { definition as ovi } from "@fortawesome/free-brands-svg-icons/faTwitch";
import { definition as Jfa } from "@fortawesome/free-brands-svg-icons/faTwitch";
import { definition as lvi } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { definition as Zfa } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { definition as dvi } from "@fortawesome/free-brands-svg-icons/faTwitterSquare";
import { definition as xfa } from "@fortawesome/free-brands-svg-icons/faTwitterSquare";
import { definition as rvi } from "@fortawesome/free-brands-svg-icons/faTypo3";
import { definition as aca } from "@fortawesome/free-brands-svg-icons/faTypo3";
import { definition as svi } from "@fortawesome/free-brands-svg-icons/faUber";
import { definition as nca } from "@fortawesome/free-brands-svg-icons/faUber";
import { definition as hvi } from "@fortawesome/free-brands-svg-icons/faUbuntu";
import { definition as cca } from "@fortawesome/free-brands-svg-icons/faUbuntu";
import { definition as vvi } from "@fortawesome/free-brands-svg-icons/faUikit";
import { definition as oca } from "@fortawesome/free-brands-svg-icons/faUikit";
import { definition as uvi } from "@fortawesome/free-brands-svg-icons/faUmbraco";
import { definition as dca } from "@fortawesome/free-brands-svg-icons/faUmbraco";
import { definition as mvi } from "@fortawesome/free-brands-svg-icons/faUncharted";
import { definition as sca } from "@fortawesome/free-brands-svg-icons/faUncharted";
import { definition as gvi } from "@fortawesome/free-brands-svg-icons/faUniregistry";
import { definition as vca } from "@fortawesome/free-brands-svg-icons/faUniregistry";
import { definition as Pvi } from "@fortawesome/free-brands-svg-icons/faUnity";
import { definition as mca } from "@fortawesome/free-brands-svg-icons/faUnity";
import { definition as Mvi } from "@fortawesome/free-brands-svg-icons/faUnsplash";
import { definition as Pca } from "@fortawesome/free-brands-svg-icons/faUnsplash";
import { definition as wvi } from "@fortawesome/free-brands-svg-icons/faUntappd";
import { definition as wca } from "@fortawesome/free-brands-svg-icons/faUntappd";
import { definition as Nvi } from "@fortawesome/free-brands-svg-icons/faUps";
import { definition as zca } from "@fortawesome/free-brands-svg-icons/faUps";
import { definition as zvi } from "@fortawesome/free-brands-svg-icons/faUpwork";
import { definition as Cca } from "@fortawesome/free-brands-svg-icons/faUpwork";
import { definition as Lvi } from "@fortawesome/free-brands-svg-icons/faUsb";
import { definition as $ca } from "@fortawesome/free-brands-svg-icons/faUsb";
import { definition as Cvi } from "@fortawesome/free-brands-svg-icons/faUsps";
import { definition as bca } from "@fortawesome/free-brands-svg-icons/faUsps";
import { definition as Dvi } from "@fortawesome/free-brands-svg-icons/faUssunnah";
import { definition as yca } from "@fortawesome/free-brands-svg-icons/faUssunnah";
import { definition as $vi } from "@fortawesome/free-brands-svg-icons/faVaadin";
import { definition as kca } from "@fortawesome/free-brands-svg-icons/faVaadin";
import { definition as _vi } from "@fortawesome/free-brands-svg-icons/faViacoin";
import { definition as jca } from "@fortawesome/free-brands-svg-icons/faViacoin";
import { definition as bvi } from "@fortawesome/free-brands-svg-icons/faViadeo";
import { definition as Tca } from "@fortawesome/free-brands-svg-icons/faViadeo";
import { definition as Svi } from "@fortawesome/free-brands-svg-icons/faViadeoSquare";
import { definition as Hca } from "@fortawesome/free-brands-svg-icons/faViadeoSquare";
import { definition as yvi } from "@fortawesome/free-brands-svg-icons/faViber";
import { definition as Uca } from "@fortawesome/free-brands-svg-icons/faViber";
import { definition as Ovi } from "@fortawesome/free-brands-svg-icons/faVimeo";
import { definition as Gca } from "@fortawesome/free-brands-svg-icons/faVimeo";
import { definition as kvi } from "@fortawesome/free-brands-svg-icons/faVimeoSquare";
import { definition as Eca } from "@fortawesome/free-brands-svg-icons/faVimeoSquare";
import { definition as Avi } from "@fortawesome/free-brands-svg-icons/faVimeoV";
import { definition as Ica } from "@fortawesome/free-brands-svg-icons/faVimeoV";
import { definition as jvi } from "@fortawesome/free-brands-svg-icons/faVine";
import { definition as Xca } from "@fortawesome/free-brands-svg-icons/faVine";
import { definition as Bvi } from "@fortawesome/free-brands-svg-icons/faVk";
import { definition as Jca } from "@fortawesome/free-brands-svg-icons/faVk";
import { definition as Tvi } from "@fortawesome/free-brands-svg-icons/faVnv";
import { definition as Zca } from "@fortawesome/free-brands-svg-icons/faVnv";
import { definition as Fvi } from "@fortawesome/free-brands-svg-icons/faVuejs";
import { definition as xca } from "@fortawesome/free-brands-svg-icons/faVuejs";
import { definition as Hvi } from "@fortawesome/free-brands-svg-icons/faWatchmanMonitoring";
import { definition as a8a } from "@fortawesome/free-brands-svg-icons/faWatchmanMonitoring";
import { definition as Rvi } from "@fortawesome/free-brands-svg-icons/faWaze";
import { definition as n8a } from "@fortawesome/free-brands-svg-icons/faWaze";
import { definition as Uvi } from "@fortawesome/free-brands-svg-icons/faWebflow";
import { definition as c8a } from "@fortawesome/free-brands-svg-icons/faWebflow";
import { definition as qvi } from "@fortawesome/free-brands-svg-icons/faWeebly";
import { definition as o8a } from "@fortawesome/free-brands-svg-icons/faWeebly";
import { definition as Gvi } from "@fortawesome/free-brands-svg-icons/faWeibo";
import { definition as d8a } from "@fortawesome/free-brands-svg-icons/faWeibo";
import { definition as Wvi } from "@fortawesome/free-brands-svg-icons/faWeixin";
import { definition as s8a } from "@fortawesome/free-brands-svg-icons/faWeixin";
import { definition as Evi } from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import { definition as v8a } from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import { definition as Vvi } from "@fortawesome/free-brands-svg-icons/faWhatsappSquare";
import { definition as m8a } from "@fortawesome/free-brands-svg-icons/faWhatsappSquare";
import { definition as Ivi } from "@fortawesome/free-brands-svg-icons/faWhmcs";
import { definition as P8a } from "@fortawesome/free-brands-svg-icons/faWhmcs";
import { definition as Kvi } from "@fortawesome/free-brands-svg-icons/faWikipediaW";
import { definition as w8a } from "@fortawesome/free-brands-svg-icons/faWikipediaW";
import { definition as Xvi } from "@fortawesome/free-brands-svg-icons/faWindows";
import { definition as z8a } from "@fortawesome/free-brands-svg-icons/faWindows";
import { definition as Qvi } from "@fortawesome/free-brands-svg-icons/faWirsindhandwerk";
import { definition as C8a } from "@fortawesome/free-brands-svg-icons/faWirsindhandwerk";
import { definition as Jvi } from "@fortawesome/free-brands-svg-icons/faWix";
import { definition as $8a } from "@fortawesome/free-brands-svg-icons/faWix";
import { definition as Yvi } from "@fortawesome/free-brands-svg-icons/faWizardsOfTheCoast";
import { definition as b8a } from "@fortawesome/free-brands-svg-icons/faWizardsOfTheCoast";
import { definition as Zvi } from "@fortawesome/free-brands-svg-icons/faWodu";
import { definition as y8a } from "@fortawesome/free-brands-svg-icons/faWodu";
import { definition as pvi } from "@fortawesome/free-brands-svg-icons/faWolfPackBattalion";
import { definition as k8a } from "@fortawesome/free-brands-svg-icons/faWolfPackBattalion";
import { definition as xvi } from "@fortawesome/free-brands-svg-icons/faWordpress";
import { definition as j8a } from "@fortawesome/free-brands-svg-icons/faWordpress";
import { definition as iui } from "@fortawesome/free-brands-svg-icons/faWordpressSimple";
import { definition as T8a } from "@fortawesome/free-brands-svg-icons/faWordpressSimple";
import { definition as aui } from "@fortawesome/free-brands-svg-icons/faWpbeginner";
import { definition as H8a } from "@fortawesome/free-brands-svg-icons/faWpbeginner";
import { definition as eui } from "@fortawesome/free-brands-svg-icons/faWpexplorer";
import { definition as U8a } from "@fortawesome/free-brands-svg-icons/faWpexplorer";
import { definition as nui } from "@fortawesome/free-brands-svg-icons/faWpforms";
import { definition as G8a } from "@fortawesome/free-brands-svg-icons/faWpforms";
import { definition as fui } from "@fortawesome/free-brands-svg-icons/faWpressr";
import { definition as E8a } from "@fortawesome/free-brands-svg-icons/faWpressr";
import { definition as cui } from "@fortawesome/free-brands-svg-icons/faWsh";
import { definition as I8a } from "@fortawesome/free-brands-svg-icons/faWsh";
import { definition as tui } from "@fortawesome/free-brands-svg-icons/faXTwitter";
import { definition as X8a } from "@fortawesome/free-brands-svg-icons/faXTwitter";
import { definition as oui } from "@fortawesome/free-brands-svg-icons/faXbox";
import { definition as J8a } from "@fortawesome/free-brands-svg-icons/faXbox";
import { definition as lui } from "@fortawesome/free-brands-svg-icons/faXing";
import { definition as Z8a } from "@fortawesome/free-brands-svg-icons/faXing";
import { definition as dui } from "@fortawesome/free-brands-svg-icons/faXingSquare";
import { definition as x8a } from "@fortawesome/free-brands-svg-icons/faXingSquare";
import { definition as rui } from "@fortawesome/free-brands-svg-icons/faYCombinator";
import { definition as a5a } from "@fortawesome/free-brands-svg-icons/faYCombinator";
import { definition as sui } from "@fortawesome/free-brands-svg-icons/faYahoo";
import { definition as n5a } from "@fortawesome/free-brands-svg-icons/faYahoo";
import { definition as hui } from "@fortawesome/free-brands-svg-icons/faYammer";
import { definition as c5a } from "@fortawesome/free-brands-svg-icons/faYammer";
import { definition as vui } from "@fortawesome/free-brands-svg-icons/faYandex";
import { definition as o5a } from "@fortawesome/free-brands-svg-icons/faYandex";
import { definition as uui } from "@fortawesome/free-brands-svg-icons/faYandexInternational";
import { definition as d5a } from "@fortawesome/free-brands-svg-icons/faYandexInternational";
import { definition as mui } from "@fortawesome/free-brands-svg-icons/faYarn";
import { definition as s5a } from "@fortawesome/free-brands-svg-icons/faYarn";
import { definition as gui } from "@fortawesome/free-brands-svg-icons/faYelp";
import { definition as v5a } from "@fortawesome/free-brands-svg-icons/faYelp";
import { definition as Pui } from "@fortawesome/free-brands-svg-icons/faYoast";
import { definition as m5a } from "@fortawesome/free-brands-svg-icons/faYoast";
import { definition as Mui } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { definition as P5a } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { definition as wui } from "@fortawesome/free-brands-svg-icons/faYoutubeSquare";
import { definition as w5a } from "@fortawesome/free-brands-svg-icons/faYoutubeSquare";
import { definition as Nui } from "@fortawesome/free-brands-svg-icons/faZhihu";
import { definition as z5a } from "@fortawesome/free-brands-svg-icons/faZhihu";
var L0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "00", f = 640, c = 512, e = [], t = "e467", o = "M144 32C64.5 32 0 96.5 0 176L0 336c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM64 176c0-44.2 35.8-80 80-80s80 35.8 80 80l0 160c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-160zM496 32c-79.5 0-144 64.5-144 144l0 160c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM416 176c0-44.2 35.8-80 80-80s80 35.8 80 80l0 160c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.fa00 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L0);
var C0 = {}, T = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hundred-points", f = 512, c = 512, e = [128175, "100"], t = "e41c", o = "M163 101.8C168 61.9 201.9 32 242 32c47.9 0 85 42 79 89.5L309 218.2c-5 39.8-38.9 69.8-79 69.8c-47.9 0-85-42-79-89.5L163 101.8zM242 96c-7.9 0-14.5 5.9-15.5 13.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6c7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6zM135.7 68l-32 224c-2.5 17.5-18.7 30-36.2 27.7S37.8 301.5 40.3 284L64.3 116.5l-19.7 8.7c-16.2 7.2-35.1 0-42-16.1s.6-35.1 16.8-42.3l72-32c10.6-4.7 22.9-3.4 32.1 3.5s13.8 18.2 12.2 29.7zm376 247.5c2.5 17.5-9.7 33.7-27.2 36.2l-448 64C19 418.2 2.8 406 .3 388.5S10 354.8 27.5 352.3l448-64c17.5-2.5 33.7 9.7 36.2 27.2zm0 96c2.5 17.5-9.7 33.7-27.2 36.2l-224 32c-17.5 2.5-33.7-9.7-36.2-27.2s9.7-33.7 27.2-36.2l224-32c17.5-2.5 33.7 9.7 36.2 27.2zM427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6c-46.9 0-83.7-40.3-79.5-87l7.3-80.4C351.9 63.5 386.4 32 427.7 32zm-15.7 78.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2c8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2c-8.2 0-15 6.2-15.7 14.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHundredPoints = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = T;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.fa100 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(C0);
var D0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "360-degrees", f = 640, c = 512, e = [], t = "e2dc", o = "M640 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l64 0L38.4 204.8c-7.3 9.7-8.4 22.7-3 33.5S51.9 256 64 256l16 0c26.5 0 48 21.5 48 48l0 48c0 17.7-14.3 32-32 32l-5.5 0c-8.5 0-16.6-3.4-22.6-9.4L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l13.3 13.3c18 18 42.4 28.1 67.9 28.1l5.5 0c53 0 96-43 96-96l0-48c0-47-29-87.3-70.1-103.9l63.7-84.9c7.3-9.7 8.4-22.7 3-33.5S172.1 64 160 64L32 64zm448 80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm96 224l0-224c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80s80-35.8 80-80zM288 160c0-17.7 14.3-32 32-32s32-14.3 32-32s-14.3-32-32-32c-53 0-96 43-96 96l0 128 0 .2 0 79.8c0 44.2 35.8 80 80 80s80-35.8 80-80l0-96c0-44.2-35.8-80-80-80c-5.5 0-10.8 .6-16 1.6l0-33.6zm0 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.fa360Degrees = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D0);
var $0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "abacus", f = 576, c = 512, e = [129518], t = "f640", o = "M512 96l0 112-64 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 64 0zm-96 32l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-128 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 128 0 0 32zm-160 0l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-96 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 96 0 0 32zm-128 0l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-64 0L64 96l64 0 0 32zM64 416l0-176 64 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-64 0zm96-32l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 96 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-96 0 0-32zm128-72l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 128 0 0 96-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-128 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24zm160 72l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-96 64 0 0 176-64 0 0-32zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAbacus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($0);
var _0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "accent-grave", f = 192, c = 512, e = [], t = "60", o = "M108.3 204.8L41.2 95c-6-9.8-9.2-21.2-9.2-32.7C32 28.1 59.7 0 93.9 0c29.2 0 54.4 20.4 60.6 49l27.1 126.6C187 200.5 168 224 142.5 224c-14 0-26.9-7.3-34.2-19.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAccentGrave = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_0);
var b0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "acorn", f = 448, c = 512, e = [], t = "f6ae", o = "M262.4 4.8c10.6 8 12.8 23 4.8 33.6l-4.8 6.4c-4.4 5.9-7.9 12.4-10.3 19.2L352 64c53 0 96 43 96 96c0 17.7-14.3 32-32 32L32 192c-17.7 0-32-14.3-32-32c0-53 43-96 96-96l106.4 0C206 46.7 213.3 30.3 224 16l4.8-6.4c8-10.6 23-12.8 33.6-4.8zM213.9 476.4C78.5 425.9 48 302.1 48 224l176 0 176 0c0 78.1-30.5 201.9-165.9 252.4c-6.5 2.4-13.7 2.4-20.2 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAcorn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b0);
var S0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "air-conditioner", f = 576, c = 512, e = [], t = "f8f4", o = "M64 0C28.7 0 0 28.7 0 64l0 96c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 0zM80 128l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 256l-64 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7c15.3-8.9 20.5-28.4 11.7-43.7s-28.4-20.5-43.7-11.7C83.4 349.4 64 380.4 64 416c0 53 43 96 96 96s96-43 96-96l0-160zm64 128c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1c-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7c9.6 5.6 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-64 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAirConditioner = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S0);
var y0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "airplay", f = 576, c = 512, e = [], t = "e089", o = "M480 96L96 96c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l69.5 0-50.7 50.7c-4 4-7.4 8.5-10.2 13.3L96 416c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 192c0 53-43 96-96 96l-8.6 0c-2.8-4.8-6.2-9.2-10.2-13.3L410.5 352l69.5 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32zM265.4 297.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAirplay = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y0);
var O0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "alarm-clock", f = 512, c = 512, e = [9200], t = "f34e", o = "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 184l0 94.1 41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlarmClock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O0);
var k0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "alarm-exclamation", f = 512, c = 512, e = [], t = "f843", o = "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlarmExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k0);
var A0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "alarm-plus", f = 512, c = 512, e = [], t = "f844", o = "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 176c-13.3 0-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlarmPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A0);
var j0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "alarm-snooze", f = 512, c = 512, e = [], t = "f845", o = "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 512c50.3 0 96.8-16.6 134.2-44.6l35.2 35.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-35.2-35.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288c0 50.3 16.6 96.8 44.6 134.2L41.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.2-35.2c37.4 28 83.8 44.6 134.1 44.6zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192l112 0c9.2 0 17.5 5.2 21.6 13.5s3 18-2.6 25.3L249.1 336l62.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L262.9 240 200 240c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlarmSnooze = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j0);
var B0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "album", f = 448, c = 512, e = [128189], t = "f89f", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM384 256A160 160 0 1 0 64 256a160 160 0 1 0 320 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlbum = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B0);
var T0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "album-circle-plus", f = 576, c = 512, e = [], t = "e48c", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 96.7c-5.3-.5-10.6-.7-16-.7c-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4c6.5 25.5 18.5 48.7 34.8 68.4L64 480c-35.3 0-64-28.7-64-64L0 96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208 0a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlbumCirclePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T0);
var F0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "album-circle-user", f = 576, c = 512, e = [], t = "e48d", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 96.7c-5.3-.5-10.6-.7-16-.7c-20.1 0-39.5 3.4-57.5 9.6C352.3 140 293.3 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c12.9 0 25.4-1.5 37.4-4.4c6.5 25.5 18.5 48.7 34.8 68.4L64 480c-35.3 0-64-28.7-64-64L0 96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C374.5 468.1 401.8 480 432 480s57.5-11.9 77.7-31.3zM480 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlbumCircleUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F0);
var H0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "album-collection", f = 512, c = 512, e = [], t = "f8a0", o = "M32 24c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42l352 0c24.2 0 44.6-18 47.6-42l32-256c1.7-13.7-2.5-27.4-11.6-37.7s-22.2-16.2-36-16.2L48 160zM440 344c0 75.1-82.4 136-184 136S72 419.1 72 344s82.4-136 184-136s184 60.9 184 136zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l432 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlbumCollection = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H0);
var R0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "album-collection-circle-plus", f = 640, c = 512, e = [], t = "e48e", o = "M32 24c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42l314.8 0c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.5 0 9 .2 13.4 .5c-2-5.9-5.2-11.5-9.4-16.3c-9.1-10.3-22.2-16.2-36-16.2L48 160zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l432 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlbumCollectionCirclePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R0);
var U0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "album-collection-circle-user", f = 640, c = 512, e = [], t = "e48f", o = "M32 24c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM48 160c-13.8 0-26.9 5.9-36 16.2S-1.3 200.3 .4 214l32 256c3 24 23.4 42 47.6 42l314.8 0c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.5 0 9 .2 13.4 .5c-2-5.9-5.2-11.5-9.4-16.3c-9.1-10.3-22.2-16.2-36-16.2L48 160zM256 376c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM40 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l432 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C553.5 468.1 526.2 480 496 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7zM448 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlbumCollectionCircleUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U0);
var q0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "alicorn", f = 640, c = 512, e = [], t = "f6b0", o = "M448 160l0 78.1 0 1.9s0 0 0 0c-.5 30-12.8 56.4-32 75.7L416 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-133.3c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3 .3 4.6 .3 6.9c0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1l-33.7 0c-13.8 0-26-8.8-30.4-21.9L95.3 437.7c-10.6-31.7-6.5-65.9 10-93.9c7.6-12.9 9.5-29.1 1.2-41.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56c0-44.6 33.2-81.5 76.3-87.2c13-21.4 35.2-36.5 61.1-40c3.8 15.3 9.2 29.8 16.5 43c11.3 20.4 27.4 37.7 49.9 49.8c6.3 3.4 13.1 6.4 20.3 8.8c-16.5-11.4-28.9-26-38.2-42.7C163.8 147.9 160 96.1 160 48c0-5.9 3.2-11.3 8.5-14.1s11.5-2.5 16.4 .8L320 124.8C321.7 55.6 378.4 0 448 0l16 0 16 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-5.7 0c5.2 4.6 9.6 10 13.1 16l79.3 0c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8L560 90.7l0 64.8c0 22.1-13.4 41.9-33.9 50.1c-26.1 10.4-55.7-.9-68.3-26L448 160zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlicorn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q0);
var G0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "alien", f = 448, c = 512, e = [128125], t = "f8f5", o = "M224 0C100.3 0 0 100.3 0 224C0 359.3 148.8 471.7 194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224C448 100.3 347.7 0 224 0zm32 306.3c0-45.4 36.8-82.3 82.3-82.3l32 0c7.6 0 13.7 6.1 13.7 13.7c0 45.4-36.8 82.3-82.3 82.3l-32 0c-7.6 0-13.7-6.1-13.7-13.7zM109.7 224c45.4 0 82.3 36.8 82.3 82.3c0 7.6-6.1 13.7-13.7 13.7l-32 0C100.8 320 64 283.2 64 237.7c0-7.6 6.1-13.7 13.7-13.7l32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlien = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G0);
var F = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "alien-8bit", f = 576, c = 512, e = [128126, "alien-monster"], t = "f8f6", o = "M96 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 16 48 0c8.8 0 16 7.2 16 16l0 48 128 0 0-48c0-8.8 7.2-16 16-16l48 0 0-16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 32 0 32 48 0c8.8 0 16 7.2 16 16l0 48 32 0 0-80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-48 0 0 80c0 8.8-7.2 16-16 16l-48 0 0 80c0 8.8-7.2 16-16 16l-48 0-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-32-192 0 0 32 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0-48 0c-8.8 0-16-7.2-16-16l0-80-48 0c-8.8 0-16-7.2-16-16l0-80-48 0c-8.8 0-16-7.2-16-16L0 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 80 32 0 0-48c0-8.8 7.2-16 16-16l48 0 0-32 0-32-48 0c-8.8 0-16-7.2-16-16l0-32zm64 192l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm192 0l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlien8bit = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F);
var W0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = F;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faAlienMonster = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(W0);
var E0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "align-slash", f = 640, c = 512, e = [], t = "f846", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352l30.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112.3 0-81.7-64L512 224c17.7 0 32-14.3 32-32s-14.3-32-32-32l-275.6 0L154.8 96 512 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L128 32c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM324.9 352l-81.2-64L128 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l196.9 0zM162.5 224l-61.8-48.7c-3 4.9-4.7 10.6-4.7 16.7c0 17.7 14.3 32 32 32l34.5 0zM487.4 480l-81.2-64L128 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l359.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlignSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E0);
var V0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "alt", f = 640, c = 512, e = [], t = "e08a", o = "M448 64c-9.7 0-18.9 4.4-25 12L176.6 384 32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c9.7 0 18.9-4.4 25-12L463.4 128 608 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L448 64zm0 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAlt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V0);
var I0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "amp-guitar", f = 512, c = 512, e = [], t = "f8a1", o = "M256 0c-48.9 0-92.5 28.8-121.6 53.8c-15 12.9-27.3 25.7-35.8 35.3c-2.3 2.6-4.3 4.9-6 6.9L64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64l-28.5 0c-1.7-2.1-3.8-4.4-6-6.9c-8.5-9.6-20.8-22.4-35.8-35.3C348.5 28.8 304.9 0 256 0zm96.9 96L159.1 96c2.1-1.9 4.3-3.8 6.5-5.8C192.5 67.2 224.9 48 256 48s63.5 19.2 90.4 42.2c2.2 1.9 4.4 3.9 6.5 5.8zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 448l0-192 384 0 0 192L64 448zm64-128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM256 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM384 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAmpGuitar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I0);
var K0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ampersand", f = 448, c = 512, e = [], t = "26", o = "M180.7 96l38 0c20.6 0 37.3 16.7 37.3 37.3c0 11.8-5.5 22.8-14.9 29.9l-48 36-39-41.3c-6.4-6.8-10-15.8-10-25.2c0-20.3 16.4-36.7 36.7-36.7zm56.6 150l42.2-31.6C305 195.3 320 165.2 320 133.3C320 77.4 274.6 32 218.7 32l-38 0C125.1 32 80 77.1 80 132.7c0 25.7 9.8 50.4 27.5 69.1l34 36L74.7 288C47.8 308.1 32 339.8 32 373.3C32 432.2 79.8 480 138.7 480l74.5 0c37.4 0 72.4-18.7 93.2-49.9l6.9-10.4L360.7 470c12.1 12.8 32.4 13.4 45.2 1.3s13.4-32.4 1.3-45.2l-57.5-60.9 60.9-91.4c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9l-52.7 79.1L237.3 246zm-51.5 38.6L268.2 372l-15.1 22.6C244.2 408 229.2 416 213.2 416l-74.5 0C115.1 416 96 396.9 96 373.3c0-13.4 6.3-26.1 17.1-34.1l72.7-54.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAmpersand = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K0);
var X0 = {}, H = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-mixed", f = 512, c = 512, e = ["analytics"], t = "f643", o = "M500 89c13.8-11 16-31.2 5-45s-31.2-16-45-5L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L500 89zM160 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 352l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32zm288-64c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32zm96-32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartMixed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = H;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faAnalytics = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(X0);
var Q0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "angel", f = 576, c = 512, e = [], t = "f779", o = "M384 64c0 0 0 .1 0 .2s-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2zm-16 80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM120 464l-70.3 0 37.9-75.8c5.6-11.1 8.4-23.4 8.4-35.8l0-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1c0-27.1 22-48.9 48.2-48.9c12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7L120 464zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3l0 .9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3L96 512l96 0 192 0 96 0 50.7 0c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3l0-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm126.8 51.4c-4.6-9.2-10.4-17.5-17.3-24.7l66.4-66.4c9-9 21.3-14.1 34.1-14.1c26.1 0 48.2 21.8 48.2 48.9c0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8l0 .9c0 12.4 2.9 24.7 8.4 35.8L526.3 464 456 464 380.6 313.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAngel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q0);
var J0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "angle", f = 448, c = 512, e = [], t = "e08c", o = "M252.6 78.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-192 384c-5 9.9-4.4 21.7 1.4 31.1S20.9 480 32 480l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L83.8 416 252.6 78.3zm-12.2 96l-21.9 43.8c21.4 17.4 40.4 37.7 56.2 60.4l40.8-25.3c-20.7-30.1-46.1-56.7-75.1-78.9zM321.1 384l49 0c-7-37-19.8-71.9-37.6-103.7l-40.8 25.3c13.3 24.2 23.3 50.5 29.5 78.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAngle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J0);
var Y0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "angle-90", f = 448, c = 512, e = [], t = "e08d", o = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 416 64 64zM96 97.6l0 48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384l48.3 0c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAngle90 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y0);
var Z0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "angles-up-down", f = 448, c = 512, e = [], t = "e60d", o = "M244 7c-11.7-9.3-28.3-9.3-40 0L44 135c-13.8 11-16 31.2-5 45s31.2 16 45 5L224 73 364 185c13.8 11 33.9 8.8 45-5s8.8-33.9-5-45L244 7zM404 377c13.8-11 16-31.2 5-45s-31.2-16-45-5L224 439 84 327c-13.8-11-33.9-8.8-45 5s-8.8 33.9 5 45L204 505c11.7 9.3 28.3 9.3 40 0L404 377z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAnglesUpDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z0);
var p0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ant", f = 640, c = 512, e = [], t = "e680", o = "M523.3 51.9c1.4-2.4 4.1-3.9 6.9-3.9L584 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L530.1 0c-19.7 0-37.9 10.3-48 27.2L458.6 66.4C415.9 76.1 384 114.3 384 160c0 14.8 3.3 28.8 9.3 41.3c-12.5-6-26.5-9.3-41.3-9.3c-27 0-51.4 11.2-68.9 29.1C267.9 167.6 218.6 128 160.4 128C72 128 0 199.6 0 288c0 44.2 35.8 80 80 80l48.9 0L67.2 476.1c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9l75.6-132.2c9.7-.7 19.1-2.7 28-5.7L147.2 476.1c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9L276.2 347c4.6 5.9 9.8 11.2 15.7 15.9l-.5 .8-.3 .4-64 112c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9l63.9-111.8 3.3-5.5c5.2 .9 10.6 1.3 16 1.3c13.6 0 26.5-2.8 38.2-7.9l39.6 39.6c3.8 3.8 6.8 8.4 8.9 13.4l27.1 67.8c4.9 12.3 18.9 18.3 31.2 13.4s18.3-18.9 13.4-31.2l-27.1-67.8c-4.4-11.1-11.1-21.1-19.5-29.5l-35.4-35.4c2.2-2.8 4.2-5.8 6.1-8.9l86.8 62c6.9 4.9 12 11.9 14.7 19.9l25.4 76.3c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-25.4-76.3c-5.9-17.6-17.2-33-32.3-43.8l-95.1-67.9-5.9-4.2 0-.2c0-14.8-3.3-28.8-9.3-41.3c12.5 6 26.5 9.3 41.3 9.3l64 0c35.3 0 64-28.7 64-64c0-59.2-40.1-108.9-94.6-123.6l9.9-16.5zM512 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAnt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p0);
var x0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "apartment", f = 576, c = 512, e = [], t = "e468", o = "M176 0c-26.5 0-48 21.5-48 48l0 48L48 96C21.5 96 0 117.5 0 144L0 464c0 26.5 21.5 48 48 48l80 0 32 0 96 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 96 0 32 0 80 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-80 0 0-144c0-26.5-21.5-48-48-48L176 0zM368 320l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zm144 80c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM112 320l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zm16 80c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zm112-80l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM384 80l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM240 64c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM384 208c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM496 320l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM128 208c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zm112 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faApartment = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x0);
var ie = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "aperture", f = 512, c = 512, e = [], t = "e2df", o = "M256 0c4 0 7.9 .1 11.9 .3c11.3 .5 17.5 12.9 11.8 22.8L177.5 200c-6.2 10.7-21.6 10.7-27.7 0L82.8 84.1c-3.6-6.3-2.6-14.3 2.9-19.2C130.9 24.5 190.6 0 256 0zM0 256c0-50.9 14.9-98.3 40.5-138.2c6.1-9.5 19.9-8.6 25.6 1.2L168.2 296c6.2 10.7-1.5 24-13.9 24L20.5 320c-7.3 0-13.7-4.9-15.2-12.1C1.8 291.2 0 273.8 0 256zM193.7 492c-3.6 6.3-11.1 9.4-18 7.1C111.8 478 59 432.5 28.5 373.6C23.3 363.5 31 352 42.3 352l204.4 0c12.3 0 20 13.3 13.9 24l-67 116zM256 512c-4 0-7.9-.1-11.9-.3c-11.3-.5-17.5-12.9-11.8-22.8L334.5 312c6.2-10.7 21.6-10.7 27.7 0l66.9 115.9c3.6 6.3 2.6 14.3-2.9 19.2C381.1 487.5 321.4 512 256 512zM512 256c0 50.9-14.9 98.3-40.5 138.2c-6.1 9.5-19.9 8.6-25.6-1.2L343.8 216c-6.2-10.7 1.5-24 13.9-24l133.9 0c7.3 0 13.7 4.9 15.2 12.1c3.5 16.8 5.3 34.1 5.3 51.9zM318.3 20c3.6-6.3 11.1-9.4 18-7.1C400.2 34 453 79.5 483.5 138.4c5.2 10.1-2.5 21.6-13.8 21.6l-204.4 0c-12.3 0-20-13.3-13.9-24l67-116z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAperture = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ie);
var ae = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "apostrophe", f = 192, c = 512, e = [], t = "27", o = "M72 352c66.3 0 120-53.7 120-120l0-72 0-32 0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l64 0 0 8c0 30.9-25.1 56-56 56l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faApostrophe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ae);
var ee = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "apple-core", f = 384, c = 512, e = [], t = "e08f", o = "M192 112c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80l16 0c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80l-16 0zM30.5 167c-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c19.3 0 36.1 5.4 50.3 14.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3c-34.9 0-69.8-18.3-98.1-49.6c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAppleCore = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ee);
var ne = {}, R = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "crate-apple", f = 512, c = 512, e = ["apple-crate"], t = "f6b1", o = "M160 54.9C160 24.6 184.6 0 214.9 0c5 0 9.1 4.1 9.1 9.1C224 39.4 199.4 64 169.1 64c-5 0-9.1-4.1-9.1-9.1zM32 171.4C32 127.8 52.4 80 96 80c15.6 0 34.1 5.9 47.2 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6L33.2 192c-.8-6.7-1.2-13.5-1.2-20.6zM319 192c.7-6.7 1-13.6 1-20.6c0-26.1-6-55.1-20.3-78.6c-2.7-4.4-5.7-8.7-9-12.7c15 .6 32.2 6.1 44.6 11c10.7 4.2 22.8 4.2 33.5 0c13.1-5.1 31.6-11 47.2-11c43.6 0 64 47.8 64 91.4c0 7-.4 13.9-1.2 20.6L319 192zM406.9 0c5 0 9.1 4.1 9.1 9.1C416 39.4 391.4 64 361.1 64c-5 0-9.1-4.1-9.1-9.1C352 24.6 376.6 0 406.9 0zM0 272c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48l0 80L0 352l0-80zM0 384l512 0 0 80c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-80zm80-96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCrateApple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = R;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faAppleCrate = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ne);
var fe = {}, U = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down", f = 384, c = 512, e = ["arrow-alt-down"], t = "f354", o = "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l96 0 0-184c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 184 96 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-160 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = U;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(fe);
var ce = {}, q = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up-from-line", f = 384, c = 512, e = ["arrow-alt-from-bottom"], t = "f346", o = "M37.9 185.4L166.5 42.6c6.1-6.7 14.7-10.6 23.8-10.6l3.5 0c9.1 0 17.7 3.9 23.8 10.6L346.1 185.4c3.8 4.2 5.9 9.8 5.9 15.5c0 12.8-10.4 23.1-23.1 23.1L256 224l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128-72.9 0C42.4 224 32 213.6 32 200.9c0-5.7 2.1-11.2 5.9-15.5zM32 416l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUpFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = q;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltFromBottom = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ce);
var te = {}, G = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "right-from-line", f = 448, c = 512, e = ["arrow-alt-from-left"], t = "f347", o = "M313.9 105.9L436.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L313.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM64 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRightFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = G;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltFromLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(te);
var oe = {}, W = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "left-from-line", f = 448, c = 512, e = ["arrow-alt-from-right"], t = "f348", o = "M134.1 406.1L11.3 283.3C4.1 276.1 0 266.2 0 256s4.1-20.1 11.3-27.3L134.1 105.9c6.4-6.4 15-9.9 24-9.9c18.7 0 33.9 15.2 33.9 33.9l0 62.1 128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0 0 62.1c0 18.7-15.2 33.9-33.9 33.9c-9 0-17.6-3.6-24-9.9zM384 416l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeftFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = W;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltFromRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(oe);
var le = {}, E = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down-from-line", f = 384, c = 512, e = ["arrow-alt-from-top"], t = "f349", o = "M41.9 345.9L164.7 468.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L342.1 345.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L256 288l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C47.2 288 32 303.2 32 321.9c0 9 3.6 17.6 9.9 24zM32 96l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDownFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = E;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltFromTop = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(le);
var de = {}, V = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "left", f = 448, c = 512, e = ["arrow-alt-left"], t = "f355", o = "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 96 184 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-184 0 0 96c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-160-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = V;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(de);
var re = {}, I = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "right", f = 448, c = 512, e = [11157, "arrow-alt-right"], t = "f356", o = "M438.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-96L40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l184 0 0-96c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l160 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = I;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(re);
var se = {}, K = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-down", f = 448, c = 512, e = [11015, "arrow-alt-square-down"], t = "f350", o = "M64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm171.3-84.7l112-112c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-64 0 0-96c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 96-64 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l112 112c6.2 6.2 16.4 6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = K;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltSquareDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(se);
var he = {}, X = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-left", f = 448, c = 512, e = [11013, "arrow-alt-square-left"], t = "f351", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM84.7 267.3l112 112c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-64 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-112 112c-6.2 6.2-6.2 16.4 0 22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = X;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltSquareLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(he);
var ve = {}, Q = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-right", f = 448, c = 512, e = [10145, "arrow-alt-square-right"], t = "f352", o = "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM363.3 267.3l-112 112c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-64-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-64c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l112 112c6.2 6.2 6.2 16.4 0 22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Q;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltSquareRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ve);
var ue = {}, J = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-up", f = 448, c = 512, e = [11014, "arrow-alt-square-up"], t = "f353", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm171.3 84.7l112 112c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-64 0 0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-64 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = J;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltSquareUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ue);
var me = {}, Y = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down-to-line", f = 384, c = 512, e = ["arrow-alt-to-bottom"], t = "f34a", o = "M342.1 249.9L219.3 372.7c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L41.9 249.9c-6.4-6.4-9.9-15-9.9-24C32 207.2 47.2 192 65.9 192l62.1 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128 62.1 0c18.7 0 33.9 15.2 33.9 33.9c0 9-3.6 17.6-9.9 24zM32 416l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDownToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Y;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltToBottom = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(me);
var ge = {}, Z = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "left-to-line", f = 448, c = 512, e = ["arrow-alt-to-left"], t = "f34b", o = "M230.1 406.1L107.3 283.3C100.1 276.1 96 266.2 96 256s4.1-20.1 11.3-27.3L230.1 105.9c6.4-6.4 15-9.9 24-9.9c18.7 0 33.9 15.2 33.9 33.9l0 62.1 128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0 0 62.1c0 18.7-15.2 33.9-33.9 33.9c-9 0-17.6-3.6-24-9.9zM64 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 78.3 14.3 64 32 64s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeftToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Z;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltToLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ge);
var Pe = {}, p = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "right-to-line", f = 448, c = 512, e = ["arrow-alt-to-right"], t = "f34c", o = "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM384 416l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRightToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = p;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltToRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Pe);
var Me = {}, x = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up-to-line", f = 384, c = 512, e = ["arrow-alt-to-top"], t = "f34d", o = "M342.1 262.1L219.3 139.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3L41.9 262.1c-6.4 6.4-9.9 15-9.9 24C32 304.8 47.2 320 65.9 320l62.1 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24zM32 96l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUpToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = x;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltToTop = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Me);
var we = {}, ii = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up", f = 384, c = 512, e = ["arrow-alt-up"], t = "f357", o = "M169.4 41.4c12.5-12.5 32.8-12.5 45.3 0l160 160c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-96 0 0 184c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-184-96 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l160-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ii);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ii;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowAltUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(we);
var ai = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-arrow-up", f = 576, c = 512, e = ["sort-alt"], t = "f883", o = "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L128 370.7 128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 306.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96zm352-333.3c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L448 141.3 448 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-306.7-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ai);
var ei = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-big-small", f = 576, c = 512, e = ["sort-size-down"], t = "f88c", o = "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM320 368l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zM368 32c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L368 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownBigSmall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ei);
var Ne = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-from-arc", f = 512, c = 512, e = [], t = "e614", o = "M256 64C150 64 64 150 64 256c0 17.7-14.3 32-32 32s-32-14.3-32-32C0 114.6 114.6 0 256 0S512 114.6 512 256c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-106-86-192-192-192zM121.4 390.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 224 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownFromArc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ne);
var ze = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-from-bracket", f = 448, c = 512, e = [], t = "e667", o = "M246.6 502.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 402.7 192 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128zM64 160c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 43 43 0 96 0L352 0c53 0 96 43 96 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96l0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownFromBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ze);
var Le = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-from-dotted-line", f = 448, c = 512, e = [], t = "e090", o = "M32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM374.6 342.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 370.7l0-66.7 0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 112 0 66.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownFromDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Le);
var ni = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-from-line", f = 384, c = 512, e = [8615, "arrow-from-top"], t = "f345", o = "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 370.7 160 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 178.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128zM32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ni);
var Ce = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-left", f = 384, c = 512, e = [], t = "e091", o = "M32 384c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-146.7 0L342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L96 306.7 96 160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ce);
var De = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-left-and-arrow-up-right-to-center", f = 512, c = 512, e = [], t = "e092", o = "M502.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L336 130.7 336 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0L502.6 54.6zM80 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L176 381.3l0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L80 272z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownLeftAndArrowUpRightToCenter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(De);
var $e = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-right", f = 384, c = 512, e = [], t = "e093", o = "M320 416c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 146.7L86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 352 96 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($e);
var fi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-small-big", f = 576, c = 512, e = ["sort-size-down-alt"], t = "f88d", o = "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 301.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM320 80l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm48 176c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownSmallBig = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fi);
var ci = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-square-triangle", f = 576, c = 512, e = ["sort-shapes-down-alt"], t = "f889", o = "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7 128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 72c0-22.1 17.9-40 40-40l112 0c22.1 0 40 17.9 40 40l0 112c0 22.1-17.9 40-40 40l-112 0c-22.1 0-40-17.9-40-40l0-112zM443.1 303l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5l-160 0c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownSquareTriangle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ci);
var _e = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-to-arc", f = 512, c = 512, e = [], t = "e4ae", o = "M256 448c106 0 192-86 192-192c0-17.7 14.3-32 32-32s32 14.3 32 32c0 141.4-114.6 256-256 256S0 397.4 0 256c0-17.7 14.3-32 32-32s32 14.3 32 32c0 106 86 192 192 192zM390.6 230.6l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 242.7 224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 57.4-57.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownToArc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_e);
var be = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-to-bracket", f = 448, c = 512, e = [], t = "e094", o = "M374.6 214.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 242.7 192 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 210.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM64 352l0 64c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 53-43 96-96 96L96 512c-53 0-96-43-96-96l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownToBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(be);
var Se = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-to-dotted-line", f = 448, c = 512, e = [], t = "e095", o = "M374.6 214.6l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 242.7l0-66.7 0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 112 0 66.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownToDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Se);
var ti = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-to-line", f = 384, c = 512, e = ["arrow-to-bottom"], t = "f33d", o = "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480zM214.6 342.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 242.7 160 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 178.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ti);
var ye = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-to-square", f = 512, c = 512, e = [], t = "e096", o = "M374.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 242.7 288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-320c0-44.2-35.8-80-80-80l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownToSquare = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ye);
var oi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-down-triangle-square", f = 576, c = 512, e = ["sort-shapes-down"], t = "f888", o = "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7 128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 301.7 32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM443.1 47l80 128c6.2 9.9 6.5 22.3 .9 32.5s-16.4 16.5-28 16.5l-160 0c-11.6 0-22.3-6.3-28-16.5s-5.3-22.6 .9-32.5l80-128c5.8-9.4 16.1-15 27.1-15s21.3 5.7 27.1 15zM320 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowDownTriangleSquare = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oi);
var Oe = {}, li = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-from-line", f = 384, c = 512, e = [8613, "arrow-from-bottom"], t = "f342", o = "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.3l0 66.7 0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112 0-66.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(li);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = li;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowFromBottom = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Oe);
var ke = {}, di = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-right-from-line", f = 448, c = 512, e = [8614, "arrow-from-left"], t = "f343", o = "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96zM438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 224 160 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l178.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowRightFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(di);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = di;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowFromLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ke);
var Ae = {}, ri = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-left-from-line", f = 448, c = 512, e = [8612, "arrow-from-right"], t = "f344", o = "M384 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320zM9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224 288 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowLeftFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ri);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ri;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowFromRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ae);
var je = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ni;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowFromTop = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(je);
var Be = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-left-from-arc", f = 512, c = 512, e = [], t = "e615", o = "M448 256c0-106-86-192-192-192c-17.7 0-32-14.3-32-32s14.3-32 32-32C397.4 0 512 114.6 512 256s-114.6 256-256 256c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192zM121.4 121.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224 320 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-210.7 0 57.4 57.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-112-112c-12.5-12.5-12.5-32.8 0-45.3l112-112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowLeftFromArc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Be);
var Te = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-left-from-bracket", f = 512, c = 512, e = [], t = "e668", o = "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 224 320 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-210.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128zM352 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowLeftFromBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Te);
var Fe = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-left-long-to-line", f = 640, c = 512, e = [], t = "e3d4", o = "M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96zM137.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 288 608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowLeftLongToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fe);
var He = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-left-to-arc", f = 512, c = 512, e = [], t = "e616", o = "M64 256C64 150 150 64 256 64c17.7 0 32-14.3 32-32s-14.3-32-32-32C114.6 0 0 114.6 0 256S114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256zM281.4 121.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L269.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-210.7 0 57.4-57.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowLeftToArc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(He);
var Re = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-left-to-bracket", f = 512, c = 512, e = [], t = "e669", o = "M160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32zm9.4 182.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 224 480 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-210.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowLeftToBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Re);
var si = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-left-to-line", f = 448, c = 512, e = [8676, "arrow-to-left"], t = "f33e", o = "M0 96C0 78.3 14.3 64 32 64s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96zM137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowLeftToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(si);
var Ue = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-progress", f = 512, c = 512, e = [], t = "e5df", o = "M448 128A64 64 0 1 0 448 0a64 64 0 1 0 0 128zM128 32C57.3 32 0 89.3 0 160s57.3 128 128 128l256 0c35.3 0 64 28.7 64 64c0 27.9-17.9 51.7-42.8 60.4c-11.5-17.1-31-28.4-53.2-28.4c-35.3 0-64 28.7-64 64s28.7 64 64 64c24.7 0 46.1-14 56.8-34.4C467.6 466.1 512 414.2 512 352c0-70.7-57.3-128-128-128l-256 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l128 0 0 14.1c0 9.9 8 17.9 17.9 17.9c4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9L284.8 3.8c-3.1-2.4-7-3.8-11-3.8C264 0 256 8 256 17.9L256 32 128 32zm-8.6 384c-11.1-19.1-31.7-32-55.4-32c-35.3 0-64 28.7-64 64s28.7 64 64 64c23.7 0 44.4-12.9 55.4-32l40.6 0 0 14.1c0 9.9 8 17.9 17.9 17.9c4 0 7.8-1.3 11-3.8l60.8-47.3c4-3.1 6.3-7.9 6.3-12.9s-2.3-9.8-6.3-12.9l-60.8-47.3c-3.1-2.4-7-3.8-11-3.8c-9.9 0-17.9 8-17.9 17.9l0 14.1-40.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowProgress = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ue);
var qe = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-right-from-arc", f = 512, c = 512, e = [], t = "e4b1", o = "M64 256C64 150 150 64 256 64c17.7 0 32-14.3 32-32s-14.3-32-32-32C114.6 0 0 114.6 0 256S114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256zM390.6 121.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-57.4 57.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowRightFromArc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qe);
var Ge = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-right-long-to-line", f = 640, c = 512, e = [], t = "e3d5", o = "M640 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32zM502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l370.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowRightLongToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ge);
var We = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-right-to-arc", f = 512, c = 512, e = [], t = "e4b2", o = "M448 256c0-106-86-192-192-192c-17.7 0-32-14.3-32-32s14.3-32 32-32C397.4 0 512 114.6 512 256s-114.6 256-256 256c-17.7 0-32-14.3-32-32s14.3-32 32-32c106 0 192-86 192-192zM230.6 121.4l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l210.7 0-57.4-57.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowRightToArc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(We);
var hi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-right-to-line", f = 448, c = 512, e = [8677, "arrow-to-right"], t = "f340", o = "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320zM310.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l178.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowRightToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hi);
var Ee = {}, vi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-arrow-down", f = 448, c = 512, e = ["arrow-square-down"], t = "f339", o = "M64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm177-71L353 297c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71L248 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 214.1-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L207 409c9.4 9.4 24.6 9.4 33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = vi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowSquareDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ee);
var Ve = {}, ui = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-arrow-left", f = 448, c = 512, e = ["arrow-square-left"], t = "f33a", o = "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM71 239L183 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L360 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-214.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 273c-9.4-9.4-9.4-24.6 0-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareArrowLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ui);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ui;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowSquareLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ve);
var Ie = {}, mi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-arrow-right", f = 448, c = 512, e = ["arrow-square-right"], t = "f33b", o = "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM377 273L265 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L88 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L377 239c9.4 9.4 9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareArrowRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = mi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowSquareRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ie);
var Ke = {}, gi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-arrow-up", f = 448, c = 512, e = ["arrow-square-up"], t = "f33c", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm177 71L353 215c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71L248 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-214.1-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 103c9.4-9.4 24.6-9.4 33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = gi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowSquareUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ke);
var Xe = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ti;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowToBottom = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Xe);
var Qe = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = si;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowToLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Qe);
var Je = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = hi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowToRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Je);
var Ye = {}, Pi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-to-line", f = 384, c = 512, e = ["arrow-to-top"], t = "f341", o = "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM214.6 169.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 269.3 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-178.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Pi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faArrowToTop = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ye);
var Ze = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-turn-down-left", f = 512, c = 512, e = [], t = "e2e1", o = "M448 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160c0 53-43 96-96 96l-306.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 416 256c17.7 0 32-14.3 32-32l0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowTurnDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ze);
var pe = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-turn-down-right", f = 512, c = 512, e = [], t = "e3d6", o = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 224c0 53 43 96 96 96l306.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 96 256c-17.7 0-32-14.3-32-32L64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowTurnDownRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pe);
var xe = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-turn-left", f = 512, c = 512, e = [], t = "e632", o = "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 416 256c17.7 0 32 14.3 32 32l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-53-43-96-96-96l-306.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowTurnLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xe);
var an = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-turn-left-down", f = 384, c = 512, e = [], t = "e633", o = "M342.6 374.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L256 0c-53 0-96 43-96 96l0 306.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowTurnLeftDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(an);
var en = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-turn-left-up", f = 384, c = 512, e = [], t = "e634", o = "M342.6 137.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 109.3 224 416c0 17.7 14.3 32 32 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-53 0-96-43-96-96l0-306.7L86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowTurnLeftUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(en);
var nn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-turn-right", f = 512, c = 512, e = [], t = "e635", o = "M374.6 374.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 256 96 256c-17.7 0-32 14.3-32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288c0-53 43-96 96-96l306.7 0-73.4-73.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3l-128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowTurnRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nn);
var Mi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-arrow-down", f = 576, c = 512, e = ["sort-up-down"], t = "e099", o = "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 141.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zm352 333.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L448 370.7 448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mi);
var wi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-big-small", f = 576, c = 512, e = ["sort-size-up"], t = "f88e", o = "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM320 368c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64zM368 32l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpBigSmall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wi);
var fn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-from-arc", f = 512, c = 512, e = [], t = "e4b4", o = "M256 448C150 448 64 362 64 256c0-17.7-14.3-32-32-32s-32 14.3-32 32C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 106-86 192-192 192zM121.4 121.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 224 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpFromArc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fn);
var cn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-from-dotted-line", f = 448, c = 512, e = [], t = "e09b", o = "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 141.3l0 66.7 0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112 0-66.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpFromDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cn);
var tn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-from-square", f = 512, c = 512, e = [], t = "e09c", o = "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 224 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM64 112c0-8.8 7.2-16 16-16l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-320c0-44.2-35.8-80-80-80l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpFromSquare = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tn);
var on = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-left", f = 384, c = 512, e = [], t = "e09d", o = "M64 96c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-146.7L297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 160 288 160c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(on);
var ln = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-left-from-circle", f = 512, c = 512, e = [], t = "e09e", o = "M192 0L32 0C14.3 0 0 14.3 0 32L0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-82.7L297.4 342.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 64 192 64c17.7 0 32-14.3 32-32s-14.3-32-32-32zM325.3 67.1c-17.4-2.9-33.9 8.8-36.9 26.3s8.8 33.9 26.3 36.9C390.4 142.9 448 208.8 448 288c0 88.4-71.6 160-160 160c-79.2 0-145.1-57.6-157.8-133.3c-2.9-17.4-19.4-29.2-36.9-26.3s-29.2 19.4-26.3 36.9C84.9 431.3 177 512 288 512c123.7 0 224-100.3 224-224c0-111-80.7-203.1-186.7-220.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpLeftFromCircle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ln);
var dn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-right", f = 384, c = 512, e = [], t = "e09f", o = "M352 128c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l146.7 0L41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 205.3 288 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dn);
var rn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-right-and-arrow-down-left-from-center", f = 512, c = 512, e = [], t = "e0a0", o = "M352 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0L297.4 169.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L352 0zM214.6 297.4c-12.5-12.5-32.8-12.5-45.3 0L64 402.7 64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32L0 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0L214.6 342.6c12.5-12.5 12.5-32.8 0-45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpRightAndArrowDownLeftFromCenter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rn);
var Ni = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-small-big", f = 576, c = 512, e = ["sort-size-up-alt"], t = "f88f", o = "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3 192 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-301.7L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM320 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64zm48 176l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpSmallBig = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ni);
var zi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-square-triangle", f = 576, c = 512, e = ["sort-shapes-up-alt"], t = "f88b", o = "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM443.1 303c-5.8-9.4-16.1-15-27.1-15s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5l160 0c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5l-80-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpSquareTriangle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zi);
var sn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-to-arc", f = 512, c = 512, e = [], t = "e617", o = "M256 64c106 0 192 86 192 192c0 17.7 14.3 32 32 32s32-14.3 32-32C512 114.6 397.4 0 256 0S0 114.6 0 256c0 17.7 14.3 32 32 32s32-14.3 32-32C64 150 150 64 256 64zM390.6 281.4l-112-112c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 269.3 224 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpToArc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sn);
var hn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-to-bracket", f = 448, c = 512, e = [], t = "e66a", o = "M374.6 297.4l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 269.3 192 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3zM64 160l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-53-43-96-96-96L96 0C43 0 0 43 0 96l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpToBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hn);
var vn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-to-dotted-line", f = 448, c = 512, e = [], t = "e0a1", o = "M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-9.4 233.4l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 269.3l0 66.7 0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112 0-66.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpToDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vn);
var Li = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrow-up-triangle-square", f = 576, c = 512, e = ["sort-shapes-up"], t = "f88a", o = "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-301.7 32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM443.1 47C437.3 37.7 427 32 416 32s-21.3 5.7-27.1 15l-80 128c-6.2 9.9-6.5 22.3-.9 32.5s16.4 16.5 28 16.5l160 0c11.6 0 22.3-6.3 28-16.5s5.3-22.6-.9-32.5l-80-128zM320 336l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowUpTriangleSquare = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Li);
var un = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-cross", f = 448, c = 512, e = [], t = "e0a2", o = "M288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0L9.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 141.3l0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L288 32zM54.6 41.4c-12.5-12.5-32.8-12.5-45.3 0S-3.1 74.1 9.4 86.6L156.1 233.4l45.3-45.3L54.6 41.4zM338.7 416L288 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 50.7-92.1-92.1-45.3 45.3L338.7 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsCross = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(un);
var mn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-from-dotted-line", f = 448, c = 512, e = [], t = "e0a3", o = "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352l0 32-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsFromDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mn);
var gn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-from-line", f = 448, c = 512, e = [], t = "e0a4", o = "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM192 352l0 32-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsFromLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gn);
var Ci = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-maximize", f = 512, c = 512, e = ["expand-arrows"], t = "f31d", o = "M320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0L256 210.7 141.3 96 192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-50.7L210.7 256 96 370.7 96 320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0L256 301.3 370.7 416 320 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 50.7L301.3 256 416 141.3l0 50.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L320 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsMaximize = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ci);
var Di = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-minimize", f = 512, c = 512, e = ["compress-arrows"], t = "e0a5", o = "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7 160 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32L64 224c-17.7 0-32-14.3-32-32s14.3-32 32-32l50.7 0L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zm448 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L397.3 160l50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 50.7L457.4 9.4zM32 320c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352 64 352c-17.7 0-32-14.3-32-32zm256 0c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-50.7 0L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 397.3l0 50.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsMinimize = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Di);
var $i = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-repeat", f = 512, c = 512, e = ["repeat-alt"], t = "f364", o = "M1.6 213.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2C77.1 189.9 118.5 160 165.2 160l173.6 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 165.2 96C91 96 25.1 143.5 1.6 213.9zm508.7 84.2c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2C434.9 322.1 393.5 352 346.8 352l-173.6 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L173.3 416l173.6 0c74.2 0 140.1-47.5 163.6-117.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsRepeat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($i);
var _i = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-repeat-1", f = 512, c = 512, e = ["repeat-1-alt"], t = "f366", o = "M21.9 254.4C5.1 248.8-3.9 230.6 1.6 213.9C25.1 143.5 91 96 165.2 96l173.6 0L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-250.8 0c-46.7 0-88.1 29.9-102.8 74.1c-5.6 16.8-23.7 25.8-40.5 20.2zm468.2 3.3c16.8 5.6 25.8 23.7 20.2 40.5C486.9 368.5 421 416 346.8 416l-173.6 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l250.8 0c46.7 0 88.1-29.9 102.8-74.1c5.6-16.8 23.7-25.8 40.5-20.2zM288 216l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsRepeat1 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_i);
var bi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-retweet", f = 640, c = 512, e = ["retweet-alt"], t = "f361", o = "M150.6 73.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 173.3 96 320c0 53 43 96 96 96l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-112 0c-17.7 0-32-14.3-32-32l0-146.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM336 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 146.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L544 338.7 544 192c0-53-43-96-96-96L336 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsRetweet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bi);
var Pn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-rotate-reverse", f = 512, c = 512, e = [], t = "e630", o = "M406.6 202.6c-7.7-21.8-20.2-42.3-37.8-59.8c-62.5-62.5-163.8-62.5-226.3 0L125.5 160l34.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48.3 224c0 0 0 0 0 0l-.4 0c-17.7 0-32-14.3-32-32l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 35.2L97.4 97.6c87.5-87.5 229.3-87.5 316.8 0c24.4 24.4 42.1 53.1 52.9 83.7c5.9 16.7-2.9 34.9-19.5 40.8s-34.9-2.9-40.8-19.5zm66.1 86.6c5 1.5 9.8 4.2 13.7 8.2c4 4 6.7 8.9 8.1 14c.3 1.2 .6 2.5 .8 3.8c.3 1.7 .4 3.4 .4 5.1l0 111.6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-35.1-17.6 17.5c0 0 0 0 0 0c-87.5 87.4-229.3 87.4-316.7 0C73 390 55.3 361.3 44.5 330.6c-5.9-16.7 2.9-34.9 19.5-40.8s34.9 2.9 40.8 19.5c7.7 21.8 20.2 42.3 37.8 59.8c62.5 62.5 163.8 62.5 226.3 0l.1-.1L386.1 352l-34.4 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l111.6 0c1.6 0 3.2 .1 4.8 .3s3.1 .5 4.6 1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsRotateReverse = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pn);
var Mn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-to-dotted-line", f = 448, c = 512, e = [], t = "e0a6", o = "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-32zM201.4 329.4l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsToDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mn);
var wn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "arrows-to-line", f = 448, c = 512, e = [], t = "e0a7", o = "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-32zM201.4 329.4l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faArrowsToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wn);
var Nn = {}, Si = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "atom-simple", f = 512, c = 512, e = ["atom-alt"], t = "f5d3", o = "M100.9 411.1c-1.3-1.3-12.4-16.8 3.3-64c3.5-10.4 8-21.4 13.6-32.9c11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6c-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zm44.1-138.1c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8c-15.7-47.2-4.6-62.7-3.3-64s16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6zM256 76.8C173.9 27.6 94.9 16.5 55.7 55.7S27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8zm58.2 41.1c11.4-5.6 22.4-10.2 32.9-13.6c47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8c-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm79.9 196.3c5.6 11.4 10.2 22.4 13.6 32.9c15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6c14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAtomSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Si);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Si;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faAtomAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Nn);
var zn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "audio-description-slash", f = 640, c = 512, e = [], t = "e0a8", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM336 238l0-54c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96c0 35.3-19 66.1-47.4 82.8l-44.6-35c24.7-2 44.1-22.7 44.1-47.8c0-26.5-21.5-48-48-48l-32 0 0 67.7L336 238zM487.4 480L314.3 343.6c-2 2.4-4.6 4.4-7.5 5.9c-11.9 5.9-26.3 1.1-32.2-10.7l-9.4-18.9-82.2 0-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l42.5-85L32 121.2 32 416c0 35.3 28.7 64 64 64l391.4 0zm-254-200.2l-21.8-17.2-8.6 17.2 30.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAudioDescriptionSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zn);
var Ln = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "avocado", f = 512, c = 512, e = [], t = "e0aa", o = "M459.4 255.3c-18.5 15.2-33.5 35.6-38.1 59.1c-10.2 51.9-34 104.5-66.3 136.7c-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c32.3-32.3 84.9-56.1 136.7-66.3c23.5-4.6 43.9-19.6 59.1-38.1C283.1 20.5 323.2 0 368 0c79.5 0 144 64.5 144 144c0 44.8-20.5 84.9-52.6 111.3zM283.2 347.2c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4s-49.1 102.1-16.4 134.8s93 25.3 134.8-16.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAvocado = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ln);
var Cn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "award-simple", f = 384, c = 512, e = [], t = "e0ab", o = "M173.3 5.3c11.5-7 26-7 37.5 0l17.9 10.9c5.9 3.6 12.7 5.4 19.6 5.2l20.9-.5c13.5-.3 26 6.9 32.5 18.7l10 18.4c3.3 6.1 8.3 11 14.3 14.3l18.4 10c11.8 6.5 19.1 19 18.7 32.5l-.5 20.9c-.2 6.9 1.7 13.7 5.2 19.6l10.9 17.9c7 11.5 7 26 0 37.5l-10.9 17.9c-3.6 5.9-5.4 12.7-5.2 19.6l.5 20.9c.3 13.5-6.9 26-18.7 32.5l-18.4 10c-6.1 3.3-11 8.3-14.3 14.3l-10 18.4c-6.5 11.8-19 19.1-32.5 18.7l-20.9-.5c-6.9-.2-13.7 1.7-19.6 5.2l-17.9 10.9c-11.5 7-26 7-37.5 0l-17.9-10.9c-5.9-3.6-12.7-5.4-19.6-5.2l-20.9 .5c-13.5 .3-26-6.9-32.5-18.7L72.4 326c-3.3-6.1-8.3-11-14.3-14.3l-18.4-10c-11.8-6.5-19.1-19-18.7-32.5l.5-20.9c.2-6.9-1.7-13.7-5.2-19.6L5.3 210.7c-7-11.5-7-26 0-37.5l10.9-17.9c3.6-5.9 5.4-12.7 5.2-19.6l-.5-20.9c-.3-13.5 6.9-26 18.7-32.5L58 72.4c6.1-3.3 11-8.3 14.3-14.3l10-18.4c6.5-11.8 19-19.1 32.5-18.7l20.9 .5c6.9 .2 13.7-1.7 19.6-5.2L173.3 5.3zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM64.4 492.4L88 390c8.9 3.7 18.6 5.6 28.6 5.4l20.7-.5c.2 0 .4 .1 .6 .2l17.6 10.7c22.4 13.6 50.5 13.6 72.9 0L246.1 395c.2-.1 .4-.2 .6-.2l20.7 .5c10 .2 19.7-1.7 28.6-5.4l23.6 102.4c1.3 5.5-.5 11.3-4.6 15.2s-10 5.3-15.4 3.8L192 480.6 84.4 511.4c-5.4 1.6-11.3 .1-15.4-3.8s-5.8-9.7-4.6-15.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAwardSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cn);
var Dn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "axe", f = 640, c = 512, e = [129683], t = "f6b2", o = "M374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3l0 82.7c0 17.7 14.3 32 32 32c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32l-82.7 0-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4zM448 316c45-11.6 80.4-47 92-92l32.8 0C560.1 286.7 510.7 336.1 448 348.8l0-32.8zM244.1 206.6L9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0L305.4 267.9l-61.3-61.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAxe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dn);
var $n = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "axe-battle", f = 512, c = 512, e = [], t = "f6b3", o = "M95.9 14l0 .1c0 .1 .1 .4 .1 .7c.1 .7 .3 1.8 .6 3.3c.6 3 1.7 7.4 3.5 12.8c3.6 10.8 9.9 25.1 20.6 39.5c13.9 18.6 36 37.9 71.2 48.8l0 147.6c-29.9 11.1-50.9 29.3-65.6 47.3c-11.9 14.6-19.7 29.3-24.5 40.3c-2.4 5.5-4 10-5.1 13.1c-.5 1.5-.9 2.7-1.1 3.5l-.2 .8 0 .1s0 0 0 0c-1.5 5.8-6.1 10.3-11.9 11.7s-12-.7-15.8-5.3L80 368c-12.2 10.3-12.2 10.3-12.2 10.3s0 0 0 0s0 0 0 0c0 0 0 0-.1-.1l-.2-.2-.6-.8c-.5-.7-1.3-1.6-2.3-2.9c-1.9-2.5-4.6-6.1-7.7-10.6c-6.3-9.2-14.7-22.4-23.1-38.9C17 291.9 0 245.3 0 192S17 92.1 33.7 59.3c8.4-16.5 16.8-29.7 23.1-38.9c3.2-4.6 5.8-8.2 7.7-10.6c1-1.2 1.7-2.2 2.3-2.9l.6-.8 .2-.2c0 0 0 0 .1-.1c0 0 0 0 0 0s0 0 0 0L80 16 67.8 5.7c4.1-4.9 10.7-6.8 16.8-5c6.1 1.8 10.5 7 11.3 13.3c0 0 0 0 0 0zM320 266.8l0-147.6c35.2-10.9 57.3-30.2 71.2-48.8C403.3 54.3 412.8 34 416.1 14c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.8 .3 16.9 5.2c13.3 16.3 24.4 34.8 33.9 53.4c12.4 24.5 25.1 56.6 30.7 93.4c.5 3.5-1.4 7-4.7 8.4l-55.1 23.6c-6.5 2.8-6.5 11.9 0 14.7L504.3 223c3.3 1.4 5.3 4.8 4.7 8.4c-8 53-31.3 105.5-64.5 146.6c-3.9 4.6-10.3 7-16.1 5.6s-10.5-6-11.9-11.8c-5.9-21-17.2-40.9-30.9-57.7c-14.7-18-35.7-36.2-65.6-47.3zM288 64l0 416c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-416c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faAxeBattle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($n);
var _n = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "backpack", f = 448, c = 512, e = [127890], t = "f5d4", o = "M192 48l64 0c4.4 0 8 3.6 8 8l0 40-80 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-8 0C57.3 96 0 153.3 0 224L0 448c0 35.3 28.7 64 64 64l0-112 0-48c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 48 0 112c35.3 0 64-28.7 64-64l0-224c0-70.7-57.3-128-128-128l-8 0 0-40c0-30.9-25.1-56-56-56L192 0c-30.9 0-56 25.1-56 56zM352 512l0-96L96 416l0 96 256 0zM144 176l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352 384l0-32c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32l0 32 256 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBackpack = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_n);
var bn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "badge", f = 512, c = 512, e = [], t = "f335", o = "M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBadge = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bn);
var Sn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "badge-check", f = 512, c = 512, e = [], t = "f336", o = "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBadgeCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sn);
var yn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "badge-dollar", f = 512, c = 512, e = [], t = "f645", o = "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20l0 17.4c-8.8 1.8-17.7 4.8-25.7 9.6c-15 8.9-27.7 24.4-27.6 46.9c.1 21.5 12.6 35.1 26.3 43.4c11.9 7.2 27 11.7 39.1 15.4l1.9 .6c13.9 4.2 24.4 7.6 31.7 12.2c6.1 3.8 7.5 6.8 7.6 11c.1 6.5-2.5 10.4-7.6 13.6c-6 3.7-15.2 5.9-25.1 5.6c-12.7-.4-24.6-4.4-39.7-9.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.6-.9-5.2-1.8-8-2.7c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2 .7 4.5 1.5 6.8 2.3c9.7 3.3 20.9 7.2 32.8 9.6l0 18c0 11 9 20 20 20s20-9 20-20l0-17.1c9.3-1.7 18.6-4.9 26.8-10.1c15.3-9.5 26.8-25.7 26.5-48.1c-.3-21.6-12.4-35.6-26.3-44.3c-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9c-6.2-3.7-7-6.3-7-9.3c0-5.1 2.1-8.8 7.9-12.3c6.5-3.8 16-6 25-5.8c10.9 .2 22.9 2.6 35.2 5.8c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4l0-17.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBadgeDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yn);
var On = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "badge-percent", f = 512, c = 512, e = [], t = "f646", o = "M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBadgePercent = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(On);
var kn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "badge-sheriff", f = 448, c = 512, e = [], t = "f8a2", o = "M272 48c0 14.8-6.7 28-17.2 36.8l25 42.8c5.7 9.8 16.2 15.8 27.5 15.9l47.6 .2c6.7-18.5 24.4-31.7 45.2-31.7c26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L363 240.1c-5.6 9.8-5.6 21.9 0 31.8l20.1 35.2c5.3-2 10.9-3.1 16.9-3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-47.6 .2c-11.3 0-21.8 6.1-27.5 15.9l-25 42.8c10.5 8.8 17.2 22 17.2 36.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8l-25-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-47.6-.2C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L85 271.9c5.6-9.8 5.6-21.9 0-31.8L64.9 204.9c-5.3 2-10.9 3.1-16.9 3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l47.6-.2c11.3 0 21.8-6.1 27.5-15.9l25-42.8C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBadgeSheriff = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kn);
var An = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "badger-honey", f = 640, c = 512, e = [129441], t = "f6b4", o = "M164.6 389.3l16-37.3 118.1 0 16.9 101.3c2.6 15.4 15.9 26.7 31.6 26.7l31.1 0c19.8 0 34.8-17.8 31.6-37.3L393 342.1c27.9-29 80.6-70.8 144.1-90.8l16.1 25.8c3.1 5 10.4 5 13.6 0l22.8-36.5c12.9-2.1 25.2-7.4 34.4-16.6c10.2-10.2 16-24.1 16-38.6l0-3.8c0-23.2-12.6-44.5-32.8-55.8L525.3 80.3C506.1 69.6 484.5 64 462.5 64c-20.1 0-39.9 4.7-57.8 13.6L400 80c-21 10.5-44.2 16-67.8 16L160 96l-32 0C57.3 96 0 153.3 0 224l0 32c0 17.7 14.3 32 32 32c5.4 0 10.6-1.4 15-3.7c9.1 17.1 22.1 31.9 37.7 43.3l-16.8 59c-2.5 8.8-2.5 18.2 .2 27l13.1 43.7c4.1 13.5 16.5 22.8 30.7 22.8l29.2 0c21.4 0 36.8-20.7 30.7-41.2l-8.3-27.7c-2.2-7.2-1.7-14.9 1.2-21.8zM570 160l-51.3 0c.9 2.5 1.4 5.2 1.4 8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-2.8 .5-5.5 1.4-8l-5.9 0c-23.2 0-46 6.3-65.9 18.2L294.8 242.3c-14.9 9-32 13.7-49.4 13.7L192 256c-46.4 0-86.2-28.2-103.2-68.5C102 161.7 129 144 160 144l172.2 0c31 0 61.5-7.2 89.2-21.1l4.7-2.4c11.3-5.6 23.7-8.6 36.3-8.6c13.8 0 27.4 3.5 39.5 10.2L570 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBadgerHoney = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(An);
var jn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "badminton", f = 576, c = 512, e = [], t = "e33a", o = "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154zM464 400c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32-96 0 0-32zm-15.3 91.4l13-43.4 33.4 0-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9zM496 496l0-48 32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16zm48.7 4.6L528.9 448l33.4 0 13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBadminton = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jn);
var Bn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bag-seedling", f = 512, c = 512, e = [], t = "e5f2", o = "M64 64L38.6 38.6c-4.2-4.2-6.6-10-6.6-16C32 10.1 42.1 0 54.6 0L457.4 0C469.9 0 480 10.1 480 22.6c0 6-2.4 11.8-6.6 16L448 64 64 64zM56 96l400 0 10.6 42.5c8.9 35.5 13.4 72 13.4 108.7l0 17.7c0 36.6-4.5 73.1-13.4 108.7L456 416 56 416 45.4 373.5C36.5 338 32 301.5 32 264.8l0-17.7c0-36.6 4.5-73.1 13.4-108.7L56 96zm8 352l384 0 25.4 25.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L54.6 512C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16L64 448zm80-288c-8.8 0-16 7.2-16 16c0 59.2 45.9 107.6 104 111.7l0 40.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40.3c58.1-4.1 104-52.6 104-111.7c0-8.8-7.2-16-16-16l-2 0c-47.3 0-88.4 26-110 64.5C234.4 186 193.3 160 146 160l-2 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBagSeedling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bn);
var Tn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bag-shopping-minus", f = 448, c = 512, e = [], t = "e650", o = "M224 48c-35.3 0-64 28.7-64 64l0 48 128 0 0-48c0-35.3-28.7-64-64-64zM48 160l64 0 0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208c0-26.5 21.5-48 48-48zm96 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBagShoppingMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tn);
var Fn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bag-shopping-plus", f = 448, c = 512, e = [], t = "e651", o = "M224 48c-35.3 0-64 28.7-64 64l0 48 128 0 0-48c0-35.3-28.7-64-64-64zM48 160l64 0 0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208c0-26.5 21.5-48 48-48zM200 416c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 56z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBagShoppingPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fn);
var Hn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bagel", f = 640, c = 512, e = [129391], t = "e3d7", o = "M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c6.5-12.3 12-25.3 16.3-38.8c4.7-.7 9.3-2.5 13.3-5.3L471 357.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6L582 275.8c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6L450.1 44.4c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6L350.5 65c-13.2 .4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zM396.1 155c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm256 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM144 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBagel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hn);
var Rn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bags-shopping", f = 576, c = 512, e = [128717], t = "f847", o = "M176 96l0 64 96 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-48 64l0-64c0-53 43-96 96-96s96 43 96 96l0 64 64 0c35.3 0 64 28.7 64 64l-208 0c-44.2 0-80 35.8-80 80l0 160c0 5.5 .6 10.8 1.6 16L64 480c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0zm128 96l256 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBagsShopping = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rn);
var Un = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "baguette", f = 640, c = 512, e = [129366], t = "e3d8", o = "M583 234.5c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5L356.5 77.8l70.8 70.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L329.3 95.9l-88 58.7 74 74c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-78.6-78.6-88 58.7 77.2 77.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L98.9 249.5 57 277.5C-1.8 316.7-17.7 396.2 21.5 455s118.7 74.7 177.5 35.5l384-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBaguette = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Un);
var qn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ball-pile", f = 576, c = 512, e = [], t = "f77e", o = "M288 160A80 80 0 1 0 288 0a80 80 0 1 0 0 160zM176 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM160 432A80 80 0 1 0 0 432a80 80 0 1 0 160 0zm128 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm288-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM400 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBallPile = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qn);
var Gn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "balloon", f = 384, c = 512, e = [], t = "e2e3", o = "M0 192C0 86 86 0 192 0S384 86 384 192c0 102.6-102.8 194.9-143.6 227.5c-9.3 7.4-12.5 20.4-7.1 31l21.4 42.7c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9l-102.1 0c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l21.4-42.7c5.3-10.6 2.1-23.6-7.1-31C102.8 386.9 0 294.6 0 192zm96-16c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.1 64 64 114.1 64 176c0 8.8 7.2 16 16 16s16-7.2 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBalloon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gn);
var Wn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "balloons", f = 640, c = 512, e = [], t = "e2e4", o = "M320 160C320 71.6 248.4 0 160 0S0 71.6 0 160c0 92.5 87.2 174 117.7 199.7c5.9 5 7.8 13.4 4.4 20.3L97.4 429.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9l102.1 0c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L198 379.9c-3.5-6.9-1.6-15.3 4.4-20.3C232.8 334 320 252.5 320 160zM144 96c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zM437.7 423.7c5.9 5 7.8 13.4 4.4 20.3l-24.7 49.3c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9l102.1 0c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8L518 443.9c-3.5-6.9-1.6-15.3 4.4-20.3C552.8 398 640 316.5 640 224c0-88.4-71.6-160-160-160c-53.7 0-101.2 26.4-130.2 67c1.4 9.5 2.2 19.2 2.2 29c0 37.2-11.5 71.8-27.3 101.9c18.5 76.2 86.8 139.7 113 161.8zM416 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBalloons = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wn);
var En = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ballot", f = 448, c = 512, e = [], t = "f732", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm0 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 128c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 352l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm112 32c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm16-272l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM192 256c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBallot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(En);
var Vn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ballot-check", f = 448, c = 512, e = [], t = "f733", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm0 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 256c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm144 0l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM192 128c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm16 112l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-52.7-27.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 249.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBallotCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vn);
var yi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ban-bug", f = 512, c = 512, e = ["debug"], t = "f7f9", o = "M256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5C335.9 434.9 297.5 448 256 448zm89-148.3l19.9 4c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7 0-18.6 35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19c-18.7 0-35.9 6.4-49.6 17.2L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L345 299.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBanBug = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yi);
var Oi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ban-parking", f = 512, c = 512, e = ["parking-circle-slash"], t = "f616", o = "M412.5 367.2L342.3 297c20.6-17.6 33.7-43.8 33.7-73c0-53-43-96-96-96l-72 0c-9.7 0-18.6 3.5-25.5 9.2L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2zm-45.3 45.3C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2L367.2 412.5zM296.6 251.4L237.3 192l42.7 0c17.7 0 32 14.3 32 32c0 11.6-6.2 21.7-15.4 27.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 325.3l-64-64 0 26.7 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-26.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBanParking = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Oi);
var In = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "banana", f = 576, c = 512, e = [], t = "e2e5", o = "M304 144c0 35.7-7.3 69.6-20.5 100.5c4.8 3 9.4 6.2 13.9 9.8l35.5 28.4L413.9 261c10.6-2.8 21.4-4.4 32.3-4.9c1.2-10.5 1.8-21.3 1.8-32.1c0-84.7-36.6-160.9-94.8-213.6C345.6 3.6 335.9 0 326.1 0c-29.4 0-47.5 29.4-38 55c10.3 27.7 15.9 57.7 15.9 89zM277.4 279.2c-18.8-15-42.1-23.2-66.1-23.2c-22.9 0-45.2 7.4-63.5 21.2l-42.2 31.6c-10.6 8-12.8 23-4.8 33.6s23 12.8 33.6 4.8l42.2-31.6c10-7.5 22.2-11.6 34.7-11.6c10.5 0 20.8 2.9 29.7 8.2C194.1 366 125 400 48 400c-26.5 0-48 21.5-48 48l0 16c0 26.5 21.5 48 48 48l112 0c117.3 0 218.2-70.1 263.1-170.6l11.5-3.1c5.7-1.5 11.6-2.3 17.5-2.3c23.8 0 45.9 12.5 58.1 32.9l21.3 35.4c6.8 11.4 21.6 15 32.9 8.2s15-21.6 8.2-32.9l-21.3-35.4C530.4 309.3 492.7 288 452 288c-3.8 0-7.5 .2-11.3 .6c-5.5 .5-10.9 1.5-16.3 2.8c-.8 .2-1.5 .4-2.3 .6l-96.7 25.8s0 0 0 0l-48.1-38.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBanana = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(In);
var Kn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "banjo", f = 512, c = 512, e = [129685], t = "f8a3", o = "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41L286 180.7c-20.6-13.9-44.3-23.4-70-27l0-1.7c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296L24 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l1.7 0c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7l0 1.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6l1.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.7 0c-3.7-25.7-13.1-49.5-27-70l76.1-76.1 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM155.3 308.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBanjo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kn);
var Xn = {}, ki = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-barcode", f = 576, c = 512, e = ["barcode-alt"], t = "f463", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 96c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm88-16c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm88 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm112-24c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleBarcode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ki);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ki;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBarcodeAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Xn);
var Qn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "barcode-read", f = 576, c = 512, e = [], t = "f464", o = "M56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48zm96 80l16 0c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm160 0l16 0c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm72 24c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-208zM240 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM528 56c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80zM56 464l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 4.4 3.6 8 8 8zm472-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c4.4 0 8-3.6 8-8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBarcodeRead = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qn);
var Jn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "barcode-scan", f = 640, c = 512, e = [], t = "f465", o = "M88 32C74.7 32 64 42.7 64 56l0 136 64 0 0-136c0-13.3-10.7-24-24-24L88 32zM64 456c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-136-64 0 0 136zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm64-8c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-136-64 0 0 136zm0-264l64 0 0-136c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24l0 136zm96 264c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-136-64 0 0 136zm0-264l64 0 0-136c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24l0 136zM448 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm0-416l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 408c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-136-64 0 0 136zm0-264l64 0 0-136c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24l0 136zm-352 0l32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBarcodeScan = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jn);
var Yn = {}, Ai = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "farm", f = 576, c = 512, e = ["barn-silo"], t = "f864", o = "M0 96C0 43 43 0 96 0s96 43 96 96L0 96zm181.4 32L132.8 246c-3.2 7.7-4.8 16-4.8 24.4L128 480c0 11.7 3.1 22.6 8.6 32L48 512c-26.5 0-48-21.5-48-48L0 128l181.4 0zM160 480l0-209.7c0-4.2 .8-8.3 2.4-12.2l48.9-118.7c3-7.4 8.7-13.3 15.9-16.7L354.3 62.5c8.7-4.1 18.7-4.1 27.4 0l127.1 60.2c7.2 3.4 12.9 9.4 15.9 16.7l48.9 118.7c1.6 3.9 2.4 8 2.4 12.2L576 480c0 17.7-14.3 32-32 32l-112 0 0-64c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 64-112 0c-17.7 0-32-14.3-32-32zM320 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFarm = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ai);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ai;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBarnSilo = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Yn);
var Zn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bars-filter", f = 448, c = 512, e = [], t = "e0ad", o = "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32zM288 416c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c17.7 0 32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBarsFilter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zn);
var pn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bars-sort", f = 448, c = 512, e = [], t = "e0ae", o = "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM192 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c17.7 0 32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBarsSort = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pn);
var xn = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "basket-shopping-minus", f = 576, c = 512, e = [], t = "e652", o = "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-85.6 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM208 328l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBasketShoppingMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xn);
var i6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "basket-shopping-plus", f = 576, c = 512, e = [], t = "e653", o = "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l85.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L492.1 463.5C485 492 459.4 512 430 512L146 512c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32l85.6 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM184 352c0 13.3 10.7 24 24 24l56 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-56 0c-13.3 0-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBasketShoppingPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i6);
var ji = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "basket-shopping-simple", f = 576, c = 512, e = ["shopping-basket-alt"], t = "e0af", o = "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l85.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L492.1 463.5C485 492 459.4 512 430 512L146 512c-29.4 0-55-20-62.1-48.5L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32l85.6 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM144 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm312-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBasketShoppingSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ji);
var a6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "basketball-hoop", f = 640, c = 512, e = [], t = "f435", o = "M6.8 187C24.7 153.1 116.7 0 320 0S615.3 153.1 633.2 187c4.9 9.4 6.8 19.1 6.8 28l0 116.3c0 25.3-14.9 48.2-38 58.5l-96.4 42.9L526.2 288l-32.3 0-7.2 50.3-22.9 160c-.9 6.1-5.2 11.2-11.1 13s-12.3 .1-16.5-4.4L384.4 451l-52.8 56c-3 3.2-7.2 5-11.6 5s-8.6-1.8-11.6-5l-52.8-56-51.9 55.9c-4.2 4.5-10.6 6.2-16.5 4.4s-10.2-6.9-11.1-13l-22.9-160L146.1 288l-32.3 0 20.7 144.6L38 389.7C14.9 379.4 0 356.5 0 331.2L0 214.9c0-8.9 1.8-18.6 6.8-28zM178.4 288l5.2 36.6 44-36.6-49.2 0zm99.3 0l-.6 .5L320 334.6l42.8-46.1-.6-.5-84.4 0zm134.5 0l44 36.6 5.2-36.6-49.2 0zM192 128c-17.7 0-32 14.3-32 32l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 288 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-17.7-14.3-32-32-32l-256 0zm256 32l0 48-256 0 0-48 256 0zM387.5 309l-45.7 49.2 42.7 46 51.6-54.7L387.5 309zm49.4 151.6l11-76.8-41.5 44 30.5 32.9zM320 381.7l-42.6 45.9L320 472.7l42.6-45.2L320 381.7zm-21.8-23.5L252.5 309l-48.7 40.5 51.6 54.7 42.7-46zm-64.6 69.5l-41.5-44 11 76.8 30.5-32.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBasketballHoop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a6);
var e6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bat", f = 576, c = 512, e = [], t = "f6b5", o = "M235.6 52.8l10.8 14.4c6 8.1 15.5 12.8 25.6 12.8l32 0c10.1 0 19.6-4.7 25.6-12.8l10.8-14.4c2.3-3 5.8-4.8 9.6-4.8c5.8 0 10.8 4.1 11.8 9.8l19 101.4L452.6 125c16.2-7.7 35.5-3.6 47.1 10C548.9 192.4 576 265.6 576 341.2l0 37.6c0 9.7-10.2 16-18.9 11.7l-63.8-31.9c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1l-36.6-36.6c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1L18.9 390.5c-8.7 4.3-18.9-2-18.9-11.7l0-37.6C0 265.6 27.1 192.4 76.3 135c11.6-13.6 30.9-17.7 47.1-10l71.8 34.2 19-101.4c1.1-5.7 6-9.8 11.8-9.8c3.8 0 7.4 1.8 9.6 4.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e6);
var n6 = {}, Bi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "battery-low", f = 576, c = 512, e = ["battery-1"], t = "e0b1", o = "M464 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm80 96l-64 0 0 128 64 0 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBatteryLow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Bi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBattery1 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(n6);
var f6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "battery-bolt", f = 576, c = 512, e = [], t = "f376", o = "M80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l92.2 0c-12.9-14.5-16.1-35.6-7.2-53.5l5.3-10.5L80 352c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l139.2 0 80-64L80 96zM464 352l-139.2 0-80 64L464 416c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80l-92.2 0c13 14.5 16.1 35.6 7.2 53.5L373.7 160l90.3 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16zM346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L193.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBatteryBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f6);
var c6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "battery-exclamation", f = 576, c = 512, e = [], t = "e0b0", o = "M208 96l0 64L80 160c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16l118.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L80 416c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l128 0zM464 416l-118.7 0c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32L464 352c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-128 0 0-64 128 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80zM272 96c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM240 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBatteryExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c6);
var t6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "battery-slash", f = 640, c = 512, e = [], t = "f377", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6C563.1 386 576 362.5 576 336l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L154.8 96 38.8 5.1zM236.4 160L496 160c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-14.6 0-245-192zM406.2 416l-81.2-64L112 352c-8.8 0-16-7.2-16-16l0-160c0-1.4 .2-2.7 .5-4L45.4 131.7C36.9 144.4 32 159.6 32 176l0 160c0 44.2 35.8 80 80 80l294.2 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBatterySlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t6);
var o6 = {}, Ti = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bed-front", f = 512, c = 512, e = ["bed-alt"], t = "f8f7", o = "M32 80c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 129.1c-14.5-8.4-30.7-14-48-16.1c0-.3 0-.7 0-1l0-32c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 32-32 0 0-32c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 32c0 .3 0 .7 0 1c-17.3 2.2-33.6 7.8-48 16.1L32 80zM0 320c0-53 43-96 96-96l320 0c53 0 96 43 96 96l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L64 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBedFront = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ti);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ti;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBedAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(o6);
var l6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bed-bunk", f = 576, c = 512, e = [], t = "f8f8", o = "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 192 0 256 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 0-32 0-128 0-32 0-64 0-32 0-48C576 50.1 525.9 0 464 0L256 0c-17.7 0-32 14.3-32 32l0 96L64 128l0-96zM512 256l-256 0c-17.7 0-32 14.3-32 32l0 96L64 384l0-192 192 0 256 0 0 64zM192 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBedBunk = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l6);
var d6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bed-empty", f = 640, c = 512, e = [128719], t = "f8f9", o = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 256l0 96 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 288 0 224 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-53-43-96-96-96L64 224 64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBedEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d6);
var r6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bee", f = 576, c = 512, e = [], t = "e0b2", o = "M196.7 4.7c6.2-6.2 16.4-6.2 22.6 0l34.8 34.8C264.4 34.7 275.9 32 288 32s23.6 2.7 33.9 7.5L356.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L347.8 58.8C360.4 73 368 91.6 368 112c0 3-.2 6-.5 8.9C390.3 105 419 96 448 96c65 0 128 44.9 128 112c0 61.9-53.6 104.9-112.9 111.2c.6-5.1 .9-10.2 .9-15.2c0-16.8-2.4-33.1-6.8-48.5c35.2-3.6 54.8-27.9 54.8-47.5c0-21.3-22.9-48-64-48c-34.8 0-56.6 19.2-62.4 38.1c28.6 26.3 46.4 64 46.4 105.9c0 83.8-103.6 179.7-129.9 202.8c-3.9 3.4-8.9 5.2-14.1 5.2s-10.2-1.8-14.1-5.2C247.6 483.7 144 387.8 144 304c0-41.9 17.9-79.6 46.4-105.9C184.6 179.2 162.8 160 128 160c-41.1 0-64 26.7-64 48c0 19.6 19.5 43.9 54.8 47.5c-4.4 15.4-6.8 31.7-6.8 48.5c0 5 .3 10.1 .9 15.2C53.6 312.9 0 269.9 0 208C0 140.9 63 96 128 96c29 0 57.7 9 80.5 24.9c-.3-2.9-.5-5.9-.5-8.9c0-20.4 7.6-39 20.2-53.2L196.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm52.8 384.1c12.8 16.4 26.5 31.3 38.5 43.4c12-12.1 25.7-27 38.5-43.4c1.2-1.6 2.5-3.2 3.7-4.8l-84.3 0c1.2 1.6 2.4 3.2 3.7 4.8zM359.6 336c5.6-12.6 8.4-23.4 8.4-32l-160 0c0 8.6 2.8 19.4 8.4 32l143.2 0zM352 256c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32l128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBee = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r6);
var s6 = {}, Fi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "beer-mug", f = 512, c = 512, e = ["beer-foam"], t = "e0b3", o = "M267.7 133.3C253 149.7 231.7 160 208 160s-45-10.3-59.7-26.7c-6.9-7.7-21.4-8.6-29.6-2.3C108 139.1 94.6 144 80 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c14.6 0 28 4.9 38.7 13c8.2 6.3 22.7 5.4 29.6-2.3C163 10.3 184.3 0 208 0s45 10.3 59.7 26.7c6.9 7.7 21.4 8.6 29.6 2.3C308 20.9 321.4 16 336 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.6 0-28-4.9-38.7-13c-8.2-6.3-22.7-5.4-29.6 2.3zM32 448l0-284.8C46.1 171.3 62.5 176 80 176c18.7 0 36.2-5.4 51-14.7c20 19 47.2 30.7 77 30.7s57-11.7 77-30.7c14.8 9.3 32.3 14.7 51 14.7c19.6 0 37.9-5.9 53.1-16l46.1 0c42.4 0 76.8 34.4 76.8 76.8l0 102.1c0 30.3-17.9 57.9-45.6 70.2L384 445.7l0 2.3c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64zm352-72.4l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7l0-102.1c0-7.1-5.7-12.8-12.8-12.8L384 224l0 151.6zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBeerMug = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Fi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBeerFoam = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(s6);
var h6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bell-exclamation", f = 448, c = 512, e = [], t = "f848", o = "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM192 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-184l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBellExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h6);
var v6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bell-on", f = 640, c = 512, e = [128365], t = "f8fa", o = "M320 0c-17.7 0-32 14.3-32 32l0 19.2C215 66 160 130.6 160 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S115.4 416 128 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C497.3 319.2 480 273.9 480 226.8l0-18.8c0-77.4-55-142-128-156.8L352 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM0 200c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zm536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM597.5 21.3c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2zM53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32C62.9 4.6 48.5 9.4 42.5 21.3s-1.1 26.3 10.7 32.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBellOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v6);
var u6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bell-plus", f = 448, c = 512, e = [], t = "f849", o = "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM224 152c13.3 0 24 10.7 24 24l0 40 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-40c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBellPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u6);
var m6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bell-ring", f = 512, c = 512, e = [], t = "e62c", o = "M256 0c-17.7 0-32 14.3-32 32l0 19.2C151 66 96 130.6 96 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S51.4 416 64 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C433.3 319.2 416 273.9 416 226.8l0-18.8c0-77.4-55-142-128-156.8L288 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7zM113.4 15.4c-9.1-9.6-24.3-10-33.9-.8C30.5 61.2 0 127.1 0 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-59.3 24.8-112.7 64.6-150.6c9.6-9.1 10-24.3 .8-33.9zM399.4 49.4C439.2 87.3 464 140.7 464 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-72.9-30.5-138.8-79.4-185.4c-9.6-9.1-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBellRing = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m6);
var g6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bell-school", f = 512, c = 512, e = [], t = "f5d5", o = "M208 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 288A208 208 0 1 0 208 0a208 208 0 1 0 0 416zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 448c-54 0-103.9-17.9-144-48l0 64c0 26.5 21.5 48 48 48l208 0 32 0 40 0c43.4 0 80.1-28.8 92-68.3c16.6-7.6 28-24.3 28-43.7c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15.5 7.3 29.2 18.7 38c-8 15.4-24.1 26-42.7 26l-40 0 0-64c-40.1 30.1-90 48-144 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBellSchool = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g6);
var P6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bell-school-slash", f = 640, c = 512, e = [], t = "f5d6", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22c0-26.5-21.5-48-48-48c-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0C211.2 0 156.6 26.1 118.5 67.6L38.8 5.1zM220 147.2c14-11.9 32.1-19.2 52-19.2c44.2 0 80 35.8 80 80c0 12.9-3.1 25.1-8.5 35.9l-26.1-20.4c1.7-4.9 2.6-10.1 2.6-15.5c0-26.5-21.5-48-48-48c-9.5 0-18.4 2.8-25.9 7.6L220 147.2zM508.3 496.5L465.8 463c-3.2 .7-6.4 1-9.8 1l-40 0 0-40.2-16.1-12.7C362.9 434.5 319 448 272 448c-54 0-103.9-17.9-144-48l0 64c0 26.5 21.5 48 48 48l208 0 32 0 40 0c19.3 0 37.3-5.7 52.3-15.5zM373 389.9L71.5 152.4C66.6 170.1 64 188.7 64 208c0 114.9 93.1 208 208 208c36.7 0 71.1-9.5 101-26.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBellSchoolSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P6);
var M6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bells", f = 640, c = 512, e = [], t = "f77f", o = "M230.8 245.5l18.7 51.2c11.7 31.8 12.9 66.5 3.5 99.1l-1.1 3.9L21.4 315.8C10 311.7 2 301.5 .6 289.5s4.1-23.8 14.3-30.4l8.2-5.4C57.6 231 84 197.8 98.2 159l14.7-40C138 50.4 214 15.1 282.6 40.1c4.8 1.7 9.4 3.7 13.9 6c-64.1 42.2-93.3 124.2-65.7 199.5zm112-187.1c71.4-26 150.4 10.8 176.5 82.1L538 191.7c14 38.2 39.8 71 73.6 93.6l13.7 9.2c10 6.7 15.4 18.5 14 30.4s-9.5 22.1-20.8 26.2L321.1 459.4c-11.3 4.1-24 1.5-32.8-6.7s-12.3-20.7-9-32.2l4.6-15.8c11.2-39 9.7-80.7-4.3-118.9l-18.8-51.2c-26.1-71.3 10.5-150.2 81.9-176.2zM480.8 480c-21.2 0-40-10.2-51.7-25.9l116.1-42.3c.1 1.3 .1 2.6 .1 3.9c0 35.5-28.9 64.3-64.5 64.3zM94.3 376.2l117.6 43.4c-11.6 17.1-31.2 28.4-53.5 28.4c-35.6 0-64.5-28.8-64.5-64.3c0-2.5 .1-5.1 .4-7.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBells = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M6);
var w6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bench-tree", f = 640, c = 512, e = [], t = "e2e7", o = "M608 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176c0 44.2-35.8 80-80 80l-16 0 0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224-16 0c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96zM32 224c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L64 320c-17.7 0-32-14.3-32-32l0-64zm0 128l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64L96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBenchTree = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w6);
var N6 = {}, Hi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cassette-betamax", f = 576, c = 512, e = ["betamax"], t = "f8a4", o = "M64 32C28.7 32 0 60.7 0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32zM576 160L0 160 0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256zM192 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 320a96 96 0 1 1 192 0A96 96 0 1 1 64 320zm256-64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCassetteBetamax = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Hi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBetamax = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(N6);
var z6 = {}, Ri = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-biking-mountain", f = 640, c = 512, e = [128693, "biking-mountain"], t = "f84b", o = "M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM427.2 160l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zm-238.8 6.7L290.8 89.9c7.2-5.4 8.5-15.7 2.9-22.8L278.8 48.4c-21.6-27-60.7-32-88.4-11.2L125.2 86.1c-7.2 5.4-8.5 15.7-2.9 22.8l44 55c5.4 6.7 15.2 8 22.1 2.8zM120 256c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3L31.8 299.1c-8.6 8.6-9.3 21.9-2.3 31.3c-3.7 6.9-6.8 14.1-9 21.8C8.9 353.9 0 363.9 0 376l0 16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9C97.9 503.1 107.9 512 120 512l16 0c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.7-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.8-3.7-14.1-6.8-21.7-9C158.1 264.9 148.1 256 136 256l-16 0zm8 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352.2-43.4c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3c-3.7 6.9-6.8 14.1-9 21.8C392.9 353.9 384 363.9 384 376l0 16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.5 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6l16 0c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.8-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.9-3.7-14.1-6.8-21.8-9C542.1 264.9 532.1 256 520 256l-16 0c-12.1 0-22.1 8.9-23.8 20.6zM448 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonBikingMountain = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ri);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ri;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBikingMountain = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(z6);
var L6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "billboard", f = 640, c = 512, e = [], t = "e5cd", o = "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32L256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32L80 32C53.5 32 32 53.5 32 80l0 272c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 208 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 208 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-272c0-26.5-21.5-48-48-48L448 32zM320 352L96 352 96 96l96 0 0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-32 128 0 0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-32 96 0 0 256-224 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBillboard = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L6);
var C6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bin-bottles", f = 640, c = 512, e = [], t = "e5f5", o = "M152 0l80 0c13.3 0 24 10.7 24 24l0 8c8.8 0 16 7.2 16 16s-7.2 16-16 16L128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-8c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96l128 0c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192L32 192zm352 0c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7l0-42.1c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 42.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5L384 192zM0 256c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L583.8 457c-4.5 31.5-31.5 55-63.4 55l-401 0c-31.8 0-58.9-23.4-63.4-55L32 288c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBinBottles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C6);
var D6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bin-bottles-recycle", f = 640, c = 512, e = [], t = "e5f6", o = "M152 0c-13.3 0-24 10.7-24 24l0 8c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-8c0-13.3-10.7-24-24-24L152 0zM32 192l320 0c0-26.5-10.7-50.5-28.1-67.9c-1.1-1.1-2.1-2.1-3.2-3.1c-17.1-15.5-39.7-25-64.6-25L128 96c-53 0-96 43-96 96zm352 0l191.1 0c-1.2-9.7-4.6-18.7-9.6-26.5c6.4-9.5 10.1-21 10.1-33.3c0-23.2-13.4-44.3-34.4-54.2L528 71.8c-5.3-2.5-10.8-4.4-16.4-5.7l0-42.1c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24l0 42.1c-5.6 1.3-11.1 3.2-16.4 5.7L354.1 78c-7.2 3.4-13.5 8-18.6 13.6C365 115.1 384 151.3 384 192zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32L56.2 457c4.5 31.5 31.5 55 63.4 55l401 0c31.8 0 58.9-23.4 63.4-55L608 288c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224zM308.5 326.1l-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7c-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4c15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4c-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2c-4.6 0-8.9 2.3-11.5 6.1zm-43.1 64.7l-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7c0 4.7 3.8 8.6 8.6 8.6l25.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-25.2 0c-22.4 0-40.6-18.2-40.6-40.6c0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7c7.6 4.8 9.8 14.9 4.8 22.4zM353.7 416l20.9 0c4.8 0 8.6-3.9 8.6-8.6c0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4c7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4c0 22.4-18.2 40.6-40.6 40.6l-20.9 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBinBottlesRecycle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D6);
var $6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bin-recycle", f = 576, c = 512, e = [], t = "e5f7", o = "M0 64C0 46.3 14.3 32 32 32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zm32 64l512 0L517.3 421.8c-3 33-30.6 58.2-63.7 58.2l-331.1 0c-33.1 0-60.7-25.2-63.7-58.2L32 128zm256 88c2.2 0 4.3 1.1 5.5 2.9l20.7 29.6c7.3 10.5 21.6 13.4 32.4 6.6c11.7-7.3 14.8-22.9 6.9-34.1l-20.7-29.6c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-20.7 29.6c-7.9 11.3-4.7 26.8 6.9 34.1c10.8 6.8 25.1 3.9 32.4-6.6l20.7-29.6c1.3-1.8 3.3-2.9 5.5-2.9zm-88.3 77.1c-10.8-6.8-25.1-3.9-32.4 6.6l-21.5 30.7c-6.4 9.1-9.8 20-9.8 31.2c0 30.1 24.4 54.4 54.4 54.4l49.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-49.6 0c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l21.5-30.7c7.9-11.3 4.7-26.8-6.9-34.1zM312 392c0 13.3 10.7 24 24 24l49.6 0c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2l-21.5-30.7c-7.3-10.5-21.6-13.4-32.4-6.6c-11.7 7.3-14.8 22.9-6.9 34.1l21.5 30.7c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4L336 368c-13.3 0-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBinRecycle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($6);
var _6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "binary", f = 384, c = 512, e = [], t = "e33b", o = "M336 32l0 128 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-83.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16C303.6-1.6 314.4 0 322.7 6s13.3 15.7 13.3 26zM112 320l0 128 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-83.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4s13.3 15.7 13.3 26zM0 64C0 28.7 28.7 0 64 0l64 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64L0 64zm128 0L64 64l0 96 64 0 0-96zM256 288l64 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-96c0-35.3 28.7-64 64-64zm0 64l0 96 64 0 0-96-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBinary = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_6);
var b6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "binary-circle-check", f = 640, c = 512, e = [], t = "e33c", o = "M322.7 6c8.3 6 13.3 15.7 13.3 26l0 128 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-83.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16C303.6-1.6 314.4 0 322.7 6zM98.7 294c8.3 6 13.3 15.7 13.3 26l0 128 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-83.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM64 0l64 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zm0 64l0 96 64 0 0-96L64 64zM192 352c0-35.3 28.7-64 64-64l64 0c6.2 0 12.2 .9 17.9 2.5c-11.2 22.9-17.6 48.6-17.9 75.7l0-14.2-64 0 0 96 64 0s0 0 0 0l19.2 0c7.8 15.3 17.8 29.3 29.5 41.5C357 503.3 339.5 512 320 512l-64 0c-35.3 0-64-28.7-64-64l0-96zm128.7 32l-.7 0 0-14.2c0 4.8 .3 9.5 .7 14.2zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBinaryCircleCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b6);
var S6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "binary-lock", f = 640, c = 512, e = [], t = "e33d", o = "M322.7 6c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 83.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128c0-10.3-4.9-19.9-13.3-26zM98.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16C5.1 311.2-3.9 329.4 1.7 346.1s23.7 25.8 40.5 20.2l5.9-2L48 448l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128c0-10.3-4.9-19.9-13.3-26zM64 0C28.7 0 0 28.7 0 64l0 96c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 0zm0 64l64 0 0 96-64 0 0-96zM192 352l0 96c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zm128 0l0 96-64 0 0-96 64 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBinaryLock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S6);
var y6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "binary-slash", f = 640, c = 512, e = [], t = "e33e", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-24c0-35.3-28.7-64-64-64l-48.3 0L298 208.3c13.5-11.7 22-29 22-48.3l0-96c0-35.3-28.7-64-64-64L192 0c-35.3 0-64 28.7-64 64l0 11L38.8 5.1zM192 125.2L192 64l64 0 0 96-19.6 0L192 125.2zM464 32c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 83.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128zM240 320c0-10.3-4.9-19.9-13.3-26s-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 83.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l48 0 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128zm80 32l0 96c0 35.3 28.7 64 64 64l64 0c20.1 0 38.1-9.3 49.8-23.8l-51-40.2L384 448l0-49.5-63.9-50.3c-.1 1.3-.1 2.5-.1 3.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBinarySlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y6);
var O6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bird", f = 512, c = 512, e = [], t = "e469", o = "M0 192l0-3.6C0 172.7 12.7 160 28.4 160L224 160c17.7 0 32-14.3 32-32l0-32c0-53 43-96 96-96c47.5 0 86.9 34.5 94.6 79.7l57.6 34.6c4.8 2.9 7.8 8.1 7.8 13.7s-2.9 10.8-7.8 13.7L448 175.5l0 16.5c0 93.9-57.7 174.3-139.7 207.6l40.9 77.2c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-45.7-86.3C249 415 236.6 416 224 416c-1 0-2 0-3 0l32.2 60.8c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-48.6-91.9C68.5 380.5 0 294.3 0 192zm376-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBird = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O6);
var k6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "blanket", f = 448, c = 512, e = [], t = "f498", o = "M0 128L0 352c0 70.7 57.3 128 128 128l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l240 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l240 0c44.2 0 80-35.8 80-80l0-176c0-53-43-96-96-96L96 32C43 32 0 75 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlanket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k6);
var A6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "blanket-fire", f = 640, c = 512, e = [], t = "e3da", o = "M0 128L0 352c0 70.7 57.3 128 128 128l209.6 0c-16.5-18.6-29.6-40.3-38.1-64L128 416c-35.3 0-64-28.7-64-64s28.7-64 64-64l173.8 0c6.3-15.5 14.4-30.8 23.3-45.3c21.7-35.2 51.9-71.2 87.3-102.8c10-8.9 23-12.8 35.5-11.7l0-.2c0-53-43-96-96-96L96 32C43 32 0 75 0 128zM288 350.1c0-9.8 1.3-19.9 3.6-30.1L128 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l163 0c-2-11.1-3-22.4-3-33.9zM505.7 208.3l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.8 320 314.8 320 352.2C320 440.7 390.4 512 480 512c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327.1 544 363.6 544 400.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlanketFire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A6);
var j6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "blinds", f = 512, c = 512, e = [], t = "f8fb", o = "M32 0C14.3 0 0 14.3 0 32C0 43.4 6 53.4 15 59.1L1.1 100.8c-.7 2.1-1.1 4.3-1.1 6.5C0 118.8 9.2 128 20.6 128L128 128l0-64 32 0 0 64 331.4 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L497 59.1c9-5.7 15-15.7 15-27.1c0-17.7-14.3-32-32-32L32 0zM24 160L1.1 228.8c-.7 2.1-1.1 4.3-1.1 6.5C0 246.8 9.2 256 20.6 256l78.1 0c4.8-13.6 15.6-24.4 29.3-29.3l0-66.7L24 160zM144 320c-20.9 0-38.7-13.4-45.3-32L24 288 1.1 356.8c-.7 2.1-1.1 4.3-1.1 6.5C0 374.8 9.2 384 20.6 384l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 288l-298.7 0c-6.6 18.6-24.4 32-45.3 32zm16-93.3c13.6 4.8 24.4 15.6 29.3 29.3l302.1 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 160l-328 0 0 66.7zM20.6 512l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 416 24 416 1.1 484.8c-.7 2.1-1.1 4.3-1.1 6.5C0 502.8 9.2 512 20.6 512z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlinds = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j6);
var B6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "blinds-open", f = 512, c = 512, e = [], t = "f8fc", o = "M0 32C0 14.3 14.3 0 32 0L480 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L160 64l0 64 0 64 0 66.7c13.6 4.8 24.4 15.6 29.3 29.3c.1 .3 .2 .7 .4 1c1.5 4.7 2.4 9.7 2.4 15c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16c4.8-13.6 15.6-24.4 29.3-29.3l0-66.7 0-64 0-64L32 64C14.3 64 0 49.7 0 32zm47.4 96L96 128l0 64-78.2 0C8 192 0 184 0 174.2c0-4 1.4-7.9 3.9-11.1L22.4 140c6.1-7.6 15.3-12 25-12zm0 160l18.2 0c-1 5.2-1.6 10.5-1.6 16c0 18 6 34.6 16 48l-62.2 0C8 352 0 344 0 334.2c0-4 1.4-7.9 3.9-11.1L22.4 300c6.1-7.6 15.3-12 25-12zm446.9 64L208 352c10-13.4 16-30 16-48c0-5.5-.6-10.8-1.6-16l242.2 0c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8zm0-160L192 192l0-64 272.6 0c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8zM17.8 512C8 512 0 504 0 494.2c0-4 1.4-7.9 3.9-11.1L22.4 460c6.1-7.6 15.3-12 25-12l417.2 0c9.7 0 18.9 4.4 25 12l18.5 23.1c2.5 3.2 3.9 7.1 3.9 11.1c0 9.8-8 17.8-17.8 17.8L17.8 512z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlindsOpen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B6);
var T6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "blinds-raised", f = 512, c = 512, e = [], t = "f8fd", o = "M32 0C14.3 0 0 14.3 0 32C0 43.9 6.5 54.2 16.1 59.8L1.2 100.6c-.8 2.2-1.2 4.6-1.2 7C0 118.9 9.1 128 20.4 128L128 128l0-64 32 0 0 64 331.6 0c11.3 0 20.4-9.1 20.4-20.4c0-2.4-.4-4.7-1.2-7L495.9 59.8C505.5 54.2 512 43.9 512 32c0-17.7-14.3-32-32-32L32 0zM144 512c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 224l331.9 0c11.1 0 20.1-9 20.1-20.1c0-2.6-.5-5.1-1.4-7.5L496 160l-336 0 0 64-32 0 0-64L16 160 1.4 196.4c-1 2.4-1.4 4.9-1.4 7.5C0 215 9 224 20.1 224L128 224l0 194.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlindsRaised = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T6);
var F6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "block", f = 448, c = 512, e = [], t = "e46a", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F6);
var Ui = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "block-brick", f = 448, c = 512, e = ["wall-brick"], t = "e3db", o = "M96 32l0 80 256 0 0-80L96 32zM64 112l0-80C28.7 32 0 60.7 0 96l0 16 64 0zM0 144l0 96 208 0 0-96L0 144zM0 368l64 0 0-96L0 272l0 96zm0 32l0 16c0 35.3 28.7 64 64 64l144 0 0-80L0 400zm240 0l0 80 144 0c35.3 0 64-28.7 64-64l0-16-208 0zm208-32l0-96-64 0 0 96 64 0zm-96 0l0-96L96 272l0 96 256 0zm96-224l-208 0 0 96 208 0 0-96zm0-32l0-16c0-35.3-28.7-64-64-64l0 80 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlockBrick = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ui);
var qi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "block-brick-fire", f = 640, c = 512, e = ["firewall"], t = "e3dc", o = "M128 32l256 0 0 80-256 0 0-80zM96 112l-64 0 0-16c0-35.3 28.7-64 64-64l0 80zM32 144l208 0 0 96L32 240l0-96zm0 224l0-96 64 0 0 96-64 0zm0 32l208 0 0 80L96 480c-35.3 0-64-28.7-64-64l0-16zm240 0l22.5 0c8 30 22.9 57.4 43.1 80L272 480l0-80zM480 144l0 .6-.6-.6 .6 0zm-208 0l135.9 0c-32.5 29.8-60.4 63.2-81 96L272 240l0-96zM128 272l181 0c-12.5 25.7-21 52.7-21 78.1c0 6 .3 12 .8 17.9L128 368l0-96zM480 112l-64 0 0-80c35.3 0 64 28.7 64 64l0 16zm25.7 96.3L518 194.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 291.2 640 322.2 640 352.2C640 440.8 568.7 512 480 512c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 400.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlockBrickFire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qi);
var H6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "block-question", f = 448, c = 512, e = [], t = "e3dd", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm73.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 280.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM376 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM48 408a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlockQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H6);
var R6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "block-quote", f = 448, c = 512, e = [], t = "e0b5", o = "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 64zM160 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0zM128 416c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlockQuote = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R6);
var U6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "blueberries", f = 512, c = 512, e = [], t = "e2e8", o = "M512 176C512 78.8 433.2 0 336 0C255.4 0 187.4 54.2 166.6 128.2c3.1-.1 6.3-.2 9.4-.2c114.9 0 208 93.1 208 208c0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM176 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-304c8.8 0 16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16zM384 64l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBlueberries = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U6);
var q6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bolt-auto", f = 576, c = 512, e = [], t = "e0b6", o = "M317.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224C.9 240.7-2.6 254.8 2 267.3S18.7 288 32 288l111.5 0L66.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L317.4 44.6zM464 288c-12.1 0-23.2 6.8-28.6 17.7l-80 160c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-80-160C487.2 294.8 476.1 288 464 288zM447.8 424L464 391.6 480.2 424l-32.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoltAuto = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q6);
var G6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bolt-slash", f = 640, c = 512, e = [], t = "e0b8", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-182.4-143 52.7-46.1c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L445.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8L228.4 153.7 38.8 5.1zM138.9 231.9c-10 8.8-13.6 22.9-8.9 35.3s16.6 20.7 30 20.7l83.7 0-88.9-70-15.9 13.9zm55.7 235.5c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8L374.4 391 264.5 304.4l-69.9 163z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoltSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G6);
var W6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bone-break", f = 640, c = 512, e = [], t = "f5d8", o = "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L201 71zM473 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48zM143.9 223.8C129.3 204.5 106.1 192 80 192c-44.2 0-80 35.8-80 80c0 35.8 23.5 66.1 55.9 76.3c4.6 1.5 8.3 5.1 9.3 9.8s-1.1 9.5-4.8 12.6C43.1 385.5 32 407.5 32 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-11.9 7-23.8 18.6-26.1L320 384l109.4 21.9C441 408.2 448 420.1 448 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-24.5-11.1-46.5-28.5-61.2c-3.7-3.1-5.7-7.9-4.8-12.6s4.7-8.4 9.3-9.8C616.5 338.1 640 307.8 640 272c0-44.2-35.8-80-80-80c-26.1 0-49.3 12.5-63.9 31.8c-10.1 13.3-25.7 23.8-42.1 20.5l-70.6-14.1c-17.3-3.5-34.2 7.8-37.7 25.1L320 384 294.3 255.4c-3.5-17.3-20.3-28.6-37.7-25.1L186 244.4c-16.4 3.3-32.1-7.2-42.1-20.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoneBreak = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W6);
var E6 = {}, Gi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-blank", f = 448, c = 512, e = [128213, 128215, 128216, 128217, "book-alt"], t = "f5d9", o = "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Gi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBookAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(E6);
var V6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-arrow-right", f = 640, c = 512, e = [], t = "e0b9", o = "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-120 110.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L448 184l0-152c0-17.7-14.3-32-32-32L384 0 96 0zM448 184l0 48-200 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l200 0zM96 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookArrowRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V6);
var I6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-arrow-up", f = 448, c = 512, e = [], t = "e0ba", o = "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64-88 0 0-174.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L216 384 96 384c-17.7 0-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I6);
var K6 = {}, Wi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-book-open", f = 512, c = 512, e = ["book-circle"], t = "e0ff", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c-23.1 0-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9l0-160.7c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5l0 160.7c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C225 347.1 207.1 336 184 336zm144 0c-23.1 0-41 11.1-46.3 14.8c-1.1 .8-2.4 1.2-3.7 1.2c-3.3 0-5.9-2.7-5.9-5.9l0-160.7c0-5.8 3.1-11.1 8.3-13.5c10.4-4.7 29.1-11.9 47.7-11.9s37.2 7.1 47.7 11.9c5.2 2.4 8.3 7.7 8.3 13.5l0 160.7c0 3.3-2.7 5.9-5.9 5.9c-1.3 0-2.6-.4-3.7-1.2C369 347.1 351.1 336 328 336z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleBookOpen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Wi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBookCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(K6);
var X6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-circle-arrow-right", f = 640, c = 512, e = [], t = "e0bc", o = "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 10.8 0c-23.3-16.4-42.5-38.4-55.6-64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l224.7 0c-.5-5.3-.7-10.6-.7-16c0-80.6 54.1-148.5 128-169.4L448 32c0-17.7-14.3-32-32-32L384 0 96 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookCircleArrowRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X6);
var Q6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-circle-arrow-up", f = 640, c = 512, e = [], t = "e0bd", o = "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 10.8 0c-23.3-16.4-42.5-38.4-55.6-64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l224.7 0c-.5-5.3-.7-10.6-.7-16c0-80.6 54.1-148.5 128-169.4L448 32c0-17.7-14.3-32-32-32L384 0 96 0zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookCircleArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q6);
var J6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-copy", f = 576, c = 512, e = [], t = "e0be", o = "M160 96L96 96C43 96 0 139 0 192L0 416c0 53 43 96 96 96l224 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0-32 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l81.1 0c-10.9-18.8-17.1-40.7-17.1-64l0-224zM320 416l32 0 160 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L512 0 288 0c-53 0-96 43-96 96l0 224c0 24.6 9.2 47 24.4 64c17.6 19.6 43.1 32 71.6 32l32 0zm-64-96c0-17.7 14.3-32 32-32l96 0 96 0 0 64-96 0-96 0c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookCopy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J6);
var Y6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-font", f = 448, c = 512, e = [], t = "e0bf", o = "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM254.3 72.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-64 128-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2L185.9 224l108.2 0 27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-32-64-64-128zM240 115.8L278.1 192l-76.2 0L240 115.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookFont = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y6);
var Z6 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-heart", f = 448, c = 512, e = [], t = "f499", o = "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zm64-258.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4C221.1 102.5 205.5 96 189.3 96c-33.8 0-61.3 27.4-61.3 61.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z6);
var p6 = {}, Ei = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-section", f = 448, c = 512, e = ["book-law"], t = "e0c1", o = "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM228.5 241.3l7.5 2c37.9 9.8 46.1 15 43.6 27.7c-2.5 13.2-23.7 19.6-51.7 15.7c-10.2-1.4-22.4-5.4-33.1-8.9l-5.9-1.9c-8.4-2.7-17.4 1.9-20.1 10.4c-2.7 8.4 2 17.4 10.4 20.1l5.8 1.9c12 3.9 25.7 8.3 38.6 10.1c7 1 13.8 1.5 20.2 1.5c36.5 0 62.2-15.8 67.3-42.8c4.1-21.2-4-34.9-16.7-44.4c8.7-7.1 14.5-16.4 16.7-27.6c8.6-45.1-36.9-56.9-67-64.7c0 0 0 0 0 0l-7.3-1.9c-36.5-9.7-38-16.5-36.2-25.8c2.5-13.2 23.8-19.7 51.6-15.7c6.6 .9 14.6 2.9 25.2 6.2c8.3 2.6 17.4-2.1 20-10.5c2.6-8.4-2.1-17.4-10.5-20c-12.2-3.8-21.9-6.2-30.2-7.3c-47.1-6.7-81.5 9.6-87.5 41.3c-4.1 21.3 4.4 35.1 16.7 44.5c-8.7 7.1-14.5 16.4-16.7 27.5c-8.5 44.6 37.4 56.8 59.5 62.7zm-2.9-72.8c.9 .2 10.3 2.7 10.3 2.7c37.9 9.8 46.1 15 43.6 27.7c-2.2 11.3-16.5 14.9-25.2 16.1c-3.6-1-17.7-4.7-17.7-4.7c-36.5-9.7-38-16.5-36.2-25.8c2.2-11.3 16.5-14.9 25.2-16.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookSection = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ei);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ei;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBookLaw = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(p6);
var x6 = {}, Vi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-open-cover", f = 640, c = 512, e = ["book-open-alt"], t = "e0c0", o = "M304 32l0 376L96 368 96 34.7C96 14.9 113.8-.2 133.3 3.1L304 32zM89.7 405.1L320 451.2l230.3-46.1c15-3 25.7-16.1 25.7-31.4l0-345 25.7-5.1C621.5 19.7 640 34.8 640 55l0 366.7c0 15.3-10.8 28.4-25.7 31.4L320 512 25.7 453.1C10.8 450.2 0 437 0 421.8L0 55C0 34.8 18.5 19.7 38.3 23.7L64 28.8l0 345c0 15.3 10.8 28.4 25.7 31.4zM336 408l0-376L506.7 3.1C526.2-.2 544 14.9 544 34.7L544 368 336 408z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookOpenCover = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Vi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBookOpenAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(x6);
var Ii = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-sparkles", f = 448, c = 512, e = ["book-spells"], t = "f6b8", o = "M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zM264 200l16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 200l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 248l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 248l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7L264 200zM168.8 78.3c2.9-5.9 11.4-5.9 14.3 0L192 96l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 128l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 128l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 96l8.8-17.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookSparkles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ii);
var af = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ii;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBookSpells = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(af);
var ef = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "book-user", f = 448, c = 512, e = [], t = "f7e7", o = "M0 96C0 43 43 0 96 0L384 0l32 0c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0L96 512c-53 0-96-43-96-96L0 96zM64 416c0 17.7 14.3 32 32 32l256 0 0-64L96 384c-17.7 0-32 14.3-32 32zM304 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM128 304c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ef);
var nf = {}, Ki = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-bookmark", f = 512, c = 512, e = ["bookmark-circle"], t = "e100", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 192c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4l0-192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleBookmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ki);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ki;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBookmarkCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(nf);
var ff = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bookmark-slash", f = 640, c = 512, e = [], t = "e0c2", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-328c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48l0 27L38.8 5.1zM128 487.7c0 13.4 10.9 24.3 24.3 24.3c5 0 9.9-1.5 14-4.4L320 400 473.7 507.6c4.1 2.9 9 4.4 14 4.4c9.9 0 18.4-5.9 22.2-14.3L128 196.9l0 290.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBookmarkSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ff);
var cf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "books", f = 512, c = 512, e = [128218], t = "f5db", o = "M0 32C0 14.3 14.3 0 32 0L96 0c17.7 0 32 14.3 32 32l0 64L0 96 0 32zm0 96l128 0 0 256L0 384 0 128zM0 416l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM160 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64L160 96l0-64zm0 96l128 0 0 256-128 0 0-256zm0 288l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm203.6-19.9L320 232.6l0-89.9 100.4-26.9 66 247.4L363.6 396.1zM412.2 85L320 109.6 320 11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L412.2 85zM371.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L371.8 427z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBooks = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cf);
var tf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "books-medical", f = 576, c = 512, e = [], t = "f7e8", o = "M64 32C64 14.3 78.3 0 96 0l64 0c17.7 0 32 14.3 32 32l0 64L64 96l0-64zm0 384l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM224 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64L224 96l0-64zm0 96l128 0 0 256-128 0 0-256zm0 288l128 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm203.6-19.9L384 232.6l0-89.9 100.4-26.9 66 247.4L427.6 396.1zM476.2 85L384 109.6 384 11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L476.2 85zM435.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L435.8 427zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBooksMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tf);
var of = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "boombox", f = 640, c = 512, e = [128254], t = "f8a5", o = "M120 48l400 0c22.1 0 40 17.9 40 40l0 72-112 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32L80 160l0-72c0-22.1 17.9-40 40-40zM608 168.6L608 88c0-48.6-39.4-88-88-88L120 0C71.4 0 32 39.4 32 88l0 80.6C12.9 179.6 0 200.3 0 224L0 448c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-224c0-23.7-12.9-44.4-32-55.4zM256 336A80 80 0 1 0 96 336a80 80 0 1 0 160 0zM64 336a112 112 0 1 1 224 0A112 112 0 1 1 64 336zm400 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoombox = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(of);
var lf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "boot", f = 512, c = 512, e = [129406], t = "f782", o = "M0 32C0 14.3 14.3 0 32 0L320 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L0 96 0 32zM0 457.4L0 448l512 0 0 9.4c0 14.5-5.8 28.4-16 38.6s-24.1 16-38.6 16l-14.9 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-14.9 0c-14.5 0-28.4-5.8-38.6-16S0 471.9 0 457.4zM0 416L0 128l320 0 0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 119.3 29.8C482 296.5 512 334.9 512 379l0 37L0 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lf);
var df = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "boot-heeled", f = 512, c = 512, e = [], t = "e33f", o = "M128 0L63.3 0C46 0 32 14 32 31.3c0 1.8 .1 3.9 .6 6.2C34.6 47.1 56 154.3 56 232c0 33.2-12.8 93.5-19.7 123.2C33.6 367 32 379.3 32 391.8L32 488c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-15.1 125 34.7c10.5 2.9 21.3 4.4 32.1 4.4L456 512l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-34.3c0-27.3-15.4-52.2-39.8-64.4L327.8 309.1c-24.4-12.2-39.8-37.1-39.8-64.4L288 24c0-13.3-10.7-24-24-24L160 0l0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16L128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBootHeeled = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(df);
var rf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "booth-curtain", f = 512, c = 512, e = [], t = "f734", o = "M64 0C28.7 0 0 28.7 0 64L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32L64 64l64 0 0-64L64 0zM512 64c0-35.3-28.7-64-64-64L352 0 256 0 192 0c-17.7 0-32 14.3-32 32l0 368c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48c0 26.5 21.5 48 48 48s48-21.5 48-48l0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoothCurtain = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rf);
var sf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-bottom", f = 448, c = 512, e = [], t = "f84d", o = "M448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32zm-64-96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 160a32 32 0 1 1 64 0A32 32 0 1 1 0 160zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderBottom = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sf);
var Xi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-bottom-right", f = 448, c = 512, e = ["border-style-alt"], t = "f854", o = "M448 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 336c0 8.8-7.2 16-16 16L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l336 0c44.2 0 80-35.8 80-80l0-336zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderBottomRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xi);
var hf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-center-h", f = 448, c = 512, e = [], t = "f89c", o = "M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderCenterH = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hf);
var vf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-center-v", f = 448, c = 512, e = [], t = "f89d", o = "M448 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 352A32 32 0 1 0 0 352a32 32 0 1 0 64 0zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 160A32 32 0 1 0 0 160a32 32 0 1 0 64 0zm320 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zM288 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM96 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderCenterV = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vf);
var uf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-inner", f = 448, c = 512, e = [], t = "f84e", o = "M64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0-384A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zM416 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM416 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 160A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM0 256c0-17.7 14.3-32 32-32l160 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160L32 288c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderInner = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uf);
var mf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-left", f = 448, c = 512, e = [], t = "f84f", o = "M32 480c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mf);
var gf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-outer", f = 448, c = 512, e = [], t = "f851", o = "M64 96l0 320 320 0 0-320L64 96zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderOuter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gf);
var Pf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-right", f = 448, c = 512, e = [], t = "f852", o = "M416 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pf);
var Mf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Xi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBorderStyleAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Mf);
var wf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "border-top", f = 448, c = 512, e = [], t = "f855", o = "M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zm64 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 352a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBorderTop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wf);
var Nf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bottle-baby", f = 512, c = 512, e = [], t = "e673", o = "M220.6 49.7L224 48l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 3.4 1.7C308.9 58.5 320 76.4 320 96c17.7 0 32 14.3 32 32l0 32-192 0 0-32c0-17.7 14.3-32 32-32c0-19.6 11.1-37.5 28.6-46.3zM200 272l-84.4 0c4.5-19.6 13-38.1 25.2-54.4L160 192l192 0 19.2 25.6C389.9 242.5 400 272.8 400 304l0 144c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-16 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-64 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBottleBaby = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nf);
var zf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bow-arrow", f = 512, c = 512, e = [127993], t = "f6b9", o = "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35L144.6 333.4 93.8 320.7c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8L425.7 120.3l35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-458 85.5c-12.6-11.6-32.1-11.3-44.3 .9c-12.5 12.5-12.5 32.8 0 45.3L145.8 287 191 241.8l-90.6-90.6c56.5-30.7 125.2-30.9 181.9-.7l46.8-46.8c-83.8-53.2-191.8-53-275.4 .8zM361.5 229.7c30.2 56.7 30 125.4-.7 181.9L270.2 321 225 366.2 361.4 502.6c12.5 12.5 32.8 12.5 45.3 0c12.2-12.2 12.5-31.8 .9-44.3c53.7-83.6 54-191.6 .8-275.4l-46.8 46.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowArrow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zf);
var Lf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowl-chopsticks", f = 512, c = 512, e = [], t = "e2e9", o = "M18.5 125.1l473.8-74c11.3-1.8 19.7-11.5 19.7-23c0-14.6-13.3-25.6-27.6-22.9L13.1 93.6C5.5 95 0 101.6 0 109.3c0 9.8 8.8 17.3 18.5 15.8zM0 159.7c0 9 7.3 16.2 16.2 16.2l472.1 0c13 0 23.6-10.6 23.6-23.6c0-13.3-11-24-24.4-23.6L15.7 143.5C7 143.8 0 151 0 159.7zM33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35l153.4 0c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5L33.6 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlChopsticks = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lf);
var Cf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowl-chopsticks-noodles", f = 512, c = 512, e = [], t = "e2ea", o = "M13.1 93.6L128 72l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 7 0 37.5 0 38 0 37.5 0 48s0 0 0 0l32 0s0 0 0 0l0-48 0-38.5 0-42L208 57l0-17c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 40 0 48 0 40 0 48s0 0 0 0l32 0s0 0 0 0l190.4 0c18.2 0 32.7 15.3 31.6 33.5c-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35l-153.4 0c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5C.9 239.3 15.4 224 33.6 224l94.4 0 0-48L16.2 176C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140l0-32L18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6zM488.4 176L288 176l0-41 199.6-6.2C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6zm3.9-124.9L288 83l0-41L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlChopsticksNoodles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cf);
var Qi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowl-hot", f = 512, c = 512, e = ["soup"], t = "f823", o = "M152 0c-13.3 0-24 10.7-24 24l0 8c0 32.7 15.4 63.6 41.6 83.2C183.7 125.8 192 142.4 192 160l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-32.7-15.4-63.6-41.6-83.2C184.3 66.2 176 49.6 176 32l0-8c0-13.3-10.7-24-24-24zM33.6 224C15.4 224 .9 239.3 2 257.5c5.4 91.7 59.7 169.7 136.4 209.7l1.2 9.7c2.5 20 19.5 35 39.7 35l153.4 0c20.2 0 37.2-15 39.7-35l1.2-9.7c76.8-40 131-118 136.4-209.7c1.1-18.2-13.4-33.5-31.6-33.5L33.6 224zM304 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 32.7 15.4 63.6 41.6 83.2C311.7 125.8 320 142.4 320 160l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-32.7-15.4-63.6-41.6-83.2C312.3 66.2 304 49.6 304 32l0-8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlHot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qi);
var Df = {}, Ji = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "salad", f = 512, c = 512, e = [129367, "bowl-salad"], t = "f81e", o = "M416 96c2.6 0 5.2 .1 7.8 .2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4C43 64 0 107 0 160s43 96 96 96l73.4 0L84.7 171.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 249.4 208 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 144 52 0c-2.6-10.2-4-21-4-32c0-70.7 57.3-128 128-128zM27.4 288C12.3 288 0 300.3 0 315.4c0 70.5 44.4 130.7 106.7 154.1l1.8 14.4c2 16 15.6 28 31.8 28l231.5 0c16.1 0 29.8-12 31.8-28l1.8-14.4C467.6 446.1 512 385.9 512 315.4c0-15.1-12.3-27.4-27.4-27.4L27.4 288zM512 224c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32l181.1 0c3.5-10 5.5-20.8 5.5-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSalad = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ji);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ji;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBowlSalad = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Df);
var Yi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowl-scoop", f = 448, c = 512, e = [127847, "bowl-shaved-ice"], t = "e3de", o = "M32 224l384 0c0-106-86-192-192-192S32 118 32 224zM16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9C11.1 361.9 72.4 416 145 416l40.4 0-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l192 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416l40.4 0c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4L16 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlScoop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yi);
var $f = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowl-scoops", f = 448, c = 512, e = [127813], t = "e3df", o = "M224 208c0 5.4 .4 10.8 1.1 16l221.7 0c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6C230.7 164.2 224 185.3 224 208zM0 208c0 5.4 .4 10.8 1.1 16l191.7 0c-.6-5.3-.9-10.6-.9-16c0-22 4.9-42.8 13.7-61.4c-13.9-21.2-34.9-37.4-59.6-45.3C135.4 97.9 123.9 96 112 96C50.1 96 0 146.1 0 208zM325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1zM16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9C11.1 361.9 72.4 416 145 416l40.4 0-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l192 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 416l40.4 0c72.6 0 133.9-54.1 142.9-126.1l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4L16 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlScoops = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($f);
var _f = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Yi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBowlShavedIce = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_f);
var bf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowl-soft-serve", f = 512, c = 512, e = [], t = "e46b", o = "M257.2 9.9c2.5-6 8.3-9.9 14.8-9.9l36.6 0C367.9 0 416 48.1 416 107.4c0 19.9-6.9 38.1-18.3 52.6l18.3 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L96 288c-35.3 0-64-28.7-64-64s28.7-64 64-64l8.6 0c-5.4-9.4-8.6-20.3-8.6-32c0-35.3 28.7-64 64-64l94.1 0C264 64 272 56 272 46.1c0-4.8-1.9-9.3-5.3-12.7l-6.1-6.1c-4.6-4.6-5.9-11.5-3.5-17.4zM64 320l384 0c8.8 0 16 7.2 16 16l0 8c0 57.4-46.6 104-104 104l-30.1 0 20.4 40.8c1.1 2.3 1.7 4.7 1.7 7.2c0 2.9-.8 5.8-2.4 8.4c-2.9 4.7-8.1 7.6-13.6 7.6l-160 0c-5.5 0-10.7-2.9-13.6-7.6c-1.6-2.6-2.4-5.5-2.4-8.4c0-2.4 .6-4.9 1.7-7.2L182.1 448 152 448C94.6 448 48 401.4 48 344l0-8c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlSoftServe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bf);
var Sf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowl-spoon", f = 512, c = 512, e = [129379], t = "e3e0", o = "M112 192C50.1 192 0 149 0 96S50.1 0 112 0c48.8 0 90.3 26.7 105.6 64L480 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-262.4 0c-15.4 37.3-56.9 64-105.6 64zM2 257.5C.9 239.3 15.4 224 33.6 224l444.8 0c18.2 0 32.7 15.3 31.6 33.5c-5.4 91.7-59.7 169.7-136.4 209.7l-1.2 9.7c-2.5 20-19.5 35-39.7 35l-153.4 0c-20.2 0-37.2-15-39.7-35l-1.2-9.7C61.6 427.2 7.4 349.3 2 257.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlSpoon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sf);
var yf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowling-ball-pin", f = 576, c = 512, e = [], t = "e0c3", o = "M416 64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 1.1c0 7.4-1 14.8-3 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1l-83.1 0c-.5-2.7-1.1-5.4-1.8-8.1L418.9 87.1c-2-7.2-2.9-14.6-2.9-22l0-1.1zm22.8 128l82.3 0c1 6.3 2.6 12.4 4.8 18.4L566 319.3c6.6 17.9 10 36.8 10 55.8c0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C536.9 504 525.1 512 512 512l-64 0c-13.1 0-24.9-8-29.7-20.1l-17.8-44.5c29.8-40 47.5-89.6 47.5-143.4c0-30.7-5.8-60.1-16.3-87.1l2.4-6.5c2.2-6 3.8-12.1 4.8-18.4zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zM224 172a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM196 288a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm-44-68a28 28 0 1 0 -56 0 28 28 0 1 0 56 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlingBallPin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yf);
var Of = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bowling-pins", f = 512, c = 512, e = [], t = "f437", o = "M128 0c35.3 0 64 28.7 64 64l0 1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1l-83.1 0c-.5-2.7-1.1-5.4-1.8-8.1L66.9 87.1c-2-7.2-2.9-14.6-2.9-22L64 64C64 28.7 92.7 0 128 0zM82.1 210.4c2.2-6 3.8-12.1 4.8-18.4l82.3 0c1 6.3 2.6 12.4 4.8 18.4l38.6 104.7c7.6 20.6 11.5 42.5 11.5 64.4c0 28.9-6.7 57.5-19.7 83.4l-15.7 31.4C183.2 505.2 172.1 512 160 512l-64 0c-12.1 0-23.2-6.8-28.6-17.7L51.7 462.9C38.7 437 32 408.5 32 379.5c0-22 3.9-43.8 11.5-64.4L82.1 210.4zM384 0c35.3 0 64 28.7 64 64l0 1.1c0 7.4-1 14.8-2.9 22l-17.7 64.8c-.7 2.7-1.3 5.4-1.8 8.1l-83.1 0c-.5-2.7-1.1-5.4-1.8-8.1L322.9 87.1c-2-7.2-2.9-14.6-2.9-22l0-1.1c0-35.3 28.7-64 64-64zM338.1 210.4c2.2-6 3.8-12.1 4.8-18.4l82.3 0c1 6.3 2.6 12.4 4.8 18.4L470 319.3c6.6 17.9 10 36.8 10 55.8c0 20.5-3.9 40.9-11.5 59.9l-22.7 56.9C440.9 504 429.1 512 416 512l-64 0c-13.1 0-24.9-8-29.7-20.1L299.5 435C291.9 416 288 395.6 288 375.1c0-19 3.4-37.9 10-55.8l40.1-108.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBowlingPins = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Of);
var kf = {}, Zi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "box-taped", f = 448, c = 512, e = ["box-alt"], t = "f49a", o = "M50.7 58.5L0 160l160 0L192 32 93.7 32C75.5 32 58.9 42.3 50.7 58.5zM288 160l160 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L256 32l32 128zM160 192L0 192 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-224-160 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoxTaped = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Zi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBoxAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(kf);
var Af = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "box-ballot", f = 576, c = 512, e = [128499], t = "f735", o = "M128 32c0-17.7 14.3-32 32-32L416 0c17.7 0 32 14.3 32 32l0 192-320 0 0-192zM0 352l576 0 0 112c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 352zM48 160l48 0 0 96 384 0 0-96 48 0c26.5 0 48 21.5 48 48l0 112L0 320 0 208c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoxBallot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Af);
var jf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "box-check", f = 448, c = 512, e = [], t = "f467", o = "M93.7 32L208 32l0 128L0 160 50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32l114.3 0c18.2 0 34.8 10.3 42.9 26.5L448 160l-208 0 0-128zM0 192l448 0 0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192zm337 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 281z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoxCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jf);
var Bf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "box-circle-check", f = 576, c = 512, e = [], t = "e0c4", o = "M93.7 32L208 32l0 128L0 160 50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32l114.3 0c18.2 0 34.8 10.3 42.9 26.5L448 160l-32 0-176 0 0-128zM0 416L0 192l416 0 0 .7c-89.7 8.1-160 83.5-160 175.3c0 42.5 15.1 81.6 40.2 112L64 480c-35.3 0-64-28.7-64-64zm288-48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoxCircleCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bf);
var pi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "box-dollar", f = 448, c = 512, e = ["box-usd"], t = "f4a0", o = "M93.7 32L208 32l0 128L0 160 50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32l114.3 0c18.2 0 34.8 10.3 42.9 26.5L448 160l-208 0 0-128zM0 192l448 0 0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192zm244 40c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoxDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pi);
var Tf = {}, s = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-fragile", f = 448, c = 512, e = ["box-fragile", "square-wine-glass-crack"], t = "f49b", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 86.3C128 106 138 96 150.3 96L176 96l32 64-32 32 80 64-32-64 48-32L240 96l57.7 0C310 96 320 106 320 118.3l0 89.7c0 47.6-34.6 87.1-80 94.7l0 81.3 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-81.3c-45.4-7.6-80-47.1-80-94.7l0-89.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareFragile = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = s;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBoxFragile = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Tf);
var Ff = {}, xi = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "box-open-full", f = 640, c = 512, e = ["box-full"], t = "f49c", o = "M508.9 64.9l-27.5 73.4L320 158.5l-7.2-.9c4.6-8.8 7.2-18.9 7.2-29.6c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1 .6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0c69.6 0 126.2 55.6 128 124.7l35.1-93.6c9.3-24.8 37-37.4 61.8-28.1s37.4 37 28.1 61.8zM576 338.3l0 83.4c0 14.7-10 27.5-24.2 31L335.5 506.8c-10.2 2.5-20.9 2.5-31 0L88.2 452.8C74 449.2 64 436.4 64 421.7l0-83.4 127.6 36.5c27.8 8 57.6-3.8 72.5-28.6L320 252.9l55.9 93.2c14.9 24.8 44.6 36.6 72.5 28.6L576 338.3zM58.9 168.8c3-6.1 9.6-9.6 16.3-8.7L320 190.7l244.8-30.6c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 344c-13.9 4-28.8-1.9-36.2-14.3L320 190.7l-83.4 139c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 297.3c-19.3-5.5-28.8-27.2-19.8-45.1l41.7-83.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoxOpenFull = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xi);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = xi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBoxFull = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ff);
var Hf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "box-heart", f = 448, c = 512, e = [], t = "f49d", o = "M93.7 32L208 32l0 128L0 160 50.7 58.5C58.9 42.3 75.5 32 93.7 32zM240 32l114.3 0c18.2 0 34.8 10.3 42.9 26.5L448 160l-208 0 0-128zM0 192l448 0 0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192zM212.7 420.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 283.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoxHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hf);
var Rf = {}, i2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-this-way-up", f = 448, c = 512, e = ["box-up"], t = "f49f", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM80 384l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 416c-8.8 0-16-7.2-16-16s7.2-16 16-16zM265.4 192c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L306.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4L352 192l0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112-22.6 0zm-192 0c-9.6 0-17.4-7.8-17.4-17.4c0-4.3 1.6-8.4 4.4-11.6L114.7 102c3.4-3.8 8.2-6 13.3-6s9.9 2.2 13.3 6l54.3 61.1c2.8 3.2 4.4 7.3 4.4 11.6c0 9.6-7.8 17.4-17.4 17.4L160 192l0 112c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-112-22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareThisWayUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = i2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBoxUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Rf);
var Uf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = pi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBoxUsd = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Uf);
var a2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "boxing-glove", f = 448, c = 512, e = [129354, "glove-boxing"], t = "f438", o = "M0 96C0 43 43 0 96 0L288 0c53 0 96 43 96 96l0 32-32 0c-26.2 0-49.4 12.6-64 32l-144 0c-21.2 0-34.3-5.3-41.8-9.7c-3.8-2.3-6.3-4.4-7.7-5.8c-.7-.7-1.1-1.2-1.3-1.5l-.1-.1s0 0 0 0c-5-7.1-14.7-9-22-4.2c-7.4 4.9-9.3 14.8-4.4 22.2L80 152c-13.3 8.9-13.3 8.9-13.3 8.9s0 0 0 0s0 0 0 0l.1 .1 .1 .2 .4 .5c.3 .4 .6 .8 1.1 1.4c.9 1.1 2 2.4 3.6 4c3.1 3.1 7.6 6.9 13.8 10.7C98.3 185.3 117.2 192 144 192l129.6 0c-1 5.2-1.6 10.5-1.6 16c0 37.3 25.5 68.6 60 77.5c8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-20.7-5.3-36-24.1-36-46.5c0-26.5 21.5-48 48-48l32 0c35.3 0 64 28.7 64 64l0 24.2c0 25.5-10.1 49.9-28.1 67.9l-49.1 49.1c-12 12-18.7 28.3-18.7 45.3l0 37.5c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-88.4C12.4 342 0 316.4 0 288L0 96zM152.9 354.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 419.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 380.8l-39.1-26.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBoxingGlove = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a2);
var qf = {}, h = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bracket-square", f = 192, c = 512, e = ["bracket", "bracket-left"], t = "5b", o = "M0 96C0 60.7 28.7 32 64 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 96l0 320 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-35.3 0-64-28.7-64-64L0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketSquare = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = h;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBracket = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(qf);
var e2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bracket-curly", f = 256, c = 512, e = ["bracket-curly-left"], t = "7b", o = "M64 128c0-53 43-96 96-96l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32l0 37.5c0 25.5-10.1 49.9-28.1 67.9L77.3 256l22.6 22.6c18 18 28.1 42.4 28.1 67.9l0 37.5c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-53 0-96-43-96-96l0-37.5c0-8.5-3.4-16.6-9.4-22.6L9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l45.3-45.3c6-6 9.4-14.1 9.4-22.6L64 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketCurly = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e2);
var Gf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = e2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBracketCurlyLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Gf);
var Wf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bracket-curly-right", f = 256, c = 512, e = [], t = "7d", o = "M192 128c0-53-43-96-96-96L64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 37.5c0 25.5 10.1 49.9 28.1 67.9L178.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9l0 37.5c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c53 0 96-43 96-96l0-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6l0-37.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketCurlyRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wf);
var Ef = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = h;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBracketLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ef);
var n2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bracket-round", f = 192, c = 512, e = ["parenthesis"], t = "28", o = "M154.6 46.2c9.8 14.7 5.8 34.6-8.9 44.4C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4c14.7 9.8 18.7 29.7 8.9 44.4s-29.7 18.7-44.4 8.9C71.9 449.1 0 371.8 0 256S71.9 62.9 110.2 37.4c14.7-9.8 34.6-5.8 44.4 8.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketRound = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n2);
var Vf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bracket-round-right", f = 192, c = 512, e = [], t = "29", o = "M37.4 46.2C27.6 61 31.5 80.8 46.3 90.6C71.9 107.7 128 167 128 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C120.1 449 192 371.8 192 256S120.1 62.9 81.8 37.4C67 27.6 47.2 31.5 37.4 46.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketRoundRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vf);
var If = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bracket-square-right", f = 192, c = 512, e = [], t = "5d", o = "M192 96c0-35.3-28.7-64-64-64L64 32C46.3 32 32 46.3 32 64s14.3 32 32 32l64 0 0 320-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c35.3 0 64-28.7 64-64l0-320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketSquareRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(If);
var Kf = {}, f2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "brackets-square", f = 448, c = 512, e = ["brackets"], t = "f7e9", o = "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 0-320-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zM64 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 96l0 320 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketsSquare = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = f2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBrackets = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Kf);
var Xf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "brackets-curly", f = 576, c = 512, e = [], t = "f7ea", o = "M416 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 37.5c0 25.5 10.1 49.9 28.1 67.9L498.7 256l-22.6 22.6c-18 18-28.1 42.4-28.1 67.9l0 37.5c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c53 0 96-43 96-96l0-37.5c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3l-45.3-45.3c-6-6-9.4-14.1-9.4-22.6l0-37.5c0-53-43-96-96-96zM160 32c-53 0-96 43-96 96l0 37.5c0 8.5-3.4 16.6-9.4 22.6L9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c6 6 9.4 14.1 9.4 22.6L64 384c0 53 43 96 96 96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32-14.3-32-32l0-37.5c0-25.5-10.1-49.9-28.1-67.9L77.3 256l22.6-22.6c18-18 28.1-42.4 28.1-67.9l0-37.5c0-17.7 14.3-32 32-32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketsCurly = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xf);
var c2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "brackets-round", f = 512, c = 512, e = ["parentheses"], t = "e0c5", o = "M145.8 90.6c14.7-9.8 18.7-29.7 8.9-44.4s-29.7-18.7-44.4-8.9C71.9 62.9 0 140.2 0 256S71.9 449 110.2 474.6c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4C120.1 404.3 64 345 64 256s56.1-148.3 81.8-165.4zm220.5 0C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9C440.1 449.1 512 371.8 512 256s-71.9-193.1-110.2-218.6c-14.7-9.8-34.6-5.8-44.4 8.9s-5.8 34.6 8.9 44.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBracketsRound = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c2);
var t2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "brain-arrow-curved-right", f = 640, c = 512, e = ["mind-share"], t = "f677", o = "M240 56c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56l0-400zm32 0l0 400c0 30.9 25.1 56 56 56c3.2 0 6.4-.3 9.5-.8C321.3 491 304 459.3 304 416c0-79.5 64.5-144 144-144l32 0 0-16c0-4.9 .8-9.8 2.2-14.3c-4.9-3.9-10.2-7.3-16-10C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56zM539.3 244.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 48-64 0c-61.9 0-112 50.1-112 112c0 54.3 34.6 85.6 45 93.8c1.9 1.5 4.3 2.2 6.7 2.2c6.8 0 12.3-5.5 12.3-12.3l0-35.7c0-35.3 28.7-64 64-64l48 0 0 48c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBrainArrowCurvedRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t2);
var Qf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "brain-circuit", f = 512, c = 512, e = [], t = "e0c6", o = "M240 56c0-30.9-25.1-56-56-56c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1c30.9 0 56-25.1 56-56l0-184-48 0c-8.8 0-16 7.2-16 16l0 34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-34.7c0-26.5 21.5-48 48-48l48 0 0-80-34.7 0c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32l34.7 0 0-72zm32 104l0 192 34.7 0c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32L272 384l0 72c0 30.9 25.1 56 56 56c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0c-30.9 0-56 25.1-56 56l0 72 48 0c26.5 0 48 21.5 48 48l0 2.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-2.7c0-8.8-7.2-16-16-16l-48 0zM144 144a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm208 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM144 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm192 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBrainCircuit = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qf);
var Jf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "brake-warning", f = 640, c = 512, e = [], t = "e0c7", o = "M96 256a224 224 0 1 1 448 0A224 224 0 1 1 96 256zM344 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM91.1 109C63.8 151.4 48 201.8 48 256s15.8 104.6 43.1 147c7.2 11.1 4 26-7.2 33.2s-26 4-33.2-7.2C18.6 379.1 0 319.7 0 256S18.6 132.9 50.7 83c7.2-11.1 22-14.4 33.2-7.2s14.4 22 7.2 33.2zM589.3 83C621.4 132.9 640 192.3 640 256s-18.6 123.1-50.7 173c-7.2 11.1-22 14.4-33.2 7.2s-14.4-22-7.2-33.2c27.3-42.4 43.1-92.8 43.1-147s-15.8-104.6-43.1-147c-7.2-11.1-4-26 7.2-33.2s26-4 33.2 7.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBrakeWarning = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jf);
var Yf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bread-loaf", f = 640, c = 512, e = [127838], t = "f7eb", o = "M0 192C0 64 176 32 240 32s240 32 240 160c0 35.3-28.7 64-64 64l0 176c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-176c-35.3 0-64-28.7-64-64zM397.4 34.9c-2-.9-4.1-1.9-6.2-2.8c3.1-.1 6-.2 8.8-.2c64 0 240 32 240 160c0 35.3-28.7 64-64 64l0 176c0 26.5-21.5 48-48 48l-96 0c10-13.4 16-30 16-48l0-149.5c37.3-13.2 64-48.7 64-90.5c0-82.2-57.6-130.7-114.6-157.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBreadLoaf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yf);
var Zf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bread-slice-butter", f = 512, c = 512, e = [], t = "e3e1", o = "M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64l0 176c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-176c-35.3 0-64-28.7-64-64zm182.6 73.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0l50.7-50.7c12.5-12.5 12.5-32.8 0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-50.7 50.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBreadSliceButter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zf);
var pf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bridge-suspension", f = 640, c = 512, e = [], t = "e4cd", o = "M128 8c9.1 0 17 5 21.1 12.5C184.2 81.6 249.7 120 320 120s135.8-38.4 170.9-99.5C495 13 502.9 8 512 8c8.8 0 16.5 4.7 20.7 11.8c13.1 21.2 26.6 42.2 42 59.8c15.5 17.7 31.7 30.6 49.4 36.9c12.5 4.5 18.9 18.2 14.4 30.7s-18.2 18.9-30.7 14.4c-25.5-9.2-46.4-25.8-63.9-44.5L544 256l64 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32c-35.3 0-64 28.7-64 64l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-53-43-96-96-96l-64 0c-53 0-96 43-96 96l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-35.3-28.7-64-64-64c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l64 0 0-138.9c-17.4 18.7-38.4 35.3-63.9 44.5c-12.5 4.5-26.2-2-30.7-14.4s2-26.2 14.4-30.7c17.7-6.4 33.9-19.3 49.4-36.9c15.4-17.6 29-38.6 42-59.8C111.5 12.7 119.2 8 128 8zM480 108.1c-12.4 10.7-25.8 20.1-40 28.2L440 256l40 0 0-147.9zm-88 49c-15.5 4.8-31.6 8.1-48 9.8l0 89.2 48 0 0-99zm-96 9.8c-16.4-1.6-32.5-4.9-48-9.8l0 99 48 0 0-89.2zm-96-30.5c-14.2-8-27.6-17.5-40-28.2L160 256l40 0 0-119.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBridgeSuspension = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pf);
var xf = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "briefcase-arrow-right", f = 512, c = 512, e = [], t = "e2f2", o = "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zM297 191l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L152 312c-13.3 0-24-10.7-24-24s10.7-24 24-24l150.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBriefcaseArrowRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xf);
var ic = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "briefcase-blank", f = 512, c = 512, e = [], t = "e0c8", o = "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBriefcaseBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ic);
var ac = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "brightness", f = 512, c = 512, e = [], t = "e0c9", o = "M224 80l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM0 256c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32zm432-32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM256 512c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 17.7-14.3 32-32 32zM73.4 438.6c-12.5-12.5-12.5-32.8 0-45.3l32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0zm288-333.3l32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm77.3 333.3c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3zm-333.3-288l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBrightness = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ac);
var ec = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "brightness-low", f = 512, c = 512, e = [], t = "e0ca", o = "M224 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM432 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0-256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBrightnessLow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ec);
var nc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bring-forward", f = 512, c = 512, e = [], t = "f856", o = "M224 448l224 0 0-224-64 0 0-64 64 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-64 64 0 0 64zm64-96L64 352c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBringForward = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nc);
var fc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bring-front", f = 640, c = 512, e = [], t = "f857", o = "M64 64l64 0 32 0 32 0 64 0c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 192c0 35.3 28.7 64 64 64l64 0 0-64-64 0L64 64zM480 448l-32 0-64 0c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-64 0 0 64 64 0 0 128-64 0-32 0zM224 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L224 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBringFront = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fc);
var cc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "broccoli", f = 512, c = 512, e = [129382], t = "e3e2", o = "M0 256c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-45.5-31.6-83.6-74.1-93.5c6.4-10 10.1-21.8 10.1-34.5c0-35.3-28.7-64-64-64c-12.7 0-24.6 3.7-34.5 10.1C339.6 31.6 301.5 0 256 0s-83.6 31.6-93.5 74.1C152.6 67.7 140.7 64 128 64c-35.3 0-64 28.7-64 64c0 12.7 3.7 24.6 10.1 34.5C31.6 172.4 0 210.5 0 256zM192.2 490.3c5 12.8 17.1 21.7 30.9 21.7l65.9 0c13.8 0 25.9-8.9 30.9-21.7c17.6-45.3 39.6-82.1 56.1-106.3L280 384l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384l-95.9 0c16.5 24.2 38.5 60.9 56.1 106.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBroccoli = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cc);
var tc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "broom-wide", f = 512, c = 512, e = [], t = "e5d1", o = "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128-15.8-15.8c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18L380.4 288.1l18-32.5c10.4-18.7 7.1-42.1-8-57.3l-15.8-15.8 128-128c12.5-12.5 12.5-32.8 0-45.3zM187.5 151.8L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4l95.1-171.1L187.5 151.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBroomWide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tc);
var oc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "browser", f = 512, c = 512, e = [128468], t = "f37e", o = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm384 0c0-13.3-10.7-24-24-24l-240 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBrowser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oc);
var lc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "browsers", f = 576, c = 512, e = [], t = "e0cb", o = "M160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L160 0zM280 72l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM224 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBrowsers = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lc);
var dc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "building-magnifying-glass", f = 640, c = 512, e = [], t = "e61c", o = "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c25.6 0 46.6-20.1 47.9-45.3C327.5 441.9 288 385.6 288 320c0-11 1.1-21.7 3.2-32L272 288c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c4.8 0 9.1 2.1 12.1 5.5c16.9-24.5 40.4-44.1 67.9-56.2L384 48c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBuildingMagnifyingGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dc);
var rc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "building-memo", f = 640, c = 512, e = [], t = "e61e", o = "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 68.1 0c-12.6-15.2-20.1-34.7-20.1-56l0-168-16 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l16 0 0-64-16 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c1.3 0 2.5 .2 3.8 .4C323.9 76.6 348.5 64 376 64l8 0 0-16c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM384 96c-35.3 0-64 28.7-64 64l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L384 96zm16 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM376 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm64-168c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm16 80l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM464 400c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBuildingMemo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rc);
var sc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "buildings", f = 512, c = 512, e = [], t = "e0cc", o = "M256 0c-35.3 0-64 28.7-64 64l0 64L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0 192 0c35.3 0 64-28.7 64-64l0-256 0-128c0-35.3-28.7-64-64-64L256 0zM64 304c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm208 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0zm112-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM80 192l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM256 208l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm144 16c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBuildings = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sc);
var hc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bulldozer", f = 640, c = 512, e = [], t = "e655", o = "M96 96l0 96 124.2 0-48-96L96 96zM229.5 67.4L291.8 192l28.2 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 32 0c17.7 0 32 14.3 32 32l0 64 64 0 0-41.6c0-21.8 7.4-42.9 21-60L583 124c11-13.8 31.2-16 45-5s16 31.2 5 45l-50 62.5c-4.5 5.7-7 12.7-7 20l0 73.6 0 69.5c0 8.5 3.4 16.6 9.4 22.6l45.3 45.3c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-45.3-45.3c-18-18-28.1-42.4-28.1-67.9l0-37.5-42.8 0c6.9 14.5 10.8 30.8 10.8 48c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400c0-30.5 12.2-58.2 32-78.4c0-.5 0-1 0-1.6l0-64 0-32L32 80c0-26.5 21.5-48 48-48l92.2 0c24.2 0 46.4 13.7 57.2 35.4zM112 352c-26.5 0-48 21.5-48 48s21.5 48 48 48l256 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-256 0zm8 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm216 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM176 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBulldozer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hc);
var vc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bullseye-arrow", f = 512, c = 512, e = [127919], t = "f648", o = "M335.2 244.7c.5 3.7 .8 7.5 .8 11.3c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c3.8 0 7.6 .3 11.3 .8l31.2-31.2L293.7 117c-12-3.3-24.7-5-37.7-5c-79.5 0-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8-31.2 31.2zm110.1-20.8c1.8 10.4 2.7 21.1 2.7 32.1c0 106-86 192-192 192S64 362 64 256S150 64 256 64c10.9 0 21.6 .9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3zm-80.2-43.1l50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80 409 22.5c-4.3-10.7-18-13.5-26.2-5.4L331.6 68.4c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7L239 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBullseyeArrow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vc);
var uc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bullseye-pointer", f = 512, c = 512, e = [], t = "f649", o = "M256 448c106 0 192-86 192-192s-86-192-192-192S64 150 64 256c0 3.9 .1 7.8 .4 11.7L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l18.4-62.6c3.9 .2 7.8 .4 11.7 .4zm2.3-48l19.7-67c33.5-9.6 58-40.4 58-76.9c0-44.2-35.8-80-80-80c-36.5 0-67.4 24.5-76.9 58L112 253.7C113.2 175.2 177.2 112 256 112c79.5 0 144 64.5 144 144c0 78.8-63.2 142.8-141.7 144zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBullseyePointer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uc);
var mc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "buoy", f = 576, c = 512, e = [], t = "e5b5", o = "M192 0c-17.7 0-32 14.3-32 32c0 15.3 10.8 28.1 25.1 31.3L133.8 320 96 320c-17.7 0-32 14.3-32 32l0 16c0 8.2 .7 16.1 2 23.9c21-11.1 46.9-9.9 66.9 4.2c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20-14.1 45.9-15.3 66.9-4.2c1.3-7.8 2-15.8 2-23.9l0-16c0-17.7-14.3-32-32-32l-37.8 0L390.9 63.3C405.2 60.1 416 47.3 416 32c0-17.7-14.3-32-32-32L192 0zM325.8 64l9.8 49L288 168.5 240.4 113l9.8-49 75.5 0zm21.8 108.8l17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6l-44.9 52.4 17-84.9 27.9 32.6zM221.3 320L288 242.2 354.7 320l-133.4 0zm85.2 101.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBuoy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mc);
var gc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "buoy-mooring", f = 576, c = 512, e = [], t = "e5b6", o = "M256 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 36.7c38 11.5 67.8 43.2 75.9 83.7l48.5 242.7c-.4 .3-.9 .6-1.3 .9c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-19 0-41.2-7.9-59.2-20.3c-.4-.3-.9-.6-1.3-.9l48.5-242.7c8.1-40.6 37.9-72.2 75.9-83.7L256 32zm32 96c-22 0-40.9 15.5-45.2 37L218.2 288l139.5 0L333.2 165c-4.3-21.5-23.2-37-45.2-37zm18.5 293.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBuoyMooring = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gc);
var o2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "burger-cheese", f = 512, c = 512, e = [127828, "cheeseburger"], t = "f7f1", o = "M32 194.9C32 211 45 224 61.1 224l389.8 0c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM128 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400l0 16c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-16c0-8.8-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16zM234 262.7c-6.5-4.4-14.2-6.7-22.1-6.7l-3.9 0-.1 0L64 256c-26.5 0-48 21.5-48 48s21.5 48 48 48l384 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-15.9 0-.1 0-3.9 0c-7.9 0-15.6 2.3-22.1 6.7l-68.2 45.5c-10.7 7.2-24.8 7.2-35.5 0L234 262.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBurgerCheese = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o2);
var Pc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "burger-fries", f = 640, c = 512, e = [], t = "e0cd", o = "M183.2 1.7c-5-2.5-10.8-2.2-15.6 .7S160 10.5 160 16l0 190.7s0 0 0 0l0 63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2l0-238c-.1-6-3.5-11.4-8.8-14.1l-32-16zM128 14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6l0-246.3zM40.3 85.6L19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2L48 192c3.6 0 7 .4 10.2 1L40.3 85.6zM383.8 98.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2-.3 4-.6 6.1-.7c11-6.5 23.3-12.3 37.1-17.2l13.4-76.1zM276.3 337.2c-11.8-10.4-19.5-25.3-20.2-42.1c-16.6 5.4-37.6 8.8-64.1 8.8c-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224l-26.6 0C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1l57.5 237C61.5 501.9 74.4 512 89.2 512L272 512c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8zm-8.5-82.9c.8-.6 1.6-1.1 2.4-1.7c4.1-6.6 9.4-14 16.1-21.6c.1-.3 .2-.6 .3-.9c.7-2.3 1.7-4.7 2.8-7L319.8 50.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4L256 261c4.8-2.1 8.7-4.4 11.8-6.6zm372.2 38c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5l296.9 0c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16l-320 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBurgerFries = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pc);
var Mc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "burger-glass", f = 640, c = 512, e = [], t = "e0ce", o = "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3L272 512c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-12.4-10.9-20.3-26.9-20.3-44.8c0-6.3 1-13.8 4.4-21.5c5.5-12.5 20.5-40.4 52.7-65.3c16.2-12.5 36.3-23.8 60.9-32l10-139.4c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM73.2 160L66.4 64l251.3 0-6.9 96L73.2 160zM640 292.3c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5l296.9 0c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16l-320 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBurgerGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mc);
var wc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "burger-lettuce", f = 512, c = 512, e = [], t = "e3e3", o = "M32 194.9C32 211 45 224 61.1 224l389.8 0c16.1 0 29.1-13 29.1-29.1c0-1.9-.2-3.7-.6-5.6C474.1 168.3 433.2 32 256 32S37.9 168.3 32.6 189.3c-.5 1.9-.6 3.7-.6 5.6zM128 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm240 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 400l0 16c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-16c0-8.8-7.2-16-16-16L48 384c-8.8 0-16 7.2-16 16zm48-48c24.6 0 44.2-11.8 56.2-19c.9-.5 1.7-1 2.5-1.5c13.7-8.1 20.8-11.5 29.3-11.5c7.7 0 12.3 2.5 25.4 10.9l.2 .1c13 8.3 32.6 21 62.4 21c29.7 0 48.6-12.6 61-20.9l.8-.5c11.6-7.7 16.6-10.6 26.2-10.6c10.5 0 17.9 3.7 30.2 11.3c.9 .5 1.8 1.1 2.8 1.7c11.4 7.1 30.3 19 55 19c21.5 0 38.4-5.4 50.3-11.4c5.9-3 10.5-6 13.9-8.5c1.7-1.3 3.1-2.4 4.1-3.3c.5-.5 1-.9 1.4-1.2l.5-.5 .2-.2 .1-.1c0 0 0 0 0 0c0 0 0 0 0 0L480 304l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.3-12.3-32-12.5-44.5-.7l-.3 .2c-.6 .5-2 1.4-4.1 2.5c-4.1 2-11.2 4.6-21.7 4.6c-5.2 0-9.2-2-24.2-11.3C394.1 268.3 373.5 256 344 256c-29.7 0-48.6 12.6-61 20.9l-.8 .5C270.6 285.1 265.7 288 256 288c-10 0-16.1-3.2-28-10.9l-1.8-1.1c-11.9-7.7-30.8-20-58.3-20c-27.7 0-48.4 12.3-61.6 20.2l-.5 .3C90.7 285.6 85.6 288 80 288c-10.5 0-17.6-2.6-21.7-4.6c-2.1-1-3.5-2-4.1-2.5l-.3-.2c-12.5-11.8-32.3-11.6-44.5 .7c-12.5 12.5-12.5 32.8 0 45.3l22.4-22.4C9.4 326.6 9.4 326.6 9.4 326.6s0 0 0 0c0 0 0 0 0 0l.1 .1 .2 .2 .5 .5c.4 .4 .8 .8 1.4 1.2c1.1 .9 2.4 2.1 4.1 3.3c3.4 2.5 8 5.6 13.9 8.5C41.6 346.6 58.5 352 80 352z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBurgerLettuce = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wc);
var Nc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "burger-soda", f = 640, c = 512, e = [], t = "f858", o = "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8L32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l301.4 0c14-8.2 30.1-15.4 48.6-20.9c1.3-3.5 2-7.2 2-11.1c0-17.7-14.3-32-32-32l-127.8 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0zM40 224L60.3 468c2.1 24.9 22.9 44 47.8 44L272 512c-10-13.4-16-30-16-48c0-14.7 6.6-27.8 17-36.6c-10.5-11.4-17-26.6-17-43.4c0-18.5 7.8-35.1 20.3-46.8c-12.4-10.9-20.3-26.9-20.3-44.8c0-6.3 1-13.8 4.4-21.5c4.2-9.5 13.8-27.8 32.2-47L40 224zm600 68.3c0-3-.5-5.9-1.7-8.6c-8.1-18.4-48.4-91.9-174.3-91.9s-166.2 73.5-174.3 91.9c-1.2 2.7-1.7 5.7-1.7 8.6c0 15.2 12.3 27.5 27.5 27.5l296.9 0c15.2 0 27.5-12.3 27.5-27.5zM384 239.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-224 112c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm-16 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48c0-8.8-7.2-16-16-16l-320 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBurgerSoda = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nc);
var zc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "burrito", f = 512, c = 512, e = [127791], t = "f7ed", o = "M251.4 52.6L33.9 270.1c-9.9 9.9-17.8 21.3-23.4 33.7C39.2 324.1 74.2 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-40.4-13.6-77.7-36.6-107.4zm15-32C299.7 57.5 320 106.4 320 160c0 11.9-1 23.6-2.9 34.9c11.4-1.9 23-2.9 34.9-2.9c53.6 0 102.5 20.3 139.4 53.6c12.8-14.2 20.6-33 20.6-53.6c0-11.4-2.4-22.2-6.7-32c4.3-9.8 6.7-20.6 6.7-32c0-34.6-22-64.1-52.8-75.2C448.1 22 418.6 0 384 0c-11.4 0-22.2 2.4-32 6.7C342.2 2.4 331.4 0 320 0c-20.6 0-39.4 7.8-53.6 20.6zm193 240C429.7 237.6 392.4 224 352 224c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-40.8 0-78.8-11.7-110.9-32C.4 341.3 0 346.6 0 352c0 30.7 12.2 60.2 33.9 81.9l44.1 44.1C99.8 499.8 129.3 512 160 512s60.2-12.2 81.9-33.9L459.4 260.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBurrito = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zc);
var Lc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "bus-school", f = 512, c = 512, e = [], t = "f5dd", o = "M256 0C380.8 0 464 35.2 464 80l0 16 0 16 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-16 0 0 28.2c9.8 8.8 16 21.6 16 35.8l0 96c0 20.9-13.4 38.7-32 45.3l0 34.7c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-192 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-34.7c-18.6-6.6-32-24.4-32-45.3l0-96c0-14.2 6.2-27 16-35.8L48 240l-16 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-16 0-16C48 35.2 131.2 0 256 0zM112 160l0 64c0 17.7 14.3 32 32 32l96 0 0-128-96 0c-17.7 0-32 14.3-32 32zm160 96l96 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-96 0 0 128zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 80c0-8.8-7.2-16-16-16L176 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faBusSchool = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lc);
var Cc = {}, l = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-hair-mullet", f = 448, c = 512, e = ["business-front", "party-back", "trian-balbot"], t = "e45c", o = "M304 128l0 16c0 18-6 34.6-16 48c0 0 0 0 0 0s0 0 0 0c-14.6 19.4-37.8 32-64 32s-49.4-12.6-64-32c0 0 0 0 0 0s0 0 0 0c-10-13.4-16-30-16-48l0-16c0-5.7 .6-11.3 1.7-16.6c30.6-3.1 58.5-17.9 78.3-40.6c19.8 22.7 47.6 37.5 78.3 40.6c1.1 5.4 1.7 10.9 1.7 16.6zM237.4 271.3L255 289c5.5 5.5 13.2 8 20.8 6.7s14.2-6.1 17.6-13l6.1-12.2 19.5 7.8c9.3 3.7 19.8 1.3 26.6-6s8.3-18.1 3.8-27c-8.5-17-11-22.3-12.2-27.1c-.7-2.9-1.1-5.9-1.2-12.3C346.2 187.5 352 166.4 352 144l0-16c0-7.1-.6-14-1.7-20.7c5.9-4.4 9.7-11.4 9.7-19.3c0-13.3-10.7-24-24-24l-1.1 0C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64L112 64C98.7 64 88 74.7 88 88c0 7.9 3.8 14.9 9.7 19.3C96.6 114 96 120.9 96 128l0 16c0 22.4 5.8 43.5 15.9 61.8c-.1 6.4-.5 9.4-1.2 12.3c-1.2 4.8-3.7 10.1-12.2 27.1c-4.5 8.9-2.9 19.7 3.8 27s17.3 9.7 26.6 6l19.5-7.8 6.1 12.2c3.5 6.9 10 11.7 17.6 13s15.4-1.3 20.8-6.7l17.7-17.7c4.4 .5 8.9 .7 13.4 .7s9-.2 13.4-.7zM161.3 320C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320l-125.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserHairMullet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = l;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faBusinessFront = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Cc);
var Dc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "butter", f = 640, c = 512, e = [129480], t = "e3e4", o = "M64 128c0-35.3 28.7-64 64-64l320 0 0 224L64 288l0-160zM32 320l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 32c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32s14.3-32 32-32zM512 64c35.3 0 64 28.7 64 64l0 160-96 0 0-224 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faButter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dc);
var $c = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cabin", f = 512, c = 512, e = [], t = "e46d", o = "M237.4 6C248.5-2 263.5-2 274.6 6L384 84.1 384 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 88.7L498.6 166c11.3 8.1 16.1 22.6 11.9 35.8S493.9 224 480 224l-32 0-32 0L32 224c-13.9 0-26.2-9-30.5-22.2S2.1 174 13.4 166L237.4 6zM32 280c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24L56 320c-13.3 0-24-10.7-24-24l0-16zm24 72l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24L56 416c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24zm0 96l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24L56 512c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24zM320 280c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-16zm24 168l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-16zM256 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCabin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($c);
var _c = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cabinet-filing", f = 448, c = 512, e = [128452], t = "f64b", o = "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 176L0 240 0 64zM0 272l448 0 0 176c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 272zM128 128l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-17.7-14.3-32-32-32L160 96c-17.7 0-32 14.3-32 32zm0 256l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 128 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCabinetFiling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_c);
var bc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cactus", f = 512, c = 512, e = [127797], t = "f8a7", o = "M160 96c0-53 43-96 96-96s96 43 96 96l0 256 48 0c8.8 0 16-7.2 16-16l0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64c0 61.9-50.1 112-112 112l-48 0 0 16c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-144-48 0C50.1 320 0 269.9 0 208l0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64c0 8.8 7.2 16 16 16l48 0 0-128zm80 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCactus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bc);
var Sc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "caduceus", f = 512, c = 512, e = [], t = "e681", o = "M280 89.6c14.3-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 22.4L171.5 71.7c-7.5-5-16.4-7.7-25.4-7.7c-11.6 0-22.9 4.4-31.3 12.4L8.8 175.7C3.2 181 0 188.4 0 196.1C0 211.5 12.5 224 27.9 224l110.8 0c33.5 0 66.2-10.5 93.3-30l0 136.5-20.6-12.3c-12-7.2-19.4-20.2-19.4-34.3l0-3.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 3.8c0 30.9 16.2 59.6 42.7 75.5l22.6 13.6-6.6 4c-26.5 15.9-42.7 44.5-42.7 75.5l0 3.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-3.8c0-14.1 7.4-27.1 19.4-34.3l4.6-2.7 0 40.8 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-40.8 4.6 2.7c12 7.2 19.4 20.2 19.4 34.3l0 3.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-3.8c0-30.9-16.2-59.6-42.7-75.5l-6.6-4 22.6-13.6c26.5-15.9 42.7-44.5 42.7-75.5l0-3.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 3.8c0 14.1-7.4 27.1-19.4 34.3L280 330.4 280 194c27.2 19.5 59.8 30 93.3 30l110.8 0c15.4 0 27.9-12.5 27.9-27.9c0-7.7-3.2-15.1-8.8-20.4l-106-99.3c-8.5-8-19.7-12.4-31.3-12.4c-9 0-17.9 2.7-25.4 7.7L280 112l0-22.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCaduceus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sc);
var l2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cake-slice", f = 512, c = 512, e = [127856, "shortcake"], t = "e3e5", o = "M276.2 38.9c5.6-4.4 12.6-6.9 19.8-6.9c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256l0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .2 0 .3 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2c0 35.4-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 272c0-9.8 4.5-19.1 12.2-25.1l264-208zM448 288L64 288l0 48 384 0c0 0 0 0 0-.1l0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4zM64 416l384 0 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.3 0-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.1L64 368l0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCakeSlice = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l2);
var yc = {}, d2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calculator-simple", f = 512, c = 512, e = ["calculator-alt"], t = "f64c", o = "M0 48C0 21.5 21.5 0 48 0L176 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48L48 224c-26.5 0-48-21.5-48-48L0 48zm288 0c0-26.5 21.5-48 48-48L464 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-128zm48 240l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48zM0 336c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 336zM416 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32zM64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 96zM83.3 348.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L89.4 400 60.7 428.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 422.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L134.6 400l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 377.4 83.3 348.7zM352 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalculatorSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = d2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCalculatorAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yc);
var r2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-arrow-down", f = 448, c = 512, e = ["calendar-download"], t = "e0d0", o = "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L248 264z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r2);
var s2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-arrow-up", f = 448, c = 512, e = ["calendar-upload"], t = "e0d1", o = "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM248 424l0-102.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L200 424c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s2);
var Oc = {}, h2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-calendar", f = 512, c = 512, e = ["calendar-circle"], t = "e102", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 96c8.8 0 16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 32 0c17.7 0 32 14.3 32 32l0 32-256 0 0-32c0-17.7 14.3-32 32-32l32 0 0-16c0-8.8 7.2-16 16-16zM128 352l0-128 256 0 0 128c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleCalendar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = h2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCalendarCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Oc);
var kc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-circle-exclamation", f = 576, c = 512, e = [], t = "e46e", o = "M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192 0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarCircleExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kc);
var Ac = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-circle-minus", f = 576, c = 512, e = [], t = "e46f", o = "M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192 0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarCircleMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ac);
var jc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-circle-plus", f = 576, c = 512, e = [], t = "e470", o = "M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192 0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarCirclePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jc);
var Bc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-circle-user", f = 576, c = 512, e = [], t = "e471", o = "M128 0C110.3 0 96 14.3 96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32zM256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192 0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarCircleUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bc);
var v2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-clock", f = 576, c = 512, e = ["calendar-time"], t = "e0d2", o = "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192l-16 0L0 192 0 464c0 26.5 21.5 48 48 48l282.8 0C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7l0-.7zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarClock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v2);
var Tc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = r2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCalendarDownload = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Tc);
var Fc = {}, u2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-pen", f = 448, c = 512, e = ["calendar-edit"], t = "f333", o = "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm308.8 75c-14.7-14.7-38.6-14.7-53.3 0L240.6 282l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM146.1 376.5c-4.1 4.1-7 9.2-8.4 14.9L128.5 428c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L218 304.6l-71.9 71.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarPen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = u2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCalendarEdit = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Fc);
var Hc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-exclamation", f = 448, c = 512, e = [], t = "f334", o = "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272zM192 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm56-176l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hc);
var Rc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-heart", f = 448, c = 512, e = [], t = "e0d3", o = "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zM112 317.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rc);
var Uc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-image", f = 448, c = 512, e = [], t = "e0d4", o = "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272zM147.2 360.7c6.5-8.4 19.1-8.3 25.5 .2L184 376l58.3-84.2c6.5-9.4 20.5-9.1 26.7 .5l83.4 131.1c6.8 10.6-.9 24.6-13.5 24.6l-226.4 0c-13.3 0-20.8-15.2-12.7-25.8l47.3-61.5zM128 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarImage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uc);
var m2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-lines", f = 448, c = 512, e = ["calendar-note"], t = "e0d5", o = "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272zM96 296c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarLines = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m2);
var qc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-lines-pen", f = 576, c = 512, e = [], t = "e472", o = "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 43.6L289.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-15 60.1c-2.3 9.4-1.8 19 1.4 27.8L48 512c-26.5 0-48-21.5-48-48L0 192zm120 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM96 392c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarLinesPen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qc);
var Gc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = m2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCalendarNote = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Gc);
var Wc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-range", f = 448, c = 512, e = [], t = "e0d6", o = "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272zM128 288a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM352 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM192 288c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm40 104c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 440c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarRange = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wc);
var Ec = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-star", f = 448, c = 512, e = [], t = "f736", o = "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm233.3 58.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L224 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarStar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ec);
var Vc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = v2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCalendarTime = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Vc);
var Ic = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = s2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCalendarUpload = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ic);
var Kc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendar-users", f = 640, c = 512, e = [], t = "e5e2", o = "M192 32l0 32-48 0c-26.5 0-48 21.5-48 48l0 48 32 0 384 0 32 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L256 64l0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32zm55.4 480l145.1 0c-5.4-9.4-8.6-20.3-8.6-32c0-43.8 29.4-80.8 69.6-92.3c-23-20.5-37.6-50.4-37.6-83.7c0-56.4 41.7-103.1 96-110.9l0-1.1-384 0 0 1.1c54.3 7.8 96 54.4 96 110.9c0 33.3-14.5 63.2-37.6 83.7C226.6 399.2 256 436.2 256 480c0 11.7-3.1 22.6-8.6 32zM528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0zM192 304A80 80 0 1 0 32 304a80 80 0 1 0 160 0zM0 480c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-35.3 0-64 28.7-64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendarUsers = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kc);
var Xc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "calendars", f = 512, c = 512, e = [], t = "e0d7", o = "M224 0c-17.7 0-32 14.3-32 32l0 32-48 0c-26.5 0-48 21.5-48 48l0 48 416 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-96 0 0-32c0-17.7-14.3-32-32-32zM96 192l0 176c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-176L96 192zm-48-8c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 392c0 66.3 53.7 120 120 120l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-39.8 0-72-32.2-72-72l0-208z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCalendars = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xc);
var g2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camcorder", f = 576, c = 512, e = [128249, "video-handheld"], t = "f8a8", o = "M128 96c-17.7 0-32 14.3-32 32l0 32 224 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 224c0-23.7 12.9-44.4 32-55.4L32 128c0-53 43-96 96-96l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L128 96zm431.1 67.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 401.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCamcorder = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g2);
var P2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camera-cctv", f = 576, c = 512, e = ["cctv"], t = "f8ac", o = "M140.3 2.5c-14.9-6.2-32.1-.3-40.1 13.7l-96 168c-4.6 8-5.5 17.5-2.5 26.2s9.5 15.7 18 19.2l158.1 65.9L137.9 400 64 400l0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48 0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 96 0c13.3 0 25.2-8.2 29.9-20.6l47-123.4 70.8 29.5c9.9 4.1 21.2 3 30.1-2.9l192-128c9.8-6.5 15.2-18 14.1-29.7s-8.6-21.9-19.5-26.5l-384-160zM513.4 398.6c3.9 1.8 8.4 1.9 12.5 .3s7.2-4.7 8.9-8.7l40-96c3.3-8-.3-17.2-8.3-20.8l-36.7-16.3L396.9 345.6l116.5 52.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCameraCctv = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P2);
var Qc = {}, M2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-camera", f = 512, c = 512, e = ["camera-circle"], t = "e103", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM196 160l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6l62.7 0c10 0 19 6.2 22.5 15.6L316 160l36 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l36 0zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleCamera = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = M2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCameraCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Qc);
var Jc = {}, w2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camera-security", f = 448, c = 512, e = ["camera-home"], t = "f8fe", o = "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-74 0 59 36.9c12.1 7.6 17.7 22.2 13.8 36S366.3 512 352 512L96 512c-14.3 0-26.8-9.5-30.8-23.2s1.7-28.4 13.8-36L138 416l-74 0c-35.3 0-64-28.7-64-64L0 64zM128 208a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 208a128 128 0 1 0 256 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCameraSecurity = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = w2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCameraHome = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Jc);
var Yc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camera-movie", f = 576, c = 512, e = [127909, 127910], t = "f8a9", o = "M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM352 256l-224 0C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66C261.8 26.6 303.8 0 352 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM558.3 259.4c10.8 5.4 17.7 16.5 17.7 28.6l0 192c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48L448 448l0-16 0-96 0-16 12.8-9.6 64-48c9.7-7.3 22.7-8.4 33.5-3zM64 288l64 0 224 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-96-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCameraMovie = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yc);
var Zc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camera-polaroid", f = 576, c = 512, e = [], t = "f8aa", o = "M64 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 150.3 53.3 79.9c7 10.5 10.7 22.9 10.7 35.5l0 54.3c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-54.3c0-12.6 3.7-25 10.7-35.5L64 246.3 64 96zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM448 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCameraPolaroid = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zc);
var pc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camera-slash", f = 640, c = 512, e = [], t = "e0d9", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6l0-256c0-35.3-28.7-64-64-64l-74.7 0L426.9 64.8C420.4 45.2 402.1 32 381.4 32L258.6 32c-20.7 0-39 13.2-45.5 32.8L202.7 96l-47.9 0L38.8 5.1zM285.4 198.4c10.7-4.1 22.4-6.4 34.6-6.4c53 0 96 43 96 96c0 4.1-.3 8.2-.8 12.2L285.4 198.4zM224 288c0-5 .4-9.9 1.1-14.6L65.2 147.4c-.8 4.1-1.2 8.3-1.2 12.6l0 256c0 35.3 28.7 64 64 64l359.4 0L356.4 376.8c-11.2 4.6-23.5 7.2-36.4 7.2c-53 0-96-43-96-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCameraSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pc);
var N2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camera-viewfinder", f = 512, c = 512, e = ["screenshot"], t = "e0da", o = "M56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0zM376 0l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376l0 80c0 4.4 3.6 8 8 8l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c4.4 0 8-3.6 8-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zM180 128l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6l94.7 0c10 0 19 6.2 22.5 15.6L332 128l36 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l36 0zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCameraViewfinder = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N2);
var z2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camera-web", f = 448, c = 512, e = ["webcam"], t = "f832", o = "M344.2 413.1C406.6 373.3 448 303.5 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 79.5 41.4 149.3 103.8 189.1L45.6 453.8c-11.4 8-16.4 22.5-12.2 35.8S50 512 64 512l320 0c14 0 26.3-9.1 30.5-22.4s-.7-27.8-12.2-35.8l-58.2-40.7zM224 352a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM176 224c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCameraWeb = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z2);
var L2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "camera-web-slash", f = 640, c = 512, e = ["webcam-slash"], t = "f833", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135.2-106C525.9 324.9 544 276.6 544 224C544 100.3 443.7 0 320 0C248 0 183.9 34 143 86.7L38.8 5.1zM193.3 126.2C222.6 88.4 268.5 64 320 64c88.4 0 160 71.6 160 160c0 37.7-13 72.3-34.8 99.6L420 303.9c17.5-21.9 28-49.7 28-79.9c0-70.7-57.3-128-128-128c-41.3 0-78.1 19.6-101.5 50l-25.2-19.7zm88.2 69.1l-25.2-19.7C270.9 156.4 294 144 320 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-15.8 0-29.8 7.6-38.5 19.3zM507.7 496L359.4 379.1c-12.6 3.2-25.8 4.9-39.4 4.9c-88.4 0-160-71.6-160-160c0-.6 0-1.3 0-1.9l-58.8-46.3C97.8 191.3 96 207.4 96 224c0 79.5 41.4 149.3 103.8 189.1l-58.2 40.7c-11.4 8-16.4 22.5-12.2 35.8S146 512 160 512l320 0c11.6 0 22.1-6.2 27.7-16zM324.8 351.9L194.5 249.2C206.2 307.8 257.9 352 320 352c1.6 0 3.2 0 4.8-.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCameraWebSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L2);
var xc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "campfire", f = 512, c = 512, e = [], t = "f6ba", o = "M279.1 43.9L262.1 25.8c-1.8-1.9-3.6-4-5.4-6.1c0 0 0 0 0 0C248.6 10.4 239.9 .3 227.2 0c-6.5-.2-13.1 2.1-18.3 6.8c-21.1 19.2-45 44.4-63.8 72.9c-18.7 28.3-33.1 61-33.1 95C112 255.2 175.4 320 256 320c79.8 0 144-64.7 144-145.3c0-27.3-9.9-55.4-23.6-80.1C362.7 69.7 344.7 47 326.9 30.4c-5-4.7-11.5-7.1-17.9-7.1c-6.8 0-14 2.5-18.8 8.1l-11 12.5zm36.5 174.4c0 32.1-26 58.2-58.2 58.2s-58.2-26-58.2-58.2c0-33.2 33.7-66.4 49.8-80.4c4.9-4.2 11.9-4.2 16.8 0c16.1 14 49.8 47.2 49.8 80.4zM42.8 289.9c-16.6-5.9-35 2.7-40.9 19.4s2.7 35 19.4 40.9L160.9 400 21.2 449.9C4.6 455.8-4.1 474.1 1.9 490.8s24.3 25.3 40.9 19.4L256 434l213.2 76.2c16.6 5.9 35-2.7 40.9-19.4s-2.7-35-19.4-40.9L351.1 400l139.6-49.9c16.6-5.9 25.3-24.3 19.4-40.9s-24.3-25.3-40.9-19.4L256 366 42.8 289.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCampfire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xc);
var i8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "can-food", f = 384, c = 512, e = [129387], t = "e3e6", o = "M270.3 304.5c12.1-2.5 23.4-5.5 33.7-9L304 426c-2.8 1.6-6.6 3.6-11.8 5.7C269.8 440.9 234.4 448 192 448s-77.8-7.1-100.2-16.3c-5.2-2.1-9-4.1-11.8-5.7l0-130.4c10.3 3.5 21.6 6.5 33.7 9c7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5zm-100.1-40a32 32 0 1 1 43.5 46.9 32 32 0 1 1 -43.5-46.9zM16 72l0 168 0 200c0 39.8 78.8 72 176 72s176-32.2 176-72l0-200 0-168c0-39.8-78.8-72-176-72S16 32.2 16 72zm288 0c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24s112 10.7 112 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCanFood = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i8);
var a8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "candle-holder", f = 448, c = 512, e = [128367], t = "f6bc", o = "M160 192c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zm-32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0c17.7 0 32 14.3 32 32l0 208 52.1 0c-2.7-7.5-4.1-15.6-4.1-24c0-39.8 32.2-72 72-72s72 32.2 72 72s-32.2 72-72 72L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-208c0-17.7 14.3-32 32-32l32 0zM400 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCandleHolder = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a8);
var e8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "candy", f = 640, c = 512, e = [127852], t = "e3e7", o = "M318.1 64c-24.5 .2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.2-28.5 52.6-47.3L318.1 64zM492.3 340.8c4.7-9.6 8.7-19.6 11.8-30l93.2 46.6c10.5 5.3 23.3 2.1 30.2-7.4s5.8-22.7-2.5-31l-29.6-29.6 29.1-10.9C633.8 275 640 266 640 256s-6.2-19-15.6-22.5l-29.1-10.9L625 193c8.3-8.3 9.4-21.5 2.5-31s-19.7-12.7-30.2-7.4L504 201.1C483.7 132.9 426.5 80.6 355.5 67.3L492.3 340.8zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zM284.5 444.7L147.7 171.2c-4.7 9.6-8.7 19.6-11.8 30L42.7 154.5c-10.5-5.3-23.3-2.1-30.2 7.4s-5.8 22.7 2.5 31l29.6 29.6L15.6 233.5C6.2 237 0 246 0 256s6.2 19 15.6 22.5l29.1 10.9L15 319c-8.3 8.3-9.4 21.5-2.5 31s19.7 12.7 30.2 7.4L136 310.9c20.3 68.2 77.5 120.6 148.5 133.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCandy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e8);
var C2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "candy-bar", f = 640, c = 512, e = [127851, "chocolate-bar"], t = "e3e8", o = "M0 320l128 0 0-96L0 224l0 96zm0 64c0 35.3 28.7 64 64 64l64 0 0-96L0 352l0 32zm288 64l0-96-128 0 0 96 128 0zm0-224l-128 0 0 96 128 0 0-96zm0-160L160 64l0 128 128 0 0-128zm288 0L320 64l0 384 256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64zM44.2 192l75.8 0s0 0 0 0l8 0 0-32s0 0 0 0l0-51.8c0-7.1-9-11.1-15-7.4C101 107.9 87 112 72 112c-4 0-7.9-.3-11.7-.9c-7-1-14.2 6.2-13.1 13.1c.6 3.8 .9 7.7 .9 11.7c0 15-4.1 29-11.3 41c-3.6 6.1 .4 15 7.4 15z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCandyBar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C2);
var n8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "candy-corn", f = 640, c = 512, e = [], t = "f6bd", o = "M440.6 256c9.8 25.6 19.6 49 28.7 67.2c3.3 6.7 6.2 12.4 9.3 17.7c.5 .8 1 1.7 1.4 2.4c.5-.8 1-1.6 1.4-2.4c3.1-5.3 6-11 9.3-17.7c9-18.2 18.9-41.5 28.7-67.2l-78.9 0zM480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 17.4-5.3 43.8-12.3 71.4c-4.4-1-9.3-2.1-14.5-3.1c-30.9-6.2-76-12.3-133.1-12.3s-102.2 6.1-133.1 12.3c-5.3 1.1-10.1 2.1-14.5 3.1c-7-27.6-12.3-54-12.3-71.4c0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zM370.3 250.4c-11-30.8-21.3-62.9-29.6-92.1c3.8-.9 8-1.8 12.4-2.7c29.1-5.8 72-11.7 126.9-11.7s97.8 5.9 126.9 11.7c4.5 .9 8.6 1.8 12.4 2.7c-8.3 29.2-18.6 61.3-29.6 92.1c-13.2 37.2-27.9 73.6-41.6 101.3c-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3zM83 211.1c30.4-30.4 65.3-59.4 103.9-79c15-7.5 33.1-4.6 45 7.3c12 12 26.6 33.9 40.7 57.7c-3.8 2.3-7.8 5-12.2 7.9c-25.6 17.1-60.9 43.9-100.3 83.3S94 363 76.9 388.6c-2.9 4.3-5.5 8.4-7.9 12.2C45.2 386.6 23.3 372 11.3 360C-.6 348.1-3.3 329.6 4.2 314.6C23.9 276.2 52.6 241.5 83 211.1zm97 248.2c-28.8-13.7-58-28.7-83.9-43c2-3.2 4.3-6.7 6.7-10.4c16-24 41.6-57.7 79.4-95.5S253.7 247 277.7 231c3.7-2.5 7.2-4.7 10.4-6.7c14.4 25.9 29.4 55.1 43.1 83.9c16.5 34.8 31.5 70 41.1 98.5c9.3 27.9 21.7 67-2.6 91.2s-63.4 11.9-91.2 2.6c-28.5-9.6-63.7-24.6-98.5-41.1zm52.3-44.6c24.4 11 47.3 20.2 66.1 26.5c6.9 2.3 12.8 4.2 18.6 5.8c.9 .2 1.8 .5 2.7 .7c-.2-.9-.4-1.7-.7-2.7c-1.5-5.8-3.4-11.7-5.8-18.6c-6.3-18.8-15.6-41.7-26.5-66.1l-54.4 54.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCandyCorn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n8);
var f8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cannon", f = 640, c = 512, e = [], t = "e642", o = "M49.1 353.8L26.5 365.1C2.8 376.9-6.8 405.8 5.1 429.5s40.7 33.3 64.4 21.5L92 439.7c42.7 41.2 108.3 53.2 164.4 25.1c6.1-3.2 14.8-8.1 25.4-14.5C265.5 427 256 398.6 256 368c0-79.5 64.5-144 144-144c52.4 0 98.3 28 123.5 69.9c32.9-21.9 62.9-41.9 86-57.4c26.7-17.9 35.7-52.7 21.4-81.5L600.2 93.5c-14.4-28.7-47.7-42.4-78-31.8C414.8 99.3 177.1 183.2 127.6 207.2c-56.1 28-85.9 87.7-78.5 146.6zM400 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-144a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCannon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f8);
var c8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-bolt", f = 512, c = 512, e = [], t = "e341", o = "M74.8 96.3L39.6 196.8C16.4 206.4 0 229.3 0 256L0 400l0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 320 0 0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 0-144c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32L165.4 32c-40.8 0-77.1 25.8-90.6 64.3zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM318.3 119.2L281.9 192l54.1 0c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L230.1 224 176 224c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5s7.4 12.8 4.1 19.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c8);
var t8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-building", f = 640, c = 512, e = [], t = "f859", o = "M48 0C21.5 0 0 21.5 0 48L0 432c0 26.5 21.5 48 48 48l144 0 0-32 0-96c0-32.8 16.5-61.8 41.6-79.1l5.6-16.9L208 256c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.2 0 14.9 6.1 15.9 14l.5-1.4c10.5-31.6 34.2-56 63.7-68.2L320 48c0-26.5-21.5-48-48-48L48 0zM80 192l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm0-96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 288l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm282.6-64l138.8 0c6.9 0 13 4.4 15.2 10.9L534.3 288l-204.5 0 17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352l0 96s0 0 0 0l0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-96c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160l-138.8 0c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarBuilding = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t8);
var o8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-bump", f = 640, c = 512, e = [], t = "f5e0", o = "M145.1 120.6L292.4 81.2c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6L114.6 211.6l7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1L47.8 234.2C27.4 249.4 17.2 276 24.2 302.1L57.3 425.8l12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5 487.8 177.9c-7-26.1-29.1-44.1-54.4-47L378.1 55.3c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8zm255.6-35.3a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6zM584.8 512c19.5 0 34.7-17.7 25.8-35c-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35l147.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarBump = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o8);
var l8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-bus", f = 640, c = 512, e = [], t = "f85a", o = "M32 416l16 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 64 0 0-64c0-32.8 16.5-61.8 41.6-79.1L249.9 224 208 224l0-128 88 0c13.3 0 24 10.7 24 24l0 16.4c13.2-5.4 27.7-8.4 42.6-8.4l21.4 0 0-53.5c0-16.2-9.2-31-23.7-38.3C312.8 12.4 260.3 0 207.1 0L176.9 0C123.7 0 71.2 12.4 23.7 36.2C9.2 43.4 0 58.2 0 74.5L0 384c0 17.7 14.3 32 32 32zM88 96l88 0 0 128-88 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm8 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm266.6-72l138.8 0c6.9 0 13 4.4 15.2 10.9L534.3 288l-204.5 0 17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352l0 96s0 0 0 0l0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-96c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160l-138.8 0c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarBus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l8);
var d8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-circle-bolt", f = 640, c = 512, e = [], t = "e342", o = "M135.2 117.4L109.1 192l293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32l181.2 0c40.8 0 77.1 25.8 90.6 64.3l34.1 97.4C385.8 205.7 320 279.2 320 368c0 10.9 1 21.6 2.9 32L96 400l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48L0 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm368-64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarCircleBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d8);
var r8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-garage", f = 640, c = 512, e = [], t = "f5e2", o = "M343.8 8.8c-14.8-8.4-32.9-8.4-47.6 0L24.1 164.2C8.8 173 3.5 192.5 12.2 207.9s28.3 20.7 43.7 11.9L320 68.9 584.1 219.8c15.3 8.8 34.9 3.4 43.7-11.9s3.4-34.9-11.9-43.7L343.8 8.8zM249.8 224l140.3 0c6.8 0 12.8 4.3 15.1 10.6L424.3 288l-208.6 0 19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9l-28.3 79.3C126.1 300.9 112 320.8 112 344l0 40 0 64 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-64 0-40c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C454.1 181.3 424 160 390.2 160l-140.3 0c-33.8 0-64 21.3-75.3 53.1zM192 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarGarage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r8);
var s8 = {}, D2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-wrench", f = 512, c = 512, e = ["car-mechanic"], t = "f5e3", o = "M468.9 104L456 104l-.5 0c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1l.5 0 12.9 0 17.6 0c10.8 0 18.4-10.6 12.5-19.6c-3.6-5.5-7.8-10.5-12.5-14.9c-4.2-3.9-8.8-7.4-13.8-10.3C470.8 10 468.9 9 466.9 8C456.4 2.9 444.5 0 432 0c-29.1 0-54.5 15.5-68.5 38.7c-3.3 5.4-8.9 9.3-15.3 9.3L163.8 48c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0C67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1c-5 2.9-9.6 6.4-13.8 10.3c-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56l17.6 0L56 56l.5 0c.7 0 1.4 .1 2.1 .1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7 .1-1.4 .1-2.1 .1l-.5 0-12.9 0-17.6 0C14.7 104 7 114.6 12.9 123.6c3.6 5.5 7.8 10.5 12.5 14.9c4.2 3.9 8.8 7.4 13.8 10.3c1.9 1.1 3.8 2.2 5.8 3.1c10.6 5.1 22.4 8 34.9 8c29.1 0 54.5-15.5 68.5-38.7c3.3-5.4 8.9-9.3 15.3-9.3l184.4 0c6.4 0 12 3.8 15.3 9.3c14 23.2 39.5 38.7 68.5 38.7c12.5 0 24.4-2.9 34.9-8c2-1 3.9-2 5.8-3.1c5-2.9 9.6-6.4 13.8-10.3c4.7-4.4 9-9.4 12.5-14.9c5.9-9-1.7-19.6-12.5-19.6l-17.6 0zM185.8 224l140.3 0c6.8 0 12.8 4.3 15.1 10.6L360.3 288l-208.6 0 19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344l0 40 0 64 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-64 0-40c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160l-140.3 0c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarWrench = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = D2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCarMechanic = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(s8);
var h8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-mirrors", f = 576, c = 512, e = [], t = "e343", o = "M167.2 117.4c4.5-12.8 16.6-21.4 30.2-21.4l181.2 0c13.6 0 25.7 8.6 30.2 21.4L434.9 192l-293.8 0 26.1-74.6zM32 224l8.6 0c-5.4 9.4-8.6 20.3-8.6 32l0 144 0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 320 0 0 48c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-48 0-144c0-11.7-3.1-22.6-8.6-32l8.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.5 0L469.2 96.3C455.7 57.8 419.4 32 378.6 32L197.4 32c-40.8 0-77.1 25.8-90.6 64.3L84.5 160 32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32zm64 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarMirrors = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h8);
var v8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-side-bolt", f = 640, c = 512, e = [], t = "e344", o = "M82.2 92.3L40.6 196.4C16.8 205.8 0 228.9 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l33.3 0c17.7 0 32-14.3 32-32l0-48c0-65.2-48.8-119-111.8-127L428.2 68c-18.2-22.8-45.8-36-75-36L171.3 32c-39.3 0-74.6 23.9-89.1 60.3zM480 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM114.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM331.2 100.6c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176l51.7 0c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L243.7 208 192 208c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarSideBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v8);
var u8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-tilt", f = 640, c = 512, e = [], t = "f5e5", o = "M145.1 120.6L292.4 81.2c12.7-3.4 26.3 1.3 34.1 12l37.8 51.6L114.6 211.6l7-63.6c1.4-13.1 10.8-24 23.5-27.4zM58 141.1L47.8 234.2C27.4 249.4 17.2 276 24.2 302.1L57.3 425.8l6 22.2L48 448c-26.5 0-48 21.5-48 48l0 16 640 0 0-16c0-26.5-21.5-48-48-48l-429.4 0c-.1-.2-.1-.5-.2-.7L150 400.9l278.2-74.5 12.4 46.4c4.6 17.1 22.1 27.2 39.2 22.6l30.9-8.3c17.1-4.6 27.2-22.1 22.6-39.2L521 301.5 487.8 177.9c-7-26.1-29.1-44.1-54.4-47L378.1 55.3c-23.4-31.9-64-46.2-102.3-36L128.5 58.8C90.3 69.1 62.3 101.7 58 141.1zm58.9 136.2a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8zm255.6-35.3a32 32 0 1 1 61.8-16.6 32 32 0 1 1 -61.8 16.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarTilt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u8);
var m8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "car-wash", f = 448, c = 512, e = [], t = "f5e6", o = "M64 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zm160 0c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48zM432 80c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48zM153.8 224l140.3 0c6.8 0 12.8 4.3 15.1 10.6L328.3 288l-208.6 0 19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zM78.5 213.1L50.2 292.4C30.1 300.9 16 320.8 16 344l0 40 0 64 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-64 0-40c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C358.1 181.3 328 160 294.2 160l-140.3 0c-33.8 0-64 21.3-75.3 53.1zM96 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCarWash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m8);
var g8 = {}, $2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "caravan-simple", f = 640, c = 512, e = ["caravan-alt"], t = "e000", o = "M80 32C35.8 32 0 67.8 0 112L0 336c0 44.2 35.8 80 80 80l16 0c0 53 43 96 96 96s96-43 96-96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-160c0-88.4-71.6-160-160-160L80 32zM64 160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-64zm288-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM144 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCaravanSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = $2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCaravanAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(g8);
var P8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "card-club", f = 384, c = 512, e = [], t = "e3e9", o = "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM130.1 208.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8l0 32.8-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCardClub = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P8);
var M8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "card-diamond", f = 384, c = 512, e = [], t = "e3ea", o = "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm180.7 84.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCardDiamond = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M8);
var w8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "card-heart", f = 384, c = 512, e = [], t = "e3eb", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM80 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCardHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w8);
var N8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "card-spade", f = 384, c = 512, e = [], t = "e3ec", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM175 137.8c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 64 64c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-7.4-7.4c-.3-.3-.6-.6-1-.9l0 40.8 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-40.8c-.3 .3-.7 .6-1 .9l-7.4 7.4c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l64-64L175 137.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCardSpade = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N8);
var z8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cards", f = 640, c = 512, e = [], t = "e3ed", o = "M7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zM197 159.6c-11.1-3-22.6 3.6-25.6 14.8l-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4 .2-.8 .3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4 .1 .8 .2 1.1 .3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4L197 159.6zM459.4 420.9c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2l224 0c30.9 0 56 25.1 56 56l0 336c0 30.9-25.1 56-56 56l-224 0c-13.7 0-26.2-4.9-35.9-13l135.3-78.1zm74.5-183.3L582 187.6c14-14.5 13.2-38.5-2.2-51.9c-14-11.7-34.5-9.5-46.9 3.2l-4.7 5.2-5-5.2c-12.5-12.7-33.2-15-46.7-3.2c-15.7 13.5-16.5 37.5-2.5 51.9l48.4 49.9c3 3.2 8.2 3.2 11.5 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCards = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z8);
var L8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cards-blank", f = 640, c = 512, e = [], t = "e4df", o = "M27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4L443.4 393.2c26.6-15.4 35.8-49.4 20.4-76.1L296.8 27.8C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zM459.4 420.9L324.1 499c9.7 8.1 22.2 13 35.9 13l224 0c30.9 0 56-25.1 56-56l0-336c0-30.9-25.1-56-56-56L360 64c-1.8 0-3.5 .1-5.3 .2L491.5 301.1c24.2 41.9 9.8 95.6-32.1 119.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCardsBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L8);
var C8 = {}, _2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-caret-down", f = 512, c = 512, e = ["caret-circle-down"], t = "f32d", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 368c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleCaretDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = _2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCaretCircleDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(C8);
var D8 = {}, b2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-caret-left", f = 512, c = 512, e = ["caret-circle-left"], t = "f32e", o = "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-368 0c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleCaretLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = b2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCaretCircleLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(D8);
var $8 = {}, S2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-caret-right", f = 512, c = 512, e = ["caret-circle-right"], t = "f330", o = "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 0c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleCaretRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = S2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCaretCircleRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})($8);
var _8 = {}, y2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-caret-up", f = 512, c = 512, e = ["caret-circle-up"], t = "f331", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleCaretUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = y2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCaretCircleUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_8);
var b8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cars", f = 640, c = 512, e = [], t = "f85b", o = "M123.4 74.9c2.2-6.5 8.3-10.9 15.2-10.9l138.8 0c6.9 0 13 4.4 15.2 10.9L310.3 128l-204.5 0 17.7-53.1zM36.1 134.4C14.8 144.7 0 166.6 0 192l0 96s0 0 0 0l0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 136.5 0c5.1-5.7 10.8-10.7 17.1-15.1l22.8-68.3c15.2-45.7 58-76.6 106.3-76.6l15.1 0L353.3 54.7C342.4 22 311.8 0 277.4 0L138.6 0c-34.4 0-65 22-75.9 54.7L36.1 134.4zM56 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm306.6 16l138.8 0c6.9 0 13 4.4 15.2 10.9L534.3 288l-204.5 0 17.7-53.1c2.2-6.5 8.3-10.9 15.2-10.9zm-75.9-9.3l-26.6 79.7C238.8 304.7 224 326.6 224 352l0 96s0 0 0 0l0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 0-96c0-25.4-14.8-47.3-36.1-57.6l-26.6-79.7C566.4 182 535.8 160 501.4 160l-138.8 0c-34.4 0-65 22-75.9 54.7zM304 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCars = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b8);
var S8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-arrow-up", f = 576, c = 512, e = [], t = "e3ee", o = "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288 312 288l0-110.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23L360 288l99.2 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S8);
var y8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-circle-arrow-down", f = 640, c = 512, e = [], t = "e3ef", o = "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4L538.8 197.2c-13.7-3.4-28.1-5.2-42.8-5.2c-68.4 0-127.7 39-156.8 96l-168.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5l123.2 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16l-121 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 140.7c-6.2-6.2-16.4-6.2-22.6 0L512 393.4l0-89.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 89.4-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56 56c6.2 6.2 16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartCircleArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y8);
var O8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-circle-arrow-up", f = 640, c = 512, e = [], t = "e3f0", o = "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4L538.8 197.2c-13.7-3.4-28.1-5.2-42.8-5.2c-68.4 0-127.7 39-156.8 96l-168.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5l123.2 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16l-121 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368 48a144 144 0 1 1 0-288 144 144 0 1 1 0 288zM428.7 371.3c6.2 6.2 16.4 6.2 22.6 0L480 342.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-89.4 28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartCircleArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O8);
var k8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-circle-check", f = 640, c = 512, e = [], t = "e3f1", o = "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4L538.8 197.2c-13.7-3.4-28.1-5.2-42.8-5.2c-68.4 0-127.7 39-156.8 96l-168.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5l123.2 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16l-121 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm188.7-43.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartCircleCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k8);
var A8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-circle-exclamation", f = 640, c = 512, e = [], t = "e3f2", o = "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4L538.8 197.2c-13.7-3.4-28.1-5.2-42.8-5.2c-68.4 0-127.7 39-156.8 96l-168.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5l123.2 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16l-121 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartCircleExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A8);
var j8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-circle-plus", f = 640, c = 512, e = [], t = "e3f3", o = "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4L538.8 197.2c-13.7-3.4-28.1-5.2-42.8-5.2c-68.4 0-127.7 39-156.8 96l-168.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5l123.2 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16l-121 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm512-96a144 144 0 1 1 -288 0 144 144 0 1 1 288 0zm-80 16c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartCirclePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j8);
var B8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-circle-xmark", f = 640, c = 512, e = [], t = "e3f4", o = "M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4L538.8 197.2c-13.7-3.4-28.1-5.2-42.8-5.2c-68.4 0-127.7 39-156.8 96l-168.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5l123.2 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16l-121 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartCircleXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B8);
var O2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-flatbed-boxes", f = 640, c = 512, e = ["dolly-flatbed-alt"], t = "f475", o = "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l16 0c8.8 0 16 7.2 16 16l0 288c0 44.2 35.8 80 80 80l18.7 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l197.5 0c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l66.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-464 0c-8.8 0-16-7.2-16-16l0-288C128 35.8 92.2 0 48 0L32 0zM224 32c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L224 32zM416 64l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartFlatbedBoxes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O2);
var k2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-flatbed-empty", f = 640, c = 512, e = ["dolly-flatbed-empty"], t = "f476", o = "M0 32C0 14.3 14.3 0 32 0L48 0c44.2 0 80 35.8 80 80l0 288c0 8.8 7.2 16 16 16l464 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-66.7 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16L144 448c-44.2 0-80-35.8-80-80L64 80c0-8.8-7.2-16-16-16L32 64C14.3 64 0 49.7 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartFlatbedEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k2);
var T8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-minus", f = 576, c = 512, e = [], t = "e0db", o = "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM280 132l112 0c11 0 20 9 20 20s-9 20-20 20l-112 0c-11 0-20-9-20-20s9-20 20-20z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T8);
var F8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-shopping-fast", f = 640, c = 512, e = [], t = "e0dc", o = "M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L552 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L234.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C640.6 57 621.4 32 595.1 32l-411 0C175 12.8 155.6 0 133.5 0L88 0zM240 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 96zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartShoppingFast = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F8);
var H8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cart-xmark", f = 576, c = 512, e = [], t = "e0dd", o = "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM395.4 128.9L364.3 160l31.1 31.1c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L336 188.3l-31.1 31.1c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L307.7 160l-31.1-31.1c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L336 131.7l31.1-31.1c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCartXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H8);
var R8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cassette-tape", f = 576, c = 512, e = [128429], t = "f8ab", o = "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-28.9 0-36.3-96.9c-7-18.7-24.9-31.1-44.9-31.1l-227.6 0c-20 0-37.9 12.4-44.9 31.1L92.9 480 64 480c-35.3 0-64-28.7-64-64L0 96zM416.8 394.4L448.9 480l-321.8 0 32.1-85.6c2.3-6.2 8.3-10.4 15-10.4l227.6 0c6.7 0 12.6 4.1 15 10.4zM341.5 192l-106.9 0c3.5 10 5.5 20.8 5.5 32s-1.9 22-5.5 32l106.9 0c-3.5-10-5.5-20.8-5.5-32s1.9-22 5.5-32zm90.5 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM112 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCassetteTape = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R8);
var A2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cassette-vhs", f = 576, c = 512, e = [128252, "vhs"], t = "f8ec", o = "M0 96l0 32 576 0 0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 64L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256L0 160zM467.9 384L416 384l0-34.7c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3l0-34.7 51.9 0c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80zM160 349.3l0 34.7-51.9 0C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80l51.9 0 0 34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3zM256 224l64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCassetteVhs = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A2);
var U8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "castle", f = 640, c = 512, e = [], t = "e0de", o = "M128 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 96 0 112 64 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 96 0 192c0 26.5-21.5 48-48 48l-208 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L48 512c-26.5 0-48-21.5-48-48L0 272l0-96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 64 0 0-112 0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCastle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U8);
var q8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cat-space", f = 640, c = 512, e = [], t = "e001", o = "M576 160c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7l0 84.7c0 53 43 96 96 96s96-43 96-96l0-84.7c19.9 22.6 32 52.2 32 84.7zM411.2 89.6L381.8 50.4C401.1 38.7 423.8 32 448 32s46.9 6.7 66.2 18.4L484.8 89.6c-3 4-7.8 6.4-12.8 6.4l-48 0c-5 0-9.8-2.4-12.8-6.4zM480 316.8C553 302 608 237.4 608 160C608 71.6 536.4 0 448 0S288 71.6 288 160c0 11.7 1.3 23.1 3.6 34.1c-54.9 8.1-102.2 39.5-131.6 83.8l0-85.3c0-48.4-36.1-89.3-84.1-95.3l-7.9-1C50.4 94.1 34.4 106.5 32.2 124s10.2 33.5 27.8 35.7l7.9 1c16 2 28 15.6 28 31.8L96 416c0 53 43 96 96 96l144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-56 0L416 339.2 416 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-163.2zM400 160a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM231.5 12.3c-2.6-7-12.4-7-15 0L205.8 41.1c-.8 2.2-2.5 3.9-4.7 4.7L172.3 56.5c-7 2.6-7 12.4 0 15l28.8 10.7c2.2 .8 3.9 2.5 4.7 4.7l10.7 28.8c2.6 7 12.4 7 15 0l10.7-28.8c.8-2.2 2.5-3.9 4.7-4.7l28.8-10.7c7-2.6 7-12.4 0-15L246.9 45.8c-2.2-.8-3.9-2.5-4.7-4.7L231.5 12.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCatSpace = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q8);
var G8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cauldron", f = 448, c = 512, e = [], t = "f6bf", o = "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5L32 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-15c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39l0 15c0 13.3 10.7 24 24 24s24-10.7 24-24l0-58.1c20.1-26.1 32-58.1 32-95.5c0-37.3-16.5-77.4-35.1-110.4l3.1 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0-144 0L80 160l-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l3.1 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCauldron = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G8);
var W8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = P2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCctv = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(W8);
var E8 = {}, j2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "link-horizontal", f = 640, c = 512, e = ["chain-horizontal"], t = "e1cb", o = "M144.6 64C64.7 64 0 128.7 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-44.5 36.1-80.6 80.6-80.6l158.8 0c44.5 0 80.6 36.1 80.6 80.6c0 39.4-28.5 73-67.4 79.5l-1.9 .3c-17.4 2.9-29.2 19.4-26.3 36.8s19.4 29.2 36.8 26.3l1.9-.3c69.7-11.6 120.8-72 120.8-142.6C448 128.7 383.3 64 303.4 64L144.6 64zM495.4 448C575.3 448 640 383.3 640 303.4c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 44.5-36.1 80.6-80.6 80.6l-158.8 0c-44.5 0-80.6-36.1-80.6-80.6c0-39.4 28.5-73 67.4-79.5l1.9-.3c17.4-2.9 29.2-19.4 26.3-36.8s-19.4-29.2-36.8-26.3l-1.9 .3C243.1 172.4 192 232.7 192 303.4C192 383.3 256.7 448 336.6 448l158.8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLinkHorizontal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = j2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChainHorizontal = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(E8);
var V8 = {}, B2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "link-horizontal-slash", f = 640, c = 512, e = ["chain-horizontal-slash"], t = "e1cc", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.7-44.4c39.6-25.8 65.9-70.5 65.9-121.3c0-70.7-51.1-131-120.8-142.6l-1.9-.3c-17.4-2.9-33.9 8.9-36.8 26.3s8.9 33.9 26.3 36.8l1.9 .3c38.9 6.5 67.4 40.1 67.4 79.5c0 36.6-24.4 67.6-57.9 77.4L415.3 300.2c20.5-25.1 32.7-57.1 32.7-91.6C448 128.7 383.3 64 303.4 64L144.6 64c-9.4 0-18.5 .9-27.4 2.6L38.8 5.1zM195.6 128l107.8 0c44.5 0 80.6 36.1 80.6 80.6c0 19.7-7.1 38-19.1 52.1L195.6 128zM446.8 448l-81.2-64-28.9 0c-44.5 0-80.6-36.1-80.6-80.6c0-1.9 .1-3.7 .2-5.5l-55.5-43.8c-5.6 15.4-8.6 32.1-8.6 49.3C192 383.3 256.7 448 336.6 448l110.2 0zM30.4 119.9C11.3 144.4 0 175.2 0 208.6c0 70.7 51.1 131 120.8 142.6l1.9 .3c17.4 2.9 33.9-8.9 36.8-26.3s-8.9-33.9-26.3-36.8l-1.9-.3C92.5 281.6 64 248 64 208.6c0-18.5 6.2-35.5 16.6-49.1L30.4 119.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLinkHorizontalSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = B2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChainHorizontalSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(V8);
var I8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chair-office", f = 448, c = 512, e = [], t = "f6c1", o = "M160 0L288 0c35.3 0 64 28.7 64 64l0 192L96 256 96 64c0-35.3 28.7-64 64-64zM64 160l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm384 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM51.4 305.7C56.8 294.8 67.9 288 80 288l288 0c12.1 0 23.2 6.8 28.6 17.7l16 32c5 9.9 4.4 21.7-1.4 31.1s-16.1 15.2-27.2 15.2l-128 0 0 64 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-64L64 384c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChairOffice = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I8);
var T2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "champagne-glass", f = 320, c = 512, e = ["glass-champagne"], t = "f79e", o = "M88 0C71.9 0 58.3 12 56.3 27.9L33.2 208C24.9 273.4 67.3 332.4 128 348l0 100-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0-100c60.7-15.6 103.1-74.6 94.8-140l-23-180.1C261.7 12 248.1 0 232 0L88 0zm20 128l8.2-64 87.7 0 8.2 64-104 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChampagneGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T2);
var K8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-bullet", f = 512, c = 512, e = [], t = "e0e1", o = "M264 32c13.3 0 24 10.7 24 24l0 8 176 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-176 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 224c-26.5 0-48-21.5-48-48l0-64C0 85.5 21.5 64 48 64l192 0 0-8c0-13.3 10.7-24 24-24zM160 128l0 32 80 0 0-32-80 0zm128 0l0 32 160 0 0-32-160 0zm48 256l0-32-80 0 0 32 80 0zm0 64L48 448c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l288 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 80 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-80 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8zm48-96l0 32 64 0 0-32-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartBullet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K8);
var X8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-candlestick", f = 512, c = 512, e = [], t = "e0e2", o = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l0-48zm64 176l0 64c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c-17.7 0-32 14.3-32 32zM160 128c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartCandlestick = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X8);
var Q8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-kanban", f = 448, c = 512, e = [], t = "e64f", o = "M320 432c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 352zM160 240c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 160zM48 416l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartKanban = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q8);
var J8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-line-down", f = 512, c = 512, e = [128201], t = "f64d", o = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm217.4 57.4L208 194.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0L304 189.3l57.4 57.4L329 279c-15.1 15.1-4.4 41 17 41L456 320c13.3 0 24-10.7 24-24l0-110.1c0-21.4-25.9-32.1-41-17l-32.4 32.4-80-80c-12.5-12.5-32.8-12.5-45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartLineDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J8);
var Y8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-line-up", f = 512, c = 512, e = [], t = "e0e5", o = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zM439 279c15.1 15.1 41 4.4 41-17L480 152c0-13.3-10.7-24-24-24l-110.1 0c-21.4 0-32.1 25.9-17 41l32.4 32.4L304 258.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 253.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80L439 279z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartLineUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y8);
var Z8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-line-up-down", f = 512, c = 512, e = [], t = "e5d7", o = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm313.4 57.4L288 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l112-112 18.7 18.7c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6l0-73.2 0-.3L480 80c0-8.8-7.2-16-16-16l-89.4 0C362.1 64 352 74.1 352 86.6c0 6 2.4 11.8 6.6 16l18.7 18.7zm64 141.3l-18.7 18.7-34.7-34.7-45.3 45.3 34.7 34.7-18.7 18.7c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6l89.4 0c8.8 0 16-7.2 16-16l0-89.4c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartLineUpDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z8);
var p8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-mixed-up-circle-currency", f = 576, c = 512, e = [], t = "e5d8", o = "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l28.8 0L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105l0 39c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112c0-17.7-14.3-32-32-32L400 0zM192 224c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L396.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartMixedUpCircleCurrency = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p8);
var x8 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-mixed-up-circle-dollar", f = 576, c = 512, e = [], t = "e5d9", o = "M400 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l28.8 0L319.4 151.5 211.2 70.4c-11.7-8.8-27.8-8.5-39.2 .6L12 199c-13.8 11-16 31.2-5 45s31.2 16 45 5L192.6 136.5l108.2 81.1c11.7 8.8 27.8 8.5 39.2-.6L480 105l0 39c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112c0-17.7-14.3-32-32-32L400 0zM192 224c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32zM64 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartMixedUpCircleDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x8);
var i5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-network", f = 640, c = 512, e = [], t = "f78a", o = "M288 64c0 13.7-4.3 26.3-11.6 36.7l29.2 62.5c9.8-2.1 20-3.2 30.4-3.2c36.1 0 69 13.3 94.3 35.2L512.4 135c-.2-2.3-.4-4.6-.4-7c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.2 0-17.9-1.9-25.8-5.4l-82 60.2c7.6 17.5 11.8 36.9 11.8 57.2c0 15.6-2.5 30.7-7.1 44.8l72 43.2c9.2-5.1 19.8-8 31.1-8c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64l0-1.1-72.1-43.3C413.7 431 376.8 448 336 448c-68.5 0-125.9-47.9-140.4-112l-76.1 0c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c23.7 0 44.4 12.9 55.4 32l76.1 0c7.5-33 26.3-61.6 52.1-81.7l-29.2-62.5C185.7 124.9 160 97.5 160 64c0-35.3 28.7-64 64-64s64 28.7 64 64zm48 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartNetwork = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i5);
var a5 = {}, F2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-pie-simple", f = 512, c = 512, e = ["chart-pie-alt"], t = "f64e", o = "M495.4 240L272 240l0-223.4c0-9 7-16.6 16-16.6C411.7 0 512 100.3 512 224c0 9-7.6 16-16.6 16zM190.2 37.2c18.1-3.8 33.8 11 33.8 29.5L224 288l221.3 0c18.5 0 33.3 15.7 29.5 33.8C451.9 430.5 355.5 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartPieSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = F2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChartPieAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(a5);
var e5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-pie-simple-circle-currency", f = 640, c = 512, e = [], t = "e604", o = "M496 192c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6L272 240l103.2 0c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80L224 288l0-221.3c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM521.4 393.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartPieSimpleCircleCurrency = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e5);
var n5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-pie-simple-circle-dollar", f = 640, c = 512, e = [], t = "e605", o = "M496 192c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-9 0-16 7.6-16 16.6L272 240l103.2 0c31.5-29.8 74-48 120.8-48zM320 368c0-28.8 6.9-56 19.2-80L224 288l0-221.3c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368zm320 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartPieSimpleCircleDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n5);
var f5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-pyramid", f = 512, c = 512, e = [], t = "e0e6", o = "M290.6 59.7c-15.4-26.5-53.7-26.5-69.1 0L163 160 349 160 290.6 59.7zM69.6 320l372.8 0L367.7 192l-223.4 0L69.6 320zM51 352L11.4 419.8C-4.2 446.5 15.1 480 45.9 480l420.1 0c30.9 0 50.1-33.5 34.6-60.2L461 352 51 352z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartPyramid = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f5);
var c5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-radar", f = 512, c = 512, e = [], t = "e0e7", o = "M72.5 252c-1.4 2.5-1.4 5.5 0 8l88.3 152.9c1.4 2.5 4.1 4 6.9 4l176.6 0c2.9 0 5.5-1.5 6.9-4L439.5 260l48.7 28.1L439.5 260c1.4-2.5 1.4-5.5 0-8L351.2 99.1c-1.4-2.5-4.1-4-6.9-4l-176.6 0c-2.9 0-5.5 1.5-6.9 4L72.5 252zM17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zM290.2 180.8l40.2 100.6c17.1 4.6 29.6 20.1 29.6 38.6c0 22.1-17.9 40-40 40c-15.9 0-29.7-9.3-36.1-22.7l-97.2-19.4c-7.1 6.3-16.4 10.2-26.7 10.2c-22.1 0-40-17.9-40-40s17.9-40 40-40l57.6-76.8c-1-3.6-1.6-7.3-1.6-11.2c0-22.1 17.9-40 40-40s40 17.9 40 40c0 7.6-2.1 14.7-5.8 20.8zM202 271.9l79.2 15.8-31.7-79.2L202 271.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartRadar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c5);
var t5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-scatter", f = 512, c = 512, e = [], t = "f7ee", o = "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartScatter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t5);
var o5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-scatter-3d", f = 512, c = 512, e = [], t = "e0e8", o = "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 209L43.5 423.4c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1L256 329.7 427.5 472.6c13.6 11.3 33.8 9.5 45.1-4.1s9.5-33.8-4.1-45.1L288 273l0-209zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartScatter3d = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o5);
var l5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-scatter-bubble", f = 512, c = 512, e = [], t = "e0e9", o = "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zm96 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM384 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartScatterBubble = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l5);
var d5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-simple-horizontal", f = 448, c = 512, e = [], t = "e474", o = "M400 320c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l352 0zM208 480c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 352c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l160 0zM384 112l0-32c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 32c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartSimpleHorizontal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d5);
var r5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-tree-map", f = 512, c = 512, e = [], t = "e0ea", o = "M0 80C0 53.5 21.5 32 48 32l128 0c26.5 0 48 21.5 48 48l0 112c0 26.5-21.5 48-48 48L48 240c-26.5 0-48-21.5-48-48L0 80zM0 320c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 112c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48L0 320zM304 32l160 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zM256 240c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-32zm48 112l160 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartTreeMap = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r5);
var H2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-user", f = 640, c = 512, e = ["user-chart"], t = "f6a3", o = "M160 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-11.8-25.5-29.9-47.5-52.4-64L576 352l0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-32zm252.7 75.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l88 0c8.8 0 16 7.2 16 16l0 88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM0 485.3C0 411.7 59.7 352 133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H2);
var s5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chart-waterfall", f = 512, c = 512, e = [], t = "e0eb", o = "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm128-64l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm64-96c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM480 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChartWaterfall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s5);
var h5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cheese-swiss", f = 512, c = 512, e = [129472], t = "f7f0", o = "M451 93c37.7 37.7 61 89.7 61 147.2l0 15.8-15.8 0L448 256 96 256l-80 0L0 256c0-5.4 .7-10.7 2.1-15.8c3.8-13.7 12.4-25.8 24.5-33.9L96 160l23.2-15.4c7.8-5.2 18.4-2.3 25.5 3.8C153.1 155.6 164 160 176 160c26.5 0 48-21.5 48-48c0-5.2-.8-10.2-2.3-14.9c-2.9-9-1.6-19.9 6.3-25.1l47-31.3c8.6-5.7 18.6-8.7 28.9-8.7c56 0 106.8 22.1 144.2 58c1 1 2 2 3 2.9zM432 288l16 0 48 0 16 0 0 16 0 112c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 304l0-16 16 0 80 0 208 0c8.8 0 15.7 7.4 18.6 15.7C329.1 322.5 347 336 368 336s38.9-13.5 45.4-32.3c2.9-8.4 9.8-15.7 18.6-15.7zM224 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCheeseSwiss = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h5);
var v5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = o2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCheeseburger = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(v5);
var u5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cherries", f = 640, c = 512, e = [], t = "e0ec", o = "M288 24L302.1 4.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0l0 .2-.1 .9c-.1 .9-.3 2.2-.6 4c-.6 3.6-1.5 9-2.9 15.8c-2.8 13.7-7.6 33.3-15.3 56.3c-14 42-37.4 94.7-75.8 143.7C152.3 233.5 126.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.5 0-38.9 4.3-54 9.7c27.1-42.6 45-85.1 56.7-120.2c5.7-17 9.9-32.3 13-45.1c11.7 10.8 25.8 24.7 40.1 41.2c29.6 34.3 59.1 78.4 73.1 128.5c-12-5.3-27-10.3-44.2-12.7C397.3 247.7 416 282.9 416 336c0 71.9-26.1 120.9-62.1 152.9C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.2 10.6-76.3 19.6C453.5 176 415.2 118.9 380.2 78.3c-19.9-23-39.2-41.3-53.6-53.9c-7.2-6.3-13.2-11.2-17.5-14.5c-2.1-1.7-3.8-3-5-3.9c-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L288 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCherries = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u5);
var m5 = {}, R2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chess-bishop-piece", f = 256, c = 512, e = ["chess-bishop-alt"], t = "f43b", o = "M104 32C90.7 32 80 42.7 80 56c0 12.2 9.1 22.3 20.9 23.8C79.6 100.1 48 139 48 192c0 26.3 13.6 40.5 26.3 48L72 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l5.7 0L64 384l128 0-13.7-96 5.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-2.3 0c12.7-7.5 26.3-21.7 26.3-48c0-22.5-5.7-42.4-13.9-59.5l-38.8 38.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L177 104.4c-7.4-10-15.2-18.2-21.9-24.6C166.9 78.3 176 68.2 176 56c0-13.3-10.7-24-24-24l-48 0zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChessBishopPiece = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = R2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChessBishopAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(m5);
var g5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chess-clock", f = 640, c = 512, e = [], t = "f43d", o = "M256 56c0-13.3-10.7-24-24-24L120 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 48-88 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-32 0 0-16c0-8.8-7.2-16-16-16L400 96c-8.8 0-16 7.2-16 16l0 16-184 0 0-48 32 0c13.3 0 24-10.7 24-24zM576 304a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zm-52.7-59.3c-6.2-6.2-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6zM176 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm-16 48l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChessClock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g5);
var P5 = {}, U2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chess-clock-flip", f = 640, c = 512, e = ["chess-clock-alt"], t = "f43e", o = "M384 56c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 48 88 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l32 0 0-16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 16 184 0 0-48-32 0c-13.3 0-24-10.7-24-24zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zm-52.7-59.3c6.2 6.2 6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l48-48c6.2-6.2 16.4-6.2 22.6 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm16-176l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChessClockFlip = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = U2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChessClockAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(P5);
var M5 = {}, q2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chess-king-piece", f = 256, c = 512, e = ["chess-king-alt"], t = "f440", o = "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L60.2 96C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208 72 208c-13.3 0-24 10.7-24 24s10.7 24 24 24l4 0L60 384l136 0L180 256l4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.8 0 32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChessKingPiece = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = q2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChessKingAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(M5);
var w5 = {}, G2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chess-knight-piece", f = 320, c = 512, e = ["chess-knight-alt"], t = "f442", o = "M57.6 102.4l-6.9 6.9c-12 12-18.7 28.3-18.7 45.3l0 81.2c0 10.7 5.3 20.7 14.2 26.6l3.5 2.4c12.7 8.5 29.1 9.5 42.8 2.7c2.3-1.1 4.5-2.5 6.5-4l38.8-29.1c5.5-4.1 13.1-4.1 18.6 0c8.2 6.1 8.3 18.4 .2 24.7L81 317c-20.8 16-33 40.7-33 67l224 0 26.9-107.6c3.4-13.6 5.1-27.5 5.1-41.5c0-94.4-76.5-171-171-171L47.8 64C39.1 64 32 71.1 32 79.8c0 6 3.4 11.5 8.7 14.2l16.9 8.4zm19.2 54.4a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L272 416 48 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChessKnightPiece = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = G2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChessKnightAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(w5);
var N5 = {}, W2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chess-pawn-piece", f = 256, c = 512, e = ["chess-pawn-alt"], t = "f444", o = "M176 240c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l5.7 0L64 384l128 0-13.7-96 5.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0zM4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416 48 416 4.8 473.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChessPawnPiece = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = W2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChessPawnAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(N5);
var z5 = {}, E2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chess-queen-piece", f = 256, c = 512, e = ["chess-queen-alt"], t = "f446", o = "M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM229.9 124.9l-41.5 67.5c11.2 2.1 19.6 11.8 19.6 23.6c0 13.3-10.7 24-24 24l-8 0 19.6 144L60.4 384 80 240l-8 0c-13.3 0-24-10.7-24-24c0-11.8 8.5-21.5 19.6-23.6L26.1 124.9c-3.7-6-3-13.6 1.6-18.9s12.1-6.9 18.6-4.1c3 1.3 6.3 2.1 9.8 2.1c11.8 0 21.6-8.5 23.6-19.7c1.1-6.3 6-11.4 12.3-12.8s12.8 1.1 16.5 6.4C112.8 84 119.9 88 128 88s15.2-4 19.6-10.1c3.7-5.3 10.2-7.8 16.5-6.4s11.1 6.4 12.3 12.8c2 11.2 11.8 19.7 23.6 19.7c3.5 0 6.8-.7 9.8-2.1c6.4-2.9 13.9-1.2 18.6 4.1s5.3 13 1.6 18.9zM208 416l43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4c0 13.3-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24c0-5.2 1.7-10.2 4.8-14.4L48 416l160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChessQueenPiece = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = E2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChessQueenAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(z5);
var L5 = {}, V2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chess-rook-piece", f = 320, c = 512, e = ["chess-rook-alt"], t = "f448", o = "M67.4 384L80 264 49.4 233.4c-6-6-9.4-14.1-9.4-22.6L40 112c0-8.8 7.2-16 16-16l24 0c8.8 0 16 7.2 16 16l0 24c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-24c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 24c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-24c0-8.8 7.2-16 16-16l24 0c8.8 0 16 7.2 16 16l0 98.7c0 8.5-3.4 16.6-9.4 22.6L240 264l12.6 120L67.4 384zM136 280.9c0 3.9 3.2 7.1 7.1 7.1l33.8 0c3.9 0 7.1-3.2 7.1-7.1l0-32.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32.9zM20.8 473.6L64 416l192 0 43.2 57.6c3.1 4.2 4.8 9.2 4.8 14.4c0 13.3-10.7 24-24 24L40 512c-13.3 0-24-10.7-24-24c0-5.2 1.7-10.2 4.8-14.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChessRookPiece = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = V2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChessRookAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(L5);
var C5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chestnut", f = 448, c = 512, e = [127792], t = "e3f6", o = "M224 32c5.3 0 10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c7.5 6.8 16.7 14.3 27.2 22.8l3.1 2.5s0 0 0 0c20.3 16.4 44.7 36.1 68.2 59.6C400.8 190.2 448 258 448 352L0 352c0-94 47.2-161.8 96.7-211.3c23.5-23.5 47.9-43.2 68.2-59.6l3.1-2.5c10.6-8.5 19.7-16 27.2-22.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1zM4 384L444 384c-14.2 55.2-64.3 96-124 96l-192 0C68.4 480 18.2 439.2 4 384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChestnut = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C5);
var D5 = {}, I2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chevrons-down", f = 512, c = 512, e = ["chevron-double-down"], t = "f322", o = "M278.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 402.7 425.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192zm192-384l-192 192c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 210.7 425.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChevronsDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = I2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChevronDoubleDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(D5);
var $5 = {}, K2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chevrons-left", f = 512, c = 512, e = ["chevron-double-left"], t = "f323", o = "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192l-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChevronsLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = K2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChevronDoubleLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})($5);
var _5 = {}, X2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chevrons-right", f = 512, c = 512, e = ["chevron-double-right"], t = "f324", o = "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 233.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l192-192zm-384 192l192-192c12.5-12.5 12.5-32.8 0-45.3l-192-192c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChevronsRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = X2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChevronDoubleRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_5);
var b5 = {}, Q2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chevrons-up", f = 512, c = 512, e = ["chevron-double-up"], t = "f325", o = "M278.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3 425.4 278.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-192-192zm192 384l-192-192c-12.5-12.5-32.8-12.5-45.3 0l-192 192c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3 425.4 470.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChevronsUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Q2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChevronDoubleUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(b5);
var S5 = {}, J2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-chevron-down", f = 448, c = 512, e = ["chevron-square-down"], t = "f329", o = "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM207 345L103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareChevronDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = J2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChevronSquareDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(S5);
var y5 = {}, Y2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-chevron-left", f = 448, c = 512, e = ["chevron-square-left"], t = "f32a", o = "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM135 239L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareChevronLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Y2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChevronSquareLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(y5);
var O5 = {}, Z2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-chevron-right", f = 448, c = 512, e = ["chevron-square-right"], t = "f32b", o = "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM313 273L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareChevronRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Z2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChevronSquareRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(O5);
var k5 = {}, p2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-chevron-up", f = 448, c = 512, e = ["chevron-square-up"], t = "f32c", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM241 167L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareChevronUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p2);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = p2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChevronSquareUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(k5);
var A5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chf-sign", f = 640, c = 512, e = [], t = "e602", o = "M0 113.4C0 68.5 36.5 32 81.4 32c30.8 0 59 17.4 72.8 45l2.3 4.7c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L97 105.6c-3-5.9-9-9.6-15.6-9.6C71.8 96 64 103.8 64 113.4l0 285.1c0 9.6 7.8 17.4 17.4 17.4c6.6 0 12.6-3.7 15.6-9.6l2.3-4.7c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.3 4.7c-13.8 27.6-42 45-72.8 45C36.5 480 0 443.5 0 398.6L0 113.4zM224 32c17.7 0 32 14.3 32 32l0 160 96 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160-96 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32zM448 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 128 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChfSign = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A5);
var j5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chimney", f = 448, c = 512, e = [], t = "f78b", o = "M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L32 160c-17.7 0-32-14.3-32-32L0 64zM32 192l96 0 0 128-96 0 0-128zm384 0l0 128-256 0 0-128 256 0zM288 352l0 128L32 480l0-128 256 0zm128 0l0 128-96 0 0-128 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChimney = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j5);
var B5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = C2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faChocolateBar = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(B5);
var T5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "chopsticks", f = 640, c = 512, e = [], t = "e3f7", o = "M368 0c-15.3 0-29 7.2-37.7 18.3L3.4 486.1c-5.5 6.9-4.3 17 2.7 22.5s17 4.2 22.5-2.7L405.7 77.7C412.2 69.5 416 59.2 416 48c0-26.5-21.5-48-48-48zM131.9 506.4c5.8 6.7 15.9 7.5 22.6 1.7L623.2 148.4c10.3-8.8 16.8-21.9 16.8-36.4c0-26.5-21.5-48-48-48c-11.9 0-22.8 4.4-31.2 11.6L133.6 483.9c-6.7 5.8-7.5 15.8-1.7 22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faChopsticks = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T5);
var F5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-0", f = 512, c = 512, e = [], t = "e0ed", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c53 0 96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64c0-53 43-96 96-96zm-48 96l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle0 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F5);
var H5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-1", f = 512, c = 512, e = [], t = "e0ee", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 131.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L232 193.4 232 336l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-184c0-8.6-4.6-16.5-12-20.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle1 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H5);
var R5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-2", f = 512, c = 512, e = [], t = "e0ef", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 184.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L244.7 336l83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L276.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle2 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R5);
var U5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-3", f = 512, c = 512, e = [], t = "e0f0", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L240 384c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L250.3 176 184 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle3 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U5);
var q5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-4", f = 512, c = 512, e = [], t = "e0f1", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM223.6 129.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l104 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-70.7 0 37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q5);
var G5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-5", f = 512, c = 512, e = [], t = "e0f2", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle5 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G5);
var W5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-6", f = 512, c = 512, e = [], t = "e0f3", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-16a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C174.2 224.8 160 255.6 160 288z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle6 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W5);
var E5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-7", f = 512, c = 512, e = [], t = "e0f4", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l144 0c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6L184 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle7 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E5);
var V5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-8", f = 512, c = 512, e = [], t = "e0f5", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0l-16 0s0 0 0 0zm16 48l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0 16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle8 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V5);
var I5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-9", f = 512, c = 512, e = [], t = "e0f6", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C337.8 287.2 352 256.4 352 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircle9 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I5);
var K5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-a", f = 512, c = 512, e = [], t = "e0f7", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L321.2 320l-130.3 0-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L214.8 272l82.3 0L256 189.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleA = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K5);
var X5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-ampersand", f = 512, c = 512, e = [], t = "e0f8", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 191.6c0 4.1 1.6 8.1 4.6 11L235 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2l-19.2 0c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L361 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4l-32.2 0c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6l19.2 0c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5l32.2 0c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleAmpersand = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X5);
var Q5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-arrow-down-left", f = 512, c = 512, e = [], t = "e0f9", o = "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm64-144c13.3 0 24-10.7 24-24s-10.7-24-24-24l-94.1 0L361 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135L192 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24l152 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleArrowDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q5);
var J5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-arrow-down-right", f = 512, c = 512, e = [], t = "e0fa", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM192 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l94.1 0L151 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135L320 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24l-152 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleArrowDownRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J5);
var Y5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-arrow-up-left", f = 512, c = 512, e = [], t = "e0fb", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm64-368c13.3 0 24 10.7 24 24s-10.7 24-24 24l-94.1 0L377 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-151-151L192 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160c0-13.3 10.7-24 24-24l152 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleArrowUpLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y5);
var Z5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-arrow-up-right", f = 512, c = 512, e = [], t = "e0fc", o = "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L184 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l160 0c13.3 0 24 10.7 24 24l0 152z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleArrowUpRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z5);
var p5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-b", f = 512, c = 512, e = [], t = "e0fd", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24l92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C356.3 261.6 368 283.4 368 308c0 42-34 76-76 76l-108 0c-13.3 0-24-10.7-24-24l0-104 0-104zm144 52c0-15.5-12.5-28-28-28l-68 0 0 56 68 0c15.5 0 28-12.5 28-28zM208 336l84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0 0 56z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleB = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p5);
var x5 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-bolt", f = 512, c = 512, e = [], t = "e0fe", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm74.1-396.4c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272 160 272c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x5);
var i7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-c", f = 512, c = 512, e = [], t = "e101", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleC = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i7);
var a7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-d", f = 512, c = 512, e = [], t = "e104", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm72 208c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleD = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a7);
var e7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-dashed", f = 512, c = 512, e = [], t = "e105", o = "M1.1 232C6 179.3 26.9 131.3 58.8 92.7l45.5 45.5C83.7 164.8 69.9 196.9 65.5 232L1.1 232zM138.3 104.3L92.7 58.8C131.3 26.9 179.3 6 232 1.1l0 64.4c-35.1 4.4-67.2 18.2-93.7 38.8zM280 446.5c35.1-4.4 67.2-18.2 93.7-38.8l45.5 45.5C380.7 485.1 332.7 506 280 510.9l0-64.4zm127.7-72.8c20.6-26.6 34.5-58.7 38.8-93.7l64.4 0c-4.9 52.7-25.8 100.7-57.7 139.3l-45.5-45.5zM92.7 453.2l45.5-45.5c26.6 20.6 58.7 34.5 93.7 38.8l0 64.4c-52.7-4.9-100.7-25.8-139.3-57.7zM58.8 419.3C26.9 380.7 6 332.7 1.1 280l64.4 0c4.4 35.1 18.2 67.2 38.8 93.7L58.8 419.3zM419.3 58.8l-45.5 45.5C347.2 83.7 315.1 69.9 280 65.5l0-64.4C332.7 6 380.7 26.9 419.3 58.8zm-11.6 79.5l45.5-45.5c31.9 38.5 52.8 86.6 57.7 139.3l-64.4 0c-4.4-35.1-18.2-67.2-38.8-93.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleDashed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e7);
var n7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-divide", f = 512, c = 512, e = [], t = "e106", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleDivide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n7);
var v = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-dollar", f = 512, c = 512, e = ["dollar-circle", "usd-circle"], t = "f2e8", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm20.8-378.4l0 14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7l0-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v);
var f7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-down-left", f = 512, c = 512, e = [], t = "e107", o = "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 198.6L160 336c0 8.8 7.2 16 16 16l137.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L296 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C322 146 317.1 144 312 144s-10 2-13.7 5.7L232 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f7);
var c7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-down-right", f = 512, c = 512, e = [], t = "e108", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 198.6L352 336c0 8.8-7.2 16-16 16l-137.4 0c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L216 280l-66.3-66.3C146 210 144 205.1 144 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L280 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleDownRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c7);
var t7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-e", f = 512, c = 512, e = [], t = "e109", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 56 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 56 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-104 0-104c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleE = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t7);
var o7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-ellipsis", f = 512, c = 512, e = [], t = "e10a", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleEllipsis = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o7);
var l7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-ellipsis-vertical", f = 512, c = 512, e = [], t = "e10b", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleEllipsisVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l7);
var x2 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-envelope", f = 512, c = 512, e = ["envelope-circle"], t = "e10c", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 9.3L264.7 255.6c-2.7 1.2-5.7 1.9-8.7 1.9s-5.9-.6-8.7-1.9L128 201.3l0-9.3zm149.9 92.7L384 236.5l0 83.5c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-83.5 106.1 48.3c6.9 3.1 14.3 4.8 21.9 4.8s15-1.6 21.9-4.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleEnvelope = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x2);
var d7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-euro", f = 512, c = 512, e = [], t = "e5ce", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 272l16 0c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8L128 240c-8.8 0-16-7.2-16-16s7.2-16 16-16l24.7 0c19.2-46.9 65.4-80 119.2-80l41.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.1 0c-26.3 0-49.6 12.6-64.4 32l80.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-95.1 0c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2l95.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-81.6 0c14.7 20.3 38.5 33.5 65.5 33.5l41.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.1 0c-54.4 0-101-33.8-119.8-81.5L128 304c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleEuro = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d7);
var r7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-exclamation-check", f = 640, c = 512, e = [], t = "e10d", o = "M506.5 203L480 229.5l-18.7-18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5l64 64c11.9 11.9 27.4 18.2 43 18.7c-44.3 76.5-127 128-221.8 128C114.6 512 0 397.4 0 256S114.6 0 256 0C379.2 0 482.1 87 506.5 203zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM625 209L497 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleExclamationCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r7);
var s7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-f", f = 512, c = 512, e = [], t = "e10e", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleF = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s7);
var h7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-g", f = 512, c = 512, e = [], t = "e10f", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L280 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleG = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h7);
var v7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-gf", f = 512, c = 512, e = [], t = "e67f", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24s-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0c13.3 0 24 10.7 24 24l0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112c0-39.8 32.2-72 72-72zm104 24c0-13.3 10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 64 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleGf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v7);
var u7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-half", f = 512, c = 512, e = [], t = "e110", o = "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256S97.8 494.3 224.1 510c17.5 2.2 31.9-12.4 31.9-30l0-448z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleHalf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u7);
var i1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-heart", f = 512, c = 512, e = ["heart-circle"], t = "f4c7", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L278.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L131.9 280.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i1);
var m7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-i", f = 512, c = 512, e = [], t = "e111", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 160 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-160-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleI = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m7);
var g7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-j", f = 512, c = 512, e = [], t = "e112", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360l0 136c0 53-43 96-96 96s-96-43-96-96l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleJ = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g7);
var P7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-k", f = 512, c = 512, e = [], t = "e113", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.1-343.2l-73.1 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L238 277.8l-30 30.5 0 51.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-61.5L160 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 87.8L310.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleK = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P7);
var M7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-l", f = 512, c = 512, e = [], t = "e114", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152l0 184 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleL = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M7);
var a1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-location-arrow", f = 512, c = 512, e = ["location-circle"], t = "f602", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM358.2 182.7l-84 196c-3.5 8.1-11.4 13.3-20.2 13.3c-1.4 0-2.9-.1-4.4-.4C239.4 389.5 232 380.4 232 370l0-90-90 0c-10.4 0-19.5-7.4-21.5-17.6c-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7c6.4 6.3 8.2 15.9 4.7 24.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleLocationArrow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a1);
var w7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-m", f = 512, c = 512, e = [], t = "e115", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.5 137.9L256 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-133.8-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L176 226.2 176 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleM = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w7);
var e1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-microphone", f = 512, c = 512, e = ["microphone-circle"], t = "e116", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112zm-64 80c8.8 0 16 7.2 16 16l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 65.3-48.9 119.1-112 127l0 17c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17c-63.1-7.9-112-61.7-112-127l0-16c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleMicrophone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e1);
var n1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-microphone-lines", f = 512, c = 512, e = ["microphone-circle-alt"], t = "e117", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96c-26.5 0-48 21.5-48 48l0 112c0 26.5 21.5 48 48 48s48-21.5 48-48l0-16-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c0-26.5-21.5-48-48-48zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 65.3 48.9 119.1 112 127l0 17c0 8.8 7.2 16 16 16s16-7.2 16-16l0-17c63.1-7.9 112-61.7 112-127l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c0 53-43 96-96 96s-96-43-96-96l0-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleMicrophoneLines = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n1);
var N7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-n", f = 512, c = 512, e = [], t = "e118", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.7 138.3L304 283.2 304 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 10.5-6.8 19.8-16.8 22.9s-20.9-.6-26.9-9.2L208 228.8 208 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.5 6.8-19.8 16.8-22.9s20.9 .6 26.9 9.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleN = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N7);
var z7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-o", f = 512, c = 512, e = [], t = "e119", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleO = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z7);
var L7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-p", f = 512, c = 512, e = [], t = "e11a", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-136c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88 68 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleP = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L7);
var f1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-parking", f = 512, c = 512, e = ["parking-circle"], t = "f615", o = "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm232 0l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64zm48 64l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-120c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96s-43 96-96 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleParking = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f1);
var c1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-phone", f = 512, c = 512, e = ["phone-circle"], t = "e11b", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.7 128.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L200 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C368.9 378 361 384 352 384c-123.7 0-224-100.3-224-224c0-9 6-16.9 14.7-19.3l44-12z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCirclePhone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c1);
var t1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-phone-flip", f = 512, c = 512, e = ["phone-circle-alt"], t = "e11c", o = "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm69.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L312 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C143.1 378 151 384 160 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCirclePhoneFlip = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t1);
var o1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-phone-hangup", f = 512, c = 512, e = ["phone-circle-down"], t = "e11d", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM391.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L98.8 274.8c-4.8-7.8-3.4-17.5 3.4-23.8c84.9-78.6 222.6-78.6 307.5 0c6.8 6.3 8.2 16.1 3.4 23.8L391.4 310z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCirclePhoneHangup = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o1);
var C7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-q", f = 512, c = 512, e = [], t = "e11e", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L377 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleQ = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C7);
var D7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-quarter", f = 512, c = 512, e = [], t = "e11f", o = "M32 256C14.3 256-.2 241.6 2 224.1C16.4 108.2 108.2 16.4 224.1 2C241.6-.2 256 14.3 256 32l0 192c0 17.7-14.3 32-32 32L32 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleQuarter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D7);
var $7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-quarter-stroke", f = 512, c = 512, e = [], t = "e5d3", o = "M64 256l160 0c17.7 0 32-14.3 32-32l0-160c106 0 192 86 192 192s-86 192-192 192S64 362 64 256zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleQuarterStroke = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($7);
var _7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-quarters", f = 512, c = 512, e = [], t = "e3f8", o = "M120.2 391.8L256 256 391.8 391.8C426.5 357 448 309 448 256s-21.5-101-56.2-135.8L256 256 120.2 120.2C85.5 155 64 203 64 256s21.5 101 56.2 135.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleQuarters = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_7);
var b7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-r", f = 512, c = 512, e = [], t = "e120", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l104 0c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L252 288l-44 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112c0-13.3 10.7-24 24-24zm80 112l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64 56 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleR = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b7);
var S7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-s", f = 512, c = 512, e = [], t = "e121", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleS = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S7);
var y7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-small", f = 320, c = 512, e = [], t = "e122", o = "M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleSmall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y7);
var l1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-sort", f = 512, c = 512, e = ["sort-circle"], t = "e030", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l192 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-192 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleSort = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l1);
var d1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-sort-down", f = 512, c = 512, e = ["sort-circle-down"], t = "e031", o = "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM267.3 411.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zm0-310.6l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zM313.4 192L256 134.6 198.6 192l114.7 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleSortDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d1);
var r1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-sort-up", f = 512, c = 512, e = ["sort-circle-up"], t = "e032", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l192 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zm0 310.6l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-192 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0zM313.4 320L256 377.4 198.6 320l114.7 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleSortUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r1);
var s1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-star", f = 512, c = 512, e = ["star-circle"], t = "e123", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 104c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L256 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleStar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s1);
var O7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-sterling", f = 512, c = 512, e = [], t = "e5cf", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm5.5-352c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5 40.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40.3 0 .1 9.7c.1 18.6-3.1 37-9.6 54.3L328 320c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1-7.7 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l7.5 0-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleSterling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O7);
var k7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-t", f = 512, c = 512, e = [], t = "e124", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144l104 0 104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleT = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k7);
var A7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-three-quarters", f = 512, c = 512, e = [], t = "e125", o = "M256 32c0-17.7-14.4-32.2-31.9-30C97.8 17.7 0 125.4 0 256C0 397.4 114.6 512 256 512c130.6 0 238.3-97.8 254-224.1c2.2-17.5-12.4-31.9-30-31.9H256V32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleThreeQuarters = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A7);
var j7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-three-quarters-stroke", f = 512, c = 512, e = [], t = "e5d4", o = "M256 64l0 160c0 17.7 14.3 32 32 32l160 0c0-106-86-192-192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleThreeQuartersStroke = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j7);
var h1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-trash", f = 512, c = 512, e = ["trash-circle"], t = "e126", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128l41.4 0 11.3-11.3c3-3 7.1-4.7 11.3-4.7l64 0c4.2 0 8.3 1.7 11.3 4.7L310.6 128l41.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l192 0L338.4 354.7c-1.4 16.6-15.2 29.3-31.9 29.3l-101.1 0c-16.6 0-30.5-12.8-31.9-29.3L160 192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleTrash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h1);
var B7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-u", f = 512, c = 512, e = [], t = "e127", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleU = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B7);
var T7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-up-left", f = 512, c = 512, e = [], t = "e128", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 313.4L160 176c0-8.8 7.2-16 16-16l137.4 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L296 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C322 366 317.1 368 312 368s-10-2-13.7-5.7L232 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleUpLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T7);
var F7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-up-right", f = 512, c = 512, e = [], t = "e129", o = "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 313.4L352 176c0-8.8-7.2-16-16-16l-137.4 0c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L216 232l-66.3 66.3C146 302 144 306.9 144 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L280 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleUpRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F7);
var H7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-v", f = 512, c = 512, e = [], t = "e12a", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM173.5 157.3L256 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleV = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H7);
var v1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-video", f = 512, c = 512, e = ["video-circle"], t = "e12b", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 192c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128zM396.9 317.9L352 288l0-64 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleVideo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v1);
var R7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-w", f = 512, c = 512, e = [], t = "e12c", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM150.9 168.7L192 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L320 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L256 254.7 214.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleW = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R7);
var u1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-waveform-lines", f = 512, c = 512, e = ["waveform-circle"], t = "e12d", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-368l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zM160 176l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-8.8 7.2-16 16-16s16 7.2 16 16zM224 216l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleWaveformLines = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u1);
var U7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-wifi", f = 512, c = 512, e = [], t = "e67d", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM127.5 241.3c-9.8 8.9-25 8.1-33.9-1.8s-8.1-25 1.8-33.9C137.9 167.3 194.3 144 256 144s118.1 23.3 160.6 61.6c9.8 8.9 10.6 24 1.8 33.9s-24 10.6-33.9 1.8c-34-30.7-79-49.3-128.5-49.3s-94.4 18.6-128.5 49.3zM256 336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-48c-22.7 0-43.4 8.6-59 22.7c-9.8 8.9-25 8.1-33.9-1.7s-8.1-25 1.7-33.9C188.9 253.3 220.9 240 256 240s67.1 13.3 91.2 35.1c9.8 8.9 10.6 24.1 1.7 33.9s-24.1 10.6-33.9 1.7c-15.6-14.1-36.3-22.7-59-22.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleWifi = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U7);
var m1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-wifi-circle-wifi", f = 640, c = 512, e = ["circle-wifi-group"], t = "e67e", o = "M256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-17.9 2.7-35.1 7.6-51.4c-4.5-.7-8.9-2.6-12.6-5.9c-15.6-14.1-36.3-22.7-59-22.7s-43.4 8.6-59 22.7c-9.8 8.9-25 8.1-33.9-1.7s-8.1-25 1.7-33.9C188.9 253.3 220.9 240 256 240c34.8 0 66.7 13.1 90.7 34.7c8.9-14.2 19.8-27.1 32.2-38.2C345.7 208.7 302.8 192 256 192c-49.4 0-94.4 18.6-128.5 49.3c-9.8 8.9-25 8.1-33.9-1.8s-8.1-25 1.8-33.9C137.9 167.3 194.3 144 256 144s118.1 23.3 160.6 61.6c1.2 1.1 2.3 2.3 3.3 3.6c23-11.1 48.8-17.3 76.1-17.3c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zm0-176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm384 32a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320c-27.2 0-51.9 10.2-70.6 27.1c-6.6 5.9-16.7 5.4-22.6-1.2s-5.4-16.7 1.2-22.6c24.4-21.9 56.6-35.3 92-35.3s67.7 13.4 92 35.3c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2C547.9 330.2 523.2 320 496 320zM476 432a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm-11.5-35.9c-6.6 5.9-16.7 5.4-22.6-1.1s-5.4-16.7 1.1-22.6c14-12.7 32.6-20.4 53-20.4s39 7.7 53 20.4c6.6 5.9 7.1 16 1.1 22.6s-16 7.1-22.6 1.1c-8.3-7.5-19.4-12.1-31.5-12.1s-23.2 4.6-31.5 12.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleWifiCircleWifi = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m1);
var q7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = m1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCircleWifiGroup = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(q7);
var G7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-x", f = 512, c = 512, e = [], t = "e12e", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.3 136.5L256 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L287.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L256 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L224.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleX = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G7);
var W7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-y", f = 512, c = 512, e = [], t = "e12f", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM170.1 152.3L256 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L280 297l0 79c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-79L133.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleY = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W7);
var E7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-yen", f = 512, c = 512, e = [], t = "e5d0", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.9 150.2c9.8-8.9 25-8.2 33.9 1.6L256 220.3l62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256l31.6 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0 0 32 40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0 0 25c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25-40 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l40 0 0-32-40 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l31.6 0-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleYen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E7);
var V7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circle-z", f = 512, c = 512, e = [], t = "e130", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128l144 0c8.9 0 17.1 5 21.3 12.9s3.6 17.5-1.5 24.8L229.8 336l98.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-8.9 0-17.1-5-21.3-12.9s-3.6-17.5 1.5-24.8L282.2 176 184 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCircleZ = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V7);
var I7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "circles-overlap", f = 640, c = 512, e = [], t = "e600", o = "M192 288c0 34.2 7.7 66.6 21.4 95.7C130 378.2 64 308.8 64 224c0-88.4 71.6-160 160-160c32.2 0 62.2 9.5 87.3 25.9C240.4 127.5 192 202.1 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224S100.3 448 224 448zm192 0c-32.2 0-62.2-9.5-87.3-25.9C399.6 384.5 448 309.9 448 224c0-34.2-7.7-66.6-21.4-95.7C510 133.8 576 203.2 576 288c0 88.4-71.6 160-160 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCirclesOverlap = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I7);
var K7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "citrus", f = 512, c = 512, e = [], t = "e2f4", o = "M304 128l80 0c53 0 96-43 96-96l0-16c0-8.8-7.2-16-16-16L384 0c-53 0-96 43-96 96l0 16c0 8.8 7.2 16 16 16zM256 96c0-23.1 6.1-44.7 16.8-63.4c-5.5-.4-11.1-.6-16.8-.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7C435 152 410.4 160 384 160l-80 0c-26.5 0-48-21.5-48-48l0-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCitrus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K7);
var X7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "citrus-slice", f = 512, c = 512, e = [], t = "e2f5", o = "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zm116.3 32.9c9.6 2.7 18.8-4.9 18.8-14.9l0-144.5c0-6.2-4.3-11.5-10-14c-5.9-2.6-13-2.1-17.6 2.5L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4c27.1 27.1 59.6 45.5 94 55.2zM250.5 166c2.5 5.7 7.8 10 14 10L409 176c10 0 17.6-9.1 14.9-18.8C414.2 123 396 90.6 369.1 63.6l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L253 148.4c-4.6 4.6-5.2 11.7-2.5 17.6zm.6 50.5c-2 4.9-1.4 10.6 2.4 14.3l114 114c6.6 6.6 17.4 6.2 22.9-1.3c26.2-35.8 40.1-77.8 41.5-120.1c.3-8.6-6.8-15.4-15.4-15.4L263 208c-5.3 0-9.8 3.7-11.8 8.5zm-34.6 34.6c-4.9 2-8.5 6.5-8.5 11.8l0 153.5c0 8.6 6.8 15.7 15.4 15.4c42.4-1.4 84.4-15.3 120.1-41.5c7.5-5.5 7.9-16.3 1.3-22.9l-114-114c-3.7-3.7-9.4-4.4-14.3-2.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCitrusSlice = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X7);
var Q7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clapperboard-play", f = 512, c = 512, e = [], t = "e132", o = "M453.8 32.3L327 159l-1 1-92.1 0L361 33l1-1L448 32c2 0 3.9 .1 5.8 .3zM393.9 160L498 56c8.8 11 14 24.9 14 40l0 64-118.1 0zM201.9 32l92.1 0L167 159l-1 1-92.1 0L201 33l1-1zm-67.9 0L7 159l-1 1L0 160 0 96C0 60.7 28.7 32 64 32l70.1 0zM0 192l512 0 0 224c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192zm216.5 65.9c-5.2 2.8-8.5 8.2-8.5 14.1l0 128c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l96-64c4.4-3 7.1-8 7.1-13.3s-2.7-10.3-7.1-13.3l-96-64c-4.9-3.3-11.2-3.6-16.4-.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClapperboardPlay = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q7);
var J7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clarinet", f = 640, c = 512, e = [], t = "f8ad", o = "M224 144c0-8.8 7.2-16 16-16l32 0 96 0 96 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 32 76.6 0c9.5 0 18.7-2.8 26.6-8.1l31.9-21.3c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1l0 192c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8l-31.9-21.3c-7.9-5.3-17.1-8.1-26.6-8.1l-448.3 0c-10.2 0-20.3-1.9-29.7-5.7L10.1 318.9C4 316.4 0 310.5 0 304l0-64c0-6.5 4-12.4 10.1-14.9l68.6-27.4c9.4-3.8 19.5-5.7 29.7-5.7L256 192l0-32-16 0c-8.8 0-16-7.2-16-16zm224 16l-64 0 0 32 64 0 0-32zm-96 0l-64 0 0 32 64 0 0-32zM272 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClarinet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J7);
var Y7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "claw-marks", f = 576, c = 512, e = [], t = "f6c2", o = "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4l96 96 64 64 160 160 64 64 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L434.7 448 384 448c-17.7 0-32-14.3-32-32l0-50.7L210.7 224 160 224c-17.7 0-32-14.3-32-32l0-50.7L41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm0 224c12.5-12.5 32.8-12.5 45.3 0l64 64 96 96 64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L210.7 448 128 448c-17.7 0-32-14.3-32-32l0-82.7L41.4 278.6c-12.5-12.5-12.5-32.8 0-45.3zM310.6 9.4l32 32 64 64 64 64 64 64 32 32c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L498.7 288 448 288c-17.7 0-32-14.3-32-32l0-50.7L370.7 160 320 160c-17.7 0-32-14.3-32-32l0-50.7L265.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClawMarks = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y7);
var Z7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clipboard-list-check", f = 384, c = 512, e = [], t = "f737", o = "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-4.7 132.7c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 249.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0zM192 272c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm-16 80l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClipboardListCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z7);
var p7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clipboard-medical", f = 384, c = 512, e = [], t = "e133", o = "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClipboardMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p7);
var x7 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clipboard-prescription", f = 384, c = 512, e = [], t = "f5e8", o = "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 196l72 0c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6l-20 0 0 44c0 11-9 20-20 20s-20-9-20-20l0-64 0-80c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20l-52 0 0 40 52 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClipboardPrescription = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x7);
var it = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-desk", f = 448, c = 512, e = [], t = "e134", o = "M0 224a224 224 0 1 1 448 0A224 224 0 1 1 0 224zM224 96c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 0-94.1c0-13.3-10.7-24-24-24zm0 384c96.4 0 180.3-53.3 224-132l0 116c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 348c43.7 78.7 127.6 132 224 132z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockDesk = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(it);
var at = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-eight", f = 512, c = 512, e = [], t = "e345", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 136c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2 232 120c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockEight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(at);
var et = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-eight-thirty", f = 512, c = 512, e = [], t = "e346", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-91.2L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockEightThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(et);
var nt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-eleven", f = 512, c = 512, e = [], t = "e347", o = "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 56.7-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockEleven = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nt);
var ft = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-eleven-thirty", f = 512, c = 512, e = [], t = "e348", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-128.7-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockElevenThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ft);
var ct = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-five", f = 512, c = 512, e = [], t = "e349", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 128.7 60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockFive = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ct);
var tt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-five-thirty", f = 512, c = 512, e = [], t = "e34a", o = "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-56.7 20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockFiveThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tt);
var ot = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-four-thirty", f = 512, c = 512, e = [], t = "e34b", o = "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-91.2L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockFourThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ot);
var lt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-nine", f = 512, c = 512, e = [], t = "e34c", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 136c0 13.3-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockNine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lt);
var dt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-nine-thirty", f = 512, c = 512, e = [], t = "e34d", o = "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-136c0-13.3-10.7-24-24-24l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 112c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockNineThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dt);
var rt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-one", f = 512, c = 512, e = [], t = "e34e", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 56.7 20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockOne = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rt);
var st = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-one-thirty", f = 512, c = 512, e = [], t = "e34f", o = "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-128.7 60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockOneThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(st);
var ht = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-seven", f = 512, c = 512, e = [], t = "e350", o = "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 128.7-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockSeven = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ht);
var vt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-seven-thirty", f = 512, c = 512, e = [], t = "e351", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-56.7-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockSevenThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vt);
var ut = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-six", f = 512, c = 512, e = [], t = "e352", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockSix = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ut);
var mt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-six-thirty", f = 512, c = 512, e = [], t = "e353", o = "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockSixThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mt);
var gt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-ten", f = 512, c = 512, e = [], t = "e354", o = "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockTen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gt);
var Pt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-ten-thirty", f = 512, c = 512, e = [], t = "e355", o = "M256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm24-120l0-136c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8 232 392c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockTenThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pt);
var Mt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-three", f = 512, c = 512, e = [], t = "e356", o = "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136c0 13.3 10.7 24 24 24l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockThree = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mt);
var wt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-three-thirty", f = 512, c = 512, e = [], t = "e357", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-136c0-13.3 10.7-24 24-24l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockThreeThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wt);
var Nt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-twelve", f = 512, c = 512, e = [], t = "e358", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockTwelve = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nt);
var zt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-twelve-thirty", f = 512, c = 512, e = [], t = "e359", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-360l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockTwelveThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zt);
var Lt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-two", f = 512, c = 512, e = [], t = "e35a", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392l0 91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockTwo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lt);
var Ct = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clock-two-thirty", f = 512, c = 512, e = [], t = "e35b", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM232 392l0-136c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8 280 392c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClockTwoThirty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ct);
var Dt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "closed-captioning-slash", f = 640, c = 512, e = [], t = "e135", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zm197.8 155c26.6 1.2 50.4 13.3 67 31.9c6.1 6.8 7.6 16.2 4.7 24.3l-71.6-56.2zm94 73.7c10-42.3 48-73.8 93.4-73.8c28.4 0 54 12.4 71.5 32c8.8 9.9 8 25-1.9 33.9s-25 8-33.9-1.9c-8.8-9.9-21.6-16-35.8-16c-26.5 0-48 21.5-48 48c0 5.4 .9 10.5 2.5 15.4l-47.9-37.6zm89.4 70c1.3 .1 2.7 .2 4.1 .2c14.2 0 27-6.1 35.8-16c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9c-7.8 8.7-17.2 16-27.7 21.4l-47.9-37.6zM32 121.2L32 416c0 35.3 28.7 64 64 64l391.4 0L295 328.4c-16.8 14.7-38.9 23.6-63 23.6c-53 0-96-43-96-96c0-16 3.9-31.1 10.8-44.3L32 121.2zM232 304c8.7 0 16.9-2.3 23.9-6.4l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5c0 26.5 21.5 48 48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClosedCaptioningSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dt);
var $t = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clothes-hanger", f = 640, c = 512, e = [], t = "e136", o = "M209.8 84.8C222.3 35 267.1 0 318.5 0L320 0c61.9 0 112 50.1 112 112l0 6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8L608.2 377.2C628.1 391 640 413.7 640 438c0 40.9-33.1 74-74 74L74 512c-40.9 0-74-33.1-74-74c0-24.2 11.9-47 31.8-60.8L301.6 189.8l.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3l0-6.3c0-26.5-21.5-48-48-48l-1.5 0c-22 0-41.2 15-46.6 36.4l-.9 3.4c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l.9-3.4zM320 255L68.3 429.7c-2.7 1.9-4.3 4.9-4.3 8.2c0 5.5 4.5 10 10 10l492 0c5.5 0 10-4.5 10-10c0-3.3-1.6-6.4-4.3-8.2L320 255z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClothesHanger = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($t);
var _t = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-binary", f = 640, c = 512, e = [], t = "e601", o = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm16-280l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8zm88-16c0 8.8 7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm136-16c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32zM176 320c0 8.8 7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm96 24l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8zm104-32c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudBinary = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_t);
var g1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-bolt-moon", f = 576, c = 512, e = ["thunderstorm-moon"], t = "f76d", o = "M361.4 79.9C380.6 33 427.1 0 481.2 0c3.7 0 7.3 .2 10.9 .5c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-26.9 15.1-44.9 43.6-44.9 76.1c0 48.1 39.4 87.4 88.4 87.4c5.2 0 10.3-.4 15.2-1.3c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-23.3 22.4-55 36.1-89.9 36.1c-.8 0-1.6 0-2.4 0c-5.4-37.8-29.7-69.5-63-85.3c-1.8-38.6-23.1-72.1-54.3-90.8zm86.4 192.1c0 44.2-35.8 80-80 80l-18.7 0C342.4 332.8 324.3 320 304 320l-18.3 0 29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L82 330.5c-6 4.8-10.5 10.7-13.6 17.4C28.8 336.1 0 299.4 0 255.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7zM282.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352l70.1 0c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384 112 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudBoltMoon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g1);
var P1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-bolt-sun", f = 640, c = 512, e = ["thunderstorm-sun"], t = "f76e", o = "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zM639.9 303.9c0 44.2-35.8 80-80 80l-18.6 0c3.5-10.1 3.7-21.3 0-31.8C534.5 332.9 516.4 320 496 320l-18.3 0 29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2l-160 128c-14.5 11.6-20.9 30.5-16.8 48.4c-37.9-12.8-65.2-48.7-65.2-90.9c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7zM474.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L425.9 352l70.1 0c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384 304 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudBoltSun = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P1);
var bt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-check", f = 640, c = 512, e = [], t = "e35c", o = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bt);
var St = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-drizzle", f = 512, c = 512, e = [], t = "f738", o = "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zm-8 56l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 64l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm-72-40l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudDrizzle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(St);
var yt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-exclamation", f = 640, c = 512, e = [], t = "e491", o = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zM320 160c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yt);
var M1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-fog", f = 640, c = 512, e = [127787, "fog"], t = "f74e", o = "M160 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2c-1.3-6.7-1.9-13.7-1.9-20.8C128 50.1 178.1 0 240 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96l-320 0zM0 392c0-13.3 10.7-24 24-24l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 416c-13.3 0-24-10.7-24-24zm64 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 512c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24l320 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-320 0c-13.3 0-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudFog = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M1);
var Ot = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-hail", f = 512, c = 512, e = [], t = "f739", o = "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zm0 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudHail = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ot);
var kt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-hail-mixed", f = 512, c = 512, e = [], t = "f73a", o = "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm232 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zM326.1 385.5l-10.3 24c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l10.3-24c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudHailMixed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kt);
var At = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-minus", f = 640, c = 512, e = [], t = "e35d", o = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(At);
var jt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-music", f = 640, c = 512, e = [], t = "f8ae", o = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zM416 184c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jt);
var Bt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-plus", f = 640, c = 512, e = [], t = "e35e", o = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zM296 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bt);
var Tt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-question", f = 640, c = 512, e = [], t = "e492", o = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm89.8-282.7l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tt);
var Ft = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-rainbow", f = 576, c = 512, e = [], t = "f73e", o = "M560 64.4C466.8 69.5 385.4 119 336.5 192l-.5 0c-19.7 0-38.3 5.1-54.4 14.1c-5.5-6-11.5-11.4-18-16.4C319.9 81.4 430.9 6.1 560 .4c8.8-.4 16 6.8 16 15.6l0 32c0 8.8-7.2 16-16 16.4zM424 234.7c-13.3-16.9-31.5-29.9-52.3-36.9C415.4 139.9 483.1 101.2 560 96.5c8.8-.5 16 6.7 16 15.5l0 32c0 8.8-7.2 15.9-16 16.7c-55.3 4.6-104 32.6-136 74zm23.4 57.2c-1-9.1-3-17.9-6.1-26.2c25.7-40.1 68.9-67.9 118.8-72.9c8.8-.9 16 6.4 16 15.2l0 32c0 8.8-7.2 15.9-15.9 17.3c-31.4 5.2-57.7 25.8-70.9 53.7c-12.5-8.7-26.6-15.3-41.8-19.1zM96 512c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 318.1 64 311.1 64 304c0-61.9 50.1-112 112-112c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 512z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudRainbow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ft);
var Ht = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-showers", f = 512, c = 512, e = [], t = "f73f", o = "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zm16 32c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm192 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm-72 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm168-24c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudShowers = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ht);
var Rt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-slash", f = 640, c = 512, e = [], t = "e137", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445c24.6-23.3 40-56.3 40-93c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-46.4 0-88.2 19.8-117.4 51.3L38.8 5.1zM97.2 172.6c-.8 6.4-1.2 12.9-1.2 19.4c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144l343.4 0L97.2 172.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rt);
var Ut = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-sleet", f = 512, c = 512, e = [], t = "f741", o = "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm272 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zM216 376l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24zm256 0l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudSleet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ut);
var qt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-snow", f = 512, c = 512, e = [127784], t = "f742", o = "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96L96 320zM64 352c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24zm192 32c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24zm216-8l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudSnow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qt);
var Gt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-word", f = 640, c = 512, e = [], t = "e138", o = "M0 336c0 79.5 64.5 144 144 144l368 0c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336zm512 32c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16 7.2 16 16zM240 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0zM128 304c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm272-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudWord = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gt);
var Wt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cloud-xmark", f = 640, c = 512, e = [], t = "e35f", o = "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm95-273c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wt);
var Et = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clouds", f = 640, c = 512, e = [], t = "f744", o = "M304 160c-74.1 0-135.2 56-143.1 128L96 288c-53 0-96-43-96-96s43-96 96-96l1.1 0C104.9 41.7 151.6 0 208 0c47.9 0 88.8 30.1 104.8 72.4C324.8 67 338 64 352 64c53 0 96 43 96 96c0 12.1-2.2 23.6-6.3 34.2c-11.4 2.3-22.2 6.4-32.1 11.9C383.3 177.7 345.7 160 304 160zM224 512c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2c-1.3-6.7-1.9-13.7-1.9-20.8c0-61.9 50.1-112 112-112c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96l-320 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClouds = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Et);
var Vt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clouds-moon", f = 640, c = 512, e = [], t = "f745", o = "M352 160c0 11.5 1.2 22.7 3.5 33.4c53.7 8.2 96.5 49.8 106.4 103c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160zM114.8 273.9c20.1-30.1 54.3-49.9 93.2-49.9c12.9 0 25.3 2.2 36.8 6.2c19.6-19.9 45.8-33.5 75-37.2l0-.9c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72c16.1 0 30.9-5.3 42.9-14.1zM64 431.9c0 44.2 35.8 80 80 80l271.9 0c53 0 96-43 96-96c0-47.6-34.6-87-80-94.6l0-1.3c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 431.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudsMoon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vt);
var It = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "clouds-sun", f = 640, c = 512, e = [], t = "f746", o = "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9C276.8 132.7 244.8 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm450.6 75c-18.9-35.1-56-59-98.7-59c-12.9 0-25.3 2.2-36.8 6.2C435.9 206.6 403.7 192 368 192c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72c0 30.4-18.8 56.3-45.4 66.9zm45.3 148.9c0 44.2-35.8 80-80 80l-271.9 0c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCloudsSun = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(It);
var Kt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "club", f = 512, c = 512, e = [9827], t = "f327", o = "M380 160.1c2.6-10.2 4-21 4-32.1C384 57.3 326.7 0 256 0S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1c-1.3 0-2.7-.1-4-.1C57.3 160 0 217.3 0 288s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3l0 75.3-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-75.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128s-57.3-128-128-128c-1.4 0-2.7 0-4 .1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faClub = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kt);
var Xt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coconut", f = 512, c = 512, e = [], t = "e2f6", o = "M141.2 141.2c-43.7 43.7-73 91.8-85.8 133.3c-13.2 42.7-7.4 71.9 7.5 86.7s44 20.6 86.7 7.5c41.5-12.8 89.6-42.1 133.3-85.8s73-91.8 85.8-133.3c13.2-42.7 7.4-71.9-7.5-86.7s-44-20.6-86.7-7.5C233 68.1 184.9 97.5 141.2 141.2zM260.4 9.5C309.6-5.7 361.5-4.8 395.2 28.8l40.9 40.9C484.7 118.4 512 184.3 512 252.9C512 396 396 512 253 512c-68.7 0-134.6-27.3-183.2-75.9l-41-41C-4.8 361.5-5.7 309.6 9.5 260.3c15.6-50.4 49.7-105 97.8-153.1S210 25 260.4 9.5zm63.5 88.1c25 25-5.4 95.9-67.9 158.4s-133.4 92.9-158.4 67.9s5.4-95.9 67.9-158.4S298.9 72.6 323.9 97.6zm95.4 107.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-56 136c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-136 56c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoconut = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xt);
var Qt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "code-pull-request-closed", f = 512, c = 512, e = [], t = "e3f9", o = "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0L400 34.7 425.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L445.3 80l25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L400 125.3l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 80 329.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zM136 80A24 24 0 1 0 88 80a24 24 0 1 0 48 0zm56 0c0 32.8-19.7 61-48 73.3l0 205.3c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-205.3C51.7 141 32 112.8 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM112 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm288 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 56c-44.2 0-80-35.8-80-80c0-32.8 19.7-61 48-73.3L368 224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 134.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCodePullRequestClosed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qt);
var Jt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "code-pull-request-draft", f = 448, c = 512, e = [], t = "e3fa", o = "M56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zm56 73.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3l0 205.3C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-205.3zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm312-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCodePullRequestDraft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jt);
var Yt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "code-simple", f = 576, c = 512, e = [], t = "e13d", o = "M214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6zm146.7 0L498.7 256 361.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCodeSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yt);
var Zt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coffee-bean", f = 448, c = 512, e = [], t = "e13e", o = "M333.6 205.6c24.4-24.6 45.4-67.3 59.9-101.7c5.1-12.2 20.9-15.3 28.2-4.3c51.2 77.7 26.2 201.2-63.4 290.8c-79.6 79.6-186 108.1-263.2 77.7c-14.8-5.8-20-23.2-13.2-37.5c.7-1.6 1.5-3.1 2.2-4.7c16.5-34.5 37.5-72.2 57.4-92.3c29.7-29.9 59.7-44.9 91.8-61l.5-.3s0 0 0 0c32-15.9 66.1-32.9 99.7-66.8zM55.3 412c-5.3 11-19.9 13.6-26.9 3.6c-54-77.4-29.6-203.2 61.2-294C169.9 41.3 277.4 13 354.7 44.7c14 5.7 19.4 22 13.7 36c-1.4 3.5-2.9 7.1-4.4 10.8c-14.5 34.5-33.5 71.8-53.1 91.5c-29.7 29.9-59.7 44.9-91.8 61l-.5 .3c-32 15.9-66.1 32.9-99.7 66.8c-24.1 24.3-47.1 66.6-63.6 101z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoffeeBean = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zt);
var pt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coffee-beans", f = 512, c = 512, e = [], t = "e13f", o = "M507.5 209.7c-3.4 12.3-19.1 11.8-25.4 .7c-5.4-9.5-11.3-18.5-17.6-26c-27.6-32.6-60.8-44.5-90.1-55l-1-.3c-30-10.7-55.8-20.2-77.5-45.9c-10.8-12.8-21.3-33.4-29.3-52c-1.7-4-.6-8.7 3-11.2C320.9-16 401.3-2.6 458 54c45.7 45.7 63.2 106.7 49.5 155.6zM228.5 78.3c3.4-12.3 19.1-11.8 25.4-.7c5.3 9.5 11.3 18.5 17.6 26c27.6 32.6 60.8 44.5 90.1 55l1 .3c30 10.7 55.8 20.2 77.5 45.9c10.8 12.8 21.3 33.4 29.3 52c1.7 4 .6 8.7-3 11.2C415.1 304 334.7 290.6 278 234c-45.7-45.7-63.2-106.7-49.5-155.6zM75.5 206c11.2-6.3 22 5.2 18.5 17.6c-2.9 10.5-5.2 21.2-6 31c-3.6 42.8 11.6 74.9 25 103.2l.4 .9c13.7 28.9 25.3 54.1 22.5 87.8c-1.4 16.7-8.6 38.9-16.1 57.9c-1.6 4.1-5.8 6.6-10.1 5.8C47.7 499.3 0 432.6 0 352c0-65 31-120.9 75.5-146zM180.5 498c-11.2 6.3-22-5.2-18.5-17.6c2.9-10.5 5.2-21.2 6-31c3.6-42.8-11.6-74.9-25-103.2l-.4-.9c-13.7-28.9-25.3-54.1-22.5-87.8c1.4-16.7 8.6-38.9 16.1-57.9c1.6-4.1 5.8-6.6 10.1-5.8C208.3 204.7 256 271.4 256 352c0 65-31 120.9-75.5 146z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoffeeBeans = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pt);
var xt = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coffee-pot", f = 512, c = 512, e = [], t = "e002", o = "M64 128c0-17.7 14.3-32 32-32l12.8 0 34 84.9C95 215.9 64 272.3 64 336l0 8c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8L418 480c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344l0-8c0-63.7-31-120.1-78.8-155.1L478.1 68.8c1.3-3.2 1.9-6.6 1.9-10C480 44 468 32 453.2 32L192 32l-69.2 0L96 32C43 32 0 75 0 128l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zm65 192c5.2-41.4 30.1-76.6 65-96l188 0c34.9 19.4 59.8 54.6 65 96l-318 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoffeePot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xt);
var io = {}, w1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cup-togo", f = 448, c = 512, e = ["coffee-togo"], t = "f6c5", o = "M55.2 17.7C60.6 6.8 71.7 0 83.8 0L364.2 0c12.1 0 23.2 6.8 28.6 17.7L416 64c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96S14.3 64 32 64L55.2 17.7zM74.7 453.8L48 160l352 0L373.3 453.8c-3 33-30.6 58.2-63.7 58.2l-171.1 0c-33.1 0-60.7-25.2-63.7-58.2zM323.8 290.9c1.7-18.7-13.1-34.9-31.9-34.9L156 256c-18.8 0-33.6 16.2-31.9 34.9l8.7 96c1.5 16.5 15.3 29.1 31.9 29.1l118.5 0c16.6 0 30.4-12.6 31.9-29.1l8.7-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCupTogo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = w1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCoffeeTogo = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(io);
var ao = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coffin", f = 384, c = 512, e = [9904], t = "f6c6", o = "M11.5 114.9l91-104C108.5 4 117.3 0 126.5 0h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoffin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ao);
var eo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coffin-cross", f = 384, c = 512, e = [], t = "e051", o = "M102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1l127.9 0c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0l-131 0c-9.2 0-18 4-24.1 10.9zM216 120l0 40 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoffinCross = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eo);
var no = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coin", f = 512, c = 512, e = [129689], t = "f85c", o = "M256 352C114.6 352 0 287.5 0 208S114.6 64 256 64s256 64.5 256 144s-114.6 144-256 144zM86.6 248.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200s10.5 36.7 22.6 48.2zM96 200c0-35.3 71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64s-160-28.7-160-64zM0 290.1c13.2 15.6 29.7 29.3 48 40.9l0 63.7C17.8 373.6 0 347.9 0 320l0-29.9zM80 413l0-64.7c28.4 13.2 60.9 23 96 29l0 64.3c-36.2-6-68.9-15.9-96-28.7zm128 32.8l0-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4l0 64.1c-15.5 1.5-31.6 2.2-48 2.2s-32.5-.8-48-2.2zm128-4.1l0-64.3c35.1-6 67.6-15.9 96-29l0 64.7c-27.1 12.8-59.8 22.7-96 28.7zm128-47l0-63.7c18.3-11.5 34.8-25.2 48-40.9l0 29.9c0 27.9-17.8 53.6-48 74.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(no);
var fo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coin-blank", f = 512, c = 512, e = [], t = "e3fb", o = "M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144s-114.6-144-256-144S0 128.5 0 208zm0 82.1L0 320c0 27.9 17.8 53.6 48 74.6L48 331c-18.3-11.5-34.8-25.2-48-40.9zM80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29L80 413zm128 32.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2l0-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4l0 64.1zm128-4.1c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.2-60.9 23-96 29l0 64.3zm128-47c30.2-21 48-46.8 48-74.6l0-29.9c-13.2 15.6-29.7 29.3-48 40.9l0 63.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoinBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fo);
var co = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coin-front", f = 512, c = 512, e = [], t = "e3fc", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm24-264c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoinFront = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(co);
var to = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "coin-vertical", f = 384, c = 512, e = [], t = "e3fd", o = "M288 256c0 141.4-64.5 256-144 256S0 397.4 0 256S64.5 0 144 0s144 114.6 144 256zM184.2 425.4c11.4-12 20.1-27.7 26.8-44.4c13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64s-36.7 10.5-48.2 22.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448s36.7-10.5 48.2-22.6zM136 416c-35.3 0-64-71.6-64-160s28.7-160 64-160s64 71.6 64 160s-28.7 160-64 160zm90.1 96c15.6-13.2 29.3-29.7 40.9-48l63.7 0c-21 30.2-46.8 48-74.6 48l-29.9 0zM349 432l-64.7 0c13.2-28.4 23-60.9 29-96l64.3 0c-6 36.2-15.9 68.9-28.7 96zm32.8-128l-64.1 0c1.6-15.7 2.4-31.7 2.4-48s-.8-32.3-2.4-48l64.1 0c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48zm-4.1-128l-64.3 0c-6-35.1-15.9-67.6-29-96L349 80c12.8 27.1 22.7 59.8 28.7 96zm-47-128L267 48c-11.5-18.3-25.2-34.8-40.9-48L256 0c27.9 0 53.6 17.8 74.6 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCoinVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(to);
var oo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "colon", f = 192, c = 512, e = [], t = "3a", o = "M96 192A64 64 0 1 0 96 64a64 64 0 1 0 0 128zm0 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faColon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oo);
var lo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "columns-3", f = 640, c = 512, e = [], t = "e361", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM192 96l0 320L64 416 64 96l128 0zm64 0l128 0 0 320-128 0 0-320zm320 0l0 320-128 0 0-320 128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faColumns3 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lo);
var ro = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comet", f = 512, c = 512, e = [], t = "e003", o = "M299.4 75.6L493.7 .9c1.5-.6 3.2-.9 4.8-.9C506 0 512 6 512 13.5c0 1.7-.3 3.3-.9 4.8L436.4 212.6l29.3-2.3c12.8-1 21.5 12.8 15.1 24L378.6 410.7C342.3 473.4 275.4 512 203 512C90.9 512 0 421.1 0 309c0-72.4 38.6-139.4 101.3-175.7L277.7 31.2c11.1-6.5 25 2.2 24 15.1l-2.3 29.3zM192 200c-6.1 0-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2L192 402.1l58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2c-2.7-5.5-8.3-8.9-14.3-8.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faComet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ro);
var so = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comma", f = 192, c = 512, e = [], t = "2c", o = "M160 350.4V349c0-33.7-27.3-61-61-61c-29.5 0-54.8 21.1-60.1 50.1l-22.2 122c-.5 2.6-.7 5.2-.7 7.9v8.2C16 495.9 32.1 512 51.9 512c12.5 0 24.1-6.5 30.6-17.2L150.8 383c6-9.8 9.2-21.1 9.2-32.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faComma = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(so);
var ho = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "command", f = 512, c = 512, e = [], t = "e142", o = "M0 96C0 43 43 0 96 0s96 43 96 96l0 32 128 0 0-32c0-53 43-96 96-96s96 43 96 96s-43 96-96 96l-32 0 0 128 32 0c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96l0-32-128 0 0 32c0 53-43 96-96 96s-96-43-96-96s43-96 96-96l32 0 0-128-32 0C43 192 0 149 0 96zm128 32l0-32c0-17.7-14.3-32-32-32S64 78.3 64 96s14.3 32 32 32l32 0zm64 192l128 0 0-128-128 0 0 128zm-64 64l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32l0-32zm256 0l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-32 0zm0-256l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32l0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommand = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ho);
var vo = {}, N1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-arrow-down", f = 512, c = 512, e = ["comment-alt-arrow-down"], t = "e1db", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 120z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = N1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltArrowDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vo);
var uo = {}, z1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-arrow-up", f = 512, c = 512, e = ["comment-alt-arrow-up"], t = "e1dc", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM280 177.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-118.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = z1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltArrowUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(uo);
var mo = {}, L1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-captions", f = 512, c = 512, e = ["comment-alt-captions"], t = "e1de", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM120 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageCaptions = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = L1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltCaptions = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(mo);
var go = {}, C1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-check", f = 512, c = 512, e = ["comment-alt-check"], t = "f4a2", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm369 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = C1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltCheck = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(go);
var Po = {}, D1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-dollar", f = 512, c = 512, e = ["comment-alt-dollar"], t = "f650", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm276 40c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = D1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltDollar = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Po);
var Mo = {}, u = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-dots", f = 512, c = 512, e = ["comment-alt-dots", "messaging"], t = "f4a3", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageDots = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = u;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltDots = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Mo);
var wo = {}, m = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-pen", f = 512, c = 512, e = ["comment-alt-edit", "message-edit"], t = "f4a4", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm340.8 59c-14.7-14.7-38.6-14.7-53.3 0L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6l-71.9 71.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessagePen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = m;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltEdit = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(wo);
var No = {}, $1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-exclamation", f = 512, c = 512, e = ["comment-alt-exclamation"], t = "f4a5", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM256 80c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = $1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltExclamation = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(No);
var zo = {}, _1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-image", f = 512, c = 512, e = ["comment-alt-image"], t = "e1e0", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm176 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84L202.7 201c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 132 304 128 296 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageImage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = _1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltImage = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(zo);
var Lo = {}, b1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-lines", f = 512, c = 512, e = ["comment-alt-lines"], t = "f4a6", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageLines = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = b1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltLines = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Lo);
var Co = {}, S1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-medical", f = 512, c = 512, e = ["comment-alt-medical"], t = "f7f4", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm224 64l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = S1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltMedical = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Co);
var Do = {}, y1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-minus", f = 512, c = 512, e = ["comment-alt-minus"], t = "f4a7", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM184 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = y1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltMinus = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Do);
var $o = {}, O1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-music", f = 512, c = 512, e = ["comment-alt-music"], t = "f8af", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM352 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = O1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltMusic = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})($o);
var _o = {}, k1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-plus", f = 512, c = 512, e = ["comment-alt-plus"], t = "f4a8", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM232 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessagePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = k1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltPlus = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_o);
var bo = {}, A1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-quote", f = 512, c = 512, e = ["comment-alt-quote"], t = "e1e4", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm160 48c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0zm224 80l0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageQuote = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = A1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltQuote = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(bo);
var So = {}, j1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-slash", f = 640, c = 512, e = ["comment-alt-slash"], t = "f4a9", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352l0-288c0-35.3-28.7-64-64-64L128 0C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zM406.2 416L64 146.4 64 352c0 35.3 28.7 64 64 64l96 0 0 80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416l32.8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = j1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(So);
var yo = {}, B1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-smile", f = 512, c = 512, e = ["comment-alt-smile"], t = "f4aa", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageSmile = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = B1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltSmile = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yo);
var Oo = {}, T1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-text", f = 512, c = 512, e = ["comment-alt-text"], t = "e1e6", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm168 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0-88 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageText = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = T1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltText = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Oo);
var ko = {}, g = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-xmark", f = 512, c = 512, e = ["comment-alt-times", "message-times"], t = "f4ab", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm175 63c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = g;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentAltTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ko);
var Ao = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-arrow-down", f = 512, c = 512, e = [], t = "e143", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm24-296l0 118.1 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L232 152c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ao);
var jo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-arrow-up", f = 512, c = 512, e = [], t = "e144", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm24-238.1L280 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jo);
var Bo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-arrow-up-right", f = 512, c = 512, e = [], t = "e145", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM200 160l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87L200 208c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentArrowUpRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bo);
var To = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-captions", f = 512, c = 512, e = [], t = "e146", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM120 208l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 288l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm128 0l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentCaptions = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(To);
var Fo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-check", f = 512, c = 512, e = [], t = "f4ac", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM369 193L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fo);
var Ho = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-code", f = 512, c = 512, e = [], t = "e147", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM217 193l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM329 159l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentCode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ho);
var Ro = {}, F1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-pen", f = 512, c = 512, e = ["comment-edit"], t = "f4ae", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm84.8-293c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L272.6 170 287.5 155c14.7-14.7 38.6-14.7 53.3 0zM178.1 264.5L250 192.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentPen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = F1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentEdit = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ro);
var Uo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-exclamation", f = 512, c = 512, e = [], t = "f4af", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm0-336c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uo);
var qo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-heart", f = 512, c = 512, e = [], t = "e5c8", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM205.3 144c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qo);
var Go = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-image", f = 512, c = 512, e = [], t = "e148", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm168-16c7.6 0 14.7 3.6 19.2 9.6l96 128c5.5 7.3 6.3 17 2.3 25.1s-12.4 13.3-21.5 13.3l-192 0-80 0c-9.3 0-17.8-5.4-21.7-13.8s-2.7-18.4 3.3-25.5l40-48c4.6-5.5 11.3-8.6 18.4-8.6s13.9 3.2 18.4 8.6L199 257.3l77.8-103.7c4.5-6 11.6-9.6 19.2-9.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentImage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Go);
var Wo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-lines", f = 512, c = 512, e = [], t = "f4b0", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM152 176l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentLines = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wo);
var Eo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-middle", f = 512, c = 512, e = [], t = "e149", o = "M188.3 408.7l44.5 89c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3l44.5-89C432.2 384.5 512 303.8 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 95.8 79.8 176.5 188.3 200.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentMiddle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Eo);
var Vo = {}, H1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-middle", f = 512, c = 512, e = ["comment-middle-alt"], t = "e1e1", o = "M343.5 416L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l104.5 0 75.2 90.2c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8L343.5 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageMiddle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = H1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentMiddleAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Vo);
var Io = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-middle-top", f = 512, c = 512, e = [], t = "e14a", o = "M188.3 103.3l44.5-89C237.2 5.5 246.2 0 256 0s18.8 5.5 23.2 14.3l44.5 89C432.2 127.5 512 208.2 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-95.8 79.8-176.5 188.3-200.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentMiddleTop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Io);
var Ko = {}, R1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-middle-top", f = 512, c = 512, e = ["comment-middle-top-alt"], t = "e1e2", o = "M343.5 96L448 96c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l104.5 0L243.7 5.8c3-3.6 7.5-5.8 12.3-5.8s9.3 2.1 12.3 5.8L343.5 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageMiddleTop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = R1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentMiddleTopAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ko);
var Xo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-minus", f = 512, c = 512, e = [], t = "f4b1", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM184 216l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xo);
var Qo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-music", f = 512, c = 512, e = [], t = "f8b0", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm96-320l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 320c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qo);
var Jo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-plus", f = 512, c = 512, e = [], t = "f4b2", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM232 328l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jo);
var Yo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-question", f = 512, c = 512, e = [], t = "e14b", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM169.8 149.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 248.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yo);
var Zo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-quote", f = 512, c = 512, e = [], t = "e14c", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM160 144l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zm224 80l0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentQuote = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zo);
var po = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-smile", f = 512, c = 512, e = [], t = "f4b4", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM192 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.5 270.1c9.9-8.8 25-8 33.9 1.9c17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9C337 333.4 298.6 352 256 352s-81-18.6-107.3-48c-8.8-9.9-8-25 1.9-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentSmile = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(po);
var xo = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-text", f = 512, c = 512, e = [], t = "e14d", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM184 160l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentText = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xo);
var il = {}, U1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comment-xmark", f = 512, c = 512, e = ["comment-times"], t = "f4b5", o = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM175 159c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = U1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(il);
var al = {}, q1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "messages", f = 640, c = 512, e = ["comments-alt"], t = "f4b6", o = "M64 0C28.7 0 0 28.7 0 64L0 256c0 35.3 28.7 64 64 64l32 0 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320 352 320c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 0zM352 352l-96 0 0 32c0 35.3 28.7 64 64 64l117.3 0 81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3l0-48 32 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-128 0 0 128c0 53-43 96-96 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessages = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = q1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentsAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(al);
var el = {}, G1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "messages-dollar", f = 640, c = 512, e = ["comments-alt-dollar"], t = "f652", o = "M0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-149.3 0-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-48-32 0c-35.3 0-64-28.7-64-64L0 64zM256 352l96 0c53 0 96-43 96-96l0-128 128 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-32 0 0 48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448 320 448c-35.3 0-64-28.7-64-64l0-32zM228 56c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7L228 56z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessagesDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = G1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCommentsAltDollar = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(el);
var nl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comments-question", f = 640, c = 512, e = [], t = "e14e", o = "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9c0 0 0 0 0 0s0 0 0 0l.2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2s0 0 0 0s0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM136.2 108.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4l48.5 0c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 162.1c-6.2 3.6-10 10.2-10 17.3l0 11.2c0 11 9 20 20 20c10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6l-48.5 0c-19.8 0-37.4 12.4-44 31.1zM234.7 264a26.7 26.7 0 1 0 -53.3 0 26.7 26.7 0 1 0 53.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentsQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nl);
var fl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "comments-question-check", f = 640, c = 512, e = [], t = "e14f", o = "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2s0 0 0 0s0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9c0 0 0 0 0 0s0 0 0 0l-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5zM180.2 77.3l48.5 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191c-.2 10.9-9.1 19.6-20 19.6c-11 0-20-9-20-20l0-11.2c0-7.2 3.8-13.8 10-17.3L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-48.5 0c-2.8 0-5.3 1.8-6.3 4.4l-.4 1c-3.7 10.4-15.1 15.9-25.5 12.2s-15.9-15.1-12.2-25.5l.4-1c6.6-18.6 24.2-31.1 44-31.1zm27.8 160a26.7 26.7 0 1 1 0 53.3 26.7 26.7 0 1 1 0-53.3zm358.1 88.8l-80 80c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L472 363.7l65.9-65.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCommentsQuestionCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fl);
var cl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "compass-slash", f = 640, c = 512, e = [], t = "f5e9", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256C576 114.6 461.4 0 320 0C246.8 0 180.9 30.7 134.2 79.9L38.8 5.1zM270.3 186.5l143.3-55.1c19.4-7.5 38.5 11.6 31 31L397.1 285.9 270.3 186.5zM320 512c55.2 0 106.3-17.5 148.1-47.2L317 345.8l-90.6 34.8c-19.4 7.5-38.5-11.6-31-31l29.4-76.5L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCompassSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cl);
var tl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Di;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCompressArrows = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(tl);
var ol = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "compress-wide", f = 512, c = 512, e = [], t = "f326", o = "M160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM416 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM384 288c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCompressWide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ol);
var ll = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "computer-classic", f = 448, c = 512, e = [], t = "f8b1", o = "M0 48C0 21.5 21.5 0 48 0L400 0c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48L48 416c-26.5 0-48-21.5-48-48L0 48zM32 480l0-32 384 0 0 32c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32zM96 64C78.3 64 64 78.3 64 96l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 64zM80 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm144-24c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faComputerClassic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ll);
var W1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "computer-mouse-scrollwheel", f = 384, c = 512, e = ["mouse-alt"], t = "f8cd", o = "M160 0C71.6 0 0 71.6 0 160L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-192C384 71.6 312.4 0 224 0L160 0zm64 128l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faComputerMouseScrollwheel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W1);
var dl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "computer-speaker", f = 640, c = 512, e = [], t = "f8b2", o = "M288 432l0-16-160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l176 0c-10-13.4-16-30-16-48zM64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64l224 0 0-64L64 320 64 96l224 0 0-16c0-18 6-34.6 16-48L64 32zm304 0c-26.5 0-48 21.5-48 48l0 352c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L368 32zM544 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm64-192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faComputerSpeaker = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dl);
var rl = {}, E1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "triangle-person-digging", f = 640, c = 512, e = ["construction"], t = "f85d", o = "M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480l432 0c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-23.1-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1l-96 0c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrianglePersonDigging = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = E1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faConstruction = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(rl);
var sl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "container-storage", f = 640, c = 512, e = [], t = "f4b7", o = "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l0 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-320c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM176 152l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faContainerStorage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sl);
var hl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "conveyor-belt", f = 640, c = 512, e = [], t = "f46e", o = "M176 0l80 0 0 112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1L384 0l80 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48zM0 416c0-53 43-96 96-96l448 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faConveyorBelt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hl);
var vl = {}, V1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "conveyor-belt-boxes", f = 640, c = 512, e = ["conveyor-belt-alt"], t = "f46f", o = "M64 32C64 14.3 78.3 0 96 0L288 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32L64 32zM384 96c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128zM0 416c0-53 43-96 96-96l448 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faConveyorBeltBoxes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = V1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faConveyorBeltAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vl);
var ul = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "conveyor-belt-arm", f = 640, c = 512, e = [], t = "e5f8", o = "M240.9 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-52.9 0-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3c17.5 2.3 29.8 18.4 27.5 35.9c-1.4 10.2-7.4 18.7-15.7 23.5l0 20.3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-17.9L255.2 164.5c-8.4 7.2-19.3 11.6-31.2 11.6c-26.5 0-48-21.5-48-48c0-17.1 8.9-32 22.3-40.6L202.2 64 160 64c-17.7 0-32-14.3-32-32s14.3-32 32-32l79 0c.6 0 1.2 0 1.9 0zM240 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 280c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 40 32 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96s43-96 96-96l0-40c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 40 64 0 0-40c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 40 64 0 0-40zM128 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faConveyorBeltArm = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ul);
var ml = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "conveyor-belt-empty", f = 640, c = 512, e = [], t = "e150", o = "M96 320c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faConveyorBeltEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ml);
var gl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "corn", f = 512, c = 512, e = [127805], t = "f6c7", o = "M512 40c0 15-8.3 28.1-20.5 34.9C499.2 82.2 504 92.6 504 104c0 18-11.8 33.2-28.2 38.2c2.7 5.4 4.2 11.4 4.2 17.8c0 18-11.8 33.2-28.2 38.2c2.7 5.4 4.2 11.4 4.2 17.8c0 22.1-17.9 40-40 40c-1.1 0-2.3 0-3.4-.1c2.2 4.9 3.4 10.4 3.4 16.1c0 13.6-6.8 25.7-17.3 32.9c-47.7-29.7-103.6-41.1-157.5-34.2c6.9-53.9-4.5-109.8-34.2-157.5C214.3 102.8 226.4 96 240 96c5.7 0 11.2 1.2 16.1 3.4c-.1-1.1-.1-2.2-.1-3.4c0-22.1 17.9-40 40-40c6.4 0 12.4 1.5 17.8 4.2C318.8 43.8 334 32 352 32c6.4 0 12.4 1.5 17.8 4.2C374.8 19.8 390 8 408 8c11.4 0 21.8 4.8 29.1 12.5C443.9 8.3 457 0 472 0c22.1 0 40 17.9 40 40zM137.7 98c1.2-6.3 8.9-8.7 13.2-3.9c45.4 50.5 69.5 114 56.9 183.4c-38.7 10.7-75.2 31.2-105.5 61.6L24.9 416.5c-34.2-37.7-33.1-96 3.2-132.4l64-64c18.3-18.3 30.6-41.7 35.3-67.1L137.7 98zM92.1 483.9L47.4 439.2l77.5-77.5c28.6-28.6 63.5-47.1 100.1-55.6c72.2-16.6 139.8 7.4 192.8 55c4.8 4.3 2.4 12.1-3.9 13.2l-54.9 10.2c-25.4 4.7-48.8 17-67.1 35.3l-64 64c-37.5 37.5-98.3 37.5-135.8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCorn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gl);
var Pl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "corner", f = 448, c = 512, e = [], t = "e3fe", o = "M0 192c0-17.7 14.3-32 32-32l352 0c35.3 0 64 28.7 64 64l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128L32 224c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCorner = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pl);
var Ml = {}, I1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "loveseat", f = 512, c = 512, e = ["couch-small"], t = "f4cc", o = "M64 160C64 89.3 121.3 32 192 32l128 0c70.7 0 128 57.3 128 128l0 33.6c-36.5 7.4-64 39.7-64 78.4l0 48-256 0 0-48c0-38.7-27.5-71-64-78.4L64 160zM416 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48l0 176c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L96 448c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3l0 48 0 32 32 0 256 0 32 0 0-32 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLoveseat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = I1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCouchSmall = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ml);
var wl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "court-sport", f = 640, c = 512, e = [], t = "e643", o = "M576 480l-240 0 0-113.1c54.3-7.8 96-54.4 96-110.9s-41.7-103.1-96-110.9L336 32l240 0c35.3 0 64 28.7 64 64l0 32-64 0c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l64 0 0 32c0 35.3-28.7 64-64 64zM304 145.1c-54.3 7.8-96 54.4-96 110.9s41.7 103.1 96 110.9L304 480 64 480c-35.3 0-64-28.7-64-64l0-32 64 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64L0 128 0 96C0 60.7 28.7 32 64 32l240 0 0 113.1zm0 189.3c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4l0 156.8zm32 0l0-156.8c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4zM576 160l64 0 0 192-64 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32zM64 352L0 352 0 160l64 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCourtSport = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wl);
var Nl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cowbell", f = 448, c = 512, e = [], t = "f8b3", o = "M112 96l16 0 0-56c0-22.1 17.9-40 40-40L280 0c22.1 0 40 17.9 40 40l0 56 16 0c21.4 0 40.3 14.2 46.2 34.8l64 224c4.1 14.5 1.2 30.1-7.8 42.1s-23.3 19.1-38.3 19.1L48 416c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96zm160 0l0-48-96 0 0 48 96 0zm16 352c0 35.3-28.7 64-64 64s-64-28.7-64-64l128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCowbell = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nl);
var K1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cowbell-circle-plus", f = 576, c = 512, e = ["cowbell-more"], t = "f8b4", o = "M112 96l16 0 0-56c0-22.1 17.9-40 40-40L280 0c22.1 0 40 17.9 40 40l0 56 16 0c21.4 0 40.3 14.2 46.2 34.8l18.3 64C318.3 209.7 256 281.6 256 368c0 16.6 2.3 32.7 6.6 48L48 416c-15.1 0-29.3-7.1-38.3-19.1s-12-27.6-7.8-42.1l64-224C71.7 110.2 90.6 96 112 96zM285.5 465.6C277.9 492.4 253.2 512 224 512c-35.3 0-64-28.7-64-64l115.2 0c3.1 6.1 6.6 12 10.3 17.6zM272 96l0-48-96 0 0 48 96 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCowbellCirclePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K1);
var zl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = K1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCowbellMore = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(zl);
var Ll = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "crab", f = 512, c = 512, e = [129408], t = "e3ff", o = "M128 0C60 0 4.4 53 .2 120c0 .2 0 .3 0 .5L0 128l7.9 0c0 0 .1 0 .1 0l-8 0 0 33.3c0 28.1 16.3 53.6 41.8 65.4L98.9 253c-3.7 6-6.9 12.4-9.6 19l-37.5 0L23.2 257.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l32 16c2.2 1.1 4.7 1.7 7.2 1.7l33 0c-.7 5.2-1 10.6-1 16l0 9.8-21.1 7c-2.4 .8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L72.6 366l28-9.3 30.7 30.7L90.9 400.8c-2.4 .8-4.5 2.1-6.3 3.9l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L104.6 430l52-17.3 15.7 15.7-36.6 21.9c-4.8 2.9-7.8 8.1-7.8 13.7l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-22.9L201.8 448l108.5 0L352 473.1l0 22.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-5.6-3-10.8-7.8-13.7l-36.6-21.9 15.7-15.7 52 17.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-40.4-13.5 30.7-30.7 28 9.3 29.3 29.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-1.8-1.8-3.9-3.1-6.3-3.9l-21.1-7 0-9.8c0-5.4-.3-10.8-1-16l33 0c2.5 0 4.9-.6 7.2-1.7l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L460.2 272l-37.5 0c-2.7-6.6-5.9-13-9.6-19l57.1-26.3c25.5-11.8 41.8-37.3 41.8-65.4l0-33.3-8 0c0 0 .1 0 .1 0l7.9 0-.2-7.5c0-.1 0-.3 0-.4c0 0 0 0 0 0s0 0 0 0C507.6 53 452 0 384 0L339.3 0c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c5 5 1.5 13.7-5.7 13.7L328 64c-4.4 0-8.1 3.6-7.5 8c3.9 31.6 30.9 56 63.5 56l80 0 0 33.3c0 9.4-5.4 17.9-13.9 21.8L378.7 216c-16.9-12.2-37-20.3-58.7-23l0-49c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 49c-21.7 2.7-41.7 10.9-58.7 23L61.9 183.1C53.4 179.2 48 170.6 48 161.3L48 128l80 0c32.6 0 59.6-24.4 63.5-56c.5-4.4-3.1-8-7.5-8l-36.7 0c-7.1 0-10.7-8.6-5.7-13.7l36.7-36.7c5-5 1.5-13.7-5.7-13.7L128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCrab = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ll);
var Cl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "crate-empty", f = 512, c = 512, e = [], t = "e151", o = "M48 224c-26.5 0-48 21.5-48 48l0 80 512 0 0-80c0-26.5-21.5-48-48-48L48 224zM512 384L0 384l0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-80zM64 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCrateEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cl);
var Dl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "credit-card-blank", f = 576, c = 512, e = [], t = "f389", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCreditCardBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dl);
var $l = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "credit-card-front", f = 576, c = 512, e = [], t = "f38a", o = "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM112 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0zM96 368c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zM408 96c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-80 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCreditCardFront = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($l);
var _l = {}, X1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "soft-serve", f = 384, c = 512, e = [127846, "creemee"], t = "e400", o = "M208 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C208 56 200 64 190.1 64L128 64c-35.3 0-64 28.7-64 64c0 11.8 3.2 22.9 8.8 32.4C40.8 164 16 191.1 16 224c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-2.3 0c11.5-14.4 18.3-32.7 18.3-52.6C320 48.1 271.9 0 212.6 0L208 0zM48 320l0 32c0 17.7 14.3 32 32 32l1.8 0 11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5l134.7 0c16.3 0 30-12.3 31.8-28.5L302.2 384l1.8 0c17.7 0 32-14.3 32-32l0-32L48 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSoftServe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = X1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCreemee = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_l);
var bl = {}, Q1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cricket-bat-ball", f = 512, c = 512, e = [127951, "cricket"], t = "f449", o = "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-135 135L409 231c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-23 23L240 288c-8.8 0-16-7.2-16-16l0-145.9 23-23c9.4-9.4 24.6-9.4 33.9 0l41.4 41.4 135-135c12.5-12.5 32.8-12.5 45.3 0zM352 432a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM16.1 334L192 158.1 192 272c0 26.5 21.5 48 48 48l113.9 0L178 495.9c-10 10-24.4 16.7-40.4 15.6c-11.3-.8-28.6-2.8-46.4-8.2C73.9 498.2 54.1 489.1 39 473c-16.2-15-25.2-34.9-30.4-52.2C3.2 403 1.2 385.7 .5 374.4C-.6 358.4 6.1 344 16.1 334z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCricketBatBall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Q1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCricket = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(bl);
var Sl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "croissant", f = 512, c = 512, e = [129360], t = "f7f6", o = "M259.4 1.4c3.9 5.9 7 12.5 9.1 19.5l59.9 199.7c1.2 4.1 2 8.2 2.4 12.4L440.3 92.2c13.6-17.4 10.5-42.8-8.6-53.9C389.4 14 340.3 0 288 0c-9.7 0-19.2 .5-28.6 1.4zM233 330.8c-4.1-.4-8.3-1.2-12.4-2.4L20.9 268.5c-7-2.1-13.6-5.2-19.5-9.1C.5 268.8 0 278.3 0 288c0 52.3 14 101.4 38.4 143.7c11 19.1 36.4 22.2 53.9 8.6L233 330.8zM232.7 19s0 0 0 0c2 3 3.6 6.4 4.8 10c-1.2-3.6-2.8-6.9-4.8-10c0 0 0 0 0 0zm232.9 92.8L390 209l87.6 14.6c1.6 .3 3.2 .4 4.9 .4c16.3 0 29.6-13.2 29.6-29.6l0-5.4c0-4.2-.7-8.3-2.3-12.2c-10.1-25.2-24.1-48.5-41.3-69c-.9 1.4-1.9 2.7-2.9 4zM209 390l-97.1 75.6c-1.3 1-2.6 2-4 2.9c20.5 17.2 43.8 31.2 69 41.3c3.9 1.5 8 2.3 12.2 2.3l5.4 0c16.3 0 29.6-13.2 29.6-29.6c0-1.6-.1-3.3-.4-4.9L209 390zM19 232.7s0 0 0 0c2.3 1.5 4.7 2.8 7.3 3.8c1.2 .5 2.5 1 3.8 1.3l199.7 59.9c11.3 3.4 23.5 .3 31.8-8l28.1-28.1c8.3-8.3 11.4-20.5 8-31.8L237.8 30.1C232.5 12.2 216 0 197.4 0c-4.6 0-9.2 .7-13.5 2.3C99.7 33 33 99.7 2.3 183.9C.7 188.2 0 192.8 0 197.4c0 14.5 7.4 27.6 19 35.3c0 0 0 0 0 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCroissant = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sl);
var yl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "crosshairs-simple", f = 512, c = 512, e = [], t = "e59f", o = "M445.3 224L384 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l61.3 0C431.9 368.4 368.4 431.9 288 445.3l0-61.3c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 61.3C143.6 431.9 80.1 368.4 66.7 288l61.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-61.3 0C80.1 143.6 143.6 80.1 224 66.7l0 61.3c0 17.7 14.3 32 32 32s32-14.3 32-32l0-61.3C368.4 80.1 431.9 143.6 445.3 224zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCrosshairsSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yl);
var Ol = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "crutches", f = 640, c = 512, e = [], t = "f7f8", o = "M470.6 9.4l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM294.6 188.2L404.1 78.6l45.3 45.3L397.3 176 464 242.7l52.1-52.1 45.3 45.3-74.6 74.6-.1 .1-.1 .1-34.7 34.7c-12.9 12.9-29.2 21.9-47.1 25.8L297.1 395.2c-5.9 1.3-11.4 4.3-15.7 8.6l-98.8 98.8c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l98.8-98.8c4.3-4.3 7.3-9.7 8.6-15.7l23.9-107.6c4-17.8 12.9-34.1 25.8-47.1zm45.3 45.3c-4.3 4.3-7.3 9.7-8.6 15.7l-17 76.7 76.7-17c5.9-1.3 11.4-4.3 15.7-8.6L418.7 288 352 221.3l-12.2 12.2zM169.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L213.3 56l84.1 84.1-25.4 25.4c-6.7 6.7-12.6 14.1-17.6 22L168 101.3 101.3 168 223.7 290.4l-10.1 45.5-17 17c-2.9-2.3-5.7-4.8-8.4-7.5L56 213.3l-1.4 1.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160zM411.7 402.5c9.3-2.1 18.3-5.2 26.9-9.2l64.1 64.1c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-90.2-90.2 44.5-9.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCrutches = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ol);
var kl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "crystal-ball", f = 448, c = 512, e = [], t = "e362", o = "M448 224c0 62.7-25.7 119.3-67.2 160L67.2 384C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM152.5 84.3l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4c-2.6-7-12.4-7-15 0zm159 48c-2.6-7-12.4-7-15 0l-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4-18.4-49.8zm98.9 331.8c3.7 5.1 5.6 11.3 5.6 17.6c0 16.7-13.6 30.3-30.3 30.3L62.3 512C45.6 512 32 498.4 32 481.7c0-6.3 2-12.5 5.6-17.6L72 416l304 0 34.4 48.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCrystalBall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kl);
var Al = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cucumber", f = 512, c = 512, e = [129362], t = "e401", o = "M37.5 474.5c47.8 47.8 124 49.9 174.3 6.3c12.6 10.3 31.1 9.6 42.9-2.2c11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4c11.7-11.7 12.5-30.3 2.2-42.9c43.6-50.3 41.5-126.5-6.3-174.3c-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6L37.5 293.5c-50 50-50 131 0 181zM400 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCucumber = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Al);
var jl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cup-straw", f = 384, c = 512, e = [129380], t = "e363", o = "M249.3 0L280 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-30.7 0c-3.7 0-6.9 2.6-7.8 6.2L224.2 128 352 128c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l142.9 0 20-84.8C200.8 17.9 223.4 0 249.3 0zM60.3 468L40 224l304 0L323.7 468c-2.1 24.9-22.9 44-47.8 44l-167.7 0c-25 0-45.8-19.1-47.8-44z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCupStraw = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jl);
var Bl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cup-straw-swoosh", f = 384, c = 512, e = [], t = "e364", o = "M194.8 43.2l-20 84.8L32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-127.8 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0c-26 0-48.6 17.9-54.5 43.2zM40 224L60.3 468c2.1 24.9 22.9 44 47.8 44l167.7 0c25 0 45.8-19.1 47.8-44L344 224 40 224zm194.4 78.9c18.8-10.1 42-17.2 72.7-20.6L303 331.2c-20.8 3.1-35.2 8.2-45.8 13.9c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-17.7 8.8-39.3 15.2-66.7 18.9l-4-47.9c22.1-3.2 37.7-8.3 49.4-14.1c19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCupStrawSwoosh = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bl);
var Tl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "cupcake", f = 448, c = 512, e = [129473], t = "e402", o = "M240 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l6.1 6.1c3.4 3.4 5.3 7.9 5.3 12.7C240 56 232 64 222.1 64L160 64c-35.3 0-64 28.7-64 64l0 .8c-3.3 .5-6.6 1.4-9.9 2.4L50.9 143C20.5 153.2 0 181.6 0 213.6C0 254.7 33.3 288 74.4 288l299.2 0c41.1 0 74.4-33.3 74.4-74.4c0-32-20.5-60.4-50.9-70.6l-35.3-11.8c-4.1-1.4-8.2-2.3-12.5-2.8c1.7-6.7 2.6-13.8 2.6-21C352 48.1 303.9 0 244.6 0L240 0zm27.9 512l24-192-135.8 0 24 192 87.8 0zM64 320L89.3 471.9C93.2 495 113.2 512 136.7 512l11.2 0-24-192L64 320zM300.1 512l11.2 0c23.5 0 43.5-17 47.3-40.1L384 320l-59.9 0-24 192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCupcake = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tl);
var Fl = {}, J1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "curling-stone", f = 576, c = 512, e = [129356, "curling"], t = "f44a", o = "M224 128c0-17.7 14.3-32 32-32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L256 32c-53 0-96 43-96 96l0 32c-35.3 0-64 28.7-64 64c-53 0-96 43-96 96l0 16 576 0 0-16c0-53-43-96-96-96c0-35.3-28.7-64-64-64l-192 0 0-32zM576 368L0 368l0 16c0 53 43 96 96 96l384 0c53 0 96-43 96-96l0-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCurlingStone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = J1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faCurling = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Fl);
var Hl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "custard", f = 576, c = 512, e = [127854], t = "e403", o = "M396.7 64c30 0 56 20.8 62.5 50.1l13.5 60.8C450.9 167.4 423.5 160 400 160c-26.4 0-45.8 9.4-62.2 17.2l-.7 .3c-16.7 8-30.4 14.4-49.1 14.4s-32.3-6.4-49.1-14.4l-.7-.3C221.8 169.4 202.4 160 176 160c-23.5 0-50.9 7.4-72.6 14.9l13.5-60.8C123.4 84.8 149.3 64 179.3 64l217.3 0zM64.3 350.9L95.1 212.1c4.1-1.6 8.5-3.3 13.2-5c22-7.9 47.8-15.1 67.7-15.1c18.7 0 32.3 6.4 49.1 14.4l.7 .3c16.4 7.9 35.8 17.2 62.2 17.2s45.8-9.4 62.2-17.2l.7-.3c16.7-8 30.4-14.4 49.1-14.4c19.8 0 45.6 7.2 67.7 15.1c4.7 1.7 9.2 3.4 13.2 5L512 352 64.3 350.9zM32 384l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faCustard = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hl);
var Rl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dagger", f = 384, c = 512, e = [], t = "f6cb", o = "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96L48 128c-26.5 0-48 21.5-48 48s21.5 48 48 48c20.9 0 38.7-13.4 45.3-32l98.7 0 98.7 0c6.6 18.6 24.4 32 45.3 32c26.5 0 48-21.5 48-48s-21.5-48-48-48l-112 0 0-96zM128 224l0 24 0 166.8c0 10.5 2.9 20.8 8.5 29.7l35.1 56.2c4.4 7 12.1 11.3 20.4 11.3s16-4.3 20.4-11.3l35.1-56.2c5.6-8.9 8.5-19.2 8.5-29.7L256 248l0-24-24 0-80 0-24 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDagger = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rl);
var Y1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dash", f = 512, c = 512, e = ["minus-large"], t = "e404", o = "M0 256c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y1);
var Ul = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = yi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDebug = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ul);
var ql = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "deer", f = 512, c = 512, e = [129420], t = "f78e", o = "M240 0c8.8 0 16 7.2 16 16l0 24c0 13.3 10.7 24 24 24l8 0 8 0c13.3 0 24-10.7 24-24l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 8.6-1.9 16.7-5.4 24l30.6 0L416 64c13.3 0 24-10.7 24-24l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 21.7-12.3 40.4-30.3 49.8c.6 .5 1.1 1.1 1.7 1.6l55.3 55.3c8.5 8.5 13.3 20 13.3 32c0 25-20.3 45.3-45.3 45.3L416 224l-5.3 0L384 304l0 64 0 112c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-112-36.3 0c-28.8 0-55.3-9.8-76.3-26.4c-2.1 16.9-9.8 32.6-21.9 44.8L142.9 397c-4.6 4.6-6.2 11.5-4 17.7l19.3 54.7c7.3 20.8-8.1 42.6-30.2 42.6l-33.9 0c-13.6 0-25.7-8.6-30.2-21.4l-15.5-44c-11.4-32.4-7.4-67.8 10-96.3C65 339.4 65 324.9 56 315.9c-3-3-5.7-6.1-8.1-9.5c-1.3 12.9-12.7 22.5-25.7 21.5C8.9 326.9-.9 315.4 .1 302.2L2.4 272c4.2-54.2 49.3-96 103.7-96l7.9 0 14.1 0 64 0c.6 0 1.2 0 1.7 0c.8 0 1.7 0 2.5 0l106.1 0 9.6-32-38 0c-9.9 0-18-8-18-18c0-8.2 5.6-15.4 13.6-17.4L320 96l-24 0-8 0-8 0c-30.9 0-56-25.1-56-56l0-24c0-8.8 7.2-16 16-16zM400 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDeer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ql);
var Gl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "deer-rudolph", f = 576, c = 512, e = [], t = "f78f", o = "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 30.9 25.1 56 56 56l8 0 8 0 24 0-50.4 12.6c-8 2-13.6 9.2-13.6 17.4c0 9.9 8 18 18 18l38 0-9.6 32-106.1 0c-.8 0-1.7 0-2.5 0c-.6 0-1.2 0-1.7 0l-64 0-14.1 0-7.9 0C51.7 176 6.6 217.8 2.4 272L.1 302.2c-1 13.2 8.9 24.8 22.1 25.8c13 1 24.4-8.6 25.7-21.5c2.4 3.3 5.2 6.5 8.1 9.5c9 9 9 23.5 2.4 34.4c-17.4 28.6-21.5 63.9-10 96.3l15.5 44C68.4 503.4 80.5 512 94.1 512l33.9 0c22.1 0 37.5-21.8 30.2-42.6l-19.3-54.7c-2.2-6.2-.6-13 4-17.7l10.6-10.6c12.1-12.1 19.8-27.9 21.9-44.8c21 16.5 47.5 26.4 76.3 26.4l36.3 0 0 112c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-112 0-64 26.7-80 5.3 0 50.7 0c25 0 45.3-20.3 45.3-45.3c0-1.2 0-2.4-.1-3.6c2.6 .5 5.4 .8 8.1 .8c22.1 0 40-17.9 40-40s-17.9-40-40-40c-19.6 0-35.9 14.1-39.3 32.7L443.4 91.4c-.6-.6-1.1-1.1-1.7-1.6C459.7 80.4 472 61.7 472 40l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-38.7 0-30.6 0c3.5-7.3 5.4-15.4 5.4-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-8 0-8 0c-13.3 0-24-10.7-24-24l0-24zM384 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDeerRudolph = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gl);
var Wl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "delete-right", f = 576, c = 512, e = [], t = "e154", o = "M0 128C0 92.7 28.7 64 64 64l306.7 0c17 0 33.3 6.7 45.3 18.7L566.6 233.4c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7L64 448c-35.3 0-64-28.7-64-64L0 128zm143 47c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDeleteRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wl);
var El = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "desktop-arrow-down", f = 576, c = 512, e = [], t = "e155", o = "M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0L336 416l176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L352 0l0 64 160 0 0 224L64 288 64 64l160 0 0-64L64 0zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 150.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L312 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDesktopArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(El);
var Vl = {}, Z1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "display-code", f = 576, c = 512, e = ["desktop-code"], t = "e165", o = "M0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-176 0 10.7 32 69.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416 64 416c-35.3 0-64-28.7-64-64L0 64zm64 0l0 288 448 0 0-288L64 64zM249 177l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM361 143l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDisplayCode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Z1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDesktopCode = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Vl);
var Il = {}, p1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "display-medical", f = 576, c = 512, e = ["desktop-medical"], t = "e166", o = "M0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-176 0 10.7 32 69.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416 64 416c-35.3 0-64-28.7-64-64L0 64zm64 0l0 288 448 0 0-288L64 64zm192 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDisplayMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = p1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDesktopMedical = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Il);
var Kl = {}, x1 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "display-slash", f = 640, c = 512, e = ["desktop-slash"], t = "e2fa", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9l0-288c0-35.3-28.7-64-64-64L96 0C79.6 0 64.6 6.2 53.2 16.4L38.8 5.1zM113.9 64L544 64l0 288-62.6 0L113.9 64zM32 352c0 35.3 28.7 64 64 64l176 0-10.7 32L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32c0-2.1-.2-4.1-.6-6.1L446.6 448l-67.9 0L368 416l38 0-81.2-64L96 352l0-180.2L32 121.4 32 352z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDisplaySlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x1);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = x1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDesktopSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Kl);
var Xl = {}, ia = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "droplet-degree", f = 512, c = 512, e = ["dewpoint"], t = "f748", o = "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0l1.8 0c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM464 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDropletDegree = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ia);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ia;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDewpoint = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Xl);
var Ql = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diagram-cells", f = 512, c = 512, e = [], t = "e475", o = "M512 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64zM448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiagramCells = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ql);
var Jl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diagram-lean-canvas", f = 640, c = 512, e = [], t = "e156", o = "M512 96l0 208 64 0 0-208-64 0zm-48 0l-64 0 0 80 64 0 0-80zM352 96l-64 0 0 208 64 0 0-208zM240 96l-64 0 0 80 64 0 0-80zM128 96L64 96l0 208 64 0 0-208zM64 352l0 64 232 0 0-64L64 352zm280 64l232 0 0-64-232 0 0 64zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM240 304l0-80-64 0 0 80 64 0zm224-80l-64 0 0 80 64 0 0-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiagramLeanCanvas = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jl);
var Yl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diagram-nested", f = 448, c = 512, e = [], t = "e157", o = "M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-16 0 0 96c0 17.7 14.3 32 32 32l96 0 0-16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-16-96 0c-53 0-96-43-96-96l0-96-16 0c-26.5 0-48-21.5-48-48L0 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiagramNested = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yl);
var Zl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diagram-previous", f = 512, c = 512, e = [], t = "e478", o = "M448 352L64 352l0 64 384 0 0-64zm0-64c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l168 0 0-64-46.1 0c-21.4 0-32.1-25.9-17-41L239 113c9.4-9.4 24.6-9.4 33.9 0L343 183c15.1 15.1 4.4 41-17 41L280 224l0 64 168 0zM365.7 160.4L295.6 90.3c-21.9-21.9-57.3-21.9-79.2 0l-70.1 70.1c-18.4 18.4-20.4 43.7-11 63.6L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-71.3 0c9.4-19.9 7.4-45.2-11-63.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiagramPrevious = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zl);
var pl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diagram-sankey", f = 576, c = 512, e = [], t = "e158", o = "M294.4 44.8c6-8.1 15.5-12.8 25.6-12.8l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L336 96 249.6 211.2c-6 8.1-15.5 12.8-25.6 12.8L32 224c-17.7 0-32-14.3-32-32s14.3-32 32-32l176 0L294.4 44.8zM141.9 320L32 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-327.5 0 57.6 96L544 416c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-11.2 0-21.7-5.9-27.4-15.5L141.9 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiagramSankey = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pl);
var xl = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diagram-subtask", f = 512, c = 512, e = [], t = "e479", o = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-288 0 0 96c0 17.7 14.3 32 32 32l32 0c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l-32 0c-53 0-96-43-96-96l0-96-32 0c-35.3 0-64-28.7-64-64L0 96zM448 352l-160 0 0 64 160 0 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiagramSubtask = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xl);
var id = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diagram-venn", f = 640, c = 512, e = [], t = "e15a", o = "M256 412.8C216.4 372.4 192 317 192 256s24.4-116.4 64-156.8C245.7 97.1 235 96 224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c11 0 21.7-1.1 32-3.2zm64 45.7c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6zM370.7 192l-101.4 0c-6.5 14.9-10.8 31.1-12.5 48l126.4 0c-1.7-16.9-6-33.1-12.5-48zM269.3 320l101.4 0c6.5-14.9 10.8-31.1 12.5-48l-126.4 0c1.7 16.9 6 33.1 12.5 48zM288 352c9.1 12.1 19.9 22.9 32 32c12.1-9.1 22.9-19.9 32-32l-64 0zm64-192c-9.1-12.1-19.9-22.9-32-32c-12.1 9.1-22.9 19.9-32 32l64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiagramVenn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(id);
var aa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dial", f = 576, c = 512, e = ["dial-med-high"], t = "e15b", o = "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM175.1 174.2c56.7-56.7 145.4-62 208-15.7L271.3 270.4c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L417.1 192.4c46.2 62.6 41 151.3-15.7 208c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDial = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aa);
var ad = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dial-high", f = 576, c = 512, e = [], t = "e15c", o = "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm.4 127.6c80.2 0 146.6 59 158.2 136l-158.2 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l158.2 0c-11.6 77-78 136-158.2 136c-88.4 0-160-71.6-160-160s71.6-160 160-160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDialHigh = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ad);
var ed = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dial-low", f = 576, c = 512, e = [], t = "e15d", o = "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-.4 447.6c-80.2 0-146.6-59-158.2-136l158.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-158.2 0c11.6-77 78-136 158.2-136c88.4 0 160 71.6 160 160s-71.6 160-160 160zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDialLow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ed);
var nd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dial-max", f = 576, c = 512, e = [], t = "e15e", o = "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM401.4 174.7c56.7 56.7 61.9 145.4 15.7 208L305.2 270.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L383.2 416.7c-62.6 46.2-151.3 41-208-15.7c-62.5-62.5-62.5-163.8 0-226.3s163.8-62.5 226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDialMax = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nd);
var fd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dial-med", f = 576, c = 512, e = [], t = "e15f", o = "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 287.2C128 207 187 140.6 264 129l0 158.2c0 13.3 10.7 24 24 24s24-10.7 24-24L312 129c77 11.6 136 78 136 158.2c0 88.4-71.6 160-160 160s-160-71.6-160-160zm384 .8a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDialMed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fd);
var cd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = aa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDialMedHigh = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(cd);
var td = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dial-med-low", f = 576, c = 512, e = [], t = "e160", o = "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM174.6 400.5c-56.7-56.7-62-145.4-15.7-208L270.8 304.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L192.8 158.5c62.6-46.2 151.3-41 208 15.7c62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDialMedLow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(td);
var od = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dial-min", f = 576, c = 512, e = [], t = "e161", o = "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM400.9 401c-56.7 56.7-145.4 62-208 15.7L304.7 304.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L158.9 382.8c-46.2-62.6-41-151.3 15.7-208c62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3zM512 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDialMin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(od);
var ld = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dial-off", f = 576, c = 512, e = [], t = "e162", o = "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 288c0 80.2-59 146.6-136 158.2L312 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 158.2c-77-11.6-136-78-136-158.2c0-88.4 71.6-160 160-160s160 71.6 160 160zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 96a32 32 0 1 1 64 0A32 32 0 1 1 64 96zM480 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm416-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDialOff = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ld);
var dd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diamond-exclamation", f = 512, c = 512, e = [], t = "e405", o = "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiamondExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dd);
var rd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diamond-half", f = 512, c = 512, e = [], t = "e5b7", o = "M256 0c-10.2 0-20.5 3.9-28.3 11.7l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c7.8 7.8 18 11.7 28.3 11.7L256 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiamondHalf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rd);
var sd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diamond-half-stroke", f = 512, c = 512, e = [], t = "e5b8", o = "M256 78.5L433.5 256 256 433.5l0-355.1zm28.3-66.8c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiamondHalfStroke = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sd);
var hd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diamonds-4", f = 512, c = 512, e = [], t = "e68b", o = "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l74.1 74.1c12.5 12.5 12.5 32.8 0 45.3l-79.7 79.7c-12.5 12.5-32.8 12.5-45.3 0L153.7 131c-12.5-12.5-12.5-32.8 0-45.3l74.1-74.1zM131 153.7l79.7 79.7c12.5 12.5 12.5 32.8 0 45.3L131 358.3c-12.5 12.5-32.8 12.5-45.3 0L11.7 284.3c-15.6-15.6-15.6-40.9 0-56.6l74.1-74.1c12.5-12.5 32.8-12.5 45.3 0zM153.7 381l79.7-79.7c12.5-12.5 32.8-12.5 45.3 0L358.3 381c12.5 12.5 12.5 32.8 0 45.3l-74.1 74.1c-15.6 15.6-40.9 15.6-56.6 0l-74.1-74.1c-12.5-12.5-12.5-32.8 0-45.3zM381 358.3l-79.7-79.7c-12.5-12.5-12.5-32.8 0-45.3L381 153.7c12.5-12.5 32.8-12.5 45.3 0l74.1 74.1c15.6 15.6 15.6 40.9 0 56.6l-74.1 74.1c-12.5 12.5-32.8 12.5-45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiamonds4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hd);
var vd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dice-d10", f = 512, c = 512, e = [], t = "f6cd", o = "M209.7 16.3C212.4 8.3 206.4 0 198 0c-3.8 0-7.3 1.7-9.7 4.6L2.4 237C.8 238.9 0 241.3 0 243.8c0 7 6.4 12.1 13.2 10.6l117.6-26.1c5.5-1.2 9.9-5.2 11.7-10.6L209.7 16.3zM8.7 288.2C3.6 289.4 0 293.9 0 299.1c0 3.1 1.3 6.1 3.6 8.2L220.7 508.9c2.1 2 4.9 3.1 7.8 3.1c6.3 0 11.5-5.1 11.5-11.5l0-171.7c0-5.3-2.6-10.2-6.9-13.2l-78.7-54.5c-3.7-2.5-8.2-3.4-12.6-2.5L8.7 288.2zM272 500.5c0 6.3 5.1 11.5 11.5 11.5c2.9 0 5.7-1.1 7.8-3.1L508.4 307.3c2.3-2.1 3.6-5.1 3.6-8.2c0-5.2-3.6-9.8-8.7-10.9L370.2 258.7c-4.4-1-8.9-.1-12.6 2.5l-78.7 54.5c-4.3 3-6.9 7.9-6.9 13.2l0 171.7zM498.8 254.4c6.8 1.5 13.2-3.7 13.2-10.6c0-2.5-.8-4.9-2.4-6.8L323.7 4.6C321.4 1.7 317.8 0 314 0c-8.5 0-14.4 8.3-11.7 16.3l67.2 201.5c1.8 5.3 6.2 9.3 11.7 10.6l117.6 26.1zM246.6 6.8L174.8 222.3c-2.2 6.7 .2 14.2 6.1 18.2l66.1 45.7c5.5 3.8 12.7 3.8 18.2 0l66.1-45.7c5.8-4 8.3-11.5 6.1-18.2L265.4 6.8C264 2.7 260.3 0 256 0s-8 2.7-9.4 6.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiceD10 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vd);
var ud = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dice-d12", f = 512, c = 512, e = [], t = "f6ce", o = "M318.2 0c4.2 0 8.4 1.1 12 3.2l72 41.6c5.9 3.4 5.1 12.2-1.3 14.5L264.1 108.1c-5.2 1.9-10.9 1.9-16.1 0L111.1 59.3c-6.4-2.3-7.2-11.1-1.3-14.5l72-41.6c3.6-2.1 7.8-3.2 12-3.2L318.2 0zM149.9 490.4L74.2 446.6c-3.6-2.1-6.7-5.1-8.8-8.8L3.2 330.2c-2.1-3.6-3.2-7.8-3.2-12l0-84.2c0-7.1 8.6-10.7 13.7-5.7l96.1 96.1c2.7 2.7 4.8 6.1 5.9 9.8L161.6 481c2.2 7-5.3 13-11.6 9.3zM512 233.9l0 84.2c0 4.2-1.1 8.4-3.2 12L446.6 437.8c-2.1 3.6-5.1 6.7-8.8 8.8l-75.8 43.7c-6.3 3.6-13.8-2.4-11.6-9.3l45.9-146.9c1.2-3.7 3.2-7.1 5.9-9.8l96.1-96.1c5-5 13.7-1.5 13.7 5.7zM15.3 184.7c-5.1-5.1-6.2-13-2.5-19.3L57.4 88c3.9-6.7 12-9.7 19.2-7.1l152.8 54.6c6.4 2.3 10.6 8.3 10.6 15.1l0 85.7c0 6.1-3.4 11.6-8.8 14.3l-89.7 44.8c-6.2 3.1-13.6 1.9-18.5-3L15.3 184.7zM454.6 88l44.7 77.3c3.6 6.3 2.6 14.2-2.5 19.3L389 292.4c-4.9 4.9-12.3 6.1-18.5 3l-89.7-44.8c-5.4-2.7-8.8-8.3-8.8-14.3l0-85.7c0-6.8 4.3-12.8 10.6-15.1L435.4 80.9c7.3-2.6 15.4 .4 19.2 7.1zM295.5 512l-78.9 0c-7 0-13.2-4.5-15.3-11.2L151.4 341.2c-2.3-7.5 1.1-15.6 8.1-19.1l89.3-44.7c4.5-2.3 9.8-2.3 14.3 0l89.3 44.7c7 3.5 10.5 11.6 8.1 19.1L310.7 500.8c-2.1 6.7-8.3 11.2-15.3 11.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiceD12 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ud);
var md = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dice-d4", f = 512, c = 512, e = [], t = "f6d0", o = "M228.8 .7C235.5 2.8 240 9 240 16l0 480c0 6.3-3.7 12-9.4 14.6s-12.5 1.6-17.2-2.6L5.4 324c-6.1-5.4-7.2-14.5-2.5-21.2l208-296c4-5.7 11.3-8.2 17.9-6.1zm54.4 0c6.7-2.1 13.9 .3 17.9 6.1l208 296c4.7 6.7 3.6 15.8-2.5 21.2l-208 184c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6l0-480c0-7 4.5-13.2 11.2-15.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiceD4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(md);
var gd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dice-d8", f = 512, c = 512, e = [], t = "f6d2", o = "M240 16c0-6.5-4-12.4-10-14.8s-13-1-17.5 3.7l-208 216c-3.7 3.9-5.3 9.3-4.1 14.6s4.9 9.5 9.9 11.5l208 80c4.9 1.9 10.5 1.2 14.8-1.7s6.9-7.9 6.9-13.2l0-296zM34.6 307.5c-4.1 6.3-3.3 14.6 1.9 20l176 179.7c4.5 4.6 11.5 6.1 17.5 3.6s10-8.3 10-14.8l0-112c0-6.6-4.1-12.6-10.3-14.9l-176-67.7c-7-2.7-15-.1-19.1 6.1zm442.7 0c-4.1-6.3-12.1-8.8-19.1-6.1l-176 67.7c-6.2 2.4-10.3 8.3-10.3 14.9l0 112c0 6.5 3.9 12.4 10 14.8s12.9 1 17.5-3.6l176-179.7c5.3-5.4 6.1-13.7 1.9-20zM282 1.2C276 3.6 272 9.5 272 16l0 296c0 5.3 2.6 10.2 6.9 13.2s9.9 3.6 14.8 1.7l208-80c5-1.9 8.7-6.2 9.9-11.5s-.4-10.7-4.1-14.6l-208-216C295 .2 288.1-1.3 282 1.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiceD8 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gd);
var Pd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dinosaur", f = 640, c = 512, e = [], t = "e5fe", o = "M446.2 0L448 0C554 0 640 86 640 192l0 30.6c0 88-51.5 165.6-128 201.5l0 55.9c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-22c-15.3 3.9-31.4 6-48 6c-6.8 0-13.5-.4-20.1-1c-7.5-18.9-24.4-33.3-45.4-36.8L162 408.1c-19.6-3.3-34-20.2-34-40.1c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.5 25.7 65.8 60.7 71.7l108.5 18.1c13.2 2.2 22.8 13.6 22.8 26.9c0 15.1-12.2 27.3-27.3 27.3l-4.7 0-32 0-32 0-71.3 0C54.1 512 0 457.9 0 391.3c0-34 14.4-66.5 39.5-89.3l89.7-81.6C172 181.5 227.6 160 285.3 160c50.2 0 99 16.3 139.2 46.4L480 248c6.9 5.2 15.3 8 24 8c22.1 0 40-17.9 40-40l0-24c0-35.3-28.7-64-64-64l-32 0-32.3 0c-26.3 0-47.7-21.4-47.7-47.7l0-4.7c0-16.7 10.1-31.6 25.6-37.8l1.7-.7c8.2-3.3 14.8-9.4 18.7-17.2C420.2 7.7 432.6 0 446.2 0zM464 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDinosaur = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pd);
var ea = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "diploma", f = 640, c = 512, e = ["scroll-ribbon"], t = "f5ea", o = "M302 59.7l18 20.6 18-20.6C353.4 42.1 375.6 32 399 32l1 0c44.2 0 80 35.8 80 80c0 11.4-2.4 22.2-6.7 32l70.7 0 0 32c0-32 0-32 0-32s0 0 0 0l.1 0 .2 0 .5 0c.4 0 .8 0 1.4 .1c1 .1 2.3 .1 3.8 .3c3 .3 7 .9 11.6 2.1c9.2 2.3 21.3 6.9 33.4 15.9C620.9 181.7 640 216.2 640 272c0 47.5-13.7 81.1-32 104.1c-18 22.6-38.5 32.6-49 36.6c-7.3 2.8-14 3.3-19 3.3l-.5 0c-4.7 0-9.3-.5-13.9-1.5L384 383l0 81c0 6.2-3.6 11.9-9.2 14.5s-12.3 1.8-17-2.2L320 444.8l-37.8 31.5c-4.8 4-11.4 4.8-17 2.2s-9.2-8.3-9.2-14.5l0-81L114.4 414.5c-4.6 1-9.2 1.5-13.9 1.5l-.5 0c-4.9 0-11.7-.5-19-3.3c-10.5-4-31-14-49-36.6C13.7 353.1 0 319.5 0 272c0-55.8 19.1-90.3 44.8-109.6c12.1-9.1 24.3-13.6 33.4-15.9c4.6-1.2 8.6-1.8 11.6-2.1c1.5-.2 2.8-.3 3.8-.3c.5 0 1 0 1.4-.1l.5 0 .2 0 .1 0c0 0 0 0 0 0l0 32 0-32 70.7 0c-4.3-9.8-6.7-20.6-6.7-32c0-44.2 35.8-80 80-80l1 0c23.4 0 45.6 10.1 61 27.7zM240 144l54.4 0c6.9 0 10.5-8.1 6-13.3L265.9 91.3C259.6 84.1 250.5 80 241 80l-1 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm105.6 0l46.4 0 8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1 0c-1.2 0-2.3 .1-3.5 .2c-8.2 .9-15.8 4.8-21.3 11.1l-34.5 39.5c-4.5 5.2-.9 13.3 6 13.3zM256 208L96.7 208c0 0 0 0-.1 0c-.5 .1-1.5 .2-2.9 .5c-2.8 .7-6.7 2.1-10.6 5.1C76.9 218.3 64 231.8 64 272c0 34.5 9.6 53.7 18.1 64.3c7.2 9 14.9 13.5 19.2 15.6L256 317.4 256 208zM384 317.4l154.8 34.4c4.3-2 12-6.6 19.2-15.6c8.4-10.6 18.1-29.8 18.1-64.3c0-40.2-12.9-53.7-19.2-58.4c-3.9-2.9-7.7-4.4-10.6-5.1c-1.4-.3-2.4-.5-2.9-.5c0 0 0 0-.1 0L384 208l0 109.4zM540.1 352c0 0 0 0 0 0s0 0 0 0s0 0 0 0zM99.9 352l0 0s0 0 0 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiploma = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ea);
var Md = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "disc-drive", f = 512, c = 512, e = [], t = "f8b5", o = "M32 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 320c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0L96 480l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 96zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDiscDrive = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Md);
var wd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "display-arrow-down", f = 576, c = 512, e = [], t = "e164", o = "M64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l176 0-10.7 32L160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-69.3 0L336 416l176 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L352 0l0 64 160 0 0 288L64 352 64 64l160 0 0-64L64 0zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 182.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L312 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDisplayArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wd);
var Nd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "display-chart-up", f = 576, c = 512, e = [], t = "e5e3", o = "M0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-176 0 10.7 32 69.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416 64 416c-35.3 0-64-28.7-64-64L0 64zm64 0l0 288 448 0 0-288L64 64zM376 96l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144 376 144c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDisplayChartUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nd);
var zd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "display-chart-up-circle-currency", f = 640, c = 512, e = [], t = "e5e5", o = "M0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 147.2c-19.5-10-41.1-16.4-64-18.5L512 64 64 64l0 288 256.7 0c-.5 5.3-.7 10.6-.7 16c0 59.5 29.5 112.1 74.8 144L160 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416 64 416c-35.3 0-64-28.7-64-64L0 64zm480 56l0 72.7c-16.7 1.5-32.7 5.3-47.7 11.2c-.2-1.3-.3-2.6-.3-3.9l0-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144 376 144c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L460.7 426c21.6 13.2 49.1 13.2 70.7 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDisplayChartUpCircleCurrency = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zd);
var Ld = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "display-chart-up-circle-dollar", f = 640, c = 512, e = [], t = "e5e6", o = "M0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 147.2c-19.5-10-41.1-16.4-64-18.5L512 64 64 64l0 288 256.7 0c-.5 5.3-.7 10.6-.7 16c0 59.5 29.5 112.1 74.8 144L160 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l69.3 0L240 416 64 416c-35.3 0-64-28.7-64-64L0 64zm480 56l0 72.7c-16.7 1.5-32.7 5.3-47.7 11.2c-.2-1.3-.3-2.6-.3-3.9l0-22.1L321 289c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-63-63-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 175c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 144 376 144c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDisplayChartUpCircleDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ld);
var Cd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "distribute-spacing-horizontal", f = 512, c = 512, e = [], t = "e365", o = "M32 24C32 10.7 42.7 0 56 0S80 10.7 80 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24L32 24zM160 144c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-224zM456 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDistributeSpacingHorizontal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cd);
var Dd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "distribute-spacing-vertical", f = 512, c = 512, e = [], t = "e366", o = "M0 56C0 42.7 10.7 32 24 32l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56zM96 208c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-96zM24 432l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDistributeSpacingVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dd);
var $d = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ditto", f = 320, c = 512, e = [], t = "22", o = "M0 96l0 2.3c0 3.8 .3 7.6 1 11.4L26.5 256.5C29.7 274.7 45.5 288 64 288s34.3-13.3 37.5-31.5L127 109.6c.7-3.8 1-7.5 1-11.4l0-2.3c0-35.3-28.7-64-64-64S0 60.7 0 96zm192 0l0 2.3c0 3.8 .3 7.6 1 11.4l25.5 146.8c3.2 18.2 19 31.5 37.5 31.5s34.3-13.3 37.5-31.5L319 109.6c.7-3.8 1-7.5 1-11.4l0-2.3c0-35.3-28.7-64-64-64s-64 28.7-64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDitto = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($d);
var _d = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "do-not-enter", f = 512, c = 512, e = [], t = "f5ec", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96 208l320 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L96 304c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDoNotEnter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_d);
var bd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dog-leashed", f = 576, c = 512, e = [129454], t = "f6d4", o = "M122.7 4.1l160 144c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-160-144c-6.6-5.9-7.1-16-1.2-22.6s16-7.1 22.6-1.2zM144 192l112 0 0 191.3c-5.3 .5-10.6 .7-16 .7c-28.8 0-56-6.9-80-19.2L160 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-230.2c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192l30 0 16 0zM320 364.8c-10.1 5.2-20.8 9.4-32 12.6l0-169.3L416 262l0 218c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-115.2zM426.7 192l-6.2 37.2L305.9 180.9l26.8-161C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32l52.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l56 0c13.3 0 24 10.7 24 24l0 24c0 44.2-35.8 80-80 80l-32 0-16 0-21.3 0zM448 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDogLeashed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bd);
var Sd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = v;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDollarCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Sd);
var yd = {}, P = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-dollar", f = 448, c = 512, e = ["dollar-square", "usd-square"], t = "f2e9", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM244.8 133.6l0 14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7l0-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = P;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDollarSquare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yd);
var Od = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dolly-empty", f = 576, c = 512, e = [], t = "f473", o = "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l72.9 0L197 340.2c-22.5 17.6-37 45-37 75.8c0 53 43 96 96 96c52.4 0 95.1-42 96-94.3l202.1-67.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2L331.8 357c-17.2-22.1-43.9-36.5-74-37L165.7 43.8C156.9 17.6 132.5 0 104.9 0L32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDollyEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Od);
var kd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = O2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDollyFlatbedAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(kd);
var Ad = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = k2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDollyFlatbedEmpty = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ad);
var jd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dolphin", f = 512, c = 512, e = [], t = "e168", o = "M477.3 24.9c3.5-5.3 3.6-12.2 .1-17.6S467.7-.8 461.4 .2c-16.7 2.8-43.1 8.6-68.8 17C378 22 362.5 28 349 35.3C306.5 12.8 258 0 206.5 0L176 0C96.5 0 32 64.5 32 144c0 18.6 3.5 36.4 10 52.7L20.5 209.6C7.8 217.2 0 231 0 245.8C0 269.1 18.9 288 42.2 288L176 288l16 0 11.2 0 92 61.3c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-48 6.6 0c31.7 0 57.4 25.7 57.4 57.4c0 30.6-24 55.8-54.5 57.3l-53.4 2.7c-20.2-33-56.3-53.4-95.4-53.4l-4.7 0c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6L190.1 432l-28.4 56.8c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6l4.7 0c35.9 0 69.2-17.2 90.1-45.4l68 3.8c94.1 5.2 173.3-70 173.3-164.3c0-80.8-31.4-154.5-82.7-209.3l48-72zM176 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDolphin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jd);
var na = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "donut", f = 512, c = 512, e = [127849, "doughnut"], t = "e406", o = "M0 208C0 119.6 114.6 48 256 48s256 71.6 256 160l0 31c-.7 10-4.3 19.5-10.5 27.4c-6.2 8-14.7 14-24.4 17.1l-.3 .1-.3 .1c-13.1 4.9-24.4 13.8-32 25.5c-9.4 13-22 23.3-36.5 30.1c-14.7 6.8-30.8 9.6-46.9 8.3l-.6 0-.6 0c-17.7-.2-35.3 3.3-51.7 10.1c0 0 0 0 0 0l-.1 0c-16.4 7-34.1 10.5-51.9 10.3c0 0 0 0 0 0l-.3 0c-17.8 .2-35.5-3.3-51.9-10.3l-.1 0c-16.4-6.8-34-10.2-51.7-10.1l-.6 0-.6 0c-16.1 1.3-32.3-1.6-46.9-8.4c-14.6-6.8-27.1-17.1-36.5-30.2c-7.7-11.7-18.9-20.6-32-25.5l-.4-.1-.4-.1c-9.7-3.1-18.2-9.1-24.4-17.1C4.3 258.4 .7 248.9 0 238.9L0 208zm0 92.7c7.4 5.7 15.7 10.1 24.6 13c6.7 2.6 12.4 7.2 16.3 13.2l.2 .3 .2 .3c12.6 17.6 29.6 31.7 49.3 40.8c19.5 9 41 12.9 62.4 11.3c13.2-.1 26.3 2.5 38.5 7.6c20.4 8.6 42.4 13 64.5 12.8c22.1 .2 44.1-4.2 64.5-12.8c12.2-5.1 25.3-7.6 38.5-7.6c21.4 1.7 42.9-2.2 62.3-11.2c19.7-9.1 36.7-23.1 49.3-40.7l.2-.3 .2-.3c3.9-6 9.6-10.6 16.3-13.2c8.9-2.9 17.3-7.4 24.6-13l0 3.2c0 88.4-114.6 160-256 160S0 392.4 0 304l0-3.3zM320 192c0-17.7-28.7-32-64-32s-64 14.3-64 32s28.7 32 64 32s64-14.3 64-32zM283.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-112 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224 9.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm331.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm-240 16c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDonut = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(na);
var Bd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = na;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDoughnut = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Bd);
var Td = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down-from-bracket", f = 448, c = 512, e = [], t = "e66b", o = "M64 160l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-53-43-96-96-96L96 0C43 0 0 43 0 96l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32zm9.9 217.9L196.7 500.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L374.1 377.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L288 320l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C79.2 320 64 335.2 64 353.9c0 9 3.6 17.6 9.9 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDownFromBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Td);
var Fd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down-from-dotted-line", f = 448, c = 512, e = [], t = "e407", o = "M73.9 345.9L196.7 468.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L374.1 345.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L288 288l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C79.2 288 64 303.2 64 321.9c0 9 3.6 17.6 9.9 24zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM256 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM448 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDownFromDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fd);
var Hd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down-left", f = 384, c = 512, e = [], t = "e16a", o = "M48 432l240 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-72-72L372.7 171.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L331.3 75.3C324.1 68.1 314.2 64 304 64s-20.1 4.1-27.3 11.3L142.6 209.4l-72-72c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 240c0 17.7 14.3 32 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hd);
var Rd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down-right", f = 384, c = 512, e = [], t = "e16b", o = "M336 432L96 432c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l72-72L11.3 171.3C4.1 164.1 0 154.2 0 144s4.1-20.1 11.3-27.3L52.7 75.3C59.9 68.1 69.8 64 80 64s20.1 4.1 27.3 11.3L241.4 209.4l72-72c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 240c0 17.7-14.3 32-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDownRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rd);
var Ud = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down-to-bracket", f = 448, c = 512, e = [], t = "e4e7", o = "M378.1 198.6L249.5 341.4c-6.1 6.7-14.7 10.6-23.8 10.6l-3.5 0c-9.1 0-17.7-3.8-23.8-10.6L69.9 198.6c-3.8-4.2-5.9-9.8-5.9-15.5C64 170.4 74.4 160 87.1 160l72.9 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 128 72.9 0c12.8 0 23.1 10.4 23.1 23.1c0 5.7-2.1 11.2-5.9 15.5zM64 352l0 64c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 53-43 96-96 96L96 512c-53 0-96-43-96-96l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDownToBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ud);
var qd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "down-to-dotted-line", f = 448, c = 512, e = [], t = "e408", o = "M0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM73.9 249.9L196.7 372.7c7.2 7.2 17.1 11.3 27.3 11.3s20.1-4.1 27.3-11.3L374.1 249.9c6.4-6.4 9.9-15 9.9-24c0-18.7-15.2-33.9-33.9-33.9L288 192l0-128c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 128-62.1 0C79.2 192 64 207.2 64 225.9c0 9 3.6 17.6 9.9 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDownToDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qd);
var Gd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "draw-circle", f = 512, c = 512, e = [], t = "f5ed", o = "M472.1 196.7c-20.8-76-80.7-135.9-156.7-156.7C305.8 16.5 282.8 0 256 0s-49.8 16.5-59.3 39.9c-76 20.8-135.9 80.7-156.7 156.7C16.5 206.2 0 229.2 0 256s16.5 49.8 39.9 59.3c20.8 76 80.7 135.9 156.7 156.7c9.5 23.4 32.5 39.9 59.3 39.9s49.8-16.5 59.3-39.9c76-20.8 135.9-80.7 156.7-156.7c23.4-9.5 39.9-32.5 39.9-59.3s-16.5-49.8-39.9-59.3zM408 206c-14.7 11.7-24 29.8-24 50s9.4 38.3 24 50c-15.8 48.2-53.9 86.2-102 102c-11.7-14.7-29.8-24-50-24s-38.3 9.4-50 24c-48.2-15.8-86.2-53.9-102-102c14.7-11.7 24-29.8 24-50s-9.4-38.3-24-50c15.8-48.2 53.9-86.2 102-102c11.7 14.7 29.8 24 50 24s38.3-9.4 50-24c48.2 15.8 86.2 53.9 102 102z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDrawCircle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gd);
var Wd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "draw-square", f = 448, c = 512, e = [], t = "f5ef", o = "M96 151.4l0 209.1c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-209.1c-9.7-5.6-17.8-13.7-23.4-23.4l-209.1 0c-5.6 9.7-13.7 17.8-23.4 23.4zM119.4 448c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4l0-209.1C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32l209.1 0c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4l0 209.1c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32l-209.1 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDrawSquare = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wd);
var Ed = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dreidel", f = 448, c = 512, e = [], t = "f792", o = "M438.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 146.7 225.9 84.7c-18.7-18.7-49.1-18.7-67.9 0l-57.4 57.4L337.9 379.3l57.4-57.4c18.7-18.7 18.7-49.1 0-67.9L333.3 192 438.6 86.6zM315.3 401.9L78.1 164.7 18.7 224C6.7 236 0 252.3 0 269.3L0 416c0 35.3 28.7 64 64 64l146.7 0c17 0 33.3-6.7 45.3-18.7l59.3-59.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDreidel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ed);
var Vd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "drone", f = 512, c = 512, e = [], t = "f85f", o = "M223 127.2L171.6 88.7C162.3 64.9 139.1 48 112 48c-35.3 0-64 28.7-64 64c0 27.1 16.9 50.3 40.7 59.6L127.2 223c-5 .7-10.1 1-15.2 1C50.1 224 0 173.9 0 112S50.1 0 112 0s112 50.1 112 112c0 5.2-.3 10.2-1 15.2zm-49.6 2.8l39.8 29.9 .1 .1 85.3 0 .1-.1 39.8-29.9 29.7-22.3C370.3 92.1 383.8 80 400 80c17.7 0 32 14.3 32 32c0 16.2-12.1 29.7-27.8 31.7l-22.3 29.7-29.9 39.8-.1 .1 0 85.3 .1 .1 29.9 39.8 22.3 29.7c15.7 2.1 27.8 15.5 27.8 31.7c0 17.7-14.3 32-32 32c-16.2 0-29.7-12.1-31.7-27.8l-29.7-22.3-39.8-29.9-.1-.1-85.3 0-.1 .1-39.8 29.9-29.7 22.3C141.7 419.9 128.2 432 112 432c-17.7 0-32-14.3-32-32c0-16.2 12.1-29.7 27.8-31.7l22.3-29.7 29.9-39.8 .1-.1 0-85.3-.1-.1-29.9-39.8-22.3-29.7C92.1 141.7 80 128.2 80 112c0-17.7 14.3-32 32-32c16.2 0 29.7 12.1 31.7 27.8l29.7 22.3zM224 400c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c5.2 0 10.2 .3 15.2 1L88.7 340.4C64.9 349.7 48 372.9 48 400c0 35.3 28.7 64 64 64c27.1 0 50.3-16.9 59.6-40.7L223 384.8c.7 5 1 10.1 1 15.2zm65-272.8c-.7-5-1-10.1-1-15.2C288 50.1 338.1 0 400 0s112 50.1 112 112s-50.1 112-112 112c-5.2 0-10.2-.3-15.2-1l38.5-51.3c23.8-9.3 40.7-32.5 40.7-59.6c0-35.3-28.7-64-64-64c-27.1 0-50.3 16.9-59.6 40.7L289 127.2zM288 400c0-5.2 .3-10.2 1-15.2l51.3 38.5c9.3 23.8 32.5 40.7 59.6 40.7c35.3 0 64-28.7 64-64c0-27.1-16.9-50.3-40.7-59.6L384.8 289c5-.7 10.1-1 15.2-1c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDrone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vd);
var Id = {}, fa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "drone-front", f = 640, c = 512, e = ["drone-alt"], t = "f860", o = "M155.7 112c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16L24 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-108.3 0zM376 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-76.3 0c-5.5-9.6-15.9-16-27.7-16s-22.2 6.4-27.7 16L376 112zM96 192l0 64c0 12.6 7.4 24.1 19 29.2l56.5 25.1c-17.8 21.5-27.5 48.5-27.5 76.4l0 5.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-5.2c0-16.8 5.9-33.2 16.7-46.1l8.4-10.1L259 349.2c4.1 1.8 8.5 2.8 13 2.8l96 0c4.5 0 8.9-.9 13-2.8l41.9-18.6 8.4 10.1c10.8 12.9 16.7 29.3 16.7 46.1l0 5.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-5.2c0-27.9-9.7-54.9-27.5-76.4L525 285.2c11.6-5.1 19-16.6 19-29.2l0-64-64 0 0 43.2-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7L160 235.2l0-43.2-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDroneFront = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = fa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDroneAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Id);
var ca = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "droplet-percent", f = 384, c = 512, e = ["humidity"], t = "f750", o = "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0l1.8 0c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zm75.3-267.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDropletPercent = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ca);
var Kd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "drumstick", f = 512, c = 512, e = [127831], t = "f6d6", o = "M150.6 287.8c6-6 9.4-14.1 9.4-22.6l0-89.2C160 78.8 238.8 0 336 0s176 78.8 176 176s-78.8 176-176 176l-89.2 0c-8.5 0-16.6 3.4-22.6 9.4l-26.8 26.8c-12.3 12.3-11.4 32.5-7.2 49.4c1.1 4.6 1.8 9.5 1.8 14.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5 0 9.8 .6 14.5 1.8c16.9 4.2 37.1 5.2 49.4-7.2l26.8-26.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDrumstick = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kd);
var Xd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dryer", f = 448, c = 512, e = [], t = "f861", o = "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM336 304c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96l62.9 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-62.9 0c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDryer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xd);
var Qd = {}, ta = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "dryer-heat", f = 448, c = 512, e = ["dryer-alt"], t = "f862", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM156.7 212.7c-6.2 6.2-6.2 16.4 0 22.6L177.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm102.6 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L257.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-20.7-20.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDryerHeat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ta);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ta;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faDryerAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Qd);
var Jd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "duck", f = 512, c = 512, e = [129414], t = "f6d8", o = "M400.7 224c-.4 0-.7 .3-.7 .7l0 24c0 6.6 2.8 12.8 7.2 17.7C427.6 289.1 440 319.1 440 352c0 70.7-57.3 128-128 128l-116 0C87.8 480 0 392.2 0 284l0-5.4C0 266.1 10.1 256 22.6 256c6 0 11.8 2.4 16 6.6L54 278c6.2 6.2 15.2 8.5 23.6 6.1l172.8-49.4c10.4-3 15.7-14.5 7.8-21.7c-21-19-34.1-46.5-34.1-77c0-57.4 46.6-104 104-104c53.8 0 98.1 40.9 103.5 93.3c0 .4 .3 .6 .7 .7c10.5 1.3 21.2 1.3 31.8 0l35.3-4.4c6.8-.8 12.8 4.4 12.8 11.3c0 50.3-40.8 91.1-91.1 91.1l-20.2 0zM368 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM340.6 296.9c.5-8.8-6.2-16.4-15-16.9s-16.4 6.2-16.9 15c-2.4 41.2-32.6 79-77.3 90.1c-40.3 10.1-80.5-4.6-103.7-33.5c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c31.1 38.7 84 57.6 136.4 44.5c58-14.5 98.3-63.8 101.5-119.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faDuck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jd);
var Yd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ear", f = 384, c = 512, e = [128066], t = "f5f0", o = "M319.9 335.2c-18.2 16.3-30 39.1-35.1 62.9c-5.6 26.3-18.6 51.3-39 71.7c-56.2 56.2-147.4 56.2-203.6 0C14.1 441.7 0 404.9 0 368L0 192C0 86 86 0 192 0S384 86 384 192c0 56.9-24.8 108-64.1 143.2zM128 192c0-35.3 28.7-64 64-64s64 28.7 64 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-61.9-50.1-112-112-112S80 130.1 80 192l0 20.2c0 21.2 12 40.6 31 50.1l14 7c1.8 .9 3 2.8 3 4.9c0 1.6-.7 3.2-2 4.2L88.6 309.6c-10.2 8.5-11.6 23.6-3.1 33.8s23.6 11.6 33.8 3.1l37.4-31.2C169 305.1 176 290.1 176 274.2c0-20.2-11.4-38.8-29.5-47.8l-14-7c-2.7-1.4-4.4-4.1-4.4-7.2l0-20.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yd);
var Zd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ear-muffs", f = 640, c = 512, e = [], t = "f795", o = "M320 64c-78.2 0-143.3 56.1-157.2 130.2c-6-1.4-12.3-2.2-18.8-2.2c-17.7 0-34.1 5.8-47.4 15.6C105 91.5 201.8 0 320 0S535 91.5 543.4 207.6C530.1 197.8 513.7 192 496 192c-6.5 0-12.7 .8-18.8 2.2C463.3 120.1 398.2 64 320 64zM179.8 304c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32s-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48c-22.1 0-40.8-15-46.3-35.4C92.2 478.8 86.2 480 80 480c-26.5 0-48-21.5-48-48c0-6.2 1.2-12.2 3.4-17.7C15 408.8 0 390.1 0 368s15-40.8 35.4-46.3C33.2 316.2 32 310.2 32 304c0-26.5 21.5-48 48-48c6.2 0 12.2 1.2 17.7 3.4C103.2 239 121.9 224 144 224c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32zm280.4 0c-7.6-8.5-12.2-19.7-12.2-32c0-26.5 21.5-48 48-48c22.1 0 40.8 15 46.3 35.4c5.5-2.2 11.4-3.4 17.7-3.4c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7c0 26.5-21.5 48-48 48c-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEarMuffs = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zd);
var pd = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "eclipse", f = 640, c = 512, e = [], t = "f749", o = "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9l9.6 52.2c-34.2 15-63.7 38.9-85.4 68.8c-12.4-4-25.6-6.2-39.4-6.2c-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2c21.7 29.9 51.1 53.9 85.4 68.8l-9.6 52.2c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM256 160c7.6 0 15 .9 22.1 2.6C264 190.7 256 222.4 256 256s8 65.3 22.1 93.4c-7.1 1.7-14.5 2.6-22.1 2.6c-53 0-96-43-96-96s43-96 96-96zM464 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEclipse = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pd);
var xd = {}, oa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "moon-over-sun", f = 512, c = 512, e = ["eclipse-alt"], t = "f74a", o = "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM400 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-258 0c0-63.1 51.6-114 115-114c3.3 0 6.5 .1 9.7 .4c7 .6 12.8 5.7 14.3 12.6s-1.7 13.9-7.8 17.4c-22.9 12.8-38.3 37.1-38.3 64.8c0 41 33.6 74.5 75.4 74.5c4.4 0 8.8-.4 13-1.1c6.9-1.2 13.8 2.3 17 8.6s1.9 13.9-3.2 18.7c-20.7 19.9-49 32.2-80.1 32.2c-63.4 0-115-50.9-115-114z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoonOverSun = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = oa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faEclipseAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(xd);
var ir = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "egg-fried", f = 512, c = 512, e = [], t = "f7fc", o = "M284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7c27.5 7 52.8 23.2 71 47.8c42.1 56.8 30.2 137-26.6 179.1c-17.8 13.2-37.9 21.1-58.4 24c-37.2 5.2-84.5 32.7-103.3 65.2c-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM336 240a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-160-8c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-39.8 32.2-72 72-72c8.8 0 16 7.2 16 16s-7.2 16-16 16c-22.1 0-40 17.9-40 40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEggFried = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ir);
var ar = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "eggplant", f = 512, c = 512, e = [], t = "e16c", o = "M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9L496 192c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48c0-5.8-4-10.7-9.4-12.6c-13.3-4.8-25.4-13-35.1-22.8s-18-21.9-22.8-35.1c-2-5.4-6.9-9.4-12.6-9.4c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16l142.1 0 9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6c11.8 20 32.1 34.4 55.9 38.3c6.7 14 15.8 26.3 25.8 36.2s22.2 19.1 36.2 25.8c5 30.4 27.1 55.1 56.2 63.8C410.6 362.7 311.1 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEggplant = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ar);
var er = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "elephant", f = 640, c = 512, e = [128024], t = "f6da", o = "M304 0C242.1 0 192 50.1 192 112s50.1 112 112 112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144-64.5-144-144c0-25.3 6.5-49.1 18-69.8c-20.5 7-39.4 17.3-56.1 30.4C67.4 111.9 32 175.8 32 248l0 19c0 12.4-1.2 24.7-3.7 36.9c-1.9 9.3-5.8 18-11.4 25.6L4.8 345.6c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l12.1-16.2c3.2-4.3 6.1-8.8 8.7-13.5L64 480c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-70c15.3 3.9 31.4 6 48 6s32.7-2.1 48-6l0 70c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-139.3c16.7 18.9 38.8 32.8 64 39.3l0 18.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4l0-18.6c22.9-5.9 43.4-18 59.4-34.4c6.2-6.3 6.1-16.4-.2-22.6c-6.3-6.2-16.3-6.1-22.5 .1c-1.3 1.3-2.6 2.6-4 3.9c-1.5 1.4-3.1 2.7-4.6 4c-8.3 6.7-17.8 12-28 15.6c0 0 0 0 0 0c-10 3.5-20.8 5.5-32 5.5s-22-1.9-32-5.5c0 0 0 0 0 0c-7.5-2.6-14.6-6.2-21.1-10.5c0 0 0 0 0 0c-9.1-6.1-17.2-13.7-23.7-22.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2C472.5 310 491.1 320 512 320c11.7 0 22.6-3.1 32-8.6L544 192c0-88.4-71.6-160-160-160l-1.6 0C362.2 12.2 334.5 0 304 0zM464 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faElephant = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(er);
var nr = {}, la = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ellipsis-stroke", f = 512, c = 512, e = ["ellipsis-h-alt"], t = "f39b", o = "M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144zM256 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-96a72 72 0 1 0 0 144 72 72 0 1 0 0-144zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-96 0a72 72 0 1 0 144 0A72 72 0 1 0 24 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEllipsisStroke = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(la);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = la;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faEllipsisHAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(nr);
var da = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ellipsis-stroke-vertical", f = 192, c = 512, e = ["ellipsis-v-alt"], t = "f39c", o = "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 96A72 72 0 1 1 96 24a72 72 0 1 1 0 144zm24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 256zm96 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEllipsisStrokeVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(da);
var fr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = da;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faEllipsisVAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(fr);
var cr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "empty-set", f = 512, c = 512, e = [8709, 216], t = "f656", o = "M435.4 121.9l67.2-67.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l67.2-67.2c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1zm-91.2 .7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5zm-176.5 267L389.5 167.8C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEmptySet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cr);
var tr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "engine", f = 640, c = 512, e = [], t = "e16e", o = "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L208 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 0 32-72 0-48 0-32 0c-17.7 0-32 14.3-32 32l0 56-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 352c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 72c0 17.7 14.3 32 32 32l44.8 0 32 40c12.1 15.2 30.5 24 50 24L448 448c35.3 0 64-28.7 64-64l0-145.2c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14L328 144l0-32 72 0zM544 224l0 192c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm-256 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEngine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tr);
var or = {}, ra = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "engine-warning", f = 640, c = 512, e = ["engine-exclamation"], t = "f5f2", o = "M400 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L208 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 0 32-72 0-48 0-32 0c-17.7 0-32 14.3-32 32l0 56-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 352c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 72c0 17.7 14.3 32 32 32l44.8 0 32 40c12.1 15.2 30.5 24 50 24L448 448c35.3 0 64-28.7 64-64l0-145.2c0-19.4-8.8-37.8-24-50L449.5 158c-11.3-9.1-25.4-14-40-14L328 144l0-32 72 0zM544 224l0 192c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zM304 188c11 0 20 9 20 20l0 88c0 11-9 20-20 20s-20-9-20-20l0-88c0-11 9-20 20-20zM280 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEngineWarning = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ra);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ra;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faEngineExclamation = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(or);
var lr = {}, sa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "envelope-dot", f = 576, c = 512, e = ["envelope-badge"], t = "e16f", o = "M496 0a80 80 0 1 1 0 160A80 80 0 1 1 496 0zM48 64l337.1 0c-.7 5.2-1.1 10.6-1.1 16c0 45.6 27.2 84.8 66.3 102.3L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112C0 85.5 21.5 64 48 64zM294.4 339.2L490.8 191.9c1.7 .1 3.4 .1 5.2 .1c5.4 0 10.8-.4 16-1.1L512 384c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 176 217.6 339.2c22.8 17.1 54 17.1 76.8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEnvelopeDot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = sa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faEnvelopeBadge = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lr);
var dr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = x2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faEnvelopeCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(dr);
var rr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "envelope-open-dollar", f = 512, c = 512, e = [], t = "f657", o = "M215.4 96L144 96l-36.2 0L96 96l0 8.8L96 144l0 40.4 0 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3 48 96c0-26.5 21.5-48 48-48l76.6 0 49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48 416 48c26.5 0 48 21.5 48 48l0 44.3 22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4l0-89 0-40.4 0-39.2 0-8.8-11.8 0L368 96l-71.4 0-81.3 0zM0 448L0 242.1 217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1 512 448s0 0 0 0c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64c0 0 0 0 0 0zM276 136l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c0 0 0 0 0 0c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEnvelopeOpenDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rr);
var sr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "envelopes", f = 576, c = 512, e = [], t = "e170", o = "M316.7 249.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4l220-163C570.8 55.7 544.2 32 512 32L160 32c-32.2 0-58.8 23.7-63.3 54.7l220 163zm57.7 25.7C363.3 283.6 349.8 288 336 288s-27.3-4.4-38.4-12.7L96 126l0 194c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-194L374.4 275.3zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEnvelopes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sr);
var hr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "escalator", f = 640, c = 512, e = [], t = "e171", o = "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM405.9 175.8C417.5 165.6 432.5 160 448 160l96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-72 0L234.1 496.2C222.5 506.4 207.5 512 192 512l-96 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l72 0L405.9 175.8zM320 192l0 16.4-128 112L192 192c0-35.3 28.7-64 64-64s64 28.7 64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEscalator = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hr);
var vr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "excavator", f = 640, c = 512, e = [], t = "e656", o = "M160 64l0 96 142.9 0-64-96L160 64zM384 190.5l0 17.5 0 16 0 48c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l48 0L96 48c0-26.5 21.5-48 48-48l94.9 0c21.4 0 41.4 10.7 53.3 28.5l78.4 117.7c8.8 13.1 13.4 28.6 13.4 44.4zM80 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 416zM0 432c0-44.2 35.8-80 80-80l256 0c44.2 0 80 35.8 80 80s-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80zM640 320l0 64 0 48c0 44.2-35.8 80-80 80l-78.1 0c-18.7 0-33.9-15.2-33.9-33.9c0-9 3.6-17.6 9.9-24L576 336l0-208L416 288l0-128L562.7 13.3c8.5-8.5 20-13.3 32-13.3c25 0 45.3 20.3 45.3 45.3L640 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faExcavator = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vr);
var ur = {}, ha = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-exclamation", f = 448, c = 512, e = ["exclamation-square"], t = "f321", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm160 96c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ha);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ha;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faExclamationSquare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ur);
var mr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ci;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faExpandArrows = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(mr);
var gr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "expand-wide", f = 512, c = 512, e = [], t = "f320", o = "M32 64C14.3 64 0 78.3 0 96l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 64zM64 320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM384 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM512 320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faExpandWide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gr);
var Pr = {}, va = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-explode", f = 512, c = 512, e = ["exploding-head"], t = "e2fe", o = "M320 196.5c0 7.9 2.5 15.4 7 21.6c-14.5-6.6-31.5-5.6-45.3 3l-17.3 10.8c-5.2 3.2-11.8 3.2-17 0L230.2 221c-13.8-8.6-30.8-9.6-45.3-3c4.5-6.2 7-13.7 7-21.6l0-4.5c0-17.7-14.3-32-32-32l-40 0c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56l-40 0c-17.7 0-32 14.3-32 32l0 4.5zM299 248c5.1-3 11.4-3 16.4 0c0 0 0 0 0 0c.1 .1 .2 .1 .3 .2L333 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c5.2-3.2 11.8-3.2 17 0l20.7 12.9c12.8 8 28.6 9.5 42.7 4.1L512 253.5c0 .8 0 1.7 0 2.5c0 141.4-114.6 256-256 256S0 397.4 0 256c0-.8 0-1.7 0-2.5l30.5 11.7c14.1 5.4 29.9 3.9 42.7-4.1l20.7-12.9c5.2-3.2 11.8-3.2 17 0L128.2 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1 .2-.1 .3-.2c0 0 0 0 0 0c5.1-3 11.4-3 16.4 0c0 0 0 0 0 0c.1 .1 .2 .1 .3 .2L230.6 259c15.6 9.7 35.3 9.7 50.9 0l17.3-10.8c.1-.1 .2-.1 .3-.2c0 0 0 0 0 0zm-90.6 88a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 437.3c0 5.9 4.8 10.7 10.7 10.7l106.7 0c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3l-21.3 0c-29.5 0-53.3 23.9-53.3 53.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceExplode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(va);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = va;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faExplodingHead = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Pr);
var Mr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "eye-dropper-full", f = 512, c = 512, e = [], t = "e172", o = "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480l42.4 0c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9 176.1 202.6 55.4 323.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEyeDropperFull = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mr);
var wr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "eye-dropper-half", f = 512, c = 512, e = [], t = "e173", o = "M240.1 130.8L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4zm-63.9 71.8l45.3 45.3L149.3 320l85.5 0 29.4-29.4 45.3 45.3L188.7 456.6c-15 15-35.4 23.4-56.6 23.4l-42.4 0L49.8 506.6c-12.7 8.5-29.6 6.8-40.4-4s-12.5-27.7-4-40.4L32 422.3l0-42.4c0-21.2 8.4-41.6 23.4-56.6L176.1 202.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEyeDropperHalf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wr);
var Nr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "eye-evil", f = 640, c = 512, e = [], t = "f6db", o = "M254.9 112.2c-10.7 2.8-21.1 6.3-30.9 10.4L114.4 76.1c-8.7-3.7-18.7-1-24.4 6.5s-5.5 17.9 .4 25.2l57.3 70.8c-7 9-12.8 18.6-17.3 28.6L15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9l114.9 28.7c4.5 10.1 10.3 19.7 17.3 28.6L90.4 404.1c-5.9 7.3-6.1 17.7-.4 25.2s15.7 10.2 24.4 6.5L224 389.4c9.8 4.1 20.1 7.6 30.9 10.4l42.7 97.6c3.9 8.9 12.7 14.7 22.4 14.7s18.5-5.8 22.4-14.7l42.7-97.6c10.7-2.8 21.1-6.3 30.9-10.4l109.7 46.5c8.7 3.7 18.7 1 24.4-6.5s5.5-17.9-.4-25.2l-57.3-70.8c7-9 12.8-18.6 17.3-28.6l114.9-28.7c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9L509.6 207.4c-4.5-10.1-10.3-19.7-17.3-28.6l57.3-70.8c5.9-7.3 6.1-17.7 .4-25.2s-15.7-10.2-24.4-6.5L416 122.6c-9.8-4.1-20.1-7.6-30.9-10.4L342.4 14.7C338.5 5.8 329.7 0 320 0s-18.5 5.8-22.4 14.7l-42.7 97.6zM320 352c-53 0-96-43-96-96c0-19.7 6-38.1 16.2-53.3c16.6 9.6 35 16.2 54.7 19.3c-3.9 9.4-6.8 20.8-6.8 34c0 31.5 16.5 52.7 23.8 60.6c2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c7.3-7.9 23.8-29.2 23.8-60.6c0-13.2-2.9-24.6-6.8-34c19.6-3.1 38.1-9.8 54.7-19.3C410 217.9 416 236.3 416 256c0 53-43 96-96 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEyeEvil = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nr);
var zr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "eyes", f = 640, c = 512, e = [], t = "e367", o = "M96 224c-11.1 0-21.6 2.8-30.7 7.8c4-36.7 16.8-68.8 34.5-92.4C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64zm224-97.3c-5-9.1-10.5-17.6-16.6-25.7C272.8 60.2 228.1 32 176 32s-96.8 28.2-127.4 69C18 141.8 0 196.7 0 256s18 114.2 48.6 155c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7c5 9.1 10.5 17.6 16.6 25.7c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155C560.8 60.2 516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7zm54.4 224.6c3.1 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c4-36.7 16.8-68.8 34.5-92.4C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4c-4.9-6.5-9.4-13.6-13.4-21.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faEyes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zr);
var Lr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-angry-horns", f = 640, c = 512, e = [], t = "e368", o = "M576 256c0 141.4-114.6 256-256 256S64 397.4 64 256c0-24.6 3.5-48.4 9.9-70.9C29.6 125.8 6.5 50.1 .3 19.1C-1 12.8 1.7 6.3 7.1 2.7s12.4-3.6 17.8 0c19.3 12.9 48.5 24.2 78.4 33.1c23.3 7 46 12.2 63 15.5C209.1 19.1 262.3 0 320 0s110.9 19.1 153.8 51.3c17-3.3 39.7-8.6 63-15.5c29.8-8.9 59.1-20.2 78.4-33.1c5.4-3.6 12.4-3.6 17.8 0s8.1 10.1 6.8 16.4c-6.2 31-29.3 106.6-73.6 166c6.5 22.5 9.9 46.3 9.9 70.9zM402.7 411.9c6.6-5.9 7.1-16 1.2-22.6C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceAngryHorns = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lr);
var Cr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-anguished", f = 512, c = 512, e = [], t = "e369", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceAnguished = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cr);
var Dr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-anxious-sweat", f = 576, c = 512, e = [], t = "e36a", o = "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5zM208 400c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceAnxiousSweat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dr);
var $r = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-astonished", f = 512, c = 512, e = [], t = "e36b", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-208c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceAstonished = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($r);
var ua = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-awesome", f = 512, c = 512, e = ["gave-dandy"], t = "e409", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm203.5-95.6c-5.6 9.4-15.8 15.6-27.5 15.6c-17.7 0-32-14.3-32-32c0-9.1 3.8-17.4 10-23.2c-3.3-.5-6.6-.8-10-.8c-35.3 0-64 28.7-64 64l0 10.3c0 16.4 13.3 29.7 29.7 29.7l68.6 0c16.4 0 29.7-13.3 29.7-29.7l0-10.3c0-8.3-1.6-16.3-4.5-23.6zM384 176c-17.7 0-32-14.3-32-32c0-8.5 3.3-16.3 8.8-22c-5.4-1.3-11-2-16.8-2c-39.8 0-72 32.2-72 72l0 7.5c0 13.5 11 24.5 24.5 24.5l95.1 0c13.5 0 24.5-11 24.5-24.5l0-7.5c0-10.4-2.2-20.2-6.1-29.1c-5.8 8-15.2 13.1-25.9 13.1zM245.5 447.8c2.7 .1 5.4 .2 8.1 .2l4.9 0c55.1 0 105.1-26.1 137-67.5c0 0 0 0 0 0c15.7-20.5 27-44.6 32.4-71.3c2.2-11-6.2-21.2-17.4-21.2c0 0 0 0 0 0l-308.8 0s0 0 0 0c-11.2 0-19.6 10.2-17.4 21.2c15.6 78.1 82.4 135 161.2 138.6zm-5.4-32.5c1.5-44.1 37.8-79.4 82.2-79.4c19.9 0 38.1 7 52.3 18.7C349 392.1 306.1 416 258.4 416l-4.9 0c-4.6 0-9.1-.2-13.5-.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceAwesome = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ua);
var _r = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-beam-hand-over-mouth", f = 512, c = 512, e = [129325], t = "e47c", o = "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52l0 53.6 0 32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM217.6 212.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 172.4 120 190.1 120 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 172.4 280 190.1 280 208c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm-78.3 63.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20s20 9 20 20l0 19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceBeamHandOverMouth = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_r);
var br = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-clouds", f = 640, c = 512, e = [], t = "e47d", o = "M128 0C104.3 0 83.6 12.9 72.6 32L64 32C28.7 32 0 60.7 0 96s28.7 64 64 64l160 0c35.3 0 64-28.7 64-64s-28.7-64-64-64c-13.2 0-25.4 4-35.6 10.8C179.7 17.9 155.9 0 128 0zM72.1 192c-5.3 20.5-8.1 41.9-8.1 64c0 114.6 75.4 211.7 179.3 244.3c-12.1-17-19.3-37.8-19.3-60.3c0-50.6 36.2-92.8 84.1-102.1C321.2 290.7 364.6 256 416 256c29.1 0 55.6 11.1 75.5 29.2c8.9-3.4 18.5-5.2 28.5-5.2c20 0 38.3 7.3 52.3 19.5c2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96c0 39.6-24 73.6-58.2 88.3c6.5 5.9 10.5 14.3 10.5 23.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L72.1 192zm328.3-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 368l-8 0c-39.8 0-72 32.2-72 72s32.2 72 72 72l240 0c39.8 0 72-32.2 72-72s-32.2-72-72-72l-.7 0c.4-2.6 .7-5.3 .7-8c0-26.5-21.5-48-48-48c-13.9 0-26.4 5.9-35.1 15.3C470.9 303.8 445.3 288 416 288c-44.2 0-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceClouds = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(br);
var Sr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-confounded", f = 512, c = 512, e = [], t = "e36c", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM116 205.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-161.6 160L256 380.8l39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceConfounded = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sr);
var yr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-confused", f = 512, c = 512, e = [], t = "e36d", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.1 395.6l-1.1 .9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304l11 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-11 0c-61.8 0-121.7 21-169.9 59.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceConfused = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yr);
var Or = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-cowboy-hat", f = 512, c = 512, e = [], t = "e36e", o = "M216 0c9.1 0 17.9 4 26.1 10.7c7.9 6.5 19.8 6.5 27.7 0C278.1 4 286.9 0 296 0c36.8 0 67.4 64.9 82.4 109.8C412 99.3 442 84.6 466.9 66.8c2.5-1.8 5.4-2.8 8.4-2.8c8.9 0 15.6 8.3 12.9 16.7C461.2 163.2 367.5 224 256 224S50.8 163.2 23.8 80.7C21 72.3 27.7 64 36.7 64c3 0 6 1 8.4 2.8C70 84.6 100 99.3 133.6 109.8C148.6 64.9 179.2 0 216 0zM48 304c0-37.9 10.1-73.4 27.8-104c48.8 35.3 112.5 56 180.2 56s131.4-20.6 180.2-56c17.7 30.6 27.8 66.1 27.8 104c0 114.9-93.1 208-208 208S48 418.9 48 304zm299.8 60.7c-27.9 7.8-59 12.1-91.6 12.1s-63.7-4.3-91.6-12.1c-12.4-3.5-24.3 7.3-18.6 18.8C166.2 424.1 208 452 256.2 452s90-27.9 110.2-68.6c5.7-11.5-6.2-22.2-18.6-18.8zM216 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceCowboyHat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Or);
var kr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-diagonal-mouth", f = 512, c = 512, e = [129764], t = "e47e", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM372.4 319.4l-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceDiagonalMouth = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kr);
var Ar = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-disappointed", f = 512, c = 512, e = [], t = "e36f", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceDisappointed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ar);
var jr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-disguise", f = 512, c = 512, e = [], t = "e370", o = "M256 512c141.4 0 256-114.6 256-256c0-16.4-1.5-32.5-4.5-48L440 208c0 50.1-38.4 91.2-87.3 95.6c9.6 7.9 15.3 19.7 15.3 32.4c0 15.9-9 30.4-23.1 37.5L364.5 398c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5l-23.9-29.9-7.3 3.6 10.5 26.3c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-10-24.9c-2.4 .7-4.8 1.3-7.2 1.8l0 25.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.2c-2.4-.5-4.8-1.1-7.2-1.8l-10 24.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l10.5-26.3-7.3-3.6L172.5 418c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l19.6-24.5C153 366.4 144 351.9 144 336c0-12.7 5.7-24.5 15.3-32.4C110.4 299.2 72 258.1 72 208L4.5 208C1.5 223.5 0 239.6 0 256C0 397.4 114.6 512 256 512zm61.9-245.5c7.9 3.5 16.8 5.5 26.1 5.5c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 2.5 .1 4.9 .4 7.3c5.4 3.6 10.1 8.4 13.5 14.1l21.4 35.7c1.1 .6 1.9 1 2.6 1.3zM232 208c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c9.3 0 18.1-2 26.1-5.5c.6-.3 1.5-.7 2.6-1.3L218 229.5c3.5-5.8 8.1-10.6 13.5-14.1c.3-2.4 .4-4.9 .4-7.3zM12.7 176l64.7 0c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l3.5 7c4.6-2 9.3-3.6 14.2-4.9l0-19c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.3c4.4 .4 8.7 1 13 2l4.7-9.5c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1c7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.7 9.5c4.2-.9 8.6-1.6 13-2L336 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-5.2 10.3c11.3 10.5 20.1 23.7 25.4 38.5l64.7 0C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176zM256 240c-4.3 0-8.3 2.3-10.5 6l-39.8 66.3-2.4 4-4.2 2.1-17.7 8.8c-3.4 1.7-5.5 5.1-5.5 8.8s2.1 7.2 5.5 8.8l53.1 26.5c13.5 6.8 29.4 6.8 42.9 0l53.1-26.5c3.4-1.7 5.5-5.1 5.5-8.8s-2.1-7.2-5.5-8.8l-17.7-8.8-4.2-2.1-2.4-4L266.5 246c-2.2-3.7-6.2-6-10.5-6zM144 216a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceDisguise = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jr);
var Br = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-dotted", f = 512, c = 512, e = [129765], t = "e47f", o = "M216 3.1C229 1.1 242.4 0 256 0s27 1.1 40 3.1c17.5 2.7 29.4 19.1 26.6 36.6s-19.1 29.4-36.6 26.6C276.3 64.8 266.3 64 256 64s-20.3 .8-30.1 2.3c-17.5 2.7-33.8-9.2-36.6-26.6S198.5 5.9 216 3.1zM150.2 55.9c10.4 14.3 7.2 34.3-7 44.7c-16.3 11.9-30.7 26.2-42.5 42.5c-10.4 14.3-30.4 17.4-44.7 7s-17.4-30.4-7-44.7c15.8-21.7 34.9-40.8 56.6-56.6c14.3-10.4 34.3-7.2 44.7 7zm211.6 0c10.4-14.3 30.4-17.4 44.7-7c21.7 15.8 40.8 34.9 56.6 56.6c10.4 14.3 7.2 34.3-7 44.7s-34.3 7.2-44.7-7c-11.9-16.3-26.2-30.7-42.5-42.5c-14.3-10.4-17.4-30.4-7-44.7zM472.3 189.3c17.5-2.7 33.8 9.2 36.6 26.6c2.1 13.1 3.1 26.4 3.1 40s-1.1 27-3.1 40c-2.7 17.5-19.1 29.4-36.6 26.6s-29.4-19.1-26.6-36.6c1.5-9.8 2.3-19.8 2.3-30.1s-.8-20.3-2.3-30.1c-2.7-17.5 9.2-33.8 26.6-36.6zm-432.6 0c17.5 2.7 29.4 19.1 26.6 36.6C64.8 235.7 64 245.7 64 256s.8 20.3 2.3 30.1c2.7 17.5-9.2 33.8-26.6 36.6S5.9 313.5 3.1 296C1.1 283 0 269.6 0 256s1.1-27 3.1-40c2.7-17.5 19.1-29.4 36.6-26.6zM55.9 361.8c14.3-10.4 34.3-7.2 44.7 7c11.9 16.3 26.2 30.7 42.5 42.5c14.3 10.4 17.4 30.4 7 44.7s-30.4 17.4-44.7 7c-21.7-15.8-40.8-34.9-56.6-56.6c-10.4-14.3-7.2-34.3 7-44.7zm400.1 0c14.3 10.4 17.4 30.4 7 44.7c-15.8 21.7-34.9 40.8-56.6 56.6c-14.3 10.4-34.3 7.2-44.7-7s-7.2-34.3 7-44.7c16.3-11.9 30.7-26.2 42.5-42.5c10.4-14.3 30.4-17.4 44.7-7zM189.3 472.3c2.7-17.5 19.1-29.4 36.6-26.6c9.8 1.5 19.8 2.3 30.1 2.3s20.3-.8 30.1-2.3c17.5-2.7 33.8 9.2 36.6 26.6s-9.2 33.8-26.6 36.6c-13.1 2.1-26.4 3.1-40 3.1s-27-1.1-40-3.1c-17.5-2.7-29.4-19.1-26.6-36.6zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM184 328l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceDotted = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Br);
var Tr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-downcast-sweat", f = 512, c = 512, e = [], t = "e371", o = "M35.2 126.3c4.1 1.1 8.4 1.7 12.8 1.7c26.5 0 48-21 48-47c0-5-1.8-11.3-4.6-18.1c-.3-.7-.6-1.4-.9-2.1c-8.9-20.2-26.5-44.9-36-57.5c-3.2-4.4-9.6-4.4-12.8 0C28.6 20.6 0 61 0 81c0 21.7 14.9 39.8 35.2 45.3zM256 0c-51.4 0-99.3 15.2-139.4 41.2c1.5 3.1 3 6.2 4.3 9.3c3.4 8 7.1 19 7.1 30.5c0 44.3-36.6 79-80 79c-9.6 0-18.8-1.7-27.4-4.8C7.3 186.2 0 220.2 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM195.9 410.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7zM96 272c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm208-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceDowncastSweat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tr);
var Fr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-drooling", f = 512, c = 512, e = [], t = "e372", o = "M384 477.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c33.9 0 66.4-6.6 96-18.6l0-122.4c-9.7 6.4-20.3 12.2-32 16.9l0 60.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-50.9c-10.1 1.9-20.8 2.9-32 2.9c-67 0-113.8-36.7-140.5-70c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5c-3.8 4.7-7.9 9.5-12.5 14.2l0 133.6zM158.6 189.6c-8.4 8-13.5 17.7-15.4 23.5c-2.8 8.4-11.9 12.9-20.2 10.1s-12.9-11.9-10.1-20.2c3.4-10.2 11.1-24.6 23.8-36.5C149.5 154.2 167.9 144 192 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-14.3 0-25.2 5.8-33.4 13.6zm210.2 23.5c-1.9-5.8-7-15.4-15.4-23.5c-8.2-7.8-19-13.6-33.4-13.6c-8.8 0-16-7.2-16-16s7.2-16 16-16c24.1 0 42.5 10.2 55.4 22.4c12.6 12 20.4 26.3 23.8 36.5c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceDrooling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fr);
var Hr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-exhaling", f = 576, c = 512, e = [], t = "e480", o = "M256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7C329.3 410.6 320 398.1 320 384s9.3-26.6 22.8-30.6L385 340.7c5.3-30 31.5-52.7 63-52.7c.7 0 1.4 0 2.1 0c13.2-14.7 32.3-24 53.7-24c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM195.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm121.6 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM256 344a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm287.4-5.5c.1-.8 .1-1.7 .1-2.5c0-22.1-17.9-40-39.9-40c-16.9 0-31.4 10.5-37.2 25.4c-3.3-.9-6.9-1.4-10.5-1.4c-22.1 0-39.9 17.9-39.9 40l-56.1 14.1c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9l56.9 14.2c-.5 2.5-.8 5.1-.8 7.8c0 22.1 17.9 40 39.9 40c4.9 0 9.6-.9 14-2.5c7.1 11.1 19.5 18.5 33.7 18.5c22.1 0 39.9-17.9 39.9-40c0-.8 0-1.7-.1-2.5c19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceExhaling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hr);
var Rr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-expressionless", f = 512, c = 512, e = [], t = "e373", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 336l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM128 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm176-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceExpressionless = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rr);
var Ur = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-eyes-xmarks", f = 512, c = 512, e = [], t = "e374", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM123.3 132.7L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm192 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM256 304c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceEyesXmarks = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ur);
var qr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-fearful", f = 512, c = 512, e = [], t = "e375", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM96 224a64 64 0 1 1 128 0A64 64 0 1 1 96 224zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8zM192.4 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceFearful = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qr);
var Gr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-frown-slight", f = 512, c = 512, e = [], t = "e376", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm91.9-117.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceFrownSlight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gr);
var Wr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-glasses", f = 512, c = 512, e = [], t = "e377", o = "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256c0-22.1 2.8-43.5 8.1-64L48 192l0 56c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-56 32 0 0 56c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-56 39.9 0c5.3 20.5 8.1 41.9 8.1 64zM256 0C363.4 0 455.4 66.2 493.4 160l-34.8 0c-9-18.9-28.3-32-50.6-32l-80 0c-22.3 0-41.6 13.1-50.6 32l-42.8 0c-9-18.9-28.3-32-50.6-32l-80 0c-22.3 0-41.6 13.1-50.6 32l-34.8 0C56.6 66.2 148.6 0 256 0zM80 192l0-8c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 64c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-56zm61.5 147.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM304 184c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 8 0 56c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-64zM184.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceGlasses = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wr);
var Er = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-hand-over-mouth", f = 512, c = 512, e = [129762], t = "e378", o = "M512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c18.1-18.1 18.7-47.1 1.8-65.9c16.9-18.8 16.3-47.8-1.8-65.9c-1-1-2.1-2-3.2-3c3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2c-18.7-18.7-49.1-18.7-67.9 0L207 301.1c-9.4-13.7-25.1-22.7-43-22.7c-28.7 0-52 23.3-52 52l0 53.6 0 32.8c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-37.1 52.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20s20 9 20 20l0 19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceHandOverMouth = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Er);
var Vr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-hand-peeking", f = 640, c = 512, e = [129763], t = "e481", o = "M497.8 144.3c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0C248.5 0 183.8 29.3 137.3 76.6c7.7 1.8 14.9 5.7 20.9 11.7c17.2 17.2 17.2 45 0 62.2l-1.5 1.5 75.2 0c22.1 0 40 17.9 40 40c0 2.6-.2 5.1-.7 7.5c10.1 7.3 16.7 19.1 16.7 32.5s-6.6 25.3-16.7 32.5c.5 2.4 .7 4.9 .7 7.5c0 22.1-17.9 40-40 40l-8 0c0 .3 0 .6 0 .9c0 22.1-17.9 40-40 40l-64.8 0c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2c-5.4 .7-10.8 1.1-16.3 1.1l-64.8 0c-22.1 0-40-17.9-40-40l0-.3 0-.6-8 0c-22.1 0-40-17.9-40-40c0-1.1 0-2.2 .1-3.3c-37-10.4-64.1-44.4-64.1-84.7c0-48.6 39.4-88 88-88c6.6 0 13 .7 19.2 2.1c11.8-4 25.2-2.4 36.1 5.4l37.9 27.1c1.1-9.6 5.3-18.9 12.6-26.2zM320 448c-35.3 0-64-21.5-64-48s28.7-48 64-48s64 21.5 64 48s-28.7 48-64 48zm90.3-208c3.8-4.2 6.1-9.9 6.1-16c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16l35.8 0zM248 192c0-8.8-7.2-16-16-16l-113.8 0c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9l64.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-14 0c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5l62 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-62.4 0c-2.2 0-4-1.8-4-4s1.8-4 4-4l78.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-78.4 0c-2.2 0-4-1.8-4-4s1.8-4 4-4l62.4 0c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9c0 7.4-6 13.4-13.4 13.4L392 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l84 0c2.2 0 4 1.8 4 4s-1.8 4-4 4l-68 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l67.5 0c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5l-19.5 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64.8 0c25.2 0 49.5-10 67.3-27.9c36.9-36.9 37.2-96.6 .8-133.8l-.8-.8L543 161.3c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19c-2.8 .3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceHandPeeking = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vr);
var Ir = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-hand-yawn", f = 512, c = 512, e = [], t = "e379", o = "M336.9 498.9C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-32.8 0-53.6c0-28.7 23.3-52 52-52c1.8 0 3.6 .1 5.3 .3C184.8 246.3 217.8 224 256 224c28.7 0 54.5 12.6 72.1 32.6c14.8-2.4 30.4 2 41.8 13.4c12.2 12.2 16.5 29.4 12.8 45c1.1 .9 2.2 1.9 3.2 3c18.1 18.1 18.7 47.1 1.8 65.9c16.9 18.8 16.3 47.8-1.8 65.9l-49 49zM204.5 102c5.5 6.9 4.4 17-2.5 22.5l-80 64c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l80-64c6.9-5.5 17-4.4 22.5 2.5zM310 124.5c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5l80 64c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5l-80-64zM299.3 276.7c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceHandYawn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ir);
var Kr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-head-bandage", f = 576, c = 512, e = [], t = "e37a", o = "M288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2c-8.2 2-15.3 7.1-19.7 14.3C26.9 130.6 15 158.9 7.8 189c-2.4 10.2 .3 20.9 7.2 28.7c-2.5 2.8-4.9 5.6-7.3 8.5c-4.7 5.5-7.3 12.4-7.6 19.6C.1 249.2 0 252.6 0 256c0 31.4 5 61.7 14.4 90.1c3.8 11.6 13.9 20 26 21.7c5.6 .8 11.2 0 16.3-2C97.8 452.2 185.9 512 288 512c141.4 0 256-114.6 256-256c0-9.5-.5-18.8-1.5-28c6.1-1.1 11.9-3.9 16.5-8.3c8.3-7.9 11.8-19.6 9.2-30.7c-7.2-30.1-19.1-58.4-34.9-84.1c-3.3-5.3-8-9.5-13.5-12.1c-.6-6-2.9-11.9-6.9-16.8c-21.2-26.5-47-49.1-76.2-66.8c-6.1-3.7-13.4-5.2-20.5-4.4c-16.2 2-32.2 4.6-48.1 7.9C342.9 4.5 316 0 288 0zM219.2 98.5s0 0 0 0s0 0 0 0C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4c2.2 .3 4.4 .6 6.6 .9c31.7 4.3 62.9 10.1 93.5 17.5l.3 .5c7.3 11.9 13.7 24.4 19 37.5c4.8 11.8 8.7 24.1 11.7 36.7c-11.9-3.6-23.9-6.9-36-10c-59.4-15.1-121.2-24-184.8-26l-.8 0c-9.1-.3-18.3-.4-27.5-.4c-17.1 0-34.1 .5-51 1.5c-48.2 2.8-95.4 9.6-141.2 20c-7 1.6-13.9 3.3-20.9 5c-12.1 3.1-24.1 6.4-36 10c.5-2 1-4 1.5-6c2.8-10.5 6.2-20.8 10.2-30.7c5.4-13.3 11.8-26 19.3-38c23.2-5.6 46.8-10.3 70.7-14.1c0 0 0 0 0 0c.8-.1 1.6-.3 2.5-.4c25-3.9 50.4-6.9 76.1-8.7zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1c-40.6 29.4-77 64.4-108 103.7c-8.5 10.7-16.5 21.7-24.2 33.1c-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5zm126 13.6c13.5-10.8 27.6-20.9 42.1-30.4c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32zM476.2 82.4C419.3 71.1 360.6 64.9 300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c13.7 8.3 26.6 17.9 38.5 28.5c6.1 5.5 11.9 11.2 17.5 17.2zm-103 315.1C356.4 382.2 330.8 368 296 368c-13.1 0-24.8 2-35.2 5.3c-8.4 2.7-17.4-2-20.1-10.5s2-17.4 10.5-20.1c13.4-4.2 28.4-6.8 44.8-6.8c44.2 0 77.2 18.3 98.8 37.9c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1zM368.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceHeadBandage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kr);
var Xr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-holding-back-tears", f = 512, c = 512, e = [129401], t = "e482", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM344.5 367.9c-6.7-5.8-16.8-5.1-22.6 1.6C309 384.4 287.1 400 256 400s-53-15.6-65.9-30.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6C183.1 410.3 213.2 432 256 432s72.9-21.7 90.1-41.5c5.8-6.7 5.1-16.8-1.6-22.6zM240 272l0-32c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9c1 8.1 7.9 14 15.9 14c-10 13.4-16 30-16 48s6 34.6 16 48l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.7c9.8 4.3 20.6 6.7 32 6.7c18 0 34.6-6 48-16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 0-16zm144 41.3l0 6.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c10-13.4 16-30 16-48s-6-34.6-16-48c8 0 14.9-5.9 15.9-14c1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7zM128 232c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceHoldingBackTears = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xr);
var Qr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-hushed", f = 512, c = 512, e = [], t = "e37b", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceHushed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qr);
var Jr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-icicles", f = 512, c = 512, e = [], t = "e37c", o = "M512 256c0 8.3-.4 16.6-1.2 24.7c0 .5-.1 1.1-.1 1.6l-14.8 200C494.7 499.1 480.8 512 464 512s-30.7-12.9-31.9-29.6l-2.8-37.9c-5 4.6-10.2 9-15.6 13.2l-11.5 32.9C397.7 503.4 385.6 512 372 512c-11.5 0-21.9-6.1-27.5-15.7C316.9 506.5 287.1 512 256 512c-69.4 0-132.3-27.6-178.4-72.4C71.9 444.9 64.3 448 56 448c-15.6 0-29-11.3-31.6-26.7L6.5 313.4C2.2 294.9 0 275.7 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM56 415.8l0 .2 0-.2 20-120.2C78.1 283.3 68.6 272 56 272s-22.1 11.3-20.1 23.7L56 415.8zM344 400l28 80 28-80 0-40-56 0 0 40zm55.3-56c-3.8-22.7-23.6-40-47.3-40l-8 0 0 40 55.3 0zM328 344l0-40-64 0 0 40 64 0zm0 56l0-40-64 0 0 40 32 48 32-48zm-80-96l-64 0 0 40 64 0 0-40zm0 56l-64 0 0 40 64 0 0-40zm-80-16l0-40-8 0c-23.8 0-43.5 17.3-47.3 40l55.3 0zm0 56l0-40-55.3 0c3.8 22.7 23.6 40 47.3 40l8 0zm40.4-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 480l21.8-232.1C487 235.1 476.9 224 464 224s-23 11.1-21.8 23.9L464 480z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceIcicles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jr);
var Yr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-kiss-closed-eyes", f = 512, c = 512, e = [], t = "e37d", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-93.5-80.1c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceKissClosedEyes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yr);
var Zr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-lying", f = 512, c = 512, e = [], t = "e37e", o = "M494 350.5c-4.5 1-9.2 1.5-14 1.5l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c108 0 200.4-66.9 238-161.5zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8c8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceLying = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zr);
var pr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-mask", f = 576, c = 512, e = [], t = "e37f", o = "M410.5 281.7L541.8 222C525.1 96.7 417.9 0 288 0S50.9 96.7 34.2 222l131.3 59.7c8-15.3 24.1-25.7 42.5-25.7l160 0c18.4 0 34.5 10.4 42.5 25.7zm5.5 32.6l0 69.7 93.8 0c21.8-37.6 34.2-81.3 34.2-127.9L416 314.3zM413.3 416c-6.6 18.6-24.4 32-45.3 32l-160 0c-20.9 0-38.7-13.4-45.3-32l-74.6 0c46.9 58.5 119 96 199.9 96s152.9-37.5 199.9-96l-74.6 0zM160 384l0-69.7L32 256.1c0 46.6 12.5 90.3 34.2 127.9l93.8 0zm-4.7-180.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C146.4 167 184.6 144 240 144c8.8 0 16 7.2 16 16s-7.2 16-16 16c-47 0-77.1 19.7-84.7 27.3zM336 176c-8.8 0-16-7.2-16-16s7.2-16 16-16c55.4 0 93.6 23 107.3 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C413.1 195.7 383 176 336 176zM208 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceMask = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pr);
var xr = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-melting", f = 640, c = 512, e = [129760], t = "e483", o = "M571.4 304.8c-4.5 23.2 11.8 47.2 35.4 47.2l1.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l12.9 0c36.8 0 58.4-50.7 42.9-84.1C72.5 331.1 64 294.5 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 16.7-1.6 33-4.6 48.8zM247.2 219.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zM441 238.7a32 32 0 1 0 -61.8-16.6A32 32 0 1 0 441 238.7zM213.2 299.4c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceMelting = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xr);
var i9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-monocle", f = 512, c = 512, e = [], t = "e380", o = "M427.2 446.3C381.9 487.2 321.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 62.8-22.6 120.3-60.1 164.9c-2.5-8.6-3.9-17.7-3.9-26.9L448 224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6l0 91.5c0 18.4 3.9 36.2 11.2 52.4zM256 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm-79.6-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336c-8.8 0-16 7.2-16 16zM305.2 89.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L376.3 61c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceMonocle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i9);
var a9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-nauseated", f = 512, c = 512, e = [], t = "e381", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm79.6-336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-12.3-84.7l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM168 282.7c19.5 11.3 33.8 30.5 38.4 53.3l99.2 0c4.6-22.8 18.9-42 38.4-53.3c7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3l-99.2 0c-4.6 22.8-18.9 42-38.4 53.3c-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceNauseated = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a9);
var e9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-nose-steam", f = 576, c = 512, e = [], t = "e382", o = "M530.2 339.1c8.9-26.1 13.8-54 13.8-83.1C544 114.6 429.4 0 288 0S32 114.6 32 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c23.3-23.3 60.1-24.9 85.3-4.7l51-30.6c30-18 64.1 16.1 46.1 46.1l-30.6 51c20.2 25.1 18.6 62-4.7 85.3c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C230.4 507 258.6 512 288 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-23.3-23.3-24.9-60.1-4.7-85.3l-30.6-51c-18-30 16.1-64.1 46.1-46.1l51 30.6c25.1-20.2 62-18.6 85.3 4.7c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1zm-12.4 29.7c-1.9-.5-3.8-.8-5.8-.9c-5.4-.3-10.8 .7-15.7 3.1c-1-5.2-3.3-10.1-6.9-14.4c-.6-.7-1.2-1.4-1.8-2c-12-12-31.2-12.5-43.8-1.4c-.5 .5-1 .9-1.5 1.4c-3.7 3.7-6.3 8.1-7.8 12.8L364.8 323c-2.8-1.8-6.5-1.4-8.8 1l-.2 .2c-.3 .2-.6 .5-.7 .8c-1.6 2.3-1.7 5.3-.1 7.7l44.2 70.4c-4.9 1.5-9.6 4.1-13.4 8c-4.7 4.7-7.6 10.4-8.8 16.4c-.5 2.4-.7 4.8-.6 7.2c.2 7.9 3.4 15.7 9.4 21.7c.7 .7 1.3 1.3 2 1.9c4.2 3.6 9.2 5.9 14.4 6.9c-1.5 3.2-2.5 6.7-2.9 10.1c-.2 1.8-.3 3.7-.2 5.6c0 .7 .1 1.4 .2 2c.8 6.9 3.9 13.5 9.1 18.8c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2c12.5-12.5 12.5-32.8 0-45.3c-4.3-4.3-9.5-7.1-15-8.5c0 0 0 0 0 0zM174.4 485.5c.4-1.8 .7-3.6 .8-5.4c.3-5.4-.7-10.8-3.1-15.7c5.2-1 10.1-3.3 14.4-6.9c.7-.6 1.4-1.2 2-1.8c1.5-1.5 2.8-3.1 4-4.8c8-11.9 7.1-27.9-2.5-38.9c-.5-.5-.9-1-1.4-1.5c-3.6-3.6-7.9-6.2-12.5-7.7l44.9-69.8c1.8-2.8 1.4-6.5-.9-8.8c-2.3-2.3-5.9-2.7-8.7-1L140 367.5c0-.2-.1-.3-.1-.5c-1.5-4.8-4.1-9.4-8-13.2c-.2-.2-.4-.4-.7-.6c-.3-.3-.6-.5-.8-.8c-12.6-11.1-31.7-10.6-43.8 1.4c-.7 .7-1.3 1.3-1.9 2c-3.6 4.3-5.9 9.2-6.9 14.4c-4.9-2.4-10.3-3.4-15.7-3.1c-1.5 .1-3.1 .3-4.6 .6c-5.9 1.2-11.6 4.1-16.2 8.7c-12.5 12.5-12.5 32.8 0 45.3c2.1 2.1 4.3 3.8 6.7 5.2c-14.4 18.8-13.1 45.9 4.2 63.1s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c4.4-4.4 7.2-9.8 8.5-15.4zM144 224l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 32c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0zm95.2-133.1c2.8 8.4-1.7 17.4-10.1 20.2c-35.5 11.8-64.4 34.8-73.7 44.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c12-12 45-38.1 86.3-51.9c8.4-2.8 17.4 1.7 20.2 10.1zm-286.4 0c2.8-8.4 11.9-12.9 20.2-10.1c41.3 13.8 74.2 39.9 86.3 51.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-9.3-9.3-38.2-32.3-73.7-44.1c-8.4-2.8-12.9-11.9-10.1-20.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceNoseSteam = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e9);
var n9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-party", f = 640, c = 512, e = [], t = "e383", o = "M531.7 400C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176l-3.3 0c-44.2 0-80 35.8-80 80c0 18 6 34.6 16 48l-80 0c-1 0-2 0-3 .1c-1.2-2.3-2.7-4.4-4.3-6.4c-4.3-5.2-10.1-9.7-16.7-13.4C378.7 276.9 361.4 272 344 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c1.6-2 3.1-4.1 4.3-6.4c1 .1 2 .1 3 .1l115.7 0zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm89.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM512 256c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-26.5 0-48-21.5-48-48zM51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8C96.5 68.5 68.5 107.7 51.3 152.2zM55.1 12.2C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9S15.2-1.1 21.1 .8L55.1 12.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceParty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n9);
var f9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-pensive", f = 512, c = 512, e = [], t = "e384", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 384l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM387.2 270.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM65.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3c-7.9 4-17.5 .7-21.5-7.2zm373.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L402 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFacePensive = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f9);
var c9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-persevering", f = 512, c = 512, e = [], t = "e385", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-101.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zm-104.8-310c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM133.5 210.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFacePersevering = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c9);
var t9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-pleading", f = 512, c = 512, e = [], t = "e386", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM302.7 427.9c6.6-5.9 7.1-16 1.2-22.6C294.7 395.1 278.7 384 256 384s-38.7 11.1-47.9 21.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c4.7-5.3 12.7-10.7 24.1-10.7s19.4 5.4 24.1 10.7c5.9 6.6 16 7.1 22.6 1.2zM240 240c0-41.5-31.5-75.6-72-79.6c10-10.8 17.6-24.1 21.9-38.8l1.5-5.2c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1c-8.8 1.1-15 9.1-13.9 17.9c1 8.1 7.9 14 15.9 14c-10 13.4-16 30-16 48c0 44.2 35.8 80 80 80s80-35.8 80-80zm192 0c0-18-6-34.6-16-48c8 0 14.9-5.9 15.9-14c1.1-8.8-5.1-16.8-13.9-17.9l-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2c-2.4-8.5-11.3-13.4-19.8-11s-13.4 11.3-11 19.8l1.5 5.2c4.2 14.8 11.8 28 21.9 38.8c-40.4 4-72 38.1-72 79.6c0 44.2 35.8 80 80 80s80-35.8 80-80zm-304-8c17.7 0 32-14.3 32-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4zm224-32c0-5.8-1.5-11.2-4.2-15.8c1.4-.1 2.8-.2 4.2-.2c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56c0-5.7 .8-11.2 2.4-16.4c5.7 5.2 13.3 8.4 21.6 8.4c17.7 0 32-14.3 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFacePleading = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t9);
var o9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-pouting", f = 512, c = 512, e = [], t = "e387", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFacePouting = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o9);
var l9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-raised-eyebrow", f = 512, c = 512, e = [], t = "e388", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zM328.8 141.8c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5zM128 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceRaisedEyebrow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l9);
var d9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-relieved", f = 512, c = 512, e = [], t = "e389", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 356.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM207.2 74.9c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zM314.9 95.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceRelieved = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d9);
var r9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-sad-sweat", f = 576, c = 512, e = [], t = "e38a", o = "M288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8c7 9.2 18.1 24.6 27.7 40.7c4.8 8.1 9.6 17 13.2 25.7c3.4 8 7.1 19 7.1 30.5c0 24.5-11.1 46-28.4 60.3C146.4 480.2 213.5 512 288 512zM79.5 404.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5zm291.3 7.4c-6.6 5.9-16.7 5.4-22.6-1.2c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6zM367.6 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM227.3 171.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSadSweat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r9);
var s9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-saluting", f = 640, c = 512, e = [129761], t = "e484", o = "M258.1 58.5s0 0 0 0c14.5-9.8 18.4-29.4 8.8-44c0 0 0 0 0 0c-.1-.1-.2-.3-.3-.4C256.7-.6 236.8-4.4 222.2 5.5L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c18.9 15.4 43.2 20.9 66 16.5c4.4-.9 8.8-2.1 13.1-3.8c.3-.1 .7-.3 1-.4c.5-.2 1-.4 1.5-.6c5.6-2.3 10.9-5.4 16-9l82.3-59.9s0 0 0 0c14.3-10.4 17.5-30.4 7.1-44.7c-4.8-6.7-11.8-10.9-19.3-12.5c-3.5-.7-7.2-.9-10.8-.4c-5.1 .7-10.1 2.6-14.6 5.8L128 185.8l0-39.1 27.3-18.5 13.1-8.9 89.7-60.9zM352 0c-18.4 0-36.3 1.9-53.5 5.6c12.6 27.9 3.8 61.6-22.4 79.4l-54.6 37c8.6 4.4 16.3 10.9 22.3 19.2c8.6 11.9 12.6 25.7 12.2 39.3c4.8-2.8 10.4-4.5 16.3-4.5c17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.9 0-25.8-8.9-30.2-21.4c-3.5 4.4-7.7 8.5-12.5 12l-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0zM257.4 341c17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3s15.2-8.8 22.3-3.6zm175-165a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSaluting = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s9);
var h9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-scream", f = 640, c = 512, e = [], t = "e38b", o = "M573.9 288.5c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6c20.6-2.5 41.7 3.5 57.8 16.9c0 0 0 0 0 0c57.5 48 87.8 118 98 187C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c10.2-69 40.4-139 98-187c0 0 0 0 0 0c16.1-13.4 37.2-19.4 57.8-17zM320 320c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zm-46.6-77c-22.5 36.9-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7s62.8-54.7 90.1-39.8s31.1 56.9 8.7 93.7zm183.3 39.8c-27.3 14.9-67.6-2.9-90.1-39.8s-18.6-78.8 8.7-93.7s67.6 2.9 90.1 39.8s18.6 78.8-8.7 93.7zM103.4 330.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3c26.4 40 43.6 75.3 43.2 125.7L192 512c-7-68.4-34.8-137-88.7-181.9zM588.5 327c-16.4-10.6-37.6-8.8-51.8 3.1C482.8 375 455 443.6 448 512l109.8 0c-.4-50.5 16.7-85.7 43.2-125.7c13.1-19.8 7.6-46.3-12.4-59.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceScream = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h9);
var v9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-shush", f = 512, c = 512, e = [], t = "e38c", o = "M0 256C0 359.8 61.8 449.1 150.5 489.3c-4.2-10.3-6.5-21.5-6.5-33.3l0-24 0-24c0-37.3 23.2-69.2 56-82l0-50.1c-14.8-6.9-26.6-15.9-35.3-24.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9c4-27 27.3-47.6 55.4-47.6s51.3 20.7 55.4 47.6c5.2-3.5 9.6-7.3 13.3-10.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-8.7 8.7-20.5 17.7-35.3 24.6l0 58.3c17.9 11.7 31.3 29.7 37 50.9c16-3.2 33.3 .6 46.9 11.9c18.4 15.3 24.5 39.9 17.1 61.3c60.3-46.8 99-120 99-202.3C512 114.6 397.4 0 256 0S0 114.6 0 256zM176.4 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM280 248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72 48 0 0-72zM224 408c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 24 0 24c0 30.9 25.1 56 56 56l48 0 17.5 0c21.4 0 41.6-9.5 55.3-25.9l25.6-30.7c8.5-10.2 7.1-25.3-3.1-33.8s-25.3-7.1-33.8 3.1L316 455.4c-4.6 5.5-11.3 8.6-18.4 8.6l-10 0L224 419.5l0-11.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceShush = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v9);
var u9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-sleeping", f = 512, c = 512, e = [], t = "e38d", o = "M512 256c0-46.6-12.5-90.3-34.2-128L432 128c-19.4 0-36.9-11.7-44.3-29.6c-7.1-17.1-3.7-36.7 8.6-50.4c-2.9-3.2-5.4-6.9-7.3-10.8C350.2 13.6 304.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM272 96c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L310.6 128l25.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L297.4 96 272 96zM216 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM387.2 238.4c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zM416 16c0 8.8 7.2 16 16 16l25.4 0L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0L432 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSleeping = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u9);
var m9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-sleepy", f = 512, c = 512, e = [], t = "e38e", o = "M385.1 477.1C347.2 499.3 303.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 37-7.8 72.1-22 103.9c-7.4-6.2-15.1-11.8-22.7-16.7C429.6 318.7 383.6 304 352 304c-15.3 0-28.5 10.9-31.4 25.9s5.3 30.1 19.5 35.8c21 8.4 31.6 23.5 37.4 41.7c6.3 19.4 6.5 40.3 6.5 56.6c0 4.5 .4 8.9 1.1 13.1zM176 389.5c-6.8 11.1 6 20.7 18.3 16.4c18.9-6.5 39.8-10.1 61.8-10.1s42.9 3.6 61.8 10.1c12.3 4.2 25.1-5.3 18.3-16.4C321 364.8 290.8 348 256 348s-64.9 16.8-80.1 41.5zM316.8 246.4c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0zm-121.6 0c-17.6 23.5-52.8 23.5-70.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128c48 0 160 48 160 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSleepy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m9);
var g9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smile-halo", f = 512, c = 512, e = [], t = "e38f", o = "M512 80c0 44.2-114.6 80-256 80S0 124.2 0 80S114.6 0 256 0S512 35.8 512 80zm-64 0c0-17.7-86-32-192-32S64 62.3 64 80s86 32 192 32s192-14.3 192-32zM16 272c0-41.9 10.7-81.3 29.6-115.5C98.1 178.3 173 192 256 192s157.9-13.7 210.4-35.5C485.3 190.7 496 230.1 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272zm148.1 85.5c-5.8-6.7-15.9-7.4-22.6-1.6s-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 378.2 299.4 400 256 400s-74-21.8-91.9-42.5zm53.5-56.7s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 260.4 120 278.1 120 296c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 260.4 280 278.1 280 296c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmileHalo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g9);
var P9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smile-hearts", f = 640, c = 512, e = [], t = "e390", o = "M448.2 34.3c-1.3 19.7 5.5 39.8 20.5 54.9l55.5 55.8c9.2 9.3 21.1 14.2 33.2 14.9C569.4 189.6 576 222 576 256c0 37.4-8 73-22.5 105.1c-27-15.2-61.9-11.3-84.8 11.8c-25.8 26-27.5 67.1-4.9 94.9C422.8 495.7 373.3 512 320 512c-61.3 0-117.6-21.6-161.7-57.6l13.1-13.1c27.6-27.7 27.6-72.6 0-100.4c-24.8-25-63.6-27.6-91.3-7.7c-1.7-1.2-3.5-2.4-5.2-3.4C67.8 306.5 64 281.7 64 256C64 114.6 178.6 0 320 0c46.7 0 90.5 12.5 128.2 34.3zM205.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm-.7-90.3c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zm230.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM573.7 11.5c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0L491.4 66.7c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L560 25.3l13.7-13.8zm54.9 384c15.2 15.3 15.2 40 0 55.2l-55.4 55.8c-7.3 7.3-19.1 7.3-26.3 0l-55.5-55.8c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L560 409.3l13.7-13.8c15.2-15.3 39.8-15.3 54.9 0zm-534.9-32c15.2-15.3 39.8-15.3 54.9 0s15.2 40 0 55.2L93.2 474.5c-7.3 7.3-19.1 7.3-26.3 0L11.4 418.7c-15.2-15.3-15.2-40 0-55.2s39.8-15.3 54.9 0L80 377.3l13.7-13.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmileHearts = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P9);
var M9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smile-horns", f = 640, c = 512, e = [], t = "e391", o = "M320 512c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM228.1 349.5C246 370.2 276.6 392 320 392s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C413.8 396.1 375.1 424 320 424s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM272.4 272c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4zm128 32c-17.7 0-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmileHorns = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M9);
var ma = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smile-plus", f = 640, c = 512, e = ["smile-plus"], t = "f5b9", o = "M544 0c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24zM224 512a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM140 346.1c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9c5.8-6.6 16-7.3 22.6-1.4s7.3 16 1.4 22.6C305.6 397.1 267 416 224 416s-81.6-18.9-108-48.7c-5.8-6.6-5.2-16.7 1.4-22.6s16.7-5.2 22.6 1.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmilePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ma);
var w9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smile-relaxed", f = 512, c = 512, e = [], t = "e392", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmileRelaxed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w9);
var N9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smile-tear", f = 512, c = 512, e = [], t = "e393", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm141.5 67.9c-6.7 5.8-7.4 15.9-1.6 22.6c22.2 25.7 61 53.5 116.1 53.5c8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM352 416c26.5 0 48-21 48-47c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C332.4 308.6 304 349 304 369c0 26 21.5 47 48 47zM208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmileTear = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N9);
var z9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smile-tongue", f = 512, c = 512, e = [], t = "e394", o = "M503.4 322c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c61.5 0 118-21.7 162.1-57.9c-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1c2.3-8.5 11.1-13.6 19.6-11.3c1.5 .4 2.9 1 4.2 1.8l65.4 37.8c5 2.9 9.6 6.2 13.7 10zM370.6 389.3l55.7 33.1c22.6 13.4 51.8 5.8 65-17c13.3-23 5.4-52.3-17.6-65.6l-48.6-28.1c-11.7 30.4-30.5 57.1-54.5 77.6zm-153-160.5s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmileTongue = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z9);
var L9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smile-upside-down", f = 512, c = 512, e = [], t = "e395", o = "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm91.9 186.5C330 165.8 299.4 144 256 144s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM367.6 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmileUpsideDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L9);
var C9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smiling-hands", f = 640, c = 512, e = [], t = "e396", o = "M411.1 495.3c-17-21.6-27.1-48.9-27.1-78.5l0-30.8c-18.1 8.4-39.4 14-64 14s-45.9-5.6-64-14l0 30.8c0 29.6-10.1 56.9-27.1 78.5c28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7zM320 0C183.1 0 71.3 107.5 64.3 242.6c16.8-5.8 36.2-2 49.6 11.4L161 301.1c9.4-13.7 25.1-22.7 43-22.7c28.7 0 52 23.3 52 52l0 19.2c16.8 10.6 38.1 18.4 64 18.4s47.2-7.7 64-18.4l0-19.2c0-28.7 23.3-52 52-52c17.9 0 33.6 9 43 22.7l47.1-47.1c13.4-13.4 32.8-17.2 49.6-11.4C568.7 107.5 456.9 0 320 0zM281.6 228.8c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm160 0s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zM68.7 299.3L120 350.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L43.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 404.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2l0-32.8 0-53.6c0-11-9-20-20-20s-20 9-20 20l0 19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm502.6 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmilingHands = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C9);
var D9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-smirking", f = 512, c = 512, e = [], t = "e397", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm96-48c0 8.8 7.2 16 16 16l32 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-64 0c-8.8 0-16 7.2-16 16zM375.8 338.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.2 1.2c-3.2 19.3-19.9 33.4-39.5 33.4L192 368c-8.8 0-16 7.2-16 16s7.2 16 16 16l112.6 0c35.2 0 65.2-25.4 71-60.2l.2-1.2zM288 208c0 8.8 7.2 16 16 16l32 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-64 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSmirking = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D9);
var $9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-spiral-eyes", f = 512, c = 512, e = [], t = "e485", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56.9-137.1l14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-147-263.3c.3 6.6-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5c6.6-.3 12.2 4.9 12.5 11.5zM357.6 292c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSpiralEyes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($9);
var _9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-sunglasses", f = 512, c = 512, e = [], t = "e398", o = "M256 512c141.4 0 256-114.6 256-256c0-16.6-1.6-32.8-4.6-48.5l2.6-15.7c7.9-47.6-20.5-91.8-63.3-106.6C399.8 32.9 331.8 0 256 0S112.2 32.9 65.3 85.2C22.4 100-6 144.2 2 191.8l2.6 15.7C1.6 223.2 0 239.4 0 256C0 397.4 114.6 512 256 512zM183.3 272l-78.7 0c-23.5 0-43.5-17-47.3-40.1l-8-48C44.4 154.6 67 128 96.7 128l94.7 0c14.4 0 27.1 6.2 35.8 16l57.8 0c8.7-9.8 21.4-16 35.8-16l94.7 0c29.7 0 52.2 26.6 47.3 55.9l-8 48C450.8 255 430.8 272 407.3 272l-78.7 0c-23.5 0-43.5-17-47.3-40.1l-8-48c-.4-2.7-.7-5.3-.7-7.9l-33.3 0c0 2.6-.2 5.2-.7 7.9l-8 48C226.8 255 206.8 272 183.3 272zm-19.2 69.5C182 362.2 212.6 384 256 384s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 388.1 311.1 416 256 416s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSunglasses = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_9);
var b9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-swear", f = 640, c = 512, e = [], t = "e399", o = "M320 0C178.6 0 64 114.6 64 256l512 0C576 114.6 461.4 0 320 0zM240.4 224c-17.7 0-32-14.3-32-32c0-8.8 3.6-16.8 9.3-22.6l-30.7-10.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.6 .1-3.2 .3-4.7l-11.7 3.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8zM48 288c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L48 288zm352 96l-16 0 0 32 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-32 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-32-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 32 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0l0 32 32 0 0-32-32 0zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 320c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM184 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 336l0 1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-2.3 1.7-2.2 4.5-.1 5.9c6.9 4.7 14.9 6.9 22.9 9.2c0 0 0 0 0 0c8.6 2.4 17.2 4.8 24.6 10.2c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4l0 .8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c0 0 0 0 0 0c3-1.8 2.9-6.7 .4-8.5c-6.8-5-15.2-7.3-23.6-9.7c-8.1-2.3-16.2-4.5-23.1-9.2c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7l0-1.5c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceSwear = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b9);
var S9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-thermometer", f = 576, c = 512, e = [], t = "e39a", o = "M544 256c0 141.4-114.6 256-256 256S32 397.4 32 256S146.6 0 288 0C400 0 495.2 72 530 172.2c-14-4.1-29.8-.7-41 10.2l-150.8 146c-14.9-5.2-31.6-8.4-50.2-8.4c-55.1 0-93.8 27.9-116.1 53.5c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6C214 373.8 244.6 352 288 352s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6c5.2-4.5 6.8-11.6 4.5-17.7l9.4-9-24.8-24.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.1 25.1 15.3-14.8-25.4-25.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l25.7 25.7 15.3-14.8-26-26c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.3 26.3L514.1 275l-26.6-26.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l26.9 26.9 12.5-12c.1 3.2 .2 6.4 .2 9.6zM240.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceThermometer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S9);
var y9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-thinking", f = 512, c = 512, e = [], t = "e39b", o = "M512 256c0 141.4-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l21-57.7 35.8-13c23.9-8.7 38.3-32 36.8-56.1c-1.3-24.4-16.5-46.1-39.2-55.6L166.2 257.3c-8.1-3.4-17.5 .4-21 8.5s.4 17.5 8.5 21l82.4 34.7L144 355l0-3c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM112 352l0 48.6 151.8-55.2c12.5-4.5 26.2 1.9 30.8 14.4s-1.9 26.2-14.4 30.8l-49.8 18.1-26.1 71.7c-6.9 19-24.9 31.6-45.1 31.6L112 512c-26.5 0-48-21.5-48-48l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceThinking = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y9);
var O9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-tissue", f = 512, c = 512, e = [], t = "e39c", o = "M512 256c0 141.4-114.6 256-256 256c-11.5 0-22.9-.8-34-2.2c.6-1.9 1-3.9 1.4-5.9l18.4-110.2 5.4 3.6c5.4 3.6 12.4 3.6 17.8 0L304 371.2l39.1 26.1c4.8 3.2 10.9 3.6 16 1l32-16c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-23.7 11.8-40.3-26.8c-5.4-3.6-12.4-3.6-17.8 0L256 364.8l-8.5-5.7 7.9-47.2c2.5-15.3-2.4-30.9-13.4-41.8s-26.5-16-41.8-13.4l-192 32c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM133.5 130.7c-7.9-4.2-17.5 1.5-17.5 10.5c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9zM396 141.1c0-9-9.6-14.7-17.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6zM219.3 292.7c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceTissue = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O9);
var k9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-tongue-money", f = 512, c = 512, e = [], t = "e39d", o = "M0 256C0 364.6 67.7 457.5 163.1 494.6C151.1 476.8 144 455.2 144 432l0-10.5c-22.4-20.1-39-46.1-47.2-75.4c-3.8-13.7 7.4-26.1 21.6-26.1l275.2 0c14.2 0 25.5 12.4 21.6 26.1c-8.2 29.4-24.9 55.4-47.2 75.4l0 10.5c0 23.2-7.1 44.8-19.1 62.6C444.3 457.5 512 364.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM192 104l0 9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2l0 8.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c0 0 0 0 0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1l0-9.3c0-8.8 7.2-16 16-16s16 7.2 16 16zM336 88c8.8 0 16 7.2 16 16l0 9.8c4.6 .8 8.7 1.8 12.1 2.7c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-8.3-2.2-18.8-4-27-3.2c-4 .4-6.1 1.4-7.1 2.1c-2.6 1.9-2.6 5.6-.2 7.2c6.9 4.8 15 6.9 23.3 9.1c8.3 2.2 16.7 4.4 23.9 9.4c4.8 3.3 9.5 8 12.4 14.6c3 6.6 3.5 13.9 2.2 21.2c-2 11.5-7.9 20.4-17 25.9c-4.6 2.8-9.5 4.4-14.4 5.2l0 8.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.8c-8.4-1.9-16-4.4-21.1-6c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.1 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c0 0 0 0 0 0c2.8-1.7 3.2-6.2 .6-8c-3.5-2.4-9.3-4.3-18.8-7l-1.1-.3c-7.9-2.2-18.8-5.4-27.2-11.2c-4.8-3.3-9.5-8-12.4-14.6c-3-6.6-3.5-13.9-2.2-21.2c1.8-10.2 6.9-18.2 14.4-23.6c5.3-3.9 11.3-6 17-7.1l0-9.3c0-8.8 7.2-16 16-16zm0 264l-160 0 0 80c0 44.2 35.8 80 80 80s80-35.8 80-80l0-80zm-80 16c5.9 0 10.7 4.9 10.7 10.9l0 6.7c3 .6 5.8 1.2 8.1 1.8c5.7 1.6 9.1 7.5 7.6 13.3s-7.4 9.3-13 7.7c-5.5-1.5-12.6-2.8-18-2.2c-2.7 .3-4.1 .9-4.7 1.4c-1.7 1.3-1.7 3.8-.2 4.9c4.6 3.3 10 4.7 15.5 6.2c5.6 1.5 11.2 3 15.9 6.4c3.2 2.3 6.3 5.5 8.3 9.9c2 4.5 2.3 9.4 1.5 14.4c-1.3 7.8-5.3 13.9-11.3 17.7c-3.1 1.9-6.4 3-9.6 3.6l0 6.1c0 6-4.8 10.9-10.7 10.9s-10.7-4.9-10.7-10.9l0-7.3c-5.6-1.3-10.7-3-14-4.1c-5.6-1.9-8.6-8.1-6.8-13.8s7.9-8.8 13.5-6.9c6.3 2.1 14.6 4.7 21.3 4.8c3.3 .1 5.1-.5 5.9-1c1.8-1.1 2.1-4.3 .4-5.5c-2.3-1.7-6.2-2.9-12.6-4.8l-.8-.2c-5.2-1.5-12.6-3.7-18.1-7.6c-3.2-2.3-6.3-5.5-8.3-9.9c-2-4.5-2.3-9.4-1.5-14.4c1.2-6.9 4.6-12.4 9.6-16.1c3.6-2.6 7.5-4.1 11.3-4.9l0-6.4c0-6 4.8-10.9 10.7-10.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceTongueMoney = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k9);
var A9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-tongue-sweat", f = 576, c = 512, e = [], t = "e39e", o = "M544 256c0 112.9-73.1 208.7-174.5 242.8C378.7 484 384 466.6 384 448l0-31.3c10.2-7.2 16-15.7 16-24.7c0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7l0 31.3c0 18.6 5.3 36 14.5 50.8c-41.3-13.9-78-38-106.9-69.4C116.9 415 128 393.5 128 369c0-11.4-3.8-22.4-7.1-30.5c-3.7-8.7-8.4-17.6-13.2-25.7C98.1 296.7 87 281.3 80 272.1c-11.6-15.6-31.7-19.9-48-12.8c0-1.1 0-2.2 0-3.3C32 114.6 146.6 0 288 0S544 114.6 544 256zM96 369c0 14.2-6.4 26.9-16.5 35.5C71 411.7 60 416 48 416c-26.5 0-48-21-48-47c0-17.3 21.4-50 35.7-69.7c2.2-3 4.2-5.8 5.9-8.1c3.2-4.4 9.6-4.4 12.8 0C67.6 308.6 96 349 96 369zm239.6-97a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM352 402.6l0 45.4c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-45.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceTongueSweat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A9);
var j9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-unamused", f = 512, c = 512, e = [], t = "e39f", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60.1-117.3c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceUnamused = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j9);
var B9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-viewfinder", f = 512, c = 512, e = [], t = "e2ff", o = "M56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0zM376 0l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376l0 80c0 4.4 3.6 8 8 8l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c4.4 0 8-3.6 8-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zm128-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM169.9 292.5c-6.4 6.1-6.6 16.2-.5 22.6C191.2 337.8 222 352 256 352s64.8-14.2 86.6-36.9c6.1-6.4 5.9-16.5-.5-22.6s-16.5-5.9-22.6 .5C303.5 309.6 281 320 256 320s-47.5-10.4-63.5-27.1c-6.1-6.4-16.2-6.6-22.6-.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceViewfinder = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B9);
var T9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-vomit", f = 576, c = 512, e = [], t = "e3a0", o = "M544 256c0 72.5-30.1 137.9-78.5 184.5l-16.7-5.6c-11.9-4-21.5-12.3-27.2-22.9c16.7-12.6 26.4-27.7 26.4-44c0-44.2-71.6-80-160-80s-160 35.8-160 80c0 16.3 9.7 31.4 26.4 44c-5.7 10.6-15.2 19-27.2 22.9l-16.7 5.6C62.1 393.9 32 328.5 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256zM148 141.1c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6c0-9-9.6-14.7-17.5-10.5zM32 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm480 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 396.1l0-57.4c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7l0 57.4c0 31 19.8 58.5 49.2 68.3l34.1 11.4c7.6 2.5 12.7 9.6 12.7 17.6c0 10.3-8.3 18.6-18.6 18.6l-346.8 0c-10.3 0-18.6-8.3-18.6-18.6c0-8 5.1-15.1 12.7-17.6l34.1-11.4c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceVomit = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T9);
var F9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-weary", f = 512, c = 512, e = [], t = "e3a1", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3l-3.2 0c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm46.6-164c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceWeary = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F9);
var H9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-woozy", f = 512, c = 512, e = [], t = "e3a2", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200.9 98.7c7.4 4.9 9.3 14.8 4.4 22.2c-28 42-69.6 64.1-88.3 70.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7c4.9-7.4 14.8-9.3 22.2-4.4zm22.6 121.4c2.1 8.6-3.1 17.3-11.6 19.4l-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6zM336 272c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceWoozy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H9);
var R9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-worried", f = 512, c = 512, e = [], t = "e3a3", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-73.6-97.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceWorried = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R9);
var U9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-zany", f = 512, c = 512, e = [], t = "e3a4", o = "M384.1 477.7C506.5 407 548.5 250.4 477.8 128S250.5-36.4 128.1 34.3S-36.3 261.6 34.4 384c36.2 62.7 94.9 104.3 160.1 120.5c-11.5-15.8-18.4-35.4-18.4-56.5l0-39.8c-10.4-6.2-20.1-13.7-28.9-22.2c-10.2-9.9-6.6-26.3 5.7-33.4L391.2 214.9c12.3-7.1 28.3-2 31.8 11.8c15.2 59.4-5.9 124.1-55 165l0 56.3c0 15.4-3.6 30-10.1 42.9c8.8-3.8 17.5-8.2 26.1-13.2zM128 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm112-8a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm96.1 296l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0C257.8 383.9 248 376 236.7 376l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64zM152 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm144-56a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceZany = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U9);
var q9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "face-zipper", f = 512, c = 512, e = [], t = "e3a5", o = "M492.4 354.4C505 324.1 512 290.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c50.3 0 97.2-14.5 136.7-39.5c-1.1-1.8-2.2-3.7-3.1-5.7l-29.1-58.1c-9.2-18.5-5.6-40.8 9-55.4l15.7-15.7c14.6-14.6 36.9-18.2 55.4-9l51.8 25.9zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM144 336l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm98.2 132.4c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5l29.1 58.1zm62.3-36.9c4.7 4.7 4.7 12.3 0 17l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFaceZipper = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q9);
var G9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "falafel", f = 576, c = 512, e = [129478], t = "e40a", o = "M166.6 162.5c5.9 7.1 8 16.7 5.7 25.7c-.3 1.3-.6 2.6-.7 3.9c17.2 .6 33.9 8.6 45.1 22.8c28.3 .2 52.1 20.3 58.1 47.4c4.8 2.4 9.2 5.4 13.1 8.8c3.9-3.4 8.3-6.4 13.1-8.8c6-27.1 29.8-47.1 58.1-47.4c17.3-21.9 47.4-29.2 72.8-17c1.5-.7 3-1.4 4.5-1.9c.1-2.6-.2-5.2-.9-7.8c-2.3-9-.1-18.6 5.7-25.7c8.8-10.7 8.8-26.3 0-37c-5.9-7.1-8-16.7-5.7-25.7c3.4-13.5-3.2-27.6-15.7-33.3c-8.3-3.8-14.3-11.5-16.1-20.6c-2.7-13.7-14.6-23.5-28.3-23.1c-9.1 .3-17.8-4-23.2-11.4C344 .3 329.1-3.2 316.9 3.2c-8.1 4.3-17.7 4.3-25.8 0C278.9-3.2 264 .3 255.8 11.4c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37zm48.8 84.4c-3.6 .1-7.2-.5-10.5-1.8c-5-1.9-9.4-5.2-12.7-9.6c-8.2-11.2-23.2-14.6-35.3-8.2c-8.1 4.3-17.7 4.3-25.8 0c-12.2-6.4-27.1-2.9-35.3 8.2c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c4.1-1.9 7.6-4.7 10.3-8.1c-3.1-10.1-3.7-21-1.2-31.7c-17.3-22.1-17.3-53.3 0-75.4c-2.4-10.7-1.9-21.7 1.2-31.7c-2.7-3.4-6.2-6.2-10.3-8.1c-8.3-3.8-14.3-11.5-16.1-20.6c-.2-1-.5-2-.8-3c-3.7-12.1-14.9-20.4-27.6-20.1zM224 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM80 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm453.4-42.6c4.1-4.1 7-9.2 8.7-14.9c0-.2 .1-.3 .1-.5c7-25-7.6-62.8-38.6-93.7c-23.3-23.3-50.5-37.4-73.1-39.9c0 0 0 0 0 0c-2-.2-3.9-.4-5.8-.4c0 0 0 0 0 0c-9.6-.2-18.3 1.8-25.1 6.4c0 0 0 0 0 0l-.1 .1c-1.6 1.1-3.1 2.3-4.5 3.6c-.2 .2-.3 .3-.5 .5c-19.2 19.2-11.4 59 16.6 94.3c4 5 8.4 10 13.2 14.8c38.4 38.4 87.2 51.7 109.1 29.8zM508.6 412c-26-7.1-52.6-23.3-74.9-45.7s-38.6-48.9-45.7-74.9c-5.3-19.6-6.4-43.3 4.2-63.6c-3.2 1.9-6.1 4.4-8.4 7.6c-5.5 7.4-14.1 11.7-23.2 11.4c-13.7-.4-25.7 9.4-28.3 23.1c-1.8 9.1-7.8 16.8-16.1 20.6c-12.5 5.7-19.2 19.8-15.7 33.3c2.3 9 .1 18.6-5.7 25.7c-8.8 10.7-8.8 26.3 0 37c5.9 7.1 8 16.7 5.7 25.7c-3.4 13.5 3.2 27.6 15.7 33.3c8.3 3.8 14.3 11.5 16.1 20.6c2.7 13.7 14.6 23.5 28.3 23.1c9.1-.3 17.8 4 23.2 11.4c8.2 11.2 23.2 14.6 35.3 8.2c8.1-4.3 17.7-4.3 25.8 0c12.2 6.4 27.1 2.9 35.3-8.2c5.5-7.4 14.1-11.7 23.2-11.4c13.7 .4 25.7-9.4 28.3-23.1c1.8-9.1 7.8-16.8 16.1-20.6c12.5-5.7 19.2-19.8 15.7-33.3l-.1-.6c-18.1 6.4-38 5-54.9 .4zM368 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFalafel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G9);
var W9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "family", f = 512, c = 512, e = [], t = "e300", o = "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 160l44.8 0c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2l0 16c0 28.4 12.4 54 32 71.6l0 56.4c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.6 2.4-11.4 2.4-17.5l0-56.4c19.6-17.6 32-43.1 32-71.6l0-16c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-2.4-.1-4.7-.3-7.1c9.6-5.7 20.8-8.9 32.6-8.9l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L448 384l0 80c0 26.5-21.5 48-48 48l-32 0zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80l0 16c0 23.7-12.9 44.4-32 55.4l0 72.6c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-72.6c-19.1-11.1-32-31.7-32-55.4l0-16c0-44.2 35.8-80 80-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFamily = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W9);
var E9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "family-dress", f = 512, c = 512, e = [], t = "e301", o = "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM112.3 160l31.4 0c11.8 0 23 3.2 32.6 8.9c-.2 2.3-.3 4.7-.3 7.1c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2l0 16c0 28.4 12.4 54 32 71.6l0 56.4c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5l-32 0c-26.5 0-48-21.5-48-48l0-80-21.6 0c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4c7.8-27.5 33-46.4 61.5-46.4zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.5 2.4-11.4 2.4-17.5l0-56.4c19.6-17.6 32-43.1 32-71.6l0-16c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-2.4-.1-4.8-.3-7.1c9.6-5.7 20.8-8.9 32.6-8.9l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L448 384l0 80c0 26.5-21.5 48-48 48l-32 0zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80l0 16c0 23.7-12.9 44.4-32 55.4l0 72.6c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-72.6c-19.1-11.1-32-31.7-32-55.4l0-16c0-44.2 35.8-80 80-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFamilyDress = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E9);
var V9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "family-pants", f = 512, c = 512, e = [], t = "e302", o = "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM105.6 160l44.8 0c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 24.3 10.9 46.1 28 60.8c-35.7 18.7-60 56.1-60 99.2l0 16c0 28.4 12.4 54 32 71.6l0 56.4c0 6.1 .8 11.9 2.4 17.5c-8.7 9-20.9 14.5-34.4 14.5l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160zM368 512c-13.5 0-25.7-5.6-34.4-14.5c1.6-5.5 2.4-11.4 2.4-17.5l0-56.4c19.6-17.6 32-43.1 32-71.6l0-16c0-43.1-24.3-80.5-60-99.2c17.1-14.7 28-36.5 28-60.8c0-3.9-.3-7.8-.8-11.5c8.3-2.9 17.2-4.5 26.4-4.5l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L448 464c0 26.5-21.5 48-48 48l-32 0zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128c44.2 0 80 35.8 80 80l0 16c0 23.7-12.9 44.4-32 55.4l0 72.6c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-72.6c-19.1-11.1-32-31.7-32-55.4l0-16c0-44.2 35.8-80 80-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFamilyPants = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V9);
var I9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fan-table", f = 448, c = 512, e = [], t = "e004", o = "M256 413.6C355.7 398.2 432 312 432 208C432 93.1 338.9 0 224 0S16 93.1 16 208c0 104 76.3 190.2 176 205.6l0 34.4-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0 0-34.4zM184.9 68.5L224.3 166c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4c-1.2 8.8-9.3 14.8-18.1 13.6L260.2 229.2c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2c-7-5.4-8.2-15.5-2.8-22.5l64.8-82.9c-31.2-3.4-59.5-23.4-72.1-54.5C97.2 129.1 119 77.9 164.1 59.7c8.2-3.3 17.5 .6 20.8 8.8zM224 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFanTable = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I9);
var K9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fence", f = 512, c = 512, e = [], t = "e303", o = "M76.8 38.4C73.8 34.4 69 32 64 32s-9.8 2.4-12.8 6.4L6.4 98.1C2.2 103.7 0 110.4 0 117.3L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32 32 0 0-64-32 0 0-128 32 0 0-64-32 0 0-42.7c0-6.9-2.2-13.7-6.4-19.2L76.8 38.4zm192 0c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4L198.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2L192 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32 32 0 0-64-32 0 0-128 32 0 0-64-32 0 0-42.7c0-6.9-2.2-13.7-6.4-19.2L268.8 38.4zM448 32c-5 0-9.8 2.4-12.8 6.4L390.4 98.1c-4.2 5.5-6.4 12.3-6.4 19.2L384 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-330.7c0-6.9-2.2-13.7-6.4-19.2L460.8 38.4c-3-4-7.8-6.4-12.8-6.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFence = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K9);
var X9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ferris-wheel", f = 512, c = 512, e = [], t = "e174", o = "M302.7 36.9c27.7 5.9 53.5 16.9 76.4 31.9c6.3-3.1 13.4-4.8 20.9-4.8c26.5 0 48 21.5 48 48c0 7.5-1.7 14.6-4.8 20.9c15.1 22.9 26 48.7 31.9 76.4c21.1 5 36.9 24 36.9 46.7s-15.7 41.7-36.9 46.7c-5.9 27.7-16.9 53.5-31.9 76.4c3.1 6.3 4.8 13.4 4.8 20.9c0 25.6-20 46.4-45.1 47.9l-38.5-80c4.6-5.1 10.3-9.2 16.6-12c17.2-21.5 29-47.5 33.2-75.9l-81.9 0c2.4-7.6 3.7-15.6 3.7-24s-1.3-16.4-3.7-24l81.9 0c-3.9-26.3-14.3-50.4-29.4-70.9L326.9 219c-7.6-14.5-19.5-26.4-33.9-33.9l57.9-57.9c-20.5-15.1-44.6-25.4-70.9-29.4l0 81.9c-7.6-2.4-15.6-3.7-24-3.7s-16.4 1.3-24 3.7l0-81.9c-26.3 4-50.4 14.3-70.9 29.4L219 185.1c-14.5 7.6-26.4 19.5-33.9 33.9l-57.9-57.9c-15.1 20.5-25.4 44.6-29.4 70.9l81.9 0c-2.4 7.6-3.7 15.6-3.7 24s1.3 16.4 3.7 24l-81.9 0c4.3 28.5 16.1 54.4 33.2 75.9c6.4 2.8 12.1 6.9 16.7 12l-38.5 80C84 446.4 64 425.6 64 400c0-7.5 1.7-14.6 4.8-20.9c-15.1-22.9-26.1-48.7-31.9-76.4C15.7 297.7 0 278.7 0 256s15.7-41.7 36.9-46.7c5.9-27.7 16.9-53.5 31.9-76.4C65.7 126.6 64 119.5 64 112c0-26.5 21.5-48 48-48c7.5 0 14.6 1.7 20.9 4.8c22.9-15.1 48.7-26.1 76.4-31.9C214.3 15.7 233.3 0 256 0s41.7 15.7 46.7 36.9zM304 256c0 11.6-4.1 22.3-11 30.6l88.8 191.3c3.4 7.4 2.9 16.1-1.5 23s-12 11.1-20.2 11.1l-208 0c-8.2 0-15.8-4.2-20.2-11.1s-5-15.6-1.5-23L219 286.6c-6.9-8.3-11-19-11-30.6c0-26.5 21.5-48 48-48s48 21.5 48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFerrisWheel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X9);
var Q9 = {}, ga = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "field-hockey-stick-ball", f = 512, c = 512, e = [127953, "field-hockey"], t = "f44c", o = "M491.2 8.5c21.8 15.1 27.3 45 12.2 66.8l-52.2 75.5L371.3 97.5l53.1-76.8c15.1-21.8 45-27.3 66.8-12.2zM353.1 123.9L433 177.2 241 454.9c-24.6 35.5-64.9 56.8-108.1 56.9C59.5 512 .1 452.3 .6 378.9l0-2.2c.2-25.7 7.8-50.8 21.8-72.4l17.3-26.5c14.5-22.2 44.2-28.4 66.4-13.9s28.4 44.2 13.9 66.4l-17.3 26.5c-4 6.1-6.2 13.3-6.2 20.6l0 2.2c-.1 20 16 36.2 36 36.1c11.7 0 22.7-5.8 29.4-15.5L353.1 123.9zM432 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFieldHockeyStickBall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ga);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ga;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFieldHockey = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Q9);
var J9 = {}, Pa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-certificate", f = 512, c = 512, e = ["file-award"], t = "f5f3", o = "M128 64c0-35.3 28.7-64 64-64L352 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-226.7 0c1.8-5.1 2.7-10.5 2.7-16l0-80c1.3-.5 2.5-1 3.8-1.5c6.8-3 14.3-7.8 20.6-15.5c6.4-7.9 10.1-17.2 11.4-27.1c.5-3.6 .8-5.7 1.1-7.1c1.1-.9 2.8-2.3 5.6-4.5c19.9-15.4 27.1-42.2 17.5-65.5c-1.4-3.3-2.1-5.4-2.6-6.7c.5-1.4 1.2-3.4 2.6-6.7c9.5-23.3 2.4-50.1-17.5-65.5c-2.8-2.2-4.5-3.6-5.6-4.5c-.3-1.4-.6-3.6-1.1-7.1c-3.4-24.9-23-44.6-47.9-47.9c-3.6-.5-5.7-.8-7.1-1.1c-.9-1.1-2.3-2.8-4.5-5.6c-15.4-19.9-42.2-27.1-65.5-17.5c-2.6 1.1-5.1 2.3-6.6 3l-.1 .1L128 64zm384 64l-128 0L384 0 512 128zM109.2 161.6L125 168c1.9 .8 4.1 .8 6.1 0l15.8-6.5c10-4.1 21.5-1 28.1 7.5l10.5 13.5c1.3 1.7 3.2 2.7 5.2 3l16.9 2.3c10.7 1.5 19.1 9.9 20.5 20.5l2.3 16.9c.3 2.1 1.4 4 3 5.2l13.5 10.5c8.5 6.6 11.6 18.1 7.5 28.1L248 285c-.8 1.9-.8 4.1 0 6.1l6.5 15.8c4.1 10 1 21.5-7.5 28.1l-13.5 10.5c-1.7 1.3-2.7 3.2-3 5.2l-2.3 16.9c-1.5 10.7-9.9 19.1-20.5 20.6L192 390.2 192 496c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L128 483.2 88.9 509.3c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-105.8-15.5-2.1c-10.7-1.5-19.1-9.9-20.5-20.6l-2.3-16.9c-.3-2.1-1.4-4-3-5.2L9.1 334.9c-8.5-6.6-11.6-18.1-7.5-28.1L8 291c.8-1.9 .8-4.1 0-6.1L1.6 269.2c-4.1-10-1-21.5 7.5-28.1l13.5-10.5c1.7-1.3 2.7-3.2 3-5.2l2.3-16.9c1.5-10.7 9.9-19.1 20.5-20.5l16.9-2.3c2.1-.3 4-1.4 5.2-3l10.5-13.5c6.6-8.5 18.1-11.6 28.1-7.5zM192 288A64 64 0 1 0 64 288a64 64 0 1 0 128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileCertificate = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Pa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFileAward = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(J9);
var Y9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-binary", f = 384, c = 512, e = [], t = "e175", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM112 256l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM96 304l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-48l32 0c8.8 0 16 7.2 16 16l0 112 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-96-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileBinary = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y9);
var Z9 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-cad", f = 512, c = 512, e = [], t = "e672", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm232 0l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm16 32l0 96 16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0zm-160 8c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 56 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-56zm32 40l32 0 0-40c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileCad = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z9);
var p9 = {}, Ma = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "page-caret-down", f = 384, c = 512, e = ["file-caret-down"], t = "e429", o = "M320 512c35.3 0 64-28.7 64-64l0-309.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2l139.6 0c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPageCaretDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ma);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ma;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFileCaretDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(p9);
var x9 = {}, wa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "page-caret-up", f = 384, c = 512, e = ["file-caret-up"], t = "e42a", o = "M320 512c35.3 0 64-28.7 64-64l0-309.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2l-139.6 0c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPageCaretUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = wa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFileCaretUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(x9);
var Na = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-chart-column", f = 384, c = 512, e = ["file-chart-line"], t = "f659", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 248l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 64l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zM128 376l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileChartColumn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Na);
var is = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Na;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFileChartLine = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(is);
var as = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-chart-pie", f = 384, c = 512, e = [], t = "f65a", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zm40 320l-88 0c-8.8 0-16-7.2-16-16l0-88c0-8.8 7.2-16.1 16-14.9c53.5 7.1 95.9 49.5 103 103c1.2 8.8-6.1 16-14.9 16zM160 230l0 106c0 8.8 7.2 16 16 16l106 0c10.1 0 17.7 9.3 14.1 18.8C278.9 415.9 235.2 448 184 448c-66.3 0-120-53.7-120-120c0-51.2 32.1-94.9 77.2-112.2c9.5-3.6 18.8 4 18.8 14.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileChartPie = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(as);
var es = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-check", f = 384, c = 512, e = [], t = "f316", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zm49 281L177 409c-9.4 9.4-24.6 9.4-33.9 0L79 345c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 247c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(es);
var ns = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-circle-info", f = 576, c = 512, e = [58604], t = "e493", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16c0 0 0 0 0 0l0 48s0 0 0 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileCircleInfo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ns);
var za = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-dashed-line", f = 640, c = 512, e = ["page-break"], t = "f877", o = "M128 64c0-35.3 28.7-64 64-64L352 0l0 128c0 17.7 14.3 32 32 32l128 0 0 96-384 0 0-192zm0 304l384 0 0 80c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-80zM512 128l-128 0L384 0 512 128zM56 288l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 336c-13.3 0-24-10.7-24-24s10.7-24 24-24zm224 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm192 0l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileDashedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(za);
var fs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-doc", f = 512, c = 512, e = [], t = "e5ed", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm16 128l16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96zM456 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileDoc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fs);
var cs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-eps", f = 512, c = 512, e = [], t = "e644", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM160 368c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64 0-64zm144-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm117.7-80l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L424 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7c0-25.2 20.4-45.7 45.7-45.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileEps = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cs);
var ts = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-exclamation", f = 384, c = 512, e = [], t = "f31a", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM192 192c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ts);
var os = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-gif", f = 512, c = 512, e = [], t = "e645", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-144 0c-35.3 0-64 28.7-64 64l0 144L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM224 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm160-24l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileGif = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(os);
var ls = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-heart", f = 384, c = 512, e = [], t = "e176", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 301.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 344.6C86.5 333.1 80 317.5 80 301.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ls);
var ds = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-jpg", f = 512, c = 512, e = [], t = "e646", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM208 512c-26.5 0-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 26.5-21.5 48-48 48zm96-160l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm80-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileJpg = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ds);
var rs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-lock", f = 576, c = 512, e = [], t = "e3a6", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 33.6c-19.8 20.2-32 47.9-32 78.4l0 24.6c-19.1 11.1-32 31.7-32 55.4l0 128c0 11.4 3 22.2 8.3 31.5c-2.7 .3-5.5 .5-8.3 .5L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm80 112c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileLock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rs);
var La = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-magnifying-glass", f = 384, c = 512, e = ["file-search"], t = "f865", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zm16 304c0 17.8-4.9 34.5-13.3 48.9L297 391.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-38.4-38.4C210.4 395.2 193.8 400 176 400c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileMagnifyingGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(La);
var ss = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-minus", f = 384, c = 512, e = [], t = "f318", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM120 304l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ss);
var hs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-mov", f = 512, c = 512, e = [], t = "e647", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-240 0c-35.3 0-64 28.7-64 64l0 144-16 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM157.7 359.8L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2zM448 368l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileMov = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hs);
var vs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-mp3", f = 512, c = 512, e = [], t = "e648", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-240 0c-35.3 0-64 28.7-64 64l0 144-16 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM139.7 352.6c6.9-1.9 14.3 1 18 7.2L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4zM288 368c0-8.8 7.2-16 16-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48zm144 80l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0c-8.8 0-16-7.2-16-16c0-.6 0-1.1 .1-1.6c.8-8.1 7.6-14.4 15.9-14.4l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileMp3 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vs);
var us = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-mp4", f = 512, c = 512, e = [], t = "e649", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-240 0c-35.3 0-64 28.7-64 64l0 144-16 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM157.7 359.8L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2zM304 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm84.7 11.3c-3-3-4.7-7.1-4.7-11.3l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-4.2 0-8.3-1.7-11.3-4.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileMp4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(us);
var ms = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-music", f = 384, c = 512, e = [], t = "f8b6", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zm32 224l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L160 416c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8s6.9 7.9 6.9 13.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ms);
var gs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-plus", f = 384, c = 512, e = [], t = "f319", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM192 240c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gs);
var Ps = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-plus-minus", f = 384, c = 512, e = [], t = "e177", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM208 208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16zM128 384l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilePlusMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ps);
var Ms = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-png", f = 512, c = 512, e = [], t = "e666", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM318.3 360.8L352 428.2l0-60.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 7.4-5.1 13.9-12.3 15.6s-14.7-1.8-18-8.4L320 435.8l0 60.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.4 5.1-13.9 12.3-15.6s14.7 1.8 18 8.4zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm208-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilePng = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ms);
var ws = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-ppt", f = 512, c = 512, e = [], t = "e64a", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM304 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm208-64c0-8.8 7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-16 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilePpt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ws);
var Ns = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = La;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFileSearch = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ns);
var zs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-slash", f = 640, c = 512, e = [], t = "e3a7", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-216-128 0c-17.7 0-32-14.3-32-32L352 0 192 0c-35.3 0-64 28.7-64 64l0 11L38.8 5.1zM128 196.9L128 448c0 35.3 28.7 64 64 64l256 0c20.1 0 38.1-9.3 49.8-23.8L128 196.9zM512 128L384 0l0 128 128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zs);
var Ls = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-spreadsheet", f = 384, c = 512, e = [], t = "f65b", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM88 224l208 0c17.7 0 32 14.3 32 32l0 16 0 80 0 64c0 17.7-14.3 32-32 32l-64 0-80 0-64 0c-17.7 0-32-14.3-32-32l0-64 0-80 0-16c0-17.7 14.3-32 32-32zm0 112l48 0 0-48-48 0 0 48zm80 0l48 0 0-48-48 0 0 48zm80 0l48 0 0-48-48 0 0 48zm0 32l0 48 48 0 0-48-48 0zm-32 0l-48 0 0 48 48 0 0-48zm-80 0l-48 0 0 48 48 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileSpreadsheet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ls);
var Cs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-svg", f = 512, c = 512, e = [], t = "e64b", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM205.7 352l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L176 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C169.8 430.8 160 415 160 397.7c0-25.2 20.4-45.7 45.7-45.7zM456 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm-152 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileSvg = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cs);
var Ds = {}, Ca = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-xmark", f = 384, c = 512, e = ["file-times"], t = "f317", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM111 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ca);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ca;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFileTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ds);
var $s = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-user", f = 384, c = 512, e = [], t = "f65c", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 448c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($s);
var _s = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-vector", f = 384, c = 512, e = [], t = "e64c", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM128 208l0 16 128 0 0-16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-16 0 0 128 16 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-16-128 0 0 16c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l16 0 0-128-16 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zm0 176l128 0 0-128-128 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileVector = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_s);
var bs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-xls", f = 512, c = 512, e = [], t = "e64d", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-176 0c-35.3 0-64 28.7-64 64l0 144-80 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM224 368c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 13.6-4 26.9-11.6 38.2L259.2 432l17.2 25.8C284 469.1 288 482.4 288 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-7.3-2.2-14.4-6.2-20.4L240 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-13.6 4-26.9 11.6-38.2L220.8 432l-17.2-25.8C196 394.9 192 381.6 192 368c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 128l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16zm88-98.3c0-25.2 20.4-45.7 45.7-45.7l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L432 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l26.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileXls = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bs);
var Ss = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-xml", f = 512, c = 512, e = [], t = "e654", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM192 368c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 13.6-4 26.9-11.6 38.2L227.2 432l17.2 25.8C252 469.1 256 482.4 256 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-7.3-2.2-14.4-6.2-20.4L208 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-13.6 4-26.9 11.6-38.2L188.8 432l-17.2-25.8C164 394.9 160 381.6 160 368c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 496l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM299.7 352.6c6.9-1.9 14.3 1 18 7.2L352 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-2.9-13.7-7.8L320 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileXml = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ss);
var ys = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "file-zip", f = 512, c = 512, e = [], t = "e5ee", o = "M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-144 0c-35.3 0-64 28.7-64 64l0 144L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM240 352l64 0c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384 240 384c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16l24 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-8 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFileZip = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ys);
var Os = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "files", f = 448, c = 512, e = [], t = "e178", o = "M320 0L160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224-96 0c-17.7 0-32-14.3-32-32l0-96zM448 96L416 64 384 32 352 0l0 45.3L352 64l0 32 32 0 18.7 0L448 96zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192 0c-48.6 0-88-39.4-88-88l0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFiles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Os);
var ks = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "files-medical", f = 448, c = 512, e = [], t = "f7fd", o = "M160 0L320 0l0 96c0 17.7 14.3 32 32 32l96 0 0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64zM416 64l32 32-45.3 0L384 96l-32 0 0-32 0-18.7L352 0l32 32 32 32zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24zm216 80l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilesMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ks);
var As = {}, Da = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "film-simple", f = 512, c = 512, e = ["film-alt"], t = "f3a0", o = "M384 32L128 32l0 48c0 8.8-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16l0-48C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 256 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm336-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM64 304c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm336-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilmSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Da);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Da;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFilmAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(As);
var $a = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "film-canister", f = 576, c = 512, e = ["film-cannister"], t = "f8b7", o = "M128 0C110.3 0 96 14.3 96 32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l0 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-352c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c0-17.7-14.3-32-32-32L128 0zM352 128l0 288 128 0c17.7 0 32-14.3 32-32l0-32c0-17.7 14.3-32 32-32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-192 0zm56 40l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM408 328l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilmCanister = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($a);
var js = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = $a;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFilmCannister = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(js);
var Bs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "film-slash", f = 640, c = 512, e = [], t = "e179", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6l0-320c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM224 150.3l0-22.3c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-65.9 0L224 150.3zM487.4 480l-87-68.5c-4.8 2.9-10.4 4.5-16.4 4.5l-128 0c-17.7 0-32-14.3-32-32l0-64c0-14.1 9.1-26.1 21.8-30.3l-71.1-56c.8 2 1.3 4.1 1.3 6.4l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c.9 0 1.9 .1 2.8 .2L64 146.4 64 416c0 35.3 28.7 64 64 64l359.4 0zM112 368c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM464 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM480 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilmSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bs);
var Ts = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "films", f = 576, c = 512, e = [], t = "e17a", o = "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zm8 48l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM472 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM168 184l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM168 288l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zM288 80l96 0c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zM256 256c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilms = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ts);
var Fs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "filter-list", f = 512, c = 512, e = [], t = "e17c", o = "M40 64C24.2 64 9.9 73.3 3.5 87.7s-3.8 31.3 6.8 43L112 243.8 112 368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6l0-172.2 101.7-113c10.6-11.7 13.2-28.6 6.8-43S327.8 64 312 64L40 64zM352 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0zM320 256c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32zM416 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilterList = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fs);
var Hs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "filter-slash", f = 640, c = 512, e = [], t = "e17d", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L406.6 293.4 567 97.3c9.8-12 11.8-28.5 5.2-42.5S551.5 32 536 32L104 32c-8.1 0-15.8 2.5-22.3 6.8L38.8 5.1zM384 398.5L256 297.7 256 400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6l0-49.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilterSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hs);
var Rs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "filters", f = 640, c = 512, e = [], t = "e17e", o = "M232 32c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L352 261.5 352 368c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6l0-154.5L629.4 99.1c10.7-11.7 13.6-28.6 7.2-43.2S615.9 32 600 32L232 32zM40 96c-15.9 0-30.2 9.4-36.6 23.9s-3.6 31.5 7.2 43.2L160 325.5l0 74.5c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6l0-122.5 32-34.8 0-16.7L179 120.7c-6.7-7.3-11.7-15.7-14.9-24.7L40 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFilters = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rs);
var _a = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fire-flame", f = 384, c = 512, e = ["flame"], t = "f6df", o = "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zM188.8 148.3c2-2.7 5.2-4.3 8.5-4.3c5.9 0 10.7 4.8 10.7 10.7l0 11.4c0 8.9 3.6 17.4 9.9 23.6l51.5 50.7C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109l-3 0c-61.9 0-112-50.1-112-112l0-8.2c0-21.2 7.8-41.6 21.8-57.4l6.9-7.8c2.1-2.4 5.1-3.7 8.3-3.7c6.1 0 11 4.9 11 11l0 44c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-13.2-13.2c-14-14-21.9-33.1-21.9-53c0-16.2 5.3-32 15-44.9l5.8-7.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFireFlame = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_a);
var Us = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fire-hydrant", f = 384, c = 512, e = [], t = "e17f", o = "M224 32l0 4c45 11.6 80.4 47 92 92l12 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 176c-13.3 0-24-10.7-24-24s10.7-24 24-24l12 0c11.6-45 47-80.4 92-92l0-4c0-17.7 14.3-32 32-32s32 14.3 32 32zM32 488c0-13.3 10.7-24 24-24l8 0 0-64-16 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-64 256 0 0 64 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-16 0 0 64 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0L64 512l-8 0c-13.3 0-24-10.7-24-24zm160-88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFireHydrant = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Us);
var qs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fire-smoke", f = 640, c = 512, e = [], t = "f74b", o = "M283.7 0c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 30 8.2 58.3 22.7 82.4c4.6 2.6 9 5.4 13.3 8.5c13.7-16.8 30.7-30.8 50.1-40.9c-3.9-9.4-6-20.2-6-32.1c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c11.3 20.7 12.3 44.9 4.2 65.2c19.3 10.1 36.2 24 49.9 40.8c4.2-3 8.5-5.8 12.9-8.3c14.6-24.1 23-52.4 23-82.5c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7c-2.8-2.5-6.3-3.7-9.8-3.8zM0 400c0 61.9 50.1 112 112 112l208 0 208 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-37 0-69.9 18-90.3 45.7C418.2 288 372.8 256 320 256s-98.2 32-117.7 77.7C181.9 306 149 288 112 288C50.1 288 0 338.1 0 400z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFireSmoke = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qs);
var Gs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fireplace", f = 640, c = 512, e = [], t = "f79a", o = "M0 32L0 64C0 81.7 14.3 96 32 96l576 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 0C14.3 0 0 14.3 0 32zm608 96L32 128l0 352c0 17.7 14.3 32 32 32l96 0 0-160c0-88.4 71.6-160 160-160s160 71.6 160 160l0 160 96 0c17.7 0 32-14.3 32-32l0-352zM338 299.4l-13.3-14c-1.4-1.5-2.8-3.1-4.2-4.7c0 0 0 0 0 0c-6.3-7.2-13.1-14.9-22.9-15.1c-5.1-.1-10.2 1.6-14.2 5.3c-16.4 14.8-35 34.2-49.6 56.1c-14.5 21.8-25.8 47-25.8 73.1c0 62 49.3 111.9 112 111.9c62.1 0 112-49.8 112-111.9c0-21-7.7-42.6-18.3-61.7C403 319.3 389 301.8 375.2 289c-3.9-3.6-8.9-5.5-13.9-5.5c-5.3 0-10.9 2-14.6 6.2l-8.6 9.7zm26.8 134.3c0 24.7-20.1 44.8-44.8 44.8s-44.8-20.1-44.8-44.8c0-25.6 25.9-51.1 38.3-61.9c3.8-3.3 9.2-3.3 12.9 0c12.4 10.8 38.3 36.3 38.3 61.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFireplace = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gs);
var Ws = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = qi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFirewall = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ws);
var Es = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fish-bones", f = 576, c = 512, e = [], t = "e304", o = "M87.1 148.2c5.6 4.6 8.9 11.4 8.9 18.7L96 208s0 0 0 0l0 24 40 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 48 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 48 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 40 0 0-101.1c0-16.9 17.1-28.4 31.8-20c16 9.1 30.6 19.7 43.7 30.7c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8c-13.1 11-27.7 21.6-43.7 30.7c-14.7 8.4-31.8-3.1-31.8-20L416 280l-40 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-48 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-48 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-40 0 0 24s0 0 0 0l0 41.1c0 7.2-3.3 14.1-8.9 18.7l-48 38.9c-8.8 7.1-21.3 7.1-30.1 .1s-11.5-19.2-6.6-29.3L54.9 266.6c3.3-6.7 3.3-14.5 0-21.2L2.5 138.6c-5-10.1-2.2-22.3 6.6-29.3s21.3-7 30.1 .1l48 38.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFishBones = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Es);
var Vs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fish-cooked", f = 576, c = 512, e = [], t = "f7fe", o = "M320 64c120 0 256 128 256 192s-136 192-256 192c-74.8 0-155.9-49.8-206.3-102.8c-6-6.3-15.8-7.2-22.5-1.7L26.1 396.4c-5.3 4.3-12.9 4.8-18.7 1.1s-8.6-10.7-6.9-17.4L30.5 259.9c.6-2.5 .6-5.2 0-7.8L.5 131.9c-1.6-6.5 .9-13.2 6.4-17s12.7-3.8 18.2 0l72 49.5c6.6 4.5 15.5 3.5 21.1-2.2C168.9 110.9 247.4 64 320 64zm-4.7 84.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm112 16c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zm16 112c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFishCooked = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vs);
var Is = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fishing-rod", f = 448, c = 512, e = [], t = "e3a8", o = "M295.9 48c-3 0-6 .4-8.8 1.2L209.8 71.3C137.7 91.9 88 157.8 88 232.8L88 288l8 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 320c0-17.7 14.3-32 32-32l8 0 0-55.2c0-96.4 63.9-181.2 156.7-207.7L273.8 3.1C281 1 288.4 0 295.9 0C340.1 0 376 35.9 376 80.1l0 55.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-55.9C328 62.4 313.6 48 295.9 48zM256 344c0-71.6 55.6-127.8 89-148.1c4.3-2.6 9.6-2.6 14 0c33.5 20.3 89 76.6 89 148.1c0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3l0 1.4c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFishingRod = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Is);
var Ks = {}, ba = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flag-swallowtail", f = 448, c = 512, e = ["flag-alt"], t = "f74c", o = "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 360 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24L64 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlagSwallowtail = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ba);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ba;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFlagAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ks);
var Sa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flag-pennant", f = 448, c = 512, e = [128681, "pennant"], t = "f456", o = "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128L433 213.6c9-3.4 15-12 15-21.6s-6-18.2-15-21.6L64 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlagPennant = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sa);
var Xs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = _a;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFlame = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Xs);
var Qs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flashlight", f = 640, c = 512, e = [128294], t = "f8b8", o = "M576 416l32 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-32 0 0 320zM544 97.7C449.1 107.9 384 160 384 160L48 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l336 0s65.1 52.1 160 62.3l0-316.5zM224 256c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlashlight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qs);
var Js = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flask-gear", f = 640, c = 512, e = [], t = "e5f1", o = "M288 0L160 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 132.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512l309.2 0c10.6 0 20.7-2.4 29.7-6.6c-2.8-6.2-4.2-12.9-4.2-19.7l0-.9c-17.6 9.7-41.5 8.1-57.2-8.7c-9.2-9.9-17.4-20.9-24.4-33s-12.5-24.7-16.4-37.6c-6.7-21.6 3.4-42.7 20-53.3l-.2-.2-207 0L173 263.9c12.4-20.2 19-43.4 19-67.1L192 64l64 0 0 132.8c0 23.7 6.6 46.9 19 67.1L304 311c.1-4 .8-8.1 2-12.2c4-12.9 9.4-25.5 16.4-37.6c4.1-7.1 8.7-13.9 13.6-20.3l-6.5-10.6c-6.2-10.1-9.5-21.7-9.5-33.5L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 0zM436 218.2l0 17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7l0-17.7c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7c-6.8 1.5-11.3 7.8-11.3 14.8zm-4.1 133.5a48.1 48.1 0 1 1 96.1 0 48.1 48.1 0 1 1 -96.1 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlaskGear = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Js);
var Ys = {}, ya = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flask-round-poison", f = 448, c = 512, e = ["flask-poison"], t = "f6e0", o = "M328.5 172.1c-5.2-3-8.5-8.4-8.5-14.4L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L304 0 256 0 192 0 144 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 93.7c0 6-3.3 11.4-8.5 14.4c0 0 0 0 0 0c-5.3 3.1-10.4 6.4-15.4 9.9C50.8 219.7 16 281.8 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9zM300 376.6c-7.1 5.2-12 13-12 21.8l0 9.6c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-9.6c0-8.8-4.9-16.7-12-21.8c-22.1-16.1-36-39.1-36-64.6c0-48.6 50.1-88 112-88s112 39.4 112 88c0 25.5-13.9 48.6-36 64.6zM184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlaskRoundPoison = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ya);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ya;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFlaskPoison = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ys);
var Zs = {}, Oa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flask-round-potion", f = 448, c = 512, e = ["flask-potion"], t = "f6e1", o = "M192 64l64 0 0 93.7c0 30.4 16.9 56.1 40.3 69.7c43 25 71.6 71.4 71.7 124.4c-58.6-1.7-85.4-12.6-109.9-22.6c-22-9-42.2-17.2-82.1-17.2c-42.3 0-73.4 9.2-94.5 18.8c6.5-44.1 33-81.7 70.2-103.4c23.4-13.6 40.3-39.3 40.3-69.7L192 64zm128 93.7L320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L304 0 144 0 128 0C110.3 0 96 14.3 96 32s14.3 32 32 32l0 93.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlaskRoundPotion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Oa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Oa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFlaskPotion = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Zs);
var ps = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flatbread", f = 512, c = 512, e = [129747], t = "e40b", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 171.3l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlatbread = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ps);
var xs = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flatbread-stuffed", f = 576, c = 512, e = [129369], t = "e40c", o = "M272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120c27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4zM159.3 313.5L281.5 191.3C267.4 181.6 250.4 176 232 176c-48.6 0-88 39.4-88 88c0 18.4 5.6 35.4 15.3 49.5zM482.8 73.1c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9zM256 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlatbreadStuffed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xs);
var ka = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "floppy-disk-circle-arrow-right", f = 576, c = 512, e = ["save-circle-arrow-right"], t = "e180", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l232.2 0c-17.6-21.4-30.3-46.9-36.3-75c-10.2 6.9-22.6 11-35.9 11c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7 .2 16 .7l0-19.5c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFloppyDiskCircleArrowRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ka);
var d = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "floppy-disk-circle-xmark", f = 576, c = 512, e = ["floppy-disk-times", "save-circle-xmark", "save-times"], t = "e181", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l232.2 0c-17.6-21.4-30.3-46.9-36.3-75c-10.2 6.9-22.6 11-35.9 11c-35.3 0-64-28.7-64-64s28.7-64 64-64c16.8 0 32.1 6.5 43.6 17.1C292.9 239 357 192 432 192c5.4 0 10.7 .2 16 .7l0-19.5c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFloppyDiskCircleXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d);
var ih = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "floppy-disk-pen", f = 576, c = 512, e = [], t = "e182", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l194.5 0 14-55.9c2.8-11.3 8.6-21.5 16.8-29.7L448 235.6l0-62.4c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm325.8-52.2c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 417.1c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 358.8l-71-71L311.9 417.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFloppyDiskPen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ih);
var ah = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = d;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFloppyDiskTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ah);
var eh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "floppy-disks", f = 512, c = 512, e = [], t = "e183", o = "M96 56c0-30.9 25.1-56 56-56L370.7 0c14.9 0 29.1 5.9 39.6 16.4l85.3 85.3c10.5 10.5 16.4 24.7 16.4 39.6L512 360c0 30.9-25.1 56-56 56l-304 0c-30.9 0-56-25.1-56-56L96 56zm96 8c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L192 64zM368 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM48 120l0 256c0 48.6 39.4 88 88 88l256 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFloppyDisks = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eh);
var nh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flower", f = 448, c = 512, e = [127804, 10047], t = "f7ff", o = "M128 480c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128c0-38.2-16.8-72.5-43.3-96c26.6-23.5 43.3-57.8 43.3-96c0-70.7-57.3-128-128-128c-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32C57.3 32 0 89.3 0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128zm96-304a80 80 0 1 1 0 160 80 80 0 1 1 0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlower = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nh);
var fh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flower-daffodil", f = 512, c = 512, e = [9880], t = "f800", o = "M288 281.3c9.8 4.3 20.6 6.7 32 6.7c44.2 0 80-35.8 80-80c0-26.2-12.6-49.4-32-64c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32C241.4 12.6 218.2 0 192 0c-44.2 0-80 35.8-80 80c0 26.2 12.6 49.4 32 64c-19.4 14.6-32 37.8-32 64c0 44.2 35.8 80 80 80c11.4 0 22.2-2.4 32-6.7l0 113.4C192.1 349.5 139.5 320 80 320l-50.5 0C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512l61.5 0 32 0 32 0 61.5 0C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5L432 320c-59.5 0-112.1 29.5-144 74.8l0-113.4zM208 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlowerDaffodil = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fh);
var ch = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flower-tulip", f = 512, c = 512, e = [127799], t = "f801", o = "M96 44l0 84c0 70.7 57.3 128 128 128l0 138.8C192.1 349.5 139.5 320 80 320l-50.5 0C13.2 320 0 333.2 0 349.5C0 439.3 72.7 512 162.5 512l61.5 0 32 0 32 0 61.5 0C439.3 512 512 439.3 512 349.5c0-16.3-13.2-29.5-29.5-29.5L432 320c-59.5 0-112.1 29.5-144 74.8L288 256c70.7 0 128-57.3 128-128l0-84c0-6.6-5.4-12-12-12c-2.6 0-5.1 .8-7.2 2.4L336 80 268.8 5.3c-3-3.4-7.4-5.3-11.9-5.3l-1.7 0c-4.5 0-8.9 1.9-11.9 5.3L176 80 115.2 34.4c-2.1-1.6-4.6-2.4-7.2-2.4c-6.6 0-12 5.4-12 12z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlowerTulip = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ch);
var th = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flute", f = 640, c = 512, e = [], t = "f8b9", o = "M48 160l48 0 0 192-48 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM592 352l-464 0 0-192 464 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlute = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(th);
var oh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flux-capacitor", f = 448, c = 512, e = [], t = "f8ba", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM148.7 237.3l-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0l49 49c1.8-6.6 2.7-13.6 2.7-20.7c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7zM184 282.7c-23.9 13.8-40 39.7-40 69.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-29.6-16.1-55.5-40-69.3l0 69.3c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-69.3zm115.3-45.4c6.6 1.8 13.6 2.7 20.7 2.7c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0 7.2 .9 14.1 2.7 20.7l49-49c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zm-160-88.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-89.4 91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-84.7-84.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFluxCapacitor = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oh);
var lh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "flying-disc", f = 448, c = 512, e = [], t = "e3a9", o = "M23.7 456.3C-1.5 431.1-5.9 389.6 7.1 341.4c3.2 9.5 8.4 18.5 16.2 26.3c15.6 15.6 36 20.7 55 20.5c18.8-.1 38.8-5.3 58.2-13.3c39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2c.1-19-5-39.5-20.5-55c-7.8-7.8-16.8-13-26.3-16.2c48.2-13 89.8-8.6 114.9 16.6c55.3 55.3 10.5 189.8-100.2 300.5S79 511.6 23.7 456.3zM235.1 267.1C161.4 340.9 76.7 375.8 46 345s4.1-115.4 77.9-189.2S282.3 47.2 313 77.9s-4.1 115.4-77.9 189.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFlyingDisc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lh);
var dh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = M1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFog = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(dh);
var Aa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-arrow-down", f = 512, c = 512, e = ["folder-download"], t = "e053", o = "M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 200z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Aa);
var ja = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-arrow-up", f = 512, c = 512, e = ["folder-upload"], t = "e054", o = "M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM280 376l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 376c0 13.3 10.7 24 24 24s24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ja);
var rh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-bookmark", f = 512, c = 512, e = [], t = "e186", o = "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM288 176l0 160c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L368 308l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3l0-160c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderBookmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rh);
var sh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-check", f = 512, c = 512, e = [], t = "e64e", o = "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM369 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 241z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sh);
var hh = {}, Ba = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-gear", f = 512, c = 512, e = ["folder-cog"], t = "e187", o = "M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM368.6 259.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1l0-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9l0 3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1l0 3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9l0-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM216 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderGear = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ba);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ba;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFolderCog = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(hh);
var vh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Aa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFolderDownload = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vh);
var uh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-grid", f = 512, c = 512, e = [], t = "e188", o = "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM104 240c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm104 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderGrid = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uh);
var mh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-heart", f = 512, c = 512, e = [], t = "e189", o = "M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mh);
var gh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-image", f = 512, c = 512, e = [], t = "e18a", o = "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm120 0c-8 0-15.5 4-20 10.7l-56 84L202.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C311.5 228 304 224 296 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderImage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gh);
var Ta = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-magnifying-glass", f = 512, c = 512, e = ["folder-search"], t = "e18b", o = "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderMagnifyingGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ta);
var Ph = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-medical", f = 512, c = 512, e = [], t = "e18c", o = "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM224 208l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ph);
var Mh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-music", f = 512, c = 512, e = [], t = "e18d", o = "M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mh);
var wh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ta;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFolderSearch = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(wh);
var Nh = {}, Fa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-xmark", f = 512, c = 512, e = ["folder-times"], t = "f65f", o = "M448 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Fa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFolderTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Nh);
var zh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ja;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFolderUpload = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(zh);
var Lh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folder-user", f = 512, c = 512, e = [], t = "e18e", o = "M512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l128 0c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8l160 0c35.3 0 64 28.7 64 64l0 256zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM144 405.3c0 5.9 4.8 10.7 10.7 10.7l202.7 0c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3l-117.3 0c-29.5 0-53.3 23.9-53.3 53.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolderUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lh);
var Ch = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "folders", f = 576, c = 512, e = [], t = "f660", o = "M512 384c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64L394.5 96c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7L160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFolders = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ch);
var Dh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fondue-pot", f = 512, c = 512, e = [129749], t = "e40d", o = "M319 39.8l-24 96c-2.9 11.5-11.6 20-22.2 23L264.5 192l-33 0 10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zm62.9 120.2L360.6 192l-38.5 0 33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM32 224l32 0 0 16 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16s16-7.2 16-16l0-32 0-16 224 0 64 0 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 52.3-25.1 98.8-64 128l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-3.2c-10.3 2.1-21 3.2-32 3.2l-128 0c-11 0-21.7-1.1-32-3.2l0 3.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32C25.1 418.8 0 372.3 0 320l0-64c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFonduePot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dh);
var $h = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "font-case", f = 640, c = 512, e = [], t = "f866", o = "M206 52.8C201.3 40.3 189.3 32 176 32s-25.3 8.3-30 20.8L2 436.8c-6.2 16.5 2.2 35 18.7 41.2s35-2.2 41.2-18.7L96.2 368l159.6 0L290 459.2c6.2 16.5 24.7 24.9 41.2 18.7s24.9-24.6 18.7-41.2L206 52.8zM231.8 304l-111.6 0L176 155.1 231.8 304zM608 160c-13 0-24.1 7.7-29.2 18.8C559.4 166.9 536.5 160 512 160c-70.7 0-128 57.3-128 128l0 64c0 70.7 57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32l0-96 0-64 0-96c0-17.7-14.3-32-32-32zM576 288l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64s64 28.7 64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFontCase = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($h);
var _h = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "football-helmet", f = 512, c = 512, e = [], t = "f44f", o = "M488.1 194.9c4.5 17.1-8.2 33.1-25.7 35.3L340.3 245.5l14 74.5L464 320c26.5 0 48 21.5 48 48l0 32 0 50.4c0 25.2-20.4 45.6-45.6 45.6l-17 0c-54.9 0-102-39.1-112.1-93.1L327.7 352 288 352l9.2 18.3c4.5 9 6.8 18.9 6.8 28.9c0 35.7-29 64.7-64.7 64.7l-1.7 0c-9 0-17.9-1.8-26.1-5.4l-93.4-40c-4-1.7-8.3-2.6-12.6-2.6l-14 0c-9.1 0-17.9-3.8-23.5-10.9C35.4 364.1 16 312.3 16 256C16 123.5 123.5 16 256 16c111.4 0 205.1 75.9 232.1 178.9zm-207.1 58c-14.3 1.8-25.1 14-25.1 28.4c0 4.4 1 8.8 3 12.8l13 26 49.7 0-13.2-70.6-27.4 3.4zM360.3 352l6 32L480 384l0-16c0-8.8-7.2-16-16-16l-103.7 0zM480 416l-105.3 0c13.1 28.7 42 48 74.7 48l17 0c7.5 0 13.6-6.1 13.6-13.6l0-34.4zM176 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFootballHelmet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_h);
var Ha = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fork", f = 512, c = 512, e = ["utensil-fork"], t = "f2e3", o = "M412.4 5.9c5.2 6.4 4.8 15.6-1.1 21.5L320 118.6c-5.2 5.2-5.2 13.6 0 18.8c4.9 4.9 12.8 5.2 18.1 .6l99.4-86.1c6.3-5.5 15.9-5.2 21.8 .8s6.3 15.4 .8 21.8L374 173.9c-4.6 5.3-4.3 13.2 .6 18.1c5.2 5.2 13.6 5.2 18.8 0l91.3-91.3c5.8-5.8 15.1-6.3 21.5-1.1s7.7 14.4 3.2 21.2l-71 106.5c-18.6 27.9-49.9 44.6-83.4 44.6c-19.3 0-37.9-5.5-53.9-15.7L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L255.7 211c-10.2-16-15.7-34.7-15.7-53.9c0-33.5 16.8-64.8 44.6-83.4l106.5-71c6.8-4.6 16-3.2 21.2 3.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFork = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ha);
var Ra = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fork-knife", f = 576, c = 512, e = ["utensils-alt"], t = "f2e6", o = "M475.3 27.3c5.8-5.8 6.3-15.1 1.1-21.5S462-1.9 455.1 2.7l-106.5 71C320.8 92.3 304 123.6 304 157.1c0 19.3 5.5 37.9 15.7 53.9L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L365 256.3c16 10.2 34.7 15.7 53.9 15.7c33.5 0 64.8-16.8 83.4-44.6l71-106.5c4.6-6.8 3.2-16-3.2-21.2s-15.6-4.8-21.5 1.1L457.4 192c-5.2 5.2-13.6 5.2-18.8 0c-4.9-4.9-5.2-12.8-.6-18.1l86.1-99.4c5.5-6.3 5.2-15.9-.8-21.8s-15.4-6.3-21.8-.8L402.1 138c-5.3 4.6-13.2 4.3-18.1-.6c-5.2-5.2-5.2-13.6 0-18.8l91.3-91.3zM52.5 7.3C47.9 2.6 41.5 0 34.9 0c-11.2 0-21 7.5-23.5 18.4C6.7 38.6 0 71.5 0 96c0 83.3 48.2 130.5 128.9 209.4c6.5 6.4 13.3 13 20.3 19.9c1.9 1.8 3.8 3.5 5.9 5.1L265.4 220.1 52.5 7.3zM457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L355.9 310.6l-45.3 45.3L457.4 502.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faForkKnife = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ra);
var bh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "forklift", f = 640, c = 512, e = [], t = "f47a", o = "M48 160l48 0L96 48c0-26.5 21.5-48 48-48L292.7 0c20.3 0 38.4 12.8 45.2 31.9l75.3 210.8c1.8 5.2 2.8 10.6 2.8 16.1l0 85.7c19.6 17.6 32 43.1 32 71.6c0 53-43 96-96 96s-96-43-96-96l-64 0c0 53-43 96-96 96s-96-43-96-96L0 208c0-26.5 21.5-48 48-48zm208 96l94 0L281.4 64 160 64l0 96 96 96zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM544 32l0 352 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faForklift = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bh);
var Sh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "fort", f = 640, c = 512, e = [], t = "e486", o = "M0 16C0 7.2 7.2 0 16 0L48 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 80 0 16 0 48 128 0 0-48 0-16 0-80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 80 0 16 0 64c0 20.9-13.4 38.7-32 45.3L608 464c0 26.5-21.5 48-48 48l-176 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L80 512c-26.5 0-48-21.5-48-48l0-242.7C13.4 214.7 0 196.9 0 176l0-64L0 96 0 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFort = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sh);
var yh = {}, Ua = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wine-glass-crack", f = 320, c = 512, e = ["fragile"], t = "f4bb", o = "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6l0 99.6-48 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0 80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0-99.6c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0L233.9 0C222 0 214.3 12.5 219.6 23.2l14.2 28.5c3.5 7.1 1.4 15.7-5.1 20.3l-58.4 40.9c-6 4.2-8.4 12-5.8 18.9l31.1 81c2.1 5.5-1.9 11.4-7.8 11.4c-2.4 0-4.7-1.1-6.3-2.9L92.1 118c-6.4-7.4-4.7-18.7 3.5-24l58.6-37.3c7.6-4.8 9.7-14.9 4.7-22.4L140.7 7.1c-3-4.5-8-7.1-13.3-7.1L64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWineGlassCrack = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ua);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ua;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFragile = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yh);
var Oh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "frame", f = 448, c = 512, e = [], t = "e495", o = "M448 128c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L128 96l0-32c0-17.7-14.3-32-32-32S64 46.3 64 64l0 32L32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l32 0 0 192-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 192 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-192 32 0c17.7 0 32-14.3 32-32zM128 352l0-192 192 0 0 192-192 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFrame = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Oh);
var kh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "french-fries", f = 384, c = 512, e = [127839], t = "f803", o = "M183.2 1.7c-5-2.5-10.8-2.2-15.6 .7S160 10.5 160 16l0 190.7s0 0 0 0l0 63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2l0-238c-.1-6-3.5-11.4-8.8-14.1l-32-16zM128 14.7l-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6l0-246.3zM40.3 85.6L19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2L48 192c3.6 0 7 .4 10.2 1L40.3 85.6zM383.8 98.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2.8-.5 5.7-.8 8.8-.8l26.6 0c1.6 0 3.2 .1 4.7 .2l16.5-93.4zm-64-48c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4L256 261c4.8-2.1 8.7-4.4 11.8-6.6c12-8.4 16.7-18 18.7-24.3c.7-2.3 1.7-4.7 2.8-7L319.8 50.8zM.6 250.5l57.5 237C61.6 501.9 74.4 512 89.2 512l205.7 0c14.8 0 27.6-10.1 31.1-24.5l57.5-237c.4-1.7 .6-3.3 .6-5.1c0-11.8-9.6-21.4-21.4-21.4L336 224c-8.8 0-16.3 7.2-18.9 15.7C309.7 263 283.7 304 192 304s-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224l-26.6 0C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFrenchFries = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kh);
var Ah = {}, qa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "snowman-head", f = 448, c = 512, e = ["frosty-head"], t = "f79b", o = "M64 64C64 28.7 92.7 0 128 0L320 0c35.3 0 64 28.7 64 64l0 96-160 0L64 160l0-96zM330.2 192l85.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-25.7 0c16.3 28.2 25.7 61 25.7 96c0 59.8-27.4 113.3-70.3 148.5c-9.7 8-22.3 11.5-34.9 11.5l-173.7 0c-12.6 0-25.1-3.5-34.9-11.5C59.4 465.3 32 411.8 32 352c0-35 9.3-67.8 25.7-96L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32l85.8 0 212.3 0zM152 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7c0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7l23.8 46.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSnowmanHead = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = qa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faFrostyHead = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ah);
var jh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "function", f = 640, c = 512, e = [], t = "f661", o = "M64 96c0-53 43-96 96-96l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32l0 96 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 127.5c0 48.4-36.1 89.3-84.1 95.3l-7.9 1C18.4 481.9 2.4 469.5 .2 452s10.2-33.5 27.8-35.7l7.9-1c16-2 28-15.6 28-31.8L64 256l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-96zm266.7 81.7C303.7 218.4 288 267.3 288 320s15.7 101.6 42.7 142.3c9.8 14.7 5.7 34.6-9 44.3s-34.6 5.7-44.3-9C243.6 446.7 224 385.6 224 320s19.6-126.7 53.3-177.7c9.8-14.7 29.6-18.8 44.3-9s18.8 29.6 9 44.3zm202.6 0c-9.8-14.7-5.7-34.6 9-44.3s34.6-5.7 44.3 9C620.4 193.3 640 254.4 640 320s-19.6 126.7-53.3 177.7c-9.8 14.7-29.6 18.8-44.3 9s-18.8-29.6-9-44.3c27-40.7 42.7-89.6 42.7-142.3s-15.7-101.6-42.7-142.3zM398.6 241.4L432 274.7l33.4-33.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L477.3 320l33.4 33.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L432 365.3l-33.4 33.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L386.7 320l-33.4-33.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faFunction = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jh);
var Bh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "galaxy", f = 512, c = 512, e = [], t = "e008", o = "M320 0l11.5 0C342.8 0 352 9.2 352 20.5c0 7.1-3.7 13.7-9.8 17.5l-12.5 7.7c-35.2 21.7-60.9 54.9-73.3 93.1c19.9-7 41.3-10.8 63.5-10.8c106 0 192 86 192 192l0 11.5c0 11.3-9.2 20.5-20.5 20.5c-7.1 0-13.7-3.7-17.5-9.8l-7.7-12.5c-21.7-35.2-54.9-60.9-93.1-73.3c7 19.9 10.8 41.3 10.8 63.5c0 106-86 192-192 192l-11.5 0c-11.3 0-20.5-9.2-20.5-20.5c0-7.1 3.7-13.7 9.8-17.5l12.5-7.7c35.2-21.7 60.9-54.9 73.3-93.1c-19.9 7-41.3 10.8-63.5 10.8C86 384 0 298 0 192l0-11.5C0 169.2 9.2 160 20.5 160c7.1 0 13.7 3.7 17.5 9.8l7.7 12.5c21.7 35.2 54.9 60.9 93.1 73.3c-7-19.9-10.8-41.3-10.8-63.5C128 86 214 0 320 0zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGalaxy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bh);
var Th = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gallery-thumbnails", f = 576, c = 512, e = [], t = "e3aa", o = "M512 64l0 224L64 288 64 64l448 0zM64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 0zM0 448l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm128 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGalleryThumbnails = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Th);
var Fh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "game-board", f = 448, c = 512, e = [], t = "f867", o = "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 0v80h80V96H144zm0 160V176H64v80h80zm80 0H144v80H64v80h80V336h80v80h80V336h80V256H304V176h80V96H304v80H224v80zm0 0h80v80H224V256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGameBoard = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fh);
var Hh = {}, Ga = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "game-board-simple", f = 448, c = 512, e = ["game-board-alt"], t = "f868", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 0l0 160 160 0 0-160L224 96zm0 160L64 256l0 160 160 0 0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGameBoardSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ga);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ga;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGameBoardAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Hh);
var Rh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "game-console-handheld", f = 384, c = 512, e = [], t = "f8bb", o = "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 352c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 64zM96 80l0 112c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-112c0-8.8-7.2-16-16-16L112 64c-8.8 0-16 7.2-16 16zM232 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 304l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGameConsoleHandheld = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rh);
var Uh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "game-console-handheld-crank", f = 576, c = 512, e = [], t = "e5b9", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 0c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 96zm32 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm144 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 168c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-24 0 0 72c0 13.3-10.7 24-24 24l-24 0 0-48 0-16 0-56 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGameConsoleHandheldCrank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uh);
var qh = {}, Wa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gamepad-modern", f = 640, c = 512, e = [127918, 63676, "gamepad-alt"], t = "e5a2", o = "M0 369.4l0 2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384l208 0 3.6 14.3c12 48 55.1 81.7 104.6 81.7C591.7 480 640 431.7 640 372.2l0-2.8c0-6.3-.5-12.5-1.6-18.7L605.7 159.8c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32s-149.5 10.9-195.3 22.3C75.2 66.6 42.9 109.6 34.3 159.8L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGamepadModern = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Wa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGamepadAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(qh);
var Gh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "garage", f = 640, c = 512, e = [], t = "e009", o = "M0 171.3L0 488c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-264c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 264c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-316.7c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM128 224l0 96 384 0 0-96-384 0zm0 128l0 160 384 0 0-160-384 0zm128 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGarage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gh);
var Wh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "garage-car", f = 640, c = 512, e = [], t = "e00a", o = "M0 488L0 171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4L640 488c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-264c0-17.7-14.3-32-32-32l-384 0c-17.7 0-32 14.3-32 32l0 264c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM254.3 293.4L242.2 328l155.6 0-12.1-34.6c-1.1-3.2-4.2-5.4-7.6-5.4l-116.3 0c-3.4 0-6.4 2.2-7.6 5.4zM188.9 335L209 277.5c7.9-22.5 29.1-37.5 52.9-37.5l116.3 0c23.8 0 45 15.1 52.9 37.5L451.1 335c17.2 9.5 28.9 27.9 28.9 49l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-192 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-21.1 11.7-39.5 28.9-49zM240 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGarageCar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wh);
var Eh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "garage-open", f = 640, c = 512, e = [], t = "e00b", o = "M0 171.3L0 488c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-264c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 264c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-316.7c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3zM194.1 320l-5.2 15c-17.2 9.5-28.9 27.9-28.9 49l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 192 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-21.1-11.7-39.5-28.9-49l-5.2-15L395 320l2.8 8-155.6 0 2.8-8-50.8 0zM240 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM512 224l-384 0 0 64 384 0 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGarageOpen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Eh);
var Vh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "garlic", f = 512, c = 512, e = [129476], t = "e40e", o = "M83.4 169.1C42.3 200.5 0 232.7 0 288C0 392.6 85.5 411.7 116.7 415.2C85 390.5 64 352.6 64 304c0-27.8 4.3-48.7 11-66.5c5.9-15.6 13.6-28.6 20.7-40.5c.8-1.4 1.7-2.8 2.5-4.2c7.8-13.2 15.1-26.2 20.5-43.3c1.2-3.7 2.3-7.7 3.3-11.9c-11.7 10.9-25.1 21.1-38.7 31.5zM384 416s128 0 128-128c0-55.3-42.3-87.5-83.4-118.9C389.8 139.5 352 110.6 352 64l0-16c0-26.5-21.5-48-48-48L288 0l0 80c0 30.2 4.7 51.9 11.4 69c6.7 17.1 15.7 30.3 25.5 43.8c1.2 1.6 2.4 3.3 3.6 4.9c0 0 0 0 0 0s0 0 0 0c19 25.8 39.4 53.5 39.4 106.3c0 49.2-21.5 87.3-53.7 112l69.7 0zM256 80l0-80L208 0c-26.5 0-48 21.5-48 48l0 16 0 16c0 33.4-4.2 58.5-10.8 79.2c-6.6 20.7-15.3 36.2-23.5 49.9l-2.5 4.2c-7.2 12.1-13.5 22.6-18.3 35.5c-5.3 13.9-9 31-9 55.2c0 69.3 54.9 112 120 112s120-42.7 120-112c0-42.1-15-62.5-33.5-87.7c0 0 0 0 0 0c0 0 0 0 0-.1c-1.1-1.5-2.2-3.1-3.4-4.6c-10.2-13.9-21.2-29.8-29.5-50.9C261.3 139.5 256 113.8 256 80zM136 448l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zm64 0l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zm64 0l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zm64 0l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGarlic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vh);
var Ih = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gas-pump-slash", f = 640, c = 512, e = [], t = "f5f4", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-72.2-56.6C569.5 397.9 576 379.7 576 360l0-136 0-32 0-24 0-13.5c0-17-6.7-33.3-18.7-45.3L480 32c-8.8-8.8-23.2-8.8-32 0s-8.8 23.2 0 32l32 32 0 64c0 29.8 20.4 54.9 48 62l0 138c0 8.5-2.7 16.4-7.2 22.9L384 275.7 384 64c0-35.3-28.7-64-64-64L160 0c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM96 171.6L96 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-49.5L96 171.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGasPumpSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ih);
var Kh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-circle-bolt", f = 640, c = 512, e = [], t = "e496", o = "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L232 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L475.6 380 440 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeCircleBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kh);
var Xh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-circle-minus", f = 640, c = 512, e = [], t = "e497", o = "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L232 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeCircleMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xh);
var Qh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-circle-plus", f = 640, c = 512, e = [], t = "e498", o = "M496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176zM320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L232 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3zM144 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM336 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeCirclePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qh);
var Ea = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-low", f = 512, c = 512, e = ["tachometer-alt-slow"], t = "f627", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-.6 0-1.3 0-1.9 0L190 142.3c-5.3-12.1-19.5-17.6-31.6-12.3s-17.6 19.5-12.3 31.6l64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeLow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ea);
var Va = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-max", f = 512, c = 512, e = ["tachometer-alt-fastest"], t = "f626", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeMax = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Va);
var Ia = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-min", f = 512, c = 512, e = ["tachometer-alt-slowest"], t = "f628", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeMin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ia);
var Ka = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-simple-low", f = 512, c = 512, e = ["tachometer-slow"], t = "f62c", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3L173.3 140.9c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4C197.8 321.6 192 336.1 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeSimpleLow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ka);
var Xa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-simple-max", f = 512, c = 512, e = ["tachometer-fastest"], t = "f62b", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-3.7-.3-7.3-.9-10.8l117.5-72.8c11.3-7 14.7-21.8 7.8-33s-21.8-14.8-33-7.8L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeSimpleMax = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xa);
var Qa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gauge-simple-min", f = 512, c = 512, e = ["tachometer-slowest"], t = "f62d", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-35.3-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6c-11.3-7-26.1-3.5-33 7.8s-3.5 26.1 7.8 33l117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGaugeSimpleMin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qa);
var Jh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ua;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGaveDandy = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Jh);
var Yh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gear-code", f = 512, c = 512, e = [], t = "e5e8", o = "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zm-208.2-3.9c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zM187.3 227.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L353.4 256l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGearCode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yh);
var Zh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gear-complex", f = 512, c = 512, e = [], t = "e5e9", o = "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2l0-51.9c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM256 176a80 80 0 1 1 0 160 80 80 0 1 1 0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGearComplex = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zh);
var ph = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gear-complex-code", f = 512, c = 512, e = [], t = "e5eb", o = "M305.4 21.8c-1.3-10.4-9.1-18.8-19.5-20C276.1 .6 266.1 0 256 0c-11.1 0-22.1 .7-32.8 2.1c-10.3 1.3-18 9.7-19.3 20l-2.9 23.1c-.8 6.4-5.4 11.6-11.5 13.7c-9.6 3.2-19 7.2-27.9 11.7c-5.8 3-12.8 2.5-18-1.5l-18-14c-8.2-6.4-19.7-6.8-27.9-.4c-16.6 13-31.5 28-44.4 44.7c-6.3 8.2-5.9 19.6 .5 27.8l14.2 18.3c4 5.1 4.4 12 1.5 17.8c-4.4 8.8-8.2 17.9-11.3 27.4c-2 6.2-7.3 10.8-13.7 11.6l-22.8 2.9c-10.3 1.3-18.7 9.1-20 19.4C.7 234.8 0 245.3 0 256c0 10.6 .6 21.1 1.9 31.4c1.3 10.3 9.7 18.1 20 19.4l22.8 2.9c6.4 .8 11.7 5.4 13.7 11.6c3.1 9.5 6.9 18.7 11.3 27.5c2.9 5.8 2.4 12.7-1.5 17.8L54 384.8c-6.4 8.2-6.8 19.6-.5 27.8c12.9 16.7 27.8 31.7 44.4 44.7c8.2 6.4 19.7 6 27.9-.4l18-14c5.1-4 12.2-4.4 18-1.5c9 4.6 18.3 8.5 27.9 11.7c6.1 2.1 10.7 7.3 11.5 13.7l2.9 23.1c1.3 10.3 9 18.7 19.3 20c10.7 1.4 21.7 2.1 32.8 2.1c10.1 0 20.1-.6 29.9-1.7c10.4-1.2 18.2-9.7 19.5-20l2.8-22.5c.8-6.5 5.5-11.8 11.7-13.8c10-3.2 19.7-7.2 29-11.8c5.8-2.9 12.7-2.4 17.8 1.5L385 457.9c8.2 6.4 19.6 6.8 27.8 .5c2.8-2.2 5.5-4.4 8.2-6.7L451.7 421c1.8-2.2 3.6-4.4 5.4-6.6c6.5-8.2 6-19.7-.4-27.9l-14-17.9c-4-5.1-4.4-12.2-1.5-18c4.8-9.4 9-19.3 12.3-29.5c2-6.2 7.3-10.8 13.7-11.6l22.8-2.8c10.3-1.3 18.8-9.1 20-19.4c.2-1.7 .4-3.5 .6-5.2l0-51.9c-.2-1.7-.4-3.5-.6-5.2c-1.3-10.3-9.7-18.1-20-19.4l-22.8-2.8c-6.4-.8-11.7-5.4-13.7-11.6c-3.4-10.2-7.5-20.1-12.3-29.5c-3-5.8-2.5-12.8 1.5-18l14-17.9c6.4-8.2 6.8-19.7 .4-27.9c-1.8-2.2-3.6-4.4-5.4-6.6L421 60.3c-2.7-2.3-5.4-4.5-8.2-6.7c-8.2-6.4-19.6-5.9-27.8 .5L366.7 68.3c-5.1 4-12.1 4.4-17.8 1.5c-9.3-4.6-19-8.6-29-11.8c-6.2-2-10.9-7.3-11.7-13.7l-2.8-22.5zM287.8 162.6l-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM187.3 227.3L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6l40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L353.4 256l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGearComplexCode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ph);
var xh = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gif", f = 576, c = 512, e = [], t = "e190", o = "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm296 64c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zm56 24l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-32 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0c-13.3 0-24 10.7-24 24zM128 256c0-26.5 21.5-48 48-48c8 0 15.4 1.9 22 5.3c11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8c7-4.4 11.2-12.1 11.2-20.3l0-51.9c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 13.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGif = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xh);
var iv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gift-card", f = 576, c = 512, e = [], t = "f663", o = "M353.5 68.8C361.1 55.9 374.9 48 389.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-72 0-1.3 0 34.8-59.2zm-131 0L257.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3L288 85.5l-24.1-41C247.7 16.9 218.1 0 186.2 0L184 0C135.4 0 96 39.4 96 88c0 14.4 3.5 28 9.6 40L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4zM512 384l0 64L64 448l0-64 448 0zm0-64L64 320l0-128 166.1 0-40.5 48.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1L288 197.5l61.6 73.9c8.5 10.2 23.6 11.6 33.8 3.1s11.6-23.6 3.1-33.8L345.9 192 512 192l0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGiftCard = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iv);
var av = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gingerbread-man", f = 448, c = 512, e = [], t = "f79d", o = "M296.9 158.5c-5.2 6-1.2 17.5 6.7 17.5l64.4 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-20.9 0c-19 0-29.4 22.2-17.2 36.7L385.2 407c22.6 27.2 19 67.5-8.2 90.1s-67.5 19-90.1-8.2l-45.6-54.8c-9-10.7-25.5-10.7-34.4 0L161.2 489c-22.6 27.2-63 30.8-90.1 8.2s-30.8-63-8.2-90.1l55.2-66.3c12.2-14.6 1.8-36.7-17.2-36.7L80 304c-35.3 0-64-28.7-64-64s28.7-64 64-64l64.4 0c7.9 0 11.9-11.5 6.7-17.5C136.7 141.7 128 119.9 128 96c0-53 43-96 96-96s96 43 96 96c0 23.9-8.7 45.7-23.1 62.5zM192 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGingerbreadMan = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(av);
var ev = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "glass", f = 384, c = 512, e = [129371], t = "f804", o = "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM70.9 128L66.4 64l251.3 0-4.6 64L70.9 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ev);
var nv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = T2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGlassChampagne = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(nv);
var fv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "glass-citrus", f = 512, c = 512, e = [], t = "f869", o = "M448 144c0-44.2-35.8-80-80-80c-26.2 0-49.4 12.6-64 32l-71.8 0C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 78.4-62.6 142.1-140.5 144l6.5-64.6c39.5-4.9 70-38.6 70-79.4zM249.3 224l-.1 1.3-.9-1.3 1 0zM8.3 138.5C14.3 131.8 23 128 32 128l288 0c9 0 17.7 3.8 23.7 10.5s9 15.7 8.1 24.7L322.7 454.4C319.5 487.1 291.9 512 259 512L93 512c-32.9 0-60.4-24.9-63.7-57.6L.2 163.2c-.9-9 2-18 8.1-24.7zM67.4 192l6.4 64 204.5 0 6.4-64L67.4 192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlassCitrus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fv);
var cv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "glass-empty", f = 384, c = 512, e = [], t = "e191", o = "M8.6 10.2C14.6 3.7 23.1 0 32 0L352 0c8.9 0 17.4 3.7 23.4 10.2s9.1 15.2 8.5 24.1L355.1 437.7c-3 41.9-37.8 74.3-79.8 74.3l-166.6 0c-42 0-76.8-32.4-79.8-74.3L.1 34.3c-.6-8.9 2.4-17.6 8.5-24.1zM66.4 64L92.7 433.1c.6 8.4 7.6 14.9 16 14.9l166.6 0c8.4 0 15.4-6.5 16-14.9L317.6 64 66.4 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlassEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cv);
var M = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "glass-half", f = 384, c = 512, e = ["glass-half-empty", "glass-half-full"], t = "e192", o = "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM77.8 224L66.4 64l251.3 0L306.2 224 77.8 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlassHalf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M);
var tv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = M;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGlassHalfEmpty = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(tv);
var ov = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = M;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGlassHalfFull = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ov);
var lv = {}, Ja = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "whiskey-glass-ice", f = 512, c = 512, e = ["glass-whiskey-rocks"], t = "f7a1", o = "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32zM417 283.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L356.3 417c-9.6 9.6-22.7 15-36.3 15s-26.7-5.4-36.3-15l-49-49L160 368c-35.3 0-64-28.7-64-64l0-22.9L69 96l374 0L415.8 282.5l1.2 1.2zM160 208c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l50.6 0c-1.7-5.1-2.6-10.5-2.6-16c0-13.6 5.4-26.7 15-36.3l33-33 0-10.7c0-17.7-14.3-32-32-32l-64 0zm85.7 98.3C242 310 240 314.9 240 320s2 10 5.7 13.7l60.7 60.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l60.7-60.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-60.7-60.7C330 242 325.1 240 320 240s-10 2-13.7 5.7l-60.7 60.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWhiskeyGlassIce = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ja);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ja;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGlassWhiskeyRocks = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lv);
var dv = {}, Ya = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "glasses-round", f = 576, c = 512, e = [128083, "glasses-alt"], t = "f5f5", o = "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80l56.1 0c21.3-47.2 68.8-80 124-80c26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6l0 10.5c0 .8 0 1.6-.1 2.4c.1 1.9 .1 3.8 .1 5.6c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128l-32.5 0c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8 .1-5.6c-.1-.8-.1-1.6-.1-2.4l0-10.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM136 416a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm376-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlassesRound = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ya);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ya;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGlassesAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(dv);
var rv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "globe-pointer", f = 512, c = 512, e = [], t = "e60e", o = "M352 256c0 22.2-1.2 43.6-3.3 64l-66.8 0 12.6-42.8c10.7-36.4-23.1-70.3-59.6-59.6l-74.6 21.9c.4-16.3 1.5-32.2 3.1-47.5l185.3 0c2.2 20.4 3.3 41.8 3.3 64zM20.4 280.6c-7.1 2.1-13.1 5.5-18.1 9.9C.8 279.2 0 267.7 0 256c0-22.1 2.8-43.5 8.1-64l123.1 0c-1.9 18.4-2.9 37.4-3.1 57L20.4 280.6zM231.4 491.6L272.4 352l71.9 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512c-7.2 0-16.3-3.1-27.3-13.4c1-2.2 1.9-4.6 2.7-7.1zM380.8 192l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-325.7 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7l-176.6 0zm-32.4 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM493.4 352c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlobePointer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rv);
var sv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "globe-snow", f = 448, c = 512, e = [], t = "f7a3", o = "M448 224c0 62.7-25.7 119.3-67.2 160L256 384l0-32 64 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4L262.6 256l25.4 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l25.4 0-68.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0 0 32L67.2 384C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM256 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM20.3 474.2L61.1 416l325.8 0 40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8S416.9 512 408 512L40 512c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlobeSnow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sv);
var hv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "globe-stand", f = 448, c = 512, e = [], t = "f5f6", o = "M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3l0 33.3-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-33.3c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L332.5 49.6c-9.4 9.4-9.4 24.6 0 33.9c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367zm193-15a144 144 0 1 0 0-288 144 144 0 1 0 0 288z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlobeStand = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hv);
var vv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "globe-wifi", f = 640, c = 512, e = [], t = "e685", o = "M352 256c0 3.7 0 7.3-.1 10.9c-11.2 16-19.8 33.8-25.3 53.1l-163.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm14.4 231c-14.3 6.8-29.3 12.4-44.9 16.5c9-12.1 17.3-26.6 24.7-43.2c5.9 9.5 12.7 18.4 20.2 26.7zM320 368c0 18 2.7 35.3 7.7 51.7c-3.2 9.6-6.7 18.6-10.4 27c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5c-11.6-26-20.9-58.2-27-94.6l153 0c-.5 5.3-.7 10.6-.7 16zM496 192l7.9 0 0 .2c-2.6-.1-5.3-.2-8-.2zm0 0c-42.7 0-81.9 15.2-112.4 40.6c-.5-13.8-1.4-27.4-2.8-40.6L496 192zm-2.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-325.7 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7l-176.6 0zm-32.4 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-48c27.2 0 51.9 10.2 70.6 27.1c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6c-24.4-21.9-56.6-35.3-92-35.3s-67.7 13.4-92 35.3c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2C444.1 330.2 468.9 320 496 320zm20 112a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm-51.5-35.9c8.3-7.5 19.4-12.1 31.5-12.1s23.2 4.6 31.5 12.1c6.6 5.9 16.7 5.4 22.6-1.1s5.4-16.7-1.1-22.6c-14-12.7-32.6-20.4-53-20.4s-39 7.7-53 20.4c-6.6 5.9-7.1 16-1.1 22.6s16 7.1 22.6 1.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGlobeWifi = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vv);
var uv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = a2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGloveBoxing = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(uv);
var mv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "goal-net", f = 640, c = 512, e = [], t = "e3ab", o = "M64 128c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-53-43-96-96-96L96 32C43 32 0 75 0 128L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320zm112 0c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16zm80 256l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm0-96l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGoalNet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mv);
var gv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "golf-club", f = 512, c = 512, e = [], t = "f451", o = "M508.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L264 392.5l0-.5L42.1 318C21.4 311.1 0 326.6 0 348.4L0 376l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 408l0 32 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 472l0 8c0 17.7 14.3 32 32 32l223.3 0c12 .3 23.6-6.3 29.3-17.7l224-448z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGolfClub = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gv);
var Pv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "golf-flag-hole", f = 512, c = 512, e = [], t = "e3ac", o = "M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24l0 208c0 1.3 .1 2.7 .3 4c-.2 1.3-.3 2.6-.3 4l0 92.8C51.5 349.4 0 380.5 0 416c0 53 114.6 96 256 96s256-43 256-96s-114.6-96-256-96c-27.9 0-54.8 1.7-80 4.8l0-77.9 194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM288 416c0 17.7-28.7 32-64 32s-64-14.3-64-32s28.7-32 64-32s64 14.3 64 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGolfFlagHole = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pv);
var Mv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gramophone", f = 384, c = 512, e = [], t = "f8bd", o = "M127 0c10.5-.4 20 6 23.6 15.9c0 0 0 .1 0 .1l.3 .7c.3 .7 .7 1.7 1.3 3.2c1.2 2.9 3.2 7.3 6 12.8c5.7 11.1 14.8 27 28.2 45.1c26.9 36.2 71.4 81.5 141.3 116.8c17.3 8.7 31.6 22.9 40.1 40.4c5.4 10.9 8.2 23 8.2 35l0 .3 0 .3c0 45-36.5 81.4-81.4 81.4L184 352c-13.3 0-24-10.7-24-24s10.7-24 24-24l110 0c18.7 0 33.9-15.1 34-33.7c-.1-5.4-1.5-10.7-4.1-15.6c-3.1-4.9-7.7-7.8-12.4-8.6c-44.1-7.3-133.1-7.9-241.4 69.4c-.3 .2-.7 .5-1 .7c-2.7 1.8-5.6 2.9-8.7 3.5c-3.2 .6-6.6 .6-10-.2c-1.2-.3-2.4-.7-3.6-1.1c-.5-.2-1-.5-1.5-.7c-.9-.4-1.7-.9-2.5-1.5c-1.2-.8-2.2-1.6-3.2-2.6c-1.4-1.3-2.5-2.7-3.6-4.2c-1.8-2.8-3-5.8-3.6-8.9c-.6-3.1-.5-6.4 .2-9.6c.1-.3 .2-.7 .3-1L104.8 17.9C107.5 7.7 116.5 .4 127 0zM32 416c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 32c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGramophone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mv);
var wv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grapes", f = 512, c = 512, e = [], t = "e306", o = "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM304 152a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM112 232a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm32 80A56 56 0 1 0 32 312a56 56 0 1 0 112 0zM112 456A56 56 0 1 0 0 456a56 56 0 1 0 112 0zm144-32a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM280 288a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm80 32a56 56 0 1 0 0-112 56 56 0 1 0 0 112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrapes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wv);
var Nv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grate", f = 448, c = 512, e = [], t = "e193", o = "M64 32C28.7 32 0 60.7 0 96L0 256 0 416c0 35.3 28.7 64 64 64l64 0 96 0 96 0 64 0c35.3 0 64-28.7 64-64l0-160 0-160c0-35.3-28.7-64-64-64l-64 0-96 0-96 0L64 32zm0 64l32 0 0 128-32 0L64 96zm0 192l32 0 0 128-32 0 0-128zm96 128l0-128 32 0 0 128-32 0zm96 0l0-128 32 0 0 128-32 0zm96 0l0-128 32 0 0 128-32 0zm32-192l-32 0 0-128 32 0 0 128zM288 96l0 128-32 0 0-128 32 0zm-96 0l0 128-32 0 0-128 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrate = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nv);
var zv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grate-droplet", f = 576, c = 512, e = [], t = "e194", o = "M0 96C0 60.7 28.7 32 64 32l64 0 96 0 96 0 64 0c35.3 0 64 28.7 64 64l0 66.2c-15.1 4.3-28.2 14.6-35.8 28.8L336.9 332.2C325.8 353.1 320 376.4 320 400c0 29.6 8.9 57.1 24.2 80L320 480l-96 0-96 0-64 0c-35.3 0-64-28.7-64-64L0 256 0 96zm96 0L64 96l0 128 32 0L96 96zM64 416l32 0 0-128-32 0 0 128zm128 0l0-128-32 0 0 128 32 0zm96 0l0-128-32 0 0 128 32 0zM384 96l-32 0 0 128 32 0 0-128zM256 96l0 128 32 0 0-128-32 0zm-96 0l0 128 32 0 0-128-32 0zM440.5 206.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrateDroplet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zv);
var Za = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid", f = 448, c = 512, e = ["grid-3"], t = "e195", o = "M0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40L0 72zM0 232c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM128 392l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM288 232l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM448 72l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM448 392l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrid = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Za);
var Lv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-2", f = 512, c = 512, e = [], t = "e196", o = "M224 80c0-26.5-21.5-48-48-48L80 32C53.5 32 32 53.5 32 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zm0 256c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zM288 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrid2 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lv);
var Cv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-2-plus", f = 512, c = 512, e = [], t = "e197", o = "M80 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 256l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM288 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm96 192c13.3 0 24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrid2Plus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cv);
var Dv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Za;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faGrid3 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Dv);
var $v = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-4", f = 448, c = 512, e = [], t = "e198", o = "M0 48c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16L0 48zM0 167.5c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6zM16 270.9l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6c0-8.8 7.2-16 16-16zM0 406.4c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16L16 480c-8.8 0-16-7.2-16-16l0-57.6zM119.5 48c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6zm0 119.5c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6zm16 103.5l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6zM254.9 32l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6c0-8.8 7.2-16 16-16zm0 119.5l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6zm16 103.5l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6c0-8.8 7.2-16 16-16zM358.4 48c0-8.8 7.2-16 16-16L432 32c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6zm0 119.5c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6zm16 103.5l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6c0-8.8 7.2-16 16-16zm-16 135.5c0-8.8 7.2-16 16-16l57.6 0c8.8 0 16 7.2 16 16l0 57.6c0 8.8-7.2 16-16 16l-57.6 0c-8.8 0-16-7.2-16-16l0-57.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrid4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($v);
var _v = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-5", f = 448, c = 512, e = [], t = "e199", o = "M0 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80L0 48zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM0 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM208 32l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM192 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM192 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 32l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM384 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM384 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrid5 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_v);
var bv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-dividers", f = 512, c = 512, e = [], t = "e3ad", o = "M0 24C0 10.7 10.7 0 24 0L488 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24zM64 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 288l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM192 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm32 256l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM352 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm32 256l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM24 288l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 336c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGridDividers = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bv);
var Sv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-horizontal", f = 448, c = 512, e = [], t = "e307", o = "M128 168c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 160c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-160l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-160l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGridHorizontal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sv);
var yv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-round", f = 448, c = 512, e = [], t = "e5da", o = "M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 160A64 64 0 1 1 0 256a64 64 0 1 1 128 0zM64 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM288 96A64 64 0 1 1 160 96a64 64 0 1 1 128 0zM224 320a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-256a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm64 96a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM384 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGridRound = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yv);
var Ov = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-round-2", f = 512, c = 512, e = [], t = "e5db", o = "M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm0 256a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM288 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGridRound2 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ov);
var kv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-round-2-plus", f = 512, c = 512, e = [], t = "e5dc", o = "M128 224a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 256a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM480 128a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c13.3 0 24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGridRound2Plus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kv);
var Av = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-round-4", f = 448, c = 512, e = [], t = "e5dd", o = "M44.8 121.6a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm0 119.5a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7A44.8 44.8 0 1 1 0 315.7a44.8 44.8 0 1 1 89.6 0zM44.8 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM209.1 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM164.3 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM328.5 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zm44.8 74.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM283.7 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 76.8a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 241.1a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6zM448 315.7a44.8 44.8 0 1 1 -89.6 0 44.8 44.8 0 1 1 89.6 0zM403.2 480a44.8 44.8 0 1 1 0-89.6 44.8 44.8 0 1 1 0 89.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGridRound4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Av);
var jv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grid-round-5", f = 448, c = 512, e = [], t = "e5de", o = "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM128 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGridRound5 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jv);
var Bv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grill", f = 448, c = 512, e = [], t = "e5a3", o = "M0 72C0 49.9 17.9 32 40 32l368 0c22.1 0 40 17.9 40 40l0 24c0 89.8-52.9 167.3-129.2 203l63.2 147.5c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L316.7 416 160 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96L0 72zM151.8 368l144.3 0-22.9-53.4c-15.9 3.6-32.3 5.4-49.3 5.4s-33.4-1.9-49.3-5.4L151.8 368zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrill = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bv);
var Tv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grill-fire", f = 576, c = 512, e = [], t = "e5a4", o = "M0 72C0 49.9 17.9 32 40 32l368 0c22.1 0 40 17.9 40 40l0 24c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1c-17.7-16-44.7-16-62.5-.1c-35.4 31.6-65.6 67.7-87.3 102.8c-15 24.3-27.7 51-33.6 77.3c-1.2 0-2.4 0-3.6 0c-16.9 0-33.4-1.9-49.3-5.4L151.8 368l73 0c1.5 16.6 5.2 32.7 10.7 48L160 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96L0 72zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm320 72c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C560.5 268 576 320.2 576 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C389 327.1 352 363.6 352 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrillFire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tv);
var Fv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grill-hot", f = 448, c = 512, e = [], t = "e5a5", o = "M120 0c13.3 0 24 10.7 24 24l0 2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4l0 2.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6L96 24c0-13.3 10.7-24 24-24zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472l-171.7 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424l151.1 0-18.3-42.7C277.7 383.1 267 384 256 384l-64 0c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 24l0 2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4l0 2.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6l0-2.6c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGrillHot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fv);
var Hv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grip-dots", f = 448, c = 512, e = [], t = "e410", o = "M336 176a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm-160 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM64 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM336 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM16 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGripDots = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hv);
var Rv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "grip-dots-vertical", f = 256, c = 512, e = [], t = "e411", o = "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 416A48 48 0 1 0 0 416a48 48 0 1 0 96 0zM208 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGripDotsVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rv);
var Uv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "guitar-electric", f = 512, c = 512, e = [127928], t = "f8be", o = "M352 81.1l0 33.6L243.8 223c-14.6-26.1-5.5-50.4 3.2-64.7c4.8-7.9 4.8-18.7-1.7-25.3s-17.1-6.6-23.6 0l-29.9 30.2c-9.1 9.2-14.7 21.5-20.2 33.5c0 0 0 0 0 0s0 0 0 0c-1.2 2.6-2.3 5.1-3.5 7.6c-3.5 7.3-8.9 15.7-17.1 24c-24.7 25-64.7 40.2-89.6 47.7c-14.5 4.4-28.1 11.7-38.7 22.4c-30 30.4-30 79.6 0 110l79.9 80.8c30 30.4 78.7 30.4 108.8 0c10.7-10.8 17.9-24.5 22.2-39.2c7.5-25.2 22.5-65.6 47.2-90.6c10-10.1 20-16 28.3-19.3l1.1-.5s0 0 0 0c11.3-4.6 23-9.4 31.6-18l21.6-21.8c6.5-6.6 6.5-17.3 0-23.8s-17.3-6.6-25.8-3c-11.1 4.7-28 7.3-48.3-4.7L461.3 96l2.7 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-1.1 0c-9.7 0-19.2 2.9-27.3 8.3L366.2 54.5C357.3 60.4 352 70.4 352 81.1zM195.3 268.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-64 64l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGuitarElectric = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uv);
var qv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "guitars", f = 512, c = 512, e = [], t = "f8bf", o = "M104 0l48 0c13.3 0 24 10.7 24 24l0 52.2c0 6.2-1.4 12.3-4.2 17.9L152 133.7l0 44.4c50.3 8.6 88 43.8 88 86c0 14-4.2 27.3-11.6 39.1c-8.2 13-7.5 32 2.9 43.4c5.9 6.5 10.9 13.7 14.8 21.3c-2.3 4.9-4.7 9.6-7 13.9c-8.8 16.3-15 35.6-15 56.5c0 11.6 1.9 22.8 5.4 33.3C205.9 496.1 169.3 512 128 512C57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5c10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-42.1 37.7-77.3 88-86l0-44.4L84.2 94.1C81.4 88.6 80 82.4 80 76.2L80 24C80 10.7 90.7 0 104 0zm24 344a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM360 148.6l-21.4-24.5c-6.6-7.6-9.3-17.9-7.2-27.8l13.9-64.8C349.2 13.1 365.4 0 384.2 0c22 0 39.8 17.8 39.8 39.8l0 4.6c0 12.4-6.4 23.3-16 29.7l0 164.7c27.9-4.2 39.6-19.4 44.5-31.3c3.3-8.2 10.7-15.5 19.5-15.5s16 7.2 16 16l0 29.3c0 11.6-4.8 22.8-9.3 33.5l-.5 1.1c-3.3 7.8-6.2 18.5-6.2 32.1c0 33.5 17 70.9 28.8 92.9c6.9 12.7 11.2 26.9 11.2 41.3c0 40.8-33 73.8-73.8 73.8l-108.4 0C289 512 256 479 256 438.2c0-14.5 4.3-28.6 11.2-41.3C279 374.9 296 337.5 296 304c0-11.2-2-20.5-4.5-27.8c-.9-2.5-1.8-5-2.7-7.5c0 0 0 0 0 0s0 0 0 0c-4.3-11.8-8.8-23.8-8.8-36.2l0-40.6c0-8.8 7.2-16 16-16s16.1 7.2 18.2 15.8c3.9 16.4 14.9 40.5 45.8 46.7l0-89.9zM336 320c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGuitars = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qv);
var Gv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gun-slash", f = 640, c = 512, e = [], t = "e19c", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8 432.9 240l31.1 0c8.5 0 16.6-3.4 22.6-9.4L509.3 208l66.7 0c17.7 0 32-14.3 32-32l0-80c0-17.7-14.3-32-32-32l-16 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L113.9 64 38.8 5.1zM195.6 128L496 128c8.8 0 16 7.2 16 16s-7.2 16-16 16l-259.6 0-40.8-32zM338.5 240l43.4 0-9.5 26.6L338.5 240zM324.9 352L264 304l-3 0 .5-2L32 121.2 32 208c0 17.7 14.3 32 32 32l10 0c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480l96 0c14.7 0 27.5-10 31-24.2L249 352l75.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGunSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gv);
var Wv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "gun-squirt", f = 576, c = 512, e = [], t = "e19d", o = "M128 56c0-13.3-10.7-24-24-24S80 42.7 80 56l0 9.3C34.6 72.9 0 112.4 0 160c0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480l104 0c14.7 0 27.5-10 31-24.2L219 376l53 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-41 0 18-72 199 0c41.8 0 77.4-26.7 90.5-64l13.5 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24l-13.5 0C525.4 90.7 489.8 64 448 64L128 64l0-8zM96 128l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 192c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faGunSquirt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wv);
var Ev = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "h1", f = 576, c = 512, e = [], t = "f313", o = "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96zm448 0c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-64 32c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l17.7-8.8L448 384l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-288z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faH1 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ev);
var Vv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "h2", f = 640, c = 512, e = [], t = "f314", o = "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96zm385.9 47.4c11.6-9.9 26.4-15.4 41.7-15.4l4.5 0c35.3 0 64 28.7 64 64l0 5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4c-9.7 8.9-13 22.9-8.2 35.2S386.8 448 400 448l208 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-125.7 0 100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4l0-5.8c0-70.7-57.3-128-128-128l-4.5 0c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5l29-24.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faH2 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vv);
var Iv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "h3", f = 640, c = 512, e = [], t = "f315", o = "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96zM400 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l114.7 0-89.4 89.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l72 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-64.6 0c-11.7 0-21.7-8.5-23.7-20.1l-.2-1.2c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.2 1.2c7.1 42.4 43.8 73.5 86.8 73.5l64.6 0c66.3 0 120-53.7 120-120c0-64.6-51-117.2-114.9-119.9l89.5-89.5c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L400 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faH3 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Iv);
var Kv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "h4", f = 640, c = 512, e = [], t = "f86a", o = "M479 103.8L441 256l135 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-176 0c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l48-192c4.3-17.1 21.7-27.6 38.8-23.3s27.6 21.7 23.3 38.8zM32 64c17.7 0 32 14.3 32 32l0 128 192 0 0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128L64 288l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 256 0 96C0 78.3 14.3 64 32 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faH4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kv);
var Xv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "h5", f = 640, c = 512, e = [], t = "e412", o = "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96zM432 64c-15.1 0-28.2 10.6-31.3 25.4l-32 152c-2 9.4 .4 19.3 6.5 26.8s15.2 11.8 24.8 11.8l124 0c28.7 0 52 23.3 52 52s-23.3 52-52 52l-67.6 0c-10.3 0-19.5-6.6-22.8-16.4l-3.2-9.7c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l3.2 9.7c12 35.9 45.6 60.2 83.5 60.2l67.6 0c64.1 0 116-51.9 116-116s-51.9-116-116-116l-84.6 0L458 128l118 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L432 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faH5 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xv);
var Qv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "h6", f = 640, c = 512, e = [], t = "e413", o = "M537 116l-35.3 44.1C578.6 163.1 640 226.4 640 304c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.3 13-75.5 37-105.5L487 76c11-13.8 31.2-16 45-5s16 31.2 5 45zM416 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM32 64c17.7 0 32 14.3 32 32l0 128 192 0 0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128L64 288l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 256 0 96C0 78.3 14.3 64 32 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faH6 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qv);
var Jv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hammer-brush", f = 640, c = 512, e = [], t = "e620", o = "M144 0C64.5 0 0 64.5 0 144c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l51.3-25.6c13.9 17.1 34.8 27.3 57.4 27.3l66.3 0c21.9 0 42-12.4 51.8-32l38.1 0c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l-38.1 0C240.1 12.4 220 0 198.1 0L144 0zM112 192L99.2 448.1c-1.7 34.8 26 63.9 60.8 63.9s62.5-29.1 60.8-63.9L208 192l-96 0zM418.2 505.4l20.7-62.1c2.9-8.8 15.3-8.8 18.2 0l20.7 62.1c1.3 3.9 5 6.6 9.1 6.6L592 512c26.5 0 48-21.5 48-48l0-144-288 0 0 144c0 26.5 21.5 48 48 48l9.1 0c4.1 0 7.8-2.6 9.1-6.6zM380.5 237c-17.2 11.5-27.7 30.5-28.5 51L640 288c-.7-20.5-11.3-39.5-28.5-51l-65.1-43.4c-.8-.5-1.6-.9-2.4-1.2L544 48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 144.5c-.9 .3-1.7 .7-2.4 1.2L380.5 237zM496 64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHammerBrush = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jv);
var Yv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hammer-crash", f = 640, c = 512, e = [], t = "e414", o = "M283.9 378.6l18.3-60.1c18-4.1 34.2-16 43.1-33.8l64-128c10.5-21.1 8.4-45.2-3.7-63.6l52.7-76.6c3.7-5.4 10.4-8 16.7-6.5s11.2 6.7 12.2 13.1l16.2 104.1 105.1-7.4c6.5-.5 12.7 3.1 15.5 9s1.8 12.9-2.6 17.8L550.1 224l71.3 77.5c4.4 4.8 5.5 11.9 2.6 17.8s-9 9.5-15.5 9l-105.1-7.4L487.3 425c-1 6.5-5.9 11.7-12.2 13.1s-13-1.1-16.7-6.5l-59.7-86.7-91.4 52.2c-5.7 3.3-12.8 2.7-17.9-1.4s-7.2-10.9-5.3-17.2zm28.3-101.7c-9.3 10.9-25.2 14.4-38.6 7.7l-65.9-32.9s0 0 0 0L122 208.8s0 0 0 0L17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80C48.8 22.8 59.9 16 72 16l120 0c5 0 9.9 1.2 14.3 3.4l78.2 39.1 81.8 40.9c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-1.2 2.4-2.7 4.6-4.4 6.6zM107.6 237.4l85.9 42.9L90.9 485.5c-11.9 23.7-40.7 33.3-64.4 21.5S-6.8 466.2 5.1 442.5L107.6 237.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHammerCrash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yv);
var Zv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hammer-war", f = 384, c = 512, e = [], t = "f6e4", o = "M192 0c17.7 0 32 14.3 32 32l0 18.8L347.3 32.4c9.2-1.4 18.6 1.3 25.6 7.4S384 54.7 384 64l0 192c0 9.3-4.1 18.2-11.1 24.2s-16.4 8.8-25.6 7.4L196.7 265.1c-3.1-.5-6.3-.5-9.5 0L36.7 287.6c-9.2 1.4-18.6-1.3-25.6-7.4S0 265.3 0 256L0 64c0-9.3 4.1-18.2 11.1-24.2s16.4-8.8 25.6-7.4L160 50.8 160 32c0-17.7 14.3-32 32-32zm0 296.7l32 4.8L224 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-178.5 32-4.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHammerWar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zv);
var pv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-back-point-down", f = 448, c = 512, e = [], t = "e19e", o = "M136 512c-22.1 0-40-17.9-40-40l0-200 0-7 0-73c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 55.7c-2-1.4-3.9-3-5.8-4.5L39 227.2C24.4 215 16 197 16 178L16 140c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0L288 0c70.7 0 128 57.3 128 128l0 64 0 32c0 26.5-21.5 48-48 48c-12.4 0-23.6-4.7-32.1-12.3C334 284.5 313.3 304 288 304c-12.4 0-23.6-4.7-32.1-12.3C254 316.5 233.3 336 208 336c-12.3 0-23.5-4.6-32-12.2L176 472c0 22.1-17.9 40-40 40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandBackPointDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pv);
var xv = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-back-point-left", f = 512, c = 512, e = [], t = "e19f", o = "M0 184c0-22.1 17.9-40 40-40l200 0 7 0 73 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-55.7 0c1.4-2 3-3.9 4.5-5.8l16-19.2C297 72.4 315 64 334 64L372 64c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4L512 336c0 70.7-57.3 128-128 128l-64 0-32 0c-26.5 0-48-21.5-48-48c0-12.4 4.7-23.6 12.3-32.1C227.5 382 208 361.3 208 336c0-12.4 4.7-23.6 12.3-32.1C195.5 302 176 281.3 176 256c0-12.3 4.6-23.5 12.2-32L40 224c-22.1 0-40-17.9-40-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandBackPointLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xv);
var iu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-back-point-ribbon", f = 448, c = 512, e = [], t = "e1a0", o = "M112 128l-68.2 0c-6.5 0-11.8-5.3-11.8-11.8c0-3.9 1.9-7.5 5.1-9.7L75.6 80 37.1 53.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 37.3 37.3 32 43.8 32l69 0C116.5 13.7 132.6 0 152 0c22.1 0 40 17.9 40 40l0 8 0 64 0 16-16 0-64 0zm0 112l0-80 80 0 0 28.2c8.5-7.6 19.7-12.2 32-12.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48l0 32 0 64c0 70.7-57.3 128-128 128l-118.1 0c-37.4 0-73.7-13.1-102.4-37.1l-5.4-4.5C48.9 446.1 32 410 32 372L32 334c0-19 8.4-37 23-49.2l19.2-16c1.9-1.6 3.8-3.1 5.8-4.5L80 320c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73 0-7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandBackPointRibbon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iu);
var au = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-back-point-right", f = 512, c = 512, e = [], t = "e1a1", o = "M512 168c0-22.1-17.9-40-40-40l-200 0-7 0-73 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l55.7 0c-1.4-2-3-3.9-4.5-5.8L227.2 71C215 56.4 197 48 178 48L140 48c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9L0 320c0 70.7 57.3 128 128 128l64 0 32 0c26.5 0 48-21.5 48-48c0-12.4-4.7-23.6-12.3-32.1C284.5 366 304 345.3 304 320c0-12.4-4.7-23.6-12.3-32.1C316.5 286 336 265.3 336 240c0-12.3-4.6-23.5-12.2-32L472 208c22.1 0 40-17.9 40-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandBackPointRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(au);
var eu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-back-point-up", f = 448, c = 512, e = [], t = "e1a2", o = "M136 0C113.9 0 96 17.9 96 40l0 200 0 7 0 73c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.7c-2 1.4-3.9 3-5.8 4.5L39 284.8C24.4 297 16 315 16 334L16 372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L288 512c70.7 0 128-57.3 128-128l0-64 0-32c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C334 227.5 313.3 208 288 208c-12.4 0-23.6 4.7-32.1 12.3C254 195.5 233.3 176 208 176c-12.3 0-23.5 4.6-32 12.2L176 40c0-22.1-17.9-40-40-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandBackPointUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eu);
var nu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-fingers-crossed", f = 384, c = 512, e = [], t = "e1a3", o = "M93 18.5l17.3 37.2L75 131.3 35 45.5c-7.5-16-.5-35.1 15.5-42.5s35.1-.5 42.5 15.5zM150.6 272s0 0 0 0l1.4 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6l0 8.6c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363l0-27c0-35.3 28.7-64 64-64l16 0s0 0 0 0l35.3 0s0 0 0 0l35.3 0zM192 252.1c-8-5.4-17.2-9.2-27-11L181 207l11 23.7 0 21.5zM130.2 240l-70.6 0L163 18.5c7.5-16 26.5-22.9 42.5-15.5s22.9 26.5 15.5 42.5L130.2 240zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandFingersCrossed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nu);
var fu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-heart", f = 512, c = 512, e = [], t = "f4bc", o = "M256 0c17.7 0 32 14.3 32 32l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 208c0 97.2-78.8 176-176 176l-19.2 0c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6l0-272c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-17.7 14.3-32 32-32zM208 362.6c0 12.1 5.1 23.6 14.1 31.6l55.2 49.7c6.1 5.5 15.3 5.5 21.4 0l55.2-49.7c9-8.1 14.1-19.6 14.1-31.6c0-23.5-19.1-42.6-42.6-42.6l-1.1 0c-14.6 0-28.3 7.3-36.4 19.5c-8.1-12.2-21.7-19.5-36.4-19.5l-1.1 0c-23.5 0-42.6 19.1-42.6 42.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fu);
var cu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-holding-box", f = 576, c = 512, e = [], t = "f47b", o = "M224 121.7c0 3.5 2.8 6.3 6.3 6.3c1.1 0 2.2-.3 3.1-.8l46.6-26.6c4.9-2.8 11-2.8 15.9 0l46.6 26.6c1 .5 2 .8 3.1 .8c3.5 0 6.3-2.8 6.3-6.3L352 0l80 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48L96 48c0-26.5 21.5-48 48-48l80 0 0 121.7zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandHoldingBox = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cu);
var tu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-holding-circle-dollar", f = 576, c = 512, e = [], t = "e621", o = "M128 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7.1 2.3 15.1 4.9 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandHoldingCircleDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tu);
var ou = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-holding-magic", f = 576, c = 512, e = [], t = "f6e5", o = "M192 80c0 8.8 7.2 16 16 16l80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0c-44.2 0-80-35.8-80-80s35.8-80 80-80L320 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l64 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L208 64c-8.8 0-16 7.2-16 16zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandHoldingMagic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ou);
var lu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-holding-seedling", f = 576, c = 512, e = [], t = "f4bf", o = "M96 14.5C96 6.5 102.5 0 110.5 0L160 0c88.4 0 160 71.6 160 160l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-14.5 0C161.1 160 96 94.9 96 14.5zm384 0C480 89 424.1 150.3 352 159c-.2-44.9-15.9-86.2-42-118.8C338.2 15.2 375.3 0 416 0l49.5 0c8 0 14.5 6.5 14.5 14.5zm88.2 321.7c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandHoldingSeedling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lu);
var du = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-holding-skull", f = 576, c = 512, e = [], t = "e1a4", o = "M371.6 232.2c-6 3.8-9.4 10.8-8 17.7l4.1 20.6c.2 .9 .3 1.9 .3 2.9c0 8-6.5 14.6-14.6 14.6l-130.9 0c-8 0-14.6-6.5-14.6-14.6c0-1 .1-1.9 .3-2.9l4.1-20.6c1.4-7-2-13.9-8-17.7C167.8 209 144 171 144 128C144 57.3 208.5 0 288 0s144 57.3 144 128c0 43-23.8 81-60.4 104.2zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L192 512 32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.8 0 44.9-36c22.7-18.2 50.9-28 80-28l78.3 0 16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l120.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384c0 0 0 0 0 0l-.9 0c.3 0 .6 0 .9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandHoldingSkull = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(du);
var ru = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-horns", f = 384, c = 512, e = [], t = "e1a9", o = "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32l0 208-64 0L32 32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-64-64c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zM320 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 0 96 0 64c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363l0-27c0-35.3 28.7-64 64-64l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c35.3 0 64-28.7 64-64l0-64 0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandHorns = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ru);
var su = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-love", f = 512, c = 512, e = [], t = "e1a5", o = "M160 0c17.7 0 32 14.3 32 32l0 159.9 0 .1 0 96c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c35.3 0 64-28.7 64-64l0-63.9c0 0 0 0 0-.1l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 240c0 97.2-78.8 176-176 176l-19.2 0c-59.6 0-116.9-22.9-160-64L12.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6l0-304c0-17.7 14.3-32 32-32zm64 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96zm128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandLove = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(su);
var hu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-point-ribbon", f = 448, c = 512, e = [], t = "e1a6", o = "M64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16L11.8 128C5.3 128 0 122.7 0 116.2c0-3.9 1.9-7.5 5.1-9.7L43.6 80 5.1 53.5C1.9 51.3 0 47.7 0 43.8C0 37.3 5.3 32 11.8 32L64 32zm0 208l0-80 64 0 0 80-64 0zm192-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-64-64c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6l0 8.6c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L69.5 453.5C45.5 429.5 32 396.9 32 363l0-27c0-35.3 28.7-64 64-64l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandPointRibbon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hu);
var vu = {}, pa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hands-holding-diamond", f = 640, c = 512, e = ["hand-receiving"], t = "f47c", o = "M297.4 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zM80 104c0-22.1-17.9-40-40-40S0 81.9 0 104l0 56 0 64L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3c0 0 0 0 0 0l-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 224l0-80 0-40zm480 0l0 40 0 80 0 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2c0 0 0 0 0 0l-25.3 25.3c-21 21-32.8 49.5-32.8 79.2l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 224l0-64 0-56c0-22.1-17.9-40-40-40s-40 17.9-40 40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandsHoldingDiamond = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = pa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHandReceiving = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vu);
var uu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hand-wave", f = 512, c = 512, e = [], t = "e1a7", o = "M352.2 82.3L351 73.8c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S297.5-1.1 306.3 .2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM185.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7l0-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40l0 176.3c0 60.2-27.9 116.9-75.5 153.7C385.7 505.3 321 515.7 263 498.7c-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9 .1 .1L165.3 344c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L57.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L229.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L105.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L293.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L185.4 70.6zM13.7 352.2c8.7-1.3 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.2 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9L.2 370.3c-1.2-8.7 4.8-16.9 13.6-18.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandWave = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uu);
var mu = {}, xa = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hands-holding-heart", f = 640, c = 512, e = ["hands-heart"], t = "f4c3", o = "M195.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L342.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L195.9 136.9zM40 64c22.1 0 40 17.9 40 40l0 40 0 80 0 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2c0 0 0 0 0 0l25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 224l0-64 0-56C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 56 0 64 0 101.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3c0 0 0 0 0 0l15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3l0-40.2 0-80 0-40c0-22.1 17.9-40 40-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandsHoldingHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xa);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = xa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHandsHeart = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(mu);
var i4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hands-holding-dollar", f = 640, c = 512, e = ["hands-usd"], t = "f4c5", o = "M344 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c0 0 0 0 0 0c-2.1-.7-4.1-1.4-5.9-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L296 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM40 64c22.1 0 40 17.9 40 40l0 40 0 80 0 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2c0 0 0 0 0 0l25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 224l0-64 0-56C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 56 0 64 0 101.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3c0 0 0 0 0 0l15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3l0-40.2 0-80 0-40c0-22.1 17.9-40 40-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHandsHoldingDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i4);
var gu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = i4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHandsUsd = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(gu);
var Pu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hashtag-lock", f = 576, c = 512, e = [], t = "e415", o = "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128l95.1 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128l58.2 0c17.7 0 32 14.3 32 32c0 .4 0 .8 0 1.1c-24.1 3.5-45.8 14.6-62.4 30.9l-38.5 0L325.8 320l2.8 0c-5.4 9.4-8.6 20.3-8.6 32l0 32-4.9 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7-95.1 0-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384 32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 21.3-128L64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l68.9 0 11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320l95.1 0 21.3-128-95.1 0zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHashtagLock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pu);
var Mu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hat-beach", f = 640, c = 512, e = [], t = "e606", o = "M320 448c176.7 0 320-57.3 320-128c0-19.3-11.8-36.7-29.7-43.9L574.9 262c.7 4.2 1.1 8.5 1.1 12.8c0 42.7-34.6 77.3-77.3 77.3c-12.2 0-24.1-2.9-34.7-8.3c-10.7 5.4-22.6 8.3-34.7 8.3c-38.6 0-70.6-28.3-76.3-65.4c-10.6 .9-21.6 1.4-32.9 1.4c-88.4 0-160-28.7-160-64c0 0 0 0 0 0L29.7 276.1C11.8 283.3 0 300.7 0 320c0 70.7 143.3 128 320 128zm32-242.7c0-42.7 34.6-77.3 77.3-77.3c7.1 0 14.1 1 20.9 2.9C421.1 90.4 373.6 64 320 64c-70.4 0-130.2 45.5-151.6 108.7l.1-.2C174.7 201.3 240.1 224 320 224c11.7 0 23-.5 34-1.4c-1.3-5.6-2-11.5-2-17.3zM473.1 168c-5.5 3.8-12.7 3.8-18.2 0c-7.5-5.2-16.4-8-25.7-8c-25 0-45.3 20.3-45.3 45.3c0 9.2 2.8 18.2 8 25.7c3.8 5.5 3.8 12.7 0 18.2c-5.2 7.5-8 16.4-8 25.7c0 25 20.3 45.3 45.3 45.3c9.2 0 18.2-2.8 25.7-8c5.5-3.8 12.7-3.8 18.2 0c7.5 5.2 16.4 8 25.7 8c25 0 45.3-20.3 45.3-45.3c0-9.2-2.8-18.2-8-25.7c-3.8-5.5-3.8-12.7 0-18.2c5.2-7.5 8-16.4 8-25.7c0-25-20.3-45.3-45.3-45.3c-9.2 0-18.2 2.8-25.7 8zM464 216a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHatBeach = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mu);
var wu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hat-chef", f = 512, c = 512, e = [], t = "f86b", o = "M153.6 51.2C177 20.1 214.1 0 256 0s79 20.1 102.4 51.2c16-12.1 36-19.2 57.6-19.2c7.1 0 14.4 .8 21.6 2.5C482 44.7 512 84.3 512 128c0 7.1-.8 14.4-2.5 21.6C496 224 448 320 448 320l-74.4 0 26.2-157.4c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2L341.1 320 272 320l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160-69.1 0L143.8 157.4c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4L138.4 320 64 320s-48-96-61.5-170.4C.8 142.4 0 135.1 0 128c0-43.7 30-83.3 74.4-93.5C81.6 32.8 88.9 32 96 32c21.6 0 41.6 7.1 57.6 19.2zM448 352l0 96c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-96 384 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHatChef = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wu);
var Nu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hat-santa", f = 640, c = 512, e = [], t = "f7a7", o = "M149.7 137.8L64 352l384 0L385.1 210.6c-.8-1.7-1.1-3.5-1.1-5.4c0-7.3 5.9-13.2 13.2-13.2l.8 0c1.4 0 2.7 .2 4 .6l55.3 16.6c2.1-3.2 4.5-6.1 7.2-8.8c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8zm434.3 44.4C583 169.8 572.7 160 560 160s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C489.8 217 480 227.3 480 240s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C537 310.2 547.3 320 560 320s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C630.2 263 640 252.7 640 240s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 384c-26.5 0-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHatSanta = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nu);
var zu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hat-winter", f = 512, c = 512, e = [], t = "f7a8", o = "M279.9 22.2C279 9.8 268.7 0 256 0s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C326.2 103 336 92.7 336 80s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 480c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32zM216.4 175.6c-14.2 0-28.4-5.4-39.3-16.1c-62.7 27.1-98.6 85.4-118.9 139.6c4.2 1.6 8.9 1.4 13-.6l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.5 2.3 9.8 2.3 14.3 0l35.4-17.7c13.5-6.8 29.4-6.8 42.9 0l35.4 17.7c4.1 2 8.8 2.2 13 .6c-20.3-54.2-56.2-112.5-118.9-139.6c-10.9 10.7-25.1 16.1-39.3 16.1C285.5 185.7 271.5 192 256 192s-29.5-6.3-39.6-16.4zM48.1 329.5C34.3 377.5 32 416 32 416l448 0s-2.3-38.5-16.1-86.5c-12.2 4.3-25.6 3.5-37.3-2.4l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0l-35.4 17.7c-13.5 6.8-29.4 6.8-42.9 0l-35.4-17.7c-4.5-2.3-9.8-2.3-14.3 0L85.5 327.2c-11.7 5.8-25.2 6.6-37.3 2.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHatWinter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zu);
var Lu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hat-witch", f = 576, c = 512, e = [], t = "f6e7", o = "M200.7 181.4L112 384l112 0 0-48c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 48 112 0L386.7 206.1c-1.8-4-2.7-8.4-2.7-12.8l0-.8c0-5.6 1.5-11 4.2-15.9l18.6-32.5c5.7-10 16.3-16.1 27.8-16.1l20.4 0c14.7 0 27.5 10 31 24.2l6.2 24.6c2.2 8.9 10.2 15.1 19.4 15.1c9.5 0 17.7-6.7 19.6-16.1l12.2-60.8c.4-2.1 .6-4.2 .6-6.3l0-6.8c0-9-3.8-17.5-10.4-23.6L457.2 8.4C451.3 3 443.6 0 435.6 0l-2.2 0c-6.1 0-12.1 1.8-17.3 5L273.1 96.6c-32 20.5-57.2 50-72.4 84.8zM320 384l0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48 64 0zM22.6 416C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512l256 0c77.4 0 134.1-41.7 153.1-57.8c4.6-3.9 6.9-9.6 6.9-15.6c0-12.5-10.1-22.6-22.6-22.6L22.6 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHatWitch = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lu);
var Cu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "head-side", f = 512, c = 512, e = [], t = "f6e9", o = "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeadSide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cu);
var Du = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "head-side-brain", f = 512, c = 512, e = [], t = "f808", o = "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM285.3 208l50.7 0c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7 .1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2c-26.5 0-48 21.5-48 48c-26.5 0-48 21.5-48 48c0 20.9 13.4 38.7 32.1 45.3c0 .9-.1 1.8-.1 2.7c0 26.5 21.5 48 48 48c5.6 0 11-1 16-2.7l0 18.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-18.7c5 1.8 10.4 2.7 16 2.7c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16zM160 176l0 2.7c0 0 0 0-.1 0c0-.9 .1-1.8 .1-2.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeadSideBrain = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Du);
var $u = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "head-side-gear", f = 512, c = 512, e = [], t = "e611", o = "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm336.6-28.3c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1l0-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9l0 3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 18c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1l0 3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9l0-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-18l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM184 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeadSideGear = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($u);
var a4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "head-side-goggles", f = 512, c = 512, e = ["head-vr"], t = "f6ea", o = "M45.9 128C75.3 53.1 148.3 0 233.7 0L256 0c39.3 0 75.8 11.8 106.2 32L304 32c-61.9 0-112 50.1-112 112c0 17.2 3.9 33.5 10.8 48L32.2 192l-.2 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l13.9 0zM304 256l203.1 0c3.2 6.2 4.9 13.1 4.9 20.2c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-104.2c0-17-7.1-33-17.5-46.4C55 299.1 38.3 261.6 33.5 224l192.2 0c20.2 19.8 47.9 32 78.4 32zm0-192l112 0 0 160-112 0c-44.2 0-80-35.8-80-80s35.8-80 80-80zM480 224l-32 0 0-160 32 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeadSideGoggles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a4);
var _u = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "head-side-headphones", f = 512, c = 512, e = [], t = "f8c2", o = "M256 0s0 0 0 0c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2C0 122.8 67.4 36.9 160 9.3l0 77.3c0 12.4-7.4 23.3-17.4 30.5C114.4 137.4 96 170.6 96 208c0 61.9 50.1 112 112 112s112-50.1 112-112c0-37.4-18.4-70.6-46.6-90.9c-10-7.2-17.4-18.2-17.4-30.5L256 0zM240 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeadSideHeadphones = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_u);
var bu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "head-side-heart", f = 512, c = 512, e = [], t = "e1aa", o = "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm112-35c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeadSideHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bu);
var Su = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "head-side-medical", f = 512, c = 512, e = [], t = "f809", o = "M0 224.2C0 100.6 100.2 0 224 0l24 0c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8L448 320l0 64c0 35.3-28.7 64-64 64l-64 0 0 32c0 17.7-14.3 32-32 32L96 512c-17.7 0-32-14.3-32-32l0-72.7c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM192 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeadSideMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Su);
var yu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = a4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHeadVr = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yu);
var Ou = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = i1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHeartCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ou);
var ku = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "heart-half", f = 512, c = 512, e = [], t = "e1ab", o = "M256 96L244 84s0 0 0 0c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9l0-50.7 0-265.4L256 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeartHalf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ku);
var Au = {}, e4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "heart-half-stroke", f = 512, c = 512, e = ["heart-half-alt"], t = "e1ac", o = "M256 186.5l0 220.9L420.7 253.6c17.4-16.2 27.3-38.9 27.3-62.7l0-5.8c0-38.6-27.9-71.5-66-77.9c-25.1-4.2-50.8 4-68.8 22l-12 12L256 186.5zM119.4 44.1C165 36.5 211.3 51.4 244 84c0 0 0 0 0 0l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1l0 5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9l0-5.8c0-69.9 50.5-129.5 119.4-141z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeartHalfStroke = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = e4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHeartHalfAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Au);
var ju = {}, n4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wave-pulse", f = 640, c = 512, e = ["heart-rate"], t = "f5f8", o = "M319.1 0c14.8-.4 27.9 9.3 31.8 23.6l74 271.2 17.7-35.4c10.8-21.7 33-35.4 57.2-35.4L608 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-108.2 0L444.6 398.3c-5.9 11.9-18.6 18.8-31.8 17.5s-24.2-10.6-27.7-23.4L323.7 167.3 255.3 486.7c-3.1 14.4-15.5 24.8-30.2 25.3s-27.8-9.1-31.8-23.2L135.9 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l103.9 0c28.6 0 53.7 18.9 61.5 46.4L219.6 348 288.7 25.3C291.8 10.9 304.4 .4 319.1 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWavePulse = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = n4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHeartRate = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ju);
var Bu = {}, f4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-heart", f = 448, c = 512, e = [128159, "heart-square"], t = "f4c8", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM99.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L246.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 280.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = f4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHeartSquare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Bu);
var Tu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "heat", f = 448, c = 512, e = [], t = "e00c", o = "M176 32c17.7 0 32 14.3 32 32l0 80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144l0-80c0-17.7 14.3-32 32-32zM32 96c17.7 0 32 14.3 32 32l0 32c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-34.6-11.2-68.3-32-96L44.8 294.4C15.7 255.6 0 208.5 0 160l0-32c0-17.7 14.3-32 32-32zm320 32l0 32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHeat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tu);
var Fu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "helmet-battle", f = 576, c = 512, e = [], t = "f6eb", o = "M80 17.1c.6-8.3-5.3-15.7-13.6-17s-16.1 4.1-18 12.2L.8 218.8c-.5 2.2-.8 4.5-.8 6.8C0 242.4 13.6 256 30.4 256l2.2 0c17.1 0 31.3-13.2 32.5-30.2L80 17.1zM320 352l0 136c0 18.4 20.8 30.1 36.5 20.5l144-88c9.2-5.6 13.5-16.7 10.6-27.1C494.1 333.6 480 270.2 480 208c0-85-89.1-149.2-153.1-189c-1.9-1.2-4-2.6-6.3-4.1C311.2 8.4 298.7 0 288 0s-23.2 8.4-32.7 14.9c-2.3 1.5-4.4 3-6.3 4.1C185.1 58.8 96 123 96 208c0 62.2-14.1 125.6-31.1 185.4c-3 10.4 1.4 21.4 10.6 27.1l144 88c15.7 9.6 36.5-2.1 36.5-20.5l0-192s0 0 0 0l0-28.5c0-6.9-4.4-13-10.9-15.2l-72.3-24.1c-7.6-2.5-12.7-9.6-12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l218.8 0c10.3 0 18.6 8.3 18.6 18.6c0 8-5.1 15.1-12.7 17.6l-72.3 24.1c-6.5 2.2-10.9 8.3-10.9 15.2l0 84.5s0 0 0 0zM509.6 .2c-8.3 1.2-14.2 8.6-13.6 17l14.9 208.6c1.2 17 15.4 30.2 32.5 30.2l2.2 0c16.8 0 30.4-13.6 30.4-30.4c0-2.3-.3-4.6-.8-6.8L527.6 12.4c-1.9-8.1-9.7-13.5-18-12.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHelmetBattle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fu);
var Hu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon", f = 512, c = 512, e = [11043], t = "f312", o = "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hu);
var Ru = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-check", f = 512, c = 512, e = [], t = "e416", o = "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ru);
var Uu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-divide", f = 512, c = 512, e = [], t = "e1ad", o = "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonDivide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uu);
var qu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-exclamation", f = 512, c = 512, e = [], t = "e417", o = "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qu);
var Gu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-image", f = 512, c = 512, e = [], t = "e504", o = "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220zm141.2 59.8c4.5-4.9 10.8-7.7 17.4-7.8s13 2.6 17.6 7.4L232.2 320l71.6-86.2c4.6-5.5 11.3-8.7 18.5-8.7s13.9 3.2 18.5 8.7l72.6 87.4-55.2 95.7c-2.9 5-8.1 8-13.9 8l-176.6 0c-5.7 0-11-3-13.9-8l-46.8-81 51.2-56.1zM192 120a40 40 0 1 1 0 80 40 40 0 1 1 0-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonImage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gu);
var c4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-minus", f = 512, c = 512, e = ["minus-hexagon"], t = "f307", o = "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c4);
var t4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-plus", f = 512, c = 512, e = ["plus-hexagon"], t = "f300", o = "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t4);
var Wu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-vertical-nft", f = 448, c = 512, e = [], t = "e505", o = "M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9L0 168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.6c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4l0 176.6c0 25.7-13.7 49.5-36 62.4L260.9 495.5zM95.8 170.6c-2.8-7.1-10.3-11.2-17.9-9.8s-13 8-13 15.7l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-76.9 33.1 82.9c2.8 7.1 10.3 11.2 17.9 9.8s13-8 13-15.7l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 76.9L95.8 170.6zm97.1 5.9l0 80 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonVerticalNft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wu);
var Eu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-vertical-nft-slanted", f = 448, c = 512, e = [], t = "e506", o = "M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9L0 168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.6c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4l0 176.6c0 25.7-13.7 49.5-36 62.4L260.9 495.5zm11.1-372c0-5.7-3.1-11-8.1-13.9L216.1 82.3c-2-1.2-4.3-2-6.8-2.2c-.5 0-1-.1-1.4-.1c0 0-.1 0-.1 0c-3.3 0-6.3 1-8.8 2.6c-1.5 1-2.9 2.2-4 3.7c-1.2 1.5-2.1 3.3-2.6 5.2c-.4 1.6-.6 3.1-.6 4.7l0 160.2 0 144c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-117 24.2 13.8c10.7 6.1 23.9-1.6 23.9-13.9zm16 27.4c0 5.7 3.1 11 8.1 13.9l23.8 13.6 0 174.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-155.9 16.2 9.3c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-72-41.1c-10.7-6.1-23.9 1.6-23.9 13.9zM143.8 128.6c-8.8 0-16 7.2-16 16l0 125.4L95 171.5c-2.5-7.4-10-12-17.7-10.7s-13.4 7.9-13.4 15.8l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-61.4 32.8 98.5c2.5 7.4 10 12 17.7 10.7s13.4-7.9 13.4-15.8l0-224c0-8.8-7.2-16-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonVerticalNftSlanted = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Eu);
var w = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hexagon-xmark", f = 512, c = 512, e = ["times-hexagon", "xmark-hexagon"], t = "f2ee", o = "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHexagonXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w);
var o4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "high-definition", f = 576, c = 512, e = ["rectangle-hd"], t = "e1ae", o = "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm304 88l0 144c0 13.3 10.7 24 24 24l56 0c53 0 96-43 96-96s-43-96-96-96l-56 0c-13.3 0-24 10.7-24 24zm80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96 32 0zM160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 64 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-64 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHighDefinition = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o4);
var Vu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "highlighter-line", f = 576, c = 512, e = [], t = "e1af", o = "M229 229l215-158.4 29.3 29.3L315 315 229 229zM128 320s0 0 0 0l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3l50.7 50.7c12.5 12.5 32.8 12.5 45.3 0L224 416l71.7 0c15.3 0 29.6-7.2 38.6-19.5L535.6 123.4c5.5-7.4 8.4-16.4 8.4-25.6c0-11.4-4.5-22.4-12.6-30.5L476.6 12.6C468.5 4.5 457.6 0 446.2 0C437 0 428 2.9 420.6 8.4L147.5 209.6c-12.3 9-19.5 23.4-19.5 38.6l0 71.7zM70.1 403.3l-63 63c-4.5 4.5-7 10.6-7 17L0 488c0 13.3 10.7 24 24 24l68.7 0c6.4 0 12.5-2.5 17-7l31-31L70.1 403.3zM224 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l328 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-328 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHighlighterLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vu);
var Iu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hockey-mask", f = 448, c = 512, e = [], t = "f6ee", o = "M0 240C0 111 64 0 224 0S448 111 448 240c0 192-48 272-224 272S0 432 0 240zM160 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 272c35.3 0 64-28.7 64-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64zm256-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64s64-28.7 64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHockeyMask = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Iu);
var Ku = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hockey-stick-puck", f = 640, c = 512, e = [], t = "e3ae", o = "M462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4L160 512l-32 0-32 0 0-32 0-128 156.2 0L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32l32 0 0 160-32 0c-17.7 0-32-14.3-32-32l0-96zm416 32l192 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHockeyStickPuck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ku);
var Xu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hockey-sticks", f = 640, c = 512, e = [], t = "f454", o = "M220.6 17.7l82.3 164.6-35.8 71.6L163.4 46.3c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3zM372.8 322.1L387.8 352 544 352l0 128 0 32-64 0s0 0 0 0l-44.2 0c-24.2 0-46.4-13.7-57.2-35.4l-41.5-83 35.8-71.6zM576 352l32 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-32 0 0-160zM462.3 3.4c15.8 7.9 22.2 27.1 14.3 42.9L261.5 476.6c-10.8 21.7-33 35.4-57.2 35.4L160 512l-32 0-32 0 0-32 0-128 156.2 0L419.4 17.7c7.9-15.8 27.1-22.2 42.9-14.3zM0 384c0-17.7 14.3-32 32-32l32 0 0 160-32 0c-17.7 0-32-14.3-32-32l0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHockeySticks = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xu);
var Qu = {}, l4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-blank", f = 576, c = 512, e = ["home-blank"], t = "e487", o = "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = l4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHomeBlank = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Qu);
var Ju = {}, d4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-heart", f = 576, c = 512, e = ["home-heart"], t = "f4c9", o = "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM176 269.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = d4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHomeHeart = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ju);
var Yu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "honey-pot", f = 448, c = 512, e = [127855], t = "e418", o = "M128 32L64 32C46.3 32 32 46.3 32 64s14.3 32 32 32C25.1 125.2 0 171.7 0 224C0 362.8 79.6 441.9 113.3 469.1c9.3 7.5 21.1 10.9 33.1 10.9l155.3 0c12 0 23.7-3.3 33.1-10.9C368.4 441.9 448 362.8 448 224c0-52.3-25.1-98.8-64-128c17.7 0 32-14.3 32-32s-14.3-32-32-32L176 32l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104zM64 224l320 0c0 53.7-14.7 96.1-32.9 128L96.9 352C78.7 320.1 64 277.7 64 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHoneyPot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yu);
var Zu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hood-cloak", f = 576, c = 512, e = [], t = "f6ef", o = "M432 0L288 0s0 0 0 0c-9.8 0-66 0-120.2 37.7C111.4 76.9 64 151.8 64 288c0 58.5-14.6 101.6-28.6 129.7c-7 14.1-14 24.5-19 31.1c-2.5 3.3-4.5 5.7-5.7 7.1c-.6 .7-1.1 1.2-1.3 1.4l-.2 .2c-9 9.1-11.7 22.8-6.8 34.7c5 12 16.6 19.8 29.6 19.8l96 0 0-192c0-88.4 71.6-160 160-160s160 71.6 160 160l0 192 96 0c12.9 0 24.6-7.8 29.6-19.8c4.9-11.9 2.2-25.6-6.8-34.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0l-.1-.1c-.2-.2-.7-.7-1.3-1.4c-1.3-1.4-3.2-3.8-5.7-7.1c-5-6.6-11.9-17-19-31.1C526.6 389.6 512 346.5 512 288c0-103.1-46.5-172.8-95.8-217.2l32-29c7.3-6.7 9.8-17.2 6.2-26.4S441.9 0 432 0zM416 512l0-192c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 192 256 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHoodCloak = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zu);
var pu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "horizontal-rule", f = 640, c = 512, e = [8213], t = "f86c", o = "M0 256c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHorizontalRule = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pu);
var xu = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "horse-saddle", f = 576, c = 512, e = [], t = "f8c3", o = "M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 448 0C377.3 0 320 57.3 320 128l0 32c0 41.8-26.7 77.4-64 90.5l0 78.6 51.7 14.8c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM224 320l0-64c-53 0-96-43-96-96l0-29.4c-21.8 5.5-40.3 19.5-51.7 38.2C33.2 174.5 0 211.4 0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l.3 .1zm64-160l0-32-64 0-20.8 0L160 128l0 32c0 35.3 28.7 64 64 64s64-28.7 64-64zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHorseSaddle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xu);
var im = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hose", f = 448, c = 512, e = [], t = "e419", o = "M288 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2.3 80.2-11.5C417.3 98 423.9 104 432 104c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16c-8.1 0-14.7 6-15.8 13.7L336 26.3l0-2.3c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80zM64 176c0-44.2 35.8-80 80-80l112 0 0-64L144 32C64.5 32 0 96.5 0 176s64.5 144 144 144l272 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-272 0c-44.2 0-80-35.8-80-80zM32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 352zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHose = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(im);
var am = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hose-reel", f = 640, c = 512, e = [], t = "e41a", o = "M320 64c-106 0-192 86-192 192s86 192 192 192c40.8 0 78.6-12.7 109.7-34.4c14.5-10.1 34.4-6.6 44.6 7.9s6.6 34.4-7.9 44.6C424.8 495 374.3 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0S576 114.6 576 256l0 96 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-2.3 0-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16c0-8.1 6-14.7 13.7-15.8L506.3 400l-2.3 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-96c0-106-86-192-192-192zM224 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHoseReel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(am);
var em = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hospitals", f = 576, c = 512, e = [], t = "f80e", o = "M304 0c-26.5 0-48 21.5-48 48l0 16c35.3 0 64 28.7 64 64l0 352c0 11.7-3.1 22.6-8.6 32L528 512c26.5 0 48-21.5 48-48l0-80-112 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-64-112 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l112 0 0-208c0-26.5-21.5-48-48-48L304 0zM408 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-24 0 0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24-24 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-24zM0 144L0 384l144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L0 416l0 48c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L48 96C21.5 96 0 117.5 0 144zm120 48c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-24 0 0 24c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-24-24 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHospitals = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(em);
var nm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hourglass-clock", f = 576, c = 512, e = [], t = "e41b", o = "M0 32C0 14.3 14.3 0 32 0L64 0 320 0l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 11c0 42.4-16.9 83.1-46.9 113.1L237.3 256l36 36c-10.7 22.2-16.8 47.1-17.2 73.3l-64-64-67.9 67.9c-18 18-28.1 42.4-28.1 67.9l0 11 179.2 0c13.1 25.6 32.2 47.6 55.6 64L320 512 64 512l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-11c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75l0-11C14.3 64 0 49.7 0 32zM96 64l0 11c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9l0-11L96 64zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHourglassClock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nm);
var fm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-building", f = 640, c = 512, e = [], t = "e1b1", o = "M368 0c-26.5 0-48 21.5-48 48l0 105.9 64 58.7 0-4.6c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-18.8 0c1.9 6.8 2.8 13.9 2.8 21.1l0 10.9 16 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-16 0 0 112c0 18-6 34.6-16 48l192 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L368 0zM512 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM400 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM0 277.1L0 464c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-186.9c0-13.5-5.6-26.3-15.6-35.4l-144-132c-18.4-16.8-46.5-16.8-64.9 0l-144 132C5.6 250.8 0 263.7 0 277.1zM144 296c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseBuilding = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fm);
var cm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-chimney-blank", f = 576, c = 512, e = [], t = "e3b0", o = "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185l0-121c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseChimneyBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cm);
var tm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-chimney-heart", f = 576, c = 512, e = [], t = "e1b2", o = "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c.2 35.5-28.5 64.3-64 64.3l-320.4 0c-35.3 0-64-28.7-64-64l0-160.4-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7 416 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 121 52.8 46.4c8 7 12 15 11 24zM237.3 208c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseChimneyHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tm);
var om = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-day", f = 640, c = 512, e = [], t = "e00e", o = "M174.2 8.3C171.4 3.2 166-.1 160.1-.1s-11.3 3.2-14.1 8.4L118.4 59.5 62.8 42.9c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7L8.3 146.1c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6L42.8 257.6c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7L133.1 288l57.4-53c-9.4 3.9-19.7 6-30.5 6c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 13.1-3.1 25.4-8.7 36.3L296 137.5l-35.3-19 16.7-55.7c1.7-5.6 .1-11.7-4-15.9s-10.3-5.7-15.9-4L201.8 59.5 174.2 8.3zM112 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm309.7-55.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352l32 0 0 112c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-112 32 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseDay = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(om);
var lm = {}, r4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-water", f = 576, c = 512, e = ["house-flood"], t = "f74f", o = "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 105.4c21.3-12.2 48.1-11.4 68.8 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c20.7-14.6 47.7-15.4 69.1-3l-.5-105.6 32 0zM224 216c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80zm82.5 205.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseWater = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = r4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHouseFlood = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lm);
var dm = {}, N = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-person-leave", f = 640, c = 512, e = ["house-leave", "house-person-depart"], t = "e00f", o = "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0L379.5 117.2c-32.6 19.5-57.5 50.2-69.6 86.7l-2.6 7.8c-11.2 33.5 6.9 69.8 40.5 81c15.8 5.3 32.2 4 46.3-2.3L361.5 372l-44 44L112 416c-26.5 0-48-21.5-48-48l0-112-32 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM443.7 200.5l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L601 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5c-1 .4-1.9 .8-2.9 1.2zm-30 135.1c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L388.7 398l25-62.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHousePersonLeave = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = N;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHouseLeave = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(dm);
var rm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-night", f = 640, c = 512, e = [], t = "e010", o = "M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6c-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2c5.2-5.6-1-14-8.6-13.2c-2.9 .3-5.9 .4-9 .4c-48.6 0-88-39.4-88-88c0-29.7 14.7-55.9 37.2-71.9zm138.3-3.8c-2.6-7-12.4-7-15 0L236.6 44.6 204.3 56.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15L275.4 44.6 263.5 12.3zm158.2 92.2c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S178.8 352 192 352l32 0 0 112c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-112 32 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM352 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64zM88.5 332.3L76.6 364.6 44.3 376.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3c-2.6-7-12.4-7-15 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseNight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rm);
var sm = {}, z = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-person-return", f = 640, c = 512, e = ["house-person-arrive", "house-return"], t = "e011", o = "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0L388.9 125.9c-19 14.8-34.4 34.5-44.1 57.7l-10.7 25.8-10.7 5.4c-31.6 15.8-44.4 54.3-28.6 85.9c15.4 30.9 52.5 43.8 83.6 29.7l-6.8 7.5c-9 9.8-15.4 21.7-18.6 34.7L342 416l-230 0c-26.5 0-48-21.5-48-48l0-112-32 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm84.3 200.5c-1-.4-1.9-.8-2.9-1.2l16.9 63.5c5.6 21.1 .1 43.6-14.7 59.7l-70.7 77.1-22 88.1c-4.3 17.1-21.7 27.6-38.8 23.3s-27.6-21.7-23.3-38.8l23-92.1c1.9-7.8 5.8-14.9 11.2-20.8l49.5-54-19.3-65.5-9.6 23c-4.4 10.6-12.5 19.3-22.8 24.5l-26.7 13.3c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L359 232.7l15.3-36.8c17.1-41.1 57.3-67.9 101.9-67.9c22.8 0 45.3 4.8 66.1 14l8 3.5c32.9 14.6 58.1 42.4 69.4 76.5l2.6 7.8c5.6 16.8-3.5 34.9-20.2 40.5s-34.9-3.5-40.5-20.2l-2.6-7.8c-5.7-17.1-18.3-30.9-34.7-38.2l-8-3.5zm30 135.1l25 62.4 59.4 59.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L523.7 441c-4.6-4.6-8.2-10.1-10.6-16.1l-14.5-36.2 40.7-44.4c2.5-2.7 4.8-5.6 7-8.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHousePersonReturn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = z;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHousePersonArrive = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(sm);
var hm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = N;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHousePersonDepart = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(hm);
var vm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = z;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHouseReturn = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vm);
var um = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-tree", f = 640, c = 512, e = [], t = "e1b3", o = "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-29.4 0L601 300c7.7 9.6 9.2 22.8 3.9 33.9S588.3 352 576 352l-29.4 0L633 460c7.7 9.6 9.2 22.8 3.9 33.9S620.3 512 608 512l-208 0c10-13.4 16-30 16-48l0-186.9c0-22.4-9.4-43.8-25.9-59L282.9 119.9 393.4 9.4zM0 277.1c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4L384 464c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 277.1zM144 296l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseTree = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(um);
var mm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-turret", f = 640, c = 512, e = [], t = "e1b4", o = "M256 464l0-186.9c0-13.5 5.6-26.3 15.6-35.4l144-132c18.4-16.8 46.5-16.8 64.9 0l144 132c9.9 9.1 15.6 21.9 15.6 35.4L640 464c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48zM424 272c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zM24 0C10.7 0 0 10.7 0 24L0 96l0 8 0 93.5c0 17 6.7 33.3 18.7 45.3L64 288l0 176c0 26.5 21.5 48 48 48l128 0c-10-13.4-16-30-16-48l0-186.9c0-22.4 9.4-43.8 25.9-59L352 124.6l0-20.6 0-8 0-72c0-13.3-10.7-24-24-24L280 0c-13.3 0-24 10.7-24 24l0 72-32 0 0-72c0-13.3-10.7-24-24-24L152 0c-13.3 0-24 10.7-24 24l0 72L96 96l0-72C96 10.7 85.3 0 72 0L24 0zM176 160c22.1 0 40 17.9 40 40l0 24c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-24c0-22.1 17.9-40 40-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseTurret = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mm);
var gm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "house-window", f = 576, c = 512, e = [], t = "e3b3", o = "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l320.4 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0zM248 192l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHouseWindow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gm);
var Pm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ca;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faHumidity = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Pm);
var Mm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hydra", f = 640, c = 512, e = [], t = "e686", o = "M256 73.1C255.8 32.7 223 0 182.5 0c-16.7 0-32.9 5.7-45.9 16.1L108 39C97.4 47.5 93.3 61.8 97.8 74.6S114.4 96 128 96l48 0s0 0 0 0c8.8 0 16 7.2 16 16l0 16s0 0 0 0l0 .8-.1 .8-11.5 115c-2.4 23.7 6 47.3 22.9 64.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-23.6-23.6-35.4-56.7-32.1-89.9l4.5-45.2c-14.2-29.5-48.3-46.8-82.5-37c-8.9 2.6-17.3 6.9-24.6 12.7L12 199C1.4 207.5-2.7 221.8 1.8 234.6S18.4 256 32 256l48 0c8.8 0 16 7.2 16 16l0 16 0 24.8c0 61 40.4 112.6 96 129.4l0 37.8c0 17.7 14.3 32 32 32l36.9 0c15.6 0 29-11.3 31.6-26.7l6.2-37.3 74.7 0 6.2 37.3c2.6 15.4 15.9 26.7 31.6 26.7l36.9 0c17.7 0 32-14.3 32-32l0-32 32 0c70.7 0 128-57.3 128-128c0-40.3-19-78.2-51.2-102.4l-25-18.8c-1.8-1.4-3.7-2.6-5.7-3.6c-4.3-2.1-8.9-3.2-13.5-3.2s-9.3 .8-13.6 2.8c-3.3 1.5-6.4 3.6-9.1 6.2c-2.7 2.6-4.9 5.7-6.5 9c-2.1 4.3-3.2 8.9-3.2 13.5s.8 9.3 2.8 13.6c.9 2 2.1 4 3.4 5.8l32.6 46.6c18.4 26.3-.4 62.4-32.5 62.4c-13.3 0-25.6-6.6-33-17.7l-10.7-16.1C448.7 279.4 405.1 256 358.4 256l-.1 0-9.2 0-5.3 0c-47.8 0-87-38.4-87.8-85.3c0-.5 0-.9 0-1.4l0-.6 0-4.7c0-.4 0-.8 0-1.2l0-34.9 0-16 0-27.8 0-11.1zm32 36.9l0 60.4c.5 25 18.8 46.7 43.3 52.3l4-24.1 6.6-26.4c1.8-7.1 8.2-12.1 15.5-12.1l58.5 0c13.6 0 25.7-8.6 30.2-21.4s.4-27.1-10.2-35.6L408.8 81.3C394.8 70.1 377.5 64 359.6 64c-31.4 0-59 18.5-71.6 45.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHydra = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mm);
var wm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "hyphen", f = 320, c = 512, e = [], t = "2d", o = "M0 256c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faHyphen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wm);
var Nm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ice-skate", f = 576, c = 512, e = [9976], t = "f7ac", o = "M512 336c0 26.5-21.5 48-48 48L80 384c-26.5 0-48-21.5-48-48l0-203.8c0-21.4 14.2-40.3 34.8-46.2L256 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 119.3 29.8C482 232.5 512 270.9 512 315l0 21zm40 72c13.3 0 24 10.7 24 24l0 8c0 39.8-32.2 72-72 72l-96 0-288 0-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0 0-48 48 0 0 48 240 0 0-48 48 0 0 48 72 0c13.3 0 24-10.7 24-24l0-8c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faIceSkate = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nm);
var zm = {}, s4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "symbols", f = 512, c = 512, e = [128291, "icons-alt"], t = "f86e", o = "M500.3 7.3C507.7 13.3 512 22.4 512 32l0 144c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-57L352 90.2 352 208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48l0-96c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM32 0L192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 64C14.3 64 0 49.7 0 32S14.3 0 32 0zM502.6 342.6l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM0 128c0-17.7 14.3-32 32-32l80 0 80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-48 0c-17.7 0-32-14.3-32-32zM288 328a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM472 432a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM135.6 374l10.3 10.8 23.5-23.5c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-24.7 24.7L215.2 458c12.2 12.8 11.6 33.1-1.2 45.2s-33.1 11.6-45.2-1.2l-24.1-25.4-12.8 12.8C117.4 503.9 97.7 512 77.3 512C34.6 512 0 477.4 0 434.7l0-.9c0-19.4 7.2-38.2 20.3-52.6l13.1-14.4C22.5 354.3 16 337.9 16 320c0-39.8 32.2-72 72-72s72 32.2 72 72c0 21.5-9.4 40.8-24.4 54zm-68 50.3c-2.4 2.6-3.7 6-3.7 9.5l0 .9c0 7.3 5.9 13.3 13.3 13.3c3.5 0 6.9-1.4 9.4-3.9l14-14L81.1 409.5 67.7 424.3zM104 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSymbols = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = s4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faIconsAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(zm);
var h4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "image-landscape", f = 576, c = 512, e = ["landscape"], t = "e1b5", o = "M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm328 64c-8 0-15.5 4-20 10.7l-56 84L234.7 265c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144C343.5 196 336 192 328 192zM160 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faImageLandscape = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h4);
var Lm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "image-polaroid", f = 448, c = 512, e = [], t = "f8c4", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 96l256 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32zm152 64c-5.3 0-10.2 2.6-13.2 6.9l-52.4 76.3-9.6-12.8c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-48 64c-3.6 4.8-4.2 11.3-1.5 16.8s8.3 8.8 14.3 8.8l48 0 48 0 40 0 88 0c5.9 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-88-128c-3-4.3-7.9-6.9-13.2-6.9zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faImagePolaroid = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lm);
var Cm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "image-polaroid-user", f = 448, c = 512, e = [], t = "e1b6", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 32l0 192c0 17.7 14.3 32 32 32l16 0c0-35.3 28.7-64 64-64l96 0c35.3 0 64 28.7 64 64l16 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32zm96 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faImagePolaroidUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cm);
var Dm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "image-slash", f = 640, c = 512, e = [], t = "e1b7", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6l0-320c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6L158.8 99.2zM328.1 231.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1 328.1 231.9zM221.7 272.5c.3-.4 .6-.7 1-1.1L64 146.4 64 416c0 35.3 28.7 64 64 64l359.4 0-81.2-64L320 416l-72 0-96 0c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faImageSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dm);
var $m = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "image-user", f = 512, c = 512, e = [], t = "e1b8", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM192 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 356.6c0-37.9 30.7-68.6 68.6-68.6l86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0c-15.1 0-27.4-12.3-27.4-27.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faImageUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($m);
var _m = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "images-user", f = 576, c = 512, e = [], t = "e1b9", o = "M96 96l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm240 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM269.7 256l132.6 0c25.2 0 45.7 20.5 45.7 45.7c0 10.1-8.2 18.3-18.3 18.3l-187.4 0c-10.1 0-18.3-8.2-18.3-18.3c0-25.2 20.5-45.7 45.7-45.7zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faImagesUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_m);
var bm = {}, v4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "inbox-in", f = 512, c = 512, e = [128229, "inbox-arrow-down"], t = "f310", o = "M288 32l0 178.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 224 32c0-17.7 14.3-32 32-32s32 14.3 32 32zM48 320l76.2 0c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7l120.4 0c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7l76.2 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInboxIn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = v4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faInboxArrowDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(bm);
var Sm = {}, u4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "inbox-out", f = 512, c = 512, e = [128228, "inbox-arrow-up"], t = "f311", o = "M288 109.3L288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-178.7-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM48 320l76.2 0c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7l120.4 0c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7l76.2 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInboxOut = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = u4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faInboxArrowUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Sm);
var ym = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "inbox-full", f = 512, c = 512, e = [], t = "e1ba", o = "M58.9 80.5C66 52 91.6 32 121 32l270 0c29.4 0 55 20 62.1 48.5l57 227.9c1.3 5.1 1.9 10.3 1.9 15.5l0 92.1c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-92.1c0-5.2 .6-10.4 1.9-15.5l57-227.9zM391 96L121 96 73 288l51.2 0c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7l120.4 0c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7l51.2 0L391 96zM176 144l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 80l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInboxFull = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ym);
var Om = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "inboxes", f = 512, c = 512, e = [], t = "e1bb", o = "M117.7 64L79.3 160l45 0c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7l120.4 0c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7l45 0L394.3 64 117.7 64zM60.3 35.2C68.8 13.9 89.4 0 112.2 0L399.8 0c22.9 0 43.5 13.9 52 35.2L508 175.8c2.6 6.6 4 13.7 4 20.8l0 67.4c0 30.9-25.1 56-56 56L56 320c-30.9 0-56-25.1-56-56l0-67.4c0-7.1 1.4-14.2 4-20.8L60.3 35.2zM48 352l76.2 0c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7l120.4 0c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7l76.2 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInboxes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Om);
var km = {}, m4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "industry-windows", f = 576, c = 512, e = [127981, "industry-alt"], t = "f3b3", o = "M32 64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 151.4L316.6 131c16-8.6 35.4 3 35.4 21.1l0 63.2L508.6 131c16-8.6 35.4 3 35.4 21.1L544 304l0 128c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-80 0-48L32 64zM264 312c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM120 328l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm272-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faIndustryWindows = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = m4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faIndustryAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(km);
var Am = {}, g4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-info", f = 448, c = 512, e = [8505, "info-square"], t = "f30f", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM184 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareInfo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = g4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faInfoSquare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Am);
var jm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "inhaler", f = 576, c = 512, e = [], t = "f5f9", o = "M429.8 32.7c-12.7-3.2-25.6 4.4-29 17l-14 51.8L533.2 248 575.2 94.3c1.7-6.2 .8-12.9-2.4-18.4s-8.6-9.6-14.9-11.2l-128-32zM534.1 305.5c1.5-5.5-.1-11.5-4.1-15.5L383.8 143.8c-8.7-8.7-23.6-4.7-26.8 7.2l-16.5 61.2c-1.9 7-8.2 11.8-15.4 11.8L232 224c-22.1 0-40 17.9-40 40l0 176c0 22.1 17.9 40 40 40l224 0c18 0 33.8-12.1 38.6-29.5l39.5-145zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zm0 96A32 32 0 1 0 0 352a32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zm64-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInhaler = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jm);
var Bm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "input-numeric", f = 640, c = 512, e = [], t = "e1bd", o = "M576 128l0 256L64 384l0-256 512 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm40 120c0 13.3 10.7 24 24 24l8 0 0 96-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-120c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-33.2 0 34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInputNumeric = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bm);
var Tm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "input-pipe", f = 640, c = 512, e = [], t = "e1be", o = "M64 128l0 256 512 0 0-256L64 128zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm144 56l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInputPipe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tm);
var Fm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "input-text", f = 640, c = 512, e = [], t = "e1bf", o = "M64 128l0 256 512 0 0-256L64 128zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7-75.5 0-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280l32.8 0L184 243.1zM304 184c0-13.3 10.7-24 24-24l52 0c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60l-68 0c-13.3 0-24-10.7-24-24l0-8 0-64 0-64 0-8zm48 24l0 24 28 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-28 0zm0 96l44 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-16 0-28 0 0 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInputText = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fm);
var Hm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "integral", f = 320, c = 512, e = [], t = "f667", o = "M216 64c-13.3 0-24 10.7-24 24l0 336c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-8c0-17.7 14.3-32 32-32s32 14.3 32 32l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-48.6 39.4-88 88-88s88 39.4 88 88l0 8c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-8c0-13.3-10.7-24-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faIntegral = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hm);
var Rm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "interrobang", f = 320, c = 512, e = [8253], t = "e5ba", o = "M144 96c-35.3 0-64 28.7-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128l0 3.6c0 43.6-22.1 84.1-58.8 107.7L203 298.4c-6.9 4.4-11 12-11 20.2l0 1.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.4L128 176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 53.4 18.6-12c18.3-11.8 29.4-32.1 29.4-53.8l0-3.6c0-35.3-28.7-64-64-64l-32 0zM120 440a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faInterrobang = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rm);
var Um = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "intersection", f = 384, c = 512, e = [8898], t = "f668", o = "M32 480c17.7 0 32-14.3 32-32l0-224c0-70.7 57.3-128 128-128s128 57.3 128 128l0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224c0-106-86-192-192-192S0 118 0 224L0 448c0 17.7 14.3 32 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faIntersection = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Um);
var qm = {}, P4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shelves", f = 640, c = 512, e = ["inventory"], t = "f480", o = "M32 0C49.7 0 64 14.3 64 32l0 128 512 0 0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 0 256 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L64 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L0 192 0 32C0 14.3 14.3 0 32 0zM64 416l512 0 0-192L64 224l0 192zM352 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM128 256l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm160 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShelves = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = P4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faInventory = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(qm);
var Gm = {}, M4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "island-tropical", f = 512, c = 512, e = [127965, "island-tree-palm"], t = "f811", o = "M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3L78.2 96c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2c2.2 8.6-5 15.8-13.8 15.8l-44.7 0c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3l-79.2 0c28 79.9 21.2 170.2 9.9 226.1C370.9 365.1 416 417.3 416 480c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32c0-70.7 57.3-128 128-128l64 0c29.7-79.3 29.4-150.9 22.8-194l-87.6 87.6c-6.2 6.2-16.5 6.2-21-1.4c-18.5-31.6-22.5-90.9 32.3-145.7c1.4-1.4 2.8-2.7 4.1-4c-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faIslandTropical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = M4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faIslandTreePalm = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Gm);
var Wm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "jack-o-lantern", f = 576, c = 512, e = [127875], t = "f30e", o = "M234.6 103.9C251.5 98.8 269.4 96 288 96c22.8 0 44.7 4.2 64.8 11.7c-.6-2-.8-4.1-.8-6.3l0-66.1c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4l-1.2 0c-6.9 0-13.1 4.1-15.8 10.4l-40.9 93.5zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320S68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3zM208 208c5.3 0 10.3 2.7 13.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5l-64 0c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1zm173.3 7.1l32 48c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5l-64 0c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l32-48c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1zM368 437.5C346.2 444 319.8 448 288 448s-58.2-4-80-10.5l0-21.5c0-8.8-7.2-16-16-16l-16 0c-8.6 0-15.7 6.9-16 15.4c-36.9-24.7-49.9-56.7-54.1-71.4c-1.4-5 .3-10.2 4-13.8c5.8-5.8 15.1-6.6 22.2-2.4c18 10.6 55.5 29.1 107.9 36.8l0 19.5c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c77.6 0 132.8-26.6 155.9-40.2c7.1-4.2 16.4-3.4 22.2 2.4c3.7 3.7 5.4 8.8 4 13.8c-4.2 14.7-17.3 46.8-54.1 71.4c-.3-8.6-7.3-15.4-16-15.4l-16 0c-8.8 0-16 7.2-16 16l0 21.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faJackOLantern = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wm);
var Em = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "joystick", f = 448, c = 512, e = [128377], t = "f8c5", o = "M336 112c0 50.7-33.7 93.6-80 107.4L256 320l-64 0 0-100.6c-46.3-13.8-80-56.6-80-107.4C112 50.1 162.1 0 224 0s112 50.1 112 112zM200 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 352c0-17.7 14.3-32 32-32s32 14.3 32 32l256 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faJoystick = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Em);
var Vm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "jug", f = 448, c = 512, e = [], t = "f8c6", o = "M160 0L288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L160 64c-17.7 0-32-14.3-32-32s14.3-32 32-32zM400 168c0-13.3-10.7-24-24-24c-10.3 0-19.1 6.5-22.5 15.6l25.1 32.2c12.1-1.3 21.4-11.5 21.4-23.9zm-89.3-63.3l11.8 15.1C335.7 105.2 354.8 96 376 96c39.8 0 72 32.2 72 72c0 29.2-17.4 54.3-42.3 65.6c6.8 15.8 10.3 32.9 10.3 50.3L416 448c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-164.1c0-28.5 9.5-56.1 27-78.6l78.3-100.7c2.1-2.6 3.7-5.6 4.8-8.7l163.9 0c1.1 3.1 2.7 6 4.8 8.7zM128 288c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-192 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faJug = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vm);
var Im = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "jug-bottle", f = 640, c = 512, e = [], t = "e5fb", o = "M120 0C106.7 0 96 10.7 96 24l0 24-8 0C74.7 48 64 58.7 64 72s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24c0-13.3-10.7-24-24-24L120 0zm8 128C57.3 128 0 185.3 0 256L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-192c0-70.7-57.3-128-128-128l-128 0zm160 96c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM472 64c-13.3 0-24 10.7-24 24l0 40 128 0 0-40c0-13.3-10.7-24-24-24l-80 0zM416.4 392.4l-.4 .2 0 55.4c0 16.9-4.3 32.7-12 46.5c11.5 10.9 27 17.5 44 17.5l128 0c35.3 0 64-28.7 64-64c0-24.1-13.3-45.1-33-56c19.7-10.9 33-31.9 33-56c0-23.5-12.6-44-31.5-55.1c18.7-10.1 31.5-29.9 31.5-52.7c0-23.2-13.4-44.3-34.4-54.2l-13.2-6.2c-11-5.1-23-7.8-35.1-7.8l-90.6 0c-12.1 0-24.1 2.7-35.1 7.8L418.4 174c-6.9 3.2-13 7.7-18 13c10 20.9 15.6 44.3 15.6 69l0 135.4c.3 .2 .7 .4 1 .6c-.2 .1-.4 .2-.6 .4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faJugBottle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Im);
var Km = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "kazoo", f = 640, c = 512, e = [], t = "f8c7", o = "M514 128l94 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-94 0c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16l-158 0c-3 0-6-.4-9-1.3l-192-56C9.4 322.7 0 310.2 0 296l0-80c0-14.2 9.4-26.7 23-30.7l192-56c2.9-.8 5.9-1.3 9-1.3l158 0c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16zm30 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM427.3 212.7L448 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L470.6 256l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L448 278.6l-20.7 20.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L425.4 256l-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKazoo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Km);
var Xm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "kerning", f = 640, c = 512, e = [], t = "f86f", o = "M454.3 23.2c4-7.9 .7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l240-480zM60.6 113.7C52.7 97.9 33.5 91.5 17.7 99.4S-4.5 126.5 3.4 142.3l128 256c5.4 10.8 16.5 17.7 28.6 17.7s23.2-6.8 28.6-17.7l128-256c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L160 312.4 60.6 113.7zm320 284.6L403.8 352l152.4 0 23.2 46.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-128-256C503.2 102.9 492.1 96 480 96s-23.2 6.8-28.6 17.7l-128 256c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3zM480 199.6L524.2 288l-88.4 0L480 199.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKerning = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xm);
var Qm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "key-skeleton", f = 448, c = 512, e = [128477], t = "f6f3", o = "M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 28.2 8.1 54.5 22.1 76.7L9.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 416 96 397.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L141.3 352l86.1-86.1c22.2 14 48.5 22.1 76.7 22.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKeySkeleton = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qm);
var Jm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "key-skeleton-left-right", f = 640, c = 512, e = [], t = "e3b4", o = "M576 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm64 0c0 70.7-57.3 128-128 128c-59.6 0-109.8-40.8-124-96l-68 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l196 0C402.2 40.8 452.4 0 512 0c70.7 0 128 57.3 128 128zM64 384a64 64 0 1 0 128 0A64 64 0 1 0 64 384zM0 384c0-70.7 57.3-128 128-128c59.6 0 109.8 40.8 124 96l68 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-196 0c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKeySkeletonLeftRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jm);
var Ym = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "keyboard-brightness", f = 640, c = 512, e = [], t = "e1c0", o = "M134.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96zm153.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64zM0 384c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm224-32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0zm320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKeyboardBrightness = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ym);
var Zm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "keyboard-brightness-low", f = 640, c = 512, e = [], t = "e1c1", o = "M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96-32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKeyboardBrightnessLow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zm);
var pm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "keyboard-down", f = 576, c = 512, e = [], t = "e1c2", o = "M64 0C28.7 0 0 28.7 0 64L0 224c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64L64 0zM80 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm272 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM176 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM368 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM153.8 366.8c-3.7 9-1.7 19.3 5.2 26.2L271 505c9.4 9.4 24.6 9.4 33.9 0L417 393c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8l-224 0c-9.7 0-18.5 5.8-22.2 14.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKeyboardDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pm);
var xm = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "keyboard-left", f = 640, c = 512, e = [], t = "e1c3", o = "M224 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L224 64zm16 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM224 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM320 336c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-32zM432 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM416 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM528 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM512 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM113.2 153.8c-9-3.7-19.3-1.7-26.2 5.2L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-160c0-9.7-5.8-18.5-14.8-22.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKeyboardLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xm);
var ig = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "keynote", f = 512, c = 512, e = [], t = "f66c", o = "M184 72l14.4 0c8.3 14.3 23.8 24 41.6 24l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L240 0c-17.8 0-33.3 9.7-41.6 24L184 24c-48.6 0-88 39.4-88 88l0 48-16 0c-12.1 0-23.2 6.8-28.6 17.7l-48 96C1.2 278.1 0 283 0 288l0 32c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-32c0-5-1.2-9.9-3.4-14.3l-48-96C455.2 166.8 444.1 160 432 160l-288 0 0-48c0-22.1 17.9-40 40-40zM160 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64-64 0 0 64-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKeynote = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ig);
var ag = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "kidneys", f = 640, c = 512, e = [], t = "f5fb", o = "M152 0c-21.5 0-45.5 6.3-64.3 23.8C56.4 52.8 0 119.6 0 224c0 24.9 3.5 54.7 7.1 79.1c7.1 48 48.8 80.9 95.3 80.9c58.4 0 104-50.4 98.2-108.5l-4.1-41.2c-2-20.1 4.5-40.1 17.9-55.1l18.2-20.5c15.2-17.1 23.5-39.1 23.5-61.9c0-31.2-15.6-60.2-41.5-77.5l-3.4-2.3C194.5 5.9 175.1 0 155.2 0L152 0zM488 0l-3.2 0c-19.9 0-39.4 5.9-55.9 16.9l-3.4 2.3C399.6 36.5 384 65.6 384 96.7c0 22.8 8.4 44.8 23.5 61.9l18.2 20.5c13.4 15.1 19.9 35.1 17.9 55.1l-4.1 41.2C433.7 333.6 479.3 384 537.7 384c46.5 0 88.2-32.9 95.3-80.9c3.6-24.4 7.1-54.2 7.1-79.1c0-104.4-56.4-171.2-87.7-200.2C533.5 6.3 509.5 0 488 0zM228.2 231.1l1.9 18.8 21.5 10.7c2.7 1.4 4.4 4.1 4.4 7.2L256 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220.2c0-21.2-12-40.6-31-50.1l-34.8-17.4-.1 .1c-7.5 8.4-11.1 19.5-10 30.7zm173.6-30.7l-.1-.1L367 217.7c-19 9.5-31 28.9-31 50.1L336 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220.2c0-3 1.7-5.8 4.4-7.2l21.5-10.7 1.9-18.8c1.1-11.2-2.5-22.3-10-30.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKidneys = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ag);
var eg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "kite", f = 640, c = 512, e = [129665], t = "f6f4", o = "M344 0c-14.9 0-27.8 10.3-31.2 24.8l-80 344c-.4 1.7-.7 3.5-.8 5.2l-85.4 85.4c-2.9 2.9-6.9 4.6-11 4.6c-8.6 0-15.6-7-15.6-15.6l0-88.6-24-12-24 12 0 88.6c0 35.1 28.5 63.6 63.6 63.6c16.9 0 33-6.7 45-18.6L266 407.9c1.8-.1 3.5-.4 5.2-.8l344-80c14.5-3.4 24.8-16.3 24.8-31.2l0-264c0-17.7-14.3-32-32-32L344 0zM24 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0c22.1 0 40 17.9 40 40l0 68L18.7 257.4c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9l0 70.1C0 346.2 5.8 352 12.9 352c2 0 4-.5 5.8-1.4L72 324s0 0 0 0l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4l.5 0c3.5 .1 7 .7 10.4 1.9c1.2 .4 2.3 .9 3.4 1.5c0 0 0 0 0 0L120 324l53.3 26.6c1.8 .9 3.8 1.4 5.8 1.4c7.1 0 12.9-5.8 12.9-12.9l0-70.1c0-7.1-5.8-12.9-12.9-12.9c-2 0-4 .5-5.8 1.4L120 284l0-68c0-48.6-39.4-88-88-88l-8 0zM427.3 84.7L480 137.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 160l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 182.6 363.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 160l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKite = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eg);
var ng = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "kiwi-fruit", f = 448, c = 512, e = [], t = "e30c", o = "M448 176c0 79.5-100.3 144-224 144S0 255.5 0 176S100.3 32 224 32s224 64.5 224 144zM224 64c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16zM139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24s25.1 24 56 24s56-10.7 56-24zM224 480C102.4 480 3.4 383.1 .1 262.2c13.2 16.4 29.8 30.7 48.2 42.5C94.7 334.6 156.9 352 224 352s129.3-17.4 175.7-47.3c18.5-11.9 35-26.2 48.2-42.5C444.6 383.1 345.6 480 224 480z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKiwiFruit = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ng);
var w4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "knife", f = 512, c = 512, e = ["utensil-knife"], t = "f2e4", o = "M217.5 249.3l242-242c4.7-4.7 11-7.3 17.6-7.3c11.2 0 21 7.5 23.5 18.4C505.3 38.6 512 71.5 512 96c0 83.3-48.2 130.5-128.9 209.4c-6.5 6.4-13.3 13-20.3 19.9c-12.1 11.9-28.4 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-14.6-14.6-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192 16-16 .1-.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKnife = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w4);
var fg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "knife-kitchen", f = 576, c = 512, e = [128298], t = "f6f5", o = "M488 0c9.4 0 18.3 3.7 25 10.3L557.7 55c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-97 97c-3 3-4.7 7.1-4.7 11.3l0 31.9c0 17.4-9.4 33.5-24.7 42l-31 17.2L295.9 200.1l-11.3-11.3L463 10.3C469.7 3.7 478.6 0 488 0zM432 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM262 211.4l11.3 11.3 126 126c6.2 6.2 6.2 16.4 0 22.6C321.4 449.2 235.3 512 112 512c-25.6 0-50.9-4.2-69.5-8.4c-9.4-2.1-17.2-4.2-22.7-5.7c-2.8-.8-4.9-1.4-6.5-1.9c-.8-.2-1.4-.4-1.8-.6l-.5-.2-.1 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0L16 480l-5.1 15.2c-5.3-1.8-9.2-6.1-10.5-11.5s.3-11.1 4.3-15l246-246L262 211.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faKnifeKitchen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fg);
var cg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lacrosse-stick", f = 512, c = 512, e = [], t = "e3b5", o = "M336 64s0 0 0 0l.3 0c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1c0 .1 0 .2 0 .3c0 0 0 0 0 0c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8c-34.7 0-62.8-28.1-62.8-62.8c0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64zm0-64s0 0 0 0C274.4 0 220.2 40.9 203.3 100.1L200 111.7c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2c0 23.4 6.3 45.3 17.4 64.1l-136 136c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4c28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3C471.1 291.8 512 237.6 512 176c0 0 0 0 0 0l0-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0L336 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLacrosseStick = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cg);
var tg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lacrosse-stick-ball", f = 576, c = 512, e = [], t = "e3b6", o = "M336 64s0 0 0 0l.3 0c19.9 0 48.1 13.6 73.1 38.6s38.6 53.2 38.6 73.1c0 .1 0 .2 0 .3c0 0 0 0 0 0c0 33.1-21.9 62.1-53.7 71.2l-11.5 3.3c-19.6 5.6-37.9 15.1-53.9 27.8L294 306.2c-11.1 8.9-25 13.8-39.2 13.8c-34.7 0-62.8-28.1-62.8-62.8c0-14.3 4.9-28.1 13.8-39.2l27.9-34.9c12.8-15.9 22.2-34.3 27.8-53.9l3.3-11.5C273.9 85.9 302.9 64 336 64zm0-64s0 0 0 0C274.4 0 220.2 40.9 203.3 100.1L200 111.7c-3.3 11.5-8.8 22.2-16.2 31.5l-27.9 34.9c-18 22.5-27.8 50.4-27.8 79.2c0 23.4 6.3 45.3 17.4 64.1l-136 136c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l136-136c18.8 11.1 40.7 17.4 64.1 17.4c28.8 0 56.7-9.8 79.2-27.8l34.9-27.9c9.3-7.4 20-13 31.5-16.2l11.5-3.3C471.1 291.8 512 237.6 512 176c0 0 0 0 0 0l0-.3c0-43.8-26.4-87.4-57.3-118.4S380.1 0 336.3 0L336 0zM496 512a80 80 0 1 0 0-160 80 80 0 1 0 0 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLacrosseStickBall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tg);
var og = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lambda", f = 448, c = 512, e = [], t = "f66e", o = "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l108.2 0 16.4 32.7L18.8 434.9c-7.3 16.1-.1 35.1 16 42.3s35.1 .1 42.3-16L193.5 202.6l121 242c10.8 21.7 33 35.4 57.2 35.4l44.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-44.2 0L197.5 67.4C186.6 45.7 164.5 32 140.2 32L32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLambda = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(og);
var lg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lamp", f = 448, c = 512, e = [], t = "f4ca", o = "M82.5 19.7C87.4 7.8 99.1 0 112 0L336 0c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2L32 256c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 288l128 0 0 32s64 50.5 64 112c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3l-139 0c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-61.5 64-112 64-112l0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLamp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lg);
var dg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lamp-desk", f = 512, c = 512, e = [], t = "e014", o = "M192 65.9C192 29.5 221.5 0 257.9 0c17.5 0 34.3 6.9 46.6 19.3L349.3 64 480 64c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-114.7-92.6 92.6L209 448l143 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-167.3 0c-.5 0-.9 0-1.4 0L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l111 0L97 263.8c-2.7-10.9 .5-22.4 8.4-30.4L218.7 120l-7.4-7.4C198.9 100.2 192 83.4 192 65.9zM432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6c0 26.5-21.5 48-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLampDesk = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dg);
var rg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lamp-floor", f = 384, c = 512, e = [], t = "e015", o = "M66.3 20.1C71.1 8 82.9 0 96 0L288 0c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1L32 224c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM160 256l64 0 0 192 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 0-192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLampFloor = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rg);
var sg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lamp-street", f = 512, c = 512, e = [], t = "e1c5", o = "M64 176c0-61.9 50.1-112 112-112c57.4 0 104.7 43.2 111.2 98.8C207.1 176.6 144 239.9 130.6 320.1C127.7 337.6 142.3 352 160 352l320 0c17.7 0 32.3-14.4 29.4-31.9c-13.5-80.6-77.2-144.2-157.9-157.6C344.6 71.6 268.7 0 176 0C78.8 0 0 78.8 0 176L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-304zM320 448c35.3 0 64-28.7 64-64l-128 0c0 35.3 28.7 64 64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLampStreet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sg);
var hg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "landmark-magnifying-glass", f = 640, c = 512, e = [], t = "e622", o = "M448 288c-22.8 0-44.4-4.8-64-13.3L384 416l-40 0 0-166.4c-8.9-7.6-17-16.2-24-25.6l-40 0 0 192-48 0 0-192-64 0 0 192-40 0 0-192-64 0 0 196.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512l448 0c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1L448 288zM32 192l269.3 0c-8.6-19.6-13.3-41.2-13.3-64c0-36.1 12-69.4 32.1-96.2L271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0L68.4 102.4 64 104l0 .9L16.1 132.2c-12.6 7.2-18.8 22-15.1 36S17.5 192 32 192zM448 48.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 313.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLandmarkMagnifyingGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hg);
var vg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = h4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLandscape = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vg);
var ug = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "laptop-arrow-down", f = 640, c = 512, e = [], t = "e1c6", o = "M128 32C92.7 32 64 60.7 64 96l0 256 64 0 0-256 128 0 0-64L128 32zM512 96l0 256 64 0 0-256c0-35.3-28.7-64-64-64L384 32l0 64 128 0zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2L19.2 384zM344 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 182.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L344 56z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLaptopArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ug);
var mg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "laptop-binary", f = 640, c = 512, e = [], t = "e5e7", o = "M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256-64 0 0-256L128 96l0 256-64 0L64 96zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM200 128l16 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-32c0-22.1 17.9-40 40-40zm-8 40l0 32c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8zm112-40l16 0c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-32zm40-8c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-16 0zM192 272l16 0c8.8 0 16 7.2 16 16l0 64-32 0 0-48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm256 16l0 64-32 0 0-48c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16zm-80 24l0 40-32 0 0-40c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 40-32 0 0-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLaptopBinary = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mg);
var N4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "laptop-mobile", f = 640, c = 512, e = ["phone-laptop"], t = "f87a", o = "M128 0C92.7 0 64 28.7 64 64l0 224-44.8 0C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384L352 384l0-96-224 0 0-224 320 0 0 32 64 0 0-32c0-35.3-28.7-64-64-64L128 0zM448 448l0-256 128 0 0 256-128 0zM384 176l0 288c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLaptopMobile = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N4);
var gg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "laptop-slash", f = 640, c = 512, e = [], t = "e1c7", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-14-10.9c14.3-13.9 23.2-33.4 23.2-55c0-10.6-8.6-19.2-19.2-19.2l-98.6 0L154.8 96 512 96l0 256 64 0 0-256c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM128 197L64 146.6 64 352l64 0 0-155zM487.2 480L365.3 384 19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480l410.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLaptopSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gg);
var Pg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lasso", f = 576, c = 512, e = [], t = "f8c8", o = "M576 176c0 97.2-128.9 176-288 176c-13.2 0-26.3-.5-39-1.6c4.6 12.8 7 26.5 7 40.6c0 66.8-54.2 121-121 121l-71 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l71 0c31.5 0 57-25.5 57-57c0-21.6-12.2-41.3-31.5-51l-46.8-23.4 .2-.4C44.7 284.1 0 233.2 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 288c123.7 0 224-50.1 224-112s-100.3-112-224-112S64 114.1 64 176s100.3 112 224 112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLasso = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pg);
var Mg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lasso-sparkles", f = 576, c = 512, e = [], t = "e1c9", o = "M290.7 0L288 0C128.9 0 0 78.8 0 176c0 57.2 44.7 108.1 113.9 140.2l-.2 .4L160.5 340c19.3 9.7 31.5 29.4 31.5 51c0 31.5-25.5 57-57 57l-71 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l71 0c66.8 0 121-54.2 121-121c0-14.1-2.4-27.8-7-40.6c12.8 1.1 25.8 1.6 39 1.6c159.1 0 288-78.8 288-176c0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80c0 5.6-1 11.1-2.8 16.2C486.4 116.5 512 144.8 512 176c0 61.9-100.3 112-224 112S64 237.9 64 176c0-51 68.2-94 161.4-107.6c3.8-15.2 14.8-27.9 29.9-33.4l26-9.6L290.7 0zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4L306.3 50.3 266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L321 149.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15L365.7 50.3 351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8L426.4 417c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L481 501.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L565.6 447c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7L511 362.4c-2.3-6.3-8.3-10.4-15-10.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLassoSparkles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mg);
var wg = {}, z4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "layer-minus", f = 576, c = 512, e = ["layer-group-minus"], t = "f5fe", o = "M408 56c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L408 56zm-96.5 77.2c-14.9-6.9-32.1-6.9-47 0L45.9 234.2C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101zm13.4 274.7c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 362.2C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLayerMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = z4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLayerGroupMinus = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(wg);
var Ng = {}, L4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "layer-plus", f = 576, c = 512, e = ["layer-group-plus"], t = "f5ff", o = "M464 0c-13.3 0-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32c0-13.3-10.7-24-24-24zM311.5 133.2c-14.9-6.9-32.1-6.9-47 0L45.9 234.2C37.4 238.1 32 246.6 32 256s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-218.6-101zm13.4 274.7c-23.4 10.8-50.4 10.8-73.8 0l-152-70.2L45.9 362.2C37.4 366.1 32 374.6 32 384s5.4 17.9 13.9 21.8l218.6 101c14.9 6.9 32.1 6.9 47 0l218.6-101c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8l-53.2-24.6-152 70.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLayerPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = L4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLayerGroupPlus = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ng);
var zg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "leaf-heart", f = 512, c = 512, e = [], t = "f4cb", o = "M272 96s0 0 0 0l104 0c42.7 0 79.9-23.9 98.8-59.1c3.5-6.5 13.6-6.8 16.2 .1c13.5 36.5 21.1 77 21.1 119.6C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.4 48 440l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-75.1 38.3-141.2 96.4-179.9C102.5 168.5 178.8 96 272 96c0 0 0 0 0 0zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0c-29.5 0-53.5 23.9-53.5 53.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeafHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zg);
var Lg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "leaf-maple", f = 512, c = 512, e = [127809], t = "f6f6", o = "M339.8 7.5l15.8 31.6c7.1 14.2 23.6 21.1 38.7 16l67.6-22.5c1.4-.5 2.9-.7 4.4-.7c7.6 0 13.8 6.2 13.8 13.8c0 1.5-.2 2.9-.7 4.4l-22.5 67.6c-5 15.1 1.8 31.6 16 38.7l31.6 15.8c4.6 2.3 7.5 7 7.5 12.2c0 4.7-2.4 9.1-6.4 11.6l-97.9 61.2c-6.8 4.3-3.8 14.8 4.2 14.8l38.3 0c7.6 0 13.8 6.2 13.8 13.8c0 1.5-.2 2.9-.7 4.4l-8.5 25.5c-4.1 12.3-.3 25.9 9.5 34.4l34.3 29.4c3.4 2.9 5.4 7.2 5.4 11.7c0 5.5-3 10.6-7.8 13.4l-28.9 16.5c-11.6 6.6-17.9 19.8-15.7 33l4.2 25.1c.1 .6 .2 1.3 .2 1.9c0 7.6-7.2 13.2-14.6 11.2l-155-40.4c-8.2-2.1-16.6 2.4-19.2 10.4l-8.5 25.4c-1.7 5-6.3 8.4-11.6 8.4c-4.4 0-8.5-2.4-10.7-6.3l-53-95.3L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239.3 270.8c3.6-6.1 2.7-14.1-2.5-19.4c-6.2-6.2-16.4-6.2-22.6 0l-84 84L22.3 275.5c-3.9-2.2-6.3-6.2-6.3-10.7c0-5.3 3.4-9.9 8.4-11.6l25.4-8.5c8-2.7 12.5-11.1 10.4-19.2L19.8 70.6C17.9 63.2 23.4 56 31 56c.6 0 1.3 .1 1.9 .2L58 60.3c13.2 2.2 26.4-4.1 33-15.7l16.5-28.9C110.3 11 115.4 8 120.9 8c4.5 0 8.8 2 11.7 5.4L162 47.7c8.5 9.9 22.1 13.6 34.4 9.5l25.5-8.5c1.4-.5 2.9-.7 4.4-.7c7.6 0 13.8 6.2 13.8 13.8l0 38.3c0 8 10.5 11.1 14.8 4.2L316 6.4c2.5-4 6.9-6.4 11.6-6.4c5.2 0 9.9 2.9 12.2 7.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeafMaple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lg);
var Cg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "leaf-oak", f = 512, c = 512, e = [], t = "f6f7", o = "M429.7 268.6l40.9-10.2c24.4-6.1 41.4-28 41.4-53.1c0-18.3-9.1-35.4-24.4-45.5l-14.3-9.5c-5.6-3.8-8.3-10.6-6.6-17.2l5-20.1c5.1-20.4-.9-42-15.8-56.9s-36.5-20.9-56.9-15.8l-20.1 5c-6.6 1.6-13.4-1-17.2-6.6l-9.5-14.3C342.1 9.1 325 0 306.7 0c-25.1 0-47 17.1-53.1 41.4L243.4 82.3c-1.5 6-9 8.1-13.4 3.7L208 64c-17.7-17.7-46.3-17.7-64 0c-10.1 10.1-14.8 24.3-12.8 38.4l10.7 75.1c.8 5.6-5.4 9.5-10.1 6.4C111 170 83.3 172.7 65.6 190.4l-3.6 3.6c-17.9 17.9-22.3 45.2-11 67.8L66.5 293C75.4 310.7 80 330.3 80 350.2l0 35.2L229.6 235.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l73-73 15.8 0c19.9 0 39.5 4.6 57.2 13.5l31.1 15.5c22.6 11.3 49.9 6.9 67.8-11l3.6-3.6c17.7-17.7 20.4-45.4 6.6-66.2c-3.1-4.7 .8-10.9 6.4-10.1l75.1 10.7c14.1 2 28.3-2.7 38.4-12.8c17.7-17.7 17.7-46.3 0-64l-22-22c-4.4-4.4-2.3-11.9 3.7-13.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeafOak = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cg);
var Dg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "leafy-green", f = 576, c = 512, e = [129388], t = "e41d", o = "M97.9 28.4C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1l0 35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6l0-45.7c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6l0-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27c4.4-12.9 10.8-24.8 18.9-35.5c-38-36.5-98.4-36-135.8 1.5zM567.5 229.9c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3l0 43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3l0 45.7c0 17-6.7 33.3-18.7 45.3L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l35.9-35.9c12-12 28.3-18.7 45.3-18.7l45.7 0c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7l43 0c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1zM475.3 100.7c6.2 6.2 6.2 16.4 0 22.6L390.6 208l57.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-89.4 0-59.3 59.3-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L272 281.4l0-89.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 57.4 36.7-36.7 112-112c6.2-6.2 16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeafyGreen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dg);
var $g = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "left-from-bracket", f = 512, c = 512, e = [], t = "e66c", o = "M352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-217.9-9.9L11.3 283.3C4.1 276.1 0 266.2 0 256s4.1-20.1 11.3-27.3L134.1 105.9c6.4-6.4 15-9.9 24-9.9c18.7 0 33.9 15.2 33.9 33.9l0 62.1 128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0 0 62.1c0 18.7-15.2 33.9-33.9 33.9c-9 0-17.6-3.6-24-9.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeftFromBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($g);
var _g = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "left-long-to-line", f = 640, c = 512, e = [], t = "e41e", o = "M0 96L0 416c0 17.7 14.3 32 32 32s32-14.3 32-32L64 96c0-17.7-14.3-32-32-32S0 78.3 0 96zM279.5 409.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-72 288 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-288 0 0-72c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136c-4.8 4.5-7.5 10.8-7.5 17.4s2.7 12.9 7.5 17.4l144 136z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeftLongToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_g);
var bg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "left-to-bracket", f = 512, c = 512, e = [], t = "e66d", o = "M294.1 105.9L171.3 228.7c-7.2 7.2-11.3 17.1-11.3 27.3s4.1 20.1 11.3 27.3L294.1 406.1c6.4 6.4 15 9.9 24 9.9c18.7 0 33.9-15.2 33.9-33.9l0-62.1 128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0 0-62.1c0-18.7-15.2-33.9-33.9-33.9c-9 0-17.6 3.6-24 9.9zM160 416l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLeftToBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bg);
var Sg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "light-ceiling", f = 512, c = 512, e = [], t = "e016", o = "M256 0c17.7 0 32 14.3 32 32l0 130c115.8 14.4 207.6 106.3 222 222.1c2.2 17.5-12.4 31.9-30 31.9L32 416C14.3 416-.2 401.6 2 384.1C16.4 268.2 108.2 176.4 224 162l0-130c0-17.7 14.3-32 32-32zm0 512c-35.3 0-64-28.7-64-64l128 0c0 35.3-28.7 64-64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightCeiling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sg);
var yg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "light-emergency", f = 448, c = 512, e = [], t = "e41f", o = "M64 192c0-88.4 71.6-160 160-160s160 71.6 160 160l0 160L64 352l0-160zm160-80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80zM32 384l384 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightEmergency = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yg);
var Og = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "light-emergency-on", f = 640, c = 512, e = [], t = "e420", o = "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM320 32c-88.4 0-160 71.6-160 160l0 160 320 0 0-160c0-88.4-71.6-160-160-160zM240 192c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80zM96 416l0 32c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-384 0c-17.7 0-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightEmergencyOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Og);
var kg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "light-switch", f = 384, c = 512, e = [], t = "e017", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm96 96l64 0c35.3 0 64 28.7 64 64l0 80L96 240l0-80c0-35.3 28.7-64 64-64zM288 272l0 80c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-80 192 0zM192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightSwitch = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kg);
var Ag = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "light-switch-off", f = 384, c = 512, e = [], t = "e018", o = "M64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512zm96-96l64 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64zm32 32a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM160 384c-17.7 0-32-14.3-32-32l0-96 128 0 0 96c0 17.7-14.3 32-32 32l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightSwitchOff = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ag);
var jg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "light-switch-on", f = 384, c = 512, e = [], t = "e019", o = "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm96 96l64 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-192c0-35.3 28.7-64 64-64zm32-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 128c-17.7 0-32 14.3-32 32l0 96 128 0 0-96c0-17.7-14.3-32-32-32l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightSwitchOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jg);
var Bg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-cfl", f = 320, c = 512, e = [], t = "e5a6", o = "M167.8 63c17.1-4.3 27.6-21.7 23.3-38.8S169.4-3.3 152.2 1L24.2 33C7.1 37.2-3.3 54.6 1 71.8S22.6 99.3 39.8 95l128-32zM319 88.2c-4.3-17.1-21.7-27.6-38.8-23.3l-256 64C7.1 133.2-3.3 150.6 1 167.8s21.7 27.6 38.8 23.3l256-64c17.1-4.3 27.6-21.7 23.3-38.8zM295.8 223c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3l-256 64C7.1 229.2-3.3 246.6 1 263.8s21.7 27.6 38.8 23.3l256-64zM64 416l0 32c0 17.7 14.3 32 32 32l32 0c0 17.7 14.3 32 32 32s32-14.3 32-32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-80 0 0-90L96 306l0 78c-17.7 0-32 14.3-32 32zM319 280.2c-4.3-17.1-21.7-27.6-38.8-23.3l-64 16-16 4c-13.2 3.3-22.4 14.3-24 27l-.2 0 0 3.3c0 .5 0 .9 0 1.4l0 75.3 48 0 0-47 7.8-1.9 64-16c17.1-4.3 27.6-21.7 23.3-38.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbCfl = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bg);
var Tg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-cfl-on", f = 640, c = 512, e = [], t = "e5a7", o = "M351 24.2c4.3 17.1-6.1 34.5-23.3 38.8l-128 32c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l128-32c17.1-4.3 34.5 6.1 38.8 23.3zM455.8 127l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM479 184.2c4.3 17.1-6.1 34.5-23.3 38.8l-256 64c-17.1 4.3-34.5-6.1-38.8-23.3s6.1-34.5 23.3-38.8l256-64c17.1-4.3 34.5 6.1 38.8 23.3zM256 384l0-78 48-12 0 90 80 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c0 17.7-14.3 32-32 32s-32-14.3-32-32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm199.8-65l-64 16L384 337l0 47-48 0 0-75.3c0-.5 0-.9 0-1.4l0-3.3 .2 0c1.6-12.7 10.8-23.7 24-27l16-4 64-16c17.1-4.3 34.5 6.1 38.8 23.3s-6.1 34.5-23.3 38.8zM53.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S42.3-3.3 53.3 4zM613.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM101.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm464-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbCflOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tg);
var Fg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-dollar", f = 384, c = 512, e = [], t = "f670", o = "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM212 88l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbDollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fg);
var Hg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-exclamation", f = 384, c = 512, e = [], t = "f671", o = "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zm0-448c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM160 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hg);
var Rg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-exclamation-on", f = 640, c = 512, e = [], t = "e1ca", o = "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2l-160 0c-9.6-31.9-29.5-59.1-49.2-86.2c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 160 0 0 16zM344 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM320 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbExclamationOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rg);
var Ug = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-gear", f = 576, c = 512, e = [], t = "e5fd", o = "M262.1 352.2c-11 7-19.1 18.6-21.4 31.8L112 384c-9.6-31.9-29.5-59.1-49.2-86.2c0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3c-17.8 7.7-28 25.6-28 43.3l0 .9c-17.6-9.7-41.5-8.2-57.2 8.7c-9.2 9.9-17.4 20.9-24.4 33s-12.4 24.7-16.4 37.6c-6.7 21.6 3.4 42.7 20 53.3zM112 416l133.6 0c3.5 9.2 7.7 18.3 12.8 27c2.9 5 6 9.9 9.4 14.6C257.1 489.2 227.2 512 192 512c-44.2 0-80-35.8-80-80l0-16zm0-240c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16zm260 42.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7l0 17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-17.4c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9l0-17.4zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbGear = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ug);
var qg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-message", f = 576, c = 512, e = [], t = "e687", o = "M256 288l0 96-144 0c-9.6-31.9-29.5-59.1-49.2-86.2c0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 16.6-2.3 32.7-6.6 48L320 224c-35.3 0-64 28.7-64 64zM112 416l144 0c0 14.4 4.8 27.7 12.8 38.4C259.1 487.7 228.4 512 192 512c-44.2 0-80-35.8-80-80l0-16zm0-240c0-44.2 35.8-80 80-80c8.8 0 16-7.2 16-16s-7.2-16-16-16C130.1 64 80 114.1 80 176c0 8.8 7.2 16 16 16s16-7.2 16-16zm432 80c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0 0 48c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L393.4 448 320 448c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l224 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbMessage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qg);
var Gg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-on", f = 640, c = 512, e = [], t = "f672", o = "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2l-160 0c-9.6-31.9-29.5-59.1-49.2-86.2c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 160 0 0 16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gg);
var Wg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lightbulb-slash", f = 640, c = 512, e = [], t = "f673", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.7 0 189.1 41.2 160.8 100.8L38.8 5.1zM213.3 141.9C227.7 96.7 270 64 320 64c8.8 0 16 7.2 16 16s-7.2 16-16 16c-40 0-73.1 29.3-79 67.6l-27.7-21.7zm-60.9 87.9c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l108.1 0L152.4 229.8zM240 416l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-7.1L388.7 416 240 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightbulbSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wg);
var Eg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lighthouse", f = 640, c = 512, e = [], t = "e612", o = "M33.5 1.9l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48C2.4 40.8-3.3 26.7 1.9 14.6S21.3-3.3 33.5 1.9zm112 204.1l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5zM303.9 4.4c10-5.8 22.3-5.8 32.2 0l96 56c15.3 8.9 20.4 28.5 11.5 43.8C437.7 114.3 427 120 416 120l0 40c17.7 0 32 14.3 32 32c0 13.3-8.1 24.7-19.7 29.5L473.6 448l6.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.1 0L352 512l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-98.9 0L160 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l6.4 0 45.3-226.5C200.1 216.7 192 205.3 192 192c0-17.7 14.3-32 32-32c0 0 0 0 0 0l0-40c-11 0-21.7-5.7-27.6-15.9c-8.9-15.3-3.7-34.9 11.5-43.8l96-56zM352 87.7L320 69.1 288 87.7l0 72.3 64 0 0-72.3zM638.1 14.6c5.2 12.2-.4 26.3-12.6 31.5l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6zm-156.1 160c5.2-12.2 19.3-17.8 31.5-12.6l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48c-12.2-5.2-17.8-19.3-12.6-31.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLighthouse = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Eg);
var Vg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lights-holiday", f = 640, c = 512, e = [], t = "f7b2", o = "M5.4 78.2c9.8-14.7 29.6-18.7 44.3-9c0 0 0 0 0 0l.4 .3c.5 .3 1.3 .8 2.5 1.5c2.4 1.4 6.3 3.6 11.7 6.3C75 82.7 91.6 90.1 114.1 97.6C159 112.6 227.6 128 320 128s161-15.4 205.9-30.4c22.5-7.5 39.1-14.9 49.8-20.3c5.4-2.7 9.3-4.9 11.7-6.3c1.2-.7 2.1-1.2 2.5-1.5l.4-.2s0 0 0 0c0 0 0 0 .1 0c14.7-9.7 34.5-5.8 44.3 8.9c9.8 14.7 5.8 34.6-8.9 44.4L608 96c17.8 26.6 17.7 26.6 17.7 26.6s0 0 0 0c0 0 0 0-.1 0l-.2 .1-.4 .3c-.3 .2-.7 .5-1.2 .8c-1 .6-2.4 1.5-4.2 2.5c-3.6 2.1-8.7 4.9-15.3 8.2c-13.3 6.6-32.7 15.2-58.2 23.7C495 175.4 419.6 192 320 192s-175-16.6-226.1-33.6c-25.5-8.5-44.9-17.1-58.2-23.7c-6.6-3.3-11.7-6.1-15.3-8.2c-1.8-1-3.2-1.9-4.2-2.5c-.5-.3-.9-.6-1.2-.8l-.4-.3-.1-.1c0 0 0 0-.1 0c0 0 0 0 0 0L32 96 14.2 122.6C-.5 112.8-4.4 93 5.4 78.2zM523.2 198.7l9.4 25.8c30.8 1.9 59 21.7 70.2 52.5c16.4 45.1-8.8 139.4-31.4 147.6s-102.5-47.8-119-92.9c-11.2-30.8-2.3-64.1 20-85.3l-12.3-33.8c23.2-4 44.2-8.7 63.1-13.8zM320 224c10.9 0 21.6-.2 32-.6l0 39.2c28.3 12.3 48 40.5 48 73.3c0 48-56 128-80 128s-80-80-80-128c0-32.8 19.7-61 48-73.3l0-39.2c10.4 .4 21.1 .6 32 .6zM179.9 212.5l-12.3 33.8c22.3 21.3 31.2 54.5 20 85.3c-16.4 45.1-96.4 101.1-119 92.9S20.8 322.1 37.3 277c11.2-30.8 39.4-50.6 70.2-52.5l9.4-25.8c18.8 5.1 39.9 9.9 63.1 13.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLightsHoliday = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vg);
var Ig = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "line-columns", f = 512, c = 512, e = [], t = "f870", o = "M224 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l160 0c17.7 0 32-14.3 32-32zm0 128c0-17.7-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32zM0 320c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32zM224 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32zM288 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 32c-17.7 0-32 14.3-32 32zM512 192c0-17.7-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32zM288 320c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32zM512 448c0-17.7-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLineColumns = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ig);
var Kg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "line-height", f = 576, c = 512, e = [], t = "f871", o = "M118.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4 0 229.5-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4 0-229.5 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0zM256 416c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLineHeight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kg);
var Xg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "link-simple", f = 576, c = 512, e = [], t = "e1cd", o = "M0 256C0 167.6 71.6 96 160 96l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96 43-96 96s43 96 96 96l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96-43 96-96s-43-96-96-96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c88.4 0 160 71.6 160 160zM192 224l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLinkSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xg);
var Qg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "link-simple-slash", f = 640, c = 512, e = [], t = "e1ce", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136c0-88.4-71.6-160-160-160l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96 43 96 96c0 43.3-28.6 79.8-67.9 91.8L399.7 288l16.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-97.9 0-81.7-64 19.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zM121 191.4L70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-53 0-96-43-96-96c0-24.9 9.5-47.6 25-64.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLinkSimpleSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qg);
var Jg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lips", f = 576, c = 512, e = [128068, 128482], t = "f600", o = "M288 101.3c3-2.4 6.2-4.8 9.7-7.3c17.8-12.7 46.8-30 78.3-30c20.3 0 42.8 9.3 61.4 19.2c20 10.6 41.1 24.7 60.2 39.5c19.1 14.8 37.1 31.2 50.8 46.5c6.8 7.6 13.1 15.7 17.9 23.7c4.3 7.2 9.7 18.3 9.7 31c0 9.2-2.6 19.1-5.3 27.5c-3 9.1-7.4 19.4-12.8 30.3c-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448l-64 0c-84.7 0-148.8-47.1-190.2-95.1C44.9 328.8 29 303.5 18.1 281.8C12.7 271 8.4 260.7 5.3 251.5C2.6 243.1 0 233.2 0 224c0-12.8 5.5-23.8 9.7-31c4.8-8.1 11.1-16.1 17.9-23.7c13.6-15.3 31.7-31.7 50.8-46.5c19.1-14.9 40.2-29 60.2-39.5C157.2 73.3 179.7 64 200 64c31.5 0 60.6 17.2 78.3 30c3.4 2.5 6.7 4.9 9.7 7.3zM64 224c0 7.9 80 96 224 96s224-88.1 224-96c0-7.7-46.3-31.1-138.8-32c-3.4 0-6.9 .5-10.1 1.5C350 197.6 313.7 208 288 208s-62-10.4-75.1-14.4c-3.3-1-6.7-1.6-10.1-1.5C110.3 192.9 64 216.3 64 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLips = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jg);
var Yg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "list-dropdown", f = 512, c = 512, e = [], t = "e1cf", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM448 192l0 224L64 416l0-224 384 0zM436.7 96c7.1 0 10.7 8.6 5.7 13.7l-36.7 36.7c-3.1 3.1-8.2 3.1-11.3 0l-36.7-36.7c-5-5-1.5-13.7 5.7-13.7l73.4 0zM128 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l256 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-256 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l256 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-256 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faListDropdown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yg);
var Zg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "list-music", f = 512, c = 512, e = [], t = "f8c9", o = "M498.7 6c8.3 6 13.3 15.7 13.3 26l0 64c0 13.8-8.8 26-21.9 30.4L416 151.1 416 432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c17.2 0 33.5 2.8 48 7.7L352 128l0-64c0-13.8 8.8-26 21.9-30.4l96-32C479.6-1.6 490.4 0 498.7 6zM32 64l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96S14.3 64 32 64zm0 128l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faListMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zg);
var pg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "list-radio", f = 512, c = 512, e = [], t = "e1d0", o = "M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zM64 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faListRadio = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pg);
var xg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "list-timeline", f = 512, c = 512, e = [], t = "e1d1", o = "M16 96a48 48 0 1 1 96 0A48 48 0 1 1 16 96zM64 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM191.5 54.4c5.5-4.2 12.3-6.4 19.2-6.4L424 48c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-213.3 0c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6l38.4-28.8zM153.1 243.2l38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4L488 208c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-277.3 0c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6zm0 160l38.4-28.8c5.5-4.2 12.3-6.4 19.2-6.4L424 368c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-213.3 0c-6.9 0-13.7-2.2-19.2-6.4l-38.4-28.8c-8.5-6.4-8.5-19.2 0-25.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faListTimeline = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xg);
var iP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "list-tree", f = 512, c = 512, e = [], t = "e1d2", o = "M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48zM160 96c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64c-17.7 0-32 14.3-32 32zM288 256c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32zm0 160c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faListTree = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iP);
var aP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "loader", f = 512, c = 512, e = [], t = "e1d4", o = "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zm0 384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zM0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm416-32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zM75 75c-12.5 12.5-12.5 32.8 0 45.3l45.3 45.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L120.2 75C107.7 62.5 87.5 62.5 75 75zM391.8 346.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L391.8 437c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-45.3-45.3zM75 437c12.5 12.5 32.8 12.5 45.3 0l45.3-45.3c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8c-12.5 12.5-12.5 32.8 0 45.3zM346.5 120.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L437 120.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-45.3 45.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLoader = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aP);
var eP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lobster", f = 512, c = 512, e = [129438], t = "e421", o = "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7 .3 67.4 0 64 0C28.7 0 0 28.7 0 64l0 64c0 35.3 28.7 64 64 64l.7 0 41.8 27.9C126.2 233 149.4 240 173.1 240l18.9 0 0 16-48.9 0c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4l48.9 0 0 16-69.6 0c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1l69.6 0 0 16-16.9 0c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1l16.9 0 21.4 64.1c-29.8 1.8-53.4 26.5-53.4 56.8c0 3.9 3.2 7.1 7.1 7.1l177.8 0c3.9 0 7.1-3.2 7.1-7.1c0-30.2-23.6-55-53.4-56.8L320 384l16.9 0c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4L320 352l0-16 69.6 0c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5L320 304l0-16 48.9 0c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1L320 256l0-16 18.9 0c23.7 0 46.9-7 66.6-20.2L447.3 192l.7 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64c-3.4 0-6.7 .3-9.9 .8c-3.6 .6-6.1 3.8-6.1 7.5L432 72c0 7.7-9.8 11-14.4 4.8L397.4 49.9c-3.7-4.9-11.2-3.9-12.3 2.1c-.7 3.9-1.1 7.9-1.1 11.9l0 64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5C367 187.8 353.1 192 338.9 192l-24.7 0c-2.7-7.3-6.2-14-10.2-20.2l0-91.1c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7l0 57.3c-3.1-2.3-6.2-4.4-9-6.1c-4.3-2.6-9.7-2.6-13.9 0c-2.8 1.7-5.9 3.8-9 6.1l0-57.3c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7l0 91.1c-4 6.2-7.5 13-10.2 20.2l-24.7 0c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4l0-64c0-4.1-.4-8.1-1.1-11.9c-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72L80 8.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLobster = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eP);
var nP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-arrow-up", f = 448, c = 512, e = [], t = "e63a", o = "M35.8 431.9L190.9 54.2C196.4 40.8 209.5 32 224 32s27.6 8.8 33.1 22.2L412.2 431.9c9.4 23-7.4 48.1-32.3 48.1c-7.8 0-15.3-2.6-21.4-7.3L224 368 89.4 472.7C83.3 477.4 75.8 480 68 480c-24.8 0-41.7-25.2-32.3-48.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nP);
var C4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-check", f = 384, c = 512, e = ["map-marker-check"], t = "f606", o = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM289 155.6L182.3 262.3c-9.4 9.4-24.6 9.4-33.9 0L95 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36.4 36.4L255 121.7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C4);
var fP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = a1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLocationCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(fP);
var D4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-crosshairs-slash", f = 640, c = 512, e = ["location-slash"], t = "f603", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c12.1-20.1 20.6-42.6 24.6-66.6l34.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-34.7 0C495.9 143.6 432.4 80.1 352 66.7L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 34.7c-39.9 6.7-75.6 25.7-103.1 52.9L38.8 5.1zm197 154.4C258.3 139.9 287.8 128 320 128c70.7 0 128 57.3 128 128c0 21.2-5.1 41.1-14.2 58.7l-38.9-30.5c3.3-8.8 5.1-18.3 5.1-28.2c0-44.2-35.8-80-80-80c-16.8 0-32.4 5.2-45.3 14l-38.9-30.5zM414.9 422.9l-56.8-44.7C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-56.8-44.7c-2 6.9-3.6 14-4.8 21.3L96 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l34.7 0c13.5 80.4 76.9 143.9 157.3 157.3l0 34.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-34.7c22.6-3.8 43.8-11.5 62.9-22.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationCrosshairsSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D4);
var $4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-dot-slash", f = 640, c = 512, e = ["map-marker-alt-slash"], t = "f605", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zm219 171.7c6.8-28 32.1-48.8 62.2-48.8c35.3 0 64 28.7 64 64c0 24.7-13.9 46-34.4 56.7l-91.8-72zm85.9 322.4c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationDotSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($4);
var _4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-exclamation", f = 384, c = 512, e = ["map-marker-exclamation"], t = "f608", o = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 96c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_4);
var b4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-minus", f = 384, c = 512, e = ["map-marker-minus"], t = "f609", o = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM120 168l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b4);
var S4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-pen", f = 384, c = 512, e = ["map-marker-edit"], t = "f607", o = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L208.6 122 223.5 107c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5L186 144.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationPen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S4);
var y4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-pin-slash", f = 640, c = 512, e = ["map-marker-slash"], t = "f60c", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM343.7 499.2c16.2-20.2 39-49.6 62.5-83.1L128.1 196.9c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationPinSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y4);
var O4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-plus", f = 384, c = 512, e = ["map-marker-plus"], t = "f60a", o = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM168 280l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O4);
var k4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-question", f = 384, c = 512, e = ["map-marker-question"], t = "f60b", o = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM105.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k4);
var cP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = D4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLocationSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(cP);
var A4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-smile", f = 384, c = 512, e = ["map-marker-smile"], t = "f60d", o = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-95.4 84.9c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationSmile = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A4);
var L = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "location-xmark", f = 384, c = 512, e = ["map-marker-times", "map-marker-xmark"], t = "f60e", o = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLocationXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L);
var tP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lock-a", f = 448, c = 512, e = [], t = "e422", o = "M224 64c44.2 0 80 35.8 80 80l0 48-160 0 0-48c0-44.2 35.8-80 80-80zM80 144l0 48-16 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-16 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144zm49.7 280.8L209.6 265c.8-1.6 1.8-3 3-4.3c1.4-1.5 3.1-2.6 5-3.4c2.1-.9 4.2-1.3 6.4-1.3s4.3 .4 6.4 1.3c1.8 .8 3.5 1.9 5 3.4c1.3 1.3 2.3 2.7 3.1 4.3l79.9 159.9c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2L270.1 400l-92.2 0-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5zM193.9 368l60.2 0L224 307.8 193.9 368z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLockA = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tP);
var oP = {}, j4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lock-keyhole", f = 448, c = 512, e = ["lock-alt"], t = "f30d", o = "M224 64c44.2 0 80 35.8 80 80l0 48-160 0 0-48c0-44.2 35.8-80 80-80zM80 144l0 48-16 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-16 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLockKeyhole = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = j4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLockAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(oP);
var lP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lock-hashtag", f = 448, c = 512, e = [], t = "e423", o = "M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 16 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l16 0zm96 48c-8.8 0-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 64-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 64 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-64 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-64 0 0-32c0-8.8-7.2-16-16-16zm16 144l0-64 64 0 0 64-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLockHashtag = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lP);
var B4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lock-keyhole-open", f = 576, c = 512, e = ["lock-open-alt"], t = "f3c2", o = "M432 64c-44.2 0-80 35.8-80 80l0 48 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l224 0 0-48C288 64.5 352.5 0 432 0s144 64.5 144 144l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-44.2-35.8-80-80-80zM256 384c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLockKeyholeOpen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B4);
var dP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = B4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLockOpenAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(dP);
var T4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "lollipop", f = 512, c = 512, e = [127853, "lollypop"], t = "e424", o = "M210.8 334.8C265.3 314.2 304 261.6 304 200l0-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64l0 8c0 53-43 96-96 96l-8 0C94.6 296 48 249.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192C0 298 86 384 192 384c41.5 0 79.9-13.1 111.2-35.5L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L348.5 303.2C370.9 271.9 384 233.5 384 192C384 86 298 0 192 0S0 86 0 192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLollipop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T4);
var rP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = T4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLollypop = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(rP);
var sP = {}, C = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "luchador-mask", f = 448, c = 512, e = ["luchador", "mask-luchador"], t = "f455", o = "M224 0C100.3 0 0 100.3 0 224l0 96C0 426 86 512 192 512l64 0c106 0 192-86 192-192l0-96C448 100.3 347.7 0 224 0zM128 384c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-35.3 0-57.4 0L160 352c-17.7 0-32 14.3-32 32zm-32 0c0-33.2 25.2-60.5 57.6-63.7c-1-3.7-1.6-7.6-1.6-11.6c0-7.3 1.8-14.4 5.3-20.7L144 288c-44.2 0-80-35.8-80-80c0-26.5 21.5-48 48-48l32 0c44.2 0 80 35.8 80 80c0-44.2 35.8-80 80-80l32 0c26.5 0 48 21.5 48 48c0 44.2-35.8 80-80 80l-13.3 0c3.4 6.3 5.3 13.4 5.3 20.7c0 4-.6 7.9-1.6 11.6c32.3 3.2 57.6 30.5 57.6 63.7c0 35.3-28.7 64-64 64l-128 0c-35.3 0-64-28.7-64-64zm156.7-64l.2 0c6.1 0 11.1-5 11.1-11.1l0-.1 0-.1c0-3-1.2-5.9-3.3-8l-8-8-4.2-4.2-.4-.4-10.3-10.3C234 274 229.1 272 224 272s-10 2-13.7 5.7L200 288l-.4 .4-4.2 4.2-8 8c-2.1 2.1-3.3 5-3.3 8l0 .1 0 .1c0 6.1 5 11.1 11.1 11.1l.2 0 11.3 0 6 0 .6 0 21.5 0 .6 0 6 0 11.3 0zM112 192c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0zm240 16c0-8.8-7.2-16-16-16l-32 0c-26.5 0-48 21.5-48 48c0 8.8 7.2 16 16 16l32 0c26.5 0 48-21.5 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faLuchadorMask = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = C;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faLuchador = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(sP);
var hP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mace", f = 512, c = 512, e = [], t = "f6f8", o = "M244.8 95l28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1C301 443.6 294.9 448 288 448s-13-4.4-15.2-10.9l-28-84.1c-9.8-3.3-19-7.6-27.7-12.9L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L171.9 294.9c-5.3-8.6-9.6-17.9-12.9-27.7l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMace = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hP);
var vP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "magnifying-glass-arrows-rotate", f = 512, c = 512, e = [], t = "e65e", o = "M73.8 155.6C69 168 57.3 175.7 44.7 176l-1.5 0c-3.6-.1-7.3-.8-10.9-2.2c-16.5-6.4-24.6-25-18.2-41.4C44.4 54.9 119.8 0 208 0c52.9 0 101.1 19.7 137.8 52.2L375 23c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 112c0 13.3-10.7 24-24 24l-112 0c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l37.4-37.4C275.4 76.6 243.2 64 208 64c-61 0-113.2 37.9-134.2 91.6zM342.2 260.4c4.8-12.4 16.6-20.1 29.1-20.4l1.5 0c3.6 .1 7.3 .8 10.9 2.2c16.5 6.4 24.6 25 18.2 41.4c-6.6 16.9-15.3 32.7-25.8 47.1L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40c-52.9 0-101.1-19.7-137.8-52.2L41 393c-6.9 6.9-17.2 8.9-26.2 5.2S0 385.7 0 376L0 264c0-13.3 10.7-24 24-24l112 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-37.4 37.4c25 21 57.3 33.6 92.5 33.6c61 0 113.2-37.9 134.2-91.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMagnifyingGlassArrowsRotate = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vP);
var uP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "magnifying-glass-music", f = 512, c = 512, e = [], t = "e65f", o = "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM278 100.5c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16c-9.8 3.3-16.4 12.4-16.4 22.8l0 32 0 57.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48c35.3 0 63.9-21.4 64-47.9c0 0 0-.1 0-.1l0-86.7 31.6-10.5c9.8-3.3 16.4-12.4 16.4-22.8l0-32c0-7.7-3.7-15-10-19.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMagnifyingGlassMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uP);
var mP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "magnifying-glass-play", f = 512, c = 512, e = [], t = "e660", o = "M376 330.7c25.2-34.4 40-76.8 40-122.7C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416c45.9 0 88.3-14.9 122.7-40L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7zM161.8 130.1c5-2.9 11.1-2.8 16 0l110.2 64c4.9 2.9 8 8.1 8 13.8s-3 11-8 13.8l-110.2 64c-4.9 2.9-11.1 2.9-16 0s-8-8.1-8-13.9l0-128c0-5.7 3.1-11 8-13.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMagnifyingGlassPlay = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mP);
var gP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "magnifying-glass-waveform", f = 512, c = 512, e = [], t = "e661", o = "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM232 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176zm-88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm176 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMagnifyingGlassWaveform = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gP);
var PP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mailbox", f = 576, c = 512, e = [128234], t = "f813", o = "M0 208L0 384c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-176c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 224c-8.8 0-16-7.2-16-16zm256 0l0 176c0 24.6-9.2 47-24.4 64L512 448c35.3 0 64-28.7 64-64l0-176c0-79.5-64.5-144-144-144L245.2 64C290.4 95.9 320 148.5 320 208zm64 0c0-8.8 7.2-16 16-16l64 0 32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMailbox = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(PP);
var MP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mailbox-flag-up", f = 576, c = 512, e = [], t = "e5bb", o = "M400 16c-29.8 0-54.9 20.4-62 48l-92.8 0C290.4 95.9 320 148.5 320 208l0 176c0 24.6-9.2 47-24.4 64L512 448c35.3 0 64-28.7 64-64l0-176c0-42.6-18.5-81-48-107.3L528 80c0-35.3-28.7-64-64-64l-64 0zm0 208c-8.8 0-16-7.2-16-16l0-96 0-32c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 80c0 8.8-7.2 16-16 16zM0 208L0 384c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-176c0-79.5-64.5-144-144-144S0 128.5 0 208zm64 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 224c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMailboxFlagUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(MP);
var wP = {}, D = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sushi-roll", f = 448, c = 512, e = ["maki-roll", "makizushi"], t = "e48b", o = "M448 368l0-224C448 82.1 347.7 32 224 32S0 82.1 0 144L0 368c0 61.9 100.3 112 224 112s224-50.1 224-112zM308.2 198.4c-24.5 6.1-53.3 9.6-84.2 9.6c-40.7 0-77.8-6.1-106-16.1c14.8-14.8 32.8-26.7 51.4-36.1c20.5-10.3 40.9-17 56.9-20.8c18.2 27.3 46.6 49.9 82 63.4zM205.1 80.4c.8 6 2.1 11.9 3.8 17.7c-17.3 4.7-37.4 11.8-57.5 21.9c-24.5 12.3-49.9 29.4-70.3 52.7C70.2 164.1 64 154.4 64 144c0-32.8 61.7-59.8 141.1-63.6zm40.7 .2c78 4.3 138.2 31 138.2 63.4c0 9.8-5.5 19.1-15.4 27.4c-69.5-5.5-113.5-48.4-122.8-90.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSushiRoll = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = D;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMakiRoll = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(wP);
var NP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = D;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMakizushi = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(NP);
var zP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mandolin", f = 512, c = 512, e = [], t = "f6f9", o = "M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4L388 169.2l-65.9 65.9C323.7 322.4 311.5 512 176 512C78.8 512 0 433.2 0 336C0 200.5 189.6 188.3 276.9 189.8L342.8 124l18.1-66.3c1.6-5.8 5.3-10.8 10.4-14l64-40zM208 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMandolin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zP);
var LP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mango", f = 512, c = 512, e = [], t = "e30f", o = "M344 0l8 0 24 0 8 0 56 0c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24l-40 0c-33.4 0-62.8-17-80-42.9l0 49c32.2 8.3 62.6 25 87.8 50.2C493.3 189.7 512 238.9 512 288c0 76.6-57.5 224-224 224c-144 0-244.1-43.3-244.1-43.3C10.3 457.6-7.9 421.4 3.3 387.9C7.4 375.4 15 365 24.7 357.5c34.3-25.7 52.1-57.6 71.2-91.8c20.6-36.8 42.6-76.3 88.4-113.5C221.7 114.7 270.9 96 320 96l0-72c0-13.3 10.7-24 24-24zm88 304c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMango = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(LP);
var CP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "manhole", f = 512, c = 512, e = [], t = "e1d6", o = "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM281.4 115.4c5.8-7.5 14.5-14.7 23.6-11.8c64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8c-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8c5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm80-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-32 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faManhole = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(CP);
var DP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = $4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerAltSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(DP);
var $P = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = C4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerCheck = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})($P);
var _P = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = S4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerEdit = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_P);
var bP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = _4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerExclamation = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(bP);
var SP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = b4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerMinus = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(SP);
var yP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = O4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerPlus = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yP);
var OP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = k4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerQuestion = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(OP);
var kP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = y4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(kP);
var AP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = A4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerSmile = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(AP);
var jP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = L;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(jP);
var BP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = L;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMapMarkerXmark = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(BP);
var TP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = C;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMaskLuchador = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(TP);
var FP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mask-snorkel", f = 576, c = 512, e = [], t = "e3b7", o = "M544 32c-17.7 0-32 14.3-32 32l0 96 64 0 0-96c0-17.7-14.3-32-32-32zM512 367.4c0 44.5-36.1 80.6-80.6 80.6c-39.4 0-73-28.5-79.5-67.4l-.3-1.9c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.3 1.9C300.4 460.9 360.7 512 431.4 512C511.3 512 576 447.3 576 367.4L576 192l-64 0 0 175.4zM64 64C28.7 64 0 92.7 0 128l0 96c0 35.3 28.7 64 64 64l79.7 0c28.6 0 53.7-18.9 61.5-46.4l3.4-11.7c4.4-15.5 26.3-15.5 30.8 0l3.4 11.7c7.8 27.5 33 46.4 61.5 46.4l79.7 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMaskSnorkel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(FP);
var HP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "meat", f = 512, c = 512, e = [127830], t = "f814", o = "M243.6 19.6C283.7-20.4 371.9 2.8 440.5 71.5s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.8 384l-58.2 0c-7.1 0-13.9 2.8-18.9 7.8c-10.3 10.3-9.7 26.9-5 40.7c2.1 6.1 3.2 12.7 3.2 19.5c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c6.8 0 13.4 1.1 19.5 3.2c13.8 4.7 30.4 5.3 40.7-5c5-5 7.8-11.8 7.8-18.9l0-58.1c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2S299.1 33.2 270.2 62.2s-12.2 92.6 37.4 142.2zm36.3-36.3c-15.3-15.3-20.4-34.9-11.5-43.8s28.5-3.7 43.8 11.5s20.4 34.9 11.5 43.8s-28.5 3.7-43.8-11.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMeat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(HP);
var RP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "megaphone", f = 576, c = 512, e = [128227], t = "f675", o = "M544 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32zM64 190.3L480 64l0 384L348.9 408.2C338.2 449.5 300.7 480 256 480c-53 0-96-43-96-96c0-11 1.9-21.7 5.3-31.5L64 321.7C63.1 338.6 49.1 352 32 352c-17.7 0-32-14.3-32-32L0 192c0-17.7 14.3-32 32-32c17.1 0 31.1 13.4 32 30.3zm239 203.9l-91.6-27.8c-2.1 5.4-3.3 11.4-3.3 17.6c0 26.5 21.5 48 48 48c23 0 42.2-16.2 46.9-37.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMegaphone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(RP);
var UP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "melon", f = 512, c = 512, e = [], t = "e310", o = "M256 512c-38.5 0-75-8.5-107.7-23.7c67.1-5.8 149.8-48.2 220.8-119.2s113.4-153.8 119.2-220.8C503.5 181 512 217.5 512 256c0 141.4-114.6 256-256 256zM74.7 436.8c-19.1-19.4-26.8-55.8-11.9-108c14.6-51.2 49.6-110.2 102.7-163.3s112.1-88.1 163.3-102.7c52.4-15 88.9-7.1 108.2 12.2s27.2 55.9 12.2 108.2c-14.6 51.2-49.6 110.2-102.7 163.3s-112.1 88.1-163.3 102.7c-52.1 14.9-88.6 7.2-108-11.9c-.2-.2-.4-.4-.5-.5zm-51-73.1C8.5 331 0 294.5 0 256C0 114.6 114.6 0 256 0c38.5 0 75 8.5 107.7 23.7c-67.1 5.8-149.8 48.2-220.8 119.2s-113.4 153.8-119.2 220.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMelon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(UP);
var qP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "melon-slice", f = 512, c = 512, e = [], t = "e311", o = "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zM320 128c0 106-86 192-192 192c-11.4 0-22.5-1-33.3-2.9c-5.4-.9-11 .6-14.8 4.5L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4c84.4 84.4 221.1 84.4 305.5 0c84.2-84.2 84.4-220.7 .3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L321.6 79.8c-3.9 3.9-5.4 9.4-4.5 14.8c1.9 10.8 2.9 22 2.9 33.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMelonSlice = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qP);
var GP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "memo", f = 384, c = 512, e = [], t = "e1d8", o = "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm64 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMemo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(GP);
var WP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "memo-circle-check", f = 576, c = 512, e = [], t = "e1d9", o = "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 134.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm64 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm208 48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm188.7-43.3L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMemoCircleCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(WP);
var EP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "memo-circle-info", f = 576, c = 512, e = [], t = "e49a", o = "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 134.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64zm64 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm352-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16c0 0 0 0 0 0l0 48s0 0 0 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMemoCircleInfo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(EP);
var VP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "memo-pad", f = 448, c = 512, e = [], t = "e1da", o = "M0 64L0 96l448 0 0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320L0 128zm96 96c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMemoPad = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(VP);
var IP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "merge", f = 512, c = 512, e = [], t = "e526", o = "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l97.2 0c9.7 0 18.9 4.4 25 12L247 256 154.2 372c-6.1 7.6-15.3 12-25 12L32 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l97.2 0c29.2 0 56.7-13.3 75-36l99.2-124 80.6 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-80.6 0L204.2 100c-18.2-22.8-45.8-36-75-36L32 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMerge = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(IP);
var KP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-arrow-up-right", f = 512, c = 512, e = [], t = "e1dd", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm200 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageArrowUpRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(KP);
var XP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-bot", f = 640, c = 512, e = [], t = "e3b8", o = "M160 0C124.7 0 96 28.7 96 64l0 112-36.3 0c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16L96 208l0 144c0 35.3 28.7 64 64 64l64 0 0 80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416 480 416c35.3 0 64-28.7 64-64l0-144 36.3 0c5.5 9.6 15.9 16 27.7 16c17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16L544 176l0-112c0-35.3-28.7-64-64-64L160 0zm0 128c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-128zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageBot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(XP);
var QP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-code", f = 512, c = 512, e = [], t = "e1df", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm217 97c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageCode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(QP);
var JP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = m;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMessageEdit = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(JP);
var YP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-heart", f = 512, c = 512, e = [], t = "e5c9", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm205.3 48c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageHeart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(YP);
var ZP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-question", f = 512, c = 512, e = [], t = "e1e3", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ZP);
var pP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "message-sms", f = 512, c = 512, e = [], t = "e1e5", o = "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 144 96 160.5 96 180.8zM372.8 144c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 153.1 192 160l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessageSms = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pP);
var xP = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = g;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMessageTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(xP);
var iM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "messages-question", f = 640, c = 512, e = [], t = "e1e7", o = "M0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-149.3 0-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-48-32 0c-35.3 0-64-28.7-64-64L0 64zM256 352l96 0c53 0 96-43 96-96l0-128 128 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-32 0 0 48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448 320 448c-35.3 0-64-28.7-64-64l0-32zM136.2 92.4l-.4 1c-3.7 10.4 1.8 21.8 12.2 25.5s21.8-1.8 25.5-12.2l.4-1c.9-2.7 3.5-4.4 6.3-4.4l48.5 0c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9L198 146.1c-6.2 3.6-10 10.2-10 17.3l0 11.2c0 11 9 20 20 20c10.9 0 19.8-8.8 20-19.6l26.9-15.4c16.3-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6l-48.5 0c-19.8 0-37.4 12.4-44 31.1zM234.7 248a26.7 26.7 0 1 0 -53.3 0 26.7 26.7 0 1 0 53.3 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMessagesQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iM);
var aM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = u;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMessaging = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(aM);
var eM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "meter", f = 512, c = 512, e = [], t = "e1e8", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMeter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eM);
var nM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "meter-bolt", f = 640, c = 512, e = [], t = "e1e9", o = "M256 512c73.7 0 140.1-31.1 186.8-81l7.5-15L432 416c-20.4 0-38.5-12.9-45.3-32.1s-.6-40.6 15.3-53.4l109.6-87.7C504.8 107.5 393 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm218.1 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L449.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMeterBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nM);
var fM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "meter-droplet", f = 640, c = 512, e = [], t = "e1ea", o = "M256 512c53.7 0 103.5-16.5 144.6-44.7C390 447.2 384 424.3 384 400c0-23.6 5.8-46.9 16.9-67.8l75.3-141.2c4.9-9.2 12.1-16.7 20.6-22.1C461.2 70.4 366.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm120.5 46.1L429.2 347.3C420.5 363.5 416 381.6 416 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7L551.5 206.1c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMeterDroplet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fM);
var cM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "meter-fire", f = 640, c = 512, e = [], t = "e1eb", o = "M256 512c33.6 0 65.7-6.5 95.1-18.3c-39-35.9-63.1-87.5-63.1-143.7c0-35.2 16.3-73.6 37.2-107.4c4.4-7.1 9.1-14.2 14.1-21.3C327.9 216.5 320 205.2 320 192l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.4c9-9.4 18.5-18.6 28.5-27.5C430.2 124 457.3 124 475 140c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512zM192 160l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm96 0l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm217.7 48.1l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352c0 88.6 70.4 159.8 160 159.8c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327 544 363.5 544 400z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMeterFire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cM);
var tM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "microchip-ai", f = 512, c = 512, e = [], t = "e1ec", o = "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c-35.3 0-64 28.7-64 64l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c0 35.3 28.7 64 64 64l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c35.3 0 64-28.7 64-64l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c0-35.3-28.7-64-64-64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40zm32 152c6.4 0 12.1 3.8 14.7 9.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304l-63.1 0-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6zm17.5 96L208 231.9 190.5 272l35.1 0zM336 176c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMicrochipAi = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tM);
var oM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = e1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMicrophoneCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(oM);
var lM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = n1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMicrophoneCircleAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lM);
var dM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "microphone-stand", f = 512, c = 512, e = [127908], t = "f8cb", o = "M479.2 32.8c-43.7-43.7-114.7-43.7-158.4 0l-4.7 4.7L474.5 195.9l4.7-4.7c43.7-43.7 43.7-114.7 0-158.4zM293.5 60.1l-4.7 4.7c-24.4 24.4-35.2 57.2-32.4 89L358.2 255.6c31.8 2.8 64.6-8 89-32.4l4.7-4.7L293.5 60.1zM229.1 171.7L215.8 187 7.8 427c-11 12.7-10.3 31.7 1.6 43.6l32 32c11.9 11.9 30.9 12.6 43.6 1.6L224 383.7l0 96.3c0 17.7 14.3 32 32 32s32-14.3 32-32l0-151.8 37-32 15.3-13.3L229.1 171.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMicrophoneStand = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dM);
var rM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "microwave", f = 576, c = 512, e = [], t = "e01b", o = "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l-320 0c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64L0 96zm96 56l0 176c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMicrowave = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rM);
var sM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = t2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMindShare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(sM);
var hM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = c4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMinusHexagon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(hM);
var vM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Y1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMinusLarge = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vM);
var uM = {}, F4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "octagon-minus", f = 512, c = 512, e = ["minus-octagon"], t = "f308", o = "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOctagonMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = F4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMinusOctagon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(uM);
var mM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mistletoe", f = 576, c = 512, e = [], t = "f7b4", o = "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 94.1-98 98L91.3 230.4C38.3 240.6 0 287 0 341c0 41.4 33.6 75 75 75c50.5 0 94.3-33.5 108.1-81.2c7.2 10.4 19.3 17.2 32.9 17.2c22.1 0 40-17.9 40-40s-17.9-40-40-40c-7.9 0-15.3 2.3-21.5 6.3l5.4-28.2L264 185.9l0 72.4c14.7 13.2 24 32.3 24 53.7c0 39.8-32.2 72-72 72c-7.2 0-14.2-1.1-20.8-3c-2.1 8.4-3.2 17.1-3.2 25.9l0 9.1c0 53 43 96 96 96s96-43 96-96l0-9.1c0-25.1-9-49.4-25.3-68.4L312 284l0-98.1L376.1 250l14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75c0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98L312 24zm64 88a40 40 0 1 0 0-80 40 40 0 1 0 0 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMistletoe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mM);
var gM = {}, H4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mobile-notch", f = 384, c = 512, e = ["mobile-iphone"], t = "e1ee", o = "M128 64l0 16c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-16 32 0c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16L96 448c-8.8 0-16-7.2-16-16L80 80c0-8.8 7.2-16 16-16l32 0zM96 0C51.8 0 16 35.8 16 80l0 352c0 44.2 35.8 80 80 80l192 0c44.2 0 80-35.8 80-80l0-352c0-44.2-35.8-80-80-80L96 0zm32 400c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMobileNotch = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = H4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMobileIphone = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(gM);
var PM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mobile-signal", f = 512, c = 512, e = [], t = "e1ef", o = "M64 64l224 0 0 251.7c18.3-21.2 39.9-39.5 64-54L352 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l160 0 0-24c0-13.6 1-27 3-40L64 448 64 64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM488 256c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-136c0-13.3-10.7-24-24-24c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMobileSignal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(PM);
var MM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mobile-signal-out", f = 512, c = 512, e = [], t = "e1f0", o = "M64 64l160 0 0-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-160-64 0 0 160L64 448 64 64zm80 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 120c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMobileSignalOut = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(MM);
var wM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "money-bill-simple", f = 576, c = 512, e = [], t = "e1f1", o = "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoneyBillSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wM);
var NM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "money-bill-simple-wave", f = 576, c = 512, e = [], t = "e1f2", o = "M0 112.5L0 422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4l0-309.9c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoneyBillSimpleWave = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(NM);
var zM = {}, R4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "money-bills-simple", f = 640, c = 512, e = ["money-bills-alt"], t = "e1f4", o = "M96 96l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoneyBillsSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = R4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMoneyBillsAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(zM);
var U4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "money-check-dollar-pen", f = 640, c = 512, e = ["money-check-edit-alt"], t = "f873", o = "M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64.6c-15.2 2-29.8 8.8-41.4 20.5L353.3 394.3c-8.2 8.2-14 18.5-16.8 29.7l-6 23.9L64 448c-35.3 0-64-28.7-64-64L0 128zM256 304c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zM144 139.9c-11.1 0-20.1 9-20.1 20.1l0 6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0s0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1l0 6.4c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1l0-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4l0-6.3c0-11.1-9-20.1-20.1-20.1zm469.8 95.8l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoneyCheckDollarPen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U4);
var LM = {}, q4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "money-check-pen", f = 640, c = 512, e = ["money-check-edit"], t = "f872", o = "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l266.5 0 6-23.9c2.8-11.3 8.6-21.5 16.8-29.7L534.6 213.1c11.6-11.6 26.3-18.5 41.4-20.5l0-64.6c0-35.3-28.7-64-64-64L64 64zm48 224l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16zm517.8 27.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoneyCheckPen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = q4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMoneyCheckEdit = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(LM);
var CM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = U4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMoneyCheckEditAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(CM);
var DM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "money-from-bracket", f = 640, c = 512, e = [], t = "e312", o = "M64 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 43 43 0 96 0L544 0c53 0 96 43 96 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96zm64 0l384 0 0 352c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-352zM256 448c0-35.3-28.7-64-64-64l0 64 64 0zm192-64c-35.3 0-64 28.7-64 64l64 0 0-64zM320 352c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoneyFromBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(DM);
var $M = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "money-simple-from-bracket", f = 640, c = 512, e = [], t = "e313", o = "M64 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 96C0 43 43 0 96 0L544 0c53 0 96 43 96 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32L96 64C78.3 64 64 78.3 64 96zm64 0l384 0 0 352c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-352zM320 352c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoneySimpleFromBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($M);
var _M = {}, G4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "monitor-waveform", f = 576, c = 512, e = ["monitor-heart-rate"], t = "f611", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM80 96l416 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L80 416c-8.8 0-16-7.2-16-16l0-128 0-160c0-8.8 7.2-16 16-16zM96 256l96 0c6.1 0 11.6 3.4 14.3 8.8L224 300.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L329.9 256l70.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-6.1 0-11.6-3.4-14.3-8.8L288 243.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L182.1 288 96 288l0 96 384 0 0-256L96 128l0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMonitorWaveform = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = G4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMonitorHeartRate = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_M);
var bM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "monkey", f = 576, c = 512, e = [128018], t = "f6fb", o = "M160 416c0-89.7 61.4-165 144.5-186.1C329.1 265 369.9 288 416 288c9.8 0 19.4-1 28.7-3L526.5 363c31.6 30.2 49.5 72 49.5 115.7l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-26.2-10.7-51.3-29.7-69.4L416 346.1 416 448l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-256 0C71.6 512 0 440.4 0 352L0 110.1C0 49.3 49.3 0 110.1 0l10.4 0c57.2 0 102.8 47.8 100.1 104.9c-2.3 48.2-38.6 88-86.4 94.6l-1.9 .3c-17.5 2.4-33.7-9.8-36.1-27.3s9.8-33.7 27.3-36.1l1.9-.3c17.3-2.4 30.4-16.7 31.2-34.2c1-20.6-15.5-37.9-36.2-37.9l-10.4 0C84.7 64 64 84.7 64 110.1L64 352c0 53 43 96 96 96l0-32zM416 256c-29.3 0-55.9-12.2-74.8-31.7c-9-9.3-16.2-20.2-21.3-32.3c-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-15.7 37.6-52.8 64-96 64zM384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48l-64 0zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMonkey = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bM);
var SM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "moon-cloud", f = 640, c = 512, e = [], t = "f754", o = "M479.5 32c-118.2 0-214.9 92-223 208.3C310 244.7 352 289.4 352 344c0 27.9-11 53.3-29 72c40.3 39.6 95.5 64 156.4 64c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.2-.5-12.6-.8-19-.8zM64 416l184 0c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C208.8 246.5 179 224 144 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoonCloud = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(SM);
var yM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "moon-stars", f = 512, c = 512, e = [], t = "f755", o = "M284.8 99.2l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11zm119 211.6c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM191.8 128C85.8 128 0 214.1 0 320.2S85.8 512.4 191.8 512.4c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.2-25.1 2.2c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-5.4-.5-10.8-.7-16.3-.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoonStars = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yM);
var OM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "moped", f = 640, c = 512, e = [], t = "e3b9", o = "M328 56c0-13.3 10.7-24 24-24l41.3 0c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4l8.4 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-8.4 0c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8c9.5 9.3 9.6 24.5 .3 33.9s-24.5 9.6-33.9 .3C570.2 284.2 542.6 272 512 272c-55.1 0-101 39.8-110.3 92.3c-2 11.5-12 19.8-23.6 19.8l-42.1 0c-.9 0-1.7 0-2.6-.1L256 384c0 53-43 96-96 96s-96-43-96-96l-32 0c-17.7 0-32-14.3-32-32l0-32c0-70.7 57.3-128 128-128l96 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l77.3 0c16.8-38.5 48.4-69.2 87.6-84.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4L352 80c-13.3 0-24-10.7-24-24zM128 96l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32 336c26.5 0 48-21.5 48-48l-96 0c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMoped = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(OM);
var kM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mountains", f = 640, c = 512, e = [9968], t = "f6fd", o = "M381.1 480L55.9 480C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79C465 164.1 472.2 160 480 160s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1l-122.8 0-75 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMountains = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kM);
var AM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = W1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMouseAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(AM);
var jM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mouse-field", f = 512, c = 512, e = [], t = "e5a8", o = "M396.4 112.9C398.8 105 400 96.6 400 88c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.9 14.9 56.3 37.6 72.2C169.5 164.3 96 240.4 96 333.6c0 12.3 2.7 24 7.5 34.4L72 368c-39.8 0-72 32.2-72 72s32.2 72 72 72l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 464c-13.3 0-24-10.7-24-24s10.7-24 24-24l106.4 0 53.6 0 8 0 19 0 123.6 0c18.5 0 33.4-15 33.4-33.4c0-14.1-8.8-26.6-22-31.4l-43.7-15.9 23.8-63.5c2 .1 4 .2 6 .2l102.8 0c16.1 0 29.1-13 29.1-29.1c0-41.5-19.3-78.4-49.4-102.4C473.5 125.8 480 107.7 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 13.9-2.5 27.2-7.2 39.5c-9.1-3.2-18.6-5.5-28.4-6.6zM400 196a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM312 48c22.1 0 40 17.9 40 40l0 24c0 8.8-7.2 16-16 16l-24 0c-22.1 0-40-17.9-40-40s17.9-40 40-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMouseField = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jM);
var BM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mp3-player", f = 384, c = 512, e = [], t = "f8ce", o = "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM96 64C78.3 64 64 78.3 64 96l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMp3Player = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(BM);
var TM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mug", f = 576, c = 512, e = [], t = "f874", o = "M64 64C46.3 64 32 78.3 32 96l0 256c0 53 43 96 96 96l192 0c53 0 96-43 96-96l0-32 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-64 0L64 64zm352 64l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMug = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(TM);
var FM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mug-marshmallows", f = 512, c = 512, e = [], t = "f7b7", o = "M192 32c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3c0 5.5 .9 10.9 2.6 16L32 128l0-64c0-17.7 14.3-32 32-32l128 0zm5.7 93.7C194 122 192 117.1 192 112s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128l-144 0-2.3-2.3zM0 192c0-17.7 14.3-32 32-32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 192 0 48 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-16 0c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 192zm384 32l0 96 16 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMugMarshmallows = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(FM);
var HM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mug-tea", f = 576, c = 512, e = [], t = "f875", o = "M144 64l0 50.7c0 8.5-3.4 16.6-9.4 22.6l-29.3 29.3c-6 6-9.4 14.1-9.4 22.6L96 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-66.7c0-8.5-3.4-16.6-9.4-22.6l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6L176 64l208 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 32c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L32 96c0-17.7 14.3-32 32-32l80 0zM416 256l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMugTea = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(HM);
var RM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mug-tea-saucer", f = 640, c = 512, e = [], t = "e1f5", o = "M208 82.7L208 32l-80 0c-17.7 0-32 14.3-32 32l0 224c0 53 43 96 96 96l192 0c53 0 96-43 96-96l32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-64 0L240 32l0 50.7c0 8.5 3.4 16.6 9.4 22.6l29.3 29.3c6 6 9.4 14.1 9.4 22.6l0 66.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-66.7c0-8.5 3.4-16.6 9.4-22.6l29.3-29.3c6-6 9.4-14.1 9.4-22.6zM480 96l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0-128zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMugTeaSaucer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(RM);
var UM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mushroom", f = 512, c = 512, e = [127812], t = "e425", o = "M24 258.1C24 133.2 125.2 32 250.1 32l11.8 0C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9L313 320l-114 0L85.9 320C51.7 320 24 292.3 24 258.1zm387.5-96.7c-3.7-.9-7.5-1.4-11.5-1.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c15.9 0 30-7.7 38.7-19.6c-3.3-27.4-12.9-52.9-27.2-75zM145.9 113.6c8 35.7 39.9 62.4 78.1 62.4c44.2 0 80-35.8 80-80c0-3.8-.3-7.5-.8-11.2C290 81.7 276.1 80 261.9 80l-11.8 0c-38.9 0-74.9 12.5-104.2 33.6zM191 352l130 0L343 440.2c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3l-112 0c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L191 352zM160 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMushroom = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(UM);
var qM = {}, W4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "music-note", f = 384, c = 512, e = ["music-alt"], t = "f8cf", o = "M384 32c0-9.9-4.5-19.2-12.3-25.2S353.8-1.4 344.2 1l-128 32C202 36.5 192 49.3 192 64l0 64 0 231.7c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-279L359.8 127C374 123.5 384 110.7 384 96l0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMusicNote = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = W4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMusicAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(qM);
var GM = {}, E4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "music-note-slash", f = 640, c = 512, e = ["music-alt-slash"], t = "f8d0", o = "M512 32c0-9.9-4.5-19.2-12.3-25.2S481.8-1.4 472.2 1l-128 32C330 36.5 320 49.3 320 64l0 64 0 97.5L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L384 275.7 384 153 487.8 127C502 123.5 512 110.7 512 96l0-64zM272 352c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-20.8L317.8 359c-14-4.5-29.5-7-45.8-7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMusicNoteSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = E4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faMusicAltSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(GM);
var WM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "music-magnifying-glass", f = 640, c = 512, e = [], t = "e662", o = "M544 208c0 45.9-14.9 88.3-40 122.7L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L458.7 376c-30.8 22.5-68.1 36.8-108.5 39.6c1.1-4.9 1.8-10.1 1.8-15.5c0-1.4 0-2.8-.1-4.2c.1-1.3 .1-2.5 .1-3.8l0-208c0-18-8.7-34.9-23.3-45.4s-33.4-13.4-50.5-7.7L129.8 180.4C143.3 78.6 230.5 0 336 0C450.9 0 544 93.1 544 208zM320 184c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-192 64C86.6 228.5 80 237.7 80 248l0 48 0 121.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-150.7 144-48 0 88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6l0-160 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMusicMagnifyingGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(WM);
var EM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "music-slash", f = 640, c = 512, e = [], t = "f8d1", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-71.5-56C569.8 400.2 576 384.7 576 368l0-264 0-72c0-10.1-4.8-19.6-12.9-25.7s-18.6-7.9-28.3-5l-320 96c-12.7 3.8-21.6 14.9-22.7 27.9L38.8 5.1zM300.7 210.4L512 147l0 145.5c-10-2.9-20.8-4.6-32-4.6c-22.2 0-42.6 6.3-58.8 16.8L300.7 210.4zM192 247.3l0 109.3c-10-3-20.8-4.6-32-4.6c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-134.3-64-50.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMusicSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(EM);
var VM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "mustache", f = 640, c = 512, e = [], t = "e5bc", o = "M147.9 148.4C169.3 125.2 199.4 112 231 112c33 0 64.4 14.4 85.9 39.5l3.1 3.6 3.1-3.6C344.6 126.4 376 112 409 112c31.6 0 61.7 13.2 83.1 36.4l2 2.1c27.6 29.9 74.6 30.9 103.4 2.1L599 151c2.5-2.5 5.5-4.4 8.6-5.5c2.6-1 5.4-1.5 8.4-1.5c5.7 0 10.9 2 15 5.2c1.3 1.1 2.6 2.3 3.6 3.6c.4 .5 .7 1 1.1 1.4c.3 .4 .5 .8 .7 1.1c.3 .5 .6 .9 .8 1.4c1.8 3.3 2.7 7.1 2.7 11.2l0 39.4C640 313.8 553.8 400 447.4 400c-46.7 0-91.7-16.9-126.9-47.7l-.5-.4-.5 .4C284.4 383.1 239.3 400 192.6 400C86.2 400 0 313.8 0 207.4L0 168c0-4.2 1.1-8.1 2.9-11.5c.6-1 1.2-2.1 2-3c1.2-1.6 2.6-3 4.1-4.2c1.5-1.2 3.1-2.2 4.8-3c3.1-1.5 6.5-2.3 10.2-2.3c2.9 0 5.8 .5 8.4 1.5c3.1 1.2 6.1 3 8.6 5.5l1.6 1.6c28.8 28.8 75.8 27.9 103.4-2.1l2-2.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faMustache = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(VM);
var IM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "narwhal", f = 640, c = 512, e = [], t = "f6fe", o = "M639.3 20.7c2.4-7.8-1.4-16.1-8.9-19.4s-16.2-.4-20.2 6.6L516.7 168.3c-16.9-5.4-34.9-8.3-53.6-8.3c-50.9 0-100.7 17.5-140.2 49.6L154.1 346.8c-10.5 8.5-26.1 1.1-26.1-12.4l0-81.3 29.9-20.9c21.4-15 34.1-39.4 34.1-65.5l0-54.7c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112l0 54.7c0 26.1 12.7 50.6 34.1 65.5L64 253.1 64 352c0 88.4 71.6 160 160 160l240 0c97.2 0 176-78.8 176-176c0-51.4-22.3-97.7-57.8-129.9l57-185.4zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNarwhal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(IM);
var KM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nesting-dolls", f = 640, c = 512, e = [], t = "e3ba", o = "M192 0c61.9 0 112 50.1 112 112l0 112L80 224l0-112C80 50.1 130.1 0 192 0zm-8.7 64.9c-11.7 15.1-28.7 26-48.2 29.7c-4 .8-7.2 4.2-6.8 8.2c1.5 14 7.6 27.7 18.4 38.5c25 25 65.5 25 90.5 0c10.8-10.8 16.9-24.4 18.4-38.5c.4-4.1-2.7-7.5-6.8-8.2c-19.5-3.7-36.5-14.6-48.2-29.7c-4.1-5.3-13.2-5.3-17.3 0zM635.5 474.1c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13l-304 0c-9 0-17.2-5-21.3-13c-4.1-8-3.4-17.6 1.8-24.9c0 0 0 0 0 0l.2-.3c.2-.3 .6-.8 1-1.5c.9-1.4 2.3-3.5 4-6.3c3.4-5.6 7.9-13.8 12.5-23.8c9.2-20.3 17.8-46.8 17.8-74.1l0-8c0-75.1 60.9-136 136-136s136 60.9 136 136l0 8c0 27.3 8.6 53.7 17.8 74.1c4.6 10 9.1 18.2 12.5 23.8c1.7 2.8 3.1 5 4 6.3c.5 .7 .8 1.2 1 1.5l.2 .3s0 0 0 0s0 0 0 0zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6c1.7 17.9 9.4 35.3 23.1 49c31.2 31.2 81.9 31.2 113.1 0c13.7-13.7 21.4-31.1 23.1-49c.4-4.3-3.3-7.6-7.6-7.6c-25.8 0-48.7-12.2-63.3-31.1c-4.1-5.3-13.2-5.3-17.3 0zM296 360l0 8c0 21-6.8 42.7-15 60.8c-4 8.7-7.9 15.8-10.8 20.6c-1.4 2.4-2.6 4.1-3.2 5.2c-.3 .5-.6 .9-.7 1c0 0 0 0 0 0c0 0 0 0 0 .1c0 0 0 0 0 0s0 0 0 0c-11.7 16.6-13.5 38.1-4.9 56.3L74.5 512c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4c2.7-5.3 8.1-8.6 14-8.6l280.2 0C309.5 284.6 296 320.7 296 360z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNestingDolls = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(KM);
var XM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nfc", f = 448, c = 512, e = [], t = "e1f7", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 48l0 224c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-80 0c-26.5 0-48 21.5-48 48l0 66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-66.7c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-26.5 0-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNfc = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(XM);
var QM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nfc-lock", f = 576, c = 512, e = [], t = "e1f8", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 65.1c-24.9 3.6-47.2 15.3-64 32.5l0-49.6c0-26.5-21.5-48-48-48l-80 0c-26.5 0-48 21.5-48 48l0 66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-66.7c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16l0 128 0 24.6c-19.1 11.1-32 31.7-32 55.4l0 32-208 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l208 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNfcLock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(QM);
var JM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nfc-magnifying-glass", f = 640, c = 512, e = [], t = "e1f9", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 64c-22.8 0-44.4 4.8-64 13.3l0-29.3c0-26.5-21.5-48-48-48l-80 0c-26.5 0-48 21.5-48 48l0 66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-66.7c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16l0 48c-38.9 29.2-64 75.7-64 128c0 22.8 4.8 44.4 13.3 64L112 384c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l208 0c21.6 28.8 52.7 50 88.6 59.1c-7.6 3.2-15.9 4.9-24.6 4.9L64 480c-35.3 0-64-28.7-64-64L0 96zM448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNfcMagnifyingGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(JM);
var YM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nfc-pen", f = 576, c = 512, e = [], t = "e1fa", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 139.6-64 64L384 144c0-26.5-21.5-48-48-48l-80 0c-26.5 0-48 21.5-48 48l0 66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-66.7c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16l0 187.6L299.6 384 112 384c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l163.1 0c-1 2.6-1.9 5.3-2.6 8.1l-14 55.9L64 480c-35.3 0-64-28.7-64-64L0 96zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNfcPen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(YM);
var ZM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nfc-signal", f = 512, c = 512, e = [], t = "e1fb", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 131c-22.4 3.4-43.8 9.6-64 18.3L384 144c0-26.5-21.5-48-48-48l-80 0c-26.5 0-48 21.5-48 48l0 66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-66.7c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16l0 117.7c-47.2 28.4-84.8 71.2-106.7 122.3L112 384c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l121.9 0c-5.8 20.4-9.2 41.9-9.8 64L64 480c-35.3 0-64-28.7-64-64L0 96zM488 256c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-72c0 13.3-10.7 24-24 24c-48.6 0-88 39.4-88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136c13.3 0 24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNfcSignal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ZM);
var pM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nfc-slash", f = 640, c = 512, e = [], t = "e1fc", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68L544 96c0-35.3-28.7-64-64-64L160 32c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM173.5 110.7c8.7-9 21-14.7 34.5-14.7l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-3.3 0-6.4 1-8.9 2.7l-25.6-20.1zM302.1 211.5c.6-.3 1.3-.5 1.9-.7l0-66.7c0-26.5 21.5-48 48-48l80 0c26.5 0 48 21.5 48 48l0 206.9-32-25.1L448 144c0-8.8-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16l0 66.7c18.6 6.6 32 24.4 32 45.3c0 2.3-.2 4.6-.5 6.8l-65.5-51.3zM486.9 479.6L406.2 416 208 416c-26.5 0-48-21.5-48-48l0-145.9L96 171.6 96 416c0 35.3 28.7 64 64 64l320 0c2.3 0 4.6-.1 6.9-.4zM208 384l157.5 0L192 247.3 192 368c0 8.8 7.2 16 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNfcSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pM);
var xM = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nfc-trash", f = 640, c = 512, e = [], t = "e1fd", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5L400 192c-5.6 0-11 1-16 2.7l0-50.7c0-26.5-21.5-48-48-48l-80 0c-26.5 0-48 21.5-48 48l0 66.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-66.7c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16l0 96 0 128c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l224 0c16.4 0 30.9-8.2 39.6-20.8l6.1 84.8L64 480c-35.3 0-64-28.7-64-64L0 96zM449.7 200.8c2.7-5.4 8.2-8.8 14.3-8.8l96 0c6.1 0 11.6 3.4 14.3 8.8L585.9 224l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-128 0-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l38.1 0 11.6-23.2zM413.9 482.3L400 288l224 0L610.1 482.3C608.9 499 595 512 578.2 512l-132.4 0c-16.8 0-30.7-13-31.9-29.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNfcTrash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xM);
var iw = {}, V4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sushi", f = 576, c = 512, e = [127843, "nigiri"], t = "e48a", o = "M479.7 320l-73.8-24.5L506.3 125.6c24.8 26.7 42.1 60.7 48.5 98.8l12.5 75.2c4 23.8-18.8 43.2-41.7 35.6l-7-2.3L479.7 320s0 0 0 0zM393.5 66.1c32.9 4.8 63.2 18 88.7 37.5L374.8 285.2 323.1 268c-14.6-4.9-29.9-7-45.2-6.4L393.5 66.1zm-36-2.1L235.6 270.4 96.1 318.7 246.6 64l110.9 0zM21.3 224.4C36.6 132.2 116.1 64.6 209.5 64L49.4 334.8C27 341.5 5 322.3 8.9 298.9l12.4-74.4zM32 384l0-15c8.5 .7 17.5-.3 26.4-3.4l193-66.9c20-6.9 41.6-7.1 61.7-.4l205.5 68.2c8.6 2.9 17.2 3.8 25.5 3.1l0 14.3c0 35.3-28.7 64-64 64c-19.1 0-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7C132.3 439.6 115.1 448 96 448c-35.3 0-64-28.7-64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSushi = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = V4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faNigiri = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(iw);
var aw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "nose", f = 448, c = 512, e = [], t = "e5bd", o = "M324.2 231.9L421 338.3c17.4 19.1 27 44 27 69.9C448 465.5 401.5 512 344.1 512l-9.4 0c-32.3 0-63.6-11.3-88.4-32l-6.4-5.3c-20.7-17.2-46.7-26.7-73.6-26.7c-21.2 0-38.3 17.2-38.3 38.3l0 5.7c0 1.7 .1 3.4 .3 5.1c.8 7.1-4 14.9-11.2 14.9l-5.1 0C50.8 512 1.1 462.9 0 401.9C1 345.3 44.3 298 100.9 292.4l44.7-4.5c8.8-.9 15.2-8.7 14.3-17.5s-8.7-15.2-17.5-14.3l-44.7 4.5c-7.1 .7-14 1.9-20.7 3.6c-6.4 1.6-13-3-13-9.7L64 32C64 14.3 78.3 0 96 0l61.6 0c11.4 0 21.9 6 27.6 15.9l75.6 129.6c18.1 30.9 39.3 59.9 63.4 86.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNose = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aw);
var ew = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "note", f = 448, c = 512, e = [], t = "e1ff", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224-112 0c-26.5 0-48 21.5-48 48l0 112L64 480c-35.3 0-64-28.7-64-64L0 96zM402.7 352l45.3 0-32 32-64 64-32 32 0-45.3 0-66.7c0-8.8 7.2-16 16-16l66.7 0zM112 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNote = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ew);
var nw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "note-medical", f = 448, c = 512, e = [], t = "e200", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224-112 0c-26.5 0-48 21.5-48 48l0 112L64 480c-35.3 0-64-28.7-64-64L0 96zM402.7 352l45.3 0-32 32-64 64-32 32 0-45.3 0-66.7c0-8.8 7.2-16 16-16l66.7 0zM192 144l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNoteMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nw);
var fw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "notebook", f = 512, c = 512, e = [], t = "e201", o = "M64 48l0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 80-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 80-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56c0 26.5 21.5 48 48 48l80 0L192 0 112 0C85.5 0 64 21.5 64 48zM432 0L224 0l0 512 208 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNotebook = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fw);
var cw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "notes", f = 512, c = 512, e = [], t = "e202", o = "M160 32c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l179.2 0c4.3 0 8.6-.4 12.8-1.3l0-94.7c0-17.7 14.3-32 32-32l94.7 0c.9-4.2 1.3-8.5 1.3-12.8L480 96c0-35.3-28.7-64-64-64L160 32zM384 352l0 45.7 0 18.3 96-96-18.3 0L416 320l-32 0 0 32zM296 464l-160 0c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 376c0 75.1 60.9 136 136 136l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faNotes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cw);
var tw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "object-exclude", f = 512, c = 512, e = [], t = "e49c", o = "M0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 96 96 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-96-96 0c-35.3 0-64-28.7-64-64L0 64zM320 192l-128 0 0 128 128 0 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectExclude = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tw);
var ow = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "object-intersect", f = 512, c = 512, e = [], t = "e49d", o = "M288 64l0 96-64 0c-35.3 0-64 28.7-64 64l0 64-96 0L64 64l224 0zM64 352l96 0 0 96c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0-96c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64zM448 224l0 224-224 0 0-96 64 0c35.3 0 64-28.7 64-64l0-64 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectIntersect = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ow);
var lw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "object-subtract", f = 512, c = 512, e = [], t = "e49e", o = "M512 448c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-96-96 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 96 96 0c35.3 0 64 28.7 64 64l0 224zM288 288l0-224L64 64l0 224 224 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectSubtract = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lw);
var dw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "object-union", f = 512, c = 512, e = [], t = "e49f", o = "M64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l96 0 0 96c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-96 0 0-96c0-35.3-28.7-64-64-64L64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectUnion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dw);
var rw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "objects-align-bottom", f = 512, c = 512, e = [], t = "e3bb", o = "M24 512l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24zM64 336c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48l0 288zm224 0c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectsAlignBottom = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rw);
var sw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "objects-align-center-horizontal", f = 512, c = 512, e = [], t = "e3bc", o = "M256 0c-13.3 0-24 10.7-24 24l0 40L80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l152 0 0 64-88 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l88 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 88 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-88 0 0-64 152 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L280 64l0-40c0-13.3-10.7-24-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectsAlignCenterHorizontal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sw);
var hw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "objects-align-center-vertical", f = 512, c = 512, e = [], t = "e3bd", o = "M64 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 152 64 0 0-88c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 88 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 88c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-88-64 0 0 152c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-152-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L64 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectsAlignCenterVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hw);
var vw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "objects-align-left", f = 512, c = 512, e = [], t = "e3be", o = "M0 24L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24L48 24C48 10.7 37.3 0 24 0S0 10.7 0 24zM176 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L176 64zm0 224c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectsAlignLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vw);
var uw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "objects-align-right", f = 512, c = 512, e = [], t = "e3bf", o = "M512 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24s24 10.7 24 24zM336 64c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 224c-26.5 0-48-21.5-48-48l0-64C0 85.5 21.5 64 48 64l288 0zm0 224c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectsAlignRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uw);
var mw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "objects-align-top", f = 512, c = 512, e = [], t = "e3c0", o = "M24 0L488 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24S10.7 0 24 0zM64 176c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-288zm224 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectsAlignTop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mw);
var gw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "objects-column", f = 448, c = 512, e = [], t = "e3c1", o = "M48 32C21.5 32 0 53.5 0 80L0 240c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 32zM304 224c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-96 0zM0 400l0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM304 32c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faObjectsColumn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gw);
var Pw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "octagon", f = 512, c = 512, e = [128721], t = "f306", o = "M191.5 .1c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6C7.7 154.1 .1 172.4 .1 191.5l0 129c0 19.1 7.6 37.4 21.1 50.9L140.6 490.8c13.5 13.5 31.8 21.1 50.9 21.1l129 0c19.1 0 37.4-7.6 50.9-21.1L490.8 371.4c13.5-13.5 21.1-31.8 21.1-50.9l0-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2C357.9 7.7 339.6 .1 320.5 .1l-129 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOctagon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pw);
var Mw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "octagon-check", f = 512, c = 512, e = [], t = "e426", o = "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOctagonCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mw);
var ww = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "octagon-divide", f = 512, c = 512, e = [], t = "e203", o = "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOctagonDivide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ww);
var Nw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "octagon-exclamation", f = 512, c = 512, e = [], t = "e204", o = "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOctagonExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nw);
var I4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "octagon-plus", f = 512, c = 512, e = ["plus-octagon"], t = "f301", o = "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOctagonPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I4);
var $ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "octagon-xmark", f = 512, c = 512, e = ["times-octagon", "xmark-octagon"], t = "f2f0", o = "M140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOctagonXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($);
var zw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "octopus", f = 640, c = 512, e = [], t = "e688", o = "M207.8 359.6c-2.8 40.4-36.4 72.4-77.6 72.4c-36.7 0-68.3-25.6-76-61.5L47.5 339c-2.8-13-15.5-21.2-28.5-18.4S-2.2 336.1 .5 349l6.8 31.6c12.4 58 63.6 99.4 122.9 99.4c0 0 .1 0 .1 0l4.1 0c42.4 0 83.8-12.5 119-36l21.4-14.2c13.4-8.9 29.2-13.7 45.3-13.7s31.9 4.8 45.3 13.7L386.7 444c35.2 23.5 76.6 36 119 36l4.1 0c59.3 0 110.5-41.4 123-99.4l6.8-31.6c2.8-13-5.5-25.7-18.4-28.5s-25.7 5.5-28.5 18.4l-6.8 31.6c-7.7 35.8-39.4 61.5-76 61.5c-41.1 0-74.8-31.9-77.6-72.4c11.3 7.3 24.5 11.9 38.9 13c38.8 2.8 74.3-21.9 85.3-59.2l10.9-36.9c6.4-21.6 26.2-36.5 48.8-36.5c13.3 0 24-10.7 24-24s-10.7-24-24-24c-43.8 0-82.5 28.9-94.8 71l-10.8 36.9c-4.6 15.7-19.5 26-35.8 24.8c-20.5-1.5-35.3-20.3-31.7-40.6l19-109.3c1.5-8.4 2.2-17 2.2-25.6l0-5.2C464 64.5 399.5 0 320 0S176 64.5 176 144l0 5.2c0 8.6 .7 17.1 2.2 25.6l19 109.3c3.5 20.3-11.2 39.1-31.7 40.6c-16.3 1.2-31.2-9.2-35.8-24.8L118.8 263c-12.4-42.1-51-71-94.8-71c-13.3 0-24 10.7-24 24s10.7 24 24 24c22.6 0 42.4 14.9 48.8 36.5l10.9 36.9c11 37.3 46.5 62 85.3 59.2c14.4-1 27.7-5.7 38.9-13zM240 272a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm144-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOctopus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zw);
var Lw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "oil-can-drip", f = 640, c = 512, e = [], t = "e205", o = "M352 96c0 17.7-14.3 32-32 32l-32 0 0 32 80.9 0c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7L144 416c-26.5 0-48-21.5-48-48l0-21.3-67.5-30C11.2 309 0 291.8 0 272.8L0 208c0-26.5 21.5-48 48-48l48 0 48 0 80 0 0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c17.7 0 32 14.3 32 32zM48 208l0 64.8 48 21.3L96 208l-48 0zM592 448c-26.5 0-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOilCanDrip = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lw);
var Cw = {}, K4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "oil-temperature", f = 576, c = 512, e = ["oil-temp"], t = "f614", o = "M256 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3L256 128l0-96zM400 304l0-1.2c21.9-3.2 43.7-12.6 61.5-24.9c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 357.7 417 368 384 368c-1.4 0-2.7 0-4-.1c12.6-18.1 20-40.2 20-63.9zM192 368c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7c0 0 0 0 0 0c17.8 12.3 39.6 21.7 61.4 24.9l0 1.2c0 23.8 7.4 45.8 20 63.9c-1.3 0-2.7 .1-4 .1zm192 80c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0C329 437.4 356.5 448 384 448z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOilTemperature = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = K4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faOilTemp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Cw);
var Dw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "olive", f = 448, c = 512, e = [], t = "e316", o = "M160 480C71.6 480 0 408.4 0 320C0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280zM287.1 192.9c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8s-69.6-40.1-87.8-21.9s-8.4 57.5 21.9 87.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOlive = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dw);
var $w = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "olive-branch", f = 640, c = 512, e = [], t = "e317", o = "M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L425.2 48c-34.2 0-67.9 7.5-98.8 22.1L191.9 133.4C189.1 219.3 118.6 288 32 288l-16 0c-8.8 0-16-7.2-16-16l0-16c0-61.4 34.5-114.6 85.2-141.5C40.4 102.8 11.3 75.8 2.7 66.9C.9 65 0 62.6 0 60s.9-5 2.7-6.9zM480 320c0 106-64.5 192-144 192s-144-86-144-192s64.5-192 144-192s144 86 144 192zM465.7 471.8c29.2-40.5 46.3-94 46.3-151.8c0-59.3-18-114.2-48.6-155c-10.5-14-22.7-26.5-36.2-36.9c48.2 1.6 101.3 25.8 144.2 70.3c75 77.8 90.2 188.1 33.9 246.4c-34.1 35.4-86.8 43.5-139.6 27z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOliveBranch = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($w);
var _w = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "omega", f = 448, c = 512, e = [], t = "f67a", o = "M224 96C135.6 96 64 167.6 64 256c0 56.4 29.1 106 73.3 134.5c13.3 8.6 22.7 23.7 22.7 41.2c0 26.7-21.6 48.3-48.3 48.3L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l35.2 0C25.8 375.4 0 318.7 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160l35.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-79.7 0c-26.7 0-48.3-21.6-48.3-48.3c0-17.5 9.4-32.6 22.7-41.2C354.9 362 384 312.4 384 256c0-88.4-71.6-160-160-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOmega = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_w);
var bw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "onion", f = 448, c = 512, e = [129477], t = "e427", o = "M216.8 17.7l-3.4-6.8C210.1 4.2 203.3 0 195.8 0c-10.9 0-19.6 9-21.3 19.8C167 67.8 132 96.2 95.3 126C49 163.7 0 203.5 0 288c0 80.4 58 135.2 131.9 160.3l-10.7 32.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2L178.6 460c7.1 1.2 14.2 2.1 21.4 2.7l0 25.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-25.3c7.2-.7 14.3-1.6 21.4-2.7l11.9 35.6c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-10.7-32.1C390 423.2 448 368.4 448 288c0-84.5-49-124.3-95.3-162C316 96.2 281 67.8 273.5 19.8C271.8 9 263.1 0 252.2 0c-7.5 0-14.3 4.2-17.7 10.9l-3.4 6.8c-2.9 5.9-11.4 5.9-14.3 0zM97 186.2l.4-.9c.4-.8 .8-1.5 1.2-2.2c2.5-3.8 6.6-6.4 11.3-6.9c1.9-.2 3.8-.1 5.6 .3s3.6 1.2 5.2 2.2c3.9 2.6 6.4 6.8 7 11.2c.3 1.9 .2 3.9-.3 5.9c-.3 1.3-.8 2.5-1.3 3.6l-.3 .7c-.3 .6-.8 1.6-1.4 2.9c-1.2 2.6-2.9 6.4-4.9 11.2c-4 9.6-9 23-13.3 38.2c-8.8 31.3-13.5 67.1-3.4 94c3.1 8.3-1.1 17.5-9.4 20.6s-17.5-1.1-20.6-9.4c-13.9-37-6.6-81.3 2.6-114c4.7-16.7 10.2-31.4 14.5-41.8c2.2-5.2 4-9.4 5.4-12.3c.7-1.5 1.2-2.6 1.6-3.4zM209 122.5c.3-.9 .8-1.8 1.3-2.7c1.2-2.1 2.9-3.8 4.8-5c3.4-2.3 7.8-3.3 12-2.5c1.9 .4 3.6 1 5.2 2c2 1.2 3.7 2.9 5 4.8s2.2 4.1 2.6 6.4c.3 1.8 .3 3.7-.1 5.5c-.2 1.1-.5 2.2-1 3.3c0 0 0 .1 0 .1l-.5 1.3c-.4 1.1-1.1 2.8-1.9 5c-1.6 4.4-4 10.9-6.6 18.9c-5.4 16.2-12.2 38.7-18.1 64c-11.9 51.7-18.9 111.9-4.4 155.3c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1c-17.5-52.5-8.5-120.3 3.6-172.7c6.1-26.6 13.3-50.1 18.9-67c2.8-8.4 5.2-15.2 7-19.9c.9-2.4 1.6-4.2 2.1-5.4l.6-1.5 .1-.1zM288 160c0-8.8 7.2-16 16-16l.2 0c.1 0 .2 0 .4 0c5.8-.2 11.6 2.7 14.6 8.2l-1 .6s0 0 0 0c1-.5 1-.5 1-.5s0 0 0 0s0 0 0 0l0 .1 .2 .3 .6 1.1c.5 .9 1.2 2.2 2.1 3.9c1.8 3.4 4.2 8.3 7.1 14.3c5.7 12.1 13.1 29.2 19.8 48.9c13.1 38.7 24.5 90.6 11.7 135.5c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c10-35.1 1.4-79.2-11.2-116.5c-6.2-18.3-13.1-34.2-18.4-45.6c-2.7-5.7-4.9-10.2-6.5-13.2l-.1-.1c-3.5-2.9-5.7-7.3-5.7-12.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOnion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bw);
var Sw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "option", f = 640, c = 512, e = [], t = "e318", o = "M448 448c-9.7 0-18.9-4.4-25-12L176.6 128 32 128C14.3 128 0 113.7 0 96S14.3 64 32 64l160 0c9.7 0 18.9 4.4 25 12L463.4 384 608 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0zm0-320c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOption = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sw);
var yw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ornament", f = 384, c = 512, e = [], t = "f7b8", o = "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32L128 96c-17.7 0-32 14.3-32 32l0 25.7C66.9 170.5 42.5 194.9 25.7 224l332.6 0c-16.9-29.1-41.2-53.5-70.3-70.3l0-25.7c0-17.7-14.3-32-32-32l-8.6 0zM0 320c0 22.4 3.8 44 10.9 64l362.2 0c7.1-20 10.9-41.6 10.9-64s-3.8-44-10.9-64L10.9 256C3.8 276 0 297.6 0 320zm25.7 96c33.2 57.4 95.2 96 166.3 96s133.1-38.6 166.3-96L25.7 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOrnament = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yw);
var Ow = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "outlet", f = 448, c = 512, e = [], t = "e01c", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm0 224c0-61.1 30.8-99.1 49.7-116.6c8.8-8.2 20.7-11.4 32.6-11.4l155.3 0c12 0 23.9 3.3 32.6 11.4C353.2 156.9 384 194.9 384 256s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4l-155.3 0c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm96-64c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-8.8-7.2-16-16-16zm-64 96c-13.3 0-24 10.7-24 24l0 16c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-16c0-13.3-10.7-24-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOutlet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ow);
var kw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "oven", f = 448, c = 512, e = [], t = "e01d", o = "M0 96l0 64 448 0 0-64c0-53-43-96-96-96L96 0C43 0 0 43 0 96zM56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zM176 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 200l0 192L64 448l0-192 320 0zM64 192L0 192l0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192 0-64-64 0L64 192zm48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOven = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kw);
var Aw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "overline", f = 448, c = 512, e = [], t = "f876", o = "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm192 96a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM336 304a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faOverline = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Aw);
var jw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "page", f = 384, c = 512, e = [], t = "e428", o = "M64 512H320c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jw);
var Bw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = za;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPageBreak = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Bw);
var Tw = {}, X4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "paintbrush-fine", f = 576, c = 512, e = ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], t = "f5a9", o = "M559.6 16.4c21.9 21.9 21.9 57.3 0 79.2L306.9 348.3l-79.2-79.2L480.4 16.4c21.9-21.9 57.3-21.9 79.2 0zM205.1 291.7l79.2 79.2-.1 .1c2.5 9.3 3.8 19 3.8 29c0 61.9-50.1 112-112 112L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l4.8 0c17.6 0 29.6-18.9 27.8-36.4c-.4-3.8-.6-7.7-.6-11.6c0-61.9 50.1-112 112-112c10 0 19.8 1.3 29 3.8l.1-.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPaintbrushFine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = X4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPaintBrushAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Tw);
var Fw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "paintbrush-pencil", f = 576, c = 512, e = [], t = "e206", o = "M559.6 95.6c21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0L227.7 269.1l79.2 79.2L559.6 95.6zM205 291.8c-9.3-2.5-19-3.8-29-3.8c-61.9 0-112 50.1-112 112c0 3.9 .2 7.8 .6 11.6C66.4 429.1 54.4 448 36.8 448L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-10-1.3-19.8-3.8-29l.1-.1-79.2-79.2-.1 .1zm93.4-138.7L164.7 19.3c-25-25-65.5-25-90.5 0L50.7 42.7c-25 25-25 65.5 0 90.5L173.5 256c.8 0 1.7 0 2.5 0c6.2 0 12.4 .4 18.4 1.2L298.5 153.1zM320 402.5l64.6 64.6c6.7 6.7 15.1 11.6 24.2 14.2l104 29.7c8.4 2.4 17.4 .1 23.6-6.1s8.5-15.2 6.1-23.6l-29.7-104c-2.6-9.2-7.5-17.5-14.2-24.2l-75.6-75.6L318.8 381.6c.8 6 1.2 12.2 1.2 18.4c0 .8 0 1.7 0 2.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPaintbrushPencil = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fw);
var Hw = {}, _ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pallet-boxes", f = 640, c = 512, e = [57863, "palette-boxes", "pallet-alt"], t = "f483", o = "M64 32C64 14.3 78.3 0 96 0L288 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32L64 32zM384 96c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128zM0 352c0-17.7 14.3-32 32-32l64 0 224 0 224 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 64 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-224 0L96 512l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-64-32 0c-17.7 0-32-14.3-32-32zm128 96l160 0 0-64-160 0 0 64zm224 0l160 0 0-64-160 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPalletBoxes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = _;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPaletteBoxes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Hw);
var Rw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = _;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPalletAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Rw);
var Uw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pallet-box", f = 640, c = 512, e = [], t = "e208", o = "M176 0l80 0 0 112c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 99.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1L384 0l80 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48zM0 352c0-17.7 14.3-32 32-32l64 0 224 0 224 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 64 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0-224 0L96 512l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-64-32 0c-17.7 0-32-14.3-32-32zm128 96l160 0 0-64-160 0 0 64zm224 0l160 0 0-64-160 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPalletBox = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uw);
var qw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pan-food", f = 640, c = 512, e = [129368], t = "e42b", o = "M320 512A256 256 0 1 0 320 0a256 256 0 1 0 0 512zm0-448c37.2 0 69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14l-131.4 0c-7.4 0-12.9-6.8-11.5-14l.6-3.2C250.7 90.3 282.8 64 320 64zM230.1 185.9c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM227.3 284.7c2.1 2.1 3.5 4.6 4.2 7.3c.4 1.7 .8 3.4 1.1 5.1c1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7l26.7 0c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56l0-26.7c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9c-1.7-.3-3.5-.7-5.1-1.1c-2.7-.7-5.2-2.1-7.3-4.2c-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zM455.8 184.2c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1C462 299.2 448.4 304 434.4 304l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4l79.6-79.6zM24 160c-13.3 0-24 10.7-24 24L0 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zm616 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPanFood = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qw);
var Gw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pan-frying", f = 576, c = 512, e = [127859], t = "e42c", o = "M448 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9C566.7 409.2 576 427.1 576 448c0 35.3-28.7 64-64 64c-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3C326.3 429.4 277.3 448 224 448C100.3 448 0 347.7 0 224S100.3 0 224 0S448 100.3 448 224zM319.9 154c-21.2-5.4-50.6-22.6-65.8-38.4c-24.5-25.5-65-26.3-90.5-1.8c-11.6 11.2-18.1 25.6-19.4 40.5c-2.2 24.7-9.2 56.2-21.5 77.6c-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3c9.4-16.3 33-30 51.6-32.6c10.2-1.4 20.3-5.4 29.2-12c28.4-21.1 34.3-61.1 13.3-89.5c-9.1-12.3-21.8-20.4-35.5-23.9zM528 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPanFrying = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gw);
var Ww = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pancakes", f = 512, c = 512, e = [129374], t = "e42d", o = "M256 192c0-17.7 14.3-31.9 32-32.6c108.6-4.4 192-31.1 192-63.4c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37C86.5 138.3 96 150.6 96 164.8L96 272c0 17.7 14.3 32 32 32s32-14.3 32-32l0-100.3c0-9.5 8.1-16.8 17.5-15.7c8.1 .9 14.5 7.6 14.5 15.7l0 52.3c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zM192 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM14.9 133C5.3 141.4 0 150.5 0 160c0 20.3 24.2 38.8 64 52.9l0-48.1c0-.1-.1-.2-.2-.4c-.4-.5-1.2-1.3-2.4-1.8c-14.7-5.9-28.7-13.4-39.6-22.9c-2.3-2-4.6-4.3-6.8-6.8zM286.1 239.5C413.3 234.8 512 201 512 160c0-9.5-5.3-18.6-14.9-27c-4 4.5-8.5 8.4-12.7 11.5c-13.4 10-30.9 17.8-49.8 24C396.6 181 345.5 189 289.3 191.3c-.5 0-.9 .2-1.2 .5c-.1 .1-.1 .2-.1 .2l0 32c0 5.3-.7 10.5-1.9 15.5zM7.2 221.1C2.5 227.2 0 233.5 0 240c0 21 25.8 40 68 54.3c-2.6-6.9-4-14.5-4-22.3l0-25.3c-21.5-6.8-41.1-15.2-56.8-25.6zM256 320c141.4 0 256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26c-47.8 14.9-111.2 24-180.2 24.8c-11.3 10-26.1 16.1-42.4 16.1c-11.8 0-22.9-3.2-32.4-8.8c-1.6 14.1-7.8 26.9-17 36.7c25.6 2.7 52.9 4.1 81.4 4.1zm256 0c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 342.8 329 352 256 352s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 307.2 0 313.5 0 320c0 44.2 114.6 80 256 80s256-35.8 256-80zm0 80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 422.8 329 432 256 432s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 387.2 0 393.5 0 400c0 44.2 114.6 80 256 80s256-35.8 256-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPancakes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ww);
var Ew = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "panel-ews", f = 512, c = 512, e = [], t = "e42e", o = "M64 0C28.7 0 0 28.7 0 64L0 288l16 0c44.2 0 80 35.8 80 80l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-26.5-21.5-48-48-48L0 320 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm48 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 128l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 128l64 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPanelEws = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ew);
var Vw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "panel-fire", f = 640, c = 512, e = [], t = "e42f", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 32.2c-12.6-1.2-25.5 2.7-35.5 11.7c-9.9 8.9-19.4 18.1-28.5 27.5l0-39.4c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l241.5 0c-4.4 6.2-8.5 12.5-12.3 18.7c-10.9 17.6-20.5 36.4-27.2 55.4c-3-1.4-6.4-2.1-9.9-2.1c-13.3 0-24 10.7-24 24s10.7 24 24 24l.2 0c-.1 2-.2 4.1-.2 6.1c0 49.3 18.6 95.2 49.6 129.9L64 480c-35.3 0-64-28.7-64-64L0 96zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM505.7 208.1L518 194.3c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 291.1 640 322 640 352c0 88.7-71.3 159.8-160 159.8c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 400c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327 416 363.5 416 400c0 35.3 28.7 64 64 64s64-28.7 64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPanelFire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vw);
var Iw = {}, b = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "paper-plane-top", f = 512, c = 512, e = ["paper-plane-alt", "send"], t = "e20a", o = "M57.6 35.8C23.1 20.6-11.3 57.4 6.1 90.9l63 121.2c4.4 8.4 12.6 14.1 22 15.3c0 0 0 0 0 0L266 249.3c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7L91.1 284.6s0 0 0 0c-9.4 1.2-17.6 6.9-22 15.3L6.1 421.1c-17.4 33.5 17 70.2 51.6 55.1L492.9 285.3c25.5-11.2 25.5-47.4 0-58.6L57.6 35.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPaperPlaneTop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = b;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPaperPlaneAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Iw);
var Kw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "paperclip-vertical", f = 384, c = 512, e = [], t = "e3c2", o = "M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128l0 192c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 208c0 61.9 50.1 112 112 112s112-50.1 112-112l0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 97.2-78.8 176-176 176s-176-78.8-176-176l0-208z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPaperclipVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kw);
var Q4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "paragraph-left", f = 384, c = 512, e = ["paragraph-rtl"], t = "f878", o = "M320 64c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 0 144 0C82.1 0 32 50.1 32 112s50.1 112 112 112l16 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 32 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224zM128 384l0-46.4c0-9.7-7.9-17.6-17.6-17.6c-4.2 0-8.2 1.5-11.3 4.2l-93 78.7C2.2 406.1 0 410.9 0 416s2.2 9.9 6.1 13.2l93 78.7c3.2 2.7 7.2 4.2 11.3 4.2c9.7 0 17.6-7.9 17.6-17.6l0-46.4 224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faParagraphLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q4);
var Xw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Q4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faParagraphRtl = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Xw);
var Qw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = c2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faParentheses = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Qw);
var Jw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = n2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faParenthesis = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Jw);
var Yw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = f1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faParkingCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Yw);
var Zw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Oi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faParkingCircleSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Zw);
var pw = {}, J4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-parking-slash", f = 640, c = 512, e = ["parking-slash"], t = "f617", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68L544 96c0-35.3-28.7-64-64-64L160 32c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM227 152.7c6-14.5 20.3-24.7 37-24.7l72 0c53 0 96 43 96 96c0 26.3-10.6 50.2-27.8 67.5l-51.4-40.3c9.1-5.6 15.2-15.7 15.2-27.2c0-17.7-14.3-32-32-32l-48 0 0 8.4-61-47.8zm259.9 327L288 322.9l0 29.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-15.5L96 171.6 96 416c0 35.3 28.7 64 64 64l320 0c2.3 0 4.6-.1 6.9-.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareParkingSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = J4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faParkingSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(pw);
var xw = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = l;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPartyBack = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(xw);
var iN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "party-bell", f = 512, c = 512, e = [], t = "e31a", o = "M0 224C0 100.3 100.3 0 224 0c35.3 0 68.9 8.2 98.7 22.8C341.9 32.3 352 51.7 352 70.7c0 14.5-5.7 28.3-16 38.5L109.2 336C99 346.3 85.1 352 70.7 352c-19 0-38.4-10.1-47.8-29.3C8.2 292.9 0 259.3 0 224zM480 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 480a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM359 167c9.4-9.4 24.6-9.4 33.9 0l8.3 8.3c16.7 16.7 38.6 27.2 62.1 29.8l27.4 3c13.2 1.5 22.7 13.3 21.2 26.5s-13.3 22.7-26.5 21.2l-27.4-3c-34.3-3.8-66.3-19.2-90.7-43.6L359 201c-9.4-9.4-9.4-24.6 0-33.9zM201 359l8.3 8.2c24.4 24.4 39.8 56.4 43.6 90.7l3 27.4c1.5 13.2-8 25-21.2 26.5s-25-8-26.5-21.2l-3-27.4c-2.6-23.5-13.1-45.4-29.8-62.1L167 393c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM503.5 506.3c-10.1 8.6-25.3 7.3-33.8-2.8l-8.5-10c-12.5-14.8-19.1-33.7-18.6-53c.5-16.6-12.4-30.6-29-31.6l-30-1.8c-42.5-2.5-75.3-38.3-74.2-80.8c.2-7.6-2.4-15-7.3-20.7l-8.5-10c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l8.5 10c12.5 14.8 19.1 33.7 18.6 53c-.5 16.6 12.4 30.6 29 31.6l30 1.8c42.5 2.5 75.3 38.3 74.2 80.8c-.2 7.6 2.4 15 7.3 20.7l8.5 10c8.6 10.1 7.3 25.3-2.8 33.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPartyBell = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iN);
var aN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "party-horn", f = 512, c = 512, e = [], t = "e31b", o = "M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7 .1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM150.6 201.4l160 160c7.7 7.7 10.9 18.8 8.6 29.4s-9.9 19.4-20 23.2l-39.7 14.9L83.1 252.5 98 212.8c3.8-10.2 12.6-17.7 23.2-20s21.7 1 29.4 8.6zM48.2 345.6l22.6-60.2L226.6 441.2l-60.2 22.6L48.2 345.6zM35.9 378.5l97.6 97.6L43.2 510c-11.7 4.4-25 1.5-33.9-7.3S-2.4 480.5 2 468.8l33.8-90.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPartyHorn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aN);
var eN = {}, Y4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "paw-simple", f = 448, c = 512, e = ["paw-alt"], t = "f701", o = "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm1.7 206c6.2-2.3 11.8-6.3 15-12.2l40-71.9c14.4-25.9 41.7-42 71.3-42s56.9 16.1 71.3 42l40 71.9c3.2 5.8 8.8 9.9 15 12.2c38.3 14 65.7 50.8 65.7 94c0 55.2-44.8 100-100 100c-21.2 0-40.8-6.6-56.9-17.8c-17.4-12-52.8-12-70.1 0C172.8 473.4 153.2 480 132 480C76.8 480 32 435.2 32 380c0-43.2 27.4-80 65.7-94zM304 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm48 160a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM48 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPawSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Y4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPawAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(eN);
var nN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "paw-claws", f = 512, c = 512, e = [], t = "f702", o = "M178.1 15.3C183 9.9 192 13.4 192 20.7l0 50.5c18.3 9.8 34.3 28.9 42.5 53.6c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5c-4-11.9-5.7-23.9-5.5-35.2c0 0 0 0 0 0c0-25.7 9.6-50.6 26.9-69.6l39.2-43.1zm132 206.3c-32.3-10.6-46.9-53.9-32.6-96.8c8.2-24.7 24.2-43.8 42.5-53.6l0-50.5c0-7.3 9-10.8 13.9-5.4l39.2 43.1c17.3 19 26.9 43.9 26.9 69.6c0 0 0 0 0 0c.2 11.3-1.5 23.2-5.5 35.1c-14.3 42.9-52.1 69.1-84.4 58.5zm-209.7 8.9c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3C3.7 267.8-.1 253.3 0 240c0 0 0 0 0 0l0-3.2c0-13.5 4.3-26.7 12.2-37.6l37.3-51.3c4.6-6.3 14.5-3 14.5 4.7l0 44.2c13.9 6.1 27.1 17.8 36.4 33.7zM69.2 433.2C121.6 291.9 214.7 256 256 256s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5l0 1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 512 64 491.1 64 465.3l0-1.6c0-10.4 1.6-20.7 5.2-30.5zM421.8 314.7c-24.5-14-29.1-51.7-10.2-84.1c9.3-15.9 22.4-27.6 36.4-33.7l0-44.2c0-7.7 9.9-11 14.5-4.7l37.3 51.3c8 10.9 12.2 24.1 12.2 37.6l0 3.2s0 0 0 0c.1 13.3-3.7 27.8-11.6 41.4c-18.9 32.4-54 47.3-78.5 33.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPawClaws = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nN);
var fN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "peach", f = 512, c = 512, e = [], t = "e20b", o = "M344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-11.4 0-22.6 1-33.5 2.8C120.5 67.2 112 46.6 112 24c0-13.3 10.7-24 24-24l24 0c53 0 96 43 96 96c0-53 43-96 96-96l24 0c13.3 0 24 10.7 24 24c0 22.6-8.5 43.2-22.5 58.8C366.6 81 355.4 80 344 80zM168 112c17.8 0 34.9 2.8 50.9 7.9c63 20 109.9 76.2 116.3 144.2c.8 8.8 7.9 16 16.8 16s16.1-7.2 15.4-16c-4.6-58.2-34.2-109.5-78-143c.8-.2 1.5-.5 2.3-.7c16.5-5.4 34-8.3 52.3-8.3c92.8 0 168 75.2 168 168c0 136.2-199.3 214.6-240.6 229.4c-5 1.8-10.1 2.6-15.4 2.6s-10.4-.8-15.4-2.6C199.3 494.6 0 416.2 0 280c0-92.8 75.2-168 168-168z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeach = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fN);
var cN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "peanut", f = 512, c = 512, e = [], t = "e430", o = "M432 0L364 0c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364l0 68c0 44.2 35.8 80 80 80l68 0c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148l0-68c0-44.2-35.8-80-80-80zM396.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM192 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeanut = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cN);
var tN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "peanuts", f = 640, c = 512, e = [129372], t = "e431", o = "M119.7 506.3c-33.1 14.7-71.8-.2-86.6-33.2L10.5 422.2C3.8 407.2 .4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6C14 314 22.7 300.5 33.4 289.3c5.8-6.1 12.3-11.7 19.5-16.6c16.7-11.8 32.5-25.8 39.8-44.9s5-40.1 .4-60c-2.1-8.4-3.2-17-3.4-25.4c-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9c10.7-11.2 23.6-20.6 38.7-27.3L212.6 5.7c33.1-14.7 71.8 .1 86.6 33.2l22.6 50.7c-3.6 10.8-6.5 22.2-8.8 31.5c0 0 0 0 0 0c-1.2 4.6-2.2 8.8-3.1 12.1c-4.2 14.8-8.7 24.6-16.3 32.2s-17.4 12.1-32.2 16.3c-3.4 1-7.5 2-12.1 3.1c-12.5 3.1-28.5 7.1-42 12.7c-21.3 8.8-41.2 21.9-58.4 39.1C114.3 271.1 96 315.4 96 364l0 68c0 27.8 10.2 53.3 27 72.9l-3.2 1.4zM492 0l68 0c44.2 0 80 35.8 80 80l0 68c0 40.6-16.4 77.4-42.9 104.2l-.9 .9c-14.1 14-30.3 24.6-47.6 31.7c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2c-.6 .6-1.1 1.1-1.7 1.7C353.1 495.8 316.5 512 276 512l-68 0c-44.2 0-80-35.8-80-80l0-68c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30C362.4 74 373 57.8 387.1 43.6l.4-.4c14.2-14.1 30.5-24.8 47.8-32C452.8 4 471.9 0 492 0zm52 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM339.2 416a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm0-64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeanuts = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tN);
var oN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "peapod", f = 512, c = 512, e = [], t = "e31c", o = "M464 0L416 0C186.2 0 0 186.2 0 416l0 48c0 26.5 21.5 48 48 48l48 0c229.8 0 416-186.2 416-416l0-48c0-26.5-21.5-48-48-48zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeapod = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oN);
var lN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pear", f = 512, c = 512, e = [], t = "e20c", o = "M505 7c9.4 9.4 9.4 24.6 0 33.9L457.9 88.1c14 20.5 22.1 45.3 22.1 71.9c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM320 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPear = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lN);
var dN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pedestal", f = 448, c = 512, e = [], t = "e20d", o = "M96 0C60.7 0 32 28.7 32 64l0 352 384 0 0-352c0-35.3-28.7-64-64-64L96 0zm24 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM304 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPedestal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dN);
var rN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pegasus", f = 576, c = 512, e = [], t = "f703", o = "M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L480 0 448 0C378.4 0 321.7 55.6 320 124.8L184.9 34.7c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1c0 48.1 3.8 99.9 26 139.8c9.2 16.6 21.7 31.3 38.2 42.7c-7.2-2.5-14-5.4-20.3-8.8c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43c-25.9 3.5-48.1 18.6-61.1 40C33.2 174.5 0 211.4 0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPegasus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rN);
var sN = {}, Z4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-clip-slash", f = 640, c = 512, e = ["pen-alt-slash"], t = "e20f", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l55-55 17-17-1-1-16-16-96-96-17-17L338.9 81c-28.1-28.1-73.7-28.1-101.8 0l-44.6 44.6L38.8 5.1zM230.5 155.4L271 114.9c9.4-9.4 24.6-9.4 33.9 0L318.1 128l-53.8 53.8-33.7-26.4zM341.2 364.8L195.8 250.3l-32.3 32.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7zM517.3 19.3c-25-25-65.5-25-90.5 0L374.6 71.4l17 17 96 96 16 16s0 0 0 0l1 1s0 0 0 0l52.1-52.1c25-25 25-65.5 0-90.5L517.3 19.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenClipSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Z4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPenAltSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(sN);
var hN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-circle", f = 512, c = 512, e = [], t = "e20e", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289L257.1 183.8l71 71L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenCircle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hN);
var vN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-fancy-slash", f = 640, c = 512, e = [], t = "e210", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L387.9 278.7l161-140.2c17.2-15 27.1-36.7 27.1-59.6c0-43.6-35.4-79-79-79c-22.8 0-44.6 9.9-59.6 27.1L287.1 199.7 38.8 5.1zM318 346.5L211 262.3l-60.1 13.9c-17.1 3.9-30.7 16.9-35.4 33.8L65.7 487.6l95.4-95.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1L88.4 510.3 266 460.5c16.9-4.7 29.9-18.3 33.8-35.4L318 346.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenFancySlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vN);
var uN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-field", f = 640, c = 512, e = [], t = "e211", o = "M601.9 16c-18.8-18.8-49.2-18.7-67.9 0L494.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L601.9 16zM328.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L560.8 167.5 471.7 78.4 328.5 221.8zM80 128c-44.2 0-80 35.8-80 80L0 432c0 44.2 35.8 80 80 80l416 0c44.2 0 80-35.8 80-80l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 128zm80 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenField = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uN);
var mN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-line", f = 576, c = 512, e = [], t = "e212", o = "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-48.4 48.4L314.3 67.7l48.4-48.4c25-25 65.5-25 90.5 0zM58.6 323.5L291.7 90.3 421.7 220.3 188.5 453.4c-10.4 10.4-23.3 18-37.4 22.2L30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L36.4 360.9c4.2-14.1 11.8-27 22.2-37.4zM248 464l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mN);
var gN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-nib-slash", f = 640, c = 512, e = [], t = "e4a1", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.3 327.6l28.3-94.4 2.8-9.2L352 94.6l-9.2 2.8L208.1 137.8 38.8 5.1zm29 440.7c-3.8 11.3-1 23.9 7.3 32.4L228.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-9.4 2.7-18.2 7.4-25.7l-85-67L67.8 445.8zM272 352c-7.4 0-14.4-1.7-20.7-4.7L97.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c3.6-1.2 7.1-2.8 10.5-4.6l-98.5-77.6c-8.7 9-20.9 14.6-34.4 14.6zM432.4 18.3L376.7 74.1 501.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L511.6 18.3c-21.9-21.9-57.3-21.9-79.2 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenNibSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gN);
var p4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-paintbrush", f = 576, c = 512, e = ["pencil-paintbrush"], t = "f618", o = "M95.6 16.4L226.3 147.1l-79.2 79.2L16.4 95.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0zM400 512c-53.6 0-98.5-37.7-109.4-88.1L423.9 290.6c50.3 11 88.1 55.8 88.1 109.4c0 3.9-.2 7.8-.6 11.6c-1.8 17.5 10.2 36.4 27.8 36.4l4.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144 0zM501.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L354.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM76.9 353.2L331.7 98.3 445.7 212.3 190.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenPaintbrush = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p4);
var PN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-slash", f = 640, c = 512, e = [], t = "e213", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296l75.7-75.7L355.7 90.3l-91.5 91.5L38.8 5.1zm78 324.1c-6.6 6.6-11.5 14.8-14.1 23.8L65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1l94.4-94.4L195.8 250.3l-79 79zM426.7 19.3L378.3 67.7 508.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(PN);
var MN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pen-swirl", f = 512, c = 512, e = [], t = "e214", o = "M347.8 17C319.3 6 288.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c17.7 0 32-14.3 32-32s-14.3-32-32-32C150 448 64 362 64 256S150 64 256 64c14.1 0 27.8 1.5 41 4.4L347.8 17zM310.6 349.4c-5.4 5.3-11.4 9.8-17.8 13.6c-1.7 2.7-3 5.7-3.8 9c-4.4 17.1 5.9 34.6 23 39c12.8 3.3 26.2 5 40 5c88.4 0 160-71.6 160-160c0-32.2-5.9-63-16.8-91.3l-51.4 51.4c2.7 12.9 4.2 26.2 4.2 39.9c0 53-43 96-96 96c-8.3 0-16.4-1.1-24-3c-5.9-1.5-11.9-1.3-17.4 .4zM473.9 16c-18.8-18.8-49.2-18.7-67.9 0L366.4 55.7l89.3 89.3 39.8-38.9c19.1-18.7 19.2-49.4 .4-68.2L473.9 16zM200.5 221.8c-7 7-12.3 15.6-15.4 25l-23.8 71.3c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l71.5-23.9c9.2-3.1 17.6-8.2 24.5-15L432.8 167.5 343.7 78.4 200.5 221.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPenSwirl = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(MN);
var wN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pencil-mechanical", f = 512, c = 512, e = [], t = "e5ca", o = "M475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L390.6 41.4l80 80 30.1-30.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3L475.3 11.3zm-233 76.3c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2C67 333 62.8 340.1 60.6 348L32.8 445.3 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7L164 451.4c7.8-2.2 15-6.4 20.8-12.2L436.7 187.3c7.2-7.2 11.3-17.1 11.3-27.3s-4.1-20.1-11.3-27.3L379.3 75.3C372.1 68.1 362.2 64 352 64s-20.1 4.1-27.3 11.3L317 83 287.6 53.7c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6zM89.1 422.9l17.3-60.5 43.2 43.2L89.1 422.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPencilMechanical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wN);
var NN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = p4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPencilPaintbrush = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(NN);
var zN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pencil-slash", f = 640, c = 512, e = [], t = "e215", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.6 295.8l42.1-42.1L474.3 231l11.3-11.3-33.9-33.9-62.1-62.1L355.7 89.8l-11.3 11.3-22.6 22.6-57.8 57.8L38.8 5.1zM306.2 214.7l50.5-50.5c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-47.8 47.8-25.4-19.9zM195.5 250l-72.9 72.9c-10.4 10.4-18 23.3-22.2 37.4L65 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2l88.3-88.3-77.9-61.4-27.6 27.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.9-24.9L195.5 250zM224 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9l-78.1 23 23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM426.7 18.7L412.3 33.2 389.7 55.8 378.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L517.3 18.7c-25-25-65.5-25-90.5 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPencilSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zN);
var LN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Sa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPennant = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(LN);
var CN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "people", f = 640, c = 512, e = [], t = "e216", o = "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1l17.8 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3l-11.6 0c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32zM528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeople = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(CN);
var DN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "people-dress", f = 640, c = 512, e = [], t = "e217", o = "M208 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM70.2 384L88 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L226.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1l17.8 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 16 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 17.8 0c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3l-11.6 0c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-53.6-89.2c-20.3-33.7-56.7-54.3-96-54.3l-11.6 0c-39.3 0-75.7 20.6-96 54.3L4.6 271.5c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L55 362.9C51.6 373.3 59.3 384 70.2 384zM528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeopleDress = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(DN);
var $N = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "people-dress-simple", f = 512, c = 512, e = [], t = "e218", o = "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 80c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4l-31.4 0zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 80c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.9-27.5-33-46.4-61.5-46.4l-31.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeopleDressSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($N);
var _N = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "people-pants", f = 640, c = 512, e = [], t = "e219", o = "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9c9.8-5.9 15.3-16.2 15.5-26.9c.2 10.7 5.7 21 15.5 26.9c15.1 9.1 34.8 4.2 43.9-10.9L408 256.9 408 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-223.1 28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-3 5-4.5 10.5-4.6 15.9c-.1-5.4-1.6-10.9-4.6-15.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6l-29.7 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeoplePants = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_N);
var bN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "people-pants-simple", f = 512, c = 512, e = [], t = "e21a", o = "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 464c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-115.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L320 464c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-115.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C482.7 191.9 448 160 406.4 160l-44.8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeoplePantsSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bN);
var SN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "people-simple", f = 512, c = 512, e = [], t = "e21b", o = "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm-22.4 32c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 464c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-115.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0zM384 128A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 80c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.9-27.5-33-46.4-61.5-46.4l-31.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeopleSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(SN);
var yN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pepper", f = 512, c = 512, e = [129745], t = "e432", o = "M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37l0 10.9c-5-1.8-10.1-3.1-15.3-4l-.9-.2c-8.8-1.5-17.9-1.7-27.1-.6c-4 .5-7.9 1.2-11.9 2.2c-51.4 12.9-74.7 65-61.9 116.4l37.1 148.3c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6L83.8 223c-11.8-47 .4-94.4 31.3-125.2c-13.6-2.8-28-2.6-42.4 1C21.3 111.7-10 163.9 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c7-1.7 13.6-4.2 19.8-7.3c5.6-2.8 12.3-2.8 17.9 0c3 1.5 6 2.8 9.2 4c10.7 4 22.2 6.2 34 6.2c11.6 0 22.9-2.1 33.5-6.1c3.2-1.2 6.4-2.6 9.4-4.1c5.6-2.8 12.3-2.8 17.9 0c6.2 3.1 12.8 5.6 19.8 7.3c51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.8-116.4c-23.2-5.8-46.5-2.6-66.3 7.3c-5.6 2.8-12.3 2.8-17.9 0c-6.2-3.1-12.8-5.6-19.8-7.3c-19-4.8-38.1-3.5-55.3 2.6l0-10.9c0-21.7-5.9-43.1-17.1-61.7L252.6 11.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPepper = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yN);
var ON = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "period", f = 192, c = 512, e = [], t = "2e", o = "M32 416a64 64 0 1 1 128 0A64 64 0 1 1 32 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPeriod = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ON);
var kN = {}, x4 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-carry-box", f = 384, c = 512, e = ["person-carry"], t = "f4cf", o = "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7l0-65.1 16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4l71.4 0 128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L224 96c-17.7 0-32 14.3-32 32l0 96-30.9 0-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6l0 88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0 0 0 0 0 0l0-69.5-64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonCarryBox = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x4);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = x4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPersonCarry = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(kN);
var AN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-dolly", f = 512, c = 512, e = [], t = "f4d0", o = "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7l0 65.1 51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3L98.1 399.4 18.7 320C6.7 308 0 291.7 0 274.7l0-88.1C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64 46.1 0-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L223.3 288l-70.7 0c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64L64 480s0 0 0 0c0 17.7-14.3 32-32 32s-32-14.3-32-32zm288-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm69.4-87.8c-17.1 4.3-34.5-6.1-38.8-23.3l-22.9-91.5c-4.3-17.1 6.1-34.5 23.3-38.8l91.5-22.9c17.1-4.3 34.5 6.1 38.8 23.3l22.9 91.5c4.3 17.1-6.1 34.5-23.3 38.8l-91.5 22.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonDolly = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(AN);
var jN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-dolly-empty", f = 512, c = 512, e = [], t = "f4d1", o = "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM96 306.7l0-65.1 16.6 24.9c8.9 13.4 23.9 21.4 39.9 21.4l70.7 0 27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1l6.5 26.2-46.1 0-42.6-64c-13.3-20-35.8-32-59.9-32C26.2 128 0 154.2 0 186.6l0 88.1c0 17 6.7 33.3 18.7 45.3l79.4 79.4 14.3 85.9c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-15.2-90.9c-1.6-9.9-6.3-19-13.4-26.1l-51-51zM0 346.5L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0 0 0 0 0 0l0-69.5-64-64zM272 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonDollyEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jN);
var BN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-dress-fairy", f = 640, c = 512, e = [], t = "e607", o = "M320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM304.3 160l31.5 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L384 384l0 80c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-80-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4c-21.5 12.1-38 32.3-45.2 57.3L172.9 334.4c-10.7 37.5 14.2 74.8 51.1 80.7l0 32.1C191.7 468 153.2 480 112 480l-16 0c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64C0 46.3 14.3 32 32 32zM528 480c-41.2 0-79.7-12-112-32.7l0-32.1c36.9-6 61.8-43.3 51.1-80.7L428 197.6c-7.1-24.9-23.7-45.1-45.2-57.3C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32l0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32l-16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonDressFairy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(BN);
var TN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-dress-simple", f = 256, c = 512, e = [], t = "e21c", o = "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM50.7 206.4c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L192 384l0 80c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-80-21.6 0c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonDressSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(TN);
var FN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-fairy", f = 640, c = 512, e = [], t = "e608", o = "M320 0a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM297.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L384 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4zM32 32c89.4 0 169.4 40.8 222.2 104.7c-37.4 15.7-64.6 51.2-68.2 94L181.9 280c-3 36.2 14.4 69 42.1 87.7l0 79.6C191.7 468 153.2 480 112 480l-16 0c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64C0 46.3 14.3 32 32 32zM528 480c-41.2 0-79.7-12-112-32.7l0-79.6c27.8-18.7 45.1-51.5 42.1-87.7L454 230.7c-3.6-42.7-30.8-78.2-68.2-94C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32l0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32l-16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonFairy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(FN);
var i3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-from-portal", f = 512, c = 512, e = ["portal-exit"], t = "e023", o = "M154.2 352c3.8-29.6 5.8-62.1 5.8-96c0-18.3-.6-36.1-1.7-53.4c12.4 8.3 29.4 7 40.4-4l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L334 299l30.9-82.4 5.1 12.3C385 264.7 419.9 288 458.7 288l21.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c0 0 0 0-.1 .1C141 63.1 112.8 0 80 0C35.8 0 0 114.6 0 256S35.8 512 80 512c25.3 0 47.8-37.5 62.5-96l55.1 0c19 0 36.2-11.2 43.9-28.5L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L187.2 352l-33 0zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonFromPortal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i3);
var HN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-pinball", f = 640, c = 512, e = [], t = "e21d", o = "M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM96 241.7l0 65.1 49.9 49.9c9 9 14.1 21.2 14.1 33.9l0 89.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L18.7 320C6.7 308 0 291.7 0 274.7l0-88.1C0 154.2 26.2 128 58.6 128c24.1 0 46.5 12 59.9 32l42.6 64 62.9 0c12.9 0 24.1 7.7 29.1 18.7l295-49.2L515.3 95c-2.2-6.5-3.3-13.4-3.3-20.2L512 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 146.2 0 37.8 0 8 0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-320 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192-39.4 0c-16 0-31-8-39.9-21.4L96 241.7zM0 480L0 346.5l64 64L64 480s0 0 0 0c0 17.7-14.3 32-32 32s-32-14.3-32-32zM280 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonPinball = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(HN);
var RN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-running-fast", f = 512, c = 512, e = [], t = "e5ff", o = "M368 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM259.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C198.4 108.3 228.2 96 259.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7l21.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-21.3 0c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L334 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L382.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM205.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5L128 416c-17.7 0-32-14.3-32-32s14.3-32 32-32l59.2 0 18.3-41.3zM16 95.8l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm16 48l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonRunningFast = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(RN);
var UN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-seat", f = 384, c = 512, e = [], t = "e21e", o = "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 160l0-32 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-66.7 0c-6.6-18.6-24.4-32-45.3-32c-26.5 0-48 21.5-48 48l0 80c0 35.3 28.7 64 64 64l85.6 0c8.1 0 14.9 6 15.9 14l10.7 86c2 16 15.6 28 31.8 28l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-19.8 0L325 358.1c-5-40-39-70.1-79.4-70.1L192 288zM64 160c0-17.7-14.3-32-32-32s-32 14.3-32 32L0 320c0 70.7 57.3 128 128 128l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-35.3 0-64-28.7-64-64l0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonSeat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(UN);
var qN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-seat-reclined", f = 512, c = 512, e = [], t = "e21f", o = "M176 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm89 160l-8-32 63 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-79.2 0c-6.6-19-24.5-32-44.9-32c-30.9 0-53.6 29.1-46.1 59l21.1 84.5C178 332 203.6 352 233 352l6.3 0c.5 0 .9 0 1.4 0l78.1 0c6.7 0 12.6 4.1 15 10.4L370 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9L265 288zM95.5 154.1c-3.3-17.4-20-28.8-37.3-25.6s-28.8 20-25.6 37.3L65.9 343.6C77.2 404.1 130.1 448 191.7 448l80.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80.3 0c-30.8 0-57.2-21.9-62.9-52.2L95.5 154.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonSeatReclined = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qN);
var GN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-sign", f = 512, c = 512, e = [], t = "f757", o = "M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7L328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7-15.4 42.4-28.8-10.8c-9.7-3.7-18.4-9.6-25.4-17.4L235 160.2c-18.2-20.5-44.3-32.2-71.8-32.2l-27.7 0c-36.4 0-69.6 20.5-85.9 53.1L3.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L80 263.6 80 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 20.2 0L192 407.6l0 72.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-72.4c0-9.9-2.3-19.7-6.8-28.6L216 312.4l0-77.3 .3 .3C230.1 251 247.5 263 267 270.3l29.3 11L289 301.5c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM192 48A48 48 0 1 0 96 48a48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonSign = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(GN);
var WN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-simple", f = 256, c = 512, e = [], t = "e220", o = "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L192 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(WN);
var a3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-ski-jumping", f = 512, c = 512, e = ["ski-jump"], t = "f7c7", o = "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32l144.5 0c46 0 65.7 58.4 29 86.2L230.1 260.8l-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6L179.5 380.6 433.7 249.1c18.6-9.6 30.3-28.8 30.3-49.7l0-7.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3C23.3 515.4 8.8 510.8 2.7 499s-1.5-26.3 10.3-32.3l111.2-57.5c-10.7-8.4-15.2-23-10.2-36.4l44-117.4c3.9-10.5 9.7-20.2 17-28.8L232.1 160 160 160c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonSkiJumping = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a3);
var e3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-ski-lift", f = 512, c = 512, e = ["ski-lift"], t = "f7c8", o = "M240 0c8.8 0 16 7.2 16 16l0 182.3-32 8.5L224 16c0-8.8 7.2-16 16-16zM64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80zm36.4 138c-14.2-30.8 8.3-66 42.2-66c18.2 0 34.8 10.7 42.3 27.3l28.8 63.4 55.9-14.9c25.4-6.8 50.3 12.4 50.3 38.6l0 122.1L443.1 343c12.6-4.6 20.9-16.6 20.9-30l0-1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L256 412.2l0-114.5-66.7 17.8c-22.6 6-46.2-5.1-55.9-26.3L100.4 218zM45.7 189.6l65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5l-36.5 9.9c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32s26.3-.7 32 11.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonSkiLift = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e3);
var n3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-sledding", f = 512, c = 512, e = ["sledding"], t = "f7cb", o = "M400 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM35.1 226.7c-11.8-6.1-26.3-1.5-32.4 10.2s-1.5 26.3 10.2 32.4L396.4 468.4c27.3 14.2 59.7 14.4 87.2 .7l15.2-7.6c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-15.2 7.6c-13.7 6.9-29.9 6.7-43.6-.3l-41.7-21.6c4.5-5.5 7.2-12.5 7.2-20.2l0-80c0-26.5-21.5-48-48-48l-34.7 0L361 196.3c25.2-25.2 7.4-68.3-28.3-68.3L160 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l84 0-59.2 40.3c-23.6 16.1-26 44.8-13.8 64.9L35.1 226.7zM320 320l0 54.6L214.7 320 320 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonSledding = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n3);
var f3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-snowmobiling", f = 640, c = 512, e = ["snowmobile"], t = "f7d1", o = "M240 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM373.5 85.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l37.4 74.7L360 192l-56 0-61.7-55.6c-11.8-10.6-27-16.4-42.8-16.4l-.9 0c-23.7 0-45.5 13.1-56.6 34.1l-35.3 66.6c-11.4 21.6-9.4 47.8 5.3 67.4l-12.2 0c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-2.5 5-3.6 10.2-3.4 15.2c4-.6 8.1-.9 12.3-.9l224 0c26.2 0 49.4 12.6 64 32l114 0 36 48-46 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l136 0c6.4 0 12.5-2.5 17-7l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33 33L546 464l-46-61.3 68.9-45.9c4.5-3 7.1-8 7.1-13.3l0-77.5c0-6.1-3.4-11.6-8.8-14.3L419.8 177.9 373.5 85.3zM298.5 256l13.5 0-24 32-24 0-72-32 32-48 29.3 29.3c12 12 28.3 18.7 45.3 18.7zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48l224 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonSnowmobiling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f3);
var EN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-to-door", f = 576, c = 512, e = [58704], t = "e433", o = "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C102.4 108.3 132.2 96 163.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c5 11.9 16.6 19.7 29.5 19.7l21.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-21.3 0c-38.8 0-73.7-23.3-88.6-59.1l-5.1-12.3L238 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L286.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM109.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5L32 416c-17.7 0-32-14.3-32-32s14.3-32 32-32l59.2 0 18.3-41.3zM384 48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-144s0 0 0 0c35.3 0 64-28.7 64-64s-28.7-64-64-64c0 0 0 0 0 0l0-144z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonToDoor = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(EN);
var c3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "person-to-portal", f = 512, c = 512, e = ["portal-enter"], t = "e022", o = "M272 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM163.2 160c-14.1 0-27.5 5.6-37.5 15.5l-23.1 23.1c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l23.1-23.1C102.4 108.3 132.2 96 163.2 96c11.7 0 23.3 1.7 34.4 5.2l48.7 15c36.4 11.2 65.9 38 80.5 73.1l6.3 15c3.6 8.7 10.9 15.2 19.6 18.1C357.8 96.9 391.4 0 432 0c44.2 0 80 114.6 80 256s-35.8 256-80 256c-40.9 0-74.6-98-79.4-224.5c-34.6-3.6-64.9-25.9-78.5-58.5l-5.1-12.3L238 299l56.7 35.4c18.1 11.3 26.6 33.3 20.7 53.9L286.8 488.8c-4.9 17-22.6 26.8-39.6 22s-26.8-22.6-22-39.6l25.4-88.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.2-93.7c-1.9-.2-3.7-.3-5.6-.3zM109.5 310.7c7.4 18.1 20.4 33.9 37.9 44.9l9.5 6-11.5 25.9c-7.7 17.3-24.9 28.5-43.9 28.5L32 416c-17.7 0-32-14.3-32-32s14.3-32 32-32l59.2 0 18.3-41.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPersonToPortal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c3);
var VN = {}, S = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-arrow-down-left", f = 512, c = 512, e = ["phone-arrow-down", "phone-incoming"], t = "e223", o = "M505 41l-135 135 46.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 46.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneArrowDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = S;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneArrowDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(VN);
var IN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-arrow-right", f = 512, c = 512, e = [], t = "e5be", o = "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L312 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l118.1 0L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneArrowRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(IN);
var KN = {}, y = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-arrow-up-right", f = 512, c = 512, e = ["phone-arrow-up", "phone-outgoing"], t = "e224", o = "M295 183l135-135L384 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L488 0c13.3 0 24 10.7 24 24l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneArrowUpRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = y;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneArrowUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(KN);
var XN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = c1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(XN);
var QN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = t1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneCircleAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(QN);
var JN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = o1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneCircleDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(JN);
var YN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-hangup", f = 640, c = 512, e = [], t = "e225", o = "M11.7 266.3l41.9 94.3c6.1 13.7 20.8 21.3 35.5 18.4l109.2-21.8c15-3 25.7-16.1 25.7-31.4V240c62.3-20.8 129.7-20.8 192 0v85.8c0 15.3 10.8 28.4 25.7 31.4L550.9 379c14.7 2.9 29.4-4.7 35.5-18.4l41.9-94.3c7.2-16.2 5.1-35.1-7.4-47.7C570.8 168.1 464.2 96 320 96S69.2 168.1 19.1 218.6c-12.5 12.6-14.6 31.5-7.4 47.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneHangup = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(YN);
var ZN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = S;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneIncoming = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ZN);
var pN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-intercom", f = 512, c = 512, e = [], t = "e434", o = "M48 32l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32zM160 96c0-35.3 28.7-64 64-64l224 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-320zM320 368a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-48c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM224 128l0 96c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L256 96c-17.7 0-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneIntercom = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pN);
var xN = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = N4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneLaptop = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(xN);
var iz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-missed", f = 640, c = 512, e = [], t = "e226", o = "M232 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-39 39 58.7 58.7C282.3 152.4 300.8 160 320 160s37.7-7.6 51.3-21.3L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L405.3 172.7C382.6 195.3 352 208 320 208s-62.6-12.7-85.3-35.3L176 113.9l-39 39c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2L96 24c0-13.3 10.7-24 24-24L232 0zM51.4 489.9l-35.4-62c-9.7-16.9-8.3-38.1 5.5-51.7C72.6 325.9 178.1 256 320 256s247.4 69.9 298.5 120.2c13.9 13.6 15.2 34.8 5.5 51.7l-35.4 62c-7.4 12.9-22.7 19.1-37 14.8L438.8 470.8c-13.5-4.1-22.8-16.5-22.8-30.6l0-56.2c-62.3-20.8-129.7-20.8-192 0l0 56.2c0 14.1-9.3 26.6-22.8 30.6L88.4 504.7c-14.3 4.3-29.6-1.8-37-14.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneMissed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iz);
var az = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-office", f = 576, c = 512, e = [], t = "f67d", o = "M128 0C110.3 0 96 14.3 96 32l0 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-352c0-17.7-14.3-32-32-32L128 0zM64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64L256 32l0 352c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64L64 32zm256 96c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32zm32 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM480 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneOffice = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(az);
var ez = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = y;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneOutgoing = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ez);
var nz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-plus", f = 576, c = 512, e = [], t = "f4d2", o = "M424 200l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24zM149.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L176 207.3c33.3 70.4 90.3 127.4 160.7 160.7L377 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C513.8 499.9 498 512 480 512C232.6 512 32 311.4 32 64c0-18 12.1-33.8 29.5-38.6l88-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhonePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nz);
var fz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-rotary", f = 512, c = 512, e = [9742], t = "f8d3", o = "M0 141.3c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1l0 34.7c0 17.7-14.3 32-32 32l-42.3 0c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16c-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208L32 208c-17.7 0-32-14.3-32-32l0-34.7zM32 432l0-31c0-11.1 2.9-22.1 8.4-31.8l101.1-177C153 172.3 174.2 160 197.1 160l117.7 0c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8l0 31c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48zM328 312a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneRotary = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fz);
var cz = {}, t3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-phone-hangup", f = 448, c = 512, e = ["phone-square-down"], t = "e27a", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM359.4 310c-5.3 8.6-16.8 12.3-26.7 8.5l-46.2-17.6c-8.7-3.3-14.1-11.6-13.1-20.3l2.9-26.7c-33.8-10.8-70.8-10.8-104.6 0l2.9 26.7c.9 8.7-4.4 16.9-13.1 20.3l-46.2 17.6c-9.9 3.8-21.4 .2-26.7-8.5L66.8 274.8C62 267 63.4 257.3 70.3 251c84.9-78.6 222.6-78.6 307.5 0c6.8 6.3 8.2 16.1 3.4 23.8L359.4 310z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquarePhoneHangup = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = t3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPhoneSquareDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(cz);
var tz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "phone-xmark", f = 576, c = 512, e = [], t = "e227", o = "M149.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L176 207.3c33.3 70.4 90.3 127.4 160.7 160.7L377 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C513.8 499.9 498 512 480 512C232.6 512 32 311.4 32 64c0-18 12.1-33.8 29.5-38.6l88-24zM367 15c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L367 49c-9.4-9.4-9.4-24.6 0-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhoneXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tz);
var oz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "photo-film-music", f = 640, c = 512, e = [], t = "e228", o = "M192 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-98.9 33-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9l64 0 0 64-112 0c-35.3 0-64-28.7-64-64l0-192zM319.5 404.6c-13.8 10.3-25.2 25.2-29.6 43.4L64 448c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l96 0 0 264c0 17.7 14.3 32 32 32l150.2 0c-8.2 3.3-15.8 7.5-22.6 12.6zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM56 168l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM56 360l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM630 164.5c6.3 4.5 10 11.8 10 19.5l0 48 0 160c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-88.2-144 48L448 464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5L400 296l0-48c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPhotoFilmMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oz);
var lz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pi", f = 448, c = 512, e = [], t = "f67e", o = "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l64 0 0 156c0 39.7-9.3 78.9-27 114.5l-1.6 3.2c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l1.6-3.2C148.4 382.7 160 333.7 160 284l0-156 128 0 0 238.6c0 45 36.5 81.4 81.4 81.4c30.8 0 59-17.4 72.8-45l2.3-4.7c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3l-2.3 4.7c-3 5.9-9 9.6-15.6 9.6c-9.6 0-17.4-7.8-17.4-17.4L352 128l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPi = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lz);
var dz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "piano", f = 512, c = 512, e = [], t = "f8d4", o = "M0 192L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-120.4c0-24.2-13.7-46.4-35.4-57.2l-58.4-29.2c-21-10.5-34.2-31.9-34.2-55.4C384 83.2 300.8 0 198.3 0L192 0C86 0 0 86 0 192zM416 352l32 0 0 96L64 448l0-96 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 32 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPiano = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dz);
var rz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "piano-keyboard", f = 576, c = 512, e = [127929], t = "f8d5", o = "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM512 224l0 160-80 0 0-68.3c9.6-5.5 16-15.9 16-27.7l0-64 64 0zM400 384l-96 0 0-68.3c9.6-5.5 16-15.9 16-27.7l0-64 64 0 0 64c0 11.8 6.4 22.2 16 27.7l0 68.3zm-128 0l-96 0 0-68.3c9.6-5.5 16-15.9 16-27.7l0-64 64 0 0 64c0 11.8 6.4 22.2 16 27.7l0 68.3zm-128 0l-80 0 0-160 64 0 0 64c0 11.8 6.4 22.2 16 27.7l0 68.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPianoKeyboard = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rz);
var sz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pickaxe", f = 512, c = 512, e = [], t = "e5bf", o = "M462.4 373.5s0 0 0 0l-.1-.2-.3-.8c-.3-.7-.7-1.8-1.3-3.3c-1.2-2.9-3-7.2-5.5-12.7c-5-11-12.6-26.7-23.1-45.3c-21-37.3-53.6-86-99.5-132s-94.7-78.5-132-99.5c-18.6-10.5-34.3-18.1-45.3-23.1c-5.5-2.5-9.8-4.3-12.7-5.5c-1.4-.6-2.5-1-3.3-1.3l-.8-.3-.2-.1s0 0 0 0s0 0 0 0c-6.2-2.3-10.4-8.2-10.5-14.8s3.9-12.6 10-15.1C169.5 7 204 0 240 0c59.6 0 114.7 19.2 159.5 51.6l9.4-9.8c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.8 9.4C492.8 157.3 512 212.4 512 272c0 36-7 70.5-19.8 102c-2.5 6.1-8.5 10.1-15.1 10s-12.5-4.3-14.8-10.5c0 0 0 0 0 0zM9.4 502.6C-3 490.3-3.1 470.4 8.9 457.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPickaxe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sz);
var hz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pickleball", f = 576, c = 512, e = [], t = "e435", o = "M250.4 28c37.5-37.4 98.4-37.4 136 0L499.9 141.3c29.2 29.2 35.7 72.4 19.4 107.8c-24.9-15.8-54.4-25-86.1-25c-72 0-133 47.3-153.3 112.5L155.7 212.8c-6.3-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L273 374.9c-.2 3-.3 6.1-.3 9.1c0 27.8 7.1 53.8 19.6 76.6c-9.3 .5-18.7-1-27.6-4.7l-56.7-23.2c-23.9-9.8-51.4-4.3-69.6 13.9L84.4 500.3c-15.6 15.6-41 15.6-56.7 0s-15.6-40.9 0-56.5l53.5-53.4c18.4-18.3 23.8-45.8 13.9-69.8L71.1 262.8c-10-23.9-4.5-51.4 13.9-69.7L250.4 28zM304 384a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm32-16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80 80a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0-64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-80-80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPickleball = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hz);
var vz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pie", f = 576, c = 512, e = [129383], t = "f705", o = "M525.8 225.1c3.1 7.8 8.8 14.4 16.3 18.2l16.2 8.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-29.6-14.8c-14.7-7.4-31.7-8.8-47.4-3.9l-41.6 12.8c-23.3 7.2-48.3 6.5-71.2-1.8l-30-10.9c-14.1-5.1-29.6-5.1-43.7 0l-30 10.9c-22.9 8.3-47.9 9-71.2 1.8l-41.6-12.8c-15.7-4.8-32.7-3.4-47.4 3.9L46.3 308.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l16.2-8.1c7.5-3.8 13.2-10.4 16.3-18.2C87.9 130.7 180.1 64 288 64s200.1 66.7 237.8 161.1zM199.2 129.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5c2.2 1.1 4.5 1.6 6.8 1.7l.7 0c5.7-.1 11.2-3.3 14-8.8l16-32c4-7.9 .7-17.5-7.2-21.5zm177.7 0c-7.9 4-11.1 13.6-7.2 21.5l16 32c2.7 5.5 8.2 8.7 14 8.8l.7 0c2.3 0 4.6-.6 6.8-1.7c7.9-4 11.1-13.6 7.2-21.5l-16-32c-4-7.9-13.6-11.1-21.5-7.2zM288 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm10.9 192.1l30 10.9c29.5 10.7 61.6 11.5 91.6 2.3l41.6-12.8c7.9-2.4 16.4-1.7 23.7 2l29.6 14.8c.4 .2 .9 .4 1.3 .6l-22.1 66.4c-8.7 26.1-33.2 43.8-60.7 43.8l-291.7 0c-27.5 0-52-17.6-60.7-43.8L59.3 337.9c.4-.2 .9-.4 1.3-.6l29.6-14.8c7.4-3.7 15.9-4.4 23.7-2l41.6 12.8c30 9.2 62.1 8.4 91.6-2.3l30-10.9c7.1-2.6 14.8-2.6 21.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPie = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vz);
var uz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pig", f = 640, c = 512, e = [128022], t = "f706", o = "M513.5 32c8 0 14.5 6.5 14.5 14.5L528 78c0 19.7-9 37.8-23.6 49.7c6.4 4.9 12.7 10.1 18.6 15.7c17.6-15.9 28.5-38.6 29-63.3l40 0c8.8 0 16 7.2 16 16l0 16c0 32.8-24.6 59.8-56.3 63.5l6.8 9C570 200 585 212.5 602.2 221.1L608 224l8 0c13.3 0 24 10.7 24 24l0 96c0 13.3-10.7 24-24 24l-43.5 0c-22.2 21.2-49.7 36.2-79.8 43.3l-13 45.5C475.8 470.5 463.3 480 449 480l-33 0c-17.7 0-32-14.3-32-32l0-32-64 0-48 0 0 32c0 17.7-14.3 32-32 32l-33 0c-14.3 0-26.8-9.5-30.8-23.2L155 382.4C110.3 358 80 310.5 80 256l0-16-32.6 0C21.2 240 0 218.8 0 192.6c0-21.8 14.8-40.7 35.9-46l8.2-2c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-8.2 2c-6.9 1.7-11.7 7.9-11.7 15c0 8.5 6.9 15.4 15.4 15.4l35.8 0C98 135 162.6 80 240 80l122.4 0c14.5 0 28.8 1.3 42.7 3.9c8.1-19.5 25.4-34.4 47-39.1l58.4-12.5c1-.2 2-.3 3-.3zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPig = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uz);
var mz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pinata", f = 512, c = 512, e = [], t = "e3c3", o = "M112 318.1l0-63.4 25.8 9.9c14.7 5.6 31.1 4.9 45.1-2.2L259.8 224l28.2 0 144 0c44.2 0 80 35.8 80 80l0 13.2-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7L112 318.1zm0 35.8l2.4 1.2c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l11.4-4.6 0 50.5-24 12-17.7-8.8c-9-4.5-19.6-4.5-28.6 0l-16.5 8.3-16.3-10.8c-2.6-1.8-5.7-2.7-8.9-2.7l-176 0c-3.2 0-6.2 .9-8.9 2.7l-16.3 10.8-16.5-8.3c-9-4.5-19.6-4.5-28.6 0L136 414.1l-24-12 0-48.2zm37.3-119.2L34.4 190.6C13.4 179.6 0 157.8 0 133.8L0 128C0 92.7 28.7 64 64 64l112 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 166.1-71.4 35.7c-6 3-13.1 3.4-19.3 .9zM112 437.9l9.7 4.8c9 4.5 19.6 4.5 28.6 0l17.7-8.8 16.5 8.3c10.3 5.1 22.5 4.4 32.1-2l7.4-4.9 0 44.8c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-42.1zm288-2.7l7.4 4.9c9.6 6.4 21.8 7.1 32.1 2l16.5-8.3 17.7 8.8c9 4.5 19.6 4.5 28.6 0l9.7-4.8 0 42.1c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-44.8zM200 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPinata = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mz);
var gz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pinball", f = 448, c = 512, e = [], t = "e229", o = "M352 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm22.1 254.4c14.9 4.8 30.7-1.8 37.9-15c7.4-13.5 4.2-30.8-8.4-40.6l-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPinball = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gz);
var Pz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pineapple", f = 512, c = 512, e = [], t = "e31f", o = "M431.5 12.1c-1.1-4.5-4.2-8.4-8.4-10.5s-9.1-2.2-13.4-.4C393.8 8.1 383 20.8 378.1 35.4L363.3 20.7c-6.2-6.2-16.4-6.2-22.6 0C325.3 36.1 317.1 56 316.2 76.2C297.3 68.2 276.9 64 256 64c-41 0-80.3 16.3-109.3 45.3L45.3 210.7C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3l37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3L402.7 365.3c29-29 45.3-68.3 45.3-109.3c0-20.9-4.2-41.3-12.2-60.2c20.2-.9 40.1-9.1 55.5-24.5c6.2-6.2 6.2-16.4 0-22.6l-14.7-14.7c14.6-4.9 27.3-15.8 34.1-31.6c1.8-4.3 1.7-9.2-.4-13.4s-5.9-7.3-10.5-8.4l-14.3-3.6C492.4 65 496 51.4 496 37.5l0-5.5c0-8.8-7.2-16-16-16l-5.5 0c-13.9 0-27.5 3.6-39.4 10.4l-3.6-14.3zM164.7 212.7c6.2-6.2 16.4-6.2 22.6 0L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6zm182.6 0L288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM164.7 395.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPineapple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pz);
var Mz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pipe", f = 64, c = 512, e = [], t = "7c", o = "M32 0C49.7 0 64 14.3 64 32l0 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPipe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mz);
var wz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pipe-circle-check", f = 640, c = 512, e = [], t = "e436", o = "M32 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32zm448 0c17.7 0 32 14.3 32 32l0 64.7c-5.3-.5-10.6-.7-16-.7c-16.6 0-32.7 2.3-48 6.6l0-70.6c0-17.7 14.3-32 32-32zM320 368c0 5.4 .2 10.7 .7 16L96 384l0-256 320 0 0 83.2c-57 29.1-96 88.4-96 156.8zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPipeCircleCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wz);
var Nz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pipe-collar", f = 512, c = 512, e = [], t = "e437", o = "M18.7 18.7c25-25 65.5-25 90.5 0L126 35.4C164.1 12.9 208.5 0 256 0s91.9 12.9 130 35.4l16.7-16.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L476.6 126c22.5 38.1 35.4 82.6 35.4 130s-12.9 91.9-35.4 130l16.7 16.7c25 25 25 65.5 0 90.5s-65.5 25-90.5 0L386 476.6C347.9 499.1 303.5 512 256 512s-91.9-12.9-130-35.4l-16.7 16.7c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5L35.4 386C12.9 347.9 0 303.5 0 256s12.9-91.9 35.4-130L18.7 109.3c-25-25-25-65.5 0-90.5zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM80 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPipeCollar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nz);
var zz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pipe-section", f = 640, c = 512, e = [], t = "e438", o = "M32 96C14.3 96 0 110.3 0 128L0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zm576 0c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zm-64 32L96 128l0 256 448 0 0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPipeSection = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zz);
var Lz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pipe-smoking", f = 640, c = 512, e = [], t = "e3c4", o = "M575.2 64c-32.1 0-62.1 16-79.9 42.7l-61.8 92.7c-3.9-4.8-8.6-9.1-14-12.7l-24-16c-4.7-3.2-9.7-5.6-14.9-7.4L442 71.2C471.7 26.7 521.7 0 575.2 0L608 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.8 0zM333.4 206.2c9.8-14.7 29.7-18.7 44.4-8.9l24 16c14.7 9.8 18.7 29.7 8.9 44.4L287.8 442.1C258.6 485.8 209.6 512 157.1 512C70.3 512 0 441.7 0 354.9L0 272c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 50.3 77.4-116.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPipeSmoking = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lz);
var Cz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pipe-valve", f = 512, c = 512, e = [], t = "e439", o = "M288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 12L128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128-16 128 16c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 76l0-12zm0 84.2l-32-4-32 4 0 43.8L96 192l0 256 320 0 0-256-128 0 0-43.8zM32 160c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zm480 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPipeValve = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cz);
var Dz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pizza", f = 576, c = 512, e = [127829], t = "f817", o = "M385.2 419c10.4-8.2 25.5-8.4 34.9 1s9.4 24.7-.8 33.1C375 489.9 318.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c62.1 0 119 22.1 163.3 58.8c10.2 8.5 10.1 23.8 .8 33.1s-24.5 9.2-34.9 1C349.7 64.8 304.8 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c48.8 0 93.7-16.8 129.2-45zm-16-49.9c6.2 6.2 6.3 16.5-.5 22.1c-69.1 57.7-172.2 54.1-237.1-10.8c-68.7-68.7-68.7-180.2 0-248.9C196.5 66.6 299.5 63 368.6 120.8c6.8 5.7 6.7 15.9 .5 22.1L267.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L369.1 369.1zM192 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM443.4 156.6c6.7-6.7 17.7-6.2 23 1.7c39.5 59 39.5 136.5 0 195.5c-5.2 7.8-16.3 8.3-23 1.7l-88.1-88.1c-6.2-6.2-6.2-16.4 0-22.6l24.2-24.2c3.6 2.2 7.9 3.5 12.5 3.5c13.3 0 24-10.7 24-24c0-4.6-1.3-8.9-3.5-12.5l30.9-30.9zM472 280a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm22.4 126.4c-8.9-8.9-9.4-23.1-2.3-33.5C514.8 339.6 528 299.3 528 256s-13.2-83.6-35.9-116.9c-7.1-10.4-6.6-24.6 2.3-33.5c9.9-9.9 26.2-9.4 34.3 2C558.5 149.5 576 200.7 576 256s-17.5 106.5-47.4 148.4c-8.1 11.4-24.4 11.9-34.3 2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPizza = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dz);
var $z = {}, o3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "plane-engines", f = 576, c = 512, e = [9992, "plane-alt"], t = "f3de", o = "M576 256c0-35-59.5-64-93.7-64l-116.6 0-37.2-65.1C342 123.1 352 110.7 352 96c0-17.7-14.3-32-32-32l-27.4 0L265.2 16.1C259.5 6.2 248.9 0 237.4 0L181.2 0c-10.6 0-18.3 10.2-15.4 20.4l49 171.6L112 192 68.8 134.4c-3-4-7.8-6.4-12.8-6.4l-42 0c-7.8 0-14 6.3-14 14c0 1.3 .2 2.6 .5 3.9l22.7 79.3C9.8 229 0 241.4 0 256s9.8 27 23.2 30.8L.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14l42 0c5 0 9.8-2.4 12.8-6.4L112 320l102.9 0-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1L292.6 448l27.4 0c17.7 0 32-14.3 32-32c0-14.7-10-27.1-23.5-30.9L365.7 320l116.6 0c34.2 0 93.7-28 93.7-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlaneEngines = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = o3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPlaneAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})($z);
var _z = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "plane-prop", f = 576, c = 512, e = [], t = "e22b", o = "M240 384l-8.3-66.4-110-11L113.8 370c-1 8-7.8 14-15.9 14l-35.8 0c-8.1 0-14.9-6-15.9-14L36 287.8c-1.3 .2-2.6 .2-4 .2c-17.7 0-32-14.3-32-32s14.3-32 32-32c1.3 0 2.7 .1 4 .2L46.2 142c1-8 7.8-14 15.9-14l35.8 0c8.1 0 14.9 6 15.9 14l7.9 63.4 110-11L240 128l-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l24 0 6.2-50c1-8 7.8-14 15.9-14l35.8 0c8.1 0 14.9 6 15.9 14L328 64l40 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-32 0 8 64 138.3 0c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64L344 320l-8 64 32 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-40 0-6.2 50c-1 8-7.8 14-15.9 14l-35.8 0c-8.1 0-14.9-6-15.9-14L248 448l-24 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlaneProp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_z);
var bz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "plane-tail", f = 512, c = 512, e = [], t = "e22c", o = "M61.5 308.8L.8 39C-3.7 19 11.5 0 32 0l76.9 0c17.3 0 33.9 7 46 19.5L384 256l104 0 24 0 0 24 0 24 0 160 0 24 0 24-24 0-220.3 0c-10.7 0-21.2-1.9-31.2-5.7L40.4 431.9C16.1 422.7 0 399.4 0 373.4c0-28.2 18.8-52.8 45.9-60.3l15.5-4.3zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlaneTail = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bz);
var Sz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "plane-up-slash", f = 640, c = 512, e = [], t = "e22e", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L482.4 352.8 554.9 377c10.4 3.5 21.1-4.3 21.1-15.2l0-56.7c0-10.7-5.3-20.7-14.2-26.6L384 160l0-66.3C384 59.5 356 0 320 0c-35 0-64 59.5-64 93.7l0 66.3-10.6 7.1L38.8 5.1zm122.5 218L78.2 278.5C69.3 284.4 64 294.4 64 305.1l0 56.7c0 10.9 10.7 18.6 21.1 15.2L256 320l0 80-57.6 43.2c-4 3-6.4 7.8-6.4 12.8l0 42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L320 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c7.8 0 14-6.3 14-14l0-42.7c0-2.8-.7-5.6-2.1-8L161.3 223.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlaneUpSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sz);
var yz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "planet-moon", f = 576, c = 512, e = [], t = "e01f", o = "M512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zM236.2 112.4c-4-.3-8.1-.4-12.2-.4c-76.2 0-141.1 48.4-165.6 116.2C53.3 242.3 64.7 256 79.7 256l28.4 0c12.7 0 24.9 5.1 33.9 14.1L185 313c4.5 4.5 7 10.6 7 17l0 22.1c0 9.2 3.9 17.6 10.2 23.4l1.9 1.8c9.3 8.6 19.9 18.4 19.9 30.8l0 23c0 13.8 11.2 25 25 25c9.2 0 17.7-5.1 22-13.2l41.3-76.6c5-9.3 7.6-19.8 7.6-30.3l0-15.9c0-17.7-14.3-32-32-32l-65.9 0c-9 0-17.7-3.6-24.1-10c-12.5-12.5-13.4-32.4-2.1-45.9l52.7-63.2c4.8-5.8 7.4-13 7.4-20.5l0-13.5c0-11.6-8.3-21.7-19.8-22.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlanetMoon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yz);
var Oz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "planet-ringed", f = 512, c = 512, e = [129680], t = "e020", o = "M456.1 31.1c0 0-.1 .5 0 1.2c.1-.9 0-1.3 0-1.2zM414.7 83.9c10.7-6.4 20.4-11.5 28.9-15.5c-4.1 8.5-9.2 18.2-15.5 28.9c-4.4 7.4-9.2 15.1-14.4 23.1c-6.8-7.9-14.1-15.2-22-22c8-5.2 15.7-10.1 23.1-14.4zM65.7 340.2C10.4 418.3-14 481.7 8.1 503.9c35.2 35.2 174.7-47.3 311.6-184.2S539.1 43.3 503.9 8.1C481.7-14 418.3 10.4 340.2 65.7C314.4 54.3 286 48 256 48C141.1 48 48 141.1 48 256c0 30 6.3 58.4 17.7 84.2zm32.6 51.5c6.8 7.9 14.1 15.2 22 22c-8 5.2-15.7 10.1-23.1 14.4c-10.7 6.4-20.4 11.5-28.9 15.5c4.1-8.5 9.2-18.2 15.5-28.9c4.4-7.4 9.2-15.1 14.4-23.1zM31.1 456.1c0 0 .4 .1 1.2 0c-.8-.1-1.2 0-1.2 0zM56 479.7c-.1 .9 0 1.3 0 1.2s.1-.5 0-1.2zM479.7 56c.8 .1 1.2 0 1.2 0s-.4-.1-1.2 0zM256 464c114.9 0 208-93.1 208-208c0-16.1-1.8-31.8-5.3-46.9c-31.8 42.6-71.4 88.2-116.4 133.2s-90.6 84.6-133.2 116.4c15.1 3.5 30.7 5.3 46.9 5.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlanetRinged = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Oz);
var kz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "plate-utensils", f = 640, c = 512, e = [58713], t = "e43b", o = "M40.7 16c4 .3 7.1 3.5 7.3 7.5L55.5 152l17.3 0L88.1 23.1c.5-4 3.9-7.1 7.9-7.1s7.5 3 7.9 7.1L119.1 152l17.3 0L144 23.5c.2-4 3.3-7.2 7.3-7.5s7.6 2.3 8.5 6.1l30.3 128.7c1.3 5.4 1.9 11 1.9 16.6c0 39.9-32.2 72.2-72 72.5l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232c-39.8-.3-72-32.6-72-72.5c0-5.6 .6-11.2 1.9-16.6L32.2 22.2c.9-3.9 4.5-6.5 8.5-6.1zm572.4 1c2-.7 4-1 6.1-1c11.5 0 20.9 9.3 20.9 20.9L640 216l0 104 0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152-48 0c-17.7 0-32-14.3-32-32l0-128C512 59.2 596.2 23.2 613.1 17zM221.2 143.6L204.9 74.3C241.8 47.7 287.1 32 336 32c60.3 0 115 23.8 155.3 62.5C484.3 113.3 480 135 480 160l0 26.2C454.1 132.8 399.3 96 336 96c-44.9 0-85.5 18.5-114.6 48.3l-.2-.8zM336 480c-76.2 0-143.5-38.1-184-96.2l0-116.9c8.5-2.8 16.6-6.7 24-11.4l0 .6c0 88.4 71.6 160 160 160c68.1 0 126.2-42.5 149.3-102.4c9.2 21 29.3 36.2 53.2 38.2C502.6 427.6 425.4 480 336 480zM208 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlateUtensils = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kz);
var Az = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "play-pause", f = 640, c = 512, e = [], t = "e22f", o = "M116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96l0 320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160zM448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlayPause = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Az);
var jz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = t4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPlusHexagon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(jz);
var Bz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "plus-large", f = 512, c = 512, e = [], t = "e59e", o = "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0 0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0 0-192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPlusLarge = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bz);
var Tz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = I4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPlusOctagon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Tz);
var Fz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "podium", f = 448, c = 512, e = [], t = "f680", o = "M182.4 72c8.3 14.3 23.8 24 41.6 24l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L224 0c-17.8 0-33.3 9.7-41.6 24L168 24c-48.6 0-88 39.4-88 88l0 32-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-296 0 0-32c0-22.1 17.9-40 40-40l14.4 0zM48 224L73.7 455.1c3.6 32.4 31 56.9 63.6 56.9l173.4 0c32.6 0 60-24.5 63.6-56.9L400 224 48 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPodium = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fz);
var Hz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "podium-star", f = 448, c = 512, e = [], t = "f758", o = "M168 72c-22.1 0-40 17.9-40 40l0 32 296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-32c0-48.6 39.4-88 88-88l14.4 0C190.7 9.7 206.2 0 224 0l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-17.8 0-33.3-9.7-41.6-24L168 72zM73.7 455.1L48 224l352 0L374.3 455.1c-3.6 32.4-31 56.9-63.6 56.9l-173.4 0c-32.6 0-60-24.5-63.6-56.9zM231.3 276.8c-2.9-6.4-11.7-6.4-14.5 0l-20.2 45.5c-1.2 2.6-3.6 4.4-6.3 4.8l-47.9 5.9c-6.8 .8-9.5 9.5-4.5 14.3l35.4 34c2 2 3 4.9 2.4 7.7l-9.4 49.1c-1.3 6.9 5.8 12.3 11.8 8.9l42.1-24.4c2.4-1.4 5.4-1.4 7.8 0L270 446.9c6 3.5 13.1-1.9 11.8-8.9L272.3 389c-.5-2.8 .4-5.8 2.4-7.7l35.4-34c5-4.8 2.3-13.5-4.5-14.3L257.8 327c-2.8-.3-5.2-2.1-6.3-4.8l-20.2-45.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPodiumStar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hz);
var Rz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "police-box", f = 384, c = 512, e = [], t = "e021", o = "M192 0c8.8 0 16 7.2 16 16l0 16 80 0c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32l0 368 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 96c0-17.7 14.3-32 32-32c0-17.7 14.3-32 32-32l80 0 0-16c0-8.8 7.2-16 16-16zM96 136l0 24 32 0 0-32-24 0c-4.4 0-8 3.6-8 8zm0 40l0 24c0 4.4 3.6 8 8 8l24 0 0-32-32 0zm72-48l-24 0 0 32 32 0 0-24c0-4.4-3.6-8-8-8zm-24 48l0 32 24 0c4.4 0 8-3.6 8-8l0-24-32 0zm72-48c-4.4 0-8 3.6-8 8l0 24 32 0 0-32-24 0zm24 48l-32 0 0 24c0 4.4 3.6 8 8 8l24 0 0-32zm16-48l0 32 32 0 0-24c0-4.4-3.6-8-8-8l-24 0zm32 48l-32 0 0 32 24 0c4.4 0 8-3.6 8-8l0-24zM96 256l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPoliceBox = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Rz);
var Uz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "poll-people", f = 640, c = 512, e = [], t = "f759", o = "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zm448 80l-96 0 0-32 96 0 0 32zM272 32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L272 32zM576 416l-224 0 0-32 224 0 0 32zM272 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-320 0zM64 128c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-32 0zm64 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPollPeople = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uz);
var qz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pompebled", f = 512, c = 512, e = [], t = "e43d", o = "M460.3 172c-46.2-33.2-117-14.1-165.1 44.3c-5.9 8.6-17.2 10.6-25.6 4.5s-10.3-17.6-4.4-26.2c36.9-66.9 29-141.3-17.7-173.5C188.6-20.6 103.1 1.5 56.9 70.4c-85.5 126.3-77.6 313.4 44.2 400.4c121.4 87 296.3 27.7 381.8-98.6c46.2-68.4 36.4-158.5-22.6-200.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPompebled = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qz);
var Gz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pool-8-ball", f = 512, c = 512, e = [], t = "e3c5", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm384-64a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zm-80-48c0 11.5-4 22-10.7 30.2C304.8 184.5 312 199.4 312 216c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48zm-48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPool8Ball = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gz);
var Wz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "popcorn", f = 448, c = 512, e = [127871], t = "f819", o = "M32.2 160c-.1-1.3-.2-2.7-.2-4c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.3-.1 2.7-.2 4l-87.6 0-208.4 0-87.6 0zm-4 32l69.6 0 30.3 257.9c1 8.8 9 15.1 17.8 14s15.1-9 14-17.8L130 192l78 0 0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256 78 0L288.1 446.1c-1 8.8 5.2 16.7 14 17.8s16.7-5.2 17.8-14L350.2 192l69.6 0c15.6 0 28.2 12.6 28.2 28.2c0 2.5-.3 5.1-1 7.5L377.8 476.8C372 497.6 353.1 512 331.5 512l-215 0c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPopcorn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wz);
var Ez = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "popsicle", f = 320, c = 512, e = [], t = "e43e", o = "M160 0C71.6 0 0 71.6 0 160L0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-176C320 71.6 248.4 0 160 0zm32 480l0-64-64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPopsicle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ez);
var Vz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = c3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPortalEnter = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Vz);
var Iz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = i3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPortalExit = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Iz);
var Kz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pot-food", f = 640, c = 512, e = [127858], t = "e43f", o = "M112 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24C64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c50.7 0 93.6 33.7 107.4 80l-214.7 0c13.8-46.3 56.6-80 107.4-80zM77.7 320L48 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l17.9 0c-.2-17.5 14-32 31.7-32l444.8 0c17.7 0 31.9 14.5 31.7 32l17.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.7 0c-20.6 64-66.1 116.7-124.7 147.2l-1.2 9.7c-2.5 20-19.5 35-39.7 35l-153.4 0c-20.2 0-37.2-15-39.7-35l-1.2-9.7C143.8 436.7 98.3 384 77.7 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPotFood = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kz);
var Xz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "potato", f = 512, c = 512, e = [129364], t = "e440", o = "M466.3 249.2C494.4 222.9 512 185.5 512 144C512 64.5 447.5 0 368 0c-39.8 0-75.9 16.2-102 42.3C238.6 69.8 205 95 170.9 113.6c-24.1 13.2-44 33.1-57.3 57.3C95 205 69.8 238.6 42.3 266C16.2 292.1 0 328.2 0 368c0 79.5 64.5 144 144 144c30.3 0 58.4-9.3 81.5-25.3c28.1-19.3 60.2-35.3 92.5-46.2c44.1-14.9 80.1-50.9 93.1-99.2c9.2-34.2 29.4-67.9 55.2-92.1zM384 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM136 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPotato = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xz);
var Qz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "prescription-bottle-pill", f = 576, c = 512, e = [], t = "e5c0", o = "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zm32 96l320 0 0 83.2c-57 29.1-96 88.4-96 156.8c0 54.5 24.8 103.3 63.8 135.6c-9.4 5.4-20.2 8.4-31.8 8.4L96 512c-35.3 0-64-28.7-64-64l0-32 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 384l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 288l0-64 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 192l0-64zM304.8 300.5c6.7-12.6 23.6-13.5 33.7-3.4L502.9 461.5c10.1 10.1 9.2 27-3.4 33.7C479.4 505.9 456.4 512 432 512c-79.5 0-144-64.5-144-144c0-24.4 6.1-47.4 16.8-67.5zm254.5 135c-6.7 12.6-23.6 13.5-33.7 3.4L361.1 274.5c-10.1-10.1-9.2-27 3.4-33.7C384.6 230.1 407.6 224 432 224c79.5 0 144 64.5 144 144c0 24.4-6.1 47.4-16.8 67.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPrescriptionBottlePill = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qz);
var Jz = {}, l3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "presentation-screen", f = 576, c = 512, e = ["presentation"], t = "f685", o = "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 224c0 35.3 28.7 64 64 64l160 0 0 34.7-70.6 70.6c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 445.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L320 386.7l0-34.7 160 0c35.3 0 64-28.7 64-64l0-224c17.7 0 32-14.3 32-32s-14.3-32-32-32L512 0 64 0 32 0zM96 64l384 0 0 224-192 0L96 288 96 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPresentationScreen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = l3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPresentation = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Jz);
var Yz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pretzel", f = 512, c = 512, e = [129384], t = "e441", o = "M138.6 32C62.1 32 0 94.1 0 170.6C0 253.3 40.9 326.5 103.7 371L71.3 417C58.6 435 62.9 460 81 472.7s43 8.4 55.7-9.7l40-56.8c21.8 6.4 44.9 9.8 68.7 9.8l10.6 0 10.6 0c23.9 0 46.9-3.4 68.7-9.8l40 56.8c12.7 18.1 37.7 22.4 55.7 9.7s22.4-37.7 9.7-55.7l-32.4-46C471.1 326.5 512 253.3 512 170.6C512 94.1 449.9 32 373.4 32L364 32c-42.6 0-81 18-108 46.8C229 50 190.6 32 148 32l-9.4 0zM216 180l0 7.4c0 15.5-4.8 30.7-13.7 43.4l-52.5 74.7C107.5 275.6 80 226.3 80 170.6c0-32.4 26.2-58.6 58.6-58.6l9.4 0c37.6 0 68 30.4 68 68zm40 113.5L285.2 335c-6.1 .7-12.3 1-18.6 1L256 336l-10.6 0c-6.3 0-12.5-.3-18.6-1L256 293.5zm53.7-62.6C300.8 218.2 296 203 296 187.4l0-7.4c0-37.6 30.4-68 68-68l9.4 0c32.4 0 58.6 26.2 58.6 58.6c0 55.7-27.5 105-69.7 134.9l-52.5-74.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPretzel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yz);
var d3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "print-magnifying-glass", f = 640, c = 512, e = ["print-search"], t = "f81a", o = "M192 0L418.7 0c17 0 33.3 6.7 45.3 18.7L493.3 48c12 12 18.7 28.3 18.7 45.3l0 66.7-64 0 0-66.7L418.7 64 192 64l0 96-64 0 0-96c0-35.3 28.7-64 64-64zM128 192l224 0c-38.9 29.2-64 75.7-64 128c0 11 1.1 21.7 3.2 32L192 352l0 16 0 16 0 64 160 0c26.7 20.1 60 32 96 32c17.5 0 34.4-2.8 50.2-8l6.3 6.3c-10.8 20.1-32 33.8-56.4 33.8l-256 0c-35.3 0-64-28.7-64-64l0-64-32 0c-17.7 0-32-14.3-32-32l0-96c0-35.3 28.7-64 64-64zM448 400.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPrintMagnifyingGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d3);
var Zz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = d3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPrintSearch = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Zz);
var pz = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "print-slash", f = 640, c = 512, e = [], t = "f686", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L522.2 384l21.8 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64l-234.8 0L192 125.2 192 64l226.7 0L448 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L464 18.7C452 6.7 435.7 0 418.7 0L192 0c-35.3 0-64 28.7-64 64l0 11L38.8 5.1zm459 483.1l-51-40.2L192 448l0-64 0-16 0-16 132.9 0L122.2 192.3C89.6 195.2 64 222.6 64 256l0 96c0 17.7 14.3 32 32 32l32 0 0 64c0 35.3 28.7 64 64 64l256 0c20.1 0 38.1-9.3 49.8-23.8zM496 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPrintSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pz);
var xz = {}, r3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-pro", f = 640, c = 512, e = ["pro"], t = "e235", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm40 128l56 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-80c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32 32 0zm80-56c0-13.3 10.7-24 24-24l56 0c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7L288 288l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-80zm48 56l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32zm200-80c48.6 0 88 39.4 88 88l0 16c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-16c0-48.6 39.4-88 88-88zm-40 88l0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16c0-22.1-17.9-40-40-40s-40 17.9-40 40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectanglePro = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = r3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPro = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(xz);
var iL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "projector", f = 640, c = 512, e = [], t = "f8d6", o = "M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM281 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L281 39zM585 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L495 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zm-9 119l-64 0c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32L64 192c-35.3 0-64 28.7-64 64L0 384c0 35.3 28.7 64 64 64l9.9 39.8C77.5 502 90.3 512 105 512l14 0c14.7 0 27.5-10 31-24.2L160 448l160 0c26.7 20.1 60 32 96 32c24.4 0 47.5-5.5 68.2-15.2l5.7 23c3.6 14.2 16.4 24.2 31 24.2l14 0c14.7 0 27.5-10 31-24.2L576 448c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64zM416 224a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faProjector = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iL);
var aL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pump", f = 640, c = 512, e = [], t = "e442", o = "M128 32c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 0c-17.7 0-32 14.3-32 32zM32 176c-17.7 0-32 14.3-32 32L0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-176c0-17.7-14.3-32-32-32zm128 48l-64 0 0 160 224 0 0-288L160 96l0 128zM431.9 106.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3l0 219.5c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3c10.5 7 22.9 10.7 35.5 10.7L576 512c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L467.4 96c-12.6 0-25 3.7-35.5 10.7zM448 208c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPump = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aL);
var eL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "pumpkin", f = 576, c = 512, e = [], t = "f707", o = "M234.6 103.9C251.5 98.8 269.4 96 288 96c22.8 0 44.7 4.2 64.8 11.7c-.6-2-.8-4.1-.8-6.3l0-66.1c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4l-1.2 0c-6.9 0-13.1 4.1-15.8 10.4l-40.9 93.5zm161.6 27.3c12.1 8.8 23.1 19.1 32.7 30.5c5.6 6.7-2.9 14.6-10.4 10.1C380.3 149 335.7 136 288 136s-92.3 13-130.5 35.7c-7.5 4.5-16-3.4-10.4-10.1c9.6-11.4 20.6-21.7 32.7-30.5c-.6-.1-1.2-.2-1.8-.3c-8.5-1.8-17.2-2.8-26-2.8C68.1 128 0 214 0 320S68.1 512 152 512c19.3 0 37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8s37.8-4.5 54.7-12.8c8.3-4.1 18.2-4.1 26.5 0c17 8.3 35.4 12.8 54.7 12.8c83.9 0 152-86 152-192s-68.1-192-152-192c-8.9 0-17.6 1-26 2.8c-.6 .1-1.2 .2-1.8 .3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPumpkin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eL);
var nL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "puzzle", f = 512, c = 512, e = [], t = "e443", o = "M320 0L448 0c35.3 0 64 28.7 64 64l0 128c0 8.8-7.2 16-16 16l-52 0c-6.6 0-12 5.4-12 12l0 4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-4c0-6.6-5.4-12-12-12l-36 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM0 256L0 128C0 92.7 28.7 64 64 64l128 0c8.8 0 16 7.2 16 16l0 36c0 6.6 5.4 12 12 12l4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-4 0c-6.6 0-12 5.4-12 12l0 52c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16zM0 448L0 320c0-8.8 7.2-16 16-16l176 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16L64 512c-35.3 0-64-28.7-64-64zM240 320c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 128c0 35.3-28.7 64-64 64l-128 0c-8.8 0-16-7.2-16-16l0-176z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPuzzle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nL);
var fL = {}, s3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "puzzle-piece-simple", f = 640, c = 512, e = ["puzzle-piece-alt"], t = "e231", o = "M264.8 64C277.6 64 288 74.4 288 87.2c0 9.2-5.8 17.3-13.2 22.8c-11.6 8.7-18.8 20.7-18.8 34c0 26.5 28.7 48 64 48s64-21.5 64-48c0-13.3-7.2-25.3-18.8-34c-7.4-5.5-13.2-13.6-13.2-22.8C352 74.4 362.4 64 375.2 64L464 64c26.5 0 48 21.5 48 48l0 88.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2l0 88.8c0 26.5-21.5 48-48 48l-88.8 0c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2L176 448c-26.5 0-48-21.5-48-48l0-88.8c0-12.8-10.4-23.2-23.2-23.2c-9.2 0-17.3 5.8-22.8 13.2C73.3 312.8 61.3 320 48 320c-26.5 0-48-28.7-48-64s21.5-64 48-64c13.3 0 25.3 7.2 34 18.8c5.5 7.4 13.6 13.2 22.8 13.2c12.8 0 23.2-10.4 23.2-23.2l0-88.8c0-26.5 21.5-48 48-48l88.8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faPuzzlePieceSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = s3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faPuzzlePieceAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(fL);
var cL = {}, h3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-question", f = 448, c = 512, e = ["question-square"], t = "f2fd", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm73.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = h3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faQuestionSquare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(cL);
var tL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "quotes", f = 576, c = 512, e = [], t = "e234", o = "M88 0C39.4 0 0 39.4 0 88l0 56 0 24 0 24c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48L64 96l0-8c0-13.3 10.7-24 24-24l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L88 0zM264 0c-48.6 0-88 39.4-88 88l0 56 0 24 0 24c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-32 0 0-8c0-13.3 10.7-24 24-24l8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0zM576 424l0-56 0-24 0-24c0-26.5-21.5-48-48-48l-48 0c-26.5 0-48 21.5-48 48l0 48c0 26.5 21.5 48 48 48l32 0 0 8c0 13.3-10.7 24-24 24l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0c48.6 0 88-39.4 88-88zM312 512c48.6 0 88-39.4 88-88l0-56 0-24 0-24c0-26.5-21.5-48-48-48l-48 0c-26.5 0-48 21.5-48 48l0 48c0 26.5 21.5 48 48 48l32 0 0 8c0 13.3-10.7 24-24 24l-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l8 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faQuotes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tL);
var oL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rabbit", f = 512, c = 512, e = [128007], t = "f708", o = "M321.4 128c4.8 0 9.6 .3 14.3 .9c1.1-24-2.6-47.9-10.9-70.1c7.6-17.8 18.6-34.2 32.7-48.3l4.6-4.6c3.7-3.7 8.8-5.8 14-5.8c9.2 0 17.2 6.4 19.3 15.4l1 4.4c9.8 42.4 1.8 86.5-21 122.4c5.5 3.1 10.7 6.6 15.6 10.6L425.8 181c14 11.4 22.2 28.6 22.2 46.7c0 33.3-27 60.3-60.3 60.3L352 288l0 25.8 61.7 154.3c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-39.4-98.6L265.6 448l22.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0-48 0c-28.5 0-52.6-18.6-60.9-44.2C88.8 480.1 73.3 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56c17.4 0 33 8 43.3 20.5C114 317.7 176.8 255.9 256 242.7l0-49.2c0-10.9 2.7-21.2 7.4-30.2c-34.3-36.5-50.3-86.8-43.2-136.8l.7-4.9C222.7 9.2 233.2 0 245.7 0c6.6 0 12.9 2.6 17.6 7.3l3.1 3.1c31.8 31.5 47.9 74.8 45.4 118.4c3.1-.5 6.3-.7 9.6-.7zM368 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRabbit = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oL);
var lL = {}, v3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rabbit-running", f = 576, c = 512, e = ["rabbit-fast"], t = "f709", o = "M460.7 39.3l-2.2-2.1c-4.7-4.6-11.5-6.4-17.9-4.7s-11.4 6.6-13.1 13l-.8 2.9c-3.3 11.8-5.1 23.7-5.5 35.6c24.3 20.6 42.9 47.8 53.3 78.8c-8.2-1.9-16.5-2.9-25-2.9c-.6 0-1.1 0-1.7 0c-18.4-44-56.5-77.4-103.6-89.3l-3.4-.9c-6.2-1.6-12.9-.6-18.5 2.6c-10.8 6.2-15.6 19.5-11.2 31.1c14.9 39.5 44.3 71.4 81.4 89.7c-3.7 6.6-6.4 14-7.6 21.8L279.7 154.9C248.8 137.3 213.8 128 178.2 128c-32.3 0-62.2 16.8-78.9 44.4C89 159.9 73.4 152 56 152c-30.9 0-56 25.1-56 56s25.1 56 56 56c11.3 0 21.8-3.3 30.6-9.1c4.9 17.2 14.5 33.1 28.4 45.9L257.2 431.2C269 442 284.4 448 300.4 448L416 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0-16.8 0L320 384l0-43.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8c-8.5-2.4-13.4-11.3-11-19.8s11.3-13.4 19.8-11l30.8 8.8c55 15.7 92.8 65.9 92.8 123.1l0 15.7 56-32.4 6.4-3.7 101.3 0c33.3 0 60.3-27 60.3-60.3c0-18.1-8.2-35.3-22.2-46.7l-34.6-28.2c-4.6-3.7-9.4-7.1-14.5-10c8.4-49.3-7.8-100-43.9-135.5zm-318.5 382c-14.7 9.8-18.7 29.7-8.9 44.4s29.7 18.7 44.4 8.9l46-30.7-48.6-44.5-32.9 22zM480 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRabbitRunning = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = v3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRabbitFast = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lL);
var dL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "raccoon", f = 512, c = 512, e = [], t = "e613", o = "M336 32c20.5 0 39.9 9.2 52.8 25.1l28.9 35.6-31.5-7.3c-20.2-4.7-39.7 4.2-50.2 19.9c-10.5-15.7-30.1-24.6-50.2-19.9l-31.5 7.3 28.9-35.6C296.1 41.2 315.5 32 336 32zM296.7 205.3c-5.6-3.7-11.4-7-17.5-10l39.9-21.8c6.9-3.8 12.6-9.1 16.8-15.3c4.2 6.3 9.9 11.6 16.8 15.3l39.9 21.8c-6 2.9-11.9 6.2-17.5 10L360 215.4c-.3-13-10.9-23.4-24-23.4s-23.7 10.4-24 23.4l-15.3-10.2zm187.5-81.4l-20.3-25 13.8-41.5c1.5-4.4 2.2-9.1 2.2-13.8C480 19.5 460.5 0 436.5 0l-1.3 0c-3.3 0-6.5 .4-9.7 1.1l-44.1 9.8C367.5 3.8 352 0 336 0s-31.5 3.8-45.3 10.9L246.6 1.1c-3.2-.7-6.5-1.1-9.7-1.1l-1.3 0C211.5 0 192 19.5 192 43.5c0 4.7 .8 9.3 2.2 13.8l13.8 41.5-20.3 25c-7.6 9.3-11.7 21-11.7 33c0 23.1 15.2 43.5 37.3 50.2l35.8 10.7c10.6 3.2 20.6 7.9 29.8 14l18.8 12.6C309.1 252 322.4 256 336 256s26.9-4 38.2-11.6L393 231.9c9.2-6.1 19.2-10.9 29.8-14l35.8-10.7c22.2-6.6 37.3-27 37.3-50.2c0-12-4.1-23.7-11.7-33zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM185.1 229.3C131.2 266.9 96 329.4 96 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-16.4 1.7-32.5 4.8-48L0 352l0 48c0 61.9 50.1 112 112 112l128 0 80 0 0-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c44.2 0 80 35.8 80 80l0 16 24 0c0 0 0 0 .1 0l39.9 0 64 0 0-16.4c-.2-26.3-21.6-47.6-48-47.6l-16 0s0 0 0 0l0-72-6.4 4.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l38.1-28.5c12.3-9.2 19.5-23.7 19.5-39.1c0-14.9-6.8-29-18.5-38.3c-6.6 2.2-12.9 5.3-18.7 9.2l-18.8 12.6c-16.6 11-36 16.9-55.9 16.9s-39.4-5.9-55.9-16.9l-18.8-12.6c-6.6-4.4-13.7-7.7-21.3-10l-35.8-10.7c-6.8-2-13.2-4.9-19.1-8.4zM0 128l128 0 0-32c0-35.3-28.7-64-64-64S0 60.7 0 96l0 32zm0 32l0 64 128 0 0-64L0 160zM0 320l77.7 0c8.2-23.2 19.8-44.7 34.3-64L0 256l0 64zm480-24l-.3-.9c0 .4-.1 .9-.1 1.3l.5-.4zM317.7 376.2c-4.5 7.6-14.4 10-22 5.5l-80-48c-7.6-4.5-10-14.4-5.5-22s14.4-10 22-5.5l80 48c7.6 4.5 10 14.4 5.5 21.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRaccoon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dL);
var rL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "racquet", f = 512, c = 512, e = [], t = "f45a", o = "M349 64c-36 0-76.4 15.8-108.8 48.2S192 184.9 192 221c0 28.2 9.6 53.2 27.7 71.3c40.4 40.4 120.7 38.9 180.1-20.5C432.2 239.4 448 199.1 448 163c0-28.2-9.6-53.2-27.7-71.3S377.1 64 349 64zm-154 2.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-54.4 54.4-131.9 78.7-198.2 61.7c-29.4-7.5-62.9-5.5-84.3 16L148.3 409c6.4 12.1 4.5 27.4-5.6 37.6l-56 56c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l56-56c10.2-10.2 25.5-12.1 37.6-5.6l14.5-14.5c21.4-21.4 23.5-54.7 16-84C129.8 250.9 128 236 128 221c0-54.2 23.4-110.5 66.9-154z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRacquet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rL);
var sL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "radar", f = 512, c = 512, e = [], t = "e024", o = "M304.8 173.3c-14.3-8.4-31-13.3-48.8-13.3c-53 0-96 43-96 96s43 96 96 96s96-43 96-96l64 0c0 73.5-49.6 135.5-117.2 154.2C290.8 394.7 274.7 384 256 384s-34.8 10.7-42.8 26.2c-51.7-14.3-92.8-53.9-109.4-104.6c14.4-8.3 24.1-23.8 24.1-41.7c0-19.4-11.5-36.1-28-43.7C116.2 149.1 179.9 96 256 96c35.5 0 68.3 11.6 94.9 31.2l22.8-22.8C341.2 79 300.4 64 256 64C163.1 64 85.7 129.9 67.9 217.6C47.2 222.9 32 241.7 32 264c0 23.8 17.3 43.6 40.1 47.4c19.3 64.3 71.5 114.4 137 130.9C213.8 463.8 233 480 256 480s42.2-16.2 46.9-37.8C386.3 421.3 448 345.9 448 256l64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l23.8-23.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRadar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sL);
var hL = {}, u3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "radio-tuner", f = 512, c = 512, e = ["radio-alt"], t = "f8d8", o = "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192l0 4L0 304 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-229.5 0L494.8 47zM320 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 336l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 224c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRadioTuner = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = u3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRadioAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(hL);
var vL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "raindrops", f = 448, c = 512, e = [], t = "f75c", o = "M102.4 133.6c-4.2 8.6-6.4 18-6.4 27.6c0 34.7 28.1 62.8 62.8 62.8l2.4 0c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L171.5 39.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2l-46.1 94.4zm-96 192c-4.2 8.6-6.4 18-6.4 27.6C0 387.9 28.1 416 62.8 416l2.4 0c34.7 0 62.8-28.1 62.8-62.8c0-9.6-2.2-19-6.4-27.6L75.5 231.2c-2.1-4.4-6.6-7.2-11.5-7.2s-9.4 2.8-11.5 7.2L6.4 325.6zM307.8 134.8L210 294.2c-11.8 19.2-18 41.3-18 63.8c0 67.4 54.6 122 122 122l12 0c67.4 0 122-54.6 122-122c0-22.5-6.2-44.6-18-63.8L332.2 134.8c-2.6-4.2-7.2-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRaindrops = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vL);
var uL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ram", f = 640, c = 512, e = [128015], t = "f70a", o = "M336 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2 0 72.2c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-72.2 14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21L544 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8 .5-16 1.3l0-1.3c0-35.3-28.7-64-64-64s-64 28.7-64 64zM308.5 174.1c-8.9-20.8-4.3-44 10-59.7C312.3 85.6 286.7 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1l29.4 0c17.7 0 32-14.3 32-32l0-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 53.7c0 17.7 14.3 32 32 32l29.4 0c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40L464 352c-61.9 0-112-50.1-112-112l0-32.6c-18.7-2.7-35.5-14.8-43.5-33.4zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRam = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uL);
var mL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ramp-loading", f = 448, c = 512, e = [], t = "f4d4", o = "M32 48C32 21.5 53.5 0 80 0L368 0c26.5 0 48 21.5 48 48l0 392.4-64-128L352 64 96 64l0 248.4-64 128L32 48zM404.4 488.8c.8 1.5 1.2 3 1.5 4.6c1.5 9.3-5.6 18.6-15.8 18.6L368 512 80 512l-22.1 0c-10.2 0-17.4-9.2-15.8-18.6c.3-1.5 .7-3.1 1.5-4.6L96 384l32-64 192 0 32 64 52.4 104.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRampLoading = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mL);
var gL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "raygun", f = 576, c = 512, e = [], t = "e025", o = "M192 64l96 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-.4L188.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9L120.2 288l-8.2 0C50.1 288 0 237.9 0 176C0 131.3 26.2 92.8 64 74.8l0-50.2C64 11 75 0 88.6 0c4.8 0 9.6 1.4 13.6 4.1L192 64zm200 0c13.3 0 24 10.7 24 24l0 56 60.9 0 77.1-30.9c4.9-2 10.5-1.4 14.9 1.6s7 7.9 7 13.2l0 96c0 5.3-2.6 10.3-7 13.2s-10 3.6-14.9 1.6L476.9 208 416 208l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM136 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRaygun = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gL);
var m3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle", f = 512, c = 512, e = [9644, "rectangle-landscape"], t = "f2fa", o = "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m3);
var PL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-code", f = 512, c = 512, e = [], t = "e322", o = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm294.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L356.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L155.9 256l60.2-54.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleCode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(PL);
var ML = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = o4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRectangleHd = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ML);
var wL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-history", f = 512, c = 512, e = [], t = "e4a2", o = "M512 224c0-35.3-28.7-64-64-64L64 160c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-224zM440 80L72 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM392 0L120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleHistory = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wL);
var NL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-history-circle-plus", f = 640, c = 512, e = [], t = "e4a3", o = "M320 368c0 59.5 29.5 112.1 74.8 144L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleHistoryCirclePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(NL);
var zL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-history-circle-user", f = 640, c = 512, e = [], t = "e4a4", o = "M320 368c0 59.5 29.5 112.1 74.8 144L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-97.2 0-176 78.8-176 176zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleHistoryCircleUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zL);
var LL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = m3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRectangleLandscape = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(LL);
var CL = {}, g3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-vertical", f = 384, c = 512, e = ["rectangle-portrait"], t = "f2fb", o = "M320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = g3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRectanglePortrait = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(CL);
var DL = {}, P3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "standard-definition", f = 576, c = 512, e = ["rectangle-sd"], t = "e28a", o = "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm304 88l0 144c0 13.3 10.7 24 24 24l56 0c53 0 96-43 96-96s-43-96-96-96l-56 0c-13.3 0-24 10.7-24 24zm48 24l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96zm-184.9 .1c7.4-2.4 19.5-2.9 36.2-.7l3-22.2-3 22.2c5.1 .7 21.1 3.4 25.7 4.4c12.1 2.8 24.1-4.8 26.8-16.9s-4.8-24.1-16.9-26.8c-6.5-1.5-23.9-4.4-29.7-5.1c-18.9-2.5-38.9-3.1-56 2.5c-18.8 6.1-33.9 19.7-38.5 42.3c-.1 .4-.1 .8-.2 1.2c-1.7 11.4-.2 22.4 5 32.3c5.1 9.6 12.9 16.1 20.5 20.7c13.7 8.2 31.5 12.3 45.1 15.5c0 0 0 0 0 0l1.7 .4c16 3.7 27.1 6.5 34.1 10.7c3 1.8 3.8 3 3.9 3.3c0 0 0 0 0 0c.1 .1 .7 1.2 .2 4.7c-.4 2.7-1.2 3.8-1.7 4.3c-.7 .7-2.3 2-5.8 3.1c-7.7 2.4-20.1 2.9-36.9 .6c-7.4-1-20.3-4.8-31.4-8c-2.5-.7-5-1.4-7.2-2.1c-11.9-3.4-24.3 3.5-27.7 15.4s3.5 24.3 15.4 27.7c1.5 .4 3.3 .9 5.3 1.5c0 0 0 0 0 0c10.8 3.2 28.4 8.3 39.4 9.9l.1 0c18.9 2.5 39.2 3.1 56.4-2.3c8.9-2.8 17.8-7.5 24.9-15.2c7.3-7.8 11.8-17.6 13.4-28.5c1.7-11.4 .2-22.4-5-32.3c-5.1-9.6-12.9-16.1-20.5-20.7c-13.7-8.2-31.5-12.3-45.1-15.5c0 0 0 0 0 0l-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7c-3-1.8-3.8-3-3.9-3.3c0 0 0 0 0 0c-.1-.1-.6-1.1-.3-4.1c.9-4 2.8-6.2 8.3-8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStandardDefinition = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = P3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRectangleSd = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(DL);
var $L = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-terminal", f = 512, c = 512, e = [], t = "e236", o = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm102.3 55.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleTerminal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($L);
var _L = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-vertical-history", f = 576, c = 512, e = [], t = "e237", o = "M256 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L256 0zM96 72l0 368c0 13.3 10.7 24 24 24s24-10.7 24-24l0-368c0-13.3-10.7-24-24-24s-24 10.7-24 24zM0 120L0 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272c0-13.3-10.7-24-24-24S0 106.7 0 120z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleVerticalHistory = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_L);
var bL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangle-wide", f = 640, c = 512, e = [], t = "f2fc", o = "M0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectangleWide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bL);
var SL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rectangles-mixed", f = 576, c = 512, e = [], t = "e323", o = "M0 80C0 53.5 21.5 32 48 32l224 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48L48 256c-26.5 0-48-21.5-48-48L0 80zm384 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 256c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-256zM112 304l176 0c26.5 0 48 21.5 48 48l0 80c0 26.5-21.5 48-48 48l-176 0c-26.5 0-48-21.5-48-48l0-80c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRectanglesMixed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(SL);
var yL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "reel", f = 448, c = 512, e = [], t = "e238", o = "M0 32C0 14.3 14.3 0 32 0L416 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 24c0 13.3-10.7 24-24 24L88 112c-13.3 0-24-10.7-24-24l0-24L32 64C14.3 64 0 49.7 0 32zM0 480c0-17.7 14.3-32 32-32l32 0 0-24c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24l0 24 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32zM80 144l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 368c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faReel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yL);
var OL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "reflect-both", f = 512, c = 512, e = [], t = "e66f", o = "M413.6 19.8C408.6 7.8 396.9 0 384 0L128 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9zM19.8 98.4C7.8 103.4 0 115.1 0 128L0 384c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9zM512 128c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256zM413.6 492.2c5-12 2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faReflectBoth = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(OL);
var kL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "reflect-horizontal", f = 512, c = 512, e = [], t = "e664", o = "M256 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM492.2 98.4c-12-5-25.7-2.2-34.9 6.9l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6zm-472.5 0C7.8 103.4 0 115.1 0 128L0 384c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faReflectHorizontal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kL);
var AL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "reflect-vertical", f = 512, c = 512, e = [], t = "e665", o = "M0 256c0-13.3 10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24zM98.4 19.8C103.4 7.8 115.1 0 128 0L384 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9zm0 472.5c-5-12-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256 0c-12.9 0-24.6-7.8-29.6-19.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faReflectVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(AL);
var jL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "refrigerator", f = 384, c = 512, e = [], t = "e026", o = "M96 0C43 0 0 43 0 96l0 64 288 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 64 0 0-64c0-53-43-96-96-96L96 0zM384 192l-64 0 0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176L0 192 0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRefrigerator = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jL);
var BL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "repeat-1", f = 512, c = 512, e = [128258], t = "f365", o = "M32 256c-17.7 0-32-14.3-32-32C0 135.6 71.6 64 160 64l160 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-160 0c-53 0-96 43-96 96c0 17.7-14.3 32-32 32zm448 0c17.7 0 32 14.3 32 32c0 88.4-71.6 160-160 160l-160 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 160 0c53 0 96-43 96-96c0-17.7 14.3-32 32-32zM288 216l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRepeat1 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(BL);
var TL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = _i;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRepeat1Alt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(TL);
var FL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = $i;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRepeatAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(FL);
var M3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "reply-clock", f = 640, c = 512, e = ["reply-time"], t = "e239", o = "M352 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM496 64c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16zm0 256c5.1 0 10.2-.2 15.2-.6c.5 5.5 .8 11 .8 16.6c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96l-96 0 0 64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 257.7 0 249.1 0 240s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2l0 64 96.7 0c8.1 89.7 83.5 160 175.3 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faReplyClock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M3);
var HL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = M3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faReplyTime = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(HL);
var RL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "restroom-simple", f = 640, c = 512, e = [], t = "e23a", o = "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM25.9 233.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 464c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-115.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-15.7 32c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 80c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-80 21.6 0c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRestroomSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(RL);
var UL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = bi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRetweetAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(UL);
var qL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rhombus", f = 448, c = 512, e = [], t = "e23b", o = "M254.4 14.1C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9l-184-216z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRhombus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qL);
var GL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "right-left-large", f = 640, c = 512, e = [], t = "e5e1", o = "M455.6 0c19 0 37.2 7.5 50.6 21L625 139.7c9.6 9.6 15 22.7 15 36.3s-5.4 26.7-15 36.3L506.2 331c-13.4 13.4-31.6 21-50.6 21c-37 0-67.4-28-71.2-64H208c-8.8 0-16-7.2-16-16V231.6c0-4.2-3.4-7.6-7.6-7.6c-2 0-3.9 .8-5.4 2.2L69.3 336 179 445.8c1.4 1.4 3.4 2.2 5.4 2.2c4.2 0 7.6-3.4 7.6-7.6V400c0-8.8 7.2-16 16-16H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H255.6c-3.8 36-34.2 64-71.2 64c-19 0-37.2-7.5-50.6-21L15 372.3C5.4 362.7 0 349.6 0 336s5.4-26.7 15-36.3L133.8 181c13.4-13.4 31.6-21 50.6-21c37 0 67.4 28 71.2 64H432c8.8 0 16 7.2 16 16v40.4c0 4.2 3.4 7.6 7.6 7.6c2 0 3.9-.8 5.4-2.2L570.7 176 461 66.2c-1.4-1.4-3.4-2.2-5.4-2.2c-4.2 0-7.6 3.4-7.6 7.6V112c0 8.8-7.2 16-16 16H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h64.4c3.8-36 34.2-64 71.2-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRightLeftLarge = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(GL);
var WL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "right-long-to-line", f = 640, c = 512, e = [], t = "e444", o = "M640 96l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-320c0-17.7 14.3-32 32-32s32 14.3 32 32zM360.5 409.4c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22l0-72L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l288 0 0-72c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRightLongToLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(WL);
var EL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ring-diamond", f = 384, c = 512, e = [], t = "e5ab", o = "M122.5 13.3C126.6 5.1 134.9 0 144 0l96 0c9.1 0 17.4 5.1 21.5 13.3l24 48c3.5 7.1 3.4 15.5-.5 22.4l-30.4 54.8C329.9 164.4 384 235.9 384 320c0 106-86 192-192 192S0 426 0 320c0-84.1 54.1-155.6 129.4-181.6L99 83.7c-3.8-6.9-4-15.3-.5-22.4l24-48zM192 192a128 128 0 1 0 0 256 128 128 0 1 0 0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRingDiamond = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(EL);
var VL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rings-wedding", f = 512, c = 512, e = [], t = "f81b", o = "M113.7 8.8C116.4 3.4 121.9 0 128 0l96 0c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3l-24.6 49.2C300.6 127.1 352 193.5 352 272c0 52.3-22.8 99.2-59 131.5c-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-12-1.9-23.6-5.4-34.5c-34.9 19-58.6 56-58.6 98.5c0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9c-5-26.2-14.8-50.7-28.6-72.4C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32zM176 160c-61.9 0-112 50.1-112 112c0 58.7 45.1 106.8 102.5 111.6c-4.2-15.1-6.5-31.1-6.5-47.6c0-64.4 34.5-120.7 86.1-151.3C226.9 169.2 202.5 160 176 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRingsWedding = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(VL);
var IL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "robot-astromech", f = 512, c = 512, e = [], t = "e2d2", o = "M256 0c70.7 0 128 57.3 128 128l0 32-256 0 0-32C128 57.3 185.3 0 256 0zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM48 240c0-26.5 21.5-48 48-48l320 0c26.5 0 48 21.5 48 48l0 158.3c0 8.7 2.4 17.2 6.8 24.7l38.9 64.8c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1l-96 0c-8.8 0-16-7.2-16-16l0-112-45.3 45.3c-12 12-28.3 18.7-45.3 18.7l-75 0c-17 0-33.3-6.7-45.3-18.7L128 384l0 112c0 8.8-7.2 16-16 16l-96 0c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1L41.2 423c4.5-7.5 6.8-16 6.8-24.7L48 240zm160 16c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRobotAstromech = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(IL);
var KL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rocket-launch", f = 512, c = 512, e = [128640], t = "e027", o = "M117.8 128l89.3 0C286.9-3.7 409.5-8.5 483.9 5.3c11.6 2.2 20.7 11.2 22.8 22.8c13.8 74.4 9 197-122.7 276.9l0 89.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-114.7c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3zM424 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM166.5 470C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5zm-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9c12.8-.7 31.2-3.7 41.3-13.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRocketLaunch = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(KL);
var XL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "roller-coaster", f = 640, c = 512, e = [], t = "e324", o = "M64 190.1c0-31.8 15.8-60 40-77L104 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-359.8c2-.1 4-.2 6.1-.2c14.8 0 29.1 3.5 41.9 9.9L200 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-301.3 48 69.1L296 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-163.1 20.3 29.2c7.9 11.3 17.2 21.3 27.7 29.8L392 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-78.4c13.6 4.2 28 6.4 42.6 6.4l5.4 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-77.6c14.4-4.2 27.8-10.5 40-18.6l0 88.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-200-.2 0c.1-2.6 .2-5.3 .2-8c0-79.5-64.5-144-144-144l-4 0c-28.9 0-57.3 7.1-82.8 20.7l-51.6 27.5L432 251.3l0-74.2 7.3-3.9c12.7-6.8 26.5-11 40.7-12.5L480 264c0 13.3 10.7 24 24 24s24-10.7 24-24l0-97.3c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80l-13.4 0c-26.2 0-50.8-12.8-65.7-34.4L287.9 99.9C258.4 57.4 209.9 32 158.1 32C70.8 32 0 102.8 0 190.1L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-257.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRollerCoaster = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(XL);
var QL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rotate-exclamation", f = 512, c = 512, e = [], t = "e23c", o = "M74.9 192L46.1 178.2c-7.6 15.9-.9 35 15 42.7s35 .9 42.7-15c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0-.1l.2-.3 .7-1.5c.6-1.3 1.6-3.2 2.8-5.6c2.5-4.8 5.9-11.4 10-18.5c8.7-15.3 18.2-29.8 25.3-36.9c62.5-62.5 163.8-62.5 226.3 0L386.3 160 352 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0c-13.8 13.8-27 35.2-35.7 50.6c-4.6 8.2-8.6 15.6-11.3 21c-1.4 2.7-2.5 4.9-3.3 6.5l-.9 1.8-.2 .5-.1 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0L74.9 192zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 464c17.7 0 32-14.3 32-32l0-35.2 17.6 17.6c87.5 87.5 229.3 87.5 316.8 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0L125.7 352l34.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48 288c-17.7 0-32 14.3-32 32l0 112c0 17.7 14.3 32 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRotateExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(QL);
var JL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rotate-reverse", f = 512, c = 512, e = [], t = "e631", o = "M368.9 142.9c17.5 17.5 30.1 38 37.8 59.8c5.9 16.7 24.2 25.4 40.8 19.5s25.4-24.2 19.5-40.8c-10.8-30.6-28.4-59.3-52.9-83.7C327 10.5 185.9 10.1 98.3 96.6L56.7 55c-6.9-6.9-17.2-8.9-26.2-5.2s-14.8 12.5-14.8 22.2l0 128c0 13.3 10.7 24 24 24l8.4 0c0 0 0 0 0 0l119.5 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-41.1-41.1c62.6-61.5 163.1-61.2 225.3 1zM495.8 312c0-13.3-10.7-24-24-24l-7.6 0-.7 0-119.6 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l41.1 41.1c-62.6 61.5-163.1 61.2-225.3-1c-17.5-17.5-30.1-38-37.8-59.8c-5.9-16.7-24.2-25.4-40.8-19.5s-25.4 24.2-19.5 40.8C55.3 361.3 73 390 97.4 414.4c87.2 87.2 228.3 87.5 315.8 1L454.8 457c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-119.6 0-.7 0-7.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRotateReverse = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(JL);
var YL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "route-highway", f = 448, c = 512, e = [], t = "f61a", o = "M240.5 4.6c-10.1-6.1-22.8-6.1-32.9 0l-4.7 2.8c-37.5 22.5-84 24.3-123.1 4.7l-1.4-.7c-15.2-7.6-33.7-2-42.1 12.7l-32 56c-5.3 9.3-5.6 20.6-.8 30.2l16.2 32.5C27.8 159.1 32 177 32 195.2c0 14.9-2.8 29.7-8.4 43.6L9.3 274.5C3.2 289.9 0 306.4 0 323c0 49.5 28 94.8 72.2 116.9l137.4 68.7c9 4.5 19.6 4.5 28.6 0l137.4-68.7C420 417.8 448 372.5 448 323c0-16.6-3.2-33.1-9.3-48.5l-14.3-35.7c-5.5-13.9-8.4-28.6-8.4-43.6c0-18.2 4.2-36.2 12.4-52.5l16.2-32.5c4.8-9.6 4.5-20.9-.8-30.2l-32-56c-8.4-14.7-26.9-20.3-42.1-12.7l-1.4 .7c-39.1 19.6-85.6 17.8-123.1-4.7l-4.7-2.8zM96 192L352 192c0 1.1 0 2.2 0 3.2c0 23.1 4.4 45.9 13 67.3l14.3 35.7c3.2 7.9 4.8 16.3 4.8 24.8c0 25.3-14.3 48.4-36.9 59.7L224 444.2 100.9 382.7C78.3 371.4 64 348.3 64 323c0-8.5 1.6-16.9 4.8-24.8L83 262.6c8.6-21.4 13-44.3 13-67.3c0-1.1 0-2.2 0-3.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRouteHighway = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(YL);
var ZL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "route-interstate", f = 512, c = 512, e = [], t = "f61b", o = "M85.3 192l341 0c-.8 44.3-7.9 81.8-21.9 114.4c-23.4 54.1-68.5 99.1-149 138.5c-81.5-36.2-126.1-80.9-149-135.4c-14-33.3-20.6-72-21-117.4zM276.9 7.3c-12.8-7.8-29-7.8-41.8 0c-27.5 16.8-50.2 26-73.4 30c-23.3 4-49.2 3.2-83.7-3.2C55.9 30 34.4 45 31.1 67.7C16 170.4 15.9 259.5 47.3 334.2c32.1 76.4 94.6 132.5 193 173.9c10.4 4.4 22.3 4.1 32.5-.6c95.7-44.8 157.8-100.7 190.3-175.7c32-73.9 32.9-161.2 17.8-264.1C477.6 45.1 456.1 30 434 34.1c-34.4 6.3-60.3 7.2-83.7 3.2c-23.2-4-45.9-13.2-73.4-30z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRouteInterstate = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ZL);
var pL = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "router", f = 576, c = 512, e = [], t = "f8da", o = "M352 48c58.8 0 112.5 21.8 153.4 57.9c9.9 8.8 25.1 7.8 33.9-2.1s7.8-25.1-2.1-33.9C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9c-9.9 8.8-10.9 23.9-2.1 33.9s23.9 10.9 33.9 2.1C239.5 69.8 293.2 48 352 48zm24 200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72L64 320c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-136 0 0-72zM96 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM276.5 186.7C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7c10.3 8.3 25.4 6.8 33.8-3.5s6.8-25.4-3.5-33.8C428.8 126 392 112 352 112s-76.8 14-105.7 37.4c-10.3 8.3-11.9 23.5-3.5 33.8s23.5 11.9 33.8 3.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRouter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pL);
var xL = {}, w3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "table-rows", f = 512, c = 512, e = ["rows"], t = "e292", o = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 0l0 128 320 0 0-128L128 96zM448 288l-320 0 0 128 320 0 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTableRows = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = w3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faRows = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(xL);
var iC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rugby-ball", f = 512, c = 512, e = [], t = "e3c6", o = "M368 16c13.4 0 26.4 2.1 38.5 5.9c-21.1 1.8-44.5 8.7-69 19.5c-53.4 23.5-114.8 66.9-172.1 124.1S64.9 284.1 41.4 337.6c-10.8 24.5-17.7 47.9-19.5 69C18.1 394.4 16 381.4 16 368l0-32C16 159.3 159.3 16 336 16l32 0zm122.1 89.5c3.8 12.2 5.9 25.1 5.9 38.5l0 32c0 176.7-143.3 320-320 320l-32 0c-13.4 0-26.4-2.1-38.5-5.9c21.1-1.8 44.5-8.7 69-19.5c53.4-23.5 114.8-66.9 172.1-124.1s100.6-118.6 124.1-172.1c10.8-24.5 17.7-47.9 19.5-69zM63.7 448.3c-6.7-6.7-10.9-17.8-10.2-34.8c.7-17.1 6.3-38.5 17.1-63c21.5-49 62.3-107.1 117.5-162.3s113.4-95.9 162.3-117.5c24.5-10.8 45.9-16.4 63-17.1c17.1-.7 28.1 3.5 34.8 10.2s10.9 17.8 10.2 34.8c-.7 17.1-6.3 38.5-17.1 63c-21.5 49-62.3 107.1-117.5 162.3s-113.4 95.9-162.3 117.5c-24.5 10.8-45.9 16.4-63 17.1c-17.1 .7-28.1-3.4-34.8-10.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRugbyBall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iC);
var aC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ruler-triangle", f = 512, c = 512, e = [128208], t = "f61c", o = "M0 32L0 448c0 35.3 28.7 64 64 64l416 0c17.7 0 32-14.3 32-32l0-2.7c0-8.5-3.4-16.6-9.4-22.6l-51.3-51.3-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24-57.4-57.4-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L131.3 83.3l-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24L57.4 9.4C51.4 3.4 43.2 0 34.7 0L32 0C14.3 0 0 14.3 0 32zM128 256L256 384l-128 0 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRulerTriangle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aC);
var eC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "rv", f = 640, c = 512, e = [], t = "f7be", o = "M224 16c0-8.8 7.2-16 16-16L368 0c8.8 0 16 7.2 16 16l0 16 128 0c53 0 96 43 96 96c0 17.7-14.3 32-32 32l-192 0 0 256-129.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16L96 416 18.7 338.7C6.7 326.7 0 310.5 0 293.5L0 96C0 60.7 28.7 32 64 32l160 0 0-16zM112 128c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-128 0zm96 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80-48l0-16 0-80 0-32 0-72 0-24 24 0 76.6 0c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3l0 16.8 0 64c0 17.7-14.3 32-32 32l-33.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16zM578.1 288l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8L464 240l0 48 114.1 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faRv = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eC);
var nC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sack", f = 512, c = 512, e = [], t = "f81c", o = "M192 96l128 0 47.4-71.1C374.5 14.2 366.9 0 354.1 0L157.9 0c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32l-128 0c-3.8 2.5-8.1 5.3-13 8.4c0 0 0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSack = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nC);
var fC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "salt-shaker", f = 384, c = 512, e = [129474], t = "e446", o = "M319.4 448L64.6 448l36.6-256 181.6 0 36.6 256zM59.8 512l264.5 0c33 0 59.8-26.8 59.8-59.8c0-2.8-.2-5.7-.6-8.5L338.1 126.7C327.7 54 265.4 0 192 0S56.3 54 45.9 126.7L.6 443.8c-.4 2.8-.6 5.6-.6 8.5c0 33 26.8 59.8 59.8 59.8zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSaltShaker = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fC);
var cC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sandwich", f = 512, c = 512, e = [129386], t = "f81f", o = "M0 96C0 78.3 14.3 64 32 64l448 0c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32L32 176c-17.7 0-32-14.3-32-32L0 96zM303.9 382.6c10 5.8 22.3 5.8 32.2 0l70.2-40.9c6.4-3.7 13.6-5.7 20.9-5.7l4.8 0 48 0c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32l176 0 4.8 0c7.4 0 14.6 2 20.9 5.7l70.2 40.9zM32 304c-17.7 0-32-14.3-32-32s14.3-32 32-32c7.2 0 15.8-3.7 35.4-13c16.6-7.8 40.6-19 68.6-19c30.6 0 53 10.2 70.1 18l1.9 .9c17.2 7.8 29.7 13.1 48.1 13.1s30.9-5.3 48.1-13.1l1.9-.9c17-7.8 39.4-18 70.1-18c28 0 52.1 11.3 68.6 19c19.6 9.2 28.2 13 35.4 13c17.7 0 32 14.3 32 32s-14.3 32-32 32c-22.7 0-44.3-10.3-58.8-17.2c0 0 0 0 0 0c-1.3-.6-2.6-1.2-3.8-1.8c-17.4-8.2-29.4-13-41.4-13c-16.2 0-27.5 5-45.4 13.1c0 0 0 0-.1 0c-18 8.2-41.4 18.9-74.5 18.9s-56.6-10.7-74.5-18.9c0 0 0 0-.1 0C163.5 277 152.2 272 136 272c-12 0-23.9 4.7-41.4 13c-1.2 .6-2.5 1.2-3.8 1.8C76.3 293.7 54.7 304 32 304z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSandwich = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cC);
var tC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sausage", f = 512, c = 512, e = [], t = "f820", o = "M320 160c0-42 26.9-77.7 64.5-90.7L369.2 27.4c-.8-2.2-1.2-4.6-1.2-7C368 9.1 377.1 0 388.4 0l55.2 0C454.9 0 464 9.1 464 20.4c0 2.4-.4 4.7-1.2 7L447.5 69.3C485.1 82.3 512 118 512 160c0 194.4-157.6 352-352 352c-42 0-77.7-26.9-90.7-64.5L27.4 462.8c-2.2 .8-4.6 1.2-7 1.2C9.1 464 0 454.9 0 443.6l0-55.2C0 377.1 9.1 368 20.4 368c2.4 0 4.7 .4 7 1.2l41.9 15.2C82.3 346.9 118 320 160 320c88.4 0 160-71.6 160-160zm80 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 114.9-93.1 208-208 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSausage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tC);
var oC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ka;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSaveCircleArrowRight = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(oC);
var lC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = d;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSaveCircleXmark = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lC);
var dC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = d;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSaveTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(dC);
var rC = {}, N3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "saxophone-fire", f = 640, c = 512, e = ["sax-hot"], t = "f8db", o = "M256 153.6c0-25.5-12.4-67.2-59.5-113.9c-9.4-9.3-24.5-8.6-33.8 .8l-9.1 9.1L116.8 12.7C112 7.9 105.6 5.3 99.2 5.4c-4.7 0-9.4 1.6-13.4 4.7C50 37.9 0 92.3 0 153.6c0 7.6 .7 15.1 2 22.4l77.6 0c7.7-23.3 29.5-44.6 41-54.6c4.3-3.7 10.5-3.7 14.8 0c11.6 10 33.4 31.3 41 54.6l77.6 0c1.3-7.3 2-14.8 2-22.4zM180.1 329.8L229.3 256l2.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 208c-13.3 0-24 10.7-24 24c0 9.5 5.5 17.7 13.5 21.6L2.7 313C.9 323 0 333.1 0 343.2l0 7C0 439.6 72.4 512 161.8 512c49.4 0 96.1-22.6 126.8-61.4L534.4 140.1c6.1-7.7 15.3-12.1 25.1-12.1l64.2 0c9 0 16.3-7.3 16.3-16.3c0-4.9-2.2-9.5-5.9-12.6L609.8 78.8c-11.5-9.6-26-14.8-41-14.8l-30.3 0c-17 0-33.3 6.7-45.3 18.7L449 127l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L401 175l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L353 223l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8 8L214.6 361.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6l0-1.9c0-4.8 1.4-9.6 4.1-13.6zM144 280a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSaxophoneFire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = N3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSaxHot = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(rC);
var sC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "saxophone", f = 640, c = 512, e = [127927], t = "f8dc", o = "M246.7 176L171.4 306.1c-2.2 3.8-3.4 8.2-3.4 12.6l0 2.6c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L319 225l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L367 177l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8L415 129l-8-8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 44.3-44.3c12-12 28.3-18.7 45.3-18.7l30.3 0c15 0 29.5 5.2 41 14.8l24.3 20.3c3.7 3.1 5.9 7.7 5.9 12.6c0 9-7.3 16.3-16.3 16.3l-64.2 0c-9.8 0-19 4.5-25.1 12.1L288.6 418.6C257.9 457.4 211.2 480 161.8 480C72.4 480 0 407.6 0 318.2l0-3.1c0-12.7 1.5-25.4 4.4-37.8L28.2 176 24 176c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-17.3 0zM120 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSaxophone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sC);
var hC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scalpel", f = 512, c = 512, e = [], t = "f61d", o = "M387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6l0 4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17L200 288c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320l6.6 0 96 0 16 0 0 16c0 74.9-65.5 118.6-126.1 142.9C100.1 503.6 34.1 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l160-160 4.7-4.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScalpel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hC);
var z3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scalpel-line-dashed", f = 576, c = 512, e = ["scalpel-path"], t = "f61e", o = "M441.4 0c-20.8 0-40.6 9.2-54 25.1L187.8 261.7c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3l132.6 0c14.1 0 27.6-6.2 36.7-17L494.4 122.7C505.8 109.2 512 92.2 512 74.6l0-4C512 31.6 480.4 0 441.4 0zM164.7 324.7l-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0-4.7 4.7zM304 480l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScalpelLineDashed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z3);
var vC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = z3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faScalpelPath = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vC);
var uC = {}, L3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scanner-gun", f = 576, c = 512, e = ["scanner"], t = "f488", o = "M112 32C50.1 32 0 82.1 0 144c0 50.7 33.8 93.6 80 107.4L8.1 374.7c-13.3 22.8-5.7 52.2 17.1 65.6l53.4 31.4c22.8 13.4 52.3 5.8 65.7-17L261.2 256l42.8 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L112 32zm328 0c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24L440 32zM416 216l0 16c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24zm24 200c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24l-112 0zM416 144c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zm16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm-16 80c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScannerGun = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = L3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faScanner = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(uC);
var mC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scanner-image", f = 576, c = 512, e = [], t = "f8f3", o = "M79.1 35.8c-15.6-8.3-35-2.4-43.3 13.2s-2.4 35 13.2 43.3L416 288 64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-76.8c0-23.6-13-45.3-33.9-56.5L79.1 35.8zM64 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScannerImage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mC);
var gC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scanner-keyboard", f = 512, c = 512, e = [], t = "f489", o = "M152 0l16 0c13.3 0 24 10.7 24 24l0 40-64 0 0-40c0-13.3 10.7-24 24-24zM312 0l16 0c13.3 0 24 10.7 24 24l0 40-64 0 0-40c0-13.3 10.7-24 24-24zM224 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48-32 0 0-48zM400 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-240zM0 160c0-35.3 28.7-64 64-64l224 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160zm64 24l0 16c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24l0-16c0-13.3-10.7-24-24-24L88 160c-13.3 0-24 10.7-24 24zm0 120l0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-64 0zm112-80l0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScannerKeyboard = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gC);
var PC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scanner-touchscreen", f = 512, c = 512, e = [], t = "f48a", o = "M152 0l16 0c13.3 0 24 10.7 24 24l0 40-64 0 0-40c0-13.3 10.7-24 24-24zM0 160c0-35.3 28.7-64 64-64l224 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 160zm64 16l0 256c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L80 160c-8.8 0-16 7.2-16 16zM288 24c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 40-64 0 0-40zM240 0c8.8 0 16 7.2 16 16l0 48-32 0 0-48c0-8.8 7.2-16 16-16zM384 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256zM472 0l16 0c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScannerTouchscreen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(PC);
var MC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scarecrow", f = 448, c = 512, e = [], t = "f70d", o = "M320 96c0 11.2-1.9 22-5.5 32L416 128c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2 .8 16.4s-8.2 8.5-14.1 8.5l-73 0c-10.1 0-17.7 9.2-15.7 19.1l24.3 121.7c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3 .9L287.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-4.9 2.8-11 2.8-15.9 0L175.9 391c-4.9-2.8-11-2.8-15.9 0l-40.1 22.9c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1l24.3-121.7c2-9.9-5.6-19.1-15.7-19.1l-73 0c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5 .8-16.4l7.6-11.4L6.4 204.8C2.4 201.8 0 197 0 192s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5l101.5 0c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 480l0-52.2 12.2 6.9c12.3 7 27.4 7 39.7 0l12.2-6.9 0 52.2c0 17.7-14.3 32-32 32s-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScarecrow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(MC);
var wC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scarf", f = 512, c = 512, e = [129507], t = "f7c1", o = "M256 137.4L374.6 256l9.4 9.4 11.3 11.3 112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L384 310.6 358.6 336 459.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 358.6 310.6 384 411.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112L128.4 247C107.7 226.3 96 198.1 96 168.8c0-19 4.9-37.7 14.2-54.2l41.5-73.8C165.9 15.6 192.5 0 221.4 0l69.1 0c28.9 0 55.6 15.6 69.7 40.8l41.5 73.8c9.3 16.6 14.2 35.2 14.2 54.2c0 22.8-7 44.9-19.9 63.4L278.6 114.7l15.1-15.1C283.1 97.5 270.3 96 256 96s-27.1 1.5-37.8 3.6L256 137.4zM4.7 388.7l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm48 48l112-112 22.6 22.6-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScarf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wC);
var C3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "screen-users", f = 640, c = 512, e = ["users-class"], t = "f63d", o = "M96 0C60.7 0 32 28.7 32 64l0 184.4C49 233.2 71.4 224 96 224L96 64l448 0 0 160c24.6 0 47 9.2 64 24.4L608 64c0-35.3-28.7-64-64-64L96 0zm64 320A64 64 0 1 0 32 320a64 64 0 1 0 128 0zM0 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zM384 320a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM224 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zm320-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScreenUsers = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C3);
var NC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "screencast", f = 576, c = 512, e = [], t = "e23e", o = "M512 96L64 96l0 99c-13-2-26.4-3-40-3L0 192 0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-224 0 0-24c0-13.6-1-27-3-40l227 0 0-320zM24 224c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 344c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScreencast = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(NC);
var zC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = N2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faScreenshot = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(zC);
var LC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scribble", f = 512, c = 512, e = [], t = "e23f", o = "M170 23.3C186.5 8.3 208 0 230.3 0l1.1 0C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4C96 373 107 384 120.6 384c6.5 0 12.8-2.6 17.4-7.2L360.8 153.9c16.6-16.6 39.1-25.9 62.6-25.9c48.9 0 88.6 39.7 88.6 88.6c0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.8 8.8-13.8 20.9-13.8 33.4c0 26 21.1 47.1 47 47.1c6.2 0 12.4-1.5 18-4.2l16.7-8.4c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L477.6 501c-14.5 7.2-30.4 11-46.6 11c-61.4 0-111-49.9-111-111.1c0-29.5 11.7-57.8 32.6-78.7l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4c0-13.6-11-24.6-24.6-24.6c-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9C71.7 448 32 408.3 32 359.4c0-23.5 9.3-46 25.9-62.6L248.8 105.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64l-1.1 0c-6.4 0-12.6 2.4-17.3 6.7L53.5 215.7c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2L170 23.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScribble = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(LC);
var CC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scroll-old", f = 576, c = 512, e = [], t = "f70f", o = "M48 32c26.5 0 48 21.5 48 48l0 80-48 0-16 0c-17.7 0-32-14.3-32-32L0 80C0 53.5 21.5 32 48 32zm80 48c0-18-6-34.6-16-48l272 0c51.4 0 93.4 40.5 95.9 91.3c-.4 3.5-2 6.9-4.6 9.4l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3l0 1.4 0 16 0 1.4c0 4.2-1.7 8.3-4.7 11.3l-21.7 21.7c-3.1 3.1-3.1 8.2 0 11.3l21.7 21.7c3 3 4.7 7.1 4.7 11.3l0 1.4 0 24-165.3 0c-32.4 0-58.7 26.3-58.7 58.7l0 5.3c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-120 0-1.4c0-4.2 1.7-8.3 4.7-11.3l21.7-21.7c3.1-3.1 3.1-8.2 0-11.3l-21.7-21.7c-3-3-4.7-7.1-4.7-11.3l0-1.4 0-104zM576 368c0 61.9-50.1 112-112 112l-96 0-176 0c53 0 96-43 96-96l0-5.3c0-14.7 11.9-26.7 26.7-26.7l29.3 0 1.4 0c4.2 0 8.3 1.7 11.3 4.7l21.7 21.7c3.1 3.1 8.2 3.1 11.3 0l21.7-21.7c3-3 7.1-4.7 11.3-4.7l1.4 0 136 0c8.8 0 16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScrollOld = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(CC);
var DC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ea;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faScrollRibbon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(DC);
var $C = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scrubber", f = 512, c = 512, e = [], t = "f2f8", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScrubber = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($C);
var _C = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "scythe", f = 640, c = 512, e = [], t = "f710", o = "M614.7 .7c5.6 1.2 10.5 3.8 14.5 7.3c8.4 7.4 12.6 19 10.1 30.7l-4.8 22.6L577.6 326.7l-34.3 160c-3.7 17.3-20.7 28.3-38 24.6s-28.3-20.7-24.6-38l26-121.3L416 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l104.4 0L569 61.3l7.7-36s0 0 0 0L582.1 0 608 0c2.2 0 4.5 .2 6.7 .7zM352 0L549.4 0l-4 18.6L508.3 192 12.7 192C5.7 192 0 186.3 0 179.2c0-2.1 .5-4.1 1.6-6C15 151.1 114.8 0 352 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faScythe = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_C);
var bC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sd-cards", f = 448, c = 512, e = [], t = "e240", o = "M384 0L237.3 0C220.3 0 204 6.7 192 18.7L114.7 96c-12 12-18.7 28.3-18.7 45.3L96 352c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64zM280 64c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0c-48.6 0-88-39.4-88-88l0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSdCards = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bC);
var SC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "seal", f = 512, c = 512, e = [], t = "e241", o = "M289.9 18.4c-18.7-18.7-49.1-18.7-67.9 0L176.5 64 112 64c-26.5 0-48 21.5-48 48l0 64.5L18.4 222.1c-18.7 18.7-18.7 49.1 0 67.9L64 335.5 64 400c0 26.5 21.5 48 48 48l64.5 0 45.6 45.6c18.7 18.7 49.1 18.7 67.9 0L335.5 448l64.5 0c26.5 0 48-21.5 48-48l0-64.5 45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176.5l0-64.5c0-26.5-21.5-48-48-48l-64.5 0L289.9 18.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSeal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(SC);
var yC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "seal-exclamation", f = 512, c = 512, e = [], t = "e242", o = "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64l64 0c26.5 0 48 21.5 48 48l0 64 45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1l0 64.9c0 26.5-21.5 48-48 48l-64.9 0-45.1 45.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448 112 448c-26.5 0-48-21.5-48-48l0-64.9L18.4 289.5c-18.7-18.7-18.7-49.1 0-67.9L64 176l0-64c0-26.5 21.5-48 48-48l64 0 46.1-46.1zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSealExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yC);
var OC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "seal-question", f = 512, c = 512, e = [], t = "e243", o = "M222.1 17.9c18.7-18.7 49.1-18.7 67.9 0L336 64l64 0c26.5 0 48 21.5 48 48l0 64 45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.1l0 64.9c0 26.5-21.5 48-48 48l-64.9 0-45.1 45.1c-18.7 18.7-49.1 18.7-67.9 0L176.9 448 112 448c-26.5 0-48-21.5-48-48l0-64.9L18.4 289.5c-18.7-18.7-18.7-49.1 0-67.9L64 176l0-64c0-26.5 21.5-48 48-48l64 0 46.1-46.1zM169.8 165.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSealQuestion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(OC);
var kC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "seat-airline", f = 448, c = 512, e = [], t = "e244", o = "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 143.6c0 15.2 3.1 30.2 9.1 44.1L82 357.8c15.1 35.3 49.8 58.2 88.2 58.2l45.8 0 0 48-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-48 96 0c15.1 0 29.3-7.1 38.4-19.2l43.2-57.6c7.3-9.7 8.4-22.7 3-33.5S428.1 288 416 288l-294.3 0L108 256l212 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80.5 192 67.9 162.5c-2.6-6-3.9-12.4-3.9-18.9L64 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSeatAirline = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kC);
var AC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "semicolon", f = 192, c = 512, e = [], t = "3b", o = "M96 64a64 64 0 1 1 0 128A64 64 0 1 1 96 64zm54.8 319L83.7 492.8C76.4 504.7 63.5 512 49.5 512C24 512 5 488.5 10.4 463.6L37.5 337c6.1-28.6 31.4-49 60.6-49c34.2 0 61.9 28.1 61.9 62.3c0 11.5-3.2 22.9-9.2 32.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSemicolon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(AC);
var jC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = b;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSend = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(jC);
var BC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "send-back", f = 640, c = 512, e = [], t = "f87e", o = "M192 64l0 128L64 192 64 64l128 0zM64 0C28.7 0 0 28.7 0 64L0 192c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64L64 0zM576 320l0 128-128 0 0-128 128 0zM448 256c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-128 0zM160 288l0 64c0 35.3 28.7 64 64 64l128 0 0-96c0-53 43-96 96-96l32 0 0-64c0-35.3-28.7-64-64-64L288 96l0 96c0 53-43 96-96 96l-32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSendBack = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(BC);
var TC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "send-backward", f = 512, c = 512, e = [], t = "f87f", o = "M64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l64 0 0-128c0-53 43-96 96-96l128 0 0-64c0-35.3-28.7-64-64-64L64 0zM224 224l224 0 0 224-224 0 0-224zm-64 0l0 224c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-224 0c-35.3 0-64 28.7-64 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSendBackward = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(TC);
var FC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sensor", f = 448, c = 512, e = [], t = "e028", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm48 88l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSensor = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(FC);
var HC = {}, D3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sensor-triangle-exclamation", f = 640, c = 512, e = ["sensor-alert"], t = "e029", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l161 0c-.6-4-1-8.1-1-12.3c0-13.2 3.4-26.2 9.9-37.7l150.4-265c13-22.9 37.3-37.1 63.7-37.1l0-32c0-35.3-28.7-64-64-64L64 32zm48 88l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm53.8 325.8c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3l295.4 0c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265zM464 272l0 88c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-88c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSensorTriangleExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = D3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSensorAlert = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(HC);
var $3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sensor-cloud", f = 640, c = 512, e = ["sensor-smoke"], t = "e02c", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l170.8 0c-6.9-14.5-10.8-30.8-10.8-48c0-44.7 26.2-83.3 64.1-101.3C290.9 271.3 339.9 224 400 224c17.2 0 33.5 3.9 48 10.8L448 96c0-35.3-28.7-64-64-64L64 32zm48 88l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zM336 512l224 0c44.2 0 80-35.8 80-80c0-39-27.9-71.5-64.8-78.6c.5-3.1 .8-6.2 .8-9.4c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C284.4 359.9 256 392.6 256 432c0 44.2 35.8 80 80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSensorCloud = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($3);
var RC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sensor-fire", f = 640, c = 512, e = [], t = "e02a", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l273.6 0c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4c21.7-35.2 51.9-71.2 87.3-102.8c10-8.9 23-12.8 35.5-11.7L448 96c0-35.3-28.7-64-64-64L64 32zm48 88l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm297.7 88.1l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352c0 88.6 70.4 159.8 160 159.8c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327 544 363.5 544 400z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSensorFire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(RC);
var UC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sensor-on", f = 640, c = 512, e = [], t = "e02b", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm88 0c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zm413.3 12l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM536 232l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm13.3 140l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSensorOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(UC);
var qC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = $3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSensorSmoke = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(qC);
var GC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "share-all", f = 576, c = 512, e = [], t = "f367", o = "M366.6 39.5c9.1-9.6 24.3-10 33.9-.9L542.2 173.2c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8 .9-33.9L509.2 208 367.5 73.4c-9.6-9.1-10-24.3-.9-33.9zM224 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2l0-64-32 0c-53 0-96 43-96 96c0 30.4 12.8 47.9 22.2 56.7c5.5 5.1 9.8 12 9.8 19.5c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176l48 0 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShareAll = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(GC);
var WC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sheep", f = 640, c = 512, e = [128017], t = "f711", o = "M384 135.8l0 72.2c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-72.2 14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5L561.6 77.4C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4L350.5 97.9c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM352 175.4c-18.7-2.7-35.5-14.8-43.5-33.4c-6.9-16.1-5.7-33.5 1.8-47.9C299 76 278.9 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1l29.4 0c17.7 0 32-14.3 32-32l0-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 53.7c0 17.7 14.3 32 32 32l29.4 0c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8L464 320c-61.9 0-112-50.1-112-112l0-32.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSheep = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(WC);
var EC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shelves-empty", f = 640, c = 512, e = [], t = "e246", o = "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 192 0 448l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l512 0c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 0-256 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 160 64 32zm0 192l512 0 0 192L64 416l0-192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShelvesEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(EC);
var VC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-check", f = 512, c = 512, e = [], t = "f2f7", o = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(VC);
var IC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-cross", f = 512, c = 512, e = [9960], t = "f712", o = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 66.8l32 13.6 0 47.7c0 17.7 14.3 32 32 32l111.3 0c-1.2 19.6-4.2 41.4-9.4 64l-102 0c-17.7 0-32 14.3-32 32l0 170.8c-10 6.5-20.7 12.5-32 18c-11.3-5.5-22-11.5-32-18L224 256c0-17.7-14.3-32-32-32L90.1 224c-5.2-22.6-8.1-44.4-9.4-64L192 160c17.7 0 32-14.3 32-32l0-47.7 32-13.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldCross = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(IC);
var KC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-exclamation", f = 512, c = 512, e = [], t = "e247", o = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 128c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(KC);
var XC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-keyhole", f = 512, c = 512, e = [], t = "e248", o = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM312 208c0 22.3-13.1 41.6-32 50.6l0 69.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-69.4c-18.9-9-32-28.3-32-50.6c0-30.9 25.1-56 56-56s56 25.1 56 56z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldKeyhole = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(XC);
var QC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-minus", f = 512, c = 512, e = [], t = "e249", o = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldMinus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(QC);
var JC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-plus", f = 512, c = 512, e = [], t = "e24a", o = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(JC);
var YC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-quartered", f = 512, c = 512, e = [], t = "e575", o = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM80 141.4L256 66.8 256 224 90.1 224c-6.9-30-9.8-58.5-10.1-82.6zM256 444.8L256 224l166 0c-18.5 80.5-65.5 172.2-166 220.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldQuartered = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(YC);
var ZC = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-slash", f = 640, c = 512, e = [], t = "e24b", o = "M320 0c4.6 0 9.2 1 13.4 2.9L521.7 82.8c22 9.3 38.4 31 38.3 57.2c-.3 58.7-14.7 146.2-62.1 225L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L131 77.4 306.7 2.9C310.8 1 315.4 0 320 0zM80.6 159.5L437.5 440.7c-25.2 24-55.3 45.4-91.1 62.5c-16.7 8-36.1 8-52.8 0C132 425.8 86.1 261.5 80.6 159.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ZC);
var pC = {}, _3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shield-xmark", f = 512, c = 512, e = ["shield-times"], t = "e24c", o = "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShieldXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = _3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faShieldTimes = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(pC);
var xC = {}, b3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-clock", f = 640, c = 512, e = ["shipping-timed"], t = "f48c", o = "M0 48C0 21.5 21.5 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 48zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 176A112 112 0 1 0 96 176a112 112 0 1 0 224 0zM208 96c8.8 0 16 7.2 16 16l0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckClock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = b3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faShippingTimed = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(xC);
var iD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shirt-long-sleeve", f = 640, c = 512, e = [], t = "e3c7", o = "M157 .3c-32.1 2.5-61 20.9-76.7 49.5L13.9 170.5C4.8 187 0 205.6 0 224.4L0 384c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-159.6c0-2.7 .7-5.3 2-7.7l46-83.7L144 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-314.9 46 83.7c1.3 2.4 2 5 2 7.7L544 384c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-159.6c0-18.9-4.8-37.4-13.9-54L559.7 49.7C544.1 21.2 515.1 2.8 483 .3c-1-.2-2-.3-3-.3l-4.4 0L460 0 432 0c-8.8 0-15.9 7.2-17.3 15.9C407.1 61.4 367.6 96 320 96s-87.1-34.6-94.7-80.1C223.9 7.2 216.8 0 208 0L180 0 164.4 0 160 0c-1 0-2 .1-3 .3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShirtLongSleeve = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iD);
var aD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shirt-running", f = 384, c = 512, e = [], t = "e3c8", o = "M80 0c17.7 0 32 14.3 32 32l0 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 33.3 2.6 61.5 6.5 85.2L0 393.8 0 282.5c0-17 6.7-33.5 14.7-48.4C28.8 207.6 48 155 48 64l0-32C48 14.3 62.3 0 80 0zM3.8 469.8L360.4 215c3 7.5 6 13.8 8.9 19c8 15 14.7 31.5 14.7 48.4L384 448c0 35.3-28.7 64-64 64L64 512c-27.7 0-51.3-17.6-60.2-42.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShirtRunning = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aD);
var eD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shirt-tank-top", f = 384, c = 512, e = [], t = "e3c9", o = "M112 32C112 14.3 97.7 0 80 0S48 14.3 48 32l0 32c0 91-19.2 143.6-33.3 170.1C6.7 249.1 0 265.5 0 282.5L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-165.5c0-17-6.7-33.5-14.7-48.4C355.2 207.6 336 155 336 64l0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShirtTankTop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eD);
var nD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shish-kebab", f = 512, c = 512, e = [], t = "f821", o = "M438.6 73.4c-12.5-12.5-32.8-12.5-45.3 0c-11.5 11.5-12.4 29.7-2.7 42.2c11.1 14.2 13.3 37.7-3 53.9L346.2 211 301 165.8l28.4-28.4c-17-35.7-10.8-79.7 18.8-109.3c37.5-37.5 98.3-37.5 135.8 0c31.4 31.4 36.5 79.2 15.3 115.9c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c7.1-12.2 5.3-28.2-5.1-38.6zM61.8 405L107 450.2 54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L61.8 405zM244.3 154.3L357.7 267.7c15.6 15.6 15.6 40.9 0 56.6l-25.4 25.4c-15.6 15.6-40.9 15.6-56.6 0L162.3 236.3c-15.6-15.6-15.6-40.9 0-56.6l25.4-25.4c15.6-15.6 40.9-15.6 56.6 0zM75.7 266.3c15.6-15.6 40.9-15.6 56.6 0L245.7 379.7c15.6 15.6 15.6 40.9 0 56.6l-25.4 25.4c-15.6 15.6-40.9 15.6-56.6 0L50.3 348.3c-15.6-15.6-15.6-40.9 0-56.6l25.4-25.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShishKebab = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nD);
var fD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ji;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faShoppingBasketAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(fD);
var cD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = l2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faShortcake = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(cD);
var tD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shovel", f = 512, c = 512, e = [], t = "f713", o = "M361.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-44.1 44.1c-18.7 18.7-44.1 29.3-70.6 29.3c-15.9 0-30.9-3.7-44.3-10.3l-97 97 50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9L32 512c-17.7 0-32-14.3-32-32l0-93.7c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7 97-97C291.7 155.1 288 140 288 124.1c0-26.5 10.5-51.9 29.3-70.6L361.4 9.4zM384 77.3L362.5 98.7c-6.7 6.7-10.5 15.9-10.5 25.4c0 19.8 16.1 35.9 35.9 35.9c9.5 0 18.6-3.8 25.4-10.5L434.7 128 384 77.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShovel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tD);
var oD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shovel-snow", f = 512, c = 512, e = [], t = "f7c3", o = "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4c-15.1 15.1-35.6 23.6-57 23.6c-13.5 0-26.2-3.3-37.4-9.2l-83.5 83.5 47 47c11.3 11.3 12.5 29.1 3 41.8l-120 160c-5.6 7.4-14.1 12.1-23.3 12.7s-18.3-2.7-24.9-9.3l-168-168C2.8 328.1-.6 319 .1 309.7s5.3-17.8 12.7-23.3l160-120c12.7-9.6 30.6-8.3 41.8 3l47 47 83.5-83.5c-5.9-11.2-9.2-23.9-9.2-37.4c0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9L393.5 72.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L454.1 104 408 57.9zM203.3 267.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShovelSnow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oD);
var lD = {}, S3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shower-down", f = 384, c = 512, e = ["shower-alt"], t = "e24d", o = "M192 0c17.7 0 32 14.3 32 32l0 3.2C297 50 352 114.6 352 192c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 256c-17.7 0-32-14.3-32-32s14.3-32 32-32C32 114.6 87 50 160 35.2l0-3.2c0-17.7 14.3-32 32-32zm52.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zm-82.2-85.6l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zm146.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM52.8 295.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShowerDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = S3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faShowerAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lD);
var dD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shredder", f = 512, c = 512, e = [], t = "f68a", o = "M64 64C64 28.7 92.7 0 128 0L354.7 0c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3l0 98.7c35.3 0 64 28.7 64 64l0 96c0 17.7-14.3 32-32 32L32 384c-17.7 0-32-14.3-32-32l0-96c0-35.3 28.7-64 64-64L64 64zM384 93.3L354.7 64 128 64l0 128 256 0 0-98.7zM432 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 416l48 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72zm96 0l48 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72zm96 0l48 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72zm96 0l48 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72zm96 0l48 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShredder = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dD);
var rD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shutters", f = 512, c = 512, e = [], t = "e449", o = "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM20.6 224l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 128 24 128 1.1 196.8c-.7 2.1-1.1 4.3-1.1 6.5C0 214.8 9.2 224 20.6 224zM491.4 352c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 256 24 256 1.1 324.8c-.7 2.1-1.1 4.3-1.1 6.5C0 342.8 9.2 352 20.6 352l470.7 0zM20.6 480l470.7 0c11.4 0 20.6-9.2 20.6-20.6c0-2.2-.4-4.4-1.1-6.5L488 384 24 384 1.1 452.8c-.7 2.1-1.1 4.3-1.1 6.5C0 470.8 9.2 480 20.6 480z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShutters = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rD);
var sD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "shuttlecock", f = 512, c = 512, e = [], t = "f45b", o = "M320 32c0 8.8-7.2 16-16 16c-24.4 0-46 15.8-53.4 39.1l-29.3 92.8c-1.3 4.1-4.2 7.6-8.1 9.5l-32.4 16.2c-3.1 1.5-5.6 4.1-7.2 7.2l-32.5 64.9c-3.1 6.2-1.9 13.6 3 18.5L163 315l71.9-71.9L281.1 96.8C284.3 86.8 293.5 80 304 80l104 0c13.3 0 24 10.7 24 24l0 104c0 10.5-6.8 19.7-16.8 22.9L268.8 277.1 197 349l18.9 18.9c4.9 4.9 12.3 6.1 18.5 3l64.9-32.5c3.1-1.5 5.6-4.1 7.2-7.2l16.2-32.4c1.9-3.9 5.4-6.8 9.5-8.1l92.8-29.3c23.3-7.4 39.1-29 39.1-53.4c0-8.8 7.2-16 16-16l8 0c13.3 0 24 10.7 24 24l0 51.7c0 12.4-7.2 23.7-18.4 29L250.1 411.2c-6.7 3.1-12.8 7.4-18 12.7l-28.8 28.8-144-144 28.8-28.8c5.2-5.2 9.5-11.3 12.7-18L215.4 18.4C220.6 7.2 231.9 0 244.3 0L296 0c13.3 0 24 10.7 24 24l0 8zM36.7 331.3l144 144-6.9 6.9c-19.1 19.1-45 29.8-72 29.8C45.6 512 0 466.4 0 410.2c0-27 10.7-52.9 29.8-72l6.9-6.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faShuttlecock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sD);
var hD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sickle", f = 512, c = 512, e = [], t = "f822", o = "M212.7 340.7L181 309c-33.9-33.9-53-80-53-128C128 81 209 0 309 0l11 0c90.1 0 165.8 62.1 186.4 145.8c1.8 7.3-4 14.2-11.5 14.2c-3.9 0-7.5-1.9-9.9-4.9C458.9 122.9 419.5 104 377.8 104C301.7 104 240 165.7 240 241.8l0 9.8c0 20.7 5.2 39.7 12.2 58.6c2.2 6 .9 12.8-3.7 17.3l-13.2 13.2c-6.2 6.2-16.4 6.2-22.6 0zM121 311l24 24 32 32 24 24c9.4 9.4 9.4 24.6 0 33.9l-16 16c-9.4 9.4-24.6 9.4-33.9 0l-7-7L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l71-71-7-7c-9.4-9.4-9.4-24.6 0-33.9l16-16c9.4-9.4 24.6-9.4 33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSickle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hD);
var vD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sidebar", f = 512, c = 512, e = [], t = "e24e", o = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 0l0 320 224 0 0-320L224 96zM88 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 96zM64 216c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSidebar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vD);
var uD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sidebar-flip", f = 512, c = 512, e = [], t = "e24f", o = "M512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320zM288 96l0 320L64 416 64 96l224 0zm136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0zm24 120c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSidebarFlip = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uD);
var mD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sigma", f = 384, c = 512, e = [8721], t = "f68b", o = "M2.4 51.8C7.4 39.8 19.1 32 32 32l288 0c35.3 0 64 28.7 64 64l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L109.3 96 246.6 233.4c12.5 12.5 12.5 32.8 0 45.3L109.3 416 320 416l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 35.3-28.7 64-64 64L32 480c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L178.7 256 9.4 86.6C.2 77.5-2.5 63.7 2.4 51.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSigma = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mD);
var gD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sign-post", f = 512, c = 512, e = [], t = "e624", o = "M224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 129 0c9.5 0 18.5 4.2 24.6 11.5l61.9 74.2c4.9 5.9 4.9 14.6 0 20.5l-61.9 74.2c-6.1 7.3-15.1 11.5-24.6 11.5L80 256c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l144 0 0-32zm64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192 64 0 0 192z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignPost = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gD);
var PD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sign-posts", f = 576, c = 512, e = [], t = "e625", o = "M96 0C78.3 0 64 14.3 64 32L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48l480 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-16 0c0-17.7-14.3-32-32-32s-32 14.3-32 32L128 32c0-17.7-14.3-32-32-32zm32 448l-64 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zm320 0l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignPosts = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(PD);
var MD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sign-posts-wrench", f = 640, c = 512, e = [], t = "e626", o = "M96 0C78.3 0 64 14.3 64 32L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48l336 0c-20.1-26.7-32-60-32-96c0-49.9 22.9-94.5 58.6-123.8c14.2-11.7 32.6-12.2 46.7-4.6c13.6 7.3 22.7 21.7 22.7 38.3l0 58.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-58.1c0-16.6 9.1-31 22.7-38.3c2.9-1.6 6.1-2.8 9.3-3.7L576 80c0-26.5-21.5-48-48-48l-16 0c0-17.7-14.3-32-32-32s-32 14.3-32 32L128 32c0-17.7-14.3-32-32-32zm32 448l-64 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zM640 320c0-39.9-18.3-75.6-46.9-99c-7.1-5.9-17.1-.3-17.1 9l0 58.1c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-58.1c0-9.2-9.9-14.8-17.1-9c-28.6 23.5-46.9 59.1-46.9 99c0 40.4 18.7 76.5 48 99.9l0 56.1c0 19.9 16.1 36 36 36l88 0c19.9 0 36-16.1 36-36l0-56.1c29.3-23.5 48-59.5 48-99.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignPostsWrench = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(MD);
var wD = {}, y3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-weak", f = 640, c = 512, e = ["signal-1"], t = "f68c", o = "M64 384c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalWeak = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = y3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignal1 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(wD);
var ND = {}, O3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-fair", f = 640, c = 512, e = ["signal-2"], t = "f68d", o = "M224 320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalFair = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = O3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignal2 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ND);
var zD = {}, k3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-good", f = 640, c = 512, e = ["signal-3"], t = "f68e", o = "M320 192c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32zM192 288c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32zM96 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalGood = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = k3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignal3 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(zD);
var LD = {}, A3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-strong", f = 640, c = 512, e = ["signal-4"], t = "f68f", o = "M480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352zM352 224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256zM192 288c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalStrong = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = A3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignal4 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(LD);
var CD = {}, r = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-bars", f = 640, c = 512, e = ["signal-alt", "signal-alt-4", "signal-bars-strong"], t = "f690", o = "M560 0c-26.5 0-48 21.5-48 48l0 416c0 26.5 21.5 48 48 48s48-21.5 48-48l0-416c0-26.5-21.5-48-48-48zM352 176l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48s-48 21.5-48 48zM240 256c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalBars = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = r;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignalAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(CD);
var DD = {}, j3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-bars-weak", f = 640, c = 512, e = ["signal-alt-1"], t = "f691", o = "M32 432c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V432z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalBarsWeak = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = j3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignalAlt1 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(DD);
var $D = {}, B3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-bars-fair", f = 640, c = 512, e = ["signal-alt-2"], t = "f692", o = "M240 256c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM80 384c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalBarsFair = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = B3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignalAlt2 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})($D);
var _D = {}, T3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-bars-good", f = 640, c = 512, e = ["signal-alt-3"], t = "f693", o = "M400 128c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48s48-21.5 48-48l0-288c0-26.5-21.5-48-48-48zM192 304l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48s-48 21.5-48 48zM32 432l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalBarsGood = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = T3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignalAlt3 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_D);
var bD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = r;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignalAlt4 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(bD);
var SD = {}, F3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-bars-slash", f = 640, c = 512, e = ["signal-alt-slash"], t = "f694", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2 608 48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 328-64-50.2L448 176c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 74.6L38.8 5.1zM288 322.9l-74.7-58.8C200.5 272.7 192 287.4 192 304l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-141.1zM448 464l0-15-96-75.6 0 90.7c0 26.5 21.5 48 48 48s48-21.5 48-48zM80 384c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalBarsSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = F3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignalAltSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(SD);
var yD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = r;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSignalBarsStrong = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yD);
var OD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-slash", f = 640, c = 512, e = [], t = "f695", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L608 451.2 608 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 369.1-64-50.2L480 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 172.8-64-50.2 0-26.6c0-17.7-14.3-32-32-32c-10.7 0-20.1 5.2-25.9 13.2L38.8 5.1zM576 512l-.3 0 .6 0-.3 0zm-96-32l0-5.8-64-50.4 0 56.2c0 17.7 14.3 32 32 32s32-14.3 32-32zM352 373.3l-64-50.4L288 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-106.7zM192 288c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32zM96 416c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(OD);
var kD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-stream", f = 576, c = 512, e = [], t = "f8dd", o = "M108.2 71c13.8 11.1 16 31.2 5 45C82.4 154.4 64 203 64 256s18.4 101.6 49.1 140c11.1 13.8 8.8 33.9-5 45s-33.9 8.8-45-5C23.7 386.7 0 324.1 0 256S23.7 125.3 63.2 76c11.1-13.8 31.2-16 45-5zm359.7 0c13.8-11.1 33.9-8.8 45 5C552.3 125.3 576 187.9 576 256s-23.7 130.7-63.2 180c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45c30.7-38.4 49.1-87 49.1-140s-18.4-101.6-49.1-140c-11.1-13.8-8.8-33.9 5-45zM232 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-27.5-74.7c-17.8 19.8-28.5 46-28.5 74.7s10.8 54.8 28.5 74.7c11.8 13.2 10.7 33.4-2.5 45.2s-33.4 10.7-45.2-2.5C129 342.2 112 301.1 112 256s17-86.2 44.8-117.3c11.8-13.2 32-14.3 45.2-2.5s14.3 32 2.5 45.2zm214.7-42.7C447 169.8 464 210.9 464 256s-17 86.2-44.8 117.3c-11.8 13.2-32 14.3-45.2 2.5s-14.3-32-2.5-45.2c17.8-19.8 28.5-46 28.5-74.7s-10.8-54.8-28.5-74.7c-11.8-13.2-10.7-33.4 2.5-45.2s33.4-10.7 45.2 2.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalStream = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kD);
var AD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signal-stream-slash", f = 640, c = 512, e = [], t = "e250", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-68.1-23.7-130.7-63.2-180c-11.1-13.8-31.2-16-45-5s-16 31.2-5 45c30.7 38.4 49.1 87 49.1 140c0 36.4-8.7 70.8-24.1 101.1l-38.7-30.4c9.5-21.7 14.8-45.6 14.8-70.8c0-45.1-17-86.2-44.8-117.3c-11.8-13.2-32-14.3-45.2-2.5s-14.3 32-2.5 45.2c17.8 19.8 28.5 46 28.5 74.7c0 10.1-1.3 19.9-3.8 29.2l-53.6-42c-5.8-24.7-28-43.2-54.5-43.2c-.2 0-.4 0-.5 0L38.8 5.1zm84.7 188.2C116.1 212.8 112 233.9 112 256c0 45.1 17 86.2 44.8 117.3c11.8 13.2 32 14.3 45.2 2.5s14.3-32 2.5-45.2c-17.8-19.8-28.5-46-28.5-74.7c0-6.8 .6-13.5 1.8-19.9l-54.3-42.8zM33 122C11.9 162 0 207.6 0 256c0 68.1 23.7 130.7 63.2 180c11.1 13.8 31.2 16 45 5s16-31.2 5-45C82.4 357.6 64 309 64 256c0-33.4 7.3-65.1 20.4-93.5L33 122z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignalStreamSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(AD);
var jD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signature-lock", f = 640, c = 512, e = [], t = "e3ca", o = "M96 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5L68.4 243.7C27.8 255.8 0 293.2 0 335.6l0 71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3l72.6 0c5.6-9.7 13.7-17.8 23.4-23.4l0-24.6c0-5.4 .4-10.8 1.1-16l-52.7 0 18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L220.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zM209.9 368c-6.7 16.3-14.2 32.3-22.3 48L384 416l0-48-174.1 0zM86.8 305l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2L79.9 411.7c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5l0-71.9c0-14.1 9.3-26.6 22.8-30.7zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignatureLock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jD);
var BD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "signature-slash", f = 640, c = 512, e = [], t = "e3cb", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416l53 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-114.2 0-61.2-48L544 320c17.7 0 32-14.3 32-32s-14.3-32-32-32l-83.6 0 18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96c-37 0-69.1 20.9-85.1 51.6L38.8 5.1zM192.1 125.3C193.5 108.9 207.2 96 224 96c17.7 0 32 14.3 32 32l0 7.8c0 12.8-.5 25.6-1.5 38.3l-62.4-48.9zM355.3 253.2l42.8-12.8-12.3 36.8-30.5-23.9zm-190.9-9.5c-40.6 12.2-68.4 49.6-68.4 92l0 71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c17.5-30.5 31.9-62.7 43.1-95.9L181.1 238.7l-16.7 5zm67.4 46.6c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5l0-71.9c0-14.1 9.3-26.6 22.8-30.7l49-14.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.3 0c-.2-2.8-.3-5.6-.3-8.5L64 368l-40 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSignatureSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(BD);
var TD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sim-cards", f = 448, c = 512, e = [], t = "e251", o = "M160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-210.7c0-17-6.7-33.3-18.7-45.3L352 18.7C340 6.7 323.7 0 306.7 0L160 0zm48 144l0 48-48 0 0-16c0-17.7 14.3-32 32-32l16 0zm-48 80l64 0 96 0 64 0 0 48-64 0-96 0-64 0 0-48zm224-32l-48 0 0-48 16 0c17.7 0 32 14.3 32 32l0 16zm-80-48l0 48-64 0 0-48 64 0zm80 160l0 16c0 17.7-14.3 32-32 32l-16 0 0-48 48 0zm-80 48l-64 0 0-48 64 0 0 48zm-96 0l-16 0c-17.7 0-32-14.3-32-32l0-16 48 0 0 48zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-224 0c-48.6 0-88-39.4-88-88l0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSimCards = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(TD);
var FD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "siren", f = 448, c = 512, e = [], t = "e02d", o = "M73 152.1L48 352l57.9 0 22.2-178c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9L138.1 352 400 352 375 152.1C371 120 343.8 96 311.5 96l-175 0C104.2 96 77 120 73 152.1zM32 384c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L32 384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSiren = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(FD);
var HD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "siren-on", f = 640, c = 512, e = [], t = "e02e", o = "M69.3 36l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM597.3 76l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM144 352l25-199.9c4-32 31.2-56.1 63.5-56.1l175 0c32.3 0 59.5 24 63.5 56.1L496 352l-261.9 0 21.8-174c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9L201.9 352 144 352zM96 416c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32l0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSirenOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(HD);
var RD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "skeleton", f = 512, c = 512, e = [], t = "f620", o = "M256 0c17.7 0 32 14.3 32 32l0 32 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0 0 32 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0 0 32 96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 64c0 .8 0 1.6-.1 2.3l67.6-29c8.3-3.5 17.2-5.4 26.1-5.4c36.7 0 66.4 29.7 66.4 66.4l0 1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3l-204.3 0c-16.6 0-32.4-6.6-44.1-18.3L83.9 467.9c-12.7-12.7-19.9-30-19.9-48l0-1.5c0-36.7 29.7-66.4 66.4-66.4c9 0 17.9 1.8 26.1 5.4l67.6 29c-.1-.8-.1-1.5-.1-2.3l0-64-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-32L32 224c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0 0-32L96 128c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0 0-32c0-17.7 14.3-32 32-32zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSkeleton = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(RD);
var UD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "skeleton-ribs", f = 640, c = 512, e = [], t = "e5cb", o = "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-27.8 0c-33.5 0-65.7 17.6-82.1 48.9C150.5 165.8 96 282.2 96 384l0 17c0 43.6 35.4 79 79 79c15.1 0 30.1-2.7 44.2-8l67.1-25.2c.6-.2 1.1-.4 1.7-.6l0 33.8c0 17.7 14.3 32 32 32s32-14.3 32-32l0-33.8c.6 .2 1.1 .4 1.7 .6L420.8 472c14.1 5.3 29.1 8 44.2 8c43.6 0 79-35.4 79-79l0-17c0-101.8-54.5-218.2-82.2-271.1C445.5 81.6 413.3 64 379.8 64L352 64l0-32zm-64 96l0 38.3-72.7 16.2c7-15.2 13.8-28.7 19.6-40c4.5-8.6 13.9-14.5 25.3-14.5l27.8 0zM186 254.6l102-22.7 0 39.7L171.2 303.4c4.1-16.5 9.2-32.9 14.7-48.8zM160.3 372.7L288 337.9l0 42c-8.2 1.7-16.3 4-24.2 7l-67.1 25.2c-7 2.6-14.3 3.9-21.7 3.9c-8.3 0-15-6.7-15-15l0-17c0-3.7 .1-7.5 .3-11.3zM352 379.9l0-40.9 118.8 35.6c3 .9 6.1 1.3 9.1 1.4c.1 2.7 .1 5.3 .1 8l0 17c0 8.3-6.7 15-15 15c-7.4 0-14.8-1.3-21.7-3.9l-67.1-25.2c-7.9-3-16-5.3-24.2-7zm117.8-72.4L352 272.2l0-40.3 102 22.7c6 17.2 11.4 35.1 15.7 53zm-45-125L352 166.3l0-38.3 27.8 0c11.4 0 20.8 5.9 25.3 14.5c5.9 11.3 12.6 24.8 19.6 40zM0 144l0 96L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-240c0-10.1 4.7-19.6 12.8-25.6l25.6-19.2C118.5 183.1 128 164.1 128 144c0-35.3-28.7-64-64-64S0 108.7 0 144zM576 80c-35.3 0-64 28.7-64 64c0 20.1 9.5 39.1 25.6 51.2l25.6 19.2c8.1 6 12.8 15.5 12.8 25.6l0 240c0 17.7 14.3 32 32 32s32-14.3 32-32l0-240 0-96c0-35.3-28.7-64-64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSkeletonRibs = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(UD);
var qD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ski-boot", f = 512, c = 512, e = [], t = "e3cc", o = "M383.4 38c3.3-17.4-8-34.1-25.4-37.5s-34.1 8-37.5 25.4l-1.2 6-73.7 0c-22.1 130.8-76 201.3-127.2 238.9c-26.2 19.3-51.2 29.5-69.9 35c-6.3 1.8-11.8 3.1-16.5 4L.6 474c-1.8 9.4 .7 19.1 6.8 26.4S22.5 512 32 512l416 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-72c0-12.3-7-23.4-18-28.8L340 288l-68 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l69.5 0 12.3-64L288 192c-8.8 0-16-7.2-16-16s7.2-16 16-16l72 0 17.3-90 6.2-32zM38.8 275.4c.3-.1 .6-.2 .9-.3c15.6-4.6 37.1-13.3 59.9-30c43-31.6 92.3-92.9 113.7-213.1L112 32C96.7 32 83.5 42.9 80.6 58L38.8 275.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSkiBoot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qD);
var GD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ski-boot-ski", f = 640, c = 512, e = [], t = "e3cd", o = "M390.3 .6c17.3 3.5 28.6 20.3 25.1 37.7l-6.4 32L397.4 128 336 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l55 0-9.6 48L320 208c-8.8 0-16 7.2-16 16s7.2 16 16 16l62.2 0 78.7 34.7c11.6 5.1 19.1 16.6 19.1 29.3l0 80c0 17.7-14.3 32-32 32l-328 0c-9.6 0-18.7-4.3-24.7-11.7s-8.5-17.2-6.6-26.6l24.7-123.6c2.9-.5 6.1-1.2 9.5-2.1c15.6-3.9 36.4-11.6 58.3-26.9c42.4-29.7 86.4-86.4 104.5-193.1l65.7 0 1.3-6.3C356.1 8.4 372.9-2.8 390.3 .6zM162.8 198.9c-15.8 11-30.8 17.2-42.6 20.7L152.6 57.7c3-15 16.1-25.7 31.4-25.7l69.2 0c-17.4 96-56.7 143.3-90.4 166.9zM640 416c0 53-43 96-96 96L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l512 0c17.7 0 32-14.3 32-32s14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSkiBootSki = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(GD);
var WD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = a3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSkiJump = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(WD);
var ED = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = e3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSkiLift = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ED);
var VD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "skull-cow", f = 640, c = 512, e = [], t = "f8de", o = "M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5C0 166.1 57.2 224 128 224l0-16 0-16 0-32 0-16 0-16-23 0c-28.7 0-52.7-21.7-55.6-50.3c-.8-7.8 .1-15.8 2.6-23.2L63.2 21.1zM240 96c-44.2 0-80 35.8-80 80l0 112c0 37 25.2 68.2 59.3 77.3l27.6 110.3c5.3 21.4 24.5 36.4 46.6 36.4l53 0c22 0 41.2-15 46.6-36.4l27.6-110.3C454.8 356.2 480 325 480 288l0-112c0-44.2-35.8-80-80-80L240 96zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM584.4 1.9c-6.8 3.7-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2C587.7 106.3 563.7 128 535 128l-23 0 0 16 0 16 0 32 0 16 0 16c70.8 0 128-57.9 128-128.5c0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSkullCow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(VD);
var ID = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "slash-back", f = 320, c = 512, e = [], t = "5c", o = "M16.1 4.2C.8 13-4.6 32.5 4.2 47.9l256 448c8.8 15.3 28.3 20.7 43.7 11.9s20.7-28.3 11.9-43.7l-256-448C51 .8 31.5-4.6 16.1 4.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSlashBack = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ID);
var KD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "slash-forward", f = 320, c = 512, e = [], t = "2f", o = "M303.9 4.2c15.3 8.8 20.7 28.3 11.9 43.7l-256 448c-8.8 15.3-28.3 20.7-43.7 11.9S-4.6 479.5 4.2 464.1l256-448C269 .8 288.5-4.6 303.9 4.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSlashForward = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(KD);
var XD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = n3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSledding = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(XD);
var QD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "slider", f = 512, c = 512, e = [], t = "e252", o = "M352 160l0 192-32 0 0-192 32 0zM320 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l32 0c35.3 0 64-28.7 64-64l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64c0-35.3-28.7-64-64-64l-32 0zM0 256c0 17.7 14.3 32 32 32l192 0 0-64L32 224c-17.7 0-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSlider = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(QD);
var JD = {}, H3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-sliders", f = 448, c = 512, e = ["sliders-h-square"], t = "f3f0", o = "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zm0-144c0 17.7-14.3 32-32 32l-32 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16L96 368c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 32 0c17.7 0 32 14.3 32 32zM352 144c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareSliders = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = H3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSlidersHSquare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(JD);
var YD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sliders-simple", f = 512, c = 512, e = [], t = "e253", o = "M96 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm90.5 0L480 320c17.7 0 32 14.3 32 32s-14.3 32-32 32l-293.5 0c-13.2 37.3-48.7 64-90.5 64c-53 0-96-43-96-96s43-96 96-96c41.8 0 77.4 26.7 90.5 64zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-58.5-32c13.2-37.3 48.7-64 90.5-64c53 0 96 43 96 96s-43 96-96 96c-41.8 0-77.4-26.7-90.5-64L32 192c-17.7 0-32-14.3-32-32s14.3-32 32-32l293.5 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSlidersSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(YD);
var R3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sliders-up", f = 512, c = 512, e = ["sliders-v"], t = "f3f1", o = "M96 0c17.7 0 32 14.3 32 32l0 54.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3L128 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-246.7C35.7 221 16 192.8 16 160s19.7-61 48-73.3L64 32C64 14.3 78.3 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 32.8-19.7 61-48 73.3l0 54.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-54.7c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3L224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 246.7c28.3 12.3 48 40.5 48 73.3zM448 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 73.3L448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-214.7c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3L384 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 86.7c28.3 12.3 48 40.5 48 73.3s-19.7 61-48 73.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSlidersUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R3);
var ZD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = R3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSlidersV = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ZD);
var pD = {}, U3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-sliders-vertical", f = 448, c = 512, e = ["sliders-v-square"], t = "f3f2", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 0c-17.7 0-32 14.3-32 32l0 32-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-32c0-17.7-14.3-32-32-32zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareSlidersVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = U3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSlidersVSquare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(pD);
var xD = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "slot-machine", f = 640, c = 512, e = [], t = "e3ce", o = "M128 0C92.7 0 64 28.7 64 64l384 0c0-35.3-28.7-64-64-64L128 0zM64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l0 32c0 35.3 28.7 64 64 64l288 0 32 0 80 0c53 0 96-43 96-96l0-204.2c9.8-8.8 16-21.6 16-35.8c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 14.2 6.2 27 16 35.8L560 416c0 17.7-14.3 32-32 32l-80 0 0-32c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 96zM56 200c0-13.3 10.7-24 24-24l59.9 0c23 0 38.5 23.5 29.4 44.6L126.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L115.6 224 80 224c-13.3 0-24-10.7-24-24zm168-24l59.9 0c23 0 38.5 23.5 29.4 44.6L270.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L259.6 224 224 224c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 24c0-13.3 10.7-24 24-24l59.9 0c23 0 38.5 23.5 29.4 44.6L414.1 321.5c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5L403.6 224 368 224c-13.3 0-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSlotMachine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xD);
var i$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ma;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSmilePlus = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(i$);
var a$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "smoke", f = 640, c = 512, e = [], t = "f760", o = "M172.3 194.3c-9.2-1.5-18.7-2.3-28.3-2.3c-29.2 0-56.7 7.1-80.9 19.6C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-11.5 7.3-22 16-31.2 25.9C372.7 102.8 347.2 96 320 96c-66.5 0-123.5 40.6-147.7 98.3zm276.3 62.5C419.5 217.5 372.7 192 320 192c-31.5 0-60.9 9.1-85.7 24.9c-9.6-5.8-19.8-10.6-30.5-14.5C224 158.5 268.4 128 320 128c31.3 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9C563.1 284.5 516.9 256 464 256c-5.2 0-10.3 .3-15.4 .8zM144 512C64.5 512 0 447.5 0 368s64.5-144 144-144c34.5 0 66.1 12.1 90.9 32.3C257.6 236.2 287.4 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112s-50.1 112-112 112l-320 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSmoke = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a$);
var e$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "snake", f = 512, c = 512, e = [128013], t = "f716", o = "M483.4 65.7L403.6 25.8c-30.8-15.4-68-9.4-92.3 15L288 64 176 64C96.5 64 32 128.5 32 208s64.5 144 144 144l144 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-63.9 0-.1 0-144.4 0c-10.3 0-20.6 1.7-30.4 4.9l-66 22C6.1 446 0 454.4 0 464s6.1 18 15.2 21.1l66 22c9.8 3.3 20 4.9 30.4 4.9l64.3 0 .1 0 144 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-144 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l112 0 23.2 23.2c24.3 24.3 61.5 30.4 92.3 15l79.8-39.9c17.5-8.8 28.6-26.7 28.6-46.3s-11.1-37.5-28.6-46.3zM352 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSnake = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e$);
var q3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "snooze", f = 448, c = 512, e = [128164, "zzz"], t = "f880", o = "M192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5s16.5 17.7 28.6 17.7l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S300.1 0 288 0L192 0zM320 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0-57.6 76.8c-7.3 9.7-8.4 22.7-3 33.5s16.5 17.7 28.6 17.7l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 57.6-76.8c7.3-9.7 8.4-22.7 3-33.5S428.1 224 416 224l-96 0zM32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l91.7 0L7.4 459.5c-7.9 9.5-9.7 22.8-4.4 34.1S19.6 512 32 512l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-91.7 0L216.6 308.5c7.9-9.5 9.7-22.8 4.4-34.1s-16.6-18.4-29-18.4L32 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSnooze = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q3);
var n$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "snow-blowing", f = 640, c = 512, e = [], t = "f761", o = "M512 48l32 0c53 0 96 43 96 96s-43 96-96 96l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM176 64c13.3 0 24 10.7 24 24l0 25.4 12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6l0 55.8 48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3l-48.2-12.9L224 256l48.3 27.9L320.6 271c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2L200 297.6l0 55.8 35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6l0 25.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25.4-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152 353.4l0-55.8-48.3 27.9L90.7 373.7c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7C31 367.4 16.4 363.5 9.7 352s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6s11.1-13.6 19.6-11.3l48.2 12.9L128 256 79.7 228.1 31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2L152 214.4l0-55.8-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L152 113.4 152 88c0-13.3 10.7-24 24-24zM480 432c0-17.7 14.3-32 32-32l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-120 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l120 0c53 0 96 43 96 96s-43 96-96 96l-24 0c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSnowBlowing = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n$);
var f$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "snowflake-droplets", f = 640, c = 512, e = [], t = "e5c1", o = "M320 0c17.7 0 32 14.3 32 32l0 30.1 15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49 0 70.3 61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.7 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L383.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 21.5 12.6-29.3 57-22.7-13.2 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L352 311.7l0 70.3 49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15 0 30.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-30.1-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49 0-70.3-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L145 395.1l-29.3-57 21.5-12.6-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L256.5 256l-60.9-35.5-67.7 18.1c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8-25.3-14.8c-15.3-8.9-20.4-28.5-11.5-43.8s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L288 200.3l0-70.3L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15L288 32c0-17.7 14.3-32 32-32zM519.1 418.1l47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5c0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSnowflakeDroplets = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f$);
var c$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "snowflakes", f = 640, c = 512, e = [], t = "f7cf", o = "M224 0c17.7 0 32 14.3 32 32l0 30.1 15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49 0 70.3 61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7l0 70.3 49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15 0 30.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-30.1-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49 0-70.3-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3l0-70.3L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15L192 32c0-17.7 14.3-32 32-32zM487 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSnowflakes = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c$);
var t$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = f3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSnowmobile = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(t$);
var o$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "solar-system", f = 512, c = 512, e = [], t = "e02f", o = "M448 256c0 41.9-13.4 80.6-36.2 112.2C387.3 370.3 368 390.9 368 416c0 26.5 21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c18.6 11.8 32 31.1 36 53.6C199.4 70.4 227 64 256 64c106 0 192 86 192 192zM256 448C150 448 64 362 64 256c0-41.9 13.4-80.6 36.2-112.2C124.7 141.7 144 121.1 144 96c0-26.5-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-18.5-11.9-31.8-31.3-35.6-53.8C312.5 441.6 285 448 256 448zM389.2 182.7c1.8-4.6 2.8-9.5 2.8-14.7c0-22.1-17.9-40-40-40c-4 0-7.8 .6-11.5 1.7C316.4 113.5 287.3 104 256 104c-83.9 0-152 68.1-152 152s68.1 152 152 152s152-68.1 152-152c0-26.6-6.8-51.5-18.8-73.3zM312 168.4c.2 20.6 16 37.6 36.2 39.5c7.5 14.4 11.8 30.8 11.8 48.2c0 57.4-46.6 104-104 104s-104-46.6-104-104s46.6-104 104-104c20.6 0 39.8 6 56 16.4zm8 87.6a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSolarSystem = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o$);
var l$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ai;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(l$);
var d$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = l1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(d$);
var r$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = d1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortCircleDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(r$);
var s$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = r1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortCircleUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(s$);
var h$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = oi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortShapesDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(h$);
var v$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ci;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortShapesDownAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(v$);
var u$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Li;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortShapesUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(u$);
var m$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = zi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortShapesUpAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(m$);
var g$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = ei;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortSizeDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(g$);
var P$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = fi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortSizeDownAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(P$);
var M$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = wi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortSizeUp = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(M$);
var w$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ni;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortSizeUpAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(w$);
var N$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Mi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSortUpDown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(N$);
var z$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Qi;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSoup = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(z$);
var L$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "space-station-moon", f = 512, c = 512, e = [], t = "e033", o = "M512 256c0 7.8-.3 15.5-1 23.1C438.8 304.7 351.2 320 256 320s-182.8-15.3-255-40.9c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0S512 114.6 512 256zM256 512C134.9 512 33.4 427.9 6.8 314.8C79.4 338.4 164.7 352 256 352s176.6-13.6 249.2-37.2C478.6 427.9 377.1 512 256 512zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpaceStationMoon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L$);
var C$ = {}, G3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "space-station-moon-construction", f = 512, c = 512, e = ["space-station-moon-alt"], t = "e034", o = "M512 256c0 7.8-.3 15.5-1 23.1C438.8 304.7 351.2 320 256 320s-182.8-15.3-255-40.9c-.7-7.6-1-15.3-1-23.1C0 114.6 114.6 0 256 0c57.8 0 111.1 19.1 153.9 51.4c3.9 2.9 6.1 7.5 6.1 12.4L416 80c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 16 0c8.8 0 16 7.2 16 16l0 32c0 8.8 7.2 16 16 16l31.9 0c8.1 0 14.9 6 15.5 14.1c.4 5.9 .6 11.9 .6 17.9zM256 512C134.9 512 33.4 427.9 6.8 314.8C79.4 338.4 164.7 352 256 352c44.3 0 87.3-3.2 128-9.2l0 25.2c0 8.8 7.2 16 16 16l32 0c8.8 0 16 7.2 16 16l0 19.3c0 3.9-1.4 7.7-4.1 10.5C397.2 480.4 330.3 512 256 512zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpaceStationMoonConstruction = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = G3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSpaceStationMoonAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(C$);
var D$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "spade", f = 512, c = 512, e = [9824], t = "f2f4", o = "M278 12.5c-12.3-11.7-31.7-11.7-44 0L168 75.1 40 196.3c-51.3 48.6-53.5 129.6-4.9 181s129.6 53.5 181 4.9l8-7.6 0 73.4-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-73.4 8 7.6c51.3 48.6 132.3 46.4 181-4.9s46.4-132.3-4.9-181L344 75.1 278 12.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpade = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D$);
var $$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sparkle", f = 448, c = 512, e = [], t = "e5d6", o = "M245.8 45.9C241.9 37.4 233.4 32 224 32s-17.9 5.4-21.8 13.9L142.7 174.7 13.9 234.2C5.4 238.1 0 246.6 0 256s5.4 17.9 13.9 21.8l128.8 59.5 59.5 128.8c3.9 8.5 12.4 13.9 21.8 13.9s17.9-5.4 21.8-13.9l59.5-128.8 128.8-59.5c8.5-3.9 13.9-12.4 13.9-21.8s-5.4-17.9-13.9-21.8L305.3 174.7 245.8 45.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSparkle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($$);
var _$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sparkles", f = 512, c = 512, e = [10024], t = "f890", o = "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSparkles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_$);
var b$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "speaker", f = 384, c = 512, e = [], t = "f8df", o = "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM304 336A112 112 0 1 0 80 336a112 112 0 1 0 224 0zM192 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpeaker = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b$);
var S$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "speakers", f = 640, c = 512, e = [], t = "f8e0", o = "M64 0L280.4 0C265.2 17 256 39.4 256 64l0 193.6c-20.3-20.7-48.7-33.6-80-33.6c-61.9 0-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6l0 33.6c0 24.6 9.2 47 24.4 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM320 503.4c-19.1-11.1-32-31.7-32-55.4l0-112 0-272c0-23.7 12.9-44.4 32-55.4C329.4 3.1 340.3 0 352 0L576 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-224 0c-11.7 0-22.6-3.1-32-8.6zM352 336a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM176 272a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 336a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpeakers = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S$);
var y$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "spider-black-widow", f = 512, c = 512, e = [], t = "f718", o = "M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5L176 174.1l0-14.1c0-31.8 18.6-59.3 45.5-72.2c9.1-4.4 18.5 3.3 18.5 13.4l0 10.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c0-10.1 9.4-17.7 18.5-13.4C317.4 100.7 336 128.2 336 160l0 14.1 48.3-48.3c2.2-2.2 2.9-5.6 1.8-8.5L353.6 32.6c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8L430.9 100c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-80.4-26.8 57.4 57.4c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-32.3 32.3c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l57.4-57.4L70.8 321.7c-2.4 .8-4.3 2.7-5.1 5.1L46.8 383.6C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4L116.1 256 55.6 235.8c-16.7-5.6-29.8-18.7-35.4-35.4L1.2 143.6C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8L93.7 159.7C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm73.8 305.6L240 336l-21.6 28.8c-1.6 2.1-2.4 4.6-2.4 7.2c0 6.6 5.4 12 12 12l56 0c6.6 0 12-5.4 12-12c0-2.6-.8-5.1-2.4-7.2L272 336l21.6-28.8c1.6-2.1 2.4-4.6 2.4-7.2c0-6.6-5.4-12-12-12l-56 0c-6.6 0-12 5.4-12 12c0 2.6 .8 5.1 2.4 7.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpiderBlackWidow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y$);
var O$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "spider-web", f = 576, c = 512, e = [128376], t = "f719", o = "M133.8 22.2c4.8-12.7 18-20.2 31.4-17.7l69 12.9c35.6 6.7 72.1 6.7 107.6 0l69-12.9c13.4-2.5 26.6 5 31.4 17.7l28.9 77.2c11.5 30.7 28.1 59.2 49.1 84.4l45.3 54.3c8.7 10.4 8.7 25.5 0 35.9l-45.3 54.3c-21 25.2-37.6 53.7-49.1 84.4l-28.9 77.2c-4.8 12.7-18 20.2-31.4 17.7l-69-12.9c-35.6-6.7-72.1-6.7-107.6 0l-69 12.9c-13.4 2.5-26.6-5-31.4-17.7l-28.9-77.2C93.3 382 76.7 353.4 55.7 328.2L10.5 273.9c-8.7-10.4-8.7-25.5 0-35.9l45.3-54.3c21-25.2 37.6-53.7 49.1-84.4l28.9-77.2zm33.3 70.6L157.3 119c-13.7 36.6-33.5 70.6-58.5 100.6L88.4 232l44.6 0c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7L167.1 92.8zm42.1-23.1l21.4 37.4c37.7 9.5 77.2 9.5 114.9 0l21.4-37.4-14.7 2.8c-42.4 7.9-85.9 7.9-128.3 0l-14.7-2.8zM408.9 92.8l-22.2 38.8 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4l44.6 0-10.3-12.4c-25-30-44.8-64-58.5-100.6l-9.8-26.2zM487.6 280L443 280c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 21.6 37.9 9.8-26.2c13.7-36.6 33.5-70.6 58.5-100.6L487.6 280zM366.8 442.3l-19.5-34.2c-37.9-11.7-78.3-12.8-116.7-3.2l-21.3 37.4 14.7-2.7c42.4-7.9 85.9-7.9 128.3 0l14.7 2.7zM167.1 419.2l22.2-38.8-2.5-7c-12.1-34.2-30.3-65.8-53.7-93.4l-44.6 0 10.3 12.4c25 30 44.8 64 58.5 100.6l9.8 26.2zM193.2 280c10.1 15 18.9 30.7 26.5 47.1L246.6 280l-53.4 0zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1L288 304.4l-26.9 47zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7l-53.8 0 27.3 47.7zM382.8 232c-10.1-15-18.9-30.7-26.5-47.1L329.4 232l53.4 0zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0L288 207.6 314.7 161zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1l53.4 0-26.9-47.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpiderWeb = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O$);
var k$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "spinner-scale", f = 512, c = 512, e = [], t = "e62a", o = "M256 116a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm0 364a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM448 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm399.4-96.2A56 56 0 1 1 352.2 80.6a56 56 0 1 1 79.2 79.2zM97.6 414.4a32 32 0 1 1 45.3-45.3A32 32 0 1 1 97.6 414.4zm271.5 0a32 32 0 1 1 45.3-45.3 32 32 0 1 1 -45.3 45.3zM86.3 86.3a48 48 0 1 1 67.9 67.9A48 48 0 1 1 86.3 86.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpinnerScale = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k$);
var A$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "spinner-third", f = 512, c = 512, e = [], t = "f3f4", o = "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSpinnerThird = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A$);
var j$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "split", f = 512, c = 512, e = [], t = "e254", o = "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-37.5 0c-8.5 0-16.6 3.4-22.6 9.4L237.3 256l86.6 86.6c6 6 14.1 9.4 22.6 9.4l37.5 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-37.5 0c-25.5 0-49.9-10.1-67.9-28.1L178.7 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l146.7 0 99.9-99.9c18-18 42.4-28.1 67.9-28.1L384 96l0-32c0-12.9 7.8-24.6 19.8-29.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSplit = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j$);
var B$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sportsball", f = 512, c = 512, e = [], t = "e44b", o = "M487.6 48.9c-.1-.5-.2-1-.3-1.5L365.3 169.3c34.8 30.2 79 49.8 127.6 53.9c9.3-63 4.7-125.5-5.4-174.3zM464.8 24.6c-1.1-.3-2.2-.5-3.3-.7c-65.6-11-122.9-12.5-172.8-6c3.9 49.1 23.6 93.7 54 128.8L464.8 24.6zM446 358.4c19.8-32.3 33-67.7 41.1-103.6c-55.1-5.3-105.1-28.1-144.4-62.8l-64 64L418.5 395.9c10.3-11.8 19.4-24.4 27.4-37.5zM320 169.4c-35-39.7-57.9-90.3-63-146.1c-17 3.6-33 8.3-48.1 13.9c-37 13.7-67.8 33-93.1 56L256 233.4l64-64zM233.4 256L93.4 116.1C83.2 127.9 74.1 140.5 66 153.6c-19.8 32.3-33 67.7-41.1 103.6c55.1 5.3 105.1 28.1 144.4 62.8l64-64zM192 342.6c35 39.7 58 90.3 63 146.1c17-3.6 33-8.3 48.1-13.9c37-13.7 67.8-33 93.1-56L256 278.6l-64 64zm-45.3 .1c-34.8-30.2-79-49.8-127.6-53.9c-9.3 63-4.7 125.5 5.4 174.3c.1 .5 .2 1 .3 1.5L146.7 342.7zm22.6 22.6L47.2 487.4c1.1 .3 2.2 .5 3.3 .7c65.6 11 122.9 12.5 172.8 6c-3.9-49.1-23.6-93.7-54-128.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSportsball = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B$);
var T$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sprinkler", f = 512, c = 512, e = [], t = "e035", o = "M24 0a24 24 0 1 1 0 48A24 24 0 1 1 24 0zM0 128a24 24 0 1 1 48 0A24 24 0 1 1 0 128zM0 232a24 24 0 1 1 48 0A24 24 0 1 1 0 232zM64 72a24 24 0 1 1 48 0A24 24 0 1 1 64 72zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm360 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM448 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-40-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 64c17.7 0 32 14.3 32 32l0 160 100.2 0c15.3 0 27.8 12.4 27.8 27.8c0 7.8-3.3 15.2-9 20.5L320 384l0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-96-87-79.7c-5.7-5.3-9-12.7-9-20.5c0-15.3 12.4-27.8 27.8-27.8L224 256l0-160c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSprinkler = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T$);
var F$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sprinkler-ceiling", f = 384, c = 512, e = [], t = "e44c", o = "M0 0L0 96c0 15.3 10.8 28.4 25.7 31.4L128 147.8l0-65.3L64 69.8 64 0 0 0zM256 82.6l0 65.3 102.3-20.5c15-3 25.7-16.1 25.7-31.4l0-96L320 0l0 69.8L256 82.6zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 496a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSprinklerCeiling = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F$);
var H$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-0", f = 448, c = 512, e = [], t = "e255", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm160 96c53 0 96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64c0-53 43-96 96-96zm-48 96l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare0 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H$);
var R$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-1", f = 448, c = 512, e = [], t = "e256", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm236 35.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4 200 336l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-184c0-8.6-4.6-16.5-12-20.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare1 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R$);
var U$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-2", f = 448, c = 512, e = [], t = "e257", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM190.7 184.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336l83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare2 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U$);
var q$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-3", f = 448, c = 512, e = [], t = "e258", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L208 384c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176 152 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare3 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(q$);
var G$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-4", f = 448, c = 512, e = [], t = "e259", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm191.6 33.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l104 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-70.7 0 37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G$);
var W$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-5", f = 448, c = 512, e = [], t = "e25a", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm112 96l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare5 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W$);
var E$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-6", f = 448, c = 512, e = [], t = "e25b", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare6 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E$);
var V$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-7", f = 448, c = 512, e = [], t = "e25c", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96l144 0c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6L152 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare7 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V$);
var I$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-8", f = 448, c = 512, e = [], t = "e25d", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm232 32l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0l-16 0s0 0 0 0zm16 48l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0 16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare8 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I$);
var K$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-9", f = 448, c = 512, e = [], t = "e25e", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquare9 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K$);
var X$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-a", f = 448, c = 512, e = [], t = "e25f", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm160 96c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336l-130.3 0-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288l82.3 0L224 205.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareA = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X$);
var Q$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-a-lock", f = 576, c = 512, e = [], t = "e44d", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l256 0 0-96c-9.1 0-17.7-5.2-21.8-13.9l-12-26.1-124.4 0-12 26.1c-5.6 12-19.8 17.3-31.8 11.7s-17.3-19.8-11.7-31.8l96-208c3.9-8.5 12.4-13.9 21.8-13.9s17.9 5.4 21.8 13.9l82.4 178.6c5.6-10 13.9-18.3 23.8-24l0-24.6c0-56.4 41.7-103.1 96-110.9L448 96c0-35.3-28.7-64-64-64L64 32zM224 209.3L184 296l80 0-40-86.7zM464 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareALock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q$);
var J$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-ampersand", f = 448, c = 512, e = [], t = "e260", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM184 191.6c0 4.1 1.6 8.1 4.6 11L203 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2l-19.2 0c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4l-32.2 0c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6l19.2 0c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5l32.2 0c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareAmpersand = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J$);
var Y$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-arrow-down-left", f = 448, c = 512, e = [], t = "e261", o = "M64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM288 368c13.3 0 24-10.7 24-24s-10.7-24-24-24l-94.1 0L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135L160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24l152 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareArrowDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y$);
var Z$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-arrow-down-right", f = 448, c = 512, e = [], t = "e262", o = "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l94.1 0L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135L288 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24l-152 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareArrowDownRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z$);
var p$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-arrow-up-left", f = 448, c = 512, e = [], t = "e263", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM288 144c13.3 0 24 10.7 24 24s-10.7 24-24 24l-94.1 0L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135L160 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160c0-13.3 10.7-24 24-24l152 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareArrowUpLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p$);
var x$ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-b", f = 448, c = 512, e = [], t = "e264", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 120c0-13.3 10.7-24 24-24l92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76l-108 0c-13.3 0-24-10.7-24-24l0-104 0-104zm144 52c0-15.5-12.5-28-28-28l-68 0 0 56 68 0c15.5 0 28-12.5 28-28zM176 336l84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0 0 56z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareB = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x$);
var i_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-bolt", f = 448, c = 512, e = [], t = "e265", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm234.1 83.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272 128 272c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i_);
var a_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-c", f = 448, c = 512, e = [], t = "e266", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM167.4 199.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareC = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a_);
var e_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-code", f = 448, c = 512, e = [], t = "e267", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm262.2 71.9c-8.9 9.9-8.1 25 1.8 33.9L324.1 256l-60.2 54.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72c-9.9-8.9-25-8.1-33.9 1.8zm-78.1 33.9c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L123.9 256l60.2-54.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareCode = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e_);
var n_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-d", f = 448, c = 512, e = [], t = "e268", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm24 208l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareD = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n_);
var f_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-dashed", f = 448, c = 512, e = [], t = "e269", o = "M96 32l32 0 0 64L96 96c-17.7 0-32 14.3-32 32l0 32L0 160l0-32C0 75 43 32 96 32zM0 192l64 0 0 128L0 320 0 192zm384 0l64 0 0 128-64 0 0-128zm64-32l-64 0 0-32c0-17.7-14.3-32-32-32l-32 0 0-64 32 0c53 0 96 43 96 96l0 32zm0 192l0 32c0 53-43 96-96 96l-32 0 0-64 32 0c17.7 0 32-14.3 32-32l0-32 64 0zM64 352l0 32c0 17.7 14.3 32 32 32l32 0 0 64-32 0c-53 0-96-43-96-96l0-32 64 0zm96 128l0-64 128 0 0 64-128 0zm0-384l0-64 128 0 0 64L160 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareDashed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f_);
var c_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-dashed-circle-plus", f = 576, c = 512, e = [], t = "e5c2", o = "M96 32C43 32 0 75 0 128l0 32 64 0 0-32c0-17.7 14.3-32 32-32l32 0 0-64L96 32zM0 192L0 320l64 0 0-128L0 192zM64 352L0 352l0 32c0 53 43 96 96 96l32 0 0-64-32 0c-17.7 0-32-14.3-32-32l0-32zM384 128l0 70.6c15.3-4.3 31.4-6.6 48-6.6c5.4 0 10.7 .2 16 .7l0-64.7c0-53-43-96-96-96l-32 0 0 64 32 0c17.7 0 32 14.3 32 32zM160 480l136.2 0c-15.3-18.5-26.9-40.2-33.6-64L160 416l0 64zm0-384l128 0 0-64L160 32l0 64zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareDashedCirclePlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c_);
var t_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-divide", f = 448, c = 512, e = [], t = "e26a", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm160 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM136 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareDivide = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t_);
var o_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-down-left", f = 448, c = 512, e = [], t = "e26b", o = "M64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM288 352c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-40-40 71-71c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C290 146 285.1 144 280 144s-10 2-13.7 5.7l-71 71-40-40c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 144c0 8.8 7.2 16 16 16l144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o_);
var l_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-down-right", f = 448, c = 512, e = [], t = "e26c", o = "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM160 352c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l40-40-71-71C114 210 112 205.1 112 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l71 71 40-40c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 144c0 8.8-7.2 16-16 16l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareDownRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l_);
var d_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-e", f = 448, c = 512, e = [], t = "e26d", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 56 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 56 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-104 0-104c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareE = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d_);
var r_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-ellipsis", f = 448, c = 512, e = [], t = "e26e", o = "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareEllipsis = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r_);
var s_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-ellipsis-vertical", f = 448, c = 512, e = [], t = "e26f", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareEllipsisVertical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s_);
var h_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-f", f = 448, c = 512, e = [], t = "e270", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareF = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h_);
var v_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-g", f = 448, c = 512, e = [], t = "e271", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 224c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L248 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareG = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v_);
var u_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-i", f = 448, c = 512, e = [], t = "e272", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 160 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-160-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareI = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u_);
var m_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-j", f = 448, c = 512, e = [], t = "e273", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 152l0 136c0 53-43 96-96 96s-96-43-96-96l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareJ = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m_);
var g_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-k", f = 448, c = 512, e = [], t = "e274", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM313.1 168.8l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5 0 51.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-61.5L128 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareK = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g_);
var P_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-kanban", f = 448, c = 512, e = [], t = "e488", o = "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zm-64-96c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 192c0 17.7-14.3 32-32 32zM256 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64zM128 320c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareKanban = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P_);
var M_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-l", f = 448, c = 512, e = [], t = "e275", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM176 152l0 184 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareL = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M_);
var w_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-list", f = 448, c = 512, e = [], t = "e489", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareList = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w_);
var N_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-m", f = 448, c = 512, e = [], t = "e276", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm75.5 105.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-133.8-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2 144 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareM = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N_);
var z_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-n", f = 448, c = 512, e = [], t = "e277", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm90.3 104.5L288 294.5 288 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5 160 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareN = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z_);
var L_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-o", f = 448, c = 512, e = [], t = "e278", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 224a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareO = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(L_);
var C_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-p", f = 448, c = 512, e = [], t = "e279", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-136c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88 68 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareP = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(C_);
var D_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-q", f = 448, c = 512, e = [], t = "e27b", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 224c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareQ = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(D_);
var $_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-quarters", f = 448, c = 512, e = [], t = "e44e", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0L224 256 384 96 64 96zm0 320l320 0L224 256 64 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareQuarters = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($_);
var __ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-quote", f = 448, c = 512, e = [], t = "e329", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 128l48 0c17.7 0 32 14.3 32 32l0 24 0 24 0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zm224 80l0 39.3c0 35.2-25.4 65.2-60.2 71l-7.9 1.3c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l7.9-1.3c11.6-1.9 20.1-11.9 20.1-23.7l0-7.3-32 0c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32l48 0c17.7 0 32 14.3 32 32l0 24 0 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareQuote = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(__);
var b_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-r", f = 448, c = 512, e = [], t = "e27c", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96l104 0c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288l-44 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112c0-13.3 10.7-24 24-24zm80 112l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64 56 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareR = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(b_);
var S_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-ring", f = 448, c = 512, e = [], t = "e44f", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 224a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 160a160 160 0 1 1 0-320 160 160 0 1 1 0 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareRing = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(S_);
var y_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-root", f = 576, c = 512, e = [8730], t = "f697", o = "M282.6 78.1c8-27.3 33-46.1 61.4-46.1l200 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L344 96 238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l45.6 0c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareRoot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(y_);
var O_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-s", f = 448, c = 512, e = [], t = "e27d", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6s0 0 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareS = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O_);
var k_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-small", f = 320, c = 512, e = [], t = "e27e", o = "M0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareSmall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k_);
var A_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-star", f = 448, c = 512, e = [], t = "e27f", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 8c-6.1 0-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2L224 342.1l72.5 38.1c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6l-13.8-80.7 58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4c-2.7-5.5-8.3-8.9-14.3-8.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareStar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A_);
var j_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-t", f = 448, c = 512, e = [], t = "e280", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 112l104 0 104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareT = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j_);
var B_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-terminal", f = 448, c = 512, e = [], t = "e32a", o = "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm70.3 55.8c-9 9.8-8.3 25 1.5 33.9L148.5 256 71.8 326.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareTerminal = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B_);
var T_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-u", f = 448, c = 512, e = [], t = "e281", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 136l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareU = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(T_);
var F_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-up-left", f = 448, c = 512, e = [], t = "e282", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM288 160c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-40 40 71 71c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C290 366 285.1 368 280 368s-10-2-13.7-5.7l-71-71-40 40c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-144c0-8.8 7.2-16 16-16l144 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareUpLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(F_);
var H_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-user", f = 448, c = 512, e = [], t = "e283", o = "M81.1 416l285.7 0c-7.8-54.3-54.4-96-110.9-96l-64 0c-56.4 0-103.1 41.7-110.9 96zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareUser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(H_);
var R_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-v", f = 448, c = 512, e = [], t = "e284", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm77.5 125.3L224 322.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareV = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(R_);
var U_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-w", f = 448, c = 512, e = [], t = "e285", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm54.9 136.7L160 297.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 297.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 254.7 182.9 383.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareW = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(U_);
var q_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = s;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSquareWineGlassCrack = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(q_);
var G_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-x", f = 448, c = 512, e = [], t = "e286", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm90.3 104.5L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareX = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(G_);
var W_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-y", f = 448, c = 512, e = [], t = "e287", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm74.1 120.3L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297l0 79c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-79L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareY = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W_);
var E_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "square-z", f = 448, c = 512, e = [], t = "e288", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm72 96l176 0c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336 312 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176 136 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquareZ = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E_);
var V_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "squid", f = 544, c = 512, e = [129425], t = "e450", o = "M276 .3c-5.3-1.1-10.8 .6-14.6 4.5s-5.4 9.4-4.2 14.7l13.1 58.9c-71.9 46.2-103.4 101.8-110.6 148.4L146 213l-2.3-2.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6l56.4-56.4c18.9-18.9 18.7-49.5-.3-68.2L140.1 4.6c-6.3-6.1-16.3-6.1-22.5 .1l-2.8 2.8c-34 34-33.3 87.7-1.9 121L98.5 142.9c-18.7 18.7-18.7 49.1 0 67.9l22.6 22.6c0 0 0 0 0 0l5.7 5.7c0 0 0 0 0 0c9.3 9.4 9.3 24.5 0 33.9c-9.3 9.3-24.4 9.4-33.8 .2L76.5 256.6c-19.1-19.1-50.2-18.7-68.7 .9L4.4 261c-6.1 6.4-5.8 16.5 .6 22.6s16.5 5.8 22.6-.6l3.3-3.5c6.2-6.5 16.6-6.7 22.9-.3l10.6 10.6 .1 .2 22.6 22.6c10.1 10.2 9 26.9-2.4 35.8l-20 15.6c-3.5 2.7-7.7 4.2-12.1 4.2c-10.9 0-19.7-8.8-19.7-19.7l0-12.3c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 12.3C.9 376.8 24.1 400 52.6 400c11.5 0 22.7-3.8 31.8-10.9l28.2-21.9c9.4-7.3 22.8-6.5 31.2 1.9s9.3 21.8 1.9 31.2l-21.9 28.2c-7.1 9.1-10.9 20.3-10.9 31.8c0 28.6 23.2 51.7 51.7 51.7l12.3 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-12.3 0c-10.9 0-19.7-8.8-19.7-19.7c0-4.4 1.5-8.7 4.2-12.1l15.6-20c8.8-11.4 25.6-12.4 35.8-2.3l.1 .1L223 448.3l.1 .1 9.9 9.8c6.5 6.5 6.2 17.2-.7 23.3l-2.8 2.5c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l2.8-2.5c20.7-18.3 21.6-50.3 2.1-69.8l-9.9-9.9-5.7-5.7-.1-.1c-9.3-9.3-9.3-24.4 0-33.8l.1-.1 .1-.1c9.3-9.2 24.4-9.2 33.7 0l28.4 28.4c18.7 18.7 49.1 18.7 67.9 0L384.4 400c33.3 31.4 87 32.1 121-1.9l2.8-2.8c6.2-6.2 6.3-16.3 .1-22.5L472 335.7c-18.7-19-49.3-19.2-68.2-.3l-56.4 56.3c-6.2 6.2-16.4 6.2-22.6 0l-22.5-22.5-.1-.1-16-16c46.6-7.2 102.2-38.7 148.4-110.6l58.9 13.1c5.3 1.2 10.8-.4 14.7-4.2s5.6-9.3 4.5-14.6L489.3 120.2c9.2-30.2 17.2-64 23.4-101.5c.9-5.1-.8-10.3-4.5-13.9S499.4-.6 494.3 .2C456.7 6.5 423 14.4 392.7 23.6L276 .3zM168.9 280a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquid = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V_);
var I_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "squirrel", f = 512, c = 512, e = [], t = "f71a", o = "M160 296.2c0 2-.7 3.9-2 5.4c-18.7 22.3-30 51-30 82.3c0 70.7 57.3 128 128 128l96 0 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0c10-13.4 16-30 16-48c0-26.2-12.6-49.4-32-64c-13.4-10-30-16-48-16c-9.4 0-18.3 1.6-26.7 4.5c-8.3 2.9-17.5-1.4-20.4-9.8s1.4-17.5 9.8-20.4c11.7-4.1 24.3-6.4 37.3-6.4c17.2 0 33.5 3.9 48 10.8l0-58.8 21.2 0c26.7 0 51.7-13.4 66.6-35.6L512 192c0-53-43-96-96-96l0-20.8C416 69 411 64 404.8 64c-15.2 0-28.7 7.6-36.8 19.2C359.9 71.6 346.4 64 331.2 64C325 64 320 69 320 75.2L320 96c0 54.4-10.5 108.1-30.7 158c-.9-2-1.3-4.2-1.3-6.4L288 144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144c2.3 0 4.6-.1 6.9-.2c4.9-.2 9.1 3.5 9.1 8.4zM416 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSquirrel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I_);
var K_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "staff", f = 512, c = 512, e = [], t = "f71b", o = "M284.2 44.2C297.8 17.1 325.5 0 355.8 0L432 0c44.2 0 80 35.8 80 80l0 103.9c0 35.7-23.7 67.1-58 76.9l-3.9 1.1c-4 1.2-7.5 3.9-9.5 7.5l-19 33.6c-4.3 7.7-14.1 10.4-21.8 6.1l-32.8-18.5c-3.7-2.1-8.1-2.6-12.3-1.5l-85.5 24.4c-2.6 .7-5 2.1-6.9 4.1L81.9 497.9c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l77.3-77.3c3-3 4.7-7.1 4.7-11.3L96 304c0-8.8 7.2-16 16-16l37.5 0c4.2 0 8.3-1.7 11.3-4.7l39.4-39.4c9.6-9.6 21.5-16.6 34.6-20.4l169.6-48.5c6.9-2 11.6-8.2 11.6-15.4l0-47.7c0-8.8-7.2-16-16-16l-28.2 0c-3.7 0-7.2 2.1-8.8 5.5c-11.9 23.7-40.7 33.3-64.4 21.5s-33.3-40.7-21.5-64.4l7.2-14.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStaff = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K_);
var X_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "star-christmas", f = 512, c = 512, e = [], t = "f7d4", o = "M15.5 275.9L192 320l44.1 176.5c2.3 9.1 10.5 15.5 19.9 15.5s17.6-6.4 19.9-15.5L320 320l176.5-44.1c9.1-2.3 15.5-10.5 15.5-19.9s-6.4-17.6-15.5-19.9L320 192 275.9 15.5C273.6 6.4 265.4 0 256 0s-17.6 6.4-19.9 15.5L192 192 15.5 236.1C6.4 238.4 0 246.6 0 256s6.4 17.6 15.5 19.9zM71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zM441 71c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zm0 336l-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarChristmas = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X_);
var Q_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = s1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faStarCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Q_);
var J_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "star-exclamation", f = 576, c = 512, e = [], t = "f2f3", o = "M288.1 0c12.2 0 23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18zM288 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J_);
var Y_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "star-sharp", f = 576, c = 512, e = [], t = "e28b", o = "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176 56 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2l-158.5 0L310.9 16.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarSharp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y_);
var Z_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "star-sharp-half", f = 576, c = 512, e = [], t = "e28c", o = "M254.4 50.4L214.5 176 90.3 176 88 176l-13.3 0L56 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L56 230.4l10.5 8.2 1.8 1.4 103.7 80.7L132 446.7l-1.1 3.5L126.1 465l-5 15.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7l13-10.1 12.3-9.5 2.9-2.3L288 406.4l0-81.1 0-169.4L288 0c-10.5 0-19.7 6.8-22.9 16.7L260 32.9s0 0 0 0l-4.6 14.3-1 3.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarSharpHalf = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z_);
var p_ = {}, W3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "star-sharp-half-stroke", f = 576, c = 512, e = ["star-sharp-half-alt"], t = "e28d", o = "M56 230.4L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176l18.7 0 2.5 0 .1 0 137.2 0L258.6 37.2l.1-.3 1.3-4s0 0 0 0l5.2-16.2C268.3 6.8 277.6 0 288 0s19.7 6.8 22.9 16.7L316 32.9l1.3 4 .1 .3L361.6 176l137.2 0 .1 0 2.5 0 18.7 0c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L520 230.4l-2 1.5-.1 .1-114 88.7 44.4 139.5 .1 .4 1.4 4.5 5 15.7c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7l-13-10.1-3.7-2.9-.3-.3L288 406.4 175.8 493.7l-.3 .3-3.7 2.9-13 10.1c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l5-15.7 1.4-4.5 .1-.4 44.4-139.5L58.1 232l-.1-.1-2-1.5zM288 335.5s0 0 0 0l34.4 26.7 47.9 37.2-19.7-61.8-11.8-37.2 30.8-24L426.7 232l-65.2 0-41 0-12.4-39L288 129.5s0 0 0 0l0 205.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarSharpHalfStroke = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(W3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = W3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faStarSharpHalfAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(p_);
var x_ = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "star-shooting", f = 512, c = 512, e = [127776], t = "e036", o = "M313 41L265 89c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM170.4 157.4c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM505 41L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarShooting = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x_);
var ib = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "starfighter", f = 640, c = 512, e = [], t = "e037", o = "M353.8 14L384 256l0 208c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-208L286.2 14c1-8 7.8-14 15.9-14l35.8 0c8.1 0 14.9 6 15.9 14zM288 256l0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zM48 72c13.3 0 24 10.7 24 24l0 24c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 184 56 0 0-32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32 0 64 0 32 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-9.6L72 444l0 4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-280c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-24c0-13.3 10.7-24 24-24zm544 0c13.3 0 24 10.7 24 24l0 24c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 280c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-4-88 26.4 0 9.6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32 0-32 0-64 0-32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32 56 0 0-184c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-24c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarfighter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ib);
var ab = {}, E3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "starfighter-twin-ion-engine", f = 576, c = 512, e = ["starfighter-alt"], t = "e038", o = "M32 32c17.7 0 32 14.3 32 32l0 147.2 75.6-15.1C163.3 137.4 220.8 96 288 96s124.7 41.4 148.4 100.1L512 211.2 512 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 0 64 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-147.2-75.6 15.1C412.7 374.6 355.2 416 288 416s-124.7-41.4-148.4-100.1L64 300.8 64 448c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 288l0-64L0 64C0 46.3 14.3 32 32 32zM272 350.7l0-32.7c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5l-32.7 0c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240l32.7 0c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8l0-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zM343.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8l0 32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6L350 272c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240l32.7 0c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4l0 32.7c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM310.8 278.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarfighterTwinIonEngine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(E3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = E3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faStarfighterAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ab);
var eb = {}, V3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "starfighter-twin-ion-engine-advanced", f = 640, c = 512, e = ["starfighter-alt-advanced"], t = "e28e", o = "M148.8 7.7c13.4 11.5 15 31.7 3.5 45.1L64 155.8l0 61.8 107.6-21.5C195.3 137.4 252.8 96 320 96s124.7 41.4 148.4 100.1L576 217.6l0-69.1L488.5 53.7c-12-13-11.2-33.2 1.8-45.2s33.2-11.2 45.2 1.8L623 105.1c10.9 11.8 17 27.3 17 43.4l0 200.3c0 14.5-4.9 28.6-14 40L537 500c-11 13.8-31.2 16-45 5s-16-31.2-5-45l89-111.2 0-54.4L468.4 315.9C444.7 374.6 387.2 416 320 416s-124.7-41.4-148.4-100.1L64 294.4l0 61.8 88.3 103c11.5 13.4 9.9 33.6-3.5 45.1s-33.6 9.9-45.1-3.5l-88.3-103C5.5 386.2 0 371.4 0 356.2L0 155.8c0-15.3 5.5-30.1 15.4-41.7l88.3-103c11.5-13.4 31.7-15 45.1-3.5zM304 350.7l0-32.7c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5l-32.7 0c2.4 14.6 8.2 28.1 16.4 39.6zM225.3 240l32.7 0c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8l0-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zM375.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8l0 32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6L382 272c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM382 240l32.7 0c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4l0 32.7c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM342.8 278.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32c0 0 0 0 0 0s0 0 0 0c-17.7 0-32 14.3-32 32c0 17.7 14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarfighterTwinIonEngineAdvanced = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(V3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = V3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faStarfighterAltAdvanced = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(eb);
var nb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "stars", f = 512, c = 512, e = [], t = "f762", o = "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zm-112.4 5.1c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94zm215.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStars = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nb);
var fb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "starship", f = 640, c = 512, e = [], t = "e039", o = "M448 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 256a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm32-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM188.9 205.4L137 160l71 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l32.1 0 65.5 57.3-2.2 .4C109.1 221.4 96 237.4 96 256s13.1 34.6 31.4 38.3l2.2 .4L64.1 352 32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l176 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-71 0 51.9-45.4 43 8.6c-5.2-18.9-7.9-38.7-7.9-59.2s2.7-40.3 7.9-59.2l-43 8.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarship = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fb);
var cb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "starship-freighter", f = 576, c = 512, e = [], t = "e03a", o = "M224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8l0 42.1c0 8.8-7.2 16-16 16l-114.3 0L432 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l13.7 0L560 288c8.8 0 16 7.2 16 16l0 42.1c0 13.2-8.1 25-20.4 29.8l-82.1 31.9c4.1 7.1 6.5 15.3 6.5 24.1c0 26.5-21.5 48-48 48l-80 0c-11.5 0-21.6-6.1-27.3-15.2C292.2 474.9 258.2 480 224 480zm0-272a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStarshipFreighter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cb);
var tb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "steak", f = 576, c = 512, e = [129385], t = "f824", o = "M268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122s0 0 0 0c2.5-6 4.8-11.8 7.1-17c6.9-15.7 13.3-27.1 21.5-34.7c7.5-7 17.5-11.7 33.9-11.7c25.4 0 53.3 16.2 75.5 44c22 27.5 36.5 64.1 36.5 100c0 40.8-28.3 84.6-74.7 119.2C359.4 393.4 298.6 416 240 416c-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9c5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8c28.6-28.6 42.9-63.7 54.3-91.9zm6.8-75.2c-13.3 12.4-21.9 29-29 45.3c-2.9 6.6-5.6 13.2-8.3 19.8c-11.4 27.8-22.8 55.7-46.4 79.3c-41.4 41.4-78.6 57.1-107 69l-1.1 .5-.7 .3s0 0 0 0c-13.5 5.7-27.5 11.6-37.7 20.3C70.4 328.8 64 342.1 64 360c0 39.3 33.9 60.8 66.8 72.1C165.1 443.9 207 448 240 448c66.3 0 133.6-25.4 184.4-63.2C474.8 347.4 512 295.2 512 240c0-44.1-17.5-87.5-43.5-120C442.7 87.8 406.6 64 368 64c-23.7 0-41.7 7.3-55.6 20.3zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSteak = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tb);
var ob = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "steering-wheel", f = 512, c = 512, e = [], t = "f622", o = "M224 358.9l0 86.5C143.6 431.9 80.1 368.4 66.7 288l102.2 0L224 358.9zm64 0L343.1 288l102.2 0C431.9 368.4 368.4 431.9 288 445.3l0-86.5zM352 224l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7l-120.4 0c-12.1 0-23.2 6.8-28.6 17.7L160 224l-93.3 0C81.9 133.2 160.9 64 256 64s174.1 69.2 189.3 160L352 224zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSteeringWheel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ob);
var lb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "stocking", f = 384, c = 512, e = [], t = "f7d5", o = "M96 0C78.3 0 64 14.3 64 32l0 32c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L96 0zm0 128l0 110.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9l0 2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5L352 128 96 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStocking = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lb);
var db = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "stomach", f = 512, c = 512, e = [], t = "f623", o = "M192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 70.7 57.3 128 128 128l0 64c0 35.3-28.7 64-64 64l-64 0C57.3 352 0 409.3 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32c0-26.5 21.5-48 48-48c24.6 0 36 9.5 58.2 28.2c0 0 0 0 0 0c1.7 1.4 3.4 2.9 5.3 4.4c12.6 10.5 28.4 22.9 49.6 32.2C246.5 506.2 272 512 304 512c114.9 0 208-93.1 208-208l0-80c0-70.7-57.3-128-128-128c-47.4 0-88.7 25.7-110.9 64L256 160c-35.3 0-64-28.7-64-64l0-64zM445.1 332.7c-7.2 1.9-14.6 3.3-21.1 3.3c-16.8 .2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9 .1-17.1 2.1-25.6 4.6c1.1-6.7 1.6-13.6 1.6-20.6l0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80c0 9.8-1 19.4-2.9 28.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStomach = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(db);
var rb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "store-lock", f = 640, c = 512, e = [], t = "e4a6", o = "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c5 5.5 10.6 10.3 16.8 14.4C455.2 179.6 489.3 160 528 160c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3zM128 384l0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L64 384l0 64c0 35.3 28.7 64 64 64l264.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-96-256 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStoreLock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rb);
var sb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "strawberry", f = 512, c = 512, e = [], t = "e32b", o = "M481.5 1.9c12.2 5.2 17.8 19.3 12.6 31.5c-13.4 31.2-36.9 59-56.3 78.7c32.8 1.8 57.4 18 68.2 26.6c4 3.2 6 8.1 6 13.2s-2 10-6 13.3C495 174.4 469.7 192 440 192c-40 0-55.3-15.3-80-40s-40-40-40-80c0-29.7 17.6-55 26.7-66c3.3-4 8.2-6 13.3-6s10 2 13.2 6C382.3 17.4 400 44.3 400 80c0 .7 0 1.4 0 2.1c.7-.7 1.4-1.3 2-2c18.2-18.2 37.7-41.7 47.9-65.5c5.2-12.2 19.3-17.8 31.5-12.6zM0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l128 128c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192C48 512 0 464 0 336zM172.8 172.8c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm87.3 2.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm32-96c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm-224-96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zM108.8 364.8c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStrawberry = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sb);
var hb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "stretcher", f = 640, c = 512, e = [], t = "f825", o = "M83 79.2C64.9 59.8 34.5 58.9 15.2 77S-5.1 125.5 13 144.8L123.5 262.7c15.1 16.1 36.3 25.3 58.4 25.3L592 288c26.5 0 48-21.5 48-48s-21.5-48-48-48l-403.2 0L83 79.2zM240 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 64-46.5-81.6 0L368 336.9 344.8 320l-81.6 0 64 46.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faStretcher = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hb);
var vb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "subtitles", f = 576, c = 512, e = [], t = "e60f", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 208l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm256 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 336l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 0l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSubtitles = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vb);
var ub = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "subtitles-slash", f = 640, c = 512, e = [], t = "e610", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zm355 278.2l-1.2-.9c-5.3-4.4-8.6-11-8.6-18.4c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-5.3 0-10.2-1.7-14.2-4.6zM461 336l27 0c13.3 0 24 10.7 24 24c0 4.8-1.4 9.3-3.8 13L461 336zm26.4 144L365.5 384 312 384c-13.3 0-24-10.7-24-24c0-11.1 7.5-20.4 17.7-23.2l-62-48.8L152 288c-13.3 0-24-10.7-24-24s10.7-24 24-24l30.8 0L32 121.2 32 416c0 35.3 28.7 64 64 64l391.4 0zM152 336l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSubtitlesSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ub);
var mb = {}, I3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "train-subway-tunnel", f = 512, c = 512, e = ["subway-tunnel"], t = "e2a3", o = "M256 0C114.6 0 0 114.6 0 256L0 448c0 35.3 28.7 64 64 64l41.4 0 64.3-64.3C137.3 444.5 112 417.2 112 384l0-192c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 192c0 33.2-25.3 60.5-57.7 63.7L406.6 512l41.4 0c35.3 0 64-28.7 64-64l0-192C512 114.6 397.4 0 256 0zM361.4 512l-64-64-82.7 0-64 64 210.7 0zM184 192c-13.3 0-24 10.7-24 24l0 8 0 64 0 8c0 13.3 10.7 24 24 24l8 0 16 0 8 0c13.3 0 24-10.7 24-24l0-8 0-64 0-8c0-13.3-10.7-24-24-24l-8 0-16 0-8 0zm88 24l0 8 0 64 0 8c0 13.3 10.7 24 24 24l8 0 16 0 8 0c13.3 0 24-10.7 24-24l0-8 0-64 0-8c0-13.3-10.7-24-24-24l-8 0-16 0-8 0c-13.3 0-24 10.7-24 24zM184 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrainSubwayTunnel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(I3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = I3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSubwayTunnel = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(mb);
var gb = {}, K3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sun-bright", f = 512, c = 512, e = ["sun-alt"], t = "e28f", o = "M256 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24zm0 400c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24zM488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0zM112 256c0-13.3-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24zM437 108.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9zM154.2 357.8c-9.4-9.4-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9zM403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437zM154.2 154.2c9.4-9.4 9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSunBright = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(K3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = K3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faSunAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(gb);
var Pb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sun-cloud", f = 640, c = 512, e = [127780], t = "f763", o = "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2l-20.1 29.1C481 193 472.6 192 464 192c-32.9 0-62.4 14.2-82.9 36.7C368.6 171.1 317.3 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1c11.3 38.8 46.5 67.5 88.7 69l-9.4 51c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM352 256c0 1.9-.1 3.7-.2 5.5c-35.6 12.6-61.5 45.6-63.7 85c-10.1 3.6-20.9 5.5-32.2 5.5c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm32 160c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72l-184 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSunCloud = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pb);
var Mb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sun-dust", f = 512, c = 512, e = [], t = "f764", o = "M371.1 13.1L391 121l-44.5 44.5C323.3 142.3 291.3 128 256 128c-70.7 0-128 57.3-128 128c0 35.3 14.3 67.3 37.5 90.5L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6s8.6 6.6 9.6 11.9zM256 160c26.5 0 50.5 10.7 67.9 28.1L188.1 323.9C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96zm192 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM240 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM368 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSunDust = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mb);
var wb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sun-haze", f = 640, c = 512, e = [], t = "f765", o = "M425.5 1.2c5 2.1 8.6 6.6 9.6 11.9L455 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L510.9 256 448 256c0-70.7-57.3-128-128-128s-128 57.3-128 128l-62.9 0L66.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L185 121 204.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L320 65.1 410.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM320 160c53 0 96 43 96 96l-192 0c0-53 43-96 96-96zM616 288c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0zm-208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 336c-13.3 0-24-10.7-24-24s10.7-24 24-24l320 0zm144 88c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 424c-13.3 0-24-10.7-24-24s10.7-24 24-24l528 0zM64 488c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 512c-13.3 0-24-10.7-24-24zm208 0c0-13.3 10.7-24 24-24l320 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-320 0c-13.3 0-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSunHaze = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wb);
var Nb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sunglasses", f = 576, c = 512, e = [128374], t = "f892", o = "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1c0 0 .1 0 .1 0c0 0 0 0 0 0s0 0 0 0L247.9 288s0 0 0 0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7s0 0 0 0c-6.3-12.7-6.3-12.7-6.3-12.7s0 0 0 0s0 0 0 0c0 0 .1 0 .1 0l.2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7l0 6.7 0 41.3 0 16c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4L64 368l105.6-52.8c-10.7-1.9-22.2-3.2-33.9-3.2c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zm409.8-10.3c-10.5-1.9-21.9-3.1-33.4-3.1c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.3 41.2 102.3-51.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSunglasses = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nb);
var zb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sunrise", f = 576, c = 512, e = [127749], t = "f766", o = "M354.5 135.7L320 104.3 320 208c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-103.7-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm39.1 89.5c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L512 432l-105.3 0c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80L64 432 34.8 389.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L288 289.1l90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM0 488c0-13.3 10.7-24 24-24l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSunrise = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zb);
var Lb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sunset", f = 576, c = 512, e = [127751], t = "f767", o = "M354.5 104.3L320 135.7 320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 103.7-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm48.7 132.8c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L288 289.1l-90.3-62.3c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L153 345 45.1 364.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L64 432l105.3 0c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80L512 432l29.2-42.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L423 345 403.1 237.1zM0 488c0 13.3 10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSunset = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Lb);
var Cb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "swap", f = 640, c = 512, e = [], t = "e609", o = "M237 141.6c-5.3 11.2-16.6 18.4-29 18.4l-48 0 0 192c0 35.3 28.7 64 64 64s64-28.7 64-64l0-192c0-70.7 57.3-128 128-128s128 57.3 128 128l0 192 48 0c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1l-80 96c-6.1 7.3-15.1 11.5-24.6 11.5s-18.5-4.2-24.6-11.5l-80-96c-7.9-9.5-9.7-22.8-4.4-34.1s16.6-18.4 29-18.4l48 0 0-192c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 192c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-192-48 0c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1l80-96C109.5 4.2 118.5 0 128 0s18.5 4.2 24.6 11.5l80 96c7.9 9.5 9.7 22.8 4.4 34.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSwap = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Cb);
var Db = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "swap-arrows", f = 640, c = 512, e = [], t = "e60a", o = "M105.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L160 109.3 160 352c0 35.3 28.7 64 64 64s64-28.7 64-64l0-192c0-70.7 57.3-128 128-128s128 57.3 128 128l0 242.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L480 402.7 480 160c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 192c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-242.7L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSwapArrows = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Db);
var $b = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sword", f = 512, c = 512, e = [128481], t = "f71c", o = "M511.8 18.6c.8-5.1-.8-10.3-4.5-13.9S498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7 269.3 345.4 476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8zM84.7 228.7l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1L79.2 394.2c-2.1 2.1-5.3 2.9-8.2 1.9L37.1 384.8c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSword = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($b);
var _b = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sword-laser", f = 512, c = 512, e = [], t = "e03b", o = "M505 7c9.1 9.1 9.4 23.7 .7 33.2L285.2 281.3l-54.4-54.4L471.8 6.3c9.5-8.7 24.1-8.3 33.2 .7zM195.3 236.7l80 80c6.2 6.2 6.2 16.4 0 22.6c-6.1 6.1-15.8 6.2-22.1 .5l-81-81c-5.8-6.3-5.6-16 .5-22.1c6.2-6.2 16.4-6.2 22.6 0zm-57.7 57.7l23.7-23.7 80 80-23.7 23.7-80-80zm-11.3 11.3l80 80-20.7 20.7-80-80 20.7-20.7zM87 330.3L181.7 425l-2.3 2.3L105 501.7C98.3 508.3 89.4 512 80 512s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l74.3-74.3 2.3-2.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSwordLaser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_b);
var bb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "sword-laser-alt", f = 512, c = 512, e = [], t = "e03c", o = "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232l105.1 0L505.7 40.2zM189.3 256c-12.7 0-24.9 5.1-33.9 14.1l-49 49 27.3 27.3 32 32L193 405.7 315.3 283.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-114.7 0zm-7.6 161L160 395.3 54.3 501l3.5 3.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5L181.7 417zM43 489.7L148.7 384 128 363.3 22.3 469 43 489.7zm-32-32L116.7 352 95 330.3 7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l3.5 3.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSwordLaserAlt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bb);
var Sb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "swords", f = 512, c = 512, e = [9876], t = "f71d", o = "M96 329.4l50.7-50.7 86.6 86.6L182.6 416l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-4.7 4.7-11.8 6-17.8 3.3l-62-27.5L51.3 507.3c-6.2 6.2-16.4 6.2-22.6 0l-24-24c-6.2-6.2-6.2-16.4 0-22.6l56.2-56.2-27.5-62c-2.7-6.1-1.4-13.1 3.3-17.8l16-16c6.2-6.2 16.4-6.2 22.6 0L96 329.4zM484.5 114.2L365.3 233.4l-86.6-86.6L397.8 27.5c6.7-6.7 15.2-11.3 24.5-13.1L492.9 .3c5.2-1 10.7 .6 14.5 4.4s5.4 9.2 4.4 14.5L497.6 89.6c-1.9 9.3-6.4 17.8-13.1 24.5zM4.7 4.7C8.5 .9 13.9-.7 19.1 .3L89.6 14.4c9.3 1.9 17.8 6.4 24.5 13.1L393.4 306.7l-86.6 86.6L27.5 114.2c-6.7-6.7-11.3-15.2-13.1-24.5L.3 19.1C-.7 13.9 .9 8.5 4.7 4.7zm454.6 304l16 16c4.7 4.7 6 11.8 3.3 17.8l-27.5 62 56.2 56.2c6.2 6.2 6.2 16.4 0 22.6l-24 24c-6.2 6.2-16.4 6.2-22.6 0l-56.2-56.2-62 27.5c-6.1 2.7-13.1 1.4-17.8-3.3l-16-16c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSwords = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sb);
var yb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "swords-laser", f = 640, c = 512, e = [], t = "e03d", o = "M135 7c-9.1 9.1-9.4 23.7-.7 33.2L360 286.9l0-105.1L168.2 6.3C158.7-2.4 144.1-2.1 135 7zm263 349.7l49 49 27.3-27.3 32-32L533.7 319 411.3 196.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 114.7c0 12.7 5.1 24.9 14.1 33.9zM523.3 352L629 457.7l3.5-3.5c4.8-4.8 7.5-11.3 7.5-18.1s-2.7-13.3-7.5-18.1L545 330.3 523.3 352zM512 363.3L491.3 384 597 489.7 617.7 469 512 363.3zm-32 32L458.3 417l87.5 87.5c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5l3.5-3.5L480 395.3zM247.6 211.4l-24.7 22.6c-1.6-3.9-4.7-7.2-8.7-8.8c-6-2.5-12.9-1.1-17.4 3.5l-25.4 25.4-4.9-4.9c-12.5-12.3-32.6-12.2-45 .2c-12.5 12.5-12.5 32.8 0 45.3l4.7 4.7L7.5 417.9C2.7 422.7 0 429.2 0 436s2.7 13.3 7.5 18.1l50.3 50.3c4.8 4.8 11.3 7.5 18.1 7.5s13.3-2.7 18.1-7.5L209.9 388.7c9-9 14.1-21.2 14.1-33.9l0-6.6 74.3-81.2-50.7-55.5zm142.8-45.2l115.3-126c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L343.7 123.5l46.7 42.7zM152 344a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faSwordsLaser = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yb);
var Ob = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "t-rex", f = 640, c = 512, e = [], t = "e629", o = "M320 128l-41 0c-70.7 0-132.9 46.3-153.3 114l-5.9 19.8c-4.7 15.5-18.9 26.2-35.1 26.2C64.4 288 48 271.6 48 251.3l0-48.9c0-5.8-4.7-10.4-10.4-10.4c-3.5 0-6.7 1.7-8.7 4.6l-3.2 4.8C9 226.6 0 256.1 0 286.4C0 358 58 416 129.6 416l54.4 0 62.4 83.2c6 8.1 15.5 12.8 25.6 12.8l96 0c8.8 0 16-7.2 16-16c0-26.5-21.5-48-48-48l-18.6-49.6 28.4-25.6C359.9 360.1 368 342 368 323c0-37-30-67-67-67l-13 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l13 0c35.1 0 66 18.3 83.5 45.8l.4-.3 43.5 29c2.2 1.5 3.6 4 3.6 6.7l0 14.9c0 13.3 10.7 24 24 24s24-10.7 24-24l0-14.9c0-18.7-9.4-36.2-24.9-46.6l-30.2-20.1L464 208l96 0c20.9 0 38.7-13.4 45.3-32l-40 0c-10.6 0-20.8-4.2-28.3-11.7L523.7 151c-4.5-4.5-10.6-7-17-7L488 144c-4.4 0-8-3.6-8-8s3.6-8 8-8l18.7 0c10.6 0 20.8 4.2 28.3 11.7L548.3 153c4.5 4.5 10.6 7 17 7l42.7 0 8 0c13.3 0 24-10.7 24-24l0-24c0-44.2-35.8-80-80-80l-18.7 0C534.7 13.4 516.9 0 496 0c-8.9 0-17.2 2.4-24.3 6.6C461.9 2.3 451.2 0 440.3 0c-33.6 0-63.5 21.5-74.2 53.4L352 96l-32 32zM480 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTRex = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ob);
var kb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "table-cells-column-unlock", f = 640, c = 512, e = [], t = "e690", o = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 56 0 0 8.6c-19.1 11.1-32 31.7-32 55.4l-24 0 0 64 24 0 0 64L64 480c-35.3 0-64-28.7-64-64L0 96zm208 0l0 64 88 0 0-64-88 0zm240 0l-88 0 0 64 88 0 0-64zM208 224l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zm288-80l0 48 32 0 32 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTableCellsColumnUnlock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kb);
var Ab = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "table-cells-lock", f = 640, c = 512, e = [], t = "e679", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-64-24 0 0-64 24 0c0-23.7 12.9-44.4 32-55.4l0-8.6-56 0 0-64 66.8 0c15.8-33.2 47.5-57.5 85.2-62.9L512 96c0-35.3-28.7-64-64-64L64 32zm88 64l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0zM64 224l88 0 0 64-88 0 0-64zm232 0l0 64-88 0 0-64 88 0zM152 352l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTableCellsLock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ab);
var jb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "table-cells-unlock", f = 640, c = 512, e = [], t = "e692", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-64-24 0 0-64 24 0c0-23.7 12.9-44.4 32-55.4l0-8.6-56 0 0-64 66.8 0c15.8-33.2 47.5-57.5 85.2-62.9L512 96c0-35.3-28.7-64-64-64L64 32zm88 64l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm240 0l0 64-88 0 0-64 88 0zM64 224l88 0 0 64-88 0 0-64zm232 0l0 64-88 0 0-64 88 0zM152 352l0 64-88 0 0-64 88 0zm56 0l88 0 0 64-88 0 0-64zm288-80c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-48 0-32 0-32 0 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTableCellsUnlock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jb);
var Bb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "table-layout", f = 512, c = 512, e = [], t = "e290", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM448 96l0 64L64 160l0-64 384 0zM64 224l64 0 0 192-64 0 0-192zm384 0l0 192-256 0 0-192 256 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTableLayout = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bb);
var Tb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "table-picnic", f = 512, c = 512, e = [], t = "e32d", o = "M319.3 64L192.7 64c-.5 0-1 0-1.5 0L96 64C78.3 64 64 78.3 64 96s14.3 32 32 32l48.7 0-38.4 96L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l48.7 0 68.9 0 212.7 0 68.9 0 48.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-74.3 0-38.4-96 48.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-95.3 0c-.5 0-1 0-1.5 0zM444.1 320l-68.9 0 43.2 107.9c6.6 16.4 25.2 24.4 41.6 17.8s24.4-25.2 17.8-41.6L444.1 320zm-307.2 0l-68.9 0L34.3 404.1c-6.6 16.4 1.4 35 17.8 41.6s35-1.4 41.6-17.8L136.9 320zm38.4-96l38.4-96 84.7 0 38.4 96-161.5 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTablePicnic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Tb);
var Fb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "table-pivot", f = 512, c = 512, e = [], t = "e291", o = "M0 96C0 60.7 28.7 32 64 32l64 0 0 128L0 160 0 96zm448 64l-288 0 0-128 288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192l128 0 0 224 320 0 0-256zm-33.2 86.1c-2.5 6-8.3 9.9-14.8 9.9l-16 0 0 48c0 26.5-21.5 48-48 48l-48 0 0 16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 16 48 0c8.8 0 16-7.2 16-16l0-48-16 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTablePivot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fb);
var Hb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "table-tree", f = 512, c = 512, e = [], t = "e293", o = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM448 160l0 256L64 416l0-256 32 0 0 64 0 96c0 26.5 21.5 48 48 48l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16-7.2-16-16l0-50.7c5 1.8 10.4 2.7 16 2.7l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16l0-64 320 0zM224 240l0 32c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm80 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTableTree = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hb);
var Rb = {}, X3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tablet-screen", f = 448, c = 512, e = ["tablet-android-alt"], t = "f3fc", o = "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 448c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM384 64L64 64l0 320 320 0 0-320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTabletScreen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(X3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = X3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTabletAndroidAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Rb);
var Ub = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tablet-rugged", f = 448, c = 512, e = [], t = "f48f", o = "M32 176L8.8 164.4C3.4 161.7 0 156.2 0 150.1L0 73.9c0-6.1 3.4-11.6 8.8-14.3L34.3 46.8C41.8 19.8 66.6 0 96 0L352 0c29.4 0 54.2 19.8 61.7 46.8l25.5 12.7c5.4 2.7 8.8 8.3 8.8 14.3l0 76.2c0 6.1-3.4 11.6-8.8 14.3L416 176l0 16 23.2 11.6c5.4 2.7 8.8 8.3 8.8 14.3l0 76.2c0 6.1-3.4 11.6-8.8 14.3L416 320l0 16 23.2 11.6c5.4 2.7 8.8 8.2 8.8 14.3l0 76.2c0 6.1-3.4 11.6-8.8 14.3l-25.5 12.7c-7.5 27-32.3 46.8-61.7 46.8L96 512c-29.4 0-54.2-19.8-61.7-46.8L8.8 452.4C3.4 449.7 0 444.2 0 438.1l0-76.2c0-6.1 3.4-11.6 8.8-14.3L32 336l0-16L8.8 308.4C3.4 305.7 0 300.2 0 294.1l0-76.2c0-6.1 3.4-11.6 8.8-14.3L32 192l0-16zM112 64c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-352c0-8.8-7.2-16-16-16L112 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTabletRugged = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ub);
var qb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Va;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTachometerAltFastest = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(qb);
var Gb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ea;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTachometerAltSlow = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Gb);
var Wb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ia;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTachometerAltSlowest = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Wb);
var Eb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Xa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTachometerFastest = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Eb);
var Vb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ka;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTachometerSlow = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Vb);
var Ib = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Qa;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTachometerSlowest = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ib);
var Kb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "taco", f = 512, c = 512, e = [127790], t = "f826", o = "M274.8 38.4l44.1 34.2c5.6 4.4 12.6 6.6 19.7 6.4l55.8-1.7c14-.4 26.5 8.6 30.4 22.1l15.6 53.6c2 6.8 6.3 12.8 12.2 16.8L498.6 201c11.6 7.9 16.3 22.5 11.6 35.7l-17.1 47.7C441.1 209.2 354.3 160 256 160s-185.1 49.2-237.1 124.4L1.8 236.7c-4.7-13.1 0-27.8 11.6-35.7l46.1-31.4c5.9-4 10.2-9.9 12.2-16.8L87.3 99.3c3.9-13.4 16.4-22.5 30.4-22.1L173.4 79c7.1 .2 14.1-2 19.7-6.4l44.1-34.2c11-8.6 26.5-8.6 37.5 0zM512 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32C0 306.6 114.6 192 256 192s256 114.6 256 256zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTaco = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kb);
var Q3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tally", f = 640, c = 512, e = ["tally-5"], t = "f69c", o = "M128 32c17.7 0 32 14.3 32 32l0 211.6 64-21.3L224 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 168.9 64-21.3L352 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 126.3 64-21.3L480 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 83.6 53.9-18c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L544 215.1 544 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-211.6-64 21.3L416 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-168.9-64 21.3L288 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-126.3-64 21.3L160 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-83.6-53.9 18c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5L96 296.9 96 64c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTally = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Q3);
var Xb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tally-1", f = 640, c = 512, e = [], t = "e294", o = "M128 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32L96 64c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTally1 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xb);
var Qb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tally-2", f = 640, c = 512, e = [], t = "e295", o = "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTally2 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qb);
var Jb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tally-3", f = 640, c = 512, e = [], t = "e296", o = "M128 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32L96 64c0-17.7 14.3-32 32-32zm128 0c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32zM416 64l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-384c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTally3 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jb);
var Yb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tally-4", f = 640, c = 512, e = [], t = "e297", o = "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384zm96-32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32zM544 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTally4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yb);
var Zb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Q3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTally5 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Zb);
var pb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tamale", f = 320, c = 512, e = [129748], t = "e451", o = "M48.1 18.3C72.3 8.6 108.4 0 160 0s87.7 8.6 111.9 18.3c12.1 4.8 21 9.9 27.4 14.1c12.7 8.5 23.1 20.4 20.3 36.9L296.4 208l-.4 0H236.2L248 72.7c.4-4.4-2.9-8.3-7.3-8.7s-8.3 2.9-8.7 7.3L220.1 208H168V64c0-4.4-3.6-8-8-8s-8 3.6-8 8V208H99.9L88 71.3c-.4-4.4-4.3-7.7-8.7-7.3s-7.7 4.3-7.3 8.7L83.8 208H24l-.4 0L.4 69.3C-2.3 52.8 8.1 40.8 20.8 32.4c6.3-4.2 15.3-9.3 27.4-14.1zM24 240H296c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16s7.2-16 16-16zM152 448c0 4.4 3.6 8 8 8s8-3.6 8-8V346.7c13.4 17.9 35.9 26.5 57.4 18.1l6.6 76c.4 4.4 4.3 7.7 8.7 7.3s7.7-4.3 7.3-8.7l-7.3-84.1c14.2-13.2 18.9-33.4 12.6-51.2H296l.4 0 23.1 138.7c1.7 10.2-1.6 20.6-8.9 27.9l0 0c-10.6 10.5-25.1 17.6-38.7 23C247.7 503.4 211.6 512 160 512s-87.7-8.6-111.9-18.3c-13.7-5.5-28.1-12.5-38.7-23l0 0c-7.3-7.3-10.6-17.7-8.9-27.9L23.6 304l.4 0H66.7c-6.3 17.7-1.6 38 12.6 51.2L72 439.3c-.4 4.4 2.9 8.3 7.3 8.7s8.3-2.9 8.7-7.3l6.6-76c21.5 8.4 44-.2 57.4-18.1V448z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTamale = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pb);
var xb = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tank-water", f = 448, c = 512, e = [], t = "e452", o = "M285.9 96l-22-40.3L251 32l133 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l133 0L184.1 55.7 162.1 96 64 96l0 201.9c8.3-3 16.2-6.8 23.3-10.8c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 18.9 12.7c15.8 9 35.5 16.8 55.2 16.9l.4 0c19.6 0 39.3-7.9 55.2-16.9c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 19 12.8c7.1 4 15 7.9 23.4 10.8l0-202-98.1 0zM175 139.2L212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7L273 139.2c4.6 8.4 7 17.9 7 27.5l0 1.4c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-1.4c0-9.6 2.4-19 7-27.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTankWater = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xb);
var iS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "taxi-bus", f = 640, c = 512, e = [], t = "e298", o = "M48 416l-16 0c-17.7 0-32-14.3-32-32L0 74.5c0-16.2 9.2-31 23.7-38.3C71.2 12.4 123.7 0 176.9 0l30.3 0c53.2 0 105.6 12.4 153.2 36.2C374.8 43.4 384 58.2 384 74.5L384 96c-21.9 0-40.4 14.7-46.2 34.8c-6.1 1.4-12.1 3.3-17.8 5.6l0-16.4c0-13.3-10.7-24-24-24l-88 0 0 128 41.9 0-16.3 48.9C208.5 290.2 192 319.2 192 352l0 64-64 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32zM64 120l0 80c0 13.3 10.7 24 24 24l88 0 0-128L88 96c-13.3 0-24 10.7-24 24zm56 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 152c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 8 5.4 0c34.4 0 65 22 75.9 54.7l26.6 79.7C625.2 304.7 640 326.6 640 352l0 96 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32-256 0 0 32c0 17.7-14.3 32-32 32l-16 0c-17.7 0-32-14.3-32-32l0-32s0 0 0 0l0-96c0-25.4 14.8-47.3 36.1-57.6l26.6-79.7C297.6 182 328.2 160 362.6 160l5.4 0 0-8zm-20.6 82.9L329.7 288l204.5 0-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9l-138.8 0c-6.9 0-13 4.4-15.2 10.9zM328 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTaxiBus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iS);
var aS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "teddy-bear", f = 576, c = 512, e = [], t = "e3cf", o = "M154.7 103.7C138.7 93.9 128 76.2 128 56c0-30.9 25.1-56 56-56c24.2 0 44.7 15.3 52.6 36.7C252.5 33.5 269.8 32 288 32s35.5 1.5 51.4 4.7C347.3 15.3 367.8 0 392 0c30.9 0 56 25.1 56 56c0 20.2-10.7 37.9-26.7 47.7c1.8 7.4 2.7 15.5 2.7 24.3c0 70.7-60.9 128-136 128s-136-57.3-136-128c0-8.8 .9-16.8 2.7-24.3zM240 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM50.3 178.3c20.8-16.4 51-12.8 67.4 8L143.5 219c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7c16.4-20.8 46.6-24.4 67.4-8s24.4 46.6 8 67.4l-25.8 32.7c-17.7 22.4-37.9 41.3-59.9 56.7l0 64.9 16.6 0c3.9-27.1 27.2-48 55.4-48c30.9 0 56 25.1 56 56c0 2.7-.2 5.4-.6 8l-13 53.3c-5.8 23.8-26.3 40.9-50.4 42.6l0 .1-4 0-28 0L96 512l-28 0-4 0 0-.1c-24.1-1.7-44.6-18.8-50.4-42.6L.6 416c-.4-2.6-.6-5.3-.6-8c0-30.9 25.1-56 56-56c28.2 0 51.6 20.9 55.4 48l16.6 0 0-64.9c-22-15.4-42.3-34.3-59.9-56.7L42.3 245.7c-16.4-20.8-12.8-51 8-67.4zM256 352c-35.3 0-64 28.7-64 64l192 0c0-35.3-28.7-64-64-64l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTeddyBear = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aS);
var eS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "telescope", f = 576, c = 512, e = [128301], t = "e03e", o = "M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L375.7 40zM11.8 343.6C.4 350.3-3.6 364.9 3.1 376.4l25.9 44.9c6.6 11.5 21.3 15.4 32.8 8.8l44.1-25.5 .8 1.4c8.6 15 27.6 20.4 42.8 12.2l88.4-47.4L193.8 478.9c-5 12.3 .9 26.3 13.2 31.3s26.3-.9 31.3-13.2L304 335.6l65.8 161.4c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3L346.4 312.5l86.1-46.2-.2-.3-96-166.3c-1-1.8-2-3.6-2.8-5.4L62.4 268.4c-14.4 9.2-19 28.1-10.4 42.9l4 6.9L11.8 343.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTelescope = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eS);
var nS = {}, J3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tty-answer", f = 640, c = 512, e = ["teletype-answer"], t = "e2b9", o = "M117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24zM304 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm0 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM496 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM384 176c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTtyAnswer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(J3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = J3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTeletypeAnswer = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(nS);
var fS = {}, Y3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "temperature-snow", f = 576, c = 512, e = ["temperature-frigid"], t = "f768", o = "M384 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C505.8 332.6 512 349.5 512 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L384 112zM432 0C370.1 0 320 50.1 320 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8c-18.9 24.4-30.1 55-30.1 88.1c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L544 112C544 50.1 493.9 0 432 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM288 131.6l-88 50.8 0-55.8 35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4 200 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 25.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L152 126.6l0 55.8-48.3-27.9L90.7 106.3C88.5 97.7 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7C31 112.6 16.3 116.5 9.7 128s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l48.2-12.9L128 224 79.7 251.9 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2L152 265.6l0 55.8-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 366.6l0 25.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-25.4 12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4l0-55.8 67.7 39.1c5.2-13.5 12-26.2 20.3-37.9l0-5.8-64-37 64-37 0-55.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTemperatureSnow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Y3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Y3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTemperatureFrigid = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(fS);
var cS = {}, Z3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "temperature-sun", f = 640, c = 512, e = ["temperature-hot"], t = "f76a", o = "M320.6 98.5l-2.7-.5L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l70.8 49.6c4.5 3.1 10.3 3.8 15.4 1.6c.7-.3 1.5-.7 2.1-1.1c-5.4-16.9-8.3-34.9-8.3-53.7c0-37.7 11.8-72.6 32-101.2L320 112c0-4.5 .2-9 .6-13.5zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm208 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C537.8 332.6 544 349.5 544 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5L416 112zM464 0C402.1 0 352 50.2 352 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8c-18.9 24.4-30.1 55-30.1 88.1c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L576 112C576 50.2 525.9 0 464 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L480 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTemperatureSun = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Z3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Z3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTemperatureHot = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(cS);
var tS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "temperature-list", f = 512, c = 512, e = [], t = "e299", o = "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 164.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5L96 112zM144 0C82.1 0 32 50.2 32 112l0 164.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 146.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM352 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L352 32zM320 192c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTemperatureList = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tS);
var oS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tennis-ball", f = 512, c = 512, e = [127934], t = "f45e", o = "M.2 245.1C.1 248.7 0 252.3 0 256C0 397.4 114.6 512 256 512c3.7 0 7.3-.1 10.9-.2c-3.8-10.7-6.6-21.8-8.4-33.1c-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4s39.7-38.2 64.5-50.1s52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9c.2-3.6 .2-7.2 .2-10.9C512 114.6 397.4 0 256 0c-3.7 0-7.3 .1-10.9 .2c10.7 30.5 13.7 63.4 8.2 95.6c-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4zM206.8 4.7C104.9 24.6 24.6 104.9 4.7 206.8C26.9 216 51.1 220 75.3 218.2c34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9zM445.4 293.4c-22.2 .4-44 5.5-64 15.1s-37.7 23.3-52 40.3s-24.6 36.9-30.5 58.3s-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6c101.9-19.8 182.2-100.2 202.1-202.1c-19.6-8.1-40.6-12.1-61.9-11.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTennisBall = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oS);
var lS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tent-double-peak", f = 576, c = 512, e = [], t = "e627", o = "M182.6 9.4C176.2 2.9 167.3-.5 158.2 0s-17.5 4.9-23.2 12L93.9 63.5c-13.5 16.9-29 31.9-46.3 44.9L12.8 134.4C4.7 140.4 0 149.9 0 160l0 32 576 0 0-32c0-10.1-4.7-19.6-12.8-25.6l-34.7-26.1c-17.3-12.9-32.8-28-46.3-44.9L441 12C435.3 4.9 426.9 .6 417.8 0s-18 2.9-24.4 9.3L374.6 28.1C351.7 51.1 320.5 64 288 64s-63.7-12.9-86.6-35.9L182.6 9.4zM576 224L0 224 0 480c0 17.7 14.3 32 32 32l208 0c0 0 0 0 0 0l16 0c17.7 0 32-14.3 32-32l0-182.1c0-5.5 4.4-9.9 9.9-9.9c3.7 0 7.2 2.1 8.8 5.5L407.2 494.3c5.4 10.8 16.5 17.7 28.6 17.7l28.2 0c0 0 0 0 0 0l80 0c17.7 0 32-14.3 32-32l0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTentDoublePeak = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lS);
var dS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "text", f = 448, c = 512, e = [], t = "f893", o = "M64 96l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 80C0 53.5 21.5 32 48 32l176 0 176 0c26.5 0 48 21.5 48 48l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32L256 96l0 320 48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0 0-320L64 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faText = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dS);
var rS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "text-size", f = 640, c = 512, e = [], t = "f894", o = "M64 128l0-32 96 0 0 320-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320 96 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L192 32 48 32C21.5 32 0 53.5 0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32zM384 304l0-16 64 0 0 128-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128 64 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTextSize = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rS);
var sS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "theta", f = 384, c = 512, e = [], t = "f69e", o = "M64 256c0-51 15.9-96 40.2-127.6C128.5 96.9 159.8 80 192 80s63.5 16.9 87.8 48.4C304.1 160 320 205 320 256s-15.9 96-40.2 127.6C255.5 415.1 224.2 432 192 432s-63.5-16.9-87.8-48.4C79.9 352 64 307 64 256zM192 16C135.8 16 87.1 45.7 53.5 89.4C19.9 133.1 0 192.1 0 256s19.9 122.9 53.5 166.6C87.1 466.3 135.8 496 192 496s104.9-29.7 138.5-73.4C364.1 378.9 384 319.9 384 256s-19.9-122.9-53.5-166.6C296.9 45.7 248.2 16 192 16zM128 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTheta = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sS);
var hS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "thought-bubble", f = 512, c = 512, e = [], t = "e32e", o = "M374.8 80.3C355.9 33.2 309.8 0 256 0s-99.9 33.2-118.8 80.3c-3-.2-6.1-.3-9.2-.3C57.3 80 0 137.3 0 208s57.3 128 128 128c14.4 0 28.3-2.4 41.3-6.8C184.7 361.6 217.7 384 256 384s71.3-22.4 86.7-54.8c12.9 4.4 26.8 6.8 41.3 6.8c70.7 0 128-57.3 128-128s-57.3-128-128-128c-3.1 0-6.1 .1-9.2 .3zM144 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faThoughtBubble = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hS);
var vS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = g1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faThunderstormMoon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(vS);
var uS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = P1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faThunderstormSun = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(uS);
var mS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tick", f = 192, c = 512, e = [], t = "e32f", o = "M32 98.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4L133.5 256.5c-3.2 18.2-19 31.5-37.5 31.5s-34.3-13.3-37.5-31.5L33 109.6c-.7-3.8-1-7.5-1-11.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTick = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mS);
var O = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ticket-airline", f = 640, c = 512, e = ["ticket-perforated-plane", "ticket-plane"], t = "e29a", o = "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.3-15.8-15.8-18c-27.7-7-48.2-32.1-48.2-62s20.5-55 48.2-62c8.6-2.2 15.8-9.1 15.8-18l0-48c0-35.3-28.7-64-64-64L64 64zm352 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 224l-28.5-85.5c-1.7-5.2 2.1-10.5 7.6-10.5l31.1 0c8.5 0 16.4 4.5 20.7 11.9L256 224l46.9 0c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288L256 288l-49.1 84.1c-4.3 7.4-12.2 11.9-20.7 11.9l-31.1 0c-5.5 0-9.3-5.4-7.6-10.5L176 288l-56 0-19.2 25.6c-3 4-7.8 6.4-12.8 6.4l-13.8 0c-5.2 0-9-4.9-7.8-9.9L79 259.9c.6-2.5 .6-5.2 0-7.8L66.5 201.9c-1.3-5 2.6-9.9 7.8-9.9L88 192c5 0 9.8 2.4 12.8 6.4L120 224l56 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTicketAirline = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(O);
var gS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ticket-perforated", f = 640, c = 512, e = [], t = "e63e", o = "M0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 48c0 8.8-7.3 15.8-15.8 18c-27.7 7-48.2 32.1-48.2 62s20.5 55 48.2 62c8.6 2.2 15.8 9.1 15.8 18l0 48c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm432 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTicketPerforated = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gS);
var PS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = O;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTicketPerforatedPlane = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(PS);
var MS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = O;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTicketPlane = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(MS);
var wS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tickets", f = 640, c = 512, e = [], t = "e658", o = "M96 96l0 48c0 8.8 7.4 15.7 15.7 18.6C130.5 169.1 144 187 144 208s-13.5 38.9-32.3 45.4C103.4 256.3 96 263.2 96 272l0 48c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-48c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm416 32l-288 0 0 160 288 0 0-160zM224 96l288 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTickets = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wS);
var k = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tickets-airline", f = 640, c = 512, e = ["tickets-perforated-plane", "tickets-plane"], t = "e29b", o = "M96 96l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-48c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm416 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM265.3 106.5c-1.7-5.2 2.1-10.5 7.6-10.5L304 96c8.5 0 16.4 4.5 20.7 11.9L364.4 176l40.3 0c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5c-11.4 11.4-26.8 17.7-42.8 17.7l-40.3 0-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9l-31.1 0c-5.5 0-9.3-5.3-7.6-10.5L288.4 240l-42.7 0-19.2 25.6c-3 4-7.8 6.4-12.8 6.4L200 272c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5 .6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9l13.8 0c5 0 9.8 2.4 12.8 6.4L245.8 176l42.7 0-23.2-69.5zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTicketsAirline = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(k);
var NS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tickets-perforated", f = 640, c = 512, e = [], t = "e63f", o = "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-48c0-35.3-28.7-64-64-64L160 32zM528 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTicketsPerforated = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(NS);
var zS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = k;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTicketsPerforatedPlane = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(zS);
var LS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = k;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTicketsPlane = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(LS);
var CS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tickets-simple", f = 640, c = 512, e = [], t = "e659", o = "M160 32c-35.3 0-64 28.7-64 64l0 48c0 8.8 7.4 15.7 15.7 18.6C130.5 169.1 144 187 144 208s-13.5 38.9-32.3 45.4C103.4 256.3 96 263.2 96 272l0 48c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-48c0-8.8-7.4-15.7-15.7-18.6C605.5 246.9 592 229 592 208s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-48c0-35.3-28.7-64-64-64L160 32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTicketsSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(CS);
var DS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tilde", f = 448, c = 512, e = [63135], t = "7e", o = "M99.9 192C80.1 192 64 208.1 64 227.9L64 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-92.1C0 172.7 44.7 128 99.9 128c26.5 0 51.9 10.5 70.6 29.3L322.7 309.5c6.7 6.7 15.9 10.5 25.4 10.5c19.8 0 35.9-16.1 35.9-35.9l0-92.1c0-17.7 14.3-32 32-32s32 14.3 32 32l0 92.1c0 55.2-44.7 99.9-99.9 99.9c-26.5 0-51.9-10.5-70.6-29.3L125.3 202.5c-6.7-6.7-15.9-10.5-25.4-10.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTilde = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(DS);
var $S = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "timeline-arrow", f = 640, c = 512, e = [], t = "e29d", o = "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3L96 224l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 0 54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-54.7 274.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224 384 224l0-54.7c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3l0 54.7-160 0 0-54.7zM328 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTimelineArrow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($S);
var _S = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "timer", f = 512, c = 512, e = [], t = "e29e", o = "M256 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-29.3C378.8 81.9 448 160.9 448 256c0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1c12.6-12.4 12.8-32.6 .5-45.3S89.5 60.8 76.8 73.1C29.5 119.6 0 184.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM193 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTimer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_S);
var bS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = w;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTimesHexagon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(bS);
var SS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = $;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTimesOctagon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(SS);
var yS = {}, A = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "xmark-to-slot", f = 576, c = 512, e = ["times-to-slot", "vote-nay"], t = "f771", o = "M96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 304L96 384 96 80zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47zM0 336c0-26.5 21.5-48 48-48l16 0 0 128 448 0 0-128 16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faXmarkToSlot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(A);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = A;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTimesToSlot = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yS);
var OS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tire", f = 512, c = 512, e = [], t = "f631", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-16.1 62l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6zm47.9-58l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4zm-40.2-63.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5zM168.3 162.7C143.5 186.1 128 219.2 128 256c0 8.3 .8 16.3 2.3 24.2L192.1 260c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7zm33.7 127.7l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4l0-65c-15.8-4.1-29.3-14.1-37.9-27.5zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(OS);
var kS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tire-flat", f = 512, c = 512, e = [], t = "f632", o = "M256 32C114.6 32 0 146.6 0 288c0 47.3 12.8 91.7 35.2 129.7C14.9 423.3 0 441.9 0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48c0-22.1-14.9-40.7-35.2-46.3c22.4-38 35.2-82.4 35.2-129.7C512 146.6 397.4 32 256 32zm96 384c-2.1 1.6-4.3 3.2-6.6 4.7C319.9 437.9 289.1 448 256 448c-36 0-69.3-11.9-96-32c-38.9-29.2-64-75.7-64-128c0-88.4 71.6-160 160-160s160 71.6 160 160c0 52.3-25.1 98.8-64 128zm-96-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm16 95c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1c-8.6 13.5-22.1 23.5-38 27.6l0 65zM381.7 312.2c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4l61.8 20.1zM256 224c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zM128 288c0 8.3 .8 16.3 2.3 24.2L192.1 292c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm12.2 54.6c18.3 38.8 55.5 66.9 99.8 72.4l0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTireFlat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kS);
var AS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tire-pressure-warning", f = 512, c = 512, e = [], t = "f633", o = "M384 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 22.5c0 24.1 3.9 48 11.5 70.8l2.5 7.4c4.8 14.4 11.5 28.6 19.3 44.4c17.5 35.6 33.4 82.6 27.5 136.2c-5.3 48.6-28.1 99-76.8 148.7l0 34c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-8-32 0 0 8c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-8-32 0 0 8c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-8-32 0 0 8c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-34C31.3 412.3 8.6 361.9 3.2 313.3c-5.9-53.6 9.9-100.6 27.5-136.2c7.8-15.8 14.5-30 19.3-44.4l2.5-7.4C60.1 102.5 64 78.5 64 54.5L64 32C64 14.3 78.3 0 96 0s32 14.3 32 32l0 22.5c0 31-5 61.7-14.8 91.1l-2.5 7.4c-6.3 19-14.8 36.6-22.6 52.5c-14.7 29.7-25.3 64-21.3 100.9c3.7 34 20.4 74.1 65.7 117.7l246.8 0c45.3-43.6 62-83.7 65.7-117.7c4.1-36.9-6.6-71.1-21.3-100.9c-7.8-15.8-16.3-33.5-22.6-52.5l-2.5-7.4C389 116.2 384 85.4 384 54.5L384 32zM280 120l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zM256 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTirePressureWarning = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(AS);
var jS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tire-rugged", f = 512, c = 512, e = [], t = "f634", o = "M320 24c0-13.3-10.7-24-24-24L216 0c-13.3 0-24 10.7-24 24l0 16c0 .4 0 .8 0 1.3c-14.9 4.4-29.2 10.4-42.6 17.7c-.3-.3-.6-.6-.9-.9L137.2 46.7c-9.4-9.4-24.6-9.4-33.9 0L46.7 103.3c-9.4 9.4-9.4 24.6 0 33.9L58 148.5c.3 .3 .6 .6 .9 .9c-7.3 13.4-13.2 27.7-17.7 42.6c-.4 0-.8 0-1.3 0l-16 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l16 0c.4 0 .8 0 1.3 0c4.4 14.9 10.4 29.2 17.7 42.6c-.3 .3-.6 .6-.9 .9L46.7 374.8c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0L148.5 454c.3-.3 .6-.6 .9-.9c13.4 7.3 27.7 13.2 42.6 17.7c0 .4 0 .8 0 1.3l0 16c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-16c0-.4 0-.8 0-1.3c14.9-4.4 29.2-10.4 42.6-17.7c.3 .3 .6 .6 .9 .9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9L454 363.5c-.3-.3-.6-.6-.9-.9c7.3-13.4 13.2-27.7 17.7-42.6c.4 0 .8 0 1.3 0l16 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-16 0c-.4 0-.8 0-1.3 0c-4.4-14.9-10.4-29.2-17.7-42.6c.3-.3 .6-.6 .9-.9l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9L408.7 46.7c-9.4-9.4-24.6-9.4-33.9 0L363.5 58c-.3 .3-.6 .6-.9 .9c-13.4-7.3-27.7-13.2-42.6-17.7c0-.4 0-.8 0-1.3l0-16zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-61.1 2.9a24 24 0 1 0 -14.8 45.7 24 24 0 1 0 14.8-45.7zm106.7 30.2a24 24 0 1 0 45.7-14.8 24 24 0 1 0 -45.7 14.8zm-22.7 87.2a24 24 0 1 0 38.8-28.2 24 24 0 1 0 -38.8 28.2zm-51.1-33.5a24 24 0 1 0 -28.2 38.8 24 24 0 1 0 28.2-38.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTireRugged = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jS);
var BS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toggle-large-off", f = 576, c = 512, e = [], t = "e5b0", o = "M192 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0 64l192 0c106 0 192-86 192-192s-86-192-192-192L192 64C86 64 0 150 0 256S86 448 192 448zm143.1-64c30.4-34 48.9-78.8 48.9-128s-18.5-94-48.9-128l48.9 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-48.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToggleLargeOff = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(BS);
var TS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toggle-large-on", f = 576, c = 512, e = [], t = "e5b1", o = "M192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64zm192 64a128 128 0 1 1 0 256 128 128 0 1 1 0-256z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToggleLargeOn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(TS);
var FS = {}, p3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toilet-paper-blank", f = 640, c = 512, e = ["toilet-paper-alt"], t = "f71f", o = "M384 192c0-65.5 13.2-142.4 60.2-192L160 0C107 0 64 86 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512l237.9 0c22.3 0 45.4-12.1 55.4-36.1C356.7 439 384 350.8 384 192zm224 0C608 86 565 0 512 0s-96 86-96 192s43 192 96 192s96-86 96-192zm-64 0c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToiletPaperBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(p3);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = p3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faToiletPaperAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(FS);
var x3 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toilet-paper-blank-under", f = 512, c = 512, e = ["toilet-paper-reverse-alt"], t = "e29f", o = "M348.2 0L96 0C43 0 0 86 0 192S43 384 96 384l252.2 0c-11.6-12.2-21.1-26.9-28.7-41.9C299.5 302 288 248.9 288 192s11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9zM384 10.9c-37.3 26.4-64 97.5-64 181.1s26.7 154.7 64 181.1c10 7.1 20.8 10.9 32 10.9c35.5 0 66.6-38.6 83.2-96c8.2-28.2 12.8-61 12.8-96C512 86 469 0 416 0c-11.2 0-22 3.8-32 10.9zM416 256c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64zM160 464c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-120.9c-19.1 37.8-51.2 72.9-96 72.9l-256 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToiletPaperBlankUnder = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(x3);
var HS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toilet-paper-check", f = 640, c = 512, e = [], t = "e5b2", o = "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0L444.2 0zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM291.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 225.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToiletPaperCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(HS);
var RS = {}, i0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toilet-paper-under", f = 512, c = 512, e = ["toilet-paper-reverse"], t = "e2a0", o = "M96 0L348.2 0C336.6 12.2 327 26.9 319.5 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9L96 384C43 384 0 298 0 192S43 0 96 0zM320 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-16.6 57.4-47.6 96-83.2 96c-11.2 0-22-3.8-32-10.9c-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zM160 416l256 0c44.8 0 76.9-35.2 96-72.9L512 464c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-48zM64 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToiletPaperUnder = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(i0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = i0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faToiletPaperReverse = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(RS);
var US = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = x3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faToiletPaperReverseAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(US);
var qS = {}, a0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toilet-paper-under-slash", f = 640, c = 512, e = ["toilet-paper-reverse-slash"], t = "e2a1", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43 0-83.1c-9.9 19.5-23.2 38.2-39.9 51.8L510 374.4c22.6-14.8 41.4-46 53.1-86.4c8.2-28.2 12.8-61 12.8-96C576 86 533 0 480 0c-11.2 0-22 3.8-32 10.9c-37.3 26.4-64 97.5-64 181.1c0 33.8 4.4 65.5 12 93.1l-39.3-30.8c-3.1-19.9-4.7-40.8-4.7-62.3c0-56.9 11.5-110 31.5-150.1c7.5-15 17.1-29.7 28.7-41.9L160 0c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM528 512L406.2 416 224 416l0 48c0 26.5 21.5 48 48 48l256 0 .3 0-.3 0zM64 192c0 106 43 192 96 192l205.5 0L66.5 148.4C64.9 162.4 64 177 64 192zm416 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToiletPaperUnderSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(a0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = a0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faToiletPaperReverseSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(qS);
var GS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toilet-paper-xmark", f = 512, c = 512, e = [], t = "e5b3", o = "M96 0L348.2 0C336.6 12.2 327 26.9 319.5 41.9C299.5 82 288 135.1 288 192s11.5 110 31.5 150.1c7.5 15 17.1 29.7 28.7 41.9L96 384C43 384 0 298 0 192S43 0 96 0zM320 192c0-83.6 26.7-154.7 64-181.1C394 3.8 404.8 0 416 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-16.6 57.4-47.6 96-83.2 96c-11.2 0-22-3.8-32-10.9c-37.3-26.4-64-97.5-64-181.1zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zM160 416l256 0c44.8 0 76.9-35.2 96-72.9L512 464c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-48zm51.3-283.3c-6.2-6.2-16.4-6.2-22.6 0L152 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L129.4 192 92.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 214.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L174.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToiletPaperXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(GS);
var WS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tomato", f = 512, c = 512, e = [], t = "e330", o = "M241 7L224 24C241 7 241 7 241 7s0 0 0 0s0 0 0 0l.1 .1 .2 .2 .5 .5c.4 .4 1 1 1.7 1.8c1.4 1.5 3.2 3.6 5.4 6.3c4.4 5.4 10.1 13.1 15.8 22.8c6.6 11.2 13.4 25.5 18 42.1c45.7 3.1 88.5 14.2 125.1 32.8c6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3l-34.6 0 15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4 150.3 190.7c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4c-4-7.9-.9-17.5 7-21.5l.8-.4C142.2 94.6 185.6 83.5 232 80.7c-2.6-6.4-5.6-12.3-8.7-17.6c-4.3-7.3-8.6-13-11.7-16.9c-1.6-1.9-2.8-3.4-3.6-4.3c-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5c-.6 11.8 3.1 23.7 11 33.2c13.6 16.3 36.3 21.8 55.8 13.4L256 180.2l93.1 39.9c19.5 8.4 42.2 2.9 55.8-13.4c7.9-9.5 11.7-21.5 11-33.2c10.3-3.5 19.1-10.4 25-19.5c44 35.5 71.1 86.4 71.1 150c0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTomato = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(WS);
var ES = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tombstone", f = 448, c = 512, e = [], t = "f720", o = "M32 192C32 86 118 0 224 0S416 86 416 192l0 224L32 416l0-224zM0 480c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32zM248 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 120c0 13.3 10.7 24 24 24s24-10.7 24-24l0-120 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-40z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTombstone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ES);
var VS = {}, e0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tombstone-blank", f = 448, c = 512, e = [129702, "tombstone-alt"], t = "f721", o = "M224 0C118 0 32 86 32 192l0 224 384 0 0-224C416 86 330 0 224 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTombstoneBlank = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(e0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = e0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTombstoneAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(VS);
var IS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "toothbrush", f = 576, c = 512, e = [129701], t = "f635", o = "M64 224c-35.3 0-64-28.7-64-64s28.7-64 64-64l224 0c31.2 0 38.2-22.7 39.6-48c.5-8.8 7.6-16.1 16.4-15.2c52.4 5.3 104 36.7 104 95.2c0 53-43 96-96 96L64 224zm-8 32c13.3 0 24 10.7 24 24l0 136 32 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136 32 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136 32 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136 32 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136 144 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-136c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faToothbrush = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(IS);
var KS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tower-control", f = 448, c = 512, e = [], t = "e2a2", o = "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 48-40 0c-17.7 0-32 14.3-32 32l-85.4 0C16 128-3.2 153.4 4.1 179L44.5 320.2C28.5 321.9 16 335.5 16 352c0 17.7 14.3 32 32 32l32 0 0 96c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-96 32 0c17.7 0 32-14.3 32-32c0-16.5-12.5-30.1-28.5-31.8L443.9 179c7.3-25.6-11.9-51-38.5-51L320 128c0-17.7-14.3-32-32-32l-40 0 0-48 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L224 0 184 0zM128 192l0 128-17 0c-.1-.3-.1-.5-.2-.8L74.4 192l53.6 0zm48 128l0-128 96 0 0 128-96 0zM320 192l53.6 0L337.2 319.2l-.1 .3-.1 .5-17 0 0-128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTowerControl = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(KS);
var XS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "traffic-cone", f = 512, c = 512, e = [], t = "f636", o = "M173.7 128L216 20.3C220.8 8.1 232.7 0 245.8 0l20.4 0c13.2 0 25 8.1 29.8 20.3L338.3 128l-164.6 0zm-25.1 64l214.9 0 37.7 96-290.3 0 37.7-96zM48 448l37.7-96 340.6 0L464 448l16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrafficCone = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(XS);
var QS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "traffic-light-go", f = 320, c = 512, e = [], t = "f638", o = "M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-200a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM136 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrafficLightGo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(QS);
var JS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "traffic-light-slow", f = 320, c = 512, e = [], t = "f639", o = "M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm72 368a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-128a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM136 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrafficLightSlow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(JS);
var YS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "traffic-light-stop", f = 320, c = 512, e = [], t = "f63a", o = "M64 0C28.7 0 0 28.7 0 64L0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l0-288c0-35.3-28.7-64-64-64L64 0zm72 368a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm72 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 72a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-128a48 48 0 1 1 0-96 48 48 0 1 1 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrafficLightStop = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(YS);
var ZS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "train-track", f = 576, c = 512, e = [], t = "e453", o = "M222.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L147.6 96 112 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l14.3 0-21.3 64L72 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.6 0L62.3 352 32 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l8.9 0-7.3 21.9c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l14-42.1 359.2 0 14 42.1c5.6 16.8 23.7 25.8 40.5 20.2s25.8-23.7 20.2-40.5L535.1 416l8.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-30.3 0-21.3-64 11.6 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32.9 0-21.3-64 14.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-35.6 0-14-42.1c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5L360.9 96 215.1 96l7.3-21.9zM193.7 160l188.5 0 21.3 64-231.2 0 21.3-64zM446.3 352l-316.5 0 21.3-64 273.9 0 21.3 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrainTrack = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ZS);
var pS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "train-tunnel", f = 512, c = 512, e = [], t = "e454", o = "M256 0C114.6 0 0 114.6 0 256L0 448c0 35.3 28.7 64 64 64l41.4 0 64.3-64.3C137.3 444.5 112 417.2 112 384l0-192c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 192c0 33.2-25.3 60.5-57.7 63.7L406.6 512l41.4 0c35.3 0 64-28.7 64-64l0-192C512 114.6 397.4 0 256 0zM361.4 512l-64-64-82.7 0-64 64 210.7 0zM184 192c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-144 0zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrainTunnel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pS);
var xS = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transformer-bolt", f = 384, c = 512, e = [], t = "e2a4", o = "M136 24l0 8 24 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0L64 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0 0-8C88 10.7 98.7 0 112 0s24 10.7 24 24zm160 0l0 8 24 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24zM48 112c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm160 0c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM0 192c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 224c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-224c-17.7 0-32-14.3-32-32zm232.9 34.7c-6-4-13.9-3.6-19.3 1.1l-112 96c-5.1 4.4-6.9 11.4-4.6 17.7s8.3 10.4 15 10.4l57.8 0-25 74.9c-2.3 6.8 .3 14.3 6.3 18.3s13.9 3.6 19.3-1.1l112-96c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4l-57.8 0 25-74.9c2.3-6.8-.3-14.3-6.3-18.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransformerBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xS);
var iy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter", f = 512, c = 512, e = [], t = "e042", o = "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 272l0 96-64 0 0-178.7L153 276c-11.1 13.8-31.2 16-45 5s-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36l40.7 0c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-31-38.7L328 416l-64 0 0-96-16 0zM216 512l-88 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-88 0-80 0zM64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128 6.6 120.7C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4C40.4 66.7 43.9 64 48 64s7.6 2.7 8.7 6.6L64 96zM472.7 6.6L480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iy);
var ay = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter-1", f = 512, c = 512, e = [], t = "e043", o = "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-88 0-80 0-88 0zM383.7 288c-9.3-.1-18.5-4.2-24.7-12l-31-38.7 0 50.7-144 0 0-50.7L153 276c-6.3 7.8-15.4 11.9-24.7 12l-.3 0s0 0 0 0c-7 0-14.1-2.3-20-7c-13.8-11.1-16-31.2-5-45l57.7-72c18.2-22.7 45.8-36 74.9-36l40.7 0c29.1 0 56.7 13.2 74.9 36L409 236c11 13.8 8.8 33.9-5 45c-5.9 4.7-13 7-20 7c0 0 0 0 0 0l-.3 0zm-327 38.6L64 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 384 6.6 376.7C2.7 375.6 0 372.1 0 368s2.7-7.6 6.6-8.7L32 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 160zM176 320l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporter1 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ay);
var ey = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter-2", f = 512, c = 512, e = [], t = "e044", o = "M56.7 6.6C55.6 2.7 52.1 0 48 0s-7.6 2.7-8.7 6.6L32 32 6.6 39.3C2.7 40.4 0 43.9 0 48s2.7 7.6 6.6 8.7L32 64l7.3 25.4C40.4 93.3 43.9 96 48 96s7.6-2.7 8.7-6.6L64 64l25.4-7.3C93.3 55.6 96 52.1 96 48s-2.7-7.6-6.6-8.7L64 32 56.7 6.6zM256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 512l88 0 80 0 88 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zM399.4 224l-48.1-60c-18.2-22.7-45.8-36-74.9-36l-40.7 0c-29.1 0-56.7 13.2-74.9 36l-48.1 60 286.7 0zM480 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 352zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporter2 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ey);
var ny = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter-3", f = 512, c = 512, e = [], t = "e045", o = "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 512l88 0 80 0 88 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zM56.7 102.6C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128 6.6 135.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128l-7.3-25.4zM480 32L472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporter3 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ny);
var fy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter-4", f = 512, c = 512, e = [], t = "e2a5", o = "M224 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 160zM56.7 358.6L64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416 6.6 408.7C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 480c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-88 0-80 0-88 0c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporter4 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fy);
var cy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter-5", f = 512, c = 512, e = [], t = "e2a6", o = "M480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6L480 32zM56.7 134.6L64 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 192 6.6 184.7C2.7 183.6 0 180.1 0 176s2.7-7.6 6.6-8.7L32 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM384 512l-88 0-80 0-88 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32zM224 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM176 128l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 128l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporter5 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cy);
var ty = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter-6", f = 512, c = 512, e = [], t = "e2a7", o = "M56.7 6.6L64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6zM384 512l-88 0-80 0-88 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32zm96-128l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 384zM224 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporter6 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ty);
var oy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter-7", f = 512, c = 512, e = [], t = "e2a8", o = "M472.7 38.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64l-7.3-25.4zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288 6.6 295.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288zM296 512l88 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l88 0 80 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporter7 = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oy);
var ly = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "transporter-empty", f = 512, c = 512, e = [], t = "e046", o = "M296 512l88 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l88 0 80 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTransporterEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ly);
var dy = {}, n0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-can-slash", f = 640, c = 512, e = ["trash-alt-slash"], t = "e2ad", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-248-316.4 0L154.8 96 512 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C403.4 6.8 392.3 0 380.2 0L259.8 0c-12.1 0-23.2 6.8-28.6 17.7L224 32l-96 0c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM304 213l0-5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 30L304 213zm96 75.2l0-80.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 105.3-32-25.1zm97.8 200L431.5 436c-1.8 6.9-8 12-15.5 12c-8.8 0-16-7.2-16-16l0-20.8-64-50.4 0 71.3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96.5-64-50.4L240 432c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-172.1-80-63L128 448c0 35.3 28.7 64 64 64l256 0c20.1 0 38.1-9.3 49.8-23.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashCanSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(n0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = n0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTrashAltSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(dy);
var ry = {}, f0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-undo", f = 448, c = 512, e = ["trash-arrow-turn-left"], t = "f895", o = "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128zM217.8 199.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264l57.5 0c48.6 0 88 39.4 88 88l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-22.1-17.9-40-40-40l-57.5 0 33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashUndo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(f0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = f0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTrashArrowTurnLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ry);
var sy = {}, j = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-can-undo", f = 448, c = 512, e = ["trash-can-arrow-turn-left", "trash-undo-alt"], t = "f896", o = "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128l0 320c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320zM217.8 199.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264l57.5 0c48.6 0 88 39.4 88 88l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-22.1-17.9-40-40-40l-57.5 0 33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashCanUndo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(j);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = j;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTrashCanArrowTurnLeft = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(sy);
var hy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-can-check", f = 448, c = 512, e = [], t = "e2a9", o = "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zM337 265c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 265z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashCanCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(hy);
var vy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-can-clock", f = 576, c = 512, e = [], t = "e2aa", o = "M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 64.7c-29.3 2.6-56.6 12.5-80 27.7l0-12.5c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 39.2c-29.8 31.5-48 74-48 120.8c0 59.5 29.6 112.1 74.8 144L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm64 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashCanClock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vy);
var uy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-can-list", f = 640, c = 512, e = [], t = "e2ab", o = "M147.8 0c-12.1 0-23.2 6.8-28.6 17.7L112 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0-7.2-14.3C291.4 6.8 280.3 0 268.2 0L147.8 0zM384 128L32 128l0 336c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-336zM160 208l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm192-80c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zM448 416c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashCanList = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uy);
var my = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-can-plus", f = 448, c = 512, e = [], t = "e2ac", o = "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zM200 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashCanPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(my);
var gy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-can-xmark", f = 448, c = 512, e = [], t = "e2ae", o = "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zM143 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashCanXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gy);
var Py = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-check", f = 448, c = 512, e = [], t = "e2af", o = "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0L394.8 467c-1.6 25.3-22.6 45-47.9 45l-245.8 0c-25.3 0-46.3-19.7-47.9-45L32 128zM337 249c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 249z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashCheck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Py);
var My = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = h1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTrashCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(My);
var wy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-clock", f = 576, c = 512, e = [], t = "e2b0", o = "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l229.7 0C285.6 480.1 256 427.5 256 368c0-90.4 68.2-164.9 155.9-174.9L416 128zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashClock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wy);
var Ny = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-list", f = 640, c = 512, e = [], t = "e2b1", o = "M147.8 0L268.2 0c12.1 0 23.2 6.8 28.6 17.7L304 32l80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l80 0 7.2-14.3C124.6 6.8 135.7 0 147.8 0zM32 128l352 0L362.8 467c-1.6 25.3-22.6 45-47.9 45l-213.8 0c-25.3 0-46.3-19.7-47.9-45L32 128zm448 0l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM448 416c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashList = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ny);
var zy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-plus", f = 448, c = 512, e = [], t = "e2b2", o = "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0L394.8 467c-1.6 25.3-22.6 45-47.9 45l-245.8 0c-25.3 0-46.3-19.7-47.9-45L32 128zM200 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zy);
var Ly = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-slash", f = 640, c = 512, e = [], t = "e2b3", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.2 364.4 512 128l-316.4 0L154.8 96 512 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C403.4 6.8 392.3 0 380.2 0L259.8 0c-12.1 0-23.2 6.8-28.6 17.7L224 32l-96 0c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM488 480.5L132.5 200.4 149.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c20.6 0 38.3-13 45.1-31.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ly);
var Cy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = j;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTrashUndoAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Cy);
var Dy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trash-xmark", f = 448, c = 512, e = [], t = "e2b4", o = "M163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128l384 0L394.8 467c-1.6 25.3-22.6 45-47.9 45l-245.8 0c-25.3 0-46.3-19.7-47.9-45L32 128zM143 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrashXmark = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dy);
var $y = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "treasure-chest", f = 576, c = 512, e = [], t = "f723", o = "M0 160l0 96 128 0 0-224C57.3 32 0 89.3 0 160zM0 432c0 26.5 21.5 48 48 48l80 0 0-192L0 288 0 432zM416 288l-64 0 0 32c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-32-64 0 0 192 256 0 0-192zM528 480c26.5 0 48-21.5 48-48l0-144-128 0 0 192 80 0zm48-320c0-70.7-57.3-128-128-128l0 224 128 0 0-96zM416 256l0-224L160 32l0 224 64 0 0-32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 32 64 0zM304 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTreasureChest = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($y);
var _y = {}, c0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tree-deciduous", f = 512, c = 512, e = [127795, "tree-alt"], t = "f400", o = "M384 80c-11.5 0-22.5 2.4-32.4 6.8C347 38.1 305.9 0 256 0s-91 38.1-95.6 86.8C150.5 82.4 139.5 80 128 80c-44.2 0-80 35.8-80 80c0 14.4 3.8 27.9 10.5 39.6C24.1 214.2 0 248.3 0 288c0 53 43 96 96 96l128 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 128 0c53 0 96-43 96-96c0-39.7-24.1-73.8-58.5-88.4c6.7-11.7 10.5-25.2 10.5-39.6c0-44.2-35.8-80-80-80z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTreeDeciduous = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(c0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = c0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTreeAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_y);
var by = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tree-christmas", f = 448, c = 512, e = [127876], t = "f7db", o = "M150.2 71l47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7L233 153.8c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zM263 165l11.8-31.5 144 180c3.4 4.2 5.2 9.4 5.2 14.8c0 13.1-10.6 23.7-23.7 23.7L368 352l76.2 122c2.5 4 3.8 8.5 3.8 13.2c0 13.7-11.1 24.9-24.9 24.9L24.9 512C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352l-32.3 0C34.6 352 24 341.4 24 328.3c0-5.4 1.8-10.6 5.2-14.8l144-180L185 165c6.1 16.2 21.6 27 39 27s32.9-10.8 39-27zM184 288a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM288 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTreeChristmas = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(by);
var Sy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tree-decorated", f = 448, c = 512, e = [], t = "f7dc", o = "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208l24.9 0L28.5 313.7c-2.9 4.1-4.5 9-4.5 14.1C24 341.1 34.8 352 48.2 352L80 352 3.8 474c-2.5 4-3.8 8.5-3.8 13.2C0 500.9 11.1 512 24.9 512l398.3 0c13.7 0 24.9-11.1 24.9-24.9c0-4.7-1.3-9.2-3.8-13.2L368 352l31.8 0c13.4 0 24.2-10.9 24.2-24.2c0-5-1.6-10-4.5-14.1L344 208l24.9 0c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9zM160 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTreeDecorated = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sy);
var yy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tree-large", f = 448, c = 512, e = [], t = "f7dd", o = "M62 169.4L210.6 5.9C214 2.1 218.9 0 224 0s10 2.1 13.4 5.9L386 169.4c3.9 4.2 6 9.8 6 15.5c0 12.7-10.3 23.1-23.1 23.1H344l75.5 105.7c2.9 4.1 4.5 9 4.5 14.1c0 13.4-10.9 24.2-24.2 24.2H368l76.2 122c2.5 4 3.8 8.5 3.8 13.2c0 13.7-11.1 24.9-24.9 24.9H24.9C11.1 512 0 500.9 0 487.1c0-4.7 1.3-9.2 3.8-13.2L80 352H48.2C34.8 352 24 341.1 24 327.8c0-5 1.6-10 4.5-14.1L104 208H79.1C66.3 208 56 197.7 56 184.9c0-5.7 2.1-11.3 6-15.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTreeLarge = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yy);
var Oy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tree-palm", f = 576, c = 512, e = [127796], t = "f82b", o = "M102.9 91.4l30.3 50.5c-4 3.5-8 7.2-12 11.2c-71 71-60.2 151-32.7 191.3c5 7.3 15.2 7.3 21.4 1L248.4 206.9c4 10.8 7.8 26.2 9.7 47.2c4.2 46.5-1.6 116.8-32.7 216.4c-3 9.7-1.3 20.3 4.8 28.5s15.6 13 25.8 13l64 0c16.1 0 29.8-12 31.8-28c12.4-99-2.3-207.2-31.7-292l126.6 0c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4 3.9 6.9 3.9l46.7 0c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0C59.6 0 10.7 64.2 1.6 112.1C-.1 120.8 7.2 128 16 128l46.7 0c2.8 0 5.4-1.5 6.9-3.9L89.1 91.4c3.1-5.2 10.6-5.2 13.7 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTreePalm = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Oy);
var ky = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trees", f = 640, c = 512, e = [], t = "f724", o = "M70.2 121.4L178.5 5.8C182 2.1 186.9 0 192 0s10 2.1 13.5 5.8L313.8 121.4c4 4.3 6.2 9.9 6.2 15.7c0 12.7-10.3 22.9-22.9 22.9L272 160l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5L304 288l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5L224 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64L23.5 416C10.5 416 0 405.5 0 392.5c0-5.5 1.9-10.8 5.4-15L80 288l-24.5 0c-13 0-23.5-10.5-23.5-23.5c0-5.5 1.9-10.8 5.4-15L112 160l-25.1 0C74.3 160 64 149.7 64 137.1c0-5.8 2.2-11.4 6.2-15.7zm271.4-16.4L434.5 5.8C438 2.1 442.9 0 448 0s10 2.1 13.5 5.8L569.8 121.4c4 4.3 6.2 9.9 6.2 15.7c0 12.7-10.3 22.9-22.9 22.9L528 160l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5L560 288l74.6 89.5c3.5 4.2 5.4 9.5 5.4 15c0 13-10.5 23.5-23.5 23.5L480 416l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64 0-23.4c0 0 0-.1 0-.1s0-.1 0-.1l0-.4s0 0 0 0c-.1-12.8-4.7-25.2-12.9-35l-40.6-48.7c13-10.2 21.4-26 21.4-43.8c0-13-4.6-25.6-12.9-35.5l-40.4-48.5c12.9-10 21.3-25.8 21.3-43.4c0-11.6-3.7-22.8-10.4-32.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrees = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ky);
var Ay = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = l;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTrianBalbot = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ay);
var jy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "triangle", f = 512, c = 512, e = [9650], t = "f2ec", o = "M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480l432 0c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTriangle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jy);
var t0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "triangle-instrument", f = 576, c = 512, e = ["triangle-music"], t = "f8e2", o = "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 37.9c-18 6.8-33.6 19.4-44.1 36.1L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94L450 512c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L448.2 239l-46.4 46.4 73.6 116.5c3 4.8 4.6 10.4 4.6 16c0 16.6-13.5 30-30 30L126 448c-16.6 0-30-13.5-30-30c0-5.7 1.6-11.2 4.6-16L266 140.1c4.8-7.6 13.1-12.1 22-12.1s17.3 4.6 22 12.1l48 75.9-51.2 51.2c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l43.5-43.5 46.4-46.4L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6L364.1 106C353.6 89.2 338 76.7 320 69.9L320 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTriangleInstrument = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(t0);
var By = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = t0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTriangleMusic = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(By);
var Ty = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tricycle", f = 512, c = 512, e = [], t = "e5c3", o = "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l73.6 0c7.9 0 14.4 6.4 14.4 14.4c0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8 .7-1.6 1.4-2.3 2.2l-10.9 0c-58.8 0-114 23.9-154.1 64.6L133.6 176l2.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l21.6 0 44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7c-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4c30.7-48.1 84-77.6 141.6-77.6l12.1 0 11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-2.4 0-4.8 .1-7.2 .2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4C416 59.9 388.1 32 353.6 32L280 32zm64.2 260l16.5 65.9c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-16.5-65.9c36.6 3.4 65.2 34.2 65.2 71.7c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-25.1 12.8-47.1 32.2-60zM112 312a56 56 0 1 1 0 112 56 56 0 1 1 0-112z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTricycle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ty);
var Fy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tricycle-adult", f = 640, c = 512, e = [], t = "e5c4", o = "M312 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l31.4 0c2.6 0 5 1.3 6.5 3.4l79.2 112.5-48.2 64.3c-5.6 7.5-14.4 11.9-23.7 11.9c-1.9 0-3.8-.2-5.7-.5l-322.9-63c-13-2.5-25.6 6-28.2 19s6 25.6 19 28.2l4.6 .9C9.1 305.4 0 327.6 0 352c0 53 43 96 96 96c18.2 0 35.3-5.1 49.8-13.9c-.6 .4-1.2 .7-1.8 1.1c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-4.1-.3-8.2-.8-12.2l55.1 10.7c4.9 1 9.9 1.4 14.9 1.4c24.4 0 47.4-11.5 62.1-31.1l38.8-51.8 13.7 19.5C457 305.6 448 327.7 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-11.4 0-22.3 2-32.5 5.6L389.2 87.8C378.7 72.9 361.6 64 343.4 64L312 64zM223.5 327.4c5.3 6.8 8.5 15.3 8.5 24.6c0 22.1-17.9 40-40 40c-2.9 0-5.6-.3-8.3-.9c5.3-12 8.3-25.2 8.3-39.1c0-11.2-1.9-21.9-5.4-31.8l36.9 7.2zM96 312a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm448 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM94.1 117.2c-6-16.6-24.3-25.3-40.9-19.3s-25.3 24.3-19.3 40.9l14.9 41.7c9.4 26.2 31.7 45.6 58.9 51.3l77.7 16.3c17.3 3.6 34.3-7.4 37.9-24.7s-7.4-34.3-24.7-37.9l-77.7-16.3c-5.4-1.1-9.9-5-11.8-10.3L94.1 117.2z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTricycleAdult = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fy);
var Hy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trillium", f = 448, c = 512, e = [], t = "e588", o = "M128 160c0-64.1 61.6-128.2 86.1-151.1c5.6-5.3 14.1-5.3 19.8 0c24.5 23 86.1 87 86.1 151.1c0 15.7-3.7 30.4-10.4 43.5c16.2 0 32.6 4.2 47.7 12.9c55.5 32 80.2 117.4 87.8 150.2c1.8 7.5-2.5 14.9-9.9 17.1c-32.1 9.7-118.4 31.1-173.9-1c-16.6-9.6-29.2-23.3-37.4-39.2c-8.1 15.9-20.8 29.6-37.4 39.2c-55.5 32-141.8 10.7-173.9 1c-7.4-2.2-11.6-9.6-9.9-17.1c7.6-32.7 32.3-118.1 87.8-150.2c15.1-8.7 31.6-12.9 47.8-12.9C131.7 190.4 128 175.7 128 160zm136 80a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm88-80s0 0 0 0c0-12.5-1.8-24.8-4.8-36.6c38.6-12.8 68.2-11.9 83-10c14.9 1.9 23.7 17.1 17.9 31c-5.6 13.3-19 38.4-47.7 64.6c-8.1-7.7-17.1-14.6-27-20.3c0 0 0 0 0 0c-7.3-4.2-14.9-7.6-22.6-10.3c.9-6 1.3-12.1 1.3-18.4zM100.8 123.4c-3 11.8-4.8 24.1-4.8 36.6c0 6.2 .4 12.3 1.3 18.3c-7.8 2.7-15.4 6.1-22.7 10.3c0 0 0 0 0 0c-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31c14.7-1.9 44.4-2.8 83 10zm73.3 299.4c9.8-3.1 19.4-7.2 28.5-12.5c7.8-4.5 14.9-9.7 21.4-15.4c6.5 5.8 13.6 11 21.4 15.4c9.2 5.3 18.8 9.4 28.6 12.5c-8.2 36.1-22.6 61.6-31 74.2c-9.1 13.7-28.8 13.7-37.9 0c-8.3-12.6-22.8-38.2-31-74.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrillium = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Hy);
var Ry = {}, o0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trophy-star", f = 576, c = 512, e = ["trophy-alt"], t = "f2eb", o = "M176 0L400 0c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8L552 64c13.3 0 24 10.7 24 24c0 92.6-33.5 157-78.5 200.7c-44.3 43.1-98.3 64.8-138.2 75.8c-23.4 6.5-39.4 26-39.4 45.6c0 20.9 17 37.9 37.9 37.9l26.1 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l26.1 0c20.9 0 37.9-17 37.9-37.9c0-19.6-15.9-39.2-39.4-45.6c-39.9-11-93.9-32.7-138.1-75.8C33.5 245 0 180.6 0 88C0 74.7 10.7 64 24 64l105.6 0c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM133.2 112l-84.4 0c5.1 66.3 31.1 111.2 63 142.3c22.4 21.8 48.3 37.3 73.2 48.3c-22.7-40.3-42.8-100.5-51.9-190.6zM390.8 302.6c24.9-11 50.8-26.5 73.2-48.3c32-31.1 58-76 63-142.3l-84.4 0c-9.1 90.1-29.2 150.3-51.9 190.6zM295.2 86.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4L212.7 136c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4L284.3 218c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4L334.4 187c-.4-2.6 .4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4L295.2 86.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrophyStar = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(o0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = o0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTrophyAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ry);
var Uy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-bolt", f = 640, c = 512, e = [], t = "e3d0", o = "M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM270.3 87.2L233.9 160l54.1 0c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-128 96c-5.9 4.5-14.2 4.2-19.9-.5s-7.4-12.8-4.1-19.4L182.1 192 128 192c-6.9 0-13-4.4-15.2-10.9s.1-13.7 5.6-17.9l128-96c5.9-4.5 14.2-4.2 19.9 .5s7.4 12.8 4.1 19.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uy);
var qy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-container", f = 640, c = 512, e = [], t = "f4dc", o = "M48 32l304 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L48 288c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32zM80 80c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16L96 96c0-8.8-7.2-16-16-16zM224 96l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16zM160 80c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zM304 96l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16zm128 72c0-13.3 10.7-24 24-24l72.8 0c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3l0 10.3 0 16 0 64c0 17.7-14.3 32-32 32l-1.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16L432 384l-145.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80l0-16 0-32c0-17.7 14.3-32 32-32l48 0 128 0 224 0 0-32 0-32 0-88zm48 88l105 0-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9L480 192l0 64zm80 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM208 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckContainer = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qy);
var Gy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-container-empty", f = 640, c = 512, e = [], t = "e2b5", o = "M456 144c-13.3 0-24 10.7-24 24l0 88 0 32 0 32-224 0L80 320l-48 0c-17.7 0-32 14.3-32 32l0 32 0 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16L432 384l17.6 0c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l1.6 0c17.7 0 32-14.3 32-32l0-64 0-16 0-10.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5L456 144zM585 256l-105 0 0-64 48.8 0c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckContainerEmpty = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gy);
var Wy = {}, l0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-ramp-couch", f = 640, c = 512, e = ["truck-couch"], t = "f4dd", o = "M640 0l0 400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8 352 64c0-35.3 28.7-64 64-64L640 0zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2l0 125.5-38.7 10.4L126.7 386.6 64.9 403.2c-17.1 4.6-34.6-5.6-39.2-22.6L13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckRampCouch = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(l0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = l0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faTruckCouch = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Wy);
var Ey = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-fire", f = 640, c = 512, e = [], t = "e65a", o = "M0 24C0 37.3 10.7 48 24 48l8 0 0 50.7C13.4 105.3 0 123.1 0 144l0 80 384 0 0-128 0-16 0-32 232 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24zM0 256L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l16 0c26.5 0 48-21.5 48-48l0-112 0-96c0-35.3-28.7-64-64-64l-16 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-48 0-32 0 0 144 0 16-16 0L0 256zM280 48l56 0 0 48-56 0 0-48zM232 96l-48 0 0-48 48 0 0 48zM80 48l56 0 0 48L80 96l0-48zM576 160l0 96-96 0 0-96 96 0zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckFire = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ey);
var Vy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-flatbed", f = 640, c = 512, e = [], t = "e2b6", o = "M608 416l-32 0c0 53-43 96-96 96s-96-43-96-96l-32 0-96 0c0 53-43 96-96 96s-96-43-96-96l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l56.4 0c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32L352 352l0-224c0-17.7 14.3-32 32-32l16 0 16 0 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32zM416 160l0 96 128 0 0-18.7L466.7 160 416 160zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckFlatbed = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Vy);
var Iy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-ladder", f = 640, c = 512, e = [], t = "e657", o = "M0 24C0 37.3 10.7 48 24 48l8 0 0 96-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-96 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24zM272 144l-32 0 0-96 32 0 0 96zM160 48l32 0 0 96-32 0 0-96zm-48 96l-32 0 0-96 32 0 0 96zM416 96c-17.7 0-32 14.3-32 32l0 96L48 224c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l16 0c26.5 0 48-21.5 48-48l0-80 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L544 114.7c-12-12-28.3-18.7-45.3-18.7L416 96zM576 256l-128 0 0-32 0-64 50.7 0L576 237.3l0 18.7zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckLadder = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Iy);
var Ky = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-plow", f = 640, c = 512, e = [], t = "f7de", o = "M192 96l0 96 135.5 0L269.9 96 192 96zm-64 96l0-112c0-26.5 21.5-48 48-48l93.9 0c22.5 0 43.3 11.8 54.9 31.1L402.1 192l45.9 0c17.7 0 32 14.3 32 32l0 64 32 0 0-112c0-7.3 2.5-14.3 7-20l64-80c11-13.8 31.2-16 45-5s16 31.2 5 45l-57 71.2L576 320l0 36.8L633 428c11 13.8 8.8 33.9-5 45s-33.9 8.8-45-5l-64-80c-4.5-5.7-7-12.7-7-20l0-16-37.5 0c3.5 10 5.5 20.8 5.5 32c0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32L224 352c-1.9 0-3.8-.2-5.6-.5c3.7 10.2 5.6 21.1 5.6 32.5c0 53-43 96-96 96s-96-43-96-96c0-11.2 1.9-22 5.5-32L32 352c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l96 0zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckPlow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ky);
var Xy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-ramp", f = 640, c = 512, e = [], t = "f4e0", o = "M640 400L640 0 416 0c-35.3 0-64 28.7-64 64l0 289.8L31.6 441.1c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5L416 402.7C417.5 463.3 467 512 528 512c61.9 0 112-50.1 112-112zM528 352a48 48 0 1 1 0 96 48 48 0 1 1 0-96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckRamp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xy);
var Qy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-tow", f = 640, c = 512, e = [], t = "e2b8", o = "M96 0l49.6 0c9.1 0 17.8 3.9 23.9 10.7L384 252l0-124c0-17.7 14.3-32 32-32l82.7 0c17 0 33.3 6.7 45.3 18.7L621.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 88c0 22.1-17.9 40-40 40l-24 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l144 0L96 64l0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16L64 32C64 14.3 78.3 0 96 0zM576 256l0-18.7L498.7 160 448 160l0 96 128 0zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckTow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qy);
var Jy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "truck-utensils", f = 640, c = 512, e = [], t = "e628", o = "M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM89.5 77.5c.7-5.9 5.6-10.3 11.6-10.3c6.2 0 11.3 4.8 11.6 11l4.4 75.5c.2 3 2.6 5.3 5.6 5.3s5.5-2.3 5.6-5.3l4.4-75.8c.3-6 5.3-10.6 11.3-10.6s10.9 4.7 11.3 10.6l4.4 75.8c.2 3 2.6 5.3 5.6 5.3s5.5-2.3 5.6-5.3l4.4-75.5c.4-6.2 5.5-11 11.6-11c5.9 0 10.9 4.4 11.6 10.3l9.5 81.4c0 29.4-20.5 54-48 60.3l0 84.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-84.8c-27.5-6.3-48-30.9-48-60.3l9.5-81.4zM256 154.9c0-63.1 41.3-86 50.3-90.2c1.1-.5 2.3-.8 3.6-.8c5.6 0 10.1 4.5 10.1 10.1l0 53.9 0 96 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c-17.7 0-32-14.3-32-32l0-37z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTruckUtensils = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jy);
var Yy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "trumpet", f = 640, c = 512, e = [127930], t = "f8e3", o = "M628.7 64.7C635.4 66.8 640 73 640 80l0 288c0 7-4.6 13.2-11.3 15.3s-14-.4-17.9-6.2c0 0 0 0 0 0c0 0 0 0 0 0l-.1-.2-.7-.9c-.6-.8-1.5-2.1-2.8-3.8c-2.5-3.3-6.2-8.1-11-13.9c-9.6-11.6-23.6-26.9-40.8-42.3c-35-31.1-81.3-60-131.4-60l-24 0 0 126c27.6-7.1 48-32.2 48-62l0-29.2c22 5 43.7 16.4 64 31.2c-1.1 69.8-58 126-128 126l-95.9 0c0 0 0 0-.1 0l-96 0c-70.7 0-128-57.3-128-128c0-23.3 6.2-45.2 17.1-64l-34.5 0c-3.3 9.3-12.2 16-22.6 16c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24c10.4 0 19.3 6.7 22.6 16L176 192l0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 40 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 40 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 24 0c50.1 0 96.4-28.8 131.4-60c17.3-15.3 31.2-30.7 40.8-42.3c4.8-5.8 8.5-10.6 11-13.9c1.2-1.7 2.2-2.9 2.8-3.8l.7-.9 .1-.2c0 0 0 0 0 0c0 0 0 0 0 0c4-5.8 11.2-8.3 17.9-6.2zM312 384l40 0 0-128-40 0 0 128zM224 256l0 128 40 0 0-128-40 0zm-96 64c0 29.8 20.4 54.9 48 62l0-124c-27.6 7.1-48 32.2-48 62z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTrumpet = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yy);
var Zy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tugrik-sign", f = 384, c = 512, e = [], t = "e2ba", o = "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l128 0 0 103L56.2 225c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 265l0 30L56.2 321c-17.1 4.3-27.6 21.7-23.3 38.8s21.7 27.6 38.8 23.3L160 361l0 87c0 17.7 14.3 32 32 32s32-14.3 32-32l0-103L327.8 319c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 279l0-30L327.8 223c17.1-4.3 27.6-21.7 23.3-38.8s-21.7-27.6-38.8-23.3L224 183l0-87 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 32 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTugrikSign = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Zy);
var py = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turkey", f = 640, c = 512, e = [], t = "f725", o = "M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-63-27.3-121.1-67.3-168.3c-.4 .2-.7 .4-1 .6l-28.3 20c-8.3 5.9-15.1 15-21.2 28.3c-6.1 13.4-10.5 28.6-15.4 46l-.3 1c-7.9 27.5-24 53-47.9 72.3c-61.8 50-152.5 40.5-202.5-21.4c-13.9-17.2-23.2-36.6-28.1-56.7c-2.3-9.4 5.3-17.9 15-17.9c8 0 14.6 5.8 16.9 13.5c4 14.5 10.9 28.5 21 41c21.3 26.3 52.1 40.5 83.5 41.5c25.9 .8 52.2-7.3 74-24.9c18.6-15 31.1-34.8 37.2-56.2l.6-2c9.6-33.7 20.1-70.5 48.7-90.6L486.7 192s0 0 0 0l2.5-1.8c18.3-12.9 43.3-10.4 67.4-8c9.4 .9 18.6 1.8 27.3 1.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2c1.1-4.4 1.7-9 1.7-13.8c0-30.9-25.1-56-56-56s-56 25.1-56 56z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurkey = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(py);
var xy = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turn-down-left", f = 512, c = 512, e = [], t = "e331", o = "M177.5 446c-8.8 3.8-19 2-26-4.6l-144-136C2.7 300.9 0 294.6 0 288s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 88 192 0c17.7 0 32-14.3 32-32l0-144c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 144c0 70.7-57.3 128-128 128l-192 0 0 88c0 9.6-5.7 18.2-14.5 22z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurnDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xy);
var iO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turn-down-right", f = 512, c = 512, e = [], t = "e455", o = "M334.5 446c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 88-192 0c-17.7 0-32-14.3-32-32L96 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64L0 208c0 70.7 57.3 128 128 128l192 0 0 88c0 9.6 5.7 18.2 14.5 22z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurnDownRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(iO);
var aO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turn-left", f = 512, c = 512, e = [], t = "e636", o = "M177.5 66c-8.8-3.8-19-2-26 4.6l-144 136C2.7 211.1 0 217.4 0 224s2.7 12.9 7.5 17.4l144 136c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-88 192 0c17.7 0 32 14.3 32 32l0 144c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-144c0-70.7-57.3-128-128-128l-192 0 0-88c0-9.6-5.7-18.2-14.5-22z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurnLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(aO);
var eO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turn-left-down", f = 384, c = 512, e = [], t = "e637", o = "M42 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-88 0 0-192c0-17.7 14.3-32 32-32l80 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L280 0C209.3 0 152 57.3 152 128l0 192-88 0c-9.6 0-18.2 5.7-22 14.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurnLeftDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eO);
var nO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turn-left-up", f = 384, c = 512, e = [], t = "e638", o = "M34 177.5c-3.8-8.8-2-19 4.6-26l136-144C179.1 2.7 185.4 0 192 0s12.9 2.7 17.4 7.5l136 144c6.6 7 8.4 17.2 4.6 26s-12.5 14.5-22 14.5l-88 0 0 192c0 17.7 14.3 32 32 32l80 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-80 0c-70.7 0-128-57.3-128-128l0-192-88 0c-9.6 0-18.2-5.7-22-14.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurnLeftUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nO);
var fO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turn-right", f = 512, c = 512, e = [], t = "e639", o = "M334.5 66c8.8-3.8 19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22l0-88-192 0c-17.7 0-32 14.3-32 32l0 144c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 304c0-70.7 57.3-128 128-128l192 0 0-88c0-9.6 5.7-18.2 14.5-22z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurnRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fO);
var cO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turntable", f = 576, c = 512, e = [], t = "f8e4", o = "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM384 256A160 160 0 1 0 64 256a160 160 0 1 0 320 0zM512 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160.4c0 2.5-.6 4.9-1.7 7.2l-16.2 32.5c-11 .7-21.4 7-26.7 17.6l-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l16-32c5.3-10.6 4.2-22.7-1.9-31.9l16.2-32.4c3.3-6.7 5.1-14 5.1-21.5L512 112zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurntable = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cO);
var tO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "turtle", f = 576, c = 512, e = [128034], t = "f726", o = "M384 249.2c0 21.4-17.4 38.8-38.8 38.8L70.8 288C49.4 288 32 270.6 32 249.2L32 208c0-97.2 78.8-176 176-176s176 78.8 176 176l0 41.2zM480 288c-2 0-4-.1-5.9-.3c-16.3 53.3-64.3 92.7-122.1 96l0 56.2c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-56-32 0 0 56c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-56-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l72 0 48 0 112 0 48 0 32 0c39.8 0 72-32.2 72-72l0-24 0-32 0-16c0-35.3 28.7-64 64-64c53 0 96 43 96 96l0 16c0 35.3-28.7 64-64 64l-32 0zm16-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTurtle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tO);
var oO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tv-music", f = 640, c = 512, e = [], t = "f8e6", o = "M576 64l0 288L64 352 64 64l512 0zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM96 480c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-384 0c-17.7 0-32 14.3-32 32zM416 112c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 48 0 49.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-68.9 96-36 0 42.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-96 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTvMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oO);
var lO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "tv-retro", f = 512, c = 512, e = [128250], t = "f401", o = "M169 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L80 96C35.8 96 0 131.8 0 176L0 432c0 44.2 35.8 80 80 80l352 0c44.2 0 80-35.8 80-80l0-256c0-44.2-35.8-80-80-80L321.9 96l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87L169 7zM424 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 224c0-35.3 28.7-64 64-64l192 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTvRetro = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(lO);
var dO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "typewriter", f = 512, c = 512, e = [], t = "f8e7", o = "M64 64C64 28.7 92.7 0 128 0L354.7 0c17 0 33.3 6.7 45.3 18.7L429.3 48c12 12 18.7 28.3 18.7 45.3l0 98.7 32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l0 160c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-160c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0L64 64zm320 64l-32 0c-17.7 0-32-14.3-32-32l0-32L128 64l0 128 18.7 0c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4l101.5 0c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4l18.7 0 0-64zM160 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 288a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0zm-32-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faTypewriter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dO);
var rO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ufo", f = 640, c = 512, e = [128760], t = "e047", o = "M320 112c59.2 0 109.6 37.9 128.3 90.7c5 14.2 7.7 29.4 7.7 45.3c0 0-40 40-136 40s-136-40-136-40c0-15.9 2.7-31.1 7.7-45.3c18.7-52.8 69-90.7 128.3-90.7zm0-48c-90.1 0-165.2 64.8-180.9 150.4C55.1 237.5 0 276.2 0 320c0 70.7 143.3 128 320 128s320-57.3 320-128c0-43.8-55.1-82.5-139.1-105.6C485.2 128.8 410.2 64 320 64zm0 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm408-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUfo = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rO);
var sO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "ufo-beam", f = 576, c = 512, e = [], t = "e048", o = "M184 152s24 40 104 40s104-40 104-40c0-48-33.3-104-104-104s-104 56-104 104zm-42.6-40.4C159.1 47.2 218.1 0 288 0s128.9 47.2 146.6 111.6C519.2 131.1 576 167 576 208c0 61.9-128.9 112-288 112S0 269.9 0 208c0-41 56.8-76.9 141.4-96.4zM120 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM312 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM74.3 325.7l4.2-8.9c14.3 5.6 29.7 10.6 46 15l-6.8 14.5-72 152c-5.7 12-20 17.1-32 11.4s-17.1-20-11.4-32l72-152zm384 20.6l-6.8-14.5c16.3-4.4 31.7-9.4 46-15l4.2 8.9 72 152c5.7 12 .6 26.3-11.4 32s-26.3 .6-32-11.4l-72-152z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUfoBeam = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sO);
var hO = {}, d0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "umbrella-simple", f = 512, c = 512, e = ["umbrella-alt"], t = "e2bc", o = "M256 0c17.7 0 32 14.3 32 32l0 2C403.8 48.4 495.6 140.2 510 256.1c2.2 17.5-12.4 31.9-30 31.9L32 288C14.3 288-.2 273.6 2 256.1C16.4 140.2 108.2 48.4 224 34l0-2c0-17.7 14.3-32 32-32zm32 430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4L224 320l64 0 0 110.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUmbrellaSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(d0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = d0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUmbrellaAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(hO);
var vO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "unicorn", f = 640, c = 512, e = [129412], t = "f727", o = "M448 160l0 78.1 0 1.9s0 0 0 0c-.5 30-12.8 56.4-32 75.7L416 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-133.3c-4.1-.7-8.2-1.6-12.3-2.8l-84-24c.2 2.3 .3 4.6 .3 6.9c0 18.6-7.4 36.5-20.6 49.7l-12.7 12.7c-4.8 4.8-6.4 11.8-4.3 18.2l20.8 62.5c6.9 20.7-8.5 42.1-30.4 42.1l-33.7 0c-13.8 0-26-8.8-30.4-21.9L95.3 437.7c-10.6-31.7-6.5-65.9 10-93.9c7.6-12.9 9.5-29.1 1.2-41.6L78.2 259.9c-7.3-11-11.9-23.4-13.6-36.4C54.6 230.8 48 242.6 48 256l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56c0-44.6 33.2-81.5 76.3-87.2c14.9-24.4 41.8-40.8 72.5-40.8l54.4 0 20.8 0 96 0C320 57.3 377.3 0 448 0l16 0 16 0 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-5.7 0c5.2 4.6 9.6 10 13.1 16l79.3 0c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8L560 90.7l0 64.8c0 22.1-13.4 41.9-33.9 50.1c-26.1 10.4-55.7-.9-68.3-26L448 160zm64-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUnicorn = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vO);
var uO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "uniform-martial-arts", f = 640, c = 512, e = [], t = "e3d1", o = "M180 0l28 0 9.6 0c12.3 0 23.5 7 28.8 18.1l61.1 126.7L253 288l-109 0 0-154.9L98 216.7c-1.3 2.4-2 5-2 7.7L96 384c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 224.4c0-18.9 4.8-37.4 13.9-54L80.3 49.7C95.9 21.2 124.9 2.8 157 .3c1-.2 2-.3 3-.3l4.4 0L180 0zM389.1 20.6C393.8 8.2 405.7 0 419 0l13 0 28 0 15.6 0L480 0c1 0 2 .1 3 .3c32.1 2.5 61 20.9 76.7 49.5l66.4 120.7c9.1 16.5 13.9 35.1 13.9 54L640 384c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-159.6c0-2.7-.7-5.3-2-7.7l-46-83.7L496 288l-208.8 0 52.7-138.3L389.1 20.6zM320 320l176 0 0 32-107.6 0-38.5 0 47.4 71.1c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-50.7-76-50.7 76c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2L290.1 352l-38.5 0L144 352l0-32 120 0 56 0zM216.1 405.4c-14.7 22.1-8.7 51.9 13.3 66.6s51.9 8.7 66.6-13.3L320 422.5l24.1 36.1c14.7 22.1 44.5 28 66.6 13.3s28-44.5 13.3-66.6L409.7 384l86.3 0 0 64c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-64 86.3 0-14.2 21.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUniformMartialArts = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uO);
var mO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "union", f = 384, c = 512, e = [8899], t = "f6a2", o = "M32 32c17.7 0 32 14.3 32 32l0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224c0 106-86 192-192 192S0 394 0 288L0 64C0 46.3 14.3 32 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUnion = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mO);
var gO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up-from-bracket", f = 448, c = 512, e = [], t = "e590", o = "M69.9 153.4L198.5 10.6C204.5 3.9 213.2 0 222.3 0l3.5 0c9.1 0 17.7 3.9 23.8 10.6L378.1 153.4c3.8 4.2 5.9 9.8 5.9 15.5c0 12.8-10.4 23.1-23.1 23.1L288 192l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128-72.9 0C74.4 192 64 181.6 64 168.9c0-5.7 2.1-11.2 5.9-15.5zM64 352l0 64c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 53-43 96-96 96L96 512c-53 0-96-43-96-96l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUpFromBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gO);
var PO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up-from-dotted-line", f = 448, c = 512, e = [], t = "e456", o = "M73.9 166.1L196.7 43.3C203.9 36.1 213.8 32 224 32s20.1 4.1 27.3 11.3L374.1 166.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9L288 224l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128-62.1 0C79.2 224 64 208.8 64 190.1c0-9 3.6-17.6 9.9-24zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUpFromDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(PO);
var MO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up-left", f = 384, c = 512, e = [], t = "e2bd", o = "M48 80l240 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-72 72L372.7 340.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3l-41.4 41.4c-7.2 7.2-17.1 11.3-27.3 11.3s-20.1-4.1-27.3-11.3L142.6 302.6l-72 72c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-240c0-17.7 14.3-32 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUpLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(MO);
var wO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up-right", f = 384, c = 512, e = [], t = "e2be", o = "M336 80L96 80c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l72 72L11.3 340.7C4.1 347.9 0 357.8 0 368s4.1 20.1 11.3 27.3l41.4 41.4C59.9 443.9 69.8 448 80 448s20.1-4.1 27.3-11.3L241.4 302.6l72 72c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-240c0-17.7-14.3-32-32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUpRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wO);
var NO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up-to-bracket", f = 448, c = 512, e = [], t = "e66e", o = "M374.1 294.1L251.3 171.3c-7.2-7.2-17.1-11.3-27.3-11.3s-20.1 4.1-27.3 11.3L73.9 294.1c-6.4 6.4-9.9 15-9.9 24C64 336.8 79.2 352 97.9 352l62.1 0 0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 62.1 0c18.7 0 33.9-15.2 33.9-33.9c0-9-3.6-17.6-9.9-24zM64 160l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-53-43-96-96-96L96 0C43 0 0 43 0 96l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUpToBracket = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(NO);
var zO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "up-to-dotted-line", f = 448, c = 512, e = [], t = "e457", o = "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM73.9 262.1L196.7 139.3c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3L374.1 262.1c6.4 6.4 9.9 15 9.9 24c0 18.7-15.2 33.9-33.9 33.9L288 320l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128-62.1 0C79.2 320 64 304.8 64 286.1c0-9 3.6-17.6 9.9-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUpToDottedLine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zO);
var LO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "usb-drive", f = 640, c = 512, e = [], t = "f8e9", o = "M64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l352 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L64 96zm544 32l-128 0 0 256 128 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32zM560 232a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm24 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUsbDrive = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(LO);
var CO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = v;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUsdCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(CO);
var DO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = P;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUsdSquare = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(DO);
var $O = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-alien", f = 448, c = 512, e = [], t = "e04a", o = "M64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3c-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm244.6 9c-37.9 0-68.6 30.7-68.6 68.6c0 6.3 5.1 11.4 11.4 11.4l16 0c37.9 0 68.6-30.7 68.6-68.6c0-6.3-5.1-11.4-11.4-11.4l-16 0zM208 244.6c0-37.9-30.7-68.6-68.6-68.6l-16 0c-6.3 0-11.4 5.1-11.4 11.4c0 37.9 30.7 68.6 68.6 68.6l16 0c6.3 0 11.4-5.1 11.4-11.4zM0 486.4C0 415 55.7 356.6 126.1 352.3c23.8 23.2 46.1 40.2 58.5 49.1c12 8.6 25.9 12.4 39.4 12.4s27.4-3.8 39.4-12.4c12.4-8.8 34.7-25.8 58.5-49.1C392.3 356.6 448 415 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserAlien = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})($O);
var _O = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-beard-bolt", f = 576, c = 512, e = [], t = "e689", o = "M198.9 0L224 0l25.1 0C305.9 0 352 46.1 352 102.9c0 6 1 12 3.1 17.6l25.2 69.3c2.4 6.7 3.7 13.8 3.7 21c0 24.6-14.6 46-35.7 55.7c2.4 6.7 3.7 14 3.7 21.5c0 15.2-5.3 29.3-14.2 40.2C326 342.7 308.1 352 288 352c-6.3 0-12.4-.9-18.2-2.6c-.8-.2-1.6-.5-2.4-.8C259.7 364.8 243.1 376 224 376s-35.7-11.2-43.4-27.4c-6.5 2.2-13.4 3.4-20.6 3.4c-19.9 0-37.6-9.1-49.4-23.3l-.4-.5c-8.9-11-14.2-25-14.2-40.2c0-7.5 1.3-14.8 3.7-21.5c-21.1-9.7-35.7-31-35.7-55.7c0-7.1 1.2-14.3 3.7-21l25.2-69.3c2-5.6 3.1-11.6 3.1-17.6C96 46.1 142.1 0 198.9 0zM304 128c0-11.4-2.4-22.2-6.7-32L280 96c-24.1 0-45.1-13.3-56-33c-10.9 19.7-31.9 33-56 33l-17.3 0c-4.3 9.8-6.7 20.6-6.7 32l0 16c0 12.5 2.9 24.4 8 35c.9-.5 1.8-1.1 2.6-1.8l.6-.6c18.2-18.2 43-28.5 68.8-28.5s50.5 10.2 68.8 28.5l.6 .6c.8 .8 1.6 1.4 2.6 1.8c5.1-10.6 8-22.4 8-35l0-16zm-34.2 81.6c-1.6-1.3-3.2-2.7-4.7-4.2l-.6-.6C253.7 194 239.2 188 224 188s-29.7 6-40.5 16.8l-.6 .6c-1.5 1.5-3.1 2.9-4.7 4.2c2.6 1.8 5.2 3.4 8 4.9c11.3 6.1 24.2 9.5 37.9 9.5s26.6-3.4 37.9-9.5c2.8-1.5 5.4-3.1 8-4.9zM160 384c2.2 0 4.5-.1 6.7-.2C181.2 398.7 201.5 408 224 408s42.8-9.3 57.3-24.2c2.2 .2 4.4 .2 6.7 .2c11.6 0 22.8-2.1 33.1-5.9c.4 1.9 1 3.8 1.6 5.7c6.7 19.2 24.9 32.1 45.3 32.1l18.3 0-29.3 58.5c-6 12-6.5 25.5-2.3 37.5l-324 0C13.8 512 0 498.2 0 481.3c0-59.6 32.3-111.7 80.4-139.6C97.7 367.2 126.9 384 160 384zM538.1 227.6c5.8 4.7 7.6 12.9 4.2 19.6L489.9 352l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L438.1 384 368 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserBeardBolt = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(_O);
var bO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-bounty-hunter", f = 448, c = 512, e = [], t = "e2bf", o = "M323 120C309.4 78 270 48 224 48s-85.4 30-99 72L323 120zm5.5 36.4L248 171.5l0 98.4 9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0l-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9 0-98.4-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2L383 256.5c1.3 20-12.4 37.9-32.1 41.8L250.1 318.4c-5.2 1-10.4 1.6-15.7 1.6l-20.9 0c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6c-1-3.4-1.6-7-1.6-10.7L64 16C64 7.2 71.2 0 80 0L96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 38zm38.4 282l179.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352zm37.1 103.4c-3.7 2.8-1.7 8.6 2.9 8.6l99.2 0c4.6 0 6.6-5.9 2.9-8.6l-47.7-35.8c-2.8-2.1-6.8-2.1-9.6 0l-47.7 35.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserBountyHunter = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bO);
var SO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = H2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUserChart = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(SO);
var yO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-chef", f = 448, c = 512, e = [], t = "e3d2", o = "M384 48c0 20.9-13.4 38.7-32 45.3l0 18.7 0 64c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-64 0-18.7C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM304 176l0-16-160 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM178.4 340.6c7.5 1.9 8.2 12.3 1 15.2l-43.2 17.3C111.9 382.8 96 406.3 96 432.5L96 480l0 24 0 8-8 0-24 0-38.4 0C11.5 512 0 500.5 0 486.4c0-58.8 37.7-108.8 90.3-127c3.3-1.2 5.7-4.3 5.7-7.8l0-21.4c0-5.2 4.9-9 9.9-7.8l72.5 18.1zM352 512l-192 0-24 0-8 0 0-8 0-24 0-47.5c0-13.1 8-24.9 20.1-29.7L341 325.6c5.3-2.1 11 1.8 11 7.4l0 18.6c0 3.5 2.3 6.6 5.7 7.8c52.6 18.2 90.3 68.2 90.3 127c0 14.1-11.5 25.6-25.6 25.6L352 512zM224 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserChef = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(yO);
var OO = {}, B = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-helmet-safety", f = 448, c = 512, e = [128119, "user-construction", "user-hard-hat"], t = "f82c", o = "M216 0c-13.3 0-24 10.7-24 24l0 56L163.6 23.1C125.6 43.5 99 82.6 96.2 128l-.2 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l256 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-.2 0C349 82.6 322.4 43.5 284.4 23.1L256 80l0-56c0-13.3-10.7-24-24-24L216 0zm8 320c65.3 0 119.1-48.9 127-112L97 208c7.9 63.1 61.7 112 127 112zm-89.6 32C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352l-179.2 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserHelmetSafety = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(B);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = B;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUserConstruction = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(OO);
var kO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-cowboy", f = 448, c = 512, e = [], t = "f8ea", o = "M224 16c6.7 0 10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.2 0 58.3 58.1 72 110.4C316.4 120 277 128 224 128s-92.4-8-120-17.6C117.7 58.1 140.8 0 176 0c18 0 25.9 5.4 32.5 9.9c4.7 3.3 8.8 6.1 15.5 6.1zM8.6 97.8c7-3.6 15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7C115.8 149.6 161.8 160 224 160s108.2-10.4 140.2-22.9c32.4-12.7 49.4-27.2 55-34.7c4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9c-7.1 5.2-14.7 10.1-22.7 14.8c0 .8 0 1.5 0 2.3c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-.8 0-1.5 0-2.3c-8-4.6-15.6-9.6-22.7-14.8C35.8 179.5 10.1 145 .8 117.1c-2.5-7.4 .8-15.6 7.8-19.2zM100.7 384l246.5 0c48.4 0 89.3 36.1 95.3 84.1l1 7.9c2.4 19.1-12.5 36-31.8 36L36.3 512C17 512 2.1 495.1 4.5 476l1-7.9c6-48 46.8-84.1 95.3-84.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserCowboy = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(kO);
var AO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-crown", f = 448, c = 512, e = [], t = "f6a4", o = "M144 128l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0zm0-108.8c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5L336 0c8.8 0 16 7.2 16 16l0 23 0 3.2c0 0 0 .1 0 .1L352 144c0 70.7-57.3 128-128 128s-128-57.3-128-128L96 42.3c0 0 0-.1 0-.1L96 39l0-23c0-8.8 7.2-16 16-16l2.4 0c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6l.1 .1zM0 472c0-92.8 75.2-168 168-168l112 0c92.8 0 168 75.2 168 168l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserCrown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(AO);
var jO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-doctor-hair", f = 448, c = 512, e = [], t = "e458", o = "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l31.8 0c28.9 0 55.8-15.2 70.6-40l5.3 5.3C265 89 280.8 95.7 297.3 96c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0zm64 320l-1.3 0-125.4 0-1.3 0 0 50.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-46.9C54.9 338.8 0 403.6 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-77.7-54.9-142.5-128-157.8l0 38.6c27.6 7.1 48 32.2 48 62l0 40c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-40c0-29.8 20.4-54.9 48-62l0-42zM168 424a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserDoctorHair = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jO);
var BO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-doctor-hair-long", f = 448, c = 512, e = [], t = "e459", o = "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zM288 320l0 42c-27.6 7.1-48 32.2-48 62l0 40c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-40c0-29.8-20.4-54.9-48-62l0-38.6c73.1 15.3 128 80.2 128 157.8c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-77.7 54.9-142.5 128-157.8l0 46.9c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-50.3 1.3 0 125.4 0 1.3 0zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserDoctorHairLong = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(BO);
var r0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-doctor-message", f = 640, c = 512, e = ["user-md-chat"], t = "f82e", o = "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3c0-81 54-149.4 128-171.1l0 59.1c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-65.4c6-.6 12.1-.9 18.3-.9l91.4 0c6.2 0 12.3 .3 18.3 .9l0 57.1c-27.6 7.1-48 32.2-48 62l0 40c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-40c0-29.8-20.4-54.9-48-62l0-50.8c74 21.7 128 90.1 128 171.1c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM432 0L592 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2l0-56-16 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserDoctorMessage = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(r0);
var s0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-group-crown", f = 640, c = 512, e = ["users-crown"], t = "f6a5", o = "M144 144l0-16 160 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80zm-.1-124.9c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5C121.5 1.2 118 0 114.4 0L112 0c-8.8 0-16 7.2-16 16l0 23 0 3.2c0 0 0 .1 0 .1L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-101.7c0 0 0-.1 0-.1l0-3.2 0-23c0-8.8-7.2-16-16-16l-2.4 0c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3 .2-.6 .4-.8 .6l-.1 .1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4L178.9 21.2c-11 6.3-24.7 5.5-34.9-2l-.1-.1zM168 304C75.2 304 0 379.2 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-92.8-75.2-168-168-168l-112 0zm264-48c61.9 0 112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8L384 144c0 5.4-.3 10.7-.8 16c-2.4 24.3-10.3 47.1-22.4 67c-.5 .8-1 1.6-1.4 2.3C379 245.9 404.3 256 432 256zm39.4 256l137.8 0c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320l-61.4 0c-2.4 0-4.8 .1-7.1 .2C452.9 356.8 480 411.3 480 472l0 8c0 11.7-3.1 22.6-8.6 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserGroupCrown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(s0);
var TO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-group-simple", f = 640, c = 512, e = [], t = "e603", o = "M160 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm320 0a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM0 416c0-70.7 57.3-128 128-128l64 0c70.7 0 128 57.3 128 128l0 16c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-16zm448 64c-38.3 0-72.7-16.8-96.1-43.5c.1-1.5 .1-3 .1-4.5l0-16c0-34.9-11.2-67.1-30.1-93.4c5.8-20 24.2-34.6 46.1-34.6l224 0c26.5 0 48 21.5 48 48l0 16c0 70.7-57.3 128-128 128l-64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserGroupSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(TO);
var FO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-hair", f = 448, c = 512, e = [], t = "e45a", o = "M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l30.4 0c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96l1.3 0c4.3 9.8 6.7 20.6 6.7 32zM96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm65.3 192C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320l-125.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserHair = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(FO);
var HO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-hair-buns", f = 448, c = 512, e = [], t = "e3d3", o = "M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l14.4 0c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32l14.4 0c1 5.2 1.6 10.5 1.6 16zM84 192c7 0 13.7-1.6 19.6-4.6c17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6c24.3 0 44-19.7 44-44l0-40c0-24.3-19.7-44-44-44c-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8C101.9 66.9 93.3 64 84 64c-24.3 0-44 19.7-44 44l0 40c0 24.3 19.7 44 44 44zm77.3 128C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320l-125.4 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserHairBuns = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(HO);
var RO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-hair-long", f = 448, c = 512, e = [], t = "e45b", o = "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zm65.3 192l125.4 0C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3C0 392.2 72.2 320 161.3 320z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserHairLong = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(RO);
var UO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = B;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUserHardHat = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(UO);
var qO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-headset", f = 448, c = 512, e = [], t = "f82d", o = "M224 32C135.6 32 64 103.6 64 192l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16C32 86 118 0 224 0S416 86 416 192l0 16c0 61.9-50.1 112-112 112l-64 0-16 0-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l32 0c44.2 0 80-35.8 80-80l0-16c0-88.4-71.6-160-160-160zM96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256l-8.6 0c-11.1-19.1-31.7-32-55.4-32l-32 0c-35.3 0-64 28.7-64 64c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192zM224 352l16 0 64 0 9.6 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352l73.6 0 16 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserHeadset = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qO);
var GO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-hoodie", f = 448, c = 512, e = [], t = "e68a", o = "M118.8 297.6c-1.3 10.6-8.6 19.5-18.2 24.2C41 350.7 0 411.7 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-70.6-41-131.6-100.6-160.5c-9.6-4.7-16.9-13.5-18.2-24.2c-1.2-9.6 2.7-19.1 9.4-26C366.7 242.8 384 203.4 384 160C384 71.6 312.4 0 224 0S64 71.6 64 160c0 43.4 17.3 82.8 45.4 111.6c6.8 6.9 10.6 16.4 9.4 26zM224 96c-36.2 0-64 28.3-64 61.3c0 17.5 8.5 35.8 22.9 53.6c13.1 16.2 29 29.5 41.1 38.5c12.1-8.9 28-22.3 41.1-38.5c14.4-17.9 22.9-36.1 22.9-53.6c0-33-27.8-61.3-64-61.3zm-96 61.3c0-51.5 43-93.3 96-93.3s96 41.8 96 93.3c0 55.6-53.3 100.9-80.5 120.4c-9.4 6.7-21.7 6.7-31.1 0C181.3 258.2 128 213 128 157.3zM160 400l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserHoodie = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(GO);
var WO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-magnifying-glass", f = 640, c = 512, e = [], t = "e5c5", o = "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3c-88.4 0-160-71.6-160-160c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1l-91.4 0zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserMagnifyingGlass = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(WO);
var EO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = r0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUserMdChat = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(EO);
var VO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-music", f = 640, c = 512, e = [], t = "f8eb", o = "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c36.3 0 70.1 10.9 98.3 29.5l0 51.6c-18 2.5-34.8 9.1-48.5 19.4c-17.6 13.2-31.5 34-31.5 59.5c0 19.1 7.7 35.4 18.9 48L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM630 164.5c6.3 4.5 10 11.8 10 19.5l0 48 0 160c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-88.2-144 48L448 464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5L400 296l0-48c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserMusic = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(VO);
var IO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-nurse-hair", f = 448, c = 512, e = [], t = "e45d", o = "M96 70.2L96 128l.3 0c-.2 2.6-.3 5.3-.3 8l0 40c0 70.7 57.3 128 128 128s128-57.3 128-128l0-40c0-2.7-.1-5.4-.3-8l.3 0 0-57.8c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160l8 0zM141.3 336.2c-7.6-8.1-18.9-11.9-29.4-8.5C47 348.5 0 409.4 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-71.8-47-132.7-111.9-153.6c-10.5-3.4-21.8 .4-29.4 8.5l-71 75.5c-6.3 6.7-17 6.7-23.3 0l-71-75.5zM208 48c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0 0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l16 0 0-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserNurseHair = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(IO);
var KO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-nurse-hair-long", f = 448, c = 512, e = [], t = "e45e", o = "M96 70.2L96 128l.3 0c-.2 2.6-.3 5.3-.3 8l0 24 0 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 293.9 58.1 304 70.6 304L224 304l153.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5l0-11 0-24c0-2.7-.1-5.4-.3-8l.3 0 0-57.8c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160l8 0zM151.4 346.8c-6.4-6.8-15.4-10.6-24.6-9.3C55.1 347.7 0 409.4 0 483.8C0 499.4 12.6 512 28.2 512l391.7 0c15.6 0 28.2-12.6 28.2-28.2c0-74.5-55.1-136.1-126.7-146.3c-9.2-1.3-18.3 2.5-24.6 9.3l-61 64.8c-6.3 6.7-17 6.7-23.3 0l-61-64.8zM208 48c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0 0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l16 0 0-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserNurseHairLong = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(KO);
var XO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-pilot", f = 448, c = 512, e = [], t = "e2c0", o = "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM161.7 72.8c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm116.3 240l-72.3-54.2c-2.2-1.7-4.9-2.6-7.7-2.6C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352c-2.8 0-5.5 .9-7.7 2.6l-72.3 54.2c-5.7 4.3-13.5 4.3-19.2 0zM336 416l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserPilot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(XO);
var QO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-pilot-tie", f = 448, c = 512, e = [], t = "e2c1", o = "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM161.7 72.8c4-7.9 13.6-11.1 21.5-7.2L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5zm-63.6 96C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512L192 512s0 0 0 0l64 0s0 0 0 0l166.4 0c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.2 464.9 240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2l-44.2 0c-11.9 0-19.6 12.5-14.3 23.2zM320 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserPilotTie = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(QO);
var JO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-police", f = 448, c = 512, e = [], t = "e333", o = "M230.1 .8l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5l0 8.4c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 131.7 80 121.6 80 110.9l0-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40c4-1.1 8.2-1.1 12.2 0zM227 48.6c-1.9-.8-4-.8-5.9 0L189 61.4c-3 1.2-5 4.2-5 7.4c0 17.2 7 46.1 36.9 58.6c2 .8 4.2 .8 6.2 0C257 114.9 264 86 264 68.8c0-3.3-2-6.2-5-7.4L227 48.6zM98.1 168.8c39.1 15 81.5 23.2 125.9 23.2s86.8-8.2 125.9-23.2c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-7.9 .7-15.7 2.1-23.2zM134.4 352c2.8 0 5.5 .9 7.7 2.6l72.3 54.2c5.7 4.3 13.5 4.3 19.2 0l72.3-54.2c2.2-1.7 4.9-2.6 7.7-2.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352zM352 408c-3.5 0-6.5 2.2-7.6 5.5L339 430.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9L331 454.8l-5.4 16.6c-1.1 3.3 .1 6.9 2.9 9s6.6 2 9.4 0L352 470.1l14.1 10.3c2.8 2 6.6 2.1 9.4 0s4-5.7 2.9-9L373 454.8l14.1-10.2c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserPolice = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(JO);
var YO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-police-tie", f = 448, c = 512, e = [], t = "e334", o = "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM98.1 168.8C96.7 176.3 96 184.1 96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2C310.8 183.8 268.4 192 224 192s-86.8-8.2-125.9-23.2zm89.5 206.3L208 416l-12.2 48.9L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512L192 512s0 0 0 0l64 0s0 0 0 0l166.4 0c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.2 464.9 240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2l-44.2 0c-11.9 0-19.6 12.5-14.3 23.2zm172 38.4l5.4 16.6 17.4 0c3.5 0 6.6 2.2 7.6 5.5s-.1 6.9-2.9 9L373 454.8l5.4 16.6c1.1 3.3-.1 6.9-2.9 9s-6.6 2-9.4 0L352 470.1l-14.1 10.3c-2.8 2-6.6 2.1-9.4 0s-4-5.7-2.9-9l5.4-16.6-14.1-10.2c-2.8-2-4-5.7-2.9-9s4.2-5.5 7.6-5.5l17.4 0 5.4-16.6c1.1-3.3 4.1-5.5 7.6-5.5s6.5 2.2 7.6 5.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserPoliceTie = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(YO);
var ZO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-robot", f = 448, c = 512, e = [], t = "e04b", o = "M224 0c8.8 0 16 7.2 16 16l0 48 64 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l64 0 0-48c0-8.8 7.2-16 16-16zM16 144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zm400-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352l256 0c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32l-64 0 0-64c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32l0 64-64 0c-17.7 0-32-14.3-32-32l0-32c0-53 43-96 96-96zm80 112l0 48-32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16l0 48-32 0 0-48c0-8.8 7.2-16 16-16zm80 16l0 48-32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserRobot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ZO);
var pO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-robot-xmarks", f = 448, c = 512, e = [], t = "e4a7", o = "M224 0c8.8 0 16 7.2 16 16l0 48 64 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l64 0 0-48c0-8.8 7.2-16 16-16zM16 144c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96zm400-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm80-16a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352l256 0c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32l-64 0 0-64c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32l0 64-64 0c-17.7 0-32-14.3-32-32l0-32c0-53 43-96 96-96zm80 112l0 48-32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16l0 48-32 0 0-48c0-8.8 7.2-16 16-16zm80 16l0 48-32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16zM119.5 119.5c-4.7 4.7-4.7 12.3 0 17L143 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L160 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L177 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L160 143l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0zm145 0c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L271 160l-23.5 23.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L288 177l23.5 23.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L305 160l23.5-23.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L288 143l-23.5-23.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserRobotXmarks = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(pO);
var xO = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-shakespeare", f = 448, c = 512, e = [], t = "e2c2", o = "M224 48c-44.2 0-80 35.8-80 80l0 32c0 40.1 29.5 73.3 68 79.1l0-15.1c0-6.6 5.4-12 12-12s12 5.4 12 12l0 15.1c38.5-5.8 68-39 68-79.1l0-32c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 23.2c0 10.9 3.7 21.5 10.5 30L373.6 195c6.7 8.4 10.4 18.8 10.4 29.6c0 26.2-21.2 47.4-47.4 47.4L286 272c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16l-50.6 0C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30L96 128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM272 304c23.9 0 45.8 8.8 62.6 23.2c65.7 20.4 113.4 81.7 113.4 154c0 17-13.8 30.7-30.7 30.7L240 512c0-8.8-7.2-16-16-16s-16 7.2-16 16L30.7 512C13.8 512 0 498.2 0 481.3c0-72.4 47.7-133.6 113.4-154C130.2 312.8 152.1 304 176 304l96 0zM208 448a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm-80-48c26.4-10.6 54.6-16 83.1-16l25.8 0c28.5 0 56.7 5.4 83.1 16c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserShakespeare = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xO);
var ik = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-tie-hair", f = 448, c = 512, e = [], t = "e45f", o = "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zM280 512l-112 0-5.5 0c0 0 0 0-.1 0L30.7 512C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4c8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2l19.7 0 19.7 0c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3c70.1 17.6 121.9 81 121.9 156.4c0 17-13.8 30.7-30.7 30.7l-131.7 0c0 0 0 0-.1 0l-5.5 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserTieHair = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ik);
var ak = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-tie-hair-long", f = 448, c = 512, e = [], t = "e460", o = "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zM280 512l-112 0-5.5 0c0 0 0 0-.1 0L30.7 512C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4c8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2l19.7 0 19.7 0c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3c70.1 17.6 121.9 81 121.9 156.4c0 17-13.8 30.7-30.7 30.7l-131.7 0c0 0 0 0-.1 0l-5.5 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserTieHairLong = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ak);
var ek = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-unlock", f = 640, c = 512, e = [], t = "e058", o = "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3l0 128c0 11.7 3.1 22.6 8.6 32L29.7 512C13.3 512 0 498.7 0 482.3zM496 272l0 48 16 0 48 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserUnlock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ek);
var nk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-visor", f = 448, c = 512, e = [], t = "e04c", o = "M343 175.2C324.2 222.5 278 256 224 256s-100.2-33.5-119-80.8c-14.3-3.2-25-16-25-31.2l0-64c0-17.7 14.3-32 32-32l12.1 0C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48L336 48c17.7 0 32 14.3 32 32l0 64c0 15.3-10.7 28-25 31.2zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zm348.7-19.9c2.4 3.2 7.3 1.4 7.3-2.5c-1.1-35.3-11.3-65.6-30.1-90.2c-1.2-2-4.6-1.9-6.1-.1c-19.9 23-31.9 53-35.8 89.5c-.3 3.5 3.7 5.5 6.5 3.5c1.8-1.4 4.1-3.4 6.6-5.6c9.2-8.1 22.3-19.5 31.7-19.5c2.3 2 7.6 7.8 19.9 25zM144 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L144 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserVisor = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nk);
var fk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-vneck", f = 448, c = 512, e = [], t = "e461", o = "M224 0a128 128 0 1 0 0 256A128 128 0 1 0 224 0zM145.9 314.9c-3.5-5.2-9.8-8-15.9-6.6C55.5 325.5 0 392.3 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-79.7-55.5-146.5-130-163.7c-6.1-1.4-12.4 1.4-15.9 6.6L237.3 412c-6.3 9.5-20.3 9.5-26.6 0l-64.8-97.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserVneck = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fk);
var ck = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-vneck-hair", f = 448, c = 512, e = [], t = "e462", o = "M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l30.4 0c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96l1.3 0c4.3 9.8 6.7 20.6 6.7 32zM96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm61.3 199.1c-3.2-4.3-8.4-6.7-13.7-6.2C62.9 329.7 0 398.2 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-83.1-62.9-151.5-143.7-160.3c-5.3-.6-10.5 1.9-13.7 6.2l-53.9 71.8c-6.4 8.5-19.2 8.5-25.6 0l-53.9-71.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserVneckHair = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(ck);
var tk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "user-vneck-hair-long", f = 448, c = 512, e = [], t = "e463", o = "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zm49.9 186.9L210.7 412c6.3 9.5 20.3 9.5 26.6 0l64.8-97.1c3.5-5.2 9.8-8 15.9-6.6c74.5 17.2 130 84 130 163.7l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-79.7 55.5-146.5 130-163.7c6.1-1.4 12.4 1.4 15.9 6.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUserVneckHairLong = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tk);
var ok = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = C3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUsersClass = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(ok);
var lk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = s0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUsersCrown = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lk);
var dk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "users-medical", f = 640, c = 512, e = [], t = "f830", o = "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM405.3 320l77.4 0c6.6-18.6 24.4-32 45.3-32l32 0c20.9 0 38.7 13.4 45.3 32l13.4 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM416 400c0-14.6 6.5-27.7 16.9-36.5C416.3 356.1 398 352 378.7 352l-117.3 0C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l328.1 0c-1.8-5-2.7-10.4-2.7-16l0-16-16 0c-26.5 0-48-21.5-48-48l0-32zm0-176a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm96 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUsersMedical = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(dk);
var rk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ha;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUtensilFork = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(rk);
var sk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = w4;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUtensilKnife = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(sk);
var hk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ra;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faUtensilsAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(hk);
var vk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "utensils-slash", f = 640, c = 512, e = [], t = "e464", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68 0-49.1 0-112 0-208c0-17.7-14.3-32-32-32C496 0 384 32 384 176l0 99.7-77.6-60.8c8.6-13.6 13.6-29.7 13.6-47c0-6.4-.7-12.8-2.1-19.1L287.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S256 7.8 256 16l0 134.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L223.9 14.6C223.2 6.3 216.3 0 208 0s-15.2 6.3-15.9 14.6l-9.4 103.3L160 100.1 160 16c0-8.2-6.1-15-14.3-15.9s-15.6 4.5-17.4 12.4L116.5 66 38.8 5.1zM176 255.6L176 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-194.9L96.1 171.7c1.9 44.2 36.3 80 79.9 83.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUtensilsSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vk);
var uk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "utility-pole", f = 512, c = 512, e = [], t = "e2c3", o = "M256 0c17.7 0 32 14.3 32 32l0 32 96 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 32 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 17.7-14.3 32-32 32l-51.2 0L288 221.9l0 66.1 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192 0-66.1L83.2 128 32 128C14.3 128 0 113.7 0 96L0 56C0 42.7 10.7 32 24 32s24 10.7 24 24l0 8 32 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 96 0 0-32c0-17.7 14.3-32 32-32zM140.8 128L224 183.4l0-55.4-83.2 0zM288 183.4L371.2 128 288 128l0 55.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUtilityPole = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uk);
var mk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "utility-pole-double", f = 512, c = 512, e = [], t = "e2c4", o = "M256 0c17.7 0 32 14.3 32 32l0 32 96 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 32 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 17.7-14.3 32-32 32l-51.2 0L288 221.9l0 34.1 96 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 32 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 17.7-14.3 32-32 32l-51.2 0L288 413.9l0 66.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.1L83.2 320 32 320c-17.7 0-32-14.3-32-32l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 32 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 96 0 0-34.1L83.2 128 32 128C14.3 128 0 113.7 0 96L0 56C0 42.7 10.7 32 24 32s24 10.7 24 24l0 8 32 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 96 0 0-32c0-17.7 14.3-32 32-32zM140.8 128L224 183.4l0-55.4-83.2 0zM288 183.4L371.2 128 288 128l0 55.4zM140.8 320L224 375.4l0-55.4-83.2 0zM288 375.4L371.2 320 288 320l0 55.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faUtilityPoleDouble = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(mk);
var gk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "vacuum", f = 640, c = 512, e = [], t = "e04d", o = "M301.6 64L512 64c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.8 52.8C513.8 148.1 467.2 128 416 128c-35.3 0-64 28.7-64 64l0 100c10.2-2.6 21-4 32-4c70.7 0 128 57.3 128 128c0 38.2-16.8 72.5-43.3 96l75.3 0c35.3 0 64-28.7 64-64l0-128c0-31.7-7.7-61.7-21.3-88C619 208.7 640 170.8 640 128C640 57.3 582.7 0 512 0L301.6 0C241.3 0 189.1 42.2 176.4 101.2L150.1 224l65.5 0L239 114.6C245.4 85.1 271.4 64 301.6 64zM208.7 256l-65.5 0L109 416l-25.2 0c-33.8 0-64.7 18.9-80 49C1.4 469.5 0 474.6 0 480c0 17.7 14.3 32 32 32l95.4 0c.4 0 .9 0 1.3 0l47.3 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-1.6 0 34.3-160zM480 416a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVacuum = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gk);
var Pk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "vacuum-robot", f = 512, c = 512, e = [], t = "e04e", o = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM356.7 356.7c55.6-55.6 55.6-145.8 0-201.4s-145.8-55.6-201.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm-144-144c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVacuumRobot = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Pk);
var Mk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "value-absolute", f = 512, c = 512, e = [], t = "f6a6", o = "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 64c0-17.7-14.3-32-32-32zM182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 301.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256l73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 210.7l-73.4-73.4zM512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faValueAbsolute = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Mk);
var wk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "vector-circle", f = 512, c = 512, e = [], t = "e2c6", o = "M192 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 9.3C392.2 62.8 449.2 119.8 470.7 192l9.3 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-9.3 0C449.2 392.2 392.2 449.2 320 470.7l0 9.3c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-9.3C119.8 449.2 62.8 392.2 41.3 320L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l9.3 0C62.8 119.8 119.8 62.8 192 41.3l0-9.3zM403.7 194.4c-16.2-38.9-47.3-70-86.2-86.2C312.7 119.9 301.3 128 288 128l-64 0c-13.3 0-24.7-8.1-29.6-19.7c-38.9 16.2-70 47.3-86.2 86.2c11.6 4.8 19.7 16.2 19.7 29.6l0 64c0 13.3-8.1 24.7-19.7 29.6c16.2 38.9 47.3 70 86.2 86.2c4.8-11.6 16.2-19.7 29.6-19.7l64 0c13.3 0 24.7 8.1 29.6 19.7c38.9-16.2 70-47.3 86.2-86.2C392.1 312.7 384 301.3 384 288l0-64c0-13.3 8.1-24.7 19.7-29.6zM240 48l0 32 32 0 0-32-32 0zm32 384l-32 0 0 32 32 0 0-32zM432 240l0 32 32 0 0-32-32 0zM80 240l-32 0 0 32 32 0 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVectorCircle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wk);
var Nk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "vector-polygon", f = 448, c = 512, e = [], t = "e2c7", o = "M0 64C0 46.3 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l192 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-31.7 0-4.5 7.9-28.4 49.7c.4 2.1 .6 4.2 .6 6.4l0 64c0 2.2-.2 4.3-.6 6.4l28.4 49.7 4.5 7.9 31.7 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l-192 0c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l0-192c-17.7 0-32-14.3-32-32L0 64zM322.2 372.3L292.3 320 256 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l36.3 0 29.9-52.3c-1.4-3.6-2.2-7.5-2.2-11.7l-192 0c0 17.7-14.3 32-32 32l0 192c17.7 0 32 14.3 32 32l192 0c0-4.1 .8-8.1 2.2-11.7zM48 80l0 32 32 0 0-32L48 80zm320 0l0 32 32 0 0-32-32 0zM80 400l-32 0 0 32 32 0 0-32zm288 0l0 32 32 0 0-32-32 0zM304 240l-32 0 0 32 32 0 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVectorPolygon = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Nk);
var zk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "vent-damper", f = 640, c = 512, e = [], t = "e465", o = "M64 128c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 32 32 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-32 0 0 32c0 35.3-28.7 64-64 64l-384 0c-35.3 0-64-28.7-64-64l0-32-32 0c-17.7 0-32-14.3-32-32L0 192c0-17.7 14.3-32 32-32l32 0 0-32zm120 16c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVentDamper = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zk);
var Lk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = A2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faVhs = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Lk);
var Ck = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "video-arrow-down-left", f = 576, c = 512, e = [], t = "e2c8", o = "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9l0 17.1 0 128 0 17.1 14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2l0-256zM232 352l-112 0c-13.3 0-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54.1L247 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-103 103 54.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVideoArrowDownLeft = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ck);
var Dk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "video-arrow-up-right", f = 576, c = 512, e = [], t = "e2c9", o = "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9l0 17.1 0 128 0 17.1 14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2l0-256zM152 160l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1L137 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l103-103L152 208c-13.3 0-24-10.7-24-24s10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVideoArrowUpRight = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Dk);
var $k = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = v1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faVideoCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})($k);
var _k = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = g2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faVideoHandheld = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(_k);
var bk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "video-plus", f = 576, c = 512, e = [], t = "f4e1", o = "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm512 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L416 174.9l0 17.1 0 128 0 17.1 14.2 9.5 96 64c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2l0-256zM216 184l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVideoPlus = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(bk);
var Sk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "violin", f = 640, c = 512, e = [127931], t = "f8ed", o = "M630.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L417 177.7C398 166.5 375.7 160 352 160c-20.8 0-40.4 5-57.8 13.8c-6.7 3.4-9.1 11.4-7.7 18.8c1 5 1.5 10.2 1.5 15.4c0 44.2-35.8 80-80 80c-11.6 0-22.7-2.5-32.7-7c-7.4-3.3-16.6-2.4-21.3 4.3C137.6 308.7 128 337.2 128 368c0 15 2.3 29.5 6.6 43.1l44.6-33.5c19.1-14.3 45.9-12.4 62.7 4.5l16 16c16.9 16.9 18.8 43.6 4.5 62.7l-33.5 44.6c13.6 4.3 28.1 6.6 43.1 6.6c30.8 0 59.3-9.6 82.6-26.1c6.7-4.7 7.6-13.8 4.3-21.3c-4.5-10-7-21-7-32.7c0-44.2 35.8-80 80-80c5.3 0 10.5 .5 15.4 1.5c7.4 1.4 15.4-1 18.8-7.7c8.8-17.4 13.8-37 13.8-57.8c0-23.7-6.5-46-17.7-65L630.6 54.6zM520 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM345 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 41zM472 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm48-48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM198.4 403.2l-64 48c-3.7 2.8-6 7-6.4 11.7s1.4 9.2 4.6 12.4l32 32c3.3 3.3 7.8 5 12.4 4.6s8.9-2.6 11.7-6.4l48-64c4.8-6.4 4.1-15.3-1.5-20.9l-16-16c-5.6-5.6-14.5-6.3-20.9-1.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faViolin = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Sk);
var h0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "volume", f = 576, c = 512, e = [128265, "volume-medium"], t = "f6a8", o = "M333.1 34.8C344.6 40 352 51.4 352 64l0 384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352 96 352c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l67.8 0L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVolume = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(h0);
var yk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = h0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faVolumeMedium = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(yk);
var Ok = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "volume-slash", f = 640, c = 512, e = [128263], t = "f2e2", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.1 386.2C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6 352 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L197.8 129.8 38.8 5.1zM352 373.3L82.9 161.3C53.8 167.4 32 193.1 32 224l0 64c0 35.3 28.7 64 64 64l67.8 0L298.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448l0-74.7z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faVolumeSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ok);
var kk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = A;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faVoteNay = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(kk);
var Ak = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "waffle", f = 512, c = 512, e = [129479], t = "e466", o = "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-64 0 0-48c0-8.8-7.2-16-16-16zm16 256l0-64 64 0 0 64-64 0zm96 0l0-64 64 0 0 64-64 0zm64-160l0 64-64 0 0-64 64 0zm-96 0l0 64-64 0 0-64 64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWaffle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ak);
var jk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wagon-covered", f = 640, c = 512, e = [], t = "f8ee", o = "M4.5 57.4C-5.2 30.3 16.1 2.1 44.8 4.1L194.1 14C210.9 15.1 224 29.1 224 45.9L224 224 64 224 4.5 57.4zM288 16l64 0c17.7 0 32 14.3 32 32l0 176-128 0 0-176c0-17.7 14.3-32 32-32zM64 288c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-1.6 0c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96l-66.3 0c-7.8 54.3-54.4 96-110.9 96c-61.9 0-112-50.1-112-112c0-31.3 12.9-59.7 33.6-80L96 320c-17.7 0-32-14.3-32-32zm96 128l-46 0c5.8 22.5 23.5 40.2 46 46l0-46zm0-32l0-46c-22.5 5.8-40.2 23.5-46 46l46 0zm32 78c22.5-5.8 40.2-23.5 46-46l-46 0 0 46zm0-124l0 46 46 0c-5.8-22.5-23.5-40.2-46-46zM448 462l0-46-46 0c5.8 22.5 23.5 40.2 46 46zm-46-78l46 0 0-46c-22.5 5.8-40.2 23.5-46 46zm124 32l-46 0 0 46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46l0 46 46 0zM595.2 4.1c28.7-1.9 50 26.2 40.3 53.4L576 224l-160 0 0-178.1c0-16.8 13.1-30.8 29.9-31.9l149.3-10z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWagonCovered = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(jk);
var Bk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "walker", f = 448, c = 512, e = [], t = "f831", o = "M194 64l126 0c17.7 0 32 14.3 32 32l0 64-207 0 17.9-71.8C166.5 74 179.3 64 194 64zM352 224l0 168.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4L416 96c0-53-43-96-96-96L194 0c-44.1 0-82.4 30-93.1 72.7L1 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3L129 224l223 0zm32 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWalker = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Bk);
var Tk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = Ui;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWallBrick = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Tk);
var Fk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wand", f = 512, c = 512, e = [], t = "f72a", o = "M497 7c-9-9-23.5-9.4-33-.9L189.3 251.9c-2.9 2.6-6.7 4.1-10.7 4.1L144 256c-8.8 0-16 7.2-16 16l0 27.6c0 4.6-1.9 8.9-5.3 11.9L11.1 411.3C4 417.7 0 426.7 0 436.2c0 8.8 3.5 17.3 9.7 23.5l42.6 42.6c6.2 6.2 14.7 9.8 23.5 9.8c9.5 0 18.5-4 24.8-11.1L372.3 197.3c3-3.4 7.4-5.3 11.9-5.3l15.8 0c8.8 0 16-7.2 16-16l0-21.4c0-3.9 1.5-7.7 4.1-10.7L505.9 48c8.5-9.5 8.1-24-.9-33l-8-8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWand = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Fk);
var Hk = {}, v0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "warehouse-full", f = 640, c = 512, e = ["warehouse-alt"], t = "f495", o = "M0 488L0 171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4L640 488c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-264c0-17.7-14.3-32-32-32l-384 0c-17.7 0-32 14.3-32 32l0 264c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM376 384l112 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zM128 248c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-80zm24 136l144 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWarehouseFull = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(v0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = v0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWarehouseAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Hk);
var Rk = {}, u0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "washing-machine", f = 448, c = 512, e = ["washer"], t = "f898", o = "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm16 328c-61.9 0-112-50.1-112-112c0-16.5 3.6-32.2 10-46.3c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5C328.5 373 281.3 416 224 416z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWashingMachine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(u0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = u0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWasher = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Rk);
var Uk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "watch", f = 384, c = 512, e = [8986], t = "f2e1", o = "M112 0L272 0c26.5 0 48 21.5 48 48l0 24.2C283.7 46.8 239.6 32 192 32s-91.7 14.8-128 40.2L64 48C64 21.5 85.5 0 112 0zM64 464l0-24.2c36.3 25.3 80.4 40.2 128 40.2s91.7-14.8 128-40.2l0 24.2c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48zM0 256a192 192 0 1 1 384 0A192 192 0 1 1 0 256zM192 152c-13.3 0-24 10.7-24 24l0 80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2l0-67.2c0-13.3-10.7-24-24-24z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWatch = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Uk);
var qk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "watch-apple", f = 384, c = 512, e = [], t = "e2cb", o = "M64 48l256 0c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160L0 352c0 44.2 35.8 80 80 80l224 0c44.2 0 80-35.8 80-80l0-192c0-44.2-35.8-80-80-80L80 80zM192 213.3a42.7 42.7 0 1 1 0 85.3 42.7 42.7 0 1 1 0-85.3zM213.3 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm74.7-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-74.7-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 512l160 0c26.5 0 48-21.5 48-48L64 464c0 26.5 21.5 48 48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWatchApple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(qk);
var Gk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "watch-calculator", f = 384, c = 512, e = [], t = "f8f0", o = "M64 48l256 0c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160L0 352c0 44.2 35.8 80 80 80l224 0c44.2 0 80-35.8 80-80l0-192c0-44.2-35.8-80-80-80L80 80zm0 64l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L80 208c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm32 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM112 512l160 0c26.5 0 48-21.5 48-48L64 464c0 26.5 21.5 48 48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWatchCalculator = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Gk);
var Wk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "watch-fitness", f = 384, c = 512, e = [], t = "f63e", o = "M64 48C64 21.5 85.5 0 112 0L272 0c26.5 0 48 21.5 48 48L64 48zm0 416l256 0c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48zM0 160c0-44.2 35.8-80 80-80l224 0c44.2 0 80 35.8 80 80l0 192c0 44.2-35.8 80-80 80L80 432c-44.2 0-80-35.8-80-80L0 160zm141.3 0C107.4 160 80 187.4 80 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWatchFitness = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Wk);
var Ek = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "watch-smart", f = 384, c = 512, e = [], t = "e2cc", o = "M64 48l256 0c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48zM80 80C35.8 80 0 115.8 0 160L0 352c0 44.2 35.8 80 80 80l224 0c44.2 0 80-35.8 80-80l0-192c0-44.2-35.8-80-80-80L80 80zm136 80l0 86.1 41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24zM112 512l160 0c26.5 0 48-21.5 48-48L64 464c0 26.5 21.5 48 48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWatchSmart = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Ek);
var m0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "water-arrow-down", f = 576, c = 512, e = ["water-lower"], t = "f774", o = "M354.5 104.3L320 135.7 320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 103.7-34.5-31.3c-13.1-11.9-33.3-10.9-45.2 2.2s-10.9 33.3 2.2 45.2l88 80c12.2 11.1 30.8 11.1 43.1 0l88-80c13.1-11.9 14-32.1 2.2-45.2s-32.1-14-45.2-2.2zm-85 189.6C247 309.4 219.5 320 192 320c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 373.7 159 384 192 384c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 309.2 410.9 320 384 320c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zm37 128c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1c0 0 0 0 0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7c0 0 0 0 0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWaterArrowDown = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(m0);
var g0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "water-arrow-up", f = 576, c = 512, e = ["water-rise"], t = "f775", o = "M354.5 135.7L320 104.3 320 208c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-103.7-34.5 31.3c-13.1 11.9-33.3 10.9-45.2-2.2s-10.9-33.3 2.2-45.2l88-80c12.2-11.1 30.8-11.1 43.1 0l88 80c13.1 11.9 14 32.1 2.2 45.2s-32.1 14-45.2 2.2zm-85 158.2c11.1-7.9 25.9-7.9 37 0C329 309.4 356.5 320 384 320c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 373.7 417 384 384 384c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 309.2 165.1 320 192 320c27.5 0 55-10.6 77.5-26.1zm37 128C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7c0 0 0 0 0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWaterArrowUp = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(g0);
var Vk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = m0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWaterLower = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Vk);
var Ik = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = g0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWaterRise = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Ik);
var Kk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "watermelon-slice", f = 512, c = 512, e = [], t = "e337", o = "M41 391c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391zm22.3-22.3c84.4 84.4 221.1 84.4 305.5 0c84.2-84.2 84.4-220.7 .3-305.1l-4.3-4.3c-6.2-6.2-16.4-6.2-22.6 0L59.3 342.2c-6.2 6.2-6.2 16.4 0 22.6l4 4zm245.4-220c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-80 80c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm-168 72c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6zm88 8c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWatermelonSlice = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Kk);
var Xk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wave", f = 576, c = 512, e = [], t = "e65b", o = "M0 336c0-17.7 14.3-32 32-32c35.3 0 64-28.7 64-64C96 125.1 189.1 32 304 32c84.7 0 157.6 50.7 190 123.2c4.7 10.5 1.3 22.8-8.1 29.4s-22.2 5.6-30.4-2.3C441 168.5 421.5 160 400 160c-44.2 0-80 35.8-80 80c0 35.3 28.7 64 64 64c0 0 0 0 0 0c26.9 0 55.4-10.8 77.4-26.1c0 0 0 0 0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c15 3.5 25.1 17.1 24.7 31.9l0 41.9c-28.7 0-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2c-4.8-2.6-10.5-2.6-15.3 0c-4.2 2.3-9.1 4.8-14.5 7.2C55.1 369.7 28.7 378.6 0 378.6L0 336zm0 74.6c35 0 66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c21 9.5 52 20.3 87.1 20.3l0 36.6c.1 2.7-.2 5.4-.8 8.1c-4 17.2-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9c-.6-2.4-.8-4.9-.8-7.3c0 0 0 0 0 0s0 0 0 0l0-37.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWave = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Xk);
var Qk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wave-sine", f = 640, c = 512, e = [8767], t = "f899", o = "M63.4 230.3l0-.1 .2-1c.2-.9 .5-2.4 1-4.3c1-3.8 2.5-9.4 4.6-16.2C73.6 195 80.3 177 90 159.4C110.2 122.8 137.8 96 176 96c29 0 49.1 14.4 67 44.4c19 31.8 31.9 75.4 46.3 124.5c.2 .8 .5 1.6 .7 2.4c13.5 46.2 28.4 97.5 52 137c25.1 42 63 75.6 122 75.6c73.8 0 118.2-53.2 142-96.6c12.3-22.4 20.6-44.5 25.7-60.8c2.6-8.2 4.5-15.1 5.7-20c.6-2.5 1.1-4.4 1.4-5.9c.2-.7 .3-1.3 .4-1.7l.1-.5 0-.2c0 0 0 0 0-.1c0 0 0 0 0 0L608 288l31.4 6.3c3.5-17.3-7.8-34.2-25.1-37.7s-34.2 7.8-37.7 25.1c0 0 0 0 0 0l0 .1-.2 1c-.2 .9-.5 2.4-1 4.3c-1 3.8-2.5 9.4-4.6 16.2c-4.3 13.7-11.1 31.6-20.8 49.2c-20.1 36.6-47.8 63.4-86 63.4c-29 0-49.1-14.4-67-44.4c-19-31.8-31.9-75.4-46.3-124.5c-.2-.8-.5-1.6-.7-2.4c-13.5-46.2-28.4-97.5-52-137C272.9 65.6 235 32 176 32C102.2 32 57.8 85.2 34 128.6C21.7 151 13.4 173 8.2 189.3c-2.6 8.2-4.5 15.1-5.7 20c-.6 2.5-1.1 4.4-1.4 5.9c-.2 .7-.3 1.3-.4 1.7l-.1 .5 0 .2c0 0 0 0 0 .1c0 0 0 0 0 0L32 224 .6 217.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWaveSine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Qk);
var Jk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wave-triangle", f = 640, c = 512, e = [], t = "f89a", o = "M176 32c10.1 0 19.6 4.7 25.6 12.8L464 394.7 582.4 236.8c10.6-14.1 30.7-17 44.8-6.4s17 30.7 6.4 44.8l-144 192c-6 8.1-15.5 12.8-25.6 12.8s-19.6-4.7-25.6-12.8L176 117.3 57.6 275.2c-10.6 14.1-30.7 17-44.8 6.4s-17-30.7-6.4-44.8l144-192c6-8.1 15.5-12.8 25.6-12.8z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWaveTriangle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Jk);
var Yk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "waveform", f = 640, c = 512, e = [], t = "f8f1", o = "M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4L424.3 84.2c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6l28.2 197.3 20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9L593.7 264l22.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6L446.7 248.3l-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6 279.8 491.3c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5L167.8 427.4c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4C83.8 305.1 74.5 312 64 312l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.3 0 26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6L168.2 84.6c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWaveform = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(Yk);
var Zk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = u1;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWaveformCircle = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(Zk);
var P0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "waveform-lines", f = 640, c = 512, e = ["waveform-path"], t = "f8f2", o = "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448zM544 96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320zM256 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192zM160 224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm576 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWaveformLines = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(P0);
var pk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = P0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWaveformPath = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(pk);
var xk = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "waves-sine", f = 640, c = 512, e = [], t = "e65d", o = "M256.2 140.6c-11 18.2-20.4 40.1-29.3 64.6c-9.2-27.9-19.8-57.4-32.9-84.7c2.4-4.5 4.9-8.9 7.5-13.2C226.3 66.4 263.3 32 320 32s93.7 34.4 118.6 75.4c23.8 39.2 40.3 90.2 55.2 136.5l.7 2.3c15.8 49.1 30.2 93.1 49.7 125.2C563 402.4 582.6 416 608 416c17.7 0 32 14.3 32 32s-14.3 32-32 32c-56.7 0-93.7-34.4-118.6-75.4c-23.8-39.2-40.3-90.2-55.2-136.5l-.7-2.3c-15.8-49.1-30.2-93.1-49.7-125.2C365 109.6 345.4 96 320 96s-45 13.6-63.8 44.6zM158.1 391.4c-2.4 4.5-4.9 8.9-7.5 13.2C125.7 445.6 88.7 480 32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32c25.4 0 45-13.6 63.8-44.6c11-18.2 20.4-40.1 29.3-64.6c9.2 27.9 19.8 57.4 32.9 84.7zm225.8-20c11-18.2 20.4-40.1 29.3-64.6c9.2 27.9 19.8 57.4 32.9 84.7c-2.4 4.5-4.9 8.9-7.5 13.2C413.7 445.6 376.7 480 320 480s-93.7-34.4-118.6-75.4c-23.8-39.2-40.3-90.2-55.2-136.5c0 0 0 0 0 0l-.7-2.3c-15.8-49.1-30.2-93.1-49.7-125.2C77 109.6 57.4 96 32 96C14.3 96 0 81.7 0 64S14.3 32 32 32c56.7 0 93.7 34.4 118.6 75.4c23.8 39.2 40.3 90.2 55.2 136.5l.7 2.3c15.8 49.1 30.2 93.1 49.7 125.2C275 402.4 294.6 416 320 416s45-13.6 63.8-44.6zM544.2 140.6c-11 18.2-20.4 40.1-29.3 64.6c-9.2-27.9-19.8-57.5-32.9-84.7c2.4-4.5 4.9-8.9 7.5-13.2C514.3 66.4 551.3 32 608 32c17.7 0 32 14.3 32 32s-14.3 32-32 32c-25.4 0-45 13.6-63.8 44.6z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWavesSine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(xk);
var iA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = z2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWebcam = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(iA);
var aA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = L2;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWebcamSlash = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(aA);
var eA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "webhook", f = 576, c = 512, e = [], t = "e5d5", o = "M306 50.1c-43.1-9.9-86 16.9-95.9 60c-7.9 34.1 7.4 68.2 35.5 85.9c5.4 3.4 9.2 8.8 10.7 15s.3 12.7-3 18.1L170.4 361.5c3.6 6.7 5.6 14.4 5.6 22.5c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.6 0 1.1 0 1.7 0L201 221.9c-32.5-30.2-48.4-76.4-37.7-122.7C179.2 30.3 247.9-12.6 316.8 3.3c65.9 15.2 108 78.7 97.7 144.4c-2.1 13.1-14.3 22-27.4 20s-22-14.3-20-27.4c6.4-41.1-19.9-80.7-61.1-90.2zM289.7 176c-.6 0-1.1 0-1.7 0c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48c0 8.1-2 15.8-5.6 22.5l71.3 114.1c45.8-17.7 99.8-8.2 136.8 28.9c50 50 50 131 0 181c-43 43-109 49-158.4 18c-11.2-7-14.6-21.8-7.6-33.1s21.8-14.6 33.1-7.6c30.9 19.3 72.1 15.5 99-11.3c31.2-31.2 31.2-81.9 0-113.1c-26.8-26.8-68.1-30.6-99-11.3c-5.4 3.4-11.9 4.5-18.1 3s-11.6-5.3-15-10.7L289.7 176zM448 432c-17.8 0-33.3-9.7-41.6-24l-152.7 0c-9.2 48.3-46 89-97 100.7c-68.9 15.9-137.6-27-153.5-95.9C-11 351 22.1 289.4 78.7 265.8c12.2-5.1 26.3 .7 31.4 12.9s-.7 26.3-12.9 31.4c-35.4 14.7-56 53.3-47.1 91.8c9.9 43 52.9 69.9 95.9 60c37-8.5 62.1-41.5 62-77.9c0-6.4 2.5-12.5 7-17s10.6-7 17-7l174.4 0c8.3-14.3 23.8-24 41.6-24c26.5 0 48 21.5 48 48s-21.5 48-48 48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWebhook = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(eA);
var nA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "whale", f = 640, c = 512, e = [128011], t = "f72c", o = "M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4C89.7 63.7 81.4 89.6 85.6 115.1l7.9 47.4L43.6 212.4C15.7 240.3 0 278.2 0 317.6C0 407.3 72.7 480 162.4 480L544 480c53 0 96-43 96-96l0-111.9C640 192.5 575.5 128 495.9 128c-82.5 0-162.4 29.5-225 83.2L156.4 309.4c-8 6.8-18.1 10.6-28.6 10.6l-1.1 0c-18.3 0-34.5-11.7-40.3-29c-4-12-2.4-25.2 4.3-35.9l37.6-60.1 44.7 7.5c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9L189.9 98.1 175.8 13.4zM400 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWhale = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(nA);
var fA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wheat", f = 512, c = 512, e = [], t = "f72d", o = "M472 0c-48.6 0-88 39.4-88 88l0 24c0 8.8 7.2 16 16 16l24 0c48.6 0 88-39.4 88-88l0-24c0-8.8-7.2-16-16-16L472 0zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L305.5 27.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWheat = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(fA);
var cA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wheat-awn-slash", f = 640, c = 512, e = [], t = "e338", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L550.5 231c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L569 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L473 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L393.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L369.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L447 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWheatAwnSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(cA);
var tA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wheat-slash", f = 640, c = 512, e = [], t = "e339", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L362.5 258.8l28.7-28.7 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L550.5 231c6.2-6.2 6.2-16.4 0-22.6L539.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L369.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L335.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-3.3 3.3-6.3 6.8-9 10.4L38.8 5.1zm255 322.4l-50.6-39.9-29.5 29.5c-3.4-27.3-15.5-53.8-36.5-74.8L165.8 231c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L73.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l36.3-36.3zM536 0c-48.6 0-88 39.4-88 88l0 24c0 8.8 7.2 16 16 16l24 0c48.6 0 88-39.4 88-88l0-24c0-8.8-7.2-16-16-16L536 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWheatSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(tA);
var oA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "whistle", f = 640, c = 512, e = [], t = "f460", o = "M44.1 188.8C18.5 180.5 0 156.4 0 128C0 92.7 28.7 64 64 64c23.4 0 43.8 12.5 55 31.2C149.2 75.5 185.2 64 224 64c7.8 0 15.4 .5 22.9 1.4c.5 0 1.1 0 1.7 .1c37.8 4.5 73.8 19.4 103.9 43.2l69.8 55.2c5 4 7.2 10.6 5.5 16.8l-6.5 24c-3.2 11.7 1.1 24.2 10.8 31.5c9.6 7.2 22.7 7.9 33 1.7l19.3-11.6c5.7-3.4 12.9-3 18.2 1.2l127 100.4c6.6 5.2 10.5 13.2 10.5 21.6c0 6.9-2.6 13.5-7.2 18.5l-63.3 69.6c-6.1 6.7-14.7 10.5-23.7 10.5l-2 0c-5.2 0-10.2-1.2-14.8-3.6L380.7 367c-34.8 49-92 81-156.7 81C118 448 32 362 32 256c0-23.6 4.3-46.3 12.1-67.2zM80 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWhistle = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(oA);
var lA = {}, M0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wifi-weak", f = 640, c = 512, e = ["wifi-1"], t = "f6aa", o = "M256 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWifiWeak = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(M0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = M0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWifi1 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(lA);
var dA = {}, w0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wifi-fair", f = 640, c = 512, e = ["wifi-2"], t = "f6ab", o = "M171.8 312c39.5-34.9 91.3-56 148.2-56s108.7 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWifiFair = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(w0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = w0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWifi2 = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(dA);
var rA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wifi-exclamation", f = 640, c = 512, e = [], t = "e2cf", o = "M320 32c-27.2 0-48.7 23.1-46.8 50.2l14.9 208C289.3 307 303.2 320 320 320s30.7-13 31.9-29.7l14.9-208C368.7 55.1 347.2 32 320 32zM241.3 84.5c-1.2-17.4 3.3-33.9 11.9-47.6C159.4 51 75.1 94.1 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c51.3-49.2 116.2-84.3 188.5-99.1l-1.4-19.3zm157.4 0l-1.4 19.3c72.3 14.8 137.2 49.9 188.5 99.1c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C564.9 94.1 480.6 51 386.8 37c8.6 13.7 13.1 30.1 11.9 47.6zM129.5 264c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c23.6-20.8 51.6-36.7 82.4-46.2l-4.7-65.1C204.4 212 163.4 234.1 129.5 264zm260.9-63.3l-4.6 65.1c30.8 9.4 58.8 25.4 82.4 46.2c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2c-33.9-29.9-74.9-52-120.1-63.3zM384 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWifiExclamation = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(rA);
var sA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wifi-slash", f = 640, c = 512, e = [], t = "f6ac", o = "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L364.6 260.4c39.2 7.9 74.7 26.1 103.6 51.6c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192c-13.3 0-26.5 .9-39.3 2.7l-95.1-74.5C227.4 104.5 272.7 96 320 96c103.2 0 196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32c-68.7 0-133.7 15.5-191.9 43.1L38.8 5.1zM380.8 396l-55.6-43.8c-1.7-.1-3.4-.2-5.2-.2c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-7-1.1-13.7-3.2-20zM228 275.7L173 232.3c-15.5 9.2-30.1 19.8-43.5 31.7c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c16.7-14.8 35.6-27 56.2-36.3zM93.6 169.8L41.7 128.9C30.7 137.7 20 147 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9c12.4-11.9 25.6-23 39.5-33.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWifiSlash = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(sA);
var hA = {}, N0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wind-warning", f = 640, c = 512, e = ["wind-circle-exclamation"], t = "f776", o = "M418 368c-38.7 67-111.1 112-194 112C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208L384 240c-35.3 0-64 28.7-64 64s28.7 64 64 64l34 0zM248 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm248 48c0-17.7 14.3-32 32-32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l152 0c53 0 96 43 96 96s-43 96-96 96l-32 0c-17.7 0-32-14.3-32-32zm72-192l-64.5 0c-1.4-22.2-5.6-43.7-12.3-64l76.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c53 0 96 43 96 96s-43 96-96 96z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWindWarning = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(N0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = N0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWindCircleExclamation = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(hA);
var vA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wind-turbine", f = 512, c = 512, e = [], t = "f89b", o = "M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.9 212c-.5-3.4 .1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5L31.1 140.6C13.7 141 9.5 165 25.7 171.4l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5L315.7 414.8zM224 326.8L224 464l-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-33.2-64-104zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWindTurbine = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(vA);
var uA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "window", f = 512, c = 512, e = [], t = "f40e", o = "M512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320zM96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWindow = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(uA);
var mA = {}, z0 = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "window-flip", f = 512, c = 512, e = ["window-alt"], t = "f40f", o = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWindowFlip = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(z0);
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = z0;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faWindowAlt = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(mA);
var gA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "window-frame", f = 512, c = 512, e = [129695], t = "e04f", o = "M32 256L32 64C32 28.7 60.7 0 96 0L416 0c35.3 0 64 28.7 64 64l0 192 0 192c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0L96 512l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-192zm384 32l-136 0 0 160 136 0 0-160zm-184 0L96 288l0 160 136 0 0-160zm48-64l136 0 0-160L280 64l0 160zM232 64L96 64l0 160 136 0 0-160z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWindowFrame = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(gA);
var PA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "window-frame-open", f = 512, c = 512, e = [], t = "e050", o = "M480 224l0-160c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 160 0 64 64 0 320 0 64 0 0-64zm-64 0l-136 0 0-160 136 0 0 160zm-184 0L96 224 96 64l136 0 0 160zM96 448l0-128-64 0 0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 384 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-128-64 0 0 128L96 448z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWindowFrameOpen = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(PA);
var MA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "windsock", f = 512, c = 512, e = [], t = "f777", o = "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 64 0 0 8.6c0 20.3 18.7 35.5 38.5 31.3l41.5-8.6 0-286.7L166.5 56c-19.9-4.1-38.5 11-38.5 31.3l0 8.6L64 96l0-64zm64 112l0 128-64 0 0-128 64 0zM272 78l0 260 96-20 0-220L272 78zM486.5 293.3c14.8-3.1 25.5-16.2 25.5-31.3l0-108c0-15.2-10.6-28.2-25.5-31.3L432 111.3l0 193.3 54.5-11.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWindsock = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(MA);
var wA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wreath", f = 448, c = 512, e = [], t = "f7e2", o = "M182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5l0-3.7c0-28.6-23.2-51.8-51.8-51.8c-7.2 0-14.4 1.5-21 4.5L224 381l-55.2-24.5c-6.6-2.9-13.8-4.5-21-4.5C119.2 352 96 375.2 96 403.8l0 3.7c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0zM203 142.4c-5.7 6-13.6 9.4-21.9 9.1c-16.6-.6-30.2 13-29.6 29.6c.3 8.3-3 16.3-9.1 21.9c-12.1 11.3-12.1 30.6 0 41.9c6 5.7 9.4 13.6 9.1 21.9c-.6 16.6 13 30.2 29.6 29.6c8.3-.3 16.3 3 21.9 9.1c11.3 12.1 30.6 12.1 41.9 0c5.7-6 13.6-9.4 21.9-9.1c16.6 .6 30.2-13 29.6-29.6c-.3-8.3 3-16.3 9.1-21.9c12.1-11.3 12.1-30.6 0-41.9c-6-5.7-9.4-13.6-9.1-21.9c.6-16.6-13-30.2-29.6-29.6c-8.3 .3-16.3-3-21.9-9.1c-11.3-12.1-30.6-12.1-41.9 0zM128 403.8c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8l0 88.4c0 10.9-8.9 19.8-19.8 19.8c-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7c-10.9 0-19.8-8.9-19.8-19.8l0-88.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWreath = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(wA);
var NA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wreath-laurel", f = 640, c = 512, e = [], t = "e5d2", o = "M144 112C144 50.1 194.1 0 256 0l16 0c8.8 0 16 7.2 16 16l0 16c0 60.2-47.5 109.3-107 111.9c-23.9 32.2-37 71.5-37 112.1c0 97.2 78.8 176 176 176l11.6 0c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5C403.1 488.4 367.6 480 331.6 480L320 480l-11.6 0c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.2 16.8-7.9 25.4-11.2c-5.6-3.2-11-6.7-16.3-10.3c-59.6 28.2-131.9 6.3-165.4-51.8l-8-13.9c-4.4-7.7-1.8-17.4 5.9-21.9c13.8-8 28.4-13.1 43.3-15.5C27.5 315.6 0 273 0 224l0-16c0-8.8 7.2-16 16-16c15.9 0 31.1 2.9 45.2 8.2c-24.3-38.8-26.8-89.5-2.3-131.9l8-13.9c4.4-7.7 14.2-10.3 21.9-5.9C115 63.7 133.8 86.8 144 113l0-1zm315 31.9C399.5 141.3 352 92.2 352 32l0-16c0-8.8 7.2-16 16-16l16 0c61.9 0 112 50.1 112 112l0 1c10.2-26.2 29-49.2 55.3-64.4c7.7-4.4 17.4-1.8 21.9 5.9l8 13.9c24.5 42.4 21.9 93.1-2.3 131.9c14.1-5.3 29.3-8.2 45.2-8.2c8.8 0 16 7.2 16 16l0 16c0 49-27.5 91.6-68 113.1c14.8 2.4 29.5 7.5 43.3 15.5c7.7 4.4 10.3 14.2 5.9 21.9l-8 13.9c-24.2 42-68.7 65.1-114 64c-4.8-5.8-10.9-10.8-18.1-14.4l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1c-10.4-4.8-21-9-31.8-12.6c-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-40.6-13.1-79.9-37-112.1z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWreathLaurel = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(NA);
var zA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "wrench-simple", f = 384, c = 512, e = [], t = "e2d1", o = "M132.7 164.7l48 48c6.2 6.2 16.4 6.2 22.6 0l48-48c3-3 4.7-7.1 4.7-11.3l0-135.8c0-11 10.9-18.7 20.8-13.8C340.3 35 384 100.4 384 176c0 71.1-38.6 133.1-96 166.3L288 464c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-121.7C38.6 309.1 0 247.1 0 176C0 100.4 43.7 35 107.2 3.7C117.1-1.2 128 6.5 128 17.6l0 135.8c0 4.2 1.7 8.3 4.7 11.3z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faWrenchSimple = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(zA);
var LA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = w;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faXmarkHexagon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(LA);
var CA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = "fas", n = "xmark-large", f = 448, c = 512, e = [], t = "e59b", o = "M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z";
  i.definition = {
    prefix: a,
    iconName: n,
    icon: [
      f,
      c,
      e,
      t,
      o
    ]
  }, i.faXmarkLarge = i.definition, i.prefix = a, i.iconName = n, i.width = f, i.height = c, i.ligatures = e, i.unicode = t, i.svgPathData = o, i.aliases = e;
})(CA);
var DA = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = $;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faXmarkOctagon = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})(DA);
var $A = {};
(function(i) {
  Object.defineProperty(i, "__esModule", { value: !0 });
  var a = q3;
  i.definition = {
    prefix: a.prefix,
    iconName: a.iconName,
    icon: [
      a.width,
      a.height,
      a.aliases,
      a.unicode,
      a.svgPathData
    ]
  }, i.faZzz = i.definition, i.prefix = a.prefix, i.iconName = a.iconName, i.width = a.width, i.height = a.height, i.ligatures = a.aliases, i.unicode = a.unicode, i.svgPathData = a.svgPathData, i.aliases = a.aliases;
})($A);
var zui = {
  prefix: "fak",
  iconName: "actors",
  icon: [
    640,
    512,
    [],
    "e000",
    "M80 161.1C80 81 145 16 225.1 16l189.8 0C495 16 560 81 560 161.1l0 189.8C560 431 495 496 414.9 496l-189.8 0C145 496 80 431 80 350.9l0-189.8zm43.3-2.2l0 192.6c0 55.5 45 100.5 100.5 100.5l192.6 0c55.5 0 100.5-45 100.5-100.5l0-192.6c0-55.5-45-100.5-100.5-100.5l-192.6 0c-55.5 0-100.5 45-100.5 100.5zm133 16.2a63.8 63.8 0 1 1 127.5 0 63.8 63.8 0 1 1 -127.5 0zm141.9 79.3l70.1 70.1c10.2 10.2 5.5 27.6-8.4 31.4l-95.8 25.7c-13.9 3.7-26.7-9-23-23l25.7-95.8c3.7-13.9 21.2-18.6 31.4-8.4zM177.7 328.4c-10.1-17.5-4.1-39.9 13.4-50L231.7 255c17.5-10.1 39.9-4.1 50 13.4l23.4 40.6c10.1 17.5 4.1 39.9-13.4 50l-40.6 23.4c-17.5 10.1-39.9 4.1-50-13.4l-23.4-40.6z"
  ]
}, Lui = {
  prefix: "fak",
  iconName: "select",
  icon: [
    512,
    512,
    [],
    "e001",
    "M244.7 52.7c6.2-6.2 16.4-6.2 22.7 0l96 96c6.2 6.2 6.2 16.4 0 22.7s-16.4 6.2-22.7 0L256 86.7l-84.7 84.6c-6.2 6.3-16.4 6.3-22.7 0s-6.2-16.4 0-22.7l96-96 0 0zm22.6 406.6c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.7s16.4-6.2 22.7 0L256 425.3l84.7-84.6c6.2-6.2 16.4-6.2 22.7 0s6.2 16.4 0 22.7l-96 96-.1-.1z"
  ]
};
const M02 = {
  fa0: { ...SA, prefix: "fas" },
  fa1: { ...yA, prefix: "fas" },
  fa2: { ...OA, prefix: "fas" },
  fa3: { ...kA, prefix: "fas" },
  fa4: { ...AA, prefix: "fas" },
  fa5: { ...jA, prefix: "fas" },
  fa6: { ...BA, prefix: "fas" },
  fa7: { ...TA, prefix: "fas" },
  fa8: { ...FA, prefix: "fas" },
  fa9: { ...HA, prefix: "fas" },
  faA: { ...RA, prefix: "fas" },
  faAd: { ...UA, prefix: "fas" },
  faAdd: { ...qA, prefix: "fas" },
  faAddressBook: { ...GA, prefix: "fas" },
  faAddressCard: { ...WA, prefix: "fas" },
  faAdjust: { ...EA, prefix: "fas" },
  faAirFreshener: { ...VA, prefix: "fas" },
  faAlignCenter: { ...IA, prefix: "fas" },
  faAlignJustify: { ...KA, prefix: "fas" },
  faAlignLeft: { ...XA, prefix: "fas" },
  faAlignRight: { ...QA, prefix: "fas" },
  faAllergies: { ...JA, prefix: "fas" },
  faAmbulance: { ...YA, prefix: "fas" },
  faAmericanSignLanguageInterpreting: { ...ZA, prefix: "fas" },
  faAnchor: { ...pA, prefix: "fas" },
  faAnchorCircleCheck: { ...xA, prefix: "fas" },
  faAnchorCircleExclamation: { ...ij, prefix: "fas" },
  faAnchorCircleXmark: { ...aj, prefix: "fas" },
  faAnchorLock: { ...ej, prefix: "fas" },
  faAngleDoubleDown: { ...nj, prefix: "fas" },
  faAngleDoubleLeft: { ...fj, prefix: "fas" },
  faAngleDoubleRight: { ...cj, prefix: "fas" },
  faAngleDoubleUp: { ...tj, prefix: "fas" },
  faAngleDown: { ...oj, prefix: "fas" },
  faAngleLeft: { ...lj, prefix: "fas" },
  faAngleRight: { ...dj, prefix: "fas" },
  faAngleUp: { ...rj, prefix: "fas" },
  faAnglesDown: { ...sj, prefix: "fas" },
  faAnglesLeft: { ...hj, prefix: "fas" },
  faAnglesRight: { ...vj, prefix: "fas" },
  faAnglesUp: { ...uj, prefix: "fas" },
  faAngry: { ...mj, prefix: "fas" },
  faAnkh: { ...gj, prefix: "fas" },
  faAppleAlt: { ...Pj, prefix: "fas" },
  faAppleWhole: { ...Mj, prefix: "fas" },
  faArchive: { ...wj, prefix: "fas" },
  faArchway: { ...Nj, prefix: "fas" },
  faAreaChart: { ...zj, prefix: "fas" },
  faArrowAltCircleDown: { ...Lj, prefix: "fas" },
  faArrowAltCircleLeft: { ...Cj, prefix: "fas" },
  faArrowAltCircleRight: { ...Dj, prefix: "fas" },
  faArrowAltCircleUp: { ...$j, prefix: "fas" },
  faArrowCircleDown: { ..._j, prefix: "fas" },
  faArrowCircleLeft: { ...bj, prefix: "fas" },
  faArrowCircleRight: { ...Sj, prefix: "fas" },
  faArrowCircleUp: { ...yj, prefix: "fas" },
  faArrowDown: { ...Oj, prefix: "fas" },
  faArrowDown19: { ...kj, prefix: "fas" },
  faArrowDown91: { ...Aj, prefix: "fas" },
  faArrowDownAZ: { ...jj, prefix: "fas" },
  faArrowDownLong: { ...Bj, prefix: "fas" },
  faArrowDownShortWide: { ...Tj, prefix: "fas" },
  faArrowDownUpAcrossLine: { ...Fj, prefix: "fas" },
  faArrowDownUpLock: { ...Hj, prefix: "fas" },
  faArrowDownWideShort: { ...Rj, prefix: "fas" },
  faArrowDownZA: { ...Uj, prefix: "fas" },
  faArrowLeft: { ...qj, prefix: "fas" },
  faArrowLeftLong: { ...Gj, prefix: "fas" },
  faArrowLeftRotate: { ...Wj, prefix: "fas" },
  faArrowPointer: { ...Ej, prefix: "fas" },
  faArrowRight: { ...Vj, prefix: "fas" },
  faArrowRightArrowLeft: { ...Ij, prefix: "fas" },
  faArrowRightFromBracket: { ...Kj, prefix: "fas" },
  faArrowRightFromFile: { ...Xj, prefix: "fas" },
  faArrowRightLong: { ...Qj, prefix: "fas" },
  faArrowRightRotate: { ...Jj, prefix: "fas" },
  faArrowRightToBracket: { ...Yj, prefix: "fas" },
  faArrowRightToCity: { ...Zj, prefix: "fas" },
  faArrowRightToFile: { ...pj, prefix: "fas" },
  faArrowRotateBack: { ...xj, prefix: "fas" },
  faArrowRotateBackward: { ...iB, prefix: "fas" },
  faArrowRotateForward: { ...aB, prefix: "fas" },
  faArrowRotateLeft: { ...eB, prefix: "fas" },
  faArrowRotateRight: { ...nB, prefix: "fas" },
  faArrowTrendDown: { ...fB, prefix: "fas" },
  faArrowTrendUp: { ...cB, prefix: "fas" },
  faArrowTurnDown: { ...tB, prefix: "fas" },
  faArrowTurnUp: { ...oB, prefix: "fas" },
  faArrowUp: { ...lB, prefix: "fas" },
  faArrowUp19: { ...dB, prefix: "fas" },
  faArrowUp91: { ...rB, prefix: "fas" },
  faArrowUpAZ: { ...sB, prefix: "fas" },
  faArrowUpFromBracket: { ...hB, prefix: "fas" },
  faArrowUpFromGroundWater: { ...vB, prefix: "fas" },
  faArrowUpFromWaterPump: { ...uB, prefix: "fas" },
  faArrowUpLong: { ...mB, prefix: "fas" },
  faArrowUpRightDots: { ...gB, prefix: "fas" },
  faArrowUpRightFromSquare: { ...PB, prefix: "fas" },
  faArrowUpShortWide: { ...MB, prefix: "fas" },
  faArrowUpWideShort: { ...wB, prefix: "fas" },
  faArrowUpZA: { ...NB, prefix: "fas" },
  faArrows: { ...zB, prefix: "fas" },
  faArrowsAlt: { ...LB, prefix: "fas" },
  faArrowsAltH: { ...CB, prefix: "fas" },
  faArrowsAltV: { ...DB, prefix: "fas" },
  faArrowsDownToLine: { ...$B, prefix: "fas" },
  faArrowsDownToPeople: { ..._B, prefix: "fas" },
  faArrowsH: { ...bB, prefix: "fas" },
  faArrowsLeftRight: { ...SB, prefix: "fas" },
  faArrowsLeftRightToLine: { ...yB, prefix: "fas" },
  faArrowsRotate: { ...OB, prefix: "fas" },
  faArrowsSpin: { ...kB, prefix: "fas" },
  faArrowsSplitUpAndLeft: { ...AB, prefix: "fas" },
  faArrowsToCircle: { ...jB, prefix: "fas" },
  faArrowsToDot: { ...BB, prefix: "fas" },
  faArrowsToEye: { ...TB, prefix: "fas" },
  faArrowsTurnRight: { ...FB, prefix: "fas" },
  faArrowsTurnToDots: { ...HB, prefix: "fas" },
  faArrowsUpDown: { ...RB, prefix: "fas" },
  faArrowsUpDownLeftRight: { ...UB, prefix: "fas" },
  faArrowsUpToLine: { ...qB, prefix: "fas" },
  faArrowsV: { ...GB, prefix: "fas" },
  faAslInterpreting: { ...WB, prefix: "fas" },
  faAssistiveListeningSystems: { ...EB, prefix: "fas" },
  faAsterisk: { ...VB, prefix: "fas" },
  faAt: { ...IB, prefix: "fas" },
  faAtlas: { ...KB, prefix: "fas" },
  faAtom: { ...XB, prefix: "fas" },
  faAudioDescription: { ...QB, prefix: "fas" },
  faAustralSign: { ...JB, prefix: "fas" },
  faAutomobile: { ...YB, prefix: "fas" },
  faAward: { ...ZB, prefix: "fas" },
  faB: { ...pB, prefix: "fas" },
  faBaby: { ...xB, prefix: "fas" },
  faBabyCarriage: { ...iT, prefix: "fas" },
  faBackspace: { ...aT, prefix: "fas" },
  faBackward: { ...eT, prefix: "fas" },
  faBackwardFast: { ...nT, prefix: "fas" },
  faBackwardStep: { ...fT, prefix: "fas" },
  faBacon: { ...cT, prefix: "fas" },
  faBacteria: { ...tT, prefix: "fas" },
  faBacterium: { ...oT, prefix: "fas" },
  faBagShopping: { ...lT, prefix: "fas" },
  faBahai: { ...dT, prefix: "fas" },
  faBahtSign: { ...rT, prefix: "fas" },
  faBalanceScale: { ...sT, prefix: "fas" },
  faBalanceScaleLeft: { ...hT, prefix: "fas" },
  faBalanceScaleRight: { ...vT, prefix: "fas" },
  faBan: { ...uT, prefix: "fas" },
  faBanSmoking: { ...mT, prefix: "fas" },
  faBandAid: { ...gT, prefix: "fas" },
  faBandage: { ...PT, prefix: "fas" },
  faBangladeshiTakaSign: { ...MT, prefix: "fas" },
  faBank: { ...wT, prefix: "fas" },
  faBarChart: { ...NT, prefix: "fas" },
  faBarcode: { ...zT, prefix: "fas" },
  faBars: { ...LT, prefix: "fas" },
  faBarsProgress: { ...CT, prefix: "fas" },
  faBarsStaggered: { ...DT, prefix: "fas" },
  faBaseball: { ...$T, prefix: "fas" },
  faBaseballBall: { ..._T, prefix: "fas" },
  faBaseballBatBall: { ...bT, prefix: "fas" },
  faBasketShopping: { ...ST, prefix: "fas" },
  faBasketball: { ...yT, prefix: "fas" },
  faBasketballBall: { ...OT, prefix: "fas" },
  faBath: { ...kT, prefix: "fas" },
  faBathtub: { ...AT, prefix: "fas" },
  faBattery: { ...jT, prefix: "fas" },
  faBattery0: { ...BT, prefix: "fas" },
  faBattery2: { ...TT, prefix: "fas" },
  faBattery3: { ...FT, prefix: "fas" },
  faBattery4: { ...HT, prefix: "fas" },
  faBattery5: { ...RT, prefix: "fas" },
  faBatteryCar: { ...UT, prefix: "fas" },
  faBatteryEmpty: { ...qT, prefix: "fas" },
  faBatteryFull: { ...GT, prefix: "fas" },
  faBatteryHalf: { ...WT, prefix: "fas" },
  faBatteryQuarter: { ...ET, prefix: "fas" },
  faBatteryThreeQuarters: { ...VT, prefix: "fas" },
  faBed: { ...IT, prefix: "fas" },
  faBedPulse: { ...KT, prefix: "fas" },
  faBeer: { ...XT, prefix: "fas" },
  faBeerMugEmpty: { ...QT, prefix: "fas" },
  faBell: { ...JT, prefix: "fas" },
  faBellConcierge: { ...YT, prefix: "fas" },
  faBellSlash: { ...ZT, prefix: "fas" },
  faBezierCurve: { ...pT, prefix: "fas" },
  faBible: { ...xT, prefix: "fas" },
  faBicycle: { ...iF, prefix: "fas" },
  faBiking: { ...aF, prefix: "fas" },
  faBinoculars: { ...eF, prefix: "fas" },
  faBiohazard: { ...nF, prefix: "fas" },
  faBirthdayCake: { ...fF, prefix: "fas" },
  faBitcoinSign: { ...cF, prefix: "fas" },
  faBlackboard: { ...tF, prefix: "fas" },
  faBlender: { ...oF, prefix: "fas" },
  faBlenderPhone: { ...lF, prefix: "fas" },
  faBlind: { ...dF, prefix: "fas" },
  faBlog: { ...rF, prefix: "fas" },
  faBold: { ...sF, prefix: "fas" },
  faBolt: { ...hF, prefix: "fas" },
  faBoltLightning: { ...vF, prefix: "fas" },
  faBomb: { ...uF, prefix: "fas" },
  faBone: { ...mF, prefix: "fas" },
  faBong: { ...gF, prefix: "fas" },
  faBook: { ...PF, prefix: "fas" },
  faBookAtlas: { ...MF, prefix: "fas" },
  faBookBible: { ...wF, prefix: "fas" },
  faBookBookmark: { ...NF, prefix: "fas" },
  faBookDead: { ...zF, prefix: "fas" },
  faBookJournalWhills: { ...LF, prefix: "fas" },
  faBookMedical: { ...CF, prefix: "fas" },
  faBookOpen: { ...DF, prefix: "fas" },
  faBookOpenReader: { ...$F, prefix: "fas" },
  faBookQuran: { ..._F, prefix: "fas" },
  faBookReader: { ...bF, prefix: "fas" },
  faBookSkull: { ...SF, prefix: "fas" },
  faBookTanakh: { ...yF, prefix: "fas" },
  faBookmark: { ...OF, prefix: "fas" },
  faBorderAll: { ...kF, prefix: "fas" },
  faBorderNone: { ...AF, prefix: "fas" },
  faBorderStyle: { ...jF, prefix: "fas" },
  faBorderTopLeft: { ...BF, prefix: "fas" },
  faBoreHole: { ...TF, prefix: "fas" },
  faBottleDroplet: { ...FF, prefix: "fas" },
  faBottleWater: { ...HF, prefix: "fas" },
  faBowlFood: { ...RF, prefix: "fas" },
  faBowlRice: { ...UF, prefix: "fas" },
  faBowlingBall: { ...qF, prefix: "fas" },
  faBox: { ...GF, prefix: "fas" },
  faBoxArchive: { ...WF, prefix: "fas" },
  faBoxOpen: { ...EF, prefix: "fas" },
  faBoxTissue: { ...VF, prefix: "fas" },
  faBoxes: { ...IF, prefix: "fas" },
  faBoxesAlt: { ...KF, prefix: "fas" },
  faBoxesPacking: { ...XF, prefix: "fas" },
  faBoxesStacked: { ...QF, prefix: "fas" },
  faBraille: { ...JF, prefix: "fas" },
  faBrain: { ...YF, prefix: "fas" },
  faBrazilianRealSign: { ...ZF, prefix: "fas" },
  faBreadSlice: { ...pF, prefix: "fas" },
  faBridge: { ...xF, prefix: "fas" },
  faBridgeCircleCheck: { ...iH, prefix: "fas" },
  faBridgeCircleExclamation: { ...aH, prefix: "fas" },
  faBridgeCircleXmark: { ...eH, prefix: "fas" },
  faBridgeLock: { ...nH, prefix: "fas" },
  faBridgeWater: { ...fH, prefix: "fas" },
  faBriefcase: { ...cH, prefix: "fas" },
  faBriefcaseClock: { ...tH, prefix: "fas" },
  faBriefcaseMedical: { ...oH, prefix: "fas" },
  faBroadcastTower: { ...lH, prefix: "fas" },
  faBroom: { ...dH, prefix: "fas" },
  faBroomBall: { ...rH, prefix: "fas" },
  faBrush: { ...sH, prefix: "fas" },
  faBucket: { ...hH, prefix: "fas" },
  faBug: { ...vH, prefix: "fas" },
  faBugSlash: { ...uH, prefix: "fas" },
  faBugs: { ...mH, prefix: "fas" },
  faBuilding: { ...gH, prefix: "fas" },
  faBuildingCircleArrowRight: { ...PH, prefix: "fas" },
  faBuildingCircleCheck: { ...MH, prefix: "fas" },
  faBuildingCircleExclamation: { ...wH, prefix: "fas" },
  faBuildingCircleXmark: { ...NH, prefix: "fas" },
  faBuildingColumns: { ...zH, prefix: "fas" },
  faBuildingFlag: { ...LH, prefix: "fas" },
  faBuildingLock: { ...CH, prefix: "fas" },
  faBuildingNgo: { ...DH, prefix: "fas" },
  faBuildingShield: { ...$H, prefix: "fas" },
  faBuildingUn: { ..._H, prefix: "fas" },
  faBuildingUser: { ...bH, prefix: "fas" },
  faBuildingWheat: { ...SH, prefix: "fas" },
  faBullhorn: { ...yH, prefix: "fas" },
  faBullseye: { ...OH, prefix: "fas" },
  faBurger: { ...kH, prefix: "fas" },
  faBurn: { ...AH, prefix: "fas" },
  faBurst: { ...jH, prefix: "fas" },
  faBus: { ...BH, prefix: "fas" },
  faBusAlt: { ...TH, prefix: "fas" },
  faBusSimple: { ...FH, prefix: "fas" },
  faBusinessTime: { ...HH, prefix: "fas" },
  faC: { ...RH, prefix: "fas" },
  faCab: { ...UH, prefix: "fas" },
  faCableCar: { ...qH, prefix: "fas" },
  faCake: { ...GH, prefix: "fas" },
  faCakeCandles: { ...WH, prefix: "fas" },
  faCalculator: { ...EH, prefix: "fas" },
  faCalendar: { ...VH, prefix: "fas" },
  faCalendarAlt: { ...IH, prefix: "fas" },
  faCalendarCheck: { ...KH, prefix: "fas" },
  faCalendarDay: { ...XH, prefix: "fas" },
  faCalendarDays: { ...QH, prefix: "fas" },
  faCalendarMinus: { ...JH, prefix: "fas" },
  faCalendarPlus: { ...YH, prefix: "fas" },
  faCalendarTimes: { ...ZH, prefix: "fas" },
  faCalendarWeek: { ...pH, prefix: "fas" },
  faCalendarXmark: { ...xH, prefix: "fas" },
  faCamera: { ...iR, prefix: "fas" },
  faCameraAlt: { ...aR, prefix: "fas" },
  faCameraRetro: { ...eR, prefix: "fas" },
  faCameraRotate: { ...nR, prefix: "fas" },
  faCampground: { ...fR, prefix: "fas" },
  faCancel: { ...cR, prefix: "fas" },
  faCandyCane: { ...tR, prefix: "fas" },
  faCannabis: { ...oR, prefix: "fas" },
  faCapsules: { ...lR, prefix: "fas" },
  faCar: { ...dR, prefix: "fas" },
  faCarAlt: { ...rR, prefix: "fas" },
  faCarBattery: { ...sR, prefix: "fas" },
  faCarBurst: { ...hR, prefix: "fas" },
  faCarCrash: { ...vR, prefix: "fas" },
  faCarOn: { ...uR, prefix: "fas" },
  faCarRear: { ...mR, prefix: "fas" },
  faCarSide: { ...gR, prefix: "fas" },
  faCarTunnel: { ...PR, prefix: "fas" },
  faCaravan: { ...MR, prefix: "fas" },
  faCaretDown: { ...wR, prefix: "fas" },
  faCaretLeft: { ...NR, prefix: "fas" },
  faCaretRight: { ...zR, prefix: "fas" },
  faCaretSquareDown: { ...LR, prefix: "fas" },
  faCaretSquareLeft: { ...CR, prefix: "fas" },
  faCaretSquareRight: { ...DR, prefix: "fas" },
  faCaretSquareUp: { ...$R, prefix: "fas" },
  faCaretUp: { ..._R, prefix: "fas" },
  faCarriageBaby: { ...bR, prefix: "fas" },
  faCarrot: { ...SR, prefix: "fas" },
  faCartArrowDown: { ...yR, prefix: "fas" },
  faCartFlatbed: { ...OR, prefix: "fas" },
  faCartFlatbedSuitcase: { ...kR, prefix: "fas" },
  faCartPlus: { ...AR, prefix: "fas" },
  faCartShopping: { ...jR, prefix: "fas" },
  faCashRegister: { ...BR, prefix: "fas" },
  faCat: { ...TR, prefix: "fas" },
  faCediSign: { ...FR, prefix: "fas" },
  faCentSign: { ...HR, prefix: "fas" },
  faCertificate: { ...RR, prefix: "fas" },
  faChain: { ...UR, prefix: "fas" },
  faChainBroken: { ...qR, prefix: "fas" },
  faChainSlash: { ...GR, prefix: "fas" },
  faChair: { ...WR, prefix: "fas" },
  faChalkboard: { ...ER, prefix: "fas" },
  faChalkboardTeacher: { ...VR, prefix: "fas" },
  faChalkboardUser: { ...IR, prefix: "fas" },
  faChampagneGlasses: { ...KR, prefix: "fas" },
  faChargingStation: { ...XR, prefix: "fas" },
  faChartArea: { ...QR, prefix: "fas" },
  faChartBar: { ...JR, prefix: "fas" },
  faChartColumn: { ...YR, prefix: "fas" },
  faChartGantt: { ...ZR, prefix: "fas" },
  faChartLine: { ...pR, prefix: "fas" },
  faChartPie: { ...xR, prefix: "fas" },
  faChartSimple: { ...iU, prefix: "fas" },
  faCheck: { ...aU, prefix: "fas" },
  faCheckCircle: { ...eU, prefix: "fas" },
  faCheckDouble: { ...nU, prefix: "fas" },
  faCheckSquare: { ...fU, prefix: "fas" },
  faCheckToSlot: { ...cU, prefix: "fas" },
  faCheese: { ...tU, prefix: "fas" },
  faChess: { ...oU, prefix: "fas" },
  faChessBishop: { ...lU, prefix: "fas" },
  faChessBoard: { ...dU, prefix: "fas" },
  faChessKing: { ...rU, prefix: "fas" },
  faChessKnight: { ...sU, prefix: "fas" },
  faChessPawn: { ...hU, prefix: "fas" },
  faChessQueen: { ...vU, prefix: "fas" },
  faChessRook: { ...uU, prefix: "fas" },
  faChevronCircleDown: { ...mU, prefix: "fas" },
  faChevronCircleLeft: { ...gU, prefix: "fas" },
  faChevronCircleRight: { ...PU, prefix: "fas" },
  faChevronCircleUp: { ...MU, prefix: "fas" },
  faChevronDown: { ...wU, prefix: "fas" },
  faChevronLeft: { ...NU, prefix: "fas" },
  faChevronRight: { ...zU, prefix: "fas" },
  faChevronUp: { ...LU, prefix: "fas" },
  faChild: { ...CU, prefix: "fas" },
  faChildCombatant: { ...DU, prefix: "fas" },
  faChildDress: { ...$U, prefix: "fas" },
  faChildReaching: { ..._U, prefix: "fas" },
  faChildRifle: { ...bU, prefix: "fas" },
  faChildren: { ...SU, prefix: "fas" },
  faChurch: { ...yU, prefix: "fas" },
  faCircle: { ...OU, prefix: "fas" },
  faCircleArrowDown: { ...kU, prefix: "fas" },
  faCircleArrowLeft: { ...AU, prefix: "fas" },
  faCircleArrowRight: { ...jU, prefix: "fas" },
  faCircleArrowUp: { ...BU, prefix: "fas" },
  faCircleCheck: { ...TU, prefix: "fas" },
  faCircleChevronDown: { ...FU, prefix: "fas" },
  faCircleChevronLeft: { ...HU, prefix: "fas" },
  faCircleChevronRight: { ...RU, prefix: "fas" },
  faCircleChevronUp: { ...UU, prefix: "fas" },
  faCircleDollarToSlot: { ...qU, prefix: "fas" },
  faCircleDot: { ...GU, prefix: "fas" },
  faCircleDown: { ...WU, prefix: "fas" },
  faCircleExclamation: { ...EU, prefix: "fas" },
  faCircleH: { ...VU, prefix: "fas" },
  faCircleHalfStroke: { ...IU, prefix: "fas" },
  faCircleInfo: { ...KU, prefix: "fas" },
  faCircleLeft: { ...XU, prefix: "fas" },
  faCircleMinus: { ...QU, prefix: "fas" },
  faCircleNodes: { ...JU, prefix: "fas" },
  faCircleNotch: { ...YU, prefix: "fas" },
  faCirclePause: { ...ZU, prefix: "fas" },
  faCirclePlay: { ...pU, prefix: "fas" },
  faCirclePlus: { ...xU, prefix: "fas" },
  faCircleQuestion: { ...iq, prefix: "fas" },
  faCircleRadiation: { ...aq, prefix: "fas" },
  faCircleRight: { ...eq, prefix: "fas" },
  faCircleStop: { ...nq, prefix: "fas" },
  faCircleUp: { ...fq, prefix: "fas" },
  faCircleUser: { ...cq, prefix: "fas" },
  faCircleXmark: { ...tq, prefix: "fas" },
  faCity: { ...oq, prefix: "fas" },
  faClapperboard: { ...lq, prefix: "fas" },
  faClinicMedical: { ...dq, prefix: "fas" },
  faClipboard: { ...rq, prefix: "fas" },
  faClipboardCheck: { ...sq, prefix: "fas" },
  faClipboardList: { ...hq, prefix: "fas" },
  faClipboardQuestion: { ...vq, prefix: "fas" },
  faClipboardUser: { ...uq, prefix: "fas" },
  faClock: { ...mq, prefix: "fas" },
  faClockFour: { ...gq, prefix: "fas" },
  faClockRotateLeft: { ...Pq, prefix: "fas" },
  faClone: { ...Mq, prefix: "fas" },
  faClose: { ...wq, prefix: "fas" },
  faClosedCaptioning: { ...Nq, prefix: "fas" },
  faCloud: { ...zq, prefix: "fas" },
  faCloudArrowDown: { ...Lq, prefix: "fas" },
  faCloudArrowUp: { ...Cq, prefix: "fas" },
  faCloudBolt: { ...Dq, prefix: "fas" },
  faCloudDownload: { ...$q, prefix: "fas" },
  faCloudDownloadAlt: { ..._q, prefix: "fas" },
  faCloudMeatball: { ...bq, prefix: "fas" },
  faCloudMoon: { ...Sq, prefix: "fas" },
  faCloudMoonRain: { ...yq, prefix: "fas" },
  faCloudRain: { ...Oq, prefix: "fas" },
  faCloudShowersHeavy: { ...kq, prefix: "fas" },
  faCloudShowersWater: { ...Aq, prefix: "fas" },
  faCloudSun: { ...jq, prefix: "fas" },
  faCloudSunRain: { ...Bq, prefix: "fas" },
  faCloudUpload: { ...Tq, prefix: "fas" },
  faCloudUploadAlt: { ...Fq, prefix: "fas" },
  faClover: { ...Hq, prefix: "fas" },
  faCny: { ...Rq, prefix: "fas" },
  faCocktail: { ...Uq, prefix: "fas" },
  faCode: { ...qq, prefix: "fas" },
  faCodeBranch: { ...Gq, prefix: "fas" },
  faCodeCommit: { ...Wq, prefix: "fas" },
  faCodeCompare: { ...Eq, prefix: "fas" },
  faCodeFork: { ...Vq, prefix: "fas" },
  faCodeMerge: { ...Iq, prefix: "fas" },
  faCodePullRequest: { ...Kq, prefix: "fas" },
  faCoffee: { ...Xq, prefix: "fas" },
  faCog: { ...Qq, prefix: "fas" },
  faCogs: { ...Jq, prefix: "fas" },
  faCoins: { ...Yq, prefix: "fas" },
  faColonSign: { ...Zq, prefix: "fas" },
  faColumns: { ...pq, prefix: "fas" },
  faComment: { ...xq, prefix: "fas" },
  faCommentAlt: { ...iG, prefix: "fas" },
  faCommentDollar: { ...aG, prefix: "fas" },
  faCommentDots: { ...eG, prefix: "fas" },
  faCommentMedical: { ...nG, prefix: "fas" },
  faCommentSlash: { ...fG, prefix: "fas" },
  faCommentSms: { ...cG, prefix: "fas" },
  faCommenting: { ...tG, prefix: "fas" },
  faComments: { ...oG, prefix: "fas" },
  faCommentsDollar: { ...lG, prefix: "fas" },
  faCompactDisc: { ...dG, prefix: "fas" },
  faCompass: { ...rG, prefix: "fas" },
  faCompassDrafting: { ...sG, prefix: "fas" },
  faCompress: { ...hG, prefix: "fas" },
  faCompressAlt: { ...vG, prefix: "fas" },
  faCompressArrowsAlt: { ...uG, prefix: "fas" },
  faComputer: { ...mG, prefix: "fas" },
  faComputerMouse: { ...gG, prefix: "fas" },
  faConciergeBell: { ...PG, prefix: "fas" },
  faContactBook: { ...MG, prefix: "fas" },
  faContactCard: { ...wG, prefix: "fas" },
  faCookie: { ...NG, prefix: "fas" },
  faCookieBite: { ...zG, prefix: "fas" },
  faCopy: { ...LG, prefix: "fas" },
  faCopyright: { ...CG, prefix: "fas" },
  faCouch: { ...DG, prefix: "fas" },
  faCow: { ...$G, prefix: "fas" },
  faCreditCard: { ..._G, prefix: "fas" },
  faCreditCardAlt: { ...bG, prefix: "fas" },
  faCrop: { ...SG, prefix: "fas" },
  faCropAlt: { ...yG, prefix: "fas" },
  faCropSimple: { ...OG, prefix: "fas" },
  faCross: { ...kG, prefix: "fas" },
  faCrosshairs: { ...AG, prefix: "fas" },
  faCrow: { ...jG, prefix: "fas" },
  faCrown: { ...BG, prefix: "fas" },
  faCrutch: { ...TG, prefix: "fas" },
  faCruzeiroSign: { ...FG, prefix: "fas" },
  faCube: { ...HG, prefix: "fas" },
  faCubes: { ...RG, prefix: "fas" },
  faCubesStacked: { ...UG, prefix: "fas" },
  faCut: { ...qG, prefix: "fas" },
  faCutlery: { ...GG, prefix: "fas" },
  faD: { ...WG, prefix: "fas" },
  faDashboard: { ...EG, prefix: "fas" },
  faDatabase: { ...VG, prefix: "fas" },
  faDeaf: { ...IG, prefix: "fas" },
  faDeafness: { ...KG, prefix: "fas" },
  faDedent: { ...XG, prefix: "fas" },
  faDeleteLeft: { ...QG, prefix: "fas" },
  faDemocrat: { ...JG, prefix: "fas" },
  faDesktop: { ...YG, prefix: "fas" },
  faDesktopAlt: { ...ZG, prefix: "fas" },
  faDharmachakra: { ...pG, prefix: "fas" },
  faDiagnoses: { ...xG, prefix: "fas" },
  faDiagramNext: { ...iW, prefix: "fas" },
  faDiagramPredecessor: { ...aW, prefix: "fas" },
  faDiagramProject: { ...eW, prefix: "fas" },
  faDiagramSuccessor: { ...nW, prefix: "fas" },
  faDiamond: { ...fW, prefix: "fas" },
  faDiamondTurnRight: { ...cW, prefix: "fas" },
  faDice: { ...tW, prefix: "fas" },
  faDiceD20: { ...oW, prefix: "fas" },
  faDiceD6: { ...lW, prefix: "fas" },
  faDiceFive: { ...dW, prefix: "fas" },
  faDiceFour: { ...rW, prefix: "fas" },
  faDiceOne: { ...sW, prefix: "fas" },
  faDiceSix: { ...hW, prefix: "fas" },
  faDiceThree: { ...vW, prefix: "fas" },
  faDiceTwo: { ...uW, prefix: "fas" },
  faDigging: { ...mW, prefix: "fas" },
  faDigitalTachograph: { ...gW, prefix: "fas" },
  faDirections: { ...PW, prefix: "fas" },
  faDisease: { ...MW, prefix: "fas" },
  faDisplay: { ...wW, prefix: "fas" },
  faDivide: { ...NW, prefix: "fas" },
  faDizzy: { ...zW, prefix: "fas" },
  faDna: { ...LW, prefix: "fas" },
  faDog: { ...CW, prefix: "fas" },
  faDollar: { ...DW, prefix: "fas" },
  faDollarSign: { ...$W, prefix: "fas" },
  faDolly: { ..._W, prefix: "fas" },
  faDollyBox: { ...bW, prefix: "fas" },
  faDollyFlatbed: { ...SW, prefix: "fas" },
  faDonate: { ...yW, prefix: "fas" },
  faDongSign: { ...OW, prefix: "fas" },
  faDoorClosed: { ...kW, prefix: "fas" },
  faDoorOpen: { ...AW, prefix: "fas" },
  faDotCircle: { ...jW, prefix: "fas" },
  faDove: { ...BW, prefix: "fas" },
  faDownLeftAndUpRightToCenter: { ...TW, prefix: "fas" },
  faDownLong: { ...FW, prefix: "fas" },
  faDownload: { ...HW, prefix: "fas" },
  faDraftingCompass: { ...RW, prefix: "fas" },
  faDragon: { ...UW, prefix: "fas" },
  faDrawPolygon: { ...qW, prefix: "fas" },
  faDriversLicense: { ...GW, prefix: "fas" },
  faDroplet: { ...WW, prefix: "fas" },
  faDropletSlash: { ...EW, prefix: "fas" },
  faDrum: { ...VW, prefix: "fas" },
  faDrumSteelpan: { ...IW, prefix: "fas" },
  faDrumstickBite: { ...KW, prefix: "fas" },
  faDumbbell: { ...XW, prefix: "fas" },
  faDumpster: { ...QW, prefix: "fas" },
  faDumpsterFire: { ...JW, prefix: "fas" },
  faDungeon: { ...YW, prefix: "fas" },
  faE: { ...ZW, prefix: "fas" },
  faEarDeaf: { ...pW, prefix: "fas" },
  faEarListen: { ...xW, prefix: "fas" },
  faEarth: { ...iE, prefix: "fas" },
  faEarthAfrica: { ...aE, prefix: "fas" },
  faEarthAmerica: { ...eE, prefix: "fas" },
  faEarthAmericas: { ...nE, prefix: "fas" },
  faEarthAsia: { ...fE, prefix: "fas" },
  faEarthEurope: { ...cE, prefix: "fas" },
  faEarthOceania: { ...tE, prefix: "fas" },
  faEdit: { ...oE, prefix: "fas" },
  faEgg: { ...lE, prefix: "fas" },
  faEject: { ...dE, prefix: "fas" },
  faElevator: { ...rE, prefix: "fas" },
  faEllipsis: { ...sE, prefix: "fas" },
  faEllipsisH: { ...hE, prefix: "fas" },
  faEllipsisV: { ...vE, prefix: "fas" },
  faEllipsisVertical: { ...uE, prefix: "fas" },
  faEnvelope: { ...mE, prefix: "fas" },
  faEnvelopeCircleCheck: { ...gE, prefix: "fas" },
  faEnvelopeOpen: { ...PE, prefix: "fas" },
  faEnvelopeOpenText: { ...ME, prefix: "fas" },
  faEnvelopeSquare: { ...wE, prefix: "fas" },
  faEnvelopesBulk: { ...NE, prefix: "fas" },
  faEquals: { ...zE, prefix: "fas" },
  faEraser: { ...LE, prefix: "fas" },
  faEthernet: { ...CE, prefix: "fas" },
  faEur: { ...DE, prefix: "fas" },
  faEuro: { ...$E, prefix: "fas" },
  faEuroSign: { ..._E, prefix: "fas" },
  faExchange: { ...bE, prefix: "fas" },
  faExchangeAlt: { ...SE, prefix: "fas" },
  faExclamation: { ...yE, prefix: "fas" },
  faExclamationCircle: { ...OE, prefix: "fas" },
  faExclamationTriangle: { ...kE, prefix: "fas" },
  faExpand: { ...AE, prefix: "fas" },
  faExpandAlt: { ...jE, prefix: "fas" },
  faExpandArrowsAlt: { ...BE, prefix: "fas" },
  faExplosion: { ...TE, prefix: "fas" },
  faExternalLink: { ...FE, prefix: "fas" },
  faExternalLinkAlt: { ...HE, prefix: "fas" },
  faExternalLinkSquare: { ...RE, prefix: "fas" },
  faExternalLinkSquareAlt: { ...UE, prefix: "fas" },
  faEye: { ...qE, prefix: "fas" },
  faEyeDropper: { ...GE, prefix: "fas" },
  faEyeDropperEmpty: { ...WE, prefix: "fas" },
  faEyeLowVision: { ...EE, prefix: "fas" },
  faEyeSlash: { ...VE, prefix: "fas" },
  faF: { ...IE, prefix: "fas" },
  faFaceAngry: { ...KE, prefix: "fas" },
  faFaceDizzy: { ...XE, prefix: "fas" },
  faFaceFlushed: { ...QE, prefix: "fas" },
  faFaceFrown: { ...JE, prefix: "fas" },
  faFaceFrownOpen: { ...YE, prefix: "fas" },
  faFaceGrimace: { ...ZE, prefix: "fas" },
  faFaceGrin: { ...pE, prefix: "fas" },
  faFaceGrinBeam: { ...xE, prefix: "fas" },
  faFaceGrinBeamSweat: { ...iV, prefix: "fas" },
  faFaceGrinHearts: { ...aV, prefix: "fas" },
  faFaceGrinSquint: { ...eV, prefix: "fas" },
  faFaceGrinSquintTears: { ...nV, prefix: "fas" },
  faFaceGrinStars: { ...fV, prefix: "fas" },
  faFaceGrinTears: { ...cV, prefix: "fas" },
  faFaceGrinTongue: { ...tV, prefix: "fas" },
  faFaceGrinTongueSquint: { ...oV, prefix: "fas" },
  faFaceGrinTongueWink: { ...lV, prefix: "fas" },
  faFaceGrinWide: { ...dV, prefix: "fas" },
  faFaceGrinWink: { ...rV, prefix: "fas" },
  faFaceKiss: { ...sV, prefix: "fas" },
  faFaceKissBeam: { ...hV, prefix: "fas" },
  faFaceKissWinkHeart: { ...vV, prefix: "fas" },
  faFaceLaugh: { ...uV, prefix: "fas" },
  faFaceLaughBeam: { ...mV, prefix: "fas" },
  faFaceLaughSquint: { ...gV, prefix: "fas" },
  faFaceLaughWink: { ...PV, prefix: "fas" },
  faFaceMeh: { ...MV, prefix: "fas" },
  faFaceMehBlank: { ...wV, prefix: "fas" },
  faFaceRollingEyes: { ...NV, prefix: "fas" },
  faFaceSadCry: { ...zV, prefix: "fas" },
  faFaceSadTear: { ...LV, prefix: "fas" },
  faFaceSmile: { ...CV, prefix: "fas" },
  faFaceSmileBeam: { ...DV, prefix: "fas" },
  faFaceSmileWink: { ...$V, prefix: "fas" },
  faFaceSurprise: { ..._V, prefix: "fas" },
  faFaceTired: { ...bV, prefix: "fas" },
  faFan: { ...SV, prefix: "fas" },
  faFastBackward: { ...yV, prefix: "fas" },
  faFastForward: { ...OV, prefix: "fas" },
  faFaucet: { ...kV, prefix: "fas" },
  faFaucetDrip: { ...AV, prefix: "fas" },
  faFax: { ...jV, prefix: "fas" },
  faFeather: { ...BV, prefix: "fas" },
  faFeatherAlt: { ...TV, prefix: "fas" },
  faFeatherPointed: { ...FV, prefix: "fas" },
  faFeed: { ...HV, prefix: "fas" },
  faFemale: { ...RV, prefix: "fas" },
  faFerry: { ...UV, prefix: "fas" },
  faFighterJet: { ...qV, prefix: "fas" },
  faFile: { ...GV, prefix: "fas" },
  faFileAlt: { ...WV, prefix: "fas" },
  faFileArchive: { ...EV, prefix: "fas" },
  faFileArrowDown: { ...VV, prefix: "fas" },
  faFileArrowUp: { ...IV, prefix: "fas" },
  faFileAudio: { ...KV, prefix: "fas" },
  faFileCircleCheck: { ...XV, prefix: "fas" },
  faFileCircleExclamation: { ...QV, prefix: "fas" },
  faFileCircleMinus: { ...JV, prefix: "fas" },
  faFileCirclePlus: { ...YV, prefix: "fas" },
  faFileCircleQuestion: { ...ZV, prefix: "fas" },
  faFileCircleXmark: { ...pV, prefix: "fas" },
  faFileClipboard: { ...xV, prefix: "fas" },
  faFileCode: { ...iI, prefix: "fas" },
  faFileContract: { ...aI, prefix: "fas" },
  faFileCsv: { ...eI, prefix: "fas" },
  faFileDownload: { ...nI, prefix: "fas" },
  faFileEdit: { ...fI, prefix: "fas" },
  faFileExcel: { ...cI, prefix: "fas" },
  faFileExport: { ...tI, prefix: "fas" },
  faFileImage: { ...oI, prefix: "fas" },
  faFileImport: { ...lI, prefix: "fas" },
  faFileInvoice: { ...dI, prefix: "fas" },
  faFileInvoiceDollar: { ...rI, prefix: "fas" },
  faFileLines: { ...sI, prefix: "fas" },
  faFileMedical: { ...hI, prefix: "fas" },
  faFileMedicalAlt: { ...vI, prefix: "fas" },
  faFilePdf: { ...uI, prefix: "fas" },
  faFilePen: { ...mI, prefix: "fas" },
  faFilePowerpoint: { ...gI, prefix: "fas" },
  faFilePrescription: { ...PI, prefix: "fas" },
  faFileShield: { ...MI, prefix: "fas" },
  faFileSignature: { ...wI, prefix: "fas" },
  faFileText: { ...NI, prefix: "fas" },
  faFileUpload: { ...zI, prefix: "fas" },
  faFileVideo: { ...LI, prefix: "fas" },
  faFileWaveform: { ...CI, prefix: "fas" },
  faFileWord: { ...DI, prefix: "fas" },
  faFileZipper: { ...$I, prefix: "fas" },
  faFill: { ..._I, prefix: "fas" },
  faFillDrip: { ...bI, prefix: "fas" },
  faFilm: { ...SI, prefix: "fas" },
  faFilter: { ...yI, prefix: "fas" },
  faFilterCircleDollar: { ...OI, prefix: "fas" },
  faFilterCircleXmark: { ...kI, prefix: "fas" },
  faFingerprint: { ...AI, prefix: "fas" },
  faFire: { ...jI, prefix: "fas" },
  faFireAlt: { ...BI, prefix: "fas" },
  faFireBurner: { ...TI, prefix: "fas" },
  faFireExtinguisher: { ...FI, prefix: "fas" },
  faFireFlameCurved: { ...HI, prefix: "fas" },
  faFireFlameSimple: { ...RI, prefix: "fas" },
  faFirstAid: { ...UI, prefix: "fas" },
  faFish: { ...qI, prefix: "fas" },
  faFishFins: { ...GI, prefix: "fas" },
  faFistRaised: { ...WI, prefix: "fas" },
  faFlag: { ...EI, prefix: "fas" },
  faFlagCheckered: { ...VI, prefix: "fas" },
  faFlagUsa: { ...II, prefix: "fas" },
  faFlask: { ...KI, prefix: "fas" },
  faFlaskVial: { ...XI, prefix: "fas" },
  faFloppyDisk: { ...QI, prefix: "fas" },
  faFlorinSign: { ...JI, prefix: "fas" },
  faFlushed: { ...YI, prefix: "fas" },
  faFolder: { ...ZI, prefix: "fas" },
  faFolderBlank: { ...pI, prefix: "fas" },
  faFolderClosed: { ...xI, prefix: "fas" },
  faFolderMinus: { ...iK, prefix: "fas" },
  faFolderOpen: { ...aK, prefix: "fas" },
  faFolderPlus: { ...eK, prefix: "fas" },
  faFolderTree: { ...nK, prefix: "fas" },
  faFont: { ...fK, prefix: "fas" },
  faFontAwesome: { ...cK, prefix: "fas" },
  faFontAwesomeFlag: { ...tK, prefix: "fas" },
  faFontAwesomeLogoFull: { ...oK, prefix: "fas" },
  faFootball: { ...lK, prefix: "fas" },
  faFootballBall: { ...dK, prefix: "fas" },
  faForward: { ...rK, prefix: "fas" },
  faForwardFast: { ...sK, prefix: "fas" },
  faForwardStep: { ...hK, prefix: "fas" },
  faFrancSign: { ...vK, prefix: "fas" },
  faFrog: { ...uK, prefix: "fas" },
  faFrown: { ...mK, prefix: "fas" },
  faFrownOpen: { ...gK, prefix: "fas" },
  faFunnelDollar: { ...PK, prefix: "fas" },
  faFutbol: { ...MK, prefix: "fas" },
  faFutbolBall: { ...wK, prefix: "fas" },
  faG: { ...NK, prefix: "fas" },
  faGamepad: { ...zK, prefix: "fas" },
  faGasPump: { ...LK, prefix: "fas" },
  faGauge: { ...CK, prefix: "fas" },
  faGaugeHigh: { ...DK, prefix: "fas" },
  faGaugeMed: { ...$K, prefix: "fas" },
  faGaugeSimple: { ..._K, prefix: "fas" },
  faGaugeSimpleHigh: { ...bK, prefix: "fas" },
  faGaugeSimpleMed: { ...SK, prefix: "fas" },
  faGavel: { ...yK, prefix: "fas" },
  faGbp: { ...OK, prefix: "fas" },
  faGear: { ...kK, prefix: "fas" },
  faGears: { ...AK, prefix: "fas" },
  faGem: { ...jK, prefix: "fas" },
  faGenderless: { ...BK, prefix: "fas" },
  faGhost: { ...TK, prefix: "fas" },
  faGift: { ...FK, prefix: "fas" },
  faGifts: { ...HK, prefix: "fas" },
  faGlassCheers: { ...RK, prefix: "fas" },
  faGlassMartini: { ...UK, prefix: "fas" },
  faGlassMartiniAlt: { ...qK, prefix: "fas" },
  faGlassWater: { ...GK, prefix: "fas" },
  faGlassWaterDroplet: { ...WK, prefix: "fas" },
  faGlassWhiskey: { ...EK, prefix: "fas" },
  faGlasses: { ...VK, prefix: "fas" },
  faGlobe: { ...IK, prefix: "fas" },
  faGlobeAfrica: { ...KK, prefix: "fas" },
  faGlobeAmericas: { ...XK, prefix: "fas" },
  faGlobeAsia: { ...QK, prefix: "fas" },
  faGlobeEurope: { ...JK, prefix: "fas" },
  faGlobeOceania: { ...YK, prefix: "fas" },
  faGolfBall: { ...ZK, prefix: "fas" },
  faGolfBallTee: { ...pK, prefix: "fas" },
  faGopuram: { ...xK, prefix: "fas" },
  faGraduationCap: { ...iX, prefix: "fas" },
  faGreaterThan: { ...aX, prefix: "fas" },
  faGreaterThanEqual: { ...eX, prefix: "fas" },
  faGrimace: { ...nX, prefix: "fas" },
  faGrin: { ...fX, prefix: "fas" },
  faGrinAlt: { ...cX, prefix: "fas" },
  faGrinBeam: { ...tX, prefix: "fas" },
  faGrinBeamSweat: { ...oX, prefix: "fas" },
  faGrinHearts: { ...lX, prefix: "fas" },
  faGrinSquint: { ...dX, prefix: "fas" },
  faGrinSquintTears: { ...rX, prefix: "fas" },
  faGrinStars: { ...sX, prefix: "fas" },
  faGrinTears: { ...hX, prefix: "fas" },
  faGrinTongue: { ...vX, prefix: "fas" },
  faGrinTongueSquint: { ...uX, prefix: "fas" },
  faGrinTongueWink: { ...mX, prefix: "fas" },
  faGrinWink: { ...gX, prefix: "fas" },
  faGrip: { ...PX, prefix: "fas" },
  faGripHorizontal: { ...MX, prefix: "fas" },
  faGripLines: { ...wX, prefix: "fas" },
  faGripLinesVertical: { ...NX, prefix: "fas" },
  faGripVertical: { ...zX, prefix: "fas" },
  faGroupArrowsRotate: { ...LX, prefix: "fas" },
  faGuaraniSign: { ...CX, prefix: "fas" },
  faGuitar: { ...DX, prefix: "fas" },
  faGun: { ...$X, prefix: "fas" },
  faH: { ..._X, prefix: "fas" },
  faHSquare: { ...bX, prefix: "fas" },
  faHamburger: { ...SX, prefix: "fas" },
  faHammer: { ...yX, prefix: "fas" },
  faHamsa: { ...OX, prefix: "fas" },
  faHand: { ...kX, prefix: "fas" },
  faHandBackFist: { ...AX, prefix: "fas" },
  faHandDots: { ...jX, prefix: "fas" },
  faHandFist: { ...BX, prefix: "fas" },
  faHandHolding: { ...TX, prefix: "fas" },
  faHandHoldingDollar: { ...FX, prefix: "fas" },
  faHandHoldingDroplet: { ...HX, prefix: "fas" },
  faHandHoldingHand: { ...RX, prefix: "fas" },
  faHandHoldingHeart: { ...UX, prefix: "fas" },
  faHandHoldingMedical: { ...qX, prefix: "fas" },
  faHandHoldingUsd: { ...GX, prefix: "fas" },
  faHandHoldingWater: { ...WX, prefix: "fas" },
  faHandLizard: { ...EX, prefix: "fas" },
  faHandMiddleFinger: { ...VX, prefix: "fas" },
  faHandPaper: { ...IX, prefix: "fas" },
  faHandPeace: { ...KX, prefix: "fas" },
  faHandPointDown: { ...XX, prefix: "fas" },
  faHandPointLeft: { ...QX, prefix: "fas" },
  faHandPointRight: { ...JX, prefix: "fas" },
  faHandPointUp: { ...YX, prefix: "fas" },
  faHandPointer: { ...ZX, prefix: "fas" },
  faHandRock: { ...pX, prefix: "fas" },
  faHandScissors: { ...xX, prefix: "fas" },
  faHandSparkles: { ...iQ, prefix: "fas" },
  faHandSpock: { ...aQ, prefix: "fas" },
  faHandcuffs: { ...eQ, prefix: "fas" },
  faHands: { ...nQ, prefix: "fas" },
  faHandsAmericanSignLanguageInterpreting: { ...fQ, prefix: "fas" },
  faHandsAslInterpreting: { ...cQ, prefix: "fas" },
  faHandsBound: { ...tQ, prefix: "fas" },
  faHandsBubbles: { ...oQ, prefix: "fas" },
  faHandsClapping: { ...lQ, prefix: "fas" },
  faHandsHelping: { ...dQ, prefix: "fas" },
  faHandsHolding: { ...rQ, prefix: "fas" },
  faHandsHoldingChild: { ...sQ, prefix: "fas" },
  faHandsHoldingCircle: { ...hQ, prefix: "fas" },
  faHandsPraying: { ...vQ, prefix: "fas" },
  faHandsWash: { ...uQ, prefix: "fas" },
  faHandshake: { ...mQ, prefix: "fas" },
  faHandshakeAlt: { ...gQ, prefix: "fas" },
  faHandshakeAltSlash: { ...PQ, prefix: "fas" },
  faHandshakeAngle: { ...MQ, prefix: "fas" },
  faHandshakeSimple: { ...wQ, prefix: "fas" },
  faHandshakeSimpleSlash: { ...NQ, prefix: "fas" },
  faHandshakeSlash: { ...zQ, prefix: "fas" },
  faHanukiah: { ...LQ, prefix: "fas" },
  faHardDrive: { ...CQ, prefix: "fas" },
  faHardHat: { ...DQ, prefix: "fas" },
  faHardOfHearing: { ...$Q, prefix: "fas" },
  faHashtag: { ..._Q, prefix: "fas" },
  faHatCowboy: { ...bQ, prefix: "fas" },
  faHatCowboySide: { ...SQ, prefix: "fas" },
  faHatHard: { ...yQ, prefix: "fas" },
  faHatWizard: { ...OQ, prefix: "fas" },
  faHaykal: { ...kQ, prefix: "fas" },
  faHdd: { ...AQ, prefix: "fas" },
  faHeadSideCough: { ...jQ, prefix: "fas" },
  faHeadSideCoughSlash: { ...BQ, prefix: "fas" },
  faHeadSideMask: { ...TQ, prefix: "fas" },
  faHeadSideVirus: { ...FQ, prefix: "fas" },
  faHeader: { ...HQ, prefix: "fas" },
  faHeading: { ...RQ, prefix: "fas" },
  faHeadphones: { ...UQ, prefix: "fas" },
  faHeadphonesAlt: { ...qQ, prefix: "fas" },
  faHeadphonesSimple: { ...GQ, prefix: "fas" },
  faHeadset: { ...WQ, prefix: "fas" },
  faHeart: { ...EQ, prefix: "fas" },
  faHeartBroken: { ...VQ, prefix: "fas" },
  faHeartCircleBolt: { ...IQ, prefix: "fas" },
  faHeartCircleCheck: { ...KQ, prefix: "fas" },
  faHeartCircleExclamation: { ...XQ, prefix: "fas" },
  faHeartCircleMinus: { ...QQ, prefix: "fas" },
  faHeartCirclePlus: { ...JQ, prefix: "fas" },
  faHeartCircleXmark: { ...YQ, prefix: "fas" },
  faHeartCrack: { ...ZQ, prefix: "fas" },
  faHeartMusicCameraBolt: { ...pQ, prefix: "fas" },
  faHeartPulse: { ...xQ, prefix: "fas" },
  faHeartbeat: { ...iJ, prefix: "fas" },
  faHelicopter: { ...aJ, prefix: "fas" },
  faHelicopterSymbol: { ...eJ, prefix: "fas" },
  faHelmetSafety: { ...nJ, prefix: "fas" },
  faHelmetUn: { ...fJ, prefix: "fas" },
  faHighlighter: { ...cJ, prefix: "fas" },
  faHiking: { ...tJ, prefix: "fas" },
  faHillAvalanche: { ...oJ, prefix: "fas" },
  faHillRockslide: { ...lJ, prefix: "fas" },
  faHippo: { ...dJ, prefix: "fas" },
  faHistory: { ...rJ, prefix: "fas" },
  faHockeyPuck: { ...sJ, prefix: "fas" },
  faHollyBerry: { ...hJ, prefix: "fas" },
  faHome: { ...vJ, prefix: "fas" },
  faHomeAlt: { ...uJ, prefix: "fas" },
  faHomeLg: { ...mJ, prefix: "fas" },
  faHomeLgAlt: { ...gJ, prefix: "fas" },
  faHomeUser: { ...PJ, prefix: "fas" },
  faHorse: { ...MJ, prefix: "fas" },
  faHorseHead: { ...wJ, prefix: "fas" },
  faHospital: { ...NJ, prefix: "fas" },
  faHospitalAlt: { ...zJ, prefix: "fas" },
  faHospitalSymbol: { ...LJ, prefix: "fas" },
  faHospitalUser: { ...CJ, prefix: "fas" },
  faHospitalWide: { ...DJ, prefix: "fas" },
  faHotTub: { ...$J, prefix: "fas" },
  faHotTubPerson: { ..._J, prefix: "fas" },
  faHotdog: { ...bJ, prefix: "fas" },
  faHotel: { ...SJ, prefix: "fas" },
  faHourglass: { ...yJ, prefix: "fas" },
  faHourglass1: { ...OJ, prefix: "fas" },
  faHourglass2: { ...kJ, prefix: "fas" },
  faHourglass3: { ...AJ, prefix: "fas" },
  faHourglassEmpty: { ...jJ, prefix: "fas" },
  faHourglassEnd: { ...BJ, prefix: "fas" },
  faHourglassHalf: { ...TJ, prefix: "fas" },
  faHourglassStart: { ...FJ, prefix: "fas" },
  faHouse: { ...HJ, prefix: "fas" },
  faHouseChimney: { ...RJ, prefix: "fas" },
  faHouseChimneyCrack: { ...UJ, prefix: "fas" },
  faHouseChimneyMedical: { ...qJ, prefix: "fas" },
  faHouseChimneyUser: { ...GJ, prefix: "fas" },
  faHouseChimneyWindow: { ...WJ, prefix: "fas" },
  faHouseCircleCheck: { ...EJ, prefix: "fas" },
  faHouseCircleExclamation: { ...VJ, prefix: "fas" },
  faHouseCircleXmark: { ...IJ, prefix: "fas" },
  faHouseCrack: { ...KJ, prefix: "fas" },
  faHouseDamage: { ...XJ, prefix: "fas" },
  faHouseFire: { ...QJ, prefix: "fas" },
  faHouseFlag: { ...JJ, prefix: "fas" },
  faHouseFloodWater: { ...YJ, prefix: "fas" },
  faHouseFloodWaterCircleArrowRight: { ...ZJ, prefix: "fas" },
  faHouseLaptop: { ...pJ, prefix: "fas" },
  faHouseLock: { ...xJ, prefix: "fas" },
  faHouseMedical: { ...iY, prefix: "fas" },
  faHouseMedicalCircleCheck: { ...aY, prefix: "fas" },
  faHouseMedicalCircleExclamation: { ...eY, prefix: "fas" },
  faHouseMedicalCircleXmark: { ...nY, prefix: "fas" },
  faHouseMedicalFlag: { ...fY, prefix: "fas" },
  faHouseSignal: { ...cY, prefix: "fas" },
  faHouseTsunami: { ...tY, prefix: "fas" },
  faHouseUser: { ...oY, prefix: "fas" },
  faHryvnia: { ...lY, prefix: "fas" },
  faHryvniaSign: { ...dY, prefix: "fas" },
  faHurricane: { ...rY, prefix: "fas" },
  faI: { ...sY, prefix: "fas" },
  faICursor: { ...hY, prefix: "fas" },
  faIceCream: { ...vY, prefix: "fas" },
  faIcicles: { ...uY, prefix: "fas" },
  faIcons: { ...mY, prefix: "fas" },
  faIdBadge: { ...gY, prefix: "fas" },
  faIdCard: { ...PY, prefix: "fas" },
  faIdCardAlt: { ...MY, prefix: "fas" },
  faIdCardClip: { ...wY, prefix: "fas" },
  faIgloo: { ...NY, prefix: "fas" },
  faIls: { ...zY, prefix: "fas" },
  faImage: { ...LY, prefix: "fas" },
  faImagePortrait: { ...CY, prefix: "fas" },
  faImages: { ...DY, prefix: "fas" },
  faInbox: { ...$Y, prefix: "fas" },
  faIndent: { ..._Y, prefix: "fas" },
  faIndianRupee: { ...bY, prefix: "fas" },
  faIndianRupeeSign: { ...SY, prefix: "fas" },
  faIndustry: { ...yY, prefix: "fas" },
  faInfinity: { ...OY, prefix: "fas" },
  faInfo: { ...kY, prefix: "fas" },
  faInfoCircle: { ...AY, prefix: "fas" },
  faInr: { ...jY, prefix: "fas" },
  faInstitution: { ...BY, prefix: "fas" },
  faItalic: { ...TY, prefix: "fas" },
  faJ: { ...FY, prefix: "fas" },
  faJar: { ...HY, prefix: "fas" },
  faJarWheat: { ...RY, prefix: "fas" },
  faJedi: { ...UY, prefix: "fas" },
  faJetFighter: { ...qY, prefix: "fas" },
  faJetFighterUp: { ...GY, prefix: "fas" },
  faJoint: { ...WY, prefix: "fas" },
  faJournalWhills: { ...EY, prefix: "fas" },
  faJpy: { ...VY, prefix: "fas" },
  faJugDetergent: { ...IY, prefix: "fas" },
  faK: { ...KY, prefix: "fas" },
  faKaaba: { ...XY, prefix: "fas" },
  faKey: { ...QY, prefix: "fas" },
  faKeyboard: { ...JY, prefix: "fas" },
  faKhanda: { ...YY, prefix: "fas" },
  faKipSign: { ...ZY, prefix: "fas" },
  faKiss: { ...pY, prefix: "fas" },
  faKissBeam: { ...xY, prefix: "fas" },
  faKissWinkHeart: { ...iZ, prefix: "fas" },
  faKitMedical: { ...aZ, prefix: "fas" },
  faKitchenSet: { ...eZ, prefix: "fas" },
  faKiwiBird: { ...nZ, prefix: "fas" },
  faKrw: { ...fZ, prefix: "fas" },
  faL: { ...cZ, prefix: "fas" },
  faLadderWater: { ...tZ, prefix: "fas" },
  faLandMineOn: { ...oZ, prefix: "fas" },
  faLandmark: { ...lZ, prefix: "fas" },
  faLandmarkAlt: { ...dZ, prefix: "fas" },
  faLandmarkDome: { ...rZ, prefix: "fas" },
  faLandmarkFlag: { ...sZ, prefix: "fas" },
  faLanguage: { ...hZ, prefix: "fas" },
  faLaptop: { ...vZ, prefix: "fas" },
  faLaptopCode: { ...uZ, prefix: "fas" },
  faLaptopFile: { ...mZ, prefix: "fas" },
  faLaptopHouse: { ...gZ, prefix: "fas" },
  faLaptopMedical: { ...PZ, prefix: "fas" },
  faLariSign: { ...MZ, prefix: "fas" },
  faLaugh: { ...wZ, prefix: "fas" },
  faLaughBeam: { ...NZ, prefix: "fas" },
  faLaughSquint: { ...zZ, prefix: "fas" },
  faLaughWink: { ...LZ, prefix: "fas" },
  faLayerGroup: { ...CZ, prefix: "fas" },
  faLeaf: { ...DZ, prefix: "fas" },
  faLeftLong: { ...$Z, prefix: "fas" },
  faLeftRight: { ..._Z, prefix: "fas" },
  faLegal: { ...bZ, prefix: "fas" },
  faLemon: { ...SZ, prefix: "fas" },
  faLessThan: { ...yZ, prefix: "fas" },
  faLessThanEqual: { ...OZ, prefix: "fas" },
  faLevelDown: { ...kZ, prefix: "fas" },
  faLevelDownAlt: { ...AZ, prefix: "fas" },
  faLevelUp: { ...jZ, prefix: "fas" },
  faLevelUpAlt: { ...BZ, prefix: "fas" },
  faLifeRing: { ...TZ, prefix: "fas" },
  faLightbulb: { ...FZ, prefix: "fas" },
  faLineChart: { ...HZ, prefix: "fas" },
  faLinesLeaning: { ...RZ, prefix: "fas" },
  faLink: { ...UZ, prefix: "fas" },
  faLinkSlash: { ...qZ, prefix: "fas" },
  faLiraSign: { ...GZ, prefix: "fas" },
  faList: { ...WZ, prefix: "fas" },
  faList12: { ...EZ, prefix: "fas" },
  faListAlt: { ...VZ, prefix: "fas" },
  faListCheck: { ...IZ, prefix: "fas" },
  faListDots: { ...KZ, prefix: "fas" },
  faListNumeric: { ...XZ, prefix: "fas" },
  faListOl: { ...QZ, prefix: "fas" },
  faListSquares: { ...JZ, prefix: "fas" },
  faListUl: { ...YZ, prefix: "fas" },
  faLitecoinSign: { ...ZZ, prefix: "fas" },
  faLocation: { ...pZ, prefix: "fas" },
  faLocationArrow: { ...xZ, prefix: "fas" },
  faLocationCrosshairs: { ...ip, prefix: "fas" },
  faLocationDot: { ...ap, prefix: "fas" },
  faLocationPin: { ...ep, prefix: "fas" },
  faLocationPinLock: { ...np, prefix: "fas" },
  faLock: { ...fp, prefix: "fas" },
  faLockOpen: { ...cp, prefix: "fas" },
  faLocust: { ...tp, prefix: "fas" },
  faLongArrowAltDown: { ...op, prefix: "fas" },
  faLongArrowAltLeft: { ...lp, prefix: "fas" },
  faLongArrowAltRight: { ...dp, prefix: "fas" },
  faLongArrowAltUp: { ...rp, prefix: "fas" },
  faLongArrowDown: { ...sp, prefix: "fas" },
  faLongArrowLeft: { ...hp, prefix: "fas" },
  faLongArrowRight: { ...vp, prefix: "fas" },
  faLongArrowUp: { ...up, prefix: "fas" },
  faLowVision: { ...mp, prefix: "fas" },
  faLuggageCart: { ...gp, prefix: "fas" },
  faLungs: { ...Pp, prefix: "fas" },
  faLungsVirus: { ...Mp, prefix: "fas" },
  faM: { ...wp, prefix: "fas" },
  faMagic: { ...Np, prefix: "fas" },
  faMagicWandSparkles: { ...zp, prefix: "fas" },
  faMagnet: { ...Lp, prefix: "fas" },
  faMagnifyingGlass: { ...Cp, prefix: "fas" },
  faMagnifyingGlassArrowRight: { ...Dp, prefix: "fas" },
  faMagnifyingGlassChart: { ...$p, prefix: "fas" },
  faMagnifyingGlassDollar: { ..._p, prefix: "fas" },
  faMagnifyingGlassLocation: { ...bp, prefix: "fas" },
  faMagnifyingGlassMinus: { ...Sp, prefix: "fas" },
  faMagnifyingGlassPlus: { ...yp, prefix: "fas" },
  faMailBulk: { ...Op, prefix: "fas" },
  faMailForward: { ...kp, prefix: "fas" },
  faMailReply: { ...Ap, prefix: "fas" },
  faMailReplyAll: { ...jp, prefix: "fas" },
  faMale: { ...Bp, prefix: "fas" },
  faManatSign: { ...Tp, prefix: "fas" },
  faMap: { ...Fp, prefix: "fas" },
  faMapLocation: { ...Hp, prefix: "fas" },
  faMapLocationDot: { ...Rp, prefix: "fas" },
  faMapMarked: { ...Up, prefix: "fas" },
  faMapMarkedAlt: { ...qp, prefix: "fas" },
  faMapMarker: { ...Gp, prefix: "fas" },
  faMapMarkerAlt: { ...Wp, prefix: "fas" },
  faMapPin: { ...Ep, prefix: "fas" },
  faMapSigns: { ...Vp, prefix: "fas" },
  faMarker: { ...Ip, prefix: "fas" },
  faMars: { ...Kp, prefix: "fas" },
  faMarsAndVenus: { ...Xp, prefix: "fas" },
  faMarsAndVenusBurst: { ...Qp, prefix: "fas" },
  faMarsDouble: { ...Jp, prefix: "fas" },
  faMarsStroke: { ...Yp, prefix: "fas" },
  faMarsStrokeH: { ...Zp, prefix: "fas" },
  faMarsStrokeRight: { ...pp, prefix: "fas" },
  faMarsStrokeUp: { ...xp, prefix: "fas" },
  faMarsStrokeV: { ...ix, prefix: "fas" },
  faMartiniGlass: { ...ax, prefix: "fas" },
  faMartiniGlassCitrus: { ...ex, prefix: "fas" },
  faMartiniGlassEmpty: { ...nx, prefix: "fas" },
  faMask: { ...fx, prefix: "fas" },
  faMaskFace: { ...cx, prefix: "fas" },
  faMaskVentilator: { ...tx, prefix: "fas" },
  faMasksTheater: { ...ox, prefix: "fas" },
  faMattressPillow: { ...lx, prefix: "fas" },
  faMaximize: { ...dx, prefix: "fas" },
  faMedal: { ...rx, prefix: "fas" },
  faMedkit: { ...sx, prefix: "fas" },
  faMeh: { ...hx, prefix: "fas" },
  faMehBlank: { ...vx, prefix: "fas" },
  faMehRollingEyes: { ...ux, prefix: "fas" },
  faMemory: { ...mx, prefix: "fas" },
  faMenorah: { ...gx, prefix: "fas" },
  faMercury: { ...Px, prefix: "fas" },
  faMessage: { ...Mx, prefix: "fas" },
  faMeteor: { ...wx, prefix: "fas" },
  faMicrochip: { ...Nx, prefix: "fas" },
  faMicrophone: { ...zx, prefix: "fas" },
  faMicrophoneAlt: { ...Lx, prefix: "fas" },
  faMicrophoneAltSlash: { ...Cx, prefix: "fas" },
  faMicrophoneLines: { ...Dx, prefix: "fas" },
  faMicrophoneLinesSlash: { ...$x, prefix: "fas" },
  faMicrophoneSlash: { ..._x, prefix: "fas" },
  faMicroscope: { ...bx, prefix: "fas" },
  faMillSign: { ...Sx, prefix: "fas" },
  faMinimize: { ...yx, prefix: "fas" },
  faMinus: { ...Ox, prefix: "fas" },
  faMinusCircle: { ...kx, prefix: "fas" },
  faMinusSquare: { ...Ax, prefix: "fas" },
  faMitten: { ...jx, prefix: "fas" },
  faMobile: { ...Bx, prefix: "fas" },
  faMobileAlt: { ...Tx, prefix: "fas" },
  faMobileAndroid: { ...Fx, prefix: "fas" },
  faMobileAndroidAlt: { ...Hx, prefix: "fas" },
  faMobileButton: { ...Rx, prefix: "fas" },
  faMobilePhone: { ...Ux, prefix: "fas" },
  faMobileRetro: { ...qx, prefix: "fas" },
  faMobileScreen: { ...Gx, prefix: "fas" },
  faMobileScreenButton: { ...Wx, prefix: "fas" },
  faMoneyBill: { ...Ex, prefix: "fas" },
  faMoneyBill1: { ...Vx, prefix: "fas" },
  faMoneyBill1Wave: { ...Ix, prefix: "fas" },
  faMoneyBillAlt: { ...Kx, prefix: "fas" },
  faMoneyBillTransfer: { ...Xx, prefix: "fas" },
  faMoneyBillTrendUp: { ...Qx, prefix: "fas" },
  faMoneyBillWave: { ...Jx, prefix: "fas" },
  faMoneyBillWaveAlt: { ...Yx, prefix: "fas" },
  faMoneyBillWheat: { ...Zx, prefix: "fas" },
  faMoneyBills: { ...px, prefix: "fas" },
  faMoneyCheck: { ...xx, prefix: "fas" },
  faMoneyCheckAlt: { ...iii, prefix: "fas" },
  faMoneyCheckDollar: { ...aii, prefix: "fas" },
  faMonument: { ...eii, prefix: "fas" },
  faMoon: { ...nii, prefix: "fas" },
  faMortarBoard: { ...fii, prefix: "fas" },
  faMortarPestle: { ...cii, prefix: "fas" },
  faMosque: { ...tii, prefix: "fas" },
  faMosquito: { ...oii, prefix: "fas" },
  faMosquitoNet: { ...lii, prefix: "fas" },
  faMotorcycle: { ...dii, prefix: "fas" },
  faMound: { ...rii, prefix: "fas" },
  faMountain: { ...sii, prefix: "fas" },
  faMountainCity: { ...hii, prefix: "fas" },
  faMountainSun: { ...vii, prefix: "fas" },
  faMouse: { ...uii, prefix: "fas" },
  faMousePointer: { ...mii, prefix: "fas" },
  faMugHot: { ...gii, prefix: "fas" },
  faMugSaucer: { ...Pii, prefix: "fas" },
  faMultiply: { ...Mii, prefix: "fas" },
  faMuseum: { ...wii, prefix: "fas" },
  faMusic: { ...Nii, prefix: "fas" },
  faN: { ...zii, prefix: "fas" },
  faNairaSign: { ...Lii, prefix: "fas" },
  faNavicon: { ...Cii, prefix: "fas" },
  faNetworkWired: { ...Dii, prefix: "fas" },
  faNeuter: { ...$ii, prefix: "fas" },
  faNewspaper: { ..._ii, prefix: "fas" },
  faNotEqual: { ...bii, prefix: "fas" },
  faNotdef: { ...Sii, prefix: "fas" },
  faNoteSticky: { ...yii, prefix: "fas" },
  faNotesMedical: { ...Oii, prefix: "fas" },
  faO: { ...kii, prefix: "fas" },
  faObjectGroup: { ...Aii, prefix: "fas" },
  faObjectUngroup: { ...jii, prefix: "fas" },
  faOilCan: { ...Bii, prefix: "fas" },
  faOilWell: { ...Tii, prefix: "fas" },
  faOm: { ...Fii, prefix: "fas" },
  faOtter: { ...Hii, prefix: "fas" },
  faOutdent: { ...Rii, prefix: "fas" },
  faP: { ...Uii, prefix: "fas" },
  faPager: { ...qii, prefix: "fas" },
  faPaintRoller: { ...Gii, prefix: "fas" },
  faPaintbrush: { ...Wii, prefix: "fas" },
  faPalette: { ...Eii, prefix: "fas" },
  faPallet: { ...Vii, prefix: "fas" },
  faPanorama: { ...Iii, prefix: "fas" },
  faPaperPlane: { ...Kii, prefix: "fas" },
  faPaperclip: { ...Xii, prefix: "fas" },
  faParachuteBox: { ...Qii, prefix: "fas" },
  faParagraph: { ...Jii, prefix: "fas" },
  faParking: { ...Yii, prefix: "fas" },
  faPassport: { ...Zii, prefix: "fas" },
  faPastafarianism: { ...pii, prefix: "fas" },
  faPaste: { ...xii, prefix: "fas" },
  faPause: { ...i2i, prefix: "fas" },
  faPauseCircle: { ...a2i, prefix: "fas" },
  faPaw: { ...e2i, prefix: "fas" },
  faPeace: { ...n2i, prefix: "fas" },
  faPen: { ...f2i, prefix: "fas" },
  faPenAlt: { ...c2i, prefix: "fas" },
  faPenClip: { ...t2i, prefix: "fas" },
  faPenFancy: { ...o2i, prefix: "fas" },
  faPenNib: { ...l2i, prefix: "fas" },
  faPenRuler: { ...d2i, prefix: "fas" },
  faPenSquare: { ...r2i, prefix: "fas" },
  faPenToSquare: { ...s2i, prefix: "fas" },
  faPencil: { ...h2i, prefix: "fas" },
  faPencilAlt: { ...v2i, prefix: "fas" },
  faPencilRuler: { ...u2i, prefix: "fas" },
  faPencilSquare: { ...m2i, prefix: "fas" },
  faPeopleArrows: { ...g2i, prefix: "fas" },
  faPeopleArrowsLeftRight: { ...P2i, prefix: "fas" },
  faPeopleCarry: { ...M2i, prefix: "fas" },
  faPeopleCarryBox: { ...w2i, prefix: "fas" },
  faPeopleGroup: { ...N2i, prefix: "fas" },
  faPeopleLine: { ...z2i, prefix: "fas" },
  faPeoplePulling: { ...L2i, prefix: "fas" },
  faPeopleRobbery: { ...C2i, prefix: "fas" },
  faPeopleRoof: { ...D2i, prefix: "fas" },
  faPepperHot: { ...$2i, prefix: "fas" },
  faPercent: { ..._2i, prefix: "fas" },
  faPercentage: { ...b2i, prefix: "fas" },
  faPerson: { ...S2i, prefix: "fas" },
  faPersonArrowDownToLine: { ...y2i, prefix: "fas" },
  faPersonArrowUpFromLine: { ...O2i, prefix: "fas" },
  faPersonBiking: { ...k2i, prefix: "fas" },
  faPersonBooth: { ...A2i, prefix: "fas" },
  faPersonBreastfeeding: { ...j2i, prefix: "fas" },
  faPersonBurst: { ...B2i, prefix: "fas" },
  faPersonCane: { ...T2i, prefix: "fas" },
  faPersonChalkboard: { ...F2i, prefix: "fas" },
  faPersonCircleCheck: { ...H2i, prefix: "fas" },
  faPersonCircleExclamation: { ...R2i, prefix: "fas" },
  faPersonCircleMinus: { ...U2i, prefix: "fas" },
  faPersonCirclePlus: { ...q2i, prefix: "fas" },
  faPersonCircleQuestion: { ...G2i, prefix: "fas" },
  faPersonCircleXmark: { ...W2i, prefix: "fas" },
  faPersonDigging: { ...E2i, prefix: "fas" },
  faPersonDotsFromLine: { ...V2i, prefix: "fas" },
  faPersonDress: { ...I2i, prefix: "fas" },
  faPersonDressBurst: { ...K2i, prefix: "fas" },
  faPersonDrowning: { ...X2i, prefix: "fas" },
  faPersonFalling: { ...Q2i, prefix: "fas" },
  faPersonFallingBurst: { ...J2i, prefix: "fas" },
  faPersonHalfDress: { ...Y2i, prefix: "fas" },
  faPersonHarassing: { ...Z2i, prefix: "fas" },
  faPersonHiking: { ...p2i, prefix: "fas" },
  faPersonMilitaryPointing: { ...x2i, prefix: "fas" },
  faPersonMilitaryRifle: { ...i1i, prefix: "fas" },
  faPersonMilitaryToPerson: { ...a1i, prefix: "fas" },
  faPersonPraying: { ...e1i, prefix: "fas" },
  faPersonPregnant: { ...n1i, prefix: "fas" },
  faPersonRays: { ...f1i, prefix: "fas" },
  faPersonRifle: { ...c1i, prefix: "fas" },
  faPersonRunning: { ...t1i, prefix: "fas" },
  faPersonShelter: { ...o1i, prefix: "fas" },
  faPersonSkating: { ...l1i, prefix: "fas" },
  faPersonSkiing: { ...d1i, prefix: "fas" },
  faPersonSkiingNordic: { ...r1i, prefix: "fas" },
  faPersonSnowboarding: { ...s1i, prefix: "fas" },
  faPersonSwimming: { ...h1i, prefix: "fas" },
  faPersonThroughWindow: { ...v1i, prefix: "fas" },
  faPersonWalking: { ...u1i, prefix: "fas" },
  faPersonWalkingArrowLoopLeft: { ...m1i, prefix: "fas" },
  faPersonWalkingArrowRight: { ...g1i, prefix: "fas" },
  faPersonWalkingDashedLineArrowRight: { ...P1i, prefix: "fas" },
  faPersonWalkingLuggage: { ...M1i, prefix: "fas" },
  faPersonWalkingWithCane: { ...w1i, prefix: "fas" },
  faPesetaSign: { ...N1i, prefix: "fas" },
  faPesoSign: { ...z1i, prefix: "fas" },
  faPhone: { ...L1i, prefix: "fas" },
  faPhoneAlt: { ...C1i, prefix: "fas" },
  faPhoneFlip: { ...D1i, prefix: "fas" },
  faPhoneSlash: { ...$1i, prefix: "fas" },
  faPhoneSquare: { ..._1i, prefix: "fas" },
  faPhoneSquareAlt: { ...b1i, prefix: "fas" },
  faPhoneVolume: { ...S1i, prefix: "fas" },
  faPhotoFilm: { ...y1i, prefix: "fas" },
  faPhotoVideo: { ...O1i, prefix: "fas" },
  faPieChart: { ...k1i, prefix: "fas" },
  faPiggyBank: { ...A1i, prefix: "fas" },
  faPills: { ...j1i, prefix: "fas" },
  faPingPongPaddleBall: { ...B1i, prefix: "fas" },
  faPizzaSlice: { ...T1i, prefix: "fas" },
  faPlaceOfWorship: { ...F1i, prefix: "fas" },
  faPlane: { ...H1i, prefix: "fas" },
  faPlaneArrival: { ...R1i, prefix: "fas" },
  faPlaneCircleCheck: { ...U1i, prefix: "fas" },
  faPlaneCircleExclamation: { ...q1i, prefix: "fas" },
  faPlaneCircleXmark: { ...G1i, prefix: "fas" },
  faPlaneDeparture: { ...W1i, prefix: "fas" },
  faPlaneLock: { ...E1i, prefix: "fas" },
  faPlaneSlash: { ...V1i, prefix: "fas" },
  faPlaneUp: { ...I1i, prefix: "fas" },
  faPlantWilt: { ...K1i, prefix: "fas" },
  faPlateWheat: { ...X1i, prefix: "fas" },
  faPlay: { ...Q1i, prefix: "fas" },
  faPlayCircle: { ...J1i, prefix: "fas" },
  faPlug: { ...Y1i, prefix: "fas" },
  faPlugCircleBolt: { ...Z1i, prefix: "fas" },
  faPlugCircleCheck: { ...p1i, prefix: "fas" },
  faPlugCircleExclamation: { ...x1i, prefix: "fas" },
  faPlugCircleMinus: { ...iai, prefix: "fas" },
  faPlugCirclePlus: { ...aai, prefix: "fas" },
  faPlugCircleXmark: { ...eai, prefix: "fas" },
  faPlus: { ...nai, prefix: "fas" },
  faPlusCircle: { ...fai, prefix: "fas" },
  faPlusMinus: { ...cai, prefix: "fas" },
  faPlusSquare: { ...tai, prefix: "fas" },
  faPodcast: { ...oai, prefix: "fas" },
  faPoll: { ...lai, prefix: "fas" },
  faPollH: { ...dai, prefix: "fas" },
  faPoo: { ...rai, prefix: "fas" },
  faPooBolt: { ...sai, prefix: "fas" },
  faPooStorm: { ...hai, prefix: "fas" },
  faPoop: { ...vai, prefix: "fas" },
  faPortrait: { ...uai, prefix: "fas" },
  faPoundSign: { ...mai, prefix: "fas" },
  faPowerOff: { ...gai, prefix: "fas" },
  faPray: { ...Pai, prefix: "fas" },
  faPrayingHands: { ...Mai, prefix: "fas" },
  faPrescription: { ...wai, prefix: "fas" },
  faPrescriptionBottle: { ...Nai, prefix: "fas" },
  faPrescriptionBottleAlt: { ...zai, prefix: "fas" },
  faPrescriptionBottleMedical: { ...Lai, prefix: "fas" },
  faPrint: { ...Cai, prefix: "fas" },
  faProcedures: { ...Dai, prefix: "fas" },
  faProjectDiagram: { ...$ai, prefix: "fas" },
  faPumpMedical: { ..._ai, prefix: "fas" },
  faPumpSoap: { ...bai, prefix: "fas" },
  faPuzzlePiece: { ...Sai, prefix: "fas" },
  faQ: { ...yai, prefix: "fas" },
  faQrcode: { ...Oai, prefix: "fas" },
  faQuestion: { ...kai, prefix: "fas" },
  faQuestionCircle: { ...Aai, prefix: "fas" },
  faQuidditch: { ...jai, prefix: "fas" },
  faQuidditchBroomBall: { ...Bai, prefix: "fas" },
  faQuoteLeft: { ...Tai, prefix: "fas" },
  faQuoteLeftAlt: { ...Fai, prefix: "fas" },
  faQuoteRight: { ...Hai, prefix: "fas" },
  faQuoteRightAlt: { ...Rai, prefix: "fas" },
  faQuran: { ...Uai, prefix: "fas" },
  faR: { ...qai, prefix: "fas" },
  faRadiation: { ...Gai, prefix: "fas" },
  faRadiationAlt: { ...Wai, prefix: "fas" },
  faRadio: { ...Eai, prefix: "fas" },
  faRainbow: { ...Vai, prefix: "fas" },
  faRandom: { ...Iai, prefix: "fas" },
  faRankingStar: { ...Kai, prefix: "fas" },
  faReceipt: { ...Xai, prefix: "fas" },
  faRecordVinyl: { ...Qai, prefix: "fas" },
  faRectangleAd: { ...Jai, prefix: "fas" },
  faRectangleList: { ...Yai, prefix: "fas" },
  faRectangleTimes: { ...Zai, prefix: "fas" },
  faRectangleXmark: { ...pai, prefix: "fas" },
  faRecycle: { ...xai, prefix: "fas" },
  faRedo: { ...i4i, prefix: "fas" },
  faRedoAlt: { ...a4i, prefix: "fas" },
  faRefresh: { ...e4i, prefix: "fas" },
  faRegistered: { ...n4i, prefix: "fas" },
  faRemove: { ...f4i, prefix: "fas" },
  faRemoveFormat: { ...c4i, prefix: "fas" },
  faReorder: { ...t4i, prefix: "fas" },
  faRepeat: { ...o4i, prefix: "fas" },
  faReply: { ...l4i, prefix: "fas" },
  faReplyAll: { ...d4i, prefix: "fas" },
  faRepublican: { ...r4i, prefix: "fas" },
  faRestroom: { ...s4i, prefix: "fas" },
  faRetweet: { ...h4i, prefix: "fas" },
  faRibbon: { ...v4i, prefix: "fas" },
  faRightFromBracket: { ...u4i, prefix: "fas" },
  faRightLeft: { ...m4i, prefix: "fas" },
  faRightLong: { ...g4i, prefix: "fas" },
  faRightToBracket: { ...P4i, prefix: "fas" },
  faRing: { ...M4i, prefix: "fas" },
  faRmb: { ...w4i, prefix: "fas" },
  faRoad: { ...N4i, prefix: "fas" },
  faRoadBarrier: { ...z4i, prefix: "fas" },
  faRoadBridge: { ...L4i, prefix: "fas" },
  faRoadCircleCheck: { ...C4i, prefix: "fas" },
  faRoadCircleExclamation: { ...D4i, prefix: "fas" },
  faRoadCircleXmark: { ...$4i, prefix: "fas" },
  faRoadLock: { ..._4i, prefix: "fas" },
  faRoadSpikes: { ...b4i, prefix: "fas" },
  faRobot: { ...S4i, prefix: "fas" },
  faRocket: { ...y4i, prefix: "fas" },
  faRodAsclepius: { ...O4i, prefix: "fas" },
  faRodSnake: { ...k4i, prefix: "fas" },
  faRotate: { ...A4i, prefix: "fas" },
  faRotateBack: { ...j4i, prefix: "fas" },
  faRotateBackward: { ...B4i, prefix: "fas" },
  faRotateForward: { ...T4i, prefix: "fas" },
  faRotateLeft: { ...F4i, prefix: "fas" },
  faRotateRight: { ...H4i, prefix: "fas" },
  faRouble: { ...R4i, prefix: "fas" },
  faRoute: { ...U4i, prefix: "fas" },
  faRss: { ...q4i, prefix: "fas" },
  faRssSquare: { ...G4i, prefix: "fas" },
  faRub: { ...W4i, prefix: "fas" },
  faRuble: { ...E4i, prefix: "fas" },
  faRubleSign: { ...V4i, prefix: "fas" },
  faRug: { ...I4i, prefix: "fas" },
  faRuler: { ...K4i, prefix: "fas" },
  faRulerCombined: { ...X4i, prefix: "fas" },
  faRulerHorizontal: { ...Q4i, prefix: "fas" },
  faRulerVertical: { ...J4i, prefix: "fas" },
  faRunning: { ...Y4i, prefix: "fas" },
  faRupee: { ...Z4i, prefix: "fas" },
  faRupeeSign: { ...p4i, prefix: "fas" },
  faRupiahSign: { ...x4i, prefix: "fas" },
  faS: { ...i3i, prefix: "fas" },
  faSackDollar: { ...a3i, prefix: "fas" },
  faSackXmark: { ...e3i, prefix: "fas" },
  faSadCry: { ...n3i, prefix: "fas" },
  faSadTear: { ...f3i, prefix: "fas" },
  faSailboat: { ...c3i, prefix: "fas" },
  faSatellite: { ...t3i, prefix: "fas" },
  faSatelliteDish: { ...o3i, prefix: "fas" },
  faSave: { ...l3i, prefix: "fas" },
  faScaleBalanced: { ...d3i, prefix: "fas" },
  faScaleUnbalanced: { ...r3i, prefix: "fas" },
  faScaleUnbalancedFlip: { ...s3i, prefix: "fas" },
  faSchool: { ...h3i, prefix: "fas" },
  faSchoolCircleCheck: { ...v3i, prefix: "fas" },
  faSchoolCircleExclamation: { ...u3i, prefix: "fas" },
  faSchoolCircleXmark: { ...m3i, prefix: "fas" },
  faSchoolFlag: { ...g3i, prefix: "fas" },
  faSchoolLock: { ...P3i, prefix: "fas" },
  faScissors: { ...M3i, prefix: "fas" },
  faScrewdriver: { ...w3i, prefix: "fas" },
  faScrewdriverWrench: { ...N3i, prefix: "fas" },
  faScroll: { ...z3i, prefix: "fas" },
  faScrollTorah: { ...L3i, prefix: "fas" },
  faSdCard: { ...C3i, prefix: "fas" },
  faSearch: { ...D3i, prefix: "fas" },
  faSearchDollar: { ...$3i, prefix: "fas" },
  faSearchLocation: { ..._3i, prefix: "fas" },
  faSearchMinus: { ...b3i, prefix: "fas" },
  faSearchPlus: { ...S3i, prefix: "fas" },
  faSection: { ...y3i, prefix: "fas" },
  faSeedling: { ...O3i, prefix: "fas" },
  faServer: { ...k3i, prefix: "fas" },
  faShapes: { ...A3i, prefix: "fas" },
  faShare: { ...j3i, prefix: "fas" },
  faShareAlt: { ...B3i, prefix: "fas" },
  faShareAltSquare: { ...T3i, prefix: "fas" },
  faShareFromSquare: { ...F3i, prefix: "fas" },
  faShareNodes: { ...H3i, prefix: "fas" },
  faShareSquare: { ...R3i, prefix: "fas" },
  faSheetPlastic: { ...U3i, prefix: "fas" },
  faShekel: { ...q3i, prefix: "fas" },
  faShekelSign: { ...G3i, prefix: "fas" },
  faSheqel: { ...W3i, prefix: "fas" },
  faSheqelSign: { ...E3i, prefix: "fas" },
  faShield: { ...V3i, prefix: "fas" },
  faShieldAlt: { ...I3i, prefix: "fas" },
  faShieldBlank: { ...K3i, prefix: "fas" },
  faShieldCat: { ...X3i, prefix: "fas" },
  faShieldDog: { ...Q3i, prefix: "fas" },
  faShieldHalved: { ...J3i, prefix: "fas" },
  faShieldHeart: { ...Y3i, prefix: "fas" },
  faShieldVirus: { ...Z3i, prefix: "fas" },
  faShip: { ...p3i, prefix: "fas" },
  faShippingFast: { ...x3i, prefix: "fas" },
  faShirt: { ...i0i, prefix: "fas" },
  faShoePrints: { ...a0i, prefix: "fas" },
  faShop: { ...e0i, prefix: "fas" },
  faShopLock: { ...n0i, prefix: "fas" },
  faShopSlash: { ...f0i, prefix: "fas" },
  faShoppingBag: { ...c0i, prefix: "fas" },
  faShoppingBasket: { ...t0i, prefix: "fas" },
  faShoppingCart: { ...o0i, prefix: "fas" },
  faShower: { ...l0i, prefix: "fas" },
  faShrimp: { ...d0i, prefix: "fas" },
  faShuffle: { ...r0i, prefix: "fas" },
  faShuttleSpace: { ...s0i, prefix: "fas" },
  faShuttleVan: { ...h0i, prefix: "fas" },
  faSign: { ...v0i, prefix: "fas" },
  faSignHanging: { ...u0i, prefix: "fas" },
  faSignIn: { ...m0i, prefix: "fas" },
  faSignInAlt: { ...g0i, prefix: "fas" },
  faSignLanguage: { ...P0i, prefix: "fas" },
  faSignOut: { ...M0i, prefix: "fas" },
  faSignOutAlt: { ...w0i, prefix: "fas" },
  faSignal: { ...N0i, prefix: "fas" },
  faSignal5: { ...z0i, prefix: "fas" },
  faSignalPerfect: { ...L0i, prefix: "fas" },
  faSignature: { ...C0i, prefix: "fas" },
  faSigning: { ...D0i, prefix: "fas" },
  faSignsPost: { ...$0i, prefix: "fas" },
  faSimCard: { ..._0i, prefix: "fas" },
  faSink: { ...b0i, prefix: "fas" },
  faSitemap: { ...S0i, prefix: "fas" },
  faSkating: { ...y0i, prefix: "fas" },
  faSkiing: { ...O0i, prefix: "fas" },
  faSkiingNordic: { ...k0i, prefix: "fas" },
  faSkull: { ...A0i, prefix: "fas" },
  faSkullCrossbones: { ...j0i, prefix: "fas" },
  faSlash: { ...B0i, prefix: "fas" },
  faSleigh: { ...T0i, prefix: "fas" },
  faSliders: { ...F0i, prefix: "fas" },
  faSlidersH: { ...H0i, prefix: "fas" },
  faSmile: { ...R0i, prefix: "fas" },
  faSmileBeam: { ...U0i, prefix: "fas" },
  faSmileWink: { ...q0i, prefix: "fas" },
  faSmog: { ...G0i, prefix: "fas" },
  faSmoking: { ...W0i, prefix: "fas" },
  faSmokingBan: { ...E0i, prefix: "fas" },
  faSms: { ...V0i, prefix: "fas" },
  faSnowboarding: { ...I0i, prefix: "fas" },
  faSnowflake: { ...K0i, prefix: "fas" },
  faSnowman: { ...X0i, prefix: "fas" },
  faSnowplow: { ...Q0i, prefix: "fas" },
  faSoap: { ...J0i, prefix: "fas" },
  faSoccerBall: { ...Y0i, prefix: "fas" },
  faSocks: { ...Z0i, prefix: "fas" },
  faSolarPanel: { ...p0i, prefix: "fas" },
  faSort: { ...x0i, prefix: "fas" },
  faSortAlphaAsc: { ...iei, prefix: "fas" },
  faSortAlphaDesc: { ...aei, prefix: "fas" },
  faSortAlphaDown: { ...eei, prefix: "fas" },
  faSortAlphaDownAlt: { ...nei, prefix: "fas" },
  faSortAlphaUp: { ...fei, prefix: "fas" },
  faSortAlphaUpAlt: { ...cei, prefix: "fas" },
  faSortAmountAsc: { ...tei, prefix: "fas" },
  faSortAmountDesc: { ...oei, prefix: "fas" },
  faSortAmountDown: { ...lei, prefix: "fas" },
  faSortAmountDownAlt: { ...dei, prefix: "fas" },
  faSortAmountUp: { ...rei, prefix: "fas" },
  faSortAmountUpAlt: { ...sei, prefix: "fas" },
  faSortAsc: { ...hei, prefix: "fas" },
  faSortDesc: { ...vei, prefix: "fas" },
  faSortDown: { ...uei, prefix: "fas" },
  faSortNumericAsc: { ...mei, prefix: "fas" },
  faSortNumericDesc: { ...gei, prefix: "fas" },
  faSortNumericDown: { ...Pei, prefix: "fas" },
  faSortNumericDownAlt: { ...Mei, prefix: "fas" },
  faSortNumericUp: { ...wei, prefix: "fas" },
  faSortNumericUpAlt: { ...Nei, prefix: "fas" },
  faSortUp: { ...zei, prefix: "fas" },
  faSpa: { ...Lei, prefix: "fas" },
  faSpaceShuttle: { ...Cei, prefix: "fas" },
  faSpaghettiMonsterFlying: { ...Dei, prefix: "fas" },
  faSpellCheck: { ...$ei, prefix: "fas" },
  faSpider: { ..._ei, prefix: "fas" },
  faSpinner: { ...bei, prefix: "fas" },
  faSplotch: { ...Sei, prefix: "fas" },
  faSpoon: { ...yei, prefix: "fas" },
  faSprayCan: { ...Oei, prefix: "fas" },
  faSprayCanSparkles: { ...kei, prefix: "fas" },
  faSprout: { ...Aei, prefix: "fas" },
  faSquare: { ...jei, prefix: "fas" },
  faSquareArrowUpRight: { ...Bei, prefix: "fas" },
  faSquareCaretDown: { ...Tei, prefix: "fas" },
  faSquareCaretLeft: { ...Fei, prefix: "fas" },
  faSquareCaretRight: { ...Hei, prefix: "fas" },
  faSquareCaretUp: { ...Rei, prefix: "fas" },
  faSquareCheck: { ...Uei, prefix: "fas" },
  faSquareEnvelope: { ...qei, prefix: "fas" },
  faSquareFull: { ...Gei, prefix: "fas" },
  faSquareH: { ...Wei, prefix: "fas" },
  faSquareMinus: { ...Eei, prefix: "fas" },
  faSquareNfi: { ...Vei, prefix: "fas" },
  faSquareParking: { ...Iei, prefix: "fas" },
  faSquarePen: { ...Kei, prefix: "fas" },
  faSquarePersonConfined: { ...Xei, prefix: "fas" },
  faSquarePhone: { ...Qei, prefix: "fas" },
  faSquarePhoneFlip: { ...Jei, prefix: "fas" },
  faSquarePlus: { ...Yei, prefix: "fas" },
  faSquarePollHorizontal: { ...Zei, prefix: "fas" },
  faSquarePollVertical: { ...pei, prefix: "fas" },
  faSquareRootAlt: { ...xei, prefix: "fas" },
  faSquareRootVariable: { ...ini, prefix: "fas" },
  faSquareRss: { ...ani, prefix: "fas" },
  faSquareShareNodes: { ...eni, prefix: "fas" },
  faSquareUpRight: { ...nni, prefix: "fas" },
  faSquareVirus: { ...fni, prefix: "fas" },
  faSquareXmark: { ...cni, prefix: "fas" },
  faStaffAesculapius: { ...tni, prefix: "fas" },
  faStaffSnake: { ...oni, prefix: "fas" },
  faStairs: { ...lni, prefix: "fas" },
  faStamp: { ...dni, prefix: "fas" },
  faStapler: { ...rni, prefix: "fas" },
  faStar: { ...sni, prefix: "fas" },
  faStarAndCrescent: { ...hni, prefix: "fas" },
  faStarHalf: { ...vni, prefix: "fas" },
  faStarHalfAlt: { ...uni, prefix: "fas" },
  faStarHalfStroke: { ...mni, prefix: "fas" },
  faStarOfDavid: { ...gni, prefix: "fas" },
  faStarOfLife: { ...Pni, prefix: "fas" },
  faStepBackward: { ...Mni, prefix: "fas" },
  faStepForward: { ...wni, prefix: "fas" },
  faSterlingSign: { ...Nni, prefix: "fas" },
  faStethoscope: { ...zni, prefix: "fas" },
  faStickyNote: { ...Lni, prefix: "fas" },
  faStop: { ...Cni, prefix: "fas" },
  faStopCircle: { ...Dni, prefix: "fas" },
  faStopwatch: { ...$ni, prefix: "fas" },
  faStopwatch20: { ..._ni, prefix: "fas" },
  faStore: { ...bni, prefix: "fas" },
  faStoreAlt: { ...Sni, prefix: "fas" },
  faStoreAltSlash: { ...yni, prefix: "fas" },
  faStoreSlash: { ...Oni, prefix: "fas" },
  faStream: { ...kni, prefix: "fas" },
  faStreetView: { ...Ani, prefix: "fas" },
  faStrikethrough: { ...jni, prefix: "fas" },
  faStroopwafel: { ...Bni, prefix: "fas" },
  faSubscript: { ...Tni, prefix: "fas" },
  faSubtract: { ...Fni, prefix: "fas" },
  faSubway: { ...Hni, prefix: "fas" },
  faSuitcase: { ...Rni, prefix: "fas" },
  faSuitcaseMedical: { ...Uni, prefix: "fas" },
  faSuitcaseRolling: { ...qni, prefix: "fas" },
  faSun: { ...Gni, prefix: "fas" },
  faSunPlantWilt: { ...Wni, prefix: "fas" },
  faSuperscript: { ...Eni, prefix: "fas" },
  faSurprise: { ...Vni, prefix: "fas" },
  faSwatchbook: { ...Ini, prefix: "fas" },
  faSwimmer: { ...Kni, prefix: "fas" },
  faSwimmingPool: { ...Xni, prefix: "fas" },
  faSynagogue: { ...Qni, prefix: "fas" },
  faSync: { ...Jni, prefix: "fas" },
  faSyncAlt: { ...Yni, prefix: "fas" },
  faSyringe: { ...Zni, prefix: "fas" },
  faT: { ...pni, prefix: "fas" },
  faTShirt: { ...xni, prefix: "fas" },
  faTable: { ...i6i, prefix: "fas" },
  faTableCells: { ...a6i, prefix: "fas" },
  faTableCellsColumnLock: { ...e6i, prefix: "fas" },
  faTableCellsLarge: { ...n6i, prefix: "fas" },
  faTableCellsRowLock: { ...f6i, prefix: "fas" },
  faTableCellsRowUnlock: { ...c6i, prefix: "fas" },
  faTableColumns: { ...t6i, prefix: "fas" },
  faTableList: { ...o6i, prefix: "fas" },
  faTableTennis: { ...l6i, prefix: "fas" },
  faTableTennisPaddleBall: { ...d6i, prefix: "fas" },
  faTablet: { ...r6i, prefix: "fas" },
  faTabletAlt: { ...s6i, prefix: "fas" },
  faTabletAndroid: { ...h6i, prefix: "fas" },
  faTabletButton: { ...v6i, prefix: "fas" },
  faTabletScreenButton: { ...u6i, prefix: "fas" },
  faTablets: { ...m6i, prefix: "fas" },
  faTachographDigital: { ...g6i, prefix: "fas" },
  faTachometer: { ...P6i, prefix: "fas" },
  faTachometerAlt: { ...M6i, prefix: "fas" },
  faTachometerAltAverage: { ...w6i, prefix: "fas" },
  faTachometerAltFast: { ...N6i, prefix: "fas" },
  faTachometerAverage: { ...z6i, prefix: "fas" },
  faTachometerFast: { ...L6i, prefix: "fas" },
  faTag: { ...C6i, prefix: "fas" },
  faTags: { ...D6i, prefix: "fas" },
  faTanakh: { ...$6i, prefix: "fas" },
  faTape: { ..._6i, prefix: "fas" },
  faTarp: { ...b6i, prefix: "fas" },
  faTarpDroplet: { ...S6i, prefix: "fas" },
  faTasks: { ...y6i, prefix: "fas" },
  faTasksAlt: { ...O6i, prefix: "fas" },
  faTaxi: { ...k6i, prefix: "fas" },
  faTeeth: { ...A6i, prefix: "fas" },
  faTeethOpen: { ...j6i, prefix: "fas" },
  faTeletype: { ...B6i, prefix: "fas" },
  faTelevision: { ...T6i, prefix: "fas" },
  faTemperature0: { ...F6i, prefix: "fas" },
  faTemperature1: { ...H6i, prefix: "fas" },
  faTemperature2: { ...R6i, prefix: "fas" },
  faTemperature3: { ...U6i, prefix: "fas" },
  faTemperature4: { ...q6i, prefix: "fas" },
  faTemperatureArrowDown: { ...G6i, prefix: "fas" },
  faTemperatureArrowUp: { ...W6i, prefix: "fas" },
  faTemperatureDown: { ...E6i, prefix: "fas" },
  faTemperatureEmpty: { ...V6i, prefix: "fas" },
  faTemperatureFull: { ...I6i, prefix: "fas" },
  faTemperatureHalf: { ...K6i, prefix: "fas" },
  faTemperatureHigh: { ...X6i, prefix: "fas" },
  faTemperatureLow: { ...Q6i, prefix: "fas" },
  faTemperatureQuarter: { ...J6i, prefix: "fas" },
  faTemperatureThreeQuarters: { ...Y6i, prefix: "fas" },
  faTemperatureUp: { ...Z6i, prefix: "fas" },
  faTenge: { ...p6i, prefix: "fas" },
  faTengeSign: { ...x6i, prefix: "fas" },
  faTent: { ...ifi, prefix: "fas" },
  faTentArrowDownToLine: { ...afi, prefix: "fas" },
  faTentArrowLeftRight: { ...efi, prefix: "fas" },
  faTentArrowTurnLeft: { ...nfi, prefix: "fas" },
  faTentArrowsDown: { ...ffi, prefix: "fas" },
  faTents: { ...cfi, prefix: "fas" },
  faTerminal: { ...tfi, prefix: "fas" },
  faTextHeight: { ...ofi, prefix: "fas" },
  faTextSlash: { ...lfi, prefix: "fas" },
  faTextWidth: { ...dfi, prefix: "fas" },
  faTh: { ...rfi, prefix: "fas" },
  faThLarge: { ...sfi, prefix: "fas" },
  faThList: { ...hfi, prefix: "fas" },
  faTheaterMasks: { ...vfi, prefix: "fas" },
  faThermometer: { ...ufi, prefix: "fas" },
  faThermometer0: { ...mfi, prefix: "fas" },
  faThermometer1: { ...gfi, prefix: "fas" },
  faThermometer2: { ...Pfi, prefix: "fas" },
  faThermometer3: { ...Mfi, prefix: "fas" },
  faThermometer4: { ...wfi, prefix: "fas" },
  faThermometerEmpty: { ...Nfi, prefix: "fas" },
  faThermometerFull: { ...zfi, prefix: "fas" },
  faThermometerHalf: { ...Lfi, prefix: "fas" },
  faThermometerQuarter: { ...Cfi, prefix: "fas" },
  faThermometerThreeQuarters: { ...Dfi, prefix: "fas" },
  faThumbsDown: { ...$fi, prefix: "fas" },
  faThumbsUp: { ..._fi, prefix: "fas" },
  faThumbtack: { ...bfi, prefix: "fas" },
  faThumbtackSlash: { ...Sfi, prefix: "fas" },
  faThunderstorm: { ...yfi, prefix: "fas" },
  faTicket: { ...Ofi, prefix: "fas" },
  faTicketAlt: { ...kfi, prefix: "fas" },
  faTicketSimple: { ...Afi, prefix: "fas" },
  faTimeline: { ...jfi, prefix: "fas" },
  faTimes: { ...Bfi, prefix: "fas" },
  faTimesCircle: { ...Tfi, prefix: "fas" },
  faTimesRectangle: { ...Ffi, prefix: "fas" },
  faTimesSquare: { ...Hfi, prefix: "fas" },
  faTint: { ...Rfi, prefix: "fas" },
  faTintSlash: { ...Ufi, prefix: "fas" },
  faTired: { ...qfi, prefix: "fas" },
  faToggleOff: { ...Gfi, prefix: "fas" },
  faToggleOn: { ...Wfi, prefix: "fas" },
  faToilet: { ...Efi, prefix: "fas" },
  faToiletPaper: { ...Vfi, prefix: "fas" },
  faToiletPaperSlash: { ...Ifi, prefix: "fas" },
  faToiletPortable: { ...Kfi, prefix: "fas" },
  faToiletsPortable: { ...Xfi, prefix: "fas" },
  faToolbox: { ...Qfi, prefix: "fas" },
  faTools: { ...Jfi, prefix: "fas" },
  faTooth: { ...Yfi, prefix: "fas" },
  faTorah: { ...Zfi, prefix: "fas" },
  faToriiGate: { ...pfi, prefix: "fas" },
  faTornado: { ...xfi, prefix: "fas" },
  faTowerBroadcast: { ...ici, prefix: "fas" },
  faTowerCell: { ...aci, prefix: "fas" },
  faTowerObservation: { ...eci, prefix: "fas" },
  faTractor: { ...nci, prefix: "fas" },
  faTrademark: { ...fci, prefix: "fas" },
  faTrafficLight: { ...cci, prefix: "fas" },
  faTrailer: { ...tci, prefix: "fas" },
  faTrain: { ...oci, prefix: "fas" },
  faTrainSubway: { ...lci, prefix: "fas" },
  faTrainTram: { ...dci, prefix: "fas" },
  faTram: { ...rci, prefix: "fas" },
  faTransgender: { ...sci, prefix: "fas" },
  faTransgenderAlt: { ...hci, prefix: "fas" },
  faTrash: { ...vci, prefix: "fas" },
  faTrashAlt: { ...uci, prefix: "fas" },
  faTrashArrowUp: { ...mci, prefix: "fas" },
  faTrashCan: { ...gci, prefix: "fas" },
  faTrashCanArrowUp: { ...Pci, prefix: "fas" },
  faTrashRestore: { ...Mci, prefix: "fas" },
  faTrashRestoreAlt: { ...wci, prefix: "fas" },
  faTree: { ...Nci, prefix: "fas" },
  faTreeCity: { ...zci, prefix: "fas" },
  faTriangleCircleSquare: { ...Lci, prefix: "fas" },
  faTriangleExclamation: { ...Cci, prefix: "fas" },
  faTrophy: { ...Dci, prefix: "fas" },
  faTrowel: { ...$ci, prefix: "fas" },
  faTrowelBricks: { ..._ci, prefix: "fas" },
  faTruck: { ...bci, prefix: "fas" },
  faTruckArrowRight: { ...Sci, prefix: "fas" },
  faTruckDroplet: { ...yci, prefix: "fas" },
  faTruckFast: { ...Oci, prefix: "fas" },
  faTruckField: { ...kci, prefix: "fas" },
  faTruckFieldUn: { ...Aci, prefix: "fas" },
  faTruckFront: { ...jci, prefix: "fas" },
  faTruckLoading: { ...Bci, prefix: "fas" },
  faTruckMedical: { ...Tci, prefix: "fas" },
  faTruckMonster: { ...Fci, prefix: "fas" },
  faTruckMoving: { ...Hci, prefix: "fas" },
  faTruckPickup: { ...Rci, prefix: "fas" },
  faTruckPlane: { ...Uci, prefix: "fas" },
  faTruckRampBox: { ...qci, prefix: "fas" },
  faTry: { ...Gci, prefix: "fas" },
  faTty: { ...Wci, prefix: "fas" },
  faTurkishLira: { ...Eci, prefix: "fas" },
  faTurkishLiraSign: { ...Vci, prefix: "fas" },
  faTurnDown: { ...Ici, prefix: "fas" },
  faTurnUp: { ...Kci, prefix: "fas" },
  faTv: { ...Xci, prefix: "fas" },
  faTvAlt: { ...Qci, prefix: "fas" },
  faU: { ...Jci, prefix: "fas" },
  faUmbrella: { ...Yci, prefix: "fas" },
  faUmbrellaBeach: { ...Zci, prefix: "fas" },
  faUnderline: { ...pci, prefix: "fas" },
  faUndo: { ...xci, prefix: "fas" },
  faUndoAlt: { ...i8i, prefix: "fas" },
  faUniversalAccess: { ...a8i, prefix: "fas" },
  faUniversity: { ...e8i, prefix: "fas" },
  faUnlink: { ...n8i, prefix: "fas" },
  faUnlock: { ...f8i, prefix: "fas" },
  faUnlockAlt: { ...c8i, prefix: "fas" },
  faUnlockKeyhole: { ...t8i, prefix: "fas" },
  faUnsorted: { ...o8i, prefix: "fas" },
  faUpDown: { ...l8i, prefix: "fas" },
  faUpDownLeftRight: { ...d8i, prefix: "fas" },
  faUpLong: { ...r8i, prefix: "fas" },
  faUpRightAndDownLeftFromCenter: { ...s8i, prefix: "fas" },
  faUpRightFromSquare: { ...h8i, prefix: "fas" },
  faUpload: { ...v8i, prefix: "fas" },
  faUsd: { ...u8i, prefix: "fas" },
  faUser: { ...m8i, prefix: "fas" },
  faUserAlt: { ...g8i, prefix: "fas" },
  faUserAltSlash: { ...P8i, prefix: "fas" },
  faUserAstronaut: { ...M8i, prefix: "fas" },
  faUserCheck: { ...w8i, prefix: "fas" },
  faUserCircle: { ...N8i, prefix: "fas" },
  faUserClock: { ...z8i, prefix: "fas" },
  faUserCog: { ...L8i, prefix: "fas" },
  faUserDoctor: { ...C8i, prefix: "fas" },
  faUserEdit: { ...D8i, prefix: "fas" },
  faUserFriends: { ...$8i, prefix: "fas" },
  faUserGear: { ..._8i, prefix: "fas" },
  faUserGraduate: { ...b8i, prefix: "fas" },
  faUserGroup: { ...S8i, prefix: "fas" },
  faUserInjured: { ...y8i, prefix: "fas" },
  faUserLarge: { ...O8i, prefix: "fas" },
  faUserLargeSlash: { ...k8i, prefix: "fas" },
  faUserLock: { ...A8i, prefix: "fas" },
  faUserMd: { ...j8i, prefix: "fas" },
  faUserMinus: { ...B8i, prefix: "fas" },
  faUserNinja: { ...T8i, prefix: "fas" },
  faUserNurse: { ...F8i, prefix: "fas" },
  faUserPen: { ...H8i, prefix: "fas" },
  faUserPlus: { ...R8i, prefix: "fas" },
  faUserSecret: { ...U8i, prefix: "fas" },
  faUserShield: { ...q8i, prefix: "fas" },
  faUserSlash: { ...G8i, prefix: "fas" },
  faUserTag: { ...W8i, prefix: "fas" },
  faUserTie: { ...E8i, prefix: "fas" },
  faUserTimes: { ...V8i, prefix: "fas" },
  faUserXmark: { ...I8i, prefix: "fas" },
  faUsers: { ...K8i, prefix: "fas" },
  faUsersBetweenLines: { ...X8i, prefix: "fas" },
  faUsersCog: { ...Q8i, prefix: "fas" },
  faUsersGear: { ...J8i, prefix: "fas" },
  faUsersLine: { ...Y8i, prefix: "fas" },
  faUsersRays: { ...Z8i, prefix: "fas" },
  faUsersRectangle: { ...p8i, prefix: "fas" },
  faUsersSlash: { ...x8i, prefix: "fas" },
  faUsersViewfinder: { ...i5i, prefix: "fas" },
  faUtensilSpoon: { ...a5i, prefix: "fas" },
  faUtensils: { ...e5i, prefix: "fas" },
  faV: { ...n5i, prefix: "fas" },
  faVanShuttle: { ...f5i, prefix: "fas" },
  faVault: { ...c5i, prefix: "fas" },
  faVcard: { ...t5i, prefix: "fas" },
  faVectorSquare: { ...o5i, prefix: "fas" },
  faVenus: { ...l5i, prefix: "fas" },
  faVenusDouble: { ...d5i, prefix: "fas" },
  faVenusMars: { ...r5i, prefix: "fas" },
  faVest: { ...s5i, prefix: "fas" },
  faVestPatches: { ...h5i, prefix: "fas" },
  faVial: { ...v5i, prefix: "fas" },
  faVialCircleCheck: { ...u5i, prefix: "fas" },
  faVialVirus: { ...m5i, prefix: "fas" },
  faVials: { ...g5i, prefix: "fas" },
  faVideo: { ...P5i, prefix: "fas" },
  faVideoCamera: { ...M5i, prefix: "fas" },
  faVideoSlash: { ...w5i, prefix: "fas" },
  faVihara: { ...N5i, prefix: "fas" },
  faVirus: { ...z5i, prefix: "fas" },
  faVirusCovid: { ...L5i, prefix: "fas" },
  faVirusCovidSlash: { ...C5i, prefix: "fas" },
  faVirusSlash: { ...D5i, prefix: "fas" },
  faViruses: { ...$5i, prefix: "fas" },
  faVoicemail: { ..._5i, prefix: "fas" },
  faVolcano: { ...b5i, prefix: "fas" },
  faVolleyball: { ...S5i, prefix: "fas" },
  faVolleyballBall: { ...y5i, prefix: "fas" },
  faVolumeControlPhone: { ...O5i, prefix: "fas" },
  faVolumeDown: { ...k5i, prefix: "fas" },
  faVolumeHigh: { ...A5i, prefix: "fas" },
  faVolumeLow: { ...j5i, prefix: "fas" },
  faVolumeMute: { ...B5i, prefix: "fas" },
  faVolumeOff: { ...T5i, prefix: "fas" },
  faVolumeTimes: { ...F5i, prefix: "fas" },
  faVolumeUp: { ...H5i, prefix: "fas" },
  faVolumeXmark: { ...R5i, prefix: "fas" },
  faVoteYea: { ...U5i, prefix: "fas" },
  faVrCardboard: { ...q5i, prefix: "fas" },
  faW: { ...G5i, prefix: "fas" },
  faWalkieTalkie: { ...W5i, prefix: "fas" },
  faWalking: { ...E5i, prefix: "fas" },
  faWallet: { ...V5i, prefix: "fas" },
  faWandMagic: { ...I5i, prefix: "fas" },
  faWandMagicSparkles: { ...K5i, prefix: "fas" },
  faWandSparkles: { ...X5i, prefix: "fas" },
  faWarehouse: { ...Q5i, prefix: "fas" },
  faWarning: { ...J5i, prefix: "fas" },
  faWater: { ...Y5i, prefix: "fas" },
  faWaterLadder: { ...Z5i, prefix: "fas" },
  faWaveSquare: { ...p5i, prefix: "fas" },
  faWebAwesome: { ...x5i, prefix: "fas" },
  faWeight: { ...i7i, prefix: "fas" },
  faWeightHanging: { ...a7i, prefix: "fas" },
  faWeightScale: { ...e7i, prefix: "fas" },
  faWheatAlt: { ...n7i, prefix: "fas" },
  faWheatAwn: { ...f7i, prefix: "fas" },
  faWheatAwnCircleExclamation: { ...c7i, prefix: "fas" },
  faWheelchair: { ...t7i, prefix: "fas" },
  faWheelchairAlt: { ...o7i, prefix: "fas" },
  faWheelchairMove: { ...l7i, prefix: "fas" },
  faWhiskeyGlass: { ...d7i, prefix: "fas" },
  faWifi: { ...r7i, prefix: "fas" },
  faWifi3: { ...s7i, prefix: "fas" },
  faWifiStrong: { ...h7i, prefix: "fas" },
  faWind: { ...v7i, prefix: "fas" },
  faWindowClose: { ...u7i, prefix: "fas" },
  faWindowMaximize: { ...m7i, prefix: "fas" },
  faWindowMinimize: { ...g7i, prefix: "fas" },
  faWindowRestore: { ...P7i, prefix: "fas" },
  faWineBottle: { ...M7i, prefix: "fas" },
  faWineGlass: { ...w7i, prefix: "fas" },
  faWineGlassAlt: { ...N7i, prefix: "fas" },
  faWineGlassEmpty: { ...z7i, prefix: "fas" },
  faWon: { ...L7i, prefix: "fas" },
  faWonSign: { ...C7i, prefix: "fas" },
  faWorm: { ...D7i, prefix: "fas" },
  faWrench: { ...$7i, prefix: "fas" },
  faX: { ..._7i, prefix: "fas" },
  faXRay: { ...b7i, prefix: "fas" },
  faXmark: { ...S7i, prefix: "fas" },
  faXmarkCircle: { ...y7i, prefix: "fas" },
  faXmarkSquare: { ...O7i, prefix: "fas" },
  faXmarksLines: { ...k7i, prefix: "fas" },
  faY: { ...A7i, prefix: "fas" },
  faYen: { ...j7i, prefix: "fas" },
  faYenSign: { ...B7i, prefix: "fas" },
  faYinYang: { ...T7i, prefix: "fas" },
  faZ: { ...F7i, prefix: "fas" },
  faZap: { ...H7i, prefix: "fas" },
  fa42Group: { ...R7i, prefix: "fas" },
  fa500px: { ...U7i, prefix: "fas" },
  faAccessibleIcon: { ...q7i, prefix: "fas" },
  faAccusoft: { ...G7i, prefix: "fas" },
  faAdn: { ...W7i, prefix: "fas" },
  faAdversal: { ...E7i, prefix: "fas" },
  faAffiliatetheme: { ...V7i, prefix: "fas" },
  faAirbnb: { ...I7i, prefix: "fas" },
  faAlgolia: { ...K7i, prefix: "fas" },
  faAlipay: { ...X7i, prefix: "fas" },
  faAmazon: { ...Q7i, prefix: "fas" },
  faAmazonPay: { ...J7i, prefix: "fas" },
  faAmilia: { ...Y7i, prefix: "fas" },
  faAndroid: { ...Z7i, prefix: "fas" },
  faAngellist: { ...p7i, prefix: "fas" },
  faAngrycreative: { ...x7i, prefix: "fas" },
  faAngular: { ...iti, prefix: "fas" },
  faAppStore: { ...ati, prefix: "fas" },
  faAppStoreIos: { ...eti, prefix: "fas" },
  faApper: { ...nti, prefix: "fas" },
  faApple: { ...fti, prefix: "fas" },
  faApplePay: { ...cti, prefix: "fas" },
  faArtstation: { ...tti, prefix: "fas" },
  faAsymmetrik: { ...oti, prefix: "fas" },
  faAtlassian: { ...lti, prefix: "fas" },
  faAudible: { ...dti, prefix: "fas" },
  faAutoprefixer: { ...rti, prefix: "fas" },
  faAvianex: { ...sti, prefix: "fas" },
  faAviato: { ...hti, prefix: "fas" },
  faAws: { ...vti, prefix: "fas" },
  faBandcamp: { ...uti, prefix: "fas" },
  faBattleNet: { ...mti, prefix: "fas" },
  faBehance: { ...gti, prefix: "fas" },
  faBehanceSquare: { ...Pti, prefix: "fas" },
  faBilibili: { ...Mti, prefix: "fas" },
  faBimobject: { ...wti, prefix: "fas" },
  faBitbucket: { ...Nti, prefix: "fas" },
  faBitcoin: { ...zti, prefix: "fas" },
  faBity: { ...Lti, prefix: "fas" },
  faBlackTie: { ...Cti, prefix: "fas" },
  faBlackberry: { ...Dti, prefix: "fas" },
  faBlogger: { ...$ti, prefix: "fas" },
  faBloggerB: { ..._ti, prefix: "fas" },
  faBluesky: { ...bti, prefix: "fas" },
  faBluetooth: { ...Sti, prefix: "fas" },
  faBluetoothB: { ...yti, prefix: "fas" },
  faBootstrap: { ...Oti, prefix: "fas" },
  faBots: { ...kti, prefix: "fas" },
  faBrave: { ...Ati, prefix: "fas" },
  faBraveReverse: { ...jti, prefix: "fas" },
  faBtc: { ...Bti, prefix: "fas" },
  faBuffer: { ...Tti, prefix: "fas" },
  faBuromobelexperte: { ...Fti, prefix: "fas" },
  faBuyNLarge: { ...Hti, prefix: "fas" },
  faBuysellads: { ...Rti, prefix: "fas" },
  faCanadianMapleLeaf: { ...Uti, prefix: "fas" },
  faCcAmazonPay: { ...qti, prefix: "fas" },
  faCcAmex: { ...Gti, prefix: "fas" },
  faCcApplePay: { ...Wti, prefix: "fas" },
  faCcDinersClub: { ...Eti, prefix: "fas" },
  faCcDiscover: { ...Vti, prefix: "fas" },
  faCcJcb: { ...Iti, prefix: "fas" },
  faCcMastercard: { ...Kti, prefix: "fas" },
  faCcPaypal: { ...Xti, prefix: "fas" },
  faCcStripe: { ...Qti, prefix: "fas" },
  faCcVisa: { ...Jti, prefix: "fas" },
  faCentercode: { ...Yti, prefix: "fas" },
  faCentos: { ...Zti, prefix: "fas" },
  faChrome: { ...pti, prefix: "fas" },
  faChromecast: { ...xti, prefix: "fas" },
  faCloudflare: { ...ioi, prefix: "fas" },
  faCloudscale: { ...aoi, prefix: "fas" },
  faCloudsmith: { ...eoi, prefix: "fas" },
  faCloudversify: { ...noi, prefix: "fas" },
  faCmplid: { ...foi, prefix: "fas" },
  faCodepen: { ...coi, prefix: "fas" },
  faCodiepie: { ...toi, prefix: "fas" },
  faConfluence: { ...ooi, prefix: "fas" },
  faConnectdevelop: { ...loi, prefix: "fas" },
  faContao: { ...doi, prefix: "fas" },
  faCottonBureau: { ...roi, prefix: "fas" },
  faCpanel: { ...soi, prefix: "fas" },
  faCreativeCommons: { ...hoi, prefix: "fas" },
  faCreativeCommonsBy: { ...voi, prefix: "fas" },
  faCreativeCommonsNc: { ...uoi, prefix: "fas" },
  faCreativeCommonsNcEu: { ...moi, prefix: "fas" },
  faCreativeCommonsNcJp: { ...goi, prefix: "fas" },
  faCreativeCommonsNd: { ...Poi, prefix: "fas" },
  faCreativeCommonsPd: { ...Moi, prefix: "fas" },
  faCreativeCommonsPdAlt: { ...woi, prefix: "fas" },
  faCreativeCommonsRemix: { ...Noi, prefix: "fas" },
  faCreativeCommonsSa: { ...zoi, prefix: "fas" },
  faCreativeCommonsSampling: { ...Loi, prefix: "fas" },
  faCreativeCommonsSamplingPlus: { ...Coi, prefix: "fas" },
  faCreativeCommonsShare: { ...Doi, prefix: "fas" },
  faCreativeCommonsZero: { ...$oi, prefix: "fas" },
  faCriticalRole: { ..._oi, prefix: "fas" },
  faCss3: { ...boi, prefix: "fas" },
  faCss3Alt: { ...Soi, prefix: "fas" },
  faCuttlefish: { ...yoi, prefix: "fas" },
  faDAndD: { ...Ooi, prefix: "fas" },
  faDAndDBeyond: { ...koi, prefix: "fas" },
  faDailymotion: { ...Aoi, prefix: "fas" },
  faDartLang: { ...joi, prefix: "fas" },
  faDashcube: { ...Boi, prefix: "fas" },
  faDebian: { ...Toi, prefix: "fas" },
  faDeezer: { ...Foi, prefix: "fas" },
  faDelicious: { ...Hoi, prefix: "fas" },
  faDeploydog: { ...Roi, prefix: "fas" },
  faDeskpro: { ...Uoi, prefix: "fas" },
  faDev: { ...qoi, prefix: "fas" },
  faDeviantart: { ...Goi, prefix: "fas" },
  faDhl: { ...Woi, prefix: "fas" },
  faDiaspora: { ...Eoi, prefix: "fas" },
  faDigg: { ...Voi, prefix: "fas" },
  faDigitalOcean: { ...Ioi, prefix: "fas" },
  faDiscord: { ...Koi, prefix: "fas" },
  faDiscourse: { ...Xoi, prefix: "fas" },
  faDochub: { ...Qoi, prefix: "fas" },
  faDocker: { ...Joi, prefix: "fas" },
  faDraft2digital: { ...Yoi, prefix: "fas" },
  faDribbble: { ...Zoi, prefix: "fas" },
  faDribbbleSquare: { ...poi, prefix: "fas" },
  faDropbox: { ...xoi, prefix: "fas" },
  faDrupal: { ...ili, prefix: "fas" },
  faDyalog: { ...ali, prefix: "fas" },
  faEarlybirds: { ...eli, prefix: "fas" },
  faEbay: { ...nli, prefix: "fas" },
  faEdge: { ...fli, prefix: "fas" },
  faEdgeLegacy: { ...cli, prefix: "fas" },
  faElementor: { ...tli, prefix: "fas" },
  faEllo: { ...oli, prefix: "fas" },
  faEmber: { ...lli, prefix: "fas" },
  faEmpire: { ...dli, prefix: "fas" },
  faEnvira: { ...rli, prefix: "fas" },
  faErlang: { ...sli, prefix: "fas" },
  faEthereum: { ...hli, prefix: "fas" },
  faEtsy: { ...vli, prefix: "fas" },
  faEvernote: { ...uli, prefix: "fas" },
  faExpeditedssl: { ...mli, prefix: "fas" },
  faFacebook: { ...gli, prefix: "fas" },
  faFacebookF: { ...Pli, prefix: "fas" },
  faFacebookMessenger: { ...Mli, prefix: "fas" },
  faFacebookSquare: { ...wli, prefix: "fas" },
  faFantasyFlightGames: { ...Nli, prefix: "fas" },
  faFedex: { ...zli, prefix: "fas" },
  faFedora: { ...Lli, prefix: "fas" },
  faFigma: { ...Cli, prefix: "fas" },
  faFirefox: { ...Dli, prefix: "fas" },
  faFirefoxBrowser: { ...$li, prefix: "fas" },
  faFirstOrder: { ..._li, prefix: "fas" },
  faFirstOrderAlt: { ...bli, prefix: "fas" },
  faFirstdraft: { ...Sli, prefix: "fas" },
  faFlickr: { ...yli, prefix: "fas" },
  faFlipboard: { ...Oli, prefix: "fas" },
  faFlutter: { ...kli, prefix: "fas" },
  faFly: { ...Ali, prefix: "fas" },
  faFontAwesomeAlt: { ...jli, prefix: "fas" },
  faFonticons: { ...Bli, prefix: "fas" },
  faFonticonsFi: { ...Tli, prefix: "fas" },
  faFortAwesome: { ...Fli, prefix: "fas" },
  faFortAwesomeAlt: { ...Hli, prefix: "fas" },
  faForumbee: { ...Rli, prefix: "fas" },
  faFoursquare: { ...Uli, prefix: "fas" },
  faFreeCodeCamp: { ...qli, prefix: "fas" },
  faFreebsd: { ...Gli, prefix: "fas" },
  faFulcrum: { ...Wli, prefix: "fas" },
  faGalacticRepublic: { ...Eli, prefix: "fas" },
  faGalacticSenate: { ...Vli, prefix: "fas" },
  faGetPocket: { ...Ili, prefix: "fas" },
  faGg: { ...Kli, prefix: "fas" },
  faGgCircle: { ...Xli, prefix: "fas" },
  faGit: { ...Qli, prefix: "fas" },
  faGitAlt: { ...Jli, prefix: "fas" },
  faGitSquare: { ...Yli, prefix: "fas" },
  faGithub: { ...Zli, prefix: "fas" },
  faGithubAlt: { ...pli, prefix: "fas" },
  faGithubSquare: { ...xli, prefix: "fas" },
  faGitkraken: { ...idi, prefix: "fas" },
  faGitlab: { ...adi, prefix: "fas" },
  faGitlabSquare: { ...edi, prefix: "fas" },
  faGitter: { ...ndi, prefix: "fas" },
  faGlide: { ...fdi, prefix: "fas" },
  faGlideG: { ...cdi, prefix: "fas" },
  faGofore: { ...tdi, prefix: "fas" },
  faGolang: { ...odi, prefix: "fas" },
  faGoodreads: { ...ldi, prefix: "fas" },
  faGoodreadsG: { ...ddi, prefix: "fas" },
  faGoogle: { ...rdi, prefix: "fas" },
  faGoogleDrive: { ...sdi, prefix: "fas" },
  faGooglePay: { ...hdi, prefix: "fas" },
  faGooglePlay: { ...vdi, prefix: "fas" },
  faGooglePlus: { ...udi, prefix: "fas" },
  faGooglePlusG: { ...mdi, prefix: "fas" },
  faGooglePlusSquare: { ...gdi, prefix: "fas" },
  faGoogleScholar: { ...Pdi, prefix: "fas" },
  faGoogleWallet: { ...Mdi, prefix: "fas" },
  faGratipay: { ...wdi, prefix: "fas" },
  faGrav: { ...Ndi, prefix: "fas" },
  faGripfire: { ...zdi, prefix: "fas" },
  faGrunt: { ...Ldi, prefix: "fas" },
  faGuilded: { ...Cdi, prefix: "fas" },
  faGulp: { ...Ddi, prefix: "fas" },
  faHackerNews: { ...$di, prefix: "fas" },
  faHackerNewsSquare: { ..._di, prefix: "fas" },
  faHackerrank: { ...bdi, prefix: "fas" },
  faHashnode: { ...Sdi, prefix: "fas" },
  faHips: { ...ydi, prefix: "fas" },
  faHireAHelper: { ...Odi, prefix: "fas" },
  faHive: { ...kdi, prefix: "fas" },
  faHooli: { ...Adi, prefix: "fas" },
  faHornbill: { ...jdi, prefix: "fas" },
  faHotjar: { ...Bdi, prefix: "fas" },
  faHouzz: { ...Tdi, prefix: "fas" },
  faHtml5: { ...Fdi, prefix: "fas" },
  faHubspot: { ...Hdi, prefix: "fas" },
  faIdeal: { ...Rdi, prefix: "fas" },
  faImdb: { ...Udi, prefix: "fas" },
  faInnosoft: { ...qdi, prefix: "fas" },
  faInstagram: { ...Gdi, prefix: "fas" },
  faInstagramSquare: { ...Wdi, prefix: "fas" },
  faInstalod: { ...Edi, prefix: "fas" },
  faIntercom: { ...Vdi, prefix: "fas" },
  faInternetExplorer: { ...Idi, prefix: "fas" },
  faInvision: { ...Kdi, prefix: "fas" },
  faIoxhost: { ...Xdi, prefix: "fas" },
  faItchIo: { ...Qdi, prefix: "fas" },
  faItunes: { ...Jdi, prefix: "fas" },
  faItunesNote: { ...Ydi, prefix: "fas" },
  faJava: { ...Zdi, prefix: "fas" },
  faJediOrder: { ...pdi, prefix: "fas" },
  faJenkins: { ...xdi, prefix: "fas" },
  faJira: { ...iri, prefix: "fas" },
  faJoget: { ...ari, prefix: "fas" },
  faJoomla: { ...eri, prefix: "fas" },
  faJs: { ...nri, prefix: "fas" },
  faJsSquare: { ...fri, prefix: "fas" },
  faJsfiddle: { ...cri, prefix: "fas" },
  faJxl: { ...tri, prefix: "fas" },
  faKaggle: { ...ori, prefix: "fas" },
  faKeybase: { ...lri, prefix: "fas" },
  faKeycdn: { ...dri, prefix: "fas" },
  faKickstarter: { ...rri, prefix: "fas" },
  faKickstarterK: { ...sri, prefix: "fas" },
  faKorvue: { ...hri, prefix: "fas" },
  faLaravel: { ...vri, prefix: "fas" },
  faLastfm: { ...uri, prefix: "fas" },
  faLastfmSquare: { ...mri, prefix: "fas" },
  faLeanpub: { ...gri, prefix: "fas" },
  faLess: { ...Pri, prefix: "fas" },
  faLetterboxd: { ...Mri, prefix: "fas" },
  faLine: { ...wri, prefix: "fas" },
  faLinkedin: { ...Nri, prefix: "fas" },
  faLinkedinIn: { ...zri, prefix: "fas" },
  faLinode: { ...Lri, prefix: "fas" },
  faLinux: { ...Cri, prefix: "fas" },
  faLyft: { ...Dri, prefix: "fas" },
  faMagento: { ...$ri, prefix: "fas" },
  faMailchimp: { ..._ri, prefix: "fas" },
  faMandalorian: { ...bri, prefix: "fas" },
  faMarkdown: { ...Sri, prefix: "fas" },
  faMastodon: { ...yri, prefix: "fas" },
  faMaxcdn: { ...Ori, prefix: "fas" },
  faMdb: { ...kri, prefix: "fas" },
  faMedapps: { ...Ari, prefix: "fas" },
  faMedium: { ...jri, prefix: "fas" },
  faMediumM: { ...Bri, prefix: "fas" },
  faMedrt: { ...Tri, prefix: "fas" },
  faMeetup: { ...Fri, prefix: "fas" },
  faMegaport: { ...Hri, prefix: "fas" },
  faMendeley: { ...Rri, prefix: "fas" },
  faMeta: { ...Uri, prefix: "fas" },
  faMicroblog: { ...qri, prefix: "fas" },
  faMicrosoft: { ...Gri, prefix: "fas" },
  faMintbit: { ...Wri, prefix: "fas" },
  faMix: { ...Eri, prefix: "fas" },
  faMixcloud: { ...Vri, prefix: "fas" },
  faMixer: { ...Iri, prefix: "fas" },
  faMizuni: { ...Kri, prefix: "fas" },
  faModx: { ...Xri, prefix: "fas" },
  faMonero: { ...Qri, prefix: "fas" },
  faNapster: { ...Jri, prefix: "fas" },
  faNeos: { ...Yri, prefix: "fas" },
  faNfcDirectional: { ...Zri, prefix: "fas" },
  faNfcSymbol: { ...pri, prefix: "fas" },
  faNimblr: { ...xri, prefix: "fas" },
  faNode: { ...i9i, prefix: "fas" },
  faNodeJs: { ...a9i, prefix: "fas" },
  faNpm: { ...e9i, prefix: "fas" },
  faNs8: { ...n9i, prefix: "fas" },
  faNutritionix: { ...f9i, prefix: "fas" },
  faOctopusDeploy: { ...c9i, prefix: "fas" },
  faOdnoklassniki: { ...t9i, prefix: "fas" },
  faOdnoklassnikiSquare: { ...o9i, prefix: "fas" },
  faOdysee: { ...l9i, prefix: "fas" },
  faOldRepublic: { ...d9i, prefix: "fas" },
  faOpencart: { ...r9i, prefix: "fas" },
  faOpenid: { ...s9i, prefix: "fas" },
  faOpensuse: { ...h9i, prefix: "fas" },
  faOpera: { ...v9i, prefix: "fas" },
  faOptinMonster: { ...u9i, prefix: "fas" },
  faOrcid: { ...m9i, prefix: "fas" },
  faOsi: { ...g9i, prefix: "fas" },
  faPadlet: { ...P9i, prefix: "fas" },
  faPage4: { ...M9i, prefix: "fas" },
  faPagelines: { ...w9i, prefix: "fas" },
  faPalfed: { ...N9i, prefix: "fas" },
  faPatreon: { ...z9i, prefix: "fas" },
  faPaypal: { ...L9i, prefix: "fas" },
  faPerbyte: { ...C9i, prefix: "fas" },
  faPeriscope: { ...D9i, prefix: "fas" },
  faPhabricator: { ...$9i, prefix: "fas" },
  faPhoenixFramework: { ..._9i, prefix: "fas" },
  faPhoenixSquadron: { ...b9i, prefix: "fas" },
  faPhp: { ...S9i, prefix: "fas" },
  faPiedPiper: { ...y9i, prefix: "fas" },
  faPiedPiperAlt: { ...O9i, prefix: "fas" },
  faPiedPiperHat: { ...k9i, prefix: "fas" },
  faPiedPiperPp: { ...A9i, prefix: "fas" },
  faPiedPiperSquare: { ...j9i, prefix: "fas" },
  faPinterest: { ...B9i, prefix: "fas" },
  faPinterestP: { ...T9i, prefix: "fas" },
  faPinterestSquare: { ...F9i, prefix: "fas" },
  faPix: { ...H9i, prefix: "fas" },
  faPixiv: { ...R9i, prefix: "fas" },
  faPlaystation: { ...U9i, prefix: "fas" },
  faProductHunt: { ...q9i, prefix: "fas" },
  faPushed: { ...G9i, prefix: "fas" },
  faPython: { ...W9i, prefix: "fas" },
  faQq: { ...E9i, prefix: "fas" },
  faQuinscape: { ...V9i, prefix: "fas" },
  faQuora: { ...I9i, prefix: "fas" },
  faRProject: { ...K9i, prefix: "fas" },
  faRaspberryPi: { ...X9i, prefix: "fas" },
  faRavelry: { ...Q9i, prefix: "fas" },
  faReact: { ...J9i, prefix: "fas" },
  faReacteurope: { ...Y9i, prefix: "fas" },
  faReadme: { ...Z9i, prefix: "fas" },
  faRebel: { ...p9i, prefix: "fas" },
  faRedRiver: { ...x9i, prefix: "fas" },
  faReddit: { ...isi, prefix: "fas" },
  faRedditAlien: { ...asi, prefix: "fas" },
  faRedditSquare: { ...esi, prefix: "fas" },
  faRedhat: { ...nsi, prefix: "fas" },
  faRendact: { ...fsi, prefix: "fas" },
  faRenren: { ...csi, prefix: "fas" },
  faReplyd: { ...tsi, prefix: "fas" },
  faResearchgate: { ...osi, prefix: "fas" },
  faResolving: { ...lsi, prefix: "fas" },
  faRev: { ...dsi, prefix: "fas" },
  faRocketchat: { ...rsi, prefix: "fas" },
  faRockrms: { ...ssi, prefix: "fas" },
  faRust: { ...hsi, prefix: "fas" },
  faSafari: { ...vsi, prefix: "fas" },
  faSalesforce: { ...usi, prefix: "fas" },
  faSass: { ...msi, prefix: "fas" },
  faSchlix: { ...gsi, prefix: "fas" },
  faScreenpal: { ...Psi, prefix: "fas" },
  faScribd: { ...Msi, prefix: "fas" },
  faSearchengin: { ...wsi, prefix: "fas" },
  faSellcast: { ...Nsi, prefix: "fas" },
  faSellsy: { ...zsi, prefix: "fas" },
  faServicestack: { ...Lsi, prefix: "fas" },
  faShirtsinbulk: { ...Csi, prefix: "fas" },
  faShoelace: { ...Dsi, prefix: "fas" },
  faShopify: { ...$si, prefix: "fas" },
  faShopware: { ..._si, prefix: "fas" },
  faSignalMessenger: { ...bsi, prefix: "fas" },
  faSimplybuilt: { ...Ssi, prefix: "fas" },
  faSistrix: { ...ysi, prefix: "fas" },
  faSith: { ...Osi, prefix: "fas" },
  faSitrox: { ...ksi, prefix: "fas" },
  faSketch: { ...Asi, prefix: "fas" },
  faSkyatlas: { ...jsi, prefix: "fas" },
  faSkype: { ...Bsi, prefix: "fas" },
  faSlack: { ...Tsi, prefix: "fas" },
  faSlackHash: { ...Fsi, prefix: "fas" },
  faSlideshare: { ...Hsi, prefix: "fas" },
  faSnapchat: { ...Rsi, prefix: "fas" },
  faSnapchatGhost: { ...Usi, prefix: "fas" },
  faSnapchatSquare: { ...qsi, prefix: "fas" },
  faSoundcloud: { ...Gsi, prefix: "fas" },
  faSourcetree: { ...Wsi, prefix: "fas" },
  faSpaceAwesome: { ...Esi, prefix: "fas" },
  faSpeakap: { ...Vsi, prefix: "fas" },
  faSpeakerDeck: { ...Isi, prefix: "fas" },
  faSpotify: { ...Ksi, prefix: "fas" },
  faSquareBehance: { ...Xsi, prefix: "fas" },
  faSquareDribbble: { ...Qsi, prefix: "fas" },
  faSquareFacebook: { ...Jsi, prefix: "fas" },
  faSquareFontAwesome: { ...Ysi, prefix: "fas" },
  faSquareFontAwesomeStroke: { ...Zsi, prefix: "fas" },
  faSquareGit: { ...psi, prefix: "fas" },
  faSquareGithub: { ...xsi, prefix: "fas" },
  faSquareGitlab: { ...ihi, prefix: "fas" },
  faSquareGooglePlus: { ...ahi, prefix: "fas" },
  faSquareHackerNews: { ...ehi, prefix: "fas" },
  faSquareInstagram: { ...nhi, prefix: "fas" },
  faSquareJs: { ...fhi, prefix: "fas" },
  faSquareKickstarter: { ...chi, prefix: "fas" },
  faSquareLastfm: { ...thi, prefix: "fas" },
  faSquareLetterboxd: { ...ohi, prefix: "fas" },
  faSquareOdnoklassniki: { ...lhi, prefix: "fas" },
  faSquarePiedPiper: { ...dhi, prefix: "fas" },
  faSquarePinterest: { ...rhi, prefix: "fas" },
  faSquareReddit: { ...shi, prefix: "fas" },
  faSquareSnapchat: { ...hhi, prefix: "fas" },
  faSquareSteam: { ...vhi, prefix: "fas" },
  faSquareThreads: { ...uhi, prefix: "fas" },
  faSquareTumblr: { ...mhi, prefix: "fas" },
  faSquareTwitter: { ...ghi, prefix: "fas" },
  faSquareUpwork: { ...Phi, prefix: "fas" },
  faSquareViadeo: { ...Mhi, prefix: "fas" },
  faSquareVimeo: { ...whi, prefix: "fas" },
  faSquareWebAwesome: { ...Nhi, prefix: "fas" },
  faSquareWebAwesomeStroke: { ...zhi, prefix: "fas" },
  faSquareWhatsapp: { ...Lhi, prefix: "fas" },
  faSquareXTwitter: { ...Chi, prefix: "fas" },
  faSquareXing: { ...Dhi, prefix: "fas" },
  faSquareYoutube: { ...$hi, prefix: "fas" },
  faSquarespace: { ..._hi, prefix: "fas" },
  faStackExchange: { ...bhi, prefix: "fas" },
  faStackOverflow: { ...Shi, prefix: "fas" },
  faStackpath: { ...yhi, prefix: "fas" },
  faStaylinked: { ...Ohi, prefix: "fas" },
  faSteam: { ...khi, prefix: "fas" },
  faSteamSquare: { ...Ahi, prefix: "fas" },
  faSteamSymbol: { ...jhi, prefix: "fas" },
  faStickerMule: { ...Bhi, prefix: "fas" },
  faStrava: { ...Thi, prefix: "fas" },
  faStripe: { ...Fhi, prefix: "fas" },
  faStripeS: { ...Hhi, prefix: "fas" },
  faStubber: { ...Rhi, prefix: "fas" },
  faStudiovinari: { ...Uhi, prefix: "fas" },
  faStumbleupon: { ...qhi, prefix: "fas" },
  faStumbleuponCircle: { ...Ghi, prefix: "fas" },
  faSuperpowers: { ...Whi, prefix: "fas" },
  faSupple: { ...Ehi, prefix: "fas" },
  faSuse: { ...Vhi, prefix: "fas" },
  faSwift: { ...Ihi, prefix: "fas" },
  faSymfony: { ...Khi, prefix: "fas" },
  faTeamspeak: { ...Xhi, prefix: "fas" },
  faTelegram: { ...Qhi, prefix: "fas" },
  faTelegramPlane: { ...Jhi, prefix: "fas" },
  faTencentWeibo: { ...Yhi, prefix: "fas" },
  faTheRedYeti: { ...Zhi, prefix: "fas" },
  faThemeco: { ...phi, prefix: "fas" },
  faThemeisle: { ...xhi, prefix: "fas" },
  faThinkPeaks: { ...ivi, prefix: "fas" },
  faThreads: { ...avi, prefix: "fas" },
  faTiktok: { ...evi, prefix: "fas" },
  faTradeFederation: { ...nvi, prefix: "fas" },
  faTrello: { ...fvi, prefix: "fas" },
  faTumblr: { ...cvi, prefix: "fas" },
  faTumblrSquare: { ...tvi, prefix: "fas" },
  faTwitch: { ...ovi, prefix: "fas" },
  faTwitter: { ...lvi, prefix: "fas" },
  faTwitterSquare: { ...dvi, prefix: "fas" },
  faTypo3: { ...rvi, prefix: "fas" },
  faUber: { ...svi, prefix: "fas" },
  faUbuntu: { ...hvi, prefix: "fas" },
  faUikit: { ...vvi, prefix: "fas" },
  faUmbraco: { ...uvi, prefix: "fas" },
  faUncharted: { ...mvi, prefix: "fas" },
  faUniregistry: { ...gvi, prefix: "fas" },
  faUnity: { ...Pvi, prefix: "fas" },
  faUnsplash: { ...Mvi, prefix: "fas" },
  faUntappd: { ...wvi, prefix: "fas" },
  faUps: { ...Nvi, prefix: "fas" },
  faUpwork: { ...zvi, prefix: "fas" },
  faUsb: { ...Lvi, prefix: "fas" },
  faUsps: { ...Cvi, prefix: "fas" },
  faUssunnah: { ...Dvi, prefix: "fas" },
  faVaadin: { ...$vi, prefix: "fas" },
  faViacoin: { ..._vi, prefix: "fas" },
  faViadeo: { ...bvi, prefix: "fas" },
  faViadeoSquare: { ...Svi, prefix: "fas" },
  faViber: { ...yvi, prefix: "fas" },
  faVimeo: { ...Ovi, prefix: "fas" },
  faVimeoSquare: { ...kvi, prefix: "fas" },
  faVimeoV: { ...Avi, prefix: "fas" },
  faVine: { ...jvi, prefix: "fas" },
  faVk: { ...Bvi, prefix: "fas" },
  faVnv: { ...Tvi, prefix: "fas" },
  faVuejs: { ...Fvi, prefix: "fas" },
  faWatchmanMonitoring: { ...Hvi, prefix: "fas" },
  faWaze: { ...Rvi, prefix: "fas" },
  faWebflow: { ...Uvi, prefix: "fas" },
  faWeebly: { ...qvi, prefix: "fas" },
  faWeibo: { ...Gvi, prefix: "fas" },
  faWeixin: { ...Wvi, prefix: "fas" },
  faWhatsapp: { ...Evi, prefix: "fas" },
  faWhatsappSquare: { ...Vvi, prefix: "fas" },
  faWhmcs: { ...Ivi, prefix: "fas" },
  faWikipediaW: { ...Kvi, prefix: "fas" },
  faWindows: { ...Xvi, prefix: "fas" },
  faWirsindhandwerk: { ...Qvi, prefix: "fas" },
  faWix: { ...Jvi, prefix: "fas" },
  faWizardsOfTheCoast: { ...Yvi, prefix: "fas" },
  faWodu: { ...Zvi, prefix: "fas" },
  faWolfPackBattalion: { ...pvi, prefix: "fas" },
  faWordpress: { ...xvi, prefix: "fas" },
  faWordpressSimple: { ...iui, prefix: "fas" },
  faWpbeginner: { ...aui, prefix: "fas" },
  faWpexplorer: { ...eui, prefix: "fas" },
  faWpforms: { ...nui, prefix: "fas" },
  faWpressr: { ...fui, prefix: "fas" },
  faWsh: { ...cui, prefix: "fas" },
  faXTwitter: { ...tui, prefix: "fas" },
  faXbox: { ...oui, prefix: "fas" },
  faXing: { ...lui, prefix: "fas" },
  faXingSquare: { ...dui, prefix: "fas" },
  faYCombinator: { ...rui, prefix: "fas" },
  faYahoo: { ...sui, prefix: "fas" },
  faYammer: { ...hui, prefix: "fas" },
  faYandex: { ...vui, prefix: "fas" },
  faYandexInternational: { ...uui, prefix: "fas" },
  faYarn: { ...mui, prefix: "fas" },
  faYelp: { ...gui, prefix: "fas" },
  faYoast: { ...Pui, prefix: "fas" },
  faYoutube: { ...Mui, prefix: "fas" },
  faYoutubeSquare: { ...wui, prefix: "fas" },
  faZhihu: { ...Nui, prefix: "fas" },
  fa00: { ...L0.definition, prefix: "fas" },
  fa100: { ...C0.definition, prefix: "fas" },
  fa360Degrees: { ...D0.definition, prefix: "fas" },
  faAbacus: { ...$0.definition, prefix: "fas" },
  faAccentGrave: { ..._0.definition, prefix: "fas" },
  faAcorn: { ...b0.definition, prefix: "fas" },
  faAirConditioner: { ...S0.definition, prefix: "fas" },
  faAirplay: { ...y0.definition, prefix: "fas" },
  faAlarmClock: { ...O0.definition, prefix: "fas" },
  faAlarmExclamation: { ...k0.definition, prefix: "fas" },
  faAlarmPlus: { ...A0.definition, prefix: "fas" },
  faAlarmSnooze: { ...j0.definition, prefix: "fas" },
  faAlbum: { ...B0.definition, prefix: "fas" },
  faAlbumCirclePlus: { ...T0.definition, prefix: "fas" },
  faAlbumCircleUser: { ...F0.definition, prefix: "fas" },
  faAlbumCollection: { ...H0.definition, prefix: "fas" },
  faAlbumCollectionCirclePlus: { ...R0.definition, prefix: "fas" },
  faAlbumCollectionCircleUser: { ...U0.definition, prefix: "fas" },
  faAlicorn: { ...q0.definition, prefix: "fas" },
  faAlien: { ...G0.definition, prefix: "fas" },
  faAlien8bit: { ...F.definition, prefix: "fas" },
  faAlienMonster: { ...W0.definition, prefix: "fas" },
  faAlignSlash: { ...E0.definition, prefix: "fas" },
  faAlt: { ...V0.definition, prefix: "fas" },
  faAmpGuitar: { ...I0.definition, prefix: "fas" },
  faAmpersand: { ...K0.definition, prefix: "fas" },
  faAnalytics: { ...X0.definition, prefix: "fas" },
  faAngel: { ...Q0.definition, prefix: "fas" },
  faAngle: { ...J0.definition, prefix: "fas" },
  faAngle90: { ...Y0.definition, prefix: "fas" },
  faAnglesUpDown: { ...Z0.definition, prefix: "fas" },
  faAnt: { ...p0.definition, prefix: "fas" },
  faApartment: { ...x0.definition, prefix: "fas" },
  faAperture: { ...ie.definition, prefix: "fas" },
  faApostrophe: { ...ae.definition, prefix: "fas" },
  faAppleCore: { ...ee.definition, prefix: "fas" },
  faAppleCrate: { ...ne.definition, prefix: "fas" },
  faArrowAltDown: { ...fe.definition, prefix: "fas" },
  faArrowAltFromBottom: { ...ce.definition, prefix: "fas" },
  faArrowAltFromLeft: { ...te.definition, prefix: "fas" },
  faArrowAltFromRight: { ...oe.definition, prefix: "fas" },
  faArrowAltFromTop: { ...le.definition, prefix: "fas" },
  faArrowAltLeft: { ...de.definition, prefix: "fas" },
  faArrowAltRight: { ...re.definition, prefix: "fas" },
  faArrowAltSquareDown: { ...se.definition, prefix: "fas" },
  faArrowAltSquareLeft: { ...he.definition, prefix: "fas" },
  faArrowAltSquareRight: { ...ve.definition, prefix: "fas" },
  faArrowAltSquareUp: { ...ue.definition, prefix: "fas" },
  faArrowAltToBottom: { ...me.definition, prefix: "fas" },
  faArrowAltToLeft: { ...ge.definition, prefix: "fas" },
  faArrowAltToRight: { ...Pe.definition, prefix: "fas" },
  faArrowAltToTop: { ...Me.definition, prefix: "fas" },
  faArrowAltUp: { ...we.definition, prefix: "fas" },
  faArrowDownArrowUp: { ...ai.definition, prefix: "fas" },
  faArrowDownBigSmall: { ...ei.definition, prefix: "fas" },
  faArrowDownFromArc: { ...Ne.definition, prefix: "fas" },
  faArrowDownFromBracket: { ...ze.definition, prefix: "fas" },
  faArrowDownFromDottedLine: { ...Le.definition, prefix: "fas" },
  faArrowDownFromLine: { ...ni.definition, prefix: "fas" },
  faArrowDownLeft: { ...Ce.definition, prefix: "fas" },
  faArrowDownLeftAndArrowUpRightToCenter: { ...De.definition, prefix: "fas" },
  faArrowDownRight: { ...$e.definition, prefix: "fas" },
  faArrowDownSmallBig: { ...fi.definition, prefix: "fas" },
  faArrowDownSquareTriangle: { ...ci.definition, prefix: "fas" },
  faArrowDownToArc: { ..._e.definition, prefix: "fas" },
  faArrowDownToBracket: { ...be.definition, prefix: "fas" },
  faArrowDownToDottedLine: { ...Se.definition, prefix: "fas" },
  faArrowDownToLine: { ...ti.definition, prefix: "fas" },
  faArrowDownToSquare: { ...ye.definition, prefix: "fas" },
  faArrowDownTriangleSquare: { ...oi.definition, prefix: "fas" },
  faArrowFromBottom: { ...Oe.definition, prefix: "fas" },
  faArrowFromLeft: { ...ke.definition, prefix: "fas" },
  faArrowFromRight: { ...Ae.definition, prefix: "fas" },
  faArrowFromTop: { ...je.definition, prefix: "fas" },
  faArrowLeftFromArc: { ...Be.definition, prefix: "fas" },
  faArrowLeftFromBracket: { ...Te.definition, prefix: "fas" },
  faArrowLeftFromLine: { ...ri.definition, prefix: "fas" },
  faArrowLeftLongToLine: { ...Fe.definition, prefix: "fas" },
  faArrowLeftToArc: { ...He.definition, prefix: "fas" },
  faArrowLeftToBracket: { ...Re.definition, prefix: "fas" },
  faArrowLeftToLine: { ...si.definition, prefix: "fas" },
  faArrowProgress: { ...Ue.definition, prefix: "fas" },
  faArrowRightFromArc: { ...qe.definition, prefix: "fas" },
  faArrowRightFromLine: { ...di.definition, prefix: "fas" },
  faArrowRightLongToLine: { ...Ge.definition, prefix: "fas" },
  faArrowRightToArc: { ...We.definition, prefix: "fas" },
  faArrowRightToLine: { ...hi.definition, prefix: "fas" },
  faArrowSquareDown: { ...Ee.definition, prefix: "fas" },
  faArrowSquareLeft: { ...Ve.definition, prefix: "fas" },
  faArrowSquareRight: { ...Ie.definition, prefix: "fas" },
  faArrowSquareUp: { ...Ke.definition, prefix: "fas" },
  faArrowToBottom: { ...Xe.definition, prefix: "fas" },
  faArrowToLeft: { ...Qe.definition, prefix: "fas" },
  faArrowToRight: { ...Je.definition, prefix: "fas" },
  faArrowToTop: { ...Ye.definition, prefix: "fas" },
  faArrowTurnDownLeft: { ...Ze.definition, prefix: "fas" },
  faArrowTurnDownRight: { ...pe.definition, prefix: "fas" },
  faArrowTurnLeft: { ...xe.definition, prefix: "fas" },
  faArrowTurnLeftDown: { ...an.definition, prefix: "fas" },
  faArrowTurnLeftUp: { ...en.definition, prefix: "fas" },
  faArrowTurnRight: { ...nn.definition, prefix: "fas" },
  faArrowUpArrowDown: { ...Mi.definition, prefix: "fas" },
  faArrowUpBigSmall: { ...wi.definition, prefix: "fas" },
  faArrowUpFromArc: { ...fn.definition, prefix: "fas" },
  faArrowUpFromDottedLine: { ...cn.definition, prefix: "fas" },
  faArrowUpFromLine: { ...li.definition, prefix: "fas" },
  faArrowUpFromSquare: { ...tn.definition, prefix: "fas" },
  faArrowUpLeft: { ...on.definition, prefix: "fas" },
  faArrowUpLeftFromCircle: { ...ln.definition, prefix: "fas" },
  faArrowUpRight: { ...dn.definition, prefix: "fas" },
  faArrowUpRightAndArrowDownLeftFromCenter: { ...rn.definition, prefix: "fas" },
  faArrowUpSmallBig: { ...Ni.definition, prefix: "fas" },
  faArrowUpSquareTriangle: { ...zi.definition, prefix: "fas" },
  faArrowUpToArc: { ...sn.definition, prefix: "fas" },
  faArrowUpToBracket: { ...hn.definition, prefix: "fas" },
  faArrowUpToDottedLine: { ...vn.definition, prefix: "fas" },
  faArrowUpToLine: { ...Pi.definition, prefix: "fas" },
  faArrowUpTriangleSquare: { ...Li.definition, prefix: "fas" },
  faArrowsCross: { ...un.definition, prefix: "fas" },
  faArrowsFromDottedLine: { ...mn.definition, prefix: "fas" },
  faArrowsFromLine: { ...gn.definition, prefix: "fas" },
  faArrowsMaximize: { ...Ci.definition, prefix: "fas" },
  faArrowsMinimize: { ...Di.definition, prefix: "fas" },
  faArrowsRepeat: { ...$i.definition, prefix: "fas" },
  faArrowsRepeat1: { ..._i.definition, prefix: "fas" },
  faArrowsRetweet: { ...bi.definition, prefix: "fas" },
  faArrowsRotateReverse: { ...Pn.definition, prefix: "fas" },
  faArrowsToDottedLine: { ...Mn.definition, prefix: "fas" },
  faArrowsToLine: { ...wn.definition, prefix: "fas" },
  faAtomAlt: { ...Nn.definition, prefix: "fas" },
  faAtomSimple: { ...Si.definition, prefix: "fas" },
  faAudioDescriptionSlash: { ...zn.definition, prefix: "fas" },
  faAvocado: { ...Ln.definition, prefix: "fas" },
  faAwardSimple: { ...Cn.definition, prefix: "fas" },
  faAxe: { ...Dn.definition, prefix: "fas" },
  faAxeBattle: { ...$n.definition, prefix: "fas" },
  faBackpack: { ..._n.definition, prefix: "fas" },
  faBadge: { ...bn.definition, prefix: "fas" },
  faBadgeCheck: { ...Sn.definition, prefix: "fas" },
  faBadgeDollar: { ...yn.definition, prefix: "fas" },
  faBadgePercent: { ...On.definition, prefix: "fas" },
  faBadgeSheriff: { ...kn.definition, prefix: "fas" },
  faBadgerHoney: { ...An.definition, prefix: "fas" },
  faBadminton: { ...jn.definition, prefix: "fas" },
  faBagSeedling: { ...Bn.definition, prefix: "fas" },
  faBagShoppingMinus: { ...Tn.definition, prefix: "fas" },
  faBagShoppingPlus: { ...Fn.definition, prefix: "fas" },
  faBagel: { ...Hn.definition, prefix: "fas" },
  faBagsShopping: { ...Rn.definition, prefix: "fas" },
  faBaguette: { ...Un.definition, prefix: "fas" },
  faBallPile: { ...qn.definition, prefix: "fas" },
  faBalloon: { ...Gn.definition, prefix: "fas" },
  faBalloons: { ...Wn.definition, prefix: "fas" },
  faBallot: { ...En.definition, prefix: "fas" },
  faBallotCheck: { ...Vn.definition, prefix: "fas" },
  faBanBug: { ...yi.definition, prefix: "fas" },
  faBanParking: { ...Oi.definition, prefix: "fas" },
  faBanana: { ...In.definition, prefix: "fas" },
  faBanjo: { ...Kn.definition, prefix: "fas" },
  faBarcodeAlt: { ...Xn.definition, prefix: "fas" },
  faBarcodeRead: { ...Qn.definition, prefix: "fas" },
  faBarcodeScan: { ...Jn.definition, prefix: "fas" },
  faBarnSilo: { ...Yn.definition, prefix: "fas" },
  faBarsFilter: { ...Zn.definition, prefix: "fas" },
  faBarsSort: { ...pn.definition, prefix: "fas" },
  faBasketShoppingMinus: { ...xn.definition, prefix: "fas" },
  faBasketShoppingPlus: { ...i6.definition, prefix: "fas" },
  faBasketShoppingSimple: { ...ji.definition, prefix: "fas" },
  faBasketballHoop: { ...a6.definition, prefix: "fas" },
  faBat: { ...e6.definition, prefix: "fas" },
  faBattery1: { ...n6.definition, prefix: "fas" },
  faBatteryBolt: { ...f6.definition, prefix: "fas" },
  faBatteryExclamation: { ...c6.definition, prefix: "fas" },
  faBatteryLow: { ...Bi.definition, prefix: "fas" },
  faBatterySlash: { ...t6.definition, prefix: "fas" },
  faBedAlt: { ...o6.definition, prefix: "fas" },
  faBedBunk: { ...l6.definition, prefix: "fas" },
  faBedEmpty: { ...d6.definition, prefix: "fas" },
  faBedFront: { ...Ti.definition, prefix: "fas" },
  faBee: { ...r6.definition, prefix: "fas" },
  faBeerFoam: { ...s6.definition, prefix: "fas" },
  faBeerMug: { ...Fi.definition, prefix: "fas" },
  faBellExclamation: { ...h6.definition, prefix: "fas" },
  faBellOn: { ...v6.definition, prefix: "fas" },
  faBellPlus: { ...u6.definition, prefix: "fas" },
  faBellRing: { ...m6.definition, prefix: "fas" },
  faBellSchool: { ...g6.definition, prefix: "fas" },
  faBellSchoolSlash: { ...P6.definition, prefix: "fas" },
  faBells: { ...M6.definition, prefix: "fas" },
  faBenchTree: { ...w6.definition, prefix: "fas" },
  faBetamax: { ...N6.definition, prefix: "fas" },
  faBikingMountain: { ...z6.definition, prefix: "fas" },
  faBillboard: { ...L6.definition, prefix: "fas" },
  faBinBottles: { ...C6.definition, prefix: "fas" },
  faBinBottlesRecycle: { ...D6.definition, prefix: "fas" },
  faBinRecycle: { ...$6.definition, prefix: "fas" },
  faBinary: { ..._6.definition, prefix: "fas" },
  faBinaryCircleCheck: { ...b6.definition, prefix: "fas" },
  faBinaryLock: { ...S6.definition, prefix: "fas" },
  faBinarySlash: { ...y6.definition, prefix: "fas" },
  faBird: { ...O6.definition, prefix: "fas" },
  faBlanket: { ...k6.definition, prefix: "fas" },
  faBlanketFire: { ...A6.definition, prefix: "fas" },
  faBlinds: { ...j6.definition, prefix: "fas" },
  faBlindsOpen: { ...B6.definition, prefix: "fas" },
  faBlindsRaised: { ...T6.definition, prefix: "fas" },
  faBlock: { ...F6.definition, prefix: "fas" },
  faBlockBrick: { ...Ui.definition, prefix: "fas" },
  faBlockBrickFire: { ...qi.definition, prefix: "fas" },
  faBlockQuestion: { ...H6.definition, prefix: "fas" },
  faBlockQuote: { ...R6.definition, prefix: "fas" },
  faBlueberries: { ...U6.definition, prefix: "fas" },
  faBoltAuto: { ...q6.definition, prefix: "fas" },
  faBoltSlash: { ...G6.definition, prefix: "fas" },
  faBoneBreak: { ...W6.definition, prefix: "fas" },
  faBookAlt: { ...E6.definition, prefix: "fas" },
  faBookArrowRight: { ...V6.definition, prefix: "fas" },
  faBookArrowUp: { ...I6.definition, prefix: "fas" },
  faBookBlank: { ...Gi.definition, prefix: "fas" },
  faBookCircle: { ...K6.definition, prefix: "fas" },
  faBookCircleArrowRight: { ...X6.definition, prefix: "fas" },
  faBookCircleArrowUp: { ...Q6.definition, prefix: "fas" },
  faBookCopy: { ...J6.definition, prefix: "fas" },
  faBookFont: { ...Y6.definition, prefix: "fas" },
  faBookHeart: { ...Z6.definition, prefix: "fas" },
  faBookLaw: { ...p6.definition, prefix: "fas" },
  faBookOpenAlt: { ...x6.definition, prefix: "fas" },
  faBookOpenCover: { ...Vi.definition, prefix: "fas" },
  faBookSection: { ...Ei.definition, prefix: "fas" },
  faBookSparkles: { ...Ii.definition, prefix: "fas" },
  faBookSpells: { ...af.definition, prefix: "fas" },
  faBookUser: { ...ef.definition, prefix: "fas" },
  faBookmarkCircle: { ...nf.definition, prefix: "fas" },
  faBookmarkSlash: { ...ff.definition, prefix: "fas" },
  faBooks: { ...cf.definition, prefix: "fas" },
  faBooksMedical: { ...tf.definition, prefix: "fas" },
  faBoombox: { ...of.definition, prefix: "fas" },
  faBoot: { ...lf.definition, prefix: "fas" },
  faBootHeeled: { ...df.definition, prefix: "fas" },
  faBoothCurtain: { ...rf.definition, prefix: "fas" },
  faBorderBottom: { ...sf.definition, prefix: "fas" },
  faBorderBottomRight: { ...Xi.definition, prefix: "fas" },
  faBorderCenterH: { ...hf.definition, prefix: "fas" },
  faBorderCenterV: { ...vf.definition, prefix: "fas" },
  faBorderInner: { ...uf.definition, prefix: "fas" },
  faBorderLeft: { ...mf.definition, prefix: "fas" },
  faBorderOuter: { ...gf.definition, prefix: "fas" },
  faBorderRight: { ...Pf.definition, prefix: "fas" },
  faBorderStyleAlt: { ...Mf.definition, prefix: "fas" },
  faBorderTop: { ...wf.definition, prefix: "fas" },
  faBottleBaby: { ...Nf.definition, prefix: "fas" },
  faBowArrow: { ...zf.definition, prefix: "fas" },
  faBowlChopsticks: { ...Lf.definition, prefix: "fas" },
  faBowlChopsticksNoodles: { ...Cf.definition, prefix: "fas" },
  faBowlHot: { ...Qi.definition, prefix: "fas" },
  faBowlSalad: { ...Df.definition, prefix: "fas" },
  faBowlScoop: { ...Yi.definition, prefix: "fas" },
  faBowlScoops: { ...$f.definition, prefix: "fas" },
  faBowlShavedIce: { ..._f.definition, prefix: "fas" },
  faBowlSoftServe: { ...bf.definition, prefix: "fas" },
  faBowlSpoon: { ...Sf.definition, prefix: "fas" },
  faBowlingBallPin: { ...yf.definition, prefix: "fas" },
  faBowlingPins: { ...Of.definition, prefix: "fas" },
  faBoxAlt: { ...kf.definition, prefix: "fas" },
  faBoxBallot: { ...Af.definition, prefix: "fas" },
  faBoxCheck: { ...jf.definition, prefix: "fas" },
  faBoxCircleCheck: { ...Bf.definition, prefix: "fas" },
  faBoxDollar: { ...pi.definition, prefix: "fas" },
  faBoxFragile: { ...Tf.definition, prefix: "fas" },
  faBoxFull: { ...Ff.definition, prefix: "fas" },
  faBoxHeart: { ...Hf.definition, prefix: "fas" },
  faBoxOpenFull: { ...xi.definition, prefix: "fas" },
  faBoxTaped: { ...Zi.definition, prefix: "fas" },
  faBoxUp: { ...Rf.definition, prefix: "fas" },
  faBoxUsd: { ...Uf.definition, prefix: "fas" },
  faBoxingGlove: { ...a2.definition, prefix: "fas" },
  faBracket: { ...qf.definition, prefix: "fas" },
  faBracketCurly: { ...e2.definition, prefix: "fas" },
  faBracketCurlyLeft: { ...Gf.definition, prefix: "fas" },
  faBracketCurlyRight: { ...Wf.definition, prefix: "fas" },
  faBracketLeft: { ...Ef.definition, prefix: "fas" },
  faBracketRound: { ...n2.definition, prefix: "fas" },
  faBracketRoundRight: { ...Vf.definition, prefix: "fas" },
  faBracketSquare: { ...h.definition, prefix: "fas" },
  faBracketSquareRight: { ...If.definition, prefix: "fas" },
  faBrackets: { ...Kf.definition, prefix: "fas" },
  faBracketsCurly: { ...Xf.definition, prefix: "fas" },
  faBracketsRound: { ...c2.definition, prefix: "fas" },
  faBracketsSquare: { ...f2.definition, prefix: "fas" },
  faBrainArrowCurvedRight: { ...t2.definition, prefix: "fas" },
  faBrainCircuit: { ...Qf.definition, prefix: "fas" },
  faBrakeWarning: { ...Jf.definition, prefix: "fas" },
  faBreadLoaf: { ...Yf.definition, prefix: "fas" },
  faBreadSliceButter: { ...Zf.definition, prefix: "fas" },
  faBridgeSuspension: { ...pf.definition, prefix: "fas" },
  faBriefcaseArrowRight: { ...xf.definition, prefix: "fas" },
  faBriefcaseBlank: { ...ic.definition, prefix: "fas" },
  faBrightness: { ...ac.definition, prefix: "fas" },
  faBrightnessLow: { ...ec.definition, prefix: "fas" },
  faBringForward: { ...nc.definition, prefix: "fas" },
  faBringFront: { ...fc.definition, prefix: "fas" },
  faBroccoli: { ...cc.definition, prefix: "fas" },
  faBroomWide: { ...tc.definition, prefix: "fas" },
  faBrowser: { ...oc.definition, prefix: "fas" },
  faBrowsers: { ...lc.definition, prefix: "fas" },
  faBuildingMagnifyingGlass: { ...dc.definition, prefix: "fas" },
  faBuildingMemo: { ...rc.definition, prefix: "fas" },
  faBuildings: { ...sc.definition, prefix: "fas" },
  faBulldozer: { ...hc.definition, prefix: "fas" },
  faBullseyeArrow: { ...vc.definition, prefix: "fas" },
  faBullseyePointer: { ...uc.definition, prefix: "fas" },
  faBuoy: { ...mc.definition, prefix: "fas" },
  faBuoyMooring: { ...gc.definition, prefix: "fas" },
  faBurgerCheese: { ...o2.definition, prefix: "fas" },
  faBurgerFries: { ...Pc.definition, prefix: "fas" },
  faBurgerGlass: { ...Mc.definition, prefix: "fas" },
  faBurgerLettuce: { ...wc.definition, prefix: "fas" },
  faBurgerSoda: { ...Nc.definition, prefix: "fas" },
  faBurrito: { ...zc.definition, prefix: "fas" },
  faBusSchool: { ...Lc.definition, prefix: "fas" },
  faBusinessFront: { ...Cc.definition, prefix: "fas" },
  faButter: { ...Dc.definition, prefix: "fas" },
  faCabin: { ...$c.definition, prefix: "fas" },
  faCabinetFiling: { ..._c.definition, prefix: "fas" },
  faCactus: { ...bc.definition, prefix: "fas" },
  faCaduceus: { ...Sc.definition, prefix: "fas" },
  faCakeSlice: { ...l2.definition, prefix: "fas" },
  faCalculatorAlt: { ...yc.definition, prefix: "fas" },
  faCalculatorSimple: { ...d2.definition, prefix: "fas" },
  faCalendarArrowDown: { ...r2.definition, prefix: "fas" },
  faCalendarArrowUp: { ...s2.definition, prefix: "fas" },
  faCalendarCircle: { ...Oc.definition, prefix: "fas" },
  faCalendarCircleExclamation: { ...kc.definition, prefix: "fas" },
  faCalendarCircleMinus: { ...Ac.definition, prefix: "fas" },
  faCalendarCirclePlus: { ...jc.definition, prefix: "fas" },
  faCalendarCircleUser: { ...Bc.definition, prefix: "fas" },
  faCalendarClock: { ...v2.definition, prefix: "fas" },
  faCalendarDownload: { ...Tc.definition, prefix: "fas" },
  faCalendarEdit: { ...Fc.definition, prefix: "fas" },
  faCalendarExclamation: { ...Hc.definition, prefix: "fas" },
  faCalendarHeart: { ...Rc.definition, prefix: "fas" },
  faCalendarImage: { ...Uc.definition, prefix: "fas" },
  faCalendarLines: { ...m2.definition, prefix: "fas" },
  faCalendarLinesPen: { ...qc.definition, prefix: "fas" },
  faCalendarNote: { ...Gc.definition, prefix: "fas" },
  faCalendarPen: { ...u2.definition, prefix: "fas" },
  faCalendarRange: { ...Wc.definition, prefix: "fas" },
  faCalendarStar: { ...Ec.definition, prefix: "fas" },
  faCalendarTime: { ...Vc.definition, prefix: "fas" },
  faCalendarUpload: { ...Ic.definition, prefix: "fas" },
  faCalendarUsers: { ...Kc.definition, prefix: "fas" },
  faCalendars: { ...Xc.definition, prefix: "fas" },
  faCamcorder: { ...g2.definition, prefix: "fas" },
  faCameraCctv: { ...P2.definition, prefix: "fas" },
  faCameraCircle: { ...Qc.definition, prefix: "fas" },
  faCameraHome: { ...Jc.definition, prefix: "fas" },
  faCameraMovie: { ...Yc.definition, prefix: "fas" },
  faCameraPolaroid: { ...Zc.definition, prefix: "fas" },
  faCameraSecurity: { ...w2.definition, prefix: "fas" },
  faCameraSlash: { ...pc.definition, prefix: "fas" },
  faCameraViewfinder: { ...N2.definition, prefix: "fas" },
  faCameraWeb: { ...z2.definition, prefix: "fas" },
  faCameraWebSlash: { ...L2.definition, prefix: "fas" },
  faCampfire: { ...xc.definition, prefix: "fas" },
  faCanFood: { ...i8.definition, prefix: "fas" },
  faCandleHolder: { ...a8.definition, prefix: "fas" },
  faCandy: { ...e8.definition, prefix: "fas" },
  faCandyBar: { ...C2.definition, prefix: "fas" },
  faCandyCorn: { ...n8.definition, prefix: "fas" },
  faCannon: { ...f8.definition, prefix: "fas" },
  faCarBolt: { ...c8.definition, prefix: "fas" },
  faCarBuilding: { ...t8.definition, prefix: "fas" },
  faCarBump: { ...o8.definition, prefix: "fas" },
  faCarBus: { ...l8.definition, prefix: "fas" },
  faCarCircleBolt: { ...d8.definition, prefix: "fas" },
  faCarGarage: { ...r8.definition, prefix: "fas" },
  faCarMechanic: { ...s8.definition, prefix: "fas" },
  faCarMirrors: { ...h8.definition, prefix: "fas" },
  faCarSideBolt: { ...v8.definition, prefix: "fas" },
  faCarTilt: { ...u8.definition, prefix: "fas" },
  faCarWash: { ...m8.definition, prefix: "fas" },
  faCarWrench: { ...D2.definition, prefix: "fas" },
  faCaravanAlt: { ...g8.definition, prefix: "fas" },
  faCaravanSimple: { ...$2.definition, prefix: "fas" },
  faCardClub: { ...P8.definition, prefix: "fas" },
  faCardDiamond: { ...M8.definition, prefix: "fas" },
  faCardHeart: { ...w8.definition, prefix: "fas" },
  faCardSpade: { ...N8.definition, prefix: "fas" },
  faCards: { ...z8.definition, prefix: "fas" },
  faCardsBlank: { ...L8.definition, prefix: "fas" },
  faCaretCircleDown: { ...C8.definition, prefix: "fas" },
  faCaretCircleLeft: { ...D8.definition, prefix: "fas" },
  faCaretCircleRight: { ...$8.definition, prefix: "fas" },
  faCaretCircleUp: { ..._8.definition, prefix: "fas" },
  faCars: { ...b8.definition, prefix: "fas" },
  faCartArrowUp: { ...S8.definition, prefix: "fas" },
  faCartCircleArrowDown: { ...y8.definition, prefix: "fas" },
  faCartCircleArrowUp: { ...O8.definition, prefix: "fas" },
  faCartCircleCheck: { ...k8.definition, prefix: "fas" },
  faCartCircleExclamation: { ...A8.definition, prefix: "fas" },
  faCartCirclePlus: { ...j8.definition, prefix: "fas" },
  faCartCircleXmark: { ...B8.definition, prefix: "fas" },
  faCartFlatbedBoxes: { ...O2.definition, prefix: "fas" },
  faCartFlatbedEmpty: { ...k2.definition, prefix: "fas" },
  faCartMinus: { ...T8.definition, prefix: "fas" },
  faCartShoppingFast: { ...F8.definition, prefix: "fas" },
  faCartXmark: { ...H8.definition, prefix: "fas" },
  faCassetteBetamax: { ...Hi.definition, prefix: "fas" },
  faCassetteTape: { ...R8.definition, prefix: "fas" },
  faCassetteVhs: { ...A2.definition, prefix: "fas" },
  faCastle: { ...U8.definition, prefix: "fas" },
  faCatSpace: { ...q8.definition, prefix: "fas" },
  faCauldron: { ...G8.definition, prefix: "fas" },
  faCctv: { ...W8.definition, prefix: "fas" },
  faChainHorizontal: { ...E8.definition, prefix: "fas" },
  faChainHorizontalSlash: { ...V8.definition, prefix: "fas" },
  faChairOffice: { ...I8.definition, prefix: "fas" },
  faChampagneGlass: { ...T2.definition, prefix: "fas" },
  faChartBullet: { ...K8.definition, prefix: "fas" },
  faChartCandlestick: { ...X8.definition, prefix: "fas" },
  faChartKanban: { ...Q8.definition, prefix: "fas" },
  faChartLineDown: { ...J8.definition, prefix: "fas" },
  faChartLineUp: { ...Y8.definition, prefix: "fas" },
  faChartLineUpDown: { ...Z8.definition, prefix: "fas" },
  faChartMixed: { ...H.definition, prefix: "fas" },
  faChartMixedUpCircleCurrency: { ...p8.definition, prefix: "fas" },
  faChartMixedUpCircleDollar: { ...x8.definition, prefix: "fas" },
  faChartNetwork: { ...i5.definition, prefix: "fas" },
  faChartPieAlt: { ...a5.definition, prefix: "fas" },
  faChartPieSimple: { ...F2.definition, prefix: "fas" },
  faChartPieSimpleCircleCurrency: { ...e5.definition, prefix: "fas" },
  faChartPieSimpleCircleDollar: { ...n5.definition, prefix: "fas" },
  faChartPyramid: { ...f5.definition, prefix: "fas" },
  faChartRadar: { ...c5.definition, prefix: "fas" },
  faChartScatter: { ...t5.definition, prefix: "fas" },
  faChartScatter3d: { ...o5.definition, prefix: "fas" },
  faChartScatterBubble: { ...l5.definition, prefix: "fas" },
  faChartSimpleHorizontal: { ...d5.definition, prefix: "fas" },
  faChartTreeMap: { ...r5.definition, prefix: "fas" },
  faChartUser: { ...H2.definition, prefix: "fas" },
  faChartWaterfall: { ...s5.definition, prefix: "fas" },
  faCheeseSwiss: { ...h5.definition, prefix: "fas" },
  faCheeseburger: { ...v5.definition, prefix: "fas" },
  faCherries: { ...u5.definition, prefix: "fas" },
  faChessBishopAlt: { ...m5.definition, prefix: "fas" },
  faChessBishopPiece: { ...R2.definition, prefix: "fas" },
  faChessClock: { ...g5.definition, prefix: "fas" },
  faChessClockAlt: { ...P5.definition, prefix: "fas" },
  faChessClockFlip: { ...U2.definition, prefix: "fas" },
  faChessKingAlt: { ...M5.definition, prefix: "fas" },
  faChessKingPiece: { ...q2.definition, prefix: "fas" },
  faChessKnightAlt: { ...w5.definition, prefix: "fas" },
  faChessKnightPiece: { ...G2.definition, prefix: "fas" },
  faChessPawnAlt: { ...N5.definition, prefix: "fas" },
  faChessPawnPiece: { ...W2.definition, prefix: "fas" },
  faChessQueenAlt: { ...z5.definition, prefix: "fas" },
  faChessQueenPiece: { ...E2.definition, prefix: "fas" },
  faChessRookAlt: { ...L5.definition, prefix: "fas" },
  faChessRookPiece: { ...V2.definition, prefix: "fas" },
  faChestnut: { ...C5.definition, prefix: "fas" },
  faChevronDoubleDown: { ...D5.definition, prefix: "fas" },
  faChevronDoubleLeft: { ...$5.definition, prefix: "fas" },
  faChevronDoubleRight: { ..._5.definition, prefix: "fas" },
  faChevronDoubleUp: { ...b5.definition, prefix: "fas" },
  faChevronSquareDown: { ...S5.definition, prefix: "fas" },
  faChevronSquareLeft: { ...y5.definition, prefix: "fas" },
  faChevronSquareRight: { ...O5.definition, prefix: "fas" },
  faChevronSquareUp: { ...k5.definition, prefix: "fas" },
  faChevronsDown: { ...I2.definition, prefix: "fas" },
  faChevronsLeft: { ...K2.definition, prefix: "fas" },
  faChevronsRight: { ...X2.definition, prefix: "fas" },
  faChevronsUp: { ...Q2.definition, prefix: "fas" },
  faChfSign: { ...A5.definition, prefix: "fas" },
  faChimney: { ...j5.definition, prefix: "fas" },
  faChocolateBar: { ...B5.definition, prefix: "fas" },
  faChopsticks: { ...T5.definition, prefix: "fas" },
  faCircle0: { ...F5.definition, prefix: "fas" },
  faCircle1: { ...H5.definition, prefix: "fas" },
  faCircle2: { ...R5.definition, prefix: "fas" },
  faCircle3: { ...U5.definition, prefix: "fas" },
  faCircle4: { ...q5.definition, prefix: "fas" },
  faCircle5: { ...G5.definition, prefix: "fas" },
  faCircle6: { ...W5.definition, prefix: "fas" },
  faCircle7: { ...E5.definition, prefix: "fas" },
  faCircle8: { ...V5.definition, prefix: "fas" },
  faCircle9: { ...I5.definition, prefix: "fas" },
  faCircleA: { ...K5.definition, prefix: "fas" },
  faCircleAmpersand: { ...X5.definition, prefix: "fas" },
  faCircleArrowDownLeft: { ...Q5.definition, prefix: "fas" },
  faCircleArrowDownRight: { ...J5.definition, prefix: "fas" },
  faCircleArrowUpLeft: { ...Y5.definition, prefix: "fas" },
  faCircleArrowUpRight: { ...Z5.definition, prefix: "fas" },
  faCircleB: { ...p5.definition, prefix: "fas" },
  faCircleBolt: { ...x5.definition, prefix: "fas" },
  faCircleBookOpen: { ...Wi.definition, prefix: "fas" },
  faCircleBookmark: { ...Ki.definition, prefix: "fas" },
  faCircleC: { ...i7.definition, prefix: "fas" },
  faCircleCalendar: { ...h2.definition, prefix: "fas" },
  faCircleCamera: { ...M2.definition, prefix: "fas" },
  faCircleCaretDown: { ..._2.definition, prefix: "fas" },
  faCircleCaretLeft: { ...b2.definition, prefix: "fas" },
  faCircleCaretRight: { ...S2.definition, prefix: "fas" },
  faCircleCaretUp: { ...y2.definition, prefix: "fas" },
  faCircleD: { ...a7.definition, prefix: "fas" },
  faCircleDashed: { ...e7.definition, prefix: "fas" },
  faCircleDivide: { ...n7.definition, prefix: "fas" },
  faCircleDollar: { ...v.definition, prefix: "fas" },
  faCircleDownLeft: { ...f7.definition, prefix: "fas" },
  faCircleDownRight: { ...c7.definition, prefix: "fas" },
  faCircleE: { ...t7.definition, prefix: "fas" },
  faCircleEllipsis: { ...o7.definition, prefix: "fas" },
  faCircleEllipsisVertical: { ...l7.definition, prefix: "fas" },
  faCircleEnvelope: { ...x2.definition, prefix: "fas" },
  faCircleEuro: { ...d7.definition, prefix: "fas" },
  faCircleExclamationCheck: { ...r7.definition, prefix: "fas" },
  faCircleF: { ...s7.definition, prefix: "fas" },
  faCircleG: { ...h7.definition, prefix: "fas" },
  faCircleGf: { ...v7.definition, prefix: "fas" },
  faCircleHalf: { ...u7.definition, prefix: "fas" },
  faCircleHeart: { ...i1.definition, prefix: "fas" },
  faCircleI: { ...m7.definition, prefix: "fas" },
  faCircleJ: { ...g7.definition, prefix: "fas" },
  faCircleK: { ...P7.definition, prefix: "fas" },
  faCircleL: { ...M7.definition, prefix: "fas" },
  faCircleLocationArrow: { ...a1.definition, prefix: "fas" },
  faCircleM: { ...w7.definition, prefix: "fas" },
  faCircleMicrophone: { ...e1.definition, prefix: "fas" },
  faCircleMicrophoneLines: { ...n1.definition, prefix: "fas" },
  faCircleN: { ...N7.definition, prefix: "fas" },
  faCircleO: { ...z7.definition, prefix: "fas" },
  faCircleP: { ...L7.definition, prefix: "fas" },
  faCircleParking: { ...f1.definition, prefix: "fas" },
  faCirclePhone: { ...c1.definition, prefix: "fas" },
  faCirclePhoneFlip: { ...t1.definition, prefix: "fas" },
  faCirclePhoneHangup: { ...o1.definition, prefix: "fas" },
  faCircleQ: { ...C7.definition, prefix: "fas" },
  faCircleQuarter: { ...D7.definition, prefix: "fas" },
  faCircleQuarterStroke: { ...$7.definition, prefix: "fas" },
  faCircleQuarters: { ..._7.definition, prefix: "fas" },
  faCircleR: { ...b7.definition, prefix: "fas" },
  faCircleS: { ...S7.definition, prefix: "fas" },
  faCircleSmall: { ...y7.definition, prefix: "fas" },
  faCircleSort: { ...l1.definition, prefix: "fas" },
  faCircleSortDown: { ...d1.definition, prefix: "fas" },
  faCircleSortUp: { ...r1.definition, prefix: "fas" },
  faCircleStar: { ...s1.definition, prefix: "fas" },
  faCircleSterling: { ...O7.definition, prefix: "fas" },
  faCircleT: { ...k7.definition, prefix: "fas" },
  faCircleThreeQuarters: { ...A7.definition, prefix: "fas" },
  faCircleThreeQuartersStroke: { ...j7.definition, prefix: "fas" },
  faCircleTrash: { ...h1.definition, prefix: "fas" },
  faCircleU: { ...B7.definition, prefix: "fas" },
  faCircleUpLeft: { ...T7.definition, prefix: "fas" },
  faCircleUpRight: { ...F7.definition, prefix: "fas" },
  faCircleV: { ...H7.definition, prefix: "fas" },
  faCircleVideo: { ...v1.definition, prefix: "fas" },
  faCircleW: { ...R7.definition, prefix: "fas" },
  faCircleWaveformLines: { ...u1.definition, prefix: "fas" },
  faCircleWifi: { ...U7.definition, prefix: "fas" },
  faCircleWifiCircleWifi: { ...m1.definition, prefix: "fas" },
  faCircleWifiGroup: { ...q7.definition, prefix: "fas" },
  faCircleX: { ...G7.definition, prefix: "fas" },
  faCircleY: { ...W7.definition, prefix: "fas" },
  faCircleYen: { ...E7.definition, prefix: "fas" },
  faCircleZ: { ...V7.definition, prefix: "fas" },
  faCirclesOverlap: { ...I7.definition, prefix: "fas" },
  faCitrus: { ...K7.definition, prefix: "fas" },
  faCitrusSlice: { ...X7.definition, prefix: "fas" },
  faClapperboardPlay: { ...Q7.definition, prefix: "fas" },
  faClarinet: { ...J7.definition, prefix: "fas" },
  faClawMarks: { ...Y7.definition, prefix: "fas" },
  faClipboardListCheck: { ...Z7.definition, prefix: "fas" },
  faClipboardMedical: { ...p7.definition, prefix: "fas" },
  faClipboardPrescription: { ...x7.definition, prefix: "fas" },
  faClockDesk: { ...it.definition, prefix: "fas" },
  faClockEight: { ...at.definition, prefix: "fas" },
  faClockEightThirty: { ...et.definition, prefix: "fas" },
  faClockEleven: { ...nt.definition, prefix: "fas" },
  faClockElevenThirty: { ...ft.definition, prefix: "fas" },
  faClockFive: { ...ct.definition, prefix: "fas" },
  faClockFiveThirty: { ...tt.definition, prefix: "fas" },
  faClockFourThirty: { ...ot.definition, prefix: "fas" },
  faClockNine: { ...lt.definition, prefix: "fas" },
  faClockNineThirty: { ...dt.definition, prefix: "fas" },
  faClockOne: { ...rt.definition, prefix: "fas" },
  faClockOneThirty: { ...st.definition, prefix: "fas" },
  faClockSeven: { ...ht.definition, prefix: "fas" },
  faClockSevenThirty: { ...vt.definition, prefix: "fas" },
  faClockSix: { ...ut.definition, prefix: "fas" },
  faClockSixThirty: { ...mt.definition, prefix: "fas" },
  faClockTen: { ...gt.definition, prefix: "fas" },
  faClockTenThirty: { ...Pt.definition, prefix: "fas" },
  faClockThree: { ...Mt.definition, prefix: "fas" },
  faClockThreeThirty: { ...wt.definition, prefix: "fas" },
  faClockTwelve: { ...Nt.definition, prefix: "fas" },
  faClockTwelveThirty: { ...zt.definition, prefix: "fas" },
  faClockTwo: { ...Lt.definition, prefix: "fas" },
  faClockTwoThirty: { ...Ct.definition, prefix: "fas" },
  faClosedCaptioningSlash: { ...Dt.definition, prefix: "fas" },
  faClothesHanger: { ...$t.definition, prefix: "fas" },
  faCloudBinary: { ..._t.definition, prefix: "fas" },
  faCloudBoltMoon: { ...g1.definition, prefix: "fas" },
  faCloudBoltSun: { ...P1.definition, prefix: "fas" },
  faCloudCheck: { ...bt.definition, prefix: "fas" },
  faCloudDrizzle: { ...St.definition, prefix: "fas" },
  faCloudExclamation: { ...yt.definition, prefix: "fas" },
  faCloudFog: { ...M1.definition, prefix: "fas" },
  faCloudHail: { ...Ot.definition, prefix: "fas" },
  faCloudHailMixed: { ...kt.definition, prefix: "fas" },
  faCloudMinus: { ...At.definition, prefix: "fas" },
  faCloudMusic: { ...jt.definition, prefix: "fas" },
  faCloudPlus: { ...Bt.definition, prefix: "fas" },
  faCloudQuestion: { ...Tt.definition, prefix: "fas" },
  faCloudRainbow: { ...Ft.definition, prefix: "fas" },
  faCloudShowers: { ...Ht.definition, prefix: "fas" },
  faCloudSlash: { ...Rt.definition, prefix: "fas" },
  faCloudSleet: { ...Ut.definition, prefix: "fas" },
  faCloudSnow: { ...qt.definition, prefix: "fas" },
  faCloudWord: { ...Gt.definition, prefix: "fas" },
  faCloudXmark: { ...Wt.definition, prefix: "fas" },
  faClouds: { ...Et.definition, prefix: "fas" },
  faCloudsMoon: { ...Vt.definition, prefix: "fas" },
  faCloudsSun: { ...It.definition, prefix: "fas" },
  faClub: { ...Kt.definition, prefix: "fas" },
  faCoconut: { ...Xt.definition, prefix: "fas" },
  faCodePullRequestClosed: { ...Qt.definition, prefix: "fas" },
  faCodePullRequestDraft: { ...Jt.definition, prefix: "fas" },
  faCodeSimple: { ...Yt.definition, prefix: "fas" },
  faCoffeeBean: { ...Zt.definition, prefix: "fas" },
  faCoffeeBeans: { ...pt.definition, prefix: "fas" },
  faCoffeePot: { ...xt.definition, prefix: "fas" },
  faCoffeeTogo: { ...io.definition, prefix: "fas" },
  faCoffin: { ...ao.definition, prefix: "fas" },
  faCoffinCross: { ...eo.definition, prefix: "fas" },
  faCoin: { ...no.definition, prefix: "fas" },
  faCoinBlank: { ...fo.definition, prefix: "fas" },
  faCoinFront: { ...co.definition, prefix: "fas" },
  faCoinVertical: { ...to.definition, prefix: "fas" },
  faColon: { ...oo.definition, prefix: "fas" },
  faColumns3: { ...lo.definition, prefix: "fas" },
  faComet: { ...ro.definition, prefix: "fas" },
  faComma: { ...so.definition, prefix: "fas" },
  faCommand: { ...ho.definition, prefix: "fas" },
  faCommentAltArrowDown: { ...vo.definition, prefix: "fas" },
  faCommentAltArrowUp: { ...uo.definition, prefix: "fas" },
  faCommentAltCaptions: { ...mo.definition, prefix: "fas" },
  faCommentAltCheck: { ...go.definition, prefix: "fas" },
  faCommentAltDollar: { ...Po.definition, prefix: "fas" },
  faCommentAltDots: { ...Mo.definition, prefix: "fas" },
  faCommentAltEdit: { ...wo.definition, prefix: "fas" },
  faCommentAltExclamation: { ...No.definition, prefix: "fas" },
  faCommentAltImage: { ...zo.definition, prefix: "fas" },
  faCommentAltLines: { ...Lo.definition, prefix: "fas" },
  faCommentAltMedical: { ...Co.definition, prefix: "fas" },
  faCommentAltMinus: { ...Do.definition, prefix: "fas" },
  faCommentAltMusic: { ...$o.definition, prefix: "fas" },
  faCommentAltPlus: { ..._o.definition, prefix: "fas" },
  faCommentAltQuote: { ...bo.definition, prefix: "fas" },
  faCommentAltSlash: { ...So.definition, prefix: "fas" },
  faCommentAltSmile: { ...yo.definition, prefix: "fas" },
  faCommentAltText: { ...Oo.definition, prefix: "fas" },
  faCommentAltTimes: { ...ko.definition, prefix: "fas" },
  faCommentArrowDown: { ...Ao.definition, prefix: "fas" },
  faCommentArrowUp: { ...jo.definition, prefix: "fas" },
  faCommentArrowUpRight: { ...Bo.definition, prefix: "fas" },
  faCommentCaptions: { ...To.definition, prefix: "fas" },
  faCommentCheck: { ...Fo.definition, prefix: "fas" },
  faCommentCode: { ...Ho.definition, prefix: "fas" },
  faCommentEdit: { ...Ro.definition, prefix: "fas" },
  faCommentExclamation: { ...Uo.definition, prefix: "fas" },
  faCommentHeart: { ...qo.definition, prefix: "fas" },
  faCommentImage: { ...Go.definition, prefix: "fas" },
  faCommentLines: { ...Wo.definition, prefix: "fas" },
  faCommentMiddle: { ...Eo.definition, prefix: "fas" },
  faCommentMiddleAlt: { ...Vo.definition, prefix: "fas" },
  faCommentMiddleTop: { ...Io.definition, prefix: "fas" },
  faCommentMiddleTopAlt: { ...Ko.definition, prefix: "fas" },
  faCommentMinus: { ...Xo.definition, prefix: "fas" },
  faCommentMusic: { ...Qo.definition, prefix: "fas" },
  faCommentPen: { ...F1.definition, prefix: "fas" },
  faCommentPlus: { ...Jo.definition, prefix: "fas" },
  faCommentQuestion: { ...Yo.definition, prefix: "fas" },
  faCommentQuote: { ...Zo.definition, prefix: "fas" },
  faCommentSmile: { ...po.definition, prefix: "fas" },
  faCommentText: { ...xo.definition, prefix: "fas" },
  faCommentTimes: { ...il.definition, prefix: "fas" },
  faCommentXmark: { ...U1.definition, prefix: "fas" },
  faCommentsAlt: { ...al.definition, prefix: "fas" },
  faCommentsAltDollar: { ...el.definition, prefix: "fas" },
  faCommentsQuestion: { ...nl.definition, prefix: "fas" },
  faCommentsQuestionCheck: { ...fl.definition, prefix: "fas" },
  faCompassSlash: { ...cl.definition, prefix: "fas" },
  faCompressArrows: { ...tl.definition, prefix: "fas" },
  faCompressWide: { ...ol.definition, prefix: "fas" },
  faComputerClassic: { ...ll.definition, prefix: "fas" },
  faComputerMouseScrollwheel: { ...W1.definition, prefix: "fas" },
  faComputerSpeaker: { ...dl.definition, prefix: "fas" },
  faConstruction: { ...rl.definition, prefix: "fas" },
  faContainerStorage: { ...sl.definition, prefix: "fas" },
  faConveyorBelt: { ...hl.definition, prefix: "fas" },
  faConveyorBeltAlt: { ...vl.definition, prefix: "fas" },
  faConveyorBeltArm: { ...ul.definition, prefix: "fas" },
  faConveyorBeltBoxes: { ...V1.definition, prefix: "fas" },
  faConveyorBeltEmpty: { ...ml.definition, prefix: "fas" },
  faCorn: { ...gl.definition, prefix: "fas" },
  faCorner: { ...Pl.definition, prefix: "fas" },
  faCouchSmall: { ...Ml.definition, prefix: "fas" },
  faCourtSport: { ...wl.definition, prefix: "fas" },
  faCowbell: { ...Nl.definition, prefix: "fas" },
  faCowbellCirclePlus: { ...K1.definition, prefix: "fas" },
  faCowbellMore: { ...zl.definition, prefix: "fas" },
  faCrab: { ...Ll.definition, prefix: "fas" },
  faCrateApple: { ...R.definition, prefix: "fas" },
  faCrateEmpty: { ...Cl.definition, prefix: "fas" },
  faCreditCardBlank: { ...Dl.definition, prefix: "fas" },
  faCreditCardFront: { ...$l.definition, prefix: "fas" },
  faCreemee: { ..._l.definition, prefix: "fas" },
  faCricket: { ...bl.definition, prefix: "fas" },
  faCricketBatBall: { ...Q1.definition, prefix: "fas" },
  faCroissant: { ...Sl.definition, prefix: "fas" },
  faCrosshairsSimple: { ...yl.definition, prefix: "fas" },
  faCrutches: { ...Ol.definition, prefix: "fas" },
  faCrystalBall: { ...kl.definition, prefix: "fas" },
  faCucumber: { ...Al.definition, prefix: "fas" },
  faCupStraw: { ...jl.definition, prefix: "fas" },
  faCupStrawSwoosh: { ...Bl.definition, prefix: "fas" },
  faCupTogo: { ...w1.definition, prefix: "fas" },
  faCupcake: { ...Tl.definition, prefix: "fas" },
  faCurling: { ...Fl.definition, prefix: "fas" },
  faCurlingStone: { ...J1.definition, prefix: "fas" },
  faCustard: { ...Hl.definition, prefix: "fas" },
  faDagger: { ...Rl.definition, prefix: "fas" },
  faDash: { ...Y1.definition, prefix: "fas" },
  faDebug: { ...Ul.definition, prefix: "fas" },
  faDeer: { ...ql.definition, prefix: "fas" },
  faDeerRudolph: { ...Gl.definition, prefix: "fas" },
  faDeleteRight: { ...Wl.definition, prefix: "fas" },
  faDesktopArrowDown: { ...El.definition, prefix: "fas" },
  faDesktopCode: { ...Vl.definition, prefix: "fas" },
  faDesktopMedical: { ...Il.definition, prefix: "fas" },
  faDesktopSlash: { ...Kl.definition, prefix: "fas" },
  faDewpoint: { ...Xl.definition, prefix: "fas" },
  faDiagramCells: { ...Ql.definition, prefix: "fas" },
  faDiagramLeanCanvas: { ...Jl.definition, prefix: "fas" },
  faDiagramNested: { ...Yl.definition, prefix: "fas" },
  faDiagramPrevious: { ...Zl.definition, prefix: "fas" },
  faDiagramSankey: { ...pl.definition, prefix: "fas" },
  faDiagramSubtask: { ...xl.definition, prefix: "fas" },
  faDiagramVenn: { ...id.definition, prefix: "fas" },
  faDial: { ...aa.definition, prefix: "fas" },
  faDialHigh: { ...ad.definition, prefix: "fas" },
  faDialLow: { ...ed.definition, prefix: "fas" },
  faDialMax: { ...nd.definition, prefix: "fas" },
  faDialMed: { ...fd.definition, prefix: "fas" },
  faDialMedHigh: { ...cd.definition, prefix: "fas" },
  faDialMedLow: { ...td.definition, prefix: "fas" },
  faDialMin: { ...od.definition, prefix: "fas" },
  faDialOff: { ...ld.definition, prefix: "fas" },
  faDiamondExclamation: { ...dd.definition, prefix: "fas" },
  faDiamondHalf: { ...rd.definition, prefix: "fas" },
  faDiamondHalfStroke: { ...sd.definition, prefix: "fas" },
  faDiamonds4: { ...hd.definition, prefix: "fas" },
  faDiceD10: { ...vd.definition, prefix: "fas" },
  faDiceD12: { ...ud.definition, prefix: "fas" },
  faDiceD4: { ...md.definition, prefix: "fas" },
  faDiceD8: { ...gd.definition, prefix: "fas" },
  faDinosaur: { ...Pd.definition, prefix: "fas" },
  faDiploma: { ...ea.definition, prefix: "fas" },
  faDiscDrive: { ...Md.definition, prefix: "fas" },
  faDisplayArrowDown: { ...wd.definition, prefix: "fas" },
  faDisplayChartUp: { ...Nd.definition, prefix: "fas" },
  faDisplayChartUpCircleCurrency: { ...zd.definition, prefix: "fas" },
  faDisplayChartUpCircleDollar: { ...Ld.definition, prefix: "fas" },
  faDisplayCode: { ...Z1.definition, prefix: "fas" },
  faDisplayMedical: { ...p1.definition, prefix: "fas" },
  faDisplaySlash: { ...x1.definition, prefix: "fas" },
  faDistributeSpacingHorizontal: { ...Cd.definition, prefix: "fas" },
  faDistributeSpacingVertical: { ...Dd.definition, prefix: "fas" },
  faDitto: { ...$d.definition, prefix: "fas" },
  faDoNotEnter: { ..._d.definition, prefix: "fas" },
  faDogLeashed: { ...bd.definition, prefix: "fas" },
  faDollarCircle: { ...Sd.definition, prefix: "fas" },
  faDollarSquare: { ...yd.definition, prefix: "fas" },
  faDollyEmpty: { ...Od.definition, prefix: "fas" },
  faDollyFlatbedAlt: { ...kd.definition, prefix: "fas" },
  faDollyFlatbedEmpty: { ...Ad.definition, prefix: "fas" },
  faDolphin: { ...jd.definition, prefix: "fas" },
  faDonut: { ...na.definition, prefix: "fas" },
  faDoughnut: { ...Bd.definition, prefix: "fas" },
  faDown: { ...U.definition, prefix: "fas" },
  faDownFromBracket: { ...Td.definition, prefix: "fas" },
  faDownFromDottedLine: { ...Fd.definition, prefix: "fas" },
  faDownFromLine: { ...E.definition, prefix: "fas" },
  faDownLeft: { ...Hd.definition, prefix: "fas" },
  faDownRight: { ...Rd.definition, prefix: "fas" },
  faDownToBracket: { ...Ud.definition, prefix: "fas" },
  faDownToDottedLine: { ...qd.definition, prefix: "fas" },
  faDownToLine: { ...Y.definition, prefix: "fas" },
  faDrawCircle: { ...Gd.definition, prefix: "fas" },
  faDrawSquare: { ...Wd.definition, prefix: "fas" },
  faDreidel: { ...Ed.definition, prefix: "fas" },
  faDrone: { ...Vd.definition, prefix: "fas" },
  faDroneAlt: { ...Id.definition, prefix: "fas" },
  faDroneFront: { ...fa.definition, prefix: "fas" },
  faDropletDegree: { ...ia.definition, prefix: "fas" },
  faDropletPercent: { ...ca.definition, prefix: "fas" },
  faDrumstick: { ...Kd.definition, prefix: "fas" },
  faDryer: { ...Xd.definition, prefix: "fas" },
  faDryerAlt: { ...Qd.definition, prefix: "fas" },
  faDryerHeat: { ...ta.definition, prefix: "fas" },
  faDuck: { ...Jd.definition, prefix: "fas" },
  faEar: { ...Yd.definition, prefix: "fas" },
  faEarMuffs: { ...Zd.definition, prefix: "fas" },
  faEclipse: { ...pd.definition, prefix: "fas" },
  faEclipseAlt: { ...xd.definition, prefix: "fas" },
  faEggFried: { ...ir.definition, prefix: "fas" },
  faEggplant: { ...ar.definition, prefix: "fas" },
  faElephant: { ...er.definition, prefix: "fas" },
  faEllipsisHAlt: { ...nr.definition, prefix: "fas" },
  faEllipsisStroke: { ...la.definition, prefix: "fas" },
  faEllipsisStrokeVertical: { ...da.definition, prefix: "fas" },
  faEllipsisVAlt: { ...fr.definition, prefix: "fas" },
  faEmptySet: { ...cr.definition, prefix: "fas" },
  faEngine: { ...tr.definition, prefix: "fas" },
  faEngineExclamation: { ...or.definition, prefix: "fas" },
  faEngineWarning: { ...ra.definition, prefix: "fas" },
  faEnvelopeBadge: { ...lr.definition, prefix: "fas" },
  faEnvelopeCircle: { ...dr.definition, prefix: "fas" },
  faEnvelopeDot: { ...sa.definition, prefix: "fas" },
  faEnvelopeOpenDollar: { ...rr.definition, prefix: "fas" },
  faEnvelopes: { ...sr.definition, prefix: "fas" },
  faEscalator: { ...hr.definition, prefix: "fas" },
  faExcavator: { ...vr.definition, prefix: "fas" },
  faExclamationSquare: { ...ur.definition, prefix: "fas" },
  faExpandArrows: { ...mr.definition, prefix: "fas" },
  faExpandWide: { ...gr.definition, prefix: "fas" },
  faExplodingHead: { ...Pr.definition, prefix: "fas" },
  faEyeDropperFull: { ...Mr.definition, prefix: "fas" },
  faEyeDropperHalf: { ...wr.definition, prefix: "fas" },
  faEyeEvil: { ...Nr.definition, prefix: "fas" },
  faEyes: { ...zr.definition, prefix: "fas" },
  faFaceAngryHorns: { ...Lr.definition, prefix: "fas" },
  faFaceAnguished: { ...Cr.definition, prefix: "fas" },
  faFaceAnxiousSweat: { ...Dr.definition, prefix: "fas" },
  faFaceAstonished: { ...$r.definition, prefix: "fas" },
  faFaceAwesome: { ...ua.definition, prefix: "fas" },
  faFaceBeamHandOverMouth: { ..._r.definition, prefix: "fas" },
  faFaceClouds: { ...br.definition, prefix: "fas" },
  faFaceConfounded: { ...Sr.definition, prefix: "fas" },
  faFaceConfused: { ...yr.definition, prefix: "fas" },
  faFaceCowboyHat: { ...Or.definition, prefix: "fas" },
  faFaceDiagonalMouth: { ...kr.definition, prefix: "fas" },
  faFaceDisappointed: { ...Ar.definition, prefix: "fas" },
  faFaceDisguise: { ...jr.definition, prefix: "fas" },
  faFaceDotted: { ...Br.definition, prefix: "fas" },
  faFaceDowncastSweat: { ...Tr.definition, prefix: "fas" },
  faFaceDrooling: { ...Fr.definition, prefix: "fas" },
  faFaceExhaling: { ...Hr.definition, prefix: "fas" },
  faFaceExplode: { ...va.definition, prefix: "fas" },
  faFaceExpressionless: { ...Rr.definition, prefix: "fas" },
  faFaceEyesXmarks: { ...Ur.definition, prefix: "fas" },
  faFaceFearful: { ...qr.definition, prefix: "fas" },
  faFaceFrownSlight: { ...Gr.definition, prefix: "fas" },
  faFaceGlasses: { ...Wr.definition, prefix: "fas" },
  faFaceHandOverMouth: { ...Er.definition, prefix: "fas" },
  faFaceHandPeeking: { ...Vr.definition, prefix: "fas" },
  faFaceHandYawn: { ...Ir.definition, prefix: "fas" },
  faFaceHeadBandage: { ...Kr.definition, prefix: "fas" },
  faFaceHoldingBackTears: { ...Xr.definition, prefix: "fas" },
  faFaceHushed: { ...Qr.definition, prefix: "fas" },
  faFaceIcicles: { ...Jr.definition, prefix: "fas" },
  faFaceKissClosedEyes: { ...Yr.definition, prefix: "fas" },
  faFaceLying: { ...Zr.definition, prefix: "fas" },
  faFaceMask: { ...pr.definition, prefix: "fas" },
  faFaceMelting: { ...xr.definition, prefix: "fas" },
  faFaceMonocle: { ...i9.definition, prefix: "fas" },
  faFaceNauseated: { ...a9.definition, prefix: "fas" },
  faFaceNoseSteam: { ...e9.definition, prefix: "fas" },
  faFaceParty: { ...n9.definition, prefix: "fas" },
  faFacePensive: { ...f9.definition, prefix: "fas" },
  faFacePersevering: { ...c9.definition, prefix: "fas" },
  faFacePleading: { ...t9.definition, prefix: "fas" },
  faFacePouting: { ...o9.definition, prefix: "fas" },
  faFaceRaisedEyebrow: { ...l9.definition, prefix: "fas" },
  faFaceRelieved: { ...d9.definition, prefix: "fas" },
  faFaceSadSweat: { ...r9.definition, prefix: "fas" },
  faFaceSaluting: { ...s9.definition, prefix: "fas" },
  faFaceScream: { ...h9.definition, prefix: "fas" },
  faFaceShush: { ...v9.definition, prefix: "fas" },
  faFaceSleeping: { ...u9.definition, prefix: "fas" },
  faFaceSleepy: { ...m9.definition, prefix: "fas" },
  faFaceSmileHalo: { ...g9.definition, prefix: "fas" },
  faFaceSmileHearts: { ...P9.definition, prefix: "fas" },
  faFaceSmileHorns: { ...M9.definition, prefix: "fas" },
  faFaceSmilePlus: { ...ma.definition, prefix: "fas" },
  faFaceSmileRelaxed: { ...w9.definition, prefix: "fas" },
  faFaceSmileTear: { ...N9.definition, prefix: "fas" },
  faFaceSmileTongue: { ...z9.definition, prefix: "fas" },
  faFaceSmileUpsideDown: { ...L9.definition, prefix: "fas" },
  faFaceSmilingHands: { ...C9.definition, prefix: "fas" },
  faFaceSmirking: { ...D9.definition, prefix: "fas" },
  faFaceSpiralEyes: { ...$9.definition, prefix: "fas" },
  faFaceSunglasses: { ..._9.definition, prefix: "fas" },
  faFaceSwear: { ...b9.definition, prefix: "fas" },
  faFaceThermometer: { ...S9.definition, prefix: "fas" },
  faFaceThinking: { ...y9.definition, prefix: "fas" },
  faFaceTissue: { ...O9.definition, prefix: "fas" },
  faFaceTongueMoney: { ...k9.definition, prefix: "fas" },
  faFaceTongueSweat: { ...A9.definition, prefix: "fas" },
  faFaceUnamused: { ...j9.definition, prefix: "fas" },
  faFaceViewfinder: { ...B9.definition, prefix: "fas" },
  faFaceVomit: { ...T9.definition, prefix: "fas" },
  faFaceWeary: { ...F9.definition, prefix: "fas" },
  faFaceWoozy: { ...H9.definition, prefix: "fas" },
  faFaceWorried: { ...R9.definition, prefix: "fas" },
  faFaceZany: { ...U9.definition, prefix: "fas" },
  faFaceZipper: { ...q9.definition, prefix: "fas" },
  faFalafel: { ...G9.definition, prefix: "fas" },
  faFamily: { ...W9.definition, prefix: "fas" },
  faFamilyDress: { ...E9.definition, prefix: "fas" },
  faFamilyPants: { ...V9.definition, prefix: "fas" },
  faFanTable: { ...I9.definition, prefix: "fas" },
  faFarm: { ...Ai.definition, prefix: "fas" },
  faFence: { ...K9.definition, prefix: "fas" },
  faFerrisWheel: { ...X9.definition, prefix: "fas" },
  faFieldHockey: { ...Q9.definition, prefix: "fas" },
  faFieldHockeyStickBall: { ...ga.definition, prefix: "fas" },
  faFileAward: { ...J9.definition, prefix: "fas" },
  faFileBinary: { ...Y9.definition, prefix: "fas" },
  faFileCad: { ...Z9.definition, prefix: "fas" },
  faFileCaretDown: { ...p9.definition, prefix: "fas" },
  faFileCaretUp: { ...x9.definition, prefix: "fas" },
  faFileCertificate: { ...Pa.definition, prefix: "fas" },
  faFileChartColumn: { ...Na.definition, prefix: "fas" },
  faFileChartLine: { ...is.definition, prefix: "fas" },
  faFileChartPie: { ...as.definition, prefix: "fas" },
  faFileCheck: { ...es.definition, prefix: "fas" },
  faFileCircleInfo: { ...ns.definition, prefix: "fas" },
  faFileDashedLine: { ...za.definition, prefix: "fas" },
  faFileDoc: { ...fs.definition, prefix: "fas" },
  faFileEps: { ...cs.definition, prefix: "fas" },
  faFileExclamation: { ...ts.definition, prefix: "fas" },
  faFileGif: { ...os.definition, prefix: "fas" },
  faFileHeart: { ...ls.definition, prefix: "fas" },
  faFileJpg: { ...ds.definition, prefix: "fas" },
  faFileLock: { ...rs.definition, prefix: "fas" },
  faFileMagnifyingGlass: { ...La.definition, prefix: "fas" },
  faFileMinus: { ...ss.definition, prefix: "fas" },
  faFileMov: { ...hs.definition, prefix: "fas" },
  faFileMp3: { ...vs.definition, prefix: "fas" },
  faFileMp4: { ...us.definition, prefix: "fas" },
  faFileMusic: { ...ms.definition, prefix: "fas" },
  faFilePlus: { ...gs.definition, prefix: "fas" },
  faFilePlusMinus: { ...Ps.definition, prefix: "fas" },
  faFilePng: { ...Ms.definition, prefix: "fas" },
  faFilePpt: { ...ws.definition, prefix: "fas" },
  faFileSearch: { ...Ns.definition, prefix: "fas" },
  faFileSlash: { ...zs.definition, prefix: "fas" },
  faFileSpreadsheet: { ...Ls.definition, prefix: "fas" },
  faFileSvg: { ...Cs.definition, prefix: "fas" },
  faFileTimes: { ...Ds.definition, prefix: "fas" },
  faFileUser: { ...$s.definition, prefix: "fas" },
  faFileVector: { ..._s.definition, prefix: "fas" },
  faFileXls: { ...bs.definition, prefix: "fas" },
  faFileXmark: { ...Ca.definition, prefix: "fas" },
  faFileXml: { ...Ss.definition, prefix: "fas" },
  faFileZip: { ...ys.definition, prefix: "fas" },
  faFiles: { ...Os.definition, prefix: "fas" },
  faFilesMedical: { ...ks.definition, prefix: "fas" },
  faFilmAlt: { ...As.definition, prefix: "fas" },
  faFilmCanister: { ...$a.definition, prefix: "fas" },
  faFilmCannister: { ...js.definition, prefix: "fas" },
  faFilmSimple: { ...Da.definition, prefix: "fas" },
  faFilmSlash: { ...Bs.definition, prefix: "fas" },
  faFilms: { ...Ts.definition, prefix: "fas" },
  faFilterList: { ...Fs.definition, prefix: "fas" },
  faFilterSlash: { ...Hs.definition, prefix: "fas" },
  faFilters: { ...Rs.definition, prefix: "fas" },
  faFireFlame: { ..._a.definition, prefix: "fas" },
  faFireHydrant: { ...Us.definition, prefix: "fas" },
  faFireSmoke: { ...qs.definition, prefix: "fas" },
  faFireplace: { ...Gs.definition, prefix: "fas" },
  faFirewall: { ...Ws.definition, prefix: "fas" },
  faFishBones: { ...Es.definition, prefix: "fas" },
  faFishCooked: { ...Vs.definition, prefix: "fas" },
  faFishingRod: { ...Is.definition, prefix: "fas" },
  faFlagAlt: { ...Ks.definition, prefix: "fas" },
  faFlagPennant: { ...Sa.definition, prefix: "fas" },
  faFlagSwallowtail: { ...ba.definition, prefix: "fas" },
  faFlame: { ...Xs.definition, prefix: "fas" },
  faFlashlight: { ...Qs.definition, prefix: "fas" },
  faFlaskGear: { ...Js.definition, prefix: "fas" },
  faFlaskPoison: { ...Ys.definition, prefix: "fas" },
  faFlaskPotion: { ...Zs.definition, prefix: "fas" },
  faFlaskRoundPoison: { ...ya.definition, prefix: "fas" },
  faFlaskRoundPotion: { ...Oa.definition, prefix: "fas" },
  faFlatbread: { ...ps.definition, prefix: "fas" },
  faFlatbreadStuffed: { ...xs.definition, prefix: "fas" },
  faFloppyDiskCircleArrowRight: { ...ka.definition, prefix: "fas" },
  faFloppyDiskCircleXmark: { ...d.definition, prefix: "fas" },
  faFloppyDiskPen: { ...ih.definition, prefix: "fas" },
  faFloppyDiskTimes: { ...ah.definition, prefix: "fas" },
  faFloppyDisks: { ...eh.definition, prefix: "fas" },
  faFlower: { ...nh.definition, prefix: "fas" },
  faFlowerDaffodil: { ...fh.definition, prefix: "fas" },
  faFlowerTulip: { ...ch.definition, prefix: "fas" },
  faFlute: { ...th.definition, prefix: "fas" },
  faFluxCapacitor: { ...oh.definition, prefix: "fas" },
  faFlyingDisc: { ...lh.definition, prefix: "fas" },
  faFog: { ...dh.definition, prefix: "fas" },
  faFolderArrowDown: { ...Aa.definition, prefix: "fas" },
  faFolderArrowUp: { ...ja.definition, prefix: "fas" },
  faFolderBookmark: { ...rh.definition, prefix: "fas" },
  faFolderCheck: { ...sh.definition, prefix: "fas" },
  faFolderCog: { ...hh.definition, prefix: "fas" },
  faFolderDownload: { ...vh.definition, prefix: "fas" },
  faFolderGear: { ...Ba.definition, prefix: "fas" },
  faFolderGrid: { ...uh.definition, prefix: "fas" },
  faFolderHeart: { ...mh.definition, prefix: "fas" },
  faFolderImage: { ...gh.definition, prefix: "fas" },
  faFolderMagnifyingGlass: { ...Ta.definition, prefix: "fas" },
  faFolderMedical: { ...Ph.definition, prefix: "fas" },
  faFolderMusic: { ...Mh.definition, prefix: "fas" },
  faFolderSearch: { ...wh.definition, prefix: "fas" },
  faFolderTimes: { ...Nh.definition, prefix: "fas" },
  faFolderUpload: { ...zh.definition, prefix: "fas" },
  faFolderUser: { ...Lh.definition, prefix: "fas" },
  faFolderXmark: { ...Fa.definition, prefix: "fas" },
  faFolders: { ...Ch.definition, prefix: "fas" },
  faFonduePot: { ...Dh.definition, prefix: "fas" },
  faFontCase: { ...$h.definition, prefix: "fas" },
  faFootballHelmet: { ..._h.definition, prefix: "fas" },
  faFork: { ...Ha.definition, prefix: "fas" },
  faForkKnife: { ...Ra.definition, prefix: "fas" },
  faForklift: { ...bh.definition, prefix: "fas" },
  faFort: { ...Sh.definition, prefix: "fas" },
  faFragile: { ...yh.definition, prefix: "fas" },
  faFrame: { ...Oh.definition, prefix: "fas" },
  faFrenchFries: { ...kh.definition, prefix: "fas" },
  faFrostyHead: { ...Ah.definition, prefix: "fas" },
  faFunction: { ...jh.definition, prefix: "fas" },
  faGalaxy: { ...Bh.definition, prefix: "fas" },
  faGalleryThumbnails: { ...Th.definition, prefix: "fas" },
  faGameBoard: { ...Fh.definition, prefix: "fas" },
  faGameBoardAlt: { ...Hh.definition, prefix: "fas" },
  faGameBoardSimple: { ...Ga.definition, prefix: "fas" },
  faGameConsoleHandheld: { ...Rh.definition, prefix: "fas" },
  faGameConsoleHandheldCrank: { ...Uh.definition, prefix: "fas" },
  faGamepadAlt: { ...qh.definition, prefix: "fas" },
  faGamepadModern: { ...Wa.definition, prefix: "fas" },
  faGarage: { ...Gh.definition, prefix: "fas" },
  faGarageCar: { ...Wh.definition, prefix: "fas" },
  faGarageOpen: { ...Eh.definition, prefix: "fas" },
  faGarlic: { ...Vh.definition, prefix: "fas" },
  faGasPumpSlash: { ...Ih.definition, prefix: "fas" },
  faGaugeCircleBolt: { ...Kh.definition, prefix: "fas" },
  faGaugeCircleMinus: { ...Xh.definition, prefix: "fas" },
  faGaugeCirclePlus: { ...Qh.definition, prefix: "fas" },
  faGaugeLow: { ...Ea.definition, prefix: "fas" },
  faGaugeMax: { ...Va.definition, prefix: "fas" },
  faGaugeMin: { ...Ia.definition, prefix: "fas" },
  faGaugeSimpleLow: { ...Ka.definition, prefix: "fas" },
  faGaugeSimpleMax: { ...Xa.definition, prefix: "fas" },
  faGaugeSimpleMin: { ...Qa.definition, prefix: "fas" },
  faGaveDandy: { ...Jh.definition, prefix: "fas" },
  faGearCode: { ...Yh.definition, prefix: "fas" },
  faGearComplex: { ...Zh.definition, prefix: "fas" },
  faGearComplexCode: { ...ph.definition, prefix: "fas" },
  faGif: { ...xh.definition, prefix: "fas" },
  faGiftCard: { ...iv.definition, prefix: "fas" },
  faGingerbreadMan: { ...av.definition, prefix: "fas" },
  faGlass: { ...ev.definition, prefix: "fas" },
  faGlassChampagne: { ...nv.definition, prefix: "fas" },
  faGlassCitrus: { ...fv.definition, prefix: "fas" },
  faGlassEmpty: { ...cv.definition, prefix: "fas" },
  faGlassHalf: { ...M.definition, prefix: "fas" },
  faGlassHalfEmpty: { ...tv.definition, prefix: "fas" },
  faGlassHalfFull: { ...ov.definition, prefix: "fas" },
  faGlassWhiskeyRocks: { ...lv.definition, prefix: "fas" },
  faGlassesAlt: { ...dv.definition, prefix: "fas" },
  faGlassesRound: { ...Ya.definition, prefix: "fas" },
  faGlobePointer: { ...rv.definition, prefix: "fas" },
  faGlobeSnow: { ...sv.definition, prefix: "fas" },
  faGlobeStand: { ...hv.definition, prefix: "fas" },
  faGlobeWifi: { ...vv.definition, prefix: "fas" },
  faGloveBoxing: { ...uv.definition, prefix: "fas" },
  faGoalNet: { ...mv.definition, prefix: "fas" },
  faGolfClub: { ...gv.definition, prefix: "fas" },
  faGolfFlagHole: { ...Pv.definition, prefix: "fas" },
  faGramophone: { ...Mv.definition, prefix: "fas" },
  faGrapes: { ...wv.definition, prefix: "fas" },
  faGrate: { ...Nv.definition, prefix: "fas" },
  faGrateDroplet: { ...zv.definition, prefix: "fas" },
  faGrid: { ...Za.definition, prefix: "fas" },
  faGrid2: { ...Lv.definition, prefix: "fas" },
  faGrid2Plus: { ...Cv.definition, prefix: "fas" },
  faGrid3: { ...Dv.definition, prefix: "fas" },
  faGrid4: { ...$v.definition, prefix: "fas" },
  faGrid5: { ..._v.definition, prefix: "fas" },
  faGridDividers: { ...bv.definition, prefix: "fas" },
  faGridHorizontal: { ...Sv.definition, prefix: "fas" },
  faGridRound: { ...yv.definition, prefix: "fas" },
  faGridRound2: { ...Ov.definition, prefix: "fas" },
  faGridRound2Plus: { ...kv.definition, prefix: "fas" },
  faGridRound4: { ...Av.definition, prefix: "fas" },
  faGridRound5: { ...jv.definition, prefix: "fas" },
  faGrill: { ...Bv.definition, prefix: "fas" },
  faGrillFire: { ...Tv.definition, prefix: "fas" },
  faGrillHot: { ...Fv.definition, prefix: "fas" },
  faGripDots: { ...Hv.definition, prefix: "fas" },
  faGripDotsVertical: { ...Rv.definition, prefix: "fas" },
  faGuitarElectric: { ...Uv.definition, prefix: "fas" },
  faGuitars: { ...qv.definition, prefix: "fas" },
  faGunSlash: { ...Gv.definition, prefix: "fas" },
  faGunSquirt: { ...Wv.definition, prefix: "fas" },
  faH1: { ...Ev.definition, prefix: "fas" },
  faH2: { ...Vv.definition, prefix: "fas" },
  faH3: { ...Iv.definition, prefix: "fas" },
  faH4: { ...Kv.definition, prefix: "fas" },
  faH5: { ...Xv.definition, prefix: "fas" },
  faH6: { ...Qv.definition, prefix: "fas" },
  faHammerBrush: { ...Jv.definition, prefix: "fas" },
  faHammerCrash: { ...Yv.definition, prefix: "fas" },
  faHammerWar: { ...Zv.definition, prefix: "fas" },
  faHandBackPointDown: { ...pv.definition, prefix: "fas" },
  faHandBackPointLeft: { ...xv.definition, prefix: "fas" },
  faHandBackPointRibbon: { ...iu.definition, prefix: "fas" },
  faHandBackPointRight: { ...au.definition, prefix: "fas" },
  faHandBackPointUp: { ...eu.definition, prefix: "fas" },
  faHandFingersCrossed: { ...nu.definition, prefix: "fas" },
  faHandHeart: { ...fu.definition, prefix: "fas" },
  faHandHoldingBox: { ...cu.definition, prefix: "fas" },
  faHandHoldingCircleDollar: { ...tu.definition, prefix: "fas" },
  faHandHoldingMagic: { ...ou.definition, prefix: "fas" },
  faHandHoldingSeedling: { ...lu.definition, prefix: "fas" },
  faHandHoldingSkull: { ...du.definition, prefix: "fas" },
  faHandHorns: { ...ru.definition, prefix: "fas" },
  faHandLove: { ...su.definition, prefix: "fas" },
  faHandPointRibbon: { ...hu.definition, prefix: "fas" },
  faHandReceiving: { ...vu.definition, prefix: "fas" },
  faHandWave: { ...uu.definition, prefix: "fas" },
  faHandsHeart: { ...mu.definition, prefix: "fas" },
  faHandsHoldingDiamond: { ...pa.definition, prefix: "fas" },
  faHandsHoldingDollar: { ...i4.definition, prefix: "fas" },
  faHandsHoldingHeart: { ...xa.definition, prefix: "fas" },
  faHandsUsd: { ...gu.definition, prefix: "fas" },
  faHashtagLock: { ...Pu.definition, prefix: "fas" },
  faHatBeach: { ...Mu.definition, prefix: "fas" },
  faHatChef: { ...wu.definition, prefix: "fas" },
  faHatSanta: { ...Nu.definition, prefix: "fas" },
  faHatWinter: { ...zu.definition, prefix: "fas" },
  faHatWitch: { ...Lu.definition, prefix: "fas" },
  faHeadSide: { ...Cu.definition, prefix: "fas" },
  faHeadSideBrain: { ...Du.definition, prefix: "fas" },
  faHeadSideGear: { ...$u.definition, prefix: "fas" },
  faHeadSideGoggles: { ...a4.definition, prefix: "fas" },
  faHeadSideHeadphones: { ..._u.definition, prefix: "fas" },
  faHeadSideHeart: { ...bu.definition, prefix: "fas" },
  faHeadSideMedical: { ...Su.definition, prefix: "fas" },
  faHeadVr: { ...yu.definition, prefix: "fas" },
  faHeartCircle: { ...Ou.definition, prefix: "fas" },
  faHeartHalf: { ...ku.definition, prefix: "fas" },
  faHeartHalfAlt: { ...Au.definition, prefix: "fas" },
  faHeartHalfStroke: { ...e4.definition, prefix: "fas" },
  faHeartRate: { ...ju.definition, prefix: "fas" },
  faHeartSquare: { ...Bu.definition, prefix: "fas" },
  faHeat: { ...Tu.definition, prefix: "fas" },
  faHelmetBattle: { ...Fu.definition, prefix: "fas" },
  faHexagon: { ...Hu.definition, prefix: "fas" },
  faHexagonCheck: { ...Ru.definition, prefix: "fas" },
  faHexagonDivide: { ...Uu.definition, prefix: "fas" },
  faHexagonExclamation: { ...qu.definition, prefix: "fas" },
  faHexagonImage: { ...Gu.definition, prefix: "fas" },
  faHexagonMinus: { ...c4.definition, prefix: "fas" },
  faHexagonPlus: { ...t4.definition, prefix: "fas" },
  faHexagonVerticalNft: { ...Wu.definition, prefix: "fas" },
  faHexagonVerticalNftSlanted: { ...Eu.definition, prefix: "fas" },
  faHexagonXmark: { ...w.definition, prefix: "fas" },
  faHighDefinition: { ...o4.definition, prefix: "fas" },
  faHighlighterLine: { ...Vu.definition, prefix: "fas" },
  faHockeyMask: { ...Iu.definition, prefix: "fas" },
  faHockeyStickPuck: { ...Ku.definition, prefix: "fas" },
  faHockeySticks: { ...Xu.definition, prefix: "fas" },
  faHomeBlank: { ...Qu.definition, prefix: "fas" },
  faHomeHeart: { ...Ju.definition, prefix: "fas" },
  faHoneyPot: { ...Yu.definition, prefix: "fas" },
  faHoodCloak: { ...Zu.definition, prefix: "fas" },
  faHorizontalRule: { ...pu.definition, prefix: "fas" },
  faHorseSaddle: { ...xu.definition, prefix: "fas" },
  faHose: { ...im.definition, prefix: "fas" },
  faHoseReel: { ...am.definition, prefix: "fas" },
  faHospitals: { ...em.definition, prefix: "fas" },
  faHourglassClock: { ...nm.definition, prefix: "fas" },
  faHouseBlank: { ...l4.definition, prefix: "fas" },
  faHouseBuilding: { ...fm.definition, prefix: "fas" },
  faHouseChimneyBlank: { ...cm.definition, prefix: "fas" },
  faHouseChimneyHeart: { ...tm.definition, prefix: "fas" },
  faHouseDay: { ...om.definition, prefix: "fas" },
  faHouseFlood: { ...lm.definition, prefix: "fas" },
  faHouseHeart: { ...d4.definition, prefix: "fas" },
  faHouseLeave: { ...dm.definition, prefix: "fas" },
  faHouseNight: { ...rm.definition, prefix: "fas" },
  faHousePersonArrive: { ...sm.definition, prefix: "fas" },
  faHousePersonDepart: { ...hm.definition, prefix: "fas" },
  faHousePersonLeave: { ...N.definition, prefix: "fas" },
  faHousePersonReturn: { ...z.definition, prefix: "fas" },
  faHouseReturn: { ...vm.definition, prefix: "fas" },
  faHouseTree: { ...um.definition, prefix: "fas" },
  faHouseTurret: { ...mm.definition, prefix: "fas" },
  faHouseWater: { ...r4.definition, prefix: "fas" },
  faHouseWindow: { ...gm.definition, prefix: "fas" },
  faHumidity: { ...Pm.definition, prefix: "fas" },
  faHundredPoints: { ...T.definition, prefix: "fas" },
  faHydra: { ...Mm.definition, prefix: "fas" },
  faHyphen: { ...wm.definition, prefix: "fas" },
  faIceSkate: { ...Nm.definition, prefix: "fas" },
  faIconsAlt: { ...zm.definition, prefix: "fas" },
  faImageLandscape: { ...h4.definition, prefix: "fas" },
  faImagePolaroid: { ...Lm.definition, prefix: "fas" },
  faImagePolaroidUser: { ...Cm.definition, prefix: "fas" },
  faImageSlash: { ...Dm.definition, prefix: "fas" },
  faImageUser: { ...$m.definition, prefix: "fas" },
  faImagesUser: { ..._m.definition, prefix: "fas" },
  faInboxArrowDown: { ...bm.definition, prefix: "fas" },
  faInboxArrowUp: { ...Sm.definition, prefix: "fas" },
  faInboxFull: { ...ym.definition, prefix: "fas" },
  faInboxIn: { ...v4.definition, prefix: "fas" },
  faInboxOut: { ...u4.definition, prefix: "fas" },
  faInboxes: { ...Om.definition, prefix: "fas" },
  faIndustryAlt: { ...km.definition, prefix: "fas" },
  faIndustryWindows: { ...m4.definition, prefix: "fas" },
  faInfoSquare: { ...Am.definition, prefix: "fas" },
  faInhaler: { ...jm.definition, prefix: "fas" },
  faInputNumeric: { ...Bm.definition, prefix: "fas" },
  faInputPipe: { ...Tm.definition, prefix: "fas" },
  faInputText: { ...Fm.definition, prefix: "fas" },
  faIntegral: { ...Hm.definition, prefix: "fas" },
  faInterrobang: { ...Rm.definition, prefix: "fas" },
  faIntersection: { ...Um.definition, prefix: "fas" },
  faInventory: { ...qm.definition, prefix: "fas" },
  faIslandTreePalm: { ...Gm.definition, prefix: "fas" },
  faIslandTropical: { ...M4.definition, prefix: "fas" },
  faJackOLantern: { ...Wm.definition, prefix: "fas" },
  faJoystick: { ...Em.definition, prefix: "fas" },
  faJug: { ...Vm.definition, prefix: "fas" },
  faJugBottle: { ...Im.definition, prefix: "fas" },
  faKazoo: { ...Km.definition, prefix: "fas" },
  faKerning: { ...Xm.definition, prefix: "fas" },
  faKeySkeleton: { ...Qm.definition, prefix: "fas" },
  faKeySkeletonLeftRight: { ...Jm.definition, prefix: "fas" },
  faKeyboardBrightness: { ...Ym.definition, prefix: "fas" },
  faKeyboardBrightnessLow: { ...Zm.definition, prefix: "fas" },
  faKeyboardDown: { ...pm.definition, prefix: "fas" },
  faKeyboardLeft: { ...xm.definition, prefix: "fas" },
  faKeynote: { ...ig.definition, prefix: "fas" },
  faKidneys: { ...ag.definition, prefix: "fas" },
  faKite: { ...eg.definition, prefix: "fas" },
  faKiwiFruit: { ...ng.definition, prefix: "fas" },
  faKnife: { ...w4.definition, prefix: "fas" },
  faKnifeKitchen: { ...fg.definition, prefix: "fas" },
  faLacrosseStick: { ...cg.definition, prefix: "fas" },
  faLacrosseStickBall: { ...tg.definition, prefix: "fas" },
  faLambda: { ...og.definition, prefix: "fas" },
  faLamp: { ...lg.definition, prefix: "fas" },
  faLampDesk: { ...dg.definition, prefix: "fas" },
  faLampFloor: { ...rg.definition, prefix: "fas" },
  faLampStreet: { ...sg.definition, prefix: "fas" },
  faLandmarkMagnifyingGlass: { ...hg.definition, prefix: "fas" },
  faLandscape: { ...vg.definition, prefix: "fas" },
  faLaptopArrowDown: { ...ug.definition, prefix: "fas" },
  faLaptopBinary: { ...mg.definition, prefix: "fas" },
  faLaptopMobile: { ...N4.definition, prefix: "fas" },
  faLaptopSlash: { ...gg.definition, prefix: "fas" },
  faLasso: { ...Pg.definition, prefix: "fas" },
  faLassoSparkles: { ...Mg.definition, prefix: "fas" },
  faLayerGroupMinus: { ...wg.definition, prefix: "fas" },
  faLayerGroupPlus: { ...Ng.definition, prefix: "fas" },
  faLayerMinus: { ...z4.definition, prefix: "fas" },
  faLayerPlus: { ...L4.definition, prefix: "fas" },
  faLeafHeart: { ...zg.definition, prefix: "fas" },
  faLeafMaple: { ...Lg.definition, prefix: "fas" },
  faLeafOak: { ...Cg.definition, prefix: "fas" },
  faLeafyGreen: { ...Dg.definition, prefix: "fas" },
  faLeft: { ...V.definition, prefix: "fas" },
  faLeftFromBracket: { ...$g.definition, prefix: "fas" },
  faLeftFromLine: { ...W.definition, prefix: "fas" },
  faLeftLongToLine: { ..._g.definition, prefix: "fas" },
  faLeftToBracket: { ...bg.definition, prefix: "fas" },
  faLeftToLine: { ...Z.definition, prefix: "fas" },
  faLightCeiling: { ...Sg.definition, prefix: "fas" },
  faLightEmergency: { ...yg.definition, prefix: "fas" },
  faLightEmergencyOn: { ...Og.definition, prefix: "fas" },
  faLightSwitch: { ...kg.definition, prefix: "fas" },
  faLightSwitchOff: { ...Ag.definition, prefix: "fas" },
  faLightSwitchOn: { ...jg.definition, prefix: "fas" },
  faLightbulbCfl: { ...Bg.definition, prefix: "fas" },
  faLightbulbCflOn: { ...Tg.definition, prefix: "fas" },
  faLightbulbDollar: { ...Fg.definition, prefix: "fas" },
  faLightbulbExclamation: { ...Hg.definition, prefix: "fas" },
  faLightbulbExclamationOn: { ...Rg.definition, prefix: "fas" },
  faLightbulbGear: { ...Ug.definition, prefix: "fas" },
  faLightbulbMessage: { ...qg.definition, prefix: "fas" },
  faLightbulbOn: { ...Gg.definition, prefix: "fas" },
  faLightbulbSlash: { ...Wg.definition, prefix: "fas" },
  faLighthouse: { ...Eg.definition, prefix: "fas" },
  faLightsHoliday: { ...Vg.definition, prefix: "fas" },
  faLineColumns: { ...Ig.definition, prefix: "fas" },
  faLineHeight: { ...Kg.definition, prefix: "fas" },
  faLinkHorizontal: { ...j2.definition, prefix: "fas" },
  faLinkHorizontalSlash: { ...B2.definition, prefix: "fas" },
  faLinkSimple: { ...Xg.definition, prefix: "fas" },
  faLinkSimpleSlash: { ...Qg.definition, prefix: "fas" },
  faLips: { ...Jg.definition, prefix: "fas" },
  faListDropdown: { ...Yg.definition, prefix: "fas" },
  faListMusic: { ...Zg.definition, prefix: "fas" },
  faListRadio: { ...pg.definition, prefix: "fas" },
  faListTimeline: { ...xg.definition, prefix: "fas" },
  faListTree: { ...iP.definition, prefix: "fas" },
  faLoader: { ...aP.definition, prefix: "fas" },
  faLobster: { ...eP.definition, prefix: "fas" },
  faLocationArrowUp: { ...nP.definition, prefix: "fas" },
  faLocationCheck: { ...C4.definition, prefix: "fas" },
  faLocationCircle: { ...fP.definition, prefix: "fas" },
  faLocationCrosshairsSlash: { ...D4.definition, prefix: "fas" },
  faLocationDotSlash: { ...$4.definition, prefix: "fas" },
  faLocationExclamation: { ..._4.definition, prefix: "fas" },
  faLocationMinus: { ...b4.definition, prefix: "fas" },
  faLocationPen: { ...S4.definition, prefix: "fas" },
  faLocationPinSlash: { ...y4.definition, prefix: "fas" },
  faLocationPlus: { ...O4.definition, prefix: "fas" },
  faLocationQuestion: { ...k4.definition, prefix: "fas" },
  faLocationSlash: { ...cP.definition, prefix: "fas" },
  faLocationSmile: { ...A4.definition, prefix: "fas" },
  faLocationXmark: { ...L.definition, prefix: "fas" },
  faLockA: { ...tP.definition, prefix: "fas" },
  faLockAlt: { ...oP.definition, prefix: "fas" },
  faLockHashtag: { ...lP.definition, prefix: "fas" },
  faLockKeyhole: { ...j4.definition, prefix: "fas" },
  faLockKeyholeOpen: { ...B4.definition, prefix: "fas" },
  faLockOpenAlt: { ...dP.definition, prefix: "fas" },
  faLollipop: { ...T4.definition, prefix: "fas" },
  faLollypop: { ...rP.definition, prefix: "fas" },
  faLoveseat: { ...I1.definition, prefix: "fas" },
  faLuchador: { ...sP.definition, prefix: "fas" },
  faLuchadorMask: { ...C.definition, prefix: "fas" },
  faMace: { ...hP.definition, prefix: "fas" },
  faMagnifyingGlassArrowsRotate: { ...vP.definition, prefix: "fas" },
  faMagnifyingGlassMusic: { ...uP.definition, prefix: "fas" },
  faMagnifyingGlassPlay: { ...mP.definition, prefix: "fas" },
  faMagnifyingGlassWaveform: { ...gP.definition, prefix: "fas" },
  faMailbox: { ...PP.definition, prefix: "fas" },
  faMailboxFlagUp: { ...MP.definition, prefix: "fas" },
  faMakiRoll: { ...wP.definition, prefix: "fas" },
  faMakizushi: { ...NP.definition, prefix: "fas" },
  faMandolin: { ...zP.definition, prefix: "fas" },
  faMango: { ...LP.definition, prefix: "fas" },
  faManhole: { ...CP.definition, prefix: "fas" },
  faMapMarkerAltSlash: { ...DP.definition, prefix: "fas" },
  faMapMarkerCheck: { ...$P.definition, prefix: "fas" },
  faMapMarkerEdit: { ..._P.definition, prefix: "fas" },
  faMapMarkerExclamation: { ...bP.definition, prefix: "fas" },
  faMapMarkerMinus: { ...SP.definition, prefix: "fas" },
  faMapMarkerPlus: { ...yP.definition, prefix: "fas" },
  faMapMarkerQuestion: { ...OP.definition, prefix: "fas" },
  faMapMarkerSlash: { ...kP.definition, prefix: "fas" },
  faMapMarkerSmile: { ...AP.definition, prefix: "fas" },
  faMapMarkerTimes: { ...jP.definition, prefix: "fas" },
  faMapMarkerXmark: { ...BP.definition, prefix: "fas" },
  faMaskLuchador: { ...TP.definition, prefix: "fas" },
  faMaskSnorkel: { ...FP.definition, prefix: "fas" },
  faMeat: { ...HP.definition, prefix: "fas" },
  faMegaphone: { ...RP.definition, prefix: "fas" },
  faMelon: { ...UP.definition, prefix: "fas" },
  faMelonSlice: { ...qP.definition, prefix: "fas" },
  faMemo: { ...GP.definition, prefix: "fas" },
  faMemoCircleCheck: { ...WP.definition, prefix: "fas" },
  faMemoCircleInfo: { ...EP.definition, prefix: "fas" },
  faMemoPad: { ...VP.definition, prefix: "fas" },
  faMerge: { ...IP.definition, prefix: "fas" },
  faMessageArrowDown: { ...N1.definition, prefix: "fas" },
  faMessageArrowUp: { ...z1.definition, prefix: "fas" },
  faMessageArrowUpRight: { ...KP.definition, prefix: "fas" },
  faMessageBot: { ...XP.definition, prefix: "fas" },
  faMessageCaptions: { ...L1.definition, prefix: "fas" },
  faMessageCheck: { ...C1.definition, prefix: "fas" },
  faMessageCode: { ...QP.definition, prefix: "fas" },
  faMessageDollar: { ...D1.definition, prefix: "fas" },
  faMessageDots: { ...u.definition, prefix: "fas" },
  faMessageEdit: { ...JP.definition, prefix: "fas" },
  faMessageExclamation: { ...$1.definition, prefix: "fas" },
  faMessageHeart: { ...YP.definition, prefix: "fas" },
  faMessageImage: { ..._1.definition, prefix: "fas" },
  faMessageLines: { ...b1.definition, prefix: "fas" },
  faMessageMedical: { ...S1.definition, prefix: "fas" },
  faMessageMiddle: { ...H1.definition, prefix: "fas" },
  faMessageMiddleTop: { ...R1.definition, prefix: "fas" },
  faMessageMinus: { ...y1.definition, prefix: "fas" },
  faMessageMusic: { ...O1.definition, prefix: "fas" },
  faMessagePen: { ...m.definition, prefix: "fas" },
  faMessagePlus: { ...k1.definition, prefix: "fas" },
  faMessageQuestion: { ...ZP.definition, prefix: "fas" },
  faMessageQuote: { ...A1.definition, prefix: "fas" },
  faMessageSlash: { ...j1.definition, prefix: "fas" },
  faMessageSmile: { ...B1.definition, prefix: "fas" },
  faMessageSms: { ...pP.definition, prefix: "fas" },
  faMessageText: { ...T1.definition, prefix: "fas" },
  faMessageTimes: { ...xP.definition, prefix: "fas" },
  faMessageXmark: { ...g.definition, prefix: "fas" },
  faMessages: { ...q1.definition, prefix: "fas" },
  faMessagesDollar: { ...G1.definition, prefix: "fas" },
  faMessagesQuestion: { ...iM.definition, prefix: "fas" },
  faMessaging: { ...aM.definition, prefix: "fas" },
  faMeter: { ...eM.definition, prefix: "fas" },
  faMeterBolt: { ...nM.definition, prefix: "fas" },
  faMeterDroplet: { ...fM.definition, prefix: "fas" },
  faMeterFire: { ...cM.definition, prefix: "fas" },
  faMicrochipAi: { ...tM.definition, prefix: "fas" },
  faMicrophoneCircle: { ...oM.definition, prefix: "fas" },
  faMicrophoneCircleAlt: { ...lM.definition, prefix: "fas" },
  faMicrophoneStand: { ...dM.definition, prefix: "fas" },
  faMicrowave: { ...rM.definition, prefix: "fas" },
  faMindShare: { ...sM.definition, prefix: "fas" },
  faMinusHexagon: { ...hM.definition, prefix: "fas" },
  faMinusLarge: { ...vM.definition, prefix: "fas" },
  faMinusOctagon: { ...uM.definition, prefix: "fas" },
  faMistletoe: { ...mM.definition, prefix: "fas" },
  faMobileIphone: { ...gM.definition, prefix: "fas" },
  faMobileNotch: { ...H4.definition, prefix: "fas" },
  faMobileSignal: { ...PM.definition, prefix: "fas" },
  faMobileSignalOut: { ...MM.definition, prefix: "fas" },
  faMoneyBillSimple: { ...wM.definition, prefix: "fas" },
  faMoneyBillSimpleWave: { ...NM.definition, prefix: "fas" },
  faMoneyBillsAlt: { ...zM.definition, prefix: "fas" },
  faMoneyBillsSimple: { ...R4.definition, prefix: "fas" },
  faMoneyCheckDollarPen: { ...U4.definition, prefix: "fas" },
  faMoneyCheckEdit: { ...LM.definition, prefix: "fas" },
  faMoneyCheckEditAlt: { ...CM.definition, prefix: "fas" },
  faMoneyCheckPen: { ...q4.definition, prefix: "fas" },
  faMoneyFromBracket: { ...DM.definition, prefix: "fas" },
  faMoneySimpleFromBracket: { ...$M.definition, prefix: "fas" },
  faMonitorHeartRate: { ..._M.definition, prefix: "fas" },
  faMonitorWaveform: { ...G4.definition, prefix: "fas" },
  faMonkey: { ...bM.definition, prefix: "fas" },
  faMoonCloud: { ...SM.definition, prefix: "fas" },
  faMoonOverSun: { ...oa.definition, prefix: "fas" },
  faMoonStars: { ...yM.definition, prefix: "fas" },
  faMoped: { ...OM.definition, prefix: "fas" },
  faMountains: { ...kM.definition, prefix: "fas" },
  faMouseAlt: { ...AM.definition, prefix: "fas" },
  faMouseField: { ...jM.definition, prefix: "fas" },
  faMp3Player: { ...BM.definition, prefix: "fas" },
  faMug: { ...TM.definition, prefix: "fas" },
  faMugMarshmallows: { ...FM.definition, prefix: "fas" },
  faMugTea: { ...HM.definition, prefix: "fas" },
  faMugTeaSaucer: { ...RM.definition, prefix: "fas" },
  faMushroom: { ...UM.definition, prefix: "fas" },
  faMusicAlt: { ...qM.definition, prefix: "fas" },
  faMusicAltSlash: { ...GM.definition, prefix: "fas" },
  faMusicMagnifyingGlass: { ...WM.definition, prefix: "fas" },
  faMusicNote: { ...W4.definition, prefix: "fas" },
  faMusicNoteSlash: { ...E4.definition, prefix: "fas" },
  faMusicSlash: { ...EM.definition, prefix: "fas" },
  faMustache: { ...VM.definition, prefix: "fas" },
  faNarwhal: { ...IM.definition, prefix: "fas" },
  faNestingDolls: { ...KM.definition, prefix: "fas" },
  faNfc: { ...XM.definition, prefix: "fas" },
  faNfcLock: { ...QM.definition, prefix: "fas" },
  faNfcMagnifyingGlass: { ...JM.definition, prefix: "fas" },
  faNfcPen: { ...YM.definition, prefix: "fas" },
  faNfcSignal: { ...ZM.definition, prefix: "fas" },
  faNfcSlash: { ...pM.definition, prefix: "fas" },
  faNfcTrash: { ...xM.definition, prefix: "fas" },
  faNigiri: { ...iw.definition, prefix: "fas" },
  faNose: { ...aw.definition, prefix: "fas" },
  faNote: { ...ew.definition, prefix: "fas" },
  faNoteMedical: { ...nw.definition, prefix: "fas" },
  faNotebook: { ...fw.definition, prefix: "fas" },
  faNotes: { ...cw.definition, prefix: "fas" },
  faObjectExclude: { ...tw.definition, prefix: "fas" },
  faObjectIntersect: { ...ow.definition, prefix: "fas" },
  faObjectSubtract: { ...lw.definition, prefix: "fas" },
  faObjectUnion: { ...dw.definition, prefix: "fas" },
  faObjectsAlignBottom: { ...rw.definition, prefix: "fas" },
  faObjectsAlignCenterHorizontal: { ...sw.definition, prefix: "fas" },
  faObjectsAlignCenterVertical: { ...hw.definition, prefix: "fas" },
  faObjectsAlignLeft: { ...vw.definition, prefix: "fas" },
  faObjectsAlignRight: { ...uw.definition, prefix: "fas" },
  faObjectsAlignTop: { ...mw.definition, prefix: "fas" },
  faObjectsColumn: { ...gw.definition, prefix: "fas" },
  faOctagon: { ...Pw.definition, prefix: "fas" },
  faOctagonCheck: { ...Mw.definition, prefix: "fas" },
  faOctagonDivide: { ...ww.definition, prefix: "fas" },
  faOctagonExclamation: { ...Nw.definition, prefix: "fas" },
  faOctagonMinus: { ...F4.definition, prefix: "fas" },
  faOctagonPlus: { ...I4.definition, prefix: "fas" },
  faOctagonXmark: { ...$.definition, prefix: "fas" },
  faOctopus: { ...zw.definition, prefix: "fas" },
  faOilCanDrip: { ...Lw.definition, prefix: "fas" },
  faOilTemp: { ...Cw.definition, prefix: "fas" },
  faOilTemperature: { ...K4.definition, prefix: "fas" },
  faOlive: { ...Dw.definition, prefix: "fas" },
  faOliveBranch: { ...$w.definition, prefix: "fas" },
  faOmega: { ..._w.definition, prefix: "fas" },
  faOnion: { ...bw.definition, prefix: "fas" },
  faOption: { ...Sw.definition, prefix: "fas" },
  faOrnament: { ...yw.definition, prefix: "fas" },
  faOutlet: { ...Ow.definition, prefix: "fas" },
  faOven: { ...kw.definition, prefix: "fas" },
  faOverline: { ...Aw.definition, prefix: "fas" },
  faPage: { ...jw.definition, prefix: "fas" },
  faPageBreak: { ...Bw.definition, prefix: "fas" },
  faPageCaretDown: { ...Ma.definition, prefix: "fas" },
  faPageCaretUp: { ...wa.definition, prefix: "fas" },
  faPaintBrushAlt: { ...Tw.definition, prefix: "fas" },
  faPaintbrushFine: { ...X4.definition, prefix: "fas" },
  faPaintbrushPencil: { ...Fw.definition, prefix: "fas" },
  faPaletteBoxes: { ...Hw.definition, prefix: "fas" },
  faPalletAlt: { ...Rw.definition, prefix: "fas" },
  faPalletBox: { ...Uw.definition, prefix: "fas" },
  faPalletBoxes: { ..._.definition, prefix: "fas" },
  faPanFood: { ...qw.definition, prefix: "fas" },
  faPanFrying: { ...Gw.definition, prefix: "fas" },
  faPancakes: { ...Ww.definition, prefix: "fas" },
  faPanelEws: { ...Ew.definition, prefix: "fas" },
  faPanelFire: { ...Vw.definition, prefix: "fas" },
  faPaperPlaneAlt: { ...Iw.definition, prefix: "fas" },
  faPaperPlaneTop: { ...b.definition, prefix: "fas" },
  faPaperclipVertical: { ...Kw.definition, prefix: "fas" },
  faParagraphLeft: { ...Q4.definition, prefix: "fas" },
  faParagraphRtl: { ...Xw.definition, prefix: "fas" },
  faParentheses: { ...Qw.definition, prefix: "fas" },
  faParenthesis: { ...Jw.definition, prefix: "fas" },
  faParkingCircle: { ...Yw.definition, prefix: "fas" },
  faParkingCircleSlash: { ...Zw.definition, prefix: "fas" },
  faParkingSlash: { ...pw.definition, prefix: "fas" },
  faPartyBack: { ...xw.definition, prefix: "fas" },
  faPartyBell: { ...iN.definition, prefix: "fas" },
  faPartyHorn: { ...aN.definition, prefix: "fas" },
  faPawAlt: { ...eN.definition, prefix: "fas" },
  faPawClaws: { ...nN.definition, prefix: "fas" },
  faPawSimple: { ...Y4.definition, prefix: "fas" },
  faPeach: { ...fN.definition, prefix: "fas" },
  faPeanut: { ...cN.definition, prefix: "fas" },
  faPeanuts: { ...tN.definition, prefix: "fas" },
  faPeapod: { ...oN.definition, prefix: "fas" },
  faPear: { ...lN.definition, prefix: "fas" },
  faPedestal: { ...dN.definition, prefix: "fas" },
  faPegasus: { ...rN.definition, prefix: "fas" },
  faPenAltSlash: { ...sN.definition, prefix: "fas" },
  faPenCircle: { ...hN.definition, prefix: "fas" },
  faPenClipSlash: { ...Z4.definition, prefix: "fas" },
  faPenFancySlash: { ...vN.definition, prefix: "fas" },
  faPenField: { ...uN.definition, prefix: "fas" },
  faPenLine: { ...mN.definition, prefix: "fas" },
  faPenNibSlash: { ...gN.definition, prefix: "fas" },
  faPenPaintbrush: { ...p4.definition, prefix: "fas" },
  faPenSlash: { ...PN.definition, prefix: "fas" },
  faPenSwirl: { ...MN.definition, prefix: "fas" },
  faPencilMechanical: { ...wN.definition, prefix: "fas" },
  faPencilPaintbrush: { ...NN.definition, prefix: "fas" },
  faPencilSlash: { ...zN.definition, prefix: "fas" },
  faPennant: { ...LN.definition, prefix: "fas" },
  faPeople: { ...CN.definition, prefix: "fas" },
  faPeopleDress: { ...DN.definition, prefix: "fas" },
  faPeopleDressSimple: { ...$N.definition, prefix: "fas" },
  faPeoplePants: { ..._N.definition, prefix: "fas" },
  faPeoplePantsSimple: { ...bN.definition, prefix: "fas" },
  faPeopleSimple: { ...SN.definition, prefix: "fas" },
  faPepper: { ...yN.definition, prefix: "fas" },
  faPeriod: { ...ON.definition, prefix: "fas" },
  faPersonBikingMountain: { ...Ri.definition, prefix: "fas" },
  faPersonCarry: { ...kN.definition, prefix: "fas" },
  faPersonCarryBox: { ...x4.definition, prefix: "fas" },
  faPersonDolly: { ...AN.definition, prefix: "fas" },
  faPersonDollyEmpty: { ...jN.definition, prefix: "fas" },
  faPersonDressFairy: { ...BN.definition, prefix: "fas" },
  faPersonDressSimple: { ...TN.definition, prefix: "fas" },
  faPersonFairy: { ...FN.definition, prefix: "fas" },
  faPersonFromPortal: { ...i3.definition, prefix: "fas" },
  faPersonPinball: { ...HN.definition, prefix: "fas" },
  faPersonRunningFast: { ...RN.definition, prefix: "fas" },
  faPersonSeat: { ...UN.definition, prefix: "fas" },
  faPersonSeatReclined: { ...qN.definition, prefix: "fas" },
  faPersonSign: { ...GN.definition, prefix: "fas" },
  faPersonSimple: { ...WN.definition, prefix: "fas" },
  faPersonSkiJumping: { ...a3.definition, prefix: "fas" },
  faPersonSkiLift: { ...e3.definition, prefix: "fas" },
  faPersonSledding: { ...n3.definition, prefix: "fas" },
  faPersonSnowmobiling: { ...f3.definition, prefix: "fas" },
  faPersonToDoor: { ...EN.definition, prefix: "fas" },
  faPersonToPortal: { ...c3.definition, prefix: "fas" },
  faPhoneArrowDown: { ...VN.definition, prefix: "fas" },
  faPhoneArrowDownLeft: { ...S.definition, prefix: "fas" },
  faPhoneArrowRight: { ...IN.definition, prefix: "fas" },
  faPhoneArrowUp: { ...KN.definition, prefix: "fas" },
  faPhoneArrowUpRight: { ...y.definition, prefix: "fas" },
  faPhoneCircle: { ...XN.definition, prefix: "fas" },
  faPhoneCircleAlt: { ...QN.definition, prefix: "fas" },
  faPhoneCircleDown: { ...JN.definition, prefix: "fas" },
  faPhoneHangup: { ...YN.definition, prefix: "fas" },
  faPhoneIncoming: { ...ZN.definition, prefix: "fas" },
  faPhoneIntercom: { ...pN.definition, prefix: "fas" },
  faPhoneLaptop: { ...xN.definition, prefix: "fas" },
  faPhoneMissed: { ...iz.definition, prefix: "fas" },
  faPhoneOffice: { ...az.definition, prefix: "fas" },
  faPhoneOutgoing: { ...ez.definition, prefix: "fas" },
  faPhonePlus: { ...nz.definition, prefix: "fas" },
  faPhoneRotary: { ...fz.definition, prefix: "fas" },
  faPhoneSquareDown: { ...cz.definition, prefix: "fas" },
  faPhoneXmark: { ...tz.definition, prefix: "fas" },
  faPhotoFilmMusic: { ...oz.definition, prefix: "fas" },
  faPi: { ...lz.definition, prefix: "fas" },
  faPiano: { ...dz.definition, prefix: "fas" },
  faPianoKeyboard: { ...rz.definition, prefix: "fas" },
  faPickaxe: { ...sz.definition, prefix: "fas" },
  faPickleball: { ...hz.definition, prefix: "fas" },
  faPie: { ...vz.definition, prefix: "fas" },
  faPig: { ...uz.definition, prefix: "fas" },
  faPinata: { ...mz.definition, prefix: "fas" },
  faPinball: { ...gz.definition, prefix: "fas" },
  faPineapple: { ...Pz.definition, prefix: "fas" },
  faPipe: { ...Mz.definition, prefix: "fas" },
  faPipeCircleCheck: { ...wz.definition, prefix: "fas" },
  faPipeCollar: { ...Nz.definition, prefix: "fas" },
  faPipeSection: { ...zz.definition, prefix: "fas" },
  faPipeSmoking: { ...Lz.definition, prefix: "fas" },
  faPipeValve: { ...Cz.definition, prefix: "fas" },
  faPizza: { ...Dz.definition, prefix: "fas" },
  faPlaneAlt: { ...$z.definition, prefix: "fas" },
  faPlaneEngines: { ...o3.definition, prefix: "fas" },
  faPlaneProp: { ..._z.definition, prefix: "fas" },
  faPlaneTail: { ...bz.definition, prefix: "fas" },
  faPlaneUpSlash: { ...Sz.definition, prefix: "fas" },
  faPlanetMoon: { ...yz.definition, prefix: "fas" },
  faPlanetRinged: { ...Oz.definition, prefix: "fas" },
  faPlateUtensils: { ...kz.definition, prefix: "fas" },
  faPlayPause: { ...Az.definition, prefix: "fas" },
  faPlusHexagon: { ...jz.definition, prefix: "fas" },
  faPlusLarge: { ...Bz.definition, prefix: "fas" },
  faPlusOctagon: { ...Tz.definition, prefix: "fas" },
  faPodium: { ...Fz.definition, prefix: "fas" },
  faPodiumStar: { ...Hz.definition, prefix: "fas" },
  faPoliceBox: { ...Rz.definition, prefix: "fas" },
  faPollPeople: { ...Uz.definition, prefix: "fas" },
  faPompebled: { ...qz.definition, prefix: "fas" },
  faPool8Ball: { ...Gz.definition, prefix: "fas" },
  faPopcorn: { ...Wz.definition, prefix: "fas" },
  faPopsicle: { ...Ez.definition, prefix: "fas" },
  faPortalEnter: { ...Vz.definition, prefix: "fas" },
  faPortalExit: { ...Iz.definition, prefix: "fas" },
  faPotFood: { ...Kz.definition, prefix: "fas" },
  faPotato: { ...Xz.definition, prefix: "fas" },
  faPrescriptionBottlePill: { ...Qz.definition, prefix: "fas" },
  faPresentation: { ...Jz.definition, prefix: "fas" },
  faPresentationScreen: { ...l3.definition, prefix: "fas" },
  faPretzel: { ...Yz.definition, prefix: "fas" },
  faPrintMagnifyingGlass: { ...d3.definition, prefix: "fas" },
  faPrintSearch: { ...Zz.definition, prefix: "fas" },
  faPrintSlash: { ...pz.definition, prefix: "fas" },
  faPro: { ...xz.definition, prefix: "fas" },
  faProjector: { ...iL.definition, prefix: "fas" },
  faPump: { ...aL.definition, prefix: "fas" },
  faPumpkin: { ...eL.definition, prefix: "fas" },
  faPuzzle: { ...nL.definition, prefix: "fas" },
  faPuzzlePieceAlt: { ...fL.definition, prefix: "fas" },
  faPuzzlePieceSimple: { ...s3.definition, prefix: "fas" },
  faQuestionSquare: { ...cL.definition, prefix: "fas" },
  faQuotes: { ...tL.definition, prefix: "fas" },
  faRabbit: { ...oL.definition, prefix: "fas" },
  faRabbitFast: { ...lL.definition, prefix: "fas" },
  faRabbitRunning: { ...v3.definition, prefix: "fas" },
  faRaccoon: { ...dL.definition, prefix: "fas" },
  faRacquet: { ...rL.definition, prefix: "fas" },
  faRadar: { ...sL.definition, prefix: "fas" },
  faRadioAlt: { ...hL.definition, prefix: "fas" },
  faRadioTuner: { ...u3.definition, prefix: "fas" },
  faRaindrops: { ...vL.definition, prefix: "fas" },
  faRam: { ...uL.definition, prefix: "fas" },
  faRampLoading: { ...mL.definition, prefix: "fas" },
  faRaygun: { ...gL.definition, prefix: "fas" },
  faRectangle: { ...m3.definition, prefix: "fas" },
  faRectangleBarcode: { ...ki.definition, prefix: "fas" },
  faRectangleCode: { ...PL.definition, prefix: "fas" },
  faRectangleHd: { ...ML.definition, prefix: "fas" },
  faRectangleHistory: { ...wL.definition, prefix: "fas" },
  faRectangleHistoryCirclePlus: { ...NL.definition, prefix: "fas" },
  faRectangleHistoryCircleUser: { ...zL.definition, prefix: "fas" },
  faRectangleLandscape: { ...LL.definition, prefix: "fas" },
  faRectanglePortrait: { ...CL.definition, prefix: "fas" },
  faRectanglePro: { ...r3.definition, prefix: "fas" },
  faRectangleSd: { ...DL.definition, prefix: "fas" },
  faRectangleTerminal: { ...$L.definition, prefix: "fas" },
  faRectangleVertical: { ...g3.definition, prefix: "fas" },
  faRectangleVerticalHistory: { ..._L.definition, prefix: "fas" },
  faRectangleWide: { ...bL.definition, prefix: "fas" },
  faRectanglesMixed: { ...SL.definition, prefix: "fas" },
  faReel: { ...yL.definition, prefix: "fas" },
  faReflectBoth: { ...OL.definition, prefix: "fas" },
  faReflectHorizontal: { ...kL.definition, prefix: "fas" },
  faReflectVertical: { ...AL.definition, prefix: "fas" },
  faRefrigerator: { ...jL.definition, prefix: "fas" },
  faRepeat1: { ...BL.definition, prefix: "fas" },
  faRepeat1Alt: { ...TL.definition, prefix: "fas" },
  faRepeatAlt: { ...FL.definition, prefix: "fas" },
  faReplyClock: { ...M3.definition, prefix: "fas" },
  faReplyTime: { ...HL.definition, prefix: "fas" },
  faRestroomSimple: { ...RL.definition, prefix: "fas" },
  faRetweetAlt: { ...UL.definition, prefix: "fas" },
  faRhombus: { ...qL.definition, prefix: "fas" },
  faRight: { ...I.definition, prefix: "fas" },
  faRightFromLine: { ...G.definition, prefix: "fas" },
  faRightLeftLarge: { ...GL.definition, prefix: "fas" },
  faRightLongToLine: { ...WL.definition, prefix: "fas" },
  faRightToLine: { ...p.definition, prefix: "fas" },
  faRingDiamond: { ...EL.definition, prefix: "fas" },
  faRingsWedding: { ...VL.definition, prefix: "fas" },
  faRobotAstromech: { ...IL.definition, prefix: "fas" },
  faRocketLaunch: { ...KL.definition, prefix: "fas" },
  faRollerCoaster: { ...XL.definition, prefix: "fas" },
  faRotateExclamation: { ...QL.definition, prefix: "fas" },
  faRotateReverse: { ...JL.definition, prefix: "fas" },
  faRouteHighway: { ...YL.definition, prefix: "fas" },
  faRouteInterstate: { ...ZL.definition, prefix: "fas" },
  faRouter: { ...pL.definition, prefix: "fas" },
  faRows: { ...xL.definition, prefix: "fas" },
  faRugbyBall: { ...iC.definition, prefix: "fas" },
  faRulerTriangle: { ...aC.definition, prefix: "fas" },
  faRv: { ...eC.definition, prefix: "fas" },
  faSack: { ...nC.definition, prefix: "fas" },
  faSalad: { ...Ji.definition, prefix: "fas" },
  faSaltShaker: { ...fC.definition, prefix: "fas" },
  faSandwich: { ...cC.definition, prefix: "fas" },
  faSausage: { ...tC.definition, prefix: "fas" },
  faSaveCircleArrowRight: { ...oC.definition, prefix: "fas" },
  faSaveCircleXmark: { ...lC.definition, prefix: "fas" },
  faSaveTimes: { ...dC.definition, prefix: "fas" },
  faSaxHot: { ...rC.definition, prefix: "fas" },
  faSaxophone: { ...sC.definition, prefix: "fas" },
  faSaxophoneFire: { ...N3.definition, prefix: "fas" },
  faScalpel: { ...hC.definition, prefix: "fas" },
  faScalpelLineDashed: { ...z3.definition, prefix: "fas" },
  faScalpelPath: { ...vC.definition, prefix: "fas" },
  faScanner: { ...uC.definition, prefix: "fas" },
  faScannerGun: { ...L3.definition, prefix: "fas" },
  faScannerImage: { ...mC.definition, prefix: "fas" },
  faScannerKeyboard: { ...gC.definition, prefix: "fas" },
  faScannerTouchscreen: { ...PC.definition, prefix: "fas" },
  faScarecrow: { ...MC.definition, prefix: "fas" },
  faScarf: { ...wC.definition, prefix: "fas" },
  faScreenUsers: { ...C3.definition, prefix: "fas" },
  faScreencast: { ...NC.definition, prefix: "fas" },
  faScreenshot: { ...zC.definition, prefix: "fas" },
  faScribble: { ...LC.definition, prefix: "fas" },
  faScrollOld: { ...CC.definition, prefix: "fas" },
  faScrollRibbon: { ...DC.definition, prefix: "fas" },
  faScrubber: { ...$C.definition, prefix: "fas" },
  faScythe: { ..._C.definition, prefix: "fas" },
  faSdCards: { ...bC.definition, prefix: "fas" },
  faSeal: { ...SC.definition, prefix: "fas" },
  faSealExclamation: { ...yC.definition, prefix: "fas" },
  faSealQuestion: { ...OC.definition, prefix: "fas" },
  faSeatAirline: { ...kC.definition, prefix: "fas" },
  faSemicolon: { ...AC.definition, prefix: "fas" },
  faSend: { ...jC.definition, prefix: "fas" },
  faSendBack: { ...BC.definition, prefix: "fas" },
  faSendBackward: { ...TC.definition, prefix: "fas" },
  faSensor: { ...FC.definition, prefix: "fas" },
  faSensorAlert: { ...HC.definition, prefix: "fas" },
  faSensorCloud: { ...$3.definition, prefix: "fas" },
  faSensorFire: { ...RC.definition, prefix: "fas" },
  faSensorOn: { ...UC.definition, prefix: "fas" },
  faSensorSmoke: { ...qC.definition, prefix: "fas" },
  faSensorTriangleExclamation: { ...D3.definition, prefix: "fas" },
  faShareAll: { ...GC.definition, prefix: "fas" },
  faSheep: { ...WC.definition, prefix: "fas" },
  faShelves: { ...P4.definition, prefix: "fas" },
  faShelvesEmpty: { ...EC.definition, prefix: "fas" },
  faShieldCheck: { ...VC.definition, prefix: "fas" },
  faShieldCross: { ...IC.definition, prefix: "fas" },
  faShieldExclamation: { ...KC.definition, prefix: "fas" },
  faShieldKeyhole: { ...XC.definition, prefix: "fas" },
  faShieldMinus: { ...QC.definition, prefix: "fas" },
  faShieldPlus: { ...JC.definition, prefix: "fas" },
  faShieldQuartered: { ...YC.definition, prefix: "fas" },
  faShieldSlash: { ...ZC.definition, prefix: "fas" },
  faShieldTimes: { ...pC.definition, prefix: "fas" },
  faShieldXmark: { ..._3.definition, prefix: "fas" },
  faShippingTimed: { ...xC.definition, prefix: "fas" },
  faShirtLongSleeve: { ...iD.definition, prefix: "fas" },
  faShirtRunning: { ...aD.definition, prefix: "fas" },
  faShirtTankTop: { ...eD.definition, prefix: "fas" },
  faShishKebab: { ...nD.definition, prefix: "fas" },
  faShoppingBasketAlt: { ...fD.definition, prefix: "fas" },
  faShortcake: { ...cD.definition, prefix: "fas" },
  faShovel: { ...tD.definition, prefix: "fas" },
  faShovelSnow: { ...oD.definition, prefix: "fas" },
  faShowerAlt: { ...lD.definition, prefix: "fas" },
  faShowerDown: { ...S3.definition, prefix: "fas" },
  faShredder: { ...dD.definition, prefix: "fas" },
  faShutters: { ...rD.definition, prefix: "fas" },
  faShuttlecock: { ...sD.definition, prefix: "fas" },
  faSickle: { ...hD.definition, prefix: "fas" },
  faSidebar: { ...vD.definition, prefix: "fas" },
  faSidebarFlip: { ...uD.definition, prefix: "fas" },
  faSigma: { ...mD.definition, prefix: "fas" },
  faSignPost: { ...gD.definition, prefix: "fas" },
  faSignPosts: { ...PD.definition, prefix: "fas" },
  faSignPostsWrench: { ...MD.definition, prefix: "fas" },
  faSignal1: { ...wD.definition, prefix: "fas" },
  faSignal2: { ...ND.definition, prefix: "fas" },
  faSignal3: { ...zD.definition, prefix: "fas" },
  faSignal4: { ...LD.definition, prefix: "fas" },
  faSignalAlt: { ...CD.definition, prefix: "fas" },
  faSignalAlt1: { ...DD.definition, prefix: "fas" },
  faSignalAlt2: { ...$D.definition, prefix: "fas" },
  faSignalAlt3: { ..._D.definition, prefix: "fas" },
  faSignalAlt4: { ...bD.definition, prefix: "fas" },
  faSignalAltSlash: { ...SD.definition, prefix: "fas" },
  faSignalBars: { ...r.definition, prefix: "fas" },
  faSignalBarsFair: { ...B3.definition, prefix: "fas" },
  faSignalBarsGood: { ...T3.definition, prefix: "fas" },
  faSignalBarsSlash: { ...F3.definition, prefix: "fas" },
  faSignalBarsStrong: { ...yD.definition, prefix: "fas" },
  faSignalBarsWeak: { ...j3.definition, prefix: "fas" },
  faSignalFair: { ...O3.definition, prefix: "fas" },
  faSignalGood: { ...k3.definition, prefix: "fas" },
  faSignalSlash: { ...OD.definition, prefix: "fas" },
  faSignalStream: { ...kD.definition, prefix: "fas" },
  faSignalStreamSlash: { ...AD.definition, prefix: "fas" },
  faSignalStrong: { ...A3.definition, prefix: "fas" },
  faSignalWeak: { ...y3.definition, prefix: "fas" },
  faSignatureLock: { ...jD.definition, prefix: "fas" },
  faSignatureSlash: { ...BD.definition, prefix: "fas" },
  faSimCards: { ...TD.definition, prefix: "fas" },
  faSiren: { ...FD.definition, prefix: "fas" },
  faSirenOn: { ...HD.definition, prefix: "fas" },
  faSkeleton: { ...RD.definition, prefix: "fas" },
  faSkeletonRibs: { ...UD.definition, prefix: "fas" },
  faSkiBoot: { ...qD.definition, prefix: "fas" },
  faSkiBootSki: { ...GD.definition, prefix: "fas" },
  faSkiJump: { ...WD.definition, prefix: "fas" },
  faSkiLift: { ...ED.definition, prefix: "fas" },
  faSkullCow: { ...VD.definition, prefix: "fas" },
  faSlashBack: { ...ID.definition, prefix: "fas" },
  faSlashForward: { ...KD.definition, prefix: "fas" },
  faSledding: { ...XD.definition, prefix: "fas" },
  faSlider: { ...QD.definition, prefix: "fas" },
  faSlidersHSquare: { ...JD.definition, prefix: "fas" },
  faSlidersSimple: { ...YD.definition, prefix: "fas" },
  faSlidersUp: { ...R3.definition, prefix: "fas" },
  faSlidersV: { ...ZD.definition, prefix: "fas" },
  faSlidersVSquare: { ...pD.definition, prefix: "fas" },
  faSlotMachine: { ...xD.definition, prefix: "fas" },
  faSmilePlus: { ...i$.definition, prefix: "fas" },
  faSmoke: { ...a$.definition, prefix: "fas" },
  faSnake: { ...e$.definition, prefix: "fas" },
  faSnooze: { ...q3.definition, prefix: "fas" },
  faSnowBlowing: { ...n$.definition, prefix: "fas" },
  faSnowflakeDroplets: { ...f$.definition, prefix: "fas" },
  faSnowflakes: { ...c$.definition, prefix: "fas" },
  faSnowmanHead: { ...qa.definition, prefix: "fas" },
  faSnowmobile: { ...t$.definition, prefix: "fas" },
  faSoftServe: { ...X1.definition, prefix: "fas" },
  faSolarSystem: { ...o$.definition, prefix: "fas" },
  faSortAlt: { ...l$.definition, prefix: "fas" },
  faSortCircle: { ...d$.definition, prefix: "fas" },
  faSortCircleDown: { ...r$.definition, prefix: "fas" },
  faSortCircleUp: { ...s$.definition, prefix: "fas" },
  faSortShapesDown: { ...h$.definition, prefix: "fas" },
  faSortShapesDownAlt: { ...v$.definition, prefix: "fas" },
  faSortShapesUp: { ...u$.definition, prefix: "fas" },
  faSortShapesUpAlt: { ...m$.definition, prefix: "fas" },
  faSortSizeDown: { ...g$.definition, prefix: "fas" },
  faSortSizeDownAlt: { ...P$.definition, prefix: "fas" },
  faSortSizeUp: { ...M$.definition, prefix: "fas" },
  faSortSizeUpAlt: { ...w$.definition, prefix: "fas" },
  faSortUpDown: { ...N$.definition, prefix: "fas" },
  faSoup: { ...z$.definition, prefix: "fas" },
  faSpaceStationMoon: { ...L$.definition, prefix: "fas" },
  faSpaceStationMoonAlt: { ...C$.definition, prefix: "fas" },
  faSpaceStationMoonConstruction: { ...G3.definition, prefix: "fas" },
  faSpade: { ...D$.definition, prefix: "fas" },
  faSparkle: { ...$$.definition, prefix: "fas" },
  faSparkles: { ..._$.definition, prefix: "fas" },
  faSpeaker: { ...b$.definition, prefix: "fas" },
  faSpeakers: { ...S$.definition, prefix: "fas" },
  faSpiderBlackWidow: { ...y$.definition, prefix: "fas" },
  faSpiderWeb: { ...O$.definition, prefix: "fas" },
  faSpinnerScale: { ...k$.definition, prefix: "fas" },
  faSpinnerThird: { ...A$.definition, prefix: "fas" },
  faSplit: { ...j$.definition, prefix: "fas" },
  faSportsball: { ...B$.definition, prefix: "fas" },
  faSprinkler: { ...T$.definition, prefix: "fas" },
  faSprinklerCeiling: { ...F$.definition, prefix: "fas" },
  faSquare0: { ...H$.definition, prefix: "fas" },
  faSquare1: { ...R$.definition, prefix: "fas" },
  faSquare2: { ...U$.definition, prefix: "fas" },
  faSquare3: { ...q$.definition, prefix: "fas" },
  faSquare4: { ...G$.definition, prefix: "fas" },
  faSquare5: { ...W$.definition, prefix: "fas" },
  faSquare6: { ...E$.definition, prefix: "fas" },
  faSquare7: { ...V$.definition, prefix: "fas" },
  faSquare8: { ...I$.definition, prefix: "fas" },
  faSquare9: { ...K$.definition, prefix: "fas" },
  faSquareA: { ...X$.definition, prefix: "fas" },
  faSquareALock: { ...Q$.definition, prefix: "fas" },
  faSquareAmpersand: { ...J$.definition, prefix: "fas" },
  faSquareArrowDown: { ...vi.definition, prefix: "fas" },
  faSquareArrowDownLeft: { ...Y$.definition, prefix: "fas" },
  faSquareArrowDownRight: { ...Z$.definition, prefix: "fas" },
  faSquareArrowLeft: { ...ui.definition, prefix: "fas" },
  faSquareArrowRight: { ...mi.definition, prefix: "fas" },
  faSquareArrowUp: { ...gi.definition, prefix: "fas" },
  faSquareArrowUpLeft: { ...p$.definition, prefix: "fas" },
  faSquareB: { ...x$.definition, prefix: "fas" },
  faSquareBolt: { ...i_.definition, prefix: "fas" },
  faSquareC: { ...a_.definition, prefix: "fas" },
  faSquareChevronDown: { ...J2.definition, prefix: "fas" },
  faSquareChevronLeft: { ...Y2.definition, prefix: "fas" },
  faSquareChevronRight: { ...Z2.definition, prefix: "fas" },
  faSquareChevronUp: { ...p2.definition, prefix: "fas" },
  faSquareCode: { ...e_.definition, prefix: "fas" },
  faSquareD: { ...n_.definition, prefix: "fas" },
  faSquareDashed: { ...f_.definition, prefix: "fas" },
  faSquareDashedCirclePlus: { ...c_.definition, prefix: "fas" },
  faSquareDivide: { ...t_.definition, prefix: "fas" },
  faSquareDollar: { ...P.definition, prefix: "fas" },
  faSquareDown: { ...K.definition, prefix: "fas" },
  faSquareDownLeft: { ...o_.definition, prefix: "fas" },
  faSquareDownRight: { ...l_.definition, prefix: "fas" },
  faSquareE: { ...d_.definition, prefix: "fas" },
  faSquareEllipsis: { ...r_.definition, prefix: "fas" },
  faSquareEllipsisVertical: { ...s_.definition, prefix: "fas" },
  faSquareExclamation: { ...ha.definition, prefix: "fas" },
  faSquareF: { ...h_.definition, prefix: "fas" },
  faSquareFragile: { ...s.definition, prefix: "fas" },
  faSquareG: { ...v_.definition, prefix: "fas" },
  faSquareHeart: { ...f4.definition, prefix: "fas" },
  faSquareI: { ...u_.definition, prefix: "fas" },
  faSquareInfo: { ...g4.definition, prefix: "fas" },
  faSquareJ: { ...m_.definition, prefix: "fas" },
  faSquareK: { ...g_.definition, prefix: "fas" },
  faSquareKanban: { ...P_.definition, prefix: "fas" },
  faSquareL: { ...M_.definition, prefix: "fas" },
  faSquareLeft: { ...X.definition, prefix: "fas" },
  faSquareList: { ...w_.definition, prefix: "fas" },
  faSquareM: { ...N_.definition, prefix: "fas" },
  faSquareN: { ...z_.definition, prefix: "fas" },
  faSquareO: { ...L_.definition, prefix: "fas" },
  faSquareP: { ...C_.definition, prefix: "fas" },
  faSquareParkingSlash: { ...J4.definition, prefix: "fas" },
  faSquarePhoneHangup: { ...t3.definition, prefix: "fas" },
  faSquareQ: { ...D_.definition, prefix: "fas" },
  faSquareQuarters: { ...$_.definition, prefix: "fas" },
  faSquareQuestion: { ...h3.definition, prefix: "fas" },
  faSquareQuote: { ...__.definition, prefix: "fas" },
  faSquareR: { ...b_.definition, prefix: "fas" },
  faSquareRight: { ...Q.definition, prefix: "fas" },
  faSquareRing: { ...S_.definition, prefix: "fas" },
  faSquareRoot: { ...y_.definition, prefix: "fas" },
  faSquareS: { ...O_.definition, prefix: "fas" },
  faSquareSliders: { ...H3.definition, prefix: "fas" },
  faSquareSlidersVertical: { ...U3.definition, prefix: "fas" },
  faSquareSmall: { ...k_.definition, prefix: "fas" },
  faSquareStar: { ...A_.definition, prefix: "fas" },
  faSquareT: { ...j_.definition, prefix: "fas" },
  faSquareTerminal: { ...B_.definition, prefix: "fas" },
  faSquareThisWayUp: { ...i2.definition, prefix: "fas" },
  faSquareU: { ...T_.definition, prefix: "fas" },
  faSquareUp: { ...J.definition, prefix: "fas" },
  faSquareUpLeft: { ...F_.definition, prefix: "fas" },
  faSquareUser: { ...H_.definition, prefix: "fas" },
  faSquareV: { ...R_.definition, prefix: "fas" },
  faSquareW: { ...U_.definition, prefix: "fas" },
  faSquareWineGlassCrack: { ...q_.definition, prefix: "fas" },
  faSquareX: { ...G_.definition, prefix: "fas" },
  faSquareY: { ...W_.definition, prefix: "fas" },
  faSquareZ: { ...E_.definition, prefix: "fas" },
  faSquid: { ...V_.definition, prefix: "fas" },
  faSquirrel: { ...I_.definition, prefix: "fas" },
  faStaff: { ...K_.definition, prefix: "fas" },
  faStandardDefinition: { ...P3.definition, prefix: "fas" },
  faStarChristmas: { ...X_.definition, prefix: "fas" },
  faStarCircle: { ...Q_.definition, prefix: "fas" },
  faStarExclamation: { ...J_.definition, prefix: "fas" },
  faStarSharp: { ...Y_.definition, prefix: "fas" },
  faStarSharpHalf: { ...Z_.definition, prefix: "fas" },
  faStarSharpHalfAlt: { ...p_.definition, prefix: "fas" },
  faStarSharpHalfStroke: { ...W3.definition, prefix: "fas" },
  faStarShooting: { ...x_.definition, prefix: "fas" },
  faStarfighter: { ...ib.definition, prefix: "fas" },
  faStarfighterAlt: { ...ab.definition, prefix: "fas" },
  faStarfighterAltAdvanced: { ...eb.definition, prefix: "fas" },
  faStarfighterTwinIonEngine: { ...E3.definition, prefix: "fas" },
  faStarfighterTwinIonEngineAdvanced: { ...V3.definition, prefix: "fas" },
  faStars: { ...nb.definition, prefix: "fas" },
  faStarship: { ...fb.definition, prefix: "fas" },
  faStarshipFreighter: { ...cb.definition, prefix: "fas" },
  faSteak: { ...tb.definition, prefix: "fas" },
  faSteeringWheel: { ...ob.definition, prefix: "fas" },
  faStocking: { ...lb.definition, prefix: "fas" },
  faStomach: { ...db.definition, prefix: "fas" },
  faStoreLock: { ...rb.definition, prefix: "fas" },
  faStrawberry: { ...sb.definition, prefix: "fas" },
  faStretcher: { ...hb.definition, prefix: "fas" },
  faSubtitles: { ...vb.definition, prefix: "fas" },
  faSubtitlesSlash: { ...ub.definition, prefix: "fas" },
  faSubwayTunnel: { ...mb.definition, prefix: "fas" },
  faSunAlt: { ...gb.definition, prefix: "fas" },
  faSunBright: { ...K3.definition, prefix: "fas" },
  faSunCloud: { ...Pb.definition, prefix: "fas" },
  faSunDust: { ...Mb.definition, prefix: "fas" },
  faSunHaze: { ...wb.definition, prefix: "fas" },
  faSunglasses: { ...Nb.definition, prefix: "fas" },
  faSunrise: { ...zb.definition, prefix: "fas" },
  faSunset: { ...Lb.definition, prefix: "fas" },
  faSushi: { ...V4.definition, prefix: "fas" },
  faSushiRoll: { ...D.definition, prefix: "fas" },
  faSwap: { ...Cb.definition, prefix: "fas" },
  faSwapArrows: { ...Db.definition, prefix: "fas" },
  faSword: { ...$b.definition, prefix: "fas" },
  faSwordLaser: { ..._b.definition, prefix: "fas" },
  faSwordLaserAlt: { ...bb.definition, prefix: "fas" },
  faSwords: { ...Sb.definition, prefix: "fas" },
  faSwordsLaser: { ...yb.definition, prefix: "fas" },
  faSymbols: { ...s4.definition, prefix: "fas" },
  faTRex: { ...Ob.definition, prefix: "fas" },
  faTableCellsColumnUnlock: { ...kb.definition, prefix: "fas" },
  faTableCellsLock: { ...Ab.definition, prefix: "fas" },
  faTableCellsUnlock: { ...jb.definition, prefix: "fas" },
  faTableLayout: { ...Bb.definition, prefix: "fas" },
  faTablePicnic: { ...Tb.definition, prefix: "fas" },
  faTablePivot: { ...Fb.definition, prefix: "fas" },
  faTableRows: { ...w3.definition, prefix: "fas" },
  faTableTree: { ...Hb.definition, prefix: "fas" },
  faTabletAndroidAlt: { ...Rb.definition, prefix: "fas" },
  faTabletRugged: { ...Ub.definition, prefix: "fas" },
  faTabletScreen: { ...X3.definition, prefix: "fas" },
  faTachometerAltFastest: { ...qb.definition, prefix: "fas" },
  faTachometerAltSlow: { ...Gb.definition, prefix: "fas" },
  faTachometerAltSlowest: { ...Wb.definition, prefix: "fas" },
  faTachometerFastest: { ...Eb.definition, prefix: "fas" },
  faTachometerSlow: { ...Vb.definition, prefix: "fas" },
  faTachometerSlowest: { ...Ib.definition, prefix: "fas" },
  faTaco: { ...Kb.definition, prefix: "fas" },
  faTally: { ...Q3.definition, prefix: "fas" },
  faTally1: { ...Xb.definition, prefix: "fas" },
  faTally2: { ...Qb.definition, prefix: "fas" },
  faTally3: { ...Jb.definition, prefix: "fas" },
  faTally4: { ...Yb.definition, prefix: "fas" },
  faTally5: { ...Zb.definition, prefix: "fas" },
  faTamale: { ...pb.definition, prefix: "fas" },
  faTankWater: { ...xb.definition, prefix: "fas" },
  faTaxiBus: { ...iS.definition, prefix: "fas" },
  faTeddyBear: { ...aS.definition, prefix: "fas" },
  faTelescope: { ...eS.definition, prefix: "fas" },
  faTeletypeAnswer: { ...nS.definition, prefix: "fas" },
  faTemperatureFrigid: { ...fS.definition, prefix: "fas" },
  faTemperatureHot: { ...cS.definition, prefix: "fas" },
  faTemperatureList: { ...tS.definition, prefix: "fas" },
  faTemperatureSnow: { ...Y3.definition, prefix: "fas" },
  faTemperatureSun: { ...Z3.definition, prefix: "fas" },
  faTennisBall: { ...oS.definition, prefix: "fas" },
  faTentDoublePeak: { ...lS.definition, prefix: "fas" },
  faText: { ...dS.definition, prefix: "fas" },
  faTextSize: { ...rS.definition, prefix: "fas" },
  faTheta: { ...sS.definition, prefix: "fas" },
  faThoughtBubble: { ...hS.definition, prefix: "fas" },
  faThunderstormMoon: { ...vS.definition, prefix: "fas" },
  faThunderstormSun: { ...uS.definition, prefix: "fas" },
  faTick: { ...mS.definition, prefix: "fas" },
  faTicketAirline: { ...O.definition, prefix: "fas" },
  faTicketPerforated: { ...gS.definition, prefix: "fas" },
  faTicketPerforatedPlane: { ...PS.definition, prefix: "fas" },
  faTicketPlane: { ...MS.definition, prefix: "fas" },
  faTickets: { ...wS.definition, prefix: "fas" },
  faTicketsAirline: { ...k.definition, prefix: "fas" },
  faTicketsPerforated: { ...NS.definition, prefix: "fas" },
  faTicketsPerforatedPlane: { ...zS.definition, prefix: "fas" },
  faTicketsPlane: { ...LS.definition, prefix: "fas" },
  faTicketsSimple: { ...CS.definition, prefix: "fas" },
  faTilde: { ...DS.definition, prefix: "fas" },
  faTimelineArrow: { ...$S.definition, prefix: "fas" },
  faTimer: { ..._S.definition, prefix: "fas" },
  faTimesHexagon: { ...bS.definition, prefix: "fas" },
  faTimesOctagon: { ...SS.definition, prefix: "fas" },
  faTimesToSlot: { ...yS.definition, prefix: "fas" },
  faTire: { ...OS.definition, prefix: "fas" },
  faTireFlat: { ...kS.definition, prefix: "fas" },
  faTirePressureWarning: { ...AS.definition, prefix: "fas" },
  faTireRugged: { ...jS.definition, prefix: "fas" },
  faToggleLargeOff: { ...BS.definition, prefix: "fas" },
  faToggleLargeOn: { ...TS.definition, prefix: "fas" },
  faToiletPaperAlt: { ...FS.definition, prefix: "fas" },
  faToiletPaperBlank: { ...p3.definition, prefix: "fas" },
  faToiletPaperBlankUnder: { ...x3.definition, prefix: "fas" },
  faToiletPaperCheck: { ...HS.definition, prefix: "fas" },
  faToiletPaperReverse: { ...RS.definition, prefix: "fas" },
  faToiletPaperReverseAlt: { ...US.definition, prefix: "fas" },
  faToiletPaperReverseSlash: { ...qS.definition, prefix: "fas" },
  faToiletPaperUnder: { ...i0.definition, prefix: "fas" },
  faToiletPaperUnderSlash: { ...a0.definition, prefix: "fas" },
  faToiletPaperXmark: { ...GS.definition, prefix: "fas" },
  faTomato: { ...WS.definition, prefix: "fas" },
  faTombstone: { ...ES.definition, prefix: "fas" },
  faTombstoneAlt: { ...VS.definition, prefix: "fas" },
  faTombstoneBlank: { ...e0.definition, prefix: "fas" },
  faToothbrush: { ...IS.definition, prefix: "fas" },
  faTowerControl: { ...KS.definition, prefix: "fas" },
  faTrafficCone: { ...XS.definition, prefix: "fas" },
  faTrafficLightGo: { ...QS.definition, prefix: "fas" },
  faTrafficLightSlow: { ...JS.definition, prefix: "fas" },
  faTrafficLightStop: { ...YS.definition, prefix: "fas" },
  faTrainSubwayTunnel: { ...I3.definition, prefix: "fas" },
  faTrainTrack: { ...ZS.definition, prefix: "fas" },
  faTrainTunnel: { ...pS.definition, prefix: "fas" },
  faTransformerBolt: { ...xS.definition, prefix: "fas" },
  faTransporter: { ...iy.definition, prefix: "fas" },
  faTransporter1: { ...ay.definition, prefix: "fas" },
  faTransporter2: { ...ey.definition, prefix: "fas" },
  faTransporter3: { ...ny.definition, prefix: "fas" },
  faTransporter4: { ...fy.definition, prefix: "fas" },
  faTransporter5: { ...cy.definition, prefix: "fas" },
  faTransporter6: { ...ty.definition, prefix: "fas" },
  faTransporter7: { ...oy.definition, prefix: "fas" },
  faTransporterEmpty: { ...ly.definition, prefix: "fas" },
  faTrashAltSlash: { ...dy.definition, prefix: "fas" },
  faTrashArrowTurnLeft: { ...ry.definition, prefix: "fas" },
  faTrashCanArrowTurnLeft: { ...sy.definition, prefix: "fas" },
  faTrashCanCheck: { ...hy.definition, prefix: "fas" },
  faTrashCanClock: { ...vy.definition, prefix: "fas" },
  faTrashCanList: { ...uy.definition, prefix: "fas" },
  faTrashCanPlus: { ...my.definition, prefix: "fas" },
  faTrashCanSlash: { ...n0.definition, prefix: "fas" },
  faTrashCanUndo: { ...j.definition, prefix: "fas" },
  faTrashCanXmark: { ...gy.definition, prefix: "fas" },
  faTrashCheck: { ...Py.definition, prefix: "fas" },
  faTrashCircle: { ...My.definition, prefix: "fas" },
  faTrashClock: { ...wy.definition, prefix: "fas" },
  faTrashList: { ...Ny.definition, prefix: "fas" },
  faTrashPlus: { ...zy.definition, prefix: "fas" },
  faTrashSlash: { ...Ly.definition, prefix: "fas" },
  faTrashUndo: { ...f0.definition, prefix: "fas" },
  faTrashUndoAlt: { ...Cy.definition, prefix: "fas" },
  faTrashXmark: { ...Dy.definition, prefix: "fas" },
  faTreasureChest: { ...$y.definition, prefix: "fas" },
  faTreeAlt: { ..._y.definition, prefix: "fas" },
  faTreeChristmas: { ...by.definition, prefix: "fas" },
  faTreeDeciduous: { ...c0.definition, prefix: "fas" },
  faTreeDecorated: { ...Sy.definition, prefix: "fas" },
  faTreeLarge: { ...yy.definition, prefix: "fas" },
  faTreePalm: { ...Oy.definition, prefix: "fas" },
  faTrees: { ...ky.definition, prefix: "fas" },
  faTrianBalbot: { ...Ay.definition, prefix: "fas" },
  faTriangle: { ...jy.definition, prefix: "fas" },
  faTriangleInstrument: { ...t0.definition, prefix: "fas" },
  faTriangleMusic: { ...By.definition, prefix: "fas" },
  faTrianglePersonDigging: { ...E1.definition, prefix: "fas" },
  faTricycle: { ...Ty.definition, prefix: "fas" },
  faTricycleAdult: { ...Fy.definition, prefix: "fas" },
  faTrillium: { ...Hy.definition, prefix: "fas" },
  faTrophyAlt: { ...Ry.definition, prefix: "fas" },
  faTrophyStar: { ...o0.definition, prefix: "fas" },
  faTruckBolt: { ...Uy.definition, prefix: "fas" },
  faTruckClock: { ...b3.definition, prefix: "fas" },
  faTruckContainer: { ...qy.definition, prefix: "fas" },
  faTruckContainerEmpty: { ...Gy.definition, prefix: "fas" },
  faTruckCouch: { ...Wy.definition, prefix: "fas" },
  faTruckFire: { ...Ey.definition, prefix: "fas" },
  faTruckFlatbed: { ...Vy.definition, prefix: "fas" },
  faTruckLadder: { ...Iy.definition, prefix: "fas" },
  faTruckPlow: { ...Ky.definition, prefix: "fas" },
  faTruckRamp: { ...Xy.definition, prefix: "fas" },
  faTruckRampCouch: { ...l0.definition, prefix: "fas" },
  faTruckTow: { ...Qy.definition, prefix: "fas" },
  faTruckUtensils: { ...Jy.definition, prefix: "fas" },
  faTrumpet: { ...Yy.definition, prefix: "fas" },
  faTtyAnswer: { ...J3.definition, prefix: "fas" },
  faTugrikSign: { ...Zy.definition, prefix: "fas" },
  faTurkey: { ...py.definition, prefix: "fas" },
  faTurnDownLeft: { ...xy.definition, prefix: "fas" },
  faTurnDownRight: { ...iO.definition, prefix: "fas" },
  faTurnLeft: { ...aO.definition, prefix: "fas" },
  faTurnLeftDown: { ...eO.definition, prefix: "fas" },
  faTurnLeftUp: { ...nO.definition, prefix: "fas" },
  faTurnRight: { ...fO.definition, prefix: "fas" },
  faTurntable: { ...cO.definition, prefix: "fas" },
  faTurtle: { ...tO.definition, prefix: "fas" },
  faTvMusic: { ...oO.definition, prefix: "fas" },
  faTvRetro: { ...lO.definition, prefix: "fas" },
  faTypewriter: { ...dO.definition, prefix: "fas" },
  faUfo: { ...rO.definition, prefix: "fas" },
  faUfoBeam: { ...sO.definition, prefix: "fas" },
  faUmbrellaAlt: { ...hO.definition, prefix: "fas" },
  faUmbrellaSimple: { ...d0.definition, prefix: "fas" },
  faUnicorn: { ...vO.definition, prefix: "fas" },
  faUniformMartialArts: { ...uO.definition, prefix: "fas" },
  faUnion: { ...mO.definition, prefix: "fas" },
  faUp: { ...ii.definition, prefix: "fas" },
  faUpFromBracket: { ...gO.definition, prefix: "fas" },
  faUpFromDottedLine: { ...PO.definition, prefix: "fas" },
  faUpFromLine: { ...q.definition, prefix: "fas" },
  faUpLeft: { ...MO.definition, prefix: "fas" },
  faUpRight: { ...wO.definition, prefix: "fas" },
  faUpToBracket: { ...NO.definition, prefix: "fas" },
  faUpToDottedLine: { ...zO.definition, prefix: "fas" },
  faUpToLine: { ...x.definition, prefix: "fas" },
  faUsbDrive: { ...LO.definition, prefix: "fas" },
  faUsdCircle: { ...CO.definition, prefix: "fas" },
  faUsdSquare: { ...DO.definition, prefix: "fas" },
  faUserAlien: { ...$O.definition, prefix: "fas" },
  faUserBeardBolt: { ..._O.definition, prefix: "fas" },
  faUserBountyHunter: { ...bO.definition, prefix: "fas" },
  faUserChart: { ...SO.definition, prefix: "fas" },
  faUserChef: { ...yO.definition, prefix: "fas" },
  faUserConstruction: { ...OO.definition, prefix: "fas" },
  faUserCowboy: { ...kO.definition, prefix: "fas" },
  faUserCrown: { ...AO.definition, prefix: "fas" },
  faUserDoctorHair: { ...jO.definition, prefix: "fas" },
  faUserDoctorHairLong: { ...BO.definition, prefix: "fas" },
  faUserDoctorMessage: { ...r0.definition, prefix: "fas" },
  faUserGroupCrown: { ...s0.definition, prefix: "fas" },
  faUserGroupSimple: { ...TO.definition, prefix: "fas" },
  faUserHair: { ...FO.definition, prefix: "fas" },
  faUserHairBuns: { ...HO.definition, prefix: "fas" },
  faUserHairLong: { ...RO.definition, prefix: "fas" },
  faUserHairMullet: { ...l.definition, prefix: "fas" },
  faUserHardHat: { ...UO.definition, prefix: "fas" },
  faUserHeadset: { ...qO.definition, prefix: "fas" },
  faUserHelmetSafety: { ...B.definition, prefix: "fas" },
  faUserHoodie: { ...GO.definition, prefix: "fas" },
  faUserMagnifyingGlass: { ...WO.definition, prefix: "fas" },
  faUserMdChat: { ...EO.definition, prefix: "fas" },
  faUserMusic: { ...VO.definition, prefix: "fas" },
  faUserNurseHair: { ...IO.definition, prefix: "fas" },
  faUserNurseHairLong: { ...KO.definition, prefix: "fas" },
  faUserPilot: { ...XO.definition, prefix: "fas" },
  faUserPilotTie: { ...QO.definition, prefix: "fas" },
  faUserPolice: { ...JO.definition, prefix: "fas" },
  faUserPoliceTie: { ...YO.definition, prefix: "fas" },
  faUserRobot: { ...ZO.definition, prefix: "fas" },
  faUserRobotXmarks: { ...pO.definition, prefix: "fas" },
  faUserShakespeare: { ...xO.definition, prefix: "fas" },
  faUserTieHair: { ...ik.definition, prefix: "fas" },
  faUserTieHairLong: { ...ak.definition, prefix: "fas" },
  faUserUnlock: { ...ek.definition, prefix: "fas" },
  faUserVisor: { ...nk.definition, prefix: "fas" },
  faUserVneck: { ...fk.definition, prefix: "fas" },
  faUserVneckHair: { ...ck.definition, prefix: "fas" },
  faUserVneckHairLong: { ...tk.definition, prefix: "fas" },
  faUsersClass: { ...ok.definition, prefix: "fas" },
  faUsersCrown: { ...lk.definition, prefix: "fas" },
  faUsersMedical: { ...dk.definition, prefix: "fas" },
  faUtensilFork: { ...rk.definition, prefix: "fas" },
  faUtensilKnife: { ...sk.definition, prefix: "fas" },
  faUtensilsAlt: { ...hk.definition, prefix: "fas" },
  faUtensilsSlash: { ...vk.definition, prefix: "fas" },
  faUtilityPole: { ...uk.definition, prefix: "fas" },
  faUtilityPoleDouble: { ...mk.definition, prefix: "fas" },
  faVacuum: { ...gk.definition, prefix: "fas" },
  faVacuumRobot: { ...Pk.definition, prefix: "fas" },
  faValueAbsolute: { ...Mk.definition, prefix: "fas" },
  faVectorCircle: { ...wk.definition, prefix: "fas" },
  faVectorPolygon: { ...Nk.definition, prefix: "fas" },
  faVentDamper: { ...zk.definition, prefix: "fas" },
  faVhs: { ...Lk.definition, prefix: "fas" },
  faVideoArrowDownLeft: { ...Ck.definition, prefix: "fas" },
  faVideoArrowUpRight: { ...Dk.definition, prefix: "fas" },
  faVideoCircle: { ...$k.definition, prefix: "fas" },
  faVideoHandheld: { ..._k.definition, prefix: "fas" },
  faVideoPlus: { ...bk.definition, prefix: "fas" },
  faViolin: { ...Sk.definition, prefix: "fas" },
  faVolume: { ...h0.definition, prefix: "fas" },
  faVolumeMedium: { ...yk.definition, prefix: "fas" },
  faVolumeSlash: { ...Ok.definition, prefix: "fas" },
  faVoteNay: { ...kk.definition, prefix: "fas" },
  faWaffle: { ...Ak.definition, prefix: "fas" },
  faWagonCovered: { ...jk.definition, prefix: "fas" },
  faWalker: { ...Bk.definition, prefix: "fas" },
  faWallBrick: { ...Tk.definition, prefix: "fas" },
  faWand: { ...Fk.definition, prefix: "fas" },
  faWarehouseAlt: { ...Hk.definition, prefix: "fas" },
  faWarehouseFull: { ...v0.definition, prefix: "fas" },
  faWasher: { ...Rk.definition, prefix: "fas" },
  faWashingMachine: { ...u0.definition, prefix: "fas" },
  faWatch: { ...Uk.definition, prefix: "fas" },
  faWatchApple: { ...qk.definition, prefix: "fas" },
  faWatchCalculator: { ...Gk.definition, prefix: "fas" },
  faWatchFitness: { ...Wk.definition, prefix: "fas" },
  faWatchSmart: { ...Ek.definition, prefix: "fas" },
  faWaterArrowDown: { ...m0.definition, prefix: "fas" },
  faWaterArrowUp: { ...g0.definition, prefix: "fas" },
  faWaterLower: { ...Vk.definition, prefix: "fas" },
  faWaterRise: { ...Ik.definition, prefix: "fas" },
  faWatermelonSlice: { ...Kk.definition, prefix: "fas" },
  faWave: { ...Xk.definition, prefix: "fas" },
  faWavePulse: { ...n4.definition, prefix: "fas" },
  faWaveSine: { ...Qk.definition, prefix: "fas" },
  faWaveTriangle: { ...Jk.definition, prefix: "fas" },
  faWaveform: { ...Yk.definition, prefix: "fas" },
  faWaveformCircle: { ...Zk.definition, prefix: "fas" },
  faWaveformLines: { ...P0.definition, prefix: "fas" },
  faWaveformPath: { ...pk.definition, prefix: "fas" },
  faWavesSine: { ...xk.definition, prefix: "fas" },
  faWebcam: { ...iA.definition, prefix: "fas" },
  faWebcamSlash: { ...aA.definition, prefix: "fas" },
  faWebhook: { ...eA.definition, prefix: "fas" },
  faWhale: { ...nA.definition, prefix: "fas" },
  faWheat: { ...fA.definition, prefix: "fas" },
  faWheatAwnSlash: { ...cA.definition, prefix: "fas" },
  faWheatSlash: { ...tA.definition, prefix: "fas" },
  faWhiskeyGlassIce: { ...Ja.definition, prefix: "fas" },
  faWhistle: { ...oA.definition, prefix: "fas" },
  faWifi1: { ...lA.definition, prefix: "fas" },
  faWifi2: { ...dA.definition, prefix: "fas" },
  faWifiExclamation: { ...rA.definition, prefix: "fas" },
  faWifiFair: { ...w0.definition, prefix: "fas" },
  faWifiSlash: { ...sA.definition, prefix: "fas" },
  faWifiWeak: { ...M0.definition, prefix: "fas" },
  faWindCircleExclamation: { ...hA.definition, prefix: "fas" },
  faWindTurbine: { ...vA.definition, prefix: "fas" },
  faWindWarning: { ...N0.definition, prefix: "fas" },
  faWindow: { ...uA.definition, prefix: "fas" },
  faWindowAlt: { ...mA.definition, prefix: "fas" },
  faWindowFlip: { ...z0.definition, prefix: "fas" },
  faWindowFrame: { ...gA.definition, prefix: "fas" },
  faWindowFrameOpen: { ...PA.definition, prefix: "fas" },
  faWindsock: { ...MA.definition, prefix: "fas" },
  faWineGlassCrack: { ...Ua.definition, prefix: "fas" },
  faWreath: { ...wA.definition, prefix: "fas" },
  faWreathLaurel: { ...NA.definition, prefix: "fas" },
  faWrenchSimple: { ...zA.definition, prefix: "fas" },
  faXmarkHexagon: { ...LA.definition, prefix: "fas" },
  faXmarkLarge: { ...CA.definition, prefix: "fas" },
  faXmarkOctagon: { ...DA.definition, prefix: "fas" },
  faXmarkToSlot: { ...A.definition, prefix: "fas" },
  faZzz: { ...$A.definition, prefix: "fas" },
  faActors: { ...zui, prefix: "fas" },
  faSelect: { ...Lui, prefix: "fas" }
};
function w02(i) {
  return bA(_A, i);
}
const N02 = L0.definition, z02 = C0.definition, L02 = D0.definition, C02 = $0.definition, D02 = _0.definition, $02 = b0.definition, _02 = S0.definition, b02 = y0.definition, S02 = O0.definition, y02 = k0.definition, O02 = A0.definition, k02 = j0.definition, A02 = B0.definition, j02 = T0.definition, B02 = F0.definition, T02 = H0.definition, F02 = R0.definition, H02 = U0.definition, R02 = q0.definition, U02 = G0.definition, q02 = F.definition, G02 = W0.definition, W02 = E0.definition, E02 = V0.definition, V02 = I0.definition, I02 = K0.definition, K02 = X0.definition, X02 = Q0.definition, Q02 = J0.definition, J02 = Y0.definition, Y02 = Z0.definition, Z02 = p0.definition, p02 = x0.definition, x02 = ie.definition, ie2 = ae.definition, ae2 = ee.definition, ee2 = ne.definition, ne2 = fe.definition, fe2 = ce.definition, ce2 = te.definition, te2 = oe.definition, oe2 = le.definition, le2 = de.definition, de2 = re.definition, re2 = se.definition, se2 = he.definition, he2 = ve.definition, ve2 = ue.definition, ue2 = me.definition, me2 = ge.definition, ge2 = Pe.definition, Pe2 = Me.definition, Me2 = we.definition, we2 = ai.definition, Ne2 = ei.definition, ze2 = Ne.definition, Le2 = ze.definition, Ce2 = Le.definition, De2 = ni.definition, $e2 = Ce.definition, _e2 = De.definition, be2 = $e.definition, Se2 = fi.definition, ye2 = ci.definition, Oe2 = _e.definition, ke2 = be.definition, Ae2 = Se.definition, je2 = ti.definition, Be2 = ye.definition, Te2 = oi.definition, Fe2 = Oe.definition, He2 = ke.definition, Re2 = Ae.definition, Ue2 = je.definition, qe2 = Be.definition, Ge2 = Te.definition, We2 = ri.definition, Ee2 = Fe.definition, Ve2 = He.definition, Ie2 = Re.definition, Ke2 = si.definition, Xe2 = Ue.definition, Qe2 = qe.definition, Je2 = di.definition, Ye2 = Ge.definition, Ze2 = We.definition, pe2 = hi.definition, xe2 = Ee.definition, in2 = Ve.definition, an2 = Ie.definition, en2 = Ke.definition, nn2 = Xe.definition, fn2 = Qe.definition, cn2 = Je.definition, tn2 = Ye.definition, on2 = Ze.definition, ln2 = pe.definition, dn2 = xe.definition, rn2 = an.definition, sn2 = en.definition, hn2 = nn.definition, vn2 = Mi.definition, un2 = wi.definition, mn2 = fn.definition, gn2 = cn.definition, Pn2 = li.definition, Mn2 = tn.definition, wn2 = on.definition, Nn2 = ln.definition, zn2 = dn.definition, Ln2 = rn.definition, Cn2 = Ni.definition, Dn2 = zi.definition, $n2 = sn.definition, _n2 = hn.definition, bn2 = vn.definition, Sn2 = Pi.definition, yn2 = Li.definition, On2 = un.definition, kn2 = mn.definition, An2 = gn.definition, jn2 = Ci.definition, Bn2 = Di.definition, Tn2 = $i.definition, Fn2 = _i.definition, Hn2 = bi.definition, Rn2 = Pn.definition, Un2 = Mn.definition, qn2 = wn.definition, Gn2 = Nn.definition, Wn2 = Si.definition, En2 = zn.definition, Vn2 = Ln.definition, In2 = Cn.definition, Kn2 = Dn.definition, Xn2 = $n.definition, Qn2 = _n.definition, Jn2 = bn.definition, Yn2 = Sn.definition, Zn2 = yn.definition, pn2 = On.definition, xn2 = kn.definition, i62 = An.definition, a62 = jn.definition, e62 = Bn.definition, n62 = Tn.definition, f62 = Fn.definition, c62 = Hn.definition, t62 = Rn.definition, o62 = Un.definition, l62 = qn.definition, d62 = Gn.definition, r62 = Wn.definition, s62 = En.definition, h62 = Vn.definition, v62 = yi.definition, u62 = Oi.definition, m62 = In.definition, g62 = Kn.definition, P62 = Xn.definition, M62 = Qn.definition, w62 = Jn.definition, N62 = Yn.definition, z62 = Zn.definition, L62 = pn.definition, C62 = xn.definition, D62 = i6.definition, $62 = ji.definition, _62 = a6.definition, b62 = e6.definition, S62 = n6.definition, y62 = f6.definition, O62 = c6.definition, k62 = Bi.definition, A62 = t6.definition, j62 = o6.definition, B62 = l6.definition, T62 = d6.definition, F62 = Ti.definition, H62 = r6.definition, R62 = s6.definition, U62 = Fi.definition, q62 = h6.definition, G62 = v6.definition, W62 = u6.definition, E62 = m6.definition, V62 = g6.definition, I62 = P6.definition, K62 = M6.definition, X62 = w6.definition, Q62 = N6.definition, J62 = z6.definition, Y62 = L6.definition, Z62 = C6.definition, p62 = D6.definition, x62 = $6.definition, if2 = _6.definition, af2 = b6.definition, ef2 = S6.definition, nf2 = y6.definition, ff2 = O6.definition, cf2 = k6.definition, tf2 = A6.definition, of2 = j6.definition, lf2 = B6.definition, df2 = T6.definition, rf2 = F6.definition, sf2 = Ui.definition, hf2 = qi.definition, vf2 = H6.definition, uf2 = R6.definition, mf2 = U6.definition, gf2 = q6.definition, Pf2 = G6.definition, Mf2 = W6.definition, wf2 = E6.definition, Nf2 = V6.definition, zf2 = I6.definition, Lf2 = Gi.definition, Cf2 = K6.definition, Df2 = X6.definition, $f2 = Q6.definition, _f2 = J6.definition, bf2 = Y6.definition, Sf2 = Z6.definition, yf2 = p6.definition, Of2 = x6.definition, kf2 = Vi.definition, Af2 = Ei.definition, jf2 = Ii.definition, Bf2 = af.definition, Tf2 = ef.definition, Ff2 = nf.definition, Hf2 = ff.definition, Rf2 = cf.definition, Uf2 = tf.definition, qf2 = of.definition, Gf2 = lf.definition, Wf2 = df.definition, Ef2 = rf.definition, Vf2 = sf.definition, If2 = Xi.definition, Kf2 = hf.definition, Xf2 = vf.definition, Qf2 = uf.definition, Jf2 = mf.definition, Yf2 = gf.definition, Zf2 = Pf.definition, pf2 = Mf.definition, xf2 = wf.definition, ic2 = Nf.definition, ac2 = zf.definition, ec2 = Lf.definition, nc2 = Cf.definition, fc2 = Qi.definition, cc2 = Df.definition, tc2 = Yi.definition, oc2 = $f.definition, lc2 = _f.definition, dc2 = bf.definition, rc2 = Sf.definition, sc2 = yf.definition, hc2 = Of.definition, vc2 = kf.definition, uc2 = Af.definition, mc2 = jf.definition, gc2 = Bf.definition, Pc2 = pi.definition, Mc2 = Tf.definition, wc2 = Ff.definition, Nc2 = Hf.definition, zc2 = xi.definition, Lc2 = Zi.definition, Cc2 = Rf.definition, Dc2 = Uf.definition, $c2 = a2.definition, _c2 = qf.definition, bc2 = e2.definition, Sc2 = Gf.definition, yc2 = Wf.definition, Oc2 = Ef.definition, kc2 = n2.definition, Ac2 = Vf.definition, jc2 = h.definition, Bc2 = If.definition, Tc2 = Kf.definition, Fc2 = Xf.definition, Hc2 = c2.definition, Rc2 = f2.definition, Uc2 = t2.definition, qc2 = Qf.definition, Gc2 = Jf.definition, Wc2 = Yf.definition, Ec2 = Zf.definition, Vc2 = pf.definition, Ic2 = xf.definition, Kc2 = ic.definition, Xc2 = ac.definition, Qc2 = ec.definition, Jc2 = nc.definition, Yc2 = fc.definition, Zc2 = cc.definition, pc2 = tc.definition, xc2 = oc.definition, i82 = lc.definition, a82 = dc.definition, e82 = rc.definition, n82 = sc.definition, f82 = hc.definition, c82 = vc.definition, t82 = uc.definition, o82 = mc.definition, l82 = gc.definition, d82 = o2.definition, r82 = Pc.definition, s82 = Mc.definition, h82 = wc.definition, v82 = Nc.definition, u82 = zc.definition, m82 = Lc.definition, g82 = Cc.definition, P82 = Dc.definition, M82 = $c.definition, w82 = _c.definition, N82 = bc.definition, z82 = Sc.definition, L82 = l2.definition, C82 = yc.definition, D82 = d2.definition, $82 = r2.definition, _82 = s2.definition, b82 = Oc.definition, S82 = kc.definition, y82 = Ac.definition, O82 = jc.definition, k82 = Bc.definition, A82 = v2.definition, j82 = Tc.definition, B82 = Fc.definition, T82 = Hc.definition, F82 = Rc.definition, H82 = Uc.definition, R82 = m2.definition, U82 = qc.definition, q82 = Gc.definition, G82 = u2.definition, W82 = Wc.definition, E82 = Ec.definition, V82 = Vc.definition, I82 = Ic.definition, K82 = Kc.definition, X82 = Xc.definition, Q82 = g2.definition, J82 = P2.definition, Y82 = Qc.definition, Z82 = Jc.definition, p82 = Yc.definition, x82 = Zc.definition, i52 = w2.definition, a52 = pc.definition, e52 = N2.definition, n52 = z2.definition, f52 = L2.definition, c52 = xc.definition, t52 = i8.definition, o52 = a8.definition, l52 = e8.definition, d52 = C2.definition, r52 = n8.definition, s52 = f8.definition, h52 = c8.definition, v52 = t8.definition, u52 = o8.definition, m52 = l8.definition, g52 = d8.definition, P52 = r8.definition, M52 = s8.definition, w52 = h8.definition, N52 = v8.definition, z52 = u8.definition, L52 = m8.definition, C52 = D2.definition, D52 = g8.definition, $52 = $2.definition, _52 = P8.definition, b52 = M8.definition, S52 = w8.definition, y52 = N8.definition, O52 = z8.definition, k52 = L8.definition, A52 = C8.definition, j52 = D8.definition, B52 = $8.definition, T52 = _8.definition, F52 = b8.definition, H52 = S8.definition, R52 = y8.definition, U52 = O8.definition, q52 = k8.definition, G52 = A8.definition, W52 = j8.definition, E52 = B8.definition, V52 = O2.definition, I52 = k2.definition, K52 = T8.definition, X52 = F8.definition, Q52 = H8.definition, J52 = Hi.definition, Y52 = R8.definition, Z52 = A2.definition, p52 = U8.definition, x52 = q8.definition, i72 = G8.definition, a72 = W8.definition, e72 = E8.definition, n72 = V8.definition, f72 = I8.definition, c72 = T2.definition, t72 = K8.definition, o72 = X8.definition, l72 = Q8.definition, d72 = J8.definition, r72 = Y8.definition, s72 = Z8.definition, h72 = H.definition, v72 = p8.definition, u72 = x8.definition, m72 = i5.definition, g72 = a5.definition, P72 = F2.definition, M72 = e5.definition, w72 = n5.definition, N72 = f5.definition, z72 = c5.definition, L72 = t5.definition, C72 = o5.definition, D72 = l5.definition, $72 = d5.definition, _72 = r5.definition, b72 = H2.definition, S72 = s5.definition, y72 = h5.definition, O72 = v5.definition, k72 = u5.definition, A72 = m5.definition, j72 = R2.definition, B72 = g5.definition, T72 = P5.definition, F72 = U2.definition, H72 = M5.definition, R72 = q2.definition, U72 = w5.definition, q72 = G2.definition, G72 = N5.definition, W72 = W2.definition, E72 = z5.definition, V72 = E2.definition, I72 = L5.definition, K72 = V2.definition, X72 = C5.definition, Q72 = D5.definition, J72 = $5.definition, Y72 = _5.definition, Z72 = b5.definition, p72 = S5.definition, x72 = y5.definition, it2 = O5.definition, at2 = k5.definition, et2 = I2.definition, nt2 = K2.definition, ft2 = X2.definition, ct2 = Q2.definition, tt2 = A5.definition, ot2 = j5.definition, lt2 = B5.definition, dt2 = T5.definition, rt2 = F5.definition, st2 = H5.definition, ht2 = R5.definition, vt2 = U5.definition, ut2 = q5.definition, mt2 = G5.definition, gt2 = W5.definition, Pt2 = E5.definition, Mt2 = V5.definition, wt2 = I5.definition, Nt2 = K5.definition, zt2 = X5.definition, Lt2 = Q5.definition, Ct2 = J5.definition, Dt2 = Y5.definition, $t2 = Z5.definition, _t2 = p5.definition, bt2 = x5.definition, St2 = Wi.definition, yt2 = Ki.definition, Ot2 = i7.definition, kt2 = h2.definition, At2 = M2.definition, jt2 = _2.definition, Bt2 = b2.definition, Tt2 = S2.definition, Ft2 = y2.definition, Ht2 = a7.definition, Rt2 = e7.definition, Ut2 = n7.definition, qt2 = v.definition, Gt2 = f7.definition, Wt2 = c7.definition, Et2 = t7.definition, Vt2 = o7.definition, It2 = l7.definition, Kt2 = x2.definition, Xt2 = d7.definition, Qt2 = r7.definition, Jt2 = s7.definition, Yt2 = h7.definition, Zt2 = v7.definition, pt2 = u7.definition, xt2 = i1.definition, io2 = m7.definition, ao2 = g7.definition, eo2 = P7.definition, no2 = M7.definition, fo2 = a1.definition, co2 = w7.definition, to2 = e1.definition, oo2 = n1.definition, lo2 = N7.definition, do2 = z7.definition, ro2 = L7.definition, so2 = f1.definition, ho2 = c1.definition, vo2 = t1.definition, uo2 = o1.definition, mo2 = C7.definition, go2 = D7.definition, Po2 = $7.definition, Mo2 = _7.definition, wo2 = b7.definition, No2 = S7.definition, zo2 = y7.definition, Lo2 = l1.definition, Co2 = d1.definition, Do2 = r1.definition, $o2 = s1.definition, _o2 = O7.definition, bo2 = k7.definition, So2 = A7.definition, yo2 = j7.definition, Oo2 = h1.definition, ko2 = B7.definition, Ao2 = T7.definition, jo2 = F7.definition, Bo2 = H7.definition, To2 = v1.definition, Fo2 = R7.definition, Ho2 = u1.definition, Ro2 = U7.definition, Uo2 = m1.definition, qo2 = q7.definition, Go2 = G7.definition, Wo2 = W7.definition, Eo2 = E7.definition, Vo2 = V7.definition, Io2 = I7.definition, Ko2 = K7.definition, Xo2 = X7.definition, Qo2 = Q7.definition, Jo2 = J7.definition, Yo2 = Y7.definition, Zo2 = Z7.definition, po2 = p7.definition, xo2 = x7.definition, il2 = it.definition, al2 = at.definition, el2 = et.definition, nl2 = nt.definition, fl2 = ft.definition, cl2 = ct.definition, tl2 = tt.definition, ol2 = ot.definition, ll2 = lt.definition, dl2 = dt.definition, rl2 = rt.definition, sl2 = st.definition, hl2 = ht.definition, vl2 = vt.definition, ul2 = ut.definition, ml2 = mt.definition, gl2 = gt.definition, Pl2 = Pt.definition, Ml2 = Mt.definition, wl2 = wt.definition, Nl2 = Nt.definition, zl2 = zt.definition, Ll2 = Lt.definition, Cl2 = Ct.definition, Dl2 = Dt.definition, $l2 = $t.definition, _l2 = _t.definition, bl2 = g1.definition, Sl2 = P1.definition, yl2 = bt.definition, Ol2 = St.definition, kl2 = yt.definition, Al2 = M1.definition, jl2 = Ot.definition, Bl2 = kt.definition, Tl2 = At.definition, Fl2 = jt.definition, Hl2 = Bt.definition, Rl2 = Tt.definition, Ul2 = Ft.definition, ql2 = Ht.definition, Gl2 = Rt.definition, Wl2 = Ut.definition, El2 = qt.definition, Vl2 = Gt.definition, Il2 = Wt.definition, Kl2 = Et.definition, Xl2 = Vt.definition, Ql2 = It.definition, Jl2 = Kt.definition, Yl2 = Xt.definition, Zl2 = Qt.definition, pl2 = Jt.definition, xl2 = Yt.definition, id2 = Zt.definition, ad2 = pt.definition, ed2 = xt.definition, nd2 = io.definition, fd2 = ao.definition, cd2 = eo.definition, td2 = no.definition, od2 = fo.definition, ld2 = co.definition, dd2 = to.definition, rd2 = oo.definition, sd2 = lo.definition, hd2 = ro.definition, vd2 = so.definition, ud2 = ho.definition, md2 = vo.definition, gd2 = uo.definition, Pd2 = mo.definition, Md2 = go.definition, wd2 = Po.definition, Nd2 = Mo.definition, zd2 = wo.definition, Ld2 = No.definition, Cd2 = zo.definition, Dd2 = Lo.definition, $d2 = Co.definition, _d2 = Do.definition, bd2 = $o.definition, Sd2 = _o.definition, yd2 = bo.definition, Od2 = So.definition, kd2 = yo.definition, Ad2 = Oo.definition, jd2 = ko.definition, Bd2 = Ao.definition, Td2 = jo.definition, Fd2 = Bo.definition, Hd2 = To.definition, Rd2 = Fo.definition, Ud2 = Ho.definition, qd2 = Ro.definition, Gd2 = Uo.definition, Wd2 = qo.definition, Ed2 = Go.definition, Vd2 = Wo.definition, Id2 = Eo.definition, Kd2 = Vo.definition, Xd2 = Io.definition, Qd2 = Ko.definition, Jd2 = Xo.definition, Yd2 = Qo.definition, Zd2 = F1.definition, pd2 = Jo.definition, xd2 = Yo.definition, ir2 = Zo.definition, ar2 = po.definition, er2 = xo.definition, nr2 = il.definition, fr2 = U1.definition, cr2 = al.definition, tr2 = el.definition, or2 = nl.definition, lr2 = fl.definition, dr2 = cl.definition, rr2 = tl.definition, sr2 = ol.definition, hr2 = ll.definition, vr2 = W1.definition, ur2 = dl.definition, mr2 = rl.definition, gr2 = sl.definition, Pr2 = hl.definition, Mr2 = vl.definition, wr2 = ul.definition, Nr2 = V1.definition, zr2 = ml.definition, Lr2 = gl.definition, Cr2 = Pl.definition, Dr2 = Ml.definition, $r2 = wl.definition, _r2 = Nl.definition, br2 = K1.definition, Sr2 = zl.definition, yr2 = Ll.definition, Or2 = R.definition, kr2 = Cl.definition, Ar2 = Dl.definition, jr2 = $l.definition, Br2 = _l.definition, Tr2 = bl.definition, Fr2 = Q1.definition, Hr2 = Sl.definition, Rr2 = yl.definition, Ur2 = Ol.definition, qr2 = kl.definition, Gr2 = Al.definition, Wr2 = jl.definition, Er2 = Bl.definition, Vr2 = w1.definition, Ir2 = Tl.definition, Kr2 = Fl.definition, Xr2 = J1.definition, Qr2 = Hl.definition, Jr2 = Rl.definition, Yr2 = Y1.definition, Zr2 = Ul.definition, pr2 = ql.definition, xr2 = Gl.definition, i92 = Wl.definition, a92 = El.definition, e92 = Vl.definition, n92 = Il.definition, f92 = Kl.definition, c92 = Xl.definition, t92 = Ql.definition, o92 = Jl.definition, l92 = Yl.definition, d92 = Zl.definition, r92 = pl.definition, s92 = xl.definition, h92 = id.definition, v92 = aa.definition, u92 = ad.definition, m92 = ed.definition, g92 = nd.definition, P92 = fd.definition, M92 = cd.definition, w92 = td.definition, N92 = od.definition, z92 = ld.definition, L92 = dd.definition, C92 = rd.definition, D92 = sd.definition, $92 = hd.definition, _92 = vd.definition, b92 = ud.definition, S92 = md.definition, y92 = gd.definition, O92 = Pd.definition, k92 = ea.definition, A92 = Md.definition, j92 = wd.definition, B92 = Nd.definition, T92 = zd.definition, F92 = Ld.definition, H92 = Z1.definition, R92 = p1.definition, U92 = x1.definition, q92 = Cd.definition, G92 = Dd.definition, W92 = $d.definition, E92 = _d.definition, V92 = bd.definition, I92 = Sd.definition, K92 = yd.definition, X92 = Od.definition, Q92 = kd.definition, J92 = Ad.definition, Y92 = jd.definition, Z92 = na.definition, p92 = Bd.definition, x92 = U.definition, is2 = Td.definition, as2 = Fd.definition, es2 = E.definition, ns2 = Hd.definition, fs2 = Rd.definition, cs2 = Ud.definition, ts2 = qd.definition, os2 = Y.definition, ls2 = Gd.definition, ds2 = Wd.definition, rs2 = Ed.definition, ss2 = Vd.definition, hs2 = Id.definition, vs2 = fa.definition, us2 = ia.definition, ms2 = ca.definition, gs2 = Kd.definition, Ps2 = Xd.definition, Ms2 = Qd.definition, ws2 = ta.definition, Ns2 = Jd.definition, zs2 = Yd.definition, Ls2 = Zd.definition, Cs2 = pd.definition, Ds2 = xd.definition, $s2 = ir.definition, _s2 = ar.definition, bs2 = er.definition, Ss2 = nr.definition, ys2 = la.definition, Os2 = da.definition, ks2 = fr.definition, As2 = cr.definition, js2 = tr.definition, Bs2 = or.definition, Ts2 = ra.definition, Fs2 = lr.definition, Hs2 = dr.definition, Rs2 = sa.definition, Us2 = rr.definition, qs2 = sr.definition, Gs2 = hr.definition, Ws2 = vr.definition, Es2 = ur.definition, Vs2 = mr.definition, Is2 = gr.definition, Ks2 = Pr.definition, Xs2 = Mr.definition, Qs2 = wr.definition, Js2 = Nr.definition, Ys2 = zr.definition, Zs2 = Lr.definition, ps2 = Cr.definition, xs2 = Dr.definition, ih2 = $r.definition, ah2 = ua.definition, eh2 = _r.definition, nh2 = br.definition, fh2 = Sr.definition, ch2 = yr.definition, th2 = Or.definition, oh2 = kr.definition, lh2 = Ar.definition, dh2 = jr.definition, rh2 = Br.definition, sh2 = Tr.definition, hh2 = Fr.definition, vh2 = Hr.definition, uh2 = va.definition, mh2 = Rr.definition, gh2 = Ur.definition, Ph2 = qr.definition, Mh2 = Gr.definition, wh2 = Wr.definition, Nh2 = Er.definition, zh2 = Vr.definition, Lh2 = Ir.definition, Ch2 = Kr.definition, Dh2 = Xr.definition, $h2 = Qr.definition, _h2 = Jr.definition, bh2 = Yr.definition, Sh2 = Zr.definition, yh2 = pr.definition, Oh2 = xr.definition, kh2 = i9.definition, Ah2 = a9.definition, jh2 = e9.definition, Bh2 = n9.definition, Th2 = f9.definition, Fh2 = c9.definition, Hh2 = t9.definition, Rh2 = o9.definition, Uh2 = l9.definition, qh2 = d9.definition, Gh2 = r9.definition, Wh2 = s9.definition, Eh2 = h9.definition, Vh2 = v9.definition, Ih2 = u9.definition, Kh2 = m9.definition, Xh2 = g9.definition, Qh2 = P9.definition, Jh2 = M9.definition, Yh2 = ma.definition, Zh2 = w9.definition, ph2 = N9.definition, xh2 = z9.definition, iv2 = L9.definition, av2 = C9.definition, ev2 = D9.definition, nv2 = $9.definition, fv2 = _9.definition, cv2 = b9.definition, tv2 = S9.definition, ov2 = y9.definition, lv2 = O9.definition, dv2 = k9.definition, rv2 = A9.definition, sv2 = j9.definition, hv2 = B9.definition, vv2 = T9.definition, uv2 = F9.definition, mv2 = H9.definition, gv2 = R9.definition, Pv2 = U9.definition, Mv2 = q9.definition, wv2 = G9.definition, Nv2 = W9.definition, zv2 = E9.definition, Lv2 = V9.definition, Cv2 = I9.definition, Dv2 = Ai.definition, $v2 = K9.definition, _v2 = X9.definition, bv2 = Q9.definition, Sv2 = ga.definition, yv2 = J9.definition, Ov2 = Y9.definition, kv2 = Z9.definition, Av2 = p9.definition, jv2 = x9.definition, Bv2 = Pa.definition, Tv2 = Na.definition, Fv2 = is.definition, Hv2 = as.definition, Rv2 = es.definition, Uv2 = ns.definition, qv2 = za.definition, Gv2 = fs.definition, Wv2 = cs.definition, Ev2 = ts.definition, Vv2 = os.definition, Iv2 = ls.definition, Kv2 = ds.definition, Xv2 = rs.definition, Qv2 = La.definition, Jv2 = ss.definition, Yv2 = hs.definition, Zv2 = vs.definition, pv2 = us.definition, xv2 = ms.definition, iu2 = gs.definition, au2 = Ps.definition, eu2 = Ms.definition, nu2 = ws.definition, fu2 = Ns.definition, cu2 = zs.definition, tu2 = Ls.definition, ou2 = Cs.definition, lu2 = Ds.definition, du2 = $s.definition, ru2 = _s.definition, su2 = bs.definition, hu2 = Ca.definition, vu2 = Ss.definition, uu2 = ys.definition, mu2 = Os.definition, gu2 = ks.definition, Pu2 = As.definition, Mu2 = $a.definition, wu2 = js.definition, Nu2 = Da.definition, zu2 = Bs.definition, Lu2 = Ts.definition, Cu2 = Fs.definition, Du2 = Hs.definition, $u2 = Rs.definition, _u2 = _a.definition, bu2 = Us.definition, Su2 = qs.definition, yu2 = Gs.definition, Ou2 = Ws.definition, ku2 = Es.definition, Au2 = Vs.definition, ju2 = Is.definition, Bu2 = Ks.definition, Tu2 = Sa.definition, Fu2 = ba.definition, Hu2 = Xs.definition, Ru2 = Qs.definition, Uu2 = Js.definition, qu2 = Ys.definition, Gu2 = Zs.definition, Wu2 = ya.definition, Eu2 = Oa.definition, Vu2 = ps.definition, Iu2 = xs.definition, Ku2 = ka.definition, Xu2 = d.definition, Qu2 = ih.definition, Ju2 = ah.definition, Yu2 = eh.definition, Zu2 = nh.definition, pu2 = fh.definition, xu2 = ch.definition, im2 = th.definition, am2 = oh.definition, em2 = lh.definition, nm2 = dh.definition, fm2 = Aa.definition, cm2 = ja.definition, tm2 = rh.definition, om2 = sh.definition, lm2 = hh.definition, dm2 = vh.definition, rm2 = Ba.definition, sm2 = uh.definition, hm2 = mh.definition, vm2 = gh.definition, um2 = Ta.definition, mm2 = Ph.definition, gm2 = Mh.definition, Pm2 = wh.definition, Mm2 = Nh.definition, wm2 = zh.definition, Nm2 = Lh.definition, zm2 = Fa.definition, Lm2 = Ch.definition, Cm2 = Dh.definition, Dm2 = $h.definition, $m2 = _h.definition, _m2 = Ha.definition, bm2 = Ra.definition, Sm2 = bh.definition, ym2 = Sh.definition, Om2 = yh.definition, km2 = Oh.definition, Am2 = kh.definition, jm2 = Ah.definition, Bm2 = jh.definition, Tm2 = Bh.definition, Fm2 = Th.definition, Hm2 = Fh.definition, Rm2 = Hh.definition, Um2 = Ga.definition, qm2 = Rh.definition, Gm2 = Uh.definition, Wm2 = qh.definition, Em2 = Wa.definition, Vm2 = Gh.definition, Im2 = Wh.definition, Km2 = Eh.definition, Xm2 = Vh.definition, Qm2 = Ih.definition, Jm2 = Kh.definition, Ym2 = Xh.definition, Zm2 = Qh.definition, pm2 = Ea.definition, xm2 = Va.definition, ig2 = Ia.definition, ag2 = Ka.definition, eg2 = Xa.definition, ng2 = Qa.definition, fg2 = Jh.definition, cg2 = Yh.definition, tg2 = Zh.definition, og2 = ph.definition, lg2 = xh.definition, dg2 = iv.definition, rg2 = av.definition, sg2 = ev.definition, hg2 = nv.definition, vg2 = fv.definition, ug2 = cv.definition, mg2 = M.definition, gg2 = tv.definition, Pg2 = ov.definition, Mg2 = lv.definition, wg2 = dv.definition, Ng2 = Ya.definition, zg2 = rv.definition, Lg2 = sv.definition, Cg2 = hv.definition, Dg2 = vv.definition, $g2 = uv.definition, _g2 = mv.definition, bg2 = gv.definition, Sg2 = Pv.definition, yg2 = Mv.definition, Og2 = wv.definition, kg2 = Nv.definition, Ag2 = zv.definition, jg2 = Za.definition, Bg2 = Lv.definition, Tg2 = Cv.definition, Fg2 = Dv.definition, Hg2 = $v.definition, Rg2 = _v.definition, Ug2 = bv.definition, qg2 = Sv.definition, Gg2 = yv.definition, Wg2 = Ov.definition, Eg2 = kv.definition, Vg2 = Av.definition, Ig2 = jv.definition, Kg2 = Bv.definition, Xg2 = Tv.definition, Qg2 = Fv.definition, Jg2 = Hv.definition, Yg2 = Rv.definition, Zg2 = Uv.definition, pg2 = qv.definition, xg2 = Gv.definition, iP2 = Wv.definition, aP2 = Ev.definition, eP2 = Vv.definition, nP2 = Iv.definition, fP2 = Kv.definition, cP2 = Xv.definition, tP2 = Qv.definition, oP2 = Jv.definition, lP2 = Yv.definition, dP2 = Zv.definition, rP2 = pv.definition, sP2 = xv.definition, hP2 = iu.definition, vP2 = au.definition, uP2 = eu.definition, mP2 = nu.definition, gP2 = fu.definition, PP2 = cu.definition, MP2 = tu.definition, wP2 = ou.definition, NP2 = lu.definition, zP2 = du.definition, LP2 = ru.definition, CP2 = su.definition, DP2 = hu.definition, $P2 = vu.definition, _P2 = uu.definition, bP2 = mu.definition, SP2 = pa.definition, yP2 = i4.definition, OP2 = xa.definition, kP2 = gu.definition, AP2 = Pu.definition, jP2 = Mu.definition, BP2 = wu.definition, TP2 = Nu.definition, FP2 = zu.definition, HP2 = Lu.definition, RP2 = Cu.definition, UP2 = Du.definition, qP2 = $u.definition, GP2 = a4.definition, WP2 = _u.definition, EP2 = bu.definition, VP2 = Su.definition, IP2 = yu.definition, KP2 = Ou.definition, XP2 = ku.definition, QP2 = Au.definition, JP2 = e4.definition, YP2 = ju.definition, ZP2 = Bu.definition, pP2 = Tu.definition, xP2 = Fu.definition, iM2 = Hu.definition, aM2 = Ru.definition, eM2 = Uu.definition, nM2 = qu.definition, fM2 = Gu.definition, cM2 = c4.definition, tM2 = t4.definition, oM2 = Wu.definition, lM2 = Eu.definition, dM2 = w.definition, rM2 = o4.definition, sM2 = Vu.definition, hM2 = Iu.definition, vM2 = Ku.definition, uM2 = Xu.definition, mM2 = Qu.definition, gM2 = Ju.definition, PM2 = Yu.definition, MM2 = Zu.definition, wM2 = pu.definition, NM2 = xu.definition, zM2 = im.definition, LM2 = am.definition, CM2 = em.definition, DM2 = nm.definition, $M2 = l4.definition, _M2 = fm.definition, bM2 = cm.definition, SM2 = tm.definition, yM2 = om.definition, OM2 = lm.definition, kM2 = d4.definition, AM2 = dm.definition, jM2 = rm.definition, BM2 = sm.definition, TM2 = hm.definition, FM2 = N.definition, HM2 = z.definition, RM2 = vm.definition, UM2 = um.definition, qM2 = mm.definition, GM2 = r4.definition, WM2 = gm.definition, EM2 = Pm.definition, VM2 = T.definition, IM2 = Mm.definition, KM2 = wm.definition, XM2 = Nm.definition, QM2 = zm.definition, JM2 = h4.definition, YM2 = Lm.definition, ZM2 = Cm.definition, pM2 = Dm.definition, xM2 = $m.definition, iw2 = _m.definition, aw2 = bm.definition, ew2 = Sm.definition, nw2 = ym.definition, fw2 = v4.definition, cw2 = u4.definition, tw2 = Om.definition, ow2 = km.definition, lw2 = m4.definition, dw2 = Am.definition, rw2 = jm.definition, sw2 = Bm.definition, hw2 = Tm.definition, vw2 = Fm.definition, uw2 = Hm.definition, mw2 = Rm.definition, gw2 = Um.definition, Pw2 = qm.definition, Mw2 = Gm.definition, ww2 = M4.definition, Nw2 = Wm.definition, zw2 = Em.definition, Lw2 = Vm.definition, Cw2 = Im.definition, Dw2 = Km.definition, $w2 = Xm.definition, _w2 = Qm.definition, bw2 = Jm.definition, Sw2 = Ym.definition, yw2 = Zm.definition, Ow2 = pm.definition, kw2 = xm.definition, Aw2 = ig.definition, jw2 = ag.definition, Bw2 = eg.definition, Tw2 = ng.definition, Fw2 = w4.definition, Hw2 = fg.definition, Rw2 = cg.definition, Uw2 = tg.definition, qw2 = og.definition, Gw2 = lg.definition, Ww2 = dg.definition, Ew2 = rg.definition, Vw2 = sg.definition, Iw2 = hg.definition, Kw2 = vg.definition, Xw2 = ug.definition, Qw2 = mg.definition, Jw2 = N4.definition, Yw2 = gg.definition, Zw2 = Pg.definition, pw2 = Mg.definition, xw2 = wg.definition, iN2 = Ng.definition, aN2 = z4.definition, eN2 = L4.definition, nN2 = zg.definition, fN2 = Lg.definition, cN2 = Cg.definition, tN2 = Dg.definition, oN2 = V.definition, lN2 = $g.definition, dN2 = W.definition, rN2 = _g.definition, sN2 = bg.definition, hN2 = Z.definition, vN2 = Sg.definition, uN2 = yg.definition, mN2 = Og.definition, gN2 = kg.definition, PN2 = Ag.definition, MN2 = jg.definition, wN2 = Bg.definition, NN2 = Tg.definition, zN2 = Fg.definition, LN2 = Hg.definition, CN2 = Rg.definition, DN2 = Ug.definition, $N2 = qg.definition, _N2 = Gg.definition, bN2 = Wg.definition, SN2 = Eg.definition, yN2 = Vg.definition, ON2 = Ig.definition, kN2 = Kg.definition, AN2 = j2.definition, jN2 = B2.definition, BN2 = Xg.definition, TN2 = Qg.definition, FN2 = Jg.definition, HN2 = Yg.definition, RN2 = Zg.definition, UN2 = pg.definition, qN2 = xg.definition, GN2 = iP.definition, WN2 = aP.definition, EN2 = eP.definition, VN2 = nP.definition, IN2 = C4.definition, KN2 = fP.definition, XN2 = D4.definition, QN2 = $4.definition, JN2 = _4.definition, YN2 = b4.definition, ZN2 = S4.definition, pN2 = y4.definition, xN2 = O4.definition, iz2 = k4.definition, az2 = cP.definition, ez2 = A4.definition, nz2 = L.definition, fz2 = tP.definition, cz2 = oP.definition, tz2 = lP.definition, oz2 = j4.definition, lz2 = B4.definition, dz2 = dP.definition, rz2 = T4.definition, sz2 = rP.definition, hz2 = I1.definition, vz2 = sP.definition, uz2 = C.definition, mz2 = hP.definition, gz2 = vP.definition, Pz2 = uP.definition, Mz2 = mP.definition, wz2 = gP.definition, Nz2 = PP.definition, zz2 = MP.definition, Lz2 = wP.definition, Cz2 = NP.definition, Dz2 = zP.definition, $z2 = LP.definition, _z2 = CP.definition, bz2 = DP.definition, Sz2 = $P.definition, yz2 = _P.definition, Oz2 = bP.definition, kz2 = SP.definition, Az2 = yP.definition, jz2 = OP.definition, Bz2 = kP.definition, Tz2 = AP.definition, Fz2 = jP.definition, Hz2 = BP.definition, Rz2 = TP.definition, Uz2 = FP.definition, qz2 = HP.definition, Gz2 = RP.definition, Wz2 = UP.definition, Ez2 = qP.definition, Vz2 = GP.definition, Iz2 = WP.definition, Kz2 = EP.definition, Xz2 = VP.definition, Qz2 = IP.definition, Jz2 = N1.definition, Yz2 = z1.definition, Zz2 = KP.definition, pz2 = XP.definition, xz2 = L1.definition, iL2 = C1.definition, aL2 = QP.definition, eL2 = D1.definition, nL2 = u.definition, fL2 = JP.definition, cL2 = $1.definition, tL2 = YP.definition, oL2 = _1.definition, lL2 = b1.definition, dL2 = S1.definition, rL2 = H1.definition, sL2 = R1.definition, hL2 = y1.definition, vL2 = O1.definition, uL2 = m.definition, mL2 = k1.definition, gL2 = ZP.definition, PL2 = A1.definition, ML2 = j1.definition, wL2 = B1.definition, NL2 = pP.definition, zL2 = T1.definition, LL2 = xP.definition, CL2 = g.definition, DL2 = q1.definition, $L2 = G1.definition, _L2 = iM.definition, bL2 = aM.definition, SL2 = eM.definition, yL2 = nM.definition, OL2 = fM.definition, kL2 = cM.definition, AL2 = tM.definition, jL2 = oM.definition, BL2 = lM.definition, TL2 = dM.definition, FL2 = rM.definition, HL2 = sM.definition, RL2 = hM.definition, UL2 = vM.definition, qL2 = uM.definition, GL2 = mM.definition, WL2 = gM.definition, EL2 = H4.definition, VL2 = PM.definition, IL2 = MM.definition, KL2 = wM.definition, XL2 = NM.definition, QL2 = zM.definition, JL2 = R4.definition, YL2 = U4.definition, ZL2 = LM.definition, pL2 = CM.definition, xL2 = q4.definition, iC2 = DM.definition, aC2 = $M.definition, eC2 = _M.definition, nC2 = G4.definition, fC2 = bM.definition, cC2 = SM.definition, tC2 = oa.definition, oC2 = yM.definition, lC2 = OM.definition, dC2 = kM.definition, rC2 = AM.definition, sC2 = jM.definition, hC2 = BM.definition, vC2 = TM.definition, uC2 = FM.definition, mC2 = HM.definition, gC2 = RM.definition, PC2 = UM.definition, MC2 = qM.definition, wC2 = GM.definition, NC2 = WM.definition, zC2 = W4.definition, LC2 = E4.definition, CC2 = EM.definition, DC2 = VM.definition, $C2 = IM.definition, _C2 = KM.definition, bC2 = XM.definition, SC2 = QM.definition, yC2 = JM.definition, OC2 = YM.definition, kC2 = ZM.definition, AC2 = pM.definition, jC2 = xM.definition, BC2 = iw.definition, TC2 = aw.definition, FC2 = ew.definition, HC2 = nw.definition, RC2 = fw.definition, UC2 = cw.definition, qC2 = tw.definition, GC2 = ow.definition, WC2 = lw.definition, EC2 = dw.definition, VC2 = rw.definition, IC2 = sw.definition, KC2 = hw.definition, XC2 = vw.definition, QC2 = uw.definition, JC2 = mw.definition, YC2 = gw.definition, ZC2 = Pw.definition, pC2 = Mw.definition, xC2 = ww.definition, iD2 = Nw.definition, aD2 = F4.definition, eD2 = I4.definition, nD2 = $.definition, fD2 = zw.definition, cD2 = Lw.definition, tD2 = Cw.definition, oD2 = K4.definition, lD2 = Dw.definition, dD2 = $w.definition, rD2 = _w.definition, sD2 = bw.definition, hD2 = Sw.definition, vD2 = yw.definition, uD2 = Ow.definition, mD2 = kw.definition, gD2 = Aw.definition, PD2 = jw.definition, MD2 = Bw.definition, wD2 = Ma.definition, ND2 = wa.definition, zD2 = Tw.definition, LD2 = X4.definition, CD2 = Fw.definition, DD2 = Hw.definition, $D2 = Rw.definition, _D2 = Uw.definition, bD2 = _.definition, SD2 = qw.definition, yD2 = Gw.definition, OD2 = Ww.definition, kD2 = Ew.definition, AD2 = Vw.definition, jD2 = Iw.definition, BD2 = b.definition, TD2 = Kw.definition, FD2 = Q4.definition, HD2 = Xw.definition, RD2 = Qw.definition, UD2 = Jw.definition, qD2 = Yw.definition, GD2 = Zw.definition, WD2 = pw.definition, ED2 = xw.definition, VD2 = iN.definition, ID2 = aN.definition, KD2 = eN.definition, XD2 = nN.definition, QD2 = Y4.definition, JD2 = fN.definition, YD2 = cN.definition, ZD2 = tN.definition, pD2 = oN.definition, xD2 = lN.definition, i$2 = dN.definition, a$2 = rN.definition, e$2 = sN.definition, n$2 = hN.definition, f$2 = Z4.definition, c$2 = vN.definition, t$2 = uN.definition, o$2 = mN.definition, l$2 = gN.definition, d$2 = p4.definition, r$2 = PN.definition, s$2 = MN.definition, h$2 = wN.definition, v$2 = NN.definition, u$2 = zN.definition, m$2 = LN.definition, g$2 = CN.definition, P$2 = DN.definition, M$2 = $N.definition, w$2 = _N.definition, N$2 = bN.definition, z$2 = SN.definition, L$2 = yN.definition, C$2 = ON.definition, D$2 = Ri.definition, $$2 = kN.definition, _$2 = x4.definition, b$2 = AN.definition, S$2 = jN.definition, y$2 = BN.definition, O$2 = TN.definition, k$2 = FN.definition, A$2 = i3.definition, j$2 = HN.definition, B$2 = RN.definition, T$2 = UN.definition, F$2 = qN.definition, H$2 = GN.definition, R$2 = WN.definition, U$2 = a3.definition, q$2 = e3.definition, G$2 = n3.definition, W$2 = f3.definition, E$2 = EN.definition, V$2 = c3.definition, I$2 = VN.definition, K$2 = S.definition, X$2 = IN.definition, Q$2 = KN.definition, J$2 = y.definition, Y$2 = XN.definition, Z$2 = QN.definition, p$2 = JN.definition, x$2 = YN.definition, i_2 = ZN.definition, a_2 = pN.definition, e_2 = xN.definition, n_2 = iz.definition, f_2 = az.definition, c_2 = ez.definition, t_2 = nz.definition, o_2 = fz.definition, l_2 = cz.definition, d_2 = tz.definition, r_2 = oz.definition, s_2 = lz.definition, h_2 = dz.definition, v_2 = rz.definition, u_2 = sz.definition, m_2 = hz.definition, g_2 = vz.definition, P_2 = uz.definition, M_2 = mz.definition, w_2 = gz.definition, N_2 = Pz.definition, z_2 = Mz.definition, L_2 = wz.definition, C_2 = Nz.definition, D_2 = zz.definition, $_2 = Lz.definition, __2 = Cz.definition, b_2 = Dz.definition, S_2 = $z.definition, y_2 = o3.definition, O_2 = _z.definition, k_2 = bz.definition, A_2 = Sz.definition, j_2 = yz.definition, B_2 = Oz.definition, T_2 = kz.definition, F_2 = Az.definition, H_2 = jz.definition, R_2 = Bz.definition, U_2 = Tz.definition, q_2 = Fz.definition, G_2 = Hz.definition, W_2 = Rz.definition, E_2 = Uz.definition, V_2 = qz.definition, I_2 = Gz.definition, K_2 = Wz.definition, X_2 = Ez.definition, Q_2 = Vz.definition, J_2 = Iz.definition, Y_2 = Kz.definition, Z_2 = Xz.definition, p_2 = Qz.definition, x_2 = Jz.definition, ib2 = l3.definition, ab2 = Yz.definition, eb2 = d3.definition, nb2 = Zz.definition, fb2 = pz.definition, cb2 = xz.definition, tb2 = iL.definition, ob2 = aL.definition, lb2 = eL.definition, db2 = nL.definition, rb2 = fL.definition, sb2 = s3.definition, hb2 = cL.definition, vb2 = tL.definition, ub2 = oL.definition, mb2 = lL.definition, gb2 = v3.definition, Pb2 = dL.definition, Mb2 = rL.definition, wb2 = sL.definition, Nb2 = hL.definition, zb2 = u3.definition, Lb2 = vL.definition, Cb2 = uL.definition, Db2 = mL.definition, $b2 = gL.definition, _b2 = m3.definition, bb2 = ki.definition, Sb2 = PL.definition, yb2 = ML.definition, Ob2 = wL.definition, kb2 = NL.definition, Ab2 = zL.definition, jb2 = LL.definition, Bb2 = CL.definition, Tb2 = r3.definition, Fb2 = DL.definition, Hb2 = $L.definition, Rb2 = g3.definition, Ub2 = _L.definition, qb2 = bL.definition, Gb2 = SL.definition, Wb2 = yL.definition, Eb2 = OL.definition, Vb2 = kL.definition, Ib2 = AL.definition, Kb2 = jL.definition, Xb2 = BL.definition, Qb2 = TL.definition, Jb2 = FL.definition, Yb2 = M3.definition, Zb2 = HL.definition, pb2 = RL.definition, xb2 = UL.definition, iS2 = qL.definition, aS2 = I.definition, eS2 = G.definition, nS2 = GL.definition, fS2 = WL.definition, cS2 = p.definition, tS2 = EL.definition, oS2 = VL.definition, lS2 = IL.definition, dS2 = KL.definition, rS2 = XL.definition, sS2 = QL.definition, hS2 = JL.definition, vS2 = YL.definition, uS2 = ZL.definition, mS2 = pL.definition, gS2 = xL.definition, PS2 = iC.definition, MS2 = aC.definition, wS2 = eC.definition, NS2 = nC.definition, zS2 = Ji.definition, LS2 = fC.definition, CS2 = cC.definition, DS2 = tC.definition, $S2 = oC.definition, _S2 = lC.definition, bS2 = dC.definition, SS2 = rC.definition, yS2 = sC.definition, OS2 = N3.definition, kS2 = hC.definition, AS2 = z3.definition, jS2 = vC.definition, BS2 = uC.definition, TS2 = L3.definition, FS2 = mC.definition, HS2 = gC.definition, RS2 = PC.definition, US2 = MC.definition, qS2 = wC.definition, GS2 = C3.definition, WS2 = NC.definition, ES2 = zC.definition, VS2 = LC.definition, IS2 = CC.definition, KS2 = DC.definition, XS2 = $C.definition, QS2 = _C.definition, JS2 = bC.definition, YS2 = SC.definition, ZS2 = yC.definition, pS2 = OC.definition, xS2 = kC.definition, iy2 = AC.definition, ay2 = jC.definition, ey2 = BC.definition, ny2 = TC.definition, fy2 = FC.definition, cy2 = HC.definition, ty2 = $3.definition, oy2 = RC.definition, ly2 = UC.definition, dy2 = qC.definition, ry2 = D3.definition, sy2 = GC.definition, hy2 = WC.definition, vy2 = P4.definition, uy2 = EC.definition, my2 = VC.definition, gy2 = IC.definition, Py2 = KC.definition, My2 = XC.definition, wy2 = QC.definition, Ny2 = JC.definition, zy2 = YC.definition, Ly2 = ZC.definition, Cy2 = pC.definition, Dy2 = _3.definition, $y2 = xC.definition, _y2 = iD.definition, by2 = aD.definition, Sy2 = eD.definition, yy2 = nD.definition, Oy2 = fD.definition, ky2 = cD.definition, Ay2 = tD.definition, jy2 = oD.definition, By2 = lD.definition, Ty2 = S3.definition, Fy2 = dD.definition, Hy2 = rD.definition, Ry2 = sD.definition, Uy2 = hD.definition, qy2 = vD.definition, Gy2 = uD.definition, Wy2 = mD.definition, Ey2 = gD.definition, Vy2 = PD.definition, Iy2 = MD.definition, Ky2 = wD.definition, Xy2 = ND.definition, Qy2 = zD.definition, Jy2 = LD.definition, Yy2 = CD.definition, Zy2 = DD.definition, py2 = $D.definition, xy2 = _D.definition, iO2 = bD.definition, aO2 = SD.definition, eO2 = r.definition, nO2 = B3.definition, fO2 = T3.definition, cO2 = F3.definition, tO2 = yD.definition, oO2 = j3.definition, lO2 = O3.definition, dO2 = k3.definition, rO2 = OD.definition, sO2 = kD.definition, hO2 = AD.definition, vO2 = A3.definition, uO2 = y3.definition, mO2 = jD.definition, gO2 = BD.definition, PO2 = TD.definition, MO2 = FD.definition, wO2 = HD.definition, NO2 = RD.definition, zO2 = UD.definition, LO2 = qD.definition, CO2 = GD.definition, DO2 = WD.definition, $O2 = ED.definition, _O2 = VD.definition, bO2 = ID.definition, SO2 = KD.definition, yO2 = XD.definition, OO2 = QD.definition, kO2 = JD.definition, AO2 = YD.definition, jO2 = R3.definition, BO2 = ZD.definition, TO2 = pD.definition, FO2 = xD.definition, HO2 = i$.definition, RO2 = a$.definition, UO2 = e$.definition, qO2 = q3.definition, GO2 = n$.definition, WO2 = f$.definition, EO2 = c$.definition, VO2 = qa.definition, IO2 = t$.definition, KO2 = X1.definition, XO2 = o$.definition, QO2 = l$.definition, JO2 = d$.definition, YO2 = r$.definition, ZO2 = s$.definition, pO2 = h$.definition, xO2 = v$.definition, ik2 = u$.definition, ak2 = m$.definition, ek2 = g$.definition, nk2 = P$.definition, fk2 = M$.definition, ck2 = w$.definition, tk2 = N$.definition, ok2 = z$.definition, lk2 = L$.definition, dk2 = C$.definition, rk2 = G3.definition, sk2 = D$.definition, hk2 = $$.definition, vk2 = _$.definition, uk2 = b$.definition, mk2 = S$.definition, gk2 = y$.definition, Pk2 = O$.definition, Mk2 = k$.definition, wk2 = A$.definition, Nk2 = j$.definition, zk2 = B$.definition, Lk2 = T$.definition, Ck2 = F$.definition, Dk2 = H$.definition, $k2 = R$.definition, _k2 = U$.definition, bk2 = q$.definition, Sk2 = G$.definition, yk2 = W$.definition, Ok2 = E$.definition, kk2 = V$.definition, Ak2 = I$.definition, jk2 = K$.definition, Bk2 = X$.definition, Tk2 = Q$.definition, Fk2 = J$.definition, Hk2 = vi.definition, Rk2 = Y$.definition, Uk2 = Z$.definition, qk2 = ui.definition, Gk2 = mi.definition, Wk2 = gi.definition, Ek2 = p$.definition, Vk2 = x$.definition, Ik2 = i_.definition, Kk2 = a_.definition, Xk2 = J2.definition, Qk2 = Y2.definition, Jk2 = Z2.definition, Yk2 = p2.definition, Zk2 = e_.definition, pk2 = n_.definition, xk2 = f_.definition, iA2 = c_.definition, aA2 = t_.definition, eA2 = P.definition, nA2 = K.definition, fA2 = o_.definition, cA2 = l_.definition, tA2 = d_.definition, oA2 = r_.definition, lA2 = s_.definition, dA2 = ha.definition, rA2 = h_.definition, sA2 = s.definition, hA2 = v_.definition, vA2 = f4.definition, uA2 = u_.definition, mA2 = g4.definition, gA2 = m_.definition, PA2 = g_.definition, MA2 = P_.definition, wA2 = M_.definition, NA2 = X.definition, zA2 = w_.definition, LA2 = N_.definition, CA2 = z_.definition, DA2 = L_.definition, $A2 = C_.definition, _A2 = J4.definition, bA2 = t3.definition, SA2 = D_.definition, yA2 = $_.definition, OA2 = h3.definition, kA2 = __.definition, AA2 = b_.definition, jA2 = Q.definition, BA2 = S_.definition, TA2 = y_.definition, FA2 = O_.definition, HA2 = H3.definition, RA2 = U3.definition, UA2 = k_.definition, qA2 = A_.definition, GA2 = j_.definition, WA2 = B_.definition, EA2 = i2.definition, VA2 = T_.definition, IA2 = J.definition, KA2 = F_.definition, XA2 = H_.definition, QA2 = R_.definition, JA2 = U_.definition, YA2 = q_.definition, ZA2 = G_.definition, pA2 = W_.definition, xA2 = E_.definition, ij2 = V_.definition, aj2 = I_.definition, ej2 = K_.definition, nj2 = P3.definition, fj2 = X_.definition, cj2 = Q_.definition, tj2 = J_.definition, oj2 = Y_.definition, lj2 = Z_.definition, dj2 = p_.definition, rj2 = W3.definition, sj2 = x_.definition, hj2 = ib.definition, vj2 = ab.definition, uj2 = eb.definition, mj2 = E3.definition, gj2 = V3.definition, Pj2 = nb.definition, Mj2 = fb.definition, wj2 = cb.definition, Nj2 = tb.definition, zj2 = ob.definition, Lj2 = lb.definition, Cj2 = db.definition, Dj2 = rb.definition, $j2 = sb.definition, _j2 = hb.definition, bj2 = vb.definition, Sj2 = ub.definition, yj2 = mb.definition, Oj2 = gb.definition, kj2 = K3.definition, Aj2 = Pb.definition, jj2 = Mb.definition, Bj2 = wb.definition, Tj2 = Nb.definition, Fj2 = zb.definition, Hj2 = Lb.definition, Rj2 = V4.definition, Uj2 = D.definition, qj2 = Cb.definition, Gj2 = Db.definition, Wj2 = $b.definition, Ej2 = _b.definition, Vj2 = bb.definition, Ij2 = Sb.definition, Kj2 = yb.definition, Xj2 = s4.definition, Qj2 = Ob.definition, Jj2 = kb.definition, Yj2 = Ab.definition, Zj2 = jb.definition, pj2 = Bb.definition, xj2 = Tb.definition, iB2 = Fb.definition, aB2 = w3.definition, eB2 = Hb.definition, nB2 = Rb.definition, fB2 = Ub.definition, cB2 = X3.definition, tB2 = qb.definition, oB2 = Gb.definition, lB2 = Wb.definition, dB2 = Eb.definition, rB2 = Vb.definition, sB2 = Ib.definition, hB2 = Kb.definition, vB2 = Q3.definition, uB2 = Xb.definition, mB2 = Qb.definition, gB2 = Jb.definition, PB2 = Yb.definition, MB2 = Zb.definition, wB2 = pb.definition, NB2 = xb.definition, zB2 = iS.definition, LB2 = aS.definition, CB2 = eS.definition, DB2 = nS.definition, $B2 = fS.definition, _B2 = cS.definition, bB2 = tS.definition, SB2 = Y3.definition, yB2 = Z3.definition, OB2 = oS.definition, kB2 = lS.definition, AB2 = dS.definition, jB2 = rS.definition, BB2 = sS.definition, TB2 = hS.definition, FB2 = vS.definition, HB2 = uS.definition, RB2 = mS.definition, UB2 = O.definition, qB2 = gS.definition, GB2 = PS.definition, WB2 = MS.definition, EB2 = wS.definition, VB2 = k.definition, IB2 = NS.definition, KB2 = zS.definition, XB2 = LS.definition, QB2 = CS.definition, JB2 = DS.definition, YB2 = $S.definition, ZB2 = _S.definition, pB2 = bS.definition, xB2 = SS.definition, iT2 = yS.definition, aT2 = OS.definition, eT2 = kS.definition, nT2 = AS.definition, fT2 = jS.definition, cT2 = BS.definition, tT2 = TS.definition, oT2 = FS.definition, lT2 = p3.definition, dT2 = x3.definition, rT2 = HS.definition, sT2 = RS.definition, hT2 = US.definition, vT2 = qS.definition, uT2 = i0.definition, mT2 = a0.definition, gT2 = GS.definition, PT2 = WS.definition, MT2 = ES.definition, wT2 = VS.definition, NT2 = e0.definition, zT2 = IS.definition, LT2 = KS.definition, CT2 = XS.definition, DT2 = QS.definition, $T2 = JS.definition, _T2 = YS.definition, bT2 = I3.definition, ST2 = ZS.definition, yT2 = pS.definition, OT2 = xS.definition, kT2 = iy.definition, AT2 = ay.definition, jT2 = ey.definition, BT2 = ny.definition, TT2 = fy.definition, FT2 = cy.definition, HT2 = ty.definition, RT2 = oy.definition, UT2 = ly.definition, qT2 = dy.definition, GT2 = ry.definition, WT2 = sy.definition, ET2 = hy.definition, VT2 = vy.definition, IT2 = uy.definition, KT2 = my.definition, XT2 = n0.definition, QT2 = j.definition, JT2 = gy.definition, YT2 = Py.definition, ZT2 = My.definition, pT2 = wy.definition, xT2 = Ny.definition, iF2 = zy.definition, aF2 = Ly.definition, eF2 = f0.definition, nF2 = Cy.definition, fF2 = Dy.definition, cF2 = $y.definition, tF2 = _y.definition, oF2 = by.definition, lF2 = c0.definition, dF2 = Sy.definition, rF2 = yy.definition, sF2 = Oy.definition, hF2 = ky.definition, vF2 = Ay.definition, uF2 = jy.definition, mF2 = t0.definition, gF2 = By.definition, PF2 = E1.definition, MF2 = Ty.definition, wF2 = Fy.definition, NF2 = Hy.definition, zF2 = Ry.definition, LF2 = o0.definition, CF2 = Uy.definition, DF2 = b3.definition, $F2 = qy.definition, _F2 = Gy.definition, bF2 = Wy.definition, SF2 = Ey.definition, yF2 = Vy.definition, OF2 = Iy.definition, kF2 = Ky.definition, AF2 = Xy.definition, jF2 = l0.definition, BF2 = Qy.definition, TF2 = Jy.definition, FF2 = Yy.definition, HF2 = J3.definition, RF2 = Zy.definition, UF2 = py.definition, qF2 = xy.definition, GF2 = iO.definition, WF2 = aO.definition, EF2 = eO.definition, VF2 = nO.definition, IF2 = fO.definition, KF2 = cO.definition, XF2 = tO.definition, QF2 = oO.definition, JF2 = lO.definition, YF2 = dO.definition, ZF2 = rO.definition, pF2 = sO.definition, xF2 = hO.definition, iH2 = d0.definition, aH2 = vO.definition, eH2 = uO.definition, nH2 = mO.definition, fH2 = ii.definition, cH2 = gO.definition, tH2 = PO.definition, oH2 = q.definition, lH2 = MO.definition, dH2 = wO.definition, rH2 = NO.definition, sH2 = zO.definition, hH2 = x.definition, vH2 = LO.definition, uH2 = CO.definition, mH2 = DO.definition, gH2 = $O.definition, PH2 = _O.definition, MH2 = bO.definition, wH2 = SO.definition, NH2 = yO.definition, zH2 = OO.definition, LH2 = kO.definition, CH2 = AO.definition, DH2 = jO.definition, $H2 = BO.definition, _H2 = r0.definition, bH2 = s0.definition, SH2 = TO.definition, yH2 = FO.definition, OH2 = HO.definition, kH2 = RO.definition, AH2 = l.definition, jH2 = UO.definition, BH2 = qO.definition, TH2 = B.definition, FH2 = GO.definition, HH2 = WO.definition, RH2 = EO.definition, UH2 = VO.definition, qH2 = IO.definition, GH2 = KO.definition, WH2 = XO.definition, EH2 = QO.definition, VH2 = JO.definition, IH2 = YO.definition, KH2 = ZO.definition, XH2 = pO.definition, QH2 = xO.definition, JH2 = ik.definition, YH2 = ak.definition, ZH2 = ek.definition, pH2 = nk.definition, xH2 = fk.definition, iR2 = ck.definition, aR2 = tk.definition, eR2 = ok.definition, nR2 = lk.definition, fR2 = dk.definition, cR2 = rk.definition, tR2 = sk.definition, oR2 = hk.definition, lR2 = vk.definition, dR2 = uk.definition, rR2 = mk.definition, sR2 = gk.definition, hR2 = Pk.definition, vR2 = Mk.definition, uR2 = wk.definition, mR2 = Nk.definition, gR2 = zk.definition, PR2 = Lk.definition, MR2 = Ck.definition, wR2 = Dk.definition, NR2 = $k.definition, zR2 = _k.definition, LR2 = bk.definition, CR2 = Sk.definition, DR2 = h0.definition, $R2 = yk.definition, _R2 = Ok.definition, bR2 = kk.definition, SR2 = Ak.definition, yR2 = jk.definition, OR2 = Bk.definition, kR2 = Tk.definition, AR2 = Fk.definition, jR2 = Hk.definition, BR2 = v0.definition, TR2 = Rk.definition, FR2 = u0.definition, HR2 = Uk.definition, RR2 = qk.definition, UR2 = Gk.definition, qR2 = Wk.definition, GR2 = Ek.definition, WR2 = m0.definition, ER2 = g0.definition, VR2 = Vk.definition, IR2 = Ik.definition, KR2 = Kk.definition, XR2 = Xk.definition, QR2 = n4.definition, JR2 = Qk.definition, YR2 = Jk.definition, ZR2 = Yk.definition, pR2 = Zk.definition, xR2 = P0.definition, iU2 = pk.definition, aU2 = xk.definition, eU2 = iA.definition, nU2 = aA.definition, fU2 = eA.definition, cU2 = nA.definition, tU2 = fA.definition, oU2 = cA.definition, lU2 = tA.definition, dU2 = Ja.definition, rU2 = oA.definition, sU2 = lA.definition, hU2 = dA.definition, vU2 = rA.definition, uU2 = w0.definition, mU2 = sA.definition, gU2 = M0.definition, PU2 = hA.definition, MU2 = vA.definition, wU2 = N0.definition, NU2 = uA.definition, zU2 = mA.definition, LU2 = z0.definition, CU2 = gA.definition, DU2 = PA.definition, $U2 = MA.definition, _U2 = Ua.definition, bU2 = wA.definition, SU2 = NA.definition, yU2 = zA.definition, OU2 = LA.definition, kU2 = CA.definition, AU2 = DA.definition, jU2 = A.definition, BU2 = $A.definition;
export {
  w02 as Icon,
  HU2 as fa0,
  N02 as fa00,
  UU2 as fa1,
  z02 as fa100,
  GU2 as fa2,
  EU2 as fa3,
  L02 as fa360Degrees,
  IU2 as fa4,
  nQ1 as fa42Group,
  XU2 as fa5,
  cQ1 as fa500px,
  JU2 as fa6,
  ZU2 as fa7,
  xU2 as fa8,
  aq2 as fa9,
  nq2 as faA,
  C02 as faAbacus,
  D02 as faAccentGrave,
  oQ1 as faAccessibleIcon,
  dQ1 as faAccusoft,
  $02 as faAcorn,
  zui as faActors,
  cq2 as faAd,
  oq2 as faAdd,
  dq2 as faAddressBook,
  sq2 as faAddressCard,
  vq2 as faAdjust,
  sQ1 as faAdn,
  vQ1 as faAdversal,
  mQ1 as faAffiliatetheme,
  _02 as faAirConditioner,
  mq2 as faAirFreshener,
  PQ1 as faAirbnb,
  b02 as faAirplay,
  S02 as faAlarmClock,
  y02 as faAlarmExclamation,
  O02 as faAlarmPlus,
  k02 as faAlarmSnooze,
  A02 as faAlbum,
  j02 as faAlbumCirclePlus,
  B02 as faAlbumCircleUser,
  T02 as faAlbumCollection,
  F02 as faAlbumCollectionCirclePlus,
  H02 as faAlbumCollectionCircleUser,
  wQ1 as faAlgolia,
  R02 as faAlicorn,
  U02 as faAlien,
  q02 as faAlien8bit,
  G02 as faAlienMonster,
  Pq2 as faAlignCenter,
  wq2 as faAlignJustify,
  zq2 as faAlignLeft,
  Cq2 as faAlignRight,
  W02 as faAlignSlash,
  zQ1 as faAlipay,
  $q2 as faAllergies,
  E02 as faAlt,
  CQ1 as faAmazon,
  $Q1 as faAmazonPay,
  bq2 as faAmbulance,
  yq2 as faAmericanSignLanguageInterpreting,
  bQ1 as faAmilia,
  V02 as faAmpGuitar,
  I02 as faAmpersand,
  K02 as faAnalytics,
  kq2 as faAnchor,
  jq2 as faAnchorCircleCheck,
  Tq2 as faAnchorCircleExclamation,
  Hq2 as faAnchorCircleXmark,
  Uq2 as faAnchorLock,
  yQ1 as faAndroid,
  X02 as faAngel,
  kQ1 as faAngellist,
  Q02 as faAngle,
  J02 as faAngle90,
  Gq2 as faAngleDoubleDown,
  Eq2 as faAngleDoubleLeft,
  Iq2 as faAngleDoubleRight,
  Xq2 as faAngleDoubleUp,
  Jq2 as faAngleDown,
  Zq2 as faAngleLeft,
  xq2 as faAngleRight,
  aG2 as faAngleUp,
  nG2 as faAnglesDown,
  cG2 as faAnglesLeft,
  oG2 as faAnglesRight,
  dG2 as faAnglesUp,
  Y02 as faAnglesUpDown,
  sG2 as faAngry,
  jQ1 as faAngrycreative,
  TQ1 as faAngular,
  vG2 as faAnkh,
  Z02 as faAnt,
  p02 as faApartment,
  x02 as faAperture,
  ie2 as faApostrophe,
  HQ1 as faAppStore,
  UQ1 as faAppStoreIos,
  GQ1 as faApper,
  EQ1 as faApple,
  mG2 as faAppleAlt,
  ae2 as faAppleCore,
  ee2 as faAppleCrate,
  IQ1 as faApplePay,
  PG2 as faAppleWhole,
  wG2 as faArchive,
  zG2 as faArchway,
  CG2 as faAreaChart,
  $G2 as faArrowAltCircleDown,
  bG2 as faArrowAltCircleLeft,
  yG2 as faArrowAltCircleRight,
  kG2 as faArrowAltCircleUp,
  ne2 as faArrowAltDown,
  fe2 as faArrowAltFromBottom,
  ce2 as faArrowAltFromLeft,
  te2 as faArrowAltFromRight,
  oe2 as faArrowAltFromTop,
  le2 as faArrowAltLeft,
  de2 as faArrowAltRight,
  re2 as faArrowAltSquareDown,
  se2 as faArrowAltSquareLeft,
  he2 as faArrowAltSquareRight,
  ve2 as faArrowAltSquareUp,
  ue2 as faArrowAltToBottom,
  me2 as faArrowAltToLeft,
  ge2 as faArrowAltToRight,
  Pe2 as faArrowAltToTop,
  Me2 as faArrowAltUp,
  jG2 as faArrowCircleDown,
  TG2 as faArrowCircleLeft,
  HG2 as faArrowCircleRight,
  UG2 as faArrowCircleUp,
  GG2 as faArrowDown,
  EG2 as faArrowDown19,
  IG2 as faArrowDown91,
  XG2 as faArrowDownAZ,
  we2 as faArrowDownArrowUp,
  Ne2 as faArrowDownBigSmall,
  ze2 as faArrowDownFromArc,
  Le2 as faArrowDownFromBracket,
  Ce2 as faArrowDownFromDottedLine,
  De2 as faArrowDownFromLine,
  $e2 as faArrowDownLeft,
  _e2 as faArrowDownLeftAndArrowUpRightToCenter,
  JG2 as faArrowDownLong,
  be2 as faArrowDownRight,
  ZG2 as faArrowDownShortWide,
  Se2 as faArrowDownSmallBig,
  ye2 as faArrowDownSquareTriangle,
  Oe2 as faArrowDownToArc,
  ke2 as faArrowDownToBracket,
  Ae2 as faArrowDownToDottedLine,
  je2 as faArrowDownToLine,
  Be2 as faArrowDownToSquare,
  Te2 as faArrowDownTriangleSquare,
  xG2 as faArrowDownUpAcrossLine,
  aW2 as faArrowDownUpLock,
  nW2 as faArrowDownWideShort,
  cW2 as faArrowDownZA,
  Fe2 as faArrowFromBottom,
  He2 as faArrowFromLeft,
  Re2 as faArrowFromRight,
  Ue2 as faArrowFromTop,
  oW2 as faArrowLeft,
  qe2 as faArrowLeftFromArc,
  Ge2 as faArrowLeftFromBracket,
  We2 as faArrowLeftFromLine,
  dW2 as faArrowLeftLong,
  Ee2 as faArrowLeftLongToLine,
  sW2 as faArrowLeftRotate,
  Ve2 as faArrowLeftToArc,
  Ie2 as faArrowLeftToBracket,
  Ke2 as faArrowLeftToLine,
  vW2 as faArrowPointer,
  Xe2 as faArrowProgress,
  mW2 as faArrowRight,
  PW2 as faArrowRightArrowLeft,
  Qe2 as faArrowRightFromArc,
  wW2 as faArrowRightFromBracket,
  zW2 as faArrowRightFromFile,
  Je2 as faArrowRightFromLine,
  CW2 as faArrowRightLong,
  Ye2 as faArrowRightLongToLine,
  $W2 as faArrowRightRotate,
  Ze2 as faArrowRightToArc,
  bW2 as faArrowRightToBracket,
  yW2 as faArrowRightToCity,
  kW2 as faArrowRightToFile,
  pe2 as faArrowRightToLine,
  jW2 as faArrowRotateBack,
  TW2 as faArrowRotateBackward,
  HW2 as faArrowRotateForward,
  UW2 as faArrowRotateLeft,
  GW2 as faArrowRotateRight,
  xe2 as faArrowSquareDown,
  in2 as faArrowSquareLeft,
  an2 as faArrowSquareRight,
  en2 as faArrowSquareUp,
  nn2 as faArrowToBottom,
  fn2 as faArrowToLeft,
  cn2 as faArrowToRight,
  tn2 as faArrowToTop,
  EW2 as faArrowTrendDown,
  IW2 as faArrowTrendUp,
  XW2 as faArrowTurnDown,
  on2 as faArrowTurnDownLeft,
  ln2 as faArrowTurnDownRight,
  dn2 as faArrowTurnLeft,
  rn2 as faArrowTurnLeftDown,
  sn2 as faArrowTurnLeftUp,
  hn2 as faArrowTurnRight,
  JW2 as faArrowTurnUp,
  ZW2 as faArrowUp,
  xW2 as faArrowUp19,
  aE2 as faArrowUp91,
  nE2 as faArrowUpAZ,
  vn2 as faArrowUpArrowDown,
  un2 as faArrowUpBigSmall,
  mn2 as faArrowUpFromArc,
  cE2 as faArrowUpFromBracket,
  gn2 as faArrowUpFromDottedLine,
  oE2 as faArrowUpFromGroundWater,
  Pn2 as faArrowUpFromLine,
  Mn2 as faArrowUpFromSquare,
  dE2 as faArrowUpFromWaterPump,
  wn2 as faArrowUpLeft,
  Nn2 as faArrowUpLeftFromCircle,
  sE2 as faArrowUpLong,
  zn2 as faArrowUpRight,
  Ln2 as faArrowUpRightAndArrowDownLeftFromCenter,
  vE2 as faArrowUpRightDots,
  mE2 as faArrowUpRightFromSquare,
  PE2 as faArrowUpShortWide,
  Cn2 as faArrowUpSmallBig,
  Dn2 as faArrowUpSquareTriangle,
  $n2 as faArrowUpToArc,
  _n2 as faArrowUpToBracket,
  bn2 as faArrowUpToDottedLine,
  Sn2 as faArrowUpToLine,
  yn2 as faArrowUpTriangleSquare,
  wE2 as faArrowUpWideShort,
  zE2 as faArrowUpZA,
  CE2 as faArrows,
  $E2 as faArrowsAlt,
  bE2 as faArrowsAltH,
  yE2 as faArrowsAltV,
  On2 as faArrowsCross,
  kE2 as faArrowsDownToLine,
  jE2 as faArrowsDownToPeople,
  kn2 as faArrowsFromDottedLine,
  An2 as faArrowsFromLine,
  TE2 as faArrowsH,
  HE2 as faArrowsLeftRight,
  UE2 as faArrowsLeftRightToLine,
  jn2 as faArrowsMaximize,
  Bn2 as faArrowsMinimize,
  Tn2 as faArrowsRepeat,
  Fn2 as faArrowsRepeat1,
  Hn2 as faArrowsRetweet,
  GE2 as faArrowsRotate,
  Rn2 as faArrowsRotateReverse,
  EE2 as faArrowsSpin,
  IE2 as faArrowsSplitUpAndLeft,
  XE2 as faArrowsToCircle,
  JE2 as faArrowsToDot,
  Un2 as faArrowsToDottedLine,
  ZE2 as faArrowsToEye,
  qn2 as faArrowsToLine,
  xE2 as faArrowsTurnRight,
  aV2 as faArrowsTurnToDots,
  nV2 as faArrowsUpDown,
  cV2 as faArrowsUpDownLeftRight,
  oV2 as faArrowsUpToLine,
  dV2 as faArrowsV,
  XQ1 as faArtstation,
  sV2 as faAslInterpreting,
  vV2 as faAssistiveListeningSystems,
  mV2 as faAsterisk,
  JQ1 as faAsymmetrik,
  PV2 as faAt,
  wV2 as faAtlas,
  ZQ1 as faAtlassian,
  zV2 as faAtom,
  Gn2 as faAtomAlt,
  Wn2 as faAtomSimple,
  xQ1 as faAudible,
  CV2 as faAudioDescription,
  En2 as faAudioDescriptionSlash,
  $V2 as faAustralSign,
  bV2 as faAutomobile,
  aJ1 as faAutoprefixer,
  nJ1 as faAvianex,
  cJ1 as faAviato,
  Vn2 as faAvocado,
  yV2 as faAward,
  In2 as faAwardSimple,
  oJ1 as faAws,
  Kn2 as faAxe,
  Xn2 as faAxeBattle,
  kV2 as faB,
  jV2 as faBaby,
  TV2 as faBabyCarriage,
  Qn2 as faBackpack,
  HV2 as faBackspace,
  UV2 as faBackward,
  GV2 as faBackwardFast,
  EV2 as faBackwardStep,
  IV2 as faBacon,
  XV2 as faBacteria,
  JV2 as faBacterium,
  Jn2 as faBadge,
  Yn2 as faBadgeCheck,
  Zn2 as faBadgeDollar,
  pn2 as faBadgePercent,
  xn2 as faBadgeSheriff,
  i62 as faBadgerHoney,
  a62 as faBadminton,
  e62 as faBagSeedling,
  ZV2 as faBagShopping,
  n62 as faBagShoppingMinus,
  f62 as faBagShoppingPlus,
  c62 as faBagel,
  t62 as faBagsShopping,
  o62 as faBaguette,
  xV2 as faBahai,
  aI2 as faBahtSign,
  nI2 as faBalanceScale,
  cI2 as faBalanceScaleLeft,
  oI2 as faBalanceScaleRight,
  l62 as faBallPile,
  d62 as faBalloon,
  r62 as faBalloons,
  s62 as faBallot,
  h62 as faBallotCheck,
  dI2 as faBan,
  v62 as faBanBug,
  u62 as faBanParking,
  sI2 as faBanSmoking,
  m62 as faBanana,
  vI2 as faBandAid,
  mI2 as faBandage,
  dJ1 as faBandcamp,
  PI2 as faBangladeshiTakaSign,
  g62 as faBanjo,
  wI2 as faBank,
  zI2 as faBarChart,
  CI2 as faBarcode,
  P62 as faBarcodeAlt,
  M62 as faBarcodeRead,
  w62 as faBarcodeScan,
  N62 as faBarnSilo,
  $I2 as faBars,
  z62 as faBarsFilter,
  bI2 as faBarsProgress,
  L62 as faBarsSort,
  yI2 as faBarsStaggered,
  kI2 as faBaseball,
  jI2 as faBaseballBall,
  TI2 as faBaseballBatBall,
  HI2 as faBasketShopping,
  C62 as faBasketShoppingMinus,
  D62 as faBasketShoppingPlus,
  $62 as faBasketShoppingSimple,
  UI2 as faBasketball,
  GI2 as faBasketballBall,
  _62 as faBasketballHoop,
  b62 as faBat,
  EI2 as faBath,
  II2 as faBathtub,
  XI2 as faBattery,
  JI2 as faBattery0,
  S62 as faBattery1,
  ZI2 as faBattery2,
  xI2 as faBattery3,
  aK2 as faBattery4,
  nK2 as faBattery5,
  y62 as faBatteryBolt,
  cK2 as faBatteryCar,
  oK2 as faBatteryEmpty,
  O62 as faBatteryExclamation,
  dK2 as faBatteryFull,
  sK2 as faBatteryHalf,
  k62 as faBatteryLow,
  vK2 as faBatteryQuarter,
  A62 as faBatterySlash,
  mK2 as faBatteryThreeQuarters,
  sJ1 as faBattleNet,
  PK2 as faBed,
  j62 as faBedAlt,
  B62 as faBedBunk,
  T62 as faBedEmpty,
  F62 as faBedFront,
  wK2 as faBedPulse,
  H62 as faBee,
  zK2 as faBeer,
  R62 as faBeerFoam,
  U62 as faBeerMug,
  CK2 as faBeerMugEmpty,
  vJ1 as faBehance,
  mJ1 as faBehanceSquare,
  $K2 as faBell,
  bK2 as faBellConcierge,
  q62 as faBellExclamation,
  G62 as faBellOn,
  W62 as faBellPlus,
  E62 as faBellRing,
  V62 as faBellSchool,
  I62 as faBellSchoolSlash,
  yK2 as faBellSlash,
  K62 as faBells,
  X62 as faBenchTree,
  Q62 as faBetamax,
  kK2 as faBezierCurve,
  jK2 as faBible,
  TK2 as faBicycle,
  HK2 as faBiking,
  J62 as faBikingMountain,
  PJ1 as faBilibili,
  Y62 as faBillboard,
  wJ1 as faBimobject,
  Z62 as faBinBottles,
  p62 as faBinBottlesRecycle,
  x62 as faBinRecycle,
  if2 as faBinary,
  af2 as faBinaryCircleCheck,
  ef2 as faBinaryLock,
  nf2 as faBinarySlash,
  UK2 as faBinoculars,
  GK2 as faBiohazard,
  ff2 as faBird,
  EK2 as faBirthdayCake,
  zJ1 as faBitbucket,
  CJ1 as faBitcoin,
  IK2 as faBitcoinSign,
  $J1 as faBity,
  bJ1 as faBlackTie,
  yJ1 as faBlackberry,
  XK2 as faBlackboard,
  cf2 as faBlanket,
  tf2 as faBlanketFire,
  JK2 as faBlender,
  ZK2 as faBlenderPhone,
  xK2 as faBlind,
  of2 as faBlinds,
  lf2 as faBlindsOpen,
  df2 as faBlindsRaised,
  rf2 as faBlock,
  sf2 as faBlockBrick,
  hf2 as faBlockBrickFire,
  vf2 as faBlockQuestion,
  uf2 as faBlockQuote,
  aX2 as faBlog,
  kJ1 as faBlogger,
  jJ1 as faBloggerB,
  mf2 as faBlueberries,
  TJ1 as faBluesky,
  HJ1 as faBluetooth,
  UJ1 as faBluetoothB,
  nX2 as faBold,
  cX2 as faBolt,
  gf2 as faBoltAuto,
  oX2 as faBoltLightning,
  Pf2 as faBoltSlash,
  dX2 as faBomb,
  sX2 as faBone,
  Mf2 as faBoneBreak,
  vX2 as faBong,
  mX2 as faBook,
  wf2 as faBookAlt,
  Nf2 as faBookArrowRight,
  zf2 as faBookArrowUp,
  PX2 as faBookAtlas,
  wX2 as faBookBible,
  Lf2 as faBookBlank,
  zX2 as faBookBookmark,
  Cf2 as faBookCircle,
  Df2 as faBookCircleArrowRight,
  $f2 as faBookCircleArrowUp,
  _f2 as faBookCopy,
  CX2 as faBookDead,
  bf2 as faBookFont,
  Sf2 as faBookHeart,
  $X2 as faBookJournalWhills,
  yf2 as faBookLaw,
  bX2 as faBookMedical,
  yX2 as faBookOpen,
  Of2 as faBookOpenAlt,
  kf2 as faBookOpenCover,
  kX2 as faBookOpenReader,
  jX2 as faBookQuran,
  TX2 as faBookReader,
  Af2 as faBookSection,
  HX2 as faBookSkull,
  jf2 as faBookSparkles,
  Bf2 as faBookSpells,
  UX2 as faBookTanakh,
  Tf2 as faBookUser,
  GX2 as faBookmark,
  Ff2 as faBookmarkCircle,
  Hf2 as faBookmarkSlash,
  Rf2 as faBooks,
  Uf2 as faBooksMedical,
  qf2 as faBoombox,
  Gf2 as faBoot,
  Wf2 as faBootHeeled,
  Ef2 as faBoothCurtain,
  GJ1 as faBootstrap,
  EX2 as faBorderAll,
  Vf2 as faBorderBottom,
  If2 as faBorderBottomRight,
  Kf2 as faBorderCenterH,
  Xf2 as faBorderCenterV,
  Qf2 as faBorderInner,
  Jf2 as faBorderLeft,
  IX2 as faBorderNone,
  Yf2 as faBorderOuter,
  Zf2 as faBorderRight,
  XX2 as faBorderStyle,
  pf2 as faBorderStyleAlt,
  xf2 as faBorderTop,
  JX2 as faBorderTopLeft,
  ZX2 as faBoreHole,
  EJ1 as faBots,
  ic2 as faBottleBaby,
  xX2 as faBottleDroplet,
  aQ2 as faBottleWater,
  ac2 as faBowArrow,
  ec2 as faBowlChopsticks,
  nc2 as faBowlChopsticksNoodles,
  nQ2 as faBowlFood,
  fc2 as faBowlHot,
  cQ2 as faBowlRice,
  cc2 as faBowlSalad,
  tc2 as faBowlScoop,
  oc2 as faBowlScoops,
  lc2 as faBowlShavedIce,
  dc2 as faBowlSoftServe,
  rc2 as faBowlSpoon,
  oQ2 as faBowlingBall,
  sc2 as faBowlingBallPin,
  hc2 as faBowlingPins,
  dQ2 as faBox,
  vc2 as faBoxAlt,
  sQ2 as faBoxArchive,
  uc2 as faBoxBallot,
  mc2 as faBoxCheck,
  gc2 as faBoxCircleCheck,
  Pc2 as faBoxDollar,
  Mc2 as faBoxFragile,
  wc2 as faBoxFull,
  Nc2 as faBoxHeart,
  vQ2 as faBoxOpen,
  zc2 as faBoxOpenFull,
  Lc2 as faBoxTaped,
  mQ2 as faBoxTissue,
  Cc2 as faBoxUp,
  Dc2 as faBoxUsd,
  PQ2 as faBoxes,
  wQ2 as faBoxesAlt,
  zQ2 as faBoxesPacking,
  CQ2 as faBoxesStacked,
  $c2 as faBoxingGlove,
  _c2 as faBracket,
  bc2 as faBracketCurly,
  Sc2 as faBracketCurlyLeft,
  yc2 as faBracketCurlyRight,
  Oc2 as faBracketLeft,
  kc2 as faBracketRound,
  Ac2 as faBracketRoundRight,
  jc2 as faBracketSquare,
  Bc2 as faBracketSquareRight,
  Tc2 as faBrackets,
  Fc2 as faBracketsCurly,
  Hc2 as faBracketsRound,
  Rc2 as faBracketsSquare,
  $Q2 as faBraille,
  bQ2 as faBrain,
  Uc2 as faBrainArrowCurvedRight,
  qc2 as faBrainCircuit,
  Gc2 as faBrakeWarning,
  IJ1 as faBrave,
  XJ1 as faBraveReverse,
  yQ2 as faBrazilianRealSign,
  Wc2 as faBreadLoaf,
  kQ2 as faBreadSlice,
  Ec2 as faBreadSliceButter,
  jQ2 as faBridge,
  TQ2 as faBridgeCircleCheck,
  HQ2 as faBridgeCircleExclamation,
  UQ2 as faBridgeCircleXmark,
  GQ2 as faBridgeLock,
  Vc2 as faBridgeSuspension,
  EQ2 as faBridgeWater,
  IQ2 as faBriefcase,
  Ic2 as faBriefcaseArrowRight,
  Kc2 as faBriefcaseBlank,
  XQ2 as faBriefcaseClock,
  JQ2 as faBriefcaseMedical,
  Xc2 as faBrightness,
  Qc2 as faBrightnessLow,
  Jc2 as faBringForward,
  Yc2 as faBringFront,
  ZQ2 as faBroadcastTower,
  Zc2 as faBroccoli,
  xQ2 as faBroom,
  aJ2 as faBroomBall,
  pc2 as faBroomWide,
  xc2 as faBrowser,
  i82 as faBrowsers,
  nJ2 as faBrush,
  JJ1 as faBtc,
  cJ2 as faBucket,
  ZJ1 as faBuffer,
  oJ2 as faBug,
  dJ2 as faBugSlash,
  sJ2 as faBugs,
  vJ2 as faBuilding,
  mJ2 as faBuildingCircleArrowRight,
  PJ2 as faBuildingCircleCheck,
  wJ2 as faBuildingCircleExclamation,
  zJ2 as faBuildingCircleXmark,
  CJ2 as faBuildingColumns,
  $J2 as faBuildingFlag,
  bJ2 as faBuildingLock,
  a82 as faBuildingMagnifyingGlass,
  e82 as faBuildingMemo,
  yJ2 as faBuildingNgo,
  kJ2 as faBuildingShield,
  jJ2 as faBuildingUn,
  TJ2 as faBuildingUser,
  HJ2 as faBuildingWheat,
  n82 as faBuildings,
  f82 as faBulldozer,
  UJ2 as faBullhorn,
  GJ2 as faBullseye,
  c82 as faBullseyeArrow,
  t82 as faBullseyePointer,
  o82 as faBuoy,
  l82 as faBuoyMooring,
  EJ2 as faBurger,
  d82 as faBurgerCheese,
  r82 as faBurgerFries,
  s82 as faBurgerGlass,
  h82 as faBurgerLettuce,
  v82 as faBurgerSoda,
  IJ2 as faBurn,
  xJ1 as faBuromobelexperte,
  u82 as faBurrito,
  XJ2 as faBurst,
  JJ2 as faBus,
  ZJ2 as faBusAlt,
  m82 as faBusSchool,
  xJ2 as faBusSimple,
  g82 as faBusinessFront,
  aY2 as faBusinessTime,
  P82 as faButter,
  aY1 as faBuyNLarge,
  nY1 as faBuysellads,
  nY2 as faC,
  cY2 as faCab,
  M82 as faCabin,
  w82 as faCabinetFiling,
  oY2 as faCableCar,
  N82 as faCactus,
  z82 as faCaduceus,
  dY2 as faCake,
  sY2 as faCakeCandles,
  L82 as faCakeSlice,
  vY2 as faCalculator,
  C82 as faCalculatorAlt,
  D82 as faCalculatorSimple,
  mY2 as faCalendar,
  PY2 as faCalendarAlt,
  $82 as faCalendarArrowDown,
  _82 as faCalendarArrowUp,
  wY2 as faCalendarCheck,
  b82 as faCalendarCircle,
  S82 as faCalendarCircleExclamation,
  y82 as faCalendarCircleMinus,
  O82 as faCalendarCirclePlus,
  k82 as faCalendarCircleUser,
  A82 as faCalendarClock,
  zY2 as faCalendarDay,
  CY2 as faCalendarDays,
  j82 as faCalendarDownload,
  B82 as faCalendarEdit,
  T82 as faCalendarExclamation,
  F82 as faCalendarHeart,
  H82 as faCalendarImage,
  R82 as faCalendarLines,
  U82 as faCalendarLinesPen,
  $Y2 as faCalendarMinus,
  q82 as faCalendarNote,
  G82 as faCalendarPen,
  bY2 as faCalendarPlus,
  W82 as faCalendarRange,
  E82 as faCalendarStar,
  V82 as faCalendarTime,
  yY2 as faCalendarTimes,
  I82 as faCalendarUpload,
  K82 as faCalendarUsers,
  kY2 as faCalendarWeek,
  jY2 as faCalendarXmark,
  X82 as faCalendars,
  Q82 as faCamcorder,
  TY2 as faCamera,
  HY2 as faCameraAlt,
  J82 as faCameraCctv,
  Y82 as faCameraCircle,
  Z82 as faCameraHome,
  p82 as faCameraMovie,
  x82 as faCameraPolaroid,
  UY2 as faCameraRetro,
  GY2 as faCameraRotate,
  i52 as faCameraSecurity,
  a52 as faCameraSlash,
  e52 as faCameraViewfinder,
  n52 as faCameraWeb,
  f52 as faCameraWebSlash,
  c52 as faCampfire,
  EY2 as faCampground,
  t52 as faCanFood,
  cY1 as faCanadianMapleLeaf,
  IY2 as faCancel,
  o52 as faCandleHolder,
  l52 as faCandy,
  d52 as faCandyBar,
  XY2 as faCandyCane,
  r52 as faCandyCorn,
  JY2 as faCannabis,
  s52 as faCannon,
  ZY2 as faCapsules,
  xY2 as faCar,
  aZ2 as faCarAlt,
  nZ2 as faCarBattery,
  h52 as faCarBolt,
  v52 as faCarBuilding,
  u52 as faCarBump,
  cZ2 as faCarBurst,
  m52 as faCarBus,
  g52 as faCarCircleBolt,
  oZ2 as faCarCrash,
  P52 as faCarGarage,
  M52 as faCarMechanic,
  w52 as faCarMirrors,
  dZ2 as faCarOn,
  sZ2 as faCarRear,
  vZ2 as faCarSide,
  N52 as faCarSideBolt,
  z52 as faCarTilt,
  mZ2 as faCarTunnel,
  L52 as faCarWash,
  C52 as faCarWrench,
  PZ2 as faCaravan,
  D52 as faCaravanAlt,
  $52 as faCaravanSimple,
  _52 as faCardClub,
  b52 as faCardDiamond,
  S52 as faCardHeart,
  y52 as faCardSpade,
  O52 as faCards,
  k52 as faCardsBlank,
  A52 as faCaretCircleDown,
  j52 as faCaretCircleLeft,
  B52 as faCaretCircleRight,
  T52 as faCaretCircleUp,
  wZ2 as faCaretDown,
  zZ2 as faCaretLeft,
  CZ2 as faCaretRight,
  $Z2 as faCaretSquareDown,
  bZ2 as faCaretSquareLeft,
  yZ2 as faCaretSquareRight,
  kZ2 as faCaretSquareUp,
  jZ2 as faCaretUp,
  TZ2 as faCarriageBaby,
  HZ2 as faCarrot,
  F52 as faCars,
  UZ2 as faCartArrowDown,
  H52 as faCartArrowUp,
  R52 as faCartCircleArrowDown,
  U52 as faCartCircleArrowUp,
  q52 as faCartCircleCheck,
  G52 as faCartCircleExclamation,
  W52 as faCartCirclePlus,
  E52 as faCartCircleXmark,
  GZ2 as faCartFlatbed,
  V52 as faCartFlatbedBoxes,
  I52 as faCartFlatbedEmpty,
  EZ2 as faCartFlatbedSuitcase,
  K52 as faCartMinus,
  IZ2 as faCartPlus,
  XZ2 as faCartShopping,
  X52 as faCartShoppingFast,
  Q52 as faCartXmark,
  JZ2 as faCashRegister,
  J52 as faCassetteBetamax,
  Y52 as faCassetteTape,
  Z52 as faCassetteVhs,
  p52 as faCastle,
  ZZ2 as faCat,
  x52 as faCatSpace,
  i72 as faCauldron,
  oY1 as faCcAmazonPay,
  dY1 as faCcAmex,
  sY1 as faCcApplePay,
  vY1 as faCcDinersClub,
  mY1 as faCcDiscover,
  PY1 as faCcJcb,
  wY1 as faCcMastercard,
  zY1 as faCcPaypal,
  CY1 as faCcStripe,
  $Y1 as faCcVisa,
  a72 as faCctv,
  xZ2 as faCediSign,
  ap2 as faCentSign,
  bY1 as faCentercode,
  yY1 as faCentos,
  np2 as faCertificate,
  cp2 as faChain,
  op2 as faChainBroken,
  e72 as faChainHorizontal,
  n72 as faChainHorizontalSlash,
  dp2 as faChainSlash,
  sp2 as faChair,
  f72 as faChairOffice,
  vp2 as faChalkboard,
  mp2 as faChalkboardTeacher,
  Pp2 as faChalkboardUser,
  c72 as faChampagneGlass,
  wp2 as faChampagneGlasses,
  zp2 as faChargingStation,
  Cp2 as faChartArea,
  $p2 as faChartBar,
  t72 as faChartBullet,
  o72 as faChartCandlestick,
  bp2 as faChartColumn,
  yp2 as faChartGantt,
  l72 as faChartKanban,
  kp2 as faChartLine,
  d72 as faChartLineDown,
  r72 as faChartLineUp,
  s72 as faChartLineUpDown,
  h72 as faChartMixed,
  v72 as faChartMixedUpCircleCurrency,
  u72 as faChartMixedUpCircleDollar,
  m72 as faChartNetwork,
  jp2 as faChartPie,
  g72 as faChartPieAlt,
  P72 as faChartPieSimple,
  M72 as faChartPieSimpleCircleCurrency,
  w72 as faChartPieSimpleCircleDollar,
  N72 as faChartPyramid,
  z72 as faChartRadar,
  L72 as faChartScatter,
  C72 as faChartScatter3d,
  D72 as faChartScatterBubble,
  Tp2 as faChartSimple,
  $72 as faChartSimpleHorizontal,
  _72 as faChartTreeMap,
  b72 as faChartUser,
  S72 as faChartWaterfall,
  Hp2 as faCheck,
  Up2 as faCheckCircle,
  Gp2 as faCheckDouble,
  Ep2 as faCheckSquare,
  Ip2 as faCheckToSlot,
  Xp2 as faCheese,
  y72 as faCheeseSwiss,
  O72 as faCheeseburger,
  k72 as faCherries,
  Jp2 as faChess,
  Zp2 as faChessBishop,
  A72 as faChessBishopAlt,
  j72 as faChessBishopPiece,
  xp2 as faChessBoard,
  B72 as faChessClock,
  T72 as faChessClockAlt,
  F72 as faChessClockFlip,
  ax2 as faChessKing,
  H72 as faChessKingAlt,
  R72 as faChessKingPiece,
  nx2 as faChessKnight,
  U72 as faChessKnightAlt,
  q72 as faChessKnightPiece,
  cx2 as faChessPawn,
  G72 as faChessPawnAlt,
  W72 as faChessPawnPiece,
  ox2 as faChessQueen,
  E72 as faChessQueenAlt,
  V72 as faChessQueenPiece,
  dx2 as faChessRook,
  I72 as faChessRookAlt,
  K72 as faChessRookPiece,
  X72 as faChestnut,
  sx2 as faChevronCircleDown,
  vx2 as faChevronCircleLeft,
  mx2 as faChevronCircleRight,
  Px2 as faChevronCircleUp,
  Q72 as faChevronDoubleDown,
  J72 as faChevronDoubleLeft,
  Y72 as faChevronDoubleRight,
  Z72 as faChevronDoubleUp,
  wx2 as faChevronDown,
  zx2 as faChevronLeft,
  Cx2 as faChevronRight,
  p72 as faChevronSquareDown,
  x72 as faChevronSquareLeft,
  it2 as faChevronSquareRight,
  at2 as faChevronSquareUp,
  $x2 as faChevronUp,
  et2 as faChevronsDown,
  nt2 as faChevronsLeft,
  ft2 as faChevronsRight,
  ct2 as faChevronsUp,
  tt2 as faChfSign,
  bx2 as faChild,
  yx2 as faChildCombatant,
  kx2 as faChildDress,
  jx2 as faChildReaching,
  Tx2 as faChildRifle,
  Hx2 as faChildren,
  ot2 as faChimney,
  lt2 as faChocolateBar,
  dt2 as faChopsticks,
  kY1 as faChrome,
  jY1 as faChromecast,
  Ux2 as faChurch,
  Gx2 as faCircle,
  rt2 as faCircle0,
  st2 as faCircle1,
  ht2 as faCircle2,
  vt2 as faCircle3,
  ut2 as faCircle4,
  mt2 as faCircle5,
  gt2 as faCircle6,
  Pt2 as faCircle7,
  Mt2 as faCircle8,
  wt2 as faCircle9,
  Nt2 as faCircleA,
  zt2 as faCircleAmpersand,
  Ex2 as faCircleArrowDown,
  Lt2 as faCircleArrowDownLeft,
  Ct2 as faCircleArrowDownRight,
  Ix2 as faCircleArrowLeft,
  Xx2 as faCircleArrowRight,
  Jx2 as faCircleArrowUp,
  Dt2 as faCircleArrowUpLeft,
  $t2 as faCircleArrowUpRight,
  _t2 as faCircleB,
  bt2 as faCircleBolt,
  St2 as faCircleBookOpen,
  yt2 as faCircleBookmark,
  Ot2 as faCircleC,
  kt2 as faCircleCalendar,
  At2 as faCircleCamera,
  jt2 as faCircleCaretDown,
  Bt2 as faCircleCaretLeft,
  Tt2 as faCircleCaretRight,
  Ft2 as faCircleCaretUp,
  Zx2 as faCircleCheck,
  xx2 as faCircleChevronDown,
  ai1 as faCircleChevronLeft,
  ni1 as faCircleChevronRight,
  ci1 as faCircleChevronUp,
  Ht2 as faCircleD,
  Rt2 as faCircleDashed,
  Ut2 as faCircleDivide,
  qt2 as faCircleDollar,
  oi1 as faCircleDollarToSlot,
  di1 as faCircleDot,
  si1 as faCircleDown,
  Gt2 as faCircleDownLeft,
  Wt2 as faCircleDownRight,
  Et2 as faCircleE,
  Vt2 as faCircleEllipsis,
  It2 as faCircleEllipsisVertical,
  Kt2 as faCircleEnvelope,
  Xt2 as faCircleEuro,
  vi1 as faCircleExclamation,
  Qt2 as faCircleExclamationCheck,
  Jt2 as faCircleF,
  Yt2 as faCircleG,
  Zt2 as faCircleGf,
  mi1 as faCircleH,
  pt2 as faCircleHalf,
  Pi1 as faCircleHalfStroke,
  xt2 as faCircleHeart,
  io2 as faCircleI,
  wi1 as faCircleInfo,
  ao2 as faCircleJ,
  eo2 as faCircleK,
  no2 as faCircleL,
  zi1 as faCircleLeft,
  fo2 as faCircleLocationArrow,
  co2 as faCircleM,
  to2 as faCircleMicrophone,
  oo2 as faCircleMicrophoneLines,
  Ci1 as faCircleMinus,
  lo2 as faCircleN,
  $i1 as faCircleNodes,
  bi1 as faCircleNotch,
  do2 as faCircleO,
  ro2 as faCircleP,
  so2 as faCircleParking,
  yi1 as faCirclePause,
  ho2 as faCirclePhone,
  vo2 as faCirclePhoneFlip,
  uo2 as faCirclePhoneHangup,
  ki1 as faCirclePlay,
  ji1 as faCirclePlus,
  mo2 as faCircleQ,
  go2 as faCircleQuarter,
  Po2 as faCircleQuarterStroke,
  Mo2 as faCircleQuarters,
  Ti1 as faCircleQuestion,
  wo2 as faCircleR,
  Hi1 as faCircleRadiation,
  Ui1 as faCircleRight,
  No2 as faCircleS,
  zo2 as faCircleSmall,
  Lo2 as faCircleSort,
  Co2 as faCircleSortDown,
  Do2 as faCircleSortUp,
  $o2 as faCircleStar,
  _o2 as faCircleSterling,
  Gi1 as faCircleStop,
  bo2 as faCircleT,
  So2 as faCircleThreeQuarters,
  yo2 as faCircleThreeQuartersStroke,
  Oo2 as faCircleTrash,
  ko2 as faCircleU,
  Ei1 as faCircleUp,
  Ao2 as faCircleUpLeft,
  jo2 as faCircleUpRight,
  Ii1 as faCircleUser,
  Bo2 as faCircleV,
  To2 as faCircleVideo,
  Fo2 as faCircleW,
  Ho2 as faCircleWaveformLines,
  Ro2 as faCircleWifi,
  Uo2 as faCircleWifiCircleWifi,
  qo2 as faCircleWifiGroup,
  Go2 as faCircleX,
  Xi1 as faCircleXmark,
  Wo2 as faCircleY,
  Eo2 as faCircleYen,
  Vo2 as faCircleZ,
  Io2 as faCirclesOverlap,
  Ko2 as faCitrus,
  Xo2 as faCitrusSlice,
  Ji1 as faCity,
  Zi1 as faClapperboard,
  Qo2 as faClapperboardPlay,
  Jo2 as faClarinet,
  Yo2 as faClawMarks,
  xi1 as faClinicMedical,
  a21 as faClipboard,
  n21 as faClipboardCheck,
  c21 as faClipboardList,
  Zo2 as faClipboardListCheck,
  po2 as faClipboardMedical,
  xo2 as faClipboardPrescription,
  o21 as faClipboardQuestion,
  d21 as faClipboardUser,
  s21 as faClock,
  il2 as faClockDesk,
  al2 as faClockEight,
  el2 as faClockEightThirty,
  nl2 as faClockEleven,
  fl2 as faClockElevenThirty,
  cl2 as faClockFive,
  tl2 as faClockFiveThirty,
  v21 as faClockFour,
  ol2 as faClockFourThirty,
  ll2 as faClockNine,
  dl2 as faClockNineThirty,
  rl2 as faClockOne,
  sl2 as faClockOneThirty,
  m21 as faClockRotateLeft,
  hl2 as faClockSeven,
  vl2 as faClockSevenThirty,
  ul2 as faClockSix,
  ml2 as faClockSixThirty,
  gl2 as faClockTen,
  Pl2 as faClockTenThirty,
  Ml2 as faClockThree,
  wl2 as faClockThreeThirty,
  Nl2 as faClockTwelve,
  zl2 as faClockTwelveThirty,
  Ll2 as faClockTwo,
  Cl2 as faClockTwoThirty,
  P21 as faClone,
  w21 as faClose,
  z21 as faClosedCaptioning,
  Dl2 as faClosedCaptioningSlash,
  $l2 as faClothesHanger,
  C21 as faCloud,
  $21 as faCloudArrowDown,
  b21 as faCloudArrowUp,
  _l2 as faCloudBinary,
  y21 as faCloudBolt,
  bl2 as faCloudBoltMoon,
  Sl2 as faCloudBoltSun,
  yl2 as faCloudCheck,
  k21 as faCloudDownload,
  j21 as faCloudDownloadAlt,
  Ol2 as faCloudDrizzle,
  kl2 as faCloudExclamation,
  Al2 as faCloudFog,
  jl2 as faCloudHail,
  Bl2 as faCloudHailMixed,
  T21 as faCloudMeatball,
  Tl2 as faCloudMinus,
  H21 as faCloudMoon,
  U21 as faCloudMoonRain,
  Fl2 as faCloudMusic,
  Hl2 as faCloudPlus,
  Rl2 as faCloudQuestion,
  G21 as faCloudRain,
  Ul2 as faCloudRainbow,
  ql2 as faCloudShowers,
  E21 as faCloudShowersHeavy,
  I21 as faCloudShowersWater,
  Gl2 as faCloudSlash,
  Wl2 as faCloudSleet,
  El2 as faCloudSnow,
  X21 as faCloudSun,
  J21 as faCloudSunRain,
  Z21 as faCloudUpload,
  x21 as faCloudUploadAlt,
  Vl2 as faCloudWord,
  Il2 as faCloudXmark,
  TY1 as faCloudflare,
  Kl2 as faClouds,
  Xl2 as faCloudsMoon,
  Ql2 as faCloudsSun,
  HY1 as faCloudscale,
  UY1 as faCloudsmith,
  GY1 as faCloudversify,
  a11 as faClover,
  Jl2 as faClub,
  EY1 as faCmplid,
  n11 as faCny,
  c11 as faCocktail,
  Yl2 as faCoconut,
  o11 as faCode,
  d11 as faCodeBranch,
  s11 as faCodeCommit,
  v11 as faCodeCompare,
  m11 as faCodeFork,
  P11 as faCodeMerge,
  w11 as faCodePullRequest,
  Zl2 as faCodePullRequestClosed,
  pl2 as faCodePullRequestDraft,
  xl2 as faCodeSimple,
  IY1 as faCodepen,
  XY1 as faCodiepie,
  z11 as faCoffee,
  id2 as faCoffeeBean,
  ad2 as faCoffeeBeans,
  ed2 as faCoffeePot,
  nd2 as faCoffeeTogo,
  fd2 as faCoffin,
  cd2 as faCoffinCross,
  C11 as faCog,
  $11 as faCogs,
  td2 as faCoin,
  od2 as faCoinBlank,
  ld2 as faCoinFront,
  dd2 as faCoinVertical,
  b11 as faCoins,
  rd2 as faColon,
  y11 as faColonSign,
  k11 as faColumns,
  sd2 as faColumns3,
  hd2 as faComet,
  vd2 as faComma,
  ud2 as faCommand,
  j11 as faComment,
  T11 as faCommentAlt,
  md2 as faCommentAltArrowDown,
  gd2 as faCommentAltArrowUp,
  Pd2 as faCommentAltCaptions,
  Md2 as faCommentAltCheck,
  wd2 as faCommentAltDollar,
  Nd2 as faCommentAltDots,
  zd2 as faCommentAltEdit,
  Ld2 as faCommentAltExclamation,
  Cd2 as faCommentAltImage,
  Dd2 as faCommentAltLines,
  $d2 as faCommentAltMedical,
  _d2 as faCommentAltMinus,
  bd2 as faCommentAltMusic,
  Sd2 as faCommentAltPlus,
  yd2 as faCommentAltQuote,
  Od2 as faCommentAltSlash,
  kd2 as faCommentAltSmile,
  Ad2 as faCommentAltText,
  jd2 as faCommentAltTimes,
  Bd2 as faCommentArrowDown,
  Td2 as faCommentArrowUp,
  Fd2 as faCommentArrowUpRight,
  Hd2 as faCommentCaptions,
  Rd2 as faCommentCheck,
  Ud2 as faCommentCode,
  H11 as faCommentDollar,
  U11 as faCommentDots,
  qd2 as faCommentEdit,
  Gd2 as faCommentExclamation,
  Wd2 as faCommentHeart,
  Ed2 as faCommentImage,
  Vd2 as faCommentLines,
  G11 as faCommentMedical,
  Id2 as faCommentMiddle,
  Kd2 as faCommentMiddleAlt,
  Xd2 as faCommentMiddleTop,
  Qd2 as faCommentMiddleTopAlt,
  Jd2 as faCommentMinus,
  Yd2 as faCommentMusic,
  Zd2 as faCommentPen,
  pd2 as faCommentPlus,
  xd2 as faCommentQuestion,
  ir2 as faCommentQuote,
  E11 as faCommentSlash,
  ar2 as faCommentSmile,
  I11 as faCommentSms,
  er2 as faCommentText,
  nr2 as faCommentTimes,
  fr2 as faCommentXmark,
  X11 as faCommenting,
  J11 as faComments,
  cr2 as faCommentsAlt,
  tr2 as faCommentsAltDollar,
  Z11 as faCommentsDollar,
  or2 as faCommentsQuestion,
  lr2 as faCommentsQuestionCheck,
  x11 as faCompactDisc,
  aa1 as faCompass,
  na1 as faCompassDrafting,
  dr2 as faCompassSlash,
  ca1 as faCompress,
  oa1 as faCompressAlt,
  rr2 as faCompressArrows,
  da1 as faCompressArrowsAlt,
  sr2 as faCompressWide,
  sa1 as faComputer,
  hr2 as faComputerClassic,
  va1 as faComputerMouse,
  vr2 as faComputerMouseScrollwheel,
  ur2 as faComputerSpeaker,
  ma1 as faConciergeBell,
  JY1 as faConfluence,
  ZY1 as faConnectdevelop,
  mr2 as faConstruction,
  Pa1 as faContactBook,
  wa1 as faContactCard,
  gr2 as faContainerStorage,
  xY1 as faContao,
  Pr2 as faConveyorBelt,
  Mr2 as faConveyorBeltAlt,
  wr2 as faConveyorBeltArm,
  Nr2 as faConveyorBeltBoxes,
  zr2 as faConveyorBeltEmpty,
  za1 as faCookie,
  Ca1 as faCookieBite,
  $a1 as faCopy,
  ba1 as faCopyright,
  Lr2 as faCorn,
  Cr2 as faCorner,
  aZ1 as faCottonBureau,
  ya1 as faCouch,
  Dr2 as faCouchSmall,
  $r2 as faCourtSport,
  ka1 as faCow,
  _r2 as faCowbell,
  br2 as faCowbellCirclePlus,
  Sr2 as faCowbellMore,
  nZ1 as faCpanel,
  yr2 as faCrab,
  Or2 as faCrateApple,
  kr2 as faCrateEmpty,
  cZ1 as faCreativeCommons,
  oZ1 as faCreativeCommonsBy,
  dZ1 as faCreativeCommonsNc,
  sZ1 as faCreativeCommonsNcEu,
  vZ1 as faCreativeCommonsNcJp,
  mZ1 as faCreativeCommonsNd,
  PZ1 as faCreativeCommonsPd,
  wZ1 as faCreativeCommonsPdAlt,
  zZ1 as faCreativeCommonsRemix,
  CZ1 as faCreativeCommonsSa,
  $Z1 as faCreativeCommonsSampling,
  bZ1 as faCreativeCommonsSamplingPlus,
  yZ1 as faCreativeCommonsShare,
  kZ1 as faCreativeCommonsZero,
  ja1 as faCreditCard,
  Ta1 as faCreditCardAlt,
  Ar2 as faCreditCardBlank,
  jr2 as faCreditCardFront,
  Br2 as faCreemee,
  Tr2 as faCricket,
  Fr2 as faCricketBatBall,
  jZ1 as faCriticalRole,
  Hr2 as faCroissant,
  Ha1 as faCrop,
  Ua1 as faCropAlt,
  Ga1 as faCropSimple,
  Ea1 as faCross,
  Ia1 as faCrosshairs,
  Rr2 as faCrosshairsSimple,
  Xa1 as faCrow,
  Ja1 as faCrown,
  Za1 as faCrutch,
  Ur2 as faCrutches,
  xa1 as faCruzeiroSign,
  qr2 as faCrystalBall,
  TZ1 as faCss3,
  HZ1 as faCss3Alt,
  a41 as faCube,
  n41 as faCubes,
  c41 as faCubesStacked,
  Gr2 as faCucumber,
  Wr2 as faCupStraw,
  Er2 as faCupStrawSwoosh,
  Vr2 as faCupTogo,
  Ir2 as faCupcake,
  Kr2 as faCurling,
  Xr2 as faCurlingStone,
  Qr2 as faCustard,
  o41 as faCut,
  d41 as faCutlery,
  UZ1 as faCuttlefish,
  s41 as faD,
  GZ1 as faDAndD,
  EZ1 as faDAndDBeyond,
  Jr2 as faDagger,
  IZ1 as faDailymotion,
  XZ1 as faDartLang,
  Yr2 as faDash,
  v41 as faDashboard,
  JZ1 as faDashcube,
  m41 as faDatabase,
  P41 as faDeaf,
  w41 as faDeafness,
  ZZ1 as faDebian,
  Zr2 as faDebug,
  z41 as faDedent,
  pr2 as faDeer,
  xr2 as faDeerRudolph,
  xZ1 as faDeezer,
  C41 as faDeleteLeft,
  i92 as faDeleteRight,
  ap1 as faDelicious,
  $41 as faDemocrat,
  np1 as faDeploydog,
  cp1 as faDeskpro,
  b41 as faDesktop,
  y41 as faDesktopAlt,
  a92 as faDesktopArrowDown,
  e92 as faDesktopCode,
  n92 as faDesktopMedical,
  f92 as faDesktopSlash,
  op1 as faDev,
  dp1 as faDeviantart,
  c92 as faDewpoint,
  k41 as faDharmachakra,
  sp1 as faDhl,
  j41 as faDiagnoses,
  t92 as faDiagramCells,
  o92 as faDiagramLeanCanvas,
  l92 as faDiagramNested,
  T41 as faDiagramNext,
  H41 as faDiagramPredecessor,
  d92 as faDiagramPrevious,
  U41 as faDiagramProject,
  r92 as faDiagramSankey,
  s92 as faDiagramSubtask,
  G41 as faDiagramSuccessor,
  h92 as faDiagramVenn,
  v92 as faDial,
  u92 as faDialHigh,
  m92 as faDialLow,
  g92 as faDialMax,
  P92 as faDialMed,
  M92 as faDialMedHigh,
  w92 as faDialMedLow,
  N92 as faDialMin,
  z92 as faDialOff,
  E41 as faDiamond,
  L92 as faDiamondExclamation,
  C92 as faDiamondHalf,
  D92 as faDiamondHalfStroke,
  I41 as faDiamondTurnRight,
  $92 as faDiamonds4,
  vp1 as faDiaspora,
  X41 as faDice,
  _92 as faDiceD10,
  b92 as faDiceD12,
  J41 as faDiceD20,
  S92 as faDiceD4,
  Z41 as faDiceD6,
  y92 as faDiceD8,
  x41 as faDiceFive,
  a31 as faDiceFour,
  n31 as faDiceOne,
  c31 as faDiceSix,
  o31 as faDiceThree,
  d31 as faDiceTwo,
  mp1 as faDigg,
  s31 as faDigging,
  Pp1 as faDigitalOcean,
  v31 as faDigitalTachograph,
  O92 as faDinosaur,
  k92 as faDiploma,
  m31 as faDirections,
  A92 as faDiscDrive,
  wp1 as faDiscord,
  zp1 as faDiscourse,
  P31 as faDisease,
  w31 as faDisplay,
  j92 as faDisplayArrowDown,
  B92 as faDisplayChartUp,
  T92 as faDisplayChartUpCircleCurrency,
  F92 as faDisplayChartUpCircleDollar,
  H92 as faDisplayCode,
  R92 as faDisplayMedical,
  U92 as faDisplaySlash,
  q92 as faDistributeSpacingHorizontal,
  G92 as faDistributeSpacingVertical,
  W92 as faDitto,
  z31 as faDivide,
  C31 as faDizzy,
  $31 as faDna,
  E92 as faDoNotEnter,
  Cp1 as faDochub,
  $p1 as faDocker,
  b31 as faDog,
  V92 as faDogLeashed,
  y31 as faDollar,
  I92 as faDollarCircle,
  k31 as faDollarSign,
  K92 as faDollarSquare,
  j31 as faDolly,
  T31 as faDollyBox,
  X92 as faDollyEmpty,
  H31 as faDollyFlatbed,
  Q92 as faDollyFlatbedAlt,
  J92 as faDollyFlatbedEmpty,
  Y92 as faDolphin,
  U31 as faDonate,
  G31 as faDongSign,
  Z92 as faDonut,
  E31 as faDoorClosed,
  I31 as faDoorOpen,
  X31 as faDotCircle,
  p92 as faDoughnut,
  J31 as faDove,
  x92 as faDown,
  is2 as faDownFromBracket,
  as2 as faDownFromDottedLine,
  es2 as faDownFromLine,
  ns2 as faDownLeft,
  Z31 as faDownLeftAndUpRightToCenter,
  x31 as faDownLong,
  fs2 as faDownRight,
  cs2 as faDownToBracket,
  ts2 as faDownToDottedLine,
  os2 as faDownToLine,
  a01 as faDownload,
  bp1 as faDraft2digital,
  n01 as faDraftingCompass,
  c01 as faDragon,
  ls2 as faDrawCircle,
  o01 as faDrawPolygon,
  ds2 as faDrawSquare,
  rs2 as faDreidel,
  yp1 as faDribbble,
  kp1 as faDribbbleSquare,
  d01 as faDriversLicense,
  ss2 as faDrone,
  hs2 as faDroneAlt,
  vs2 as faDroneFront,
  jp1 as faDropbox,
  s01 as faDroplet,
  us2 as faDropletDegree,
  ms2 as faDropletPercent,
  v01 as faDropletSlash,
  m01 as faDrum,
  P01 as faDrumSteelpan,
  gs2 as faDrumstick,
  w01 as faDrumstickBite,
  Tp1 as faDrupal,
  Ps2 as faDryer,
  Ms2 as faDryerAlt,
  ws2 as faDryerHeat,
  Ns2 as faDuck,
  z01 as faDumbbell,
  C01 as faDumpster,
  $01 as faDumpsterFire,
  b01 as faDungeon,
  Hp1 as faDyalog,
  y01 as faE,
  zs2 as faEar,
  k01 as faEarDeaf,
  j01 as faEarListen,
  Ls2 as faEarMuffs,
  Up1 as faEarlybirds,
  T01 as faEarth,
  H01 as faEarthAfrica,
  U01 as faEarthAmerica,
  G01 as faEarthAmericas,
  E01 as faEarthAsia,
  I01 as faEarthEurope,
  X01 as faEarthOceania,
  Gp1 as faEbay,
  Cs2 as faEclipse,
  Ds2 as faEclipseAlt,
  Ep1 as faEdge,
  Ip1 as faEdgeLegacy,
  J01 as faEdit,
  Z01 as faEgg,
  $s2 as faEggFried,
  _s2 as faEggplant,
  x01 as faEject,
  Xp1 as faElementor,
  bs2 as faElephant,
  ae1 as faElevator,
  ne1 as faEllipsis,
  ce1 as faEllipsisH,
  Ss2 as faEllipsisHAlt,
  ys2 as faEllipsisStroke,
  Os2 as faEllipsisStrokeVertical,
  oe1 as faEllipsisV,
  ks2 as faEllipsisVAlt,
  de1 as faEllipsisVertical,
  Jp1 as faEllo,
  Zp1 as faEmber,
  xp1 as faEmpire,
  As2 as faEmptySet,
  js2 as faEngine,
  Bs2 as faEngineExclamation,
  Ts2 as faEngineWarning,
  se1 as faEnvelope,
  Fs2 as faEnvelopeBadge,
  Hs2 as faEnvelopeCircle,
  ve1 as faEnvelopeCircleCheck,
  Rs2 as faEnvelopeDot,
  me1 as faEnvelopeOpen,
  Us2 as faEnvelopeOpenDollar,
  Pe1 as faEnvelopeOpenText,
  we1 as faEnvelopeSquare,
  qs2 as faEnvelopes,
  ze1 as faEnvelopesBulk,
  ax1 as faEnvira,
  Ce1 as faEquals,
  $e1 as faEraser,
  nx1 as faErlang,
  Gs2 as faEscalator,
  cx1 as faEthereum,
  be1 as faEthernet,
  ox1 as faEtsy,
  ye1 as faEur,
  ke1 as faEuro,
  je1 as faEuroSign,
  dx1 as faEvernote,
  Ws2 as faExcavator,
  Te1 as faExchange,
  He1 as faExchangeAlt,
  Ue1 as faExclamation,
  Ge1 as faExclamationCircle,
  Es2 as faExclamationSquare,
  Ee1 as faExclamationTriangle,
  Ie1 as faExpand,
  Xe1 as faExpandAlt,
  Vs2 as faExpandArrows,
  Je1 as faExpandArrowsAlt,
  Is2 as faExpandWide,
  sx1 as faExpeditedssl,
  Ks2 as faExplodingHead,
  Ze1 as faExplosion,
  xe1 as faExternalLink,
  an1 as faExternalLinkAlt,
  nn1 as faExternalLinkSquare,
  cn1 as faExternalLinkSquareAlt,
  on1 as faEye,
  dn1 as faEyeDropper,
  sn1 as faEyeDropperEmpty,
  Xs2 as faEyeDropperFull,
  Qs2 as faEyeDropperHalf,
  Js2 as faEyeEvil,
  vn1 as faEyeLowVision,
  mn1 as faEyeSlash,
  Ys2 as faEyes,
  Pn1 as faF,
  wn1 as faFaceAngry,
  Zs2 as faFaceAngryHorns,
  ps2 as faFaceAnguished,
  xs2 as faFaceAnxiousSweat,
  ih2 as faFaceAstonished,
  ah2 as faFaceAwesome,
  eh2 as faFaceBeamHandOverMouth,
  nh2 as faFaceClouds,
  fh2 as faFaceConfounded,
  ch2 as faFaceConfused,
  th2 as faFaceCowboyHat,
  oh2 as faFaceDiagonalMouth,
  lh2 as faFaceDisappointed,
  dh2 as faFaceDisguise,
  zn1 as faFaceDizzy,
  rh2 as faFaceDotted,
  sh2 as faFaceDowncastSweat,
  hh2 as faFaceDrooling,
  vh2 as faFaceExhaling,
  uh2 as faFaceExplode,
  mh2 as faFaceExpressionless,
  gh2 as faFaceEyesXmarks,
  Ph2 as faFaceFearful,
  Cn1 as faFaceFlushed,
  $n1 as faFaceFrown,
  bn1 as faFaceFrownOpen,
  Mh2 as faFaceFrownSlight,
  wh2 as faFaceGlasses,
  yn1 as faFaceGrimace,
  kn1 as faFaceGrin,
  jn1 as faFaceGrinBeam,
  Tn1 as faFaceGrinBeamSweat,
  Hn1 as faFaceGrinHearts,
  Un1 as faFaceGrinSquint,
  Gn1 as faFaceGrinSquintTears,
  En1 as faFaceGrinStars,
  In1 as faFaceGrinTears,
  Xn1 as faFaceGrinTongue,
  Jn1 as faFaceGrinTongueSquint,
  Zn1 as faFaceGrinTongueWink,
  xn1 as faFaceGrinWide,
  a61 as faFaceGrinWink,
  Nh2 as faFaceHandOverMouth,
  zh2 as faFaceHandPeeking,
  Lh2 as faFaceHandYawn,
  Ch2 as faFaceHeadBandage,
  Dh2 as faFaceHoldingBackTears,
  $h2 as faFaceHushed,
  _h2 as faFaceIcicles,
  n61 as faFaceKiss,
  c61 as faFaceKissBeam,
  bh2 as faFaceKissClosedEyes,
  o61 as faFaceKissWinkHeart,
  d61 as faFaceLaugh,
  s61 as faFaceLaughBeam,
  v61 as faFaceLaughSquint,
  m61 as faFaceLaughWink,
  Sh2 as faFaceLying,
  yh2 as faFaceMask,
  P61 as faFaceMeh,
  w61 as faFaceMehBlank,
  Oh2 as faFaceMelting,
  kh2 as faFaceMonocle,
  Ah2 as faFaceNauseated,
  jh2 as faFaceNoseSteam,
  Bh2 as faFaceParty,
  Th2 as faFacePensive,
  Fh2 as faFacePersevering,
  Hh2 as faFacePleading,
  Rh2 as faFacePouting,
  Uh2 as faFaceRaisedEyebrow,
  qh2 as faFaceRelieved,
  z61 as faFaceRollingEyes,
  C61 as faFaceSadCry,
  Gh2 as faFaceSadSweat,
  $61 as faFaceSadTear,
  Wh2 as faFaceSaluting,
  Eh2 as faFaceScream,
  Vh2 as faFaceShush,
  Ih2 as faFaceSleeping,
  Kh2 as faFaceSleepy,
  b61 as faFaceSmile,
  y61 as faFaceSmileBeam,
  Xh2 as faFaceSmileHalo,
  Qh2 as faFaceSmileHearts,
  Jh2 as faFaceSmileHorns,
  Yh2 as faFaceSmilePlus,
  Zh2 as faFaceSmileRelaxed,
  ph2 as faFaceSmileTear,
  xh2 as faFaceSmileTongue,
  iv2 as faFaceSmileUpsideDown,
  k61 as faFaceSmileWink,
  av2 as faFaceSmilingHands,
  ev2 as faFaceSmirking,
  nv2 as faFaceSpiralEyes,
  fv2 as faFaceSunglasses,
  j61 as faFaceSurprise,
  cv2 as faFaceSwear,
  tv2 as faFaceThermometer,
  ov2 as faFaceThinking,
  T61 as faFaceTired,
  lv2 as faFaceTissue,
  dv2 as faFaceTongueMoney,
  rv2 as faFaceTongueSweat,
  sv2 as faFaceUnamused,
  hv2 as faFaceViewfinder,
  vv2 as faFaceVomit,
  uv2 as faFaceWeary,
  mv2 as faFaceWoozy,
  gv2 as faFaceWorried,
  Pv2 as faFaceZany,
  Mv2 as faFaceZipper,
  vx1 as faFacebook,
  mx1 as faFacebookF,
  Px1 as faFacebookMessenger,
  wx1 as faFacebookSquare,
  wv2 as faFalafel,
  Nv2 as faFamily,
  zv2 as faFamilyDress,
  Lv2 as faFamilyPants,
  H61 as faFan,
  Cv2 as faFanTable,
  zx1 as faFantasyFlightGames,
  Dv2 as faFarm,
  U61 as faFastBackward,
  G61 as faFastForward,
  E61 as faFaucet,
  I61 as faFaucetDrip,
  X61 as faFax,
  J61 as faFeather,
  Z61 as faFeatherAlt,
  x61 as faFeatherPointed,
  Cx1 as faFedex,
  $x1 as faFedora,
  af1 as faFeed,
  nf1 as faFemale,
  $v2 as faFence,
  _v2 as faFerrisWheel,
  cf1 as faFerry,
  bv2 as faFieldHockey,
  Sv2 as faFieldHockeyStickBall,
  of1 as faFighterJet,
  bx1 as faFigma,
  df1 as faFile,
  sf1 as faFileAlt,
  vf1 as faFileArchive,
  mf1 as faFileArrowDown,
  Pf1 as faFileArrowUp,
  wf1 as faFileAudio,
  yv2 as faFileAward,
  Ov2 as faFileBinary,
  kv2 as faFileCad,
  Av2 as faFileCaretDown,
  jv2 as faFileCaretUp,
  Bv2 as faFileCertificate,
  Tv2 as faFileChartColumn,
  Fv2 as faFileChartLine,
  Hv2 as faFileChartPie,
  Rv2 as faFileCheck,
  zf1 as faFileCircleCheck,
  Cf1 as faFileCircleExclamation,
  Uv2 as faFileCircleInfo,
  $f1 as faFileCircleMinus,
  bf1 as faFileCirclePlus,
  yf1 as faFileCircleQuestion,
  kf1 as faFileCircleXmark,
  jf1 as faFileClipboard,
  Tf1 as faFileCode,
  Hf1 as faFileContract,
  Uf1 as faFileCsv,
  qv2 as faFileDashedLine,
  Gv2 as faFileDoc,
  Gf1 as faFileDownload,
  Ef1 as faFileEdit,
  Wv2 as faFileEps,
  If1 as faFileExcel,
  Ev2 as faFileExclamation,
  Xf1 as faFileExport,
  Vv2 as faFileGif,
  Iv2 as faFileHeart,
  Jf1 as faFileImage,
  Zf1 as faFileImport,
  xf1 as faFileInvoice,
  ac1 as faFileInvoiceDollar,
  Kv2 as faFileJpg,
  nc1 as faFileLines,
  Xv2 as faFileLock,
  Qv2 as faFileMagnifyingGlass,
  cc1 as faFileMedical,
  oc1 as faFileMedicalAlt,
  Jv2 as faFileMinus,
  Yv2 as faFileMov,
  Zv2 as faFileMp3,
  pv2 as faFileMp4,
  xv2 as faFileMusic,
  dc1 as faFilePdf,
  sc1 as faFilePen,
  iu2 as faFilePlus,
  au2 as faFilePlusMinus,
  eu2 as faFilePng,
  vc1 as faFilePowerpoint,
  nu2 as faFilePpt,
  mc1 as faFilePrescription,
  fu2 as faFileSearch,
  Pc1 as faFileShield,
  wc1 as faFileSignature,
  cu2 as faFileSlash,
  tu2 as faFileSpreadsheet,
  ou2 as faFileSvg,
  zc1 as faFileText,
  lu2 as faFileTimes,
  Cc1 as faFileUpload,
  du2 as faFileUser,
  ru2 as faFileVector,
  $c1 as faFileVideo,
  bc1 as faFileWaveform,
  yc1 as faFileWord,
  su2 as faFileXls,
  hu2 as faFileXmark,
  vu2 as faFileXml,
  uu2 as faFileZip,
  kc1 as faFileZipper,
  mu2 as faFiles,
  gu2 as faFilesMedical,
  jc1 as faFill,
  Tc1 as faFillDrip,
  Hc1 as faFilm,
  Pu2 as faFilmAlt,
  Mu2 as faFilmCanister,
  wu2 as faFilmCannister,
  Nu2 as faFilmSimple,
  zu2 as faFilmSlash,
  Lu2 as faFilms,
  Uc1 as faFilter,
  Gc1 as faFilterCircleDollar,
  Ec1 as faFilterCircleXmark,
  Cu2 as faFilterList,
  Du2 as faFilterSlash,
  $u2 as faFilters,
  Ic1 as faFingerprint,
  Xc1 as faFire,
  Jc1 as faFireAlt,
  Zc1 as faFireBurner,
  xc1 as faFireExtinguisher,
  _u2 as faFireFlame,
  a81 as faFireFlameCurved,
  n81 as faFireFlameSimple,
  bu2 as faFireHydrant,
  Su2 as faFireSmoke,
  yx1 as faFirefox,
  kx1 as faFirefoxBrowser,
  yu2 as faFireplace,
  Ou2 as faFirewall,
  c81 as faFirstAid,
  jx1 as faFirstOrder,
  Tx1 as faFirstOrderAlt,
  Hx1 as faFirstdraft,
  o81 as faFish,
  ku2 as faFishBones,
  Au2 as faFishCooked,
  d81 as faFishFins,
  ju2 as faFishingRod,
  s81 as faFistRaised,
  v81 as faFlag,
  Bu2 as faFlagAlt,
  m81 as faFlagCheckered,
  Tu2 as faFlagPennant,
  Fu2 as faFlagSwallowtail,
  P81 as faFlagUsa,
  Hu2 as faFlame,
  Ru2 as faFlashlight,
  w81 as faFlask,
  Uu2 as faFlaskGear,
  qu2 as faFlaskPoison,
  Gu2 as faFlaskPotion,
  Wu2 as faFlaskRoundPoison,
  Eu2 as faFlaskRoundPotion,
  z81 as faFlaskVial,
  Vu2 as faFlatbread,
  Iu2 as faFlatbreadStuffed,
  Ux1 as faFlickr,
  Gx1 as faFlipboard,
  C81 as faFloppyDisk,
  Ku2 as faFloppyDiskCircleArrowRight,
  Xu2 as faFloppyDiskCircleXmark,
  Qu2 as faFloppyDiskPen,
  Ju2 as faFloppyDiskTimes,
  Yu2 as faFloppyDisks,
  $81 as faFlorinSign,
  Zu2 as faFlower,
  pu2 as faFlowerDaffodil,
  xu2 as faFlowerTulip,
  b81 as faFlushed,
  im2 as faFlute,
  Ex1 as faFlutter,
  am2 as faFluxCapacitor,
  Ix1 as faFly,
  em2 as faFlyingDisc,
  nm2 as faFog,
  y81 as faFolder,
  fm2 as faFolderArrowDown,
  cm2 as faFolderArrowUp,
  k81 as faFolderBlank,
  tm2 as faFolderBookmark,
  om2 as faFolderCheck,
  j81 as faFolderClosed,
  lm2 as faFolderCog,
  dm2 as faFolderDownload,
  rm2 as faFolderGear,
  sm2 as faFolderGrid,
  hm2 as faFolderHeart,
  vm2 as faFolderImage,
  um2 as faFolderMagnifyingGlass,
  mm2 as faFolderMedical,
  T81 as faFolderMinus,
  gm2 as faFolderMusic,
  H81 as faFolderOpen,
  U81 as faFolderPlus,
  Pm2 as faFolderSearch,
  Mm2 as faFolderTimes,
  G81 as faFolderTree,
  wm2 as faFolderUpload,
  Nm2 as faFolderUser,
  zm2 as faFolderXmark,
  Lm2 as faFolders,
  Cm2 as faFonduePot,
  E81 as faFont,
  I81 as faFontAwesome,
  Xx1 as faFontAwesomeAlt,
  X81 as faFontAwesomeFlag,
  J81 as faFontAwesomeLogoFull,
  Dm2 as faFontCase,
  Jx1 as faFonticons,
  Zx1 as faFonticonsFi,
  Z81 as faFootball,
  x81 as faFootballBall,
  $m2 as faFootballHelmet,
  _m2 as faFork,
  bm2 as faForkKnife,
  Sm2 as faForklift,
  ym2 as faFort,
  xx1 as faFortAwesome,
  aia as faFortAwesomeAlt,
  nia as faForumbee,
  a51 as faForward,
  n51 as faForwardFast,
  c51 as faForwardStep,
  cia as faFoursquare,
  Om2 as faFragile,
  km2 as faFrame,
  o51 as faFrancSign,
  oia as faFreeCodeCamp,
  dia as faFreebsd,
  Am2 as faFrenchFries,
  d51 as faFrog,
  jm2 as faFrostyHead,
  s51 as faFrown,
  v51 as faFrownOpen,
  sia as faFulcrum,
  Bm2 as faFunction,
  m51 as faFunnelDollar,
  P51 as faFutbol,
  w51 as faFutbolBall,
  z51 as faG,
  via as faGalacticRepublic,
  mia as faGalacticSenate,
  Tm2 as faGalaxy,
  Fm2 as faGalleryThumbnails,
  Hm2 as faGameBoard,
  Rm2 as faGameBoardAlt,
  Um2 as faGameBoardSimple,
  qm2 as faGameConsoleHandheld,
  Gm2 as faGameConsoleHandheldCrank,
  C51 as faGamepad,
  Wm2 as faGamepadAlt,
  Em2 as faGamepadModern,
  Vm2 as faGarage,
  Im2 as faGarageCar,
  Km2 as faGarageOpen,
  Xm2 as faGarlic,
  $51 as faGasPump,
  Qm2 as faGasPumpSlash,
  b51 as faGauge,
  Jm2 as faGaugeCircleBolt,
  Ym2 as faGaugeCircleMinus,
  Zm2 as faGaugeCirclePlus,
  y51 as faGaugeHigh,
  pm2 as faGaugeLow,
  xm2 as faGaugeMax,
  k51 as faGaugeMed,
  ig2 as faGaugeMin,
  j51 as faGaugeSimple,
  T51 as faGaugeSimpleHigh,
  ag2 as faGaugeSimpleLow,
  eg2 as faGaugeSimpleMax,
  H51 as faGaugeSimpleMed,
  ng2 as faGaugeSimpleMin,
  fg2 as faGaveDandy,
  U51 as faGavel,
  G51 as faGbp,
  E51 as faGear,
  cg2 as faGearCode,
  tg2 as faGearComplex,
  og2 as faGearComplexCode,
  I51 as faGears,
  X51 as faGem,
  J51 as faGenderless,
  Pia as faGetPocket,
  wia as faGg,
  zia as faGgCircle,
  Z51 as faGhost,
  lg2 as faGif,
  x51 as faGift,
  dg2 as faGiftCard,
  a71 as faGifts,
  rg2 as faGingerbreadMan,
  Cia as faGit,
  $ia as faGitAlt,
  bia as faGitSquare,
  yia as faGithub,
  kia as faGithubAlt,
  jia as faGithubSquare,
  Tia as faGitkraken,
  Hia as faGitlab,
  Uia as faGitlabSquare,
  Gia as faGitter,
  sg2 as faGlass,
  hg2 as faGlassChampagne,
  n71 as faGlassCheers,
  vg2 as faGlassCitrus,
  ug2 as faGlassEmpty,
  mg2 as faGlassHalf,
  gg2 as faGlassHalfEmpty,
  Pg2 as faGlassHalfFull,
  c71 as faGlassMartini,
  o71 as faGlassMartiniAlt,
  d71 as faGlassWater,
  s71 as faGlassWaterDroplet,
  v71 as faGlassWhiskey,
  Mg2 as faGlassWhiskeyRocks,
  m71 as faGlasses,
  wg2 as faGlassesAlt,
  Ng2 as faGlassesRound,
  Eia as faGlide,
  Iia as faGlideG,
  P71 as faGlobe,
  w71 as faGlobeAfrica,
  z71 as faGlobeAmericas,
  C71 as faGlobeAsia,
  $71 as faGlobeEurope,
  b71 as faGlobeOceania,
  zg2 as faGlobePointer,
  Lg2 as faGlobeSnow,
  Cg2 as faGlobeStand,
  Dg2 as faGlobeWifi,
  $g2 as faGloveBoxing,
  _g2 as faGoalNet,
  Xia as faGofore,
  Jia as faGolang,
  y71 as faGolfBall,
  k71 as faGolfBallTee,
  bg2 as faGolfClub,
  Sg2 as faGolfFlagHole,
  Zia as faGoodreads,
  xia as faGoodreadsG,
  a2a as faGoogle,
  n2a as faGoogleDrive,
  c2a as faGooglePay,
  o2a as faGooglePlay,
  d2a as faGooglePlus,
  s2a as faGooglePlusG,
  v2a as faGooglePlusSquare,
  m2a as faGoogleScholar,
  P2a as faGoogleWallet,
  j71 as faGopuram,
  T71 as faGraduationCap,
  yg2 as faGramophone,
  Og2 as faGrapes,
  kg2 as faGrate,
  Ag2 as faGrateDroplet,
  w2a as faGratipay,
  z2a as faGrav,
  H71 as faGreaterThan,
  U71 as faGreaterThanEqual,
  jg2 as faGrid,
  Bg2 as faGrid2,
  Tg2 as faGrid2Plus,
  Fg2 as faGrid3,
  Hg2 as faGrid4,
  Rg2 as faGrid5,
  Ug2 as faGridDividers,
  qg2 as faGridHorizontal,
  Gg2 as faGridRound,
  Wg2 as faGridRound2,
  Eg2 as faGridRound2Plus,
  Vg2 as faGridRound4,
  Ig2 as faGridRound5,
  Kg2 as faGrill,
  Xg2 as faGrillFire,
  Qg2 as faGrillHot,
  G71 as faGrimace,
  E71 as faGrin,
  I71 as faGrinAlt,
  X71 as faGrinBeam,
  J71 as faGrinBeamSweat,
  Z71 as faGrinHearts,
  x71 as faGrinSquint,
  at1 as faGrinSquintTears,
  nt1 as faGrinStars,
  ct1 as faGrinTears,
  ot1 as faGrinTongue,
  dt1 as faGrinTongueSquint,
  st1 as faGrinTongueWink,
  vt1 as faGrinWink,
  mt1 as faGrip,
  Jg2 as faGripDots,
  Yg2 as faGripDotsVertical,
  Pt1 as faGripHorizontal,
  wt1 as faGripLines,
  zt1 as faGripLinesVertical,
  Ct1 as faGripVertical,
  C2a as faGripfire,
  $t1 as faGroupArrowsRotate,
  $2a as faGrunt,
  bt1 as faGuaraniSign,
  b2a as faGuilded,
  yt1 as faGuitar,
  Zg2 as faGuitarElectric,
  pg2 as faGuitars,
  y2a as faGulp,
  kt1 as faGun,
  xg2 as faGunSlash,
  iP2 as faGunSquirt,
  jt1 as faH,
  aP2 as faH1,
  eP2 as faH2,
  nP2 as faH3,
  fP2 as faH4,
  cP2 as faH5,
  tP2 as faH6,
  Tt1 as faHSquare,
  k2a as faHackerNews,
  j2a as faHackerNewsSquare,
  T2a as faHackerrank,
  Ht1 as faHamburger,
  Ut1 as faHammer,
  oP2 as faHammerBrush,
  lP2 as faHammerCrash,
  dP2 as faHammerWar,
  Gt1 as faHamsa,
  Et1 as faHand,
  It1 as faHandBackFist,
  rP2 as faHandBackPointDown,
  sP2 as faHandBackPointLeft,
  hP2 as faHandBackPointRibbon,
  vP2 as faHandBackPointRight,
  uP2 as faHandBackPointUp,
  Xt1 as faHandDots,
  mP2 as faHandFingersCrossed,
  Jt1 as faHandFist,
  gP2 as faHandHeart,
  Zt1 as faHandHolding,
  PP2 as faHandHoldingBox,
  MP2 as faHandHoldingCircleDollar,
  xt1 as faHandHoldingDollar,
  ao1 as faHandHoldingDroplet,
  no1 as faHandHoldingHand,
  co1 as faHandHoldingHeart,
  wP2 as faHandHoldingMagic,
  oo1 as faHandHoldingMedical,
  NP2 as faHandHoldingSeedling,
  zP2 as faHandHoldingSkull,
  do1 as faHandHoldingUsd,
  so1 as faHandHoldingWater,
  LP2 as faHandHorns,
  vo1 as faHandLizard,
  CP2 as faHandLove,
  mo1 as faHandMiddleFinger,
  Po1 as faHandPaper,
  wo1 as faHandPeace,
  zo1 as faHandPointDown,
  Co1 as faHandPointLeft,
  DP2 as faHandPointRibbon,
  $o1 as faHandPointRight,
  bo1 as faHandPointUp,
  yo1 as faHandPointer,
  $P2 as faHandReceiving,
  ko1 as faHandRock,
  jo1 as faHandScissors,
  To1 as faHandSparkles,
  Ho1 as faHandSpock,
  _P2 as faHandWave,
  Uo1 as faHandcuffs,
  Go1 as faHands,
  Eo1 as faHandsAmericanSignLanguageInterpreting,
  Io1 as faHandsAslInterpreting,
  Xo1 as faHandsBound,
  Jo1 as faHandsBubbles,
  Zo1 as faHandsClapping,
  bP2 as faHandsHeart,
  xo1 as faHandsHelping,
  al1 as faHandsHolding,
  nl1 as faHandsHoldingChild,
  cl1 as faHandsHoldingCircle,
  SP2 as faHandsHoldingDiamond,
  yP2 as faHandsHoldingDollar,
  OP2 as faHandsHoldingHeart,
  ol1 as faHandsPraying,
  kP2 as faHandsUsd,
  dl1 as faHandsWash,
  sl1 as faHandshake,
  vl1 as faHandshakeAlt,
  ml1 as faHandshakeAltSlash,
  Pl1 as faHandshakeAngle,
  wl1 as faHandshakeSimple,
  zl1 as faHandshakeSimpleSlash,
  Cl1 as faHandshakeSlash,
  $l1 as faHanukiah,
  bl1 as faHardDrive,
  yl1 as faHardHat,
  kl1 as faHardOfHearing,
  H2a as faHashnode,
  jl1 as faHashtag,
  AP2 as faHashtagLock,
  jP2 as faHatBeach,
  BP2 as faHatChef,
  Tl1 as faHatCowboy,
  Hl1 as faHatCowboySide,
  Ul1 as faHatHard,
  TP2 as faHatSanta,
  FP2 as faHatWinter,
  HP2 as faHatWitch,
  Gl1 as faHatWizard,
  El1 as faHaykal,
  Il1 as faHdd,
  RP2 as faHeadSide,
  UP2 as faHeadSideBrain,
  Xl1 as faHeadSideCough,
  Jl1 as faHeadSideCoughSlash,
  qP2 as faHeadSideGear,
  GP2 as faHeadSideGoggles,
  WP2 as faHeadSideHeadphones,
  EP2 as faHeadSideHeart,
  Zl1 as faHeadSideMask,
  VP2 as faHeadSideMedical,
  xl1 as faHeadSideVirus,
  IP2 as faHeadVr,
  ad1 as faHeader,
  nd1 as faHeading,
  cd1 as faHeadphones,
  od1 as faHeadphonesAlt,
  dd1 as faHeadphonesSimple,
  sd1 as faHeadset,
  vd1 as faHeart,
  md1 as faHeartBroken,
  KP2 as faHeartCircle,
  Pd1 as faHeartCircleBolt,
  wd1 as faHeartCircleCheck,
  zd1 as faHeartCircleExclamation,
  Cd1 as faHeartCircleMinus,
  $d1 as faHeartCirclePlus,
  bd1 as faHeartCircleXmark,
  yd1 as faHeartCrack,
  XP2 as faHeartHalf,
  QP2 as faHeartHalfAlt,
  JP2 as faHeartHalfStroke,
  kd1 as faHeartMusicCameraBolt,
  jd1 as faHeartPulse,
  YP2 as faHeartRate,
  ZP2 as faHeartSquare,
  Td1 as faHeartbeat,
  pP2 as faHeat,
  Hd1 as faHelicopter,
  Ud1 as faHelicopterSymbol,
  xP2 as faHelmetBattle,
  Gd1 as faHelmetSafety,
  Ed1 as faHelmetUn,
  iM2 as faHexagon,
  aM2 as faHexagonCheck,
  eM2 as faHexagonDivide,
  nM2 as faHexagonExclamation,
  fM2 as faHexagonImage,
  cM2 as faHexagonMinus,
  tM2 as faHexagonPlus,
  oM2 as faHexagonVerticalNft,
  lM2 as faHexagonVerticalNftSlanted,
  dM2 as faHexagonXmark,
  rM2 as faHighDefinition,
  Id1 as faHighlighter,
  sM2 as faHighlighterLine,
  Xd1 as faHiking,
  Jd1 as faHillAvalanche,
  Zd1 as faHillRockslide,
  xd1 as faHippo,
  U2a as faHips,
  G2a as faHireAHelper,
  ar1 as faHistory,
  E2a as faHive,
  hM2 as faHockeyMask,
  nr1 as faHockeyPuck,
  vM2 as faHockeyStickPuck,
  uM2 as faHockeySticks,
  cr1 as faHollyBerry,
  or1 as faHome,
  dr1 as faHomeAlt,
  mM2 as faHomeBlank,
  gM2 as faHomeHeart,
  sr1 as faHomeLg,
  vr1 as faHomeLgAlt,
  mr1 as faHomeUser,
  PM2 as faHoneyPot,
  MM2 as faHoodCloak,
  I2a as faHooli,
  wM2 as faHorizontalRule,
  X2a as faHornbill,
  Pr1 as faHorse,
  wr1 as faHorseHead,
  NM2 as faHorseSaddle,
  zM2 as faHose,
  LM2 as faHoseReel,
  zr1 as faHospital,
  Cr1 as faHospitalAlt,
  $r1 as faHospitalSymbol,
  br1 as faHospitalUser,
  yr1 as faHospitalWide,
  CM2 as faHospitals,
  kr1 as faHotTub,
  jr1 as faHotTubPerson,
  Tr1 as faHotdog,
  Hr1 as faHotel,
  J2a as faHotjar,
  Ur1 as faHourglass,
  Gr1 as faHourglass1,
  Er1 as faHourglass2,
  Ir1 as faHourglass3,
  DM2 as faHourglassClock,
  Xr1 as faHourglassEmpty,
  Jr1 as faHourglassEnd,
  Zr1 as faHourglassHalf,
  xr1 as faHourglassStart,
  a91 as faHouse,
  $M2 as faHouseBlank,
  _M2 as faHouseBuilding,
  n91 as faHouseChimney,
  bM2 as faHouseChimneyBlank,
  c91 as faHouseChimneyCrack,
  SM2 as faHouseChimneyHeart,
  o91 as faHouseChimneyMedical,
  d91 as faHouseChimneyUser,
  s91 as faHouseChimneyWindow,
  v91 as faHouseCircleCheck,
  m91 as faHouseCircleExclamation,
  P91 as faHouseCircleXmark,
  w91 as faHouseCrack,
  z91 as faHouseDamage,
  yM2 as faHouseDay,
  C91 as faHouseFire,
  $91 as faHouseFlag,
  OM2 as faHouseFlood,
  b91 as faHouseFloodWater,
  y91 as faHouseFloodWaterCircleArrowRight,
  kM2 as faHouseHeart,
  k91 as faHouseLaptop,
  AM2 as faHouseLeave,
  j91 as faHouseLock,
  T91 as faHouseMedical,
  H91 as faHouseMedicalCircleCheck,
  U91 as faHouseMedicalCircleExclamation,
  G91 as faHouseMedicalCircleXmark,
  E91 as faHouseMedicalFlag,
  jM2 as faHouseNight,
  BM2 as faHousePersonArrive,
  TM2 as faHousePersonDepart,
  FM2 as faHousePersonLeave,
  HM2 as faHousePersonReturn,
  RM2 as faHouseReturn,
  I91 as faHouseSignal,
  UM2 as faHouseTree,
  X91 as faHouseTsunami,
  qM2 as faHouseTurret,
  J91 as faHouseUser,
  GM2 as faHouseWater,
  WM2 as faHouseWindow,
  Z2a as faHouzz,
  Z91 as faHryvnia,
  x91 as faHryvniaSign,
  x2a as faHtml5,
  a1a as faHubspot,
  EM2 as faHumidity,
  VM2 as faHundredPoints,
  as1 as faHurricane,
  IM2 as faHydra,
  KM2 as faHyphen,
  ns1 as faI,
  cs1 as faICursor,
  os1 as faIceCream,
  XM2 as faIceSkate,
  ds1 as faIcicles,
  ss1 as faIcons,
  QM2 as faIconsAlt,
  vs1 as faIdBadge,
  ms1 as faIdCard,
  Ps1 as faIdCardAlt,
  ws1 as faIdCardClip,
  n1a as faIdeal,
  zs1 as faIgloo,
  Cs1 as faIls,
  $s1 as faImage,
  JM2 as faImageLandscape,
  YM2 as faImagePolaroid,
  ZM2 as faImagePolaroidUser,
  bs1 as faImagePortrait,
  pM2 as faImageSlash,
  xM2 as faImageUser,
  ys1 as faImages,
  iw2 as faImagesUser,
  c1a as faImdb,
  ks1 as faInbox,
  aw2 as faInboxArrowDown,
  ew2 as faInboxArrowUp,
  nw2 as faInboxFull,
  fw2 as faInboxIn,
  cw2 as faInboxOut,
  tw2 as faInboxes,
  js1 as faIndent,
  Ts1 as faIndianRupee,
  Hs1 as faIndianRupeeSign,
  Us1 as faIndustry,
  ow2 as faIndustryAlt,
  lw2 as faIndustryWindows,
  Gs1 as faInfinity,
  Es1 as faInfo,
  Is1 as faInfoCircle,
  dw2 as faInfoSquare,
  rw2 as faInhaler,
  o1a as faInnosoft,
  sw2 as faInputNumeric,
  hw2 as faInputPipe,
  vw2 as faInputText,
  Xs1 as faInr,
  d1a as faInstagram,
  s1a as faInstagramSquare,
  v1a as faInstalod,
  Js1 as faInstitution,
  uw2 as faIntegral,
  m1a as faIntercom,
  P1a as faInternetExplorer,
  mw2 as faInterrobang,
  gw2 as faIntersection,
  Pw2 as faInventory,
  w1a as faInvision,
  z1a as faIoxhost,
  Mw2 as faIslandTreePalm,
  ww2 as faIslandTropical,
  Zs1 as faItalic,
  C1a as faItchIo,
  $1a as faItunes,
  b1a as faItunesNote,
  xs1 as faJ,
  Nw2 as faJackOLantern,
  ah1 as faJar,
  nh1 as faJarWheat,
  y1a as faJava,
  ch1 as faJedi,
  k1a as faJediOrder,
  j1a as faJenkins,
  oh1 as faJetFighter,
  dh1 as faJetFighterUp,
  T1a as faJira,
  H1a as faJoget,
  sh1 as faJoint,
  U1a as faJoomla,
  vh1 as faJournalWhills,
  zw2 as faJoystick,
  mh1 as faJpy,
  G1a as faJs,
  E1a as faJsSquare,
  I1a as faJsfiddle,
  Lw2 as faJug,
  Cw2 as faJugBottle,
  Ph1 as faJugDetergent,
  X1a as faJxl,
  wh1 as faK,
  zh1 as faKaaba,
  J1a as faKaggle,
  Dw2 as faKazoo,
  $w2 as faKerning,
  Ch1 as faKey,
  _w2 as faKeySkeleton,
  bw2 as faKeySkeletonLeftRight,
  Z1a as faKeybase,
  $h1 as faKeyboard,
  Sw2 as faKeyboardBrightness,
  yw2 as faKeyboardBrightnessLow,
  Ow2 as faKeyboardDown,
  kw2 as faKeyboardLeft,
  x1a as faKeycdn,
  Aw2 as faKeynote,
  bh1 as faKhanda,
  aaa as faKickstarter,
  naa as faKickstarterK,
  jw2 as faKidneys,
  yh1 as faKipSign,
  kh1 as faKiss,
  jh1 as faKissBeam,
  Th1 as faKissWinkHeart,
  Hh1 as faKitMedical,
  Uh1 as faKitchenSet,
  Bw2 as faKite,
  Gh1 as faKiwiBird,
  Tw2 as faKiwiFruit,
  Fw2 as faKnife,
  Hw2 as faKnifeKitchen,
  caa as faKorvue,
  Eh1 as faKrw,
  Ih1 as faL,
  Rw2 as faLacrosseStick,
  Uw2 as faLacrosseStickBall,
  Xh1 as faLadderWater,
  qw2 as faLambda,
  Gw2 as faLamp,
  Ww2 as faLampDesk,
  Ew2 as faLampFloor,
  Vw2 as faLampStreet,
  Jh1 as faLandMineOn,
  Zh1 as faLandmark,
  xh1 as faLandmarkAlt,
  av1 as faLandmarkDome,
  nv1 as faLandmarkFlag,
  Iw2 as faLandmarkMagnifyingGlass,
  Kw2 as faLandscape,
  cv1 as faLanguage,
  ov1 as faLaptop,
  Xw2 as faLaptopArrowDown,
  Qw2 as faLaptopBinary,
  dv1 as faLaptopCode,
  sv1 as faLaptopFile,
  vv1 as faLaptopHouse,
  mv1 as faLaptopMedical,
  Jw2 as faLaptopMobile,
  Yw2 as faLaptopSlash,
  oaa as faLaravel,
  Pv1 as faLariSign,
  Zw2 as faLasso,
  pw2 as faLassoSparkles,
  daa as faLastfm,
  saa as faLastfmSquare,
  wv1 as faLaugh,
  zv1 as faLaughBeam,
  Cv1 as faLaughSquint,
  $v1 as faLaughWink,
  bv1 as faLayerGroup,
  xw2 as faLayerGroupMinus,
  iN2 as faLayerGroupPlus,
  aN2 as faLayerMinus,
  eN2 as faLayerPlus,
  yv1 as faLeaf,
  nN2 as faLeafHeart,
  fN2 as faLeafMaple,
  cN2 as faLeafOak,
  tN2 as faLeafyGreen,
  vaa as faLeanpub,
  oN2 as faLeft,
  lN2 as faLeftFromBracket,
  dN2 as faLeftFromLine,
  kv1 as faLeftLong,
  rN2 as faLeftLongToLine,
  jv1 as faLeftRight,
  sN2 as faLeftToBracket,
  hN2 as faLeftToLine,
  Tv1 as faLegal,
  Hv1 as faLemon,
  maa as faLess,
  Uv1 as faLessThan,
  Gv1 as faLessThanEqual,
  Paa as faLetterboxd,
  Ev1 as faLevelDown,
  Iv1 as faLevelDownAlt,
  Xv1 as faLevelUp,
  Jv1 as faLevelUpAlt,
  Zv1 as faLifeRing,
  vN2 as faLightCeiling,
  uN2 as faLightEmergency,
  mN2 as faLightEmergencyOn,
  gN2 as faLightSwitch,
  PN2 as faLightSwitchOff,
  MN2 as faLightSwitchOn,
  xv1 as faLightbulb,
  wN2 as faLightbulbCfl,
  NN2 as faLightbulbCflOn,
  zN2 as faLightbulbDollar,
  LN2 as faLightbulbExclamation,
  CN2 as faLightbulbExclamationOn,
  DN2 as faLightbulbGear,
  $N2 as faLightbulbMessage,
  _N2 as faLightbulbOn,
  bN2 as faLightbulbSlash,
  SN2 as faLighthouse,
  yN2 as faLightsHoliday,
  waa as faLine,
  au1 as faLineChart,
  ON2 as faLineColumns,
  kN2 as faLineHeight,
  nu1 as faLinesLeaning,
  cu1 as faLink,
  AN2 as faLinkHorizontal,
  jN2 as faLinkHorizontalSlash,
  BN2 as faLinkSimple,
  TN2 as faLinkSimpleSlash,
  ou1 as faLinkSlash,
  zaa as faLinkedin,
  Caa as faLinkedinIn,
  $aa as faLinode,
  baa as faLinux,
  FN2 as faLips,
  du1 as faLiraSign,
  su1 as faList,
  vu1 as faList12,
  mu1 as faListAlt,
  Pu1 as faListCheck,
  wu1 as faListDots,
  HN2 as faListDropdown,
  RN2 as faListMusic,
  zu1 as faListNumeric,
  Cu1 as faListOl,
  UN2 as faListRadio,
  $u1 as faListSquares,
  qN2 as faListTimeline,
  GN2 as faListTree,
  bu1 as faListUl,
  yu1 as faLitecoinSign,
  WN2 as faLoader,
  EN2 as faLobster,
  ku1 as faLocation,
  ju1 as faLocationArrow,
  VN2 as faLocationArrowUp,
  IN2 as faLocationCheck,
  KN2 as faLocationCircle,
  Tu1 as faLocationCrosshairs,
  XN2 as faLocationCrosshairsSlash,
  Hu1 as faLocationDot,
  QN2 as faLocationDotSlash,
  JN2 as faLocationExclamation,
  YN2 as faLocationMinus,
  ZN2 as faLocationPen,
  Uu1 as faLocationPin,
  Gu1 as faLocationPinLock,
  pN2 as faLocationPinSlash,
  xN2 as faLocationPlus,
  iz2 as faLocationQuestion,
  az2 as faLocationSlash,
  ez2 as faLocationSmile,
  nz2 as faLocationXmark,
  Eu1 as faLock,
  fz2 as faLockA,
  cz2 as faLockAlt,
  tz2 as faLockHashtag,
  oz2 as faLockKeyhole,
  lz2 as faLockKeyholeOpen,
  Iu1 as faLockOpen,
  dz2 as faLockOpenAlt,
  Xu1 as faLocust,
  rz2 as faLollipop,
  sz2 as faLollypop,
  Ju1 as faLongArrowAltDown,
  Zu1 as faLongArrowAltLeft,
  xu1 as faLongArrowAltRight,
  am1 as faLongArrowAltUp,
  nm1 as faLongArrowDown,
  cm1 as faLongArrowLeft,
  om1 as faLongArrowRight,
  dm1 as faLongArrowUp,
  hz2 as faLoveseat,
  sm1 as faLowVision,
  vz2 as faLuchador,
  uz2 as faLuchadorMask,
  vm1 as faLuggageCart,
  mm1 as faLungs,
  Pm1 as faLungsVirus,
  yaa as faLyft,
  wm1 as faM,
  mz2 as faMace,
  kaa as faMagento,
  zm1 as faMagic,
  Cm1 as faMagicWandSparkles,
  $m1 as faMagnet,
  bm1 as faMagnifyingGlass,
  ym1 as faMagnifyingGlassArrowRight,
  gz2 as faMagnifyingGlassArrowsRotate,
  km1 as faMagnifyingGlassChart,
  jm1 as faMagnifyingGlassDollar,
  Tm1 as faMagnifyingGlassLocation,
  Hm1 as faMagnifyingGlassMinus,
  Pz2 as faMagnifyingGlassMusic,
  Mz2 as faMagnifyingGlassPlay,
  Um1 as faMagnifyingGlassPlus,
  wz2 as faMagnifyingGlassWaveform,
  Gm1 as faMailBulk,
  Em1 as faMailForward,
  Im1 as faMailReply,
  Xm1 as faMailReplyAll,
  Nz2 as faMailbox,
  zz2 as faMailboxFlagUp,
  jaa as faMailchimp,
  Lz2 as faMakiRoll,
  Cz2 as faMakizushi,
  Jm1 as faMale,
  Zm1 as faManatSign,
  Taa as faMandalorian,
  Dz2 as faMandolin,
  $z2 as faMango,
  _z2 as faManhole,
  xm1 as faMap,
  ag1 as faMapLocation,
  ng1 as faMapLocationDot,
  cg1 as faMapMarked,
  og1 as faMapMarkedAlt,
  dg1 as faMapMarker,
  sg1 as faMapMarkerAlt,
  bz2 as faMapMarkerAltSlash,
  Sz2 as faMapMarkerCheck,
  yz2 as faMapMarkerEdit,
  Oz2 as faMapMarkerExclamation,
  kz2 as faMapMarkerMinus,
  Az2 as faMapMarkerPlus,
  jz2 as faMapMarkerQuestion,
  Bz2 as faMapMarkerSlash,
  Tz2 as faMapMarkerSmile,
  Fz2 as faMapMarkerTimes,
  Hz2 as faMapMarkerXmark,
  vg1 as faMapPin,
  mg1 as faMapSigns,
  Haa as faMarkdown,
  Pg1 as faMarker,
  wg1 as faMars,
  zg1 as faMarsAndVenus,
  Cg1 as faMarsAndVenusBurst,
  $g1 as faMarsDouble,
  bg1 as faMarsStroke,
  yg1 as faMarsStrokeH,
  kg1 as faMarsStrokeRight,
  jg1 as faMarsStrokeUp,
  Tg1 as faMarsStrokeV,
  Hg1 as faMartiniGlass,
  Ug1 as faMartiniGlassCitrus,
  Gg1 as faMartiniGlassEmpty,
  Eg1 as faMask,
  Ig1 as faMaskFace,
  Rz2 as faMaskLuchador,
  Uz2 as faMaskSnorkel,
  Xg1 as faMaskVentilator,
  Jg1 as faMasksTheater,
  Uaa as faMastodon,
  Zg1 as faMattressPillow,
  Gaa as faMaxcdn,
  xg1 as faMaximize,
  Eaa as faMdb,
  qz2 as faMeat,
  aP1 as faMedal,
  Iaa as faMedapps,
  Xaa as faMedium,
  Jaa as faMediumM,
  nP1 as faMedkit,
  Zaa as faMedrt,
  xaa as faMeetup,
  Gz2 as faMegaphone,
  a4a as faMegaport,
  cP1 as faMeh,
  oP1 as faMehBlank,
  dP1 as faMehRollingEyes,
  Wz2 as faMelon,
  Ez2 as faMelonSlice,
  Vz2 as faMemo,
  Iz2 as faMemoCircleCheck,
  Kz2 as faMemoCircleInfo,
  Xz2 as faMemoPad,
  sP1 as faMemory,
  n4a as faMendeley,
  vP1 as faMenorah,
  mP1 as faMercury,
  Qz2 as faMerge,
  PP1 as faMessage,
  Jz2 as faMessageArrowDown,
  Yz2 as faMessageArrowUp,
  Zz2 as faMessageArrowUpRight,
  pz2 as faMessageBot,
  xz2 as faMessageCaptions,
  iL2 as faMessageCheck,
  aL2 as faMessageCode,
  eL2 as faMessageDollar,
  nL2 as faMessageDots,
  fL2 as faMessageEdit,
  cL2 as faMessageExclamation,
  tL2 as faMessageHeart,
  oL2 as faMessageImage,
  lL2 as faMessageLines,
  dL2 as faMessageMedical,
  rL2 as faMessageMiddle,
  sL2 as faMessageMiddleTop,
  hL2 as faMessageMinus,
  vL2 as faMessageMusic,
  uL2 as faMessagePen,
  mL2 as faMessagePlus,
  gL2 as faMessageQuestion,
  PL2 as faMessageQuote,
  ML2 as faMessageSlash,
  wL2 as faMessageSmile,
  NL2 as faMessageSms,
  zL2 as faMessageText,
  LL2 as faMessageTimes,
  CL2 as faMessageXmark,
  DL2 as faMessages,
  $L2 as faMessagesDollar,
  _L2 as faMessagesQuestion,
  bL2 as faMessaging,
  c4a as faMeta,
  wP1 as faMeteor,
  SL2 as faMeter,
  yL2 as faMeterBolt,
  OL2 as faMeterDroplet,
  kL2 as faMeterFire,
  o4a as faMicroblog,
  zP1 as faMicrochip,
  AL2 as faMicrochipAi,
  CP1 as faMicrophone,
  $P1 as faMicrophoneAlt,
  bP1 as faMicrophoneAltSlash,
  jL2 as faMicrophoneCircle,
  BL2 as faMicrophoneCircleAlt,
  yP1 as faMicrophoneLines,
  kP1 as faMicrophoneLinesSlash,
  jP1 as faMicrophoneSlash,
  TL2 as faMicrophoneStand,
  TP1 as faMicroscope,
  d4a as faMicrosoft,
  FL2 as faMicrowave,
  HP1 as faMillSign,
  HL2 as faMindShare,
  UP1 as faMinimize,
  s4a as faMintbit,
  GP1 as faMinus,
  EP1 as faMinusCircle,
  RL2 as faMinusHexagon,
  UL2 as faMinusLarge,
  qL2 as faMinusOctagon,
  IP1 as faMinusSquare,
  GL2 as faMistletoe,
  XP1 as faMitten,
  v4a as faMix,
  m4a as faMixcloud,
  P4a as faMixer,
  w4a as faMizuni,
  JP1 as faMobile,
  ZP1 as faMobileAlt,
  xP1 as faMobileAndroid,
  aM1 as faMobileAndroidAlt,
  nM1 as faMobileButton,
  WL2 as faMobileIphone,
  EL2 as faMobileNotch,
  cM1 as faMobilePhone,
  oM1 as faMobileRetro,
  dM1 as faMobileScreen,
  sM1 as faMobileScreenButton,
  VL2 as faMobileSignal,
  IL2 as faMobileSignalOut,
  z4a as faModx,
  C4a as faMonero,
  vM1 as faMoneyBill,
  mM1 as faMoneyBill1,
  PM1 as faMoneyBill1Wave,
  wM1 as faMoneyBillAlt,
  KL2 as faMoneyBillSimple,
  XL2 as faMoneyBillSimpleWave,
  zM1 as faMoneyBillTransfer,
  CM1 as faMoneyBillTrendUp,
  $M1 as faMoneyBillWave,
  bM1 as faMoneyBillWaveAlt,
  yM1 as faMoneyBillWheat,
  kM1 as faMoneyBills,
  QL2 as faMoneyBillsAlt,
  JL2 as faMoneyBillsSimple,
  jM1 as faMoneyCheck,
  TM1 as faMoneyCheckAlt,
  HM1 as faMoneyCheckDollar,
  YL2 as faMoneyCheckDollarPen,
  ZL2 as faMoneyCheckEdit,
  pL2 as faMoneyCheckEditAlt,
  xL2 as faMoneyCheckPen,
  iC2 as faMoneyFromBracket,
  aC2 as faMoneySimpleFromBracket,
  eC2 as faMonitorHeartRate,
  nC2 as faMonitorWaveform,
  fC2 as faMonkey,
  UM1 as faMonument,
  GM1 as faMoon,
  cC2 as faMoonCloud,
  tC2 as faMoonOverSun,
  oC2 as faMoonStars,
  lC2 as faMoped,
  EM1 as faMortarBoard,
  IM1 as faMortarPestle,
  XM1 as faMosque,
  JM1 as faMosquito,
  ZM1 as faMosquitoNet,
  xM1 as faMotorcycle,
  aw1 as faMound,
  nw1 as faMountain,
  cw1 as faMountainCity,
  ow1 as faMountainSun,
  dC2 as faMountains,
  dw1 as faMouse,
  rC2 as faMouseAlt,
  sC2 as faMouseField,
  sw1 as faMousePointer,
  hC2 as faMp3Player,
  vC2 as faMug,
  vw1 as faMugHot,
  uC2 as faMugMarshmallows,
  mw1 as faMugSaucer,
  mC2 as faMugTea,
  gC2 as faMugTeaSaucer,
  Pw1 as faMultiply,
  ww1 as faMuseum,
  PC2 as faMushroom,
  zw1 as faMusic,
  MC2 as faMusicAlt,
  wC2 as faMusicAltSlash,
  NC2 as faMusicMagnifyingGlass,
  zC2 as faMusicNote,
  LC2 as faMusicNoteSlash,
  CC2 as faMusicSlash,
  DC2 as faMustache,
  Cw1 as faN,
  $w1 as faNairaSign,
  $4a as faNapster,
  $C2 as faNarwhal,
  bw1 as faNavicon,
  b4a as faNeos,
  _C2 as faNestingDolls,
  yw1 as faNetworkWired,
  kw1 as faNeuter,
  jw1 as faNewspaper,
  bC2 as faNfc,
  y4a as faNfcDirectional,
  SC2 as faNfcLock,
  yC2 as faNfcMagnifyingGlass,
  OC2 as faNfcPen,
  kC2 as faNfcSignal,
  AC2 as faNfcSlash,
  k4a as faNfcSymbol,
  jC2 as faNfcTrash,
  BC2 as faNigiri,
  j4a as faNimblr,
  T4a as faNode,
  H4a as faNodeJs,
  TC2 as faNose,
  Tw1 as faNotEqual,
  Hw1 as faNotdef,
  FC2 as faNote,
  HC2 as faNoteMedical,
  Uw1 as faNoteSticky,
  RC2 as faNotebook,
  UC2 as faNotes,
  Gw1 as faNotesMedical,
  U4a as faNpm,
  G4a as faNs8,
  E4a as faNutritionix,
  Ew1 as faO,
  qC2 as faObjectExclude,
  Iw1 as faObjectGroup,
  GC2 as faObjectIntersect,
  WC2 as faObjectSubtract,
  Xw1 as faObjectUngroup,
  EC2 as faObjectUnion,
  VC2 as faObjectsAlignBottom,
  IC2 as faObjectsAlignCenterHorizontal,
  KC2 as faObjectsAlignCenterVertical,
  XC2 as faObjectsAlignLeft,
  QC2 as faObjectsAlignRight,
  JC2 as faObjectsAlignTop,
  YC2 as faObjectsColumn,
  ZC2 as faOctagon,
  pC2 as faOctagonCheck,
  xC2 as faOctagonDivide,
  iD2 as faOctagonExclamation,
  aD2 as faOctagonMinus,
  eD2 as faOctagonPlus,
  nD2 as faOctagonXmark,
  fD2 as faOctopus,
  I4a as faOctopusDeploy,
  X4a as faOdnoklassniki,
  J4a as faOdnoklassnikiSquare,
  Z4a as faOdysee,
  Jw1 as faOilCan,
  cD2 as faOilCanDrip,
  tD2 as faOilTemp,
  oD2 as faOilTemperature,
  Zw1 as faOilWell,
  x4a as faOldRepublic,
  lD2 as faOlive,
  dD2 as faOliveBranch,
  xw1 as faOm,
  rD2 as faOmega,
  sD2 as faOnion,
  a3a as faOpencart,
  n3a as faOpenid,
  c3a as faOpensuse,
  o3a as faOpera,
  d3a as faOptinMonster,
  hD2 as faOption,
  s3a as faOrcid,
  vD2 as faOrnament,
  v3a as faOsi,
  aN1 as faOtter,
  nN1 as faOutdent,
  uD2 as faOutlet,
  mD2 as faOven,
  gD2 as faOverline,
  cN1 as faP,
  m3a as faPadlet,
  PD2 as faPage,
  P3a as faPage4,
  MD2 as faPageBreak,
  wD2 as faPageCaretDown,
  ND2 as faPageCaretUp,
  w3a as faPagelines,
  oN1 as faPager,
  zD2 as faPaintBrushAlt,
  dN1 as faPaintRoller,
  sN1 as faPaintbrush,
  LD2 as faPaintbrushFine,
  CD2 as faPaintbrushPencil,
  vN1 as faPalette,
  DD2 as faPaletteBoxes,
  z3a as faPalfed,
  mN1 as faPallet,
  $D2 as faPalletAlt,
  _D2 as faPalletBox,
  bD2 as faPalletBoxes,
  SD2 as faPanFood,
  yD2 as faPanFrying,
  OD2 as faPancakes,
  kD2 as faPanelEws,
  AD2 as faPanelFire,
  PN1 as faPanorama,
  wN1 as faPaperPlane,
  jD2 as faPaperPlaneAlt,
  BD2 as faPaperPlaneTop,
  zN1 as faPaperclip,
  TD2 as faPaperclipVertical,
  CN1 as faParachuteBox,
  $N1 as faParagraph,
  FD2 as faParagraphLeft,
  HD2 as faParagraphRtl,
  RD2 as faParentheses,
  UD2 as faParenthesis,
  bN1 as faParking,
  qD2 as faParkingCircle,
  GD2 as faParkingCircleSlash,
  WD2 as faParkingSlash,
  ED2 as faPartyBack,
  VD2 as faPartyBell,
  ID2 as faPartyHorn,
  yN1 as faPassport,
  kN1 as faPastafarianism,
  jN1 as faPaste,
  C3a as faPatreon,
  TN1 as faPause,
  HN1 as faPauseCircle,
  UN1 as faPaw,
  KD2 as faPawAlt,
  XD2 as faPawClaws,
  QD2 as faPawSimple,
  $3a as faPaypal,
  GN1 as faPeace,
  JD2 as faPeach,
  YD2 as faPeanut,
  ZD2 as faPeanuts,
  pD2 as faPeapod,
  xD2 as faPear,
  i$2 as faPedestal,
  a$2 as faPegasus,
  EN1 as faPen,
  IN1 as faPenAlt,
  e$2 as faPenAltSlash,
  n$2 as faPenCircle,
  XN1 as faPenClip,
  f$2 as faPenClipSlash,
  JN1 as faPenFancy,
  c$2 as faPenFancySlash,
  t$2 as faPenField,
  o$2 as faPenLine,
  ZN1 as faPenNib,
  l$2 as faPenNibSlash,
  d$2 as faPenPaintbrush,
  xN1 as faPenRuler,
  r$2 as faPenSlash,
  az1 as faPenSquare,
  s$2 as faPenSwirl,
  nz1 as faPenToSquare,
  cz1 as faPencil,
  oz1 as faPencilAlt,
  h$2 as faPencilMechanical,
  v$2 as faPencilPaintbrush,
  dz1 as faPencilRuler,
  u$2 as faPencilSlash,
  sz1 as faPencilSquare,
  m$2 as faPennant,
  g$2 as faPeople,
  vz1 as faPeopleArrows,
  mz1 as faPeopleArrowsLeftRight,
  Pz1 as faPeopleCarry,
  wz1 as faPeopleCarryBox,
  P$2 as faPeopleDress,
  M$2 as faPeopleDressSimple,
  zz1 as faPeopleGroup,
  Cz1 as faPeopleLine,
  w$2 as faPeoplePants,
  N$2 as faPeoplePantsSimple,
  $z1 as faPeoplePulling,
  bz1 as faPeopleRobbery,
  yz1 as faPeopleRoof,
  z$2 as faPeopleSimple,
  L$2 as faPepper,
  kz1 as faPepperHot,
  b3a as faPerbyte,
  jz1 as faPercent,
  Tz1 as faPercentage,
  C$2 as faPeriod,
  y3a as faPeriscope,
  Hz1 as faPerson,
  Uz1 as faPersonArrowDownToLine,
  Gz1 as faPersonArrowUpFromLine,
  Ez1 as faPersonBiking,
  D$2 as faPersonBikingMountain,
  Iz1 as faPersonBooth,
  Xz1 as faPersonBreastfeeding,
  Jz1 as faPersonBurst,
  Zz1 as faPersonCane,
  $$2 as faPersonCarry,
  _$2 as faPersonCarryBox,
  xz1 as faPersonChalkboard,
  aL1 as faPersonCircleCheck,
  nL1 as faPersonCircleExclamation,
  cL1 as faPersonCircleMinus,
  oL1 as faPersonCirclePlus,
  dL1 as faPersonCircleQuestion,
  sL1 as faPersonCircleXmark,
  vL1 as faPersonDigging,
  b$2 as faPersonDolly,
  S$2 as faPersonDollyEmpty,
  mL1 as faPersonDotsFromLine,
  PL1 as faPersonDress,
  wL1 as faPersonDressBurst,
  y$2 as faPersonDressFairy,
  O$2 as faPersonDressSimple,
  zL1 as faPersonDrowning,
  k$2 as faPersonFairy,
  CL1 as faPersonFalling,
  $L1 as faPersonFallingBurst,
  A$2 as faPersonFromPortal,
  bL1 as faPersonHalfDress,
  yL1 as faPersonHarassing,
  kL1 as faPersonHiking,
  jL1 as faPersonMilitaryPointing,
  TL1 as faPersonMilitaryRifle,
  HL1 as faPersonMilitaryToPerson,
  j$2 as faPersonPinball,
  UL1 as faPersonPraying,
  GL1 as faPersonPregnant,
  EL1 as faPersonRays,
  IL1 as faPersonRifle,
  XL1 as faPersonRunning,
  B$2 as faPersonRunningFast,
  T$2 as faPersonSeat,
  F$2 as faPersonSeatReclined,
  JL1 as faPersonShelter,
  H$2 as faPersonSign,
  R$2 as faPersonSimple,
  ZL1 as faPersonSkating,
  U$2 as faPersonSkiJumping,
  q$2 as faPersonSkiLift,
  xL1 as faPersonSkiing,
  aC1 as faPersonSkiingNordic,
  G$2 as faPersonSledding,
  nC1 as faPersonSnowboarding,
  W$2 as faPersonSnowmobiling,
  cC1 as faPersonSwimming,
  oC1 as faPersonThroughWindow,
  E$2 as faPersonToDoor,
  V$2 as faPersonToPortal,
  dC1 as faPersonWalking,
  sC1 as faPersonWalkingArrowLoopLeft,
  vC1 as faPersonWalkingArrowRight,
  mC1 as faPersonWalkingDashedLineArrowRight,
  PC1 as faPersonWalkingLuggage,
  wC1 as faPersonWalkingWithCane,
  zC1 as faPesetaSign,
  CC1 as faPesoSign,
  k3a as faPhabricator,
  j3a as faPhoenixFramework,
  T3a as faPhoenixSquadron,
  $C1 as faPhone,
  bC1 as faPhoneAlt,
  I$2 as faPhoneArrowDown,
  K$2 as faPhoneArrowDownLeft,
  X$2 as faPhoneArrowRight,
  Q$2 as faPhoneArrowUp,
  J$2 as faPhoneArrowUpRight,
  Y$2 as faPhoneCircle,
  Z$2 as faPhoneCircleAlt,
  p$2 as faPhoneCircleDown,
  yC1 as faPhoneFlip,
  x$2 as faPhoneHangup,
  i_2 as faPhoneIncoming,
  a_2 as faPhoneIntercom,
  e_2 as faPhoneLaptop,
  n_2 as faPhoneMissed,
  f_2 as faPhoneOffice,
  c_2 as faPhoneOutgoing,
  t_2 as faPhonePlus,
  o_2 as faPhoneRotary,
  kC1 as faPhoneSlash,
  jC1 as faPhoneSquare,
  TC1 as faPhoneSquareAlt,
  l_2 as faPhoneSquareDown,
  HC1 as faPhoneVolume,
  d_2 as faPhoneXmark,
  UC1 as faPhotoFilm,
  r_2 as faPhotoFilmMusic,
  GC1 as faPhotoVideo,
  H3a as faPhp,
  s_2 as faPi,
  h_2 as faPiano,
  v_2 as faPianoKeyboard,
  u_2 as faPickaxe,
  m_2 as faPickleball,
  g_2 as faPie,
  EC1 as faPieChart,
  U3a as faPiedPiper,
  G3a as faPiedPiperAlt,
  E3a as faPiedPiperHat,
  I3a as faPiedPiperPp,
  X3a as faPiedPiperSquare,
  P_2 as faPig,
  IC1 as faPiggyBank,
  XC1 as faPills,
  M_2 as faPinata,
  w_2 as faPinball,
  N_2 as faPineapple,
  JC1 as faPingPongPaddleBall,
  J3a as faPinterest,
  Z3a as faPinterestP,
  x3a as faPinterestSquare,
  z_2 as faPipe,
  L_2 as faPipeCircleCheck,
  C_2 as faPipeCollar,
  D_2 as faPipeSection,
  $_2 as faPipeSmoking,
  __2 as faPipeValve,
  a0a as faPix,
  n0a as faPixiv,
  b_2 as faPizza,
  ZC1 as faPizzaSlice,
  xC1 as faPlaceOfWorship,
  aD1 as faPlane,
  S_2 as faPlaneAlt,
  nD1 as faPlaneArrival,
  cD1 as faPlaneCircleCheck,
  oD1 as faPlaneCircleExclamation,
  dD1 as faPlaneCircleXmark,
  sD1 as faPlaneDeparture,
  y_2 as faPlaneEngines,
  vD1 as faPlaneLock,
  O_2 as faPlaneProp,
  mD1 as faPlaneSlash,
  k_2 as faPlaneTail,
  PD1 as faPlaneUp,
  A_2 as faPlaneUpSlash,
  j_2 as faPlanetMoon,
  B_2 as faPlanetRinged,
  wD1 as faPlantWilt,
  T_2 as faPlateUtensils,
  zD1 as faPlateWheat,
  CD1 as faPlay,
  $D1 as faPlayCircle,
  F_2 as faPlayPause,
  c0a as faPlaystation,
  bD1 as faPlug,
  yD1 as faPlugCircleBolt,
  kD1 as faPlugCircleCheck,
  jD1 as faPlugCircleExclamation,
  TD1 as faPlugCircleMinus,
  HD1 as faPlugCirclePlus,
  UD1 as faPlugCircleXmark,
  GD1 as faPlus,
  ED1 as faPlusCircle,
  H_2 as faPlusHexagon,
  R_2 as faPlusLarge,
  ID1 as faPlusMinus,
  U_2 as faPlusOctagon,
  XD1 as faPlusSquare,
  JD1 as faPodcast,
  q_2 as faPodium,
  G_2 as faPodiumStar,
  W_2 as faPoliceBox,
  ZD1 as faPoll,
  xD1 as faPollH,
  E_2 as faPollPeople,
  V_2 as faPompebled,
  a$1 as faPoo,
  n$1 as faPooBolt,
  c$1 as faPooStorm,
  I_2 as faPool8Ball,
  o$1 as faPoop,
  K_2 as faPopcorn,
  X_2 as faPopsicle,
  Q_2 as faPortalEnter,
  J_2 as faPortalExit,
  d$1 as faPortrait,
  Y_2 as faPotFood,
  Z_2 as faPotato,
  s$1 as faPoundSign,
  v$1 as faPowerOff,
  m$1 as faPray,
  P$1 as faPrayingHands,
  w$1 as faPrescription,
  z$1 as faPrescriptionBottle,
  C$1 as faPrescriptionBottleAlt,
  $$1 as faPrescriptionBottleMedical,
  p_2 as faPrescriptionBottlePill,
  x_2 as faPresentation,
  ib2 as faPresentationScreen,
  ab2 as faPretzel,
  b$1 as faPrint,
  eb2 as faPrintMagnifyingGlass,
  nb2 as faPrintSearch,
  fb2 as faPrintSlash,
  cb2 as faPro,
  y$1 as faProcedures,
  o0a as faProductHunt,
  k$1 as faProjectDiagram,
  tb2 as faProjector,
  ob2 as faPump,
  j$1 as faPumpMedical,
  T$1 as faPumpSoap,
  lb2 as faPumpkin,
  d0a as faPushed,
  db2 as faPuzzle,
  H$1 as faPuzzlePiece,
  rb2 as faPuzzlePieceAlt,
  sb2 as faPuzzlePieceSimple,
  s0a as faPython,
  U$1 as faQ,
  v0a as faQq,
  G$1 as faQrcode,
  E$1 as faQuestion,
  I$1 as faQuestionCircle,
  hb2 as faQuestionSquare,
  X$1 as faQuidditch,
  J$1 as faQuidditchBroomBall,
  m0a as faQuinscape,
  P0a as faQuora,
  Z$1 as faQuoteLeft,
  x$1 as faQuoteLeftAlt,
  a_1 as faQuoteRight,
  n_1 as faQuoteRightAlt,
  vb2 as faQuotes,
  c_1 as faQuran,
  o_1 as faR,
  w0a as faRProject,
  ub2 as faRabbit,
  mb2 as faRabbitFast,
  gb2 as faRabbitRunning,
  Pb2 as faRaccoon,
  Mb2 as faRacquet,
  wb2 as faRadar,
  d_1 as faRadiation,
  s_1 as faRadiationAlt,
  v_1 as faRadio,
  Nb2 as faRadioAlt,
  zb2 as faRadioTuner,
  m_1 as faRainbow,
  Lb2 as faRaindrops,
  Cb2 as faRam,
  Db2 as faRampLoading,
  P_1 as faRandom,
  w_1 as faRankingStar,
  z0a as faRaspberryPi,
  C0a as faRavelry,
  $b2 as faRaygun,
  $0a as faReact,
  b0a as faReacteurope,
  y0a as faReadme,
  k0a as faRebel,
  z_1 as faReceipt,
  C_1 as faRecordVinyl,
  _b2 as faRectangle,
  $_1 as faRectangleAd,
  bb2 as faRectangleBarcode,
  Sb2 as faRectangleCode,
  yb2 as faRectangleHd,
  Ob2 as faRectangleHistory,
  kb2 as faRectangleHistoryCirclePlus,
  Ab2 as faRectangleHistoryCircleUser,
  jb2 as faRectangleLandscape,
  b_1 as faRectangleList,
  Bb2 as faRectanglePortrait,
  Tb2 as faRectanglePro,
  Fb2 as faRectangleSd,
  Hb2 as faRectangleTerminal,
  y_1 as faRectangleTimes,
  Rb2 as faRectangleVertical,
  Ub2 as faRectangleVerticalHistory,
  qb2 as faRectangleWide,
  k_1 as faRectangleXmark,
  Gb2 as faRectanglesMixed,
  j_1 as faRecycle,
  j0a as faRedRiver,
  T0a as faReddit,
  H0a as faRedditAlien,
  U0a as faRedditSquare,
  G0a as faRedhat,
  T_1 as faRedo,
  H_1 as faRedoAlt,
  Wb2 as faReel,
  Eb2 as faReflectBoth,
  Vb2 as faReflectHorizontal,
  Ib2 as faReflectVertical,
  U_1 as faRefresh,
  Kb2 as faRefrigerator,
  G_1 as faRegistered,
  E_1 as faRemove,
  I_1 as faRemoveFormat,
  E0a as faRendact,
  I0a as faRenren,
  X_1 as faReorder,
  J_1 as faRepeat,
  Xb2 as faRepeat1,
  Qb2 as faRepeat1Alt,
  Jb2 as faRepeatAlt,
  Z_1 as faReply,
  x_1 as faReplyAll,
  Yb2 as faReplyClock,
  Zb2 as faReplyTime,
  X0a as faReplyd,
  ab1 as faRepublican,
  J0a as faResearchgate,
  Z0a as faResolving,
  nb1 as faRestroom,
  pb2 as faRestroomSimple,
  cb1 as faRetweet,
  xb2 as faRetweetAlt,
  x0a as faRev,
  iS2 as faRhombus,
  ob1 as faRibbon,
  aS2 as faRight,
  db1 as faRightFromBracket,
  eS2 as faRightFromLine,
  sb1 as faRightLeft,
  nS2 as faRightLeftLarge,
  vb1 as faRightLong,
  fS2 as faRightLongToLine,
  mb1 as faRightToBracket,
  cS2 as faRightToLine,
  Pb1 as faRing,
  tS2 as faRingDiamond,
  oS2 as faRingsWedding,
  wb1 as faRmb,
  zb1 as faRoad,
  Cb1 as faRoadBarrier,
  $b1 as faRoadBridge,
  bb1 as faRoadCircleCheck,
  yb1 as faRoadCircleExclamation,
  kb1 as faRoadCircleXmark,
  jb1 as faRoadLock,
  Tb1 as faRoadSpikes,
  Hb1 as faRobot,
  lS2 as faRobotAstromech,
  Ub1 as faRocket,
  dS2 as faRocketLaunch,
  aea as faRocketchat,
  nea as faRockrms,
  Gb1 as faRodAsclepius,
  Eb1 as faRodSnake,
  rS2 as faRollerCoaster,
  Ib1 as faRotate,
  Xb1 as faRotateBack,
  Jb1 as faRotateBackward,
  sS2 as faRotateExclamation,
  Zb1 as faRotateForward,
  xb1 as faRotateLeft,
  hS2 as faRotateReverse,
  aS1 as faRotateRight,
  nS1 as faRouble,
  cS1 as faRoute,
  vS2 as faRouteHighway,
  uS2 as faRouteInterstate,
  mS2 as faRouter,
  gS2 as faRows,
  oS1 as faRss,
  dS1 as faRssSquare,
  sS1 as faRub,
  vS1 as faRuble,
  mS1 as faRubleSign,
  PS1 as faRug,
  PS2 as faRugbyBall,
  wS1 as faRuler,
  zS1 as faRulerCombined,
  CS1 as faRulerHorizontal,
  MS2 as faRulerTriangle,
  $S1 as faRulerVertical,
  bS1 as faRunning,
  yS1 as faRupee,
  kS1 as faRupeeSign,
  jS1 as faRupiahSign,
  cea as faRust,
  wS2 as faRv,
  TS1 as faS,
  NS2 as faSack,
  HS1 as faSackDollar,
  US1 as faSackXmark,
  GS1 as faSadCry,
  ES1 as faSadTear,
  oea as faSafari,
  IS1 as faSailboat,
  zS2 as faSalad,
  dea as faSalesforce,
  LS2 as faSaltShaker,
  CS2 as faSandwich,
  sea as faSass,
  XS1 as faSatellite,
  JS1 as faSatelliteDish,
  DS2 as faSausage,
  ZS1 as faSave,
  $S2 as faSaveCircleArrowRight,
  _S2 as faSaveCircleXmark,
  bS2 as faSaveTimes,
  SS2 as faSaxHot,
  yS2 as faSaxophone,
  OS2 as faSaxophoneFire,
  xS1 as faScaleBalanced,
  ay1 as faScaleUnbalanced,
  ny1 as faScaleUnbalancedFlip,
  kS2 as faScalpel,
  AS2 as faScalpelLineDashed,
  jS2 as faScalpelPath,
  BS2 as faScanner,
  TS2 as faScannerGun,
  FS2 as faScannerImage,
  HS2 as faScannerKeyboard,
  RS2 as faScannerTouchscreen,
  US2 as faScarecrow,
  qS2 as faScarf,
  vea as faSchlix,
  cy1 as faSchool,
  oy1 as faSchoolCircleCheck,
  dy1 as faSchoolCircleExclamation,
  sy1 as faSchoolCircleXmark,
  vy1 as faSchoolFlag,
  my1 as faSchoolLock,
  Py1 as faScissors,
  GS2 as faScreenUsers,
  WS2 as faScreencast,
  mea as faScreenpal,
  ES2 as faScreenshot,
  wy1 as faScrewdriver,
  zy1 as faScrewdriverWrench,
  VS2 as faScribble,
  Pea as faScribd,
  Cy1 as faScroll,
  IS2 as faScrollOld,
  KS2 as faScrollRibbon,
  $y1 as faScrollTorah,
  XS2 as faScrubber,
  QS2 as faScythe,
  by1 as faSdCard,
  JS2 as faSdCards,
  YS2 as faSeal,
  ZS2 as faSealExclamation,
  pS2 as faSealQuestion,
  yy1 as faSearch,
  ky1 as faSearchDollar,
  jy1 as faSearchLocation,
  Ty1 as faSearchMinus,
  Hy1 as faSearchPlus,
  wea as faSearchengin,
  xS2 as faSeatAirline,
  Uy1 as faSection,
  Gy1 as faSeedling,
  Lui as faSelect,
  zea as faSellcast,
  Cea as faSellsy,
  iy2 as faSemicolon,
  ay2 as faSend,
  ey2 as faSendBack,
  ny2 as faSendBackward,
  fy2 as faSensor,
  cy2 as faSensorAlert,
  ty2 as faSensorCloud,
  oy2 as faSensorFire,
  ly2 as faSensorOn,
  dy2 as faSensorSmoke,
  ry2 as faSensorTriangleExclamation,
  Ey1 as faServer,
  $ea as faServicestack,
  Iy1 as faShapes,
  Xy1 as faShare,
  sy2 as faShareAll,
  Jy1 as faShareAlt,
  Zy1 as faShareAltSquare,
  xy1 as faShareFromSquare,
  aO1 as faShareNodes,
  nO1 as faShareSquare,
  hy2 as faSheep,
  cO1 as faSheetPlastic,
  oO1 as faShekel,
  dO1 as faShekelSign,
  vy2 as faShelves,
  uy2 as faShelvesEmpty,
  sO1 as faSheqel,
  vO1 as faSheqelSign,
  mO1 as faShield,
  PO1 as faShieldAlt,
  wO1 as faShieldBlank,
  zO1 as faShieldCat,
  my2 as faShieldCheck,
  gy2 as faShieldCross,
  CO1 as faShieldDog,
  Py2 as faShieldExclamation,
  $O1 as faShieldHalved,
  bO1 as faShieldHeart,
  My2 as faShieldKeyhole,
  wy2 as faShieldMinus,
  Ny2 as faShieldPlus,
  zy2 as faShieldQuartered,
  Ly2 as faShieldSlash,
  Cy2 as faShieldTimes,
  yO1 as faShieldVirus,
  Dy2 as faShieldXmark,
  kO1 as faShip,
  jO1 as faShippingFast,
  $y2 as faShippingTimed,
  TO1 as faShirt,
  _y2 as faShirtLongSleeve,
  by2 as faShirtRunning,
  Sy2 as faShirtTankTop,
  bea as faShirtsinbulk,
  yy2 as faShishKebab,
  HO1 as faShoePrints,
  yea as faShoelace,
  UO1 as faShop,
  GO1 as faShopLock,
  EO1 as faShopSlash,
  kea as faShopify,
  IO1 as faShoppingBag,
  XO1 as faShoppingBasket,
  Oy2 as faShoppingBasketAlt,
  JO1 as faShoppingCart,
  jea as faShopware,
  ky2 as faShortcake,
  Ay2 as faShovel,
  jy2 as faShovelSnow,
  ZO1 as faShower,
  By2 as faShowerAlt,
  Ty2 as faShowerDown,
  Fy2 as faShredder,
  xO1 as faShrimp,
  ak1 as faShuffle,
  Hy2 as faShutters,
  nk1 as faShuttleSpace,
  ck1 as faShuttleVan,
  Ry2 as faShuttlecock,
  Uy2 as faSickle,
  qy2 as faSidebar,
  Gy2 as faSidebarFlip,
  Wy2 as faSigma,
  ok1 as faSign,
  dk1 as faSignHanging,
  sk1 as faSignIn,
  vk1 as faSignInAlt,
  mk1 as faSignLanguage,
  Pk1 as faSignOut,
  wk1 as faSignOutAlt,
  Ey2 as faSignPost,
  Vy2 as faSignPosts,
  Iy2 as faSignPostsWrench,
  zk1 as faSignal,
  Ky2 as faSignal1,
  Xy2 as faSignal2,
  Qy2 as faSignal3,
  Jy2 as faSignal4,
  Ck1 as faSignal5,
  Yy2 as faSignalAlt,
  Zy2 as faSignalAlt1,
  py2 as faSignalAlt2,
  xy2 as faSignalAlt3,
  iO2 as faSignalAlt4,
  aO2 as faSignalAltSlash,
  eO2 as faSignalBars,
  nO2 as faSignalBarsFair,
  fO2 as faSignalBarsGood,
  cO2 as faSignalBarsSlash,
  tO2 as faSignalBarsStrong,
  oO2 as faSignalBarsWeak,
  lO2 as faSignalFair,
  dO2 as faSignalGood,
  Tea as faSignalMessenger,
  $k1 as faSignalPerfect,
  rO2 as faSignalSlash,
  sO2 as faSignalStream,
  hO2 as faSignalStreamSlash,
  vO2 as faSignalStrong,
  uO2 as faSignalWeak,
  bk1 as faSignature,
  mO2 as faSignatureLock,
  gO2 as faSignatureSlash,
  yk1 as faSigning,
  kk1 as faSignsPost,
  jk1 as faSimCard,
  PO2 as faSimCards,
  Hea as faSimplybuilt,
  Tk1 as faSink,
  MO2 as faSiren,
  wO2 as faSirenOn,
  Uea as faSistrix,
  Hk1 as faSitemap,
  Gea as faSith,
  Eea as faSitrox,
  Uk1 as faSkating,
  NO2 as faSkeleton,
  zO2 as faSkeletonRibs,
  Iea as faSketch,
  LO2 as faSkiBoot,
  CO2 as faSkiBootSki,
  DO2 as faSkiJump,
  $O2 as faSkiLift,
  Gk1 as faSkiing,
  Ek1 as faSkiingNordic,
  Ik1 as faSkull,
  _O2 as faSkullCow,
  Xk1 as faSkullCrossbones,
  Xea as faSkyatlas,
  Jea as faSkype,
  Zea as faSlack,
  xea as faSlackHash,
  Jk1 as faSlash,
  bO2 as faSlashBack,
  SO2 as faSlashForward,
  yO2 as faSledding,
  Zk1 as faSleigh,
  OO2 as faSlider,
  xk1 as faSliders,
  aA1 as faSlidersH,
  kO2 as faSlidersHSquare,
  AO2 as faSlidersSimple,
  jO2 as faSlidersUp,
  BO2 as faSlidersV,
  TO2 as faSlidersVSquare,
  ana as faSlideshare,
  FO2 as faSlotMachine,
  nA1 as faSmile,
  cA1 as faSmileBeam,
  HO2 as faSmilePlus,
  oA1 as faSmileWink,
  dA1 as faSmog,
  RO2 as faSmoke,
  sA1 as faSmoking,
  vA1 as faSmokingBan,
  mA1 as faSms,
  UO2 as faSnake,
  nna as faSnapchat,
  cna as faSnapchatGhost,
  ona as faSnapchatSquare,
  qO2 as faSnooze,
  GO2 as faSnowBlowing,
  PA1 as faSnowboarding,
  wA1 as faSnowflake,
  WO2 as faSnowflakeDroplets,
  EO2 as faSnowflakes,
  zA1 as faSnowman,
  VO2 as faSnowmanHead,
  IO2 as faSnowmobile,
  CA1 as faSnowplow,
  $A1 as faSoap,
  bA1 as faSoccerBall,
  yA1 as faSocks,
  KO2 as faSoftServe,
  kA1 as faSolarPanel,
  XO2 as faSolarSystem,
  jA1 as faSort,
  TA1 as faSortAlphaAsc,
  HA1 as faSortAlphaDesc,
  UA1 as faSortAlphaDown,
  GA1 as faSortAlphaDownAlt,
  EA1 as faSortAlphaUp,
  IA1 as faSortAlphaUpAlt,
  QO2 as faSortAlt,
  XA1 as faSortAmountAsc,
  JA1 as faSortAmountDesc,
  ZA1 as faSortAmountDown,
  xA1 as faSortAmountDownAlt,
  aj1 as faSortAmountUp,
  nj1 as faSortAmountUpAlt,
  cj1 as faSortAsc,
  JO2 as faSortCircle,
  YO2 as faSortCircleDown,
  ZO2 as faSortCircleUp,
  oj1 as faSortDesc,
  dj1 as faSortDown,
  sj1 as faSortNumericAsc,
  vj1 as faSortNumericDesc,
  mj1 as faSortNumericDown,
  Pj1 as faSortNumericDownAlt,
  wj1 as faSortNumericUp,
  zj1 as faSortNumericUpAlt,
  pO2 as faSortShapesDown,
  xO2 as faSortShapesDownAlt,
  ik2 as faSortShapesUp,
  ak2 as faSortShapesUpAlt,
  ek2 as faSortSizeDown,
  nk2 as faSortSizeDownAlt,
  fk2 as faSortSizeUp,
  ck2 as faSortSizeUpAlt,
  Cj1 as faSortUp,
  tk2 as faSortUpDown,
  dna as faSoundcloud,
  ok2 as faSoup,
  sna as faSourcetree,
  $j1 as faSpa,
  vna as faSpaceAwesome,
  bj1 as faSpaceShuttle,
  lk2 as faSpaceStationMoon,
  dk2 as faSpaceStationMoonAlt,
  rk2 as faSpaceStationMoonConstruction,
  sk2 as faSpade,
  yj1 as faSpaghettiMonsterFlying,
  hk2 as faSparkle,
  vk2 as faSparkles,
  mna as faSpeakap,
  uk2 as faSpeaker,
  Pna as faSpeakerDeck,
  mk2 as faSpeakers,
  kj1 as faSpellCheck,
  jj1 as faSpider,
  gk2 as faSpiderBlackWidow,
  Pk2 as faSpiderWeb,
  Tj1 as faSpinner,
  Mk2 as faSpinnerScale,
  wk2 as faSpinnerThird,
  Nk2 as faSplit,
  Hj1 as faSplotch,
  Uj1 as faSpoon,
  zk2 as faSportsball,
  wna as faSpotify,
  Gj1 as faSprayCan,
  Ej1 as faSprayCanSparkles,
  Lk2 as faSprinkler,
  Ck2 as faSprinklerCeiling,
  Ij1 as faSprout,
  Xj1 as faSquare,
  Dk2 as faSquare0,
  $k2 as faSquare1,
  _k2 as faSquare2,
  bk2 as faSquare3,
  Sk2 as faSquare4,
  yk2 as faSquare5,
  Ok2 as faSquare6,
  kk2 as faSquare7,
  Ak2 as faSquare8,
  jk2 as faSquare9,
  Bk2 as faSquareA,
  Tk2 as faSquareALock,
  Fk2 as faSquareAmpersand,
  Hk2 as faSquareArrowDown,
  Rk2 as faSquareArrowDownLeft,
  Uk2 as faSquareArrowDownRight,
  qk2 as faSquareArrowLeft,
  Gk2 as faSquareArrowRight,
  Wk2 as faSquareArrowUp,
  Ek2 as faSquareArrowUpLeft,
  Jj1 as faSquareArrowUpRight,
  Vk2 as faSquareB,
  zna as faSquareBehance,
  Ik2 as faSquareBolt,
  Kk2 as faSquareC,
  Zj1 as faSquareCaretDown,
  xj1 as faSquareCaretLeft,
  aB1 as faSquareCaretRight,
  nB1 as faSquareCaretUp,
  cB1 as faSquareCheck,
  Xk2 as faSquareChevronDown,
  Qk2 as faSquareChevronLeft,
  Jk2 as faSquareChevronRight,
  Yk2 as faSquareChevronUp,
  Zk2 as faSquareCode,
  pk2 as faSquareD,
  xk2 as faSquareDashed,
  iA2 as faSquareDashedCirclePlus,
  aA2 as faSquareDivide,
  eA2 as faSquareDollar,
  nA2 as faSquareDown,
  fA2 as faSquareDownLeft,
  cA2 as faSquareDownRight,
  Cna as faSquareDribbble,
  tA2 as faSquareE,
  oA2 as faSquareEllipsis,
  lA2 as faSquareEllipsisVertical,
  oB1 as faSquareEnvelope,
  dA2 as faSquareExclamation,
  rA2 as faSquareF,
  $na as faSquareFacebook,
  bna as faSquareFontAwesome,
  yna as faSquareFontAwesomeStroke,
  sA2 as faSquareFragile,
  dB1 as faSquareFull,
  hA2 as faSquareG,
  kna as faSquareGit,
  jna as faSquareGithub,
  Tna as faSquareGitlab,
  Hna as faSquareGooglePlus,
  sB1 as faSquareH,
  Una as faSquareHackerNews,
  vA2 as faSquareHeart,
  uA2 as faSquareI,
  mA2 as faSquareInfo,
  Gna as faSquareInstagram,
  gA2 as faSquareJ,
  Ena as faSquareJs,
  PA2 as faSquareK,
  MA2 as faSquareKanban,
  Ina as faSquareKickstarter,
  wA2 as faSquareL,
  Xna as faSquareLastfm,
  NA2 as faSquareLeft,
  Jna as faSquareLetterboxd,
  zA2 as faSquareList,
  LA2 as faSquareM,
  vB1 as faSquareMinus,
  CA2 as faSquareN,
  mB1 as faSquareNfi,
  DA2 as faSquareO,
  Zna as faSquareOdnoklassniki,
  $A2 as faSquareP,
  PB1 as faSquareParking,
  _A2 as faSquareParkingSlash,
  wB1 as faSquarePen,
  zB1 as faSquarePersonConfined,
  CB1 as faSquarePhone,
  $B1 as faSquarePhoneFlip,
  bA2 as faSquarePhoneHangup,
  xna as faSquarePiedPiper,
  a6a as faSquarePinterest,
  bB1 as faSquarePlus,
  yB1 as faSquarePollHorizontal,
  kB1 as faSquarePollVertical,
  SA2 as faSquareQ,
  yA2 as faSquareQuarters,
  OA2 as faSquareQuestion,
  kA2 as faSquareQuote,
  AA2 as faSquareR,
  n6a as faSquareReddit,
  jA2 as faSquareRight,
  BA2 as faSquareRing,
  TA2 as faSquareRoot,
  jB1 as faSquareRootAlt,
  TB1 as faSquareRootVariable,
  HB1 as faSquareRss,
  FA2 as faSquareS,
  UB1 as faSquareShareNodes,
  HA2 as faSquareSliders,
  RA2 as faSquareSlidersVertical,
  UA2 as faSquareSmall,
  c6a as faSquareSnapchat,
  qA2 as faSquareStar,
  o6a as faSquareSteam,
  GA2 as faSquareT,
  WA2 as faSquareTerminal,
  EA2 as faSquareThisWayUp,
  d6a as faSquareThreads,
  s6a as faSquareTumblr,
  v6a as faSquareTwitter,
  VA2 as faSquareU,
  IA2 as faSquareUp,
  KA2 as faSquareUpLeft,
  GB1 as faSquareUpRight,
  m6a as faSquareUpwork,
  XA2 as faSquareUser,
  QA2 as faSquareV,
  P6a as faSquareViadeo,
  w6a as faSquareVimeo,
  EB1 as faSquareVirus,
  JA2 as faSquareW,
  z6a as faSquareWebAwesome,
  C6a as faSquareWebAwesomeStroke,
  $6a as faSquareWhatsapp,
  YA2 as faSquareWineGlassCrack,
  ZA2 as faSquareX,
  b6a as faSquareXTwitter,
  y6a as faSquareXing,
  IB1 as faSquareXmark,
  pA2 as faSquareY,
  k6a as faSquareYoutube,
  xA2 as faSquareZ,
  j6a as faSquarespace,
  ij2 as faSquid,
  aj2 as faSquirrel,
  T6a as faStackExchange,
  H6a as faStackOverflow,
  U6a as faStackpath,
  ej2 as faStaff,
  XB1 as faStaffAesculapius,
  JB1 as faStaffSnake,
  ZB1 as faStairs,
  xB1 as faStamp,
  nj2 as faStandardDefinition,
  aT1 as faStapler,
  nT1 as faStar,
  cT1 as faStarAndCrescent,
  fj2 as faStarChristmas,
  cj2 as faStarCircle,
  tj2 as faStarExclamation,
  oT1 as faStarHalf,
  dT1 as faStarHalfAlt,
  sT1 as faStarHalfStroke,
  vT1 as faStarOfDavid,
  mT1 as faStarOfLife,
  oj2 as faStarSharp,
  lj2 as faStarSharpHalf,
  dj2 as faStarSharpHalfAlt,
  rj2 as faStarSharpHalfStroke,
  sj2 as faStarShooting,
  hj2 as faStarfighter,
  vj2 as faStarfighterAlt,
  uj2 as faStarfighterAltAdvanced,
  mj2 as faStarfighterTwinIonEngine,
  gj2 as faStarfighterTwinIonEngineAdvanced,
  Pj2 as faStars,
  Mj2 as faStarship,
  wj2 as faStarshipFreighter,
  G6a as faStaylinked,
  Nj2 as faSteak,
  E6a as faSteam,
  I6a as faSteamSquare,
  X6a as faSteamSymbol,
  zj2 as faSteeringWheel,
  PT1 as faStepBackward,
  wT1 as faStepForward,
  zT1 as faSterlingSign,
  CT1 as faStethoscope,
  J6a as faStickerMule,
  $T1 as faStickyNote,
  Lj2 as faStocking,
  Cj2 as faStomach,
  bT1 as faStop,
  yT1 as faStopCircle,
  kT1 as faStopwatch,
  jT1 as faStopwatch20,
  TT1 as faStore,
  HT1 as faStoreAlt,
  UT1 as faStoreAltSlash,
  Dj2 as faStoreLock,
  GT1 as faStoreSlash,
  Z6a as faStrava,
  $j2 as faStrawberry,
  ET1 as faStream,
  IT1 as faStreetView,
  _j2 as faStretcher,
  XT1 as faStrikethrough,
  x6a as faStripe,
  afa as faStripeS,
  JT1 as faStroopwafel,
  nfa as faStubber,
  cfa as faStudiovinari,
  ofa as faStumbleupon,
  dfa as faStumbleuponCircle,
  ZT1 as faSubscript,
  bj2 as faSubtitles,
  Sj2 as faSubtitlesSlash,
  xT1 as faSubtract,
  aF1 as faSubway,
  yj2 as faSubwayTunnel,
  nF1 as faSuitcase,
  cF1 as faSuitcaseMedical,
  oF1 as faSuitcaseRolling,
  dF1 as faSun,
  Oj2 as faSunAlt,
  kj2 as faSunBright,
  Aj2 as faSunCloud,
  jj2 as faSunDust,
  Bj2 as faSunHaze,
  sF1 as faSunPlantWilt,
  Tj2 as faSunglasses,
  Fj2 as faSunrise,
  Hj2 as faSunset,
  sfa as faSuperpowers,
  vF1 as faSuperscript,
  vfa as faSupple,
  mF1 as faSurprise,
  mfa as faSuse,
  Rj2 as faSushi,
  Uj2 as faSushiRoll,
  qj2 as faSwap,
  Gj2 as faSwapArrows,
  PF1 as faSwatchbook,
  Pfa as faSwift,
  wF1 as faSwimmer,
  zF1 as faSwimmingPool,
  Wj2 as faSword,
  Ej2 as faSwordLaser,
  Vj2 as faSwordLaserAlt,
  Ij2 as faSwords,
  Kj2 as faSwordsLaser,
  Xj2 as faSymbols,
  wfa as faSymfony,
  CF1 as faSynagogue,
  $F1 as faSync,
  bF1 as faSyncAlt,
  yF1 as faSyringe,
  kF1 as faT,
  Qj2 as faTRex,
  jF1 as faTShirt,
  TF1 as faTable,
  HF1 as faTableCells,
  UF1 as faTableCellsColumnLock,
  Jj2 as faTableCellsColumnUnlock,
  GF1 as faTableCellsLarge,
  Yj2 as faTableCellsLock,
  EF1 as faTableCellsRowLock,
  IF1 as faTableCellsRowUnlock,
  Zj2 as faTableCellsUnlock,
  XF1 as faTableColumns,
  pj2 as faTableLayout,
  JF1 as faTableList,
  xj2 as faTablePicnic,
  iB2 as faTablePivot,
  aB2 as faTableRows,
  ZF1 as faTableTennis,
  xF1 as faTableTennisPaddleBall,
  eB2 as faTableTree,
  aH1 as faTablet,
  nH1 as faTabletAlt,
  cH1 as faTabletAndroid,
  nB2 as faTabletAndroidAlt,
  oH1 as faTabletButton,
  fB2 as faTabletRugged,
  cB2 as faTabletScreen,
  dH1 as faTabletScreenButton,
  sH1 as faTablets,
  vH1 as faTachographDigital,
  mH1 as faTachometer,
  PH1 as faTachometerAlt,
  wH1 as faTachometerAltAverage,
  zH1 as faTachometerAltFast,
  tB2 as faTachometerAltFastest,
  oB2 as faTachometerAltSlow,
  lB2 as faTachometerAltSlowest,
  CH1 as faTachometerAverage,
  $H1 as faTachometerFast,
  dB2 as faTachometerFastest,
  rB2 as faTachometerSlow,
  sB2 as faTachometerSlowest,
  hB2 as faTaco,
  bH1 as faTag,
  yH1 as faTags,
  vB2 as faTally,
  uB2 as faTally1,
  mB2 as faTally2,
  gB2 as faTally3,
  PB2 as faTally4,
  MB2 as faTally5,
  wB2 as faTamale,
  kH1 as faTanakh,
  NB2 as faTankWater,
  jH1 as faTape,
  TH1 as faTarp,
  HH1 as faTarpDroplet,
  UH1 as faTasks,
  GH1 as faTasksAlt,
  EH1 as faTaxi,
  zB2 as faTaxiBus,
  zfa as faTeamspeak,
  LB2 as faTeddyBear,
  IH1 as faTeeth,
  XH1 as faTeethOpen,
  Cfa as faTelegram,
  $fa as faTelegramPlane,
  CB2 as faTelescope,
  JH1 as faTeletype,
  DB2 as faTeletypeAnswer,
  ZH1 as faTelevision,
  xH1 as faTemperature0,
  aR1 as faTemperature1,
  nR1 as faTemperature2,
  cR1 as faTemperature3,
  oR1 as faTemperature4,
  dR1 as faTemperatureArrowDown,
  sR1 as faTemperatureArrowUp,
  vR1 as faTemperatureDown,
  mR1 as faTemperatureEmpty,
  $B2 as faTemperatureFrigid,
  PR1 as faTemperatureFull,
  wR1 as faTemperatureHalf,
  zR1 as faTemperatureHigh,
  _B2 as faTemperatureHot,
  bB2 as faTemperatureList,
  CR1 as faTemperatureLow,
  $R1 as faTemperatureQuarter,
  SB2 as faTemperatureSnow,
  yB2 as faTemperatureSun,
  bR1 as faTemperatureThreeQuarters,
  yR1 as faTemperatureUp,
  bfa as faTencentWeibo,
  kR1 as faTenge,
  jR1 as faTengeSign,
  OB2 as faTennisBall,
  TR1 as faTent,
  HR1 as faTentArrowDownToLine,
  UR1 as faTentArrowLeftRight,
  GR1 as faTentArrowTurnLeft,
  ER1 as faTentArrowsDown,
  kB2 as faTentDoublePeak,
  IR1 as faTents,
  XR1 as faTerminal,
  AB2 as faText,
  JR1 as faTextHeight,
  jB2 as faTextSize,
  ZR1 as faTextSlash,
  xR1 as faTextWidth,
  aU1 as faTh,
  nU1 as faThLarge,
  cU1 as faThList,
  yfa as faTheRedYeti,
  oU1 as faTheaterMasks,
  kfa as faThemeco,
  jfa as faThemeisle,
  dU1 as faThermometer,
  sU1 as faThermometer0,
  vU1 as faThermometer1,
  mU1 as faThermometer2,
  PU1 as faThermometer3,
  wU1 as faThermometer4,
  zU1 as faThermometerEmpty,
  CU1 as faThermometerFull,
  $U1 as faThermometerHalf,
  bU1 as faThermometerQuarter,
  yU1 as faThermometerThreeQuarters,
  BB2 as faTheta,
  Tfa as faThinkPeaks,
  TB2 as faThoughtBubble,
  Hfa as faThreads,
  kU1 as faThumbsDown,
  jU1 as faThumbsUp,
  TU1 as faThumbtack,
  HU1 as faThumbtackSlash,
  UU1 as faThunderstorm,
  FB2 as faThunderstormMoon,
  HB2 as faThunderstormSun,
  RB2 as faTick,
  GU1 as faTicket,
  UB2 as faTicketAirline,
  EU1 as faTicketAlt,
  qB2 as faTicketPerforated,
  GB2 as faTicketPerforatedPlane,
  WB2 as faTicketPlane,
  IU1 as faTicketSimple,
  EB2 as faTickets,
  VB2 as faTicketsAirline,
  IB2 as faTicketsPerforated,
  KB2 as faTicketsPerforatedPlane,
  XB2 as faTicketsPlane,
  QB2 as faTicketsSimple,
  Ufa as faTiktok,
  JB2 as faTilde,
  XU1 as faTimeline,
  YB2 as faTimelineArrow,
  ZB2 as faTimer,
  JU1 as faTimes,
  ZU1 as faTimesCircle,
  pB2 as faTimesHexagon,
  xB2 as faTimesOctagon,
  xU1 as faTimesRectangle,
  aq1 as faTimesSquare,
  iT2 as faTimesToSlot,
  nq1 as faTint,
  cq1 as faTintSlash,
  aT2 as faTire,
  eT2 as faTireFlat,
  nT2 as faTirePressureWarning,
  fT2 as faTireRugged,
  oq1 as faTired,
  cT2 as faToggleLargeOff,
  tT2 as faToggleLargeOn,
  dq1 as faToggleOff,
  sq1 as faToggleOn,
  vq1 as faToilet,
  mq1 as faToiletPaper,
  oT2 as faToiletPaperAlt,
  lT2 as faToiletPaperBlank,
  dT2 as faToiletPaperBlankUnder,
  rT2 as faToiletPaperCheck,
  sT2 as faToiletPaperReverse,
  hT2 as faToiletPaperReverseAlt,
  vT2 as faToiletPaperReverseSlash,
  Pq1 as faToiletPaperSlash,
  uT2 as faToiletPaperUnder,
  mT2 as faToiletPaperUnderSlash,
  gT2 as faToiletPaperXmark,
  wq1 as faToiletPortable,
  zq1 as faToiletsPortable,
  PT2 as faTomato,
  MT2 as faTombstone,
  wT2 as faTombstoneAlt,
  NT2 as faTombstoneBlank,
  Cq1 as faToolbox,
  $q1 as faTools,
  bq1 as faTooth,
  zT2 as faToothbrush,
  yq1 as faTorah,
  kq1 as faToriiGate,
  jq1 as faTornado,
  Tq1 as faTowerBroadcast,
  Hq1 as faTowerCell,
  LT2 as faTowerControl,
  Uq1 as faTowerObservation,
  Gq1 as faTractor,
  Gfa as faTradeFederation,
  Eq1 as faTrademark,
  CT2 as faTrafficCone,
  Iq1 as faTrafficLight,
  DT2 as faTrafficLightGo,
  $T2 as faTrafficLightSlow,
  _T2 as faTrafficLightStop,
  Xq1 as faTrailer,
  Jq1 as faTrain,
  Zq1 as faTrainSubway,
  bT2 as faTrainSubwayTunnel,
  ST2 as faTrainTrack,
  xq1 as faTrainTram,
  yT2 as faTrainTunnel,
  aG1 as faTram,
  OT2 as faTransformerBolt,
  nG1 as faTransgender,
  cG1 as faTransgenderAlt,
  kT2 as faTransporter,
  AT2 as faTransporter1,
  jT2 as faTransporter2,
  BT2 as faTransporter3,
  TT2 as faTransporter4,
  FT2 as faTransporter5,
  HT2 as faTransporter6,
  RT2 as faTransporter7,
  UT2 as faTransporterEmpty,
  oG1 as faTrash,
  dG1 as faTrashAlt,
  qT2 as faTrashAltSlash,
  GT2 as faTrashArrowTurnLeft,
  sG1 as faTrashArrowUp,
  vG1 as faTrashCan,
  WT2 as faTrashCanArrowTurnLeft,
  mG1 as faTrashCanArrowUp,
  ET2 as faTrashCanCheck,
  VT2 as faTrashCanClock,
  IT2 as faTrashCanList,
  KT2 as faTrashCanPlus,
  XT2 as faTrashCanSlash,
  QT2 as faTrashCanUndo,
  JT2 as faTrashCanXmark,
  YT2 as faTrashCheck,
  ZT2 as faTrashCircle,
  pT2 as faTrashClock,
  xT2 as faTrashList,
  iF2 as faTrashPlus,
  PG1 as faTrashRestore,
  wG1 as faTrashRestoreAlt,
  aF2 as faTrashSlash,
  eF2 as faTrashUndo,
  nF2 as faTrashUndoAlt,
  fF2 as faTrashXmark,
  cF2 as faTreasureChest,
  zG1 as faTree,
  tF2 as faTreeAlt,
  oF2 as faTreeChristmas,
  CG1 as faTreeCity,
  lF2 as faTreeDeciduous,
  dF2 as faTreeDecorated,
  rF2 as faTreeLarge,
  sF2 as faTreePalm,
  hF2 as faTrees,
  Efa as faTrello,
  vF2 as faTrianBalbot,
  uF2 as faTriangle,
  $G1 as faTriangleCircleSquare,
  bG1 as faTriangleExclamation,
  mF2 as faTriangleInstrument,
  gF2 as faTriangleMusic,
  PF2 as faTrianglePersonDigging,
  MF2 as faTricycle,
  wF2 as faTricycleAdult,
  NF2 as faTrillium,
  yG1 as faTrophy,
  zF2 as faTrophyAlt,
  LF2 as faTrophyStar,
  kG1 as faTrowel,
  jG1 as faTrowelBricks,
  TG1 as faTruck,
  HG1 as faTruckArrowRight,
  CF2 as faTruckBolt,
  DF2 as faTruckClock,
  $F2 as faTruckContainer,
  _F2 as faTruckContainerEmpty,
  bF2 as faTruckCouch,
  UG1 as faTruckDroplet,
  GG1 as faTruckFast,
  EG1 as faTruckField,
  IG1 as faTruckFieldUn,
  SF2 as faTruckFire,
  yF2 as faTruckFlatbed,
  XG1 as faTruckFront,
  OF2 as faTruckLadder,
  JG1 as faTruckLoading,
  ZG1 as faTruckMedical,
  xG1 as faTruckMonster,
  aW1 as faTruckMoving,
  nW1 as faTruckPickup,
  cW1 as faTruckPlane,
  kF2 as faTruckPlow,
  AF2 as faTruckRamp,
  oW1 as faTruckRampBox,
  jF2 as faTruckRampCouch,
  BF2 as faTruckTow,
  TF2 as faTruckUtensils,
  FF2 as faTrumpet,
  dW1 as faTry,
  sW1 as faTty,
  HF2 as faTtyAnswer,
  RF2 as faTugrikSign,
  Ifa as faTumblr,
  Xfa as faTumblrSquare,
  UF2 as faTurkey,
  vW1 as faTurkishLira,
  mW1 as faTurkishLiraSign,
  PW1 as faTurnDown,
  qF2 as faTurnDownLeft,
  GF2 as faTurnDownRight,
  WF2 as faTurnLeft,
  EF2 as faTurnLeftDown,
  VF2 as faTurnLeftUp,
  IF2 as faTurnRight,
  wW1 as faTurnUp,
  KF2 as faTurntable,
  XF2 as faTurtle,
  zW1 as faTv,
  CW1 as faTvAlt,
  QF2 as faTvMusic,
  JF2 as faTvRetro,
  Jfa as faTwitch,
  Zfa as faTwitter,
  xfa as faTwitterSquare,
  YF2 as faTypewriter,
  aca as faTypo3,
  $W1 as faU,
  nca as faUber,
  cca as faUbuntu,
  ZF2 as faUfo,
  pF2 as faUfoBeam,
  oca as faUikit,
  dca as faUmbraco,
  bW1 as faUmbrella,
  xF2 as faUmbrellaAlt,
  yW1 as faUmbrellaBeach,
  iH2 as faUmbrellaSimple,
  sca as faUncharted,
  kW1 as faUnderline,
  jW1 as faUndo,
  TW1 as faUndoAlt,
  aH2 as faUnicorn,
  eH2 as faUniformMartialArts,
  nH2 as faUnion,
  vca as faUniregistry,
  mca as faUnity,
  HW1 as faUniversalAccess,
  UW1 as faUniversity,
  GW1 as faUnlink,
  EW1 as faUnlock,
  IW1 as faUnlockAlt,
  XW1 as faUnlockKeyhole,
  JW1 as faUnsorted,
  Pca as faUnsplash,
  wca as faUntappd,
  fH2 as faUp,
  ZW1 as faUpDown,
  xW1 as faUpDownLeftRight,
  cH2 as faUpFromBracket,
  tH2 as faUpFromDottedLine,
  oH2 as faUpFromLine,
  lH2 as faUpLeft,
  aE1 as faUpLong,
  dH2 as faUpRight,
  nE1 as faUpRightAndDownLeftFromCenter,
  cE1 as faUpRightFromSquare,
  rH2 as faUpToBracket,
  sH2 as faUpToDottedLine,
  hH2 as faUpToLine,
  oE1 as faUpload,
  zca as faUps,
  Cca as faUpwork,
  $ca as faUsb,
  vH2 as faUsbDrive,
  dE1 as faUsd,
  uH2 as faUsdCircle,
  mH2 as faUsdSquare,
  sE1 as faUser,
  gH2 as faUserAlien,
  vE1 as faUserAlt,
  mE1 as faUserAltSlash,
  PE1 as faUserAstronaut,
  PH2 as faUserBeardBolt,
  MH2 as faUserBountyHunter,
  wH2 as faUserChart,
  wE1 as faUserCheck,
  NH2 as faUserChef,
  zE1 as faUserCircle,
  CE1 as faUserClock,
  $E1 as faUserCog,
  zH2 as faUserConstruction,
  LH2 as faUserCowboy,
  CH2 as faUserCrown,
  bE1 as faUserDoctor,
  DH2 as faUserDoctorHair,
  $H2 as faUserDoctorHairLong,
  _H2 as faUserDoctorMessage,
  yE1 as faUserEdit,
  kE1 as faUserFriends,
  jE1 as faUserGear,
  TE1 as faUserGraduate,
  HE1 as faUserGroup,
  bH2 as faUserGroupCrown,
  SH2 as faUserGroupSimple,
  yH2 as faUserHair,
  OH2 as faUserHairBuns,
  kH2 as faUserHairLong,
  AH2 as faUserHairMullet,
  jH2 as faUserHardHat,
  BH2 as faUserHeadset,
  TH2 as faUserHelmetSafety,
  FH2 as faUserHoodie,
  UE1 as faUserInjured,
  GE1 as faUserLarge,
  EE1 as faUserLargeSlash,
  IE1 as faUserLock,
  HH2 as faUserMagnifyingGlass,
  XE1 as faUserMd,
  RH2 as faUserMdChat,
  JE1 as faUserMinus,
  UH2 as faUserMusic,
  ZE1 as faUserNinja,
  xE1 as faUserNurse,
  qH2 as faUserNurseHair,
  GH2 as faUserNurseHairLong,
  aV1 as faUserPen,
  WH2 as faUserPilot,
  EH2 as faUserPilotTie,
  nV1 as faUserPlus,
  VH2 as faUserPolice,
  IH2 as faUserPoliceTie,
  KH2 as faUserRobot,
  XH2 as faUserRobotXmarks,
  cV1 as faUserSecret,
  QH2 as faUserShakespeare,
  oV1 as faUserShield,
  dV1 as faUserSlash,
  sV1 as faUserTag,
  vV1 as faUserTie,
  JH2 as faUserTieHair,
  YH2 as faUserTieHairLong,
  mV1 as faUserTimes,
  ZH2 as faUserUnlock,
  pH2 as faUserVisor,
  xH2 as faUserVneck,
  iR2 as faUserVneckHair,
  aR2 as faUserVneckHairLong,
  PV1 as faUserXmark,
  wV1 as faUsers,
  zV1 as faUsersBetweenLines,
  eR2 as faUsersClass,
  CV1 as faUsersCog,
  nR2 as faUsersCrown,
  $V1 as faUsersGear,
  bV1 as faUsersLine,
  fR2 as faUsersMedical,
  yV1 as faUsersRays,
  kV1 as faUsersRectangle,
  jV1 as faUsersSlash,
  TV1 as faUsersViewfinder,
  bca as faUsps,
  yca as faUssunnah,
  cR2 as faUtensilFork,
  tR2 as faUtensilKnife,
  HV1 as faUtensilSpoon,
  UV1 as faUtensils,
  oR2 as faUtensilsAlt,
  lR2 as faUtensilsSlash,
  dR2 as faUtilityPole,
  rR2 as faUtilityPoleDouble,
  GV1 as faV,
  kca as faVaadin,
  sR2 as faVacuum,
  hR2 as faVacuumRobot,
  vR2 as faValueAbsolute,
  EV1 as faVanShuttle,
  IV1 as faVault,
  XV1 as faVcard,
  uR2 as faVectorCircle,
  mR2 as faVectorPolygon,
  JV1 as faVectorSquare,
  gR2 as faVentDamper,
  ZV1 as faVenus,
  xV1 as faVenusDouble,
  aI1 as faVenusMars,
  nI1 as faVest,
  cI1 as faVestPatches,
  PR2 as faVhs,
  jca as faViacoin,
  Tca as faViadeo,
  Hca as faViadeoSquare,
  oI1 as faVial,
  dI1 as faVialCircleCheck,
  sI1 as faVialVirus,
  vI1 as faVials,
  Uca as faViber,
  mI1 as faVideo,
  MR2 as faVideoArrowDownLeft,
  wR2 as faVideoArrowUpRight,
  PI1 as faVideoCamera,
  NR2 as faVideoCircle,
  zR2 as faVideoHandheld,
  LR2 as faVideoPlus,
  wI1 as faVideoSlash,
  zI1 as faVihara,
  Gca as faVimeo,
  Eca as faVimeoSquare,
  Ica as faVimeoV,
  Xca as faVine,
  CR2 as faViolin,
  CI1 as faVirus,
  $I1 as faVirusCovid,
  bI1 as faVirusCovidSlash,
  yI1 as faVirusSlash,
  kI1 as faViruses,
  Jca as faVk,
  Zca as faVnv,
  jI1 as faVoicemail,
  TI1 as faVolcano,
  HI1 as faVolleyball,
  UI1 as faVolleyballBall,
  DR2 as faVolume,
  GI1 as faVolumeControlPhone,
  EI1 as faVolumeDown,
  II1 as faVolumeHigh,
  XI1 as faVolumeLow,
  $R2 as faVolumeMedium,
  JI1 as faVolumeMute,
  ZI1 as faVolumeOff,
  _R2 as faVolumeSlash,
  xI1 as faVolumeTimes,
  aK1 as faVolumeUp,
  nK1 as faVolumeXmark,
  bR2 as faVoteNay,
  cK1 as faVoteYea,
  oK1 as faVrCardboard,
  xca as faVuejs,
  dK1 as faW,
  SR2 as faWaffle,
  yR2 as faWagonCovered,
  OR2 as faWalker,
  sK1 as faWalkieTalkie,
  vK1 as faWalking,
  kR2 as faWallBrick,
  mK1 as faWallet,
  AR2 as faWand,
  PK1 as faWandMagic,
  wK1 as faWandMagicSparkles,
  zK1 as faWandSparkles,
  CK1 as faWarehouse,
  jR2 as faWarehouseAlt,
  BR2 as faWarehouseFull,
  $K1 as faWarning,
  TR2 as faWasher,
  FR2 as faWashingMachine,
  HR2 as faWatch,
  RR2 as faWatchApple,
  UR2 as faWatchCalculator,
  qR2 as faWatchFitness,
  GR2 as faWatchSmart,
  a8a as faWatchmanMonitoring,
  bK1 as faWater,
  WR2 as faWaterArrowDown,
  ER2 as faWaterArrowUp,
  yK1 as faWaterLadder,
  VR2 as faWaterLower,
  IR2 as faWaterRise,
  KR2 as faWatermelonSlice,
  XR2 as faWave,
  QR2 as faWavePulse,
  JR2 as faWaveSine,
  kK1 as faWaveSquare,
  YR2 as faWaveTriangle,
  ZR2 as faWaveform,
  pR2 as faWaveformCircle,
  xR2 as faWaveformLines,
  iU2 as faWaveformPath,
  aU2 as faWavesSine,
  n8a as faWaze,
  jK1 as faWebAwesome,
  eU2 as faWebcam,
  nU2 as faWebcamSlash,
  c8a as faWebflow,
  fU2 as faWebhook,
  o8a as faWeebly,
  d8a as faWeibo,
  TK1 as faWeight,
  HK1 as faWeightHanging,
  UK1 as faWeightScale,
  s8a as faWeixin,
  cU2 as faWhale,
  v8a as faWhatsapp,
  m8a as faWhatsappSquare,
  tU2 as faWheat,
  GK1 as faWheatAlt,
  EK1 as faWheatAwn,
  IK1 as faWheatAwnCircleExclamation,
  oU2 as faWheatAwnSlash,
  lU2 as faWheatSlash,
  XK1 as faWheelchair,
  JK1 as faWheelchairAlt,
  ZK1 as faWheelchairMove,
  xK1 as faWhiskeyGlass,
  dU2 as faWhiskeyGlassIce,
  rU2 as faWhistle,
  P8a as faWhmcs,
  aX1 as faWifi,
  sU2 as faWifi1,
  hU2 as faWifi2,
  nX1 as faWifi3,
  vU2 as faWifiExclamation,
  uU2 as faWifiFair,
  mU2 as faWifiSlash,
  cX1 as faWifiStrong,
  gU2 as faWifiWeak,
  w8a as faWikipediaW,
  oX1 as faWind,
  PU2 as faWindCircleExclamation,
  MU2 as faWindTurbine,
  wU2 as faWindWarning,
  NU2 as faWindow,
  zU2 as faWindowAlt,
  dX1 as faWindowClose,
  LU2 as faWindowFlip,
  CU2 as faWindowFrame,
  DU2 as faWindowFrameOpen,
  sX1 as faWindowMaximize,
  vX1 as faWindowMinimize,
  mX1 as faWindowRestore,
  z8a as faWindows,
  $U2 as faWindsock,
  PX1 as faWineBottle,
  wX1 as faWineGlass,
  zX1 as faWineGlassAlt,
  _U2 as faWineGlassCrack,
  CX1 as faWineGlassEmpty,
  C8a as faWirsindhandwerk,
  $8a as faWix,
  b8a as faWizardsOfTheCoast,
  y8a as faWodu,
  k8a as faWolfPackBattalion,
  $X1 as faWon,
  bX1 as faWonSign,
  j8a as faWordpress,
  T8a as faWordpressSimple,
  yX1 as faWorm,
  H8a as faWpbeginner,
  U8a as faWpexplorer,
  G8a as faWpforms,
  E8a as faWpressr,
  bU2 as faWreath,
  SU2 as faWreathLaurel,
  kX1 as faWrench,
  yU2 as faWrenchSimple,
  I8a as faWsh,
  jX1 as faX,
  TX1 as faXRay,
  X8a as faXTwitter,
  J8a as faXbox,
  Z8a as faXing,
  x8a as faXingSquare,
  HX1 as faXmark,
  UX1 as faXmarkCircle,
  OU2 as faXmarkHexagon,
  kU2 as faXmarkLarge,
  AU2 as faXmarkOctagon,
  GX1 as faXmarkSquare,
  jU2 as faXmarkToSlot,
  EX1 as faXmarksLines,
  IX1 as faY,
  a5a as faYCombinator,
  n5a as faYahoo,
  c5a as faYammer,
  o5a as faYandex,
  d5a as faYandexInternational,
  s5a as faYarn,
  v5a as faYelp,
  XX1 as faYen,
  JX1 as faYenSign,
  ZX1 as faYinYang,
  m5a as faYoast,
  P5a as faYoutube,
  w5a as faYoutubeSquare,
  xX1 as faZ,
  aQ1 as faZap,
  z5a as faZhihu,
  BU2 as faZzz,
  M02 as iconPack
};
